shadow$provide[21] = function(require,module,exports,global) {
var process = require('process');
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, AgentAuditLogs:{enumerable:true, get:function() {
  return ffe;
}}, AuthContextInstance:{enumerable:true, get:function() {
  return Whe;
}}, BroadcastStudioPage:{enumerable:true, get:function() {
  return qhe;
}}, ChatPage:{enumerable:true, get:function() {
  return Vhe;
}}, ChatWorkspacePane:{enumerable:true, get:function() {
  return fd;
}}, CmsPage:{enumerable:true, get:function() {
  return efe;
}}, ContractsPage:{enumerable:true, get:function() {
  return Qhe;
}}, DataPage:{enumerable:true, get:function() {
  return Khe;
}}, OpsRoot:{enumerable:true, get:function() {
  return Zhe;
}}, VisualCmsEditorPage:{enumerable:true, get:function() {
  return hfe;
}}, useChatWorkspaceController:{enumerable:true, get:function() {
  return Pg;
}}});
var require$react = require("react");
var require$react_SLASH_jsx_runtime = require("react/jsx-runtime");
var require$react_dom = require("react-dom");
var require$react_router_dom = require("react-router-dom");
var default$$require$react = require.esmDefault(require$react);
var _L = Object.defineProperty;
var SL = (t, e, n) => e in t ? _L(t, e, {enumerable:!0, configurable:!0, writable:!0, value:n}) : t[e] = n;
var It = (t, e, n) => SL(t, typeof e != "symbol" ? e + "" : e, n);
const Whe = (0,require$react.createContext)(null);
function Fa({label:t, edge:e, onExpand:n, title:r}) {
  const i = e === "left" || e === "right";
  return (0,require$react_SLASH_jsx_runtime.jsx)("button", {onClick:n, title:r ?? `Show ${t} panel`, "aria-label":r ?? `Show ${t} panel`, style:{...(i ? {width:28, flexShrink:0, display:"flex", alignItems:"center", justifyContent:"center", padding:0} : {height:28, width:"100%", flexShrink:0, display:"flex", alignItems:"center", justifyContent:"center", padding:"0 8px"}), border:"none", ...(e === "left" ? {borderRight:"1px solid var(--token-colors-border-default)"} : {}), ...(e === "right" ? {borderLeft:"1px solid var(--token-colors-border-default)"} : 
  {}), ...(e === "bottom" ? {borderTop:"1px solid var(--token-colors-border-default)"} : {}), background:"var(--token-colors-background-surface)", color:"var(--token-colors-text-muted)", fontSize:"12px", cursor:"pointer"}, children:(0,require$react_SLASH_jsx_runtime.jsx)("span", {style:i ? {writingMode:"vertical-rl", textOrientation:"mixed"} : void 0, children:t})});
}
function AL(t) {
  const e = t.replace("#", "").trim();
  return e.length === 3 ? e.split("").map(n => `${n}${n}`).join("") : e;
}
function NL(t) {
  const e = Number(t.toFixed(2));
  return String(e);
}
function ce(t, e) {
  const n = AL(t);
  if (n.length !== 6) {
    return t;
  }
  const r = parseInt(n.slice(0, 2), 16), i = parseInt(n.slice(2, 4), 16), s = parseInt(n.slice(4, 6), 16);
  return `rgba(${r}, ${i}, ${s}, ${NL(e)})`;
}
function wT(t, e) {
  if (!e) {
    return t;
  }
  const n = {...t};
  for (const [r, i] of Object.entries(e)) {
    const s = n[r];
    if (i && typeof i == "object" && !Array.isArray(i) && s && typeof s == "object" && !Array.isArray(s)) {
      n[r] = wT(s, i);
      continue;
    }
    n[r] = i;
  }
  return n;
}
function IL(t, e) {
  const n = {background:{default:t.bg.default, surface:t.bg.darker, elevated:t.bg.tabInactive, highlight:t.bg.lighter, overlay:"rgba(0, 0, 0, 0.6)"}, selection:{default:ce(t.bg.selection, 0.5)}, text:{default:t.fg.default, bright:t.fg.bright, panel:t.fg.panel, soft:t.fg.soft, muted:t.fg.muted, subtle:t.fg.subtle, inverse:t.bg.default, secondary:t.fg.muted}, interactive:{default:t.accent.cyan, hover:ce(t.accent.cyan, 0.88), active:ce(t.accent.cyan, 0.72), disabled:t.fg.muted}, button:{primary:{bg:t.accent.cyan, 
  fg:t.bg.default, hover:ce(t.accent.cyan, 0.88), active:ce(t.accent.cyan, 0.72)}, secondary:{bg:t.bg.selection, fg:t.fg.default, hover:ce(t.bg.selection, 0.88), active:ce(t.bg.selection, 0.72)}, ghost:{bg:"transparent", fg:t.fg.default, hover:ce(t.fg.default, 0.08), active:ce(t.fg.default, 0.14)}, danger:{bg:t.accent.red, fg:t.fg.default, hover:ce(t.accent.red, 0.88), active:ce(t.accent.red, 0.72)}}, badge:{default:{bg:t.fg.muted, fg:t.fg.default}, success:{bg:ce(t.accent.green, 0.15), fg:t.accent.green}, 
  warning:{bg:ce(t.accent.orange, 0.15), fg:t.accent.orange}, error:{bg:ce(t.accent.red, 0.15), fg:t.accent.red}, info:{bg:ce(t.accent.blue, 0.15), fg:t.accent.blue}}, border:{default:t.bg.groupBorder, subtle:t.fg.subtle, focus:t.accent.cyan, error:t.accent.red}, accent:t.accent, semantic:{error:t.semantic.error, warning:t.semantic.warning, success:t.semantic.success, info:t.semantic.info}, status:{alive:t.accent.green, dead:t.accent.red, open:t.accent.green, closed:t.fg.muted, merged:t.accent.magenta, 
  sleeping:t.accent.blue, eating:t.accent.orange, working:t.accent.yellow}, chart:{segment0:t.accent.blue, segment1:t.accent.green, segment2:t.accent.yellow, segment3:t.accent.orange, segment4:t.accent.magenta, segment5:t.fg.soft}, fill:{good:{start:t.accent.green, end:ce(t.accent.green, 0.55)}, warn:{start:t.accent.orange, end:ce(t.accent.orange, 0.55)}, danger:{start:t.accent.red, end:ce(t.accent.red, 0.55)}, neutral:{start:t.accent.blue, end:ce(t.accent.blue, 0.55)}}, surface:{panel:ce(t.bg.darker, 
  0.82), card:ce(t.bg.tabInactive, 0.65), cardAlt:ce(t.bg.lighter, 0.55), input:ce(t.bg.selection, 0.78), nav:ce(t.bg.darker, 0.6)}, alpha:{green:{_08:ce(t.accent.green, 0.08), _12:ce(t.accent.green, 0.12), _14:ce(t.accent.green, 0.14), _15:ce(t.accent.green, 0.15), _16:ce(t.accent.green, 0.16), _25:ce(t.accent.green, 0.25), _28:ce(t.accent.green, 0.28), _30:ce(t.accent.green, 0.3), _35:ce(t.accent.green, 0.35), _38:ce(t.accent.green, 0.38), _40:ce(t.accent.green, 0.4), _45:ce(t.accent.green, 0.45), 
  _50:ce(t.accent.green, 0.5), _55:ce(t.accent.green, 0.55), _60:ce(t.accent.green, 0.6), _80:ce(t.accent.green, 0.8)}, red:{_12:ce(t.accent.red, 0.12), _14:ce(t.accent.red, 0.14), _15:ce(t.accent.red, 0.15), _25:ce(t.accent.red, 0.25), _30:ce(t.accent.red, 0.3), _38:ce(t.accent.red, 0.38), _40:ce(t.accent.red, 0.4), _45:ce(t.accent.red, 0.45), _46:ce(t.accent.red, 0.46), _50:ce(t.accent.red, 0.5)}, orange:{_12:ce(t.accent.orange, 0.12), _15:ce(t.accent.orange, 0.15), _32:ce(t.accent.orange, 0.32), 
  _35:ce(t.accent.orange, 0.35), _40:ce(t.accent.orange, 0.4)}, blue:{_15:ce(t.accent.blue, 0.15), _20:ce(t.accent.blue, 0.2), _35:ce(t.accent.blue, 0.35), _45:ce(t.accent.blue, 0.45), _80:ce(t.accent.blue, 0.8), _95:ce(t.accent.blue, 0.95)}, magenta:{_08:ce(t.accent.magenta, 0.08), _14:ce(t.accent.magenta, 0.14), _30:ce(t.accent.magenta, 0.3)}, yellow:{_06:ce(t.accent.yellow, 0.06)}, bg:{_08:ce(t.bg.selection, 0.08), _10:ce(t.bg.selection, 0.1), _12:ce(t.bg.selection, 0.12), _14:ce(t.bg.selection, 
  0.14), _16:ce(t.bg.selection, 0.16), _18:ce(t.bg.selection, 0.18), _24:ce(t.bg.lighter, 0.24), _25:ce(t.bg.selection, 0.25), _28:ce(t.bg.selection, 0.28), _30:ce(t.bg.selection, 0.3), _46:ce(t.bg.darker, 0.46), _55:ce(t.bg.selection, 0.55), _60:ce(t.bg.darker, 0.6), _62:ce(t.bg.darker, 0.62), _68:ce(t.bg.darker, 0.68), _70:ce(t.bg.selection, 0.7), _72:ce(t.bg.darker, 0.72), _80:ce(t.bg.darker, 0.8), _85:ce(t.bg.lighter, 0.85), _88:ce(t.bg.lighter, 0.88), _88b:ce(t.bg.default, 0.88), _90:ce(t.bg.darker, 
  0.9), _95:ce(t.bg.darker, 0.95)}, warningBg:ce(t.accent.orange, 0.2), errorBg:ce(t.accent.red, 0.42), errorBgSolid:ce(t.accent.red, 0.9), federationError:ce(t.accent.red, 0.22), white:{_08:"rgba(255, 255, 255, 0.08)"}, shadow:"rgba(0, 0, 0, 0.35)", shadowLight:"rgba(0, 0, 0, 0.3)", shadowDeep:"rgba(15, 23, 42, 0.22)"}};
  return wT(n, e);
}
function _T(t) {
  return t.replace(/([A-Z])/g, "-$1").toLowerCase();
}
function OL(t, e) {
  return `var(--uxx-${t.map(_T).join("-")}, ${e})`;
}
function ST(t, e = []) {
  if (typeof t == "string") {
    return OL(e, t);
  }
  if (typeof t == "object" && t !== null) {
    const n = Object.entries(t).map(([r, i]) => [r, ST(i, [...e, r])]);
    return Object.fromEntries(n);
  }
  return t;
}
function pm(t, e, n, r) {
  return {name:t, label:e, appearance:(r == null ? void 0 : r.appearance) ?? "dark", palette:n, colors:IL(n, r == null ? void 0 : r.colorOverrides)};
}
const _r = {bg:{default:"#272822", darker:"#1e1f1c", lighter:"#3e3d32", selection:"#414339", tabInactive:"#34352f", groupBorder:"#34352f"}, fg:{default:"#f8f8f2", bright:"#f8f8f2", panel:"#cccccc", soft:"#90908a", muted:"#75715e", subtle:"#464741"}, accent:{yellow:"#e6db74", orange:"#fd971f", red:"#f92672", magenta:"#ae81ff", blue:"#66d9ef", cyan:"#66d9ef", green:"#a6e22e"}, semantic:{error:"#f92672", warning:"#fd971f", success:"#a6e22e", info:"#66d9ef"}}, er = {bg:{default:"#011627", darker:"#01111d", 
lighter:"#0b2942", selection:"#1d3b53", tabInactive:"#0b253a", groupBorder:"#5f7e97"}, fg:{default:"#d6deeb", bright:"#ffffff", panel:"#d2dee7", soft:"#89a4bb", muted:"#5f7e97", subtle:"#4b6479"}, accent:{yellow:"#ffeb95", orange:"#F78C6C", red:"#EF5350", magenta:"#c792ea", blue:"#82AAFF", cyan:"#80CBC4", green:"#c5e478"}, semantic:{error:"#EF5350", warning:"#FFCA28", success:"#c5e478", info:"#82AAFF"}}, Ge = {bg:{default:"#0A0C0F", darker:"#0F1318", lighter:"#1E2530", selection:"#131820", tabInactive:"#131820", 
groupBorder:"#1E2530"}, fg:{default:"#E8ECF1", bright:"#F4F7FB", panel:"#D6DCE6", soft:"#A6B1C2", muted:"#8A94A6", subtle:"#5A6478"}, accent:{yellow:"#F5A623", orange:"#F5A623", red:"#FF4C4C", magenta:"#9B8CFF", blue:"#00D4FF", cyan:"#00D4FF", green:"#00E5A0"}, semantic:{error:"#FF4C4C", warning:"#F5A623", success:"#00E5A0", info:"#00D4FF"}}, Xa = {monokai:pm("monokai", "Monokai", _r, {appearance:"dark", colorOverrides:{selection:{default:"rgba(135, 139, 145, 0.5)"}, interactive:{default:_r.accent.green, 
hover:"#8fce26", active:"#7cb824", disabled:_r.fg.muted}, button:{primary:{bg:_r.fg.muted, fg:_r.fg.default, hover:"#8a856e", active:"#6a6654"}, secondary:{bg:_r.bg.selection, fg:_r.fg.default, hover:"#505248", active:"#3a3c33"}, ghost:{bg:"transparent", fg:_r.fg.default, hover:_r.bg.selection, active:_r.bg.tabInactive}, danger:{bg:_r.accent.red, fg:_r.fg.default, hover:"#e61b63", active:"#d1155c"}}, border:{focus:"#99947c"}, chart:{segment5:"#7ca3b5"}, fill:{good:{start:_r.accent.green, end:"#78efb7"}, 
warn:{start:_r.accent.orange, end:"#ffd280"}, danger:{start:_r.accent.red, end:"#ff9e92"}, neutral:{start:"#7aa7bd", end:"#98bfd0"}}, alpha:{warningBg:"rgba(58, 41, 16, 0.88)", errorBg:"rgba(70, 24, 24, 0.42)", errorBgSolid:"rgba(70, 24, 24, 0.9)", federationError:"rgba(127, 29, 29, 0.22)"}}}), "night-owl":pm("night-owl", "Night Owl", er, {appearance:"dark", colorOverrides:{interactive:{default:er.accent.cyan, hover:"#7fdbca", active:"#21c7a8", disabled:er.fg.muted}, button:{primary:{bg:"#7e57c2cc", 
fg:"#ffffffcc", hover:"#7e57c2", active:"#6747a4"}, secondary:{bg:er.bg.selection, fg:er.fg.default, hover:"#234d708c", active:"#0e293f"}, ghost:{bg:"transparent", fg:er.fg.default, hover:ce(er.bg.selection, 0.55), active:er.bg.lighter}, danger:{bg:er.accent.red, fg:"#ffffffcc", hover:"#ec5f67", active:"#d3423e"}}, badge:{default:{bg:er.fg.muted, fg:"#ffffff"}}, border:{default:er.bg.groupBorder, subtle:er.fg.subtle, focus:er.accent.blue}, chart:{segment5:"#5f7e97"}, fill:{good:{start:er.accent.green, 
end:"#d9f5dd"}, warn:{start:er.accent.orange, end:"#ffcb8b"}, danger:{start:er.accent.red, end:"#ff869a"}, neutral:{start:er.accent.blue, end:"#c5e4fd"}}, alpha:{warningBg:"#675700F2", errorBg:"rgba(171, 3, 0, 0.42)", errorBgSolid:"#AB0300F2", federationError:ce(er.accent.red, 0.22), shadow:"rgba(1, 22, 39, 0.35)", shadowLight:"rgba(1, 11, 20, 0.3)", shadowDeep:"rgba(1, 17, 29, 0.45)"}}}), "proxy-console":pm("proxy-console", "Proxy Console", Ge, {appearance:"dark", colorOverrides:{interactive:{default:Ge.accent.cyan, 
hover:"#34DEFF", active:"#00B8DE", disabled:Ge.fg.subtle}, button:{primary:{bg:"#00D4FF", fg:"#0A0C0F", hover:"#34DEFF", active:"#00B8DE"}, secondary:{bg:"#0F1318", fg:"#E8ECF1", hover:"#131820", active:"#1A212C"}, ghost:{bg:"transparent", fg:"#E8ECF1", hover:ce(Ge.accent.cyan, 0.12), active:ce(Ge.accent.cyan, 0.18)}, danger:{bg:"#FF4C4C", fg:"#FDFEFF", hover:"#FF6666", active:"#E64545"}}, badge:{default:{bg:ce(Ge.fg.subtle, 0.2), fg:"#E8ECF1"}, success:{bg:ce(Ge.accent.green, 0.12), fg:"#00E5A0"}, 
warning:{bg:ce(Ge.accent.orange, 0.12), fg:"#F5A623"}, error:{bg:ce(Ge.accent.red, 0.12), fg:"#FF4C4C"}, info:{bg:ce(Ge.accent.cyan, 0.12), fg:"#00D4FF"}}, border:{default:"#1E2530", subtle:"#171C25", focus:"#00D4FF", error:"#FF4C4C"}, chart:{segment0:"#00D4FF", segment1:"#00E5A0", segment2:"#F5A623", segment3:"#FF4C4C", segment4:"#9B8CFF", segment5:"#7A90AA"}, fill:{good:{start:"#00E5A0", end:"#57F0C0"}, warn:{start:"#F5A623", end:"#FFD07A"}, danger:{start:"#FF4C4C", end:"#FF8C8C"}, neutral:{start:"#00D4FF", 
end:"#8EEBFF"}}, surface:{panel:ce(Ge.bg.darker, 0.92), card:ce(Ge.bg.tabInactive, 0.82), cardAlt:ce(Ge.bg.lighter, 0.62), input:ce("#0A0D11", 0.95), nav:ce(Ge.bg.default, 0.88)}, alpha:{green:{_08:ce(Ge.accent.green, 0.08), _12:ce(Ge.accent.green, 0.12), _14:ce(Ge.accent.green, 0.14), _15:ce(Ge.accent.green, 0.15), _16:ce(Ge.accent.green, 0.16), _25:ce(Ge.accent.green, 0.25), _28:ce(Ge.accent.green, 0.28), _30:ce(Ge.accent.green, 0.3), _35:ce(Ge.accent.green, 0.35), _38:ce(Ge.accent.green, 0.38), 
_40:ce(Ge.accent.green, 0.4), _45:ce(Ge.accent.green, 0.45), _50:ce(Ge.accent.green, 0.5), _55:ce(Ge.accent.green, 0.55), _60:ce(Ge.accent.green, 0.6), _80:ce(Ge.accent.green, 0.8)}, red:{_12:ce(Ge.accent.red, 0.12), _14:ce(Ge.accent.red, 0.14), _15:ce(Ge.accent.red, 0.15), _25:ce(Ge.accent.red, 0.25), _30:ce(Ge.accent.red, 0.3), _38:ce(Ge.accent.red, 0.38), _40:ce(Ge.accent.red, 0.4), _45:ce(Ge.accent.red, 0.45), _46:ce(Ge.accent.red, 0.46), _50:ce(Ge.accent.red, 0.5)}, orange:{_12:ce(Ge.accent.orange, 
0.12), _15:ce(Ge.accent.orange, 0.15), _32:ce(Ge.accent.orange, 0.32), _35:ce(Ge.accent.orange, 0.35), _40:ce(Ge.accent.orange, 0.4)}, blue:{_15:ce(Ge.accent.blue, 0.15), _20:ce(Ge.accent.blue, 0.2), _35:ce(Ge.accent.blue, 0.35), _45:ce(Ge.accent.blue, 0.45), _80:ce(Ge.accent.blue, 0.8), _95:ce(Ge.accent.blue, 0.95)}, magenta:{_08:ce(Ge.accent.magenta, 0.08), _14:ce(Ge.accent.magenta, 0.14), _30:ce(Ge.accent.magenta, 0.3)}, yellow:{_06:ce(Ge.accent.yellow, 0.06)}, bg:{_08:ce(Ge.bg.tabInactive, 0.08), 
_10:ce(Ge.bg.tabInactive, 0.1), _12:ce(Ge.bg.tabInactive, 0.12), _14:ce(Ge.bg.tabInactive, 0.14), _16:ce(Ge.bg.tabInactive, 0.16), _18:ce(Ge.bg.tabInactive, 0.18), _24:ce(Ge.bg.tabInactive, 0.24), _25:ce(Ge.bg.tabInactive, 0.25), _28:ce(Ge.bg.tabInactive, 0.28), _30:ce(Ge.bg.tabInactive, 0.3), _46:ce(Ge.bg.default, 0.46), _55:ce(Ge.bg.tabInactive, 0.55), _60:ce(Ge.bg.default, 0.6), _62:ce(Ge.bg.default, 0.62), _68:ce(Ge.bg.default, 0.68), _70:ce(Ge.bg.tabInactive, 0.7), _72:ce(Ge.bg.default, 0.72), 
_80:ce(Ge.bg.default, 0.8), _85:ce(Ge.bg.tabInactive, 0.85), _88:ce(Ge.bg.tabInactive, 0.88), _88b:ce(Ge.bg.default, 0.88), _90:ce(Ge.bg.default, 0.9), _95:ce(Ge.bg.default, 0.95)}, warningBg:ce("#442E0C", 0.88), errorBg:ce("#5A1C1C", 0.42), errorBgSolid:ce("#5A1C1C", 0.9), federationError:ce("#7F1D1D", 0.22), white:{_08:ce("#FFFFFF", 0.08)}, shadow:ce("#000000", 0.4), shadowLight:ce("#000000", 0.3), shadowDeep:ce("#000000", 0.5)}}})}, Os = "monokai";
function Sh(t) {
  return Object.values(Xa).find(e => e.appearance === t) ?? Xa[Os];
}
function kT(t = Os) {
  return t === "dark" ? Sh("dark").name : t === "light" ? Sh("light").name : t === "auto" ? typeof window < "u" && typeof window.matchMedia == "function" ? window.matchMedia("(prefers-color-scheme: light)").matches ? Sh("light").name : Sh("dark").name : Os : t;
}
function PL(t = Os) {
  return Xa[t];
}
function RL(t = Os) {
  return PL(kT(t));
}
ST(Xa[Os].colors, ["colors"]);
const Ws = 4, DL = {"0.5":Ws * 0.5, 1:Ws * 1, "1.5":Ws * 1.5, 2:Ws * 2, 3:Ws * 3, 4:Ws * 4, 5:Ws * 5, 6:Ws * 6, 8:Ws * 8}, rc = {sans:["Inter", "system-ui", "-apple-system", "BlinkMacSystemFont", "Segoe UI", "Roboto", "Helvetica Neue", "Arial", "sans-serif"].join(", "), mono:["JetBrains Mono", "Fira Code", "Monaco", "Consolas", "Liberation Mono", "Courier New", "monospace"].join(", ")}, Lr = {xs:"0.75rem", sm:"0.875rem", base:"1rem", lg:"1.125rem", xl:"1.25rem", "2xl":"1.5rem", "3xl":"1.875rem", 
"4xl":"2.25rem", "5xl":"3rem", inlineCode:"0.875em"}, LL = {medium:500, semibold:600}, ML = {none:1, normal:1.5};
Lr["4xl"], Lr["3xl"], Lr["2xl"], Lr.xl, Lr.lg, Lr.base, Lr.base, Lr.sm, Lr.sm, Lr.xs, rc.mono, Lr.sm, rc.mono, Lr.inlineCode;
const BL = {fast:"100ms"}, $L = {easeInOut:"cubic-bezier(0.4, 0, 0.2, 1)"}, FL = {colors:`color, background-color, border-color ${BL.fast} ${$L.easeInOut}`}, xa = {xs:"0 1px 2px 0 rgba(0, 0, 0, 0.05)", sm:"0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px -1px rgba(0, 0, 0, 0.1)", md:"0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1)", lg:"0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1)", xl:"0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1)", 
"2xl":"0 25px 50px -12px rgba(0, 0, 0, 0.25)", inner:"inset 0 2px 4px 0 rgba(0, 0, 0, 0.05)", focus:"0 0 0 2px rgba(166, 226, 46, 0.5)", focusError:"0 0 0 2px rgba(249, 38, 114, 0.5)", none:"none"};
xa.none, xa.sm, xa.md, xa.lg, xa.xl, xa["2xl"];
const zL = {dropdown:1e3, modal:1400}, Oa = {none:"0px", xs:"2px", sm:"4px", md:"6px", lg:"8px", xl:"12px", full:"9999px"};
function Ho(t) {
  return structuredClone(t);
}
function sb(t) {
  return typeof t == "object" && t !== null && !Array.isArray(t);
}
function ET(t, e) {
  if (!e) {
    return Ho(t);
  }
  const n = Ho(t);
  for (const [r, i] of Object.entries(e)) {
    if (i === void 0) {
      continue;
    }
    const s = n[r];
    if (sb(s) && sb(i)) {
      n[r] = ET(s, i);
      continue;
    }
    n[r] = i;
  }
  return n;
}
function ob(t, e) {
  return ET(t, e);
}
const gm = {colors:Ho(Xa.monokai.colors), palette:Ho(_r), fontFamily:rc, fontSize:Lr, shadow:xa, radius:Oa}, Xo = {monokai:gm, "night-owl":ob(gm, {colors:Ho(Xa["night-owl"].colors), palette:Ho(er), shadow:{focus:"0 0 0 2px rgba(130, 170, 255, 0.35)", focusError:"0 0 0 2px rgba(239, 83, 80, 0.35)"}}), "proxy-console":ob(gm, {colors:Ho(Xa["proxy-console"].colors), palette:Ho(Ge), fontFamily:{sans:["IBM Plex Sans", "Segoe UI", "system-ui", "sans-serif"].join(", "), mono:["JetBrains Mono", "Fira Code", 
"monospace"].join(", ")}, shadow:{xs:"0 1px 2px 0 rgba(0, 0, 0, 0.35)", sm:"0 1px 3px rgba(0, 0, 0, 0.4)", md:"0 4px 12px rgba(0, 0, 0, 0.5)", lg:"0 10px 24px rgba(0, 0, 0, 0.55)", xl:"0 20px 36px rgba(0, 0, 0, 0.6)", "2xl":"0 28px 64px rgba(0, 0, 0, 0.65)", inner:"inset 0 1px 2px rgba(0, 0, 0, 0.28)", focus:"0 0 0 2px rgba(0, 212, 255, 0.35)", focusError:"0 0 0 2px rgba(255, 76, 76, 0.35)", none:"none"}, radius:{none:"0px", xs:"2px", sm:"4px", md:"4px", lg:"6px", xl:"8px", full:"9999px"}})};
function HL(t) {
  return `--uxx-${t.map(_T).join("-")}`;
}
function il(t, e = []) {
  const n = {};
  for (const [r, i] of Object.entries(t)) {
    const s = [...e, r];
    if (sb(i)) {
      n[r] = il(i, s);
      continue;
    }
    n[r] = `var(${HL(s)}, ${String(i)})`;
  }
  return n;
}
const UL = il(Xo.monokai.colors, ["colors"]);
il(Xo.monokai.palette, ["palette"]);
const ab = il(Xo.monokai.fontFamily, ["fontFamily"]), di = il(Xo.monokai.fontSize, ["fontSize"]), WL = il(Xo.monokai.shadow, ["shadow"]), jL = il(Xo.monokai.radius, ["radius"]), VL = {h1:{fontSize:di["4xl"]}, h2:{fontSize:di["3xl"]}, h3:{fontSize:di["2xl"]}, h4:{fontSize:di.xl}, h5:{fontSize:di.lg}, h6:{fontSize:di.base}, body:{fontSize:di.base}, bodySm:{fontSize:di.sm}, label:{fontSize:di.sm}, caption:{fontSize:di.xs}, code:{fontFamily:ab.mono, fontSize:di.sm}, codeInline:{fontFamily:ab.mono, fontSize:di.inlineCode}}, 
O = {colors:UL, spacing:DL, fontFamily:ab, fontSize:di, fontWeight:LL, lineHeight:ML, typography:VL, transitions:FL, shadow:WL, zIndex:zL, radius:jL};
function qL(t) {
  return Xo[t] ?? Xo[Os];
}
function TT(t, e) {
  const n = RL(t), r = ob(qL(t), e);
  return {...n, palette:r.palette, colors:r.colors, fontFamily:r.fontFamily, fontSize:r.fontSize, shadow:r.shadow, radius:r.radius};
}
const YL = (0,require$react.createContext)({theme:Os, themeName:Os, resolvedTheme:TT(Os)});
function GL() {
  return (0,require$react.useContext)(YL);
}
function _c(t) {
  const e = GL();
  return (0,require$react.useMemo)(() => t === void 0 ? e.resolvedTheme : TT(kT(t)), [e.resolvedTheme, t]);
}
const QL = {primary:{backgroundColor:O.colors.button.primary.bg, color:O.colors.button.primary.fg, border:"none"}, secondary:{backgroundColor:O.colors.button.secondary.bg, color:O.colors.button.secondary.fg, border:`1px solid ${O.colors.border.default}`}, ghost:{backgroundColor:"transparent", color:O.colors.button.ghost.fg, border:"none"}, danger:{backgroundColor:O.colors.button.danger.bg, color:O.colors.button.danger.fg, border:"none"}}, KL = {sm:{padding:`${O.spacing[1.5]}px ${O.spacing[3]}px`, 
fontSize:O.typography.bodySm.fontSize, gap:`${O.spacing[1]}px`}, md:{padding:`${O.spacing[2]}px ${O.spacing[4]}px`, fontSize:O.typography.body.fontSize, gap:`${O.spacing[2]}px`}, lg:{padding:`${O.spacing[3]}px ${O.spacing[6]}px`, fontSize:O.typography.body.fontSize, gap:`${O.spacing[2]}px`}}, XL = {display:"inline-flex", alignItems:"center", justifyContent:"center", fontWeight:O.fontWeight.medium, lineHeight:O.lineHeight.none, borderRadius:O.radius.md, cursor:"pointer", transition:O.transitions.colors, 
outline:"none", fontFamily:O.fontFamily.sans};
function JL({size:t}) {
  const e = t === "sm" ? 14 : t === "lg" ? 20 : 16;
  return (0,require$react_SLASH_jsx_runtime.jsx)("svg", {width:e, height:e, viewBox:"0 0 24 24", fill:"none", stroke:"currentColor", strokeWidth:"2", strokeLinecap:"round", strokeLinejoin:"round", style:{animation:"spin 1s linear infinite"}, children:(0,require$react_SLASH_jsx_runtime.jsx)("path", {d:"M21 12a9 9 0 11-6.219-8.56"})});
}
const Ke = (0,require$react.forwardRef)(({variant:t = "secondary", size:e = "md", disabled:n = !1, loading:r = !1, fullWidth:i = !1, iconStart:s, iconEnd:o, children:a, type:l = "button", ...c}, u) => {
  const h = n || r, f = {...XL, ...QL[t], ...KL[e], width:i ? "100%" : void 0, opacity:h ? 0.6 : 1, cursor:h ? "not-allowed" : "pointer"};
  return (0,require$react_SLASH_jsx_runtime.jsxs)("button", {ref:u, type:l, disabled:h, "data-component":"button", "data-variant":t, "data-size":e, "data-loading":r || void 0, "data-full-width":i || void 0, "aria-busy":r, style:f, ...c, children:[r && (0,require$react_SLASH_jsx_runtime.jsx)(JL, {size:e}), !r && s, a, !r && o]});
});
Ke.displayName = "Button";
const ZL = {default:{bg:O.colors.badge.default.bg, fg:O.colors.badge.default.fg}, success:{bg:O.colors.badge.success.bg, fg:O.colors.badge.success.fg}, warning:{bg:O.colors.badge.warning.bg, fg:O.colors.badge.warning.fg}, error:{bg:O.colors.badge.error.bg, fg:O.colors.badge.error.fg}, info:{bg:O.colors.badge.info.bg, fg:O.colors.badge.info.fg}, open:{bg:O.colors.badge.success.bg, fg:O.colors.badge.success.fg}, closed:{bg:O.colors.badge.default.bg, fg:O.colors.badge.default.fg}, merged:{bg:O.colors.alpha.magenta._14, 
fg:O.colors.accent.magenta}, alive:{bg:O.colors.alpha.green._12, fg:O.colors.accent.green}, dead:{bg:O.colors.alpha.red._12, fg:O.colors.accent.red}, running:{bg:O.colors.alpha.blue._15, fg:O.colors.accent.blue}, stopped:{bg:O.colors.badge.default.bg, fg:O.colors.text.muted}}, e5 = {xs:{padding:"1px 4px", fontSize:"10px", gap:"2px"}, sm:{padding:`${O.spacing[0.5]}px ${O.spacing[1.5]}px`, fontSize:O.fontSize.xs, gap:`${O.spacing[0.5]}px`}, md:{padding:`${O.spacing[1]}px ${O.spacing[2]}px`, fontSize:O.fontSize.xs, 
gap:`${O.spacing[0.5]}px`}, lg:{padding:`${O.spacing[1.5]}px ${O.spacing[3]}px`, fontSize:O.fontSize.sm, gap:`${O.spacing[1]}px`}}, t5 = {display:"inline-flex", alignItems:"center", justifyContent:"center", fontWeight:O.fontWeight.medium, lineHeight:O.lineHeight.none, borderRadius:O.radius.sm, fontFamily:O.fontFamily.sans, whiteSpace:"nowrap"}, n5 = `
@keyframes devel-badge-pulse {
  0%, 100% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.5;
    transform: scale(1.2);
  }
}
`;
if (typeof document < "u") {
  const t = document.createElement("style");
  t.textContent = n5, document.head.appendChild(t);
}
function r5({color:t, size:e, pulse:n}) {
  const r = e === "xs" ? 4 : e === "sm" ? 6 : e === "lg" ? 10 : 8;
  return (0,require$react_SLASH_jsx_runtime.jsx)("span", {style:{width:r, height:r, borderRadius:"50%", backgroundColor:t, flexShrink:0, animation:n ? "devel-badge-pulse 2s ease-in-out infinite" : void 0}});
}
function ct({variant:t = "default", size:e = "md", dot:n = !1, pulse:r = !1, rounded:i = !1, outline:s = !1, dotColor:o, children:a, iconStart:l, iconEnd:c, className:u}) {
  const {bg:h, fg:f} = ZL[t], p = {...t5, ...e5[e], backgroundColor:s ? "transparent" : h, color:s ? h : f, border:s ? `1px solid ${h}` : "none", borderRadius:i ? O.radius.full : O.radius.sm};
  return (0,require$react_SLASH_jsx_runtime.jsxs)("span", {"data-component":"badge", "data-variant":t, "data-size":e, "data-dot":n || void 0, "data-pulse":r || void 0, "data-rounded":i || void 0, "data-outline":s || void 0, role:"status", "aria-label":t, style:p, className:u, children:[n && (0,require$react_SLASH_jsx_runtime.jsx)(r5, {color:o || (s ? h : f), size:e, pulse:r}), l, a, c]});
}
const i5 = {sm:14, md:16, lg:20, xl:24};
function tp({size:t = "md", color:e = "currentColor", thickness:n = 2.5, label:r = "Loading"}) {
  const i = i5[t];
  return (0,require$react_SLASH_jsx_runtime.jsx)("svg", {"data-component":"spinner", "data-size":t, role:"status", "aria-busy":"true", "aria-label":r, width:i, height:i, viewBox:"0 0 24 24", fill:"none", stroke:e, strokeWidth:n, strokeLinecap:"round", style:{animation:"devel-ui-spin 1s linear infinite"}, children:(0,require$react_SLASH_jsx_runtime.jsx)("path", {d:"M21 12a9 9 0 11-6.219-8.56"})});
}
const s5 = {default:{backgroundColor:O.colors.background.surface, border:`1px solid ${O.colors.border.default}`, boxShadow:O.shadow.sm}, outlined:{backgroundColor:"transparent", border:`1px solid ${O.colors.border.default}`, boxShadow:O.shadow.none}, elevated:{backgroundColor:O.colors.background.elevated, border:`1px solid ${O.colors.border.subtle}`, boxShadow:O.shadow.md}}, dw = {none:{padding:0}, sm:{padding:`${O.spacing[2]}px ${O.spacing[3]}px`}, md:{padding:`${O.spacing[4]}px ${O.spacing[5]}px`}, 
lg:{padding:`${O.spacing[6]}px ${O.spacing[8]}px`}}, o5 = {none:O.radius.none, sm:O.radius.sm, md:O.radius.md, lg:O.radius.lg, full:O.radius.full}, a5 = {display:"flex", flexDirection:"column", transition:O.transitions.colors, fontFamily:O.fontFamily.sans, overflow:"hidden"}, l5 = {display:"flex", alignItems:"center", justifyContent:"space-between", padding:`${O.spacing[3]}px ${O.spacing[4]}px`, borderBottom:`1px solid ${O.colors.border.default}`, fontWeight:O.fontWeight.semibold, fontSize:O.fontSize.lg}, 
c5 = {flex:1, minHeight:0}, u5 = {display:"flex", alignItems:"center", justifyContent:"flex-end", gap:`${O.spacing[2]}px`, padding:`${O.spacing[3]}px ${O.spacing[4]}px`, borderTop:`1px solid ${O.colors.border.default}`}, Mn = (0,require$react.forwardRef)(({variant:t = "default", interactive:e = !1, padding:n = "md", radius:r = "md", header:i, title:s, extra:o, children:a, footer:l, onClick:c, style:u}, h) => {
  const f = e || typeof c == "function", p = dw[n].padding, g = {...a5, ...s5[t], padding:i || l ? void 0 : p, borderRadius:o5[r], cursor:f ? "pointer" : "default"}, m = w => {
    f && (w.key === "Enter" || w.key === " ") && (w.preventDefault(), c == null || c({...w, currentTarget:w.currentTarget}));
  }, b = i !== void 0 || s !== void 0 || o !== void 0, x = b || l ? dw[n].padding : void 0;
  return (0,require$react_SLASH_jsx_runtime.jsxs)("div", {ref:h, "data-component":"card", "data-variant":t, "data-interactive":f || void 0, role:f ? "button" : "region", tabIndex:f ? 0 : void 0, onClick:f ? c : void 0, onKeyDown:f ? m : void 0, style:{...g, ...u}, children:[b && (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:l5, children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{display:"flex", alignItems:"center", gap:O.spacing[2]}, children:[i, s && !i && (0,require$react_SLASH_jsx_runtime.jsx)("span", 
  {children:s})]}), o && (0,require$react_SLASH_jsx_runtime.jsx)("div", {children:o})]}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{...c5, padding:x}, children:a}), l !== void 0 && (0,require$react_SLASH_jsx_runtime.jsx)("div", {style:u5, children:l})]});
});
Mn.displayName = "Card";
`${O.colors.border.default}`, O.fontSize.lg;
`${O.colors.border.default}`;
const d5 = {sm:{maxWidth:"400px"}, md:{maxWidth:"600px"}, lg:{maxWidth:"800px"}, xl:{maxWidth:"1000px"}, full:{maxWidth:"calc(100vw - 64px)", maxHeight:"calc(100vh - 64px)"}}, h5 = {position:"fixed", inset:0, backgroundColor:"var(--token-colors-background-overlay)", backdropFilter:"blur(4px)", zIndex:O.zIndex.modal, display:"flex", alignItems:"center", justifyContent:"center", padding:"32px"}, f5 = {backgroundColor:O.colors.background.elevated, borderRadius:O.radius.lg, boxShadow:O.shadow["2xl"], 
border:`1px solid ${O.colors.border.subtle}`, display:"flex", flexDirection:"column", width:"100%", maxHeight:"calc(100vh - 64px)", fontFamily:O.fontFamily.sans}, p5 = {display:"flex", alignItems:"center", justifyContent:"space-between", padding:`${O.spacing[4]}px ${O.spacing[5]}px`, borderBottom:`1px solid ${O.colors.border.default}`, fontWeight:O.fontWeight.semibold, fontSize:O.fontSize.lg}, g5 = {flex:1, padding:`${O.spacing[4]}px ${O.spacing[5]}px`, overflowY:"auto"}, m5 = {display:"flex", alignItems:"center", 
justifyContent:"flex-end", gap:`${O.spacing[2]}px`, padding:`${O.spacing[3]}px ${O.spacing[5]}px`, borderTop:`1px solid ${O.colors.border.default}`}, b5 = {background:"none", border:"none", cursor:"pointer", padding:`${O.spacing[1]}px`, fontSize:"20px", lineHeight:1, color:O.colors.text.muted, transition:O.transitions.colors}, CT = (0,require$react.forwardRef)(({open:t = !1, onClose:e, size:n = "md", closable:r = !0, closeOnBackdrop:i = !0, closeOnEscape:s = !0, centered:o = !0, scrollBehavior:a = 
"inside", header:l, title:c, children:u, footer:h}, f) => {
  const p = (0,require$react.useRef)(null), g = (0,require$react.useRef)(null), m = (0,require$react.useId)(), b = (0,require$react.useId)();
  (0,require$react.useEffect)(() => {
    var I;
    if (t) {
      return g.current = document.activeElement, (I = p.current) == null || I.focus(), document.body.style.overflow = "hidden", () => {
        var _;
        document.body.style.overflow = "", (_ = g.current) == null || _.focus();
      };
    }
  }, [t]);
  const x = (0,require$react.useCallback)(I => {
    I.key === "Escape" && r && s && e();
  }, [r, s, e]), w = (0,require$react.useCallback)(I => {
    i && r && I.target === I.currentTarget && e();
  }, [i, r, e]), v = (0,require$react.useCallback)(I => {
    var _;
    if (I.key === "Tab") {
      const N = (_ = p.current) == null ? void 0 : _.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex\x3d"-1"])');
      if (!N || N.length === 0) {
        return;
      }
      const E = N[0], C = N[N.length - 1];
      I.shiftKey && document.activeElement === E ? (I.preventDefault(), C.focus()) : !I.shiftKey && document.activeElement === C && (I.preventDefault(), E.focus());
    }
  }, []);
  if (!t) {
    return null;
  }
  const T = (0,require$react_SLASH_jsx_runtime.jsx)("div", {"data-component":"modal", "data-size":n, "data-open":t, style:h5, onClick:w, onKeyDown:x, children:(0,require$react_SLASH_jsx_runtime.jsxs)("div", {ref:I => {
    p.current = I, typeof f == "function" ? f(I) : f && (f.current = I);
  }, role:"dialog", "aria-modal":"true", "aria-labelledby":c ? m : void 0, tabIndex:-1, style:{...f5, ...d5[n]}, onKeyDown:v, children:[(l !== void 0 || c !== void 0) && (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:p5, children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {id:m, style:{display:"flex", alignItems:"center", gap:O.spacing[2]}, children:[l, c && !l && (0,require$react_SLASH_jsx_runtime.jsx)("span", {children:c})]}), r && (0,require$react_SLASH_jsx_runtime.jsx)("button", 
  {type:"button", style:b5, onClick:e, "aria-label":"Close modal", children:"\u00d7"})]}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {id:b, style:g5, children:u}), h !== void 0 && (0,require$react_SLASH_jsx_runtime.jsx)("div", {style:m5, children:h})]})});
  return (0,require$react_dom.createPortal)(T, document.body);
});
CT.displayName = "Modal";
const y5 = {display:"flex", alignItems:"center", justifyContent:"space-between", padding:`${O.spacing[4]}px ${O.spacing[5]}px`, borderBottom:`1px solid ${O.colors.border.default}`, fontWeight:O.fontWeight.semibold, fontSize:O.fontSize.lg, gap:`${O.spacing[2]}px`};
function x5({children:t, style:e, className:n}) {
  return (0,require$react_SLASH_jsx_runtime.jsx)("div", {"data-component":"modal-header", style:{...y5, ...e}, className:n, children:t});
}
const v5 = {flex:1, padding:`${O.spacing[4]}px ${O.spacing[5]}px`, overflowY:"auto"};
function w5({children:t, style:e, className:n}) {
  return (0,require$react_SLASH_jsx_runtime.jsx)("div", {"data-component":"modal-body", style:{...v5, ...e}, className:n, children:t});
}
const _5 = {display:"flex", alignItems:"center", justifyContent:"flex-end", gap:`${O.spacing[2]}px`, padding:`${O.spacing[3]}px ${O.spacing[5]}px`, borderTop:`1px solid ${O.colors.border.default}`};
function S5({children:t, style:e, className:n}) {
  return (0,require$react_SLASH_jsx_runtime.jsx)("div", {"data-component":"modal-footer", style:{..._5, ...e}, className:n, children:t});
}
O.colors.background.surface, O.colors.text.default, O.fontSize.xs, O.radius.sm, O.shadow.md;
const k5 = {sm:{padding:`${O.spacing[1]}px ${O.spacing[2]}px`, fontSize:O.fontSize.sm}, md:{padding:`${O.spacing[2]}px ${O.spacing[3]}px`, fontSize:O.fontSize.base}, lg:{padding:`${O.spacing[3]}px ${O.spacing[4]}px`, fontSize:O.fontSize.lg}}, E5 = {default:{backgroundColor:O.colors.background.default, border:`1px solid ${O.colors.border.default}`}, filled:{backgroundColor:O.colors.background.surface, border:"1px solid transparent"}, unstyled:{backgroundColor:"transparent", border:"none", padding:0}}, 
T5 = {width:"100%", fontFamily:O.fontFamily.sans, color:O.colors.text.default, borderRadius:O.radius.sm, outline:"none", transition:O.transitions.colors}, C5 = {borderColor:O.colors.border.error}, A5 = {backgroundColor:O.colors.background.surface, color:O.colors.text.muted, cursor:"not-allowed", opacity:0.7}, N5 = {borderColor:O.colors.border.focus, boxShadow:`0 0 0 2px ${O.colors.alpha.blue._35}`}, hw = {position:"absolute", top:"50%", transform:"translateY(-50%)", display:"flex", alignItems:"center", 
justifyContent:"center", color:O.colors.text.muted, pointerEvents:"none"}, I5 = {fontSize:O.fontSize.xs, color:O.colors.border.error, marginTop:`${O.spacing[1]}px`}, Cn = (0,require$react.forwardRef)(({type:t = "text", value:e, defaultValue:n, placeholder:r, size:i = "md", variant:s = "default", disabled:o = !1, readonly:a = !1, required:l = !1, error:c = !1, errorMessage:u, leftIcon:h, rightIcon:f, onChange:p, onFocus:g, onBlur:m, name:b, id:x, autoFocus:w, autoComplete:v, maxLength:T, minLength:I, 
pattern:_}, N) => {
  const [E, C] = (0,require$react.useState)(!1), k = F => {
    C(!0), g == null || g(F);
  }, A = F => {
    C(!1), m == null || m(F);
  }, P = {...T5, ...E5[s], ...(s !== "unstyled" ? k5[i] : {}), ...(c ? C5 : {}), ...(o ? A5 : {}), ...(E && !o && s !== "unstyled" ? N5 : {}), paddingLeft:h && s !== "unstyled" ? "32px" : void 0, paddingRight:f && s !== "unstyled" ? "32px" : void 0};
  return (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{position:"relative", width:"100%"}, children:[h && s !== "unstyled" && (0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{...hw, left:`${O.spacing[2]}px`}, children:h}), (0,require$react_SLASH_jsx_runtime.jsx)("input", {ref:N, "data-component":"input", "data-size":i, "data-variant":s, "data-error":c || void 0, "data-disabled":o || void 0, type:t, value:e, defaultValue:n, placeholder:r, disabled:o, readOnly:a, required:l, name:b, 
  id:x, autoFocus:w, autoComplete:v, maxLength:T, minLength:I, pattern:_, style:P, onChange:p, onFocus:k, onBlur:A, "aria-invalid":c, "aria-describedby":c && u ? `${x}-error` : void 0}), f && s !== "unstyled" && (0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{...hw, right:`${O.spacing[2]}px`}, children:f}), c && u && (0,require$react_SLASH_jsx_runtime.jsx)("div", {id:`${x}-error`, style:I5, role:"alert", children:u})]});
});
Cn.displayName = "Input";
const O5 = {sm:{padding:`${O.spacing[1]}px ${O.spacing[2]}px`, fontSize:O.fontSize.sm}, md:{padding:`${O.spacing[2]}px ${O.spacing[3]}px`, fontSize:O.fontSize.base}, lg:{padding:`${O.spacing[3]}px ${O.spacing[4]}px`, fontSize:O.fontSize.lg}}, P5 = {default:{backgroundColor:"transparent"}, filled:{backgroundColor:O.colors.background.surface}, unstyled:{backgroundColor:"transparent", border:"none", padding:0}}, R5 = {display:"inline-flex", alignItems:"center", borderRadius:O.radius.md, border:`1px solid ${O.colors.border.default}`, 
color:O.colors.text.default, fontFamily:O.fontFamily.sans, lineHeight:O.lineHeight.normal, cursor:"pointer", appearance:"none", backgroundImage:`url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12' fill='none'%3E%3Cpath d='M2.5 4.5L6 8L9.5 4.5' stroke='%2375715e' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E")`, backgroundRepeat:"no-repeat", backgroundPosition:`right ${O.spacing[2]}px center`, paddingRight:`${O.spacing[6]}px`, 
transition:O.transitions.colors}, D5 = {borderColor:O.colors.border.error}, L5 = {opacity:0.5, cursor:"not-allowed"}, AT = (0,require$react.forwardRef)(({size:t = "md", variant:e = "default", error:n = !1, errorMessage:r, options:i, placeholder:s, children:o, className:a, disabled:l, style:c, ...u}, h) => {
  const f = {...R5, ...O5[t], ...P5[e], ...(n ? D5 : {}), ...(l ? L5 : {}), ...c};
  return (0,require$react_SLASH_jsx_runtime.jsxs)("div", {"data-component":"select-wrapper", style:{display:"inline-flex", flexDirection:"column", gap:`${O.spacing[1]}px`}, children:[(0,require$react_SLASH_jsx_runtime.jsxs)("select", {ref:h, "data-component":"select", "data-size":t, "data-variant":e, "data-error":n || void 0, disabled:l, style:f, className:a, ...u, children:[s && (0,require$react_SLASH_jsx_runtime.jsx)("option", {value:"", disabled:!0, children:s}), i == null ? void 0 : i.map(p => 
  (0,require$react_SLASH_jsx_runtime.jsx)("option", {value:p.value, disabled:p.disabled, children:p.label}, p.value)), o]}), n && r && (0,require$react_SLASH_jsx_runtime.jsx)("span", {style:{fontSize:O.fontSize.xs, color:O.colors.accent.red}, children:r})]});
});
AT.displayName = "Select";
const M5 = {sm:{padding:`${O.spacing[1]}px ${O.spacing[2]}px`, fontSize:O.fontSize.sm}, md:{padding:`${O.spacing[2]}px ${O.spacing[3]}px`, fontSize:O.fontSize.base}, lg:{padding:`${O.spacing[3]}px ${O.spacing[4]}px`, fontSize:O.fontSize.lg}}, B5 = {default:{backgroundColor:"transparent"}, filled:{backgroundColor:O.colors.background.surface}, unstyled:{backgroundColor:"transparent", border:"none", padding:0}}, $5 = {display:"block", width:"100%", borderRadius:O.radius.md, border:`1px solid ${O.colors.border.default}`, 
color:O.colors.text.default, fontFamily:O.fontFamily.sans, lineHeight:O.lineHeight.normal, resize:"vertical", transition:O.transitions.colors}, F5 = {borderColor:O.colors.border.error}, z5 = {opacity:0.5, cursor:"not-allowed"}, H5 = (0,require$react.forwardRef)(({size:t = "md", variant:e = "default", error:n = !1, errorMessage:r, className:i, disabled:s, style:o, ...a}, l) => {
  const c = {...$5, ...M5[t], ...B5[e], ...(n ? F5 : {}), ...(s ? z5 : {}), ...o};
  return (0,require$react_SLASH_jsx_runtime.jsxs)("div", {"data-component":"textarea-wrapper", style:{display:"flex", flexDirection:"column", gap:`${O.spacing[1]}px`}, children:[(0,require$react_SLASH_jsx_runtime.jsx)("textarea", {ref:l, "data-component":"textarea", "data-size":t, "data-variant":e, "data-error":n || void 0, disabled:s, style:c, className:i, ...a}), n && r && (0,require$react_SLASH_jsx_runtime.jsx)("span", {style:{fontSize:O.fontSize.xs, color:O.colors.accent.red}, children:r})]});
});
H5.displayName = "Textarea";
`${O.colors.alpha.blue._80}${O.colors.accent.cyan}`, `${O.colors.alpha.green._80}${O.colors.accent.green}`, `${O.colors.alpha.orange._40}${O.colors.accent.orange}`, `${O.colors.alpha.red._45}${O.colors.accent.red}`, `${O.colors.alpha.blue._80}${O.colors.accent.blue}`, `${O.colors.alpha.blue._95}${O.colors.alpha.green._80}${O.colors.alpha.magenta._30}`;
O.colors.background.surface, O.radius.sm;
O.radius.sm;
O.fontSize.xs, O.colors.text.muted;
O.fontSize.xs, O.colors.text.muted;
const U5 = `
@keyframes devel-progress-indeterminate {
  0% { transform: translateX(-100%); }
  100% { transform: translateX(200%); }
}
`, W5 = `
@keyframes devel-progress-striped {
  0% { background-position: 1rem 0; }
  100% { background-position: 0 0; }
}
`;
if (typeof document < "u") {
  const t = document.createElement("style");
  t.textContent = U5 + W5, document.head.appendChild(t);
}
`${O.colors.border.default}`, O.colors.background.default;
O.colors.text.default;
O.colors.text.muted;
O.colors.text.secondary, O.fontFamily.mono;
`${O.colors.border.default}`, O.colors.background.default;
O.colors.text.default;
O.colors.text.secondary;
`${O.colors.border.default}`, O.fontFamily.mono, O.colors.background.elevated, O.colors.text.default;
(0,require$react.createContext)(null);
O.colors.background.overlay;
O.colors.background.elevated, O.shadow["2xl"], `${O.colors.border.subtle}`, O.fontFamily.sans;
`${O.colors.border.default}`;
O.colors.text.default, O.fontSize.lg, O.fontFamily.sans;
O.fontSize.xs, O.colors.text.muted;
O.colors.background.surface;
O.colors.background.surface, O.fontSize.xs, O.colors.text.muted, O.fontFamily.mono;
O.colors.text.muted;
`${O.colors.border.default}`, O.colors.background.default, O.fontFamily.sans;
`${O.colors.border.default}`, O.fontSize.sm, O.colors.text.muted;
O.colors.background.elevated, O.fontSize.xs, O.colors.text.muted;
`${O.colors.border.default}`;
`${O.colors.border.default}`, O.colors.background.surface, O.colors.text.default, O.fontFamily.sans, O.fontSize.sm;
O.colors.button.primary.bg, O.colors.button.primary.fg, O.fontFamily.sans, O.fontSize.sm;
O.fontSize.xs, O.colors.text.muted;
O.colors.text.muted, O.fontSize.sm;
O.fontSize.xs, O.colors.text.muted;
(0,require$react.createContext)(null);
O.colors.badge.info.bg, O.colors.semantic.info, O.colors.badge.success.bg, O.colors.semantic.success, O.colors.badge.warning.bg, O.colors.semantic.warning, O.colors.badge.error.bg, O.colors.semantic.error;
O.radius.md, O.shadow.lg, O.fontFamily.sans;
O.colors.text.muted;
O.fontSize.sm, O.colors.accent.cyan;
O.fontFamily.sans, O.fontSize.sm, O.colors.text.default;
O.colors.background.surface;
O.colors.background.elevated;
O.colors.text.muted;
O.colors.background.surface, O.colors.text.muted;
O.colors.text.muted;
O.fontSize.sm, O.fontSize.base, O.fontSize.lg;
O.colors.text.muted, O.radius.xs;
`${O.colors.border.default}`, O.radius.sm, O.colors.text.muted, O.fontFamily.sans, O.fontSize.sm;
const j5 = {sm:{padding:`${O.spacing[1]}px ${O.spacing[2]}px`, fontSize:O.fontSize.sm}, md:{padding:`${O.spacing[2]}px ${O.spacing[3]}px`, fontSize:O.fontSize.base}, lg:{padding:`${O.spacing[3]}px ${O.spacing[4]}px`, fontSize:O.fontSize.lg}}, V5 = {position:"relative", width:"100%", fontFamily:O.fontFamily.sans}, q5 = {width:"100%", fontFamily:O.fontFamily.sans, color:O.colors.text.default, backgroundColor:O.colors.background.surface, border:`1px solid ${O.colors.border.default}`, borderRadius:O.radius.md, 
outline:"none", transition:O.transitions.colors, cursor:"text"}, Y5 = {borderColor:O.colors.border.focus, boxShadow:`0 0 0 2px ${O.colors.alpha.blue._35}`}, G5 = {backgroundColor:O.colors.background.surface, color:O.colors.text.muted, cursor:"not-allowed", opacity:0.7}, fw = {position:"absolute", top:"100%", left:0, right:0, marginTop:`${O.spacing[1]}px`, backgroundColor:O.colors.background.elevated, border:`1px solid ${O.colors.border.default}`, borderRadius:O.radius.md, boxShadow:O.shadow.lg, zIndex:O.zIndex.dropdown, 
maxHeight:"240px", overflow:"auto"}, pw = {padding:`${O.spacing[2]}px ${O.spacing[3]}px`, cursor:"pointer", transition:O.transitions.colors, color:O.colors.text.default}, gw = {backgroundColor:O.colors.background.elevated, fontWeight:O.fontWeight.medium}, mw = {backgroundColor:O.colors.background.surface, outline:`2px solid ${O.colors.border.focus}`, outlineOffset:"-2px"}, Q5 = {padding:`${O.spacing[4]}px ${O.spacing[3]}px`, textAlign:"center", color:O.colors.text.muted, fontSize:O.fontSize.sm}, 
K5 = {position:"absolute", width:"1px", height:"1px", padding:0, margin:"-1px", overflow:"hidden", clip:"rect(0, 0, 0, 0)", whiteSpace:"nowrap", border:0}, X5 = {padding:`${O.spacing[1]}px ${O.spacing[3]}px`, fontSize:O.fontSize.xs, fontWeight:O.fontWeight.semibold, color:O.colors.text.muted, textTransform:"uppercase", letterSpacing:"0.05em"}, J5 = {height:"1px", backgroundColor:O.colors.border.default, margin:`${O.spacing[1]}px 0`}, Z5 = {fontWeight:O.fontWeight.semibold}, e6 = {position:"absolute", 
right:`${O.spacing[2]}px`, top:"50%", transform:"translateY(-50%)", background:"none", border:"none", cursor:"pointer", padding:`${O.spacing[1]}px`, color:O.colors.text.muted, fontSize:"16px", lineHeight:1, display:"flex", alignItems:"center", justifyContent:"center", transition:O.transitions.colors}, NT = t => {
  if (typeof t == "string") {
    return t;
  }
  if (typeof t == "number") {
    return String(t);
  }
  if (typeof t == "object" && t !== null) {
    const e = t;
    if ("label" in e && typeof e.label == "string") {
      return e.label;
    }
    if ("name" in e && typeof e.name == "string") {
      return e.name;
    }
  }
  return String(t);
}, t6 = t => {
  if (typeof t == "string") {
    return t;
  }
  if (typeof t == "number") {
    return String(t);
  }
  if (typeof t == "object" && t !== null) {
    const e = t;
    if ("id" in e) {
      return String(e.id);
    }
    if ("key" in e) {
      return String(e.key);
    }
    if ("value" in e) {
      return String(e.value);
    }
  }
  return NT(t);
};
function bw(t, e) {
  if (!e) {
    return t;
  }
  const n = t.toLowerCase(), r = e.toLowerCase(), i = n.indexOf(r);
  return i === -1 ? t : (0,require$react_SLASH_jsx_runtime.jsxs)(require$react_SLASH_jsx_runtime.Fragment, {children:[t.slice(0, i), (0,require$react_SLASH_jsx_runtime.jsx)("strong", {style:Z5, children:t.slice(i, i + e.length)}), t.slice(i + e.length)]});
}
function n6({options:t, value:e, onChange:n, getOptionLabel:r = NT, getOptionKey:i = t6, placeholder:s = "Search...", disabled:o = !1, clearable:a = !1, maxSuggestions:l = 10, size:c = "md", noOptionsMessage:u = "No options found", className:h, ariaLabel:f, ariaDescribedBy:p, recentOptions:g, maxRecentOptions:m = 5, highlightMatches:b = !1}) {
  const [x, w] = (0,require$react.useState)(""), [v, T] = (0,require$react.useState)(!1), [I, _] = (0,require$react.useState)(!1), [N, E] = (0,require$react.useState)(-1), [C, k] = (0,require$react.useState)(""), A = (0,require$react.useRef)(null), P = (0,require$react.useRef)([]), W = (0,require$react.useCallback)((q, R) => R ? r(q).toLowerCase().includes(R.toLowerCase()) : !0, [r]), F = (0,require$react.useMemo)(() => g ? g.filter(q => W(q, x)).slice(0, m) : [], [g, x, m, W]), B = (0,require$react.useMemo)(() => 
  {
    const q = new Set(F.map(i));
    return t.filter(R => W(R, x)).filter(R => !q.has(i(R))).slice(0, l);
  }, [t, x, l, F, i, W]), z = (0,require$react.useMemo)(() => [...F, ...B], [F, B]), j = (0,require$react.useId)(), V = `${j}-listbox`, ne = q => `${j}-option-${q}`;
  (0,require$react.useEffect)(() => {
    E(-1);
  }, [x]), (0,require$react.useEffect)(() => {
    e != null && w(r(e));
  }, [e, r]), (0,require$react.useEffect)(() => {
    var q;
    N >= 0 && P.current[N] && ((q = P.current[N]) == null || q.scrollIntoView({block:"nearest"}));
  }, [N]), (0,require$react.useEffect)(() => {
    v && z.length > 0 && k(`${z.length} option${z.length === 1 ? "" : "s"} available`);
  }, [v, z.length]);
  const D = (0,require$react.useCallback)(q => {
    const R = r(q);
    w(R), T(!1), E(-1), k(`Selected ${R}`), n(q);
  }, [r, n]), ie = (0,require$react.useCallback)(() => {
    var q;
    w(""), E(-1), (q = A.current) == null || q.focus();
  }, []), ee = (0,require$react.useCallback)(q => {
    w(q.target.value), T(!0);
  }, []), M = (0,require$react.useCallback)(() => {
    o || (T(!0), _(!0));
  }, [o]), X = (0,require$react.useCallback)(() => {
    setTimeout(() => {
      T(!1), _(!1), E(-1);
    }, 100);
  }, []), ge = (0,require$react.useCallback)(q => {
    if (!o) {
      switch(q.key) {
        case "ArrowDown":
          q.preventDefault(), v ? N < z.length - 1 && E(R => R + 1) : T(!0);
          break;
        case "ArrowUp":
          q.preventDefault(), v && N > 0 && E(R => R - 1);
          break;
        case "Enter":
          q.preventDefault(), N >= 0 && z[N] ? D(z[N]) : z.length > 0 && D(z[0]);
          break;
        case "Escape":
          q.preventDefault(), T(!1), E(-1);
          break;
        case "Tab":
          N >= 0 && z[N] && D(z[N]);
          break;
      }
    }
  }, [o, v, N, z, D]), me = e != null ? i(e) : null, te = {...q5, ...j5[c], ...(I ? Y5 : {}), ...(o ? G5 : {}), paddingRight:a && e ? `${O.spacing[8]}px` : void 0};
  return (0,require$react_SLASH_jsx_runtime.jsxs)("div", {role:"combobox", "aria-expanded":v, "aria-haspopup":"listbox", style:V5, className:h, "data-component":"searchable-select", "data-size":c, "data-disabled":o, children:[(0,require$react_SLASH_jsx_runtime.jsx)("input", {ref:A, type:"text", value:x, placeholder:s, disabled:o, style:te, onChange:ee, onFocus:M, onBlur:X, onKeyDown:ge, "aria-label":f || s, "aria-describedby":p, "aria-autocomplete":"list", "aria-controls":v ? V : void 0, "aria-activedescendant":N >= 
  0 ? ne(N) : void 0}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {role:"status", "aria-live":"polite", style:K5, children:C}), a && e && !o && (0,require$react_SLASH_jsx_runtime.jsx)("button", {type:"button", style:e6, onClick:ie, "aria-label":"Clear selection", tabIndex:-1, children:"\u00d7"}), v && z.length > 0 && (0,require$react_SLASH_jsx_runtime.jsxs)("ul", {role:"listbox", id:V, style:fw, "data-component":"searchable-select-dropdown", children:[F.length > 0 && (0,require$react_SLASH_jsx_runtime.jsxs)(require$react_SLASH_jsx_runtime.Fragment, 
  {children:[(0,require$react_SLASH_jsx_runtime.jsx)("li", {role:"presentation", style:X5, children:"Recent"}), F.map((q, R) => {
    const $ = i(q), G = r(q), J = $ === me, U = R === N;
    return (0,require$react_SLASH_jsx_runtime.jsx)("li", {ref:le => {
      P.current[R] = le;
    }, id:ne(R), role:"option", "aria-selected":J, style:{...pw, ...(J ? gw : {}), ...(U ? mw : {})}, onClick:() => D(q), onMouseEnter:() => E(R), onMouseLeave:() => E(-1), children:b ? bw(G, x) : G}, $);
  }), B.length > 0 && (0,require$react_SLASH_jsx_runtime.jsx)("li", {role:"presentation", style:J5})]}), B.map((q, R) => {
    const $ = F.length + R, G = i(q), J = r(q), U = G === me, le = $ === N;
    return (0,require$react_SLASH_jsx_runtime.jsx)("li", {ref:be => {
      P.current[$] = be;
    }, id:ne($), role:"option", "aria-selected":U, style:{...pw, ...(U ? gw : {}), ...(le ? mw : {})}, onClick:() => D(q), onMouseEnter:() => E($), onMouseLeave:() => E(-1), children:b ? bw(J, x) : J}, G);
  })]}), v && z.length === 0 && (0,require$react_SLASH_jsx_runtime.jsx)("div", {style:fw, children:(0,require$react_SLASH_jsx_runtime.jsx)("div", {style:Q5, children:u})})]});
}
O.colors.background.surface, O.colors.background.surface, `${O.colors.border.default}`, O.colors.background.elevated, O.shadow.sm;
O.fontFamily.sans;
O.colors.background.surface;
O.fontSize.base, O.colors.text.default;
O.fontSize.sm, O.colors.text.muted;
O.fontSize.sm;
O.colors.text.muted;
O.colors.text.default;
O.colors.text.muted;
O.fontSize.sm, O.fontSize.base, O.fontSize.lg;
O.fontFamily.sans;
O.colors.text.default;
O.fontSize.sm, O.colors.text.muted;
O.fontSize.sm, O.colors.text.default;
O.fontSize.xs, O.colors.text.muted, O.colors.background.surface;
`${O.colors.border.default}`;
O.fontSize.sm, O.colors.text.muted;
O.fontSize.xs, O.colors.accent.cyan;
O.fontSize["2xl"], O.colors.text.default;
O.colors.text.muted, O.fontSize.base;
O.fontSize.xs, O.colors.accent.cyan;
O.fontSize.xl, O.colors.text.default;
O.colors.text.muted, O.fontSize.sm;
O.colors.border.default, O.colors.badge.info.fg, O.colors.badge.success.fg, O.colors.badge.warning.fg, O.colors.badge.error.fg;
O.colors.text.muted, O.fontSize.sm;
O.fontSize["2xl"], O.colors.text.default;
O.colors.text.muted, O.fontSize.sm;
`${O.colors.accent.blue}${O.colors.alpha.blue._35}`;
O.fontFamily.sans, O.fontSize.sm;
O.fontSize.xs;
O.colors.text.muted, `${O.colors.border.default}`;
O.colors.background.surface;
`${O.colors.border.subtle}`, O.colors.text.default;
O.colors.text.muted, O.fontSize.sm;
O.colors.text.muted;
`${O.colors.border.default}`, O.colors.background.surface;
`${O.colors.border.default}`, O.colors.background.default, O.colors.text.default, O.fontFamily.sans, O.fontSize.sm;
O.colors.text.muted;
O.fontSize.sm, O.colors.text.secondary, O.fontFamily.sans;
function yw(t) {
  const e = [], n = String(t || "");
  let r = n.indexOf(","), i = 0, s = !1;
  for (; !s;) {
    r === -1 && (r = n.length, s = !0);
    const o = n.slice(i, r).trim();
    (o || !s) && e.push(o), i = r + 1, r = n.indexOf(",", i);
  }
  return e;
}
function IT(t, e) {
  const n = {};
  return (t[t.length - 1] === "" ? [...t, ""] : t).join((n.padRight ? " " : "") + "," + (n.padLeft === !1 ? "" : " ")).trim();
}
const r6 = /^[$_\p{ID_Start}][$_\u{200C}\u{200D}\p{ID_Continue}]*$/u, i6 = /^[$_\p{ID_Start}][-$_\u{200C}\u{200D}\p{ID_Continue}]*$/u, s6 = {};
function xw(t, e) {
  return (s6.jsx ? i6 : r6).test(t);
}
const o6 = /[ \t\n\f\r]/g;
function a6(t) {
  return typeof t == "object" ? t.type === "text" ? vw(t.value) : !1 : vw(t);
}
function vw(t) {
  return t.replace(o6, "") === "";
}
class Wd {
  constructor(e, n, r) {
    this.normal = n, this.property = e, r && (this.space = r);
  }
}
Wd.prototype.normal = {};
Wd.prototype.property = {};
Wd.prototype.space = void 0;
function OT(t, e) {
  const n = {}, r = {};
  for (const i of t) {
    Object.assign(n, i.property), Object.assign(r, i.normal);
  }
  return new Wd(n, r, e);
}
function ld(t) {
  return t.toLowerCase();
}
class ri {
  constructor(e, n) {
    this.attribute = n, this.property = e;
  }
}
ri.prototype.attribute = "";
ri.prototype.booleanish = !1;
ri.prototype.boolean = !1;
ri.prototype.commaOrSpaceSeparated = !1;
ri.prototype.commaSeparated = !1;
ri.prototype.defined = !1;
ri.prototype.mustUseProperty = !1;
ri.prototype.number = !1;
ri.prototype.overloadedBoolean = !1;
ri.prototype.property = "";
ri.prototype.spaceSeparated = !1;
ri.prototype.space = void 0;
let l6 = 0;
const wt = sl(), Yn = sl(), lb = sl(), Ve = sl(), dn = sl(), za = sl(), hi = sl();
function sl() {
  return 2 ** ++l6;
}
const cb = Object.freeze(Object.defineProperty({__proto__:null, boolean:wt, booleanish:Yn, commaOrSpaceSeparated:hi, commaSeparated:za, number:Ve, overloadedBoolean:lb, spaceSeparated:dn}, Symbol.toStringTag, {value:"Module"})), mm = Object.keys(cb);
class _x extends ri {
  constructor(e, n, r, i) {
    let s = -1;
    if (super(e, n), ww(this, "space", i), typeof r == "number") {
      for (; ++s < mm.length;) {
        const o = mm[s];
        ww(this, mm[s], (r & cb[o]) === cb[o]);
      }
    }
  }
}
_x.prototype.defined = !0;
function ww(t, e, n) {
  n && (t[e] = n);
}
function Sc(t) {
  const e = {}, n = {};
  for (const [r, i] of Object.entries(t.properties)) {
    const s = new _x(r, t.transform(t.attributes || {}, r), i, t.space);
    t.mustUseProperty && t.mustUseProperty.includes(r) && (s.mustUseProperty = !0), e[r] = s, n[ld(r)] = r, n[ld(s.attribute)] = r;
  }
  return new Wd(e, n, t.space);
}
const PT = Sc({properties:{ariaActiveDescendant:null, ariaAtomic:Yn, ariaAutoComplete:null, ariaBusy:Yn, ariaChecked:Yn, ariaColCount:Ve, ariaColIndex:Ve, ariaColSpan:Ve, ariaControls:dn, ariaCurrent:null, ariaDescribedBy:dn, ariaDetails:null, ariaDisabled:Yn, ariaDropEffect:dn, ariaErrorMessage:null, ariaExpanded:Yn, ariaFlowTo:dn, ariaGrabbed:Yn, ariaHasPopup:null, ariaHidden:Yn, ariaInvalid:null, ariaKeyShortcuts:null, ariaLabel:null, ariaLabelledBy:dn, ariaLevel:Ve, ariaLive:null, ariaModal:Yn, 
ariaMultiLine:Yn, ariaMultiSelectable:Yn, ariaOrientation:null, ariaOwns:dn, ariaPlaceholder:null, ariaPosInSet:Ve, ariaPressed:Yn, ariaReadOnly:Yn, ariaRelevant:null, ariaRequired:Yn, ariaRoleDescription:dn, ariaRowCount:Ve, ariaRowIndex:Ve, ariaRowSpan:Ve, ariaSelected:Yn, ariaSetSize:Ve, ariaSort:null, ariaValueMax:Ve, ariaValueMin:Ve, ariaValueNow:Ve, ariaValueText:null, role:null}, transform(t, e) {
  return e === "role" ? e : "aria-" + e.slice(4).toLowerCase();
}});
function RT(t, e) {
  return e in t ? t[e] : e;
}
function DT(t, e) {
  return RT(t, e.toLowerCase());
}
const c6 = Sc({attributes:{acceptcharset:"accept-charset", classname:"class", htmlfor:"for", httpequiv:"http-equiv"}, mustUseProperty:["checked", "multiple", "muted", "selected"], properties:{abbr:null, accept:za, acceptCharset:dn, accessKey:dn, action:null, allow:null, allowFullScreen:wt, allowPaymentRequest:wt, allowUserMedia:wt, alpha:wt, alt:null, as:null, async:wt, autoCapitalize:null, autoComplete:dn, autoFocus:wt, autoPlay:wt, blocking:dn, capture:null, charSet:null, checked:wt, cite:null, 
className:dn, closedBy:null, colorSpace:null, cols:Ve, colSpan:Ve, command:null, commandFor:null, content:null, contentEditable:Yn, controls:wt, controlsList:dn, coords:Ve | za, crossOrigin:null, data:null, dateTime:null, decoding:null, default:wt, defer:wt, dir:null, dirName:null, disabled:wt, download:lb, draggable:Yn, encType:null, enterKeyHint:null, fetchPriority:null, form:null, formAction:null, formEncType:null, formMethod:null, formNoValidate:wt, formTarget:null, headers:dn, height:Ve, hidden:lb, 
high:Ve, href:null, hrefLang:null, htmlFor:dn, httpEquiv:dn, id:null, imageSizes:null, imageSrcSet:null, inert:wt, inputMode:null, integrity:null, is:null, isMap:wt, itemId:null, itemProp:dn, itemRef:dn, itemScope:wt, itemType:dn, kind:null, label:null, lang:null, language:null, list:null, loading:null, loop:wt, low:Ve, manifest:null, max:null, maxLength:Ve, media:null, method:null, min:null, minLength:Ve, multiple:wt, muted:wt, name:null, nonce:null, noModule:wt, noValidate:wt, onAbort:null, onAfterPrint:null, 
onAuxClick:null, onBeforeMatch:null, onBeforePrint:null, onBeforeToggle:null, onBeforeUnload:null, onBlur:null, onCancel:null, onCanPlay:null, onCanPlayThrough:null, onChange:null, onClick:null, onClose:null, onContextLost:null, onContextMenu:null, onContextRestored:null, onCopy:null, onCueChange:null, onCut:null, onDblClick:null, onDrag:null, onDragEnd:null, onDragEnter:null, onDragExit:null, onDragLeave:null, onDragOver:null, onDragStart:null, onDrop:null, onDurationChange:null, onEmptied:null, 
onEnded:null, onError:null, onFocus:null, onFormData:null, onHashChange:null, onInput:null, onInvalid:null, onKeyDown:null, onKeyPress:null, onKeyUp:null, onLanguageChange:null, onLoad:null, onLoadedData:null, onLoadedMetadata:null, onLoadEnd:null, onLoadStart:null, onMessage:null, onMessageError:null, onMouseDown:null, onMouseEnter:null, onMouseLeave:null, onMouseMove:null, onMouseOut:null, onMouseOver:null, onMouseUp:null, onOffline:null, onOnline:null, onPageHide:null, onPageShow:null, onPaste:null, 
onPause:null, onPlay:null, onPlaying:null, onPopState:null, onProgress:null, onRateChange:null, onRejectionHandled:null, onReset:null, onResize:null, onScroll:null, onScrollEnd:null, onSecurityPolicyViolation:null, onSeeked:null, onSeeking:null, onSelect:null, onSlotChange:null, onStalled:null, onStorage:null, onSubmit:null, onSuspend:null, onTimeUpdate:null, onToggle:null, onUnhandledRejection:null, onUnload:null, onVolumeChange:null, onWaiting:null, onWheel:null, open:wt, optimum:Ve, pattern:null, 
ping:dn, placeholder:null, playsInline:wt, popover:null, popoverTarget:null, popoverTargetAction:null, poster:null, preload:null, readOnly:wt, referrerPolicy:null, rel:dn, required:wt, reversed:wt, rows:Ve, rowSpan:Ve, sandbox:dn, scope:null, scoped:wt, seamless:wt, selected:wt, shadowRootClonable:wt, shadowRootCustomElementRegistry:wt, shadowRootDelegatesFocus:wt, shadowRootMode:null, shadowRootSerializable:wt, shape:null, size:Ve, sizes:null, slot:null, span:Ve, spellCheck:Yn, src:null, srcDoc:null, 
srcLang:null, srcSet:null, start:Ve, step:null, style:null, tabIndex:Ve, target:null, title:null, translate:null, type:null, typeMustMatch:wt, useMap:null, value:Yn, width:Ve, wrap:null, writingSuggestions:null, align:null, aLink:null, archive:dn, axis:null, background:null, bgColor:null, border:Ve, borderColor:null, bottomMargin:Ve, cellPadding:null, cellSpacing:null, char:null, charOff:null, classId:null, clear:null, code:null, codeBase:null, codeType:null, color:null, compact:wt, declare:wt, event:null, 
face:null, frame:null, frameBorder:null, hSpace:Ve, leftMargin:Ve, link:null, longDesc:null, lowSrc:null, marginHeight:Ve, marginWidth:Ve, noResize:wt, noHref:wt, noShade:wt, noWrap:wt, object:null, profile:null, prompt:null, rev:null, rightMargin:Ve, rules:null, scheme:null, scrolling:Yn, standby:null, summary:null, text:null, topMargin:Ve, valueType:null, version:null, vAlign:null, vLink:null, vSpace:Ve, allowTransparency:null, autoCorrect:null, autoSave:null, credentialless:wt, disablePictureInPicture:wt, 
disableRemotePlayback:wt, exportParts:za, part:dn, prefix:null, property:null, results:Ve, security:null, unselectable:null}, space:"html", transform:DT}), u6 = Sc({attributes:{accentHeight:"accent-height", alignmentBaseline:"alignment-baseline", arabicForm:"arabic-form", baselineShift:"baseline-shift", capHeight:"cap-height", className:"class", clipPath:"clip-path", clipRule:"clip-rule", colorInterpolation:"color-interpolation", colorInterpolationFilters:"color-interpolation-filters", colorProfile:"color-profile", 
colorRendering:"color-rendering", crossOrigin:"crossorigin", dataType:"datatype", dominantBaseline:"dominant-baseline", enableBackground:"enable-background", fillOpacity:"fill-opacity", fillRule:"fill-rule", floodColor:"flood-color", floodOpacity:"flood-opacity", fontFamily:"font-family", fontSize:"font-size", fontSizeAdjust:"font-size-adjust", fontStretch:"font-stretch", fontStyle:"font-style", fontVariant:"font-variant", fontWeight:"font-weight", glyphName:"glyph-name", glyphOrientationHorizontal:"glyph-orientation-horizontal", 
glyphOrientationVertical:"glyph-orientation-vertical", hrefLang:"hreflang", horizAdvX:"horiz-adv-x", horizOriginX:"horiz-origin-x", horizOriginY:"horiz-origin-y", imageRendering:"image-rendering", letterSpacing:"letter-spacing", lightingColor:"lighting-color", markerEnd:"marker-end", markerMid:"marker-mid", markerStart:"marker-start", maskType:"mask-type", navDown:"nav-down", navDownLeft:"nav-down-left", navDownRight:"nav-down-right", navLeft:"nav-left", navNext:"nav-next", navPrev:"nav-prev", navRight:"nav-right", 
navUp:"nav-up", navUpLeft:"nav-up-left", navUpRight:"nav-up-right", onAbort:"onabort", onActivate:"onactivate", onAfterPrint:"onafterprint", onBeforePrint:"onbeforeprint", onBegin:"onbegin", onCancel:"oncancel", onCanPlay:"oncanplay", onCanPlayThrough:"oncanplaythrough", onChange:"onchange", onClick:"onclick", onClose:"onclose", onCopy:"oncopy", onCueChange:"oncuechange", onCut:"oncut", onDblClick:"ondblclick", onDrag:"ondrag", onDragEnd:"ondragend", onDragEnter:"ondragenter", onDragExit:"ondragexit", 
onDragLeave:"ondragleave", onDragOver:"ondragover", onDragStart:"ondragstart", onDrop:"ondrop", onDurationChange:"ondurationchange", onEmptied:"onemptied", onEnd:"onend", onEnded:"onended", onError:"onerror", onFocus:"onfocus", onFocusIn:"onfocusin", onFocusOut:"onfocusout", onHashChange:"onhashchange", onInput:"oninput", onInvalid:"oninvalid", onKeyDown:"onkeydown", onKeyPress:"onkeypress", onKeyUp:"onkeyup", onLoad:"onload", onLoadedData:"onloadeddata", onLoadedMetadata:"onloadedmetadata", onLoadStart:"onloadstart", 
onMessage:"onmessage", onMouseDown:"onmousedown", onMouseEnter:"onmouseenter", onMouseLeave:"onmouseleave", onMouseMove:"onmousemove", onMouseOut:"onmouseout", onMouseOver:"onmouseover", onMouseUp:"onmouseup", onMouseWheel:"onmousewheel", onOffline:"onoffline", onOnline:"ononline", onPageHide:"onpagehide", onPageShow:"onpageshow", onPaste:"onpaste", onPause:"onpause", onPlay:"onplay", onPlaying:"onplaying", onPopState:"onpopstate", onProgress:"onprogress", onRateChange:"onratechange", onRepeat:"onrepeat", 
onReset:"onreset", onResize:"onresize", onScroll:"onscroll", onSeeked:"onseeked", onSeeking:"onseeking", onSelect:"onselect", onShow:"onshow", onStalled:"onstalled", onStorage:"onstorage", onSubmit:"onsubmit", onSuspend:"onsuspend", onTimeUpdate:"ontimeupdate", onToggle:"ontoggle", onUnload:"onunload", onVolumeChange:"onvolumechange", onWaiting:"onwaiting", onZoom:"onzoom", overlinePosition:"overline-position", overlineThickness:"overline-thickness", paintOrder:"paint-order", panose1:"panose-1", 
pointerEvents:"pointer-events", referrerPolicy:"referrerpolicy", renderingIntent:"rendering-intent", shapeRendering:"shape-rendering", stopColor:"stop-color", stopOpacity:"stop-opacity", strikethroughPosition:"strikethrough-position", strikethroughThickness:"strikethrough-thickness", strokeDashArray:"stroke-dasharray", strokeDashOffset:"stroke-dashoffset", strokeLineCap:"stroke-linecap", strokeLineJoin:"stroke-linejoin", strokeMiterLimit:"stroke-miterlimit", strokeOpacity:"stroke-opacity", strokeWidth:"stroke-width", 
tabIndex:"tabindex", textAnchor:"text-anchor", textDecoration:"text-decoration", textRendering:"text-rendering", transformOrigin:"transform-origin", typeOf:"typeof", underlinePosition:"underline-position", underlineThickness:"underline-thickness", unicodeBidi:"unicode-bidi", unicodeRange:"unicode-range", unitsPerEm:"units-per-em", vAlphabetic:"v-alphabetic", vHanging:"v-hanging", vIdeographic:"v-ideographic", vMathematical:"v-mathematical", vectorEffect:"vector-effect", vertAdvY:"vert-adv-y", vertOriginX:"vert-origin-x", 
vertOriginY:"vert-origin-y", wordSpacing:"word-spacing", writingMode:"writing-mode", xHeight:"x-height", playbackOrder:"playbackorder", timelineBegin:"timelinebegin"}, properties:{about:hi, accentHeight:Ve, accumulate:null, additive:null, alignmentBaseline:null, alphabetic:Ve, amplitude:Ve, arabicForm:null, ascent:Ve, attributeName:null, attributeType:null, azimuth:Ve, bandwidth:null, baselineShift:null, baseFrequency:null, baseProfile:null, bbox:null, begin:null, bias:Ve, by:null, calcMode:null, 
capHeight:Ve, className:dn, clip:null, clipPath:null, clipPathUnits:null, clipRule:null, color:null, colorInterpolation:null, colorInterpolationFilters:null, colorProfile:null, colorRendering:null, content:null, contentScriptType:null, contentStyleType:null, crossOrigin:null, cursor:null, cx:null, cy:null, d:null, dataType:null, defaultAction:null, descent:Ve, diffuseConstant:Ve, direction:null, display:null, dur:null, divisor:Ve, dominantBaseline:null, download:wt, dx:null, dy:null, edgeMode:null, 
editable:null, elevation:Ve, enableBackground:null, end:null, event:null, exponent:Ve, externalResourcesRequired:null, fill:null, fillOpacity:Ve, fillRule:null, filter:null, filterRes:null, filterUnits:null, floodColor:null, floodOpacity:null, focusable:null, focusHighlight:null, fontFamily:null, fontSize:null, fontSizeAdjust:null, fontStretch:null, fontStyle:null, fontVariant:null, fontWeight:null, format:null, fr:null, from:null, fx:null, fy:null, g1:za, g2:za, glyphName:za, glyphOrientationHorizontal:null, 
glyphOrientationVertical:null, glyphRef:null, gradientTransform:null, gradientUnits:null, handler:null, hanging:Ve, hatchContentUnits:null, hatchUnits:null, height:null, href:null, hrefLang:null, horizAdvX:Ve, horizOriginX:Ve, horizOriginY:Ve, id:null, ideographic:Ve, imageRendering:null, initialVisibility:null, in:null, in2:null, intercept:Ve, k:Ve, k1:Ve, k2:Ve, k3:Ve, k4:Ve, kernelMatrix:hi, kernelUnitLength:null, keyPoints:null, keySplines:null, keyTimes:null, kerning:null, lang:null, lengthAdjust:null, 
letterSpacing:null, lightingColor:null, limitingConeAngle:Ve, local:null, markerEnd:null, markerMid:null, markerStart:null, markerHeight:null, markerUnits:null, markerWidth:null, mask:null, maskContentUnits:null, maskType:null, maskUnits:null, mathematical:null, max:null, media:null, mediaCharacterEncoding:null, mediaContentEncodings:null, mediaSize:Ve, mediaTime:null, method:null, min:null, mode:null, name:null, navDown:null, navDownLeft:null, navDownRight:null, navLeft:null, navNext:null, navPrev:null, 
navRight:null, navUp:null, navUpLeft:null, navUpRight:null, numOctaves:null, observer:null, offset:null, onAbort:null, onActivate:null, onAfterPrint:null, onBeforePrint:null, onBegin:null, onCancel:null, onCanPlay:null, onCanPlayThrough:null, onChange:null, onClick:null, onClose:null, onCopy:null, onCueChange:null, onCut:null, onDblClick:null, onDrag:null, onDragEnd:null, onDragEnter:null, onDragExit:null, onDragLeave:null, onDragOver:null, onDragStart:null, onDrop:null, onDurationChange:null, onEmptied:null, 
onEnd:null, onEnded:null, onError:null, onFocus:null, onFocusIn:null, onFocusOut:null, onHashChange:null, onInput:null, onInvalid:null, onKeyDown:null, onKeyPress:null, onKeyUp:null, onLoad:null, onLoadedData:null, onLoadedMetadata:null, onLoadStart:null, onMessage:null, onMouseDown:null, onMouseEnter:null, onMouseLeave:null, onMouseMove:null, onMouseOut:null, onMouseOver:null, onMouseUp:null, onMouseWheel:null, onOffline:null, onOnline:null, onPageHide:null, onPageShow:null, onPaste:null, onPause:null, 
onPlay:null, onPlaying:null, onPopState:null, onProgress:null, onRateChange:null, onRepeat:null, onReset:null, onResize:null, onScroll:null, onSeeked:null, onSeeking:null, onSelect:null, onShow:null, onStalled:null, onStorage:null, onSubmit:null, onSuspend:null, onTimeUpdate:null, onToggle:null, onUnload:null, onVolumeChange:null, onWaiting:null, onZoom:null, opacity:null, operator:null, order:null, orient:null, orientation:null, origin:null, overflow:null, overlay:null, overlinePosition:Ve, overlineThickness:Ve, 
paintOrder:null, panose1:null, path:null, pathLength:Ve, patternContentUnits:null, patternTransform:null, patternUnits:null, phase:null, ping:dn, pitch:null, playbackOrder:null, pointerEvents:null, points:null, pointsAtX:Ve, pointsAtY:Ve, pointsAtZ:Ve, preserveAlpha:null, preserveAspectRatio:null, primitiveUnits:null, propagate:null, property:hi, r:null, radius:null, referrerPolicy:null, refX:null, refY:null, rel:hi, rev:hi, renderingIntent:null, repeatCount:null, repeatDur:null, requiredExtensions:hi, 
requiredFeatures:hi, requiredFonts:hi, requiredFormats:hi, resource:null, restart:null, result:null, rotate:null, rx:null, ry:null, scale:null, seed:null, shapeRendering:null, side:null, slope:null, snapshotTime:null, specularConstant:Ve, specularExponent:Ve, spreadMethod:null, spacing:null, startOffset:null, stdDeviation:null, stemh:null, stemv:null, stitchTiles:null, stopColor:null, stopOpacity:null, strikethroughPosition:Ve, strikethroughThickness:Ve, string:null, stroke:null, strokeDashArray:hi, 
strokeDashOffset:null, strokeLineCap:null, strokeLineJoin:null, strokeMiterLimit:Ve, strokeOpacity:Ve, strokeWidth:null, style:null, surfaceScale:Ve, syncBehavior:null, syncBehaviorDefault:null, syncMaster:null, syncTolerance:null, syncToleranceDefault:null, systemLanguage:hi, tabIndex:Ve, tableValues:null, target:null, targetX:Ve, targetY:Ve, textAnchor:null, textDecoration:null, textRendering:null, textLength:null, timelineBegin:null, title:null, transformBehavior:null, type:null, typeOf:hi, to:null, 
transform:null, transformOrigin:null, u1:null, u2:null, underlinePosition:Ve, underlineThickness:Ve, unicode:null, unicodeBidi:null, unicodeRange:null, unitsPerEm:Ve, values:null, vAlphabetic:Ve, vMathematical:Ve, vectorEffect:null, vHanging:Ve, vIdeographic:Ve, version:null, vertAdvY:Ve, vertOriginX:Ve, vertOriginY:Ve, viewBox:null, viewTarget:null, visibility:null, width:null, widths:null, wordSpacing:null, writingMode:null, x:null, x1:null, x2:null, xChannelSelector:null, xHeight:Ve, y:null, y1:null, 
y2:null, yChannelSelector:null, z:null, zoomAndPan:null}, space:"svg", transform:RT}), LT = Sc({properties:{xLinkActuate:null, xLinkArcRole:null, xLinkHref:null, xLinkRole:null, xLinkShow:null, xLinkTitle:null, xLinkType:null}, space:"xlink", transform(t, e) {
  return "xlink:" + e.slice(5).toLowerCase();
}}), MT = Sc({attributes:{xmlnsxlink:"xmlns:xlink"}, properties:{xmlnsXLink:null, xmlns:null}, space:"xmlns", transform:DT}), BT = Sc({properties:{xmlBase:null, xmlLang:null, xmlSpace:null}, space:"xml", transform(t, e) {
  return "xml:" + e.slice(3).toLowerCase();
}}), d6 = {classId:"classID", dataType:"datatype", itemId:"itemID", strokeDashArray:"strokeDasharray", strokeDashOffset:"strokeDashoffset", strokeLineCap:"strokeLinecap", strokeLineJoin:"strokeLinejoin", strokeMiterLimit:"strokeMiterlimit", typeOf:"typeof", xLinkActuate:"xlinkActuate", xLinkArcRole:"xlinkArcrole", xLinkHref:"xlinkHref", xLinkRole:"xlinkRole", xLinkShow:"xlinkShow", xLinkTitle:"xlinkTitle", xLinkType:"xlinkType", xmlnsXLink:"xmlnsXlink"}, h6 = /[A-Z]/g, _w = /-[a-z]/g, f6 = /^data[-\w.:]+$/i;
function pg(t, e) {
  const n = ld(e);
  let r = e, i = ri;
  if (n in t.normal) {
    return t.property[t.normal[n]];
  }
  if (n.length > 4 && n.slice(0, 4) === "data" && f6.test(e)) {
    if (e.charAt(4) === "-") {
      const s = e.slice(5).replace(_w, g6);
      r = "data" + s.charAt(0).toUpperCase() + s.slice(1);
    } else {
      const s = e.slice(4);
      if (!_w.test(s)) {
        let o = s.replace(h6, p6);
        o.charAt(0) !== "-" && (o = "-" + o), e = "data" + o;
      }
    }
    i = _x;
  }
  return new i(r, e);
}
function p6(t) {
  return "-" + t.toLowerCase();
}
function g6(t) {
  return t.charAt(1).toUpperCase();
}
const jd = OT([PT, c6, LT, MT, BT], "html"), sa = OT([PT, u6, LT, MT, BT], "svg");
function Sw(t) {
  const e = String(t || "").trim();
  return e ? e.split(/[ \t\n\r\f]+/g) : [];
}
function $T(t) {
  return t.join(" ").trim();
}
var np = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Vd(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var Sx = {}, kw = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g, m6 = /\n/g, b6 = /^\s*/, y6 = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/, x6 = /^:\s*/, v6 = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/, w6 = /^[;\s]*/, _6 = /^\s+|\s+$/g, S6 = `
`, Ew = "/", Tw = "*", Ca = "", k6 = "comment", E6 = "declaration";
function T6(t, e) {
  if (typeof t != "string") {
    throw new TypeError("First argument must be a string");
  }
  if (!t) {
    return [];
  }
  e = e || {};
  var n = 1, r = 1;
  function i(g) {
    var m = g.match(m6);
    m && (n += m.length);
    var b = g.lastIndexOf(S6);
    r = ~b ? g.length - b : r + g.length;
  }
  function s() {
    var g = {line:n, column:r};
    return function(m) {
      return m.position = new o(g), c(), m;
    };
  }
  function o(g) {
    this.start = g, this.end = {line:n, column:r}, this.source = e.source;
  }
  o.prototype.content = t;
  function a(g) {
    var m = new Error(e.source + ":" + n + ":" + r + ": " + g);
    if (m.reason = g, m.filename = e.source, m.line = n, m.column = r, m.source = t, !e.silent) {
      throw m;
    }
  }
  function l(g) {
    var m = g.exec(t);
    if (m) {
      var b = m[0];
      return i(b), t = t.slice(b.length), m;
    }
  }
  function c() {
    l(b6);
  }
  function u(g) {
    var m;
    for (g = g || []; m = h();) {
      m !== !1 && g.push(m);
    }
    return g;
  }
  function h() {
    var g = s();
    if (!(Ew != t.charAt(0) || Tw != t.charAt(1))) {
      for (var m = 2; Ca != t.charAt(m) && (Tw != t.charAt(m) || Ew != t.charAt(m + 1));) {
        ++m;
      }
      if (m += 2, Ca === t.charAt(m - 1)) {
        return a("End of comment missing");
      }
      var b = t.slice(2, m - 2);
      return r += 2, i(b), t = t.slice(m), r += 2, g({type:k6, comment:b});
    }
  }
  function f() {
    var g = s(), m = l(y6);
    if (m) {
      if (h(), !l(x6)) {
        return a("property missing ':'");
      }
      var b = l(v6), x = g({type:E6, property:Cw(m[0].replace(kw, Ca)), value:b ? Cw(b[0].replace(kw, Ca)) : Ca});
      return l(w6), x;
    }
  }
  function p() {
    var g = [];
    u(g);
    for (var m; m = f();) {
      m !== !1 && (g.push(m), u(g));
    }
    return g;
  }
  return c(), p();
}
function Cw(t) {
  return t ? t.replace(_6, Ca) : Ca;
}
var C6 = T6, A6 = np && np.__importDefault || function(t) {
  return t && t.__esModule ? t : {default:t};
};
Object.defineProperty(Sx, "__esModule", {value:!0});
Sx.default = I6;
const N6 = A6(C6);
function I6(t, e) {
  let n = null;
  if (!t || typeof t != "string") {
    return n;
  }
  const r = (0,N6.default)(t), i = typeof e == "function";
  return r.forEach(s => {
    if (s.type !== "declaration") {
      return;
    }
    const {property:o, value:a} = s;
    i ? e(o, a, s) : a && (n = n || {}, n[o] = a);
  }), n;
}
var gg = {};
Object.defineProperty(gg, "__esModule", {value:!0});
gg.camelCase = void 0;
var O6 = /^--[a-zA-Z0-9_-]+$/, P6 = /-([a-z])/g, R6 = /^[^-]+$/, D6 = /^-(webkit|moz|ms|o|khtml)-/, L6 = /^-(ms)-/, M6 = function(t) {
  return !t || R6.test(t) || O6.test(t);
}, B6 = function(t, e) {
  return e.toUpperCase();
}, Aw = function(t, e) {
  return "".concat(e, "-");
}, $6 = function(t, e) {
  return e === void 0 && (e = {}), M6(t) ? t : (t = t.toLowerCase(), e.reactCompat ? t = t.replace(L6, Aw) : t = t.replace(D6, Aw), t.replace(P6, B6));
};
gg.camelCase = $6;
var F6 = np && np.__importDefault || function(t) {
  return t && t.__esModule ? t : {default:t};
}, z6 = F6(Sx), H6 = gg;
function ub(t, e) {
  var n = {};
  return !t || typeof t != "string" || (0,z6.default)(t, function(r, i) {
    r && i && (n[(0,H6.camelCase)(r, e)] = i);
  }), n;
}
ub.default = ub;
var U6 = ub;
const W6 = Vd(U6), mg = FT("end"), Bs = FT("start");
function FT(t) {
  return e;
  function e(n) {
    const r = n && n.position && n.position[t] || {};
    if (typeof r.line == "number" && r.line > 0 && typeof r.column == "number" && r.column > 0) {
      return {line:r.line, column:r.column, offset:typeof r.offset == "number" && r.offset > -1 ? r.offset : void 0};
    }
  }
}
function j6(t) {
  const e = Bs(t), n = mg(t);
  if (e && n) {
    return {start:e, end:n};
  }
}
function Ru(t) {
  return !t || typeof t != "object" ? "" : "position" in t || "type" in t ? Nw(t.position) : "start" in t || "end" in t ? Nw(t) : "line" in t || "column" in t ? db(t) : "";
}
function db(t) {
  return Iw(t && t.line) + ":" + Iw(t && t.column);
}
function Nw(t) {
  return db(t && t.start) + "-" + db(t && t.end);
}
function Iw(t) {
  return t && typeof t == "number" ? t : 1;
}
class Ir extends Error {
  constructor(e, n, r) {
    super(), typeof n == "string" && (r = n, n = void 0);
    let i = "", s = {}, o = !1;
    if (n && ("line" in n && "column" in n ? s = {place:n} : "start" in n && "end" in n ? s = {place:n} : "type" in n ? s = {ancestors:[n], place:n.position} : s = {...n}), typeof e == "string" ? i = e : !s.cause && e && (o = !0, i = e.message, s.cause = e), !s.ruleId && !s.source && typeof r == "string") {
      const l = r.indexOf(":");
      l === -1 ? s.ruleId = r : (s.source = r.slice(0, l), s.ruleId = r.slice(l + 1));
    }
    if (!s.place && s.ancestors && s.ancestors) {
      const l = s.ancestors[s.ancestors.length - 1];
      l && (s.place = l.position);
    }
    const a = s.place && "start" in s.place ? s.place.start : s.place;
    this.ancestors = s.ancestors || void 0, this.cause = s.cause || void 0, this.column = a ? a.column : void 0, this.fatal = void 0, this.file = "", this.message = i, this.line = a ? a.line : void 0, this.name = Ru(s.place) || "1:1", this.place = s.place || void 0, this.reason = this.message, this.ruleId = s.ruleId || void 0, this.source = s.source || void 0, this.stack = o && s.cause && typeof s.cause.stack == "string" ? s.cause.stack : "", this.actual = void 0, this.expected = void 0, this.note = 
    void 0, this.url = void 0;
  }
}
Ir.prototype.file = "";
Ir.prototype.name = "";
Ir.prototype.reason = "";
Ir.prototype.message = "";
Ir.prototype.stack = "";
Ir.prototype.column = void 0;
Ir.prototype.line = void 0;
Ir.prototype.ancestors = void 0;
Ir.prototype.cause = void 0;
Ir.prototype.fatal = void 0;
Ir.prototype.place = void 0;
Ir.prototype.ruleId = void 0;
Ir.prototype.source = void 0;
const kx = {}.hasOwnProperty, V6 = new Map(), q6 = /[A-Z]/g, Y6 = new Set(["table", "tbody", "thead", "tfoot", "tr"]), G6 = new Set(["td", "th"]), zT = "https://github.com/syntax-tree/hast-util-to-jsx-runtime";
function Q6(t, e) {
  if (!e || e.Fragment === void 0) {
    throw new TypeError("Expected `Fragment` in options");
  }
  const n = e.filePath || void 0;
  let r;
  if (e.development) {
    if (typeof e.jsxDEV != "function") {
      throw new TypeError("Expected `jsxDEV` in options when `development: true`");
    }
    r = rM(n, e.jsxDEV);
  } else {
    if (typeof e.jsx != "function") {
      throw new TypeError("Expected `jsx` in production options");
    }
    if (typeof e.jsxs != "function") {
      throw new TypeError("Expected `jsxs` in production options");
    }
    r = nM(n, e.jsx, e.jsxs);
  }
  const i = {Fragment:e.Fragment, ancestors:[], components:e.components || {}, create:r, elementAttributeNameCase:e.elementAttributeNameCase || "react", evaluater:e.createEvaluater ? e.createEvaluater() : void 0, filePath:n, ignoreInvalidStyle:e.ignoreInvalidStyle || !1, passKeys:e.passKeys !== !1, passNode:e.passNode || !1, schema:e.space === "svg" ? sa : jd, stylePropertyNameCase:e.stylePropertyNameCase || "dom", tableCellAlignToStyle:e.tableCellAlignToStyle !== !1}, s = HT(i, t, void 0);
  return s && typeof s != "string" ? s : i.create(t, i.Fragment, {children:s || void 0}, void 0);
}
function HT(t, e, n) {
  if (e.type === "element") {
    return K6(t, e, n);
  }
  if (e.type === "mdxFlowExpression" || e.type === "mdxTextExpression") {
    return X6(t, e);
  }
  if (e.type === "mdxJsxFlowElement" || e.type === "mdxJsxTextElement") {
    return Z6(t, e, n);
  }
  if (e.type === "mdxjsEsm") {
    return J6(t, e);
  }
  if (e.type === "root") {
    return eM(t, e, n);
  }
  if (e.type === "text") {
    return tM(t, e);
  }
}
function K6(t, e, n) {
  const r = t.schema;
  let i = r;
  e.tagName.toLowerCase() === "svg" && r.space === "html" && (i = sa, t.schema = i), t.ancestors.push(e);
  const s = WT(t, e.tagName, !1), o = iM(t, e);
  let a = Tx(t, e);
  return Y6.has(e.tagName) && (a = a.filter(function(l) {
    return typeof l == "string" ? !a6(l) : !0;
  })), UT(t, o, s, e), Ex(o, a), t.ancestors.pop(), t.schema = r, t.create(e, s, o, n);
}
function X6(t, e) {
  if (e.data && e.data.estree && t.evaluater) {
    const r = e.data.estree.body[0];
    return r.type, t.evaluater.evaluateExpression(r.expression);
  }
  cd(t, e.position);
}
function J6(t, e) {
  if (e.data && e.data.estree && t.evaluater) {
    return t.evaluater.evaluateProgram(e.data.estree);
  }
  cd(t, e.position);
}
function Z6(t, e, n) {
  const r = t.schema;
  let i = r;
  e.name === "svg" && r.space === "html" && (i = sa, t.schema = i), t.ancestors.push(e);
  const s = e.name === null ? t.Fragment : WT(t, e.name, !0), o = sM(t, e), a = Tx(t, e);
  return UT(t, o, s, e), Ex(o, a), t.ancestors.pop(), t.schema = r, t.create(e, s, o, n);
}
function eM(t, e, n) {
  const r = {};
  return Ex(r, Tx(t, e)), t.create(e, t.Fragment, r, n);
}
function tM(t, e) {
  return e.value;
}
function UT(t, e, n, r) {
  typeof n != "string" && n !== t.Fragment && t.passNode && (e.node = r);
}
function Ex(t, e) {
  if (e.length > 0) {
    const n = e.length > 1 ? e : e[0];
    n && (t.children = n);
  }
}
function nM(t, e, n) {
  return r;
  function r(i, s, o, a) {
    const c = Array.isArray(o.children) ? n : e;
    return a ? c(s, o, a) : c(s, o);
  }
}
function rM(t, e) {
  return n;
  function n(r, i, s, o) {
    const a = Array.isArray(s.children), l = Bs(r);
    return e(i, s, o, a, {columnNumber:l ? l.column - 1 : void 0, fileName:t, lineNumber:l ? l.line : void 0}, void 0);
  }
}
function iM(t, e) {
  const n = {};
  let r, i;
  for (i in e.properties) {
    if (i !== "children" && kx.call(e.properties, i)) {
      const s = oM(t, i, e.properties[i]);
      if (s) {
        const [o, a] = s;
        t.tableCellAlignToStyle && o === "align" && typeof a == "string" && G6.has(e.tagName) ? r = a : n[o] = a;
      }
    }
  }
  if (r) {
    const s = n.style || (n.style = {});
    s[t.stylePropertyNameCase === "css" ? "text-align" : "textAlign"] = r;
  }
  return n;
}
function sM(t, e) {
  const n = {};
  for (const r of e.attributes) {
    if (r.type === "mdxJsxExpressionAttribute") {
      if (r.data && r.data.estree && t.evaluater) {
        const s = r.data.estree.body[0];
        s.type;
        const o = s.expression;
        o.type;
        const a = o.properties[0];
        a.type, Object.assign(n, t.evaluater.evaluateExpression(a.argument));
      } else {
        cd(t, e.position);
      }
    } else {
      const i = r.name;
      let s;
      if (r.value && typeof r.value == "object") {
        if (r.value.data && r.value.data.estree && t.evaluater) {
          const a = r.value.data.estree.body[0];
          a.type, s = t.evaluater.evaluateExpression(a.expression);
        } else {
          cd(t, e.position);
        }
      } else {
        s = r.value === null ? !0 : r.value;
      }
      n[i] = s;
    }
  }
  return n;
}
function Tx(t, e) {
  const n = [];
  let r = -1;
  const i = t.passKeys ? new Map() : V6;
  for (; ++r < e.children.length;) {
    const s = e.children[r];
    let o;
    if (t.passKeys) {
      const l = s.type === "element" ? s.tagName : s.type === "mdxJsxFlowElement" || s.type === "mdxJsxTextElement" ? s.name : void 0;
      if (l) {
        const c = i.get(l) || 0;
        o = l + "-" + c, i.set(l, c + 1);
      }
    }
    const a = HT(t, s, o);
    a !== void 0 && n.push(a);
  }
  return n;
}
function oM(t, e, n) {
  const r = pg(t.schema, e);
  if (!(n == null || typeof n == "number" && Number.isNaN(n))) {
    if (Array.isArray(n) && (n = r.commaSeparated ? IT(n) : $T(n)), r.property === "style") {
      let i = typeof n == "object" ? n : aM(t, String(n));
      return t.stylePropertyNameCase === "css" && (i = lM(i)), ["style", i];
    }
    return [t.elementAttributeNameCase === "react" && r.space ? d6[r.property] || r.property : r.attribute, n];
  }
}
function aM(t, e) {
  try {
    return W6(e, {reactCompat:!0});
  } catch (n) {
    if (t.ignoreInvalidStyle) {
      return {};
    }
    const r = n, i = new Ir("Cannot parse `style` attribute", {ancestors:t.ancestors, cause:r, ruleId:"style", source:"hast-util-to-jsx-runtime"});
    throw i.file = t.filePath || void 0, i.url = zT + "#cannot-parse-style-attribute", i;
  }
}
function WT(t, e, n) {
  let r;
  if (!n) {
    r = {type:"Literal", value:e};
  } else if (e.includes(".")) {
    const i = e.split(".");
    let s = -1, o;
    for (; ++s < i.length;) {
      const a = xw(i[s]) ? {type:"Identifier", name:i[s]} : {type:"Literal", value:i[s]};
      o = o ? {type:"MemberExpression", object:o, property:a, computed:!!(s && a.type === "Literal"), optional:!1} : a;
    }
    r = o;
  } else {
    r = xw(e) && !/^[a-z]/.test(e) ? {type:"Identifier", name:e} : {type:"Literal", value:e};
  }
  if (r.type === "Literal") {
    const i = r.value;
    return kx.call(t.components, i) ? t.components[i] : i;
  }
  if (t.evaluater) {
    return t.evaluater.evaluateExpression(r);
  }
  cd(t);
}
function cd(t, e) {
  const n = new Ir("Cannot handle MDX estrees without `createEvaluater`", {ancestors:t.ancestors, place:e, ruleId:"mdx-estree", source:"hast-util-to-jsx-runtime"});
  throw n.file = t.filePath || void 0, n.url = zT + "#cannot-handle-mdx-estrees-without-createevaluater", n;
}
function lM(t) {
  const e = {};
  let n;
  for (n in t) {
    kx.call(t, n) && (e[cM(n)] = t[n]);
  }
  return e;
}
function cM(t) {
  let e = t.replace(q6, uM);
  return e.slice(0, 3) === "ms-" && (e = "-" + e), e;
}
function uM(t) {
  return "-" + t.toLowerCase();
}
const bm = {action:["form"], cite:["blockquote", "del", "ins", "q"], data:["object"], formAction:["button", "input"], href:["a", "area", "base", "link"], icon:["menuitem"], itemId:null, manifest:["html"], ping:["a", "area"], poster:["video"], src:["audio", "embed", "iframe", "img", "input", "script", "source", "track", "video"]}, dM = {};
function Cx(t, e) {
  const n = dM, r = typeof n.includeImageAlt == "boolean" ? n.includeImageAlt : !0, i = typeof n.includeHtml == "boolean" ? n.includeHtml : !0;
  return jT(t, r, i);
}
function jT(t, e, n) {
  if (hM(t)) {
    if ("value" in t) {
      return t.type === "html" && !n ? "" : t.value;
    }
    if (e && "alt" in t && t.alt) {
      return t.alt;
    }
    if ("children" in t) {
      return Ow(t.children, e, n);
    }
  }
  return Array.isArray(t) ? Ow(t, e, n) : "";
}
function Ow(t, e, n) {
  const r = [];
  let i = -1;
  for (; ++i < t.length;) {
    r[i] = jT(t[i], e, n);
  }
  return r.join("");
}
function hM(t) {
  return !!(t && typeof t == "object");
}
const Pw = document.createElement("i");
function Ax(t) {
  const e = "\x26" + t + ";";
  Pw.innerHTML = e;
  const n = Pw.textContent;
  return n.charCodeAt(n.length - 1) === 59 && t !== "semi" || n === e ? !1 : n;
}
function yi(t, e, n, r) {
  const i = t.length;
  let s = 0, o;
  if (e < 0 ? e = -e > i ? 0 : i + e : e = e > i ? i : e, n = n > 0 ? n : 0, r.length < 1e4) {
    o = Array.from(r), o.unshift(e, n), t.splice(...o);
  } else {
    for (n && t.splice(e, n); s < r.length;) {
      o = r.slice(s, s + 1e4), o.unshift(e, 0), t.splice(...o), s += 1e4, e += 1e4;
    }
  }
}
function Ai(t, e) {
  return t.length > 0 ? (yi(t, t.length, 0, e), t) : e;
}
const Rw = {}.hasOwnProperty;
function VT(t) {
  const e = {};
  let n = -1;
  for (; ++n < t.length;) {
    fM(e, t[n]);
  }
  return e;
}
function fM(t, e) {
  let n;
  for (n in e) {
    const i = (Rw.call(t, n) ? t[n] : void 0) || (t[n] = {}), s = e[n];
    let o;
    if (s) {
      for (o in s) {
        Rw.call(i, o) || (i[o] = []);
        const a = s[o];
        pM(i[o], Array.isArray(a) ? a : a ? [a] : []);
      }
    }
  }
}
function pM(t, e) {
  let n = -1;
  const r = [];
  for (; ++n < e.length;) {
    (e[n].add === "after" ? t : r).push(e[n]);
  }
  yi(t, 0, 0, r);
}
function qT(t, e) {
  const n = Number.parseInt(t, e);
  return n < 9 || n === 11 || n > 13 && n < 32 || n > 126 && n < 160 || n > 55295 && n < 57344 || n > 64975 && n < 65008 || (n & 65535) === 65535 || (n & 65535) === 65534 || n > 1114111 ? "\ufffd" : String.fromCodePoint(n);
}
function ns(t) {
  return t.replace(/[\t\n\r ]+/g, " ").replace(/^ | $/g, "").toLowerCase().toUpperCase();
}
const Fr = oa(/[A-Za-z]/), Nr = oa(/[\dA-Za-z]/), gM = oa(/[#-'*+\--9=?A-Z^-~]/);
function rp(t) {
  return t !== null && (t < 32 || t === 127);
}
const hb = oa(/\d/), mM = oa(/[\dA-Fa-f]/), bM = oa(/[!-/:-@[-`{-~]/);
function mt(t) {
  return t !== null && t < -2;
}
function gn(t) {
  return t !== null && (t < 0 || t === 32);
}
function Ft(t) {
  return t === -2 || t === -1 || t === 32;
}
const bg = oa(new RegExp("\\p{P}|\\p{S}", "u")), Ja = oa(/\s/);
function oa(t) {
  return e;
  function e(n) {
    return n !== null && n > -1 && t.test(String.fromCharCode(n));
  }
}
function kc(t) {
  const e = [];
  let n = -1, r = 0, i = 0;
  for (; ++n < t.length;) {
    const s = t.charCodeAt(n);
    let o = "";
    if (s === 37 && Nr(t.charCodeAt(n + 1)) && Nr(t.charCodeAt(n + 2))) {
      i = 2;
    } else if (s < 128) {
      /[!#$&-;=?-Z_a-z~]/.test(String.fromCharCode(s)) || (o = String.fromCharCode(s));
    } else if (s > 55295 && s < 57344) {
      const a = t.charCodeAt(n + 1);
      s < 56320 && a > 56319 && a < 57344 ? (o = String.fromCharCode(s, a), i = 1) : o = "\ufffd";
    } else {
      o = String.fromCharCode(s);
    }
    o && (e.push(t.slice(r, n), encodeURIComponent(o)), r = n + i + 1, o = ""), i && (n += i, i = 0);
  }
  return e.join("") + t.slice(r);
}
function Gt(t, e, n, r) {
  const i = r ? r - 1 : Number.POSITIVE_INFINITY;
  let s = 0;
  return o;
  function o(l) {
    return Ft(l) ? (t.enter(n), a(l)) : e(l);
  }
  function a(l) {
    return Ft(l) && s++ < i ? (t.consume(l), a) : (t.exit(n), e(l));
  }
}
const yM = {tokenize:xM};
function xM(t) {
  const e = t.attempt(this.parser.constructs.contentInitial, r, i);
  let n;
  return e;
  function r(a) {
    if (a === null) {
      t.consume(a);
      return;
    }
    return t.enter("lineEnding"), t.consume(a), t.exit("lineEnding"), Gt(t, e, "linePrefix");
  }
  function i(a) {
    return t.enter("paragraph"), s(a);
  }
  function s(a) {
    const l = t.enter("chunkText", {contentType:"text", previous:n});
    return n && (n.next = l), n = l, o(a);
  }
  function o(a) {
    if (a === null) {
      t.exit("chunkText"), t.exit("paragraph"), t.consume(a);
      return;
    }
    return mt(a) ? (t.consume(a), t.exit("chunkText"), s) : (t.consume(a), o);
  }
}
const vM = {tokenize:wM}, Dw = {tokenize:_M};
function wM(t) {
  const e = this, n = [];
  let r = 0, i, s, o;
  return a;
  function a(v) {
    if (r < n.length) {
      const T = n[r];
      return e.containerState = T[1], t.attempt(T[0].continuation, l, c)(v);
    }
    return c(v);
  }
  function l(v) {
    if (r++, e.containerState._closeFlow) {
      e.containerState._closeFlow = void 0, i && w();
      const T = e.events.length;
      let I = T, _;
      for (; I--;) {
        if (e.events[I][0] === "exit" && e.events[I][1].type === "chunkFlow") {
          _ = e.events[I][1].end;
          break;
        }
      }
      x(r);
      let N = T;
      for (; N < e.events.length;) {
        e.events[N][1].end = {..._}, N++;
      }
      return yi(e.events, I + 1, 0, e.events.slice(T)), e.events.length = N, c(v);
    }
    return a(v);
  }
  function c(v) {
    if (r === n.length) {
      if (!i) {
        return f(v);
      }
      if (i.currentConstruct && i.currentConstruct.concrete) {
        return g(v);
      }
      e.interrupt = !!(i.currentConstruct && !i._gfmTableDynamicInterruptHack);
    }
    return e.containerState = {}, t.check(Dw, u, h)(v);
  }
  function u(v) {
    return i && w(), x(r), f(v);
  }
  function h(v) {
    return e.parser.lazy[e.now().line] = r !== n.length, o = e.now().offset, g(v);
  }
  function f(v) {
    return e.containerState = {}, t.attempt(Dw, p, g)(v);
  }
  function p(v) {
    return r++, n.push([e.currentConstruct, e.containerState]), f(v);
  }
  function g(v) {
    if (v === null) {
      i && w(), x(0), t.consume(v);
      return;
    }
    return i = i || e.parser.flow(e.now()), t.enter("chunkFlow", {_tokenizer:i, contentType:"flow", previous:s}), m(v);
  }
  function m(v) {
    if (v === null) {
      b(t.exit("chunkFlow"), !0), x(0), t.consume(v);
      return;
    }
    return mt(v) ? (t.consume(v), b(t.exit("chunkFlow")), r = 0, e.interrupt = void 0, a) : (t.consume(v), m);
  }
  function b(v, T) {
    const I = e.sliceStream(v);
    if (T && I.push(null), v.previous = s, s && (s.next = v), s = v, i.defineSkip(v.start), i.write(I), e.parser.lazy[v.start.line]) {
      let _ = i.events.length;
      for (; _--;) {
        if (i.events[_][1].start.offset < o && (!i.events[_][1].end || i.events[_][1].end.offset > o)) {
          return;
        }
      }
      const N = e.events.length;
      let E = N, C, k;
      for (; E--;) {
        if (e.events[E][0] === "exit" && e.events[E][1].type === "chunkFlow") {
          if (C) {
            k = e.events[E][1].end;
            break;
          }
          C = !0;
        }
      }
      for (x(r), _ = N; _ < e.events.length;) {
        e.events[_][1].end = {...k}, _++;
      }
      yi(e.events, E + 1, 0, e.events.slice(N)), e.events.length = _;
    }
  }
  function x(v) {
    let T = n.length;
    for (; T-- > v;) {
      const I = n[T];
      e.containerState = I[1], I[0].exit.call(e, t);
    }
    n.length = v;
  }
  function w() {
    i.write([null]), s = void 0, i = void 0, e.containerState._closeFlow = void 0;
  }
}
function _M(t, e, n) {
  return Gt(t, t.attempt(this.parser.constructs.document, e, n), "linePrefix", this.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4);
}
function ic(t) {
  if (t === null || gn(t) || Ja(t)) {
    return 1;
  }
  if (bg(t)) {
    return 2;
  }
}
function yg(t, e, n) {
  const r = [];
  let i = -1;
  for (; ++i < t.length;) {
    const s = t[i].resolveAll;
    s && !r.includes(s) && (e = s(e, n), r.push(s));
  }
  return e;
}
const fb = {name:"attention", resolveAll:SM, tokenize:kM};
function SM(t, e) {
  let n = -1, r, i, s, o, a, l, c, u;
  for (; ++n < t.length;) {
    if (t[n][0] === "enter" && t[n][1].type === "attentionSequence" && t[n][1]._close) {
      for (r = n; r--;) {
        if (t[r][0] === "exit" && t[r][1].type === "attentionSequence" && t[r][1]._open && e.sliceSerialize(t[r][1]).charCodeAt(0) === e.sliceSerialize(t[n][1]).charCodeAt(0)) {
          if ((t[r][1]._close || t[n][1]._open) && (t[n][1].end.offset - t[n][1].start.offset) % 3 && !((t[r][1].end.offset - t[r][1].start.offset + t[n][1].end.offset - t[n][1].start.offset) % 3)) {
            continue;
          }
          l = t[r][1].end.offset - t[r][1].start.offset > 1 && t[n][1].end.offset - t[n][1].start.offset > 1 ? 2 : 1;
          const h = {...t[r][1].end}, f = {...t[n][1].start};
          Lw(h, -l), Lw(f, l), o = {type:l > 1 ? "strongSequence" : "emphasisSequence", start:h, end:{...t[r][1].end}}, a = {type:l > 1 ? "strongSequence" : "emphasisSequence", start:{...t[n][1].start}, end:f}, s = {type:l > 1 ? "strongText" : "emphasisText", start:{...t[r][1].end}, end:{...t[n][1].start}}, i = {type:l > 1 ? "strong" : "emphasis", start:{...o.start}, end:{...a.end}}, t[r][1].end = {...o.start}, t[n][1].start = {...a.end}, c = [], t[r][1].end.offset - t[r][1].start.offset && (c = 
          Ai(c, [["enter", t[r][1], e], ["exit", t[r][1], e]])), c = Ai(c, [["enter", i, e], ["enter", o, e], ["exit", o, e], ["enter", s, e]]), c = Ai(c, yg(e.parser.constructs.insideSpan.null, t.slice(r + 1, n), e)), c = Ai(c, [["exit", s, e], ["enter", a, e], ["exit", a, e], ["exit", i, e]]), t[n][1].end.offset - t[n][1].start.offset ? (u = 2, c = Ai(c, [["enter", t[n][1], e], ["exit", t[n][1], e]])) : u = 0, yi(t, r - 1, n - r + 3, c), n = r + c.length - u - 2;
          break;
        }
      }
    }
  }
  for (n = -1; ++n < t.length;) {
    t[n][1].type === "attentionSequence" && (t[n][1].type = "data");
  }
  return t;
}
function kM(t, e) {
  const n = this.parser.constructs.attentionMarkers.null, r = this.previous, i = ic(r);
  let s;
  return o;
  function o(l) {
    return s = l, t.enter("attentionSequence"), a(l);
  }
  function a(l) {
    if (l === s) {
      return t.consume(l), a;
    }
    const c = t.exit("attentionSequence"), u = ic(l), h = !u || u === 2 && i || n.includes(l), f = !i || i === 2 && u || n.includes(r);
    return c._open = !!(s === 42 ? h : h && (i || !f)), c._close = !!(s === 42 ? f : f && (u || !h)), e(l);
  }
}
function Lw(t, e) {
  t.column += e, t.offset += e, t._bufferIndex += e;
}
const EM = {name:"autolink", tokenize:TM};
function TM(t, e, n) {
  let r = 0;
  return i;
  function i(p) {
    return t.enter("autolink"), t.enter("autolinkMarker"), t.consume(p), t.exit("autolinkMarker"), t.enter("autolinkProtocol"), s;
  }
  function s(p) {
    return Fr(p) ? (t.consume(p), o) : p === 64 ? n(p) : c(p);
  }
  function o(p) {
    return p === 43 || p === 45 || p === 46 || Nr(p) ? (r = 1, a(p)) : c(p);
  }
  function a(p) {
    return p === 58 ? (t.consume(p), r = 0, l) : (p === 43 || p === 45 || p === 46 || Nr(p)) && r++ < 32 ? (t.consume(p), a) : (r = 0, c(p));
  }
  function l(p) {
    return p === 62 ? (t.exit("autolinkProtocol"), t.enter("autolinkMarker"), t.consume(p), t.exit("autolinkMarker"), t.exit("autolink"), e) : p === null || p === 32 || p === 60 || rp(p) ? n(p) : (t.consume(p), l);
  }
  function c(p) {
    return p === 64 ? (t.consume(p), u) : gM(p) ? (t.consume(p), c) : n(p);
  }
  function u(p) {
    return Nr(p) ? h(p) : n(p);
  }
  function h(p) {
    return p === 46 ? (t.consume(p), r = 0, u) : p === 62 ? (t.exit("autolinkProtocol").type = "autolinkEmail", t.enter("autolinkMarker"), t.consume(p), t.exit("autolinkMarker"), t.exit("autolink"), e) : f(p);
  }
  function f(p) {
    if ((p === 45 || Nr(p)) && r++ < 63) {
      const g = p === 45 ? f : h;
      return t.consume(p), g;
    }
    return n(p);
  }
}
const qd = {partial:!0, tokenize:CM};
function CM(t, e, n) {
  return r;
  function r(s) {
    return Ft(s) ? Gt(t, i, "linePrefix")(s) : i(s);
  }
  function i(s) {
    return s === null || mt(s) ? e(s) : n(s);
  }
}
const YT = {continuation:{tokenize:NM}, exit:IM, name:"blockQuote", tokenize:AM};
function AM(t, e, n) {
  const r = this;
  return i;
  function i(o) {
    if (o === 62) {
      const a = r.containerState;
      return a.open || (t.enter("blockQuote", {_container:!0}), a.open = !0), t.enter("blockQuotePrefix"), t.enter("blockQuoteMarker"), t.consume(o), t.exit("blockQuoteMarker"), s;
    }
    return n(o);
  }
  function s(o) {
    return Ft(o) ? (t.enter("blockQuotePrefixWhitespace"), t.consume(o), t.exit("blockQuotePrefixWhitespace"), t.exit("blockQuotePrefix"), e) : (t.exit("blockQuotePrefix"), e(o));
  }
}
function NM(t, e, n) {
  const r = this;
  return i;
  function i(o) {
    return Ft(o) ? Gt(t, s, "linePrefix", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(o) : s(o);
  }
  function s(o) {
    return t.attempt(YT, e, n)(o);
  }
}
function IM(t) {
  t.exit("blockQuote");
}
const GT = {name:"characterEscape", tokenize:OM};
function OM(t, e, n) {
  return r;
  function r(s) {
    return t.enter("characterEscape"), t.enter("escapeMarker"), t.consume(s), t.exit("escapeMarker"), i;
  }
  function i(s) {
    return bM(s) ? (t.enter("characterEscapeValue"), t.consume(s), t.exit("characterEscapeValue"), t.exit("characterEscape"), e) : n(s);
  }
}
const QT = {name:"characterReference", tokenize:PM};
function PM(t, e, n) {
  const r = this;
  let i = 0, s, o;
  return a;
  function a(h) {
    return t.enter("characterReference"), t.enter("characterReferenceMarker"), t.consume(h), t.exit("characterReferenceMarker"), l;
  }
  function l(h) {
    return h === 35 ? (t.enter("characterReferenceMarkerNumeric"), t.consume(h), t.exit("characterReferenceMarkerNumeric"), c) : (t.enter("characterReferenceValue"), s = 31, o = Nr, u(h));
  }
  function c(h) {
    return h === 88 || h === 120 ? (t.enter("characterReferenceMarkerHexadecimal"), t.consume(h), t.exit("characterReferenceMarkerHexadecimal"), t.enter("characterReferenceValue"), s = 6, o = mM, u) : (t.enter("characterReferenceValue"), s = 7, o = hb, u(h));
  }
  function u(h) {
    if (h === 59 && i) {
      const f = t.exit("characterReferenceValue");
      return o === Nr && !Ax(r.sliceSerialize(f)) ? n(h) : (t.enter("characterReferenceMarker"), t.consume(h), t.exit("characterReferenceMarker"), t.exit("characterReference"), e);
    }
    return o(h) && i++ < s ? (t.consume(h), u) : n(h);
  }
}
const Mw = {partial:!0, tokenize:DM}, Bw = {concrete:!0, name:"codeFenced", tokenize:RM};
function RM(t, e, n) {
  const r = this, i = {partial:!0, tokenize:I};
  let s = 0, o = 0, a;
  return l;
  function l(_) {
    return c(_);
  }
  function c(_) {
    const N = r.events[r.events.length - 1];
    return s = N && N[1].type === "linePrefix" ? N[2].sliceSerialize(N[1], !0).length : 0, a = _, t.enter("codeFenced"), t.enter("codeFencedFence"), t.enter("codeFencedFenceSequence"), u(_);
  }
  function u(_) {
    return _ === a ? (o++, t.consume(_), u) : o < 3 ? n(_) : (t.exit("codeFencedFenceSequence"), Ft(_) ? Gt(t, h, "whitespace")(_) : h(_));
  }
  function h(_) {
    return _ === null || mt(_) ? (t.exit("codeFencedFence"), r.interrupt ? e(_) : t.check(Mw, m, T)(_)) : (t.enter("codeFencedFenceInfo"), t.enter("chunkString", {contentType:"string"}), f(_));
  }
  function f(_) {
    return _ === null || mt(_) ? (t.exit("chunkString"), t.exit("codeFencedFenceInfo"), h(_)) : Ft(_) ? (t.exit("chunkString"), t.exit("codeFencedFenceInfo"), Gt(t, p, "whitespace")(_)) : _ === 96 && _ === a ? n(_) : (t.consume(_), f);
  }
  function p(_) {
    return _ === null || mt(_) ? h(_) : (t.enter("codeFencedFenceMeta"), t.enter("chunkString", {contentType:"string"}), g(_));
  }
  function g(_) {
    return _ === null || mt(_) ? (t.exit("chunkString"), t.exit("codeFencedFenceMeta"), h(_)) : _ === 96 && _ === a ? n(_) : (t.consume(_), g);
  }
  function m(_) {
    return t.attempt(i, T, b)(_);
  }
  function b(_) {
    return t.enter("lineEnding"), t.consume(_), t.exit("lineEnding"), x;
  }
  function x(_) {
    return s > 0 && Ft(_) ? Gt(t, w, "linePrefix", s + 1)(_) : w(_);
  }
  function w(_) {
    return _ === null || mt(_) ? t.check(Mw, m, T)(_) : (t.enter("codeFlowValue"), v(_));
  }
  function v(_) {
    return _ === null || mt(_) ? (t.exit("codeFlowValue"), w(_)) : (t.consume(_), v);
  }
  function T(_) {
    return t.exit("codeFenced"), e(_);
  }
  function I(_, N, E) {
    let C = 0;
    return k;
    function k(B) {
      return _.enter("lineEnding"), _.consume(B), _.exit("lineEnding"), A;
    }
    function A(B) {
      return _.enter("codeFencedFence"), Ft(B) ? Gt(_, P, "linePrefix", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(B) : P(B);
    }
    function P(B) {
      return B === a ? (_.enter("codeFencedFenceSequence"), W(B)) : E(B);
    }
    function W(B) {
      return B === a ? (C++, _.consume(B), W) : C >= o ? (_.exit("codeFencedFenceSequence"), Ft(B) ? Gt(_, F, "whitespace")(B) : F(B)) : E(B);
    }
    function F(B) {
      return B === null || mt(B) ? (_.exit("codeFencedFence"), N(B)) : E(B);
    }
  }
}
function DM(t, e, n) {
  const r = this;
  return i;
  function i(o) {
    return o === null ? n(o) : (t.enter("lineEnding"), t.consume(o), t.exit("lineEnding"), s);
  }
  function s(o) {
    return r.parser.lazy[r.now().line] ? n(o) : e(o);
  }
}
const ym = {name:"codeIndented", tokenize:MM}, LM = {partial:!0, tokenize:BM};
function MM(t, e, n) {
  const r = this;
  return i;
  function i(c) {
    return t.enter("codeIndented"), Gt(t, s, "linePrefix", 5)(c);
  }
  function s(c) {
    const u = r.events[r.events.length - 1];
    return u && u[1].type === "linePrefix" && u[2].sliceSerialize(u[1], !0).length >= 4 ? o(c) : n(c);
  }
  function o(c) {
    return c === null ? l(c) : mt(c) ? t.attempt(LM, o, l)(c) : (t.enter("codeFlowValue"), a(c));
  }
  function a(c) {
    return c === null || mt(c) ? (t.exit("codeFlowValue"), o(c)) : (t.consume(c), a);
  }
  function l(c) {
    return t.exit("codeIndented"), e(c);
  }
}
function BM(t, e, n) {
  const r = this;
  return i;
  function i(o) {
    return r.parser.lazy[r.now().line] ? n(o) : mt(o) ? (t.enter("lineEnding"), t.consume(o), t.exit("lineEnding"), i) : Gt(t, s, "linePrefix", 5)(o);
  }
  function s(o) {
    const a = r.events[r.events.length - 1];
    return a && a[1].type === "linePrefix" && a[2].sliceSerialize(a[1], !0).length >= 4 ? e(o) : mt(o) ? i(o) : n(o);
  }
}
const $M = {name:"codeText", previous:zM, resolve:FM, tokenize:HM};
function FM(t) {
  let e = t.length - 4, n = 3, r, i;
  if ((t[n][1].type === "lineEnding" || t[n][1].type === "space") && (t[e][1].type === "lineEnding" || t[e][1].type === "space")) {
    for (r = n; ++r < e;) {
      if (t[r][1].type === "codeTextData") {
        t[n][1].type = "codeTextPadding", t[e][1].type = "codeTextPadding", n += 2, e -= 2;
        break;
      }
    }
  }
  for (r = n - 1, e++; ++r <= e;) {
    i === void 0 ? r !== e && t[r][1].type !== "lineEnding" && (i = r) : (r === e || t[r][1].type === "lineEnding") && (t[i][1].type = "codeTextData", r !== i + 2 && (t[i][1].end = t[r - 1][1].end, t.splice(i + 2, r - i - 2), e -= r - i - 2, r = i + 2), i = void 0);
  }
  return t;
}
function zM(t) {
  return t !== 96 || this.events[this.events.length - 1][1].type === "characterEscape";
}
function HM(t, e, n) {
  let r = 0, i, s;
  return o;
  function o(h) {
    return t.enter("codeText"), t.enter("codeTextSequence"), a(h);
  }
  function a(h) {
    return h === 96 ? (t.consume(h), r++, a) : (t.exit("codeTextSequence"), l(h));
  }
  function l(h) {
    return h === null ? n(h) : h === 32 ? (t.enter("space"), t.consume(h), t.exit("space"), l) : h === 96 ? (s = t.enter("codeTextSequence"), i = 0, u(h)) : mt(h) ? (t.enter("lineEnding"), t.consume(h), t.exit("lineEnding"), l) : (t.enter("codeTextData"), c(h));
  }
  function c(h) {
    return h === null || h === 32 || h === 96 || mt(h) ? (t.exit("codeTextData"), l(h)) : (t.consume(h), c);
  }
  function u(h) {
    return h === 96 ? (t.consume(h), i++, u) : i === r ? (t.exit("codeTextSequence"), t.exit("codeText"), e(h)) : (s.type = "codeTextData", c(h));
  }
}
class UM {
  constructor(e) {
    this.left = e ? [...e] : [], this.right = [];
  }
  get(e) {
    if (e < 0 || e >= this.left.length + this.right.length) {
      throw new RangeError("Cannot access index `" + e + "` in a splice buffer of size `" + (this.left.length + this.right.length) + "`");
    }
    return e < this.left.length ? this.left[e] : this.right[this.right.length - e + this.left.length - 1];
  }
  get length() {
    return this.left.length + this.right.length;
  }
  shift() {
    return this.setCursor(0), this.right.pop();
  }
  slice(e, n) {
    const r = n ?? Number.POSITIVE_INFINITY;
    return r < this.left.length ? this.left.slice(e, r) : e > this.left.length ? this.right.slice(this.right.length - r + this.left.length, this.right.length - e + this.left.length).reverse() : this.left.slice(e).concat(this.right.slice(this.right.length - r + this.left.length).reverse());
  }
  splice(e, n, r) {
    const i = n || 0;
    this.setCursor(Math.trunc(e));
    const s = this.right.splice(this.right.length - i, Number.POSITIVE_INFINITY);
    return r && Yc(this.left, r), s.reverse();
  }
  pop() {
    return this.setCursor(Number.POSITIVE_INFINITY), this.left.pop();
  }
  push(e) {
    this.setCursor(Number.POSITIVE_INFINITY), this.left.push(e);
  }
  pushMany(e) {
    this.setCursor(Number.POSITIVE_INFINITY), Yc(this.left, e);
  }
  unshift(e) {
    this.setCursor(0), this.right.push(e);
  }
  unshiftMany(e) {
    this.setCursor(0), Yc(this.right, e.reverse());
  }
  setCursor(e) {
    if (!(e === this.left.length || e > this.left.length && this.right.length === 0 || e < 0 && this.left.length === 0)) {
      if (e < this.left.length) {
        const n = this.left.splice(e, Number.POSITIVE_INFINITY);
        Yc(this.right, n.reverse());
      } else {
        const n = this.right.splice(this.left.length + this.right.length - e, Number.POSITIVE_INFINITY);
        Yc(this.left, n.reverse());
      }
    }
  }
}
function Yc(t, e) {
  let n = 0;
  if (e.length < 1e4) {
    t.push(...e);
  } else {
    for (; n < e.length;) {
      t.push(...e.slice(n, n + 1e4)), n += 1e4;
    }
  }
}
function KT(t) {
  const e = {};
  let n = -1, r, i, s, o, a, l, c;
  const u = new UM(t);
  for (; ++n < u.length;) {
    for (; n in e;) {
      n = e[n];
    }
    if (r = u.get(n), n && r[1].type === "chunkFlow" && u.get(n - 1)[1].type === "listItemPrefix" && (l = r[1]._tokenizer.events, s = 0, s < l.length && l[s][1].type === "lineEndingBlank" && (s += 2), s < l.length && l[s][1].type === "content")) {
      for (; ++s < l.length && l[s][1].type !== "content";) {
        l[s][1].type === "chunkText" && (l[s][1]._isInFirstContentOfListItem = !0, s++);
      }
    }
    if (r[0] === "enter") {
      r[1].contentType && (Object.assign(e, WM(u, n)), n = e[n], c = !0);
    } else if (r[1]._container) {
      for (s = n, i = void 0; s--;) {
        if (o = u.get(s), o[1].type === "lineEnding" || o[1].type === "lineEndingBlank") {
          o[0] === "enter" && (i && (u.get(i)[1].type = "lineEndingBlank"), o[1].type = "lineEnding", i = s);
        } else if (!(o[1].type === "linePrefix" || o[1].type === "listItemIndent")) {
          break;
        }
      }
      i && (r[1].end = {...u.get(i)[1].start}, a = u.slice(i, n), a.unshift(r), u.splice(i, n - i + 1, a));
    }
  }
  return yi(t, 0, Number.POSITIVE_INFINITY, u.slice(0)), !c;
}
function WM(t, e) {
  const n = t.get(e)[1], r = t.get(e)[2];
  let i = e - 1;
  const s = [];
  let o = n._tokenizer;
  o || (o = r.parser[n.contentType](n.start), n._contentTypeTextTrailing && (o._contentTypeTextTrailing = !0));
  const a = o.events, l = [], c = {};
  let u, h, f = -1, p = n, g = 0, m = 0;
  const b = [m];
  for (; p;) {
    for (; t.get(++i)[1] !== p;) {
    }
    s.push(i), p._tokenizer || (u = r.sliceStream(p), p.next || u.push(null), h && o.defineSkip(p.start), p._isInFirstContentOfListItem && (o._gfmTasklistFirstContentOfListItem = !0), o.write(u), p._isInFirstContentOfListItem && (o._gfmTasklistFirstContentOfListItem = void 0)), h = p, p = p.next;
  }
  for (p = n; ++f < a.length;) {
    a[f][0] === "exit" && a[f - 1][0] === "enter" && a[f][1].type === a[f - 1][1].type && a[f][1].start.line !== a[f][1].end.line && (m = f + 1, b.push(m), p._tokenizer = void 0, p.previous = void 0, p = p.next);
  }
  for (o.events = [], p ? (p._tokenizer = void 0, p.previous = void 0) : b.pop(), f = b.length; f--;) {
    const x = a.slice(b[f], b[f + 1]), w = s.pop();
    l.push([w, w + x.length - 1]), t.splice(w, 2, x);
  }
  for (l.reverse(), f = -1; ++f < l.length;) {
    c[g + l[f][0]] = g + l[f][1], g += l[f][1] - l[f][0] - 1;
  }
  return c;
}
const jM = {resolve:qM, tokenize:YM}, VM = {partial:!0, tokenize:GM};
function qM(t) {
  return KT(t), t;
}
function YM(t, e) {
  let n;
  return r;
  function r(a) {
    return t.enter("content"), n = t.enter("chunkContent", {contentType:"content"}), i(a);
  }
  function i(a) {
    return a === null ? s(a) : mt(a) ? t.check(VM, o, s)(a) : (t.consume(a), i);
  }
  function s(a) {
    return t.exit("chunkContent"), t.exit("content"), e(a);
  }
  function o(a) {
    return t.consume(a), t.exit("chunkContent"), n.next = t.enter("chunkContent", {contentType:"content", previous:n}), n = n.next, i;
  }
}
function GM(t, e, n) {
  const r = this;
  return i;
  function i(o) {
    return t.exit("chunkContent"), t.enter("lineEnding"), t.consume(o), t.exit("lineEnding"), Gt(t, s, "linePrefix");
  }
  function s(o) {
    if (o === null || mt(o)) {
      return n(o);
    }
    const a = r.events[r.events.length - 1];
    return !r.parser.constructs.disable.null.includes("codeIndented") && a && a[1].type === "linePrefix" && a[2].sliceSerialize(a[1], !0).length >= 4 ? e(o) : t.interrupt(r.parser.constructs.flow, n, e)(o);
  }
}
function XT(t, e, n, r, i, s, o, a, l) {
  const c = l || Number.POSITIVE_INFINITY;
  let u = 0;
  return h;
  function h(x) {
    return x === 60 ? (t.enter(r), t.enter(i), t.enter(s), t.consume(x), t.exit(s), f) : x === null || x === 32 || x === 41 || rp(x) ? n(x) : (t.enter(r), t.enter(o), t.enter(a), t.enter("chunkString", {contentType:"string"}), m(x));
  }
  function f(x) {
    return x === 62 ? (t.enter(s), t.consume(x), t.exit(s), t.exit(i), t.exit(r), e) : (t.enter(a), t.enter("chunkString", {contentType:"string"}), p(x));
  }
  function p(x) {
    return x === 62 ? (t.exit("chunkString"), t.exit(a), f(x)) : x === null || x === 60 || mt(x) ? n(x) : (t.consume(x), x === 92 ? g : p);
  }
  function g(x) {
    return x === 60 || x === 62 || x === 92 ? (t.consume(x), p) : p(x);
  }
  function m(x) {
    return !u && (x === null || x === 41 || gn(x)) ? (t.exit("chunkString"), t.exit(a), t.exit(o), t.exit(r), e(x)) : u < c && x === 40 ? (t.consume(x), u++, m) : x === 41 ? (t.consume(x), u--, m) : x === null || x === 32 || x === 40 || rp(x) ? n(x) : (t.consume(x), x === 92 ? b : m);
  }
  function b(x) {
    return x === 40 || x === 41 || x === 92 ? (t.consume(x), m) : m(x);
  }
}
function JT(t, e, n, r, i, s) {
  const o = this;
  let a = 0, l;
  return c;
  function c(p) {
    return t.enter(r), t.enter(i), t.consume(p), t.exit(i), t.enter(s), u;
  }
  function u(p) {
    return a > 999 || p === null || p === 91 || p === 93 && !l || p === 94 && !a && "_hiddenFootnoteSupport" in o.parser.constructs ? n(p) : p === 93 ? (t.exit(s), t.enter(i), t.consume(p), t.exit(i), t.exit(r), e) : mt(p) ? (t.enter("lineEnding"), t.consume(p), t.exit("lineEnding"), u) : (t.enter("chunkString", {contentType:"string"}), h(p));
  }
  function h(p) {
    return p === null || p === 91 || p === 93 || mt(p) || a++ > 999 ? (t.exit("chunkString"), u(p)) : (t.consume(p), l || (l = !Ft(p)), p === 92 ? f : h);
  }
  function f(p) {
    return p === 91 || p === 92 || p === 93 ? (t.consume(p), a++, h) : h(p);
  }
}
function ZT(t, e, n, r, i, s) {
  let o;
  return a;
  function a(f) {
    return f === 34 || f === 39 || f === 40 ? (t.enter(r), t.enter(i), t.consume(f), t.exit(i), o = f === 40 ? 41 : f, l) : n(f);
  }
  function l(f) {
    return f === o ? (t.enter(i), t.consume(f), t.exit(i), t.exit(r), e) : (t.enter(s), c(f));
  }
  function c(f) {
    return f === o ? (t.exit(s), l(o)) : f === null ? n(f) : mt(f) ? (t.enter("lineEnding"), t.consume(f), t.exit("lineEnding"), Gt(t, c, "linePrefix")) : (t.enter("chunkString", {contentType:"string"}), u(f));
  }
  function u(f) {
    return f === o || f === null || mt(f) ? (t.exit("chunkString"), c(f)) : (t.consume(f), f === 92 ? h : u);
  }
  function h(f) {
    return f === o || f === 92 ? (t.consume(f), u) : u(f);
  }
}
function Du(t, e) {
  let n;
  return r;
  function r(i) {
    return mt(i) ? (t.enter("lineEnding"), t.consume(i), t.exit("lineEnding"), n = !0, r) : Ft(i) ? Gt(t, r, n ? "linePrefix" : "lineSuffix")(i) : e(i);
  }
}
const QM = {name:"definition", tokenize:XM}, KM = {partial:!0, tokenize:JM};
function XM(t, e, n) {
  const r = this;
  let i;
  return s;
  function s(p) {
    return t.enter("definition"), o(p);
  }
  function o(p) {
    return JT.call(r, t, a, n, "definitionLabel", "definitionLabelMarker", "definitionLabelString")(p);
  }
  function a(p) {
    return i = ns(r.sliceSerialize(r.events[r.events.length - 1][1]).slice(1, -1)), p === 58 ? (t.enter("definitionMarker"), t.consume(p), t.exit("definitionMarker"), l) : n(p);
  }
  function l(p) {
    return gn(p) ? Du(t, c)(p) : c(p);
  }
  function c(p) {
    return XT(t, u, n, "definitionDestination", "definitionDestinationLiteral", "definitionDestinationLiteralMarker", "definitionDestinationRaw", "definitionDestinationString")(p);
  }
  function u(p) {
    return t.attempt(KM, h, h)(p);
  }
  function h(p) {
    return Ft(p) ? Gt(t, f, "whitespace")(p) : f(p);
  }
  function f(p) {
    return p === null || mt(p) ? (t.exit("definition"), r.parser.defined.push(i), e(p)) : n(p);
  }
}
function JM(t, e, n) {
  return r;
  function r(a) {
    return gn(a) ? Du(t, i)(a) : n(a);
  }
  function i(a) {
    return ZT(t, s, n, "definitionTitle", "definitionTitleMarker", "definitionTitleString")(a);
  }
  function s(a) {
    return Ft(a) ? Gt(t, o, "whitespace")(a) : o(a);
  }
  function o(a) {
    return a === null || mt(a) ? e(a) : n(a);
  }
}
const ZM = {name:"hardBreakEscape", tokenize:e8};
function e8(t, e, n) {
  return r;
  function r(s) {
    return t.enter("hardBreakEscape"), t.consume(s), i;
  }
  function i(s) {
    return mt(s) ? (t.exit("hardBreakEscape"), e(s)) : n(s);
  }
}
const t8 = {name:"headingAtx", resolve:n8, tokenize:r8};
function n8(t, e) {
  let n = t.length - 2, r = 3, i, s;
  return t[r][1].type === "whitespace" && (r += 2), n - 2 > r && t[n][1].type === "whitespace" && (n -= 2), t[n][1].type === "atxHeadingSequence" && (r === n - 1 || n - 4 > r && t[n - 2][1].type === "whitespace") && (n -= r + 1 === n ? 2 : 4), n > r && (i = {type:"atxHeadingText", start:t[r][1].start, end:t[n][1].end}, s = {type:"chunkText", start:t[r][1].start, end:t[n][1].end, contentType:"text"}, yi(t, r, n - r + 1, [["enter", i, e], ["enter", s, e], ["exit", s, e], ["exit", i, e]])), t;
}
function r8(t, e, n) {
  let r = 0;
  return i;
  function i(u) {
    return t.enter("atxHeading"), s(u);
  }
  function s(u) {
    return t.enter("atxHeadingSequence"), o(u);
  }
  function o(u) {
    return u === 35 && r++ < 6 ? (t.consume(u), o) : u === null || gn(u) ? (t.exit("atxHeadingSequence"), a(u)) : n(u);
  }
  function a(u) {
    return u === 35 ? (t.enter("atxHeadingSequence"), l(u)) : u === null || mt(u) ? (t.exit("atxHeading"), e(u)) : Ft(u) ? Gt(t, a, "whitespace")(u) : (t.enter("atxHeadingText"), c(u));
  }
  function l(u) {
    return u === 35 ? (t.consume(u), l) : (t.exit("atxHeadingSequence"), a(u));
  }
  function c(u) {
    return u === null || u === 35 || gn(u) ? (t.exit("atxHeadingText"), a(u)) : (t.consume(u), c);
  }
}
const i8 = ["address", "article", "aside", "base", "basefont", "blockquote", "body", "caption", "center", "col", "colgroup", "dd", "details", "dialog", "dir", "div", "dl", "dt", "fieldset", "figcaption", "figure", "footer", "form", "frame", "frameset", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hr", "html", "iframe", "legend", "li", "link", "main", "menu", "menuitem", "nav", "noframes", "ol", "optgroup", "option", "p", "param", "search", "section", "summary", "table", "tbody", "td", "tfoot", 
"th", "thead", "title", "tr", "track", "ul"], $w = ["pre", "script", "style", "textarea"], s8 = {concrete:!0, name:"htmlFlow", resolveTo:l8, tokenize:c8}, o8 = {partial:!0, tokenize:d8}, a8 = {partial:!0, tokenize:u8};
function l8(t) {
  let e = t.length;
  for (; e-- && !(t[e][0] === "enter" && t[e][1].type === "htmlFlow");) {
  }
  return e > 1 && t[e - 2][1].type === "linePrefix" && (t[e][1].start = t[e - 2][1].start, t[e + 1][1].start = t[e - 2][1].start, t.splice(e - 2, 2)), t;
}
function c8(t, e, n) {
  const r = this;
  let i, s, o, a, l;
  return c;
  function c(M) {
    return u(M);
  }
  function u(M) {
    return t.enter("htmlFlow"), t.enter("htmlFlowData"), t.consume(M), h;
  }
  function h(M) {
    return M === 33 ? (t.consume(M), f) : M === 47 ? (t.consume(M), s = !0, m) : M === 63 ? (t.consume(M), i = 3, r.interrupt ? e : D) : Fr(M) ? (t.consume(M), o = String.fromCharCode(M), b) : n(M);
  }
  function f(M) {
    return M === 45 ? (t.consume(M), i = 2, p) : M === 91 ? (t.consume(M), i = 5, a = 0, g) : Fr(M) ? (t.consume(M), i = 4, r.interrupt ? e : D) : n(M);
  }
  function p(M) {
    return M === 45 ? (t.consume(M), r.interrupt ? e : D) : n(M);
  }
  function g(M) {
    const X = "CDATA[";
    return M === X.charCodeAt(a++) ? (t.consume(M), a === X.length ? r.interrupt ? e : P : g) : n(M);
  }
  function m(M) {
    return Fr(M) ? (t.consume(M), o = String.fromCharCode(M), b) : n(M);
  }
  function b(M) {
    if (M === null || M === 47 || M === 62 || gn(M)) {
      const X = M === 47, ge = o.toLowerCase();
      return !X && !s && $w.includes(ge) ? (i = 1, r.interrupt ? e(M) : P(M)) : i8.includes(o.toLowerCase()) ? (i = 6, X ? (t.consume(M), x) : r.interrupt ? e(M) : P(M)) : (i = 7, r.interrupt && !r.parser.lazy[r.now().line] ? n(M) : s ? w(M) : v(M));
    }
    return M === 45 || Nr(M) ? (t.consume(M), o += String.fromCharCode(M), b) : n(M);
  }
  function x(M) {
    return M === 62 ? (t.consume(M), r.interrupt ? e : P) : n(M);
  }
  function w(M) {
    return Ft(M) ? (t.consume(M), w) : k(M);
  }
  function v(M) {
    return M === 47 ? (t.consume(M), k) : M === 58 || M === 95 || Fr(M) ? (t.consume(M), T) : Ft(M) ? (t.consume(M), v) : k(M);
  }
  function T(M) {
    return M === 45 || M === 46 || M === 58 || M === 95 || Nr(M) ? (t.consume(M), T) : I(M);
  }
  function I(M) {
    return M === 61 ? (t.consume(M), _) : Ft(M) ? (t.consume(M), I) : v(M);
  }
  function _(M) {
    return M === null || M === 60 || M === 61 || M === 62 || M === 96 ? n(M) : M === 34 || M === 39 ? (t.consume(M), l = M, N) : Ft(M) ? (t.consume(M), _) : E(M);
  }
  function N(M) {
    return M === l ? (t.consume(M), l = null, C) : M === null || mt(M) ? n(M) : (t.consume(M), N);
  }
  function E(M) {
    return M === null || M === 34 || M === 39 || M === 47 || M === 60 || M === 61 || M === 62 || M === 96 || gn(M) ? I(M) : (t.consume(M), E);
  }
  function C(M) {
    return M === 47 || M === 62 || Ft(M) ? v(M) : n(M);
  }
  function k(M) {
    return M === 62 ? (t.consume(M), A) : n(M);
  }
  function A(M) {
    return M === null || mt(M) ? P(M) : Ft(M) ? (t.consume(M), A) : n(M);
  }
  function P(M) {
    return M === 45 && i === 2 ? (t.consume(M), z) : M === 60 && i === 1 ? (t.consume(M), j) : M === 62 && i === 4 ? (t.consume(M), ie) : M === 63 && i === 3 ? (t.consume(M), D) : M === 93 && i === 5 ? (t.consume(M), ne) : mt(M) && (i === 6 || i === 7) ? (t.exit("htmlFlowData"), t.check(o8, ee, W)(M)) : M === null || mt(M) ? (t.exit("htmlFlowData"), W(M)) : (t.consume(M), P);
  }
  function W(M) {
    return t.check(a8, F, ee)(M);
  }
  function F(M) {
    return t.enter("lineEnding"), t.consume(M), t.exit("lineEnding"), B;
  }
  function B(M) {
    return M === null || mt(M) ? W(M) : (t.enter("htmlFlowData"), P(M));
  }
  function z(M) {
    return M === 45 ? (t.consume(M), D) : P(M);
  }
  function j(M) {
    return M === 47 ? (t.consume(M), o = "", V) : P(M);
  }
  function V(M) {
    if (M === 62) {
      const X = o.toLowerCase();
      return $w.includes(X) ? (t.consume(M), ie) : P(M);
    }
    return Fr(M) && o.length < 8 ? (t.consume(M), o += String.fromCharCode(M), V) : P(M);
  }
  function ne(M) {
    return M === 93 ? (t.consume(M), D) : P(M);
  }
  function D(M) {
    return M === 62 ? (t.consume(M), ie) : M === 45 && i === 2 ? (t.consume(M), D) : P(M);
  }
  function ie(M) {
    return M === null || mt(M) ? (t.exit("htmlFlowData"), ee(M)) : (t.consume(M), ie);
  }
  function ee(M) {
    return t.exit("htmlFlow"), e(M);
  }
}
function u8(t, e, n) {
  const r = this;
  return i;
  function i(o) {
    return mt(o) ? (t.enter("lineEnding"), t.consume(o), t.exit("lineEnding"), s) : n(o);
  }
  function s(o) {
    return r.parser.lazy[r.now().line] ? n(o) : e(o);
  }
}
function d8(t, e, n) {
  return r;
  function r(i) {
    return t.enter("lineEnding"), t.consume(i), t.exit("lineEnding"), t.attempt(qd, e, n);
  }
}
const h8 = {name:"htmlText", tokenize:f8};
function f8(t, e, n) {
  const r = this;
  let i, s, o;
  return a;
  function a(D) {
    return t.enter("htmlText"), t.enter("htmlTextData"), t.consume(D), l;
  }
  function l(D) {
    return D === 33 ? (t.consume(D), c) : D === 47 ? (t.consume(D), I) : D === 63 ? (t.consume(D), v) : Fr(D) ? (t.consume(D), E) : n(D);
  }
  function c(D) {
    return D === 45 ? (t.consume(D), u) : D === 91 ? (t.consume(D), s = 0, g) : Fr(D) ? (t.consume(D), w) : n(D);
  }
  function u(D) {
    return D === 45 ? (t.consume(D), p) : n(D);
  }
  function h(D) {
    return D === null ? n(D) : D === 45 ? (t.consume(D), f) : mt(D) ? (o = h, j(D)) : (t.consume(D), h);
  }
  function f(D) {
    return D === 45 ? (t.consume(D), p) : h(D);
  }
  function p(D) {
    return D === 62 ? z(D) : D === 45 ? f(D) : h(D);
  }
  function g(D) {
    const ie = "CDATA[";
    return D === ie.charCodeAt(s++) ? (t.consume(D), s === ie.length ? m : g) : n(D);
  }
  function m(D) {
    return D === null ? n(D) : D === 93 ? (t.consume(D), b) : mt(D) ? (o = m, j(D)) : (t.consume(D), m);
  }
  function b(D) {
    return D === 93 ? (t.consume(D), x) : m(D);
  }
  function x(D) {
    return D === 62 ? z(D) : D === 93 ? (t.consume(D), x) : m(D);
  }
  function w(D) {
    return D === null || D === 62 ? z(D) : mt(D) ? (o = w, j(D)) : (t.consume(D), w);
  }
  function v(D) {
    return D === null ? n(D) : D === 63 ? (t.consume(D), T) : mt(D) ? (o = v, j(D)) : (t.consume(D), v);
  }
  function T(D) {
    return D === 62 ? z(D) : v(D);
  }
  function I(D) {
    return Fr(D) ? (t.consume(D), _) : n(D);
  }
  function _(D) {
    return D === 45 || Nr(D) ? (t.consume(D), _) : N(D);
  }
  function N(D) {
    return mt(D) ? (o = N, j(D)) : Ft(D) ? (t.consume(D), N) : z(D);
  }
  function E(D) {
    return D === 45 || Nr(D) ? (t.consume(D), E) : D === 47 || D === 62 || gn(D) ? C(D) : n(D);
  }
  function C(D) {
    return D === 47 ? (t.consume(D), z) : D === 58 || D === 95 || Fr(D) ? (t.consume(D), k) : mt(D) ? (o = C, j(D)) : Ft(D) ? (t.consume(D), C) : z(D);
  }
  function k(D) {
    return D === 45 || D === 46 || D === 58 || D === 95 || Nr(D) ? (t.consume(D), k) : A(D);
  }
  function A(D) {
    return D === 61 ? (t.consume(D), P) : mt(D) ? (o = A, j(D)) : Ft(D) ? (t.consume(D), A) : C(D);
  }
  function P(D) {
    return D === null || D === 60 || D === 61 || D === 62 || D === 96 ? n(D) : D === 34 || D === 39 ? (t.consume(D), i = D, W) : mt(D) ? (o = P, j(D)) : Ft(D) ? (t.consume(D), P) : (t.consume(D), F);
  }
  function W(D) {
    return D === i ? (t.consume(D), i = void 0, B) : D === null ? n(D) : mt(D) ? (o = W, j(D)) : (t.consume(D), W);
  }
  function F(D) {
    return D === null || D === 34 || D === 39 || D === 60 || D === 61 || D === 96 ? n(D) : D === 47 || D === 62 || gn(D) ? C(D) : (t.consume(D), F);
  }
  function B(D) {
    return D === 47 || D === 62 || gn(D) ? C(D) : n(D);
  }
  function z(D) {
    return D === 62 ? (t.consume(D), t.exit("htmlTextData"), t.exit("htmlText"), e) : n(D);
  }
  function j(D) {
    return t.exit("htmlTextData"), t.enter("lineEnding"), t.consume(D), t.exit("lineEnding"), V;
  }
  function V(D) {
    return Ft(D) ? Gt(t, ne, "linePrefix", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(D) : ne(D);
  }
  function ne(D) {
    return t.enter("htmlTextData"), o(D);
  }
}
const Nx = {name:"labelEnd", resolveAll:b8, resolveTo:y8, tokenize:x8}, p8 = {tokenize:v8}, g8 = {tokenize:w8}, m8 = {tokenize:_8};
function b8(t) {
  let e = -1;
  const n = [];
  for (; ++e < t.length;) {
    const r = t[e][1];
    if (n.push(t[e]), r.type === "labelImage" || r.type === "labelLink" || r.type === "labelEnd") {
      const i = r.type === "labelImage" ? 4 : 2;
      r.type = "data", e += i;
    }
  }
  return t.length !== n.length && yi(t, 0, t.length, n), t;
}
function y8(t, e) {
  let n = t.length, r = 0, i, s, o, a;
  for (; n--;) {
    if (i = t[n][1], s) {
      if (i.type === "link" || i.type === "labelLink" && i._inactive) {
        break;
      }
      t[n][0] === "enter" && i.type === "labelLink" && (i._inactive = !0);
    } else if (o) {
      if (t[n][0] === "enter" && (i.type === "labelImage" || i.type === "labelLink") && !i._balanced && (s = n, i.type !== "labelLink")) {
        r = 2;
        break;
      }
    } else {
      i.type === "labelEnd" && (o = n);
    }
  }
  const l = {type:t[s][1].type === "labelLink" ? "link" : "image", start:{...t[s][1].start}, end:{...t[t.length - 1][1].end}}, c = {type:"label", start:{...t[s][1].start}, end:{...t[o][1].end}}, u = {type:"labelText", start:{...t[s + r + 2][1].end}, end:{...t[o - 2][1].start}};
  return a = [["enter", l, e], ["enter", c, e]], a = Ai(a, t.slice(s + 1, s + r + 3)), a = Ai(a, [["enter", u, e]]), a = Ai(a, yg(e.parser.constructs.insideSpan.null, t.slice(s + r + 4, o - 3), e)), a = Ai(a, [["exit", u, e], t[o - 2], t[o - 1], ["exit", c, e]]), a = Ai(a, t.slice(o + 1)), a = Ai(a, [["exit", l, e]]), yi(t, s, t.length, a), t;
}
function x8(t, e, n) {
  const r = this;
  let i = r.events.length, s, o;
  for (; i--;) {
    if ((r.events[i][1].type === "labelImage" || r.events[i][1].type === "labelLink") && !r.events[i][1]._balanced) {
      s = r.events[i][1];
      break;
    }
  }
  return a;
  function a(f) {
    return s ? s._inactive ? h(f) : (o = r.parser.defined.includes(ns(r.sliceSerialize({start:s.end, end:r.now()}))), t.enter("labelEnd"), t.enter("labelMarker"), t.consume(f), t.exit("labelMarker"), t.exit("labelEnd"), l) : n(f);
  }
  function l(f) {
    return f === 40 ? t.attempt(p8, u, o ? u : h)(f) : f === 91 ? t.attempt(g8, u, o ? c : h)(f) : o ? u(f) : h(f);
  }
  function c(f) {
    return t.attempt(m8, u, h)(f);
  }
  function u(f) {
    return e(f);
  }
  function h(f) {
    return s._balanced = !0, n(f);
  }
}
function v8(t, e, n) {
  return r;
  function r(h) {
    return t.enter("resource"), t.enter("resourceMarker"), t.consume(h), t.exit("resourceMarker"), i;
  }
  function i(h) {
    return gn(h) ? Du(t, s)(h) : s(h);
  }
  function s(h) {
    return h === 41 ? u(h) : XT(t, o, a, "resourceDestination", "resourceDestinationLiteral", "resourceDestinationLiteralMarker", "resourceDestinationRaw", "resourceDestinationString", 32)(h);
  }
  function o(h) {
    return gn(h) ? Du(t, l)(h) : u(h);
  }
  function a(h) {
    return n(h);
  }
  function l(h) {
    return h === 34 || h === 39 || h === 40 ? ZT(t, c, n, "resourceTitle", "resourceTitleMarker", "resourceTitleString")(h) : u(h);
  }
  function c(h) {
    return gn(h) ? Du(t, u)(h) : u(h);
  }
  function u(h) {
    return h === 41 ? (t.enter("resourceMarker"), t.consume(h), t.exit("resourceMarker"), t.exit("resource"), e) : n(h);
  }
}
function w8(t, e, n) {
  const r = this;
  return i;
  function i(a) {
    return JT.call(r, t, s, o, "reference", "referenceMarker", "referenceString")(a);
  }
  function s(a) {
    return r.parser.defined.includes(ns(r.sliceSerialize(r.events[r.events.length - 1][1]).slice(1, -1))) ? e(a) : n(a);
  }
  function o(a) {
    return n(a);
  }
}
function _8(t, e, n) {
  return r;
  function r(s) {
    return t.enter("reference"), t.enter("referenceMarker"), t.consume(s), t.exit("referenceMarker"), i;
  }
  function i(s) {
    return s === 93 ? (t.enter("referenceMarker"), t.consume(s), t.exit("referenceMarker"), t.exit("reference"), e) : n(s);
  }
}
const S8 = {name:"labelStartImage", resolveAll:Nx.resolveAll, tokenize:k8};
function k8(t, e, n) {
  const r = this;
  return i;
  function i(a) {
    return t.enter("labelImage"), t.enter("labelImageMarker"), t.consume(a), t.exit("labelImageMarker"), s;
  }
  function s(a) {
    return a === 91 ? (t.enter("labelMarker"), t.consume(a), t.exit("labelMarker"), t.exit("labelImage"), o) : n(a);
  }
  function o(a) {
    return a === 94 && "_hiddenFootnoteSupport" in r.parser.constructs ? n(a) : e(a);
  }
}
const E8 = {name:"labelStartLink", resolveAll:Nx.resolveAll, tokenize:T8};
function T8(t, e, n) {
  const r = this;
  return i;
  function i(o) {
    return t.enter("labelLink"), t.enter("labelMarker"), t.consume(o), t.exit("labelMarker"), t.exit("labelLink"), s;
  }
  function s(o) {
    return o === 94 && "_hiddenFootnoteSupport" in r.parser.constructs ? n(o) : e(o);
  }
}
const xm = {name:"lineEnding", tokenize:C8};
function C8(t, e) {
  return n;
  function n(r) {
    return t.enter("lineEnding"), t.consume(r), t.exit("lineEnding"), Gt(t, e, "linePrefix");
  }
}
const Tf = {name:"thematicBreak", tokenize:A8};
function A8(t, e, n) {
  let r = 0, i;
  return s;
  function s(c) {
    return t.enter("thematicBreak"), o(c);
  }
  function o(c) {
    return i = c, a(c);
  }
  function a(c) {
    return c === i ? (t.enter("thematicBreakSequence"), l(c)) : r >= 3 && (c === null || mt(c)) ? (t.exit("thematicBreak"), e(c)) : n(c);
  }
  function l(c) {
    return c === i ? (t.consume(c), r++, l) : (t.exit("thematicBreakSequence"), Ft(c) ? Gt(t, a, "whitespace")(c) : a(c));
  }
}
const Qr = {continuation:{tokenize:P8}, exit:D8, name:"list", tokenize:O8}, N8 = {partial:!0, tokenize:L8}, I8 = {partial:!0, tokenize:R8};
function O8(t, e, n) {
  const r = this, i = r.events[r.events.length - 1];
  let s = i && i[1].type === "linePrefix" ? i[2].sliceSerialize(i[1], !0).length : 0, o = 0;
  return a;
  function a(p) {
    const g = r.containerState.type || (p === 42 || p === 43 || p === 45 ? "listUnordered" : "listOrdered");
    if (g === "listUnordered" ? !r.containerState.marker || p === r.containerState.marker : hb(p)) {
      if (r.containerState.type || (r.containerState.type = g, t.enter(g, {_container:!0})), g === "listUnordered") {
        return t.enter("listItemPrefix"), p === 42 || p === 45 ? t.check(Tf, n, c)(p) : c(p);
      }
      if (!r.interrupt || p === 49) {
        return t.enter("listItemPrefix"), t.enter("listItemValue"), l(p);
      }
    }
    return n(p);
  }
  function l(p) {
    return hb(p) && ++o < 10 ? (t.consume(p), l) : (!r.interrupt || o < 2) && (r.containerState.marker ? p === r.containerState.marker : p === 41 || p === 46) ? (t.exit("listItemValue"), c(p)) : n(p);
  }
  function c(p) {
    return t.enter("listItemMarker"), t.consume(p), t.exit("listItemMarker"), r.containerState.marker = r.containerState.marker || p, t.check(qd, r.interrupt ? n : u, t.attempt(N8, f, h));
  }
  function u(p) {
    return r.containerState.initialBlankLine = !0, s++, f(p);
  }
  function h(p) {
    return Ft(p) ? (t.enter("listItemPrefixWhitespace"), t.consume(p), t.exit("listItemPrefixWhitespace"), f) : n(p);
  }
  function f(p) {
    return r.containerState.size = s + r.sliceSerialize(t.exit("listItemPrefix"), !0).length, e(p);
  }
}
function P8(t, e, n) {
  const r = this;
  return r.containerState._closeFlow = void 0, t.check(qd, i, s);
  function i(a) {
    return r.containerState.furtherBlankLines = r.containerState.furtherBlankLines || r.containerState.initialBlankLine, Gt(t, e, "listItemIndent", r.containerState.size + 1)(a);
  }
  function s(a) {
    return r.containerState.furtherBlankLines || !Ft(a) ? (r.containerState.furtherBlankLines = void 0, r.containerState.initialBlankLine = void 0, o(a)) : (r.containerState.furtherBlankLines = void 0, r.containerState.initialBlankLine = void 0, t.attempt(I8, e, o)(a));
  }
  function o(a) {
    return r.containerState._closeFlow = !0, r.interrupt = void 0, Gt(t, t.attempt(Qr, e, n), "linePrefix", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(a);
  }
}
function R8(t, e, n) {
  const r = this;
  return Gt(t, i, "listItemIndent", r.containerState.size + 1);
  function i(s) {
    const o = r.events[r.events.length - 1];
    return o && o[1].type === "listItemIndent" && o[2].sliceSerialize(o[1], !0).length === r.containerState.size ? e(s) : n(s);
  }
}
function D8(t) {
  t.exit(this.containerState.type);
}
function L8(t, e, n) {
  const r = this;
  return Gt(t, i, "listItemPrefixWhitespace", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 5);
  function i(s) {
    const o = r.events[r.events.length - 1];
    return !Ft(s) && o && o[1].type === "listItemPrefixWhitespace" ? e(s) : n(s);
  }
}
const Fw = {name:"setextUnderline", resolveTo:M8, tokenize:B8};
function M8(t, e) {
  let n = t.length, r, i, s;
  for (; n--;) {
    if (t[n][0] === "enter") {
      if (t[n][1].type === "content") {
        r = n;
        break;
      }
      t[n][1].type === "paragraph" && (i = n);
    } else {
      t[n][1].type === "content" && t.splice(n, 1), !s && t[n][1].type === "definition" && (s = n);
    }
  }
  const o = {type:"setextHeading", start:{...t[r][1].start}, end:{...t[t.length - 1][1].end}};
  return t[i][1].type = "setextHeadingText", s ? (t.splice(i, 0, ["enter", o, e]), t.splice(s + 1, 0, ["exit", t[r][1], e]), t[r][1].end = {...t[s][1].end}) : t[r][1] = o, t.push(["exit", o, e]), t;
}
function B8(t, e, n) {
  const r = this;
  let i;
  return s;
  function s(c) {
    let u = r.events.length, h;
    for (; u--;) {
      if (r.events[u][1].type !== "lineEnding" && r.events[u][1].type !== "linePrefix" && r.events[u][1].type !== "content") {
        h = r.events[u][1].type === "paragraph";
        break;
      }
    }
    return !r.parser.lazy[r.now().line] && (r.interrupt || h) ? (t.enter("setextHeadingLine"), i = c, o(c)) : n(c);
  }
  function o(c) {
    return t.enter("setextHeadingLineSequence"), a(c);
  }
  function a(c) {
    return c === i ? (t.consume(c), a) : (t.exit("setextHeadingLineSequence"), Ft(c) ? Gt(t, l, "lineSuffix")(c) : l(c));
  }
  function l(c) {
    return c === null || mt(c) ? (t.exit("setextHeadingLine"), e(c)) : n(c);
  }
}
const $8 = {tokenize:F8};
function F8(t) {
  const e = this, n = t.attempt(qd, r, t.attempt(this.parser.constructs.flowInitial, i, Gt(t, t.attempt(this.parser.constructs.flow, i, t.attempt(jM, i)), "linePrefix")));
  return n;
  function r(s) {
    if (s === null) {
      t.consume(s);
      return;
    }
    return t.enter("lineEndingBlank"), t.consume(s), t.exit("lineEndingBlank"), e.currentConstruct = void 0, n;
  }
  function i(s) {
    if (s === null) {
      t.consume(s);
      return;
    }
    return t.enter("lineEnding"), t.consume(s), t.exit("lineEnding"), e.currentConstruct = void 0, n;
  }
}
const z8 = {resolveAll:tC()}, H8 = eC("string"), U8 = eC("text");
function eC(t) {
  return {resolveAll:tC(t === "text" ? W8 : void 0), tokenize:e};
  function e(n) {
    const r = this, i = this.parser.constructs[t], s = n.attempt(i, o, a);
    return o;
    function o(u) {
      return c(u) ? s(u) : a(u);
    }
    function a(u) {
      if (u === null) {
        n.consume(u);
        return;
      }
      return n.enter("data"), n.consume(u), l;
    }
    function l(u) {
      return c(u) ? (n.exit("data"), s(u)) : (n.consume(u), l);
    }
    function c(u) {
      if (u === null) {
        return !0;
      }
      const h = i[u];
      let f = -1;
      if (h) {
        for (; ++f < h.length;) {
          const p = h[f];
          if (!p.previous || p.previous.call(r, r.previous)) {
            return !0;
          }
        }
      }
      return !1;
    }
  }
}
function tC(t) {
  return e;
  function e(n, r) {
    let i = -1, s;
    for (; ++i <= n.length;) {
      s === void 0 ? n[i] && n[i][1].type === "data" && (s = i, i++) : (!n[i] || n[i][1].type !== "data") && (i !== s + 2 && (n[s][1].end = n[i - 1][1].end, n.splice(s + 2, i - s - 2), i = s + 2), s = void 0);
    }
    return t ? t(n, r) : n;
  }
}
function W8(t, e) {
  let n = 0;
  for (; ++n <= t.length;) {
    if ((n === t.length || t[n][1].type === "lineEnding") && t[n - 1][1].type === "data") {
      const r = t[n - 1][1], i = e.sliceStream(r);
      let s = i.length, o = -1, a = 0, l;
      for (; s--;) {
        const c = i[s];
        if (typeof c == "string") {
          for (o = c.length; c.charCodeAt(o - 1) === 32;) {
            a++, o--;
          }
          if (o) {
            break;
          }
          o = -1;
        } else if (c === -2) {
          l = !0, a++;
        } else if (c !== -1) {
          s++;
          break;
        }
      }
      if (e._contentTypeTextTrailing && n === t.length && (a = 0), a) {
        const c = {type:n === t.length || l || a < 2 ? "lineSuffix" : "hardBreakTrailing", start:{_bufferIndex:s ? o : r.start._bufferIndex + o, _index:r.start._index + s, line:r.end.line, column:r.end.column - a, offset:r.end.offset - a}, end:{...r.end}};
        r.end = {...c.start}, r.start.offset === r.end.offset ? Object.assign(r, c) : (t.splice(n, 0, ["enter", c, e], ["exit", c, e]), n += 2);
      }
      n++;
    }
  }
  return t;
}
const j8 = {42:Qr, 43:Qr, 45:Qr, 48:Qr, 49:Qr, 50:Qr, 51:Qr, 52:Qr, 53:Qr, 54:Qr, 55:Qr, 56:Qr, 57:Qr, 62:YT}, V8 = {91:QM}, q8 = {[-2]:ym, [-1]:ym, 32:ym}, Y8 = {35:t8, 42:Tf, 45:[Fw, Tf], 60:s8, 61:Fw, 95:Tf, 96:Bw, 126:Bw}, G8 = {38:QT, 92:GT}, Q8 = {[-5]:xm, [-4]:xm, [-3]:xm, 33:S8, 38:QT, 42:fb, 60:[EM, h8], 91:E8, 92:[ZM, GT], 93:Nx, 95:fb, 96:$M}, K8 = {null:[fb, z8]}, X8 = {null:[42, 95]}, J8 = {null:[]}, Z8 = Object.freeze(Object.defineProperty({__proto__:null, attentionMarkers:X8, contentInitial:V8, 
disable:J8, document:j8, flow:Y8, flowInitial:q8, insideSpan:K8, string:G8, text:Q8}, Symbol.toStringTag, {value:"Module"}));
function eB(t, e, n) {
  let r = {_bufferIndex:-1, _index:0, line:n && n.line || 1, column:n && n.column || 1, offset:n && n.offset || 0};
  const i = {}, s = [];
  let o = [], a = [];
  const l = {attempt:N(I), check:N(_), consume:w, enter:v, exit:T, interrupt:N(_, {interrupt:!0})}, c = {code:null, containerState:{}, defineSkip:m, events:[], now:g, parser:t, previous:null, sliceSerialize:f, sliceStream:p, write:h};
  let u = e.tokenize.call(c, l);
  return e.resolveAll && s.push(e), c;
  function h(A) {
    return o = Ai(o, A), b(), o[o.length - 1] !== null ? [] : (E(e, 0), c.events = yg(s, c.events, c), c.events);
  }
  function f(A, P) {
    return nB(p(A), P);
  }
  function p(A) {
    return tB(o, A);
  }
  function g() {
    const {_bufferIndex:A, _index:P, line:W, column:F, offset:B} = r;
    return {_bufferIndex:A, _index:P, line:W, column:F, offset:B};
  }
  function m(A) {
    i[A.line] = A.column, k();
  }
  function b() {
    let A;
    for (; r._index < o.length;) {
      const P = o[r._index];
      if (typeof P == "string") {
        for (A = r._index, r._bufferIndex < 0 && (r._bufferIndex = 0); r._index === A && r._bufferIndex < P.length;) {
          x(P.charCodeAt(r._bufferIndex));
        }
      } else {
        x(P);
      }
    }
  }
  function x(A) {
    u = u(A);
  }
  function w(A) {
    mt(A) ? (r.line++, r.column = 1, r.offset += A === -3 ? 2 : 1, k()) : A !== -1 && (r.column++, r.offset++), r._bufferIndex < 0 ? r._index++ : (r._bufferIndex++, r._bufferIndex === o[r._index].length && (r._bufferIndex = -1, r._index++)), c.previous = A;
  }
  function v(A, P) {
    const W = P || {};
    return W.type = A, W.start = g(), c.events.push(["enter", W, c]), a.push(W), W;
  }
  function T(A) {
    const P = a.pop();
    return P.end = g(), c.events.push(["exit", P, c]), P;
  }
  function I(A, P) {
    E(A, P.from);
  }
  function _(A, P) {
    P.restore();
  }
  function N(A, P) {
    return W;
    function W(F, B, z) {
      let j, V, ne, D;
      return Array.isArray(F) ? ee(F) : "tokenize" in F ? ee([F]) : ie(F);
      function ie(me) {
        return te;
        function te(q) {
          const R = q !== null && me[q], $ = q !== null && me.null, G = [...(Array.isArray(R) ? R : R ? [R] : []), ...(Array.isArray($) ? $ : $ ? [$] : [])];
          return ee(G)(q);
        }
      }
      function ee(me) {
        return j = me, V = 0, me.length === 0 ? z : M(me[V]);
      }
      function M(me) {
        return te;
        function te(q) {
          return D = C(), ne = me, me.partial || (c.currentConstruct = me), me.name && c.parser.constructs.disable.null.includes(me.name) ? ge() : me.tokenize.call(P ? Object.assign(Object.create(c), P) : c, l, X, ge)(q);
        }
      }
      function X(me) {
        return A(ne, D), B;
      }
      function ge(me) {
        return D.restore(), ++V < j.length ? M(j[V]) : z;
      }
    }
  }
  function E(A, P) {
    A.resolveAll && !s.includes(A) && s.push(A), A.resolve && yi(c.events, P, c.events.length - P, A.resolve(c.events.slice(P), c)), A.resolveTo && (c.events = A.resolveTo(c.events, c));
  }
  function C() {
    const A = g(), P = c.previous, W = c.currentConstruct, F = c.events.length, B = Array.from(a);
    return {from:F, restore:z};
    function z() {
      r = A, c.previous = P, c.currentConstruct = W, c.events.length = F, a = B, k();
    }
  }
  function k() {
    r.line in i && r.column < 2 && (r.column = i[r.line], r.offset += i[r.line] - 1);
  }
}
function tB(t, e) {
  const n = e.start._index, r = e.start._bufferIndex, i = e.end._index, s = e.end._bufferIndex;
  let o;
  if (n === i) {
    o = [t[n].slice(r, s)];
  } else {
    if (o = t.slice(n, i), r > -1) {
      const a = o[0];
      typeof a == "string" ? o[0] = a.slice(r) : o.shift();
    }
    s > 0 && o.push(t[i].slice(0, s));
  }
  return o;
}
function nB(t, e) {
  let n = -1;
  const r = [];
  let i;
  for (; ++n < t.length;) {
    const s = t[n];
    let o;
    if (typeof s == "string") {
      o = s;
    } else {
      switch(s) {
        case -5:
          {
            o = "\r";
            break;
          }
        case -4:
          {
            o = `
`;
            break;
          }
        case -3:
          {
            o = `\r
`;
            break;
          }
        case -2:
          {
            o = e ? " " : "\t";
            break;
          }
        case -1:
          {
            if (!e && i) {
              continue;
            }
            o = " ";
            break;
          }
        default:
          o = String.fromCharCode(s);
      }
    }
    i = s === -2, r.push(o);
  }
  return r.join("");
}
function rB(t) {
  const r = {constructs:VT([Z8, ...((t || {}).extensions || [])]), content:i(yM), defined:[], document:i(vM), flow:i($8), lazy:{}, string:i(H8), text:i(U8)};
  return r;
  function i(s) {
    return o;
    function o(a) {
      return eB(r, s, a);
    }
  }
}
function iB(t) {
  for (; !KT(t);) {
  }
  return t;
}
const zw = /[\0\t\n\r]/g;
function sB() {
  let t = 1, e = "", n = !0, r;
  return i;
  function i(s, o, a) {
    const l = [];
    let c, u, h, f, p;
    for (s = e + (typeof s == "string" ? s.toString() : (new TextDecoder(o || void 0)).decode(s)), h = 0, e = "", n && (s.charCodeAt(0) === 65279 && h++, n = void 0); h < s.length;) {
      if (zw.lastIndex = h, c = zw.exec(s), f = c && c.index !== void 0 ? c.index : s.length, p = s.charCodeAt(f), !c) {
        e = s.slice(h);
        break;
      }
      if (p === 10 && h === f && r) {
        l.push(-3), r = void 0;
      } else {
        switch(r && (l.push(-5), r = void 0), h < f && (l.push(s.slice(h, f)), t += f - h), p) {
          case 0:
            {
              l.push(65533), t++;
              break;
            }
          case 9:
            {
              for (u = Math.ceil(t / 4) * 4, l.push(-2); t++ < u;) {
                l.push(-1);
              }
              break;
            }
          case 10:
            {
              l.push(-4), t = 1;
              break;
            }
          default:
            r = !0, t = 1;
        }
      }
      h = f + 1;
    }
    return a && (r && l.push(-5), e && l.push(e), l.push(null)), l;
  }
}
const oB = /\\([!-/:-@[-`{-~])|&(#(?:\d{1,7}|x[\da-f]{1,6})|[\da-z]{1,31});/gi;
function aB(t) {
  return t.replace(oB, lB);
}
function lB(t, e, n) {
  if (e) {
    return e;
  }
  if (n.charCodeAt(0) === 35) {
    const i = n.charCodeAt(1), s = i === 120 || i === 88;
    return qT(n.slice(s ? 2 : 1), s ? 16 : 10);
  }
  return Ax(n) || t;
}
const nC = {}.hasOwnProperty;
function cB(t, e, n) {
  return e && typeof e == "object" && (n = e, e = void 0), uB(n)(iB(rB(n).document().write(sB()(t, e, !0))));
}
function uB(t) {
  const e = {transforms:[], canContainEols:["emphasis", "fragment", "heading", "paragraph", "strong"], enter:{autolink:s(Le), autolinkProtocol:C, autolinkEmail:C, atxHeading:s(be), blockQuote:s($), characterEscape:C, characterReference:C, codeFenced:s(G), codeFencedFenceInfo:o, codeFencedFenceMeta:o, codeIndented:s(G, o), codeText:s(J, o), codeTextData:C, data:C, codeFlowValue:C, definition:s(U), definitionDestinationString:o, definitionLabelString:o, definitionTitleString:o, emphasis:s(le), hardBreakEscape:s(je), 
  hardBreakTrailing:s(je), htmlFlow:s(Ae, o), htmlFlowData:C, htmlText:s(Ae, o), htmlTextData:C, image:s(ue), label:o, link:s(Le), listItem:s(Ye), listItemValue:f, listOrdered:s($e, h), listUnordered:s($e), paragraph:s(Me), reference:M, referenceString:o, resourceDestinationString:o, resourceTitleString:o, setextHeading:s(be), strong:s(Xe), thematicBreak:s(se)}, exit:{atxHeading:l(), atxHeadingSequence:I, autolink:l(), autolinkEmail:R, autolinkProtocol:q, blockQuote:l(), characterEscapeValue:k, characterReferenceMarkerHexadecimal:ge, 
  characterReferenceMarkerNumeric:ge, characterReferenceValue:me, characterReference:te, codeFenced:l(b), codeFencedFence:m, codeFencedFenceInfo:p, codeFencedFenceMeta:g, codeFlowValue:k, codeIndented:l(x), codeText:l(B), codeTextData:k, data:k, definition:l(), definitionDestinationString:T, definitionLabelString:w, definitionTitleString:v, emphasis:l(), hardBreakEscape:l(P), hardBreakTrailing:l(P), htmlFlow:l(W), htmlFlowData:k, htmlText:l(F), htmlTextData:k, image:l(j), label:ne, labelText:V, lineEnding:A, 
  link:l(z), listItem:l(), listOrdered:l(), listUnordered:l(), paragraph:l(), referenceString:X, resourceDestinationString:D, resourceTitleString:ie, resource:ee, setextHeading:l(E), setextHeadingLineSequence:N, setextHeadingText:_, strong:l(), thematicBreak:l()}};
  rC(e, (t || {}).mdastExtensions || []);
  const n = {};
  return r;
  function r(oe) {
    let we = {type:"root", children:[]};
    const ke = {stack:[we], tokenStack:[], config:e, enter:a, exit:c, buffer:o, resume:u, data:n}, fe = [];
    let Oe = -1;
    for (; ++Oe < oe.length;) {
      if (oe[Oe][1].type === "listOrdered" || oe[Oe][1].type === "listUnordered") {
        if (oe[Oe][0] === "enter") {
          fe.push(Oe);
        } else {
          const We = fe.pop();
          Oe = i(oe, We, Oe);
        }
      }
    }
    for (Oe = -1; ++Oe < oe.length;) {
      const We = e[oe[Oe][0]];
      nC.call(We, oe[Oe][1].type) && We[oe[Oe][1].type].call(Object.assign({sliceSerialize:oe[Oe][2].sliceSerialize}, ke), oe[Oe][1]);
    }
    if (ke.tokenStack.length > 0) {
      const We = ke.tokenStack[ke.tokenStack.length - 1];
      (We[1] || Hw).call(ke, void 0, We[0]);
    }
    for (we.position = {start:To(oe.length > 0 ? oe[0][1].start : {line:1, column:1, offset:0}), end:To(oe.length > 0 ? oe[oe.length - 2][1].end : {line:1, column:1, offset:0})}, Oe = -1; ++Oe < e.transforms.length;) {
      we = e.transforms[Oe](we) || we;
    }
    return we;
  }
  function i(oe, we, ke) {
    let fe = we - 1, Oe = -1, We = !1, rt, st, ft, St;
    for (; ++fe <= ke;) {
      const ht = oe[fe];
      switch(ht[1].type) {
        case "listUnordered":
        case "listOrdered":
        case "blockQuote":
          {
            ht[0] === "enter" ? Oe++ : Oe--, St = void 0;
            break;
          }
        case "lineEndingBlank":
          {
            ht[0] === "enter" && (rt && !St && !Oe && !ft && (ft = fe), St = void 0);
            break;
          }
        case "linePrefix":
        case "listItemValue":
        case "listItemMarker":
        case "listItemPrefix":
        case "listItemPrefixWhitespace":
          break;
        default:
          St = void 0;
      }
      if (!Oe && ht[0] === "enter" && ht[1].type === "listItemPrefix" || Oe === -1 && ht[0] === "exit" && (ht[1].type === "listUnordered" || ht[1].type === "listOrdered")) {
        if (rt) {
          let xe = fe;
          for (st = void 0; xe--;) {
            const de = oe[xe];
            if (de[1].type === "lineEnding" || de[1].type === "lineEndingBlank") {
              if (de[0] === "exit") {
                continue;
              }
              st && (oe[st][1].type = "lineEndingBlank", We = !0), de[1].type = "lineEnding", st = xe;
            } else if (!(de[1].type === "linePrefix" || de[1].type === "blockQuotePrefix" || de[1].type === "blockQuotePrefixWhitespace" || de[1].type === "blockQuoteMarker" || de[1].type === "listItemIndent")) {
              break;
            }
          }
          ft && (!st || ft < st) && (rt._spread = !0), rt.end = Object.assign({}, st ? oe[st][1].start : ht[1].end), oe.splice(st || fe, 0, ["exit", rt, ht[2]]), fe++, ke++;
        }
        if (ht[1].type === "listItemPrefix") {
          const xe = {type:"listItem", _spread:!1, start:Object.assign({}, ht[1].start), end:void 0};
          rt = xe, oe.splice(fe, 0, ["enter", xe, ht[2]]), fe++, ke++, ft = void 0, St = !0;
        }
      }
    }
    return oe[we][1]._spread = We, ke;
  }
  function s(oe, we) {
    return ke;
    function ke(fe) {
      a.call(this, oe(fe), fe), we && we.call(this, fe);
    }
  }
  function o() {
    this.stack.push({type:"fragment", children:[]});
  }
  function a(oe, we, ke) {
    this.stack[this.stack.length - 1].children.push(oe), this.stack.push(oe), this.tokenStack.push([we, ke || void 0]), oe.position = {start:To(we.start), end:void 0};
  }
  function l(oe) {
    return we;
    function we(ke) {
      oe && oe.call(this, ke), c.call(this, ke);
    }
  }
  function c(oe, we) {
    const ke = this.stack.pop(), fe = this.tokenStack.pop();
    if (fe) {
      fe[0].type !== oe.type && (we ? we.call(this, oe, fe[0]) : (fe[1] || Hw).call(this, oe, fe[0]));
    } else {
      throw new Error("Cannot close `" + oe.type + "` (" + Ru({start:oe.start, end:oe.end}) + "): it\u2019s not open");
    }
    ke.position.end = To(oe.end);
  }
  function u() {
    return Cx(this.stack.pop());
  }
  function h() {
    this.data.expectingFirstListItemValue = !0;
  }
  function f(oe) {
    if (this.data.expectingFirstListItemValue) {
      const we = this.stack[this.stack.length - 2];
      we.start = Number.parseInt(this.sliceSerialize(oe), 10), this.data.expectingFirstListItemValue = void 0;
    }
  }
  function p() {
    const oe = this.resume(), we = this.stack[this.stack.length - 1];
    we.lang = oe;
  }
  function g() {
    const oe = this.resume(), we = this.stack[this.stack.length - 1];
    we.meta = oe;
  }
  function m() {
    this.data.flowCodeInside || (this.buffer(), this.data.flowCodeInside = !0);
  }
  function b() {
    const oe = this.resume(), we = this.stack[this.stack.length - 1];
    we.value = oe.replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, ""), this.data.flowCodeInside = void 0;
  }
  function x() {
    const oe = this.resume(), we = this.stack[this.stack.length - 1];
    we.value = oe.replace(/(\r?\n|\r)$/g, "");
  }
  function w(oe) {
    const we = this.resume(), ke = this.stack[this.stack.length - 1];
    ke.label = we, ke.identifier = ns(this.sliceSerialize(oe)).toLowerCase();
  }
  function v() {
    const oe = this.resume(), we = this.stack[this.stack.length - 1];
    we.title = oe;
  }
  function T() {
    const oe = this.resume(), we = this.stack[this.stack.length - 1];
    we.url = oe;
  }
  function I(oe) {
    const we = this.stack[this.stack.length - 1];
    if (!we.depth) {
      const ke = this.sliceSerialize(oe).length;
      we.depth = ke;
    }
  }
  function _() {
    this.data.setextHeadingSlurpLineEnding = !0;
  }
  function N(oe) {
    const we = this.stack[this.stack.length - 1];
    we.depth = this.sliceSerialize(oe).codePointAt(0) === 61 ? 1 : 2;
  }
  function E() {
    this.data.setextHeadingSlurpLineEnding = void 0;
  }
  function C(oe) {
    const ke = this.stack[this.stack.length - 1].children;
    let fe = ke[ke.length - 1];
    (!fe || fe.type !== "text") && (fe = it(), fe.position = {start:To(oe.start), end:void 0}, ke.push(fe)), this.stack.push(fe);
  }
  function k(oe) {
    const we = this.stack.pop();
    we.value += this.sliceSerialize(oe), we.position.end = To(oe.end);
  }
  function A(oe) {
    const we = this.stack[this.stack.length - 1];
    if (this.data.atHardBreak) {
      const ke = we.children[we.children.length - 1];
      ke.position.end = To(oe.end), this.data.atHardBreak = void 0;
      return;
    }
    !this.data.setextHeadingSlurpLineEnding && e.canContainEols.includes(we.type) && (C.call(this, oe), k.call(this, oe));
  }
  function P() {
    this.data.atHardBreak = !0;
  }
  function W() {
    const oe = this.resume(), we = this.stack[this.stack.length - 1];
    we.value = oe;
  }
  function F() {
    const oe = this.resume(), we = this.stack[this.stack.length - 1];
    we.value = oe;
  }
  function B() {
    const oe = this.resume(), we = this.stack[this.stack.length - 1];
    we.value = oe;
  }
  function z() {
    const oe = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const we = this.data.referenceType || "shortcut";
      oe.type += "Reference", oe.referenceType = we, delete oe.url, delete oe.title;
    } else {
      delete oe.identifier, delete oe.label;
    }
    this.data.referenceType = void 0;
  }
  function j() {
    const oe = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const we = this.data.referenceType || "shortcut";
      oe.type += "Reference", oe.referenceType = we, delete oe.url, delete oe.title;
    } else {
      delete oe.identifier, delete oe.label;
    }
    this.data.referenceType = void 0;
  }
  function V(oe) {
    const we = this.sliceSerialize(oe), ke = this.stack[this.stack.length - 2];
    ke.label = aB(we), ke.identifier = ns(we).toLowerCase();
  }
  function ne() {
    const oe = this.stack[this.stack.length - 1], we = this.resume(), ke = this.stack[this.stack.length - 1];
    if (this.data.inReference = !0, ke.type === "link") {
      const fe = oe.children;
      ke.children = fe;
    } else {
      ke.alt = we;
    }
  }
  function D() {
    const oe = this.resume(), we = this.stack[this.stack.length - 1];
    we.url = oe;
  }
  function ie() {
    const oe = this.resume(), we = this.stack[this.stack.length - 1];
    we.title = oe;
  }
  function ee() {
    this.data.inReference = void 0;
  }
  function M() {
    this.data.referenceType = "collapsed";
  }
  function X(oe) {
    const we = this.resume(), ke = this.stack[this.stack.length - 1];
    ke.label = we, ke.identifier = ns(this.sliceSerialize(oe)).toLowerCase(), this.data.referenceType = "full";
  }
  function ge(oe) {
    this.data.characterReferenceType = oe.type;
  }
  function me(oe) {
    const we = this.sliceSerialize(oe), ke = this.data.characterReferenceType;
    let fe;
    ke ? (fe = qT(we, ke === "characterReferenceMarkerNumeric" ? 10 : 16), this.data.characterReferenceType = void 0) : fe = Ax(we);
    const Oe = this.stack[this.stack.length - 1];
    Oe.value += fe;
  }
  function te(oe) {
    const we = this.stack.pop();
    we.position.end = To(oe.end);
  }
  function q(oe) {
    k.call(this, oe);
    const we = this.stack[this.stack.length - 1];
    we.url = this.sliceSerialize(oe);
  }
  function R(oe) {
    k.call(this, oe);
    const we = this.stack[this.stack.length - 1];
    we.url = "mailto:" + this.sliceSerialize(oe);
  }
  function $() {
    return {type:"blockquote", children:[]};
  }
  function G() {
    return {type:"code", lang:null, meta:null, value:""};
  }
  function J() {
    return {type:"inlineCode", value:""};
  }
  function U() {
    return {type:"definition", identifier:"", label:null, title:null, url:""};
  }
  function le() {
    return {type:"emphasis", children:[]};
  }
  function be() {
    return {type:"heading", depth:0, children:[]};
  }
  function je() {
    return {type:"break"};
  }
  function Ae() {
    return {type:"html", value:""};
  }
  function ue() {
    return {type:"image", title:null, url:"", alt:null};
  }
  function Le() {
    return {type:"link", title:null, url:"", children:[]};
  }
  function $e(oe) {
    return {type:"list", ordered:oe.type === "listOrdered", start:null, spread:oe._spread, children:[]};
  }
  function Ye(oe) {
    return {type:"listItem", spread:oe._spread, checked:null, children:[]};
  }
  function Me() {
    return {type:"paragraph", children:[]};
  }
  function Xe() {
    return {type:"strong", children:[]};
  }
  function it() {
    return {type:"text", value:""};
  }
  function se() {
    return {type:"thematicBreak"};
  }
}
function To(t) {
  return {line:t.line, column:t.column, offset:t.offset};
}
function rC(t, e) {
  let n = -1;
  for (; ++n < e.length;) {
    const r = e[n];
    Array.isArray(r) ? rC(t, r) : dB(t, r);
  }
}
function dB(t, e) {
  let n;
  for (n in e) {
    if (nC.call(e, n)) {
      switch(n) {
        case "canContainEols":
          {
            const r = e[n];
            r && t[n].push(...r);
            break;
          }
        case "transforms":
          {
            const r = e[n];
            r && t[n].push(...r);
            break;
          }
        case "enter":
        case "exit":
          {
            const r = e[n];
            r && Object.assign(t[n], r);
            break;
          }
      }
    }
  }
}
function Hw(t, e) {
  throw t ? new Error("Cannot close `" + t.type + "` (" + Ru({start:t.start, end:t.end}) + "): a different token (`" + e.type + "`, " + Ru({start:e.start, end:e.end}) + ") is open") : new Error("Cannot close document, a token (`" + e.type + "`, " + Ru({start:e.start, end:e.end}) + ") is still open");
}
function hB(t) {
  const e = this;
  e.parser = n;
  function n(r) {
    return cB(r, {...e.data("settings"), ...t, extensions:e.data("micromarkExtensions") || [], mdastExtensions:e.data("fromMarkdownExtensions") || []});
  }
}
function fB(t, e) {
  const n = {type:"element", tagName:"blockquote", properties:{}, children:t.wrap(t.all(e), !0)};
  return t.patch(e, n), t.applyData(e, n);
}
function pB(t, e) {
  const n = {type:"element", tagName:"br", properties:{}, children:[]};
  return t.patch(e, n), [t.applyData(e, n), {type:"text", value:`
`}];
}
function gB(t, e) {
  const n = e.value ? e.value + `
` : "", r = {}, i = e.lang ? e.lang.split(/\s+/) : [];
  i.length > 0 && (r.className = ["language-" + i[0]]);
  let s = {type:"element", tagName:"code", properties:r, children:[{type:"text", value:n}]};
  return e.meta && (s.data = {meta:e.meta}), t.patch(e, s), s = t.applyData(e, s), s = {type:"element", tagName:"pre", properties:{}, children:[s]}, t.patch(e, s), s;
}
function mB(t, e) {
  const n = {type:"element", tagName:"del", properties:{}, children:t.all(e)};
  return t.patch(e, n), t.applyData(e, n);
}
function bB(t, e) {
  const n = {type:"element", tagName:"em", properties:{}, children:t.all(e)};
  return t.patch(e, n), t.applyData(e, n);
}
function yB(t, e) {
  const n = typeof t.options.clobberPrefix == "string" ? t.options.clobberPrefix : "user-content-", r = String(e.identifier).toUpperCase(), i = kc(r.toLowerCase()), s = t.footnoteOrder.indexOf(r);
  let o, a = t.footnoteCounts.get(r);
  a === void 0 ? (a = 0, t.footnoteOrder.push(r), o = t.footnoteOrder.length) : o = s + 1, a += 1, t.footnoteCounts.set(r, a);
  const l = {type:"element", tagName:"a", properties:{href:"#" + n + "fn-" + i, id:n + "fnref-" + i + (a > 1 ? "-" + a : ""), dataFootnoteRef:!0, ariaDescribedBy:["footnote-label"]}, children:[{type:"text", value:String(o)}]};
  t.patch(e, l);
  const c = {type:"element", tagName:"sup", properties:{}, children:[l]};
  return t.patch(e, c), t.applyData(e, c);
}
function xB(t, e) {
  const n = {type:"element", tagName:"h" + e.depth, properties:{}, children:t.all(e)};
  return t.patch(e, n), t.applyData(e, n);
}
function vB(t, e) {
  if (t.options.allowDangerousHtml) {
    const n = {type:"raw", value:e.value};
    return t.patch(e, n), t.applyData(e, n);
  }
}
function iC(t, e) {
  const n = e.referenceType;
  let r = "]";
  if (n === "collapsed" ? r += "[]" : n === "full" && (r += "[" + (e.label || e.identifier) + "]"), e.type === "imageReference") {
    return [{type:"text", value:"![" + e.alt + r}];
  }
  const i = t.all(e), s = i[0];
  s && s.type === "text" ? s.value = "[" + s.value : i.unshift({type:"text", value:"["});
  const o = i[i.length - 1];
  return o && o.type === "text" ? o.value += r : i.push({type:"text", value:r}), i;
}
function wB(t, e) {
  const n = String(e.identifier).toUpperCase(), r = t.definitionById.get(n);
  if (!r) {
    return iC(t, e);
  }
  const i = {src:kc(r.url || ""), alt:e.alt};
  r.title !== null && r.title !== void 0 && (i.title = r.title);
  const s = {type:"element", tagName:"img", properties:i, children:[]};
  return t.patch(e, s), t.applyData(e, s);
}
function _B(t, e) {
  const n = {src:kc(e.url)};
  e.alt !== null && e.alt !== void 0 && (n.alt = e.alt), e.title !== null && e.title !== void 0 && (n.title = e.title);
  const r = {type:"element", tagName:"img", properties:n, children:[]};
  return t.patch(e, r), t.applyData(e, r);
}
function SB(t, e) {
  const n = {type:"text", value:e.value.replace(/\r?\n|\r/g, " ")};
  t.patch(e, n);
  const r = {type:"element", tagName:"code", properties:{}, children:[n]};
  return t.patch(e, r), t.applyData(e, r);
}
function kB(t, e) {
  const n = String(e.identifier).toUpperCase(), r = t.definitionById.get(n);
  if (!r) {
    return iC(t, e);
  }
  const i = {href:kc(r.url || "")};
  r.title !== null && r.title !== void 0 && (i.title = r.title);
  const s = {type:"element", tagName:"a", properties:i, children:t.all(e)};
  return t.patch(e, s), t.applyData(e, s);
}
function EB(t, e) {
  const n = {href:kc(e.url)};
  e.title !== null && e.title !== void 0 && (n.title = e.title);
  const r = {type:"element", tagName:"a", properties:n, children:t.all(e)};
  return t.patch(e, r), t.applyData(e, r);
}
function TB(t, e, n) {
  const r = t.all(e), i = n ? CB(n) : sC(e), s = {}, o = [];
  if (typeof e.checked == "boolean") {
    const u = r[0];
    let h;
    u && u.type === "element" && u.tagName === "p" ? h = u : (h = {type:"element", tagName:"p", properties:{}, children:[]}, r.unshift(h)), h.children.length > 0 && h.children.unshift({type:"text", value:" "}), h.children.unshift({type:"element", tagName:"input", properties:{type:"checkbox", checked:e.checked, disabled:!0}, children:[]}), s.className = ["task-list-item"];
  }
  let a = -1;
  for (; ++a < r.length;) {
    const u = r[a];
    (i || a !== 0 || u.type !== "element" || u.tagName !== "p") && o.push({type:"text", value:`
`}), u.type === "element" && u.tagName === "p" && !i ? o.push(...u.children) : o.push(u);
  }
  const l = r[r.length - 1];
  l && (i || l.type !== "element" || l.tagName !== "p") && o.push({type:"text", value:`
`});
  const c = {type:"element", tagName:"li", properties:s, children:o};
  return t.patch(e, c), t.applyData(e, c);
}
function CB(t) {
  let e = !1;
  if (t.type === "list") {
    e = t.spread || !1;
    const n = t.children;
    let r = -1;
    for (; !e && ++r < n.length;) {
      e = sC(n[r]);
    }
  }
  return e;
}
function sC(t) {
  const e = t.spread;
  return e ?? t.children.length > 1;
}
function AB(t, e) {
  const n = {}, r = t.all(e);
  let i = -1;
  for (typeof e.start == "number" && e.start !== 1 && (n.start = e.start); ++i < r.length;) {
    const o = r[i];
    if (o.type === "element" && o.tagName === "li" && o.properties && Array.isArray(o.properties.className) && o.properties.className.includes("task-list-item")) {
      n.className = ["contains-task-list"];
      break;
    }
  }
  const s = {type:"element", tagName:e.ordered ? "ol" : "ul", properties:n, children:t.wrap(r, !0)};
  return t.patch(e, s), t.applyData(e, s);
}
function NB(t, e) {
  const n = {type:"element", tagName:"p", properties:{}, children:t.all(e)};
  return t.patch(e, n), t.applyData(e, n);
}
function IB(t, e) {
  const n = {type:"root", children:t.wrap(t.all(e))};
  return t.patch(e, n), t.applyData(e, n);
}
function OB(t, e) {
  const n = {type:"element", tagName:"strong", properties:{}, children:t.all(e)};
  return t.patch(e, n), t.applyData(e, n);
}
function PB(t, e) {
  const n = t.all(e), r = n.shift(), i = [];
  if (r) {
    const o = {type:"element", tagName:"thead", properties:{}, children:t.wrap([r], !0)};
    t.patch(e.children[0], o), i.push(o);
  }
  if (n.length > 0) {
    const o = {type:"element", tagName:"tbody", properties:{}, children:t.wrap(n, !0)}, a = Bs(e.children[1]), l = mg(e.children[e.children.length - 1]);
    a && l && (o.position = {start:a, end:l}), i.push(o);
  }
  const s = {type:"element", tagName:"table", properties:{}, children:t.wrap(i, !0)};
  return t.patch(e, s), t.applyData(e, s);
}
function RB(t, e, n) {
  const r = n ? n.children : void 0, s = (r ? r.indexOf(e) : 1) === 0 ? "th" : "td", o = n && n.type === "table" ? n.align : void 0, a = o ? o.length : e.children.length;
  let l = -1;
  const c = [];
  for (; ++l < a;) {
    const h = e.children[l], f = {}, p = o ? o[l] : void 0;
    p && (f.align = p);
    let g = {type:"element", tagName:s, properties:f, children:[]};
    h && (g.children = t.all(h), t.patch(h, g), g = t.applyData(h, g)), c.push(g);
  }
  const u = {type:"element", tagName:"tr", properties:{}, children:t.wrap(c, !0)};
  return t.patch(e, u), t.applyData(e, u);
}
function DB(t, e) {
  const n = {type:"element", tagName:"td", properties:{}, children:t.all(e)};
  return t.patch(e, n), t.applyData(e, n);
}
const Uw = 9, Ww = 32;
function LB(t) {
  const e = String(t), n = /\r?\n|\r/g;
  let r = n.exec(e), i = 0;
  const s = [];
  for (; r;) {
    s.push(jw(e.slice(i, r.index), i > 0, !0), r[0]), i = r.index + r[0].length, r = n.exec(e);
  }
  return s.push(jw(e.slice(i), i > 0, !1)), s.join("");
}
function jw(t, e, n) {
  let r = 0, i = t.length;
  if (e) {
    let s = t.codePointAt(r);
    for (; s === Uw || s === Ww;) {
      r++, s = t.codePointAt(r);
    }
  }
  if (n) {
    let s = t.codePointAt(i - 1);
    for (; s === Uw || s === Ww;) {
      i--, s = t.codePointAt(i - 1);
    }
  }
  return i > r ? t.slice(r, i) : "";
}
function MB(t, e) {
  const n = {type:"text", value:LB(String(e.value))};
  return t.patch(e, n), t.applyData(e, n);
}
function BB(t, e) {
  const n = {type:"element", tagName:"hr", properties:{}, children:[]};
  return t.patch(e, n), t.applyData(e, n);
}
const $B = {blockquote:fB, break:pB, code:gB, delete:mB, emphasis:bB, footnoteReference:yB, heading:xB, html:vB, imageReference:wB, image:_B, inlineCode:SB, linkReference:kB, link:EB, listItem:TB, list:AB, paragraph:NB, root:IB, strong:OB, table:PB, tableCell:DB, tableRow:RB, text:MB, thematicBreak:BB, toml:kh, yaml:kh, definition:kh, footnoteDefinition:kh};
function kh() {
}
const oC = -1, xg = 0, Lu = 1, ip = 2, Ix = 3, Ox = 4, Px = 5, Rx = 6, aC = 7, lC = 8, FB = typeof self == "object" ? self : globalThis, Vw = (t, e) => {
  switch(t) {
    case "Function":
    case "SharedWorker":
    case "Worker":
    case "eval":
    case "setInterval":
    case "setTimeout":
      throw new TypeError("unable to deserialize " + t);
  }
  return new FB[t](e);
}, zB = (t, e) => {
  const n = (i, s) => (t.set(s, i), i), r = i => {
    if (t.has(i)) {
      return t.get(i);
    }
    const [s, o] = e[i];
    switch(s) {
      case xg:
      case oC:
        return n(o, i);
      case Lu:
        {
          const a = n([], i);
          for (const l of o) {
            a.push(r(l));
          }
          return a;
        }
      case ip:
        {
          const a = n({}, i);
          for (const [l, c] of o) {
            a[r(l)] = r(c);
          }
          return a;
        }
      case Ix:
        return n(new Date(o), i);
      case Ox:
        {
          const {source:a, flags:l} = o;
          return n(new RegExp(a, l), i);
        }
      case Px:
        {
          const a = n(new Map(), i);
          for (const [l, c] of o) {
            a.set(r(l), r(c));
          }
          return a;
        }
      case Rx:
        {
          const a = n(new Set(), i);
          for (const l of o) {
            a.add(r(l));
          }
          return a;
        }
      case aC:
        {
          const {name:a, message:l} = o;
          return n(Vw(a, l), i);
        }
      case lC:
        return n(BigInt(o), i);
      case "BigInt":
        return n(Object(BigInt(o)), i);
      case "ArrayBuffer":
        return n((new Uint8Array(o)).buffer, o);
      case "DataView":
        {
          const {buffer:a} = new Uint8Array(o);
          return n(new DataView(a), o);
        }
    }
    return n(Vw(s, o), i);
  };
  return r;
}, qw = t => zB(new Map(), t)(0), yl = "", {toString:HB} = {}, {keys:UB} = Object, Gc = t => {
  const e = typeof t;
  if (e !== "object" || !t) {
    return [xg, e];
  }
  const n = HB.call(t).slice(8, -1);
  switch(n) {
    case "Array":
      return [Lu, yl];
    case "Object":
      return [ip, yl];
    case "Date":
      return [Ix, yl];
    case "RegExp":
      return [Ox, yl];
    case "Map":
      return [Px, yl];
    case "Set":
      return [Rx, yl];
    case "DataView":
      return [Lu, n];
  }
  return n.includes("Array") ? [Lu, n] : n.includes("Error") ? [aC, n] : [ip, n];
}, Eh = ([t, e]) => t === xg && (e === "function" || e === "symbol"), WB = (t, e, n, r) => {
  const i = (o, a) => {
    const l = r.push(o) - 1;
    return n.set(a, l), l;
  }, s = o => {
    if (n.has(o)) {
      return n.get(o);
    }
    let [a, l] = Gc(o);
    switch(a) {
      case xg:
        {
          let u = o;
          switch(l) {
            case "bigint":
              a = lC, u = o.toString();
              break;
            case "function":
            case "symbol":
              if (t) {
                throw new TypeError("unable to serialize " + l);
              }
              u = null;
              break;
            case "undefined":
              return i([oC], o);
          }
          return i([a, u], o);
        }
      case Lu:
        {
          if (l) {
            let f = o;
            return l === "DataView" ? f = new Uint8Array(o.buffer) : l === "ArrayBuffer" && (f = new Uint8Array(o)), i([l, [...f]], o);
          }
          const u = [], h = i([a, u], o);
          for (const f of o) {
            u.push(s(f));
          }
          return h;
        }
      case ip:
        {
          if (l) {
            switch(l) {
              case "BigInt":
                return i([l, o.toString()], o);
              case "Boolean":
              case "Number":
              case "String":
                return i([l, o.valueOf()], o);
            }
          }
          if (e && "toJSON" in o) {
            return s(o.toJSON());
          }
          const u = [], h = i([a, u], o);
          for (const f of UB(o)) {
            (t || !Eh(Gc(o[f]))) && u.push([s(f), s(o[f])]);
          }
          return h;
        }
      case Ix:
        return i([a, o.toISOString()], o);
      case Ox:
        {
          const {source:u, flags:h} = o;
          return i([a, {source:u, flags:h}], o);
        }
      case Px:
        {
          const u = [], h = i([a, u], o);
          for (const [f, p] of o) {
            (t || !(Eh(Gc(f)) || Eh(Gc(p)))) && u.push([s(f), s(p)]);
          }
          return h;
        }
      case Rx:
        {
          const u = [], h = i([a, u], o);
          for (const f of o) {
            (t || !Eh(Gc(f))) && u.push(s(f));
          }
          return h;
        }
    }
    const {message:c} = o;
    return i([a, {name:l, message:c}], o);
  };
  return s;
}, Yw = (t, {json:e, lossy:n} = {}) => {
  const r = [];
  return WB(!(e || n), !!e, new Map(), r)(t), r;
}, sc = typeof structuredClone == "function" ? (t, e) => e && ("json" in e || "lossy" in e) ? qw(Yw(t, e)) : structuredClone(t) : (t, e) => qw(Yw(t, e));
function jB(t, e) {
  const n = [{type:"text", value:"\u21a9"}];
  return e > 1 && n.push({type:"element", tagName:"sup", properties:{}, children:[{type:"text", value:String(e)}]}), n;
}
function VB(t, e) {
  return "Back to reference " + (t + 1) + (e > 1 ? "-" + e : "");
}
function qB(t) {
  const e = typeof t.options.clobberPrefix == "string" ? t.options.clobberPrefix : "user-content-", n = t.options.footnoteBackContent || jB, r = t.options.footnoteBackLabel || VB, i = t.options.footnoteLabel || "Footnotes", s = t.options.footnoteLabelTagName || "h2", o = t.options.footnoteLabelProperties || {className:["sr-only"]}, a = [];
  let l = -1;
  for (; ++l < t.footnoteOrder.length;) {
    const c = t.footnoteById.get(t.footnoteOrder[l]);
    if (!c) {
      continue;
    }
    const u = t.all(c), h = String(c.identifier).toUpperCase(), f = kc(h.toLowerCase());
    let p = 0;
    const g = [], m = t.footnoteCounts.get(h);
    for (; m !== void 0 && ++p <= m;) {
      g.length > 0 && g.push({type:"text", value:" "});
      let w = typeof n == "string" ? n : n(l, p);
      typeof w == "string" && (w = {type:"text", value:w}), g.push({type:"element", tagName:"a", properties:{href:"#" + e + "fnref-" + f + (p > 1 ? "-" + p : ""), dataFootnoteBackref:"", ariaLabel:typeof r == "string" ? r : r(l, p), className:["data-footnote-backref"]}, children:Array.isArray(w) ? w : [w]});
    }
    const b = u[u.length - 1];
    if (b && b.type === "element" && b.tagName === "p") {
      const w = b.children[b.children.length - 1];
      w && w.type === "text" ? w.value += " " : b.children.push({type:"text", value:" "}), b.children.push(...g);
    } else {
      u.push(...g);
    }
    const x = {type:"element", tagName:"li", properties:{id:e + "fn-" + f}, children:t.wrap(u, !0)};
    t.patch(c, x), a.push(x);
  }
  if (a.length !== 0) {
    return {type:"element", tagName:"section", properties:{dataFootnotes:!0, className:["footnotes"]}, children:[{type:"element", tagName:s, properties:{...sc(o), id:"footnote-label"}, children:[{type:"text", value:i}]}, {type:"text", value:`
`}, {type:"element", tagName:"ol", properties:{}, children:t.wrap(a, !0)}, {type:"text", value:`
`}]};
  }
}
const vg = function(t) {
  if (t == null) {
    return KB;
  }
  if (typeof t == "function") {
    return wg(t);
  }
  if (typeof t == "object") {
    return Array.isArray(t) ? YB(t) : GB(t);
  }
  if (typeof t == "string") {
    return QB(t);
  }
  throw new Error("Expected function, string, or object as test");
};
function YB(t) {
  const e = [];
  let n = -1;
  for (; ++n < t.length;) {
    e[n] = vg(t[n]);
  }
  return wg(r);
  function r(...i) {
    let s = -1;
    for (; ++s < e.length;) {
      if (e[s].apply(this, i)) {
        return !0;
      }
    }
    return !1;
  }
}
function GB(t) {
  const e = t;
  return wg(n);
  function n(r) {
    const i = r;
    let s;
    for (s in t) {
      if (i[s] !== e[s]) {
        return !1;
      }
    }
    return !0;
  }
}
function QB(t) {
  return wg(e);
  function e(n) {
    return n && n.type === t;
  }
}
function wg(t) {
  return e;
  function e(n, r, i) {
    return !!(XB(n) && t.call(this, n, typeof r == "number" ? r : void 0, i || void 0));
  }
}
function KB() {
  return !0;
}
function XB(t) {
  return t !== null && typeof t == "object" && "type" in t;
}
const cC = [], JB = !0, pb = !1, ZB = "skip";
function uC(t, e, n, r) {
  let i;
  typeof e == "function" && typeof n != "function" ? (r = n, n = e) : i = e;
  const s = vg(i), o = r ? -1 : 1;
  a(t, void 0, [])();
  function a(l, c, u) {
    const h = l && typeof l == "object" ? l : {};
    if (typeof h.type == "string") {
      const p = typeof h.tagName == "string" ? h.tagName : typeof h.name == "string" ? h.name : void 0;
      Object.defineProperty(f, "name", {value:"node (" + (l.type + (p ? "\x3c" + p + "\x3e" : "")) + ")"});
    }
    return f;
    function f() {
      let p = cC, g, m, b;
      if ((!e || s(l, c, u[u.length - 1] || void 0)) && (p = e$(n(l, u)), p[0] === pb)) {
        return p;
      }
      if ("children" in l && l.children) {
        const x = l;
        if (x.children && p[0] !== ZB) {
          for (m = (r ? x.children.length : -1) + o, b = u.concat(x); m > -1 && m < x.children.length;) {
            const w = x.children[m];
            if (g = a(w, m, b)(), g[0] === pb) {
              return g;
            }
            m = typeof g[1] == "number" ? g[1] : m + o;
          }
        }
      }
      return p;
    }
  }
}
function e$(t) {
  return Array.isArray(t) ? t : typeof t == "number" ? [JB, t] : t == null ? cC : [t];
}
function _g(t, e, n, r) {
  let i, s, o;
  typeof e == "function" && typeof n != "function" ? (s = void 0, o = e, i = n) : (s = e, o = n, i = r), uC(t, s, a, i);
  function a(l, c) {
    const u = c[c.length - 1], h = u ? u.children.indexOf(l) : void 0;
    return o(l, h, u);
  }
}
const gb = {}.hasOwnProperty, t$ = {};
function n$(t, e) {
  const n = e || t$, r = new Map(), i = new Map(), s = new Map(), o = {...$B, ...n.handlers}, a = {all:c, applyData:i$, definitionById:r, footnoteById:i, footnoteCounts:s, footnoteOrder:[], handlers:o, one:l, options:n, patch:r$, wrap:o$};
  return _g(t, function(u) {
    if (u.type === "definition" || u.type === "footnoteDefinition") {
      const h = u.type === "definition" ? r : i, f = String(u.identifier).toUpperCase();
      h.has(f) || h.set(f, u);
    }
  }), a;
  function l(u, h) {
    const f = u.type, p = a.handlers[f];
    if (gb.call(a.handlers, f) && p) {
      return p(a, u, h);
    }
    if (a.options.passThrough && a.options.passThrough.includes(f)) {
      if ("children" in u) {
        const {children:m, ...b} = u, x = sc(b);
        return x.children = a.all(u), x;
      }
      return sc(u);
    }
    return (a.options.unknownHandler || s$)(a, u, h);
  }
  function c(u) {
    const h = [];
    if ("children" in u) {
      const f = u.children;
      let p = -1;
      for (; ++p < f.length;) {
        const g = a.one(f[p], u);
        if (g) {
          if (p && f[p - 1].type === "break" && (!Array.isArray(g) && g.type === "text" && (g.value = Gw(g.value)), !Array.isArray(g) && g.type === "element")) {
            const m = g.children[0];
            m && m.type === "text" && (m.value = Gw(m.value));
          }
          Array.isArray(g) ? h.push(...g) : h.push(g);
        }
      }
    }
    return h;
  }
}
function r$(t, e) {
  t.position && (e.position = j6(t));
}
function i$(t, e) {
  let n = e;
  if (t && t.data) {
    const r = t.data.hName, i = t.data.hChildren, s = t.data.hProperties;
    if (typeof r == "string") {
      if (n.type === "element") {
        n.tagName = r;
      } else {
        const o = "children" in n ? n.children : [n];
        n = {type:"element", tagName:r, properties:{}, children:o};
      }
    }
    n.type === "element" && s && Object.assign(n.properties, sc(s)), "children" in n && n.children && i !== null && i !== void 0 && (n.children = i);
  }
  return n;
}
function s$(t, e) {
  const n = e.data || {}, r = "value" in e && !(gb.call(n, "hProperties") || gb.call(n, "hChildren")) ? {type:"text", value:e.value} : {type:"element", tagName:"div", properties:{}, children:t.all(e)};
  return t.patch(e, r), t.applyData(e, r);
}
function o$(t, e) {
  const n = [];
  let r = -1;
  for (e && n.push({type:"text", value:`
`}); ++r < t.length;) {
    r && n.push({type:"text", value:`
`}), n.push(t[r]);
  }
  return e && t.length > 0 && n.push({type:"text", value:`
`}), n;
}
function Gw(t) {
  let e = 0, n = t.charCodeAt(e);
  for (; n === 9 || n === 32;) {
    e++, n = t.charCodeAt(e);
  }
  return t.slice(e);
}
function Qw(t, e) {
  const n = n$(t, e), r = n.one(t, void 0), i = qB(n), s = Array.isArray(r) ? {type:"root", children:r} : r || {type:"root", children:[]};
  return i && s.children.push({type:"text", value:`
`}, i), s;
}
function a$(t, e) {
  return t && "run" in t ? async function(n, r) {
    const i = Qw(n, {file:r, ...e});
    await t.run(i, r);
  } : function(n, r) {
    return Qw(n, {file:r, ...(t || e)});
  };
}
function Kw(t) {
  if (t) {
    throw t;
  }
}
var Cf = Object.prototype.hasOwnProperty, dC = Object.prototype.toString, Xw = Object.defineProperty, Jw = Object.getOwnPropertyDescriptor, Zw = function(e) {
  return typeof Array.isArray == "function" ? Array.isArray(e) : dC.call(e) === "[object Array]";
}, e_ = function(e) {
  if (!e || dC.call(e) !== "[object Object]") {
    return !1;
  }
  var n = Cf.call(e, "constructor"), r = e.constructor && e.constructor.prototype && Cf.call(e.constructor.prototype, "isPrototypeOf");
  if (e.constructor && !n && !r) {
    return !1;
  }
  var i;
  for (i in e) {
  }
  return typeof i > "u" || Cf.call(e, i);
}, t_ = function(e, n) {
  Xw && n.name === "__proto__" ? Xw(e, n.name, {enumerable:!0, configurable:!0, value:n.newValue, writable:!0}) : e[n.name] = n.newValue;
}, n_ = function(e, n) {
  if (n === "__proto__") {
    if (Cf.call(e, n)) {
      if (Jw) {
        return Jw(e, n).value;
      }
    } else {
      return;
    }
  }
  return e[n];
}, l$ = function t() {
  var e, n, r, i, s, o, a = arguments[0], l = 1, c = arguments.length, u = !1;
  for (typeof a == "boolean" && (u = a, a = arguments[1] || {}, l = 2), (a == null || typeof a != "object" && typeof a != "function") && (a = {}); l < c; ++l) {
    if (e = arguments[l], e != null) {
      for (n in e) {
        r = n_(a, n), i = n_(e, n), a !== i && (u && i && (e_(i) || (s = Zw(i))) ? (s ? (s = !1, o = r && Zw(r) ? r : []) : o = r && e_(r) ? r : {}, t_(a, {name:n, newValue:t(u, o, i)})) : typeof i < "u" && t_(a, {name:n, newValue:i}));
      }
    }
  }
  return a;
};
const vm = Vd(l$);
function mb(t) {
  if (typeof t != "object" || t === null) {
    return !1;
  }
  const e = Object.getPrototypeOf(t);
  return (e === null || e === Object.prototype || Object.getPrototypeOf(e) === null) && !(Symbol.toStringTag in t) && !(Symbol.iterator in t);
}
function c$() {
  const t = [], e = {run:n, use:r};
  return e;
  function n(...i) {
    let s = -1;
    const o = i.pop();
    if (typeof o != "function") {
      throw new TypeError("Expected function as last argument, not " + o);
    }
    a(null, ...i);
    function a(l, ...c) {
      const u = t[++s];
      let h = -1;
      if (l) {
        o(l);
        return;
      }
      for (; ++h < i.length;) {
        (c[h] === null || c[h] === void 0) && (c[h] = i[h]);
      }
      i = c, u ? u$(u, a)(...c) : o(null, ...c);
    }
  }
  function r(i) {
    if (typeof i != "function") {
      throw new TypeError("Expected `middelware` to be a function, not " + i);
    }
    return t.push(i), e;
  }
}
function u$(t, e) {
  let n;
  return r;
  function r(...o) {
    const a = t.length > o.length;
    let l;
    a && o.push(i);
    try {
      l = t.apply(this, o);
    } catch (c) {
      const u = c;
      if (a && n) {
        throw u;
      }
      return i(u);
    }
    a || (l && l.then && typeof l.then == "function" ? l.then(s, i) : l instanceof Error ? i(l) : s(l));
  }
  function i(o, ...a) {
    n || (n = !0, e(o, ...a));
  }
  function s(o) {
    i(null, o);
  }
}
const ws = {basename:d$, dirname:h$, extname:f$, join:p$, sep:"/"};
function d$(t, e) {
  if (e !== void 0 && typeof e != "string") {
    throw new TypeError('"ext" argument must be a string');
  }
  Yd(t);
  let n = 0, r = -1, i = t.length, s;
  if (e === void 0 || e.length === 0 || e.length > t.length) {
    for (; i--;) {
      if (t.codePointAt(i) === 47) {
        if (s) {
          n = i + 1;
          break;
        }
      } else {
        r < 0 && (s = !0, r = i + 1);
      }
    }
    return r < 0 ? "" : t.slice(n, r);
  }
  if (e === t) {
    return "";
  }
  let o = -1, a = e.length - 1;
  for (; i--;) {
    if (t.codePointAt(i) === 47) {
      if (s) {
        n = i + 1;
        break;
      }
    } else {
      o < 0 && (s = !0, o = i + 1), a > -1 && (t.codePointAt(i) === e.codePointAt(a--) ? a < 0 && (r = i) : (a = -1, r = o));
    }
  }
  return n === r ? r = o : r < 0 && (r = t.length), t.slice(n, r);
}
function h$(t) {
  if (Yd(t), t.length === 0) {
    return ".";
  }
  let e = -1, n = t.length, r;
  for (; --n;) {
    if (t.codePointAt(n) === 47) {
      if (r) {
        e = n;
        break;
      }
    } else {
      r || (r = !0);
    }
  }
  return e < 0 ? t.codePointAt(0) === 47 ? "/" : "." : e === 1 && t.codePointAt(0) === 47 ? "//" : t.slice(0, e);
}
function f$(t) {
  Yd(t);
  let e = t.length, n = -1, r = 0, i = -1, s = 0, o;
  for (; e--;) {
    const a = t.codePointAt(e);
    if (a === 47) {
      if (o) {
        r = e + 1;
        break;
      }
      continue;
    }
    n < 0 && (o = !0, n = e + 1), a === 46 ? i < 0 ? i = e : s !== 1 && (s = 1) : i > -1 && (s = -1);
  }
  return i < 0 || n < 0 || s === 0 || s === 1 && i === n - 1 && i === r + 1 ? "" : t.slice(i, n);
}
function p$(...t) {
  let e = -1, n;
  for (; ++e < t.length;) {
    Yd(t[e]), t[e] && (n = n === void 0 ? t[e] : n + "/" + t[e]);
  }
  return n === void 0 ? "." : g$(n);
}
function g$(t) {
  Yd(t);
  const e = t.codePointAt(0) === 47;
  let n = m$(t, !e);
  return n.length === 0 && !e && (n = "."), n.length > 0 && t.codePointAt(t.length - 1) === 47 && (n += "/"), e ? "/" + n : n;
}
function m$(t, e) {
  let n = "", r = 0, i = -1, s = 0, o = -1, a, l;
  for (; ++o <= t.length;) {
    if (o < t.length) {
      a = t.codePointAt(o);
    } else {
      if (a === 47) {
        break;
      }
      a = 47;
    }
    if (a === 47) {
      if (!(i === o - 1 || s === 1)) {
        if (i !== o - 1 && s === 2) {
          if (n.length < 2 || r !== 2 || n.codePointAt(n.length - 1) !== 46 || n.codePointAt(n.length - 2) !== 46) {
            if (n.length > 2) {
              if (l = n.lastIndexOf("/"), l !== n.length - 1) {
                l < 0 ? (n = "", r = 0) : (n = n.slice(0, l), r = n.length - 1 - n.lastIndexOf("/")), i = o, s = 0;
                continue;
              }
            } else if (n.length > 0) {
              n = "", r = 0, i = o, s = 0;
              continue;
            }
          }
          e && (n = n.length > 0 ? n + "/.." : "..", r = 2);
        } else {
          n.length > 0 ? n += "/" + t.slice(i + 1, o) : n = t.slice(i + 1, o), r = o - i - 1;
        }
      }
      i = o, s = 0;
    } else {
      a === 46 && s > -1 ? s++ : s = -1;
    }
  }
  return n;
}
function Yd(t) {
  if (typeof t != "string") {
    throw new TypeError("Path must be a string. Received " + JSON.stringify(t));
  }
}
const b$ = {cwd:y$};
function y$() {
  return "/";
}
function bb(t) {
  return !!(t !== null && typeof t == "object" && "href" in t && t.href && "protocol" in t && t.protocol && t.auth === void 0);
}
function x$(t) {
  if (typeof t == "string") {
    t = new URL(t);
  } else if (!bb(t)) {
    const e = new TypeError('The "path" argument must be of type string or an instance of URL. Received `' + t + "`");
    throw e.code = "ERR_INVALID_ARG_TYPE", e;
  }
  if (t.protocol !== "file:") {
    const e = new TypeError("The URL must be of scheme file");
    throw e.code = "ERR_INVALID_URL_SCHEME", e;
  }
  return v$(t);
}
function v$(t) {
  if (t.hostname !== "") {
    const r = new TypeError('File URL host must be "localhost" or empty on darwin');
    throw r.code = "ERR_INVALID_FILE_URL_HOST", r;
  }
  const e = t.pathname;
  let n = -1;
  for (; ++n < e.length;) {
    if (e.codePointAt(n) === 37 && e.codePointAt(n + 1) === 50) {
      const r = e.codePointAt(n + 2);
      if (r === 70 || r === 102) {
        const i = new TypeError("File URL path must not include encoded / characters");
        throw i.code = "ERR_INVALID_FILE_URL_PATH", i;
      }
    }
  }
  return decodeURIComponent(e);
}
const wm = ["history", "path", "basename", "stem", "extname", "dirname"];
class hC {
  constructor(e) {
    let n;
    e ? bb(e) ? n = {path:e} : typeof e == "string" || w$(e) ? n = {value:e} : n = e : n = {}, this.cwd = "cwd" in n ? "" : b$.cwd(), this.data = {}, this.history = [], this.messages = [], this.value, this.map, this.result, this.stored;
    let r = -1;
    for (; ++r < wm.length;) {
      const s = wm[r];
      s in n && n[s] !== void 0 && n[s] !== null && (this[s] = s === "history" ? [...n[s]] : n[s]);
    }
    let i;
    for (i in n) {
      wm.includes(i) || (this[i] = n[i]);
    }
  }
  get basename() {
    return typeof this.path == "string" ? ws.basename(this.path) : void 0;
  }
  set basename(e) {
    Sm(e, "basename"), _m(e, "basename"), this.path = ws.join(this.dirname || "", e);
  }
  get dirname() {
    return typeof this.path == "string" ? ws.dirname(this.path) : void 0;
  }
  set dirname(e) {
    r_(this.basename, "dirname"), this.path = ws.join(e || "", this.basename);
  }
  get extname() {
    return typeof this.path == "string" ? ws.extname(this.path) : void 0;
  }
  set extname(e) {
    if (_m(e, "extname"), r_(this.dirname, "extname"), e) {
      if (e.codePointAt(0) !== 46) {
        throw new Error("`extname` must start with `.`");
      }
      if (e.includes(".", 1)) {
        throw new Error("`extname` cannot contain multiple dots");
      }
    }
    this.path = ws.join(this.dirname, this.stem + (e || ""));
  }
  get path() {
    return this.history[this.history.length - 1];
  }
  set path(e) {
    bb(e) && (e = x$(e)), Sm(e, "path"), this.path !== e && this.history.push(e);
  }
  get stem() {
    return typeof this.path == "string" ? ws.basename(this.path, this.extname) : void 0;
  }
  set stem(e) {
    Sm(e, "stem"), _m(e, "stem"), this.path = ws.join(this.dirname || "", e + (this.extname || ""));
  }
  fail(e, n, r) {
    const i = this.message(e, n, r);
    throw i.fatal = !0, i;
  }
  info(e, n, r) {
    const i = this.message(e, n, r);
    return i.fatal = void 0, i;
  }
  message(e, n, r) {
    const i = new Ir(e, n, r);
    return this.path && (i.name = this.path + ":" + i.name, i.file = this.path), i.fatal = !1, this.messages.push(i), i;
  }
  toString(e) {
    return this.value === void 0 ? "" : typeof this.value == "string" ? this.value : (new TextDecoder(e || void 0)).decode(this.value);
  }
}
function _m(t, e) {
  if (t && t.includes(ws.sep)) {
    throw new Error("`" + e + "` cannot be a path: did not expect `" + ws.sep + "`");
  }
}
function Sm(t, e) {
  if (!t) {
    throw new Error("`" + e + "` cannot be empty");
  }
}
function r_(t, e) {
  if (!t) {
    throw new Error("Setting `" + e + "` requires `path` to be set too");
  }
}
function w$(t) {
  return !!(t && typeof t == "object" && "byteLength" in t && "byteOffset" in t);
}
const _$ = function(t) {
  const r = this.constructor.prototype, i = r[t], s = function() {
    return i.apply(s, arguments);
  };
  return Object.setPrototypeOf(s, r), s;
}, S$ = {}.hasOwnProperty;
class Dx extends _$ {
  constructor() {
    super("copy"), this.Compiler = void 0, this.Parser = void 0, this.attachers = [], this.compiler = void 0, this.freezeIndex = -1, this.frozen = void 0, this.namespace = {}, this.parser = void 0, this.transformers = c$();
  }
  copy() {
    const e = new Dx();
    let n = -1;
    for (; ++n < this.attachers.length;) {
      const r = this.attachers[n];
      e.use(...r);
    }
    return e.data(vm(!0, {}, this.namespace)), e;
  }
  data(e, n) {
    return typeof e == "string" ? arguments.length === 2 ? (Tm("data", this.frozen), this.namespace[e] = n, this) : S$.call(this.namespace, e) && this.namespace[e] || void 0 : e ? (Tm("data", this.frozen), this.namespace = e, this) : this.namespace;
  }
  freeze() {
    if (this.frozen) {
      return this;
    }
    const e = this;
    for (; ++this.freezeIndex < this.attachers.length;) {
      const [n, ...r] = this.attachers[this.freezeIndex];
      if (r[0] === !1) {
        continue;
      }
      r[0] === !0 && (r[0] = void 0);
      const i = n.call(e, ...r);
      typeof i == "function" && this.transformers.use(i);
    }
    return this.frozen = !0, this.freezeIndex = Number.POSITIVE_INFINITY, this;
  }
  parse(e) {
    this.freeze();
    const n = Th(e), r = this.parser || this.Parser;
    return km("parse", r), r(String(n), n);
  }
  process(e, n) {
    const r = this;
    return this.freeze(), km("process", this.parser || this.Parser), Em("process", this.compiler || this.Compiler), n ? i(void 0, n) : new Promise(i);
    function i(s, o) {
      const a = Th(e), l = r.parse(a);
      r.run(l, a, function(u, h, f) {
        if (u || !h || !f) {
          return c(u);
        }
        const p = h, g = r.stringify(p, f);
        T$(g) ? f.value = g : f.result = g, c(u, f);
      });
      function c(u, h) {
        u || !h ? o(u) : s ? s(h) : n(void 0, h);
      }
    }
  }
  processSync(e) {
    let n = !1, r;
    return this.freeze(), km("processSync", this.parser || this.Parser), Em("processSync", this.compiler || this.Compiler), this.process(e, i), s_("processSync", "process", n), r;
    function i(s, o) {
      n = !0, Kw(s), r = o;
    }
  }
  run(e, n, r) {
    i_(e), this.freeze();
    const i = this.transformers;
    return !r && typeof n == "function" && (r = n, n = void 0), r ? s(void 0, r) : new Promise(s);
    function s(o, a) {
      const l = Th(n);
      i.run(e, l, c);
      function c(u, h, f) {
        const p = h || e;
        u ? a(u) : o ? o(p) : r(void 0, p, f);
      }
    }
  }
  runSync(e, n) {
    let r = !1, i;
    return this.run(e, n, s), s_("runSync", "run", r), i;
    function s(o, a) {
      Kw(o), i = a, r = !0;
    }
  }
  stringify(e, n) {
    this.freeze();
    const r = Th(n), i = this.compiler || this.Compiler;
    return Em("stringify", i), i_(e), i(e, r);
  }
  use(e, ...n) {
    const r = this.attachers, i = this.namespace;
    if (Tm("use", this.frozen), e != null) {
      if (typeof e == "function") {
        l(e, n);
      } else if (typeof e == "object") {
        Array.isArray(e) ? a(e) : o(e);
      } else {
        throw new TypeError("Expected usable value, not `" + e + "`");
      }
    }
    return this;
    function s(c) {
      if (typeof c == "function") {
        l(c, []);
      } else if (typeof c == "object") {
        if (Array.isArray(c)) {
          const [u, ...h] = c;
          l(u, h);
        } else {
          o(c);
        }
      } else {
        throw new TypeError("Expected usable value, not `" + c + "`");
      }
    }
    function o(c) {
      if (!("plugins" in c) && !("settings" in c)) {
        throw new Error("Expected usable value but received an empty preset, which is probably a mistake: presets typically come with `plugins` and sometimes with `settings`, but this has neither");
      }
      a(c.plugins), c.settings && (i.settings = vm(!0, i.settings, c.settings));
    }
    function a(c) {
      let u = -1;
      if (c != null) {
        if (Array.isArray(c)) {
          for (; ++u < c.length;) {
            const h = c[u];
            s(h);
          }
        } else {
          throw new TypeError("Expected a list of plugins, not `" + c + "`");
        }
      }
    }
    function l(c, u) {
      let h = -1, f = -1;
      for (; ++h < r.length;) {
        if (r[h][0] === c) {
          f = h;
          break;
        }
      }
      if (f === -1) {
        r.push([c, ...u]);
      } else if (u.length > 0) {
        let [p, ...g] = u;
        const m = r[f][1];
        mb(m) && mb(p) && (p = vm(!0, m, p)), r[f] = [c, p, ...g];
      }
    }
  }
}
const k$ = (new Dx()).freeze();
function km(t, e) {
  if (typeof e != "function") {
    throw new TypeError("Cannot `" + t + "` without `parser`");
  }
}
function Em(t, e) {
  if (typeof e != "function") {
    throw new TypeError("Cannot `" + t + "` without `compiler`");
  }
}
function Tm(t, e) {
  if (e) {
    throw new Error("Cannot call `" + t + "` on a frozen processor.\nCreate a new processor first, by calling it: use `processor()` instead of `processor`.");
  }
}
function i_(t) {
  if (!mb(t) || typeof t.type != "string") {
    throw new TypeError("Expected node, got `" + t + "`");
  }
}
function s_(t, e, n) {
  if (!n) {
    throw new Error("`" + t + "` finished async. Use `" + e + "` instead");
  }
}
function Th(t) {
  return E$(t) ? t : new hC(t);
}
function E$(t) {
  return !!(t && typeof t == "object" && "message" in t && "messages" in t);
}
function T$(t) {
  return typeof t == "string" || C$(t);
}
function C$(t) {
  return !!(t && typeof t == "object" && "byteLength" in t && "byteOffset" in t);
}
const A$ = "https://github.com/remarkjs/react-markdown/blob/main/changelog.md", o_ = [], a_ = {allowDangerousHtml:!0}, N$ = /^(https?|ircs?|mailto|xmpp)$/i, I$ = [{from:"astPlugins", id:"remove-buggy-html-in-markdown-parser"}, {from:"allowDangerousHtml", id:"remove-buggy-html-in-markdown-parser"}, {from:"allowNode", id:"replace-allownode-allowedtypes-and-disallowedtypes", to:"allowElement"}, {from:"allowedTypes", id:"replace-allownode-allowedtypes-and-disallowedtypes", to:"allowedElements"}, {from:"className", 
id:"remove-classname"}, {from:"disallowedTypes", id:"replace-allownode-allowedtypes-and-disallowedtypes", to:"disallowedElements"}, {from:"escapeHtml", id:"remove-buggy-html-in-markdown-parser"}, {from:"includeElementIndex", id:"#remove-includeelementindex"}, {from:"includeNodeIndex", id:"change-includenodeindex-to-includeelementindex"}, {from:"linkTarget", id:"remove-linktarget"}, {from:"plugins", id:"change-plugins-to-remarkplugins", to:"remarkPlugins"}, {from:"rawSourcePos", id:"#remove-rawsourcepos"}, 
{from:"renderers", id:"change-renderers-to-components", to:"components"}, {from:"source", id:"change-source-to-children", to:"children"}, {from:"sourcePos", id:"#remove-sourcepos"}, {from:"transformImageUri", id:"#add-urltransform", to:"urlTransform"}, {from:"transformLinkUri", id:"#add-urltransform", to:"urlTransform"}];
function Mu(t) {
  const e = O$(t), n = P$(t);
  return R$(e.runSync(e.parse(n), n), t);
}
function O$(t) {
  const e = t.rehypePlugins || o_, n = t.remarkPlugins || o_, r = t.remarkRehypeOptions ? {...t.remarkRehypeOptions, ...a_} : a_;
  return k$().use(hB).use(n).use(a$, r).use(e);
}
function P$(t) {
  const e = t.children || "", n = new hC();
  return typeof e == "string" && (n.value = e), n;
}
function R$(t, e) {
  const n = e.allowedElements, r = e.allowElement, i = e.components, s = e.disallowedElements, o = e.skipHtml, a = e.unwrapDisallowed, l = e.urlTransform || D$;
  for (const u of I$) {
    Object.hasOwn(e, u.from) && ("" + u.from + (u.to ? "use `" + u.to + "` instead" : "remove it") + A$ + u.id, void 0);
  }
  return _g(t, c), Q6(t, {Fragment:require$react_SLASH_jsx_runtime.Fragment, components:i, ignoreInvalidStyle:!0, jsx:require$react_SLASH_jsx_runtime.jsx, jsxs:require$react_SLASH_jsx_runtime.jsxs, passKeys:!0, passNode:!0});
  function c(u, h, f) {
    if (u.type === "raw" && f && typeof h == "number") {
      return o ? f.children.splice(h, 1) : f.children[h] = {type:"text", value:u.value}, h;
    }
    if (u.type === "element") {
      let p;
      for (p in bm) {
        if (Object.hasOwn(bm, p) && Object.hasOwn(u.properties, p)) {
          const g = u.properties[p], m = bm[p];
          (m === null || m.includes(u.tagName)) && (u.properties[p] = l(String(g || ""), p, u));
        }
      }
    }
    if (u.type === "element") {
      let p = n ? !n.includes(u.tagName) : s ? s.includes(u.tagName) : !1;
      if (!p && r && typeof h == "number" && (p = !r(u, h, f)), p && f && typeof h == "number") {
        return a && u.children ? f.children.splice(h, 1, ...u.children) : f.children.splice(h, 1), h;
      }
    }
  }
}
function D$(t) {
  const e = t.indexOf(":"), n = t.indexOf("?"), r = t.indexOf("#"), i = t.indexOf("/");
  return e === -1 || i !== -1 && e > i || n !== -1 && e > n || r !== -1 && e > r || N$.test(t.slice(0, e)) ? t : "";
}
function l_(t, e) {
  const n = String(t);
  if (typeof e != "string") {
    throw new TypeError("Expected character");
  }
  let r = 0, i = n.indexOf(e);
  for (; i !== -1;) {
    r++, i = n.indexOf(e, i + e.length);
  }
  return r;
}
function L$(t) {
  if (typeof t != "string") {
    throw new TypeError("Expected a string");
  }
  return t.replace(/[|\\{}()[\]^$+*?.]/g, "\\$\x26").replace(/-/g, "\\x2d");
}
function M$(t, e, n) {
  const i = vg((n || {}).ignore || []), s = B$(e);
  let o = -1;
  for (; ++o < s.length;) {
    uC(t, "text", a);
  }
  function a(c, u) {
    let h = -1, f;
    for (; ++h < u.length;) {
      const p = u[h], g = f ? f.children : void 0;
      if (i(p, g ? g.indexOf(p) : void 0, f)) {
        return;
      }
      f = p;
    }
    if (f) {
      return l(c, u);
    }
  }
  function l(c, u) {
    const h = u[u.length - 1], f = s[o][0], p = s[o][1];
    let g = 0;
    const b = h.children.indexOf(c);
    let x = !1, w = [];
    f.lastIndex = 0;
    let v = f.exec(c.value);
    for (; v;) {
      const T = v.index, I = {index:v.index, input:v.input, stack:[...u, c]};
      let _ = p(...v, I);
      if (typeof _ == "string" && (_ = _.length > 0 ? {type:"text", value:_} : void 0), _ === !1 ? f.lastIndex = T + 1 : (g !== T && w.push({type:"text", value:c.value.slice(g, T)}), Array.isArray(_) ? w.push(..._) : _ && w.push(_), g = T + v[0].length, x = !0), !f.global) {
        break;
      }
      v = f.exec(c.value);
    }
    return x ? (g < c.value.length && w.push({type:"text", value:c.value.slice(g)}), h.children.splice(b, 1, ...w)) : w = [c], b + w.length;
  }
}
function B$(t) {
  const e = [];
  if (!Array.isArray(t)) {
    throw new TypeError("Expected find and replace tuple or list of tuples");
  }
  const n = !t[0] || Array.isArray(t[0]) ? t : [t];
  let r = -1;
  for (; ++r < n.length;) {
    const i = n[r];
    e.push([$$(i[0]), F$(i[1])]);
  }
  return e;
}
function $$(t) {
  return typeof t == "string" ? new RegExp(L$(t), "g") : t;
}
function F$(t) {
  return typeof t == "function" ? t : function() {
    return t;
  };
}
const Cm = "phrasing", Am = ["autolink", "link", "image", "label"];
function z$() {
  return {transforms:[Y$], enter:{literalAutolink:U$, literalAutolinkEmail:Nm, literalAutolinkHttp:Nm, literalAutolinkWww:Nm}, exit:{literalAutolink:q$, literalAutolinkEmail:V$, literalAutolinkHttp:W$, literalAutolinkWww:j$}};
}
function H$() {
  return {unsafe:[{character:"@", before:"[+\\-.\\w]", after:"[\\-.\\w]", inConstruct:Cm, notInConstruct:Am}, {character:".", before:"[Ww]", after:"[\\-.\\w]", inConstruct:Cm, notInConstruct:Am}, {character:":", before:"[ps]", after:"\\/", inConstruct:Cm, notInConstruct:Am}]};
}
function U$(t) {
  this.enter({type:"link", title:null, url:"", children:[]}, t);
}
function Nm(t) {
  this.config.enter.autolinkProtocol.call(this, t);
}
function W$(t) {
  this.config.exit.autolinkProtocol.call(this, t);
}
function j$(t) {
  this.config.exit.data.call(this, t);
  const e = this.stack[this.stack.length - 1];
  e.type, e.url = "http://" + this.sliceSerialize(t);
}
function V$(t) {
  this.config.exit.autolinkEmail.call(this, t);
}
function q$(t) {
  this.exit(t);
}
function Y$(t) {
  M$(t, [[/(https?:\/\/|www(?=\.))([-.\w]+)([^ \t\r\n]*)/gi, G$], [new RegExp("(?\x3c\x3d^|\\s|\\p{P}|\\p{S})([-.\\w+]+)@([-\\w]+(?:\\.[-\\w]+)+)", "gu"), Q$]], {ignore:["link", "linkReference"]});
}
function G$(t, e, n, r, i) {
  let s = "";
  if (!fC(i) || (/^w/i.test(e) && (n = e + n, e = "", s = "http://"), !K$(n))) {
    return !1;
  }
  const o = X$(n + r);
  if (!o[0]) {
    return !1;
  }
  const a = {type:"link", title:null, url:s + e + o[0], children:[{type:"text", value:e + o[0]}]};
  return o[1] ? [a, {type:"text", value:o[1]}] : a;
}
function Q$(t, e, n, r) {
  return !fC(r, !0) || /[-\d_]$/.test(n) ? !1 : {type:"link", title:null, url:"mailto:" + e + "@" + n, children:[{type:"text", value:e + "@" + n}]};
}
function K$(t) {
  const e = t.split(".");
  return !(e.length < 2 || e[e.length - 1] && (/_/.test(e[e.length - 1]) || !/[a-zA-Z\d]/.test(e[e.length - 1])) || e[e.length - 2] && (/_/.test(e[e.length - 2]) || !/[a-zA-Z\d]/.test(e[e.length - 2])));
}
function X$(t) {
  const e = /[!"&'),.:;<>?\]}]+$/.exec(t);
  if (!e) {
    return [t, void 0];
  }
  t = t.slice(0, e.index);
  let n = e[0], r = n.indexOf(")");
  const i = l_(t, "(");
  let s = l_(t, ")");
  for (; r !== -1 && i > s;) {
    t += n.slice(0, r + 1), n = n.slice(r + 1), r = n.indexOf(")"), s++;
  }
  return [t, n];
}
function fC(t, e) {
  const n = t.input.charCodeAt(t.index - 1);
  return (t.index === 0 || Ja(n) || bg(n)) && (!e || n !== 47);
}
pC.peek = oF;
function J$() {
  this.buffer();
}
function Z$(t) {
  this.enter({type:"footnoteReference", identifier:"", label:""}, t);
}
function eF() {
  this.buffer();
}
function tF(t) {
  this.enter({type:"footnoteDefinition", identifier:"", label:"", children:[]}, t);
}
function nF(t) {
  const e = this.resume(), n = this.stack[this.stack.length - 1];
  n.type, n.identifier = ns(this.sliceSerialize(t)).toLowerCase(), n.label = e;
}
function rF(t) {
  this.exit(t);
}
function iF(t) {
  const e = this.resume(), n = this.stack[this.stack.length - 1];
  n.type, n.identifier = ns(this.sliceSerialize(t)).toLowerCase(), n.label = e;
}
function sF(t) {
  this.exit(t);
}
function oF() {
  return "[";
}
function pC(t, e, n, r) {
  const i = n.createTracker(r);
  let s = i.move("[^");
  const o = n.enter("footnoteReference"), a = n.enter("reference");
  return s += i.move(n.safe(n.associationId(t), {after:"]", before:s})), a(), o(), s += i.move("]"), s;
}
function aF() {
  return {enter:{gfmFootnoteCallString:J$, gfmFootnoteCall:Z$, gfmFootnoteDefinitionLabelString:eF, gfmFootnoteDefinition:tF}, exit:{gfmFootnoteCallString:nF, gfmFootnoteCall:rF, gfmFootnoteDefinitionLabelString:iF, gfmFootnoteDefinition:sF}};
}
function lF(t) {
  let e = !1;
  return t && t.firstLineBlank && (e = !0), {handlers:{footnoteDefinition:n, footnoteReference:pC}, unsafe:[{character:"[", inConstruct:["label", "phrasing", "reference"]}]};
  function n(r, i, s, o) {
    const a = s.createTracker(o);
    let l = a.move("[^");
    const c = s.enter("footnoteDefinition"), u = s.enter("label");
    return l += a.move(s.safe(s.associationId(r), {before:l, after:"]"})), u(), l += a.move("]:"), r.children && r.children.length > 0 && (a.shift(4), l += a.move((e ? `
` : " ") + s.indentLines(s.containerFlow(r, a.current()), e ? gC : cF))), c(), l;
  }
}
function cF(t, e, n) {
  return e === 0 ? t : gC(t, e, n);
}
function gC(t, e, n) {
  return (n ? "" : "    ") + t;
}
const uF = ["autolink", "destinationLiteral", "destinationRaw", "reference", "titleQuote", "titleApostrophe"];
mC.peek = gF;
function dF() {
  return {canContainEols:["delete"], enter:{strikethrough:fF}, exit:{strikethrough:pF}};
}
function hF() {
  return {unsafe:[{character:"~", inConstruct:"phrasing", notInConstruct:uF}], handlers:{delete:mC}};
}
function fF(t) {
  this.enter({type:"delete", children:[]}, t);
}
function pF(t) {
  this.exit(t);
}
function mC(t, e, n, r) {
  const i = n.createTracker(r), s = n.enter("strikethrough");
  let o = i.move("~~");
  return o += n.containerPhrasing(t, {...i.current(), before:o, after:"~"}), o += i.move("~~"), s(), o;
}
function gF() {
  return "~";
}
function mF(t) {
  return t.length;
}
function bF(t, e) {
  const n = e || {}, r = (n.align || []).concat(), i = n.stringLength || mF, s = [], o = [], a = [], l = [];
  let c = 0, u = -1;
  for (; ++u < t.length;) {
    const m = [], b = [];
    let x = -1;
    for (t[u].length > c && (c = t[u].length); ++x < t[u].length;) {
      const w = yF(t[u][x]);
      if (n.alignDelimiters !== !1) {
        const v = i(w);
        b[x] = v, (l[x] === void 0 || v > l[x]) && (l[x] = v);
      }
      m.push(w);
    }
    o[u] = m, a[u] = b;
  }
  let h = -1;
  if (typeof r == "object" && "length" in r) {
    for (; ++h < c;) {
      s[h] = c_(r[h]);
    }
  } else {
    const m = c_(r);
    for (; ++h < c;) {
      s[h] = m;
    }
  }
  h = -1;
  const f = [], p = [];
  for (; ++h < c;) {
    const m = s[h];
    let b = "", x = "";
    m === 99 ? (b = ":", x = ":") : m === 108 ? b = ":" : m === 114 && (x = ":");
    let w = n.alignDelimiters === !1 ? 1 : Math.max(1, l[h] - b.length - x.length);
    const v = b + "-".repeat(w) + x;
    n.alignDelimiters !== !1 && (w = b.length + w + x.length, w > l[h] && (l[h] = w), p[h] = w), f[h] = v;
  }
  o.splice(1, 0, f), a.splice(1, 0, p), u = -1;
  const g = [];
  for (; ++u < o.length;) {
    const m = o[u], b = a[u];
    h = -1;
    const x = [];
    for (; ++h < c;) {
      const w = m[h] || "";
      let v = "", T = "";
      if (n.alignDelimiters !== !1) {
        const I = l[h] - (b[h] || 0), _ = s[h];
        _ === 114 ? v = " ".repeat(I) : _ === 99 ? I % 2 ? (v = " ".repeat(I / 2 + 0.5), T = " ".repeat(I / 2 - 0.5)) : (v = " ".repeat(I / 2), T = v) : T = " ".repeat(I);
      }
      n.delimiterStart !== !1 && !h && x.push("|"), n.padding !== !1 && !(n.alignDelimiters === !1 && w === "") && (n.delimiterStart !== !1 || h) && x.push(" "), n.alignDelimiters !== !1 && x.push(v), x.push(w), n.alignDelimiters !== !1 && x.push(T), n.padding !== !1 && x.push(" "), (n.delimiterEnd !== !1 || h !== c - 1) && x.push("|");
    }
    g.push(n.delimiterEnd === !1 ? x.join("").replace(/ +$/, "") : x.join(""));
  }
  return g.join(`
`);
}
function yF(t) {
  return t == null ? "" : String(t);
}
function c_(t) {
  const e = typeof t == "string" ? t.codePointAt(0) : 0;
  return e === 67 || e === 99 ? 99 : e === 76 || e === 108 ? 108 : e === 82 || e === 114 ? 114 : 0;
}
const u_ = {}.hasOwnProperty;
function bC(t, e) {
  const n = e || {};
  function r(i, ...s) {
    let o = r.invalid;
    const a = r.handlers;
    if (i && u_.call(i, t)) {
      const l = String(i[t]);
      o = u_.call(a, l) ? a[l] : r.unknown;
    }
    if (o) {
      return o.call(this, i, ...s);
    }
  }
  return r.handlers = n.handlers || {}, r.invalid = n.invalid, r.unknown = n.unknown, r;
}
function xF(t, e, n, r) {
  const i = n.enter("blockquote"), s = n.createTracker(r);
  s.move("\x3e "), s.shift(2);
  const o = n.indentLines(n.containerFlow(t, s.current()), vF);
  return i(), o;
}
function vF(t, e, n) {
  return "\x3e" + (n ? "" : " ") + t;
}
function wF(t, e) {
  return d_(t, e.inConstruct, !0) && !d_(t, e.notInConstruct, !1);
}
function d_(t, e, n) {
  if (typeof e == "string" && (e = [e]), !e || e.length === 0) {
    return n;
  }
  let r = -1;
  for (; ++r < e.length;) {
    if (t.includes(e[r])) {
      return !0;
    }
  }
  return !1;
}
function h_(t, e, n, r) {
  let i = -1;
  for (; ++i < n.unsafe.length;) {
    if (n.unsafe[i].character === `
` && wF(n.stack, n.unsafe[i])) {
      return /[ \t]/.test(r.before) ? "" : " ";
    }
  }
  return `\\
`;
}
function _F(t, e) {
  const n = String(t);
  let r = n.indexOf(e), i = r, s = 0, o = 0;
  if (typeof e != "string") {
    throw new TypeError("Expected substring");
  }
  for (; r !== -1;) {
    r === i ? ++s > o && (o = s) : s = 1, i = r + e.length, r = n.indexOf(e, i);
  }
  return o;
}
function SF(t, e) {
  return !!(e.options.fences === !1 && t.value && !t.lang && /[^ \r\n]/.test(t.value) && !/^[\t ]*(?:[\r\n]|$)|(?:^|[\r\n])[\t ]*$/.test(t.value));
}
function kF(t) {
  const e = t.options.fence || "`";
  if (e !== "`" && e !== "~") {
    throw new Error("Cannot serialize code with `" + e + "` for `options.fence`, expected `` ` `` or `~`");
  }
  return e;
}
function EF(t, e, n, r) {
  const i = kF(n), s = t.value || "", o = i === "`" ? "GraveAccent" : "Tilde";
  if (SF(t, n)) {
    const h = n.enter("codeIndented"), f = n.indentLines(s, TF);
    return h(), f;
  }
  const a = n.createTracker(r), l = i.repeat(Math.max(_F(s, i) + 1, 3)), c = n.enter("codeFenced");
  let u = a.move(l);
  if (t.lang) {
    const h = n.enter(`codeFencedLang${o}`);
    u += a.move(n.safe(t.lang, {before:u, after:" ", encode:["`"], ...a.current()})), h();
  }
  if (t.lang && t.meta) {
    const h = n.enter(`codeFencedMeta${o}`);
    u += a.move(" "), u += a.move(n.safe(t.meta, {before:u, after:`
`, encode:["`"], ...a.current()})), h();
  }
  return u += a.move(`
`), s && (u += a.move(s + `
`)), u += a.move(l), c(), u;
}
function TF(t, e, n) {
  return (n ? "" : "    ") + t;
}
function Lx(t) {
  const e = t.options.quote || '"';
  if (e !== '"' && e !== "'") {
    throw new Error("Cannot serialize title with `" + e + "` for `options.quote`, expected `\"`, or `'`");
  }
  return e;
}
function CF(t, e, n, r) {
  const i = Lx(n), s = i === '"' ? "Quote" : "Apostrophe", o = n.enter("definition");
  let a = n.enter("label");
  const l = n.createTracker(r);
  let c = l.move("[");
  return c += l.move(n.safe(n.associationId(t), {before:c, after:"]", ...l.current()})), c += l.move("]: "), a(), !t.url || /[\0- \u007F]/.test(t.url) ? (a = n.enter("destinationLiteral"), c += l.move("\x3c"), c += l.move(n.safe(t.url, {before:c, after:"\x3e", ...l.current()})), c += l.move("\x3e")) : (a = n.enter("destinationRaw"), c += l.move(n.safe(t.url, {before:c, after:t.title ? " " : `
`, ...l.current()}))), a(), t.title && (a = n.enter(`title${s}`), c += l.move(" " + i), c += l.move(n.safe(t.title, {before:c, after:i, ...l.current()})), c += l.move(i), a()), o(), c;
}
function AF(t) {
  const e = t.options.emphasis || "*";
  if (e !== "*" && e !== "_") {
    throw new Error("Cannot serialize emphasis with `" + e + "` for `options.emphasis`, expected `*`, or `_`");
  }
  return e;
}
function ud(t) {
  return "\x26#x" + t.toString(16).toUpperCase() + ";";
}
function sp(t, e, n) {
  const r = ic(t), i = ic(e);
  return r === void 0 ? i === void 0 ? n === "_" ? {inside:!0, outside:!0} : {inside:!1, outside:!1} : i === 1 ? {inside:!0, outside:!0} : {inside:!1, outside:!0} : r === 1 ? i === void 0 ? {inside:!1, outside:!1} : i === 1 ? {inside:!0, outside:!0} : {inside:!1, outside:!1} : i === void 0 ? {inside:!1, outside:!1} : i === 1 ? {inside:!0, outside:!1} : {inside:!1, outside:!1};
}
yC.peek = NF;
function yC(t, e, n, r) {
  const i = AF(n), s = n.enter("emphasis"), o = n.createTracker(r), a = o.move(i);
  let l = o.move(n.containerPhrasing(t, {after:i, before:a, ...o.current()}));
  const c = l.charCodeAt(0), u = sp(r.before.charCodeAt(r.before.length - 1), c, i);
  u.inside && (l = ud(c) + l.slice(1));
  const h = l.charCodeAt(l.length - 1), f = sp(r.after.charCodeAt(0), h, i);
  f.inside && (l = l.slice(0, -1) + ud(h));
  const p = o.move(i);
  return s(), n.attentionEncodeSurroundingInfo = {after:f.outside, before:u.outside}, a + l + p;
}
function NF(t, e, n) {
  return n.options.emphasis || "*";
}
function IF(t, e) {
  let n = !1;
  return _g(t, function(r) {
    if ("value" in r && /\r?\n|\r/.test(r.value) || r.type === "break") {
      return n = !0, pb;
    }
  }), !!((!t.depth || t.depth < 3) && Cx(t) && (e.options.setext || n));
}
function OF(t, e, n, r) {
  const i = Math.max(Math.min(6, t.depth || 1), 1), s = n.createTracker(r);
  if (IF(t, n)) {
    const u = n.enter("headingSetext"), h = n.enter("phrasing"), f = n.containerPhrasing(t, {...s.current(), before:`
`, after:`
`});
    return h(), u(), f + `
` + (i === 1 ? "\x3d" : "-").repeat(f.length - (Math.max(f.lastIndexOf("\r"), f.lastIndexOf(`
`)) + 1));
  }
  const o = "#".repeat(i), a = n.enter("headingAtx"), l = n.enter("phrasing");
  s.move(o + " ");
  let c = n.containerPhrasing(t, {before:"# ", after:`
`, ...s.current()});
  return /^[\t ]/.test(c) && (c = ud(c.charCodeAt(0)) + c.slice(1)), c = c ? o + " " + c : o, n.options.closeAtx && (c += " " + o), l(), a(), c;
}
xC.peek = PF;
function xC(t) {
  return t.value || "";
}
function PF() {
  return "\x3c";
}
vC.peek = RF;
function vC(t, e, n, r) {
  const i = Lx(n), s = i === '"' ? "Quote" : "Apostrophe", o = n.enter("image");
  let a = n.enter("label");
  const l = n.createTracker(r);
  let c = l.move("![");
  return c += l.move(n.safe(t.alt, {before:c, after:"]", ...l.current()})), c += l.move("]("), a(), !t.url && t.title || /[\0- \u007F]/.test(t.url) ? (a = n.enter("destinationLiteral"), c += l.move("\x3c"), c += l.move(n.safe(t.url, {before:c, after:"\x3e", ...l.current()})), c += l.move("\x3e")) : (a = n.enter("destinationRaw"), c += l.move(n.safe(t.url, {before:c, after:t.title ? " " : ")", ...l.current()}))), a(), t.title && (a = n.enter(`title${s}`), c += l.move(" " + i), c += l.move(n.safe(t.title, 
  {before:c, after:i, ...l.current()})), c += l.move(i), a()), c += l.move(")"), o(), c;
}
function RF() {
  return "!";
}
wC.peek = DF;
function wC(t, e, n, r) {
  const i = t.referenceType, s = n.enter("imageReference");
  let o = n.enter("label");
  const a = n.createTracker(r);
  let l = a.move("![");
  const c = n.safe(t.alt, {before:l, after:"]", ...a.current()});
  l += a.move(c + "]["), o();
  const u = n.stack;
  n.stack = [], o = n.enter("reference");
  const h = n.safe(n.associationId(t), {before:l, after:"]", ...a.current()});
  return o(), n.stack = u, s(), i === "full" || !c || c !== h ? l += a.move(h + "]") : i === "shortcut" ? l = l.slice(0, -1) : l += a.move("]"), l;
}
function DF() {
  return "!";
}
_C.peek = LF;
function _C(t, e, n) {
  let r = t.value || "", i = "`", s = -1;
  for (; (new RegExp("(^|[^`])" + i + "([^`]|$)")).test(r);) {
    i += "`";
  }
  for (/[^ \r\n]/.test(r) && (/^[ \r\n]/.test(r) && /[ \r\n]$/.test(r) || /^`|`$/.test(r)) && (r = " " + r + " "); ++s < n.unsafe.length;) {
    const o = n.unsafe[s], a = n.compilePattern(o);
    let l;
    if (o.atBreak) {
      for (; l = a.exec(r);) {
        let c = l.index;
        r.charCodeAt(c) === 10 && r.charCodeAt(c - 1) === 13 && c--, r = r.slice(0, c) + " " + r.slice(l.index + 1);
      }
    }
  }
  return i + r + i;
}
function LF() {
  return "`";
}
function SC(t, e) {
  const n = Cx(t);
  return !!(!e.options.resourceLink && t.url && !t.title && t.children && t.children.length === 1 && t.children[0].type === "text" && (n === t.url || "mailto:" + n === t.url) && /^[a-z][a-z+.-]+:/i.test(t.url) && !/[\0- <>\u007F]/.test(t.url));
}
kC.peek = MF;
function kC(t, e, n, r) {
  const i = Lx(n), s = i === '"' ? "Quote" : "Apostrophe", o = n.createTracker(r);
  let a, l;
  if (SC(t, n)) {
    const u = n.stack;
    n.stack = [], a = n.enter("autolink");
    let h = o.move("\x3c");
    return h += o.move(n.containerPhrasing(t, {before:h, after:"\x3e", ...o.current()})), h += o.move("\x3e"), a(), n.stack = u, h;
  }
  a = n.enter("link"), l = n.enter("label");
  let c = o.move("[");
  return c += o.move(n.containerPhrasing(t, {before:c, after:"](", ...o.current()})), c += o.move("]("), l(), !t.url && t.title || /[\0- \u007F]/.test(t.url) ? (l = n.enter("destinationLiteral"), c += o.move("\x3c"), c += o.move(n.safe(t.url, {before:c, after:"\x3e", ...o.current()})), c += o.move("\x3e")) : (l = n.enter("destinationRaw"), c += o.move(n.safe(t.url, {before:c, after:t.title ? " " : ")", ...o.current()}))), l(), t.title && (l = n.enter(`title${s}`), c += o.move(" " + i), c += o.move(n.safe(t.title, 
  {before:c, after:i, ...o.current()})), c += o.move(i), l()), c += o.move(")"), a(), c;
}
function MF(t, e, n) {
  return SC(t, n) ? "\x3c" : "[";
}
EC.peek = BF;
function EC(t, e, n, r) {
  const i = t.referenceType, s = n.enter("linkReference");
  let o = n.enter("label");
  const a = n.createTracker(r);
  let l = a.move("[");
  const c = n.containerPhrasing(t, {before:l, after:"]", ...a.current()});
  l += a.move(c + "]["), o();
  const u = n.stack;
  n.stack = [], o = n.enter("reference");
  const h = n.safe(n.associationId(t), {before:l, after:"]", ...a.current()});
  return o(), n.stack = u, s(), i === "full" || !c || c !== h ? l += a.move(h + "]") : i === "shortcut" ? l = l.slice(0, -1) : l += a.move("]"), l;
}
function BF() {
  return "[";
}
function Mx(t) {
  const e = t.options.bullet || "*";
  if (e !== "*" && e !== "+" && e !== "-") {
    throw new Error("Cannot serialize items with `" + e + "` for `options.bullet`, expected `*`, `+`, or `-`");
  }
  return e;
}
function $F(t) {
  const e = Mx(t), n = t.options.bulletOther;
  if (!n) {
    return e === "*" ? "-" : "*";
  }
  if (n !== "*" && n !== "+" && n !== "-") {
    throw new Error("Cannot serialize items with `" + n + "` for `options.bulletOther`, expected `*`, `+`, or `-`");
  }
  if (n === e) {
    throw new Error("Expected `bullet` (`" + e + "`) and `bulletOther` (`" + n + "`) to be different");
  }
  return n;
}
function FF(t) {
  const e = t.options.bulletOrdered || ".";
  if (e !== "." && e !== ")") {
    throw new Error("Cannot serialize items with `" + e + "` for `options.bulletOrdered`, expected `.` or `)`");
  }
  return e;
}
function TC(t) {
  const e = t.options.rule || "*";
  if (e !== "*" && e !== "-" && e !== "_") {
    throw new Error("Cannot serialize rules with `" + e + "` for `options.rule`, expected `*`, `-`, or `_`");
  }
  return e;
}
function zF(t, e, n, r) {
  const i = n.enter("list"), s = n.bulletCurrent;
  let o = t.ordered ? FF(n) : Mx(n);
  const a = t.ordered ? o === "." ? ")" : "." : $F(n);
  let l = e && n.bulletLastUsed ? o === n.bulletLastUsed : !1;
  if (!t.ordered) {
    const u = t.children ? t.children[0] : void 0;
    if ((o === "*" || o === "-") && u && (!u.children || !u.children[0]) && n.stack[n.stack.length - 1] === "list" && n.stack[n.stack.length - 2] === "listItem" && n.stack[n.stack.length - 3] === "list" && n.stack[n.stack.length - 4] === "listItem" && n.indexStack[n.indexStack.length - 1] === 0 && n.indexStack[n.indexStack.length - 2] === 0 && n.indexStack[n.indexStack.length - 3] === 0 && (l = !0), TC(n) === o && u) {
      let h = -1;
      for (; ++h < t.children.length;) {
        const f = t.children[h];
        if (f && f.type === "listItem" && f.children && f.children[0] && f.children[0].type === "thematicBreak") {
          l = !0;
          break;
        }
      }
    }
  }
  l && (o = a), n.bulletCurrent = o;
  const c = n.containerFlow(t, r);
  return n.bulletLastUsed = o, n.bulletCurrent = s, i(), c;
}
function HF(t) {
  const e = t.options.listItemIndent || "one";
  if (e !== "tab" && e !== "one" && e !== "mixed") {
    throw new Error("Cannot serialize items with `" + e + "` for `options.listItemIndent`, expected `tab`, `one`, or `mixed`");
  }
  return e;
}
function UF(t, e, n, r) {
  const i = HF(n);
  let s = n.bulletCurrent || Mx(n);
  e && e.type === "list" && e.ordered && (s = (typeof e.start == "number" && e.start > -1 ? e.start : 1) + (n.options.incrementListMarker === !1 ? 0 : e.children.indexOf(t)) + s);
  let o = s.length + 1;
  (i === "tab" || i === "mixed" && (e && e.type === "list" && e.spread || t.spread)) && (o = Math.ceil(o / 4) * 4);
  const a = n.createTracker(r);
  a.move(s + " ".repeat(o - s.length)), a.shift(o);
  const l = n.enter("listItem"), c = n.indentLines(n.containerFlow(t, a.current()), u);
  return l(), c;
  function u(h, f, p) {
    return f ? (p ? "" : " ".repeat(o)) + h : (p ? s : s + " ".repeat(o - s.length)) + h;
  }
}
function WF(t, e, n, r) {
  const i = n.enter("paragraph"), s = n.enter("phrasing"), o = n.containerPhrasing(t, r);
  return s(), i(), o;
}
const jF = vg(["break", "delete", "emphasis", "footnote", "footnoteReference", "image", "imageReference", "inlineCode", "inlineMath", "link", "linkReference", "mdxJsxTextElement", "mdxTextExpression", "strong", "text", "textDirective"]);
function VF(t, e, n, r) {
  return (t.children.some(function(o) {
    return jF(o);
  }) ? n.containerPhrasing : n.containerFlow).call(n, t, r);
}
function qF(t) {
  const e = t.options.strong || "*";
  if (e !== "*" && e !== "_") {
    throw new Error("Cannot serialize strong with `" + e + "` for `options.strong`, expected `*`, or `_`");
  }
  return e;
}
CC.peek = YF;
function CC(t, e, n, r) {
  const i = qF(n), s = n.enter("strong"), o = n.createTracker(r), a = o.move(i + i);
  let l = o.move(n.containerPhrasing(t, {after:i, before:a, ...o.current()}));
  const c = l.charCodeAt(0), u = sp(r.before.charCodeAt(r.before.length - 1), c, i);
  u.inside && (l = ud(c) + l.slice(1));
  const h = l.charCodeAt(l.length - 1), f = sp(r.after.charCodeAt(0), h, i);
  f.inside && (l = l.slice(0, -1) + ud(h));
  const p = o.move(i + i);
  return s(), n.attentionEncodeSurroundingInfo = {after:f.outside, before:u.outside}, a + l + p;
}
function YF(t, e, n) {
  return n.options.strong || "*";
}
function GF(t, e, n, r) {
  return n.safe(t.value, r);
}
function QF(t) {
  const e = t.options.ruleRepetition || 3;
  if (e < 3) {
    throw new Error("Cannot serialize rules with repetition `" + e + "` for `options.ruleRepetition`, expected `3` or more");
  }
  return e;
}
function KF(t, e, n) {
  const r = (TC(n) + (n.options.ruleSpaces ? " " : "")).repeat(QF(n));
  return n.options.ruleSpaces ? r.slice(0, -1) : r;
}
const AC = {blockquote:xF, break:h_, code:EF, definition:CF, emphasis:yC, hardBreak:h_, heading:OF, html:xC, image:vC, imageReference:wC, inlineCode:_C, link:kC, linkReference:EC, list:zF, listItem:UF, paragraph:WF, root:VF, strong:CC, text:GF, thematicBreak:KF};
function XF() {
  return {enter:{table:JF, tableData:f_, tableHeader:f_, tableRow:ez}, exit:{codeText:tz, table:ZF, tableData:Im, tableHeader:Im, tableRow:Im}};
}
function JF(t) {
  const e = t._align;
  this.enter({type:"table", align:e.map(function(n) {
    return n === "none" ? null : n;
  }), children:[]}, t), this.data.inTable = !0;
}
function ZF(t) {
  this.exit(t), this.data.inTable = void 0;
}
function ez(t) {
  this.enter({type:"tableRow", children:[]}, t);
}
function Im(t) {
  this.exit(t);
}
function f_(t) {
  this.enter({type:"tableCell", children:[]}, t);
}
function tz(t) {
  let e = this.resume();
  this.data.inTable && (e = e.replace(/\\([\\|])/g, nz));
  const n = this.stack[this.stack.length - 1];
  n.type, n.value = e, this.exit(t);
}
function nz(t, e) {
  return e === "|" ? e : t;
}
function rz(t) {
  const e = t || {}, n = e.tableCellPadding, r = e.tablePipeAlign, i = e.stringLength, s = n ? " " : "|";
  return {unsafe:[{character:"\r", inConstruct:"tableCell"}, {character:`
`, inConstruct:"tableCell"}, {atBreak:!0, character:"|", after:"[\t :-]"}, {character:"|", inConstruct:"tableCell"}, {atBreak:!0, character:":", after:"-"}, {atBreak:!0, character:"-", after:"[:|-]"}], handlers:{inlineCode:f, table:o, tableCell:l, tableRow:a}};
  function o(p, g, m, b) {
    return c(u(p, m, b), p.align);
  }
  function a(p, g, m, b) {
    const x = h(p, m, b), w = c([x]);
    return w.slice(0, w.indexOf(`
`));
  }
  function l(p, g, m, b) {
    const x = m.enter("tableCell"), w = m.enter("phrasing"), v = m.containerPhrasing(p, {...b, before:s, after:s});
    return w(), x(), v;
  }
  function c(p, g) {
    return bF(p, {align:g, alignDelimiters:r, padding:n, stringLength:i});
  }
  function u(p, g, m) {
    const b = p.children;
    let x = -1;
    const w = [], v = g.enter("table");
    for (; ++x < b.length;) {
      w[x] = h(b[x], g, m);
    }
    return v(), w;
  }
  function h(p, g, m) {
    const b = p.children;
    let x = -1;
    const w = [], v = g.enter("tableRow");
    for (; ++x < b.length;) {
      w[x] = l(b[x], p, g, m);
    }
    return v(), w;
  }
  function f(p, g, m) {
    let b = AC.inlineCode(p, g, m);
    return m.stack.includes("tableCell") && (b = b.replace(/\|/g, "\\$\x26")), b;
  }
}
function iz() {
  return {exit:{taskListCheckValueChecked:p_, taskListCheckValueUnchecked:p_, paragraph:oz}};
}
function sz() {
  return {unsafe:[{atBreak:!0, character:"-", after:"[:|-]"}], handlers:{listItem:az}};
}
function p_(t) {
  const e = this.stack[this.stack.length - 2];
  e.type, e.checked = t.type === "taskListCheckValueChecked";
}
function oz(t) {
  const e = this.stack[this.stack.length - 2];
  if (e && e.type === "listItem" && typeof e.checked == "boolean") {
    const n = this.stack[this.stack.length - 1];
    n.type;
    const r = n.children[0];
    if (r && r.type === "text") {
      const i = e.children;
      let s = -1, o;
      for (; ++s < i.length;) {
        const a = i[s];
        if (a.type === "paragraph") {
          o = a;
          break;
        }
      }
      o === n && (r.value = r.value.slice(1), r.value.length === 0 ? n.children.shift() : n.position && r.position && typeof r.position.start.offset == "number" && (r.position.start.column++, r.position.start.offset++, n.position.start = Object.assign({}, r.position.start)));
    }
  }
  this.exit(t);
}
function az(t, e, n, r) {
  const i = t.children[0], s = typeof t.checked == "boolean" && i && i.type === "paragraph", o = "[" + (t.checked ? "x" : " ") + "] ", a = n.createTracker(r);
  s && a.move(o);
  let l = AC.listItem(t, e, n, {...r, ...a.current()});
  return s && (l = l.replace(/^(?:[*+-]|\d+\.)([\r\n]| {1,3})/, c)), l;
  function c(u) {
    return u + o;
  }
}
function lz() {
  return [z$(), aF(), dF(), XF(), iz()];
}
function cz(t) {
  return {extensions:[H$(), lF(t), hF(), rz(t), sz()]};
}
const uz = {tokenize:mz, partial:!0}, NC = {tokenize:bz, partial:!0}, IC = {tokenize:yz, partial:!0}, OC = {tokenize:xz, partial:!0}, dz = {tokenize:vz, partial:!0}, PC = {name:"wwwAutolink", tokenize:pz, previous:DC}, RC = {name:"protocolAutolink", tokenize:gz, previous:LC}, po = {name:"emailAutolink", tokenize:fz, previous:MC}, $s = {};
function hz() {
  return {text:$s};
}
let ga = 48;
for (; ga < 123;) {
  $s[ga] = po, ga++, ga === 58 ? ga = 65 : ga === 91 && (ga = 97);
}
$s[43] = po;
$s[45] = po;
$s[46] = po;
$s[95] = po;
$s[72] = [po, RC];
$s[104] = [po, RC];
$s[87] = [po, PC];
$s[119] = [po, PC];
function fz(t, e, n) {
  const r = this;
  let i, s;
  return o;
  function o(h) {
    return !yb(h) || !MC.call(r, r.previous) || Bx(r.events) ? n(h) : (t.enter("literalAutolink"), t.enter("literalAutolinkEmail"), a(h));
  }
  function a(h) {
    return yb(h) ? (t.consume(h), a) : h === 64 ? (t.consume(h), l) : n(h);
  }
  function l(h) {
    return h === 46 ? t.check(dz, u, c)(h) : h === 45 || h === 95 || Nr(h) ? (s = !0, t.consume(h), l) : u(h);
  }
  function c(h) {
    return t.consume(h), i = !0, l;
  }
  function u(h) {
    return s && i && Fr(r.previous) ? (t.exit("literalAutolinkEmail"), t.exit("literalAutolink"), e(h)) : n(h);
  }
}
function pz(t, e, n) {
  const r = this;
  return i;
  function i(o) {
    return o !== 87 && o !== 119 || !DC.call(r, r.previous) || Bx(r.events) ? n(o) : (t.enter("literalAutolink"), t.enter("literalAutolinkWww"), t.check(uz, t.attempt(NC, t.attempt(IC, s), n), n)(o));
  }
  function s(o) {
    return t.exit("literalAutolinkWww"), t.exit("literalAutolink"), e(o);
  }
}
function gz(t, e, n) {
  const r = this;
  let i = "", s = !1;
  return o;
  function o(h) {
    return (h === 72 || h === 104) && LC.call(r, r.previous) && !Bx(r.events) ? (t.enter("literalAutolink"), t.enter("literalAutolinkHttp"), i += String.fromCodePoint(h), t.consume(h), a) : n(h);
  }
  function a(h) {
    if (Fr(h) && i.length < 5) {
      return i += String.fromCodePoint(h), t.consume(h), a;
    }
    if (h === 58) {
      const f = i.toLowerCase();
      if (f === "http" || f === "https") {
        return t.consume(h), l;
      }
    }
    return n(h);
  }
  function l(h) {
    return h === 47 ? (t.consume(h), s ? c : (s = !0, l)) : n(h);
  }
  function c(h) {
    return h === null || rp(h) || gn(h) || Ja(h) || bg(h) ? n(h) : t.attempt(NC, t.attempt(IC, u), n)(h);
  }
  function u(h) {
    return t.exit("literalAutolinkHttp"), t.exit("literalAutolink"), e(h);
  }
}
function mz(t, e, n) {
  let r = 0;
  return i;
  function i(o) {
    return (o === 87 || o === 119) && r < 3 ? (r++, t.consume(o), i) : o === 46 && r === 3 ? (t.consume(o), s) : n(o);
  }
  function s(o) {
    return o === null ? n(o) : e(o);
  }
}
function bz(t, e, n) {
  let r, i, s;
  return o;
  function o(c) {
    return c === 46 || c === 95 ? t.check(OC, l, a)(c) : c === null || gn(c) || Ja(c) || c !== 45 && bg(c) ? l(c) : (s = !0, t.consume(c), o);
  }
  function a(c) {
    return c === 95 ? r = !0 : (i = r, r = void 0), t.consume(c), o;
  }
  function l(c) {
    return i || r || !s ? n(c) : e(c);
  }
}
function yz(t, e) {
  let n = 0, r = 0;
  return i;
  function i(o) {
    return o === 40 ? (n++, t.consume(o), i) : o === 41 && r < n ? s(o) : o === 33 || o === 34 || o === 38 || o === 39 || o === 41 || o === 42 || o === 44 || o === 46 || o === 58 || o === 59 || o === 60 || o === 63 || o === 93 || o === 95 || o === 126 ? t.check(OC, e, s)(o) : o === null || gn(o) || Ja(o) ? e(o) : (t.consume(o), i);
  }
  function s(o) {
    return o === 41 && r++, t.consume(o), i;
  }
}
function xz(t, e, n) {
  return r;
  function r(a) {
    return a === 33 || a === 34 || a === 39 || a === 41 || a === 42 || a === 44 || a === 46 || a === 58 || a === 59 || a === 63 || a === 95 || a === 126 ? (t.consume(a), r) : a === 38 ? (t.consume(a), s) : a === 93 ? (t.consume(a), i) : a === 60 || a === null || gn(a) || Ja(a) ? e(a) : n(a);
  }
  function i(a) {
    return a === null || a === 40 || a === 91 || gn(a) || Ja(a) ? e(a) : r(a);
  }
  function s(a) {
    return Fr(a) ? o(a) : n(a);
  }
  function o(a) {
    return a === 59 ? (t.consume(a), r) : Fr(a) ? (t.consume(a), o) : n(a);
  }
}
function vz(t, e, n) {
  return r;
  function r(s) {
    return t.consume(s), i;
  }
  function i(s) {
    return Nr(s) ? n(s) : e(s);
  }
}
function DC(t) {
  return t === null || t === 40 || t === 42 || t === 95 || t === 91 || t === 93 || t === 126 || gn(t);
}
function LC(t) {
  return !Fr(t);
}
function MC(t) {
  return !(t === 47 || yb(t));
}
function yb(t) {
  return t === 43 || t === 45 || t === 46 || t === 95 || Nr(t);
}
function Bx(t) {
  let e = t.length, n = !1;
  for (; e--;) {
    const r = t[e][1];
    if ((r.type === "labelLink" || r.type === "labelImage") && !r._balanced) {
      n = !0;
      break;
    }
    if (r._gfmAutolinkLiteralWalkedInto) {
      n = !1;
      break;
    }
  }
  return t.length > 0 && !n && (t[t.length - 1][1]._gfmAutolinkLiteralWalkedInto = !0), n;
}
const wz = {tokenize:Nz, partial:!0};
function _z() {
  return {document:{91:{name:"gfmFootnoteDefinition", tokenize:Tz, continuation:{tokenize:Cz}, exit:Az}}, text:{91:{name:"gfmFootnoteCall", tokenize:Ez}, 93:{name:"gfmPotentialFootnoteCall", add:"after", tokenize:Sz, resolveTo:kz}}};
}
function Sz(t, e, n) {
  const r = this;
  let i = r.events.length;
  const s = r.parser.gfmFootnotes || (r.parser.gfmFootnotes = []);
  let o;
  for (; i--;) {
    const l = r.events[i][1];
    if (l.type === "labelImage") {
      o = l;
      break;
    }
    if (l.type === "gfmFootnoteCall" || l.type === "labelLink" || l.type === "label" || l.type === "image" || l.type === "link") {
      break;
    }
  }
  return a;
  function a(l) {
    if (!o || !o._balanced) {
      return n(l);
    }
    const c = ns(r.sliceSerialize({start:o.end, end:r.now()}));
    return c.codePointAt(0) !== 94 || !s.includes(c.slice(1)) ? n(l) : (t.enter("gfmFootnoteCallLabelMarker"), t.consume(l), t.exit("gfmFootnoteCallLabelMarker"), e(l));
  }
}
function kz(t, e) {
  let n = t.length;
  for (; n--;) {
    if (t[n][1].type === "labelImage" && t[n][0] === "enter") {
      t[n][1];
      break;
    }
  }
  t[n + 1][1].type = "data", t[n + 3][1].type = "gfmFootnoteCallLabelMarker";
  const r = {type:"gfmFootnoteCall", start:Object.assign({}, t[n + 3][1].start), end:Object.assign({}, t[t.length - 1][1].end)}, i = {type:"gfmFootnoteCallMarker", start:Object.assign({}, t[n + 3][1].end), end:Object.assign({}, t[n + 3][1].end)};
  i.end.column++, i.end.offset++, i.end._bufferIndex++;
  const s = {type:"gfmFootnoteCallString", start:Object.assign({}, i.end), end:Object.assign({}, t[t.length - 1][1].start)}, o = {type:"chunkString", contentType:"string", start:Object.assign({}, s.start), end:Object.assign({}, s.end)}, a = [t[n + 1], t[n + 2], ["enter", r, e], t[n + 3], t[n + 4], ["enter", i, e], ["exit", i, e], ["enter", s, e], ["enter", o, e], ["exit", o, e], ["exit", s, e], t[t.length - 2], t[t.length - 1], ["exit", r, e]];
  return t.splice(n, t.length - n + 1, ...a), t;
}
function Ez(t, e, n) {
  const r = this, i = r.parser.gfmFootnotes || (r.parser.gfmFootnotes = []);
  let s = 0, o;
  return a;
  function a(h) {
    return t.enter("gfmFootnoteCall"), t.enter("gfmFootnoteCallLabelMarker"), t.consume(h), t.exit("gfmFootnoteCallLabelMarker"), l;
  }
  function l(h) {
    return h !== 94 ? n(h) : (t.enter("gfmFootnoteCallMarker"), t.consume(h), t.exit("gfmFootnoteCallMarker"), t.enter("gfmFootnoteCallString"), t.enter("chunkString").contentType = "string", c);
  }
  function c(h) {
    if (s > 999 || h === 93 && !o || h === null || h === 91 || gn(h)) {
      return n(h);
    }
    if (h === 93) {
      t.exit("chunkString");
      const f = t.exit("gfmFootnoteCallString");
      return i.includes(ns(r.sliceSerialize(f))) ? (t.enter("gfmFootnoteCallLabelMarker"), t.consume(h), t.exit("gfmFootnoteCallLabelMarker"), t.exit("gfmFootnoteCall"), e) : n(h);
    }
    return gn(h) || (o = !0), s++, t.consume(h), h === 92 ? u : c;
  }
  function u(h) {
    return h === 91 || h === 92 || h === 93 ? (t.consume(h), s++, c) : c(h);
  }
}
function Tz(t, e, n) {
  const r = this, i = r.parser.gfmFootnotes || (r.parser.gfmFootnotes = []);
  let s, o = 0, a;
  return l;
  function l(g) {
    return t.enter("gfmFootnoteDefinition")._container = !0, t.enter("gfmFootnoteDefinitionLabel"), t.enter("gfmFootnoteDefinitionLabelMarker"), t.consume(g), t.exit("gfmFootnoteDefinitionLabelMarker"), c;
  }
  function c(g) {
    return g === 94 ? (t.enter("gfmFootnoteDefinitionMarker"), t.consume(g), t.exit("gfmFootnoteDefinitionMarker"), t.enter("gfmFootnoteDefinitionLabelString"), t.enter("chunkString").contentType = "string", u) : n(g);
  }
  function u(g) {
    if (o > 999 || g === 93 && !a || g === null || g === 91 || gn(g)) {
      return n(g);
    }
    if (g === 93) {
      t.exit("chunkString");
      const m = t.exit("gfmFootnoteDefinitionLabelString");
      return s = ns(r.sliceSerialize(m)), t.enter("gfmFootnoteDefinitionLabelMarker"), t.consume(g), t.exit("gfmFootnoteDefinitionLabelMarker"), t.exit("gfmFootnoteDefinitionLabel"), f;
    }
    return gn(g) || (a = !0), o++, t.consume(g), g === 92 ? h : u;
  }
  function h(g) {
    return g === 91 || g === 92 || g === 93 ? (t.consume(g), o++, u) : u(g);
  }
  function f(g) {
    return g === 58 ? (t.enter("definitionMarker"), t.consume(g), t.exit("definitionMarker"), i.includes(s) || i.push(s), Gt(t, p, "gfmFootnoteDefinitionWhitespace")) : n(g);
  }
  function p(g) {
    return e(g);
  }
}
function Cz(t, e, n) {
  return t.check(qd, e, t.attempt(wz, e, n));
}
function Az(t) {
  t.exit("gfmFootnoteDefinition");
}
function Nz(t, e, n) {
  const r = this;
  return Gt(t, i, "gfmFootnoteDefinitionIndent", 5);
  function i(s) {
    const o = r.events[r.events.length - 1];
    return o && o[1].type === "gfmFootnoteDefinitionIndent" && o[2].sliceSerialize(o[1], !0).length === 4 ? e(s) : n(s);
  }
}
function Iz(t) {
  let n = (t || {}).singleTilde;
  const r = {name:"strikethrough", tokenize:s, resolveAll:i};
  return n == null && (n = !0), {text:{126:r}, insideSpan:{null:[r]}, attentionMarkers:{null:[126]}};
  function i(o, a) {
    let l = -1;
    for (; ++l < o.length;) {
      if (o[l][0] === "enter" && o[l][1].type === "strikethroughSequenceTemporary" && o[l][1]._close) {
        let c = l;
        for (; c--;) {
          if (o[c][0] === "exit" && o[c][1].type === "strikethroughSequenceTemporary" && o[c][1]._open && o[l][1].end.offset - o[l][1].start.offset === o[c][1].end.offset - o[c][1].start.offset) {
            o[l][1].type = "strikethroughSequence", o[c][1].type = "strikethroughSequence";
            const u = {type:"strikethrough", start:Object.assign({}, o[c][1].start), end:Object.assign({}, o[l][1].end)}, h = {type:"strikethroughText", start:Object.assign({}, o[c][1].end), end:Object.assign({}, o[l][1].start)}, f = [["enter", u, a], ["enter", o[c][1], a], ["exit", o[c][1], a], ["enter", h, a]], p = a.parser.constructs.insideSpan.null;
            p && yi(f, f.length, 0, yg(p, o.slice(c + 1, l), a)), yi(f, f.length, 0, [["exit", h, a], ["enter", o[l][1], a], ["exit", o[l][1], a], ["exit", u, a]]), yi(o, c - 1, l - c + 3, f), l = c + f.length - 2;
            break;
          }
        }
      }
    }
    for (l = -1; ++l < o.length;) {
      o[l][1].type === "strikethroughSequenceTemporary" && (o[l][1].type = "data");
    }
    return o;
  }
  function s(o, a, l) {
    const c = this.previous, u = this.events;
    let h = 0;
    return f;
    function f(g) {
      return c === 126 && u[u.length - 1][1].type !== "characterEscape" ? l(g) : (o.enter("strikethroughSequenceTemporary"), p(g));
    }
    function p(g) {
      const m = ic(c);
      if (g === 126) {
        return h > 1 ? l(g) : (o.consume(g), h++, p);
      }
      if (h < 2 && !n) {
        return l(g);
      }
      const b = o.exit("strikethroughSequenceTemporary"), x = ic(g);
      return b._open = !x || x === 2 && !!m, b._close = !m || m === 2 && !!x, a(g);
    }
  }
}
class Oz {
  constructor() {
    this.map = [];
  }
  add(e, n, r) {
    Pz(this, e, n, r);
  }
  consume(e) {
    if (this.map.sort(function(s, o) {
      return s[0] - o[0];
    }), this.map.length === 0) {
      return;
    }
    let n = this.map.length;
    const r = [];
    for (; n > 0;) {
      n -= 1, r.push(e.slice(this.map[n][0] + this.map[n][1]), this.map[n][2]), e.length = this.map[n][0];
    }
    r.push(e.slice()), e.length = 0;
    let i = r.pop();
    for (; i;) {
      for (const s of i) {
        e.push(s);
      }
      i = r.pop();
    }
    this.map.length = 0;
  }
}
function Pz(t, e, n, r) {
  let i = 0;
  if (!(n === 0 && r.length === 0)) {
    for (; i < t.map.length;) {
      if (t.map[i][0] === e) {
        t.map[i][1] += n, t.map[i][2].push(...r);
        return;
      }
      i += 1;
    }
    t.map.push([e, n, r]);
  }
}
function Rz(t, e) {
  let n = !1;
  const r = [];
  for (; e < t.length;) {
    const i = t[e];
    if (n) {
      if (i[0] === "enter") {
        i[1].type === "tableContent" && r.push(t[e + 1][1].type === "tableDelimiterMarker" ? "left" : "none");
      } else if (i[1].type === "tableContent") {
        if (t[e - 1][1].type === "tableDelimiterMarker") {
          const s = r.length - 1;
          r[s] = r[s] === "left" ? "center" : "right";
        }
      } else if (i[1].type === "tableDelimiterRow") {
        break;
      }
    } else {
      i[0] === "enter" && i[1].type === "tableDelimiterRow" && (n = !0);
    }
    e += 1;
  }
  return r;
}
function Dz() {
  return {flow:{null:{name:"table", tokenize:Lz, resolveAll:Mz}}};
}
function Lz(t, e, n) {
  const r = this;
  let i = 0, s = 0, o;
  return a;
  function a(k) {
    let A = r.events.length - 1;
    for (; A > -1;) {
      const F = r.events[A][1].type;
      if (F === "lineEnding" || F === "linePrefix") {
        A--;
      } else {
        break;
      }
    }
    const P = A > -1 ? r.events[A][1].type : null, W = P === "tableHead" || P === "tableRow" ? _ : l;
    return W === _ && r.parser.lazy[r.now().line] ? n(k) : W(k);
  }
  function l(k) {
    return t.enter("tableHead"), t.enter("tableRow"), c(k);
  }
  function c(k) {
    return k === 124 || (o = !0, s += 1), u(k);
  }
  function u(k) {
    return k === null ? n(k) : mt(k) ? s > 1 ? (s = 0, r.interrupt = !0, t.exit("tableRow"), t.enter("lineEnding"), t.consume(k), t.exit("lineEnding"), p) : n(k) : Ft(k) ? Gt(t, u, "whitespace")(k) : (s += 1, o && (o = !1, i += 1), k === 124 ? (t.enter("tableCellDivider"), t.consume(k), t.exit("tableCellDivider"), o = !0, u) : (t.enter("data"), h(k)));
  }
  function h(k) {
    return k === null || k === 124 || gn(k) ? (t.exit("data"), u(k)) : (t.consume(k), k === 92 ? f : h);
  }
  function f(k) {
    return k === 92 || k === 124 ? (t.consume(k), h) : h(k);
  }
  function p(k) {
    return r.interrupt = !1, r.parser.lazy[r.now().line] ? n(k) : (t.enter("tableDelimiterRow"), o = !1, Ft(k) ? Gt(t, g, "linePrefix", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(k) : g(k));
  }
  function g(k) {
    return k === 45 || k === 58 ? b(k) : k === 124 ? (o = !0, t.enter("tableCellDivider"), t.consume(k), t.exit("tableCellDivider"), m) : I(k);
  }
  function m(k) {
    return Ft(k) ? Gt(t, b, "whitespace")(k) : b(k);
  }
  function b(k) {
    return k === 58 ? (s += 1, o = !0, t.enter("tableDelimiterMarker"), t.consume(k), t.exit("tableDelimiterMarker"), x) : k === 45 ? (s += 1, x(k)) : k === null || mt(k) ? T(k) : I(k);
  }
  function x(k) {
    return k === 45 ? (t.enter("tableDelimiterFiller"), w(k)) : I(k);
  }
  function w(k) {
    return k === 45 ? (t.consume(k), w) : k === 58 ? (o = !0, t.exit("tableDelimiterFiller"), t.enter("tableDelimiterMarker"), t.consume(k), t.exit("tableDelimiterMarker"), v) : (t.exit("tableDelimiterFiller"), v(k));
  }
  function v(k) {
    return Ft(k) ? Gt(t, T, "whitespace")(k) : T(k);
  }
  function T(k) {
    return k === 124 ? g(k) : k === null || mt(k) ? !o || i !== s ? I(k) : (t.exit("tableDelimiterRow"), t.exit("tableHead"), e(k)) : I(k);
  }
  function I(k) {
    return n(k);
  }
  function _(k) {
    return t.enter("tableRow"), N(k);
  }
  function N(k) {
    return k === 124 ? (t.enter("tableCellDivider"), t.consume(k), t.exit("tableCellDivider"), N) : k === null || mt(k) ? (t.exit("tableRow"), e(k)) : Ft(k) ? Gt(t, N, "whitespace")(k) : (t.enter("data"), E(k));
  }
  function E(k) {
    return k === null || k === 124 || gn(k) ? (t.exit("data"), N(k)) : (t.consume(k), k === 92 ? C : E);
  }
  function C(k) {
    return k === 92 || k === 124 ? (t.consume(k), E) : E(k);
  }
}
function Mz(t, e) {
  let n = -1, r = !0, i = 0, s = [0, 0, 0, 0], o = [0, 0, 0, 0], a = !1, l = 0, c, u, h;
  const f = new Oz();
  for (; ++n < t.length;) {
    const p = t[n], g = p[1];
    p[0] === "enter" ? g.type === "tableHead" ? (a = !1, l !== 0 && (g_(f, e, l, c, u), u = void 0, l = 0), c = {type:"table", start:Object.assign({}, g.start), end:Object.assign({}, g.end)}, f.add(n, 0, [["enter", c, e]])) : g.type === "tableRow" || g.type === "tableDelimiterRow" ? (r = !0, h = void 0, s = [0, 0, 0, 0], o = [0, n + 1, 0, 0], a && (a = !1, u = {type:"tableBody", start:Object.assign({}, g.start), end:Object.assign({}, g.end)}, f.add(n, 0, [["enter", u, e]])), i = g.type === "tableDelimiterRow" ? 
    2 : u ? 3 : 1) : i && (g.type === "data" || g.type === "tableDelimiterMarker" || g.type === "tableDelimiterFiller") ? (r = !1, o[2] === 0 && (s[1] !== 0 && (o[0] = o[1], h = Ch(f, e, s, i, void 0, h), s = [0, 0, 0, 0]), o[2] = n)) : g.type === "tableCellDivider" && (r ? r = !1 : (s[1] !== 0 && (o[0] = o[1], h = Ch(f, e, s, i, void 0, h)), s = o, o = [s[1], n, 0, 0])) : g.type === "tableHead" ? (a = !0, l = n) : g.type === "tableRow" || g.type === "tableDelimiterRow" ? (l = n, s[1] !== 0 ? (o[0] = 
    o[1], h = Ch(f, e, s, i, n, h)) : o[1] !== 0 && (h = Ch(f, e, o, i, n, h)), i = 0) : i && (g.type === "data" || g.type === "tableDelimiterMarker" || g.type === "tableDelimiterFiller") && (o[3] = n);
  }
  for (l !== 0 && g_(f, e, l, c, u), f.consume(e.events), n = -1; ++n < e.events.length;) {
    const p = e.events[n];
    p[0] === "enter" && p[1].type === "table" && (p[1]._align = Rz(e.events, n));
  }
  return t;
}
function Ch(t, e, n, r, i, s) {
  const o = r === 1 ? "tableHeader" : r === 2 ? "tableDelimiter" : "tableData", a = "tableContent";
  n[0] !== 0 && (s.end = Object.assign({}, Tl(e.events, n[0])), t.add(n[0], 0, [["exit", s, e]]));
  const l = Tl(e.events, n[1]);
  if (s = {type:o, start:Object.assign({}, l), end:Object.assign({}, l)}, t.add(n[1], 0, [["enter", s, e]]), n[2] !== 0) {
    const c = Tl(e.events, n[2]), u = Tl(e.events, n[3]), h = {type:a, start:Object.assign({}, c), end:Object.assign({}, u)};
    if (t.add(n[2], 0, [["enter", h, e]]), r !== 2) {
      const f = e.events[n[2]], p = e.events[n[3]];
      if (f[1].end = Object.assign({}, p[1].end), f[1].type = "chunkText", f[1].contentType = "text", n[3] > n[2] + 1) {
        const g = n[2] + 1, m = n[3] - n[2] - 1;
        t.add(g, m, []);
      }
    }
    t.add(n[3] + 1, 0, [["exit", h, e]]);
  }
  return i !== void 0 && (s.end = Object.assign({}, Tl(e.events, i)), t.add(i, 0, [["exit", s, e]]), s = void 0), s;
}
function g_(t, e, n, r, i) {
  const s = [], o = Tl(e.events, n);
  i && (i.end = Object.assign({}, o), s.push(["exit", i, e])), r.end = Object.assign({}, o), s.push(["exit", r, e]), t.add(n + 1, 0, s);
}
function Tl(t, e) {
  const n = t[e], r = n[0] === "enter" ? "start" : "end";
  return n[1][r];
}
const Bz = {name:"tasklistCheck", tokenize:Fz};
function $z() {
  return {text:{91:Bz}};
}
function Fz(t, e, n) {
  const r = this;
  return i;
  function i(l) {
    return r.previous !== null || !r._gfmTasklistFirstContentOfListItem ? n(l) : (t.enter("taskListCheck"), t.enter("taskListCheckMarker"), t.consume(l), t.exit("taskListCheckMarker"), s);
  }
  function s(l) {
    return gn(l) ? (t.enter("taskListCheckValueUnchecked"), t.consume(l), t.exit("taskListCheckValueUnchecked"), o) : l === 88 || l === 120 ? (t.enter("taskListCheckValueChecked"), t.consume(l), t.exit("taskListCheckValueChecked"), o) : n(l);
  }
  function o(l) {
    return l === 93 ? (t.enter("taskListCheckMarker"), t.consume(l), t.exit("taskListCheckMarker"), t.exit("taskListCheck"), a) : n(l);
  }
  function a(l) {
    return mt(l) ? e(l) : Ft(l) ? t.check({tokenize:zz}, e, n)(l) : n(l);
  }
}
function zz(t, e, n) {
  return Gt(t, r, "whitespace");
  function r(i) {
    return i === null ? n(i) : e(i);
  }
}
function Hz(t) {
  return VT([hz(), _z(), Iz(t), Dz(), $z()]);
}
const Uz = {};
function Wz(t) {
  const e = this, n = t || Uz, r = e.data(), i = r.micromarkExtensions || (r.micromarkExtensions = []), s = r.fromMarkdownExtensions || (r.fromMarkdownExtensions = []), o = r.toMarkdownExtensions || (r.toMarkdownExtensions = []);
  i.push(Hz(n)), s.push(lz()), o.push(cz(n));
}
const m_ = /[#.]/g;
function jz(t, e) {
  const n = t || "", r = {};
  let i = 0, s, o;
  for (; i < n.length;) {
    m_.lastIndex = i;
    const a = m_.exec(n), l = n.slice(i, a ? a.index : n.length);
    l && (s ? s === "#" ? r.id = l : Array.isArray(r.className) ? r.className.push(l) : r.className = [l] : o = l, i += l.length), a && (s = a[0], i++);
  }
  return {type:"element", tagName:o || e || "div", properties:r, children:[]};
}
function BC(t, e, n) {
  const r = n ? Gz(n) : void 0;
  function i(s, o, ...a) {
    let l;
    if (s == null) {
      l = {type:"root", children:[]};
      const c = o;
      a.unshift(c);
    } else {
      l = jz(s, e);
      const c = l.tagName.toLowerCase(), u = r ? r.get(c) : void 0;
      if (l.tagName = u || c, Vz(o)) {
        a.unshift(o);
      } else {
        for (const [h, f] of Object.entries(o)) {
          qz(t, l.properties, h, f);
        }
      }
    }
    for (const c of a) {
      xb(l.children, c);
    }
    return l.type === "element" && l.tagName === "template" && (l.content = {type:"root", children:l.children}, l.children = []), l;
  }
  return i;
}
function Vz(t) {
  if (t === null || typeof t != "object" || Array.isArray(t)) {
    return !0;
  }
  if (typeof t.type != "string") {
    return !1;
  }
  const e = t, n = Object.keys(t);
  for (const r of n) {
    const i = e[r];
    if (i && typeof i == "object") {
      if (!Array.isArray(i)) {
        return !0;
      }
      const s = i;
      for (const o of s) {
        if (typeof o != "number" && typeof o != "string") {
          return !0;
        }
      }
    }
  }
  return !!("children" in t && Array.isArray(t.children));
}
function qz(t, e, n, r) {
  const i = pg(t, n);
  let s;
  if (r != null) {
    if (typeof r == "number") {
      if (Number.isNaN(r)) {
        return;
      }
      s = r;
    } else {
      typeof r == "boolean" ? s = r : typeof r == "string" ? i.spaceSeparated ? s = Sw(r) : i.commaSeparated ? s = yw(r) : i.commaOrSpaceSeparated ? s = Sw(yw(r).join(" ")) : s = b_(i, i.property, r) : Array.isArray(r) ? s = [...r] : s = i.property === "style" ? Yz(r) : String(r);
    }
    if (Array.isArray(s)) {
      const o = [];
      for (const a of s) {
        o.push(b_(i, i.property, a));
      }
      s = o;
    }
    i.property === "className" && Array.isArray(e.className) && (s = e.className.concat(s)), e[i.property] = s;
  }
}
function xb(t, e) {
  if (e != null) {
    if (typeof e == "number" || typeof e == "string") {
      t.push({type:"text", value:String(e)});
    } else if (Array.isArray(e)) {
      for (const n of e) {
        xb(t, n);
      }
    } else if (typeof e == "object" && "type" in e) {
      e.type === "root" ? xb(t, e.children) : t.push(e);
    } else {
      throw new Error("Expected node, nodes, or string, got `" + e + "`");
    }
  }
}
function b_(t, e, n) {
  if (typeof n == "string") {
    if (t.number && n && !Number.isNaN(Number(n))) {
      return Number(n);
    }
    if ((t.boolean || t.overloadedBoolean) && (n === "" || ld(n) === ld(e))) {
      return !0;
    }
  }
  return n;
}
function Yz(t) {
  const e = [];
  for (const [n, r] of Object.entries(t)) {
    e.push([n, r].join(": "));
  }
  return e.join("; ");
}
function Gz(t) {
  const e = new Map();
  for (const n of t) {
    e.set(n.toLowerCase(), n);
  }
  return e;
}
const Qz = ["altGlyph", "altGlyphDef", "altGlyphItem", "animateColor", "animateMotion", "animateTransform", "clipPath", "feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feDropShadow", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence", "foreignObject", 
"glyphRef", "linearGradient", "radialGradient", "solidColor", "textArea", "textPath"], Kz = BC(jd, "div"), Xz = BC(sa, "g", Qz);
function Jz(t) {
  const e = String(t), n = [];
  return {toOffset:i, toPoint:r};
  function r(s) {
    if (typeof s == "number" && s > -1 && s <= e.length) {
      let o = 0;
      for (;;) {
        let a = n[o];
        if (a === void 0) {
          const l = y_(e, n[o - 1]);
          a = l === -1 ? e.length + 1 : l + 1, n[o] = a;
        }
        if (a > s) {
          return {line:o + 1, column:s - (o > 0 ? n[o - 1] : 0) + 1, offset:s};
        }
        o++;
      }
    }
  }
  function i(s) {
    if (s && typeof s.line == "number" && typeof s.column == "number" && !Number.isNaN(s.line) && !Number.isNaN(s.column)) {
      for (; n.length < s.line;) {
        const a = n[n.length - 1], l = y_(e, a), c = l === -1 ? e.length + 1 : l + 1;
        if (a === c) {
          break;
        }
        n.push(c);
      }
      const o = (s.line > 1 ? n[s.line - 2] : 0) + s.column - 1;
      if (o < n[s.line - 1]) {
        return o;
      }
    }
  }
}
function y_(t, e) {
  const n = t.indexOf("\r", e), r = t.indexOf(`
`, e);
  return r === -1 ? n : n === -1 || n + 1 === r ? r : n < r ? n : r;
}
const Pa = {html:"http://www.w3.org/1999/xhtml", mathml:"http://www.w3.org/1998/Math/MathML", svg:"http://www.w3.org/2000/svg", xlink:"http://www.w3.org/1999/xlink", xml:"http://www.w3.org/XML/1998/namespace", xmlns:"http://www.w3.org/2000/xmlns/"}, $C = {}.hasOwnProperty, Zz = Object.prototype;
function e9(t, e) {
  const n = e || {};
  return $x({file:n.file || void 0, location:!1, schema:n.space === "svg" ? sa : jd, verbose:n.verbose || !1}, t);
}
function $x(t, e) {
  let n;
  switch(e.nodeName) {
    case "#comment":
      {
        const r = e;
        return n = {type:"comment", value:r.data}, Af(t, r, n), n;
      }
    case "#document":
    case "#document-fragment":
      {
        const r = e, i = "mode" in r ? r.mode === "quirks" || r.mode === "limited-quirks" : !1;
        if (n = {type:"root", children:FC(t, e.childNodes), data:{quirksMode:i}}, t.file && t.location) {
          const s = String(t.file), o = Jz(s), a = o.toPoint(0), l = o.toPoint(s.length);
          n.position = {start:a, end:l};
        }
        return n;
      }
    case "#documentType":
      {
        const r = e;
        return n = {type:"doctype"}, Af(t, r, n), n;
      }
    case "#text":
      {
        const r = e;
        return n = {type:"text", value:r.value}, Af(t, r, n), n;
      }
    default:
      return n = t9(t, e), n;
  }
}
function FC(t, e) {
  let n = -1;
  const r = [];
  for (; ++n < e.length;) {
    const i = $x(t, e[n]);
    r.push(i);
  }
  return r;
}
function t9(t, e) {
  const n = t.schema;
  t.schema = e.namespaceURI === Pa.svg ? sa : jd;
  let r = -1;
  const i = {};
  for (; ++r < e.attrs.length;) {
    const a = e.attrs[r], l = (a.prefix ? a.prefix + ":" : "") + a.name;
    $C.call(Zz, l) || (i[l] = a.value);
  }
  const o = (t.schema.space === "svg" ? Xz : Kz)(e.tagName, i, FC(t, e.childNodes));
  if (Af(t, e, o), o.tagName === "template") {
    const a = e, l = a.sourceCodeLocation, c = l && l.startTag && Hl(l.startTag), u = l && l.endTag && Hl(l.endTag), h = $x(t, a.content);
    c && u && t.file && (h.position = {start:c.end, end:u.start}), o.content = h;
  }
  return t.schema = n, o;
}
function Af(t, e, n) {
  if ("sourceCodeLocation" in e && e.sourceCodeLocation && t.file) {
    const r = n9(t, n, e.sourceCodeLocation);
    r && (t.location = !0, n.position = r);
  }
}
function n9(t, e, n) {
  const r = Hl(n);
  if (e.type === "element") {
    const i = e.children[e.children.length - 1];
    if (r && !n.endTag && i && i.position && i.position.end && (r.end = Object.assign({}, i.position.end)), t.verbose) {
      const s = {};
      let o;
      if (n.attrs) {
        for (o in n.attrs) {
          $C.call(n.attrs, o) && (s[pg(t.schema, o).property] = Hl(n.attrs[o]));
        }
      }
      n.startTag;
      const a = Hl(n.startTag), l = n.endTag ? Hl(n.endTag) : void 0, c = {opening:a};
      l && (c.closing = l), c.properties = s, e.data = {position:c};
    }
  }
  return r;
}
function Hl(t) {
  const e = x_({line:t.startLine, column:t.startCol, offset:t.startOffset}), n = x_({line:t.endLine, column:t.endCol, offset:t.endOffset});
  return e || n ? {start:e, end:n} : void 0;
}
function x_(t) {
  return t.line && t.column ? t : void 0;
}
const r9 = {}, i9 = {}.hasOwnProperty, zC = bC("type", {handlers:{root:o9, element:d9, text:c9, comment:u9, doctype:l9}});
function s9(t, e) {
  const r = (e || r9).space;
  return zC(t, r === "svg" ? sa : jd);
}
function o9(t, e) {
  const n = {nodeName:"#document", mode:(t.data || {}).quirksMode ? "quirks" : "no-quirks", childNodes:[]};
  return n.childNodes = Fx(t.children, n, e), Ec(t, n), n;
}
function a9(t, e) {
  const n = {nodeName:"#document-fragment", childNodes:[]};
  return n.childNodes = Fx(t.children, n, e), Ec(t, n), n;
}
function l9(t) {
  const e = {nodeName:"#documentType", name:"html", publicId:"", systemId:"", parentNode:null};
  return Ec(t, e), e;
}
function c9(t) {
  const e = {nodeName:"#text", value:t.value, parentNode:null};
  return Ec(t, e), e;
}
function u9(t) {
  const e = {nodeName:"#comment", data:t.value, parentNode:null};
  return Ec(t, e), e;
}
function d9(t, e) {
  const n = e;
  let r = n;
  t.type === "element" && t.tagName.toLowerCase() === "svg" && n.space === "html" && (r = sa);
  const i = [];
  let s;
  if (t.properties) {
    for (s in t.properties) {
      if (s !== "children" && i9.call(t.properties, s)) {
        const l = h9(r, s, t.properties[s]);
        l && i.push(l);
      }
    }
  }
  const o = r.space, a = {nodeName:t.tagName, tagName:t.tagName, attrs:i, namespaceURI:Pa[o], childNodes:[], parentNode:null};
  return a.childNodes = Fx(t.children, a, r), Ec(t, a), t.tagName === "template" && t.content && (a.content = a9(t.content, r)), a;
}
function h9(t, e, n) {
  const r = pg(t, e);
  if (n === !1 || n === null || n === void 0 || typeof n == "number" && Number.isNaN(n) || !n && r.boolean) {
    return;
  }
  Array.isArray(n) && (n = r.commaSeparated ? IT(n) : $T(n));
  const i = {name:r.attribute, value:n === !0 ? "" : String(n)};
  if (r.space && r.space !== "html" && r.space !== "svg") {
    const s = i.name.indexOf(":");
    s < 0 ? i.prefix = "" : (i.name = i.name.slice(s + 1), i.prefix = r.attribute.slice(0, s)), i.namespace = Pa[r.space];
  }
  return i;
}
function Fx(t, e, n) {
  let r = -1;
  const i = [];
  if (t) {
    for (; ++r < t.length;) {
      const s = zC(t[r], n);
      s.parentNode = e, i.push(s);
    }
  }
  return i;
}
function Ec(t, e) {
  const n = t.position;
  n && n.start && n.end && (n.start.offset, n.end.offset, e.sourceCodeLocation = {startLine:n.start.line, startCol:n.start.column, startOffset:n.start.offset, endLine:n.end.line, endCol:n.end.column, endOffset:n.end.offset});
}
const f9 = ["area", "base", "basefont", "bgsound", "br", "col", "command", "embed", "frame", "hr", "image", "img", "input", "keygen", "link", "meta", "param", "source", "track", "wbr"], p9 = new Set([65534, 65535, 131070, 131071, 196606, 196607, 262142, 262143, 327678, 327679, 393214, 393215, 458750, 458751, 524286, 524287, 589822, 589823, 655358, 655359, 720894, 720895, 786430, 786431, 851966, 851967, 917502, 917503, 983038, 983039, 1048574, 1048575, 1114110, 1114111]), Tn = "\ufffd";
var Y;
(function(t) {
  t[t.EOF = -1] = "EOF", t[t.NULL = 0] = "NULL", t[t.TABULATION = 9] = "TABULATION", t[t.CARRIAGE_RETURN = 13] = "CARRIAGE_RETURN", t[t.LINE_FEED = 10] = "LINE_FEED", t[t.FORM_FEED = 12] = "FORM_FEED", t[t.SPACE = 32] = "SPACE", t[t.EXCLAMATION_MARK = 33] = "EXCLAMATION_MARK", t[t.QUOTATION_MARK = 34] = "QUOTATION_MARK", t[t.AMPERSAND = 38] = "AMPERSAND", t[t.APOSTROPHE = 39] = "APOSTROPHE", t[t.HYPHEN_MINUS = 45] = "HYPHEN_MINUS", t[t.SOLIDUS = 47] = "SOLIDUS", t[t.DIGIT_0 = 48] = "DIGIT_0", t[t.DIGIT_9 = 
  57] = "DIGIT_9", t[t.SEMICOLON = 59] = "SEMICOLON", t[t.LESS_THAN_SIGN = 60] = "LESS_THAN_SIGN", t[t.EQUALS_SIGN = 61] = "EQUALS_SIGN", t[t.GREATER_THAN_SIGN = 62] = "GREATER_THAN_SIGN", t[t.QUESTION_MARK = 63] = "QUESTION_MARK", t[t.LATIN_CAPITAL_A = 65] = "LATIN_CAPITAL_A", t[t.LATIN_CAPITAL_Z = 90] = "LATIN_CAPITAL_Z", t[t.RIGHT_SQUARE_BRACKET = 93] = "RIGHT_SQUARE_BRACKET", t[t.GRAVE_ACCENT = 96] = "GRAVE_ACCENT", t[t.LATIN_SMALL_A = 97] = "LATIN_SMALL_A", t[t.LATIN_SMALL_Z = 122] = "LATIN_SMALL_Z";
})(Y || (Y = {}));
const Gr = {DASH_DASH:"--", CDATA_START:"[CDATA[", DOCTYPE:"doctype", SCRIPT:"script", PUBLIC:"public", SYSTEM:"system"};
function HC(t) {
  return t >= 55296 && t <= 57343;
}
function g9(t) {
  return t >= 56320 && t <= 57343;
}
function m9(t, e) {
  return (t - 55296) * 1024 + 9216 + e;
}
function UC(t) {
  return t !== 32 && t !== 10 && t !== 13 && t !== 9 && t !== 12 && t >= 1 && t <= 31 || t >= 127 && t <= 159;
}
function WC(t) {
  return t >= 64976 && t <= 65007 || p9.has(t);
}
var Se;
(function(t) {
  t.controlCharacterInInputStream = "control-character-in-input-stream", t.noncharacterInInputStream = "noncharacter-in-input-stream", t.surrogateInInputStream = "surrogate-in-input-stream", t.nonVoidHtmlElementStartTagWithTrailingSolidus = "non-void-html-element-start-tag-with-trailing-solidus", t.endTagWithAttributes = "end-tag-with-attributes", t.endTagWithTrailingSolidus = "end-tag-with-trailing-solidus", t.unexpectedSolidusInTag = "unexpected-solidus-in-tag", t.unexpectedNullCharacter = "unexpected-null-character", 
  t.unexpectedQuestionMarkInsteadOfTagName = "unexpected-question-mark-instead-of-tag-name", t.invalidFirstCharacterOfTagName = "invalid-first-character-of-tag-name", t.unexpectedEqualsSignBeforeAttributeName = "unexpected-equals-sign-before-attribute-name", t.missingEndTagName = "missing-end-tag-name", t.unexpectedCharacterInAttributeName = "unexpected-character-in-attribute-name", t.unknownNamedCharacterReference = "unknown-named-character-reference", t.missingSemicolonAfterCharacterReference = 
  "missing-semicolon-after-character-reference", t.unexpectedCharacterAfterDoctypeSystemIdentifier = "unexpected-character-after-doctype-system-identifier", t.unexpectedCharacterInUnquotedAttributeValue = "unexpected-character-in-unquoted-attribute-value", t.eofBeforeTagName = "eof-before-tag-name", t.eofInTag = "eof-in-tag", t.missingAttributeValue = "missing-attribute-value", t.missingWhitespaceBetweenAttributes = "missing-whitespace-between-attributes", t.missingWhitespaceAfterDoctypePublicKeyword = 
  "missing-whitespace-after-doctype-public-keyword", t.missingWhitespaceBetweenDoctypePublicAndSystemIdentifiers = "missing-whitespace-between-doctype-public-and-system-identifiers", t.missingWhitespaceAfterDoctypeSystemKeyword = "missing-whitespace-after-doctype-system-keyword", t.missingQuoteBeforeDoctypePublicIdentifier = "missing-quote-before-doctype-public-identifier", t.missingQuoteBeforeDoctypeSystemIdentifier = "missing-quote-before-doctype-system-identifier", t.missingDoctypePublicIdentifier = 
  "missing-doctype-public-identifier", t.missingDoctypeSystemIdentifier = "missing-doctype-system-identifier", t.abruptDoctypePublicIdentifier = "abrupt-doctype-public-identifier", t.abruptDoctypeSystemIdentifier = "abrupt-doctype-system-identifier", t.cdataInHtmlContent = "cdata-in-html-content", t.incorrectlyOpenedComment = "incorrectly-opened-comment", t.eofInScriptHtmlCommentLikeText = "eof-in-script-html-comment-like-text", t.eofInDoctype = "eof-in-doctype", t.nestedComment = "nested-comment", 
  t.abruptClosingOfEmptyComment = "abrupt-closing-of-empty-comment", t.eofInComment = "eof-in-comment", t.incorrectlyClosedComment = "incorrectly-closed-comment", t.eofInCdata = "eof-in-cdata", t.absenceOfDigitsInNumericCharacterReference = "absence-of-digits-in-numeric-character-reference", t.nullCharacterReference = "null-character-reference", t.surrogateCharacterReference = "surrogate-character-reference", t.characterReferenceOutsideUnicodeRange = "character-reference-outside-unicode-range", t.controlCharacterReference = 
  "control-character-reference", t.noncharacterCharacterReference = "noncharacter-character-reference", t.missingWhitespaceBeforeDoctypeName = "missing-whitespace-before-doctype-name", t.missingDoctypeName = "missing-doctype-name", t.invalidCharacterSequenceAfterDoctypeName = "invalid-character-sequence-after-doctype-name", t.duplicateAttribute = "duplicate-attribute", t.nonConformingDoctype = "non-conforming-doctype", t.missingDoctype = "missing-doctype", t.misplacedDoctype = "misplaced-doctype", 
  t.endTagWithoutMatchingOpenElement = "end-tag-without-matching-open-element", t.closingOfElementWithOpenChildElements = "closing-of-element-with-open-child-elements", t.disallowedContentInNoscriptInHead = "disallowed-content-in-noscript-in-head", t.openElementsLeftAfterEof = "open-elements-left-after-eof", t.abandonedHeadElementChild = "abandoned-head-element-child", t.misplacedStartTagForHeadElement = "misplaced-start-tag-for-head-element", t.nestedNoscriptInHead = "nested-noscript-in-head", t.eofInElementThatCanContainOnlyText = 
  "eof-in-element-that-can-contain-only-text";
})(Se || (Se = {}));
const b9 = 65536;
class y9 {
  constructor(e) {
    this.handler = e, this.html = "", this.pos = -1, this.lastGapPos = -2, this.gapStack = [], this.skipNextNewLine = !1, this.lastChunkWritten = !1, this.endOfChunkHit = !1, this.bufferWaterline = b9, this.isEol = !1, this.lineStartPos = 0, this.droppedBufferSize = 0, this.line = 1, this.lastErrOffset = -1;
  }
  get col() {
    return this.pos - this.lineStartPos + +(this.lastGapPos !== this.pos);
  }
  get offset() {
    return this.droppedBufferSize + this.pos;
  }
  getError(e, n) {
    const {line:r, col:i, offset:s} = this, o = i + n, a = s + n;
    return {code:e, startLine:r, endLine:r, startCol:o, endCol:o, startOffset:a, endOffset:a};
  }
  _err(e) {
    this.handler.onParseError && this.lastErrOffset !== this.offset && (this.lastErrOffset = this.offset, this.handler.onParseError(this.getError(e, 0)));
  }
  _addGap() {
    this.gapStack.push(this.lastGapPos), this.lastGapPos = this.pos;
  }
  _processSurrogate(e) {
    if (this.pos !== this.html.length - 1) {
      const n = this.html.charCodeAt(this.pos + 1);
      if (g9(n)) {
        return this.pos++, this._addGap(), m9(e, n);
      }
    } else if (!this.lastChunkWritten) {
      return this.endOfChunkHit = !0, Y.EOF;
    }
    return this._err(Se.surrogateInInputStream), e;
  }
  willDropParsedChunk() {
    return this.pos > this.bufferWaterline;
  }
  dropParsedChunk() {
    this.willDropParsedChunk() && (this.html = this.html.substring(this.pos), this.lineStartPos -= this.pos, this.droppedBufferSize += this.pos, this.pos = 0, this.lastGapPos = -2, this.gapStack.length = 0);
  }
  write(e, n) {
    this.html.length > 0 ? this.html += e : this.html = e, this.endOfChunkHit = !1, this.lastChunkWritten = n;
  }
  insertHtmlAtCurrentPos(e) {
    this.html = this.html.substring(0, this.pos + 1) + e + this.html.substring(this.pos + 1), this.endOfChunkHit = !1;
  }
  startsWith(e, n) {
    if (this.pos + e.length > this.html.length) {
      return this.endOfChunkHit = !this.lastChunkWritten, !1;
    }
    if (n) {
      return this.html.startsWith(e, this.pos);
    }
    for (let r = 0; r < e.length; r++) {
      if ((this.html.charCodeAt(this.pos + r) | 32) !== e.charCodeAt(r)) {
        return !1;
      }
    }
    return !0;
  }
  peek(e) {
    const n = this.pos + e;
    if (n >= this.html.length) {
      return this.endOfChunkHit = !this.lastChunkWritten, Y.EOF;
    }
    const r = this.html.charCodeAt(n);
    return r === Y.CARRIAGE_RETURN ? Y.LINE_FEED : r;
  }
  advance() {
    if (this.pos++, this.isEol && (this.isEol = !1, this.line++, this.lineStartPos = this.pos), this.pos >= this.html.length) {
      return this.endOfChunkHit = !this.lastChunkWritten, Y.EOF;
    }
    let e = this.html.charCodeAt(this.pos);
    return e === Y.CARRIAGE_RETURN ? (this.isEol = !0, this.skipNextNewLine = !0, Y.LINE_FEED) : e === Y.LINE_FEED && (this.isEol = !0, this.skipNextNewLine) ? (this.line--, this.skipNextNewLine = !1, this._addGap(), this.advance()) : (this.skipNextNewLine = !1, HC(e) && (e = this._processSurrogate(e)), this.handler.onParseError === null || e > 31 && e < 127 || e === Y.LINE_FEED || e === Y.CARRIAGE_RETURN || e > 159 && e < 64976 || this._checkForProblematicCharacters(e), e);
  }
  _checkForProblematicCharacters(e) {
    UC(e) ? this._err(Se.controlCharacterInInputStream) : WC(e) && this._err(Se.noncharacterInInputStream);
  }
  retreat(e) {
    for (this.pos -= e; this.pos < this.lastGapPos;) {
      this.lastGapPos = this.gapStack.pop(), this.pos--;
    }
    this.isEol = !1;
  }
}
var Pt;
(function(t) {
  t[t.CHARACTER = 0] = "CHARACTER", t[t.NULL_CHARACTER = 1] = "NULL_CHARACTER", t[t.WHITESPACE_CHARACTER = 2] = "WHITESPACE_CHARACTER", t[t.START_TAG = 3] = "START_TAG", t[t.END_TAG = 4] = "END_TAG", t[t.COMMENT = 5] = "COMMENT", t[t.DOCTYPE = 6] = "DOCTYPE", t[t.EOF = 7] = "EOF", t[t.HIBERNATION = 8] = "HIBERNATION";
})(Pt || (Pt = {}));
function jC(t, e) {
  for (let n = t.attrs.length - 1; n >= 0; n--) {
    if (t.attrs[n].name === e) {
      return t.attrs[n].value;
    }
  }
  return null;
}
const x9 = new Uint16Array('\u1d41\x3c\u00d5\u0131\u028a\u049d\u057b\u05d0\u0675\u06de\u07a2\u07d6\u080f\u0a4a\u0a91\u0da1\u0e6d\u0f09\u0f26\u10ca\u1228\u12e1\u1415\u149d\u14c3\u14df\u1525\x00\x00\x00\x00\x00\x00\u156b\u16cd\u198d\u1c12\u1ddd\u1f7e\u2060\u21b0\u228d\u23c0\u23fb\u2442\u2824\u2912\u2d08\u2e48\u2fce\u3016\u32ba\u3639\u37ac\u38fe\u3a28\u3a71\u3ae0\u3b2e\u0800EMabcfglmnoprstu\\bfms\u007f\u0084\u008b\u0090\u0095\u0098\u00a6\u00b3\u00b9\u00c8\u00cflig\u803b\u00c6\u40c6P\u803b\x26\u4026cute\u803b\u00c1\u40c1reve;\u4102\u0100iyx}rc\u803b\u00c2\u40c2;\u4410r;\uc000\ud835\udd04rave\u803b\u00c0\u40c0pha;\u4391acr;\u4100d;\u6a53\u0100gp\u009d\u00a1on;\u4104f;\uc000\ud835\udd38plyFunction;\u6061ing\u803b\u00c5\u40c5\u0100cs\u00be\u00c3r;\uc000\ud835\udc9cign;\u6254ilde\u803b\u00c3\u40c3ml\u803b\u00c4\u40c4\u0400aceforsu\u00e5\u00fb\u00fe\u0117\u011c\u0122\u0127\u012a\u0100cr\u00ea\u00f2kslash;\u6216\u0176\u00f6\u00f8;\u6ae7ed;\u6306y;\u4411\u0180crt\u0105\u010b\u0114ause;\u6235noullis;\u612ca;\u4392r;\uc000\ud835\udd05pf;\uc000\ud835\udd39eve;\u42d8c\u00f2\u0113mpeq;\u624e\u0700HOacdefhilorsu\u014d\u0151\u0156\u0180\u019e\u01a2\u01b5\u01b7\u01ba\u01dc\u0215\u0273\u0278\u027ecy;\u4427PY\u803b\u00a9\u40a9\u0180cpy\u015d\u0162\u017aute;\u4106\u0100;i\u0167\u0168\u62d2talDifferentialD;\u6145leys;\u612d\u0200aeio\u0189\u018e\u0194\u0198ron;\u410cdil\u803b\u00c7\u40c7rc;\u4108nint;\u6230ot;\u410a\u0100dn\u01a7\u01adilla;\u40b8terDot;\u40b7\u00f2\u017fi;\u43a7rcle\u0200DMPT\u01c7\u01cb\u01d1\u01d6ot;\u6299inus;\u6296lus;\u6295imes;\u6297o\u0100cs\u01e2\u01f8kwiseContourIntegral;\u6232eCurly\u0100DQ\u0203\u020foubleQuote;\u601duote;\u6019\u0200lnpu\u021e\u0228\u0247\u0255on\u0100;e\u0225\u0226\u6237;\u6a74\u0180git\u022f\u0236\u023aruent;\u6261nt;\u622fourIntegral;\u622e\u0100fr\u024c\u024e;\u6102oduct;\u6210nterClockwiseContourIntegral;\u6233oss;\u6a2fcr;\uc000\ud835\udc9ep\u0100;C\u0284\u0285\u62d3ap;\u624d\u0580DJSZacefios\u02a0\u02ac\u02b0\u02b4\u02b8\u02cb\u02d7\u02e1\u02e6\u0333\u048d\u0100;o\u0179\u02a5trahd;\u6911cy;\u4402cy;\u4405cy;\u440f\u0180grs\u02bf\u02c4\u02c7ger;\u6021r;\u61a1hv;\u6ae4\u0100ay\u02d0\u02d5ron;\u410e;\u4414l\u0100;t\u02dd\u02de\u6207a;\u4394r;\uc000\ud835\udd07\u0100af\u02eb\u0327\u0100cm\u02f0\u0322ritical\u0200ADGT\u0300\u0306\u0316\u031ccute;\u40b4o\u0174\u030b\u030d;\u42d9bleAcute;\u42ddrave;\u4060ilde;\u42dcond;\u62c4ferentialD;\u6146\u0470\u033d\x00\x00\x00\u0342\u0354\x00\u0405f;\uc000\ud835\udd3b\u0180;DE\u0348\u0349\u034d\u40a8ot;\u60dcqual;\u6250ble\u0300CDLRUV\u0363\u0372\u0382\u03cf\u03e2\u03f8ontourIntegra\u00ec\u0239o\u0274\u0379\x00\x00\u037b\u00bb\u0349nArrow;\u61d3\u0100eo\u0387\u03a4ft\u0180ART\u0390\u0396\u03a1rrow;\u61d0ightArrow;\u61d4e\u00e5\u02cang\u0100LR\u03ab\u03c4eft\u0100AR\u03b3\u03b9rrow;\u67f8ightArrow;\u67faightArrow;\u67f9ight\u0100AT\u03d8\u03derrow;\u61d2ee;\u62a8p\u0241\u03e9\x00\x00\u03efrrow;\u61d1ownArrow;\u61d5erticalBar;\u6225n\u0300ABLRTa\u0412\u042a\u0430\u045e\u047f\u037crrow\u0180;BU\u041d\u041e\u0422\u6193ar;\u6913pArrow;\u61f5reve;\u4311eft\u02d2\u043a\x00\u0446\x00\u0450ightVector;\u6950eeVector;\u695eector\u0100;B\u0459\u045a\u61bdar;\u6956ight\u01d4\u0467\x00\u0471eeVector;\u695fector\u0100;B\u047a\u047b\u61c1ar;\u6957ee\u0100;A\u0486\u0487\u62a4rrow;\u61a7\u0100ct\u0492\u0497r;\uc000\ud835\udc9frok;\u4110\u0800NTacdfglmopqstux\u04bd\u04c0\u04c4\u04cb\u04de\u04e2\u04e7\u04ee\u04f5\u0521\u052f\u0536\u0552\u055d\u0560\u0565G;\u414aH\u803b\u00d0\u40d0cute\u803b\u00c9\u40c9\u0180aiy\u04d2\u04d7\u04dcron;\u411arc\u803b\u00ca\u40ca;\u442dot;\u4116r;\uc000\ud835\udd08rave\u803b\u00c8\u40c8ement;\u6208\u0100ap\u04fa\u04fecr;\u4112ty\u0253\u0506\x00\x00\u0512mallSquare;\u65fberySmallSquare;\u65ab\u0100gp\u0526\u052aon;\u4118f;\uc000\ud835\udd3csilon;\u4395u\u0100ai\u053c\u0549l\u0100;T\u0542\u0543\u6a75ilde;\u6242librium;\u61cc\u0100ci\u0557\u055ar;\u6130m;\u6a73a;\u4397ml\u803b\u00cb\u40cb\u0100ip\u056a\u056fsts;\u6203onentialE;\u6147\u0280cfios\u0585\u0588\u058d\u05b2\u05ccy;\u4424r;\uc000\ud835\udd09lled\u0253\u0597\x00\x00\u05a3mallSquare;\u65fcerySmallSquare;\u65aa\u0370\u05ba\x00\u05bf\x00\x00\u05c4f;\uc000\ud835\udd3dAll;\u6200riertrf;\u6131c\u00f2\u05cb\u0600JTabcdfgorst\u05e8\u05ec\u05ef\u05fa\u0600\u0612\u0616\u061b\u061d\u0623\u066c\u0672cy;\u4403\u803b\x3e\u403emma\u0100;d\u05f7\u05f8\u4393;\u43dcreve;\u411e\u0180eiy\u0607\u060c\u0610dil;\u4122rc;\u411c;\u4413ot;\u4120r;\uc000\ud835\udd0a;\u62d9pf;\uc000\ud835\udd3eeater\u0300EFGLST\u0635\u0644\u064e\u0656\u065b\u0666qual\u0100;L\u063e\u063f\u6265ess;\u62dbullEqual;\u6267reater;\u6aa2ess;\u6277lantEqual;\u6a7eilde;\u6273cr;\uc000\ud835\udca2;\u626b\u0400Aacfiosu\u0685\u068b\u0696\u069b\u069e\u06aa\u06be\u06caRDcy;\u442a\u0100ct\u0690\u0694ek;\u42c7;\u405eirc;\u4124r;\u610clbertSpace;\u610b\u01f0\u06af\x00\u06b2f;\u610dizontalLine;\u6500\u0100ct\u06c3\u06c5\u00f2\u06a9rok;\u4126mp\u0144\u06d0\u06d8ownHum\u00f0\u012fqual;\u624f\u0700EJOacdfgmnostu\u06fa\u06fe\u0703\u0707\u070e\u071a\u071e\u0721\u0728\u0744\u0778\u078b\u078f\u0795cy;\u4415lig;\u4132cy;\u4401cute\u803b\u00cd\u40cd\u0100iy\u0713\u0718rc\u803b\u00ce\u40ce;\u4418ot;\u4130r;\u6111rave\u803b\u00cc\u40cc\u0180;ap\u0720\u072f\u073f\u0100cg\u0734\u0737r;\u412ainaryI;\u6148lie\u00f3\u03dd\u01f4\u0749\x00\u0762\u0100;e\u074d\u074e\u622c\u0100gr\u0753\u0758ral;\u622bsection;\u62c2isible\u0100CT\u076c\u0772omma;\u6063imes;\u6062\u0180gpt\u077f\u0783\u0788on;\u412ef;\uc000\ud835\udd40a;\u4399cr;\u6110ilde;\u4128\u01eb\u079a\x00\u079ecy;\u4406l\u803b\u00cf\u40cf\u0280cfosu\u07ac\u07b7\u07bc\u07c2\u07d0\u0100iy\u07b1\u07b5rc;\u4134;\u4419r;\uc000\ud835\udd0dpf;\uc000\ud835\udd41\u01e3\u07c7\x00\u07ccr;\uc000\ud835\udca5rcy;\u4408kcy;\u4404\u0380HJacfos\u07e4\u07e8\u07ec\u07f1\u07fd\u0802\u0808cy;\u4425cy;\u440cppa;\u439a\u0100ey\u07f6\u07fbdil;\u4136;\u441ar;\uc000\ud835\udd0epf;\uc000\ud835\udd42cr;\uc000\ud835\udca6\u0580JTaceflmost\u0825\u0829\u082c\u0850\u0863\u09b3\u09b8\u09c7\u09cd\u0a37\u0a47cy;\u4409\u803b\x3c\u403c\u0280cmnpr\u0837\u083c\u0841\u0844\u084dute;\u4139bda;\u439bg;\u67ealacetrf;\u6112r;\u619e\u0180aey\u0857\u085c\u0861ron;\u413ddil;\u413b;\u441b\u0100fs\u0868\u0970t\u0500ACDFRTUVar\u087e\u08a9\u08b1\u08e0\u08e6\u08fc\u092f\u095b\u0390\u096a\u0100nr\u0883\u088fgleBracket;\u67e8row\u0180;BR\u0899\u089a\u089e\u6190ar;\u61e4ightArrow;\u61c6eiling;\u6308o\u01f5\u08b7\x00\u08c3bleBracket;\u67e6n\u01d4\u08c8\x00\u08d2eeVector;\u6961ector\u0100;B\u08db\u08dc\u61c3ar;\u6959loor;\u630aight\u0100AV\u08ef\u08f5rrow;\u6194ector;\u694e\u0100er\u0901\u0917e\u0180;AV\u0909\u090a\u0910\u62a3rrow;\u61a4ector;\u695aiangle\u0180;BE\u0924\u0925\u0929\u62b2ar;\u69cfqual;\u62b4p\u0180DTV\u0937\u0942\u094cownVector;\u6951eeVector;\u6960ector\u0100;B\u0956\u0957\u61bfar;\u6958ector\u0100;B\u0965\u0966\u61bcar;\u6952ight\u00e1\u039cs\u0300EFGLST\u097e\u098b\u0995\u099d\u09a2\u09adqualGreater;\u62daullEqual;\u6266reater;\u6276ess;\u6aa1lantEqual;\u6a7dilde;\u6272r;\uc000\ud835\udd0f\u0100;e\u09bd\u09be\u62d8ftarrow;\u61daidot;\u413f\u0180npw\u09d4\u0a16\u0a1bg\u0200LRlr\u09de\u09f7\u0a02\u0a10eft\u0100AR\u09e6\u09ecrrow;\u67f5ightArrow;\u67f7ightArrow;\u67f6eft\u0100ar\u03b3\u0a0aight\u00e1\u03bfight\u00e1\u03caf;\uc000\ud835\udd43er\u0100LR\u0a22\u0a2ceftArrow;\u6199ightArrow;\u6198\u0180cht\u0a3e\u0a40\u0a42\u00f2\u084c;\u61b0rok;\u4141;\u626a\u0400acefiosu\u0a5a\u0a5d\u0a60\u0a77\u0a7c\u0a85\u0a8b\u0a8ep;\u6905y;\u441c\u0100dl\u0a65\u0a6fiumSpace;\u605flintrf;\u6133r;\uc000\ud835\udd10nusPlus;\u6213pf;\uc000\ud835\udd44c\u00f2\u0a76;\u439c\u0480Jacefostu\u0aa3\u0aa7\u0aad\u0ac0\u0b14\u0b19\u0d91\u0d97\u0d9ecy;\u440acute;\u4143\u0180aey\u0ab4\u0ab9\u0aberon;\u4147dil;\u4145;\u441d\u0180gsw\u0ac7\u0af0\u0b0eative\u0180MTV\u0ad3\u0adf\u0ae8ediumSpace;\u600bhi\u0100cn\u0ae6\u0ad8\u00eb\u0ad9eryThi\u00ee\u0ad9ted\u0100GL\u0af8\u0b06reaterGreate\u00f2\u0673essLes\u00f3\u0a48Line;\u400ar;\uc000\ud835\udd11\u0200Bnpt\u0b22\u0b28\u0b37\u0b3areak;\u6060BreakingSpace;\u40a0f;\u6115\u0680;CDEGHLNPRSTV\u0b55\u0b56\u0b6a\u0b7c\u0ba1\u0beb\u0c04\u0c5e\u0c84\u0ca6\u0cd8\u0d61\u0d85\u6aec\u0100ou\u0b5b\u0b64ngruent;\u6262pCap;\u626doubleVerticalBar;\u6226\u0180lqx\u0b83\u0b8a\u0b9bement;\u6209ual\u0100;T\u0b92\u0b93\u6260ilde;\uc000\u2242\u0338ists;\u6204reater\u0380;EFGLST\u0bb6\u0bb7\u0bbd\u0bc9\u0bd3\u0bd8\u0be5\u626fqual;\u6271ullEqual;\uc000\u2267\u0338reater;\uc000\u226b\u0338ess;\u6279lantEqual;\uc000\u2a7e\u0338ilde;\u6275ump\u0144\u0bf2\u0bfdownHump;\uc000\u224e\u0338qual;\uc000\u224f\u0338e\u0100fs\u0c0a\u0c27tTriangle\u0180;BE\u0c1a\u0c1b\u0c21\u62eaar;\uc000\u29cf\u0338qual;\u62ecs\u0300;EGLST\u0c35\u0c36\u0c3c\u0c44\u0c4b\u0c58\u626equal;\u6270reater;\u6278ess;\uc000\u226a\u0338lantEqual;\uc000\u2a7d\u0338ilde;\u6274ested\u0100GL\u0c68\u0c79reaterGreater;\uc000\u2aa2\u0338essLess;\uc000\u2aa1\u0338recedes\u0180;ES\u0c92\u0c93\u0c9b\u6280qual;\uc000\u2aaf\u0338lantEqual;\u62e0\u0100ei\u0cab\u0cb9verseElement;\u620cghtTriangle\u0180;BE\u0ccb\u0ccc\u0cd2\u62ebar;\uc000\u29d0\u0338qual;\u62ed\u0100qu\u0cdd\u0d0cuareSu\u0100bp\u0ce8\u0cf9set\u0100;E\u0cf0\u0cf3\uc000\u228f\u0338qual;\u62e2erset\u0100;E\u0d03\u0d06\uc000\u2290\u0338qual;\u62e3\u0180bcp\u0d13\u0d24\u0d4eset\u0100;E\u0d1b\u0d1e\uc000\u2282\u20d2qual;\u6288ceeds\u0200;EST\u0d32\u0d33\u0d3b\u0d46\u6281qual;\uc000\u2ab0\u0338lantEqual;\u62e1ilde;\uc000\u227f\u0338erset\u0100;E\u0d58\u0d5b\uc000\u2283\u20d2qual;\u6289ilde\u0200;EFT\u0d6e\u0d6f\u0d75\u0d7f\u6241qual;\u6244ullEqual;\u6247ilde;\u6249erticalBar;\u6224cr;\uc000\ud835\udca9ilde\u803b\u00d1\u40d1;\u439d\u0700Eacdfgmoprstuv\u0dbd\u0dc2\u0dc9\u0dd5\u0ddb\u0de0\u0de7\u0dfc\u0e02\u0e20\u0e22\u0e32\u0e3f\u0e44lig;\u4152cute\u803b\u00d3\u40d3\u0100iy\u0dce\u0dd3rc\u803b\u00d4\u40d4;\u441eblac;\u4150r;\uc000\ud835\udd12rave\u803b\u00d2\u40d2\u0180aei\u0dee\u0df2\u0df6cr;\u414cga;\u43a9cron;\u439fpf;\uc000\ud835\udd46enCurly\u0100DQ\u0e0e\u0e1aoubleQuote;\u601cuote;\u6018;\u6a54\u0100cl\u0e27\u0e2cr;\uc000\ud835\udcaaash\u803b\u00d8\u40d8i\u016c\u0e37\u0e3cde\u803b\u00d5\u40d5es;\u6a37ml\u803b\u00d6\u40d6er\u0100BP\u0e4b\u0e60\u0100ar\u0e50\u0e53r;\u603eac\u0100ek\u0e5a\u0e5c;\u63deet;\u63b4arenthesis;\u63dc\u0480acfhilors\u0e7f\u0e87\u0e8a\u0e8f\u0e92\u0e94\u0e9d\u0eb0\u0efcrtialD;\u6202y;\u441fr;\uc000\ud835\udd13i;\u43a6;\u43a0usMinus;\u40b1\u0100ip\u0ea2\u0eadncareplan\u00e5\u069df;\u6119\u0200;eio\u0eb9\u0eba\u0ee0\u0ee4\u6abbcedes\u0200;EST\u0ec8\u0ec9\u0ecf\u0eda\u627aqual;\u6aaflantEqual;\u627cilde;\u627eme;\u6033\u0100dp\u0ee9\u0eeeuct;\u620fortion\u0100;a\u0225\u0ef9l;\u621d\u0100ci\u0f01\u0f06r;\uc000\ud835\udcab;\u43a8\u0200Ufos\u0f11\u0f16\u0f1b\u0f1fOT\u803b"\u4022r;\uc000\ud835\udd14pf;\u611acr;\uc000\ud835\udcac\u0600BEacefhiorsu\u0f3e\u0f43\u0f47\u0f60\u0f73\u0fa7\u0faa\u0fad\u1096\u10a9\u10b4\u10bearr;\u6910G\u803b\u00ae\u40ae\u0180cnr\u0f4e\u0f53\u0f56ute;\u4154g;\u67ebr\u0100;t\u0f5c\u0f5d\u61a0l;\u6916\u0180aey\u0f67\u0f6c\u0f71ron;\u4158dil;\u4156;\u4420\u0100;v\u0f78\u0f79\u611cerse\u0100EU\u0f82\u0f99\u0100lq\u0f87\u0f8eement;\u620builibrium;\u61cbpEquilibrium;\u696fr\u00bb\u0f79o;\u43a1ght\u0400ACDFTUVa\u0fc1\u0feb\u0ff3\u1022\u1028\u105b\u1087\u03d8\u0100nr\u0fc6\u0fd2gleBracket;\u67e9row\u0180;BL\u0fdc\u0fdd\u0fe1\u6192ar;\u61e5eftArrow;\u61c4eiling;\u6309o\u01f5\u0ff9\x00\u1005bleBracket;\u67e7n\u01d4\u100a\x00\u1014eeVector;\u695dector\u0100;B\u101d\u101e\u61c2ar;\u6955loor;\u630b\u0100er\u102d\u1043e\u0180;AV\u1035\u1036\u103c\u62a2rrow;\u61a6ector;\u695biangle\u0180;BE\u1050\u1051\u1055\u62b3ar;\u69d0qual;\u62b5p\u0180DTV\u1063\u106e\u1078ownVector;\u694feeVector;\u695cector\u0100;B\u1082\u1083\u61bear;\u6954ector\u0100;B\u1091\u1092\u61c0ar;\u6953\u0100pu\u109b\u109ef;\u611dndImplies;\u6970ightarrow;\u61db\u0100ch\u10b9\u10bcr;\u611b;\u61b1leDelayed;\u69f4\u0680HOacfhimoqstu\u10e4\u10f1\u10f7\u10fd\u1119\u111e\u1151\u1156\u1161\u1167\u11b5\u11bb\u11bf\u0100Cc\u10e9\u10eeHcy;\u4429y;\u4428FTcy;\u442ccute;\u415a\u0280;aeiy\u1108\u1109\u110e\u1113\u1117\u6abcron;\u4160dil;\u415erc;\u415c;\u4421r;\uc000\ud835\udd16ort\u0200DLRU\u112a\u1134\u113e\u1149ownArrow\u00bb\u041eeftArrow\u00bb\u089aightArrow\u00bb\u0fddpArrow;\u6191gma;\u43a3allCircle;\u6218pf;\uc000\ud835\udd4a\u0272\u116d\x00\x00\u1170t;\u621aare\u0200;ISU\u117b\u117c\u1189\u11af\u65a1ntersection;\u6293u\u0100bp\u118f\u119eset\u0100;E\u1197\u1198\u628fqual;\u6291erset\u0100;E\u11a8\u11a9\u6290qual;\u6292nion;\u6294cr;\uc000\ud835\udcaear;\u62c6\u0200bcmp\u11c8\u11db\u1209\u120b\u0100;s\u11cd\u11ce\u62d0et\u0100;E\u11cd\u11d5qual;\u6286\u0100ch\u11e0\u1205eeds\u0200;EST\u11ed\u11ee\u11f4\u11ff\u627bqual;\u6ab0lantEqual;\u627dilde;\u627fTh\u00e1\u0f8c;\u6211\u0180;es\u1212\u1213\u1223\u62d1rset\u0100;E\u121c\u121d\u6283qual;\u6287et\u00bb\u1213\u0580HRSacfhiors\u123e\u1244\u1249\u1255\u125e\u1271\u1276\u129f\u12c2\u12c8\u12d1ORN\u803b\u00de\u40deADE;\u6122\u0100Hc\u124e\u1252cy;\u440by;\u4426\u0100bu\u125a\u125c;\u4009;\u43a4\u0180aey\u1265\u126a\u126fron;\u4164dil;\u4162;\u4422r;\uc000\ud835\udd17\u0100ei\u127b\u1289\u01f2\u1280\x00\u1287efore;\u6234a;\u4398\u0100cn\u128e\u1298kSpace;\uc000\u205f\u200aSpace;\u6009lde\u0200;EFT\u12ab\u12ac\u12b2\u12bc\u623cqual;\u6243ullEqual;\u6245ilde;\u6248pf;\uc000\ud835\udd4bipleDot;\u60db\u0100ct\u12d6\u12dbr;\uc000\ud835\udcafrok;\u4166\u0ae1\u12f7\u130e\u131a\u1326\x00\u132c\u1331\x00\x00\x00\x00\x00\u1338\u133d\u1377\u1385\x00\u13ff\u1404\u140a\u1410\u0100cr\u12fb\u1301ute\u803b\u00da\u40dar\u0100;o\u1307\u1308\u619fcir;\u6949r\u01e3\u1313\x00\u1316y;\u440eve;\u416c\u0100iy\u131e\u1323rc\u803b\u00db\u40db;\u4423blac;\u4170r;\uc000\ud835\udd18rave\u803b\u00d9\u40d9acr;\u416a\u0100di\u1341\u1369er\u0100BP\u1348\u135d\u0100ar\u134d\u1350r;\u405fac\u0100ek\u1357\u1359;\u63dfet;\u63b5arenthesis;\u63ddon\u0100;P\u1370\u1371\u62c3lus;\u628e\u0100gp\u137b\u137fon;\u4172f;\uc000\ud835\udd4c\u0400ADETadps\u1395\u13ae\u13b8\u13c4\u03e8\u13d2\u13d7\u13f3rrow\u0180;BD\u1150\u13a0\u13a4ar;\u6912ownArrow;\u61c5ownArrow;\u6195quilibrium;\u696eee\u0100;A\u13cb\u13cc\u62a5rrow;\u61a5own\u00e1\u03f3er\u0100LR\u13de\u13e8eftArrow;\u6196ightArrow;\u6197i\u0100;l\u13f9\u13fa\u43d2on;\u43a5ing;\u416ecr;\uc000\ud835\udcb0ilde;\u4168ml\u803b\u00dc\u40dc\u0480Dbcdefosv\u1427\u142c\u1430\u1433\u143e\u1485\u148a\u1490\u1496ash;\u62abar;\u6aeby;\u4412ash\u0100;l\u143b\u143c\u62a9;\u6ae6\u0100er\u1443\u1445;\u62c1\u0180bty\u144c\u1450\u147aar;\u6016\u0100;i\u144f\u1455cal\u0200BLST\u1461\u1465\u146a\u1474ar;\u6223ine;\u407ceparator;\u6758ilde;\u6240ThinSpace;\u600ar;\uc000\ud835\udd19pf;\uc000\ud835\udd4dcr;\uc000\ud835\udcb1dash;\u62aa\u0280cefos\u14a7\u14ac\u14b1\u14b6\u14bcirc;\u4174dge;\u62c0r;\uc000\ud835\udd1apf;\uc000\ud835\udd4ecr;\uc000\ud835\udcb2\u0200fios\u14cb\u14d0\u14d2\u14d8r;\uc000\ud835\udd1b;\u439epf;\uc000\ud835\udd4fcr;\uc000\ud835\udcb3\u0480AIUacfosu\u14f1\u14f5\u14f9\u14fd\u1504\u150f\u1514\u151a\u1520cy;\u442fcy;\u4407cy;\u442ecute\u803b\u00dd\u40dd\u0100iy\u1509\u150drc;\u4176;\u442br;\uc000\ud835\udd1cpf;\uc000\ud835\udd50cr;\uc000\ud835\udcb4ml;\u4178\u0400Hacdefos\u1535\u1539\u153f\u154b\u154f\u155d\u1560\u1564cy;\u4416cute;\u4179\u0100ay\u1544\u1549ron;\u417d;\u4417ot;\u417b\u01f2\u1554\x00\u155boWidt\u00e8\u0ad9a;\u4396r;\u6128pf;\u6124cr;\uc000\ud835\udcb5\u0be1\u1583\u158a\u1590\x00\u15b0\u15b6\u15bf\x00\x00\x00\x00\u15c6\u15db\u15eb\u165f\u166d\x00\u1695\u169b\u16b2\u16b9\x00\u16becute\u803b\u00e1\u40e1reve;\u4103\u0300;Ediuy\u159c\u159d\u15a1\u15a3\u15a8\u15ad\u623e;\uc000\u223e\u0333;\u623frc\u803b\u00e2\u40e2te\u80bb\u00b4\u0306;\u4430lig\u803b\u00e6\u40e6\u0100;r\u00b2\u15ba;\uc000\ud835\udd1erave\u803b\u00e0\u40e0\u0100ep\u15ca\u15d6\u0100fp\u15cf\u15d4sym;\u6135\u00e8\u15d3ha;\u43b1\u0100ap\u15dfc\u0100cl\u15e4\u15e7r;\u4101g;\u6a3f\u0264\u15f0\x00\x00\u160a\u0280;adsv\u15fa\u15fb\u15ff\u1601\u1607\u6227nd;\u6a55;\u6a5clope;\u6a58;\u6a5a\u0380;elmrsz\u1618\u1619\u161b\u161e\u163f\u164f\u1659\u6220;\u69a4e\u00bb\u1619sd\u0100;a\u1625\u1626\u6221\u0461\u1630\u1632\u1634\u1636\u1638\u163a\u163c\u163e;\u69a8;\u69a9;\u69aa;\u69ab;\u69ac;\u69ad;\u69ae;\u69aft\u0100;v\u1645\u1646\u621fb\u0100;d\u164c\u164d\u62be;\u699d\u0100pt\u1654\u1657h;\u6222\u00bb\u00b9arr;\u637c\u0100gp\u1663\u1667on;\u4105f;\uc000\ud835\udd52\u0380;Eaeiop\u12c1\u167b\u167d\u1682\u1684\u1687\u168a;\u6a70cir;\u6a6f;\u624ad;\u624bs;\u4027rox\u0100;e\u12c1\u1692\u00f1\u1683ing\u803b\u00e5\u40e5\u0180cty\u16a1\u16a6\u16a8r;\uc000\ud835\udcb6;\u402amp\u0100;e\u12c1\u16af\u00f1\u0288ilde\u803b\u00e3\u40e3ml\u803b\u00e4\u40e4\u0100ci\u16c2\u16c8onin\u00f4\u0272nt;\u6a11\u0800Nabcdefiklnoprsu\u16ed\u16f1\u1730\u173c\u1743\u1748\u1778\u177d\u17e0\u17e6\u1839\u1850\u170d\u193d\u1948\u1970ot;\u6aed\u0100cr\u16f6\u171ek\u0200ceps\u1700\u1705\u170d\u1713ong;\u624cpsilon;\u43f6rime;\u6035im\u0100;e\u171a\u171b\u623dq;\u62cd\u0176\u1722\u1726ee;\u62bded\u0100;g\u172c\u172d\u6305e\u00bb\u172drk\u0100;t\u135c\u1737brk;\u63b6\u0100oy\u1701\u1741;\u4431quo;\u601e\u0280cmprt\u1753\u175b\u1761\u1764\u1768aus\u0100;e\u010a\u0109ptyv;\u69b0s\u00e9\u170cno\u00f5\u0113\u0180ahw\u176f\u1771\u1773;\u43b2;\u6136een;\u626cr;\uc000\ud835\udd1fg\u0380costuvw\u178d\u179d\u17b3\u17c1\u17d5\u17db\u17de\u0180aiu\u1794\u1796\u179a\u00f0\u0760rc;\u65efp\u00bb\u1371\u0180dpt\u17a4\u17a8\u17adot;\u6a00lus;\u6a01imes;\u6a02\u0271\u17b9\x00\x00\u17becup;\u6a06ar;\u6605riangle\u0100du\u17cd\u17d2own;\u65bdp;\u65b3plus;\u6a04e\u00e5\u1444\u00e5\u14adarow;\u690d\u0180ako\u17ed\u1826\u1835\u0100cn\u17f2\u1823k\u0180lst\u17fa\u05ab\u1802ozenge;\u69ebriangle\u0200;dlr\u1812\u1813\u1818\u181d\u65b4own;\u65beeft;\u65c2ight;\u65b8k;\u6423\u01b1\u182b\x00\u1833\u01b2\u182f\x00\u1831;\u6592;\u65914;\u6593ck;\u6588\u0100eo\u183e\u184d\u0100;q\u1843\u1846\uc000\x3d\u20e5uiv;\uc000\u2261\u20e5t;\u6310\u0200ptwx\u1859\u185e\u1867\u186cf;\uc000\ud835\udd53\u0100;t\u13cb\u1863om\u00bb\u13cctie;\u62c8\u0600DHUVbdhmptuv\u1885\u1896\u18aa\u18bb\u18d7\u18db\u18ec\u18ff\u1905\u190a\u1910\u1921\u0200LRlr\u188e\u1890\u1892\u1894;\u6557;\u6554;\u6556;\u6553\u0280;DUdu\u18a1\u18a2\u18a4\u18a6\u18a8\u6550;\u6566;\u6569;\u6564;\u6567\u0200LRlr\u18b3\u18b5\u18b7\u18b9;\u655d;\u655a;\u655c;\u6559\u0380;HLRhlr\u18ca\u18cb\u18cd\u18cf\u18d1\u18d3\u18d5\u6551;\u656c;\u6563;\u6560;\u656b;\u6562;\u655fox;\u69c9\u0200LRlr\u18e4\u18e6\u18e8\u18ea;\u6555;\u6552;\u6510;\u650c\u0280;DUdu\u06bd\u18f7\u18f9\u18fb\u18fd;\u6565;\u6568;\u652c;\u6534inus;\u629flus;\u629eimes;\u62a0\u0200LRlr\u1919\u191b\u191d\u191f;\u655b;\u6558;\u6518;\u6514\u0380;HLRhlr\u1930\u1931\u1933\u1935\u1937\u1939\u193b\u6502;\u656a;\u6561;\u655e;\u653c;\u6524;\u651c\u0100ev\u0123\u1942bar\u803b\u00a6\u40a6\u0200ceio\u1951\u1956\u195a\u1960r;\uc000\ud835\udcb7mi;\u604fm\u0100;e\u171a\u171cl\u0180;bh\u1968\u1969\u196b\u405c;\u69c5sub;\u67c8\u016c\u1974\u197el\u0100;e\u1979\u197a\u6022t\u00bb\u197ap\u0180;Ee\u012f\u1985\u1987;\u6aae\u0100;q\u06dc\u06db\u0ce1\u19a7\x00\u19e8\u1a11\u1a15\u1a32\x00\u1a37\u1a50\x00\x00\u1ab4\x00\x00\u1ac1\x00\x00\u1b21\u1b2e\u1b4d\u1b52\x00\u1bfd\x00\u1c0c\u0180cpr\u19ad\u19b2\u19ddute;\u4107\u0300;abcds\u19bf\u19c0\u19c4\u19ca\u19d5\u19d9\u6229nd;\u6a44rcup;\u6a49\u0100au\u19cf\u19d2p;\u6a4bp;\u6a47ot;\u6a40;\uc000\u2229\ufe00\u0100eo\u19e2\u19e5t;\u6041\u00ee\u0693\u0200aeiu\u19f0\u19fb\u1a01\u1a05\u01f0\u19f5\x00\u19f8s;\u6a4don;\u410ddil\u803b\u00e7\u40e7rc;\u4109ps\u0100;s\u1a0c\u1a0d\u6a4cm;\u6a50ot;\u410b\u0180dmn\u1a1b\u1a20\u1a26il\u80bb\u00b8\u01adptyv;\u69b2t\u8100\u00a2;e\u1a2d\u1a2e\u40a2r\u00e4\u01b2r;\uc000\ud835\udd20\u0180cei\u1a3d\u1a40\u1a4dy;\u4447ck\u0100;m\u1a47\u1a48\u6713ark\u00bb\u1a48;\u43c7r\u0380;Ecefms\u1a5f\u1a60\u1a62\u1a6b\u1aa4\u1aaa\u1aae\u65cb;\u69c3\u0180;el\u1a69\u1a6a\u1a6d\u42c6q;\u6257e\u0261\u1a74\x00\x00\u1a88rrow\u0100lr\u1a7c\u1a81eft;\u61baight;\u61bb\u0280RSacd\u1a92\u1a94\u1a96\u1a9a\u1a9f\u00bb\u0f47;\u64c8st;\u629birc;\u629aash;\u629dnint;\u6a10id;\u6aefcir;\u69c2ubs\u0100;u\u1abb\u1abc\u6663it\u00bb\u1abc\u02ec\u1ac7\u1ad4\u1afa\x00\u1b0aon\u0100;e\u1acd\u1ace\u403a\u0100;q\u00c7\u00c6\u026d\u1ad9\x00\x00\u1ae2a\u0100;t\u1ade\u1adf\u402c;\u4040\u0180;fl\u1ae8\u1ae9\u1aeb\u6201\u00ee\u1160e\u0100mx\u1af1\u1af6ent\u00bb\u1ae9e\u00f3\u024d\u01e7\u1afe\x00\u1b07\u0100;d\u12bb\u1b02ot;\u6a6dn\u00f4\u0246\u0180fry\u1b10\u1b14\u1b17;\uc000\ud835\udd54o\u00e4\u0254\u8100\u00a9;s\u0155\u1b1dr;\u6117\u0100ao\u1b25\u1b29rr;\u61b5ss;\u6717\u0100cu\u1b32\u1b37r;\uc000\ud835\udcb8\u0100bp\u1b3c\u1b44\u0100;e\u1b41\u1b42\u6acf;\u6ad1\u0100;e\u1b49\u1b4a\u6ad0;\u6ad2dot;\u62ef\u0380delprvw\u1b60\u1b6c\u1b77\u1b82\u1bac\u1bd4\u1bf9arr\u0100lr\u1b68\u1b6a;\u6938;\u6935\u0270\u1b72\x00\x00\u1b75r;\u62dec;\u62dfarr\u0100;p\u1b7f\u1b80\u61b6;\u693d\u0300;bcdos\u1b8f\u1b90\u1b96\u1ba1\u1ba5\u1ba8\u622arcap;\u6a48\u0100au\u1b9b\u1b9ep;\u6a46p;\u6a4aot;\u628dr;\u6a45;\uc000\u222a\ufe00\u0200alrv\u1bb5\u1bbf\u1bde\u1be3rr\u0100;m\u1bbc\u1bbd\u61b7;\u693cy\u0180evw\u1bc7\u1bd4\u1bd8q\u0270\u1bce\x00\x00\u1bd2re\u00e3\u1b73u\u00e3\u1b75ee;\u62ceedge;\u62cfen\u803b\u00a4\u40a4earrow\u0100lr\u1bee\u1bf3eft\u00bb\u1b80ight\u00bb\u1bbde\u00e4\u1bdd\u0100ci\u1c01\u1c07onin\u00f4\u01f7nt;\u6231lcty;\u632d\u0980AHabcdefhijlorstuwz\u1c38\u1c3b\u1c3f\u1c5d\u1c69\u1c75\u1c8a\u1c9e\u1cac\u1cb7\u1cfb\u1cff\u1d0d\u1d7b\u1d91\u1dab\u1dbb\u1dc6\u1dcdr\u00f2\u0381ar;\u6965\u0200glrs\u1c48\u1c4d\u1c52\u1c54ger;\u6020eth;\u6138\u00f2\u1133h\u0100;v\u1c5a\u1c5b\u6010\u00bb\u090a\u016b\u1c61\u1c67arow;\u690fa\u00e3\u0315\u0100ay\u1c6e\u1c73ron;\u410f;\u4434\u0180;ao\u0332\u1c7c\u1c84\u0100gr\u02bf\u1c81r;\u61catseq;\u6a77\u0180glm\u1c91\u1c94\u1c98\u803b\u00b0\u40b0ta;\u43b4ptyv;\u69b1\u0100ir\u1ca3\u1ca8sht;\u697f;\uc000\ud835\udd21ar\u0100lr\u1cb3\u1cb5\u00bb\u08dc\u00bb\u101e\u0280aegsv\u1cc2\u0378\u1cd6\u1cdc\u1ce0m\u0180;os\u0326\u1cca\u1cd4nd\u0100;s\u0326\u1cd1uit;\u6666amma;\u43ddin;\u62f2\u0180;io\u1ce7\u1ce8\u1cf8\u40f7de\u8100\u00f7;o\u1ce7\u1cf0ntimes;\u62c7n\u00f8\u1cf7cy;\u4452c\u026f\u1d06\x00\x00\u1d0arn;\u631eop;\u630d\u0280lptuw\u1d18\u1d1d\u1d22\u1d49\u1d55lar;\u4024f;\uc000\ud835\udd55\u0280;emps\u030b\u1d2d\u1d37\u1d3d\u1d42q\u0100;d\u0352\u1d33ot;\u6251inus;\u6238lus;\u6214quare;\u62a1blebarwedg\u00e5\u00fan\u0180adh\u112e\u1d5d\u1d67ownarrow\u00f3\u1c83arpoon\u0100lr\u1d72\u1d76ef\u00f4\u1cb4igh\u00f4\u1cb6\u0162\u1d7f\u1d85karo\u00f7\u0f42\u026f\u1d8a\x00\x00\u1d8ern;\u631fop;\u630c\u0180cot\u1d98\u1da3\u1da6\u0100ry\u1d9d\u1da1;\uc000\ud835\udcb9;\u4455l;\u69f6rok;\u4111\u0100dr\u1db0\u1db4ot;\u62f1i\u0100;f\u1dba\u1816\u65bf\u0100ah\u1dc0\u1dc3r\u00f2\u0429a\u00f2\u0fa6angle;\u69a6\u0100ci\u1dd2\u1dd5y;\u445fgrarr;\u67ff\u0900Dacdefglmnopqrstux\u1e01\u1e09\u1e19\u1e38\u0578\u1e3c\u1e49\u1e61\u1e7e\u1ea5\u1eaf\u1ebd\u1ee1\u1f2a\u1f37\u1f44\u1f4e\u1f5a\u0100Do\u1e06\u1d34o\u00f4\u1c89\u0100cs\u1e0e\u1e14ute\u803b\u00e9\u40e9ter;\u6a6e\u0200aioy\u1e22\u1e27\u1e31\u1e36ron;\u411br\u0100;c\u1e2d\u1e2e\u6256\u803b\u00ea\u40ealon;\u6255;\u444dot;\u4117\u0100Dr\u1e41\u1e45ot;\u6252;\uc000\ud835\udd22\u0180;rs\u1e50\u1e51\u1e57\u6a9aave\u803b\u00e8\u40e8\u0100;d\u1e5c\u1e5d\u6a96ot;\u6a98\u0200;ils\u1e6a\u1e6b\u1e72\u1e74\u6a99nters;\u63e7;\u6113\u0100;d\u1e79\u1e7a\u6a95ot;\u6a97\u0180aps\u1e85\u1e89\u1e97cr;\u4113ty\u0180;sv\u1e92\u1e93\u1e95\u6205et\u00bb\u1e93p\u01001;\u1e9d\u1ea4\u0133\u1ea1\u1ea3;\u6004;\u6005\u6003\u0100gs\u1eaa\u1eac;\u414bp;\u6002\u0100gp\u1eb4\u1eb8on;\u4119f;\uc000\ud835\udd56\u0180als\u1ec4\u1ece\u1ed2r\u0100;s\u1eca\u1ecb\u62d5l;\u69e3us;\u6a71i\u0180;lv\u1eda\u1edb\u1edf\u43b5on\u00bb\u1edb;\u43f5\u0200csuv\u1eea\u1ef3\u1f0b\u1f23\u0100io\u1eef\u1e31rc\u00bb\u1e2e\u0269\u1ef9\x00\x00\u1efb\u00ed\u0548ant\u0100gl\u1f02\u1f06tr\u00bb\u1e5dess\u00bb\u1e7a\u0180aei\u1f12\u1f16\u1f1als;\u403dst;\u625fv\u0100;D\u0235\u1f20D;\u6a78parsl;\u69e5\u0100Da\u1f2f\u1f33ot;\u6253rr;\u6971\u0180cdi\u1f3e\u1f41\u1ef8r;\u612fo\u00f4\u0352\u0100ah\u1f49\u1f4b;\u43b7\u803b\u00f0\u40f0\u0100mr\u1f53\u1f57l\u803b\u00eb\u40ebo;\u60ac\u0180cip\u1f61\u1f64\u1f67l;\u4021s\u00f4\u056e\u0100eo\u1f6c\u1f74ctatio\u00ee\u0559nential\u00e5\u0579\u09e1\u1f92\x00\u1f9e\x00\u1fa1\u1fa7\x00\x00\u1fc6\u1fcc\x00\u1fd3\x00\u1fe6\u1fea\u2000\x00\u2008\u205allingdotse\u00f1\u1e44y;\u4444male;\u6640\u0180ilr\u1fad\u1fb3\u1fc1lig;\u8000\ufb03\u0269\u1fb9\x00\x00\u1fbdg;\u8000\ufb00ig;\u8000\ufb04;\uc000\ud835\udd23lig;\u8000\ufb01lig;\uc000fj\u0180alt\u1fd9\u1fdc\u1fe1t;\u666dig;\u8000\ufb02ns;\u65b1of;\u4192\u01f0\u1fee\x00\u1ff3f;\uc000\ud835\udd57\u0100ak\u05bf\u1ff7\u0100;v\u1ffc\u1ffd\u62d4;\u6ad9artint;\u6a0d\u0100ao\u200c\u2055\u0100cs\u2011\u2052\u03b1\u201a\u2030\u2038\u2045\u2048\x00\u2050\u03b2\u2022\u2025\u2027\u202a\u202c\x00\u202e\u803b\u00bd\u40bd;\u6153\u803b\u00bc\u40bc;\u6155;\u6159;\u615b\u01b3\u2034\x00\u2036;\u6154;\u6156\u02b4\u203e\u2041\x00\x00\u2043\u803b\u00be\u40be;\u6157;\u615c5;\u6158\u01b6\u204c\x00\u204e;\u615a;\u615d8;\u615el;\u6044wn;\u6322cr;\uc000\ud835\udcbb\u0880Eabcdefgijlnorstv\u2082\u2089\u209f\u20a5\u20b0\u20b4\u20f0\u20f5\u20fa\u20ff\u2103\u2112\u2138\u0317\u213e\u2152\u219e\u0100;l\u064d\u2087;\u6a8c\u0180cmp\u2090\u2095\u209dute;\u41f5ma\u0100;d\u209c\u1cda\u43b3;\u6a86reve;\u411f\u0100iy\u20aa\u20aerc;\u411d;\u4433ot;\u4121\u0200;lqs\u063e\u0642\u20bd\u20c9\u0180;qs\u063e\u064c\u20c4lan\u00f4\u0665\u0200;cdl\u0665\u20d2\u20d5\u20e5c;\u6aa9ot\u0100;o\u20dc\u20dd\u6a80\u0100;l\u20e2\u20e3\u6a82;\u6a84\u0100;e\u20ea\u20ed\uc000\u22db\ufe00s;\u6a94r;\uc000\ud835\udd24\u0100;g\u0673\u061bmel;\u6137cy;\u4453\u0200;Eaj\u065a\u210c\u210e\u2110;\u6a92;\u6aa5;\u6aa4\u0200Eaes\u211b\u211d\u2129\u2134;\u6269p\u0100;p\u2123\u2124\u6a8arox\u00bb\u2124\u0100;q\u212e\u212f\u6a88\u0100;q\u212e\u211bim;\u62e7pf;\uc000\ud835\udd58\u0100ci\u2143\u2146r;\u610am\u0180;el\u066b\u214e\u2150;\u6a8e;\u6a90\u8300\x3e;cdlqr\u05ee\u2160\u216a\u216e\u2173\u2179\u0100ci\u2165\u2167;\u6aa7r;\u6a7aot;\u62d7Par;\u6995uest;\u6a7c\u0280adels\u2184\u216a\u2190\u0656\u219b\u01f0\u2189\x00\u218epro\u00f8\u209er;\u6978q\u0100lq\u063f\u2196les\u00f3\u2088i\u00ed\u066b\u0100en\u21a3\u21adrtneqq;\uc000\u2269\ufe00\u00c5\u21aa\u0500Aabcefkosy\u21c4\u21c7\u21f1\u21f5\u21fa\u2218\u221d\u222f\u2268\u227dr\u00f2\u03a0\u0200ilmr\u21d0\u21d4\u21d7\u21dbrs\u00f0\u1484f\u00bb\u2024il\u00f4\u06a9\u0100dr\u21e0\u21e4cy;\u444a\u0180;cw\u08f4\u21eb\u21efir;\u6948;\u61adar;\u610firc;\u4125\u0180alr\u2201\u220e\u2213rts\u0100;u\u2209\u220a\u6665it\u00bb\u220alip;\u6026con;\u62b9r;\uc000\ud835\udd25s\u0100ew\u2223\u2229arow;\u6925arow;\u6926\u0280amopr\u223a\u223e\u2243\u225e\u2263rr;\u61fftht;\u623bk\u0100lr\u2249\u2253eftarrow;\u61a9ightarrow;\u61aaf;\uc000\ud835\udd59bar;\u6015\u0180clt\u226f\u2274\u2278r;\uc000\ud835\udcbdas\u00e8\u21f4rok;\u4127\u0100bp\u2282\u2287ull;\u6043hen\u00bb\u1c5b\u0ae1\u22a3\x00\u22aa\x00\u22b8\u22c5\u22ce\x00\u22d5\u22f3\x00\x00\u22f8\u2322\u2367\u2362\u237f\x00\u2386\u23aa\u23b4cute\u803b\u00ed\u40ed\u0180;iy\u0771\u22b0\u22b5rc\u803b\u00ee\u40ee;\u4438\u0100cx\u22bc\u22bfy;\u4435cl\u803b\u00a1\u40a1\u0100fr\u039f\u22c9;\uc000\ud835\udd26rave\u803b\u00ec\u40ec\u0200;ino\u073e\u22dd\u22e9\u22ee\u0100in\u22e2\u22e6nt;\u6a0ct;\u622dfin;\u69dcta;\u6129lig;\u4133\u0180aop\u22fe\u231a\u231d\u0180cgt\u2305\u2308\u2317r;\u412b\u0180elp\u071f\u230f\u2313in\u00e5\u078ear\u00f4\u0720h;\u4131f;\u62b7ed;\u41b5\u0280;cfot\u04f4\u232c\u2331\u233d\u2341are;\u6105in\u0100;t\u2338\u2339\u621eie;\u69dddo\u00f4\u2319\u0280;celp\u0757\u234c\u2350\u235b\u2361al;\u62ba\u0100gr\u2355\u2359er\u00f3\u1563\u00e3\u234darhk;\u6a17rod;\u6a3c\u0200cgpt\u236f\u2372\u2376\u237by;\u4451on;\u412ff;\uc000\ud835\udd5aa;\u43b9uest\u803b\u00bf\u40bf\u0100ci\u238a\u238fr;\uc000\ud835\udcben\u0280;Edsv\u04f4\u239b\u239d\u23a1\u04f3;\u62f9ot;\u62f5\u0100;v\u23a6\u23a7\u62f4;\u62f3\u0100;i\u0777\u23aelde;\u4129\u01eb\u23b8\x00\u23bccy;\u4456l\u803b\u00ef\u40ef\u0300cfmosu\u23cc\u23d7\u23dc\u23e1\u23e7\u23f5\u0100iy\u23d1\u23d5rc;\u4135;\u4439r;\uc000\ud835\udd27ath;\u4237pf;\uc000\ud835\udd5b\u01e3\u23ec\x00\u23f1r;\uc000\ud835\udcbfrcy;\u4458kcy;\u4454\u0400acfghjos\u240b\u2416\u2422\u2427\u242d\u2431\u2435\u243bppa\u0100;v\u2413\u2414\u43ba;\u43f0\u0100ey\u241b\u2420dil;\u4137;\u443ar;\uc000\ud835\udd28reen;\u4138cy;\u4445cy;\u445cpf;\uc000\ud835\udd5ccr;\uc000\ud835\udcc0\u0b80ABEHabcdefghjlmnoprstuv\u2470\u2481\u2486\u248d\u2491\u250e\u253d\u255a\u2580\u264e\u265e\u2665\u2679\u267d\u269a\u26b2\u26d8\u275d\u2768\u278b\u27c0\u2801\u2812\u0180art\u2477\u247a\u247cr\u00f2\u09c6\u00f2\u0395ail;\u691barr;\u690e\u0100;g\u0994\u248b;\u6a8bar;\u6962\u0963\u24a5\x00\u24aa\x00\u24b1\x00\x00\x00\x00\x00\u24b5\u24ba\x00\u24c6\u24c8\u24cd\x00\u24f9ute;\u413amptyv;\u69b4ra\u00ee\u084cbda;\u43bbg\u0180;dl\u088e\u24c1\u24c3;\u6991\u00e5\u088e;\u6a85uo\u803b\u00ab\u40abr\u0400;bfhlpst\u0899\u24de\u24e6\u24e9\u24eb\u24ee\u24f1\u24f5\u0100;f\u089d\u24e3s;\u691fs;\u691d\u00eb\u2252p;\u61abl;\u6939im;\u6973l;\u61a2\u0180;ae\u24ff\u2500\u2504\u6aabil;\u6919\u0100;s\u2509\u250a\u6aad;\uc000\u2aad\ufe00\u0180abr\u2515\u2519\u251drr;\u690crk;\u6772\u0100ak\u2522\u252cc\u0100ek\u2528\u252a;\u407b;\u405b\u0100es\u2531\u2533;\u698bl\u0100du\u2539\u253b;\u698f;\u698d\u0200aeuy\u2546\u254b\u2556\u2558ron;\u413e\u0100di\u2550\u2554il;\u413c\u00ec\u08b0\u00e2\u2529;\u443b\u0200cqrs\u2563\u2566\u256d\u257da;\u6936uo\u0100;r\u0e19\u1746\u0100du\u2572\u2577har;\u6967shar;\u694bh;\u61b2\u0280;fgqs\u258b\u258c\u0989\u25f3\u25ff\u6264t\u0280ahlrt\u2598\u25a4\u25b7\u25c2\u25e8rrow\u0100;t\u0899\u25a1a\u00e9\u24f6arpoon\u0100du\u25af\u25b4own\u00bb\u045ap\u00bb\u0966eftarrows;\u61c7ight\u0180ahs\u25cd\u25d6\u25derrow\u0100;s\u08f4\u08a7arpoon\u00f3\u0f98quigarro\u00f7\u21f0hreetimes;\u62cb\u0180;qs\u258b\u0993\u25falan\u00f4\u09ac\u0280;cdgs\u09ac\u260a\u260d\u261d\u2628c;\u6aa8ot\u0100;o\u2614\u2615\u6a7f\u0100;r\u261a\u261b\u6a81;\u6a83\u0100;e\u2622\u2625\uc000\u22da\ufe00s;\u6a93\u0280adegs\u2633\u2639\u263d\u2649\u264bppro\u00f8\u24c6ot;\u62d6q\u0100gq\u2643\u2645\u00f4\u0989gt\u00f2\u248c\u00f4\u099bi\u00ed\u09b2\u0180ilr\u2655\u08e1\u265asht;\u697c;\uc000\ud835\udd29\u0100;E\u099c\u2663;\u6a91\u0161\u2669\u2676r\u0100du\u25b2\u266e\u0100;l\u0965\u2673;\u696alk;\u6584cy;\u4459\u0280;acht\u0a48\u2688\u268b\u2691\u2696r\u00f2\u25c1orne\u00f2\u1d08ard;\u696bri;\u65fa\u0100io\u269f\u26a4dot;\u4140ust\u0100;a\u26ac\u26ad\u63b0che\u00bb\u26ad\u0200Eaes\u26bb\u26bd\u26c9\u26d4;\u6268p\u0100;p\u26c3\u26c4\u6a89rox\u00bb\u26c4\u0100;q\u26ce\u26cf\u6a87\u0100;q\u26ce\u26bbim;\u62e6\u0400abnoptwz\u26e9\u26f4\u26f7\u271a\u272f\u2741\u2747\u2750\u0100nr\u26ee\u26f1g;\u67ecr;\u61fdr\u00eb\u08c1g\u0180lmr\u26ff\u270d\u2714eft\u0100ar\u09e6\u2707ight\u00e1\u09f2apsto;\u67fcight\u00e1\u09fdparrow\u0100lr\u2725\u2729ef\u00f4\u24edight;\u61ac\u0180afl\u2736\u2739\u273dr;\u6985;\uc000\ud835\udd5dus;\u6a2dimes;\u6a34\u0161\u274b\u274fst;\u6217\u00e1\u134e\u0180;ef\u2757\u2758\u1800\u65cange\u00bb\u2758ar\u0100;l\u2764\u2765\u4028t;\u6993\u0280achmt\u2773\u2776\u277c\u2785\u2787r\u00f2\u08a8orne\u00f2\u1d8car\u0100;d\u0f98\u2783;\u696d;\u600eri;\u62bf\u0300achiqt\u2798\u279d\u0a40\u27a2\u27ae\u27bbquo;\u6039r;\uc000\ud835\udcc1m\u0180;eg\u09b2\u27aa\u27ac;\u6a8d;\u6a8f\u0100bu\u252a\u27b3o\u0100;r\u0e1f\u27b9;\u601arok;\u4142\u8400\x3c;cdhilqr\u082b\u27d2\u2639\u27dc\u27e0\u27e5\u27ea\u27f0\u0100ci\u27d7\u27d9;\u6aa6r;\u6a79re\u00e5\u25f2mes;\u62c9arr;\u6976uest;\u6a7b\u0100Pi\u27f5\u27f9ar;\u6996\u0180;ef\u2800\u092d\u181b\u65c3r\u0100du\u2807\u280dshar;\u694ahar;\u6966\u0100en\u2817\u2821rtneqq;\uc000\u2268\ufe00\u00c5\u281e\u0700Dacdefhilnopsu\u2840\u2845\u2882\u288e\u2893\u28a0\u28a5\u28a8\u28da\u28e2\u28e4\u0a83\u28f3\u2902Dot;\u623a\u0200clpr\u284e\u2852\u2863\u287dr\u803b\u00af\u40af\u0100et\u2857\u2859;\u6642\u0100;e\u285e\u285f\u6720se\u00bb\u285f\u0100;s\u103b\u2868to\u0200;dlu\u103b\u2873\u2877\u287bow\u00ee\u048cef\u00f4\u090f\u00f0\u13d1ker;\u65ae\u0100oy\u2887\u288cmma;\u6a29;\u443cash;\u6014asuredangle\u00bb\u1626r;\uc000\ud835\udd2ao;\u6127\u0180cdn\u28af\u28b4\u28c9ro\u803b\u00b5\u40b5\u0200;acd\u1464\u28bd\u28c0\u28c4s\u00f4\u16a7ir;\u6af0ot\u80bb\u00b7\u01b5us\u0180;bd\u28d2\u1903\u28d3\u6212\u0100;u\u1d3c\u28d8;\u6a2a\u0163\u28de\u28e1p;\u6adb\u00f2\u2212\u00f0\u0a81\u0100dp\u28e9\u28eeels;\u62a7f;\uc000\ud835\udd5e\u0100ct\u28f8\u28fdr;\uc000\ud835\udcc2pos\u00bb\u159d\u0180;lm\u2909\u290a\u290d\u43bctimap;\u62b8\u0c00GLRVabcdefghijlmoprstuvw\u2942\u2953\u297e\u2989\u2998\u29da\u29e9\u2a15\u2a1a\u2a58\u2a5d\u2a83\u2a95\u2aa4\u2aa8\u2b04\u2b07\u2b44\u2b7f\u2bae\u2c34\u2c67\u2c7c\u2ce9\u0100gt\u2947\u294b;\uc000\u22d9\u0338\u0100;v\u2950\u0bcf\uc000\u226b\u20d2\u0180elt\u295a\u2972\u2976ft\u0100ar\u2961\u2967rrow;\u61cdightarrow;\u61ce;\uc000\u22d8\u0338\u0100;v\u297b\u0c47\uc000\u226a\u20d2ightarrow;\u61cf\u0100Dd\u298e\u2993ash;\u62afash;\u62ae\u0280bcnpt\u29a3\u29a7\u29ac\u29b1\u29ccla\u00bb\u02deute;\u4144g;\uc000\u2220\u20d2\u0280;Eiop\u0d84\u29bc\u29c0\u29c5\u29c8;\uc000\u2a70\u0338d;\uc000\u224b\u0338s;\u4149ro\u00f8\u0d84ur\u0100;a\u29d3\u29d4\u666el\u0100;s\u29d3\u0b38\u01f3\u29df\x00\u29e3p\u80bb\u00a0\u0b37mp\u0100;e\u0bf9\u0c00\u0280aeouy\u29f4\u29fe\u2a03\u2a10\u2a13\u01f0\u29f9\x00\u29fb;\u6a43on;\u4148dil;\u4146ng\u0100;d\u0d7e\u2a0aot;\uc000\u2a6d\u0338p;\u6a42;\u443dash;\u6013\u0380;Aadqsx\u0b92\u2a29\u2a2d\u2a3b\u2a41\u2a45\u2a50rr;\u61d7r\u0100hr\u2a33\u2a36k;\u6924\u0100;o\u13f2\u13f0ot;\uc000\u2250\u0338ui\u00f6\u0b63\u0100ei\u2a4a\u2a4ear;\u6928\u00ed\u0b98ist\u0100;s\u0ba0\u0b9fr;\uc000\ud835\udd2b\u0200Eest\u0bc5\u2a66\u2a79\u2a7c\u0180;qs\u0bbc\u2a6d\u0be1\u0180;qs\u0bbc\u0bc5\u2a74lan\u00f4\u0be2i\u00ed\u0bea\u0100;r\u0bb6\u2a81\u00bb\u0bb7\u0180Aap\u2a8a\u2a8d\u2a91r\u00f2\u2971rr;\u61aear;\u6af2\u0180;sv\u0f8d\u2a9c\u0f8c\u0100;d\u2aa1\u2aa2\u62fc;\u62facy;\u445a\u0380AEadest\u2ab7\u2aba\u2abe\u2ac2\u2ac5\u2af6\u2af9r\u00f2\u2966;\uc000\u2266\u0338rr;\u619ar;\u6025\u0200;fqs\u0c3b\u2ace\u2ae3\u2aeft\u0100ar\u2ad4\u2ad9rro\u00f7\u2ac1ightarro\u00f7\u2a90\u0180;qs\u0c3b\u2aba\u2aealan\u00f4\u0c55\u0100;s\u0c55\u2af4\u00bb\u0c36i\u00ed\u0c5d\u0100;r\u0c35\u2afei\u0100;e\u0c1a\u0c25i\u00e4\u0d90\u0100pt\u2b0c\u2b11f;\uc000\ud835\udd5f\u8180\u00ac;in\u2b19\u2b1a\u2b36\u40acn\u0200;Edv\u0b89\u2b24\u2b28\u2b2e;\uc000\u22f9\u0338ot;\uc000\u22f5\u0338\u01e1\u0b89\u2b33\u2b35;\u62f7;\u62f6i\u0100;v\u0cb8\u2b3c\u01e1\u0cb8\u2b41\u2b43;\u62fe;\u62fd\u0180aor\u2b4b\u2b63\u2b69r\u0200;ast\u0b7b\u2b55\u2b5a\u2b5flle\u00ec\u0b7bl;\uc000\u2afd\u20e5;\uc000\u2202\u0338lint;\u6a14\u0180;ce\u0c92\u2b70\u2b73u\u00e5\u0ca5\u0100;c\u0c98\u2b78\u0100;e\u0c92\u2b7d\u00f1\u0c98\u0200Aait\u2b88\u2b8b\u2b9d\u2ba7r\u00f2\u2988rr\u0180;cw\u2b94\u2b95\u2b99\u619b;\uc000\u2933\u0338;\uc000\u219d\u0338ghtarrow\u00bb\u2b95ri\u0100;e\u0ccb\u0cd6\u0380chimpqu\u2bbd\u2bcd\u2bd9\u2b04\u0b78\u2be4\u2bef\u0200;cer\u0d32\u2bc6\u0d37\u2bc9u\u00e5\u0d45;\uc000\ud835\udcc3ort\u026d\u2b05\x00\x00\u2bd6ar\u00e1\u2b56m\u0100;e\u0d6e\u2bdf\u0100;q\u0d74\u0d73su\u0100bp\u2beb\u2bed\u00e5\u0cf8\u00e5\u0d0b\u0180bcp\u2bf6\u2c11\u2c19\u0200;Ees\u2bff\u2c00\u0d22\u2c04\u6284;\uc000\u2ac5\u0338et\u0100;e\u0d1b\u2c0bq\u0100;q\u0d23\u2c00c\u0100;e\u0d32\u2c17\u00f1\u0d38\u0200;Ees\u2c22\u2c23\u0d5f\u2c27\u6285;\uc000\u2ac6\u0338et\u0100;e\u0d58\u2c2eq\u0100;q\u0d60\u2c23\u0200gilr\u2c3d\u2c3f\u2c45\u2c47\u00ec\u0bd7lde\u803b\u00f1\u40f1\u00e7\u0c43iangle\u0100lr\u2c52\u2c5ceft\u0100;e\u0c1a\u2c5a\u00f1\u0c26ight\u0100;e\u0ccb\u2c65\u00f1\u0cd7\u0100;m\u2c6c\u2c6d\u43bd\u0180;es\u2c74\u2c75\u2c79\u4023ro;\u6116p;\u6007\u0480DHadgilrs\u2c8f\u2c94\u2c99\u2c9e\u2ca3\u2cb0\u2cb6\u2cd3\u2ce3ash;\u62adarr;\u6904p;\uc000\u224d\u20d2ash;\u62ac\u0100et\u2ca8\u2cac;\uc000\u2265\u20d2;\uc000\x3e\u20d2nfin;\u69de\u0180Aet\u2cbd\u2cc1\u2cc5rr;\u6902;\uc000\u2264\u20d2\u0100;r\u2cca\u2ccd\uc000\x3c\u20d2ie;\uc000\u22b4\u20d2\u0100At\u2cd8\u2cdcrr;\u6903rie;\uc000\u22b5\u20d2im;\uc000\u223c\u20d2\u0180Aan\u2cf0\u2cf4\u2d02rr;\u61d6r\u0100hr\u2cfa\u2cfdk;\u6923\u0100;o\u13e7\u13e5ear;\u6927\u1253\u1a95\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\u2d2d\x00\u2d38\u2d48\u2d60\u2d65\u2d72\u2d84\u1b07\x00\x00\u2d8d\u2dab\x00\u2dc8\u2dce\x00\u2ddc\u2e19\u2e2b\u2e3e\u2e43\u0100cs\u2d31\u1a97ute\u803b\u00f3\u40f3\u0100iy\u2d3c\u2d45r\u0100;c\u1a9e\u2d42\u803b\u00f4\u40f4;\u443e\u0280abios\u1aa0\u2d52\u2d57\u01c8\u2d5alac;\u4151v;\u6a38old;\u69bclig;\u4153\u0100cr\u2d69\u2d6dir;\u69bf;\uc000\ud835\udd2c\u036f\u2d79\x00\x00\u2d7c\x00\u2d82n;\u42dbave\u803b\u00f2\u40f2;\u69c1\u0100bm\u2d88\u0df4ar;\u69b5\u0200acit\u2d95\u2d98\u2da5\u2da8r\u00f2\u1a80\u0100ir\u2d9d\u2da0r;\u69beoss;\u69bbn\u00e5\u0e52;\u69c0\u0180aei\u2db1\u2db5\u2db9cr;\u414dga;\u43c9\u0180cdn\u2dc0\u2dc5\u01cdron;\u43bf;\u69b6pf;\uc000\ud835\udd60\u0180ael\u2dd4\u2dd7\u01d2r;\u69b7rp;\u69b9\u0380;adiosv\u2dea\u2deb\u2dee\u2e08\u2e0d\u2e10\u2e16\u6228r\u00f2\u1a86\u0200;efm\u2df7\u2df8\u2e02\u2e05\u6a5dr\u0100;o\u2dfe\u2dff\u6134f\u00bb\u2dff\u803b\u00aa\u40aa\u803b\u00ba\u40bagof;\u62b6r;\u6a56lope;\u6a57;\u6a5b\u0180clo\u2e1f\u2e21\u2e27\u00f2\u2e01ash\u803b\u00f8\u40f8l;\u6298i\u016c\u2e2f\u2e34de\u803b\u00f5\u40f5es\u0100;a\u01db\u2e3as;\u6a36ml\u803b\u00f6\u40f6bar;\u633d\u0ae1\u2e5e\x00\u2e7d\x00\u2e80\u2e9d\x00\u2ea2\u2eb9\x00\x00\u2ecb\u0e9c\x00\u2f13\x00\x00\u2f2b\u2fbc\x00\u2fc8r\u0200;ast\u0403\u2e67\u2e72\u0e85\u8100\u00b6;l\u2e6d\u2e6e\u40b6le\u00ec\u0403\u0269\u2e78\x00\x00\u2e7bm;\u6af3;\u6afdy;\u443fr\u0280cimpt\u2e8b\u2e8f\u2e93\u1865\u2e97nt;\u4025od;\u402eil;\u6030enk;\u6031r;\uc000\ud835\udd2d\u0180imo\u2ea8\u2eb0\u2eb4\u0100;v\u2ead\u2eae\u43c6;\u43d5ma\u00f4\u0a76ne;\u660e\u0180;tv\u2ebf\u2ec0\u2ec8\u43c0chfork\u00bb\u1ffd;\u43d6\u0100au\u2ecf\u2edfn\u0100ck\u2ed5\u2eddk\u0100;h\u21f4\u2edb;\u610e\u00f6\u21f4s\u0480;abcdemst\u2ef3\u2ef4\u1908\u2ef9\u2efd\u2f04\u2f06\u2f0a\u2f0e\u402bcir;\u6a23ir;\u6a22\u0100ou\u1d40\u2f02;\u6a25;\u6a72n\u80bb\u00b1\u0e9dim;\u6a26wo;\u6a27\u0180ipu\u2f19\u2f20\u2f25ntint;\u6a15f;\uc000\ud835\udd61nd\u803b\u00a3\u40a3\u0500;Eaceinosu\u0ec8\u2f3f\u2f41\u2f44\u2f47\u2f81\u2f89\u2f92\u2f7e\u2fb6;\u6ab3p;\u6ab7u\u00e5\u0ed9\u0100;c\u0ece\u2f4c\u0300;acens\u0ec8\u2f59\u2f5f\u2f66\u2f68\u2f7eppro\u00f8\u2f43urlye\u00f1\u0ed9\u00f1\u0ece\u0180aes\u2f6f\u2f76\u2f7approx;\u6ab9qq;\u6ab5im;\u62e8i\u00ed\u0edfme\u0100;s\u2f88\u0eae\u6032\u0180Eas\u2f78\u2f90\u2f7a\u00f0\u2f75\u0180dfp\u0eec\u2f99\u2faf\u0180als\u2fa0\u2fa5\u2faalar;\u632eine;\u6312urf;\u6313\u0100;t\u0efb\u2fb4\u00ef\u0efbrel;\u62b0\u0100ci\u2fc0\u2fc5r;\uc000\ud835\udcc5;\u43c8ncsp;\u6008\u0300fiopsu\u2fda\u22e2\u2fdf\u2fe5\u2feb\u2ff1r;\uc000\ud835\udd2epf;\uc000\ud835\udd62rime;\u6057cr;\uc000\ud835\udcc6\u0180aeo\u2ff8\u3009\u3013t\u0100ei\u2ffe\u3005rnion\u00f3\u06b0nt;\u6a16st\u0100;e\u3010\u3011\u403f\u00f1\u1f19\u00f4\u0f14\u0a80ABHabcdefhilmnoprstux\u3040\u3051\u3055\u3059\u30e0\u310e\u312b\u3147\u3162\u3172\u318e\u3206\u3215\u3224\u3229\u3258\u326e\u3272\u3290\u32b0\u32b7\u0180art\u3047\u304a\u304cr\u00f2\u10b3\u00f2\u03ddail;\u691car\u00f2\u1c65ar;\u6964\u0380cdenqrt\u3068\u3075\u3078\u307f\u308f\u3094\u30cc\u0100eu\u306d\u3071;\uc000\u223d\u0331te;\u4155i\u00e3\u116emptyv;\u69b3g\u0200;del\u0fd1\u3089\u308b\u308d;\u6992;\u69a5\u00e5\u0fd1uo\u803b\u00bb\u40bbr\u0580;abcfhlpstw\u0fdc\u30ac\u30af\u30b7\u30b9\u30bc\u30be\u30c0\u30c3\u30c7\u30cap;\u6975\u0100;f\u0fe0\u30b4s;\u6920;\u6933s;\u691e\u00eb\u225d\u00f0\u272el;\u6945im;\u6974l;\u61a3;\u619d\u0100ai\u30d1\u30d5il;\u691ao\u0100;n\u30db\u30dc\u6236al\u00f3\u0f1e\u0180abr\u30e7\u30ea\u30eer\u00f2\u17e5rk;\u6773\u0100ak\u30f3\u30fdc\u0100ek\u30f9\u30fb;\u407d;\u405d\u0100es\u3102\u3104;\u698cl\u0100du\u310a\u310c;\u698e;\u6990\u0200aeuy\u3117\u311c\u3127\u3129ron;\u4159\u0100di\u3121\u3125il;\u4157\u00ec\u0ff2\u00e2\u30fa;\u4440\u0200clqs\u3134\u3137\u313d\u3144a;\u6937dhar;\u6969uo\u0100;r\u020e\u020dh;\u61b3\u0180acg\u314e\u315f\u0f44l\u0200;ips\u0f78\u3158\u315b\u109cn\u00e5\u10bbar\u00f4\u0fa9t;\u65ad\u0180ilr\u3169\u1023\u316esht;\u697d;\uc000\ud835\udd2f\u0100ao\u3177\u3186r\u0100du\u317d\u317f\u00bb\u047b\u0100;l\u1091\u3184;\u696c\u0100;v\u318b\u318c\u43c1;\u43f1\u0180gns\u3195\u31f9\u31fcht\u0300ahlrst\u31a4\u31b0\u31c2\u31d8\u31e4\u31eerrow\u0100;t\u0fdc\u31ada\u00e9\u30c8arpoon\u0100du\u31bb\u31bfow\u00ee\u317ep\u00bb\u1092eft\u0100ah\u31ca\u31d0rrow\u00f3\u0feaarpoon\u00f3\u0551ightarrows;\u61c9quigarro\u00f7\u30cbhreetimes;\u62ccg;\u42daingdotse\u00f1\u1f32\u0180ahm\u320d\u3210\u3213r\u00f2\u0feaa\u00f2\u0551;\u600foust\u0100;a\u321e\u321f\u63b1che\u00bb\u321fmid;\u6aee\u0200abpt\u3232\u323d\u3240\u3252\u0100nr\u3237\u323ag;\u67edr;\u61fer\u00eb\u1003\u0180afl\u3247\u324a\u324er;\u6986;\uc000\ud835\udd63us;\u6a2eimes;\u6a35\u0100ap\u325d\u3267r\u0100;g\u3263\u3264\u4029t;\u6994olint;\u6a12ar\u00f2\u31e3\u0200achq\u327b\u3280\u10bc\u3285quo;\u603ar;\uc000\ud835\udcc7\u0100bu\u30fb\u328ao\u0100;r\u0214\u0213\u0180hir\u3297\u329b\u32a0re\u00e5\u31f8mes;\u62cai\u0200;efl\u32aa\u1059\u1821\u32ab\u65b9tri;\u69celuhar;\u6968;\u611e\u0d61\u32d5\u32db\u32df\u332c\u3338\u3371\x00\u337a\u33a4\x00\x00\u33ec\u33f0\x00\u3428\u3448\u345a\u34ad\u34b1\u34ca\u34f1\x00\u3616\x00\x00\u3633cute;\u415bqu\u00ef\u27ba\u0500;Eaceinpsy\u11ed\u32f3\u32f5\u32ff\u3302\u330b\u330f\u331f\u3326\u3329;\u6ab4\u01f0\u32fa\x00\u32fc;\u6ab8on;\u4161u\u00e5\u11fe\u0100;d\u11f3\u3307il;\u415frc;\u415d\u0180Eas\u3316\u3318\u331b;\u6ab6p;\u6abaim;\u62e9olint;\u6a13i\u00ed\u1204;\u4441ot\u0180;be\u3334\u1d47\u3335\u62c5;\u6a66\u0380Aacmstx\u3346\u334a\u3357\u335b\u335e\u3363\u336drr;\u61d8r\u0100hr\u3350\u3352\u00eb\u2228\u0100;o\u0a36\u0a34t\u803b\u00a7\u40a7i;\u403bwar;\u6929m\u0100in\u3369\u00f0nu\u00f3\u00f1t;\u6736r\u0100;o\u3376\u2055\uc000\ud835\udd30\u0200acoy\u3382\u3386\u3391\u33a0rp;\u666f\u0100hy\u338b\u338fcy;\u4449;\u4448rt\u026d\u3399\x00\x00\u339ci\u00e4\u1464ara\u00ec\u2e6f\u803b\u00ad\u40ad\u0100gm\u33a8\u33b4ma\u0180;fv\u33b1\u33b2\u33b2\u43c3;\u43c2\u0400;deglnpr\u12ab\u33c5\u33c9\u33ce\u33d6\u33de\u33e1\u33e6ot;\u6a6a\u0100;q\u12b1\u12b0\u0100;E\u33d3\u33d4\u6a9e;\u6aa0\u0100;E\u33db\u33dc\u6a9d;\u6a9fe;\u6246lus;\u6a24arr;\u6972ar\u00f2\u113d\u0200aeit\u33f8\u3408\u340f\u3417\u0100ls\u33fd\u3404lsetm\u00e9\u336ahp;\u6a33parsl;\u69e4\u0100dl\u1463\u3414e;\u6323\u0100;e\u341c\u341d\u6aaa\u0100;s\u3422\u3423\u6aac;\uc000\u2aac\ufe00\u0180flp\u342e\u3433\u3442tcy;\u444c\u0100;b\u3438\u3439\u402f\u0100;a\u343e\u343f\u69c4r;\u633ff;\uc000\ud835\udd64a\u0100dr\u344d\u0402es\u0100;u\u3454\u3455\u6660it\u00bb\u3455\u0180csu\u3460\u3479\u349f\u0100au\u3465\u346fp\u0100;s\u1188\u346b;\uc000\u2293\ufe00p\u0100;s\u11b4\u3475;\uc000\u2294\ufe00u\u0100bp\u347f\u348f\u0180;es\u1197\u119c\u3486et\u0100;e\u1197\u348d\u00f1\u119d\u0180;es\u11a8\u11ad\u3496et\u0100;e\u11a8\u349d\u00f1\u11ae\u0180;af\u117b\u34a6\u05b0r\u0165\u34ab\u05b1\u00bb\u117car\u00f2\u1148\u0200cemt\u34b9\u34be\u34c2\u34c5r;\uc000\ud835\udcc8tm\u00ee\u00f1i\u00ec\u3415ar\u00e6\u11be\u0100ar\u34ce\u34d5r\u0100;f\u34d4\u17bf\u6606\u0100an\u34da\u34edight\u0100ep\u34e3\u34eapsilo\u00ee\u1ee0h\u00e9\u2eafs\u00bb\u2852\u0280bcmnp\u34fb\u355e\u1209\u358b\u358e\u0480;Edemnprs\u350e\u350f\u3511\u3515\u351e\u3523\u352c\u3531\u3536\u6282;\u6ac5ot;\u6abd\u0100;d\u11da\u351aot;\u6ac3ult;\u6ac1\u0100Ee\u3528\u352a;\u6acb;\u628alus;\u6abfarr;\u6979\u0180eiu\u353d\u3552\u3555t\u0180;en\u350e\u3545\u354bq\u0100;q\u11da\u350feq\u0100;q\u352b\u3528m;\u6ac7\u0100bp\u355a\u355c;\u6ad5;\u6ad3c\u0300;acens\u11ed\u356c\u3572\u3579\u357b\u3326ppro\u00f8\u32faurlye\u00f1\u11fe\u00f1\u11f3\u0180aes\u3582\u3588\u331bppro\u00f8\u331aq\u00f1\u3317g;\u666a\u0680123;Edehlmnps\u35a9\u35ac\u35af\u121c\u35b2\u35b4\u35c0\u35c9\u35d5\u35da\u35df\u35e8\u35ed\u803b\u00b9\u40b9\u803b\u00b2\u40b2\u803b\u00b3\u40b3;\u6ac6\u0100os\u35b9\u35bct;\u6abeub;\u6ad8\u0100;d\u1222\u35c5ot;\u6ac4s\u0100ou\u35cf\u35d2l;\u67c9b;\u6ad7arr;\u697bult;\u6ac2\u0100Ee\u35e4\u35e6;\u6acc;\u628blus;\u6ac0\u0180eiu\u35f4\u3609\u360ct\u0180;en\u121c\u35fc\u3602q\u0100;q\u1222\u35b2eq\u0100;q\u35e7\u35e4m;\u6ac8\u0100bp\u3611\u3613;\u6ad4;\u6ad6\u0180Aan\u361c\u3620\u362drr;\u61d9r\u0100hr\u3626\u3628\u00eb\u222e\u0100;o\u0a2b\u0a29war;\u692alig\u803b\u00df\u40df\u0be1\u3651\u365d\u3660\u12ce\u3673\u3679\x00\u367e\u36c2\x00\x00\x00\x00\x00\u36db\u3703\x00\u3709\u376c\x00\x00\x00\u3787\u0272\u3656\x00\x00\u365bget;\u6316;\u43c4r\u00eb\u0e5f\u0180aey\u3666\u366b\u3670ron;\u4165dil;\u4163;\u4442lrec;\u6315r;\uc000\ud835\udd31\u0200eiko\u3686\u369d\u36b5\u36bc\u01f2\u368b\x00\u3691e\u01004f\u1284\u1281a\u0180;sv\u3698\u3699\u369b\u43b8ym;\u43d1\u0100cn\u36a2\u36b2k\u0100as\u36a8\u36aeppro\u00f8\u12c1im\u00bb\u12acs\u00f0\u129e\u0100as\u36ba\u36ae\u00f0\u12c1rn\u803b\u00fe\u40fe\u01ec\u031f\u36c6\u22e7es\u8180\u00d7;bd\u36cf\u36d0\u36d8\u40d7\u0100;a\u190f\u36d5r;\u6a31;\u6a30\u0180eps\u36e1\u36e3\u3700\u00e1\u2a4d\u0200;bcf\u0486\u36ec\u36f0\u36f4ot;\u6336ir;\u6af1\u0100;o\u36f9\u36fc\uc000\ud835\udd65rk;\u6ada\u00e1\u3362rime;\u6034\u0180aip\u370f\u3712\u3764d\u00e5\u1248\u0380adempst\u3721\u374d\u3740\u3751\u3757\u375c\u375fngle\u0280;dlqr\u3730\u3731\u3736\u3740\u3742\u65b5own\u00bb\u1dbbeft\u0100;e\u2800\u373e\u00f1\u092e;\u625cight\u0100;e\u32aa\u374b\u00f1\u105aot;\u65ecinus;\u6a3alus;\u6a39b;\u69cdime;\u6a3bezium;\u63e2\u0180cht\u3772\u377d\u3781\u0100ry\u3777\u377b;\uc000\ud835\udcc9;\u4446cy;\u445brok;\u4167\u0100io\u378b\u378ex\u00f4\u1777head\u0100lr\u3797\u37a0eftarro\u00f7\u084fightarrow\u00bb\u0f5d\u0900AHabcdfghlmoprstuw\u37d0\u37d3\u37d7\u37e4\u37f0\u37fc\u380e\u381c\u3823\u3834\u3851\u385d\u386b\u38a9\u38cc\u38d2\u38ea\u38f6r\u00f2\u03edar;\u6963\u0100cr\u37dc\u37e2ute\u803b\u00fa\u40fa\u00f2\u1150r\u01e3\u37ea\x00\u37edy;\u445eve;\u416d\u0100iy\u37f5\u37farc\u803b\u00fb\u40fb;\u4443\u0180abh\u3803\u3806\u380br\u00f2\u13adlac;\u4171a\u00f2\u13c3\u0100ir\u3813\u3818sht;\u697e;\uc000\ud835\udd32rave\u803b\u00f9\u40f9\u0161\u3827\u3831r\u0100lr\u382c\u382e\u00bb\u0957\u00bb\u1083lk;\u6580\u0100ct\u3839\u384d\u026f\u383f\x00\x00\u384arn\u0100;e\u3845\u3846\u631cr\u00bb\u3846op;\u630fri;\u65f8\u0100al\u3856\u385acr;\u416b\u80bb\u00a8\u0349\u0100gp\u3862\u3866on;\u4173f;\uc000\ud835\udd66\u0300adhlsu\u114b\u3878\u387d\u1372\u3891\u38a0own\u00e1\u13b3arpoon\u0100lr\u3888\u388cef\u00f4\u382digh\u00f4\u382fi\u0180;hl\u3899\u389a\u389c\u43c5\u00bb\u13faon\u00bb\u389aparrows;\u61c8\u0180cit\u38b0\u38c4\u38c8\u026f\u38b6\x00\x00\u38c1rn\u0100;e\u38bc\u38bd\u631dr\u00bb\u38bdop;\u630eng;\u416fri;\u65f9cr;\uc000\ud835\udcca\u0180dir\u38d9\u38dd\u38e2ot;\u62f0lde;\u4169i\u0100;f\u3730\u38e8\u00bb\u1813\u0100am\u38ef\u38f2r\u00f2\u38a8l\u803b\u00fc\u40fcangle;\u69a7\u0780ABDacdeflnoprsz\u391c\u391f\u3929\u392d\u39b5\u39b8\u39bd\u39df\u39e4\u39e8\u39f3\u39f9\u39fd\u3a01\u3a20r\u00f2\u03f7ar\u0100;v\u3926\u3927\u6ae8;\u6ae9as\u00e8\u03e1\u0100nr\u3932\u3937grt;\u699c\u0380eknprst\u34e3\u3946\u394b\u3952\u395d\u3964\u3996app\u00e1\u2415othin\u00e7\u1e96\u0180hir\u34eb\u2ec8\u3959op\u00f4\u2fb5\u0100;h\u13b7\u3962\u00ef\u318d\u0100iu\u3969\u396dgm\u00e1\u33b3\u0100bp\u3972\u3984setneq\u0100;q\u397d\u3980\uc000\u228a\ufe00;\uc000\u2acb\ufe00setneq\u0100;q\u398f\u3992\uc000\u228b\ufe00;\uc000\u2acc\ufe00\u0100hr\u399b\u399fet\u00e1\u369ciangle\u0100lr\u39aa\u39afeft\u00bb\u0925ight\u00bb\u1051y;\u4432ash\u00bb\u1036\u0180elr\u39c4\u39d2\u39d7\u0180;be\u2dea\u39cb\u39cfar;\u62bbq;\u625alip;\u62ee\u0100bt\u39dc\u1468a\u00f2\u1469r;\uc000\ud835\udd33tr\u00e9\u39aesu\u0100bp\u39ef\u39f1\u00bb\u0d1c\u00bb\u0d59pf;\uc000\ud835\udd67ro\u00f0\u0efbtr\u00e9\u39b4\u0100cu\u3a06\u3a0br;\uc000\ud835\udccb\u0100bp\u3a10\u3a18n\u0100Ee\u3980\u3a16\u00bb\u397en\u0100Ee\u3992\u3a1e\u00bb\u3990igzag;\u699a\u0380cefoprs\u3a36\u3a3b\u3a56\u3a5b\u3a54\u3a61\u3a6airc;\u4175\u0100di\u3a40\u3a51\u0100bg\u3a45\u3a49ar;\u6a5fe\u0100;q\u15fa\u3a4f;\u6259erp;\u6118r;\uc000\ud835\udd34pf;\uc000\ud835\udd68\u0100;e\u1479\u3a66at\u00e8\u1479cr;\uc000\ud835\udccc\u0ae3\u178e\u3a87\x00\u3a8b\x00\u3a90\u3a9b\x00\x00\u3a9d\u3aa8\u3aab\u3aaf\x00\x00\u3ac3\u3ace\x00\u3ad8\u17dc\u17dftr\u00e9\u17d1r;\uc000\ud835\udd35\u0100Aa\u3a94\u3a97r\u00f2\u03c3r\u00f2\u09f6;\u43be\u0100Aa\u3aa1\u3aa4r\u00f2\u03b8r\u00f2\u09eba\u00f0\u2713is;\u62fb\u0180dpt\u17a4\u3ab5\u3abe\u0100fl\u3aba\u17a9;\uc000\ud835\udd69im\u00e5\u17b2\u0100Aa\u3ac7\u3acar\u00f2\u03cer\u00f2\u0a01\u0100cq\u3ad2\u17b8r;\uc000\ud835\udccd\u0100pt\u17d6\u3adcr\u00e9\u17d4\u0400acefiosu\u3af0\u3afd\u3b08\u3b0c\u3b11\u3b15\u3b1b\u3b21c\u0100uy\u3af6\u3afbte\u803b\u00fd\u40fd;\u444f\u0100iy\u3b02\u3b06rc;\u4177;\u444bn\u803b\u00a5\u40a5r;\uc000\ud835\udd36cy;\u4457pf;\uc000\ud835\udd6acr;\uc000\ud835\udcce\u0100cm\u3b26\u3b29y;\u444el\u803b\u00ff\u40ff\u0500acdefhiosw\u3b42\u3b48\u3b54\u3b58\u3b64\u3b69\u3b6d\u3b74\u3b7a\u3b80cute;\u417a\u0100ay\u3b4d\u3b52ron;\u417e;\u4437ot;\u417c\u0100et\u3b5d\u3b61tr\u00e6\u155fa;\u43b6r;\uc000\ud835\udd37cy;\u4436grarr;\u61ddpf;\uc000\ud835\udd6bcr;\uc000\ud835\udccf\u0100jn\u3b85\u3b87;\u600dj;\u600c'.split("").map(t => 
t.charCodeAt(0))), v9 = new Map([[0, 65533], [128, 8364], [130, 8218], [131, 402], [132, 8222], [133, 8230], [134, 8224], [135, 8225], [136, 710], [137, 8240], [138, 352], [139, 8249], [140, 338], [142, 381], [145, 8216], [146, 8217], [147, 8220], [148, 8221], [149, 8226], [150, 8211], [151, 8212], [152, 732], [153, 8482], [154, 353], [155, 8250], [156, 339], [158, 382], [159, 376]]);
function w9(t) {
  var e;
  return t >= 55296 && t <= 57343 || t > 1114111 ? 65533 : (e = v9.get(t)) !== null && e !== void 0 ? e : t;
}
var lr;
(function(t) {
  t[t.NUM = 35] = "NUM", t[t.SEMI = 59] = "SEMI", t[t.EQUALS = 61] = "EQUALS", t[t.ZERO = 48] = "ZERO", t[t.NINE = 57] = "NINE", t[t.LOWER_A = 97] = "LOWER_A", t[t.LOWER_F = 102] = "LOWER_F", t[t.LOWER_X = 120] = "LOWER_X", t[t.LOWER_Z = 122] = "LOWER_Z", t[t.UPPER_A = 65] = "UPPER_A", t[t.UPPER_F = 70] = "UPPER_F", t[t.UPPER_Z = 90] = "UPPER_Z";
})(lr || (lr = {}));
const _9 = 32;
var Uo;
(function(t) {
  t[t.VALUE_LENGTH = 49152] = "VALUE_LENGTH", t[t.BRANCH_LENGTH = 16256] = "BRANCH_LENGTH", t[t.JUMP_TABLE = 127] = "JUMP_TABLE";
})(Uo || (Uo = {}));
function vb(t) {
  return t >= lr.ZERO && t <= lr.NINE;
}
function S9(t) {
  return t >= lr.UPPER_A && t <= lr.UPPER_F || t >= lr.LOWER_A && t <= lr.LOWER_F;
}
function k9(t) {
  return t >= lr.UPPER_A && t <= lr.UPPER_Z || t >= lr.LOWER_A && t <= lr.LOWER_Z || vb(t);
}
function E9(t) {
  return t === lr.EQUALS || k9(t);
}
var sr;
(function(t) {
  t[t.EntityStart = 0] = "EntityStart", t[t.NumericStart = 1] = "NumericStart", t[t.NumericDecimal = 2] = "NumericDecimal", t[t.NumericHex = 3] = "NumericHex", t[t.NamedEntity = 4] = "NamedEntity";
})(sr || (sr = {}));
var to;
(function(t) {
  t[t.Legacy = 0] = "Legacy", t[t.Strict = 1] = "Strict", t[t.Attribute = 2] = "Attribute";
})(to || (to = {}));
class T9 {
  constructor(e, n, r) {
    this.decodeTree = e, this.emitCodePoint = n, this.errors = r, this.state = sr.EntityStart, this.consumed = 1, this.result = 0, this.treeIndex = 0, this.excess = 1, this.decodeMode = to.Strict;
  }
  startEntity(e) {
    this.decodeMode = e, this.state = sr.EntityStart, this.result = 0, this.treeIndex = 0, this.excess = 1, this.consumed = 1;
  }
  write(e, n) {
    switch(this.state) {
      case sr.EntityStart:
        return e.charCodeAt(n) === lr.NUM ? (this.state = sr.NumericStart, this.consumed += 1, this.stateNumericStart(e, n + 1)) : (this.state = sr.NamedEntity, this.stateNamedEntity(e, n));
      case sr.NumericStart:
        return this.stateNumericStart(e, n);
      case sr.NumericDecimal:
        return this.stateNumericDecimal(e, n);
      case sr.NumericHex:
        return this.stateNumericHex(e, n);
      case sr.NamedEntity:
        return this.stateNamedEntity(e, n);
    }
  }
  stateNumericStart(e, n) {
    return n >= e.length ? -1 : (e.charCodeAt(n) | _9) === lr.LOWER_X ? (this.state = sr.NumericHex, this.consumed += 1, this.stateNumericHex(e, n + 1)) : (this.state = sr.NumericDecimal, this.stateNumericDecimal(e, n));
  }
  addToNumericResult(e, n, r, i) {
    if (n !== r) {
      const s = r - n;
      this.result = this.result * Math.pow(i, s) + Number.parseInt(e.substr(n, s), i), this.consumed += s;
    }
  }
  stateNumericHex(e, n) {
    const r = n;
    for (; n < e.length;) {
      const i = e.charCodeAt(n);
      if (vb(i) || S9(i)) {
        n += 1;
      } else {
        return this.addToNumericResult(e, r, n, 16), this.emitNumericEntity(i, 3);
      }
    }
    return this.addToNumericResult(e, r, n, 16), -1;
  }
  stateNumericDecimal(e, n) {
    const r = n;
    for (; n < e.length;) {
      const i = e.charCodeAt(n);
      if (vb(i)) {
        n += 1;
      } else {
        return this.addToNumericResult(e, r, n, 10), this.emitNumericEntity(i, 2);
      }
    }
    return this.addToNumericResult(e, r, n, 10), -1;
  }
  emitNumericEntity(e, n) {
    var r;
    if (this.consumed <= n) {
      return (r = this.errors) === null || r === void 0 || r.absenceOfDigitsInNumericCharacterReference(this.consumed), 0;
    }
    if (e === lr.SEMI) {
      this.consumed += 1;
    } else if (this.decodeMode === to.Strict) {
      return 0;
    }
    return this.emitCodePoint(w9(this.result), this.consumed), this.errors && (e !== lr.SEMI && this.errors.missingSemicolonAfterCharacterReference(), this.errors.validateNumericCharacterReference(this.result)), this.consumed;
  }
  stateNamedEntity(e, n) {
    const {decodeTree:r} = this;
    let i = r[this.treeIndex], s = (i & Uo.VALUE_LENGTH) >> 14;
    for (; n < e.length; n++, this.excess++) {
      const o = e.charCodeAt(n);
      if (this.treeIndex = C9(r, i, this.treeIndex + Math.max(1, s), o), this.treeIndex < 0) {
        return this.result === 0 || this.decodeMode === to.Attribute && (s === 0 || E9(o)) ? 0 : this.emitNotTerminatedNamedEntity();
      }
      if (i = r[this.treeIndex], s = (i & Uo.VALUE_LENGTH) >> 14, s !== 0) {
        if (o === lr.SEMI) {
          return this.emitNamedEntityData(this.treeIndex, s, this.consumed + this.excess);
        }
        this.decodeMode !== to.Strict && (this.result = this.treeIndex, this.consumed += this.excess, this.excess = 0);
      }
    }
    return -1;
  }
  emitNotTerminatedNamedEntity() {
    var e;
    const {result:n, decodeTree:r} = this, i = (r[n] & Uo.VALUE_LENGTH) >> 14;
    return this.emitNamedEntityData(n, i, this.consumed), (e = this.errors) === null || e === void 0 || e.missingSemicolonAfterCharacterReference(), this.consumed;
  }
  emitNamedEntityData(e, n, r) {
    const {decodeTree:i} = this;
    return this.emitCodePoint(n === 1 ? i[e] & ~Uo.VALUE_LENGTH : i[e + 1], r), n === 3 && this.emitCodePoint(i[e + 2], r), r;
  }
  end() {
    var e;
    switch(this.state) {
      case sr.NamedEntity:
        return this.result !== 0 && (this.decodeMode !== to.Attribute || this.result === this.treeIndex) ? this.emitNotTerminatedNamedEntity() : 0;
      case sr.NumericDecimal:
        return this.emitNumericEntity(0, 2);
      case sr.NumericHex:
        return this.emitNumericEntity(0, 3);
      case sr.NumericStart:
        return (e = this.errors) === null || e === void 0 || e.absenceOfDigitsInNumericCharacterReference(this.consumed), 0;
      case sr.EntityStart:
        return 0;
    }
  }
}
function C9(t, e, n, r) {
  const i = (e & Uo.BRANCH_LENGTH) >> 7, s = e & Uo.JUMP_TABLE;
  if (i === 0) {
    return s !== 0 && r === s ? n : -1;
  }
  if (s) {
    const l = r - s;
    return l < 0 || l >= i ? -1 : t[n + l] - 1;
  }
  let o = n, a = o + i - 1;
  for (; o <= a;) {
    const l = o + a >>> 1, c = t[l];
    if (c < r) {
      o = l + 1;
    } else if (c > r) {
      a = l - 1;
    } else {
      return t[l + i];
    }
  }
  return -1;
}
var Fe;
(function(t) {
  t.HTML = "http://www.w3.org/1999/xhtml", t.MATHML = "http://www.w3.org/1998/Math/MathML", t.SVG = "http://www.w3.org/2000/svg", t.XLINK = "http://www.w3.org/1999/xlink", t.XML = "http://www.w3.org/XML/1998/namespace", t.XMLNS = "http://www.w3.org/2000/xmlns/";
})(Fe || (Fe = {}));
var Ha;
(function(t) {
  t.TYPE = "type", t.ACTION = "action", t.ENCODING = "encoding", t.PROMPT = "prompt", t.NAME = "name", t.COLOR = "color", t.FACE = "face", t.SIZE = "size";
})(Ha || (Ha = {}));
var Ni;
(function(t) {
  t.NO_QUIRKS = "no-quirks", t.QUIRKS = "quirks", t.LIMITED_QUIRKS = "limited-quirks";
})(Ni || (Ni = {}));
var ye;
(function(t) {
  t.A = "a", t.ADDRESS = "address", t.ANNOTATION_XML = "annotation-xml", t.APPLET = "applet", t.AREA = "area", t.ARTICLE = "article", t.ASIDE = "aside", t.B = "b", t.BASE = "base", t.BASEFONT = "basefont", t.BGSOUND = "bgsound", t.BIG = "big", t.BLOCKQUOTE = "blockquote", t.BODY = "body", t.BR = "br", t.BUTTON = "button", t.CAPTION = "caption", t.CENTER = "center", t.CODE = "code", t.COL = "col", t.COLGROUP = "colgroup", t.DD = "dd", t.DESC = "desc", t.DETAILS = "details", t.DIALOG = "dialog", t.DIR = 
  "dir", t.DIV = "div", t.DL = "dl", t.DT = "dt", t.EM = "em", t.EMBED = "embed", t.FIELDSET = "fieldset", t.FIGCAPTION = "figcaption", t.FIGURE = "figure", t.FONT = "font", t.FOOTER = "footer", t.FOREIGN_OBJECT = "foreignObject", t.FORM = "form", t.FRAME = "frame", t.FRAMESET = "frameset", t.H1 = "h1", t.H2 = "h2", t.H3 = "h3", t.H4 = "h4", t.H5 = "h5", t.H6 = "h6", t.HEAD = "head", t.HEADER = "header", t.HGROUP = "hgroup", t.HR = "hr", t.HTML = "html", t.I = "i", t.IMG = "img", t.IMAGE = "image", 
  t.INPUT = "input", t.IFRAME = "iframe", t.KEYGEN = "keygen", t.LABEL = "label", t.LI = "li", t.LINK = "link", t.LISTING = "listing", t.MAIN = "main", t.MALIGNMARK = "malignmark", t.MARQUEE = "marquee", t.MATH = "math", t.MENU = "menu", t.META = "meta", t.MGLYPH = "mglyph", t.MI = "mi", t.MO = "mo", t.MN = "mn", t.MS = "ms", t.MTEXT = "mtext", t.NAV = "nav", t.NOBR = "nobr", t.NOFRAMES = "noframes", t.NOEMBED = "noembed", t.NOSCRIPT = "noscript", t.OBJECT = "object", t.OL = "ol", t.OPTGROUP = "optgroup", 
  t.OPTION = "option", t.P = "p", t.PARAM = "param", t.PLAINTEXT = "plaintext", t.PRE = "pre", t.RB = "rb", t.RP = "rp", t.RT = "rt", t.RTC = "rtc", t.RUBY = "ruby", t.S = "s", t.SCRIPT = "script", t.SEARCH = "search", t.SECTION = "section", t.SELECT = "select", t.SOURCE = "source", t.SMALL = "small", t.SPAN = "span", t.STRIKE = "strike", t.STRONG = "strong", t.STYLE = "style", t.SUB = "sub", t.SUMMARY = "summary", t.SUP = "sup", t.TABLE = "table", t.TBODY = "tbody", t.TEMPLATE = "template", t.TEXTAREA = 
  "textarea", t.TFOOT = "tfoot", t.TD = "td", t.TH = "th", t.THEAD = "thead", t.TITLE = "title", t.TR = "tr", t.TRACK = "track", t.TT = "tt", t.U = "u", t.UL = "ul", t.SVG = "svg", t.VAR = "var", t.WBR = "wbr", t.XMP = "xmp";
})(ye || (ye = {}));
var S;
(function(t) {
  t[t.UNKNOWN = 0] = "UNKNOWN", t[t.A = 1] = "A", t[t.ADDRESS = 2] = "ADDRESS", t[t.ANNOTATION_XML = 3] = "ANNOTATION_XML", t[t.APPLET = 4] = "APPLET", t[t.AREA = 5] = "AREA", t[t.ARTICLE = 6] = "ARTICLE", t[t.ASIDE = 7] = "ASIDE", t[t.B = 8] = "B", t[t.BASE = 9] = "BASE", t[t.BASEFONT = 10] = "BASEFONT", t[t.BGSOUND = 11] = "BGSOUND", t[t.BIG = 12] = "BIG", t[t.BLOCKQUOTE = 13] = "BLOCKQUOTE", t[t.BODY = 14] = "BODY", t[t.BR = 15] = "BR", t[t.BUTTON = 16] = "BUTTON", t[t.CAPTION = 17] = "CAPTION", 
  t[t.CENTER = 18] = "CENTER", t[t.CODE = 19] = "CODE", t[t.COL = 20] = "COL", t[t.COLGROUP = 21] = "COLGROUP", t[t.DD = 22] = "DD", t[t.DESC = 23] = "DESC", t[t.DETAILS = 24] = "DETAILS", t[t.DIALOG = 25] = "DIALOG", t[t.DIR = 26] = "DIR", t[t.DIV = 27] = "DIV", t[t.DL = 28] = "DL", t[t.DT = 29] = "DT", t[t.EM = 30] = "EM", t[t.EMBED = 31] = "EMBED", t[t.FIELDSET = 32] = "FIELDSET", t[t.FIGCAPTION = 33] = "FIGCAPTION", t[t.FIGURE = 34] = "FIGURE", t[t.FONT = 35] = "FONT", t[t.FOOTER = 36] = "FOOTER", 
  t[t.FOREIGN_OBJECT = 37] = "FOREIGN_OBJECT", t[t.FORM = 38] = "FORM", t[t.FRAME = 39] = "FRAME", t[t.FRAMESET = 40] = "FRAMESET", t[t.H1 = 41] = "H1", t[t.H2 = 42] = "H2", t[t.H3 = 43] = "H3", t[t.H4 = 44] = "H4", t[t.H5 = 45] = "H5", t[t.H6 = 46] = "H6", t[t.HEAD = 47] = "HEAD", t[t.HEADER = 48] = "HEADER", t[t.HGROUP = 49] = "HGROUP", t[t.HR = 50] = "HR", t[t.HTML = 51] = "HTML", t[t.I = 52] = "I", t[t.IMG = 53] = "IMG", t[t.IMAGE = 54] = "IMAGE", t[t.INPUT = 55] = "INPUT", t[t.IFRAME = 56] = 
  "IFRAME", t[t.KEYGEN = 57] = "KEYGEN", t[t.LABEL = 58] = "LABEL", t[t.LI = 59] = "LI", t[t.LINK = 60] = "LINK", t[t.LISTING = 61] = "LISTING", t[t.MAIN = 62] = "MAIN", t[t.MALIGNMARK = 63] = "MALIGNMARK", t[t.MARQUEE = 64] = "MARQUEE", t[t.MATH = 65] = "MATH", t[t.MENU = 66] = "MENU", t[t.META = 67] = "META", t[t.MGLYPH = 68] = "MGLYPH", t[t.MI = 69] = "MI", t[t.MO = 70] = "MO", t[t.MN = 71] = "MN", t[t.MS = 72] = "MS", t[t.MTEXT = 73] = "MTEXT", t[t.NAV = 74] = "NAV", t[t.NOBR = 75] = "NOBR", 
  t[t.NOFRAMES = 76] = "NOFRAMES", t[t.NOEMBED = 77] = "NOEMBED", t[t.NOSCRIPT = 78] = "NOSCRIPT", t[t.OBJECT = 79] = "OBJECT", t[t.OL = 80] = "OL", t[t.OPTGROUP = 81] = "OPTGROUP", t[t.OPTION = 82] = "OPTION", t[t.P = 83] = "P", t[t.PARAM = 84] = "PARAM", t[t.PLAINTEXT = 85] = "PLAINTEXT", t[t.PRE = 86] = "PRE", t[t.RB = 87] = "RB", t[t.RP = 88] = "RP", t[t.RT = 89] = "RT", t[t.RTC = 90] = "RTC", t[t.RUBY = 91] = "RUBY", t[t.S = 92] = "S", t[t.SCRIPT = 93] = "SCRIPT", t[t.SEARCH = 94] = "SEARCH", 
  t[t.SECTION = 95] = "SECTION", t[t.SELECT = 96] = "SELECT", t[t.SOURCE = 97] = "SOURCE", t[t.SMALL = 98] = "SMALL", t[t.SPAN = 99] = "SPAN", t[t.STRIKE = 100] = "STRIKE", t[t.STRONG = 101] = "STRONG", t[t.STYLE = 102] = "STYLE", t[t.SUB = 103] = "SUB", t[t.SUMMARY = 104] = "SUMMARY", t[t.SUP = 105] = "SUP", t[t.TABLE = 106] = "TABLE", t[t.TBODY = 107] = "TBODY", t[t.TEMPLATE = 108] = "TEMPLATE", t[t.TEXTAREA = 109] = "TEXTAREA", t[t.TFOOT = 110] = "TFOOT", t[t.TD = 111] = "TD", t[t.TH = 112] = 
  "TH", t[t.THEAD = 113] = "THEAD", t[t.TITLE = 114] = "TITLE", t[t.TR = 115] = "TR", t[t.TRACK = 116] = "TRACK", t[t.TT = 117] = "TT", t[t.U = 118] = "U", t[t.UL = 119] = "UL", t[t.SVG = 120] = "SVG", t[t.VAR = 121] = "VAR", t[t.WBR = 122] = "WBR", t[t.XMP = 123] = "XMP";
})(S || (S = {}));
const A9 = new Map([[ye.A, S.A], [ye.ADDRESS, S.ADDRESS], [ye.ANNOTATION_XML, S.ANNOTATION_XML], [ye.APPLET, S.APPLET], [ye.AREA, S.AREA], [ye.ARTICLE, S.ARTICLE], [ye.ASIDE, S.ASIDE], [ye.B, S.B], [ye.BASE, S.BASE], [ye.BASEFONT, S.BASEFONT], [ye.BGSOUND, S.BGSOUND], [ye.BIG, S.BIG], [ye.BLOCKQUOTE, S.BLOCKQUOTE], [ye.BODY, S.BODY], [ye.BR, S.BR], [ye.BUTTON, S.BUTTON], [ye.CAPTION, S.CAPTION], [ye.CENTER, S.CENTER], [ye.CODE, S.CODE], [ye.COL, S.COL], [ye.COLGROUP, S.COLGROUP], [ye.DD, S.DD], [ye.DESC, 
S.DESC], [ye.DETAILS, S.DETAILS], [ye.DIALOG, S.DIALOG], [ye.DIR, S.DIR], [ye.DIV, S.DIV], [ye.DL, S.DL], [ye.DT, S.DT], [ye.EM, S.EM], [ye.EMBED, S.EMBED], [ye.FIELDSET, S.FIELDSET], [ye.FIGCAPTION, S.FIGCAPTION], [ye.FIGURE, S.FIGURE], [ye.FONT, S.FONT], [ye.FOOTER, S.FOOTER], [ye.FOREIGN_OBJECT, S.FOREIGN_OBJECT], [ye.FORM, S.FORM], [ye.FRAME, S.FRAME], [ye.FRAMESET, S.FRAMESET], [ye.H1, S.H1], [ye.H2, S.H2], [ye.H3, S.H3], [ye.H4, S.H4], [ye.H5, S.H5], [ye.H6, S.H6], [ye.HEAD, S.HEAD], [ye.HEADER, 
S.HEADER], [ye.HGROUP, S.HGROUP], [ye.HR, S.HR], [ye.HTML, S.HTML], [ye.I, S.I], [ye.IMG, S.IMG], [ye.IMAGE, S.IMAGE], [ye.INPUT, S.INPUT], [ye.IFRAME, S.IFRAME], [ye.KEYGEN, S.KEYGEN], [ye.LABEL, S.LABEL], [ye.LI, S.LI], [ye.LINK, S.LINK], [ye.LISTING, S.LISTING], [ye.MAIN, S.MAIN], [ye.MALIGNMARK, S.MALIGNMARK], [ye.MARQUEE, S.MARQUEE], [ye.MATH, S.MATH], [ye.MENU, S.MENU], [ye.META, S.META], [ye.MGLYPH, S.MGLYPH], [ye.MI, S.MI], [ye.MO, S.MO], [ye.MN, S.MN], [ye.MS, S.MS], [ye.MTEXT, S.MTEXT], 
[ye.NAV, S.NAV], [ye.NOBR, S.NOBR], [ye.NOFRAMES, S.NOFRAMES], [ye.NOEMBED, S.NOEMBED], [ye.NOSCRIPT, S.NOSCRIPT], [ye.OBJECT, S.OBJECT], [ye.OL, S.OL], [ye.OPTGROUP, S.OPTGROUP], [ye.OPTION, S.OPTION], [ye.P, S.P], [ye.PARAM, S.PARAM], [ye.PLAINTEXT, S.PLAINTEXT], [ye.PRE, S.PRE], [ye.RB, S.RB], [ye.RP, S.RP], [ye.RT, S.RT], [ye.RTC, S.RTC], [ye.RUBY, S.RUBY], [ye.S, S.S], [ye.SCRIPT, S.SCRIPT], [ye.SEARCH, S.SEARCH], [ye.SECTION, S.SECTION], [ye.SELECT, S.SELECT], [ye.SOURCE, S.SOURCE], [ye.SMALL, 
S.SMALL], [ye.SPAN, S.SPAN], [ye.STRIKE, S.STRIKE], [ye.STRONG, S.STRONG], [ye.STYLE, S.STYLE], [ye.SUB, S.SUB], [ye.SUMMARY, S.SUMMARY], [ye.SUP, S.SUP], [ye.TABLE, S.TABLE], [ye.TBODY, S.TBODY], [ye.TEMPLATE, S.TEMPLATE], [ye.TEXTAREA, S.TEXTAREA], [ye.TFOOT, S.TFOOT], [ye.TD, S.TD], [ye.TH, S.TH], [ye.THEAD, S.THEAD], [ye.TITLE, S.TITLE], [ye.TR, S.TR], [ye.TRACK, S.TRACK], [ye.TT, S.TT], [ye.U, S.U], [ye.UL, S.UL], [ye.SVG, S.SVG], [ye.VAR, S.VAR], [ye.WBR, S.WBR], [ye.XMP, S.XMP]]);
function Tc(t) {
  var e;
  return (e = A9.get(t)) !== null && e !== void 0 ? e : S.UNKNOWN;
}
const Ue = S, N9 = {[Fe.HTML]:new Set([Ue.ADDRESS, Ue.APPLET, Ue.AREA, Ue.ARTICLE, Ue.ASIDE, Ue.BASE, Ue.BASEFONT, Ue.BGSOUND, Ue.BLOCKQUOTE, Ue.BODY, Ue.BR, Ue.BUTTON, Ue.CAPTION, Ue.CENTER, Ue.COL, Ue.COLGROUP, Ue.DD, Ue.DETAILS, Ue.DIR, Ue.DIV, Ue.DL, Ue.DT, Ue.EMBED, Ue.FIELDSET, Ue.FIGCAPTION, Ue.FIGURE, Ue.FOOTER, Ue.FORM, Ue.FRAME, Ue.FRAMESET, Ue.H1, Ue.H2, Ue.H3, Ue.H4, Ue.H5, Ue.H6, Ue.HEAD, Ue.HEADER, Ue.HGROUP, Ue.HR, Ue.HTML, Ue.IFRAME, Ue.IMG, Ue.INPUT, Ue.LI, Ue.LINK, Ue.LISTING, Ue.MAIN, 
Ue.MARQUEE, Ue.MENU, Ue.META, Ue.NAV, Ue.NOEMBED, Ue.NOFRAMES, Ue.NOSCRIPT, Ue.OBJECT, Ue.OL, Ue.P, Ue.PARAM, Ue.PLAINTEXT, Ue.PRE, Ue.SCRIPT, Ue.SECTION, Ue.SELECT, Ue.SOURCE, Ue.STYLE, Ue.SUMMARY, Ue.TABLE, Ue.TBODY, Ue.TD, Ue.TEMPLATE, Ue.TEXTAREA, Ue.TFOOT, Ue.TH, Ue.THEAD, Ue.TITLE, Ue.TR, Ue.TRACK, Ue.UL, Ue.WBR, Ue.XMP]), [Fe.MATHML]:new Set([Ue.MI, Ue.MO, Ue.MN, Ue.MS, Ue.MTEXT, Ue.ANNOTATION_XML]), [Fe.SVG]:new Set([Ue.TITLE, Ue.FOREIGN_OBJECT, Ue.DESC]), [Fe.XLINK]:new Set(), [Fe.XML]:new Set(), 
[Fe.XMLNS]:new Set()}, wb = new Set([Ue.H1, Ue.H2, Ue.H3, Ue.H4, Ue.H5, Ue.H6]);
ye.STYLE, ye.SCRIPT, ye.XMP, ye.IFRAME, ye.NOEMBED, ye.NOFRAMES, ye.PLAINTEXT;
var Q;
(function(t) {
  t[t.DATA = 0] = "DATA", t[t.RCDATA = 1] = "RCDATA", t[t.RAWTEXT = 2] = "RAWTEXT", t[t.SCRIPT_DATA = 3] = "SCRIPT_DATA", t[t.PLAINTEXT = 4] = "PLAINTEXT", t[t.TAG_OPEN = 5] = "TAG_OPEN", t[t.END_TAG_OPEN = 6] = "END_TAG_OPEN", t[t.TAG_NAME = 7] = "TAG_NAME", t[t.RCDATA_LESS_THAN_SIGN = 8] = "RCDATA_LESS_THAN_SIGN", t[t.RCDATA_END_TAG_OPEN = 9] = "RCDATA_END_TAG_OPEN", t[t.RCDATA_END_TAG_NAME = 10] = "RCDATA_END_TAG_NAME", t[t.RAWTEXT_LESS_THAN_SIGN = 11] = "RAWTEXT_LESS_THAN_SIGN", t[t.RAWTEXT_END_TAG_OPEN = 
  12] = "RAWTEXT_END_TAG_OPEN", t[t.RAWTEXT_END_TAG_NAME = 13] = "RAWTEXT_END_TAG_NAME", t[t.SCRIPT_DATA_LESS_THAN_SIGN = 14] = "SCRIPT_DATA_LESS_THAN_SIGN", t[t.SCRIPT_DATA_END_TAG_OPEN = 15] = "SCRIPT_DATA_END_TAG_OPEN", t[t.SCRIPT_DATA_END_TAG_NAME = 16] = "SCRIPT_DATA_END_TAG_NAME", t[t.SCRIPT_DATA_ESCAPE_START = 17] = "SCRIPT_DATA_ESCAPE_START", t[t.SCRIPT_DATA_ESCAPE_START_DASH = 18] = "SCRIPT_DATA_ESCAPE_START_DASH", t[t.SCRIPT_DATA_ESCAPED = 19] = "SCRIPT_DATA_ESCAPED", t[t.SCRIPT_DATA_ESCAPED_DASH = 
  20] = "SCRIPT_DATA_ESCAPED_DASH", t[t.SCRIPT_DATA_ESCAPED_DASH_DASH = 21] = "SCRIPT_DATA_ESCAPED_DASH_DASH", t[t.SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN = 22] = "SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN", t[t.SCRIPT_DATA_ESCAPED_END_TAG_OPEN = 23] = "SCRIPT_DATA_ESCAPED_END_TAG_OPEN", t[t.SCRIPT_DATA_ESCAPED_END_TAG_NAME = 24] = "SCRIPT_DATA_ESCAPED_END_TAG_NAME", t[t.SCRIPT_DATA_DOUBLE_ESCAPE_START = 25] = "SCRIPT_DATA_DOUBLE_ESCAPE_START", t[t.SCRIPT_DATA_DOUBLE_ESCAPED = 26] = "SCRIPT_DATA_DOUBLE_ESCAPED", 
  t[t.SCRIPT_DATA_DOUBLE_ESCAPED_DASH = 27] = "SCRIPT_DATA_DOUBLE_ESCAPED_DASH", t[t.SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH = 28] = "SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH", t[t.SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN = 29] = "SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN", t[t.SCRIPT_DATA_DOUBLE_ESCAPE_END = 30] = "SCRIPT_DATA_DOUBLE_ESCAPE_END", t[t.BEFORE_ATTRIBUTE_NAME = 31] = "BEFORE_ATTRIBUTE_NAME", t[t.ATTRIBUTE_NAME = 32] = "ATTRIBUTE_NAME", t[t.AFTER_ATTRIBUTE_NAME = 33] = "AFTER_ATTRIBUTE_NAME", 
  t[t.BEFORE_ATTRIBUTE_VALUE = 34] = "BEFORE_ATTRIBUTE_VALUE", t[t.ATTRIBUTE_VALUE_DOUBLE_QUOTED = 35] = "ATTRIBUTE_VALUE_DOUBLE_QUOTED", t[t.ATTRIBUTE_VALUE_SINGLE_QUOTED = 36] = "ATTRIBUTE_VALUE_SINGLE_QUOTED", t[t.ATTRIBUTE_VALUE_UNQUOTED = 37] = "ATTRIBUTE_VALUE_UNQUOTED", t[t.AFTER_ATTRIBUTE_VALUE_QUOTED = 38] = "AFTER_ATTRIBUTE_VALUE_QUOTED", t[t.SELF_CLOSING_START_TAG = 39] = "SELF_CLOSING_START_TAG", t[t.BOGUS_COMMENT = 40] = "BOGUS_COMMENT", t[t.MARKUP_DECLARATION_OPEN = 41] = "MARKUP_DECLARATION_OPEN", 
  t[t.COMMENT_START = 42] = "COMMENT_START", t[t.COMMENT_START_DASH = 43] = "COMMENT_START_DASH", t[t.COMMENT = 44] = "COMMENT", t[t.COMMENT_LESS_THAN_SIGN = 45] = "COMMENT_LESS_THAN_SIGN", t[t.COMMENT_LESS_THAN_SIGN_BANG = 46] = "COMMENT_LESS_THAN_SIGN_BANG", t[t.COMMENT_LESS_THAN_SIGN_BANG_DASH = 47] = "COMMENT_LESS_THAN_SIGN_BANG_DASH", t[t.COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH = 48] = "COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH", t[t.COMMENT_END_DASH = 49] = "COMMENT_END_DASH", t[t.COMMENT_END = 50] = 
  "COMMENT_END", t[t.COMMENT_END_BANG = 51] = "COMMENT_END_BANG", t[t.DOCTYPE = 52] = "DOCTYPE", t[t.BEFORE_DOCTYPE_NAME = 53] = "BEFORE_DOCTYPE_NAME", t[t.DOCTYPE_NAME = 54] = "DOCTYPE_NAME", t[t.AFTER_DOCTYPE_NAME = 55] = "AFTER_DOCTYPE_NAME", t[t.AFTER_DOCTYPE_PUBLIC_KEYWORD = 56] = "AFTER_DOCTYPE_PUBLIC_KEYWORD", t[t.BEFORE_DOCTYPE_PUBLIC_IDENTIFIER = 57] = "BEFORE_DOCTYPE_PUBLIC_IDENTIFIER", t[t.DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED = 58] = "DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED", t[t.DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED = 
  59] = "DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED", t[t.AFTER_DOCTYPE_PUBLIC_IDENTIFIER = 60] = "AFTER_DOCTYPE_PUBLIC_IDENTIFIER", t[t.BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS = 61] = "BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS", t[t.AFTER_DOCTYPE_SYSTEM_KEYWORD = 62] = "AFTER_DOCTYPE_SYSTEM_KEYWORD", t[t.BEFORE_DOCTYPE_SYSTEM_IDENTIFIER = 63] = "BEFORE_DOCTYPE_SYSTEM_IDENTIFIER", t[t.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED = 64] = "DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED", t[t.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED = 
  65] = "DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED", t[t.AFTER_DOCTYPE_SYSTEM_IDENTIFIER = 66] = "AFTER_DOCTYPE_SYSTEM_IDENTIFIER", t[t.BOGUS_DOCTYPE = 67] = "BOGUS_DOCTYPE", t[t.CDATA_SECTION = 68] = "CDATA_SECTION", t[t.CDATA_SECTION_BRACKET = 69] = "CDATA_SECTION_BRACKET", t[t.CDATA_SECTION_END = 70] = "CDATA_SECTION_END", t[t.CHARACTER_REFERENCE = 71] = "CHARACTER_REFERENCE", t[t.AMBIGUOUS_AMPERSAND = 72] = "AMBIGUOUS_AMPERSAND";
})(Q || (Q = {}));
const jn = {DATA:Q.DATA, RCDATA:Q.RCDATA, RAWTEXT:Q.RAWTEXT, SCRIPT_DATA:Q.SCRIPT_DATA, PLAINTEXT:Q.PLAINTEXT, CDATA_SECTION:Q.CDATA_SECTION};
function I9(t) {
  return t >= Y.DIGIT_0 && t <= Y.DIGIT_9;
}
function cu(t) {
  return t >= Y.LATIN_CAPITAL_A && t <= Y.LATIN_CAPITAL_Z;
}
function O9(t) {
  return t >= Y.LATIN_SMALL_A && t <= Y.LATIN_SMALL_Z;
}
function Po(t) {
  return O9(t) || cu(t);
}
function v_(t) {
  return Po(t) || I9(t);
}
function Ah(t) {
  return t + 32;
}
function VC(t) {
  return t === Y.SPACE || t === Y.LINE_FEED || t === Y.TABULATION || t === Y.FORM_FEED;
}
function w_(t) {
  return VC(t) || t === Y.SOLIDUS || t === Y.GREATER_THAN_SIGN;
}
function P9(t) {
  return t === Y.NULL ? Se.nullCharacterReference : t > 1114111 ? Se.characterReferenceOutsideUnicodeRange : HC(t) ? Se.surrogateCharacterReference : WC(t) ? Se.noncharacterCharacterReference : UC(t) || t === Y.CARRIAGE_RETURN ? Se.controlCharacterReference : null;
}
class R9 {
  constructor(e, n) {
    this.options = e, this.handler = n, this.paused = !1, this.inLoop = !1, this.inForeignNode = !1, this.lastStartTagName = "", this.active = !1, this.state = Q.DATA, this.returnState = Q.DATA, this.entityStartPos = 0, this.consumedAfterSnapshot = -1, this.currentCharacterToken = null, this.currentToken = null, this.currentAttr = {name:"", value:""}, this.preprocessor = new y9(n), this.currentLocation = this.getCurrentLocation(-1), this.entityDecoder = new T9(x9, (r, i) => {
      this.preprocessor.pos = this.entityStartPos + i - 1, this._flushCodePointConsumedAsCharacterReference(r);
    }, n.onParseError ? {missingSemicolonAfterCharacterReference:() => {
      this._err(Se.missingSemicolonAfterCharacterReference, 1);
    }, absenceOfDigitsInNumericCharacterReference:r => {
      this._err(Se.absenceOfDigitsInNumericCharacterReference, this.entityStartPos - this.preprocessor.pos + r);
    }, validateNumericCharacterReference:r => {
      const i = P9(r);
      i && this._err(i, 1);
    }} : void 0);
  }
  _err(e, n = 0) {
    var r, i;
    (i = (r = this.handler).onParseError) === null || i === void 0 || i.call(r, this.preprocessor.getError(e, n));
  }
  getCurrentLocation(e) {
    return this.options.sourceCodeLocationInfo ? {startLine:this.preprocessor.line, startCol:this.preprocessor.col - e, startOffset:this.preprocessor.offset - e, endLine:-1, endCol:-1, endOffset:-1} : null;
  }
  _runParsingLoop() {
    if (!this.inLoop) {
      for (this.inLoop = !0; this.active && !this.paused;) {
        this.consumedAfterSnapshot = 0;
        const e = this._consume();
        this._ensureHibernation() || this._callState(e);
      }
      this.inLoop = !1;
    }
  }
  pause() {
    this.paused = !0;
  }
  resume(e) {
    if (!this.paused) {
      throw new Error("Parser was already resumed");
    }
    this.paused = !1, !this.inLoop && (this._runParsingLoop(), this.paused || e == null || e());
  }
  write(e, n, r) {
    this.active = !0, this.preprocessor.write(e, n), this._runParsingLoop(), this.paused || r == null || r();
  }
  insertHtmlAtCurrentPos(e) {
    this.active = !0, this.preprocessor.insertHtmlAtCurrentPos(e), this._runParsingLoop();
  }
  _ensureHibernation() {
    return this.preprocessor.endOfChunkHit ? (this.preprocessor.retreat(this.consumedAfterSnapshot), this.consumedAfterSnapshot = 0, this.active = !1, !0) : !1;
  }
  _consume() {
    return this.consumedAfterSnapshot++, this.preprocessor.advance();
  }
  _advanceBy(e) {
    this.consumedAfterSnapshot += e;
    for (let n = 0; n < e; n++) {
      this.preprocessor.advance();
    }
  }
  _consumeSequenceIfMatch(e, n) {
    return this.preprocessor.startsWith(e, n) ? (this._advanceBy(e.length - 1), !0) : !1;
  }
  _createStartTagToken() {
    this.currentToken = {type:Pt.START_TAG, tagName:"", tagID:S.UNKNOWN, selfClosing:!1, ackSelfClosing:!1, attrs:[], location:this.getCurrentLocation(1)};
  }
  _createEndTagToken() {
    this.currentToken = {type:Pt.END_TAG, tagName:"", tagID:S.UNKNOWN, selfClosing:!1, ackSelfClosing:!1, attrs:[], location:this.getCurrentLocation(2)};
  }
  _createCommentToken(e) {
    this.currentToken = {type:Pt.COMMENT, data:"", location:this.getCurrentLocation(e)};
  }
  _createDoctypeToken(e) {
    this.currentToken = {type:Pt.DOCTYPE, name:e, forceQuirks:!1, publicId:null, systemId:null, location:this.currentLocation};
  }
  _createCharacterToken(e, n) {
    this.currentCharacterToken = {type:e, chars:n, location:this.currentLocation};
  }
  _createAttr(e) {
    this.currentAttr = {name:e, value:""}, this.currentLocation = this.getCurrentLocation(0);
  }
  _leaveAttrName() {
    var e, n;
    const r = this.currentToken;
    if (jC(r, this.currentAttr.name) === null) {
      if (r.attrs.push(this.currentAttr), r.location && this.currentLocation) {
        const i = (e = (n = r.location).attrs) !== null && e !== void 0 ? e : n.attrs = Object.create(null);
        i[this.currentAttr.name] = this.currentLocation, this._leaveAttrValue();
      }
    } else {
      this._err(Se.duplicateAttribute);
    }
  }
  _leaveAttrValue() {
    this.currentLocation && (this.currentLocation.endLine = this.preprocessor.line, this.currentLocation.endCol = this.preprocessor.col, this.currentLocation.endOffset = this.preprocessor.offset);
  }
  prepareToken(e) {
    this._emitCurrentCharacterToken(e.location), this.currentToken = null, e.location && (e.location.endLine = this.preprocessor.line, e.location.endCol = this.preprocessor.col + 1, e.location.endOffset = this.preprocessor.offset + 1), this.currentLocation = this.getCurrentLocation(-1);
  }
  emitCurrentTagToken() {
    const e = this.currentToken;
    this.prepareToken(e), e.tagID = Tc(e.tagName), e.type === Pt.START_TAG ? (this.lastStartTagName = e.tagName, this.handler.onStartTag(e)) : (e.attrs.length > 0 && this._err(Se.endTagWithAttributes), e.selfClosing && this._err(Se.endTagWithTrailingSolidus), this.handler.onEndTag(e)), this.preprocessor.dropParsedChunk();
  }
  emitCurrentComment(e) {
    this.prepareToken(e), this.handler.onComment(e), this.preprocessor.dropParsedChunk();
  }
  emitCurrentDoctype(e) {
    this.prepareToken(e), this.handler.onDoctype(e), this.preprocessor.dropParsedChunk();
  }
  _emitCurrentCharacterToken(e) {
    if (this.currentCharacterToken) {
      switch(e && this.currentCharacterToken.location && (this.currentCharacterToken.location.endLine = e.startLine, this.currentCharacterToken.location.endCol = e.startCol, this.currentCharacterToken.location.endOffset = e.startOffset), this.currentCharacterToken.type) {
        case Pt.CHARACTER:
          {
            this.handler.onCharacter(this.currentCharacterToken);
            break;
          }
        case Pt.NULL_CHARACTER:
          {
            this.handler.onNullCharacter(this.currentCharacterToken);
            break;
          }
        case Pt.WHITESPACE_CHARACTER:
          {
            this.handler.onWhitespaceCharacter(this.currentCharacterToken);
            break;
          }
      }
      this.currentCharacterToken = null;
    }
  }
  _emitEOFToken() {
    const e = this.getCurrentLocation(0);
    e && (e.endLine = e.startLine, e.endCol = e.startCol, e.endOffset = e.startOffset), this._emitCurrentCharacterToken(e), this.handler.onEof({type:Pt.EOF, location:e}), this.active = !1;
  }
  _appendCharToCurrentCharacterToken(e, n) {
    if (this.currentCharacterToken) {
      if (this.currentCharacterToken.type === e) {
        this.currentCharacterToken.chars += n;
        return;
      } else {
        this.currentLocation = this.getCurrentLocation(0), this._emitCurrentCharacterToken(this.currentLocation), this.preprocessor.dropParsedChunk();
      }
    }
    this._createCharacterToken(e, n);
  }
  _emitCodePoint(e) {
    const n = VC(e) ? Pt.WHITESPACE_CHARACTER : e === Y.NULL ? Pt.NULL_CHARACTER : Pt.CHARACTER;
    this._appendCharToCurrentCharacterToken(n, String.fromCodePoint(e));
  }
  _emitChars(e) {
    this._appendCharToCurrentCharacterToken(Pt.CHARACTER, e);
  }
  _startCharacterReference() {
    this.returnState = this.state, this.state = Q.CHARACTER_REFERENCE, this.entityStartPos = this.preprocessor.pos, this.entityDecoder.startEntity(this._isCharacterReferenceInAttribute() ? to.Attribute : to.Legacy);
  }
  _isCharacterReferenceInAttribute() {
    return this.returnState === Q.ATTRIBUTE_VALUE_DOUBLE_QUOTED || this.returnState === Q.ATTRIBUTE_VALUE_SINGLE_QUOTED || this.returnState === Q.ATTRIBUTE_VALUE_UNQUOTED;
  }
  _flushCodePointConsumedAsCharacterReference(e) {
    this._isCharacterReferenceInAttribute() ? this.currentAttr.value += String.fromCodePoint(e) : this._emitCodePoint(e);
  }
  _callState(e) {
    switch(this.state) {
      case Q.DATA:
        {
          this._stateData(e);
          break;
        }
      case Q.RCDATA:
        {
          this._stateRcdata(e);
          break;
        }
      case Q.RAWTEXT:
        {
          this._stateRawtext(e);
          break;
        }
      case Q.SCRIPT_DATA:
        {
          this._stateScriptData(e);
          break;
        }
      case Q.PLAINTEXT:
        {
          this._statePlaintext(e);
          break;
        }
      case Q.TAG_OPEN:
        {
          this._stateTagOpen(e);
          break;
        }
      case Q.END_TAG_OPEN:
        {
          this._stateEndTagOpen(e);
          break;
        }
      case Q.TAG_NAME:
        {
          this._stateTagName(e);
          break;
        }
      case Q.RCDATA_LESS_THAN_SIGN:
        {
          this._stateRcdataLessThanSign(e);
          break;
        }
      case Q.RCDATA_END_TAG_OPEN:
        {
          this._stateRcdataEndTagOpen(e);
          break;
        }
      case Q.RCDATA_END_TAG_NAME:
        {
          this._stateRcdataEndTagName(e);
          break;
        }
      case Q.RAWTEXT_LESS_THAN_SIGN:
        {
          this._stateRawtextLessThanSign(e);
          break;
        }
      case Q.RAWTEXT_END_TAG_OPEN:
        {
          this._stateRawtextEndTagOpen(e);
          break;
        }
      case Q.RAWTEXT_END_TAG_NAME:
        {
          this._stateRawtextEndTagName(e);
          break;
        }
      case Q.SCRIPT_DATA_LESS_THAN_SIGN:
        {
          this._stateScriptDataLessThanSign(e);
          break;
        }
      case Q.SCRIPT_DATA_END_TAG_OPEN:
        {
          this._stateScriptDataEndTagOpen(e);
          break;
        }
      case Q.SCRIPT_DATA_END_TAG_NAME:
        {
          this._stateScriptDataEndTagName(e);
          break;
        }
      case Q.SCRIPT_DATA_ESCAPE_START:
        {
          this._stateScriptDataEscapeStart(e);
          break;
        }
      case Q.SCRIPT_DATA_ESCAPE_START_DASH:
        {
          this._stateScriptDataEscapeStartDash(e);
          break;
        }
      case Q.SCRIPT_DATA_ESCAPED:
        {
          this._stateScriptDataEscaped(e);
          break;
        }
      case Q.SCRIPT_DATA_ESCAPED_DASH:
        {
          this._stateScriptDataEscapedDash(e);
          break;
        }
      case Q.SCRIPT_DATA_ESCAPED_DASH_DASH:
        {
          this._stateScriptDataEscapedDashDash(e);
          break;
        }
      case Q.SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN:
        {
          this._stateScriptDataEscapedLessThanSign(e);
          break;
        }
      case Q.SCRIPT_DATA_ESCAPED_END_TAG_OPEN:
        {
          this._stateScriptDataEscapedEndTagOpen(e);
          break;
        }
      case Q.SCRIPT_DATA_ESCAPED_END_TAG_NAME:
        {
          this._stateScriptDataEscapedEndTagName(e);
          break;
        }
      case Q.SCRIPT_DATA_DOUBLE_ESCAPE_START:
        {
          this._stateScriptDataDoubleEscapeStart(e);
          break;
        }
      case Q.SCRIPT_DATA_DOUBLE_ESCAPED:
        {
          this._stateScriptDataDoubleEscaped(e);
          break;
        }
      case Q.SCRIPT_DATA_DOUBLE_ESCAPED_DASH:
        {
          this._stateScriptDataDoubleEscapedDash(e);
          break;
        }
      case Q.SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH:
        {
          this._stateScriptDataDoubleEscapedDashDash(e);
          break;
        }
      case Q.SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN:
        {
          this._stateScriptDataDoubleEscapedLessThanSign(e);
          break;
        }
      case Q.SCRIPT_DATA_DOUBLE_ESCAPE_END:
        {
          this._stateScriptDataDoubleEscapeEnd(e);
          break;
        }
      case Q.BEFORE_ATTRIBUTE_NAME:
        {
          this._stateBeforeAttributeName(e);
          break;
        }
      case Q.ATTRIBUTE_NAME:
        {
          this._stateAttributeName(e);
          break;
        }
      case Q.AFTER_ATTRIBUTE_NAME:
        {
          this._stateAfterAttributeName(e);
          break;
        }
      case Q.BEFORE_ATTRIBUTE_VALUE:
        {
          this._stateBeforeAttributeValue(e);
          break;
        }
      case Q.ATTRIBUTE_VALUE_DOUBLE_QUOTED:
        {
          this._stateAttributeValueDoubleQuoted(e);
          break;
        }
      case Q.ATTRIBUTE_VALUE_SINGLE_QUOTED:
        {
          this._stateAttributeValueSingleQuoted(e);
          break;
        }
      case Q.ATTRIBUTE_VALUE_UNQUOTED:
        {
          this._stateAttributeValueUnquoted(e);
          break;
        }
      case Q.AFTER_ATTRIBUTE_VALUE_QUOTED:
        {
          this._stateAfterAttributeValueQuoted(e);
          break;
        }
      case Q.SELF_CLOSING_START_TAG:
        {
          this._stateSelfClosingStartTag(e);
          break;
        }
      case Q.BOGUS_COMMENT:
        {
          this._stateBogusComment(e);
          break;
        }
      case Q.MARKUP_DECLARATION_OPEN:
        {
          this._stateMarkupDeclarationOpen(e);
          break;
        }
      case Q.COMMENT_START:
        {
          this._stateCommentStart(e);
          break;
        }
      case Q.COMMENT_START_DASH:
        {
          this._stateCommentStartDash(e);
          break;
        }
      case Q.COMMENT:
        {
          this._stateComment(e);
          break;
        }
      case Q.COMMENT_LESS_THAN_SIGN:
        {
          this._stateCommentLessThanSign(e);
          break;
        }
      case Q.COMMENT_LESS_THAN_SIGN_BANG:
        {
          this._stateCommentLessThanSignBang(e);
          break;
        }
      case Q.COMMENT_LESS_THAN_SIGN_BANG_DASH:
        {
          this._stateCommentLessThanSignBangDash(e);
          break;
        }
      case Q.COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH:
        {
          this._stateCommentLessThanSignBangDashDash(e);
          break;
        }
      case Q.COMMENT_END_DASH:
        {
          this._stateCommentEndDash(e);
          break;
        }
      case Q.COMMENT_END:
        {
          this._stateCommentEnd(e);
          break;
        }
      case Q.COMMENT_END_BANG:
        {
          this._stateCommentEndBang(e);
          break;
        }
      case Q.DOCTYPE:
        {
          this._stateDoctype(e);
          break;
        }
      case Q.BEFORE_DOCTYPE_NAME:
        {
          this._stateBeforeDoctypeName(e);
          break;
        }
      case Q.DOCTYPE_NAME:
        {
          this._stateDoctypeName(e);
          break;
        }
      case Q.AFTER_DOCTYPE_NAME:
        {
          this._stateAfterDoctypeName(e);
          break;
        }
      case Q.AFTER_DOCTYPE_PUBLIC_KEYWORD:
        {
          this._stateAfterDoctypePublicKeyword(e);
          break;
        }
      case Q.BEFORE_DOCTYPE_PUBLIC_IDENTIFIER:
        {
          this._stateBeforeDoctypePublicIdentifier(e);
          break;
        }
      case Q.DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED:
        {
          this._stateDoctypePublicIdentifierDoubleQuoted(e);
          break;
        }
      case Q.DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED:
        {
          this._stateDoctypePublicIdentifierSingleQuoted(e);
          break;
        }
      case Q.AFTER_DOCTYPE_PUBLIC_IDENTIFIER:
        {
          this._stateAfterDoctypePublicIdentifier(e);
          break;
        }
      case Q.BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS:
        {
          this._stateBetweenDoctypePublicAndSystemIdentifiers(e);
          break;
        }
      case Q.AFTER_DOCTYPE_SYSTEM_KEYWORD:
        {
          this._stateAfterDoctypeSystemKeyword(e);
          break;
        }
      case Q.BEFORE_DOCTYPE_SYSTEM_IDENTIFIER:
        {
          this._stateBeforeDoctypeSystemIdentifier(e);
          break;
        }
      case Q.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED:
        {
          this._stateDoctypeSystemIdentifierDoubleQuoted(e);
          break;
        }
      case Q.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED:
        {
          this._stateDoctypeSystemIdentifierSingleQuoted(e);
          break;
        }
      case Q.AFTER_DOCTYPE_SYSTEM_IDENTIFIER:
        {
          this._stateAfterDoctypeSystemIdentifier(e);
          break;
        }
      case Q.BOGUS_DOCTYPE:
        {
          this._stateBogusDoctype(e);
          break;
        }
      case Q.CDATA_SECTION:
        {
          this._stateCdataSection(e);
          break;
        }
      case Q.CDATA_SECTION_BRACKET:
        {
          this._stateCdataSectionBracket(e);
          break;
        }
      case Q.CDATA_SECTION_END:
        {
          this._stateCdataSectionEnd(e);
          break;
        }
      case Q.CHARACTER_REFERENCE:
        {
          this._stateCharacterReference();
          break;
        }
      case Q.AMBIGUOUS_AMPERSAND:
        {
          this._stateAmbiguousAmpersand(e);
          break;
        }
      default:
        throw new Error("Unknown state");
    }
  }
  _stateData(e) {
    switch(e) {
      case Y.LESS_THAN_SIGN:
        {
          this.state = Q.TAG_OPEN;
          break;
        }
      case Y.AMPERSAND:
        {
          this._startCharacterReference();
          break;
        }
      case Y.NULL:
        {
          this._err(Se.unexpectedNullCharacter), this._emitCodePoint(e);
          break;
        }
      case Y.EOF:
        {
          this._emitEOFToken();
          break;
        }
      default:
        this._emitCodePoint(e);
    }
  }
  _stateRcdata(e) {
    switch(e) {
      case Y.AMPERSAND:
        {
          this._startCharacterReference();
          break;
        }
      case Y.LESS_THAN_SIGN:
        {
          this.state = Q.RCDATA_LESS_THAN_SIGN;
          break;
        }
      case Y.NULL:
        {
          this._err(Se.unexpectedNullCharacter), this._emitChars(Tn);
          break;
        }
      case Y.EOF:
        {
          this._emitEOFToken();
          break;
        }
      default:
        this._emitCodePoint(e);
    }
  }
  _stateRawtext(e) {
    switch(e) {
      case Y.LESS_THAN_SIGN:
        {
          this.state = Q.RAWTEXT_LESS_THAN_SIGN;
          break;
        }
      case Y.NULL:
        {
          this._err(Se.unexpectedNullCharacter), this._emitChars(Tn);
          break;
        }
      case Y.EOF:
        {
          this._emitEOFToken();
          break;
        }
      default:
        this._emitCodePoint(e);
    }
  }
  _stateScriptData(e) {
    switch(e) {
      case Y.LESS_THAN_SIGN:
        {
          this.state = Q.SCRIPT_DATA_LESS_THAN_SIGN;
          break;
        }
      case Y.NULL:
        {
          this._err(Se.unexpectedNullCharacter), this._emitChars(Tn);
          break;
        }
      case Y.EOF:
        {
          this._emitEOFToken();
          break;
        }
      default:
        this._emitCodePoint(e);
    }
  }
  _statePlaintext(e) {
    switch(e) {
      case Y.NULL:
        {
          this._err(Se.unexpectedNullCharacter), this._emitChars(Tn);
          break;
        }
      case Y.EOF:
        {
          this._emitEOFToken();
          break;
        }
      default:
        this._emitCodePoint(e);
    }
  }
  _stateTagOpen(e) {
    if (Po(e)) {
      this._createStartTagToken(), this.state = Q.TAG_NAME, this._stateTagName(e);
    } else {
      switch(e) {
        case Y.EXCLAMATION_MARK:
          {
            this.state = Q.MARKUP_DECLARATION_OPEN;
            break;
          }
        case Y.SOLIDUS:
          {
            this.state = Q.END_TAG_OPEN;
            break;
          }
        case Y.QUESTION_MARK:
          {
            this._err(Se.unexpectedQuestionMarkInsteadOfTagName), this._createCommentToken(1), this.state = Q.BOGUS_COMMENT, this._stateBogusComment(e);
            break;
          }
        case Y.EOF:
          {
            this._err(Se.eofBeforeTagName), this._emitChars("\x3c"), this._emitEOFToken();
            break;
          }
        default:
          this._err(Se.invalidFirstCharacterOfTagName), this._emitChars("\x3c"), this.state = Q.DATA, this._stateData(e);
      }
    }
  }
  _stateEndTagOpen(e) {
    if (Po(e)) {
      this._createEndTagToken(), this.state = Q.TAG_NAME, this._stateTagName(e);
    } else {
      switch(e) {
        case Y.GREATER_THAN_SIGN:
          {
            this._err(Se.missingEndTagName), this.state = Q.DATA;
            break;
          }
        case Y.EOF:
          {
            this._err(Se.eofBeforeTagName), this._emitChars("\x3c/"), this._emitEOFToken();
            break;
          }
        default:
          this._err(Se.invalidFirstCharacterOfTagName), this._createCommentToken(2), this.state = Q.BOGUS_COMMENT, this._stateBogusComment(e);
      }
    }
  }
  _stateTagName(e) {
    const n = this.currentToken;
    switch(e) {
      case Y.SPACE:
      case Y.LINE_FEED:
      case Y.TABULATION:
      case Y.FORM_FEED:
        {
          this.state = Q.BEFORE_ATTRIBUTE_NAME;
          break;
        }
      case Y.SOLIDUS:
        {
          this.state = Q.SELF_CLOSING_START_TAG;
          break;
        }
      case Y.GREATER_THAN_SIGN:
        {
          this.state = Q.DATA, this.emitCurrentTagToken();
          break;
        }
      case Y.NULL:
        {
          this._err(Se.unexpectedNullCharacter), n.tagName += Tn;
          break;
        }
      case Y.EOF:
        {
          this._err(Se.eofInTag), this._emitEOFToken();
          break;
        }
      default:
        n.tagName += String.fromCodePoint(cu(e) ? Ah(e) : e);
    }
  }
  _stateRcdataLessThanSign(e) {
    e === Y.SOLIDUS ? this.state = Q.RCDATA_END_TAG_OPEN : (this._emitChars("\x3c"), this.state = Q.RCDATA, this._stateRcdata(e));
  }
  _stateRcdataEndTagOpen(e) {
    Po(e) ? (this.state = Q.RCDATA_END_TAG_NAME, this._stateRcdataEndTagName(e)) : (this._emitChars("\x3c/"), this.state = Q.RCDATA, this._stateRcdata(e));
  }
  handleSpecialEndTag(e) {
    if (!this.preprocessor.startsWith(this.lastStartTagName, !1)) {
      return !this._ensureHibernation();
    }
    this._createEndTagToken();
    const n = this.currentToken;
    switch(n.tagName = this.lastStartTagName, this.preprocessor.peek(this.lastStartTagName.length)) {
      case Y.SPACE:
      case Y.LINE_FEED:
      case Y.TABULATION:
      case Y.FORM_FEED:
        return this._advanceBy(this.lastStartTagName.length), this.state = Q.BEFORE_ATTRIBUTE_NAME, !1;
      case Y.SOLIDUS:
        return this._advanceBy(this.lastStartTagName.length), this.state = Q.SELF_CLOSING_START_TAG, !1;
      case Y.GREATER_THAN_SIGN:
        return this._advanceBy(this.lastStartTagName.length), this.emitCurrentTagToken(), this.state = Q.DATA, !1;
      default:
        return !this._ensureHibernation();
    }
  }
  _stateRcdataEndTagName(e) {
    this.handleSpecialEndTag(e) && (this._emitChars("\x3c/"), this.state = Q.RCDATA, this._stateRcdata(e));
  }
  _stateRawtextLessThanSign(e) {
    e === Y.SOLIDUS ? this.state = Q.RAWTEXT_END_TAG_OPEN : (this._emitChars("\x3c"), this.state = Q.RAWTEXT, this._stateRawtext(e));
  }
  _stateRawtextEndTagOpen(e) {
    Po(e) ? (this.state = Q.RAWTEXT_END_TAG_NAME, this._stateRawtextEndTagName(e)) : (this._emitChars("\x3c/"), this.state = Q.RAWTEXT, this._stateRawtext(e));
  }
  _stateRawtextEndTagName(e) {
    this.handleSpecialEndTag(e) && (this._emitChars("\x3c/"), this.state = Q.RAWTEXT, this._stateRawtext(e));
  }
  _stateScriptDataLessThanSign(e) {
    switch(e) {
      case Y.SOLIDUS:
        {
          this.state = Q.SCRIPT_DATA_END_TAG_OPEN;
          break;
        }
      case Y.EXCLAMATION_MARK:
        {
          this.state = Q.SCRIPT_DATA_ESCAPE_START, this._emitChars("\x3c!");
          break;
        }
      default:
        this._emitChars("\x3c"), this.state = Q.SCRIPT_DATA, this._stateScriptData(e);
    }
  }
  _stateScriptDataEndTagOpen(e) {
    Po(e) ? (this.state = Q.SCRIPT_DATA_END_TAG_NAME, this._stateScriptDataEndTagName(e)) : (this._emitChars("\x3c/"), this.state = Q.SCRIPT_DATA, this._stateScriptData(e));
  }
  _stateScriptDataEndTagName(e) {
    this.handleSpecialEndTag(e) && (this._emitChars("\x3c/"), this.state = Q.SCRIPT_DATA, this._stateScriptData(e));
  }
  _stateScriptDataEscapeStart(e) {
    e === Y.HYPHEN_MINUS ? (this.state = Q.SCRIPT_DATA_ESCAPE_START_DASH, this._emitChars("-")) : (this.state = Q.SCRIPT_DATA, this._stateScriptData(e));
  }
  _stateScriptDataEscapeStartDash(e) {
    e === Y.HYPHEN_MINUS ? (this.state = Q.SCRIPT_DATA_ESCAPED_DASH_DASH, this._emitChars("-")) : (this.state = Q.SCRIPT_DATA, this._stateScriptData(e));
  }
  _stateScriptDataEscaped(e) {
    switch(e) {
      case Y.HYPHEN_MINUS:
        {
          this.state = Q.SCRIPT_DATA_ESCAPED_DASH, this._emitChars("-");
          break;
        }
      case Y.LESS_THAN_SIGN:
        {
          this.state = Q.SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN;
          break;
        }
      case Y.NULL:
        {
          this._err(Se.unexpectedNullCharacter), this._emitChars(Tn);
          break;
        }
      case Y.EOF:
        {
          this._err(Se.eofInScriptHtmlCommentLikeText), this._emitEOFToken();
          break;
        }
      default:
        this._emitCodePoint(e);
    }
  }
  _stateScriptDataEscapedDash(e) {
    switch(e) {
      case Y.HYPHEN_MINUS:
        {
          this.state = Q.SCRIPT_DATA_ESCAPED_DASH_DASH, this._emitChars("-");
          break;
        }
      case Y.LESS_THAN_SIGN:
        {
          this.state = Q.SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN;
          break;
        }
      case Y.NULL:
        {
          this._err(Se.unexpectedNullCharacter), this.state = Q.SCRIPT_DATA_ESCAPED, this._emitChars(Tn);
          break;
        }
      case Y.EOF:
        {
          this._err(Se.eofInScriptHtmlCommentLikeText), this._emitEOFToken();
          break;
        }
      default:
        this.state = Q.SCRIPT_DATA_ESCAPED, this._emitCodePoint(e);
    }
  }
  _stateScriptDataEscapedDashDash(e) {
    switch(e) {
      case Y.HYPHEN_MINUS:
        {
          this._emitChars("-");
          break;
        }
      case Y.LESS_THAN_SIGN:
        {
          this.state = Q.SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN;
          break;
        }
      case Y.GREATER_THAN_SIGN:
        {
          this.state = Q.SCRIPT_DATA, this._emitChars("\x3e");
          break;
        }
      case Y.NULL:
        {
          this._err(Se.unexpectedNullCharacter), this.state = Q.SCRIPT_DATA_ESCAPED, this._emitChars(Tn);
          break;
        }
      case Y.EOF:
        {
          this._err(Se.eofInScriptHtmlCommentLikeText), this._emitEOFToken();
          break;
        }
      default:
        this.state = Q.SCRIPT_DATA_ESCAPED, this._emitCodePoint(e);
    }
  }
  _stateScriptDataEscapedLessThanSign(e) {
    e === Y.SOLIDUS ? this.state = Q.SCRIPT_DATA_ESCAPED_END_TAG_OPEN : Po(e) ? (this._emitChars("\x3c"), this.state = Q.SCRIPT_DATA_DOUBLE_ESCAPE_START, this._stateScriptDataDoubleEscapeStart(e)) : (this._emitChars("\x3c"), this.state = Q.SCRIPT_DATA_ESCAPED, this._stateScriptDataEscaped(e));
  }
  _stateScriptDataEscapedEndTagOpen(e) {
    Po(e) ? (this.state = Q.SCRIPT_DATA_ESCAPED_END_TAG_NAME, this._stateScriptDataEscapedEndTagName(e)) : (this._emitChars("\x3c/"), this.state = Q.SCRIPT_DATA_ESCAPED, this._stateScriptDataEscaped(e));
  }
  _stateScriptDataEscapedEndTagName(e) {
    this.handleSpecialEndTag(e) && (this._emitChars("\x3c/"), this.state = Q.SCRIPT_DATA_ESCAPED, this._stateScriptDataEscaped(e));
  }
  _stateScriptDataDoubleEscapeStart(e) {
    if (this.preprocessor.startsWith(Gr.SCRIPT, !1) && w_(this.preprocessor.peek(Gr.SCRIPT.length))) {
      this._emitCodePoint(e);
      for (let n = 0; n < Gr.SCRIPT.length; n++) {
        this._emitCodePoint(this._consume());
      }
      this.state = Q.SCRIPT_DATA_DOUBLE_ESCAPED;
    } else {
      this._ensureHibernation() || (this.state = Q.SCRIPT_DATA_ESCAPED, this._stateScriptDataEscaped(e));
    }
  }
  _stateScriptDataDoubleEscaped(e) {
    switch(e) {
      case Y.HYPHEN_MINUS:
        {
          this.state = Q.SCRIPT_DATA_DOUBLE_ESCAPED_DASH, this._emitChars("-");
          break;
        }
      case Y.LESS_THAN_SIGN:
        {
          this.state = Q.SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN, this._emitChars("\x3c");
          break;
        }
      case Y.NULL:
        {
          this._err(Se.unexpectedNullCharacter), this._emitChars(Tn);
          break;
        }
      case Y.EOF:
        {
          this._err(Se.eofInScriptHtmlCommentLikeText), this._emitEOFToken();
          break;
        }
      default:
        this._emitCodePoint(e);
    }
  }
  _stateScriptDataDoubleEscapedDash(e) {
    switch(e) {
      case Y.HYPHEN_MINUS:
        {
          this.state = Q.SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH, this._emitChars("-");
          break;
        }
      case Y.LESS_THAN_SIGN:
        {
          this.state = Q.SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN, this._emitChars("\x3c");
          break;
        }
      case Y.NULL:
        {
          this._err(Se.unexpectedNullCharacter), this.state = Q.SCRIPT_DATA_DOUBLE_ESCAPED, this._emitChars(Tn);
          break;
        }
      case Y.EOF:
        {
          this._err(Se.eofInScriptHtmlCommentLikeText), this._emitEOFToken();
          break;
        }
      default:
        this.state = Q.SCRIPT_DATA_DOUBLE_ESCAPED, this._emitCodePoint(e);
    }
  }
  _stateScriptDataDoubleEscapedDashDash(e) {
    switch(e) {
      case Y.HYPHEN_MINUS:
        {
          this._emitChars("-");
          break;
        }
      case Y.LESS_THAN_SIGN:
        {
          this.state = Q.SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN, this._emitChars("\x3c");
          break;
        }
      case Y.GREATER_THAN_SIGN:
        {
          this.state = Q.SCRIPT_DATA, this._emitChars("\x3e");
          break;
        }
      case Y.NULL:
        {
          this._err(Se.unexpectedNullCharacter), this.state = Q.SCRIPT_DATA_DOUBLE_ESCAPED, this._emitChars(Tn);
          break;
        }
      case Y.EOF:
        {
          this._err(Se.eofInScriptHtmlCommentLikeText), this._emitEOFToken();
          break;
        }
      default:
        this.state = Q.SCRIPT_DATA_DOUBLE_ESCAPED, this._emitCodePoint(e);
    }
  }
  _stateScriptDataDoubleEscapedLessThanSign(e) {
    e === Y.SOLIDUS ? (this.state = Q.SCRIPT_DATA_DOUBLE_ESCAPE_END, this._emitChars("/")) : (this.state = Q.SCRIPT_DATA_DOUBLE_ESCAPED, this._stateScriptDataDoubleEscaped(e));
  }
  _stateScriptDataDoubleEscapeEnd(e) {
    if (this.preprocessor.startsWith(Gr.SCRIPT, !1) && w_(this.preprocessor.peek(Gr.SCRIPT.length))) {
      this._emitCodePoint(e);
      for (let n = 0; n < Gr.SCRIPT.length; n++) {
        this._emitCodePoint(this._consume());
      }
      this.state = Q.SCRIPT_DATA_ESCAPED;
    } else {
      this._ensureHibernation() || (this.state = Q.SCRIPT_DATA_DOUBLE_ESCAPED, this._stateScriptDataDoubleEscaped(e));
    }
  }
  _stateBeforeAttributeName(e) {
    switch(e) {
      case Y.SPACE:
      case Y.LINE_FEED:
      case Y.TABULATION:
      case Y.FORM_FEED:
        break;
      case Y.SOLIDUS:
      case Y.GREATER_THAN_SIGN:
      case Y.EOF:
        {
          this.state = Q.AFTER_ATTRIBUTE_NAME, this._stateAfterAttributeName(e);
          break;
        }
      case Y.EQUALS_SIGN:
        {
          this._err(Se.unexpectedEqualsSignBeforeAttributeName), this._createAttr("\x3d"), this.state = Q.ATTRIBUTE_NAME;
          break;
        }
      default:
        this._createAttr(""), this.state = Q.ATTRIBUTE_NAME, this._stateAttributeName(e);
    }
  }
  _stateAttributeName(e) {
    switch(e) {
      case Y.SPACE:
      case Y.LINE_FEED:
      case Y.TABULATION:
      case Y.FORM_FEED:
      case Y.SOLIDUS:
      case Y.GREATER_THAN_SIGN:
      case Y.EOF:
        {
          this._leaveAttrName(), this.state = Q.AFTER_ATTRIBUTE_NAME, this._stateAfterAttributeName(e);
          break;
        }
      case Y.EQUALS_SIGN:
        {
          this._leaveAttrName(), this.state = Q.BEFORE_ATTRIBUTE_VALUE;
          break;
        }
      case Y.QUOTATION_MARK:
      case Y.APOSTROPHE:
      case Y.LESS_THAN_SIGN:
        {
          this._err(Se.unexpectedCharacterInAttributeName), this.currentAttr.name += String.fromCodePoint(e);
          break;
        }
      case Y.NULL:
        {
          this._err(Se.unexpectedNullCharacter), this.currentAttr.name += Tn;
          break;
        }
      default:
        this.currentAttr.name += String.fromCodePoint(cu(e) ? Ah(e) : e);
    }
  }
  _stateAfterAttributeName(e) {
    switch(e) {
      case Y.SPACE:
      case Y.LINE_FEED:
      case Y.TABULATION:
      case Y.FORM_FEED:
        break;
      case Y.SOLIDUS:
        {
          this.state = Q.SELF_CLOSING_START_TAG;
          break;
        }
      case Y.EQUALS_SIGN:
        {
          this.state = Q.BEFORE_ATTRIBUTE_VALUE;
          break;
        }
      case Y.GREATER_THAN_SIGN:
        {
          this.state = Q.DATA, this.emitCurrentTagToken();
          break;
        }
      case Y.EOF:
        {
          this._err(Se.eofInTag), this._emitEOFToken();
          break;
        }
      default:
        this._createAttr(""), this.state = Q.ATTRIBUTE_NAME, this._stateAttributeName(e);
    }
  }
  _stateBeforeAttributeValue(e) {
    switch(e) {
      case Y.SPACE:
      case Y.LINE_FEED:
      case Y.TABULATION:
      case Y.FORM_FEED:
        break;
      case Y.QUOTATION_MARK:
        {
          this.state = Q.ATTRIBUTE_VALUE_DOUBLE_QUOTED;
          break;
        }
      case Y.APOSTROPHE:
        {
          this.state = Q.ATTRIBUTE_VALUE_SINGLE_QUOTED;
          break;
        }
      case Y.GREATER_THAN_SIGN:
        {
          this._err(Se.missingAttributeValue), this.state = Q.DATA, this.emitCurrentTagToken();
          break;
        }
      default:
        this.state = Q.ATTRIBUTE_VALUE_UNQUOTED, this._stateAttributeValueUnquoted(e);
    }
  }
  _stateAttributeValueDoubleQuoted(e) {
    switch(e) {
      case Y.QUOTATION_MARK:
        {
          this.state = Q.AFTER_ATTRIBUTE_VALUE_QUOTED;
          break;
        }
      case Y.AMPERSAND:
        {
          this._startCharacterReference();
          break;
        }
      case Y.NULL:
        {
          this._err(Se.unexpectedNullCharacter), this.currentAttr.value += Tn;
          break;
        }
      case Y.EOF:
        {
          this._err(Se.eofInTag), this._emitEOFToken();
          break;
        }
      default:
        this.currentAttr.value += String.fromCodePoint(e);
    }
  }
  _stateAttributeValueSingleQuoted(e) {
    switch(e) {
      case Y.APOSTROPHE:
        {
          this.state = Q.AFTER_ATTRIBUTE_VALUE_QUOTED;
          break;
        }
      case Y.AMPERSAND:
        {
          this._startCharacterReference();
          break;
        }
      case Y.NULL:
        {
          this._err(Se.unexpectedNullCharacter), this.currentAttr.value += Tn;
          break;
        }
      case Y.EOF:
        {
          this._err(Se.eofInTag), this._emitEOFToken();
          break;
        }
      default:
        this.currentAttr.value += String.fromCodePoint(e);
    }
  }
  _stateAttributeValueUnquoted(e) {
    switch(e) {
      case Y.SPACE:
      case Y.LINE_FEED:
      case Y.TABULATION:
      case Y.FORM_FEED:
        {
          this._leaveAttrValue(), this.state = Q.BEFORE_ATTRIBUTE_NAME;
          break;
        }
      case Y.AMPERSAND:
        {
          this._startCharacterReference();
          break;
        }
      case Y.GREATER_THAN_SIGN:
        {
          this._leaveAttrValue(), this.state = Q.DATA, this.emitCurrentTagToken();
          break;
        }
      case Y.NULL:
        {
          this._err(Se.unexpectedNullCharacter), this.currentAttr.value += Tn;
          break;
        }
      case Y.QUOTATION_MARK:
      case Y.APOSTROPHE:
      case Y.LESS_THAN_SIGN:
      case Y.EQUALS_SIGN:
      case Y.GRAVE_ACCENT:
        {
          this._err(Se.unexpectedCharacterInUnquotedAttributeValue), this.currentAttr.value += String.fromCodePoint(e);
          break;
        }
      case Y.EOF:
        {
          this._err(Se.eofInTag), this._emitEOFToken();
          break;
        }
      default:
        this.currentAttr.value += String.fromCodePoint(e);
    }
  }
  _stateAfterAttributeValueQuoted(e) {
    switch(e) {
      case Y.SPACE:
      case Y.LINE_FEED:
      case Y.TABULATION:
      case Y.FORM_FEED:
        {
          this._leaveAttrValue(), this.state = Q.BEFORE_ATTRIBUTE_NAME;
          break;
        }
      case Y.SOLIDUS:
        {
          this._leaveAttrValue(), this.state = Q.SELF_CLOSING_START_TAG;
          break;
        }
      case Y.GREATER_THAN_SIGN:
        {
          this._leaveAttrValue(), this.state = Q.DATA, this.emitCurrentTagToken();
          break;
        }
      case Y.EOF:
        {
          this._err(Se.eofInTag), this._emitEOFToken();
          break;
        }
      default:
        this._err(Se.missingWhitespaceBetweenAttributes), this.state = Q.BEFORE_ATTRIBUTE_NAME, this._stateBeforeAttributeName(e);
    }
  }
  _stateSelfClosingStartTag(e) {
    switch(e) {
      case Y.GREATER_THAN_SIGN:
        {
          const n = this.currentToken;
          n.selfClosing = !0, this.state = Q.DATA, this.emitCurrentTagToken();
          break;
        }
      case Y.EOF:
        {
          this._err(Se.eofInTag), this._emitEOFToken();
          break;
        }
      default:
        this._err(Se.unexpectedSolidusInTag), this.state = Q.BEFORE_ATTRIBUTE_NAME, this._stateBeforeAttributeName(e);
    }
  }
  _stateBogusComment(e) {
    const n = this.currentToken;
    switch(e) {
      case Y.GREATER_THAN_SIGN:
        {
          this.state = Q.DATA, this.emitCurrentComment(n);
          break;
        }
      case Y.EOF:
        {
          this.emitCurrentComment(n), this._emitEOFToken();
          break;
        }
      case Y.NULL:
        {
          this._err(Se.unexpectedNullCharacter), n.data += Tn;
          break;
        }
      default:
        n.data += String.fromCodePoint(e);
    }
  }
  _stateMarkupDeclarationOpen(e) {
    this._consumeSequenceIfMatch(Gr.DASH_DASH, !0) ? (this._createCommentToken(Gr.DASH_DASH.length + 1), this.state = Q.COMMENT_START) : this._consumeSequenceIfMatch(Gr.DOCTYPE, !1) ? (this.currentLocation = this.getCurrentLocation(Gr.DOCTYPE.length + 1), this.state = Q.DOCTYPE) : this._consumeSequenceIfMatch(Gr.CDATA_START, !0) ? this.inForeignNode ? this.state = Q.CDATA_SECTION : (this._err(Se.cdataInHtmlContent), this._createCommentToken(Gr.CDATA_START.length + 1), this.currentToken.data = "[CDATA[", 
    this.state = Q.BOGUS_COMMENT) : this._ensureHibernation() || (this._err(Se.incorrectlyOpenedComment), this._createCommentToken(2), this.state = Q.BOGUS_COMMENT, this._stateBogusComment(e));
  }
  _stateCommentStart(e) {
    switch(e) {
      case Y.HYPHEN_MINUS:
        {
          this.state = Q.COMMENT_START_DASH;
          break;
        }
      case Y.GREATER_THAN_SIGN:
        {
          this._err(Se.abruptClosingOfEmptyComment), this.state = Q.DATA;
          const n = this.currentToken;
          this.emitCurrentComment(n);
          break;
        }
      default:
        this.state = Q.COMMENT, this._stateComment(e);
    }
  }
  _stateCommentStartDash(e) {
    const n = this.currentToken;
    switch(e) {
      case Y.HYPHEN_MINUS:
        {
          this.state = Q.COMMENT_END;
          break;
        }
      case Y.GREATER_THAN_SIGN:
        {
          this._err(Se.abruptClosingOfEmptyComment), this.state = Q.DATA, this.emitCurrentComment(n);
          break;
        }
      case Y.EOF:
        {
          this._err(Se.eofInComment), this.emitCurrentComment(n), this._emitEOFToken();
          break;
        }
      default:
        n.data += "-", this.state = Q.COMMENT, this._stateComment(e);
    }
  }
  _stateComment(e) {
    const n = this.currentToken;
    switch(e) {
      case Y.HYPHEN_MINUS:
        {
          this.state = Q.COMMENT_END_DASH;
          break;
        }
      case Y.LESS_THAN_SIGN:
        {
          n.data += "\x3c", this.state = Q.COMMENT_LESS_THAN_SIGN;
          break;
        }
      case Y.NULL:
        {
          this._err(Se.unexpectedNullCharacter), n.data += Tn;
          break;
        }
      case Y.EOF:
        {
          this._err(Se.eofInComment), this.emitCurrentComment(n), this._emitEOFToken();
          break;
        }
      default:
        n.data += String.fromCodePoint(e);
    }
  }
  _stateCommentLessThanSign(e) {
    const n = this.currentToken;
    switch(e) {
      case Y.EXCLAMATION_MARK:
        {
          n.data += "!", this.state = Q.COMMENT_LESS_THAN_SIGN_BANG;
          break;
        }
      case Y.LESS_THAN_SIGN:
        {
          n.data += "\x3c";
          break;
        }
      default:
        this.state = Q.COMMENT, this._stateComment(e);
    }
  }
  _stateCommentLessThanSignBang(e) {
    e === Y.HYPHEN_MINUS ? this.state = Q.COMMENT_LESS_THAN_SIGN_BANG_DASH : (this.state = Q.COMMENT, this._stateComment(e));
  }
  _stateCommentLessThanSignBangDash(e) {
    e === Y.HYPHEN_MINUS ? this.state = Q.COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH : (this.state = Q.COMMENT_END_DASH, this._stateCommentEndDash(e));
  }
  _stateCommentLessThanSignBangDashDash(e) {
    e !== Y.GREATER_THAN_SIGN && e !== Y.EOF && this._err(Se.nestedComment), this.state = Q.COMMENT_END, this._stateCommentEnd(e);
  }
  _stateCommentEndDash(e) {
    const n = this.currentToken;
    switch(e) {
      case Y.HYPHEN_MINUS:
        {
          this.state = Q.COMMENT_END;
          break;
        }
      case Y.EOF:
        {
          this._err(Se.eofInComment), this.emitCurrentComment(n), this._emitEOFToken();
          break;
        }
      default:
        n.data += "-", this.state = Q.COMMENT, this._stateComment(e);
    }
  }
  _stateCommentEnd(e) {
    const n = this.currentToken;
    switch(e) {
      case Y.GREATER_THAN_SIGN:
        {
          this.state = Q.DATA, this.emitCurrentComment(n);
          break;
        }
      case Y.EXCLAMATION_MARK:
        {
          this.state = Q.COMMENT_END_BANG;
          break;
        }
      case Y.HYPHEN_MINUS:
        {
          n.data += "-";
          break;
        }
      case Y.EOF:
        {
          this._err(Se.eofInComment), this.emitCurrentComment(n), this._emitEOFToken();
          break;
        }
      default:
        n.data += "--", this.state = Q.COMMENT, this._stateComment(e);
    }
  }
  _stateCommentEndBang(e) {
    const n = this.currentToken;
    switch(e) {
      case Y.HYPHEN_MINUS:
        {
          n.data += "--!", this.state = Q.COMMENT_END_DASH;
          break;
        }
      case Y.GREATER_THAN_SIGN:
        {
          this._err(Se.incorrectlyClosedComment), this.state = Q.DATA, this.emitCurrentComment(n);
          break;
        }
      case Y.EOF:
        {
          this._err(Se.eofInComment), this.emitCurrentComment(n), this._emitEOFToken();
          break;
        }
      default:
        n.data += "--!", this.state = Q.COMMENT, this._stateComment(e);
    }
  }
  _stateDoctype(e) {
    switch(e) {
      case Y.SPACE:
      case Y.LINE_FEED:
      case Y.TABULATION:
      case Y.FORM_FEED:
        {
          this.state = Q.BEFORE_DOCTYPE_NAME;
          break;
        }
      case Y.GREATER_THAN_SIGN:
        {
          this.state = Q.BEFORE_DOCTYPE_NAME, this._stateBeforeDoctypeName(e);
          break;
        }
      case Y.EOF:
        {
          this._err(Se.eofInDoctype), this._createDoctypeToken(null);
          const n = this.currentToken;
          n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
          break;
        }
      default:
        this._err(Se.missingWhitespaceBeforeDoctypeName), this.state = Q.BEFORE_DOCTYPE_NAME, this._stateBeforeDoctypeName(e);
    }
  }
  _stateBeforeDoctypeName(e) {
    if (cu(e)) {
      this._createDoctypeToken(String.fromCharCode(Ah(e))), this.state = Q.DOCTYPE_NAME;
    } else {
      switch(e) {
        case Y.SPACE:
        case Y.LINE_FEED:
        case Y.TABULATION:
        case Y.FORM_FEED:
          break;
        case Y.NULL:
          {
            this._err(Se.unexpectedNullCharacter), this._createDoctypeToken(Tn), this.state = Q.DOCTYPE_NAME;
            break;
          }
        case Y.GREATER_THAN_SIGN:
          {
            this._err(Se.missingDoctypeName), this._createDoctypeToken(null);
            const n = this.currentToken;
            n.forceQuirks = !0, this.emitCurrentDoctype(n), this.state = Q.DATA;
            break;
          }
        case Y.EOF:
          {
            this._err(Se.eofInDoctype), this._createDoctypeToken(null);
            const n = this.currentToken;
            n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
            break;
          }
        default:
          this._createDoctypeToken(String.fromCodePoint(e)), this.state = Q.DOCTYPE_NAME;
      }
    }
  }
  _stateDoctypeName(e) {
    const n = this.currentToken;
    switch(e) {
      case Y.SPACE:
      case Y.LINE_FEED:
      case Y.TABULATION:
      case Y.FORM_FEED:
        {
          this.state = Q.AFTER_DOCTYPE_NAME;
          break;
        }
      case Y.GREATER_THAN_SIGN:
        {
          this.state = Q.DATA, this.emitCurrentDoctype(n);
          break;
        }
      case Y.NULL:
        {
          this._err(Se.unexpectedNullCharacter), n.name += Tn;
          break;
        }
      case Y.EOF:
        {
          this._err(Se.eofInDoctype), n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
          break;
        }
      default:
        n.name += String.fromCodePoint(cu(e) ? Ah(e) : e);
    }
  }
  _stateAfterDoctypeName(e) {
    const n = this.currentToken;
    switch(e) {
      case Y.SPACE:
      case Y.LINE_FEED:
      case Y.TABULATION:
      case Y.FORM_FEED:
        break;
      case Y.GREATER_THAN_SIGN:
        {
          this.state = Q.DATA, this.emitCurrentDoctype(n);
          break;
        }
      case Y.EOF:
        {
          this._err(Se.eofInDoctype), n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
          break;
        }
      default:
        this._consumeSequenceIfMatch(Gr.PUBLIC, !1) ? this.state = Q.AFTER_DOCTYPE_PUBLIC_KEYWORD : this._consumeSequenceIfMatch(Gr.SYSTEM, !1) ? this.state = Q.AFTER_DOCTYPE_SYSTEM_KEYWORD : this._ensureHibernation() || (this._err(Se.invalidCharacterSequenceAfterDoctypeName), n.forceQuirks = !0, this.state = Q.BOGUS_DOCTYPE, this._stateBogusDoctype(e));
    }
  }
  _stateAfterDoctypePublicKeyword(e) {
    const n = this.currentToken;
    switch(e) {
      case Y.SPACE:
      case Y.LINE_FEED:
      case Y.TABULATION:
      case Y.FORM_FEED:
        {
          this.state = Q.BEFORE_DOCTYPE_PUBLIC_IDENTIFIER;
          break;
        }
      case Y.QUOTATION_MARK:
        {
          this._err(Se.missingWhitespaceAfterDoctypePublicKeyword), n.publicId = "", this.state = Q.DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED;
          break;
        }
      case Y.APOSTROPHE:
        {
          this._err(Se.missingWhitespaceAfterDoctypePublicKeyword), n.publicId = "", this.state = Q.DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED;
          break;
        }
      case Y.GREATER_THAN_SIGN:
        {
          this._err(Se.missingDoctypePublicIdentifier), n.forceQuirks = !0, this.state = Q.DATA, this.emitCurrentDoctype(n);
          break;
        }
      case Y.EOF:
        {
          this._err(Se.eofInDoctype), n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
          break;
        }
      default:
        this._err(Se.missingQuoteBeforeDoctypePublicIdentifier), n.forceQuirks = !0, this.state = Q.BOGUS_DOCTYPE, this._stateBogusDoctype(e);
    }
  }
  _stateBeforeDoctypePublicIdentifier(e) {
    const n = this.currentToken;
    switch(e) {
      case Y.SPACE:
      case Y.LINE_FEED:
      case Y.TABULATION:
      case Y.FORM_FEED:
        break;
      case Y.QUOTATION_MARK:
        {
          n.publicId = "", this.state = Q.DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED;
          break;
        }
      case Y.APOSTROPHE:
        {
          n.publicId = "", this.state = Q.DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED;
          break;
        }
      case Y.GREATER_THAN_SIGN:
        {
          this._err(Se.missingDoctypePublicIdentifier), n.forceQuirks = !0, this.state = Q.DATA, this.emitCurrentDoctype(n);
          break;
        }
      case Y.EOF:
        {
          this._err(Se.eofInDoctype), n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
          break;
        }
      default:
        this._err(Se.missingQuoteBeforeDoctypePublicIdentifier), n.forceQuirks = !0, this.state = Q.BOGUS_DOCTYPE, this._stateBogusDoctype(e);
    }
  }
  _stateDoctypePublicIdentifierDoubleQuoted(e) {
    const n = this.currentToken;
    switch(e) {
      case Y.QUOTATION_MARK:
        {
          this.state = Q.AFTER_DOCTYPE_PUBLIC_IDENTIFIER;
          break;
        }
      case Y.NULL:
        {
          this._err(Se.unexpectedNullCharacter), n.publicId += Tn;
          break;
        }
      case Y.GREATER_THAN_SIGN:
        {
          this._err(Se.abruptDoctypePublicIdentifier), n.forceQuirks = !0, this.emitCurrentDoctype(n), this.state = Q.DATA;
          break;
        }
      case Y.EOF:
        {
          this._err(Se.eofInDoctype), n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
          break;
        }
      default:
        n.publicId += String.fromCodePoint(e);
    }
  }
  _stateDoctypePublicIdentifierSingleQuoted(e) {
    const n = this.currentToken;
    switch(e) {
      case Y.APOSTROPHE:
        {
          this.state = Q.AFTER_DOCTYPE_PUBLIC_IDENTIFIER;
          break;
        }
      case Y.NULL:
        {
          this._err(Se.unexpectedNullCharacter), n.publicId += Tn;
          break;
        }
      case Y.GREATER_THAN_SIGN:
        {
          this._err(Se.abruptDoctypePublicIdentifier), n.forceQuirks = !0, this.emitCurrentDoctype(n), this.state = Q.DATA;
          break;
        }
      case Y.EOF:
        {
          this._err(Se.eofInDoctype), n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
          break;
        }
      default:
        n.publicId += String.fromCodePoint(e);
    }
  }
  _stateAfterDoctypePublicIdentifier(e) {
    const n = this.currentToken;
    switch(e) {
      case Y.SPACE:
      case Y.LINE_FEED:
      case Y.TABULATION:
      case Y.FORM_FEED:
        {
          this.state = Q.BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS;
          break;
        }
      case Y.GREATER_THAN_SIGN:
        {
          this.state = Q.DATA, this.emitCurrentDoctype(n);
          break;
        }
      case Y.QUOTATION_MARK:
        {
          this._err(Se.missingWhitespaceBetweenDoctypePublicAndSystemIdentifiers), n.systemId = "", this.state = Q.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED;
          break;
        }
      case Y.APOSTROPHE:
        {
          this._err(Se.missingWhitespaceBetweenDoctypePublicAndSystemIdentifiers), n.systemId = "", this.state = Q.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED;
          break;
        }
      case Y.EOF:
        {
          this._err(Se.eofInDoctype), n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
          break;
        }
      default:
        this._err(Se.missingQuoteBeforeDoctypeSystemIdentifier), n.forceQuirks = !0, this.state = Q.BOGUS_DOCTYPE, this._stateBogusDoctype(e);
    }
  }
  _stateBetweenDoctypePublicAndSystemIdentifiers(e) {
    const n = this.currentToken;
    switch(e) {
      case Y.SPACE:
      case Y.LINE_FEED:
      case Y.TABULATION:
      case Y.FORM_FEED:
        break;
      case Y.GREATER_THAN_SIGN:
        {
          this.emitCurrentDoctype(n), this.state = Q.DATA;
          break;
        }
      case Y.QUOTATION_MARK:
        {
          n.systemId = "", this.state = Q.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED;
          break;
        }
      case Y.APOSTROPHE:
        {
          n.systemId = "", this.state = Q.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED;
          break;
        }
      case Y.EOF:
        {
          this._err(Se.eofInDoctype), n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
          break;
        }
      default:
        this._err(Se.missingQuoteBeforeDoctypeSystemIdentifier), n.forceQuirks = !0, this.state = Q.BOGUS_DOCTYPE, this._stateBogusDoctype(e);
    }
  }
  _stateAfterDoctypeSystemKeyword(e) {
    const n = this.currentToken;
    switch(e) {
      case Y.SPACE:
      case Y.LINE_FEED:
      case Y.TABULATION:
      case Y.FORM_FEED:
        {
          this.state = Q.BEFORE_DOCTYPE_SYSTEM_IDENTIFIER;
          break;
        }
      case Y.QUOTATION_MARK:
        {
          this._err(Se.missingWhitespaceAfterDoctypeSystemKeyword), n.systemId = "", this.state = Q.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED;
          break;
        }
      case Y.APOSTROPHE:
        {
          this._err(Se.missingWhitespaceAfterDoctypeSystemKeyword), n.systemId = "", this.state = Q.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED;
          break;
        }
      case Y.GREATER_THAN_SIGN:
        {
          this._err(Se.missingDoctypeSystemIdentifier), n.forceQuirks = !0, this.state = Q.DATA, this.emitCurrentDoctype(n);
          break;
        }
      case Y.EOF:
        {
          this._err(Se.eofInDoctype), n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
          break;
        }
      default:
        this._err(Se.missingQuoteBeforeDoctypeSystemIdentifier), n.forceQuirks = !0, this.state = Q.BOGUS_DOCTYPE, this._stateBogusDoctype(e);
    }
  }
  _stateBeforeDoctypeSystemIdentifier(e) {
    const n = this.currentToken;
    switch(e) {
      case Y.SPACE:
      case Y.LINE_FEED:
      case Y.TABULATION:
      case Y.FORM_FEED:
        break;
      case Y.QUOTATION_MARK:
        {
          n.systemId = "", this.state = Q.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED;
          break;
        }
      case Y.APOSTROPHE:
        {
          n.systemId = "", this.state = Q.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED;
          break;
        }
      case Y.GREATER_THAN_SIGN:
        {
          this._err(Se.missingDoctypeSystemIdentifier), n.forceQuirks = !0, this.state = Q.DATA, this.emitCurrentDoctype(n);
          break;
        }
      case Y.EOF:
        {
          this._err(Se.eofInDoctype), n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
          break;
        }
      default:
        this._err(Se.missingQuoteBeforeDoctypeSystemIdentifier), n.forceQuirks = !0, this.state = Q.BOGUS_DOCTYPE, this._stateBogusDoctype(e);
    }
  }
  _stateDoctypeSystemIdentifierDoubleQuoted(e) {
    const n = this.currentToken;
    switch(e) {
      case Y.QUOTATION_MARK:
        {
          this.state = Q.AFTER_DOCTYPE_SYSTEM_IDENTIFIER;
          break;
        }
      case Y.NULL:
        {
          this._err(Se.unexpectedNullCharacter), n.systemId += Tn;
          break;
        }
      case Y.GREATER_THAN_SIGN:
        {
          this._err(Se.abruptDoctypeSystemIdentifier), n.forceQuirks = !0, this.emitCurrentDoctype(n), this.state = Q.DATA;
          break;
        }
      case Y.EOF:
        {
          this._err(Se.eofInDoctype), n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
          break;
        }
      default:
        n.systemId += String.fromCodePoint(e);
    }
  }
  _stateDoctypeSystemIdentifierSingleQuoted(e) {
    const n = this.currentToken;
    switch(e) {
      case Y.APOSTROPHE:
        {
          this.state = Q.AFTER_DOCTYPE_SYSTEM_IDENTIFIER;
          break;
        }
      case Y.NULL:
        {
          this._err(Se.unexpectedNullCharacter), n.systemId += Tn;
          break;
        }
      case Y.GREATER_THAN_SIGN:
        {
          this._err(Se.abruptDoctypeSystemIdentifier), n.forceQuirks = !0, this.emitCurrentDoctype(n), this.state = Q.DATA;
          break;
        }
      case Y.EOF:
        {
          this._err(Se.eofInDoctype), n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
          break;
        }
      default:
        n.systemId += String.fromCodePoint(e);
    }
  }
  _stateAfterDoctypeSystemIdentifier(e) {
    const n = this.currentToken;
    switch(e) {
      case Y.SPACE:
      case Y.LINE_FEED:
      case Y.TABULATION:
      case Y.FORM_FEED:
        break;
      case Y.GREATER_THAN_SIGN:
        {
          this.emitCurrentDoctype(n), this.state = Q.DATA;
          break;
        }
      case Y.EOF:
        {
          this._err(Se.eofInDoctype), n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
          break;
        }
      default:
        this._err(Se.unexpectedCharacterAfterDoctypeSystemIdentifier), this.state = Q.BOGUS_DOCTYPE, this._stateBogusDoctype(e);
    }
  }
  _stateBogusDoctype(e) {
    const n = this.currentToken;
    switch(e) {
      case Y.GREATER_THAN_SIGN:
        {
          this.emitCurrentDoctype(n), this.state = Q.DATA;
          break;
        }
      case Y.NULL:
        {
          this._err(Se.unexpectedNullCharacter);
          break;
        }
      case Y.EOF:
        {
          this.emitCurrentDoctype(n), this._emitEOFToken();
          break;
        }
    }
  }
  _stateCdataSection(e) {
    switch(e) {
      case Y.RIGHT_SQUARE_BRACKET:
        {
          this.state = Q.CDATA_SECTION_BRACKET;
          break;
        }
      case Y.EOF:
        {
          this._err(Se.eofInCdata), this._emitEOFToken();
          break;
        }
      default:
        this._emitCodePoint(e);
    }
  }
  _stateCdataSectionBracket(e) {
    e === Y.RIGHT_SQUARE_BRACKET ? this.state = Q.CDATA_SECTION_END : (this._emitChars("]"), this.state = Q.CDATA_SECTION, this._stateCdataSection(e));
  }
  _stateCdataSectionEnd(e) {
    switch(e) {
      case Y.GREATER_THAN_SIGN:
        {
          this.state = Q.DATA;
          break;
        }
      case Y.RIGHT_SQUARE_BRACKET:
        {
          this._emitChars("]");
          break;
        }
      default:
        this._emitChars("]]"), this.state = Q.CDATA_SECTION, this._stateCdataSection(e);
    }
  }
  _stateCharacterReference() {
    let e = this.entityDecoder.write(this.preprocessor.html, this.preprocessor.pos);
    if (e < 0) {
      if (this.preprocessor.lastChunkWritten) {
        e = this.entityDecoder.end();
      } else {
        this.active = !1, this.preprocessor.pos = this.preprocessor.html.length - 1, this.consumedAfterSnapshot = 0, this.preprocessor.endOfChunkHit = !0;
        return;
      }
    }
    e === 0 ? (this.preprocessor.pos = this.entityStartPos, this._flushCodePointConsumedAsCharacterReference(Y.AMPERSAND), this.state = !this._isCharacterReferenceInAttribute() && v_(this.preprocessor.peek(1)) ? Q.AMBIGUOUS_AMPERSAND : this.returnState) : this.state = this.returnState;
  }
  _stateAmbiguousAmpersand(e) {
    v_(e) ? this._flushCodePointConsumedAsCharacterReference(e) : (e === Y.SEMICOLON && this._err(Se.unknownNamedCharacterReference), this.state = this.returnState, this._callState(e));
  }
}
const qC = new Set([S.DD, S.DT, S.LI, S.OPTGROUP, S.OPTION, S.P, S.RB, S.RP, S.RT, S.RTC]), __ = new Set([...qC, S.CAPTION, S.COLGROUP, S.TBODY, S.TD, S.TFOOT, S.TH, S.THEAD, S.TR]), op = new Set([S.APPLET, S.CAPTION, S.HTML, S.MARQUEE, S.OBJECT, S.TABLE, S.TD, S.TEMPLATE, S.TH]), D9 = new Set([...op, S.OL, S.UL]), L9 = new Set([...op, S.BUTTON]), S_ = new Set([S.ANNOTATION_XML, S.MI, S.MN, S.MO, S.MS, S.MTEXT]), k_ = new Set([S.DESC, S.FOREIGN_OBJECT, S.TITLE]), M9 = new Set([S.TR, S.TEMPLATE, S.HTML]), 
B9 = new Set([S.TBODY, S.TFOOT, S.THEAD, S.TEMPLATE, S.HTML]), $9 = new Set([S.TABLE, S.TEMPLATE, S.HTML]), F9 = new Set([S.TD, S.TH]);
class z9 {
  get currentTmplContentOrNode() {
    return this._isInTemplate() ? this.treeAdapter.getTemplateContent(this.current) : this.current;
  }
  constructor(e, n, r) {
    this.treeAdapter = n, this.handler = r, this.items = [], this.tagIDs = [], this.stackTop = -1, this.tmplCount = 0, this.currentTagId = S.UNKNOWN, this.current = e;
  }
  _indexOf(e) {
    return this.items.lastIndexOf(e, this.stackTop);
  }
  _isInTemplate() {
    return this.currentTagId === S.TEMPLATE && this.treeAdapter.getNamespaceURI(this.current) === Fe.HTML;
  }
  _updateCurrentElement() {
    this.current = this.items[this.stackTop], this.currentTagId = this.tagIDs[this.stackTop];
  }
  push(e, n) {
    this.stackTop++, this.items[this.stackTop] = e, this.current = e, this.tagIDs[this.stackTop] = n, this.currentTagId = n, this._isInTemplate() && this.tmplCount++, this.handler.onItemPush(e, n, !0);
  }
  pop() {
    const e = this.current;
    this.tmplCount > 0 && this._isInTemplate() && this.tmplCount--, this.stackTop--, this._updateCurrentElement(), this.handler.onItemPop(e, !0);
  }
  replace(e, n) {
    const r = this._indexOf(e);
    this.items[r] = n, r === this.stackTop && (this.current = n);
  }
  insertAfter(e, n, r) {
    const i = this._indexOf(e) + 1;
    this.items.splice(i, 0, n), this.tagIDs.splice(i, 0, r), this.stackTop++, i === this.stackTop && this._updateCurrentElement(), this.current && this.currentTagId !== void 0 && this.handler.onItemPush(this.current, this.currentTagId, i === this.stackTop);
  }
  popUntilTagNamePopped(e) {
    let n = this.stackTop + 1;
    do {
      n = this.tagIDs.lastIndexOf(e, n - 1);
    } while (n > 0 && this.treeAdapter.getNamespaceURI(this.items[n]) !== Fe.HTML);
    this.shortenToLength(Math.max(n, 0));
  }
  shortenToLength(e) {
    for (; this.stackTop >= e;) {
      const n = this.current;
      this.tmplCount > 0 && this._isInTemplate() && (this.tmplCount -= 1), this.stackTop--, this._updateCurrentElement(), this.handler.onItemPop(n, this.stackTop < e);
    }
  }
  popUntilElementPopped(e) {
    const n = this._indexOf(e);
    this.shortenToLength(Math.max(n, 0));
  }
  popUntilPopped(e, n) {
    const r = this._indexOfTagNames(e, n);
    this.shortenToLength(Math.max(r, 0));
  }
  popUntilNumberedHeaderPopped() {
    this.popUntilPopped(wb, Fe.HTML);
  }
  popUntilTableCellPopped() {
    this.popUntilPopped(F9, Fe.HTML);
  }
  popAllUpToHtmlElement() {
    this.tmplCount = 0, this.shortenToLength(1);
  }
  _indexOfTagNames(e, n) {
    for (let r = this.stackTop; r >= 0; r--) {
      if (e.has(this.tagIDs[r]) && this.treeAdapter.getNamespaceURI(this.items[r]) === n) {
        return r;
      }
    }
    return -1;
  }
  clearBackTo(e, n) {
    const r = this._indexOfTagNames(e, n);
    this.shortenToLength(r + 1);
  }
  clearBackToTableContext() {
    this.clearBackTo($9, Fe.HTML);
  }
  clearBackToTableBodyContext() {
    this.clearBackTo(B9, Fe.HTML);
  }
  clearBackToTableRowContext() {
    this.clearBackTo(M9, Fe.HTML);
  }
  remove(e) {
    const n = this._indexOf(e);
    n >= 0 && (n === this.stackTop ? this.pop() : (this.items.splice(n, 1), this.tagIDs.splice(n, 1), this.stackTop--, this._updateCurrentElement(), this.handler.onItemPop(e, !1)));
  }
  tryPeekProperlyNestedBodyElement() {
    return this.stackTop >= 1 && this.tagIDs[1] === S.BODY ? this.items[1] : null;
  }
  contains(e) {
    return this._indexOf(e) > -1;
  }
  getCommonAncestor(e) {
    const n = this._indexOf(e) - 1;
    return n >= 0 ? this.items[n] : null;
  }
  isRootHtmlElementCurrent() {
    return this.stackTop === 0 && this.tagIDs[0] === S.HTML;
  }
  hasInDynamicScope(e, n) {
    for (let r = this.stackTop; r >= 0; r--) {
      const i = this.tagIDs[r];
      switch(this.treeAdapter.getNamespaceURI(this.items[r])) {
        case Fe.HTML:
          {
            if (i === e) {
              return !0;
            }
            if (n.has(i)) {
              return !1;
            }
            break;
          }
        case Fe.SVG:
          {
            if (k_.has(i)) {
              return !1;
            }
            break;
          }
        case Fe.MATHML:
          {
            if (S_.has(i)) {
              return !1;
            }
            break;
          }
      }
    }
    return !0;
  }
  hasInScope(e) {
    return this.hasInDynamicScope(e, op);
  }
  hasInListItemScope(e) {
    return this.hasInDynamicScope(e, D9);
  }
  hasInButtonScope(e) {
    return this.hasInDynamicScope(e, L9);
  }
  hasNumberedHeaderInScope() {
    for (let e = this.stackTop; e >= 0; e--) {
      const n = this.tagIDs[e];
      switch(this.treeAdapter.getNamespaceURI(this.items[e])) {
        case Fe.HTML:
          {
            if (wb.has(n)) {
              return !0;
            }
            if (op.has(n)) {
              return !1;
            }
            break;
          }
        case Fe.SVG:
          {
            if (k_.has(n)) {
              return !1;
            }
            break;
          }
        case Fe.MATHML:
          {
            if (S_.has(n)) {
              return !1;
            }
            break;
          }
      }
    }
    return !0;
  }
  hasInTableScope(e) {
    for (let n = this.stackTop; n >= 0; n--) {
      if (this.treeAdapter.getNamespaceURI(this.items[n]) === Fe.HTML) {
        switch(this.tagIDs[n]) {
          case e:
            return !0;
          case S.TABLE:
          case S.HTML:
            return !1;
        }
      }
    }
    return !0;
  }
  hasTableBodyContextInTableScope() {
    for (let e = this.stackTop; e >= 0; e--) {
      if (this.treeAdapter.getNamespaceURI(this.items[e]) === Fe.HTML) {
        switch(this.tagIDs[e]) {
          case S.TBODY:
          case S.THEAD:
          case S.TFOOT:
            return !0;
          case S.TABLE:
          case S.HTML:
            return !1;
        }
      }
    }
    return !0;
  }
  hasInSelectScope(e) {
    for (let n = this.stackTop; n >= 0; n--) {
      if (this.treeAdapter.getNamespaceURI(this.items[n]) === Fe.HTML) {
        switch(this.tagIDs[n]) {
          case e:
            return !0;
          case S.OPTION:
          case S.OPTGROUP:
            break;
          default:
            return !1;
        }
      }
    }
    return !0;
  }
  generateImpliedEndTags() {
    for (; this.currentTagId !== void 0 && qC.has(this.currentTagId);) {
      this.pop();
    }
  }
  generateImpliedEndTagsThoroughly() {
    for (; this.currentTagId !== void 0 && __.has(this.currentTagId);) {
      this.pop();
    }
  }
  generateImpliedEndTagsWithExclusion(e) {
    for (; this.currentTagId !== void 0 && this.currentTagId !== e && __.has(this.currentTagId);) {
      this.pop();
    }
  }
}
const Om = 3;
var Ss;
(function(t) {
  t[t.Marker = 0] = "Marker", t[t.Element = 1] = "Element";
})(Ss || (Ss = {}));
const E_ = {type:Ss.Marker};
class H9 {
  constructor(e) {
    this.treeAdapter = e, this.entries = [], this.bookmark = null;
  }
  _getNoahArkConditionCandidates(e, n) {
    const r = [], i = n.length, s = this.treeAdapter.getTagName(e), o = this.treeAdapter.getNamespaceURI(e);
    for (let a = 0; a < this.entries.length; a++) {
      const l = this.entries[a];
      if (l.type === Ss.Marker) {
        break;
      }
      const {element:c} = l;
      if (this.treeAdapter.getTagName(c) === s && this.treeAdapter.getNamespaceURI(c) === o) {
        const u = this.treeAdapter.getAttrList(c);
        u.length === i && r.push({idx:a, attrs:u});
      }
    }
    return r;
  }
  _ensureNoahArkCondition(e) {
    if (this.entries.length < Om) {
      return;
    }
    const n = this.treeAdapter.getAttrList(e), r = this._getNoahArkConditionCandidates(e, n);
    if (r.length < Om) {
      return;
    }
    const i = new Map(n.map(o => [o.name, o.value]));
    let s = 0;
    for (let o = 0; o < r.length; o++) {
      const a = r[o];
      a.attrs.every(l => i.get(l.name) === l.value) && (s += 1, s >= Om && this.entries.splice(a.idx, 1));
    }
  }
  insertMarker() {
    this.entries.unshift(E_);
  }
  pushElement(e, n) {
    this._ensureNoahArkCondition(e), this.entries.unshift({type:Ss.Element, element:e, token:n});
  }
  insertElementAfterBookmark(e, n) {
    const r = this.entries.indexOf(this.bookmark);
    this.entries.splice(r, 0, {type:Ss.Element, element:e, token:n});
  }
  removeEntry(e) {
    const n = this.entries.indexOf(e);
    n !== -1 && this.entries.splice(n, 1);
  }
  clearToLastMarker() {
    const e = this.entries.indexOf(E_);
    e === -1 ? this.entries.length = 0 : this.entries.splice(0, e + 1);
  }
  getElementEntryInScopeWithTagName(e) {
    const n = this.entries.find(r => r.type === Ss.Marker || this.treeAdapter.getTagName(r.element) === e);
    return n && n.type === Ss.Element ? n : null;
  }
  getElementEntry(e) {
    return this.entries.find(n => n.type === Ss.Element && n.element === e);
  }
}
const Ro = {createDocument() {
  return {nodeName:"#document", mode:Ni.NO_QUIRKS, childNodes:[]};
}, createDocumentFragment() {
  return {nodeName:"#document-fragment", childNodes:[]};
}, createElement(t, e, n) {
  return {nodeName:t, tagName:t, attrs:n, namespaceURI:e, childNodes:[], parentNode:null};
}, createCommentNode(t) {
  return {nodeName:"#comment", data:t, parentNode:null};
}, createTextNode(t) {
  return {nodeName:"#text", value:t, parentNode:null};
}, appendChild(t, e) {
  t.childNodes.push(e), e.parentNode = t;
}, insertBefore(t, e, n) {
  const r = t.childNodes.indexOf(n);
  t.childNodes.splice(r, 0, e), e.parentNode = t;
}, setTemplateContent(t, e) {
  t.content = e;
}, getTemplateContent(t) {
  return t.content;
}, setDocumentType(t, e, n, r) {
  const i = t.childNodes.find(s => s.nodeName === "#documentType");
  if (i) {
    i.name = e, i.publicId = n, i.systemId = r;
  } else {
    const s = {nodeName:"#documentType", name:e, publicId:n, systemId:r, parentNode:null};
    Ro.appendChild(t, s);
  }
}, setDocumentMode(t, e) {
  t.mode = e;
}, getDocumentMode(t) {
  return t.mode;
}, detachNode(t) {
  if (t.parentNode) {
    const e = t.parentNode.childNodes.indexOf(t);
    t.parentNode.childNodes.splice(e, 1), t.parentNode = null;
  }
}, insertText(t, e) {
  if (t.childNodes.length > 0) {
    const n = t.childNodes[t.childNodes.length - 1];
    if (Ro.isTextNode(n)) {
      n.value += e;
      return;
    }
  }
  Ro.appendChild(t, Ro.createTextNode(e));
}, insertTextBefore(t, e, n) {
  const r = t.childNodes[t.childNodes.indexOf(n) - 1];
  r && Ro.isTextNode(r) ? r.value += e : Ro.insertBefore(t, Ro.createTextNode(e), n);
}, adoptAttributes(t, e) {
  const n = new Set(t.attrs.map(r => r.name));
  for (let r = 0; r < e.length; r++) {
    n.has(e[r].name) || t.attrs.push(e[r]);
  }
}, getFirstChild(t) {
  return t.childNodes[0];
}, getChildNodes(t) {
  return t.childNodes;
}, getParentNode(t) {
  return t.parentNode;
}, getAttrList(t) {
  return t.attrs;
}, getTagName(t) {
  return t.tagName;
}, getNamespaceURI(t) {
  return t.namespaceURI;
}, getTextNodeContent(t) {
  return t.value;
}, getCommentNodeContent(t) {
  return t.data;
}, getDocumentTypeNodeName(t) {
  return t.name;
}, getDocumentTypeNodePublicId(t) {
  return t.publicId;
}, getDocumentTypeNodeSystemId(t) {
  return t.systemId;
}, isTextNode(t) {
  return t.nodeName === "#text";
}, isCommentNode(t) {
  return t.nodeName === "#comment";
}, isDocumentTypeNode(t) {
  return t.nodeName === "#documentType";
}, isElementNode(t) {
  return Object.prototype.hasOwnProperty.call(t, "tagName");
}, setNodeSourceCodeLocation(t, e) {
  t.sourceCodeLocation = e;
}, getNodeSourceCodeLocation(t) {
  return t.sourceCodeLocation;
}, updateNodeSourceCodeLocation(t, e) {
  t.sourceCodeLocation = {...t.sourceCodeLocation, ...e};
}}, YC = "html", U9 = "about:legacy-compat", W9 = "http://www.ibm.com/data/dtd/v11/ibmxhtml1-transitional.dtd", GC = ["+//silmaril//dtd html pro v0r11 19970101//", "-//as//dtd html 3.0 aswedit + extensions//", "-//advasoft ltd//dtd html 3.0 aswedit + extensions//", "-//ietf//dtd html 2.0 level 1//", "-//ietf//dtd html 2.0 level 2//", "-//ietf//dtd html 2.0 strict level 1//", "-//ietf//dtd html 2.0 strict level 2//", "-//ietf//dtd html 2.0 strict//", "-//ietf//dtd html 2.0//", "-//ietf//dtd html 2.1e//", 
"-//ietf//dtd html 3.0//", "-//ietf//dtd html 3.2 final//", "-//ietf//dtd html 3.2//", "-//ietf//dtd html 3//", "-//ietf//dtd html level 0//", "-//ietf//dtd html level 1//", "-//ietf//dtd html level 2//", "-//ietf//dtd html level 3//", "-//ietf//dtd html strict level 0//", "-//ietf//dtd html strict level 1//", "-//ietf//dtd html strict level 2//", "-//ietf//dtd html strict level 3//", "-//ietf//dtd html strict//", "-//ietf//dtd html//", "-//metrius//dtd metrius presentational//", "-//microsoft//dtd internet explorer 2.0 html strict//", 
"-//microsoft//dtd internet explorer 2.0 html//", "-//microsoft//dtd internet explorer 2.0 tables//", "-//microsoft//dtd internet explorer 3.0 html strict//", "-//microsoft//dtd internet explorer 3.0 html//", "-//microsoft//dtd internet explorer 3.0 tables//", "-//netscape comm. corp.//dtd html//", "-//netscape comm. corp.//dtd strict html//", "-//o'reilly and associates//dtd html 2.0//", "-//o'reilly and associates//dtd html extended 1.0//", "-//o'reilly and associates//dtd html extended relaxed 1.0//", 
"-//sq//dtd html 2.0 hotmetal + extensions//", "-//softquad software//dtd hotmetal pro 6.0::19990601::extensions to html 4.0//", "-//softquad//dtd hotmetal pro 4.0::19971010::extensions to html 4.0//", "-//spyglass//dtd html 2.0 extended//", "-//sun microsystems corp.//dtd hotjava html//", "-//sun microsystems corp.//dtd hotjava strict html//", "-//w3c//dtd html 3 1995-03-24//", "-//w3c//dtd html 3.2 draft//", "-//w3c//dtd html 3.2 final//", "-//w3c//dtd html 3.2//", "-//w3c//dtd html 3.2s draft//", 
"-//w3c//dtd html 4.0 frameset//", "-//w3c//dtd html 4.0 transitional//", "-//w3c//dtd html experimental 19960712//", "-//w3c//dtd html experimental 970421//", "-//w3c//dtd w3 html//", "-//w3o//dtd w3 html 3.0//", "-//webtechs//dtd mozilla html 2.0//", "-//webtechs//dtd mozilla html//"], j9 = [...GC, "-//w3c//dtd html 4.01 frameset//", "-//w3c//dtd html 4.01 transitional//"], V9 = new Set(["-//w3o//dtd w3 html strict 3.0//en//", "-/w3c/dtd html 4.0 transitional/en", "html"]), QC = ["-//w3c//dtd xhtml 1.0 frameset//", 
"-//w3c//dtd xhtml 1.0 transitional//"], q9 = [...QC, "-//w3c//dtd html 4.01 frameset//", "-//w3c//dtd html 4.01 transitional//"];
function T_(t, e) {
  return e.some(n => t.startsWith(n));
}
function Y9(t) {
  return t.name === YC && t.publicId === null && (t.systemId === null || t.systemId === U9);
}
function G9(t) {
  if (t.name !== YC) {
    return Ni.QUIRKS;
  }
  const {systemId:e} = t;
  if (e && e.toLowerCase() === W9) {
    return Ni.QUIRKS;
  }
  let {publicId:n} = t;
  if (n !== null) {
    if (n = n.toLowerCase(), V9.has(n)) {
      return Ni.QUIRKS;
    }
    let r = e === null ? j9 : GC;
    if (T_(n, r)) {
      return Ni.QUIRKS;
    }
    if (r = e === null ? QC : q9, T_(n, r)) {
      return Ni.LIMITED_QUIRKS;
    }
  }
  return Ni.NO_QUIRKS;
}
const C_ = {TEXT_HTML:"text/html", APPLICATION_XML:"application/xhtml+xml"}, Q9 = "definitionurl", K9 = "definitionURL", X9 = new Map(["attributeName", "attributeType", "baseFrequency", "baseProfile", "calcMode", "clipPathUnits", "diffuseConstant", "edgeMode", "filterUnits", "glyphRef", "gradientTransform", "gradientUnits", "kernelMatrix", "kernelUnitLength", "keyPoints", "keySplines", "keyTimes", "lengthAdjust", "limitingConeAngle", "markerHeight", "markerUnits", "markerWidth", "maskContentUnits", 
"maskUnits", "numOctaves", "pathLength", "patternContentUnits", "patternTransform", "patternUnits", "pointsAtX", "pointsAtY", "pointsAtZ", "preserveAlpha", "preserveAspectRatio", "primitiveUnits", "refX", "refY", "repeatCount", "repeatDur", "requiredExtensions", "requiredFeatures", "specularConstant", "specularExponent", "spreadMethod", "startOffset", "stdDeviation", "stitchTiles", "surfaceScale", "systemLanguage", "tableValues", "targetX", "targetY", "textLength", "viewBox", "viewTarget", "xChannelSelector", 
"yChannelSelector", "zoomAndPan"].map(t => [t.toLowerCase(), t])), J9 = new Map([["xlink:actuate", {prefix:"xlink", name:"actuate", namespace:Fe.XLINK}], ["xlink:arcrole", {prefix:"xlink", name:"arcrole", namespace:Fe.XLINK}], ["xlink:href", {prefix:"xlink", name:"href", namespace:Fe.XLINK}], ["xlink:role", {prefix:"xlink", name:"role", namespace:Fe.XLINK}], ["xlink:show", {prefix:"xlink", name:"show", namespace:Fe.XLINK}], ["xlink:title", {prefix:"xlink", name:"title", namespace:Fe.XLINK}], ["xlink:type", 
{prefix:"xlink", name:"type", namespace:Fe.XLINK}], ["xml:lang", {prefix:"xml", name:"lang", namespace:Fe.XML}], ["xml:space", {prefix:"xml", name:"space", namespace:Fe.XML}], ["xmlns", {prefix:"", name:"xmlns", namespace:Fe.XMLNS}], ["xmlns:xlink", {prefix:"xmlns", name:"xlink", namespace:Fe.XMLNS}]]), Z9 = new Map(["altGlyph", "altGlyphDef", "altGlyphItem", "animateColor", "animateMotion", "animateTransform", "clipPath", "feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", 
"feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence", "foreignObject", "glyphRef", "linearGradient", "radialGradient", "textPath"].map(t => [t.toLowerCase(), t])), e7 = new Set([S.B, S.BIG, S.BLOCKQUOTE, S.BODY, S.BR, S.CENTER, S.CODE, S.DD, S.DIV, S.DL, S.DT, S.EM, S.EMBED, S.H1, 
S.H2, S.H3, S.H4, S.H5, S.H6, S.HEAD, S.HR, S.I, S.IMG, S.LI, S.LISTING, S.MENU, S.META, S.NOBR, S.OL, S.P, S.PRE, S.RUBY, S.S, S.SMALL, S.SPAN, S.STRONG, S.STRIKE, S.SUB, S.SUP, S.TABLE, S.TT, S.U, S.UL, S.VAR]);
function t7(t) {
  const e = t.tagID;
  return e === S.FONT && t.attrs.some(({name:r}) => r === Ha.COLOR || r === Ha.SIZE || r === Ha.FACE) || e7.has(e);
}
function KC(t) {
  for (let e = 0; e < t.attrs.length; e++) {
    if (t.attrs[e].name === Q9) {
      t.attrs[e].name = K9;
      break;
    }
  }
}
function XC(t) {
  for (let e = 0; e < t.attrs.length; e++) {
    const n = X9.get(t.attrs[e].name);
    n != null && (t.attrs[e].name = n);
  }
}
function zx(t) {
  for (let e = 0; e < t.attrs.length; e++) {
    const n = J9.get(t.attrs[e].name);
    n && (t.attrs[e].prefix = n.prefix, t.attrs[e].name = n.name, t.attrs[e].namespace = n.namespace);
  }
}
function n7(t) {
  const e = Z9.get(t.tagName);
  e != null && (t.tagName = e, t.tagID = Tc(t.tagName));
}
function r7(t, e) {
  return e === Fe.MATHML && (t === S.MI || t === S.MO || t === S.MN || t === S.MS || t === S.MTEXT);
}
function i7(t, e, n) {
  if (e === Fe.MATHML && t === S.ANNOTATION_XML) {
    for (let r = 0; r < n.length; r++) {
      if (n[r].name === Ha.ENCODING) {
        const i = n[r].value.toLowerCase();
        return i === C_.TEXT_HTML || i === C_.APPLICATION_XML;
      }
    }
  }
  return e === Fe.SVG && (t === S.FOREIGN_OBJECT || t === S.DESC || t === S.TITLE);
}
function s7(t, e, n, r) {
  return (!r || r === Fe.HTML) && i7(t, e, n) || (!r || r === Fe.MATHML) && r7(t, e);
}
const o7 = "hidden", a7 = 8, l7 = 3;
var Z;
(function(t) {
  t[t.INITIAL = 0] = "INITIAL", t[t.BEFORE_HTML = 1] = "BEFORE_HTML", t[t.BEFORE_HEAD = 2] = "BEFORE_HEAD", t[t.IN_HEAD = 3] = "IN_HEAD", t[t.IN_HEAD_NO_SCRIPT = 4] = "IN_HEAD_NO_SCRIPT", t[t.AFTER_HEAD = 5] = "AFTER_HEAD", t[t.IN_BODY = 6] = "IN_BODY", t[t.TEXT = 7] = "TEXT", t[t.IN_TABLE = 8] = "IN_TABLE", t[t.IN_TABLE_TEXT = 9] = "IN_TABLE_TEXT", t[t.IN_CAPTION = 10] = "IN_CAPTION", t[t.IN_COLUMN_GROUP = 11] = "IN_COLUMN_GROUP", t[t.IN_TABLE_BODY = 12] = "IN_TABLE_BODY", t[t.IN_ROW = 13] = "IN_ROW", 
  t[t.IN_CELL = 14] = "IN_CELL", t[t.IN_SELECT = 15] = "IN_SELECT", t[t.IN_SELECT_IN_TABLE = 16] = "IN_SELECT_IN_TABLE", t[t.IN_TEMPLATE = 17] = "IN_TEMPLATE", t[t.AFTER_BODY = 18] = "AFTER_BODY", t[t.IN_FRAMESET = 19] = "IN_FRAMESET", t[t.AFTER_FRAMESET = 20] = "AFTER_FRAMESET", t[t.AFTER_AFTER_BODY = 21] = "AFTER_AFTER_BODY", t[t.AFTER_AFTER_FRAMESET = 22] = "AFTER_AFTER_FRAMESET";
})(Z || (Z = {}));
const c7 = {startLine:-1, startCol:-1, startOffset:-1, endLine:-1, endCol:-1, endOffset:-1}, JC = new Set([S.TABLE, S.TBODY, S.TFOOT, S.THEAD, S.TR]), A_ = {scriptingEnabled:!0, sourceCodeLocationInfo:!1, treeAdapter:Ro, onParseError:null};
let N_ = class {
  constructor(e, n, r = null, i = null) {
    this.fragmentContext = r, this.scriptHandler = i, this.currentToken = null, this.stopped = !1, this.insertionMode = Z.INITIAL, this.originalInsertionMode = Z.INITIAL, this.headElement = null, this.formElement = null, this.currentNotInHTML = !1, this.tmplInsertionModeStack = [], this.pendingCharacterTokens = [], this.hasNonWhitespacePendingCharacterToken = !1, this.framesetOk = !0, this.skipNextNewLine = !1, this.fosterParentingEnabled = !1, this.options = {...A_, ...e}, this.treeAdapter = this.options.treeAdapter, 
    this.onParseError = this.options.onParseError, this.onParseError && (this.options.sourceCodeLocationInfo = !0), this.document = n ?? this.treeAdapter.createDocument(), this.tokenizer = new R9(this.options, this), this.activeFormattingElements = new H9(this.treeAdapter), this.fragmentContextID = r ? Tc(this.treeAdapter.getTagName(r)) : S.UNKNOWN, this._setContextModes(r ?? this.document, this.fragmentContextID), this.openElements = new z9(this.document, this.treeAdapter, this);
  }
  static parse(e, n) {
    const r = new this(n);
    return r.tokenizer.write(e, !0), r.document;
  }
  static getFragmentParser(e, n) {
    const r = {...A_, ...n};
    e ?? (e = r.treeAdapter.createElement(ye.TEMPLATE, Fe.HTML, []));
    const i = r.treeAdapter.createElement("documentmock", Fe.HTML, []), s = new this(r, i, e);
    return s.fragmentContextID === S.TEMPLATE && s.tmplInsertionModeStack.unshift(Z.IN_TEMPLATE), s._initTokenizerForFragmentParsing(), s._insertFakeRootElement(), s._resetInsertionMode(), s._findFormInFragmentContext(), s;
  }
  getFragment() {
    const e = this.treeAdapter.getFirstChild(this.document), n = this.treeAdapter.createDocumentFragment();
    return this._adoptNodes(e, n), n;
  }
  _err(e, n, r) {
    var i;
    if (!this.onParseError) {
      return;
    }
    const s = (i = e.location) !== null && i !== void 0 ? i : c7, o = {code:n, startLine:s.startLine, startCol:s.startCol, startOffset:s.startOffset, endLine:r ? s.startLine : s.endLine, endCol:r ? s.startCol : s.endCol, endOffset:r ? s.startOffset : s.endOffset};
    this.onParseError(o);
  }
  onItemPush(e, n, r) {
    var i, s;
    (s = (i = this.treeAdapter).onItemPush) === null || s === void 0 || s.call(i, e), r && this.openElements.stackTop > 0 && this._setContextModes(e, n);
  }
  onItemPop(e, n) {
    var r, i;
    if (this.options.sourceCodeLocationInfo && this._setEndLocation(e, this.currentToken), (i = (r = this.treeAdapter).onItemPop) === null || i === void 0 || i.call(r, e, this.openElements.current), n) {
      let s, o;
      this.openElements.stackTop === 0 && this.fragmentContext ? (s = this.fragmentContext, o = this.fragmentContextID) : {current:s, currentTagId:o} = this.openElements, this._setContextModes(s, o);
    }
  }
  _setContextModes(e, n) {
    const r = e === this.document || e && this.treeAdapter.getNamespaceURI(e) === Fe.HTML;
    this.currentNotInHTML = !r, this.tokenizer.inForeignNode = !r && e !== void 0 && n !== void 0 && !this._isIntegrationPoint(n, e);
  }
  _switchToTextParsing(e, n) {
    this._insertElement(e, Fe.HTML), this.tokenizer.state = n, this.originalInsertionMode = this.insertionMode, this.insertionMode = Z.TEXT;
  }
  switchToPlaintextParsing() {
    this.insertionMode = Z.TEXT, this.originalInsertionMode = Z.IN_BODY, this.tokenizer.state = jn.PLAINTEXT;
  }
  _getAdjustedCurrentElement() {
    return this.openElements.stackTop === 0 && this.fragmentContext ? this.fragmentContext : this.openElements.current;
  }
  _findFormInFragmentContext() {
    let e = this.fragmentContext;
    for (; e;) {
      if (this.treeAdapter.getTagName(e) === ye.FORM) {
        this.formElement = e;
        break;
      }
      e = this.treeAdapter.getParentNode(e);
    }
  }
  _initTokenizerForFragmentParsing() {
    if (!(!this.fragmentContext || this.treeAdapter.getNamespaceURI(this.fragmentContext) !== Fe.HTML)) {
      switch(this.fragmentContextID) {
        case S.TITLE:
        case S.TEXTAREA:
          {
            this.tokenizer.state = jn.RCDATA;
            break;
          }
        case S.STYLE:
        case S.XMP:
        case S.IFRAME:
        case S.NOEMBED:
        case S.NOFRAMES:
        case S.NOSCRIPT:
          {
            this.tokenizer.state = jn.RAWTEXT;
            break;
          }
        case S.SCRIPT:
          {
            this.tokenizer.state = jn.SCRIPT_DATA;
            break;
          }
        case S.PLAINTEXT:
          {
            this.tokenizer.state = jn.PLAINTEXT;
            break;
          }
      }
    }
  }
  _setDocumentType(e) {
    const n = e.name || "", r = e.publicId || "", i = e.systemId || "";
    if (this.treeAdapter.setDocumentType(this.document, n, r, i), e.location) {
      const o = this.treeAdapter.getChildNodes(this.document).find(a => this.treeAdapter.isDocumentTypeNode(a));
      o && this.treeAdapter.setNodeSourceCodeLocation(o, e.location);
    }
  }
  _attachElementToTree(e, n) {
    if (this.options.sourceCodeLocationInfo) {
      const r = n && {...n, startTag:n};
      this.treeAdapter.setNodeSourceCodeLocation(e, r);
    }
    if (this._shouldFosterParentOnInsertion()) {
      this._fosterParentElement(e);
    } else {
      const r = this.openElements.currentTmplContentOrNode;
      this.treeAdapter.appendChild(r ?? this.document, e);
    }
  }
  _appendElement(e, n) {
    const r = this.treeAdapter.createElement(e.tagName, n, e.attrs);
    this._attachElementToTree(r, e.location);
  }
  _insertElement(e, n) {
    const r = this.treeAdapter.createElement(e.tagName, n, e.attrs);
    this._attachElementToTree(r, e.location), this.openElements.push(r, e.tagID);
  }
  _insertFakeElement(e, n) {
    const r = this.treeAdapter.createElement(e, Fe.HTML, []);
    this._attachElementToTree(r, null), this.openElements.push(r, n);
  }
  _insertTemplate(e) {
    const n = this.treeAdapter.createElement(e.tagName, Fe.HTML, e.attrs), r = this.treeAdapter.createDocumentFragment();
    this.treeAdapter.setTemplateContent(n, r), this._attachElementToTree(n, e.location), this.openElements.push(n, e.tagID), this.options.sourceCodeLocationInfo && this.treeAdapter.setNodeSourceCodeLocation(r, null);
  }
  _insertFakeRootElement() {
    const e = this.treeAdapter.createElement(ye.HTML, Fe.HTML, []);
    this.options.sourceCodeLocationInfo && this.treeAdapter.setNodeSourceCodeLocation(e, null), this.treeAdapter.appendChild(this.openElements.current, e), this.openElements.push(e, S.HTML);
  }
  _appendCommentNode(e, n) {
    const r = this.treeAdapter.createCommentNode(e.data);
    this.treeAdapter.appendChild(n, r), this.options.sourceCodeLocationInfo && this.treeAdapter.setNodeSourceCodeLocation(r, e.location);
  }
  _insertCharacters(e) {
    let n, r;
    if (this._shouldFosterParentOnInsertion() ? ({parent:n, beforeElement:r} = this._findFosterParentingLocation(), r ? this.treeAdapter.insertTextBefore(n, e.chars, r) : this.treeAdapter.insertText(n, e.chars)) : (n = this.openElements.currentTmplContentOrNode, this.treeAdapter.insertText(n, e.chars)), !e.location) {
      return;
    }
    const i = this.treeAdapter.getChildNodes(n), s = r ? i.lastIndexOf(r) : i.length, o = i[s - 1];
    if (this.treeAdapter.getNodeSourceCodeLocation(o)) {
      const {endLine:l, endCol:c, endOffset:u} = e.location;
      this.treeAdapter.updateNodeSourceCodeLocation(o, {endLine:l, endCol:c, endOffset:u});
    } else {
      this.options.sourceCodeLocationInfo && this.treeAdapter.setNodeSourceCodeLocation(o, e.location);
    }
  }
  _adoptNodes(e, n) {
    for (let r = this.treeAdapter.getFirstChild(e); r; r = this.treeAdapter.getFirstChild(e)) {
      this.treeAdapter.detachNode(r), this.treeAdapter.appendChild(n, r);
    }
  }
  _setEndLocation(e, n) {
    if (this.treeAdapter.getNodeSourceCodeLocation(e) && n.location) {
      const r = n.location, i = this.treeAdapter.getTagName(e), s = n.type === Pt.END_TAG && i === n.tagName ? {endTag:{...r}, endLine:r.endLine, endCol:r.endCol, endOffset:r.endOffset} : {endLine:r.startLine, endCol:r.startCol, endOffset:r.startOffset};
      this.treeAdapter.updateNodeSourceCodeLocation(e, s);
    }
  }
  shouldProcessStartTagTokenInForeignContent(e) {
    if (!this.currentNotInHTML) {
      return !1;
    }
    let n, r;
    return this.openElements.stackTop === 0 && this.fragmentContext ? (n = this.fragmentContext, r = this.fragmentContextID) : {current:n, currentTagId:r} = this.openElements, e.tagID === S.SVG && this.treeAdapter.getTagName(n) === ye.ANNOTATION_XML && this.treeAdapter.getNamespaceURI(n) === Fe.MATHML ? !1 : this.tokenizer.inForeignNode || (e.tagID === S.MGLYPH || e.tagID === S.MALIGNMARK) && r !== void 0 && !this._isIntegrationPoint(r, n, Fe.HTML);
  }
  _processToken(e) {
    switch(e.type) {
      case Pt.CHARACTER:
        {
          this.onCharacter(e);
          break;
        }
      case Pt.NULL_CHARACTER:
        {
          this.onNullCharacter(e);
          break;
        }
      case Pt.COMMENT:
        {
          this.onComment(e);
          break;
        }
      case Pt.DOCTYPE:
        {
          this.onDoctype(e);
          break;
        }
      case Pt.START_TAG:
        {
          this._processStartTag(e);
          break;
        }
      case Pt.END_TAG:
        {
          this.onEndTag(e);
          break;
        }
      case Pt.EOF:
        {
          this.onEof(e);
          break;
        }
      case Pt.WHITESPACE_CHARACTER:
        {
          this.onWhitespaceCharacter(e);
          break;
        }
    }
  }
  _isIntegrationPoint(e, n, r) {
    const i = this.treeAdapter.getNamespaceURI(n), s = this.treeAdapter.getAttrList(n);
    return s7(e, i, s, r);
  }
  _reconstructActiveFormattingElements() {
    const e = this.activeFormattingElements.entries.length;
    if (e) {
      const n = this.activeFormattingElements.entries.findIndex(i => i.type === Ss.Marker || this.openElements.contains(i.element)), r = n === -1 ? e - 1 : n - 1;
      for (let i = r; i >= 0; i--) {
        const s = this.activeFormattingElements.entries[i];
        this._insertElement(s.token, this.treeAdapter.getNamespaceURI(s.element)), s.element = this.openElements.current;
      }
    }
  }
  _closeTableCell() {
    this.openElements.generateImpliedEndTags(), this.openElements.popUntilTableCellPopped(), this.activeFormattingElements.clearToLastMarker(), this.insertionMode = Z.IN_ROW;
  }
  _closePElement() {
    this.openElements.generateImpliedEndTagsWithExclusion(S.P), this.openElements.popUntilTagNamePopped(S.P);
  }
  _resetInsertionMode() {
    for (let e = this.openElements.stackTop; e >= 0; e--) {
      switch(e === 0 && this.fragmentContext ? this.fragmentContextID : this.openElements.tagIDs[e]) {
        case S.TR:
          {
            this.insertionMode = Z.IN_ROW;
            return;
          }
        case S.TBODY:
        case S.THEAD:
        case S.TFOOT:
          {
            this.insertionMode = Z.IN_TABLE_BODY;
            return;
          }
        case S.CAPTION:
          {
            this.insertionMode = Z.IN_CAPTION;
            return;
          }
        case S.COLGROUP:
          {
            this.insertionMode = Z.IN_COLUMN_GROUP;
            return;
          }
        case S.TABLE:
          {
            this.insertionMode = Z.IN_TABLE;
            return;
          }
        case S.BODY:
          {
            this.insertionMode = Z.IN_BODY;
            return;
          }
        case S.FRAMESET:
          {
            this.insertionMode = Z.IN_FRAMESET;
            return;
          }
        case S.SELECT:
          {
            this._resetInsertionModeForSelect(e);
            return;
          }
        case S.TEMPLATE:
          {
            this.insertionMode = this.tmplInsertionModeStack[0];
            return;
          }
        case S.HTML:
          {
            this.insertionMode = this.headElement ? Z.AFTER_HEAD : Z.BEFORE_HEAD;
            return;
          }
        case S.TD:
        case S.TH:
          {
            if (e > 0) {
              this.insertionMode = Z.IN_CELL;
              return;
            }
            break;
          }
        case S.HEAD:
          {
            if (e > 0) {
              this.insertionMode = Z.IN_HEAD;
              return;
            }
            break;
          }
      }
    }
    this.insertionMode = Z.IN_BODY;
  }
  _resetInsertionModeForSelect(e) {
    if (e > 0) {
      for (let n = e - 1; n > 0; n--) {
        const r = this.openElements.tagIDs[n];
        if (r === S.TEMPLATE) {
          break;
        }
        if (r === S.TABLE) {
          this.insertionMode = Z.IN_SELECT_IN_TABLE;
          return;
        }
      }
    }
    this.insertionMode = Z.IN_SELECT;
  }
  _isElementCausesFosterParenting(e) {
    return JC.has(e);
  }
  _shouldFosterParentOnInsertion() {
    return this.fosterParentingEnabled && this.openElements.currentTagId !== void 0 && this._isElementCausesFosterParenting(this.openElements.currentTagId);
  }
  _findFosterParentingLocation() {
    for (let e = this.openElements.stackTop; e >= 0; e--) {
      const n = this.openElements.items[e];
      switch(this.openElements.tagIDs[e]) {
        case S.TEMPLATE:
          {
            if (this.treeAdapter.getNamespaceURI(n) === Fe.HTML) {
              return {parent:this.treeAdapter.getTemplateContent(n), beforeElement:null};
            }
            break;
          }
        case S.TABLE:
          {
            const r = this.treeAdapter.getParentNode(n);
            return r ? {parent:r, beforeElement:n} : {parent:this.openElements.items[e - 1], beforeElement:null};
          }
      }
    }
    return {parent:this.openElements.items[0], beforeElement:null};
  }
  _fosterParentElement(e) {
    const n = this._findFosterParentingLocation();
    n.beforeElement ? this.treeAdapter.insertBefore(n.parent, e, n.beforeElement) : this.treeAdapter.appendChild(n.parent, e);
  }
  _isSpecialElement(e, n) {
    const r = this.treeAdapter.getNamespaceURI(e);
    return N9[r].has(n);
  }
  onCharacter(e) {
    if (this.skipNextNewLine = !1, this.tokenizer.inForeignNode) {
      FH(this, e);
      return;
    }
    switch(this.insertionMode) {
      case Z.INITIAL:
        {
          Qc(this, e);
          break;
        }
      case Z.BEFORE_HTML:
        {
          Bu(this, e);
          break;
        }
      case Z.BEFORE_HEAD:
        {
          $u(this, e);
          break;
        }
      case Z.IN_HEAD:
        {
          Fu(this, e);
          break;
        }
      case Z.IN_HEAD_NO_SCRIPT:
        {
          zu(this, e);
          break;
        }
      case Z.AFTER_HEAD:
        {
          Hu(this, e);
          break;
        }
      case Z.IN_BODY:
      case Z.IN_CAPTION:
      case Z.IN_CELL:
      case Z.IN_TEMPLATE:
        {
          eA(this, e);
          break;
        }
      case Z.TEXT:
      case Z.IN_SELECT:
      case Z.IN_SELECT_IN_TABLE:
        {
          this._insertCharacters(e);
          break;
        }
      case Z.IN_TABLE:
      case Z.IN_TABLE_BODY:
      case Z.IN_ROW:
        {
          Pm(this, e);
          break;
        }
      case Z.IN_TABLE_TEXT:
        {
          oA(this, e);
          break;
        }
      case Z.IN_COLUMN_GROUP:
        {
          ap(this, e);
          break;
        }
      case Z.AFTER_BODY:
        {
          lp(this, e);
          break;
        }
      case Z.AFTER_AFTER_BODY:
        {
          Nf(this, e);
          break;
        }
    }
  }
  onNullCharacter(e) {
    if (this.skipNextNewLine = !1, this.tokenizer.inForeignNode) {
      $H(this, e);
      return;
    }
    switch(this.insertionMode) {
      case Z.INITIAL:
        {
          Qc(this, e);
          break;
        }
      case Z.BEFORE_HTML:
        {
          Bu(this, e);
          break;
        }
      case Z.BEFORE_HEAD:
        {
          $u(this, e);
          break;
        }
      case Z.IN_HEAD:
        {
          Fu(this, e);
          break;
        }
      case Z.IN_HEAD_NO_SCRIPT:
        {
          zu(this, e);
          break;
        }
      case Z.AFTER_HEAD:
        {
          Hu(this, e);
          break;
        }
      case Z.TEXT:
        {
          this._insertCharacters(e);
          break;
        }
      case Z.IN_TABLE:
      case Z.IN_TABLE_BODY:
      case Z.IN_ROW:
        {
          Pm(this, e);
          break;
        }
      case Z.IN_COLUMN_GROUP:
        {
          ap(this, e);
          break;
        }
      case Z.AFTER_BODY:
        {
          lp(this, e);
          break;
        }
      case Z.AFTER_AFTER_BODY:
        {
          Nf(this, e);
          break;
        }
    }
  }
  onComment(e) {
    if (this.skipNextNewLine = !1, this.currentNotInHTML) {
      _b(this, e);
      return;
    }
    switch(this.insertionMode) {
      case Z.INITIAL:
      case Z.BEFORE_HTML:
      case Z.BEFORE_HEAD:
      case Z.IN_HEAD:
      case Z.IN_HEAD_NO_SCRIPT:
      case Z.AFTER_HEAD:
      case Z.IN_BODY:
      case Z.IN_TABLE:
      case Z.IN_CAPTION:
      case Z.IN_COLUMN_GROUP:
      case Z.IN_TABLE_BODY:
      case Z.IN_ROW:
      case Z.IN_CELL:
      case Z.IN_SELECT:
      case Z.IN_SELECT_IN_TABLE:
      case Z.IN_TEMPLATE:
      case Z.IN_FRAMESET:
      case Z.AFTER_FRAMESET:
        {
          _b(this, e);
          break;
        }
      case Z.IN_TABLE_TEXT:
        {
          Kc(this, e);
          break;
        }
      case Z.AFTER_BODY:
        {
          m7(this, e);
          break;
        }
      case Z.AFTER_AFTER_BODY:
      case Z.AFTER_AFTER_FRAMESET:
        {
          b7(this, e);
          break;
        }
    }
  }
  onDoctype(e) {
    switch(this.skipNextNewLine = !1, this.insertionMode) {
      case Z.INITIAL:
        {
          y7(this, e);
          break;
        }
      case Z.BEFORE_HEAD:
      case Z.IN_HEAD:
      case Z.IN_HEAD_NO_SCRIPT:
      case Z.AFTER_HEAD:
        {
          this._err(e, Se.misplacedDoctype);
          break;
        }
      case Z.IN_TABLE_TEXT:
        {
          Kc(this, e);
          break;
        }
    }
  }
  onStartTag(e) {
    this.skipNextNewLine = !1, this.currentToken = e, this._processStartTag(e), e.selfClosing && !e.ackSelfClosing && this._err(e, Se.nonVoidHtmlElementStartTagWithTrailingSolidus);
  }
  _processStartTag(e) {
    this.shouldProcessStartTagTokenInForeignContent(e) ? zH(this, e) : this._startTagOutsideForeignContent(e);
  }
  _startTagOutsideForeignContent(e) {
    switch(this.insertionMode) {
      case Z.INITIAL:
        {
          Qc(this, e);
          break;
        }
      case Z.BEFORE_HTML:
        {
          x7(this, e);
          break;
        }
      case Z.BEFORE_HEAD:
        {
          w7(this, e);
          break;
        }
      case Z.IN_HEAD:
        {
          cs(this, e);
          break;
        }
      case Z.IN_HEAD_NO_SCRIPT:
        {
          k7(this, e);
          break;
        }
      case Z.AFTER_HEAD:
        {
          T7(this, e);
          break;
        }
      case Z.IN_BODY:
        {
          Or(this, e);
          break;
        }
      case Z.IN_TABLE:
        {
          oc(this, e);
          break;
        }
      case Z.IN_TABLE_TEXT:
        {
          Kc(this, e);
          break;
        }
      case Z.IN_CAPTION:
        {
          _H(this, e);
          break;
        }
      case Z.IN_COLUMN_GROUP:
        {
          Wx(this, e);
          break;
        }
      case Z.IN_TABLE_BODY:
        {
          Eg(this, e);
          break;
        }
      case Z.IN_ROW:
        {
          Tg(this, e);
          break;
        }
      case Z.IN_CELL:
        {
          EH(this, e);
          break;
        }
      case Z.IN_SELECT:
        {
          cA(this, e);
          break;
        }
      case Z.IN_SELECT_IN_TABLE:
        {
          CH(this, e);
          break;
        }
      case Z.IN_TEMPLATE:
        {
          NH(this, e);
          break;
        }
      case Z.AFTER_BODY:
        {
          OH(this, e);
          break;
        }
      case Z.IN_FRAMESET:
        {
          PH(this, e);
          break;
        }
      case Z.AFTER_FRAMESET:
        {
          DH(this, e);
          break;
        }
      case Z.AFTER_AFTER_BODY:
        {
          MH(this, e);
          break;
        }
      case Z.AFTER_AFTER_FRAMESET:
        {
          BH(this, e);
          break;
        }
    }
  }
  onEndTag(e) {
    this.skipNextNewLine = !1, this.currentToken = e, this.currentNotInHTML ? HH(this, e) : this._endTagOutsideForeignContent(e);
  }
  _endTagOutsideForeignContent(e) {
    switch(this.insertionMode) {
      case Z.INITIAL:
        {
          Qc(this, e);
          break;
        }
      case Z.BEFORE_HTML:
        {
          v7(this, e);
          break;
        }
      case Z.BEFORE_HEAD:
        {
          _7(this, e);
          break;
        }
      case Z.IN_HEAD:
        {
          S7(this, e);
          break;
        }
      case Z.IN_HEAD_NO_SCRIPT:
        {
          E7(this, e);
          break;
        }
      case Z.AFTER_HEAD:
        {
          C7(this, e);
          break;
        }
      case Z.IN_BODY:
        {
          kg(this, e);
          break;
        }
      case Z.TEXT:
        {
          hH(this, e);
          break;
        }
      case Z.IN_TABLE:
        {
          dd(this, e);
          break;
        }
      case Z.IN_TABLE_TEXT:
        {
          Kc(this, e);
          break;
        }
      case Z.IN_CAPTION:
        {
          SH(this, e);
          break;
        }
      case Z.IN_COLUMN_GROUP:
        {
          kH(this, e);
          break;
        }
      case Z.IN_TABLE_BODY:
        {
          Sb(this, e);
          break;
        }
      case Z.IN_ROW:
        {
          lA(this, e);
          break;
        }
      case Z.IN_CELL:
        {
          TH(this, e);
          break;
        }
      case Z.IN_SELECT:
        {
          uA(this, e);
          break;
        }
      case Z.IN_SELECT_IN_TABLE:
        {
          AH(this, e);
          break;
        }
      case Z.IN_TEMPLATE:
        {
          IH(this, e);
          break;
        }
      case Z.AFTER_BODY:
        {
          hA(this, e);
          break;
        }
      case Z.IN_FRAMESET:
        {
          RH(this, e);
          break;
        }
      case Z.AFTER_FRAMESET:
        {
          LH(this, e);
          break;
        }
      case Z.AFTER_AFTER_BODY:
        {
          Nf(this, e);
          break;
        }
    }
  }
  onEof(e) {
    switch(this.insertionMode) {
      case Z.INITIAL:
        {
          Qc(this, e);
          break;
        }
      case Z.BEFORE_HTML:
        {
          Bu(this, e);
          break;
        }
      case Z.BEFORE_HEAD:
        {
          $u(this, e);
          break;
        }
      case Z.IN_HEAD:
        {
          Fu(this, e);
          break;
        }
      case Z.IN_HEAD_NO_SCRIPT:
        {
          zu(this, e);
          break;
        }
      case Z.AFTER_HEAD:
        {
          Hu(this, e);
          break;
        }
      case Z.IN_BODY:
      case Z.IN_TABLE:
      case Z.IN_CAPTION:
      case Z.IN_COLUMN_GROUP:
      case Z.IN_TABLE_BODY:
      case Z.IN_ROW:
      case Z.IN_CELL:
      case Z.IN_SELECT:
      case Z.IN_SELECT_IN_TABLE:
        {
          iA(this, e);
          break;
        }
      case Z.TEXT:
        {
          fH(this, e);
          break;
        }
      case Z.IN_TABLE_TEXT:
        {
          Kc(this, e);
          break;
        }
      case Z.IN_TEMPLATE:
        {
          dA(this, e);
          break;
        }
      case Z.AFTER_BODY:
      case Z.IN_FRAMESET:
      case Z.AFTER_FRAMESET:
      case Z.AFTER_AFTER_BODY:
      case Z.AFTER_AFTER_FRAMESET:
        {
          Ux(this, e);
          break;
        }
    }
  }
  onWhitespaceCharacter(e) {
    if (this.skipNextNewLine && (this.skipNextNewLine = !1, e.chars.charCodeAt(0) === Y.LINE_FEED)) {
      if (e.chars.length === 1) {
        return;
      }
      e.chars = e.chars.substr(1);
    }
    if (this.tokenizer.inForeignNode) {
      this._insertCharacters(e);
      return;
    }
    switch(this.insertionMode) {
      case Z.IN_HEAD:
      case Z.IN_HEAD_NO_SCRIPT:
      case Z.AFTER_HEAD:
      case Z.TEXT:
      case Z.IN_COLUMN_GROUP:
      case Z.IN_SELECT:
      case Z.IN_SELECT_IN_TABLE:
      case Z.IN_FRAMESET:
      case Z.AFTER_FRAMESET:
        {
          this._insertCharacters(e);
          break;
        }
      case Z.IN_BODY:
      case Z.IN_CAPTION:
      case Z.IN_CELL:
      case Z.IN_TEMPLATE:
      case Z.AFTER_BODY:
      case Z.AFTER_AFTER_BODY:
      case Z.AFTER_AFTER_FRAMESET:
        {
          ZC(this, e);
          break;
        }
      case Z.IN_TABLE:
      case Z.IN_TABLE_BODY:
      case Z.IN_ROW:
        {
          Pm(this, e);
          break;
        }
      case Z.IN_TABLE_TEXT:
        {
          sA(this, e);
          break;
        }
    }
  }
};
function u7(t, e) {
  let n = t.activeFormattingElements.getElementEntryInScopeWithTagName(e.tagName);
  return n ? t.openElements.contains(n.element) ? t.openElements.hasInScope(e.tagID) || (n = null) : (t.activeFormattingElements.removeEntry(n), n = null) : rA(t, e), n;
}
function d7(t, e) {
  let n = null, r = t.openElements.stackTop;
  for (; r >= 0; r--) {
    const i = t.openElements.items[r];
    if (i === e.element) {
      break;
    }
    t._isSpecialElement(i, t.openElements.tagIDs[r]) && (n = i);
  }
  return n || (t.openElements.shortenToLength(Math.max(r, 0)), t.activeFormattingElements.removeEntry(e)), n;
}
function h7(t, e, n) {
  let r = e, i = t.openElements.getCommonAncestor(e);
  for (let s = 0, o = i; o !== n; s++, o = i) {
    i = t.openElements.getCommonAncestor(o);
    const a = t.activeFormattingElements.getElementEntry(o), l = a && s >= l7;
    !a || l ? (l && t.activeFormattingElements.removeEntry(a), t.openElements.remove(o)) : (o = f7(t, a), r === e && (t.activeFormattingElements.bookmark = a), t.treeAdapter.detachNode(r), t.treeAdapter.appendChild(o, r), r = o);
  }
  return r;
}
function f7(t, e) {
  const n = t.treeAdapter.getNamespaceURI(e.element), r = t.treeAdapter.createElement(e.token.tagName, n, e.token.attrs);
  return t.openElements.replace(e.element, r), e.element = r, r;
}
function p7(t, e, n) {
  const r = t.treeAdapter.getTagName(e), i = Tc(r);
  if (t._isElementCausesFosterParenting(i)) {
    t._fosterParentElement(n);
  } else {
    const s = t.treeAdapter.getNamespaceURI(e);
    i === S.TEMPLATE && s === Fe.HTML && (e = t.treeAdapter.getTemplateContent(e)), t.treeAdapter.appendChild(e, n);
  }
}
function g7(t, e, n) {
  const r = t.treeAdapter.getNamespaceURI(n.element), {token:i} = n, s = t.treeAdapter.createElement(i.tagName, r, i.attrs);
  t._adoptNodes(e, s), t.treeAdapter.appendChild(e, s), t.activeFormattingElements.insertElementAfterBookmark(s, i), t.activeFormattingElements.removeEntry(n), t.openElements.remove(n.element), t.openElements.insertAfter(e, s, i.tagID);
}
function Hx(t, e) {
  for (let n = 0; n < a7; n++) {
    const r = u7(t, e);
    if (!r) {
      break;
    }
    const i = d7(t, r);
    if (!i) {
      break;
    }
    t.activeFormattingElements.bookmark = r;
    const s = h7(t, i, r.element), o = t.openElements.getCommonAncestor(r.element);
    t.treeAdapter.detachNode(s), o && p7(t, o, s), g7(t, i, r);
  }
}
function _b(t, e) {
  t._appendCommentNode(e, t.openElements.currentTmplContentOrNode);
}
function m7(t, e) {
  t._appendCommentNode(e, t.openElements.items[0]);
}
function b7(t, e) {
  t._appendCommentNode(e, t.document);
}
function Ux(t, e) {
  if (t.stopped = !0, e.location) {
    const n = t.fragmentContext ? 0 : 2;
    for (let r = t.openElements.stackTop; r >= n; r--) {
      t._setEndLocation(t.openElements.items[r], e);
    }
    if (!t.fragmentContext && t.openElements.stackTop >= 0) {
      const r = t.openElements.items[0], i = t.treeAdapter.getNodeSourceCodeLocation(r);
      if (i && !i.endTag && (t._setEndLocation(r, e), t.openElements.stackTop >= 1)) {
        const s = t.openElements.items[1], o = t.treeAdapter.getNodeSourceCodeLocation(s);
        o && !o.endTag && t._setEndLocation(s, e);
      }
    }
  }
}
function y7(t, e) {
  t._setDocumentType(e);
  const n = e.forceQuirks ? Ni.QUIRKS : G9(e);
  Y9(e) || t._err(e, Se.nonConformingDoctype), t.treeAdapter.setDocumentMode(t.document, n), t.insertionMode = Z.BEFORE_HTML;
}
function Qc(t, e) {
  t._err(e, Se.missingDoctype, !0), t.treeAdapter.setDocumentMode(t.document, Ni.QUIRKS), t.insertionMode = Z.BEFORE_HTML, t._processToken(e);
}
function x7(t, e) {
  e.tagID === S.HTML ? (t._insertElement(e, Fe.HTML), t.insertionMode = Z.BEFORE_HEAD) : Bu(t, e);
}
function v7(t, e) {
  const n = e.tagID;
  (n === S.HTML || n === S.HEAD || n === S.BODY || n === S.BR) && Bu(t, e);
}
function Bu(t, e) {
  t._insertFakeRootElement(), t.insertionMode = Z.BEFORE_HEAD, t._processToken(e);
}
function w7(t, e) {
  switch(e.tagID) {
    case S.HTML:
      {
        Or(t, e);
        break;
      }
    case S.HEAD:
      {
        t._insertElement(e, Fe.HTML), t.headElement = t.openElements.current, t.insertionMode = Z.IN_HEAD;
        break;
      }
    default:
      $u(t, e);
  }
}
function _7(t, e) {
  const n = e.tagID;
  n === S.HEAD || n === S.BODY || n === S.HTML || n === S.BR ? $u(t, e) : t._err(e, Se.endTagWithoutMatchingOpenElement);
}
function $u(t, e) {
  t._insertFakeElement(ye.HEAD, S.HEAD), t.headElement = t.openElements.current, t.insertionMode = Z.IN_HEAD, t._processToken(e);
}
function cs(t, e) {
  switch(e.tagID) {
    case S.HTML:
      {
        Or(t, e);
        break;
      }
    case S.BASE:
    case S.BASEFONT:
    case S.BGSOUND:
    case S.LINK:
    case S.META:
      {
        t._appendElement(e, Fe.HTML), e.ackSelfClosing = !0;
        break;
      }
    case S.TITLE:
      {
        t._switchToTextParsing(e, jn.RCDATA);
        break;
      }
    case S.NOSCRIPT:
      {
        t.options.scriptingEnabled ? t._switchToTextParsing(e, jn.RAWTEXT) : (t._insertElement(e, Fe.HTML), t.insertionMode = Z.IN_HEAD_NO_SCRIPT);
        break;
      }
    case S.NOFRAMES:
    case S.STYLE:
      {
        t._switchToTextParsing(e, jn.RAWTEXT);
        break;
      }
    case S.SCRIPT:
      {
        t._switchToTextParsing(e, jn.SCRIPT_DATA);
        break;
      }
    case S.TEMPLATE:
      {
        t._insertTemplate(e), t.activeFormattingElements.insertMarker(), t.framesetOk = !1, t.insertionMode = Z.IN_TEMPLATE, t.tmplInsertionModeStack.unshift(Z.IN_TEMPLATE);
        break;
      }
    case S.HEAD:
      {
        t._err(e, Se.misplacedStartTagForHeadElement);
        break;
      }
    default:
      Fu(t, e);
  }
}
function S7(t, e) {
  switch(e.tagID) {
    case S.HEAD:
      {
        t.openElements.pop(), t.insertionMode = Z.AFTER_HEAD;
        break;
      }
    case S.BODY:
    case S.BR:
    case S.HTML:
      {
        Fu(t, e);
        break;
      }
    case S.TEMPLATE:
      {
        ol(t, e);
        break;
      }
    default:
      t._err(e, Se.endTagWithoutMatchingOpenElement);
  }
}
function ol(t, e) {
  t.openElements.tmplCount > 0 ? (t.openElements.generateImpliedEndTagsThoroughly(), t.openElements.currentTagId !== S.TEMPLATE && t._err(e, Se.closingOfElementWithOpenChildElements), t.openElements.popUntilTagNamePopped(S.TEMPLATE), t.activeFormattingElements.clearToLastMarker(), t.tmplInsertionModeStack.shift(), t._resetInsertionMode()) : t._err(e, Se.endTagWithoutMatchingOpenElement);
}
function Fu(t, e) {
  t.openElements.pop(), t.insertionMode = Z.AFTER_HEAD, t._processToken(e);
}
function k7(t, e) {
  switch(e.tagID) {
    case S.HTML:
      {
        Or(t, e);
        break;
      }
    case S.BASEFONT:
    case S.BGSOUND:
    case S.HEAD:
    case S.LINK:
    case S.META:
    case S.NOFRAMES:
    case S.STYLE:
      {
        cs(t, e);
        break;
      }
    case S.NOSCRIPT:
      {
        t._err(e, Se.nestedNoscriptInHead);
        break;
      }
    default:
      zu(t, e);
  }
}
function E7(t, e) {
  switch(e.tagID) {
    case S.NOSCRIPT:
      {
        t.openElements.pop(), t.insertionMode = Z.IN_HEAD;
        break;
      }
    case S.BR:
      {
        zu(t, e);
        break;
      }
    default:
      t._err(e, Se.endTagWithoutMatchingOpenElement);
  }
}
function zu(t, e) {
  const n = e.type === Pt.EOF ? Se.openElementsLeftAfterEof : Se.disallowedContentInNoscriptInHead;
  t._err(e, n), t.openElements.pop(), t.insertionMode = Z.IN_HEAD, t._processToken(e);
}
function T7(t, e) {
  switch(e.tagID) {
    case S.HTML:
      {
        Or(t, e);
        break;
      }
    case S.BODY:
      {
        t._insertElement(e, Fe.HTML), t.framesetOk = !1, t.insertionMode = Z.IN_BODY;
        break;
      }
    case S.FRAMESET:
      {
        t._insertElement(e, Fe.HTML), t.insertionMode = Z.IN_FRAMESET;
        break;
      }
    case S.BASE:
    case S.BASEFONT:
    case S.BGSOUND:
    case S.LINK:
    case S.META:
    case S.NOFRAMES:
    case S.SCRIPT:
    case S.STYLE:
    case S.TEMPLATE:
    case S.TITLE:
      {
        t._err(e, Se.abandonedHeadElementChild), t.openElements.push(t.headElement, S.HEAD), cs(t, e), t.openElements.remove(t.headElement);
        break;
      }
    case S.HEAD:
      {
        t._err(e, Se.misplacedStartTagForHeadElement);
        break;
      }
    default:
      Hu(t, e);
  }
}
function C7(t, e) {
  switch(e.tagID) {
    case S.BODY:
    case S.HTML:
    case S.BR:
      {
        Hu(t, e);
        break;
      }
    case S.TEMPLATE:
      {
        ol(t, e);
        break;
      }
    default:
      t._err(e, Se.endTagWithoutMatchingOpenElement);
  }
}
function Hu(t, e) {
  t._insertFakeElement(ye.BODY, S.BODY), t.insertionMode = Z.IN_BODY, Sg(t, e);
}
function Sg(t, e) {
  switch(e.type) {
    case Pt.CHARACTER:
      {
        eA(t, e);
        break;
      }
    case Pt.WHITESPACE_CHARACTER:
      {
        ZC(t, e);
        break;
      }
    case Pt.COMMENT:
      {
        _b(t, e);
        break;
      }
    case Pt.START_TAG:
      {
        Or(t, e);
        break;
      }
    case Pt.END_TAG:
      {
        kg(t, e);
        break;
      }
    case Pt.EOF:
      {
        iA(t, e);
        break;
      }
  }
}
function ZC(t, e) {
  t._reconstructActiveFormattingElements(), t._insertCharacters(e);
}
function eA(t, e) {
  t._reconstructActiveFormattingElements(), t._insertCharacters(e), t.framesetOk = !1;
}
function A7(t, e) {
  t.openElements.tmplCount === 0 && t.treeAdapter.adoptAttributes(t.openElements.items[0], e.attrs);
}
function N7(t, e) {
  const n = t.openElements.tryPeekProperlyNestedBodyElement();
  n && t.openElements.tmplCount === 0 && (t.framesetOk = !1, t.treeAdapter.adoptAttributes(n, e.attrs));
}
function I7(t, e) {
  const n = t.openElements.tryPeekProperlyNestedBodyElement();
  t.framesetOk && n && (t.treeAdapter.detachNode(n), t.openElements.popAllUpToHtmlElement(), t._insertElement(e, Fe.HTML), t.insertionMode = Z.IN_FRAMESET);
}
function O7(t, e) {
  t.openElements.hasInButtonScope(S.P) && t._closePElement(), t._insertElement(e, Fe.HTML);
}
function P7(t, e) {
  t.openElements.hasInButtonScope(S.P) && t._closePElement(), t.openElements.currentTagId !== void 0 && wb.has(t.openElements.currentTagId) && t.openElements.pop(), t._insertElement(e, Fe.HTML);
}
function R7(t, e) {
  t.openElements.hasInButtonScope(S.P) && t._closePElement(), t._insertElement(e, Fe.HTML), t.skipNextNewLine = !0, t.framesetOk = !1;
}
function D7(t, e) {
  const n = t.openElements.tmplCount > 0;
  (!t.formElement || n) && (t.openElements.hasInButtonScope(S.P) && t._closePElement(), t._insertElement(e, Fe.HTML), n || (t.formElement = t.openElements.current));
}
function L7(t, e) {
  t.framesetOk = !1;
  const n = e.tagID;
  for (let r = t.openElements.stackTop; r >= 0; r--) {
    const i = t.openElements.tagIDs[r];
    if (n === S.LI && i === S.LI || (n === S.DD || n === S.DT) && (i === S.DD || i === S.DT)) {
      t.openElements.generateImpliedEndTagsWithExclusion(i), t.openElements.popUntilTagNamePopped(i);
      break;
    }
    if (i !== S.ADDRESS && i !== S.DIV && i !== S.P && t._isSpecialElement(t.openElements.items[r], i)) {
      break;
    }
  }
  t.openElements.hasInButtonScope(S.P) && t._closePElement(), t._insertElement(e, Fe.HTML);
}
function M7(t, e) {
  t.openElements.hasInButtonScope(S.P) && t._closePElement(), t._insertElement(e, Fe.HTML), t.tokenizer.state = jn.PLAINTEXT;
}
function B7(t, e) {
  t.openElements.hasInScope(S.BUTTON) && (t.openElements.generateImpliedEndTags(), t.openElements.popUntilTagNamePopped(S.BUTTON)), t._reconstructActiveFormattingElements(), t._insertElement(e, Fe.HTML), t.framesetOk = !1;
}
function $7(t, e) {
  const n = t.activeFormattingElements.getElementEntryInScopeWithTagName(ye.A);
  n && (Hx(t, e), t.openElements.remove(n.element), t.activeFormattingElements.removeEntry(n)), t._reconstructActiveFormattingElements(), t._insertElement(e, Fe.HTML), t.activeFormattingElements.pushElement(t.openElements.current, e);
}
function F7(t, e) {
  t._reconstructActiveFormattingElements(), t._insertElement(e, Fe.HTML), t.activeFormattingElements.pushElement(t.openElements.current, e);
}
function z7(t, e) {
  t._reconstructActiveFormattingElements(), t.openElements.hasInScope(S.NOBR) && (Hx(t, e), t._reconstructActiveFormattingElements()), t._insertElement(e, Fe.HTML), t.activeFormattingElements.pushElement(t.openElements.current, e);
}
function H7(t, e) {
  t._reconstructActiveFormattingElements(), t._insertElement(e, Fe.HTML), t.activeFormattingElements.insertMarker(), t.framesetOk = !1;
}
function U7(t, e) {
  t.treeAdapter.getDocumentMode(t.document) !== Ni.QUIRKS && t.openElements.hasInButtonScope(S.P) && t._closePElement(), t._insertElement(e, Fe.HTML), t.framesetOk = !1, t.insertionMode = Z.IN_TABLE;
}
function tA(t, e) {
  t._reconstructActiveFormattingElements(), t._appendElement(e, Fe.HTML), t.framesetOk = !1, e.ackSelfClosing = !0;
}
function nA(t) {
  const e = jC(t, Ha.TYPE);
  return e != null && e.toLowerCase() === o7;
}
function W7(t, e) {
  t._reconstructActiveFormattingElements(), t._appendElement(e, Fe.HTML), nA(e) || (t.framesetOk = !1), e.ackSelfClosing = !0;
}
function j7(t, e) {
  t._appendElement(e, Fe.HTML), e.ackSelfClosing = !0;
}
function V7(t, e) {
  t.openElements.hasInButtonScope(S.P) && t._closePElement(), t._appendElement(e, Fe.HTML), t.framesetOk = !1, e.ackSelfClosing = !0;
}
function q7(t, e) {
  e.tagName = ye.IMG, e.tagID = S.IMG, tA(t, e);
}
function Y7(t, e) {
  t._insertElement(e, Fe.HTML), t.skipNextNewLine = !0, t.tokenizer.state = jn.RCDATA, t.originalInsertionMode = t.insertionMode, t.framesetOk = !1, t.insertionMode = Z.TEXT;
}
function G7(t, e) {
  t.openElements.hasInButtonScope(S.P) && t._closePElement(), t._reconstructActiveFormattingElements(), t.framesetOk = !1, t._switchToTextParsing(e, jn.RAWTEXT);
}
function Q7(t, e) {
  t.framesetOk = !1, t._switchToTextParsing(e, jn.RAWTEXT);
}
function I_(t, e) {
  t._switchToTextParsing(e, jn.RAWTEXT);
}
function K7(t, e) {
  t._reconstructActiveFormattingElements(), t._insertElement(e, Fe.HTML), t.framesetOk = !1, t.insertionMode = t.insertionMode === Z.IN_TABLE || t.insertionMode === Z.IN_CAPTION || t.insertionMode === Z.IN_TABLE_BODY || t.insertionMode === Z.IN_ROW || t.insertionMode === Z.IN_CELL ? Z.IN_SELECT_IN_TABLE : Z.IN_SELECT;
}
function X7(t, e) {
  t.openElements.currentTagId === S.OPTION && t.openElements.pop(), t._reconstructActiveFormattingElements(), t._insertElement(e, Fe.HTML);
}
function J7(t, e) {
  t.openElements.hasInScope(S.RUBY) && t.openElements.generateImpliedEndTags(), t._insertElement(e, Fe.HTML);
}
function Z7(t, e) {
  t.openElements.hasInScope(S.RUBY) && t.openElements.generateImpliedEndTagsWithExclusion(S.RTC), t._insertElement(e, Fe.HTML);
}
function eH(t, e) {
  t._reconstructActiveFormattingElements(), KC(e), zx(e), e.selfClosing ? t._appendElement(e, Fe.MATHML) : t._insertElement(e, Fe.MATHML), e.ackSelfClosing = !0;
}
function tH(t, e) {
  t._reconstructActiveFormattingElements(), XC(e), zx(e), e.selfClosing ? t._appendElement(e, Fe.SVG) : t._insertElement(e, Fe.SVG), e.ackSelfClosing = !0;
}
function O_(t, e) {
  t._reconstructActiveFormattingElements(), t._insertElement(e, Fe.HTML);
}
function Or(t, e) {
  switch(e.tagID) {
    case S.I:
    case S.S:
    case S.B:
    case S.U:
    case S.EM:
    case S.TT:
    case S.BIG:
    case S.CODE:
    case S.FONT:
    case S.SMALL:
    case S.STRIKE:
    case S.STRONG:
      {
        F7(t, e);
        break;
      }
    case S.A:
      {
        $7(t, e);
        break;
      }
    case S.H1:
    case S.H2:
    case S.H3:
    case S.H4:
    case S.H5:
    case S.H6:
      {
        P7(t, e);
        break;
      }
    case S.P:
    case S.DL:
    case S.OL:
    case S.UL:
    case S.DIV:
    case S.DIR:
    case S.NAV:
    case S.MAIN:
    case S.MENU:
    case S.ASIDE:
    case S.CENTER:
    case S.FIGURE:
    case S.FOOTER:
    case S.HEADER:
    case S.HGROUP:
    case S.DIALOG:
    case S.DETAILS:
    case S.ADDRESS:
    case S.ARTICLE:
    case S.SEARCH:
    case S.SECTION:
    case S.SUMMARY:
    case S.FIELDSET:
    case S.BLOCKQUOTE:
    case S.FIGCAPTION:
      {
        O7(t, e);
        break;
      }
    case S.LI:
    case S.DD:
    case S.DT:
      {
        L7(t, e);
        break;
      }
    case S.BR:
    case S.IMG:
    case S.WBR:
    case S.AREA:
    case S.EMBED:
    case S.KEYGEN:
      {
        tA(t, e);
        break;
      }
    case S.HR:
      {
        V7(t, e);
        break;
      }
    case S.RB:
    case S.RTC:
      {
        J7(t, e);
        break;
      }
    case S.RT:
    case S.RP:
      {
        Z7(t, e);
        break;
      }
    case S.PRE:
    case S.LISTING:
      {
        R7(t, e);
        break;
      }
    case S.XMP:
      {
        G7(t, e);
        break;
      }
    case S.SVG:
      {
        tH(t, e);
        break;
      }
    case S.HTML:
      {
        A7(t, e);
        break;
      }
    case S.BASE:
    case S.LINK:
    case S.META:
    case S.STYLE:
    case S.TITLE:
    case S.SCRIPT:
    case S.BGSOUND:
    case S.BASEFONT:
    case S.TEMPLATE:
      {
        cs(t, e);
        break;
      }
    case S.BODY:
      {
        N7(t, e);
        break;
      }
    case S.FORM:
      {
        D7(t, e);
        break;
      }
    case S.NOBR:
      {
        z7(t, e);
        break;
      }
    case S.MATH:
      {
        eH(t, e);
        break;
      }
    case S.TABLE:
      {
        U7(t, e);
        break;
      }
    case S.INPUT:
      {
        W7(t, e);
        break;
      }
    case S.PARAM:
    case S.TRACK:
    case S.SOURCE:
      {
        j7(t, e);
        break;
      }
    case S.IMAGE:
      {
        q7(t, e);
        break;
      }
    case S.BUTTON:
      {
        B7(t, e);
        break;
      }
    case S.APPLET:
    case S.OBJECT:
    case S.MARQUEE:
      {
        H7(t, e);
        break;
      }
    case S.IFRAME:
      {
        Q7(t, e);
        break;
      }
    case S.SELECT:
      {
        K7(t, e);
        break;
      }
    case S.OPTION:
    case S.OPTGROUP:
      {
        X7(t, e);
        break;
      }
    case S.NOEMBED:
    case S.NOFRAMES:
      {
        I_(t, e);
        break;
      }
    case S.FRAMESET:
      {
        I7(t, e);
        break;
      }
    case S.TEXTAREA:
      {
        Y7(t, e);
        break;
      }
    case S.NOSCRIPT:
      {
        t.options.scriptingEnabled ? I_(t, e) : O_(t, e);
        break;
      }
    case S.PLAINTEXT:
      {
        M7(t, e);
        break;
      }
    case S.COL:
    case S.TH:
    case S.TD:
    case S.TR:
    case S.HEAD:
    case S.FRAME:
    case S.TBODY:
    case S.TFOOT:
    case S.THEAD:
    case S.CAPTION:
    case S.COLGROUP:
      break;
    default:
      O_(t, e);
  }
}
function nH(t, e) {
  if (t.openElements.hasInScope(S.BODY) && (t.insertionMode = Z.AFTER_BODY, t.options.sourceCodeLocationInfo)) {
    const n = t.openElements.tryPeekProperlyNestedBodyElement();
    n && t._setEndLocation(n, e);
  }
}
function rH(t, e) {
  t.openElements.hasInScope(S.BODY) && (t.insertionMode = Z.AFTER_BODY, hA(t, e));
}
function iH(t, e) {
  const n = e.tagID;
  t.openElements.hasInScope(n) && (t.openElements.generateImpliedEndTags(), t.openElements.popUntilTagNamePopped(n));
}
function sH(t) {
  const e = t.openElements.tmplCount > 0, {formElement:n} = t;
  e || (t.formElement = null), (n || e) && t.openElements.hasInScope(S.FORM) && (t.openElements.generateImpliedEndTags(), e ? t.openElements.popUntilTagNamePopped(S.FORM) : n && t.openElements.remove(n));
}
function oH(t) {
  t.openElements.hasInButtonScope(S.P) || t._insertFakeElement(ye.P, S.P), t._closePElement();
}
function aH(t) {
  t.openElements.hasInListItemScope(S.LI) && (t.openElements.generateImpliedEndTagsWithExclusion(S.LI), t.openElements.popUntilTagNamePopped(S.LI));
}
function lH(t, e) {
  const n = e.tagID;
  t.openElements.hasInScope(n) && (t.openElements.generateImpliedEndTagsWithExclusion(n), t.openElements.popUntilTagNamePopped(n));
}
function cH(t) {
  t.openElements.hasNumberedHeaderInScope() && (t.openElements.generateImpliedEndTags(), t.openElements.popUntilNumberedHeaderPopped());
}
function uH(t, e) {
  const n = e.tagID;
  t.openElements.hasInScope(n) && (t.openElements.generateImpliedEndTags(), t.openElements.popUntilTagNamePopped(n), t.activeFormattingElements.clearToLastMarker());
}
function dH(t) {
  t._reconstructActiveFormattingElements(), t._insertFakeElement(ye.BR, S.BR), t.openElements.pop(), t.framesetOk = !1;
}
function rA(t, e) {
  const n = e.tagName, r = e.tagID;
  for (let i = t.openElements.stackTop; i > 0; i--) {
    const s = t.openElements.items[i], o = t.openElements.tagIDs[i];
    if (r === o && (r !== S.UNKNOWN || t.treeAdapter.getTagName(s) === n)) {
      t.openElements.generateImpliedEndTagsWithExclusion(r), t.openElements.stackTop >= i && t.openElements.shortenToLength(i);
      break;
    }
    if (t._isSpecialElement(s, o)) {
      break;
    }
  }
}
function kg(t, e) {
  switch(e.tagID) {
    case S.A:
    case S.B:
    case S.I:
    case S.S:
    case S.U:
    case S.EM:
    case S.TT:
    case S.BIG:
    case S.CODE:
    case S.FONT:
    case S.NOBR:
    case S.SMALL:
    case S.STRIKE:
    case S.STRONG:
      {
        Hx(t, e);
        break;
      }
    case S.P:
      {
        oH(t);
        break;
      }
    case S.DL:
    case S.UL:
    case S.OL:
    case S.DIR:
    case S.DIV:
    case S.NAV:
    case S.PRE:
    case S.MAIN:
    case S.MENU:
    case S.ASIDE:
    case S.BUTTON:
    case S.CENTER:
    case S.FIGURE:
    case S.FOOTER:
    case S.HEADER:
    case S.HGROUP:
    case S.DIALOG:
    case S.ADDRESS:
    case S.ARTICLE:
    case S.DETAILS:
    case S.SEARCH:
    case S.SECTION:
    case S.SUMMARY:
    case S.LISTING:
    case S.FIELDSET:
    case S.BLOCKQUOTE:
    case S.FIGCAPTION:
      {
        iH(t, e);
        break;
      }
    case S.LI:
      {
        aH(t);
        break;
      }
    case S.DD:
    case S.DT:
      {
        lH(t, e);
        break;
      }
    case S.H1:
    case S.H2:
    case S.H3:
    case S.H4:
    case S.H5:
    case S.H6:
      {
        cH(t);
        break;
      }
    case S.BR:
      {
        dH(t);
        break;
      }
    case S.BODY:
      {
        nH(t, e);
        break;
      }
    case S.HTML:
      {
        rH(t, e);
        break;
      }
    case S.FORM:
      {
        sH(t);
        break;
      }
    case S.APPLET:
    case S.OBJECT:
    case S.MARQUEE:
      {
        uH(t, e);
        break;
      }
    case S.TEMPLATE:
      {
        ol(t, e);
        break;
      }
    default:
      rA(t, e);
  }
}
function iA(t, e) {
  t.tmplInsertionModeStack.length > 0 ? dA(t, e) : Ux(t, e);
}
function hH(t, e) {
  var n;
  e.tagID === S.SCRIPT && ((n = t.scriptHandler) === null || n === void 0 || n.call(t, t.openElements.current)), t.openElements.pop(), t.insertionMode = t.originalInsertionMode;
}
function fH(t, e) {
  t._err(e, Se.eofInElementThatCanContainOnlyText), t.openElements.pop(), t.insertionMode = t.originalInsertionMode, t.onEof(e);
}
function Pm(t, e) {
  if (t.openElements.currentTagId !== void 0 && JC.has(t.openElements.currentTagId)) {
    switch(t.pendingCharacterTokens.length = 0, t.hasNonWhitespacePendingCharacterToken = !1, t.originalInsertionMode = t.insertionMode, t.insertionMode = Z.IN_TABLE_TEXT, e.type) {
      case Pt.CHARACTER:
        {
          oA(t, e);
          break;
        }
      case Pt.WHITESPACE_CHARACTER:
        {
          sA(t, e);
          break;
        }
    }
  } else {
    Gd(t, e);
  }
}
function pH(t, e) {
  t.openElements.clearBackToTableContext(), t.activeFormattingElements.insertMarker(), t._insertElement(e, Fe.HTML), t.insertionMode = Z.IN_CAPTION;
}
function gH(t, e) {
  t.openElements.clearBackToTableContext(), t._insertElement(e, Fe.HTML), t.insertionMode = Z.IN_COLUMN_GROUP;
}
function mH(t, e) {
  t.openElements.clearBackToTableContext(), t._insertFakeElement(ye.COLGROUP, S.COLGROUP), t.insertionMode = Z.IN_COLUMN_GROUP, Wx(t, e);
}
function bH(t, e) {
  t.openElements.clearBackToTableContext(), t._insertElement(e, Fe.HTML), t.insertionMode = Z.IN_TABLE_BODY;
}
function yH(t, e) {
  t.openElements.clearBackToTableContext(), t._insertFakeElement(ye.TBODY, S.TBODY), t.insertionMode = Z.IN_TABLE_BODY, Eg(t, e);
}
function xH(t, e) {
  t.openElements.hasInTableScope(S.TABLE) && (t.openElements.popUntilTagNamePopped(S.TABLE), t._resetInsertionMode(), t._processStartTag(e));
}
function vH(t, e) {
  nA(e) ? t._appendElement(e, Fe.HTML) : Gd(t, e), e.ackSelfClosing = !0;
}
function wH(t, e) {
  !t.formElement && t.openElements.tmplCount === 0 && (t._insertElement(e, Fe.HTML), t.formElement = t.openElements.current, t.openElements.pop());
}
function oc(t, e) {
  switch(e.tagID) {
    case S.TD:
    case S.TH:
    case S.TR:
      {
        yH(t, e);
        break;
      }
    case S.STYLE:
    case S.SCRIPT:
    case S.TEMPLATE:
      {
        cs(t, e);
        break;
      }
    case S.COL:
      {
        mH(t, e);
        break;
      }
    case S.FORM:
      {
        wH(t, e);
        break;
      }
    case S.TABLE:
      {
        xH(t, e);
        break;
      }
    case S.TBODY:
    case S.TFOOT:
    case S.THEAD:
      {
        bH(t, e);
        break;
      }
    case S.INPUT:
      {
        vH(t, e);
        break;
      }
    case S.CAPTION:
      {
        pH(t, e);
        break;
      }
    case S.COLGROUP:
      {
        gH(t, e);
        break;
      }
    default:
      Gd(t, e);
  }
}
function dd(t, e) {
  switch(e.tagID) {
    case S.TABLE:
      {
        t.openElements.hasInTableScope(S.TABLE) && (t.openElements.popUntilTagNamePopped(S.TABLE), t._resetInsertionMode());
        break;
      }
    case S.TEMPLATE:
      {
        ol(t, e);
        break;
      }
    case S.BODY:
    case S.CAPTION:
    case S.COL:
    case S.COLGROUP:
    case S.HTML:
    case S.TBODY:
    case S.TD:
    case S.TFOOT:
    case S.TH:
    case S.THEAD:
    case S.TR:
      break;
    default:
      Gd(t, e);
  }
}
function Gd(t, e) {
  const n = t.fosterParentingEnabled;
  t.fosterParentingEnabled = !0, Sg(t, e), t.fosterParentingEnabled = n;
}
function sA(t, e) {
  t.pendingCharacterTokens.push(e);
}
function oA(t, e) {
  t.pendingCharacterTokens.push(e), t.hasNonWhitespacePendingCharacterToken = !0;
}
function Kc(t, e) {
  let n = 0;
  if (t.hasNonWhitespacePendingCharacterToken) {
    for (; n < t.pendingCharacterTokens.length; n++) {
      Gd(t, t.pendingCharacterTokens[n]);
    }
  } else {
    for (; n < t.pendingCharacterTokens.length; n++) {
      t._insertCharacters(t.pendingCharacterTokens[n]);
    }
  }
  t.insertionMode = t.originalInsertionMode, t._processToken(e);
}
const aA = new Set([S.CAPTION, S.COL, S.COLGROUP, S.TBODY, S.TD, S.TFOOT, S.TH, S.THEAD, S.TR]);
function _H(t, e) {
  const n = e.tagID;
  aA.has(n) ? t.openElements.hasInTableScope(S.CAPTION) && (t.openElements.generateImpliedEndTags(), t.openElements.popUntilTagNamePopped(S.CAPTION), t.activeFormattingElements.clearToLastMarker(), t.insertionMode = Z.IN_TABLE, oc(t, e)) : Or(t, e);
}
function SH(t, e) {
  const n = e.tagID;
  switch(n) {
    case S.CAPTION:
    case S.TABLE:
      {
        t.openElements.hasInTableScope(S.CAPTION) && (t.openElements.generateImpliedEndTags(), t.openElements.popUntilTagNamePopped(S.CAPTION), t.activeFormattingElements.clearToLastMarker(), t.insertionMode = Z.IN_TABLE, n === S.TABLE && dd(t, e));
        break;
      }
    case S.BODY:
    case S.COL:
    case S.COLGROUP:
    case S.HTML:
    case S.TBODY:
    case S.TD:
    case S.TFOOT:
    case S.TH:
    case S.THEAD:
    case S.TR:
      break;
    default:
      kg(t, e);
  }
}
function Wx(t, e) {
  switch(e.tagID) {
    case S.HTML:
      {
        Or(t, e);
        break;
      }
    case S.COL:
      {
        t._appendElement(e, Fe.HTML), e.ackSelfClosing = !0;
        break;
      }
    case S.TEMPLATE:
      {
        cs(t, e);
        break;
      }
    default:
      ap(t, e);
  }
}
function kH(t, e) {
  switch(e.tagID) {
    case S.COLGROUP:
      {
        t.openElements.currentTagId === S.COLGROUP && (t.openElements.pop(), t.insertionMode = Z.IN_TABLE);
        break;
      }
    case S.TEMPLATE:
      {
        ol(t, e);
        break;
      }
    case S.COL:
      break;
    default:
      ap(t, e);
  }
}
function ap(t, e) {
  t.openElements.currentTagId === S.COLGROUP && (t.openElements.pop(), t.insertionMode = Z.IN_TABLE, t._processToken(e));
}
function Eg(t, e) {
  switch(e.tagID) {
    case S.TR:
      {
        t.openElements.clearBackToTableBodyContext(), t._insertElement(e, Fe.HTML), t.insertionMode = Z.IN_ROW;
        break;
      }
    case S.TH:
    case S.TD:
      {
        t.openElements.clearBackToTableBodyContext(), t._insertFakeElement(ye.TR, S.TR), t.insertionMode = Z.IN_ROW, Tg(t, e);
        break;
      }
    case S.CAPTION:
    case S.COL:
    case S.COLGROUP:
    case S.TBODY:
    case S.TFOOT:
    case S.THEAD:
      {
        t.openElements.hasTableBodyContextInTableScope() && (t.openElements.clearBackToTableBodyContext(), t.openElements.pop(), t.insertionMode = Z.IN_TABLE, oc(t, e));
        break;
      }
    default:
      oc(t, e);
  }
}
function Sb(t, e) {
  const n = e.tagID;
  switch(e.tagID) {
    case S.TBODY:
    case S.TFOOT:
    case S.THEAD:
      {
        t.openElements.hasInTableScope(n) && (t.openElements.clearBackToTableBodyContext(), t.openElements.pop(), t.insertionMode = Z.IN_TABLE);
        break;
      }
    case S.TABLE:
      {
        t.openElements.hasTableBodyContextInTableScope() && (t.openElements.clearBackToTableBodyContext(), t.openElements.pop(), t.insertionMode = Z.IN_TABLE, dd(t, e));
        break;
      }
    case S.BODY:
    case S.CAPTION:
    case S.COL:
    case S.COLGROUP:
    case S.HTML:
    case S.TD:
    case S.TH:
    case S.TR:
      break;
    default:
      dd(t, e);
  }
}
function Tg(t, e) {
  switch(e.tagID) {
    case S.TH:
    case S.TD:
      {
        t.openElements.clearBackToTableRowContext(), t._insertElement(e, Fe.HTML), t.insertionMode = Z.IN_CELL, t.activeFormattingElements.insertMarker();
        break;
      }
    case S.CAPTION:
    case S.COL:
    case S.COLGROUP:
    case S.TBODY:
    case S.TFOOT:
    case S.THEAD:
    case S.TR:
      {
        t.openElements.hasInTableScope(S.TR) && (t.openElements.clearBackToTableRowContext(), t.openElements.pop(), t.insertionMode = Z.IN_TABLE_BODY, Eg(t, e));
        break;
      }
    default:
      oc(t, e);
  }
}
function lA(t, e) {
  switch(e.tagID) {
    case S.TR:
      {
        t.openElements.hasInTableScope(S.TR) && (t.openElements.clearBackToTableRowContext(), t.openElements.pop(), t.insertionMode = Z.IN_TABLE_BODY);
        break;
      }
    case S.TABLE:
      {
        t.openElements.hasInTableScope(S.TR) && (t.openElements.clearBackToTableRowContext(), t.openElements.pop(), t.insertionMode = Z.IN_TABLE_BODY, Sb(t, e));
        break;
      }
    case S.TBODY:
    case S.TFOOT:
    case S.THEAD:
      {
        (t.openElements.hasInTableScope(e.tagID) || t.openElements.hasInTableScope(S.TR)) && (t.openElements.clearBackToTableRowContext(), t.openElements.pop(), t.insertionMode = Z.IN_TABLE_BODY, Sb(t, e));
        break;
      }
    case S.BODY:
    case S.CAPTION:
    case S.COL:
    case S.COLGROUP:
    case S.HTML:
    case S.TD:
    case S.TH:
      break;
    default:
      dd(t, e);
  }
}
function EH(t, e) {
  const n = e.tagID;
  aA.has(n) ? (t.openElements.hasInTableScope(S.TD) || t.openElements.hasInTableScope(S.TH)) && (t._closeTableCell(), Tg(t, e)) : Or(t, e);
}
function TH(t, e) {
  const n = e.tagID;
  switch(n) {
    case S.TD:
    case S.TH:
      {
        t.openElements.hasInTableScope(n) && (t.openElements.generateImpliedEndTags(), t.openElements.popUntilTagNamePopped(n), t.activeFormattingElements.clearToLastMarker(), t.insertionMode = Z.IN_ROW);
        break;
      }
    case S.TABLE:
    case S.TBODY:
    case S.TFOOT:
    case S.THEAD:
    case S.TR:
      {
        t.openElements.hasInTableScope(n) && (t._closeTableCell(), lA(t, e));
        break;
      }
    case S.BODY:
    case S.CAPTION:
    case S.COL:
    case S.COLGROUP:
    case S.HTML:
      break;
    default:
      kg(t, e);
  }
}
function cA(t, e) {
  switch(e.tagID) {
    case S.HTML:
      {
        Or(t, e);
        break;
      }
    case S.OPTION:
      {
        t.openElements.currentTagId === S.OPTION && t.openElements.pop(), t._insertElement(e, Fe.HTML);
        break;
      }
    case S.OPTGROUP:
      {
        t.openElements.currentTagId === S.OPTION && t.openElements.pop(), t.openElements.currentTagId === S.OPTGROUP && t.openElements.pop(), t._insertElement(e, Fe.HTML);
        break;
      }
    case S.HR:
      {
        t.openElements.currentTagId === S.OPTION && t.openElements.pop(), t.openElements.currentTagId === S.OPTGROUP && t.openElements.pop(), t._appendElement(e, Fe.HTML), e.ackSelfClosing = !0;
        break;
      }
    case S.INPUT:
    case S.KEYGEN:
    case S.TEXTAREA:
    case S.SELECT:
      {
        t.openElements.hasInSelectScope(S.SELECT) && (t.openElements.popUntilTagNamePopped(S.SELECT), t._resetInsertionMode(), e.tagID !== S.SELECT && t._processStartTag(e));
        break;
      }
    case S.SCRIPT:
    case S.TEMPLATE:
      {
        cs(t, e);
        break;
      }
  }
}
function uA(t, e) {
  switch(e.tagID) {
    case S.OPTGROUP:
      {
        t.openElements.stackTop > 0 && t.openElements.currentTagId === S.OPTION && t.openElements.tagIDs[t.openElements.stackTop - 1] === S.OPTGROUP && t.openElements.pop(), t.openElements.currentTagId === S.OPTGROUP && t.openElements.pop();
        break;
      }
    case S.OPTION:
      {
        t.openElements.currentTagId === S.OPTION && t.openElements.pop();
        break;
      }
    case S.SELECT:
      {
        t.openElements.hasInSelectScope(S.SELECT) && (t.openElements.popUntilTagNamePopped(S.SELECT), t._resetInsertionMode());
        break;
      }
    case S.TEMPLATE:
      {
        ol(t, e);
        break;
      }
  }
}
function CH(t, e) {
  const n = e.tagID;
  n === S.CAPTION || n === S.TABLE || n === S.TBODY || n === S.TFOOT || n === S.THEAD || n === S.TR || n === S.TD || n === S.TH ? (t.openElements.popUntilTagNamePopped(S.SELECT), t._resetInsertionMode(), t._processStartTag(e)) : cA(t, e);
}
function AH(t, e) {
  const n = e.tagID;
  n === S.CAPTION || n === S.TABLE || n === S.TBODY || n === S.TFOOT || n === S.THEAD || n === S.TR || n === S.TD || n === S.TH ? t.openElements.hasInTableScope(n) && (t.openElements.popUntilTagNamePopped(S.SELECT), t._resetInsertionMode(), t.onEndTag(e)) : uA(t, e);
}
function NH(t, e) {
  switch(e.tagID) {
    case S.BASE:
    case S.BASEFONT:
    case S.BGSOUND:
    case S.LINK:
    case S.META:
    case S.NOFRAMES:
    case S.SCRIPT:
    case S.STYLE:
    case S.TEMPLATE:
    case S.TITLE:
      {
        cs(t, e);
        break;
      }
    case S.CAPTION:
    case S.COLGROUP:
    case S.TBODY:
    case S.TFOOT:
    case S.THEAD:
      {
        t.tmplInsertionModeStack[0] = Z.IN_TABLE, t.insertionMode = Z.IN_TABLE, oc(t, e);
        break;
      }
    case S.COL:
      {
        t.tmplInsertionModeStack[0] = Z.IN_COLUMN_GROUP, t.insertionMode = Z.IN_COLUMN_GROUP, Wx(t, e);
        break;
      }
    case S.TR:
      {
        t.tmplInsertionModeStack[0] = Z.IN_TABLE_BODY, t.insertionMode = Z.IN_TABLE_BODY, Eg(t, e);
        break;
      }
    case S.TD:
    case S.TH:
      {
        t.tmplInsertionModeStack[0] = Z.IN_ROW, t.insertionMode = Z.IN_ROW, Tg(t, e);
        break;
      }
    default:
      t.tmplInsertionModeStack[0] = Z.IN_BODY, t.insertionMode = Z.IN_BODY, Or(t, e);
  }
}
function IH(t, e) {
  e.tagID === S.TEMPLATE && ol(t, e);
}
function dA(t, e) {
  t.openElements.tmplCount > 0 ? (t.openElements.popUntilTagNamePopped(S.TEMPLATE), t.activeFormattingElements.clearToLastMarker(), t.tmplInsertionModeStack.shift(), t._resetInsertionMode(), t.onEof(e)) : Ux(t, e);
}
function OH(t, e) {
  e.tagID === S.HTML ? Or(t, e) : lp(t, e);
}
function hA(t, e) {
  var n;
  if (e.tagID === S.HTML) {
    if (t.fragmentContext || (t.insertionMode = Z.AFTER_AFTER_BODY), t.options.sourceCodeLocationInfo && t.openElements.tagIDs[0] === S.HTML) {
      t._setEndLocation(t.openElements.items[0], e);
      const r = t.openElements.items[1];
      r && !(!((n = t.treeAdapter.getNodeSourceCodeLocation(r)) === null || n === void 0) && n.endTag) && t._setEndLocation(r, e);
    }
  } else {
    lp(t, e);
  }
}
function lp(t, e) {
  t.insertionMode = Z.IN_BODY, Sg(t, e);
}
function PH(t, e) {
  switch(e.tagID) {
    case S.HTML:
      {
        Or(t, e);
        break;
      }
    case S.FRAMESET:
      {
        t._insertElement(e, Fe.HTML);
        break;
      }
    case S.FRAME:
      {
        t._appendElement(e, Fe.HTML), e.ackSelfClosing = !0;
        break;
      }
    case S.NOFRAMES:
      {
        cs(t, e);
        break;
      }
  }
}
function RH(t, e) {
  e.tagID === S.FRAMESET && !t.openElements.isRootHtmlElementCurrent() && (t.openElements.pop(), !t.fragmentContext && t.openElements.currentTagId !== S.FRAMESET && (t.insertionMode = Z.AFTER_FRAMESET));
}
function DH(t, e) {
  switch(e.tagID) {
    case S.HTML:
      {
        Or(t, e);
        break;
      }
    case S.NOFRAMES:
      {
        cs(t, e);
        break;
      }
  }
}
function LH(t, e) {
  e.tagID === S.HTML && (t.insertionMode = Z.AFTER_AFTER_FRAMESET);
}
function MH(t, e) {
  e.tagID === S.HTML ? Or(t, e) : Nf(t, e);
}
function Nf(t, e) {
  t.insertionMode = Z.IN_BODY, Sg(t, e);
}
function BH(t, e) {
  switch(e.tagID) {
    case S.HTML:
      {
        Or(t, e);
        break;
      }
    case S.NOFRAMES:
      {
        cs(t, e);
        break;
      }
  }
}
function $H(t, e) {
  e.chars = Tn, t._insertCharacters(e);
}
function FH(t, e) {
  t._insertCharacters(e), t.framesetOk = !1;
}
function fA(t) {
  for (; t.treeAdapter.getNamespaceURI(t.openElements.current) !== Fe.HTML && t.openElements.currentTagId !== void 0 && !t._isIntegrationPoint(t.openElements.currentTagId, t.openElements.current);) {
    t.openElements.pop();
  }
}
function zH(t, e) {
  if (t7(e)) {
    fA(t), t._startTagOutsideForeignContent(e);
  } else {
    const n = t._getAdjustedCurrentElement(), r = t.treeAdapter.getNamespaceURI(n);
    r === Fe.MATHML ? KC(e) : r === Fe.SVG && (n7(e), XC(e)), zx(e), e.selfClosing ? t._appendElement(e, r) : t._insertElement(e, r), e.ackSelfClosing = !0;
  }
}
function HH(t, e) {
  if (e.tagID === S.P || e.tagID === S.BR) {
    fA(t), t._endTagOutsideForeignContent(e);
    return;
  }
  for (let n = t.openElements.stackTop; n > 0; n--) {
    const r = t.openElements.items[n];
    if (t.treeAdapter.getNamespaceURI(r) === Fe.HTML) {
      t._endTagOutsideForeignContent(e);
      break;
    }
    const i = t.treeAdapter.getTagName(r);
    if (i.toLowerCase() === e.tagName) {
      e.tagName = i, t.openElements.shortenToLength(n);
      break;
    }
  }
}
ye.AREA, ye.BASE, ye.BASEFONT, ye.BGSOUND, ye.BR, ye.COL, ye.EMBED, ye.FRAME, ye.HR, ye.IMG, ye.INPUT, ye.KEYGEN, ye.LINK, ye.META, ye.PARAM, ye.SOURCE, ye.TRACK, ye.WBR;
const UH = /<(\/?)(iframe|noembed|noframes|plaintext|script|style|textarea|title|xmp)(?=[\t\n\f\r />])/gi, WH = new Set(["mdxFlowExpression", "mdxJsxFlowElement", "mdxJsxTextElement", "mdxTextExpression", "mdxjsEsm"]), P_ = {sourceCodeLocationInfo:!0, scriptingEnabled:!1};
function pA(t, e) {
  const n = ZH(t), r = bC("type", {handlers:{root:jH, element:VH, text:qH, comment:mA, doctype:YH, raw:QH}, unknown:KH}), i = {parser:n ? new N_(P_) : N_.getFragmentParser(void 0, P_), handle(a) {
    r(a, i);
  }, stitches:!1, options:e || {}};
  r(t, i), Cc(i, Bs());
  const s = n ? i.parser.document : i.parser.getFragment(), o = e9(s, {file:i.options.file});
  return i.stitches && _g(o, "comment", function(a, l, c) {
    const u = a;
    if (u.value.stitch && c && l !== void 0) {
      const h = c.children;
      return h[l] = u.value.stitch, l;
    }
  }), o.type === "root" && o.children.length === 1 && o.children[0].type === t.type ? o.children[0] : o;
}
function gA(t, e) {
  let n = -1;
  if (t) {
    for (; ++n < t.length;) {
      e.handle(t[n]);
    }
  }
}
function jH(t, e) {
  gA(t.children, e);
}
function VH(t, e) {
  XH(t, e), gA(t.children, e), JH(t, e);
}
function qH(t, e) {
  e.parser.tokenizer.state > 4 && (e.parser.tokenizer.state = 0);
  const n = {type:Pt.CHARACTER, chars:t.value, location:Qd(t)};
  Cc(e, Bs(t)), e.parser.currentToken = n, e.parser._processToken(e.parser.currentToken);
}
function YH(t, e) {
  const n = {type:Pt.DOCTYPE, name:"html", forceQuirks:!1, publicId:"", systemId:"", location:Qd(t)};
  Cc(e, Bs(t)), e.parser.currentToken = n, e.parser._processToken(e.parser.currentToken);
}
function GH(t, e) {
  e.stitches = !0;
  const n = eU(t);
  if ("children" in t && "children" in n) {
    const r = pA({type:"root", children:t.children}, e.options);
    n.children = r.children;
  }
  mA({type:"comment", value:{stitch:n}}, e);
}
function mA(t, e) {
  const n = t.value, r = {type:Pt.COMMENT, data:n, location:Qd(t)};
  Cc(e, Bs(t)), e.parser.currentToken = r, e.parser._processToken(e.parser.currentToken);
}
function QH(t, e) {
  if (e.parser.tokenizer.preprocessor.html = "", e.parser.tokenizer.preprocessor.pos = -1, e.parser.tokenizer.preprocessor.lastGapPos = -2, e.parser.tokenizer.preprocessor.gapStack = [], e.parser.tokenizer.preprocessor.skipNextNewLine = !1, e.parser.tokenizer.preprocessor.lastChunkWritten = !1, e.parser.tokenizer.preprocessor.endOfChunkHit = !1, e.parser.tokenizer.preprocessor.isEol = !1, bA(e, Bs(t)), e.parser.tokenizer.write(e.options.tagfilter ? t.value.replace(UH, "\x26lt;$1$2") : t.value, !1), 
  e.parser.tokenizer._runParsingLoop(), e.parser.tokenizer.state === 72 || e.parser.tokenizer.state === 78) {
    e.parser.tokenizer.preprocessor.lastChunkWritten = !0;
    const n = e.parser.tokenizer._consume();
    e.parser.tokenizer._callState(n);
  }
}
function KH(t, e) {
  const n = t;
  if (e.options.passThrough && e.options.passThrough.includes(n.type)) {
    GH(n, e);
  } else {
    let r = "";
    throw WH.has(n.type) && (r = ". It looks like you are using MDX nodes with `hast-util-raw` (or `rehype-raw`). If you use this because you are using remark or rehype plugins that inject `'html'` nodes, then please raise an issue with that plugin, as its a bad and slow idea. If you use this because you are using markdown syntax, then you have to configure this utility (or plugin) to pass through these nodes (see `passThrough` in docs), but you can also migrate to use the MDX syntax"), new Error("Cannot compile `" + 
    n.type + "` node" + r);
  }
}
function Cc(t, e) {
  bA(t, e);
  const n = t.parser.tokenizer.currentCharacterToken;
  n && n.location && (n.location.endLine = t.parser.tokenizer.preprocessor.line, n.location.endCol = t.parser.tokenizer.preprocessor.col + 1, n.location.endOffset = t.parser.tokenizer.preprocessor.offset + 1, t.parser.currentToken = n, t.parser._processToken(t.parser.currentToken)), t.parser.tokenizer.paused = !1, t.parser.tokenizer.inLoop = !1, t.parser.tokenizer.active = !1, t.parser.tokenizer.returnState = jn.DATA, t.parser.tokenizer.charRefCode = -1, t.parser.tokenizer.consumedAfterSnapshot = 
  -1, t.parser.tokenizer.currentLocation = null, t.parser.tokenizer.currentCharacterToken = null, t.parser.tokenizer.currentToken = null, t.parser.tokenizer.currentAttr = {name:"", value:""};
}
function bA(t, e) {
  if (e && e.offset !== void 0) {
    const n = {startLine:e.line, startCol:e.column, startOffset:e.offset, endLine:-1, endCol:-1, endOffset:-1};
    t.parser.tokenizer.preprocessor.lineStartPos = -e.column + 1, t.parser.tokenizer.preprocessor.droppedBufferSize = e.offset, t.parser.tokenizer.preprocessor.line = e.line, t.parser.tokenizer.currentLocation = n;
  }
}
function XH(t, e) {
  const n = t.tagName.toLowerCase();
  if (e.parser.tokenizer.state === jn.PLAINTEXT) {
    return;
  }
  Cc(e, Bs(t));
  const r = e.parser.openElements.current;
  let i = "namespaceURI" in r ? r.namespaceURI : Pa.html;
  i === Pa.html && n === "svg" && (i = Pa.svg);
  const s = s9({...t, children:[]}, {space:i === Pa.svg ? "svg" : "html"}), o = {type:Pt.START_TAG, tagName:n, tagID:Tc(n), selfClosing:!1, ackSelfClosing:!1, attrs:"attrs" in s ? s.attrs : [], location:Qd(t)};
  e.parser.currentToken = o, e.parser._processToken(e.parser.currentToken), e.parser.tokenizer.lastStartTagName = n;
}
function JH(t, e) {
  const n = t.tagName.toLowerCase();
  if (!e.parser.tokenizer.inForeignNode && f9.includes(n) || e.parser.tokenizer.state === jn.PLAINTEXT) {
    return;
  }
  Cc(e, mg(t));
  const r = {type:Pt.END_TAG, tagName:n, tagID:Tc(n), selfClosing:!1, ackSelfClosing:!1, attrs:[], location:Qd(t)};
  e.parser.currentToken = r, e.parser._processToken(e.parser.currentToken), n === e.parser.tokenizer.lastStartTagName && (e.parser.tokenizer.state === jn.RCDATA || e.parser.tokenizer.state === jn.RAWTEXT || e.parser.tokenizer.state === jn.SCRIPT_DATA) && (e.parser.tokenizer.state = jn.DATA);
}
function ZH(t) {
  const e = t.type === "root" ? t.children[0] : t;
  return !!(e && (e.type === "doctype" || e.type === "element" && e.tagName.toLowerCase() === "html"));
}
function Qd(t) {
  const e = Bs(t) || {line:void 0, column:void 0, offset:void 0}, n = mg(t) || {line:void 0, column:void 0, offset:void 0};
  return {startLine:e.line, startCol:e.column, startOffset:e.offset, endLine:n.line, endCol:n.column, endOffset:n.offset};
}
function eU(t) {
  return "children" in t ? sc({...t, children:[]}) : sc(t);
}
function tU(t) {
  return function(e, n) {
    return pA(e, {...t, file:n});
  };
}
function yA(t) {
  var e, n, r = "";
  if (typeof t == "string" || typeof t == "number") {
    r += t;
  } else if (typeof t == "object") {
    if (Array.isArray(t)) {
      var i = t.length;
      for (e = 0; e < i; e++) {
        t[e] && (n = yA(t[e])) && (r && (r += " "), r += n);
      }
    } else {
      for (n in t) {
        t[n] && (r && (r += " "), r += n);
      }
    }
  }
  return r;
}
function xA() {
  for (var t, e, n = 0, r = "", i = arguments.length; n < i; n++) {
    (t = arguments[n]) && (e = yA(t)) && (r && (r += " "), r += e);
  }
  return r;
}
var nU = Object.create, Cg = Object.defineProperty, rU = Object.defineProperties, iU = Object.getOwnPropertyDescriptor, sU = Object.getOwnPropertyDescriptors, vA = Object.getOwnPropertyNames, cp = Object.getOwnPropertySymbols, oU = Object.getPrototypeOf, jx = Object.prototype.hasOwnProperty, wA = Object.prototype.propertyIsEnumerable, R_ = (t, e, n) => e in t ? Cg(t, e, {enumerable:!0, configurable:!0, writable:!0, value:n}) : t[e] = n, Ps = (t, e) => {
  for (var n in e || (e = {})) {
    jx.call(e, n) && R_(t, n, e[n]);
  }
  if (cp) {
    for (var n of cp(e)) {
      wA.call(e, n) && R_(t, n, e[n]);
    }
  }
  return t;
}, Ag = (t, e) => rU(t, sU(e)), _A = (t, e) => {
  var n = {};
  for (var r in t) {
    jx.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
  }
  if (t != null && cp) {
    for (var r of cp(t)) {
      e.indexOf(r) < 0 && wA.call(t, r) && (n[r] = t[r]);
    }
  }
  return n;
}, aU = (t, e) => function() {
  return e || (0,t[vA(t)[0]])((e = {exports:{}}).exports, e), e.exports;
}, lU = (t, e) => {
  for (var n in e) {
    Cg(t, n, {get:e[n], enumerable:!0});
  }
}, cU = (t, e, n, r) => {
  if (e && typeof e == "object" || typeof e == "function") {
    for (let i of vA(e)) {
      !jx.call(t, i) && i !== n && Cg(t, i, {get:() => e[i], enumerable:!(r = iU(e, i)) || r.enumerable});
    }
  }
  return t;
}, uU = (t, e, n) => (n = t != null ? nU(oU(t)) : {}, cU(!t || !t.__esModule ? Cg(n, "default", {value:t, enumerable:!0}) : n, t)), dU = aU({["../../node_modules/.pnpm/prismjs@1.29.0_patch_hash\x3dvrxx3pzkik6jpmgpayxfjunetu/node_modules/prismjs/prism.js"](t, e) {
  var n = function() {
    var r = /(?:^|\s)lang(?:uage)?-([\w-]+)(?=\s|$)/i, i = 0, s = {}, o = {util:{encode:function g(m) {
      return m instanceof a ? new a(m.type, g(m.content), m.alias) : Array.isArray(m) ? m.map(g) : m.replace(/&/g, "\x26amp;").replace(/</g, "\x26lt;").replace(/\u00a0/g, " ");
    }, type:function(g) {
      return Object.prototype.toString.call(g).slice(8, -1);
    }, objId:function(g) {
      return g.__id || Object.defineProperty(g, "__id", {value:++i}), g.__id;
    }, clone:function g(m, b) {
      b = b || {};
      var x, w;
      switch(o.util.type(m)) {
        case "Object":
          if (w = o.util.objId(m), b[w]) {
            return b[w];
          }
          x = {}, b[w] = x;
          for (var v in m) {
            m.hasOwnProperty(v) && (x[v] = g(m[v], b));
          }
          return x;
        case "Array":
          return w = o.util.objId(m), b[w] ? b[w] : (x = [], b[w] = x, m.forEach(function(T, I) {
            x[I] = g(T, b);
          }), x);
        default:
          return m;
      }
    }, getLanguage:function(g) {
      for (; g;) {
        var m = r.exec(g.className);
        if (m) {
          return m[1].toLowerCase();
        }
        g = g.parentElement;
      }
      return "none";
    }, setLanguage:function(g, m) {
      g.className = g.className.replace(RegExp(r, "gi"), ""), g.classList.add("language-" + m);
    }, isActive:function(g, m, b) {
      for (var x = "no-" + m; g;) {
        var w = g.classList;
        if (w.contains(m)) {
          return !0;
        }
        if (w.contains(x)) {
          return !1;
        }
        g = g.parentElement;
      }
      return !!b;
    }}, languages:{plain:s, plaintext:s, text:s, txt:s, extend:function(g, m) {
      var b = o.util.clone(o.languages[g]);
      for (var x in m) {
        b[x] = m[x];
      }
      return b;
    }, insertBefore:function(g, m, b, x) {
      x = x || o.languages;
      var w = x[g], v = {};
      for (var T in w) {
        if (w.hasOwnProperty(T)) {
          if (T == m) {
            for (var I in b) {
              b.hasOwnProperty(I) && (v[I] = b[I]);
            }
          }
          b.hasOwnProperty(T) || (v[T] = w[T]);
        }
      }
      var _ = x[g];
      return x[g] = v, o.languages.DFS(o.languages, function(N, E) {
        E === _ && N != g && (this[N] = v);
      }), v;
    }, DFS:function g(m, b, x, w) {
      w = w || {};
      var v = o.util.objId;
      for (var T in m) {
        if (m.hasOwnProperty(T)) {
          b.call(m, T, m[T], x || T);
          var I = m[T], _ = o.util.type(I);
          _ === "Object" && !w[v(I)] ? (w[v(I)] = !0, g(I, b, null, w)) : _ === "Array" && !w[v(I)] && (w[v(I)] = !0, g(I, b, T, w));
        }
      }
    }}, plugins:{}, highlight:function(g, m, b) {
      var x = {code:g, grammar:m, language:b};
      if (o.hooks.run("before-tokenize", x), !x.grammar) {
        throw new Error('The language "' + x.language + '" has no grammar.');
      }
      return x.tokens = o.tokenize(x.code, x.grammar), o.hooks.run("after-tokenize", x), a.stringify(o.util.encode(x.tokens), x.language);
    }, tokenize:function(g, m) {
      var b = m.rest;
      if (b) {
        for (var x in b) {
          m[x] = b[x];
        }
        delete m.rest;
      }
      var w = new u();
      return h(w, w.head, g), c(g, w, m, w.head, 0), p(w);
    }, hooks:{all:{}, add:function(g, m) {
      var b = o.hooks.all;
      b[g] = b[g] || [], b[g].push(m);
    }, run:function(g, m) {
      var b = o.hooks.all[g];
      if (!(!b || !b.length)) {
        for (var x = 0, w; w = b[x++];) {
          w(m);
        }
      }
    }}, Token:a};
    function a(g, m, b, x) {
      this.type = g, this.content = m, this.alias = b, this.length = (x || "").length | 0;
    }
    a.stringify = function g(m, b) {
      if (typeof m == "string") {
        return m;
      }
      if (Array.isArray(m)) {
        var x = "";
        return m.forEach(function(_) {
          x += g(_, b);
        }), x;
      }
      var w = {type:m.type, content:g(m.content, b), tag:"span", classes:["token", m.type], attributes:{}, language:b}, v = m.alias;
      v && (Array.isArray(v) ? Array.prototype.push.apply(w.classes, v) : w.classes.push(v)), o.hooks.run("wrap", w);
      var T = "";
      for (var I in w.attributes) {
        T += " " + I + '\x3d"' + (w.attributes[I] || "").replace(/"/g, "\x26quot;") + '"';
      }
      return "\x3c" + w.tag + ' class\x3d"' + w.classes.join(" ") + '"' + T + "\x3e" + w.content + "\x3c/" + w.tag + "\x3e";
    };
    function l(g, m, b, x) {
      g.lastIndex = m;
      var w = g.exec(b);
      if (w && x && w[1]) {
        var v = w[1].length;
        w.index += v, w[0] = w[0].slice(v);
      }
      return w;
    }
    function c(g, m, b, x, w, v) {
      for (var T in b) {
        if (!(!b.hasOwnProperty(T) || !b[T])) {
          var I = b[T];
          I = Array.isArray(I) ? I : [I];
          for (var _ = 0; _ < I.length; ++_) {
            if (v && v.cause == T + "," + _) {
              return;
            }
            var N = I[_], E = N.inside, C = !!N.lookbehind, k = !!N.greedy, A = N.alias;
            if (k && !N.pattern.global) {
              var P = N.pattern.toString().match(/[imsuy]*$/)[0];
              N.pattern = RegExp(N.pattern.source, P + "g");
            }
            for (var W = N.pattern || N, F = x.next, B = w; F !== m.tail && !(v && B >= v.reach); B += F.value.length, F = F.next) {
              var z = F.value;
              if (m.length > g.length) {
                return;
              }
              if (!(z instanceof a)) {
                var j = 1, V;
                if (k) {
                  if (V = l(W, B, g, C), !V || V.index >= g.length) {
                    break;
                  }
                  var ee = V.index, ne = V.index + V[0].length, D = B;
                  for (D += F.value.length; ee >= D;) {
                    F = F.next, D += F.value.length;
                  }
                  if (D -= F.value.length, B = D, F.value instanceof a) {
                    continue;
                  }
                  for (var ie = F; ie !== m.tail && (D < ne || typeof ie.value == "string"); ie = ie.next) {
                    j++, D += ie.value.length;
                  }
                  j--, z = g.slice(B, D), V.index -= B;
                } else if (V = l(W, 0, z, C), !V) {
                  continue;
                }
                var ee = V.index, M = V[0], X = z.slice(0, ee), ge = z.slice(ee + M.length), me = B + z.length;
                v && me > v.reach && (v.reach = me);
                var te = F.prev;
                X && (te = h(m, te, X), B += X.length), f(m, te, j);
                var q = new a(T, E ? o.tokenize(M, E) : M, A, M);
                if (F = h(m, te, q), ge && h(m, F, ge), j > 1) {
                  var R = {cause:T + "," + _, reach:me};
                  c(g, m, b, F.prev, B, R), v && R.reach > v.reach && (v.reach = R.reach);
                }
              }
            }
          }
        }
      }
    }
    function u() {
      var g = {value:null, prev:null, next:null}, m = {value:null, prev:g, next:null};
      g.next = m, this.head = g, this.tail = m, this.length = 0;
    }
    function h(g, m, b) {
      var x = m.next, w = {value:b, prev:m, next:x};
      return m.next = w, x.prev = w, g.length++, w;
    }
    function f(g, m, b) {
      for (var x = m.next, w = 0; w < b && x !== g.tail; w++) {
        x = x.next;
      }
      m.next = x, x.prev = m, g.length -= w;
    }
    function p(g) {
      for (var m = [], b = g.head.next; b !== g.tail;) {
        m.push(b.value), b = b.next;
      }
      return m;
    }
    return o;
  }();
  e.exports = n, n.default = n;
}}), Ne = uU(dU());
Ne.languages.markup = {comment:{pattern:/\x3c!--(?:(?!\x3c!--)[\s\S])*?--\x3e/, greedy:!0}, prolog:{pattern:/<\?[\s\S]+?\?>/, greedy:!0}, doctype:{pattern:/<!DOCTYPE(?:[^>"'[\]]|"[^"]*"|'[^']*')+(?:\[(?:[^<"'\]]|"[^"]*"|'[^']*'|<(?!!--)|\x3c!--(?:[^-]|-(?!->))*--\x3e)*\]\s*)?>/i, greedy:!0, inside:{"internal-subset":{pattern:/(^[^\[]*\[)[\s\S]+(?=\]>$)/, lookbehind:!0, greedy:!0, inside:null}, string:{pattern:/"[^"]*"|'[^']*'/, greedy:!0}, punctuation:/^<!|>$|[[\]]/, "doctype-tag":/^DOCTYPE/i, name:/[^\s<>'"]+/}}, 
cdata:{pattern:/<!\[CDATA\[[\s\S]*?\]\]>/i, greedy:!0}, tag:{pattern:/<\/?(?!\d)[^\s>\/=$<%]+(?:\s(?:\s*[^\s>\/=]+(?:\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))|(?=[\s/>])))+)?\s*\/?>/, greedy:!0, inside:{tag:{pattern:/^<\/?[^\s>\/]+/, inside:{punctuation:/^<\/?/, namespace:/^[^\s>\/:]+:/}}, "special-attr":[], "attr-value":{pattern:/=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+)/, inside:{punctuation:[{pattern:/^=/, alias:"attr-equals"}, {pattern:/^(\s*)["']|["']$/, lookbehind:!0}]}}, punctuation:/\/?>/, 
"attr-name":{pattern:/[^\s>\/]+/, inside:{namespace:/^[^\s>\/:]+:/}}}}, entity:[{pattern:/&[\da-z]{1,8};/i, alias:"named-entity"}, /&#x?[\da-f]{1,8};/i]}, Ne.languages.markup.tag.inside["attr-value"].inside.entity = Ne.languages.markup.entity, Ne.languages.markup.doctype.inside["internal-subset"].inside = Ne.languages.markup, Ne.hooks.add("wrap", function(t) {
  t.type === "entity" && (t.attributes.title = t.content.replace(/&amp;/, "\x26"));
}), Object.defineProperty(Ne.languages.markup.tag, "addInlined", {value:function(t, r) {
  var n = {}, n = (n["language-" + r] = {pattern:/(^<!\[CDATA\[)[\s\S]+?(?=\]\]>$)/i, lookbehind:!0, inside:Ne.languages[r]}, n.cdata = /^<!\[CDATA\[|\]\]>$/i, {"included-cdata":{pattern:/<!\[CDATA\[[\s\S]*?\]\]>/i, inside:n}}), r = (n["language-" + r] = {pattern:/[\s\S]+/, inside:Ne.languages[r]}, {});
  r[t] = {pattern:RegExp(/(<__[^>]*>)(?:<!\[CDATA\[(?:[^\]]|\](?!\]>))*\]\]>|(?!<!\[CDATA\[)[\s\S])*?(?=<\/__>)/.source.replace(/__/g, function() {
    return t;
  }), "i"), lookbehind:!0, greedy:!0, inside:n}, Ne.languages.insertBefore("markup", "cdata", r);
}}), Object.defineProperty(Ne.languages.markup.tag, "addAttribute", {value:function(t, e) {
  Ne.languages.markup.tag.inside["special-attr"].push({pattern:RegExp(/(^|["'\s])/.source + "(?:" + t + ")" + /\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))/.source, "i"), lookbehind:!0, inside:{"attr-name":/^[^\s=]+/, "attr-value":{pattern:/=[\s\S]+/, inside:{value:{pattern:/(^=\s*(["']|(?!["'])))\S[\s\S]*(?=\2$)/, lookbehind:!0, alias:[e, "language-" + e], inside:Ne.languages[e]}, punctuation:[{pattern:/^=/, alias:"attr-equals"}, /"|'/]}}}});
}}), Ne.languages.html = Ne.languages.markup, Ne.languages.mathml = Ne.languages.markup, Ne.languages.svg = Ne.languages.markup, Ne.languages.xml = Ne.languages.extend("markup", {}), Ne.languages.ssml = Ne.languages.xml, Ne.languages.atom = Ne.languages.xml, Ne.languages.rss = Ne.languages.xml, function(t) {
  var e = {pattern:/\\[\\(){}[\]^$+*?|.]/, alias:"escape"}, n = /\\(?:x[\da-fA-F]{2}|u[\da-fA-F]{4}|u\{[\da-fA-F]+\}|0[0-7]{0,2}|[123][0-7]{2}|c[a-zA-Z]|.)/, r = "(?:[^\\\\-]|" + n.source + ")", r = RegExp(r + "-" + r), i = {pattern:/(<|')[^<>']+(?=[>']$)/, lookbehind:!0, alias:"variable"};
  t.languages.regex = {"char-class":{pattern:/((?:^|[^\\])(?:\\\\)*)\[(?:[^\\\]]|\\[\s\S])*\]/, lookbehind:!0, inside:{"char-class-negation":{pattern:/(^\[)\^/, lookbehind:!0, alias:"operator"}, "char-class-punctuation":{pattern:/^\[|\]$/, alias:"punctuation"}, range:{pattern:r, inside:{escape:n, "range-punctuation":{pattern:/-/, alias:"operator"}}}, "special-escape":e, "char-set":{pattern:/\\[wsd]|\\p\{[^{}]+\}/i, alias:"class-name"}, escape:n}}, "special-escape":e, "char-set":{pattern:/\.|\\[wsd]|\\p\{[^{}]+\}/i, 
  alias:"class-name"}, backreference:[{pattern:/\\(?![123][0-7]{2})[1-9]/, alias:"keyword"}, {pattern:/\\k<[^<>']+>/, alias:"keyword", inside:{"group-name":i}}], anchor:{pattern:/[$^]|\\[ABbGZz]/, alias:"function"}, escape:n, group:[{pattern:/\((?:\?(?:<[^<>']+>|'[^<>']+'|[>:]|<?[=!]|[idmnsuxU]+(?:-[idmnsuxU]+)?:?))?/, alias:"punctuation", inside:{"group-name":i}}, {pattern:/\)/, alias:"punctuation"}], quantifier:{pattern:/(?:[+*?]|\{\d+(?:,\d*)?\})[?+]?/, alias:"number"}, alternation:{pattern:/\|/, 
  alias:"keyword"}};
}(Ne), Ne.languages.clike = {comment:[{pattern:/(^|[^\\])\/\*[\s\S]*?(?:\*\/|$)/, lookbehind:!0, greedy:!0}, {pattern:/(^|[^\\:])\/\/.*/, lookbehind:!0, greedy:!0}], string:{pattern:/(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/, greedy:!0}, "class-name":{pattern:/(\b(?:class|extends|implements|instanceof|interface|new|trait)\s+|\bcatch\s+\()[\w.\\]+/i, lookbehind:!0, inside:{punctuation:/[.\\]/}}, keyword:/\b(?:break|catch|continue|do|else|finally|for|function|if|in|instanceof|new|null|return|throw|try|while)\b/, 
boolean:/\b(?:false|true)\b/, function:/\b\w+(?=\()/, number:/\b0x[\da-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?/i, operator:/[<>]=?|[!=]=?=?|--?|\+\+?|&&?|\|\|?|[?*/~^%]/, punctuation:/[{}[\];(),.:]/}, Ne.languages.javascript = Ne.languages.extend("clike", {"class-name":[Ne.languages.clike["class-name"], {pattern:/(^|[^$\w\xA0-\uFFFF])(?!\s)[_$A-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\.(?:constructor|prototype))/, lookbehind:!0}], keyword:[{pattern:/((?:^|\})\s*)catch\b/, lookbehind:!0}, 
{pattern:/(^|[^.]|\.\.\.\s*)\b(?:as|assert(?=\s*\{)|async(?=\s*(?:function\b|\(|[$\w\xA0-\uFFFF]|$))|await|break|case|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally(?=\s*(?:\{|$))|for|from(?=\s*(?:['"]|$))|function|(?:get|set)(?=\s*(?:[#\[$\w\xA0-\uFFFF]|$))|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)\b/, lookbehind:!0}], function:/#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*(?:\.\s*(?:apply|bind|call)\s*)?\()/, 
number:{pattern:RegExp(/(^|[^\w$])/.source + "(?:" + /NaN|Infinity/.source + "|" + /0[bB][01]+(?:_[01]+)*n?/.source + "|" + /0[oO][0-7]+(?:_[0-7]+)*n?/.source + "|" + /0[xX][\dA-Fa-f]+(?:_[\dA-Fa-f]+)*n?/.source + "|" + /\d+(?:_\d+)*n/.source + "|" + /(?:\d+(?:_\d+)*(?:\.(?:\d+(?:_\d+)*)?)?|\.\d+(?:_\d+)*)(?:[Ee][+-]?\d+(?:_\d+)*)?/.source + ")" + /(?![\w$])/.source), lookbehind:!0}, operator:/--|\+\+|\*\*=?|=>|&&=?|\|\|=?|[!=]==|<<=?|>>>?=?|[-+*/%&|^!=<>]=?|\.{3}|\?\?=?|\?\.?|[~:]/}), Ne.languages.javascript["class-name"][0].pattern = 
/(\b(?:class|extends|implements|instanceof|interface|new)\s+)[\w.\\]+/, Ne.languages.insertBefore("javascript", "keyword", {regex:{pattern:RegExp(/((?:^|[^$\w\xA0-\uFFFF."'\])\s]|\b(?:return|yield))\s*)/.source + /\//.source + "(?:" + /(?:\[(?:[^\]\\\r\n]|\\.)*\]|\\.|[^/\\\[\r\n])+\/[dgimyus]{0,7}/.source + "|" + /(?:\[(?:[^[\]\\\r\n]|\\.|\[(?:[^[\]\\\r\n]|\\.|\[(?:[^[\]\\\r\n]|\\.)*\])*\])*\]|\\.|[^/\\\[\r\n])+\/[dgimyus]{0,7}v[dgimyus]{0,7}/.source + ")" + /(?=(?:\s|\/\*(?:[^*]|\*(?!\/))*\*\/)*(?:$|[\r\n,.;:})\]]|\/\/))/.source), 
lookbehind:!0, greedy:!0, inside:{"regex-source":{pattern:/^(\/)[\s\S]+(?=\/[a-z]*$)/, lookbehind:!0, alias:"language-regex", inside:Ne.languages.regex}, "regex-delimiter":/^\/|\/$/, "regex-flags":/^[a-z]+$/}}, "function-variable":{pattern:/#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*[=:]\s*(?:async\s*)?(?:\bfunction\b|(?:\((?:[^()]|\([^()]*\))*\)|(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)\s*=>))/, alias:"function"}, parameter:[{pattern:/(function(?:\s+(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)?\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\))/, 
lookbehind:!0, inside:Ne.languages.javascript}, {pattern:/(^|[^$\w\xA0-\uFFFF])(?!\s)[_$a-z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*=>)/i, lookbehind:!0, inside:Ne.languages.javascript}, {pattern:/(\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*=>)/, lookbehind:!0, inside:Ne.languages.javascript}, {pattern:/((?:\b|\s|^)(?!(?:as|async|await|break|case|catch|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally|for|from|function|get|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|set|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)(?![$\w\xA0-\uFFFF]))(?:(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*\s*)\(\s*|\]\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*\{)/, 
lookbehind:!0, inside:Ne.languages.javascript}], constant:/\b[A-Z](?:[A-Z_]|\dx?)*\b/}), Ne.languages.insertBefore("javascript", "string", {hashbang:{pattern:/^#!.*/, greedy:!0, alias:"comment"}, "template-string":{pattern:/`(?:\\[\s\S]|\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}|(?!\$\{)[^\\`])*`/, greedy:!0, inside:{"template-punctuation":{pattern:/^`|`$/, alias:"string"}, interpolation:{pattern:/((?:^|[^\\])(?:\\{2})*)\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}/, lookbehind:!0, inside:{"interpolation-punctuation":{pattern:/^\$\{|\}$/, 
alias:"punctuation"}, rest:Ne.languages.javascript}}, string:/[\s\S]+/}}, "string-property":{pattern:/((?:^|[,{])[ \t]*)(["'])(?:\\(?:\r\n|[\s\S])|(?!\2)[^\\\r\n])*\2(?=\s*:)/m, lookbehind:!0, greedy:!0, alias:"property"}}), Ne.languages.insertBefore("javascript", "operator", {"literal-property":{pattern:/((?:^|[,{])[ \t]*)(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*:)/m, lookbehind:!0, alias:"property"}}), Ne.languages.markup && (Ne.languages.markup.tag.addInlined("script", "javascript"), 
Ne.languages.markup.tag.addAttribute(/on(?:abort|blur|change|click|composition(?:end|start|update)|dblclick|error|focus(?:in|out)?|key(?:down|up)|load|mouse(?:down|enter|leave|move|out|over|up)|reset|resize|scroll|select|slotchange|submit|unload|wheel)/.source, "javascript")), Ne.languages.js = Ne.languages.javascript, Ne.languages.actionscript = Ne.languages.extend("javascript", {keyword:/\b(?:as|break|case|catch|class|const|default|delete|do|dynamic|each|else|extends|final|finally|for|function|get|if|implements|import|in|include|instanceof|interface|internal|is|namespace|native|new|null|override|package|private|protected|public|return|set|static|super|switch|this|throw|try|typeof|use|var|void|while|with)\b/, 
operator:/\+\+|--|(?:[+\-*\/%^]|&&?|\|\|?|<<?|>>?>?|[!=]=?)=?|[~?@]/}), Ne.languages.actionscript["class-name"].alias = "function", delete Ne.languages.actionscript.parameter, delete Ne.languages.actionscript["literal-property"], Ne.languages.markup && Ne.languages.insertBefore("actionscript", "string", {xml:{pattern:/(^|[^.])<\/?\w+(?:\s+[^\s>\/=]+=("|')(?:\\[\s\S]|(?!\2)[^\\])*\2)*\s*\/?>/, lookbehind:!0, inside:Ne.languages.markup}}), function(t) {
  var e = /#(?!\{).+/, n = {pattern:/#\{[^}]+\}/, alias:"variable"};
  t.languages.coffeescript = t.languages.extend("javascript", {comment:e, string:[{pattern:/'(?:\\[\s\S]|[^\\'])*'/, greedy:!0}, {pattern:/"(?:\\[\s\S]|[^\\"])*"/, greedy:!0, inside:{interpolation:n}}], keyword:/\b(?:and|break|by|catch|class|continue|debugger|delete|do|each|else|extend|extends|false|finally|for|if|in|instanceof|is|isnt|let|loop|namespace|new|no|not|null|of|off|on|or|own|return|super|switch|then|this|throw|true|try|typeof|undefined|unless|until|when|while|window|with|yes|yield)\b/, 
  "class-member":{pattern:/@(?!\d)\w+/, alias:"variable"}}), t.languages.insertBefore("coffeescript", "comment", {"multiline-comment":{pattern:/###[\s\S]+?###/, alias:"comment"}, "block-regex":{pattern:/\/{3}[\s\S]*?\/{3}/, alias:"regex", inside:{comment:e, interpolation:n}}}), t.languages.insertBefore("coffeescript", "string", {"inline-javascript":{pattern:/`(?:\\[\s\S]|[^\\`])*`/, inside:{delimiter:{pattern:/^`|`$/, alias:"punctuation"}, script:{pattern:/[\s\S]+/, alias:"language-javascript", inside:t.languages.javascript}}}, 
  "multiline-string":[{pattern:/'''[\s\S]*?'''/, greedy:!0, alias:"string"}, {pattern:/"""[\s\S]*?"""/, greedy:!0, alias:"string", inside:{interpolation:n}}]}), t.languages.insertBefore("coffeescript", "keyword", {property:/(?!\d)\w+(?=\s*:(?!:))/}), delete t.languages.coffeescript["template-string"], t.languages.coffee = t.languages.coffeescript;
}(Ne), function(t) {
  var e = t.languages.javadoclike = {parameter:{pattern:/(^[\t ]*(?:\/{3}|\*|\/\*\*)\s*@(?:arg|arguments|param)\s+)\w+/m, lookbehind:!0}, keyword:{pattern:/(^[\t ]*(?:\/{3}|\*|\/\*\*)\s*|\{)@[a-z][a-zA-Z-]+\b/m, lookbehind:!0}, punctuation:/[{}]/};
  Object.defineProperty(e, "addSupport", {value:function(n, r) {
    (n = typeof n == "string" ? [n] : n).forEach(function(i) {
      var s = function(h) {
        h.inside || (h.inside = {}), h.inside.rest = r;
      }, o = "doc-comment";
      if (a = t.languages[i]) {
        var a, l = a[o];
        if ((l = l || (a = t.languages.insertBefore(i, "comment", {"doc-comment":{pattern:/(^|[^\\])\/\*\*[^/][\s\S]*?(?:\*\/|$)/, lookbehind:!0, alias:"comment"}}))[o]) instanceof RegExp && (l = a[o] = {pattern:l}), Array.isArray(l)) {
          for (var c = 0, u = l.length; c < u; c++) {
            l[c] instanceof RegExp && (l[c] = {pattern:l[c]}), s(l[c]);
          }
        } else {
          s(l);
        }
      }
    });
  }}), e.addSupport(["java", "javascript", "php"], e);
}(Ne), function(t) {
  var e = /(?:"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"|'(?:\\(?:\r\n|[\s\S])|[^'\\\r\n])*')/, e = (t.languages.css = {comment:/\/\*[\s\S]*?\*\//, atrule:{pattern:RegExp("@[\\w-](?:" + /[^;{\s"']|\s+(?!\s)/.source + "|" + e.source + ")*?" + /(?:;|(?=\s*\{))/.source), inside:{rule:/^@[\w-]+/, "selector-function-argument":{pattern:/(\bselector\s*\(\s*(?![\s)]))(?:[^()\s]|\s+(?![\s)])|\((?:[^()]|\([^()]*\))*\))+(?=\s*\))/, lookbehind:!0, alias:"selector"}, keyword:{pattern:/(^|[^\w-])(?:and|not|only|or)(?![\w-])/, 
  lookbehind:!0}}}, url:{pattern:RegExp("\\burl\\((?:" + e.source + "|" + /(?:[^\\\r\n()"']|\\[\s\S])*/.source + ")\\)", "i"), greedy:!0, inside:{function:/^url/i, punctuation:/^\(|\)$/, string:{pattern:RegExp("^" + e.source + "$"), alias:"url"}}}, selector:{pattern:RegExp(`(^|[{}\\s])[^{}\\s](?:[^{};"'\\s]|\\s+(?![\\s{])|` + e.source + ")*(?\x3d\\s*\\{)"), lookbehind:!0}, string:{pattern:e, greedy:!0}, property:{pattern:/(^|[^-\w\xA0-\uFFFF])(?!\s)[-_a-z\xA0-\uFFFF](?:(?!\s)[-\w\xA0-\uFFFF])*(?=\s*:)/i, 
  lookbehind:!0}, important:/!important\b/i, function:{pattern:/(^|[^-a-z0-9])[-a-z0-9]+(?=\()/i, lookbehind:!0}, punctuation:/[(){};:,]/}, t.languages.css.atrule.inside.rest = t.languages.css, t.languages.markup);
  e && (e.tag.addInlined("style", "css"), e.tag.addAttribute("style", "css"));
}(Ne), function(t) {
  var e = /("|')(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/, e = (t.languages.css.selector = {pattern:t.languages.css.selector.pattern, lookbehind:!0, inside:e = {"pseudo-element":/:(?:after|before|first-letter|first-line|selection)|::[-\w]+/, "pseudo-class":/:[-\w]+/, class:/\.[-\w]+/, id:/#[-\w]+/, attribute:{pattern:RegExp(`\\[(?:[^[\\]"']|` + e.source + ")*\\]"), greedy:!0, inside:{punctuation:/^\[|\]$/, "case-sensitivity":{pattern:/(\s)[si]$/i, lookbehind:!0, alias:"keyword"}, namespace:{pattern:/^(\s*)(?:(?!\s)[-*\w\xA0-\uFFFF])*\|(?!=)/, 
  lookbehind:!0, inside:{punctuation:/\|$/}}, "attr-name":{pattern:/^(\s*)(?:(?!\s)[-\w\xA0-\uFFFF])+/, lookbehind:!0}, "attr-value":[e, {pattern:/(=\s*)(?:(?!\s)[-\w\xA0-\uFFFF])+(?=\s*$)/, lookbehind:!0}], operator:/[|~*^$]?=/}}, "n-th":[{pattern:/(\(\s*)[+-]?\d*[\dn](?:\s*[+-]\s*\d+)?(?=\s*\))/, lookbehind:!0, inside:{number:/[\dn]+/, operator:/[+-]/}}, {pattern:/(\(\s*)(?:even|odd)(?=\s*\))/i, lookbehind:!0}], combinator:/>|\+|~|\|\|/, punctuation:/[(),]/}}, t.languages.css.atrule.inside["selector-function-argument"].inside = 
  e, t.languages.insertBefore("css", "property", {variable:{pattern:/(^|[^-\w\xA0-\uFFFF])--(?!\s)[-_a-z\xA0-\uFFFF](?:(?!\s)[-\w\xA0-\uFFFF])*/i, lookbehind:!0}}), {pattern:/(\b\d+)(?:%|[a-z]+(?![\w-]))/, lookbehind:!0}), n = {pattern:/(^|[^\w.-])-?(?:\d+(?:\.\d+)?|\.\d+)/, lookbehind:!0};
  t.languages.insertBefore("css", "function", {operator:{pattern:/(\s)[+\-*\/](?=\s)/, lookbehind:!0}, hexcode:{pattern:/\B#[\da-f]{3,8}\b/i, alias:"color"}, color:[{pattern:/(^|[^\w-])(?:AliceBlue|AntiqueWhite|Aqua|Aquamarine|Azure|Beige|Bisque|Black|BlanchedAlmond|Blue|BlueViolet|Brown|BurlyWood|CadetBlue|Chartreuse|Chocolate|Coral|CornflowerBlue|Cornsilk|Crimson|Cyan|DarkBlue|DarkCyan|DarkGoldenRod|DarkGr[ae]y|DarkGreen|DarkKhaki|DarkMagenta|DarkOliveGreen|DarkOrange|DarkOrchid|DarkRed|DarkSalmon|DarkSeaGreen|DarkSlateBlue|DarkSlateGr[ae]y|DarkTurquoise|DarkViolet|DeepPink|DeepSkyBlue|DimGr[ae]y|DodgerBlue|FireBrick|FloralWhite|ForestGreen|Fuchsia|Gainsboro|GhostWhite|Gold|GoldenRod|Gr[ae]y|Green|GreenYellow|HoneyDew|HotPink|IndianRed|Indigo|Ivory|Khaki|Lavender|LavenderBlush|LawnGreen|LemonChiffon|LightBlue|LightCoral|LightCyan|LightGoldenRodYellow|LightGr[ae]y|LightGreen|LightPink|LightSalmon|LightSeaGreen|LightSkyBlue|LightSlateGr[ae]y|LightSteelBlue|LightYellow|Lime|LimeGreen|Linen|Magenta|Maroon|MediumAquaMarine|MediumBlue|MediumOrchid|MediumPurple|MediumSeaGreen|MediumSlateBlue|MediumSpringGreen|MediumTurquoise|MediumVioletRed|MidnightBlue|MintCream|MistyRose|Moccasin|NavajoWhite|Navy|OldLace|Olive|OliveDrab|Orange|OrangeRed|Orchid|PaleGoldenRod|PaleGreen|PaleTurquoise|PaleVioletRed|PapayaWhip|PeachPuff|Peru|Pink|Plum|PowderBlue|Purple|RebeccaPurple|Red|RosyBrown|RoyalBlue|SaddleBrown|Salmon|SandyBrown|SeaGreen|SeaShell|Sienna|Silver|SkyBlue|SlateBlue|SlateGr[ae]y|Snow|SpringGreen|SteelBlue|Tan|Teal|Thistle|Tomato|Transparent|Turquoise|Violet|Wheat|White|WhiteSmoke|Yellow|YellowGreen)(?![\w-])/i, 
  lookbehind:!0}, {pattern:/\b(?:hsl|rgb)\(\s*\d{1,3}\s*,\s*\d{1,3}%?\s*,\s*\d{1,3}%?\s*\)\B|\b(?:hsl|rgb)a\(\s*\d{1,3}\s*,\s*\d{1,3}%?\s*,\s*\d{1,3}%?\s*,\s*(?:0|0?\.\d+|1)\s*\)\B/i, inside:{unit:e, number:n, function:/[\w-]+(?=\()/, punctuation:/[(),]/}}], entity:/\\[\da-f]{1,8}/i, unit:e, number:n});
}(Ne), function(t) {
  var e = /[*&][^\s[\]{},]+/, n = /!(?:<[\w\-%#;/?:@&=+$,.!~*'()[\]]+>|(?:[a-zA-Z\d-]*!)?[\w\-%#;/?:@&=+$.~*'()]+)?/, r = "(?:" + n.source + "(?:[ \t]+" + e.source + ")?|" + e.source + "(?:[ \t]+" + n.source + ")?)", i = /(?:[^\s\x00-\x08\x0e-\x1f!"#%&'*,\-:>?@[\]`{|}\x7f-\x84\x86-\x9f\ud800-\udfff\ufffe\uffff]|[?:-]<PLAIN>)(?:[ \t]*(?:(?![#:])<PLAIN>|:<PLAIN>))*/.source.replace(/<PLAIN>/g, function() {
    return /[^\s\x00-\x08\x0e-\x1f,[\]{}\x7f-\x84\x86-\x9f\ud800-\udfff\ufffe\uffff]/.source;
  }), s = /"(?:[^"\\\r\n]|\\.)*"|'(?:[^'\\\r\n]|\\.)*'/.source;
  function o(a, l) {
    l = (l || "").replace(/m/g, "") + "m";
    var c = /([:\-,[{]\s*(?:\s<<prop>>[ \t]+)?)(?:<<value>>)(?=[ \t]*(?:$|,|\]|\}|(?:[\r\n]\s*)?#))/.source.replace(/<<prop>>/g, function() {
      return r;
    }).replace(/<<value>>/g, function() {
      return a;
    });
    return RegExp(c, l);
  }
  t.languages.yaml = {scalar:{pattern:RegExp(/([\-:]\s*(?:\s<<prop>>[ \t]+)?[|>])[ \t]*(?:((?:\r?\n|\r)[ \t]+)\S[^\r\n]*(?:\2[^\r\n]+)*)/.source.replace(/<<prop>>/g, function() {
    return r;
  })), lookbehind:!0, alias:"string"}, comment:/#.*/, key:{pattern:RegExp(/((?:^|[:\-,[{\r\n?])[ \t]*(?:<<prop>>[ \t]+)?)<<key>>(?=\s*:\s)/.source.replace(/<<prop>>/g, function() {
    return r;
  }).replace(/<<key>>/g, function() {
    return "(?:" + i + "|" + s + ")";
  })), lookbehind:!0, greedy:!0, alias:"atrule"}, directive:{pattern:/(^[ \t]*)%.+/m, lookbehind:!0, alias:"important"}, datetime:{pattern:o(/\d{4}-\d\d?-\d\d?(?:[tT]|[ \t]+)\d\d?:\d{2}:\d{2}(?:\.\d*)?(?:[ \t]*(?:Z|[-+]\d\d?(?::\d{2})?))?|\d{4}-\d{2}-\d{2}|\d\d?:\d{2}(?::\d{2}(?:\.\d*)?)?/.source), lookbehind:!0, alias:"number"}, boolean:{pattern:o(/false|true/.source, "i"), lookbehind:!0, alias:"important"}, null:{pattern:o(/null|~/.source, "i"), lookbehind:!0, alias:"important"}, string:{pattern:o(s), 
  lookbehind:!0, greedy:!0}, number:{pattern:o(/[+-]?(?:0x[\da-f]+|0o[0-7]+|(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?|\.inf|\.nan)/.source, "i"), lookbehind:!0}, tag:n, important:e, punctuation:/---|[:[\]{}\-,|>?]|\.\.\./}, t.languages.yml = t.languages.yaml;
}(Ne), function(t) {
  var e = /(?:\\.|[^\\\n\r]|(?:\n|\r\n?)(?![\r\n]))/.source;
  function n(c) {
    return c = c.replace(/<inner>/g, function() {
      return e;
    }), RegExp(/((?:^|[^\\])(?:\\{2})*)/.source + "(?:" + c + ")");
  }
  var r = /(?:\\.|``(?:[^`\r\n]|`(?!`))+``|`[^`\r\n]+`|[^\\|\r\n`])+/.source, i = /\|?__(?:\|__)+\|?(?:(?:\n|\r\n?)|(?![\s\S]))/.source.replace(/__/g, function() {
    return r;
  }), s = /\|?[ \t]*:?-{3,}:?[ \t]*(?:\|[ \t]*:?-{3,}:?[ \t]*)+\|?(?:\n|\r\n?)/.source, o = (t.languages.markdown = t.languages.extend("markup", {}), t.languages.insertBefore("markdown", "prolog", {"front-matter-block":{pattern:/(^(?:\s*[\r\n])?)---(?!.)[\s\S]*?[\r\n]---(?!.)/, lookbehind:!0, greedy:!0, inside:{punctuation:/^---|---$/, "front-matter":{pattern:/\S+(?:\s+\S+)*/, alias:["yaml", "language-yaml"], inside:t.languages.yaml}}}, blockquote:{pattern:/^>(?:[\t ]*>)*/m, alias:"punctuation"}, 
  table:{pattern:RegExp("^" + i + s + "(?:" + i + ")*", "m"), inside:{"table-data-rows":{pattern:RegExp("^(" + i + s + ")(?:" + i + ")*$"), lookbehind:!0, inside:{"table-data":{pattern:RegExp(r), inside:t.languages.markdown}, punctuation:/\|/}}, "table-line":{pattern:RegExp("^(" + i + ")" + s + "$"), lookbehind:!0, inside:{punctuation:/\||:?-{3,}:?/}}, "table-header-row":{pattern:RegExp("^" + i + "$"), inside:{"table-header":{pattern:RegExp(r), alias:"important", inside:t.languages.markdown}, punctuation:/\|/}}}}, 
  code:[{pattern:/((?:^|\n)[ \t]*\n|(?:^|\r\n?)[ \t]*\r\n?)(?: {4}|\t).+(?:(?:\n|\r\n?)(?: {4}|\t).+)*/, lookbehind:!0, alias:"keyword"}, {pattern:/^```[\s\S]*?^```$/m, greedy:!0, inside:{"code-block":{pattern:/^(```.*(?:\n|\r\n?))[\s\S]+?(?=(?:\n|\r\n?)^```$)/m, lookbehind:!0}, "code-language":{pattern:/^(```).+/, lookbehind:!0}, punctuation:/```/}}], title:[{pattern:/\S.*(?:\n|\r\n?)(?:==+|--+)(?=[ \t]*$)/m, alias:"important", inside:{punctuation:/==+$|--+$/}}, {pattern:/(^\s*)#.+/m, lookbehind:!0, 
  alias:"important", inside:{punctuation:/^#+|#+$/}}], hr:{pattern:/(^\s*)([*-])(?:[\t ]*\2){2,}(?=\s*$)/m, lookbehind:!0, alias:"punctuation"}, list:{pattern:/(^\s*)(?:[*+-]|\d+\.)(?=[\t ].)/m, lookbehind:!0, alias:"punctuation"}, "url-reference":{pattern:/!?\[[^\]]+\]:[\t ]+(?:\S+|<(?:\\.|[^>\\])+>)(?:[\t ]+(?:"(?:\\.|[^"\\])*"|'(?:\\.|[^'\\])*'|\((?:\\.|[^)\\])*\)))?/, inside:{variable:{pattern:/^(!?\[)[^\]]+/, lookbehind:!0}, string:/(?:"(?:\\.|[^"\\])*"|'(?:\\.|[^'\\])*'|\((?:\\.|[^)\\])*\))$/, 
  punctuation:/^[\[\]!:]|[<>]/}, alias:"url"}, bold:{pattern:n(/\b__(?:(?!_)<inner>|_(?:(?!_)<inner>)+_)+__\b|\*\*(?:(?!\*)<inner>|\*(?:(?!\*)<inner>)+\*)+\*\*/.source), lookbehind:!0, greedy:!0, inside:{content:{pattern:/(^..)[\s\S]+(?=..$)/, lookbehind:!0, inside:{}}, punctuation:/\*\*|__/}}, italic:{pattern:n(/\b_(?:(?!_)<inner>|__(?:(?!_)<inner>)+__)+_\b|\*(?:(?!\*)<inner>|\*\*(?:(?!\*)<inner>)+\*\*)+\*/.source), lookbehind:!0, greedy:!0, inside:{content:{pattern:/(^.)[\s\S]+(?=.$)/, lookbehind:!0, 
  inside:{}}, punctuation:/[*_]/}}, strike:{pattern:n(/(~~?)(?:(?!~)<inner>)+\2/.source), lookbehind:!0, greedy:!0, inside:{content:{pattern:/(^~~?)[\s\S]+(?=\1$)/, lookbehind:!0, inside:{}}, punctuation:/~~?/}}, "code-snippet":{pattern:/(^|[^\\`])(?:``[^`\r\n]+(?:`[^`\r\n]+)*``(?!`)|`[^`\r\n]+`(?!`))/, lookbehind:!0, greedy:!0, alias:["code", "keyword"]}, url:{pattern:n(/!?\[(?:(?!\])<inner>)+\](?:\([^\s)]+(?:[\t ]+"(?:\\.|[^"\\])*")?\)|[ \t]?\[(?:(?!\])<inner>)+\])/.source), lookbehind:!0, greedy:!0, 
  inside:{operator:/^!/, content:{pattern:/(^\[)[^\]]+(?=\])/, lookbehind:!0, inside:{}}, variable:{pattern:/(^\][ \t]?\[)[^\]]+(?=\]$)/, lookbehind:!0}, url:{pattern:/(^\]\()[^\s)]+/, lookbehind:!0}, string:{pattern:/(^[ \t]+)"(?:\\.|[^"\\])*"(?=\)$)/, lookbehind:!0}}}}), ["url", "bold", "italic", "strike"].forEach(function(c) {
    ["url", "bold", "italic", "strike", "code-snippet"].forEach(function(u) {
      c !== u && (t.languages.markdown[c].inside.content.inside[u] = t.languages.markdown[u]);
    });
  }), t.hooks.add("after-tokenize", function(c) {
    c.language !== "markdown" && c.language !== "md" || function u(h) {
      if (h && typeof h != "string") {
        for (var f = 0, p = h.length; f < p; f++) {
          var g, m = h[f];
          m.type !== "code" ? u(m.content) : (g = m.content[1], m = m.content[3], g && m && g.type === "code-language" && m.type === "code-block" && typeof g.content == "string" && (g = g.content.replace(/\b#/g, "sharp").replace(/\b\+\+/g, "pp"), g = "language-" + (g = (/[a-z][\w-]*/i.exec(g) || [""])[0].toLowerCase()), m.alias ? typeof m.alias == "string" ? m.alias = [m.alias, g] : m.alias.push(g) : m.alias = [g]));
        }
      }
    }(c.tokens);
  }), t.hooks.add("wrap", function(c) {
    if (c.type === "code-block") {
      for (var u = "", h = 0, f = c.classes.length; h < f; h++) {
        var p = c.classes[h], p = /language-(.+)/.exec(p);
        if (p) {
          u = p[1];
          break;
        }
      }
      var g, m = t.languages[u];
      m ? c.content = t.highlight(function(b) {
        return b = b.replace(o, ""), b = b.replace(/&(\w{1,8}|#x?[\da-f]{1,8});/gi, function(x, w) {
          var v;
          return (w = w.toLowerCase())[0] === "#" ? (v = w[1] === "x" ? parseInt(w.slice(2), 16) : Number(w.slice(1)), l(v)) : a[w] || x;
        });
      }(c.content), m, u) : u && u !== "none" && t.plugins.autoloader && (g = "md-" + (new Date()).valueOf() + "-" + Math.floor(1e16 * Math.random()), c.attributes.id = g, t.plugins.autoloader.loadLanguages(u, function() {
        var b = document.getElementById(g);
        b && (b.innerHTML = t.highlight(b.textContent, t.languages[u], u));
      }));
    }
  }), RegExp(t.languages.markup.tag.pattern.source, "gi")), a = {amp:"\x26", lt:"\x3c", gt:"\x3e", quot:'"'}, l = String.fromCodePoint || String.fromCharCode;
  t.languages.md = t.languages.markdown;
}(Ne), Ne.languages.graphql = {comment:/#.*/, description:{pattern:/(?:"""(?:[^"]|(?!""")")*"""|"(?:\\.|[^\\"\r\n])*")(?=\s*[a-z_])/i, greedy:!0, alias:"string", inside:{"language-markdown":{pattern:/(^"(?:"")?)(?!\1)[\s\S]+(?=\1$)/, lookbehind:!0, inside:Ne.languages.markdown}}}, string:{pattern:/"""(?:[^"]|(?!""")")*"""|"(?:\\.|[^\\"\r\n])*"/, greedy:!0}, number:/(?:\B-|\b)\d+(?:\.\d+)?(?:e[+-]?\d+)?\b/i, boolean:/\b(?:false|true)\b/, variable:/\$[a-z_]\w*/i, directive:{pattern:/@[a-z_]\w*/i, alias:"function"}, 
"attr-name":{pattern:/\b[a-z_]\w*(?=\s*(?:\((?:[^()"]|"(?:\\.|[^\\"\r\n])*")*\))?:)/i, greedy:!0}, "atom-input":{pattern:/\b[A-Z]\w*Input\b/, alias:"class-name"}, scalar:/\b(?:Boolean|Float|ID|Int|String)\b/, constant:/\b[A-Z][A-Z_\d]*\b/, "class-name":{pattern:/(\b(?:enum|implements|interface|on|scalar|type|union)\s+|&\s*|:\s*|\[)[A-Z_]\w*/, lookbehind:!0}, fragment:{pattern:/(\bfragment\s+|\.{3}\s*(?!on\b))[a-zA-Z_]\w*/, lookbehind:!0, alias:"function"}, "definition-mutation":{pattern:/(\bmutation\s+)[a-zA-Z_]\w*/, 
lookbehind:!0, alias:"function"}, "definition-query":{pattern:/(\bquery\s+)[a-zA-Z_]\w*/, lookbehind:!0, alias:"function"}, keyword:/\b(?:directive|enum|extend|fragment|implements|input|interface|mutation|on|query|repeatable|scalar|schema|subscription|type|union)\b/, operator:/[!=|&]|\.{3}/, "property-query":/\w+(?=\s*\()/, object:/\w+(?=\s*\{)/, punctuation:/[!(){}\[\]:=,]/, property:/\w+/}, Ne.hooks.add("after-tokenize", function(t) {
  if (t.language === "graphql") {
    for (var e = t.tokens.filter(function(g) {
      return typeof g != "string" && g.type !== "comment" && g.type !== "scalar";
    }), n = 0; n < e.length;) {
      var r = e[n++];
      if (r.type === "keyword" && r.content === "mutation") {
        var i = [];
        if (h(["definition-mutation", "punctuation"]) && u(1).content === "(") {
          n += 2;
          var s = f(/^\($/, /^\)$/);
          if (s === -1) {
            continue;
          }
          for (; n < s; n++) {
            var o = u(0);
            o.type === "variable" && (p(o, "variable-input"), i.push(o.content));
          }
          n = s + 1;
        }
        if (h(["punctuation", "property-query"]) && u(0).content === "{" && (n++, p(u(0), "property-mutation"), 0 < i.length)) {
          var a = f(/^\{$/, /^\}$/);
          if (a !== -1) {
            for (var l = n; l < a; l++) {
              var c = e[l];
              c.type === "variable" && 0 <= i.indexOf(c.content) && p(c, "variable-input");
            }
          }
        }
      }
    }
  }
  function u(g) {
    return e[n + g];
  }
  function h(g, m) {
    m = m || 0;
    for (var b = 0; b < g.length; b++) {
      var x = u(b + m);
      if (!x || x.type !== g[b]) {
        return;
      }
    }
    return 1;
  }
  function f(g, m) {
    for (var b = 1, x = n; x < e.length; x++) {
      var w = e[x], v = w.content;
      if (w.type === "punctuation" && typeof v == "string") {
        if (g.test(v)) {
          b++;
        } else if (m.test(v) && --b === 0) {
          return x;
        }
      }
    }
    return -1;
  }
  function p(g, m) {
    var b = g.alias;
    b ? Array.isArray(b) || (g.alias = b = [b]) : g.alias = b = [], b.push(m);
  }
}), Ne.languages.sql = {comment:{pattern:/(^|[^\\])(?:\/\*[\s\S]*?\*\/|(?:--|\/\/|#).*)/, lookbehind:!0}, variable:[{pattern:/@(["'`])(?:\\[\s\S]|(?!\1)[^\\])+\1/, greedy:!0}, /@[\w.$]+/], string:{pattern:/(^|[^@\\])("|')(?:\\[\s\S]|(?!\2)[^\\]|\2\2)*\2/, greedy:!0, lookbehind:!0}, identifier:{pattern:/(^|[^@\\])`(?:\\[\s\S]|[^`\\]|``)*`/, greedy:!0, lookbehind:!0, inside:{punctuation:/^`|`$/}}, function:/\b(?:AVG|COUNT|FIRST|FORMAT|LAST|LCASE|LEN|MAX|MID|MIN|MOD|NOW|ROUND|SUM|UCASE)(?=\s*\()/i, 
keyword:/\b(?:ACTION|ADD|AFTER|ALGORITHM|ALL|ALTER|ANALYZE|ANY|APPLY|AS|ASC|AUTHORIZATION|AUTO_INCREMENT|BACKUP|BDB|BEGIN|BERKELEYDB|BIGINT|BINARY|BIT|BLOB|BOOL|BOOLEAN|BREAK|BROWSE|BTREE|BULK|BY|CALL|CASCADED?|CASE|CHAIN|CHAR(?:ACTER|SET)?|CHECK(?:POINT)?|CLOSE|CLUSTERED|COALESCE|COLLATE|COLUMNS?|COMMENT|COMMIT(?:TED)?|COMPUTE|CONNECT|CONSISTENT|CONSTRAINT|CONTAINS(?:TABLE)?|CONTINUE|CONVERT|CREATE|CROSS|CURRENT(?:_DATE|_TIME|_TIMESTAMP|_USER)?|CURSOR|CYCLE|DATA(?:BASES?)?|DATE(?:TIME)?|DAY|DBCC|DEALLOCATE|DEC|DECIMAL|DECLARE|DEFAULT|DEFINER|DELAYED|DELETE|DELIMITERS?|DENY|DESC|DESCRIBE|DETERMINISTIC|DISABLE|DISCARD|DISK|DISTINCT|DISTINCTROW|DISTRIBUTED|DO|DOUBLE|DROP|DUMMY|DUMP(?:FILE)?|DUPLICATE|ELSE(?:IF)?|ENABLE|ENCLOSED|END|ENGINE|ENUM|ERRLVL|ERRORS|ESCAPED?|EXCEPT|EXEC(?:UTE)?|EXISTS|EXIT|EXPLAIN|EXTENDED|FETCH|FIELDS|FILE|FILLFACTOR|FIRST|FIXED|FLOAT|FOLLOWING|FOR(?: EACH ROW)?|FORCE|FOREIGN|FREETEXT(?:TABLE)?|FROM|FULL|FUNCTION|GEOMETRY(?:COLLECTION)?|GLOBAL|GOTO|GRANT|GROUP|HANDLER|HASH|HAVING|HOLDLOCK|HOUR|IDENTITY(?:COL|_INSERT)?|IF|IGNORE|IMPORT|INDEX|INFILE|INNER|INNODB|INOUT|INSERT|INT|INTEGER|INTERSECT|INTERVAL|INTO|INVOKER|ISOLATION|ITERATE|JOIN|KEYS?|KILL|LANGUAGE|LAST|LEAVE|LEFT|LEVEL|LIMIT|LINENO|LINES|LINESTRING|LOAD|LOCAL|LOCK|LONG(?:BLOB|TEXT)|LOOP|MATCH(?:ED)?|MEDIUM(?:BLOB|INT|TEXT)|MERGE|MIDDLEINT|MINUTE|MODE|MODIFIES|MODIFY|MONTH|MULTI(?:LINESTRING|POINT|POLYGON)|NATIONAL|NATURAL|NCHAR|NEXT|NO|NONCLUSTERED|NULLIF|NUMERIC|OFF?|OFFSETS?|ON|OPEN(?:DATASOURCE|QUERY|ROWSET)?|OPTIMIZE|OPTION(?:ALLY)?|ORDER|OUT(?:ER|FILE)?|OVER|PARTIAL|PARTITION|PERCENT|PIVOT|PLAN|POINT|POLYGON|PRECEDING|PRECISION|PREPARE|PREV|PRIMARY|PRINT|PRIVILEGES|PROC(?:EDURE)?|PUBLIC|PURGE|QUICK|RAISERROR|READS?|REAL|RECONFIGURE|REFERENCES|RELEASE|RENAME|REPEAT(?:ABLE)?|REPLACE|REPLICATION|REQUIRE|RESIGNAL|RESTORE|RESTRICT|RETURN(?:ING|S)?|REVOKE|RIGHT|ROLLBACK|ROUTINE|ROW(?:COUNT|GUIDCOL|S)?|RTREE|RULE|SAVE(?:POINT)?|SCHEMA|SECOND|SELECT|SERIAL(?:IZABLE)?|SESSION(?:_USER)?|SET(?:USER)?|SHARE|SHOW|SHUTDOWN|SIMPLE|SMALLINT|SNAPSHOT|SOME|SONAME|SQL|START(?:ING)?|STATISTICS|STATUS|STRIPED|SYSTEM_USER|TABLES?|TABLESPACE|TEMP(?:ORARY|TABLE)?|TERMINATED|TEXT(?:SIZE)?|THEN|TIME(?:STAMP)?|TINY(?:BLOB|INT|TEXT)|TOP?|TRAN(?:SACTIONS?)?|TRIGGER|TRUNCATE|TSEQUAL|TYPES?|UNBOUNDED|UNCOMMITTED|UNDEFINED|UNION|UNIQUE|UNLOCK|UNPIVOT|UNSIGNED|UPDATE(?:TEXT)?|USAGE|USE|USER|USING|VALUES?|VAR(?:BINARY|CHAR|CHARACTER|YING)|VIEW|WAITFOR|WARNINGS|WHEN|WHERE|WHILE|WITH(?: ROLLUP|IN)?|WORK|WRITE(?:TEXT)?|YEAR)\b/i, 
boolean:/\b(?:FALSE|NULL|TRUE)\b/i, number:/\b0x[\da-f]+\b|\b\d+(?:\.\d*)?|\B\.\d+\b/i, operator:/[-+*\/=%^~]|&&?|\|\|?|!=?|<(?:=>?|<|>)?|>[>=]?|\b(?:AND|BETWEEN|DIV|ILIKE|IN|IS|LIKE|NOT|OR|REGEXP|RLIKE|SOUNDS LIKE|XOR)\b/i, punctuation:/[;[\]()`,.]/}, function(t) {
  var e = t.languages.javascript["template-string"], n = e.pattern.source, r = e.inside.interpolation, i = r.inside["interpolation-punctuation"], s = r.pattern.source;
  function o(h, f) {
    if (t.languages[h]) {
      return {pattern:RegExp("((?:" + f + ")\\s*)" + n), lookbehind:!0, greedy:!0, inside:{"template-punctuation":{pattern:/^`|`$/, alias:"string"}, "embedded-code":{pattern:/[\s\S]+/, alias:h}}};
    }
  }
  function a(h, f, p) {
    return h = {code:h, grammar:f, language:p}, t.hooks.run("before-tokenize", h), h.tokens = t.tokenize(h.code, h.grammar), t.hooks.run("after-tokenize", h), h.tokens;
  }
  function l(h, f, p) {
    var b = t.tokenize(h, {interpolation:{pattern:RegExp(s), lookbehind:!0}}), g = 0, m = {}, b = a(b.map(function(w) {
      if (typeof w == "string") {
        return w;
      }
      for (var v, T, w = w.content; h.indexOf((T = g++, v = "___" + p.toUpperCase() + "_" + T + "___")) !== -1;) {
      }
      return m[v] = w, v;
    }).join(""), f, p), x = Object.keys(m);
    return g = 0, function w(v) {
      for (var T = 0; T < v.length; T++) {
        if (g >= x.length) {
          return;
        }
        var I, _, N, E, C, k, A, P = v[T];
        typeof P == "string" || typeof P.content == "string" ? (I = x[g], (A = (k = typeof P == "string" ? P : P.content).indexOf(I)) !== -1 && (++g, _ = k.substring(0, A), C = m[I], N = void 0, (E = {})["interpolation-punctuation"] = i, (E = t.tokenize(C, E)).length === 3 && ((N = [1, 1]).push.apply(N, a(E[1], t.languages.javascript, "javascript")), E.splice.apply(E, N)), N = new t.Token("interpolation", E, r.alias, C), E = k.substring(A + I.length), C = [], _ && C.push(_), C.push(N), E && (w(k = 
        [E]), C.push.apply(C, k)), typeof P == "string" ? (v.splice.apply(v, [T, 1].concat(C)), T += C.length - 1) : P.content = C)) : (A = P.content, Array.isArray(A) ? w(A) : w([A]));
      }
    }(b), new t.Token(p, b, "language-" + p, h);
  }
  t.languages.javascript["template-string"] = [o("css", /\b(?:styled(?:\([^)]*\))?(?:\s*\.\s*\w+(?:\([^)]*\))*)*|css(?:\s*\.\s*(?:global|resolve))?|createGlobalStyle|keyframes)/.source), o("html", /\bhtml|\.\s*(?:inner|outer)HTML\s*\+?=/.source), o("svg", /\bsvg/.source), o("markdown", /\b(?:markdown|md)/.source), o("graphql", /\b(?:gql|graphql(?:\s*\.\s*experimental)?)/.source), o("sql", /\bsql/.source), e].filter(Boolean);
  var c = {javascript:!0, js:!0, typescript:!0, ts:!0, jsx:!0, tsx:!0};
  function u(h) {
    return typeof h == "string" ? h : Array.isArray(h) ? h.map(u).join("") : u(h.content);
  }
  t.hooks.add("after-tokenize", function(h) {
    h.language in c && function f(p) {
      for (var g = 0, m = p.length; g < m; g++) {
        var b, x, w, v = p[g];
        typeof v != "string" && (b = v.content, Array.isArray(b) ? v.type === "template-string" ? (v = b[1], b.length === 3 && typeof v != "string" && v.type === "embedded-code" && (x = u(v), v = v.alias, v = Array.isArray(v) ? v[0] : v, w = t.languages[v]) && (b[1] = l(x, w, v))) : f(b) : typeof b != "string" && f([b]));
      }
    }(h.tokens);
  });
}(Ne), function(t) {
  t.languages.typescript = t.languages.extend("javascript", {"class-name":{pattern:/(\b(?:class|extends|implements|instanceof|interface|new|type)\s+)(?!keyof\b)(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?:\s*<(?:[^<>]|<(?:[^<>]|<[^<>]*>)*>)*>)?/, lookbehind:!0, greedy:!0, inside:null}, builtin:/\b(?:Array|Function|Promise|any|boolean|console|never|number|string|symbol|unknown)\b/}), t.languages.typescript.keyword.push(/\b(?:abstract|declare|is|keyof|readonly|require)\b/, /\b(?:asserts|infer|interface|module|namespace|type)\b(?=\s*(?:[{_$a-zA-Z\xA0-\uFFFF]|$))/, 
  /\btype\b(?=\s*(?:[\{*]|$))/), delete t.languages.typescript.parameter, delete t.languages.typescript["literal-property"];
  var e = t.languages.extend("typescript", {});
  delete e["class-name"], t.languages.typescript["class-name"].inside = e, t.languages.insertBefore("typescript", "function", {decorator:{pattern:/@[$\w\xA0-\uFFFF]+/, inside:{at:{pattern:/^@/, alias:"operator"}, function:/^[\s\S]+/}}, "generic-function":{pattern:/#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*\s*<(?:[^<>]|<(?:[^<>]|<[^<>]*>)*>)*>(?=\s*\()/, greedy:!0, inside:{function:/^#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*/, generic:{pattern:/<[\s\S]+/, alias:"class-name", 
  inside:e}}}}), t.languages.ts = t.languages.typescript;
}(Ne), function(t) {
  var e = t.languages.javascript, n = /\{(?:[^{}]|\{(?:[^{}]|\{[^{}]*\})*\})+\}/.source, r = "(@(?:arg|argument|param|property)\\s+(?:" + n + "\\s+)?)";
  t.languages.jsdoc = t.languages.extend("javadoclike", {parameter:{pattern:RegExp(r + /(?:(?!\s)[$\w\xA0-\uFFFF.])+(?=\s|$)/.source), lookbehind:!0, inside:{punctuation:/\./}}}), t.languages.insertBefore("jsdoc", "keyword", {"optional-parameter":{pattern:RegExp(r + /\[(?:(?!\s)[$\w\xA0-\uFFFF.])+(?:=[^[\]]+)?\](?=\s|$)/.source), lookbehind:!0, inside:{parameter:{pattern:/(^\[)[$\w\xA0-\uFFFF\.]+/, lookbehind:!0, inside:{punctuation:/\./}}, code:{pattern:/(=)[\s\S]*(?=\]$)/, lookbehind:!0, inside:e, 
  alias:"language-javascript"}, punctuation:/[=[\]]/}}, "class-name":[{pattern:RegExp(/(@(?:augments|class|extends|interface|memberof!?|template|this|typedef)\s+(?:<TYPE>\s+)?)[A-Z]\w*(?:\.[A-Z]\w*)*/.source.replace(/<TYPE>/g, function() {
    return n;
  })), lookbehind:!0, inside:{punctuation:/\./}}, {pattern:RegExp("(@[a-z]+\\s+)" + n), lookbehind:!0, inside:{string:e.string, number:e.number, boolean:e.boolean, keyword:t.languages.typescript.keyword, operator:/=>|\.\.\.|[&|?:*]/, punctuation:/[.,;=<>{}()[\]]/}}], example:{pattern:/(@example\s+(?!\s))(?:[^@\s]|\s+(?!\s))+?(?=\s*(?:\*\s*)?(?:@\w|\*\/))/, lookbehind:!0, inside:{code:{pattern:/^([\t ]*(?:\*\s*)?)\S.*$/m, lookbehind:!0, inside:e, alias:"language-javascript"}}}}), t.languages.javadoclike.addSupport("javascript", 
  t.languages.jsdoc);
}(Ne), function(t) {
  t.languages.flow = t.languages.extend("javascript", {}), t.languages.insertBefore("flow", "keyword", {type:[{pattern:/\b(?:[Bb]oolean|Function|[Nn]umber|[Ss]tring|[Ss]ymbol|any|mixed|null|void)\b/, alias:"class-name"}]}), t.languages.flow["function-variable"].pattern = /(?!\s)[_$a-z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*=\s*(?:function\b|(?:\([^()]*\)(?:\s*:\s*\w+)?|(?!\s)[_$a-z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)\s*=>))/i, delete t.languages.flow.parameter, t.languages.insertBefore("flow", 
  "operator", {"flow-punctuation":{pattern:/\{\||\|\}/, alias:"punctuation"}}), Array.isArray(t.languages.flow.keyword) || (t.languages.flow.keyword = [t.languages.flow.keyword]), t.languages.flow.keyword.unshift({pattern:/(^|[^$]\b)(?:Class|declare|opaque|type)\b(?!\$)/, lookbehind:!0}, {pattern:/(^|[^$]\B)\$(?:Diff|Enum|Exact|Keys|ObjMap|PropertyType|Record|Shape|Subtype|Supertype|await)\b(?!\$)/, lookbehind:!0});
}(Ne), Ne.languages.n4js = Ne.languages.extend("javascript", {keyword:/\b(?:Array|any|boolean|break|case|catch|class|const|constructor|continue|debugger|declare|default|delete|do|else|enum|export|extends|false|finally|for|from|function|get|if|implements|import|in|instanceof|interface|let|module|new|null|number|package|private|protected|public|return|set|static|string|super|switch|this|throw|true|try|typeof|var|void|while|with|yield)\b/}), Ne.languages.insertBefore("n4js", "constant", {annotation:{pattern:/@+\w+/, 
alias:"operator"}}), Ne.languages.n4jsd = Ne.languages.n4js, function(t) {
  function e(o, a) {
    return RegExp(o.replace(/<ID>/g, function() {
      return /(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*/.source;
    }), a);
  }
  t.languages.insertBefore("javascript", "function-variable", {"method-variable":{pattern:RegExp("(\\.\\s*)" + t.languages.javascript["function-variable"].pattern.source), lookbehind:!0, alias:["function-variable", "method", "function", "property-access"]}}), t.languages.insertBefore("javascript", "function", {method:{pattern:RegExp("(\\.\\s*)" + t.languages.javascript.function.source), lookbehind:!0, alias:["function", "property-access"]}}), t.languages.insertBefore("javascript", "constant", {"known-class-name":[{pattern:/\b(?:(?:Float(?:32|64)|(?:Int|Uint)(?:8|16|32)|Uint8Clamped)?Array|ArrayBuffer|BigInt|Boolean|DataView|Date|Error|Function|Intl|JSON|(?:Weak)?(?:Map|Set)|Math|Number|Object|Promise|Proxy|Reflect|RegExp|String|Symbol|WebAssembly)\b/, 
  alias:"class-name"}, {pattern:/\b(?:[A-Z]\w*)Error\b/, alias:"class-name"}]}), t.languages.insertBefore("javascript", "keyword", {imports:{pattern:e(/(\bimport\b\s*)(?:<ID>(?:\s*,\s*(?:\*\s*as\s+<ID>|\{[^{}]*\}))?|\*\s*as\s+<ID>|\{[^{}]*\})(?=\s*\bfrom\b)/.source), lookbehind:!0, inside:t.languages.javascript}, exports:{pattern:e(/(\bexport\b\s*)(?:\*(?:\s*as\s+<ID>)?(?=\s*\bfrom\b)|\{[^{}]*\})/.source), lookbehind:!0, inside:t.languages.javascript}}), t.languages.javascript.keyword.unshift({pattern:/\b(?:as|default|export|from|import)\b/, 
  alias:"module"}, {pattern:/\b(?:await|break|catch|continue|do|else|finally|for|if|return|switch|throw|try|while|yield)\b/, alias:"control-flow"}, {pattern:/\bnull\b/, alias:["null", "nil"]}, {pattern:/\bundefined\b/, alias:"nil"}), t.languages.insertBefore("javascript", "operator", {spread:{pattern:/\.{3}/, alias:"operator"}, arrow:{pattern:/=>/, alias:"operator"}}), t.languages.insertBefore("javascript", "punctuation", {"property-access":{pattern:e(/(\.\s*)#?<ID>/.source), lookbehind:!0}, "maybe-class-name":{pattern:/(^|[^$\w\xA0-\uFFFF])[A-Z][$\w\xA0-\uFFFF]+/, 
  lookbehind:!0}, dom:{pattern:/\b(?:document|(?:local|session)Storage|location|navigator|performance|window)\b/, alias:"variable"}, console:{pattern:/\bconsole(?=\s*\.)/, alias:"class-name"}});
  for (var n = ["function", "function-variable", "method", "method-variable", "property-access"], r = 0; r < n.length; r++) {
    var s = n[r], i = t.languages.javascript[s], s = (i = t.util.type(i) === "RegExp" ? t.languages.javascript[s] = {pattern:i} : i).inside || {};
    (i.inside = s)["maybe-class-name"] = /^[A-Z][\s\S]*/;
  }
}(Ne), function(t) {
  var e = t.util.clone(t.languages.javascript), n = /(?:\s|\/\/.*(?!.)|\/\*(?:[^*]|\*(?!\/))\*\/)/.source, r = /(?:\{(?:\{(?:\{[^{}]*\}|[^{}])*\}|[^{}])*\})/.source, i = /(?:\{<S>*\.{3}(?:[^{}]|<BRACES>)*\})/.source;
  function s(l, c) {
    return l = l.replace(/<S>/g, function() {
      return n;
    }).replace(/<BRACES>/g, function() {
      return r;
    }).replace(/<SPREAD>/g, function() {
      return i;
    }), RegExp(l, c);
  }
  i = s(i).source, t.languages.jsx = t.languages.extend("markup", e), t.languages.jsx.tag.pattern = s(/<\/?(?:[\w.:-]+(?:<S>+(?:[\w.:$-]+(?:=(?:"(?:\\[\s\S]|[^\\"])*"|'(?:\\[\s\S]|[^\\'])*'|[^\s{'"/>=]+|<BRACES>))?|<SPREAD>))*<S>*\/?)?>/.source), t.languages.jsx.tag.inside.tag.pattern = /^<\/?[^\s>\/]*/, t.languages.jsx.tag.inside["attr-value"].pattern = /=(?!\{)(?:"(?:\\[\s\S]|[^\\"])*"|'(?:\\[\s\S]|[^\\'])*'|[^\s'">]+)/, t.languages.jsx.tag.inside.tag.inside["class-name"] = /^[A-Z]\w*(?:\.[A-Z]\w*)*$/, 
  t.languages.jsx.tag.inside.comment = e.comment, t.languages.insertBefore("inside", "attr-name", {spread:{pattern:s(/<SPREAD>/.source), inside:t.languages.jsx}}, t.languages.jsx.tag), t.languages.insertBefore("inside", "special-attr", {script:{pattern:s(/=<BRACES>/.source), alias:"language-javascript", inside:{"script-punctuation":{pattern:/^=(?=\{)/, alias:"punctuation"}, rest:t.languages.jsx}}}, t.languages.jsx.tag);
  function o(l) {
    for (var c = [], u = 0; u < l.length; u++) {
      var h = l[u], f = !1;
      typeof h != "string" && (h.type === "tag" && h.content[0] && h.content[0].type === "tag" ? h.content[0].content[0].content === "\x3c/" ? 0 < c.length && c[c.length - 1].tagName === a(h.content[0].content[1]) && c.pop() : h.content[h.content.length - 1].content !== "/\x3e" && c.push({tagName:a(h.content[0].content[1]), openedBraces:0}) : 0 < c.length && h.type === "punctuation" && h.content === "{" ? c[c.length - 1].openedBraces++ : 0 < c.length && 0 < c[c.length - 1].openedBraces && h.type === 
      "punctuation" && h.content === "}" ? c[c.length - 1].openedBraces-- : f = !0), (f || typeof h == "string") && 0 < c.length && c[c.length - 1].openedBraces === 0 && (f = a(h), u < l.length - 1 && (typeof l[u + 1] == "string" || l[u + 1].type === "plain-text") && (f += a(l[u + 1]), l.splice(u + 1, 1)), 0 < u && (typeof l[u - 1] == "string" || l[u - 1].type === "plain-text") && (f = a(l[u - 1]) + f, l.splice(u - 1, 1), u--), l[u] = new t.Token("plain-text", f, null, f)), h.content && typeof h.content != 
      "string" && o(h.content);
    }
  }
  var a = function(l) {
    return l ? typeof l == "string" ? l : typeof l.content == "string" ? l.content : l.content.map(a).join("") : "";
  };
  t.hooks.add("after-tokenize", function(l) {
    l.language !== "jsx" && l.language !== "tsx" || o(l.tokens);
  });
}(Ne), function(t) {
  var e = t.util.clone(t.languages.typescript), e = (t.languages.tsx = t.languages.extend("jsx", e), delete t.languages.tsx.parameter, delete t.languages.tsx["literal-property"], t.languages.tsx.tag);
  e.pattern = RegExp(/(^|[^\w$]|(?=<\/))/.source + "(?:" + e.pattern.source + ")", e.pattern.flags), e.lookbehind = !0;
}(Ne), Ne.languages.swift = {comment:{pattern:/(^|[^\\:])(?:\/\/.*|\/\*(?:[^/*]|\/(?!\*)|\*(?!\/)|\/\*(?:[^*]|\*(?!\/))*\*\/)*\*\/)/, lookbehind:!0, greedy:!0}, "string-literal":[{pattern:RegExp(/(^|[^"#])/.source + "(?:" + /"(?:\\(?:\((?:[^()]|\([^()]*\))*\)|\r\n|[^(])|[^\\\r\n"])*"/.source + "|" + /"""(?:\\(?:\((?:[^()]|\([^()]*\))*\)|[^(])|[^\\"]|"(?!""))*"""/.source + ")" + /(?!["#])/.source), lookbehind:!0, greedy:!0, inside:{interpolation:{pattern:/(\\\()(?:[^()]|\([^()]*\))*(?=\))/, lookbehind:!0, 
inside:null}, "interpolation-punctuation":{pattern:/^\)|\\\($/, alias:"punctuation"}, punctuation:/\\(?=[\r\n])/, string:/[\s\S]+/}}, {pattern:RegExp(/(^|[^"#])(#+)/.source + "(?:" + /"(?:\\(?:#+\((?:[^()]|\([^()]*\))*\)|\r\n|[^#])|[^\\\r\n])*?"/.source + "|" + /"""(?:\\(?:#+\((?:[^()]|\([^()]*\))*\)|[^#])|[^\\])*?"""/.source + ")\\2"), lookbehind:!0, greedy:!0, inside:{interpolation:{pattern:/(\\#+\()(?:[^()]|\([^()]*\))*(?=\))/, lookbehind:!0, inside:null}, "interpolation-punctuation":{pattern:/^\)|\\#+\($/, 
alias:"punctuation"}, string:/[\s\S]+/}}], directive:{pattern:RegExp(/#/.source + "(?:" + /(?:elseif|if)\b/.source + "(?:[ \t]*" + /(?:![ \t]*)?(?:\b\w+\b(?:[ \t]*\((?:[^()]|\([^()]*\))*\))?|\((?:[^()]|\([^()]*\))*\))(?:[ \t]*(?:&&|\|\|))?/.source + ")+|" + /(?:else|endif)\b/.source + ")"), alias:"property", inside:{"directive-name":/^#\w+/, boolean:/\b(?:false|true)\b/, number:/\b\d+(?:\.\d+)*\b/, operator:/!|&&|\|\||[<>]=?/, punctuation:/[(),]/}}, literal:{pattern:/#(?:colorLiteral|column|dsohandle|file(?:ID|Literal|Path)?|function|imageLiteral|line)\b/, 
alias:"constant"}, "other-directive":{pattern:/#\w+\b/, alias:"property"}, attribute:{pattern:/@\w+/, alias:"atrule"}, "function-definition":{pattern:/(\bfunc\s+)\w+/, lookbehind:!0, alias:"function"}, label:{pattern:/\b(break|continue)\s+\w+|\b[a-zA-Z_]\w*(?=\s*:\s*(?:for|repeat|while)\b)/, lookbehind:!0, alias:"important"}, keyword:/\b(?:Any|Protocol|Self|Type|actor|as|assignment|associatedtype|associativity|async|await|break|case|catch|class|continue|convenience|default|defer|deinit|didSet|do|dynamic|else|enum|extension|fallthrough|fileprivate|final|for|func|get|guard|higherThan|if|import|in|indirect|infix|init|inout|internal|is|isolated|lazy|left|let|lowerThan|mutating|none|nonisolated|nonmutating|open|operator|optional|override|postfix|precedencegroup|prefix|private|protocol|public|repeat|required|rethrows|return|right|safe|self|set|some|static|struct|subscript|super|switch|throw|throws|try|typealias|unowned|unsafe|var|weak|where|while|willSet)\b/, 
boolean:/\b(?:false|true)\b/, nil:{pattern:/\bnil\b/, alias:"constant"}, "short-argument":/\$\d+\b/, omit:{pattern:/\b_\b/, alias:"keyword"}, number:/\b(?:[\d_]+(?:\.[\de_]+)?|0x[a-f0-9_]+(?:\.[a-f0-9p_]+)?|0b[01_]+|0o[0-7_]+)\b/i, "class-name":/\b[A-Z](?:[A-Z_\d]*[a-z]\w*)?\b/, function:/\b[a-z_]\w*(?=\s*\()/i, constant:/\b(?:[A-Z_]{2,}|k[A-Z][A-Za-z_]+)\b/, operator:/[-+*/%=!<>&|^~?]+|\.[.\-+*/%=!<>&|^~?]+/, punctuation:/[{}[\]();,.:\\]/}, Ne.languages.swift["string-literal"].forEach(function(t) {
  t.inside.interpolation.inside = Ne.languages.swift;
}), function(t) {
  t.languages.kotlin = t.languages.extend("clike", {keyword:{pattern:/(^|[^.])\b(?:abstract|actual|annotation|as|break|by|catch|class|companion|const|constructor|continue|crossinline|data|do|dynamic|else|enum|expect|external|final|finally|for|fun|get|if|import|in|infix|init|inline|inner|interface|internal|is|lateinit|noinline|null|object|open|operator|out|override|package|private|protected|public|reified|return|sealed|set|super|suspend|tailrec|this|throw|to|try|typealias|val|var|vararg|when|where|while)\b/, 
  lookbehind:!0}, function:[{pattern:/(?:`[^\r\n`]+`|\b\w+)(?=\s*\()/, greedy:!0}, {pattern:/(\.)(?:`[^\r\n`]+`|\w+)(?=\s*\{)/, lookbehind:!0, greedy:!0}], number:/\b(?:0[xX][\da-fA-F]+(?:_[\da-fA-F]+)*|0[bB][01]+(?:_[01]+)*|\d+(?:_\d+)*(?:\.\d+(?:_\d+)*)?(?:[eE][+-]?\d+(?:_\d+)*)?[fFL]?)\b/, operator:/\+[+=]?|-[-=>]?|==?=?|!(?:!|==?)?|[\/*%<>]=?|[?:]:?|\.\.|&&|\|\||\b(?:and|inv|or|shl|shr|ushr|xor)\b/}), delete t.languages.kotlin["class-name"];
  var e = {"interpolation-punctuation":{pattern:/^\$\{?|\}$/, alias:"punctuation"}, expression:{pattern:/[\s\S]+/, inside:t.languages.kotlin}};
  t.languages.insertBefore("kotlin", "string", {"string-literal":[{pattern:/"""(?:[^$]|\$(?:(?!\{)|\{[^{}]*\}))*?"""/, alias:"multiline", inside:{interpolation:{pattern:/\$(?:[a-z_]\w*|\{[^{}]*\})/i, inside:e}, string:/[\s\S]+/}}, {pattern:/"(?:[^"\\\r\n$]|\\.|\$(?:(?!\{)|\{[^{}]*\}))*"/, alias:"singleline", inside:{interpolation:{pattern:/((?:^|[^\\])(?:\\{2})*)\$(?:[a-z_]\w*|\{[^{}]*\})/i, lookbehind:!0, inside:e}, string:/[\s\S]+/}}], char:{pattern:/'(?:[^'\\\r\n]|\\(?:.|u[a-fA-F0-9]{0,4}))'/, 
  greedy:!0}}), delete t.languages.kotlin.string, t.languages.insertBefore("kotlin", "keyword", {annotation:{pattern:/\B@(?:\w+:)?(?:[A-Z]\w*|\[[^\]]+\])/, alias:"builtin"}}), t.languages.insertBefore("kotlin", "function", {label:{pattern:/\b\w+@|@\w+\b/, alias:"symbol"}}), t.languages.kt = t.languages.kotlin, t.languages.kts = t.languages.kotlin;
}(Ne), Ne.languages.c = Ne.languages.extend("clike", {comment:{pattern:/\/\/(?:[^\r\n\\]|\\(?:\r\n?|\n|(?![\r\n])))*|\/\*[\s\S]*?(?:\*\/|$)/, greedy:!0}, string:{pattern:/"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"/, greedy:!0}, "class-name":{pattern:/(\b(?:enum|struct)\s+(?:__attribute__\s*\(\([\s\S]*?\)\)\s*)?)\w+|\b[a-z]\w*_t\b/, lookbehind:!0}, keyword:/\b(?:_Alignas|_Alignof|_Atomic|_Bool|_Complex|_Generic|_Imaginary|_Noreturn|_Static_assert|_Thread_local|__attribute__|asm|auto|break|case|char|const|continue|default|do|double|else|enum|extern|float|for|goto|if|inline|int|long|register|return|short|signed|sizeof|static|struct|switch|typedef|typeof|union|unsigned|void|volatile|while)\b/, 
function:/\b[a-z_]\w*(?=\s*\()/i, number:/(?:\b0x(?:[\da-f]+(?:\.[\da-f]*)?|\.[\da-f]+)(?:p[+-]?\d+)?|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?)[ful]{0,4}/i, operator:/>>=?|<<=?|->|([-+&|:])\1|[?:~]|[-+*/%&|^!=<>]=?/}), Ne.languages.insertBefore("c", "string", {char:{pattern:/'(?:\\(?:\r\n|[\s\S])|[^'\\\r\n]){0,32}'/, greedy:!0}}), Ne.languages.insertBefore("c", "string", {macro:{pattern:/(^[\t ]*)#\s*[a-z](?:[^\r\n\\/]|\/(?!\*)|\/\*(?:[^*]|\*(?!\/))*\*\/|\\(?:\r\n|[\s\S]))*/im, lookbehind:!0, greedy:!0, 
alias:"property", inside:{string:[{pattern:/^(#\s*include\s*)<[^>]+>/, lookbehind:!0}, Ne.languages.c.string], char:Ne.languages.c.char, comment:Ne.languages.c.comment, "macro-name":[{pattern:/(^#\s*define\s+)\w+\b(?!\()/i, lookbehind:!0}, {pattern:/(^#\s*define\s+)\w+\b(?=\()/i, lookbehind:!0, alias:"function"}], directive:{pattern:/^(#\s*)[a-z]+/, lookbehind:!0, alias:"keyword"}, "directive-hash":/^#/, punctuation:/##|\\(?=[\r\n])/, expression:{pattern:/\S[\s\S]*/, inside:Ne.languages.c}}}}), Ne.languages.insertBefore("c", 
"function", {constant:/\b(?:EOF|NULL|SEEK_CUR|SEEK_END|SEEK_SET|__DATE__|__FILE__|__LINE__|__TIMESTAMP__|__TIME__|__func__|stderr|stdin|stdout)\b/}), delete Ne.languages.c.boolean, Ne.languages.objectivec = Ne.languages.extend("c", {string:{pattern:/@?"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"/, greedy:!0}, keyword:/\b(?:asm|auto|break|case|char|const|continue|default|do|double|else|enum|extern|float|for|goto|if|in|inline|int|long|register|return|self|short|signed|sizeof|static|struct|super|switch|typedef|typeof|union|unsigned|void|volatile|while)\b|(?:@interface|@end|@implementation|@protocol|@class|@public|@protected|@private|@property|@try|@catch|@finally|@throw|@synthesize|@dynamic|@selector)\b/, 
operator:/-[->]?|\+\+?|!=?|<<?=?|>>?=?|==?|&&?|\|\|?|[~^%?*\/@]/}), delete Ne.languages.objectivec["class-name"], Ne.languages.objc = Ne.languages.objectivec, Ne.languages.reason = Ne.languages.extend("clike", {string:{pattern:/"(?:\\(?:\r\n|[\s\S])|[^\\\r\n"])*"/, greedy:!0}, "class-name":/\b[A-Z]\w*/, keyword:/\b(?:and|as|assert|begin|class|constraint|do|done|downto|else|end|exception|external|for|fun|function|functor|if|in|include|inherit|initializer|lazy|let|method|module|mutable|new|nonrec|object|of|open|or|private|rec|sig|struct|switch|then|to|try|type|val|virtual|when|while|with)\b/, 
operator:/\.{3}|:[:=]|\|>|->|=(?:==?|>)?|<=?|>=?|[|^?'#!~`]|[+\-*\/]\.?|\b(?:asr|land|lor|lsl|lsr|lxor|mod)\b/}), Ne.languages.insertBefore("reason", "class-name", {char:{pattern:/'(?:\\x[\da-f]{2}|\\o[0-3][0-7][0-7]|\\\d{3}|\\.|[^'\\\r\n])'/, greedy:!0}, constructor:/\b[A-Z]\w*\b(?!\s*\.)/, label:{pattern:/\b[a-z]\w*(?=::)/, alias:"symbol"}}), delete Ne.languages.reason.function, function(t) {
  for (var e = /\/\*(?:[^*/]|\*(?!\/)|\/(?!\*)|<self>)*\*\//.source, n = 0; n < 2; n++) {
    e = e.replace(/<self>/g, function() {
      return e;
    });
  }
  e = e.replace(/<self>/g, function() {
    return /[^\s\S]/.source;
  }), t.languages.rust = {comment:[{pattern:RegExp(/(^|[^\\])/.source + e), lookbehind:!0, greedy:!0}, {pattern:/(^|[^\\:])\/\/.*/, lookbehind:!0, greedy:!0}], string:{pattern:/b?"(?:\\[\s\S]|[^\\"])*"|b?r(#*)"(?:[^"]|"(?!\1))*"\1/, greedy:!0}, char:{pattern:/b?'(?:\\(?:x[0-7][\da-fA-F]|u\{(?:[\da-fA-F]_*){1,6}\}|.)|[^\\\r\n\t'])'/, greedy:!0}, attribute:{pattern:/#!?\[(?:[^\[\]"]|"(?:\\[\s\S]|[^\\"])*")*\]/, greedy:!0, alias:"attr-name", inside:{string:null}}, "closure-params":{pattern:/([=(,:]\s*|\bmove\s*)\|[^|]*\||\|[^|]*\|(?=\s*(?:\{|->))/, 
  lookbehind:!0, greedy:!0, inside:{"closure-punctuation":{pattern:/^\||\|$/, alias:"punctuation"}, rest:null}}, "lifetime-annotation":{pattern:/'\w+/, alias:"symbol"}, "fragment-specifier":{pattern:/(\$\w+:)[a-z]+/, lookbehind:!0, alias:"punctuation"}, variable:/\$\w+/, "function-definition":{pattern:/(\bfn\s+)\w+/, lookbehind:!0, alias:"function"}, "type-definition":{pattern:/(\b(?:enum|struct|trait|type|union)\s+)\w+/, lookbehind:!0, alias:"class-name"}, "module-declaration":[{pattern:/(\b(?:crate|mod)\s+)[a-z][a-z_\d]*/, 
  lookbehind:!0, alias:"namespace"}, {pattern:/(\b(?:crate|self|super)\s*)::\s*[a-z][a-z_\d]*\b(?:\s*::(?:\s*[a-z][a-z_\d]*\s*::)*)?/, lookbehind:!0, alias:"namespace", inside:{punctuation:/::/}}], keyword:[/\b(?:Self|abstract|as|async|await|become|box|break|const|continue|crate|do|dyn|else|enum|extern|final|fn|for|if|impl|in|let|loop|macro|match|mod|move|mut|override|priv|pub|ref|return|self|static|struct|super|trait|try|type|typeof|union|unsafe|unsized|use|virtual|where|while|yield)\b/, /\b(?:bool|char|f(?:32|64)|[ui](?:8|16|32|64|128|size)|str)\b/], 
  function:/\b[a-z_]\w*(?=\s*(?:::\s*<|\())/, macro:{pattern:/\b\w+!/, alias:"property"}, constant:/\b[A-Z_][A-Z_\d]+\b/, "class-name":/\b[A-Z]\w*\b/, namespace:{pattern:/(?:\b[a-z][a-z_\d]*\s*::\s*)*\b[a-z][a-z_\d]*\s*::(?!\s*<)/, inside:{punctuation:/::/}}, number:/\b(?:0x[\dA-Fa-f](?:_?[\dA-Fa-f])*|0o[0-7](?:_?[0-7])*|0b[01](?:_?[01])*|(?:(?:\d(?:_?\d)*)?\.)?\d(?:_?\d)*(?:[Ee][+-]?\d+)?)(?:_?(?:f32|f64|[iu](?:8|16|32|64|size)?))?\b/, boolean:/\b(?:false|true)\b/, punctuation:/->|\.\.=|\.{1,3}|::|[{}[\];(),:]/, 
  operator:/[-+*\/%!^]=?|=[=>]?|&[&=]?|\|[|=]?|<<?=?|>>?=?|[@?]/}, t.languages.rust["closure-params"].inside.rest = t.languages.rust, t.languages.rust.attribute.inside.string = t.languages.rust.string;
}(Ne), Ne.languages.go = Ne.languages.extend("clike", {string:{pattern:/(^|[^\\])"(?:\\.|[^"\\\r\n])*"|`[^`]*`/, lookbehind:!0, greedy:!0}, keyword:/\b(?:break|case|chan|const|continue|default|defer|else|fallthrough|for|func|go(?:to)?|if|import|interface|map|package|range|return|select|struct|switch|type|var)\b/, boolean:/\b(?:_|false|iota|nil|true)\b/, number:[/\b0(?:b[01_]+|o[0-7_]+)i?\b/i, /\b0x(?:[a-f\d_]+(?:\.[a-f\d_]*)?|\.[a-f\d_]+)(?:p[+-]?\d+(?:_\d+)*)?i?(?!\w)/i, /(?:\b\d[\d_]*(?:\.[\d_]*)?|\B\.\d[\d_]*)(?:e[+-]?[\d_]+)?i?(?!\w)/i], 
operator:/[*\/%^!=]=?|\+[=+]?|-[=-]?|\|[=|]?|&(?:=|&|\^=?)?|>(?:>=?|=)?|<(?:<=?|=|-)?|:=|\.\.\./, builtin:/\b(?:append|bool|byte|cap|close|complex|complex(?:64|128)|copy|delete|error|float(?:32|64)|u?int(?:8|16|32|64)?|imag|len|make|new|panic|print(?:ln)?|real|recover|rune|string|uintptr)\b/}), Ne.languages.insertBefore("go", "string", {char:{pattern:/'(?:\\.|[^'\\\r\n]){0,10}'/, greedy:!0}}), delete Ne.languages.go["class-name"], function(t) {
  var e = /\b(?:alignas|alignof|asm|auto|bool|break|case|catch|char|char16_t|char32_t|char8_t|class|co_await|co_return|co_yield|compl|concept|const|const_cast|consteval|constexpr|constinit|continue|decltype|default|delete|do|double|dynamic_cast|else|enum|explicit|export|extern|final|float|for|friend|goto|if|import|inline|int|int16_t|int32_t|int64_t|int8_t|long|module|mutable|namespace|new|noexcept|nullptr|operator|override|private|protected|public|register|reinterpret_cast|requires|return|short|signed|sizeof|static|static_assert|static_cast|struct|switch|template|this|thread_local|throw|try|typedef|typeid|typename|uint16_t|uint32_t|uint64_t|uint8_t|union|unsigned|using|virtual|void|volatile|wchar_t|while)\b/, 
  n = /\b(?!<keyword>)\w+(?:\s*\.\s*\w+)*\b/.source.replace(/<keyword>/g, function() {
    return e.source;
  });
  t.languages.cpp = t.languages.extend("c", {"class-name":[{pattern:RegExp(/(\b(?:class|concept|enum|struct|typename)\s+)(?!<keyword>)\w+/.source.replace(/<keyword>/g, function() {
    return e.source;
  })), lookbehind:!0}, /\b[A-Z]\w*(?=\s*::\s*\w+\s*\()/, /\b[A-Z_]\w*(?=\s*::\s*~\w+\s*\()/i, /\b\w+(?=\s*<(?:[^<>]|<(?:[^<>]|<[^<>]*>)*>)*>\s*::\s*\w+\s*\()/], keyword:e, number:{pattern:/(?:\b0b[01']+|\b0x(?:[\da-f']+(?:\.[\da-f']*)?|\.[\da-f']+)(?:p[+-]?[\d']+)?|(?:\b[\d']+(?:\.[\d']*)?|\B\.[\d']+)(?:e[+-]?[\d']+)?)[ful]{0,4}/i, greedy:!0}, operator:/>>=?|<<=?|->|--|\+\+|&&|\|\||[?:~]|<=>|[-+*/%&|^!=<>]=?|\b(?:and|and_eq|bitand|bitor|not|not_eq|or|or_eq|xor|xor_eq)\b/, boolean:/\b(?:false|true)\b/}), 
  t.languages.insertBefore("cpp", "string", {module:{pattern:RegExp(/(\b(?:import|module)\s+)/.source + "(?:" + /"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"|<[^<>\r\n]*>/.source + "|" + /<mod-name>(?:\s*:\s*<mod-name>)?|:\s*<mod-name>/.source.replace(/<mod-name>/g, function() {
    return n;
  }) + ")"), lookbehind:!0, greedy:!0, inside:{string:/^[<"][\s\S]+/, operator:/:/, punctuation:/\./}}, "raw-string":{pattern:/R"([^()\\ ]{0,16})\([\s\S]*?\)\1"/, alias:"string", greedy:!0}}), t.languages.insertBefore("cpp", "keyword", {"generic-function":{pattern:/\b(?!operator\b)[a-z_]\w*\s*<(?:[^<>]|<[^<>]*>)*>(?=\s*\()/i, inside:{function:/^\w+/, generic:{pattern:/<[\s\S]+/, alias:"class-name", inside:t.languages.cpp}}}}), t.languages.insertBefore("cpp", "operator", {"double-colon":{pattern:/::/, 
  alias:"punctuation"}}), t.languages.insertBefore("cpp", "class-name", {"base-clause":{pattern:/(\b(?:class|struct)\s+\w+\s*:\s*)[^;{}"'\s]+(?:\s+[^;{}"'\s]+)*(?=\s*[;{])/, lookbehind:!0, greedy:!0, inside:t.languages.extend("cpp", {})}}), t.languages.insertBefore("inside", "double-colon", {"class-name":/\b[a-z_]\w*\b(?!\s*::)/i}, t.languages.cpp["base-clause"]);
}(Ne), Ne.languages.python = {comment:{pattern:/(^|[^\\])#.*/, lookbehind:!0, greedy:!0}, "string-interpolation":{pattern:/(?:f|fr|rf)(?:("""|''')[\s\S]*?\1|("|')(?:\\.|(?!\2)[^\\\r\n])*\2)/i, greedy:!0, inside:{interpolation:{pattern:/((?:^|[^{])(?:\{\{)*)\{(?!\{)(?:[^{}]|\{(?!\{)(?:[^{}]|\{(?!\{)(?:[^{}])+\})+\})+\}/, lookbehind:!0, inside:{"format-spec":{pattern:/(:)[^:(){}]+(?=\}$)/, lookbehind:!0}, "conversion-option":{pattern:/![sra](?=[:}]$)/, alias:"punctuation"}, rest:null}}, string:/[\s\S]+/}}, 
"triple-quoted-string":{pattern:/(?:[rub]|br|rb)?("""|''')[\s\S]*?\1/i, greedy:!0, alias:"string"}, string:{pattern:/(?:[rub]|br|rb)?("|')(?:\\.|(?!\1)[^\\\r\n])*\1/i, greedy:!0}, function:{pattern:/((?:^|\s)def[ \t]+)[a-zA-Z_]\w*(?=\s*\()/g, lookbehind:!0}, "class-name":{pattern:/(\bclass\s+)\w+/i, lookbehind:!0}, decorator:{pattern:/(^[\t ]*)@\w+(?:\.\w+)*/m, lookbehind:!0, alias:["annotation", "punctuation"], inside:{punctuation:/\./}}, keyword:/\b(?:_(?=\s*:)|and|as|assert|async|await|break|case|class|continue|def|del|elif|else|except|exec|finally|for|from|global|if|import|in|is|lambda|match|nonlocal|not|or|pass|print|raise|return|try|while|with|yield)\b/, 
builtin:/\b(?:__import__|abs|all|any|apply|ascii|basestring|bin|bool|buffer|bytearray|bytes|callable|chr|classmethod|cmp|coerce|compile|complex|delattr|dict|dir|divmod|enumerate|eval|execfile|file|filter|float|format|frozenset|getattr|globals|hasattr|hash|help|hex|id|input|int|intern|isinstance|issubclass|iter|len|list|locals|long|map|max|memoryview|min|next|object|oct|open|ord|pow|property|range|raw_input|reduce|reload|repr|reversed|round|set|setattr|slice|sorted|staticmethod|str|sum|super|tuple|type|unichr|unicode|vars|xrange|zip)\b/, 
boolean:/\b(?:False|None|True)\b/, number:/\b0(?:b(?:_?[01])+|o(?:_?[0-7])+|x(?:_?[a-f0-9])+)\b|(?:\b\d+(?:_\d+)*(?:\.(?:\d+(?:_\d+)*)?)?|\B\.\d+(?:_\d+)*)(?:e[+-]?\d+(?:_\d+)*)?j?(?!\w)/i, operator:/[-+%=]=?|!=|:=|\*\*?=?|\/\/?=?|<[<=>]?|>[=>]?|[&|^~]/, punctuation:/[{}[\];(),.:]/}, Ne.languages.python["string-interpolation"].inside.interpolation.inside.rest = Ne.languages.python, Ne.languages.py = Ne.languages.python, Ne.languages.json = {property:{pattern:/(^|[^\\])"(?:\\.|[^\\"\r\n])*"(?=\s*:)/, 
lookbehind:!0, greedy:!0}, string:{pattern:/(^|[^\\])"(?:\\.|[^\\"\r\n])*"(?!\s*:)/, lookbehind:!0, greedy:!0}, comment:{pattern:/\/\/.*|\/\*[\s\S]*?(?:\*\/|$)/, greedy:!0}, number:/-?\b\d+(?:\.\d+)?(?:e[+-]?\d+)?\b/i, punctuation:/[{}[\],]/, operator:/:/, boolean:/\b(?:false|true)\b/, null:{pattern:/\bnull\b/, alias:"keyword"}}, Ne.languages.webmanifest = Ne.languages.json;
var Uu = {};
lU(Uu, {dracula:() => fU, duotoneDark:() => gU, duotoneLight:() => bU, github:() => xU, gruvboxMaterialDark:() => GU, gruvboxMaterialLight:() => KU, jettwaveDark:() => zU, jettwaveLight:() => UU, nightOwl:() => wU, nightOwlLight:() => SU, oceanicNext:() => EU, okaidia:() => CU, oneDark:() => jU, oneLight:() => qU, palenight:() => NU, shadesOfPurple:() => OU, synthwave84:() => RU, ultramin:() => LU, vsDark:() => SA, vsLight:() => $U});
var hU = {plain:{color:"#F8F8F2", backgroundColor:"#282A36"}, styles:[{types:["prolog", "constant", "builtin"], style:{color:"rgb(189, 147, 249)"}}, {types:["inserted", "function"], style:{color:"rgb(80, 250, 123)"}}, {types:["deleted"], style:{color:"rgb(255, 85, 85)"}}, {types:["changed"], style:{color:"rgb(255, 184, 108)"}}, {types:["punctuation", "symbol"], style:{color:"rgb(248, 248, 242)"}}, {types:["string", "char", "tag", "selector"], style:{color:"rgb(255, 121, 198)"}}, {types:["keyword", 
"variable"], style:{color:"rgb(189, 147, 249)", fontStyle:"italic"}}, {types:["comment"], style:{color:"rgb(98, 114, 164)"}}, {types:["attr-name"], style:{color:"rgb(241, 250, 140)"}}]}, fU = hU, pU = {plain:{backgroundColor:"#2a2734", color:"#9a86fd"}, styles:[{types:["comment", "prolog", "doctype", "cdata", "punctuation"], style:{color:"#6c6783"}}, {types:["namespace"], style:{opacity:0.7}}, {types:["tag", "operator", "number"], style:{color:"#e09142"}}, {types:["property", "function"], style:{color:"#9a86fd"}}, 
{types:["tag-id", "selector", "atrule-id"], style:{color:"#eeebff"}}, {types:["attr-name"], style:{color:"#c4b9fe"}}, {types:["boolean", "string", "entity", "url", "attr-value", "keyword", "control", "directive", "unit", "statement", "regex", "atrule", "placeholder", "variable"], style:{color:"#ffcc99"}}, {types:["deleted"], style:{textDecorationLine:"line-through"}}, {types:["inserted"], style:{textDecorationLine:"underline"}}, {types:["italic"], style:{fontStyle:"italic"}}, {types:["important", 
"bold"], style:{fontWeight:"bold"}}, {types:["important"], style:{color:"#c4b9fe"}}]}, gU = pU, mU = {plain:{backgroundColor:"#faf8f5", color:"#728fcb"}, styles:[{types:["comment", "prolog", "doctype", "cdata", "punctuation"], style:{color:"#b6ad9a"}}, {types:["namespace"], style:{opacity:0.7}}, {types:["tag", "operator", "number"], style:{color:"#063289"}}, {types:["property", "function"], style:{color:"#b29762"}}, {types:["tag-id", "selector", "atrule-id"], style:{color:"#2d2006"}}, {types:["attr-name"], 
style:{color:"#896724"}}, {types:["boolean", "string", "entity", "url", "attr-value", "keyword", "control", "directive", "unit", "statement", "regex", "atrule"], style:{color:"#728fcb"}}, {types:["placeholder", "variable"], style:{color:"#93abdc"}}, {types:["deleted"], style:{textDecorationLine:"line-through"}}, {types:["inserted"], style:{textDecorationLine:"underline"}}, {types:["italic"], style:{fontStyle:"italic"}}, {types:["important", "bold"], style:{fontWeight:"bold"}}, {types:["important"], 
style:{color:"#896724"}}]}, bU = mU, yU = {plain:{color:"#393A34", backgroundColor:"#f6f8fa"}, styles:[{types:["comment", "prolog", "doctype", "cdata"], style:{color:"#999988", fontStyle:"italic"}}, {types:["namespace"], style:{opacity:0.7}}, {types:["string", "attr-value"], style:{color:"#e3116c"}}, {types:["punctuation", "operator"], style:{color:"#393A34"}}, {types:["entity", "url", "symbol", "number", "boolean", "variable", "constant", "property", "regex", "inserted"], style:{color:"#36acaa"}}, 
{types:["atrule", "keyword", "attr-name", "selector"], style:{color:"#00a4db"}}, {types:["function", "deleted", "tag"], style:{color:"#d73a49"}}, {types:["function-variable"], style:{color:"#6f42c1"}}, {types:["tag", "selector", "keyword"], style:{color:"#00009f"}}]}, xU = yU, vU = {plain:{color:"#d6deeb", backgroundColor:"#011627"}, styles:[{types:["changed"], style:{color:"rgb(162, 191, 252)", fontStyle:"italic"}}, {types:["deleted"], style:{color:"rgba(239, 83, 80, 0.56)", fontStyle:"italic"}}, 
{types:["inserted", "attr-name"], style:{color:"rgb(173, 219, 103)", fontStyle:"italic"}}, {types:["comment"], style:{color:"rgb(99, 119, 119)", fontStyle:"italic"}}, {types:["string", "url"], style:{color:"rgb(173, 219, 103)"}}, {types:["variable"], style:{color:"rgb(214, 222, 235)"}}, {types:["number"], style:{color:"rgb(247, 140, 108)"}}, {types:["builtin", "char", "constant", "function"], style:{color:"rgb(130, 170, 255)"}}, {types:["punctuation"], style:{color:"rgb(199, 146, 234)"}}, {types:["selector", 
"doctype"], style:{color:"rgb(199, 146, 234)", fontStyle:"italic"}}, {types:["class-name"], style:{color:"rgb(255, 203, 139)"}}, {types:["tag", "operator", "keyword"], style:{color:"rgb(127, 219, 202)"}}, {types:["boolean"], style:{color:"rgb(255, 88, 116)"}}, {types:["property"], style:{color:"rgb(128, 203, 196)"}}, {types:["namespace"], style:{color:"rgb(178, 204, 214)"}}]}, wU = vU, _U = {plain:{color:"#403f53", backgroundColor:"#FBFBFB"}, styles:[{types:["changed"], style:{color:"rgb(162, 191, 252)", 
fontStyle:"italic"}}, {types:["deleted"], style:{color:"rgba(239, 83, 80, 0.56)", fontStyle:"italic"}}, {types:["inserted", "attr-name"], style:{color:"rgb(72, 118, 214)", fontStyle:"italic"}}, {types:["comment"], style:{color:"rgb(152, 159, 177)", fontStyle:"italic"}}, {types:["string", "builtin", "char", "constant", "url"], style:{color:"rgb(72, 118, 214)"}}, {types:["variable"], style:{color:"rgb(201, 103, 101)"}}, {types:["number"], style:{color:"rgb(170, 9, 130)"}}, {types:["punctuation"], style:{color:"rgb(153, 76, 195)"}}, 
{types:["function", "selector", "doctype"], style:{color:"rgb(153, 76, 195)", fontStyle:"italic"}}, {types:["class-name"], style:{color:"rgb(17, 17, 17)"}}, {types:["tag"], style:{color:"rgb(153, 76, 195)"}}, {types:["operator", "property", "keyword", "namespace"], style:{color:"rgb(12, 150, 155)"}}, {types:["boolean"], style:{color:"rgb(188, 84, 84)"}}]}, SU = _U, li = {char:"#D8DEE9", comment:"#999999", keyword:"#c5a5c5", primitive:"#5a9bcf", string:"#8dc891", variable:"#d7deea", boolean:"#ff8b50", 
tag:"#fc929e", function:"#79b6f2", className:"#FAC863"}, kU = {plain:{backgroundColor:"#282c34", color:"#ffffff"}, styles:[{types:["attr-name"], style:{color:li.keyword}}, {types:["attr-value"], style:{color:li.string}}, {types:["comment", "block-comment", "prolog", "doctype", "cdata", "shebang"], style:{color:li.comment}}, {types:["property", "number", "function-name", "constant", "symbol", "deleted"], style:{color:li.primitive}}, {types:["boolean"], style:{color:li.boolean}}, {types:["tag"], style:{color:li.tag}}, 
{types:["string"], style:{color:li.string}}, {types:["punctuation"], style:{color:li.string}}, {types:["selector", "char", "builtin", "inserted"], style:{color:li.char}}, {types:["function"], style:{color:li.function}}, {types:["operator", "entity", "url", "variable"], style:{color:li.variable}}, {types:["keyword"], style:{color:li.keyword}}, {types:["atrule", "class-name"], style:{color:li.className}}, {types:["important"], style:{fontWeight:"400"}}, {types:["bold"], style:{fontWeight:"bold"}}, 
{types:["italic"], style:{fontStyle:"italic"}}, {types:["namespace"], style:{opacity:0.7}}]}, EU = kU, TU = {plain:{color:"#f8f8f2", backgroundColor:"#272822"}, styles:[{types:["changed"], style:{color:"rgb(162, 191, 252)", fontStyle:"italic"}}, {types:["deleted"], style:{color:"#f92672", fontStyle:"italic"}}, {types:["inserted"], style:{color:"rgb(173, 219, 103)", fontStyle:"italic"}}, {types:["comment"], style:{color:"#8292a2", fontStyle:"italic"}}, {types:["string", "url"], style:{color:"#a6e22e"}}, 
{types:["variable"], style:{color:"#f8f8f2"}}, {types:["number"], style:{color:"#ae81ff"}}, {types:["builtin", "char", "constant", "function", "class-name"], style:{color:"#e6db74"}}, {types:["punctuation"], style:{color:"#f8f8f2"}}, {types:["selector", "doctype"], style:{color:"#a6e22e", fontStyle:"italic"}}, {types:["tag", "operator", "keyword"], style:{color:"#66d9ef"}}, {types:["boolean"], style:{color:"#ae81ff"}}, {types:["namespace"], style:{color:"rgb(178, 204, 214)", opacity:0.7}}, {types:["tag", 
"property"], style:{color:"#f92672"}}, {types:["attr-name"], style:{color:"#a6e22e !important"}}, {types:["doctype"], style:{color:"#8292a2"}}, {types:["rule"], style:{color:"#e6db74"}}]}, CU = TU, AU = {plain:{color:"#bfc7d5", backgroundColor:"#292d3e"}, styles:[{types:["comment"], style:{color:"rgb(105, 112, 152)", fontStyle:"italic"}}, {types:["string", "inserted"], style:{color:"rgb(195, 232, 141)"}}, {types:["number"], style:{color:"rgb(247, 140, 108)"}}, {types:["builtin", "char", "constant", 
"function"], style:{color:"rgb(130, 170, 255)"}}, {types:["punctuation", "selector"], style:{color:"rgb(199, 146, 234)"}}, {types:["variable"], style:{color:"rgb(191, 199, 213)"}}, {types:["class-name", "attr-name"], style:{color:"rgb(255, 203, 107)"}}, {types:["tag", "deleted"], style:{color:"rgb(255, 85, 114)"}}, {types:["operator"], style:{color:"rgb(137, 221, 255)"}}, {types:["boolean"], style:{color:"rgb(255, 88, 116)"}}, {types:["keyword"], style:{fontStyle:"italic"}}, {types:["doctype"], style:{color:"rgb(199, 146, 234)", 
fontStyle:"italic"}}, {types:["namespace"], style:{color:"rgb(178, 204, 214)"}}, {types:["url"], style:{color:"rgb(221, 221, 221)"}}]}, NU = AU, IU = {plain:{color:"#9EFEFF", backgroundColor:"#2D2A55"}, styles:[{types:["changed"], style:{color:"rgb(255, 238, 128)"}}, {types:["deleted"], style:{color:"rgba(239, 83, 80, 0.56)"}}, {types:["inserted"], style:{color:"rgb(173, 219, 103)"}}, {types:["comment"], style:{color:"rgb(179, 98, 255)", fontStyle:"italic"}}, {types:["punctuation"], style:{color:"rgb(255, 255, 255)"}}, 
{types:["constant"], style:{color:"rgb(255, 98, 140)"}}, {types:["string", "url"], style:{color:"rgb(165, 255, 144)"}}, {types:["variable"], style:{color:"rgb(255, 238, 128)"}}, {types:["number", "boolean"], style:{color:"rgb(255, 98, 140)"}}, {types:["attr-name"], style:{color:"rgb(255, 180, 84)"}}, {types:["keyword", "operator", "property", "namespace", "tag", "selector", "doctype"], style:{color:"rgb(255, 157, 0)"}}, {types:["builtin", "char", "constant", "function", "class-name"], style:{color:"rgb(250, 208, 0)"}}]}, 
OU = IU, PU = {plain:{backgroundColor:"linear-gradient(to bottom, #2a2139 75%, #34294f)", backgroundImage:"#34294f", color:"#f92aad", textShadow:"0 0 2px #100c0f, 0 0 5px #dc078e33, 0 0 10px #fff3"}, styles:[{types:["comment", "block-comment", "prolog", "doctype", "cdata"], style:{color:"#495495", fontStyle:"italic"}}, {types:["punctuation"], style:{color:"#ccc"}}, {types:["tag", "attr-name", "namespace", "number", "unit", "hexcode", "deleted"], style:{color:"#e2777a"}}, {types:["property", "selector"], 
style:{color:"#72f1b8", textShadow:"0 0 2px #100c0f, 0 0 10px #257c5575, 0 0 35px #21272475"}}, {types:["function-name"], style:{color:"#6196cc"}}, {types:["boolean", "selector-id", "function"], style:{color:"#fdfdfd", textShadow:"0 0 2px #001716, 0 0 3px #03edf975, 0 0 5px #03edf975, 0 0 8px #03edf975"}}, {types:["class-name", "maybe-class-name", "builtin"], style:{color:"#fff5f6", textShadow:"0 0 2px #000, 0 0 10px #fc1f2c75, 0 0 5px #fc1f2c75, 0 0 25px #fc1f2c75"}}, {types:["constant", "symbol"], 
style:{color:"#f92aad", textShadow:"0 0 2px #100c0f, 0 0 5px #dc078e33, 0 0 10px #fff3"}}, {types:["important", "atrule", "keyword", "selector-class"], style:{color:"#f4eee4", textShadow:"0 0 2px #393a33, 0 0 8px #f39f0575, 0 0 2px #f39f0575"}}, {types:["string", "char", "attr-value", "regex", "variable"], style:{color:"#f87c32"}}, {types:["parameter"], style:{fontStyle:"italic"}}, {types:["entity", "url"], style:{color:"#67cdcc"}}, {types:["operator"], style:{color:"ffffffee"}}, {types:["important", 
"bold"], style:{fontWeight:"bold"}}, {types:["italic"], style:{fontStyle:"italic"}}, {types:["entity"], style:{cursor:"help"}}, {types:["inserted"], style:{color:"green"}}]}, RU = PU, DU = {plain:{color:"#282a2e", backgroundColor:"#ffffff"}, styles:[{types:["comment"], style:{color:"rgb(197, 200, 198)"}}, {types:["string", "number", "builtin", "variable"], style:{color:"rgb(150, 152, 150)"}}, {types:["class-name", "function", "tag", "attr-name"], style:{color:"rgb(40, 42, 46)"}}]}, LU = DU, MU = 
{plain:{color:"#9CDCFE", backgroundColor:"#1E1E1E"}, styles:[{types:["prolog"], style:{color:"rgb(0, 0, 128)"}}, {types:["comment"], style:{color:"rgb(106, 153, 85)"}}, {types:["builtin", "changed", "keyword", "interpolation-punctuation"], style:{color:"rgb(86, 156, 214)"}}, {types:["number", "inserted"], style:{color:"rgb(181, 206, 168)"}}, {types:["constant"], style:{color:"rgb(100, 102, 149)"}}, {types:["attr-name", "variable"], style:{color:"rgb(156, 220, 254)"}}, {types:["deleted", "string", 
"attr-value", "template-punctuation"], style:{color:"rgb(206, 145, 120)"}}, {types:["selector"], style:{color:"rgb(215, 186, 125)"}}, {types:["tag"], style:{color:"rgb(78, 201, 176)"}}, {types:["tag"], languages:["markup"], style:{color:"rgb(86, 156, 214)"}}, {types:["punctuation", "operator"], style:{color:"rgb(212, 212, 212)"}}, {types:["punctuation"], languages:["markup"], style:{color:"#808080"}}, {types:["function"], style:{color:"rgb(220, 220, 170)"}}, {types:["class-name"], style:{color:"rgb(78, 201, 176)"}}, 
{types:["char"], style:{color:"rgb(209, 105, 105)"}}]}, SA = MU, BU = {plain:{color:"#000000", backgroundColor:"#ffffff"}, styles:[{types:["comment"], style:{color:"rgb(0, 128, 0)"}}, {types:["builtin"], style:{color:"rgb(0, 112, 193)"}}, {types:["number", "variable", "inserted"], style:{color:"rgb(9, 134, 88)"}}, {types:["operator"], style:{color:"rgb(0, 0, 0)"}}, {types:["constant", "char"], style:{color:"rgb(129, 31, 63)"}}, {types:["tag"], style:{color:"rgb(128, 0, 0)"}}, {types:["attr-name"], 
style:{color:"rgb(255, 0, 0)"}}, {types:["deleted", "string"], style:{color:"rgb(163, 21, 21)"}}, {types:["changed", "punctuation"], style:{color:"rgb(4, 81, 165)"}}, {types:["function", "keyword"], style:{color:"rgb(0, 0, 255)"}}, {types:["class-name"], style:{color:"rgb(38, 127, 153)"}}]}, $U = BU, FU = {plain:{color:"#f8fafc", backgroundColor:"#011627"}, styles:[{types:["prolog"], style:{color:"#000080"}}, {types:["comment"], style:{color:"#6A9955"}}, {types:["builtin", "changed", "keyword", "interpolation-punctuation"], 
style:{color:"#569CD6"}}, {types:["number", "inserted"], style:{color:"#B5CEA8"}}, {types:["constant"], style:{color:"#f8fafc"}}, {types:["attr-name", "variable"], style:{color:"#9CDCFE"}}, {types:["deleted", "string", "attr-value", "template-punctuation"], style:{color:"#cbd5e1"}}, {types:["selector"], style:{color:"#D7BA7D"}}, {types:["tag"], style:{color:"#0ea5e9"}}, {types:["tag"], languages:["markup"], style:{color:"#0ea5e9"}}, {types:["punctuation", "operator"], style:{color:"#D4D4D4"}}, {types:["punctuation"], 
languages:["markup"], style:{color:"#808080"}}, {types:["function"], style:{color:"#7dd3fc"}}, {types:["class-name"], style:{color:"#0ea5e9"}}, {types:["char"], style:{color:"#D16969"}}]}, zU = FU, HU = {plain:{color:"#0f172a", backgroundColor:"#f1f5f9"}, styles:[{types:["prolog"], style:{color:"#000080"}}, {types:["comment"], style:{color:"#6A9955"}}, {types:["builtin", "changed", "keyword", "interpolation-punctuation"], style:{color:"#0c4a6e"}}, {types:["number", "inserted"], style:{color:"#B5CEA8"}}, 
{types:["constant"], style:{color:"#0f172a"}}, {types:["attr-name", "variable"], style:{color:"#0c4a6e"}}, {types:["deleted", "string", "attr-value", "template-punctuation"], style:{color:"#64748b"}}, {types:["selector"], style:{color:"#D7BA7D"}}, {types:["tag"], style:{color:"#0ea5e9"}}, {types:["tag"], languages:["markup"], style:{color:"#0ea5e9"}}, {types:["punctuation", "operator"], style:{color:"#475569"}}, {types:["punctuation"], languages:["markup"], style:{color:"#808080"}}, {types:["function"], 
style:{color:"#0e7490"}}, {types:["class-name"], style:{color:"#0ea5e9"}}, {types:["char"], style:{color:"#D16969"}}]}, UU = HU, WU = {plain:{backgroundColor:"hsl(220, 13%, 18%)", color:"hsl(220, 14%, 71%)", textShadow:"0 1px rgba(0, 0, 0, 0.3)"}, styles:[{types:["comment", "prolog", "cdata"], style:{color:"hsl(220, 10%, 40%)"}}, {types:["doctype", "punctuation", "entity"], style:{color:"hsl(220, 14%, 71%)"}}, {types:["attr-name", "class-name", "maybe-class-name", "boolean", "constant", "number", 
"atrule"], style:{color:"hsl(29, 54%, 61%)"}}, {types:["keyword"], style:{color:"hsl(286, 60%, 67%)"}}, {types:["property", "tag", "symbol", "deleted", "important"], style:{color:"hsl(355, 65%, 65%)"}}, {types:["selector", "string", "char", "builtin", "inserted", "regex", "attr-value"], style:{color:"hsl(95, 38%, 62%)"}}, {types:["variable", "operator", "function"], style:{color:"hsl(207, 82%, 66%)"}}, {types:["url"], style:{color:"hsl(187, 47%, 55%)"}}, {types:["deleted"], style:{textDecorationLine:"line-through"}}, 
{types:["inserted"], style:{textDecorationLine:"underline"}}, {types:["italic"], style:{fontStyle:"italic"}}, {types:["important", "bold"], style:{fontWeight:"bold"}}, {types:["important"], style:{color:"hsl(220, 14%, 71%)"}}]}, jU = WU, VU = {plain:{backgroundColor:"hsl(230, 1%, 98%)", color:"hsl(230, 8%, 24%)"}, styles:[{types:["comment", "prolog", "cdata"], style:{color:"hsl(230, 4%, 64%)"}}, {types:["doctype", "punctuation", "entity"], style:{color:"hsl(230, 8%, 24%)"}}, {types:["attr-name", 
"class-name", "boolean", "constant", "number", "atrule"], style:{color:"hsl(35, 99%, 36%)"}}, {types:["keyword"], style:{color:"hsl(301, 63%, 40%)"}}, {types:["property", "tag", "symbol", "deleted", "important"], style:{color:"hsl(5, 74%, 59%)"}}, {types:["selector", "string", "char", "builtin", "inserted", "regex", "attr-value", "punctuation"], style:{color:"hsl(119, 34%, 47%)"}}, {types:["variable", "operator", "function"], style:{color:"hsl(221, 87%, 60%)"}}, {types:["url"], style:{color:"hsl(198, 99%, 37%)"}}, 
{types:["deleted"], style:{textDecorationLine:"line-through"}}, {types:["inserted"], style:{textDecorationLine:"underline"}}, {types:["italic"], style:{fontStyle:"italic"}}, {types:["important", "bold"], style:{fontWeight:"bold"}}, {types:["important"], style:{color:"hsl(230, 8%, 24%)"}}]}, qU = VU, YU = {plain:{color:"#ebdbb2", backgroundColor:"#292828"}, styles:[{types:["imports", "class-name", "maybe-class-name", "constant", "doctype", "builtin", "function"], style:{color:"#d8a657"}}, {types:["property-access"], 
style:{color:"#7daea3"}}, {types:["tag"], style:{color:"#e78a4e"}}, {types:["attr-name", "char", "url", "regex"], style:{color:"#a9b665"}}, {types:["attr-value", "string"], style:{color:"#89b482"}}, {types:["comment", "prolog", "cdata", "operator", "inserted"], style:{color:"#a89984"}}, {types:["delimiter", "boolean", "keyword", "selector", "important", "atrule", "property", "variable", "deleted"], style:{color:"#ea6962"}}, {types:["entity", "number", "symbol"], style:{color:"#d3869b"}}]}, GU = YU, 
QU = {plain:{color:"#654735", backgroundColor:"#f9f5d7"}, styles:[{types:["delimiter", "boolean", "keyword", "selector", "important", "atrule", "property", "variable", "deleted"], style:{color:"#af2528"}}, {types:["imports", "class-name", "maybe-class-name", "constant", "doctype", "builtin"], style:{color:"#b4730e"}}, {types:["string", "attr-value"], style:{color:"#477a5b"}}, {types:["property-access"], style:{color:"#266b79"}}, {types:["function", "attr-name", "char", "url"], style:{color:"#72761e"}}, 
{types:["tag"], style:{color:"#b94c07"}}, {types:["comment", "prolog", "cdata", "operator", "inserted"], style:{color:"#a89984"}}, {types:["entity", "number", "symbol"], style:{color:"#924f79"}}]}, KU = QU, XU = t => (0,require$react.useCallback)(e => {
  var n = e, {className:r, style:i, line:s} = n, o = _A(n, ["className", "style", "line"]);
  const a = Ag(Ps({}, o), {className:xA("token-line", r)});
  return typeof t == "object" && "plain" in t && (a.style = t.plain), typeof i == "object" && (a.style = Ps(Ps({}, a.style || {}), i)), a;
}, [t]), JU = t => {
  const e = (0,require$react.useCallback)(({types:n, empty:r}) => {
    if (t != null) {
      {
        if (n.length === 1 && n[0] === "plain") {
          return r != null ? {display:"inline-block"} : void 0;
        }
        if (n.length === 1 && r != null) {
          return t[n[0]];
        }
      }
      return Object.assign(r != null ? {display:"inline-block"} : {}, ...n.map(i => t[i]));
    }
  }, [t]);
  return (0,require$react.useCallback)(n => {
    var r = n, {token:i, className:s, style:o} = r, a = _A(r, ["token", "className", "style"]);
    const l = Ag(Ps({}, a), {className:xA("token", ...i.types, s), children:i.content, style:e(i)});
    return o != null && (l.style = Ps(Ps({}, l.style || {}), o)), l;
  }, [e]);
}, ZU = /\r\n|\r|\n/, D_ = t => {
  t.length === 0 ? t.push({types:["plain"], content:`
`, empty:!0}) : t.length === 1 && t[0].content === "" && (t[0].content = `
`, t[0].empty = !0);
}, L_ = (t, e) => {
  const n = t.length;
  return n > 0 && t[n - 1] === e ? t : t.concat(e);
}, eW = t => {
  const e = [[]], n = [t], r = [0], i = [t.length];
  let s = 0, o = 0, a = [];
  const l = [a];
  for (; o > -1;) {
    for (; (s = r[o]++) < i[o];) {
      let c, u = e[o];
      const f = n[o][s];
      if (typeof f == "string" ? (u = o > 0 ? u : ["plain"], c = f) : (u = L_(u, f.type), f.alias && (u = L_(u, f.alias)), c = f.content), typeof c != "string") {
        o++, e.push(u), n.push(c), r.push(0), i.push(c.length);
        continue;
      }
      const p = c.split(ZU), g = p.length;
      a.push({types:u, content:p[0]});
      for (let m = 1; m < g; m++) {
        D_(a), l.push(a = []), a.push({types:u, content:p[m]});
      }
    }
    o--, e.pop(), n.pop(), r.pop(), i.pop();
  }
  return D_(a), l;
}, M_ = eW, tW = ({prism:t, code:e, grammar:n, language:r}) => (0,require$react.useMemo)(() => {
  if (n == null) {
    return M_([e]);
  }
  const i = {code:e, grammar:n, language:r, tokens:[]};
  return t.hooks.run("before-tokenize", i), i.tokens = t.tokenize(e, n), t.hooks.run("after-tokenize", i), M_(i.tokens);
}, [e, n, r, t]), nW = (t, e) => {
  const {plain:n} = t, r = t.styles.reduce((i, s) => {
    const {languages:o, style:a} = s;
    return o && !o.includes(e) || s.types.forEach(l => {
      const c = Ps(Ps({}, i[l]), a);
      i[l] = c;
    }), i;
  }, {});
  return r.root = n, r.plain = Ag(Ps({}, n), {backgroundColor:void 0}), r;
}, rW = nW, iW = ({children:t, language:e, code:n, theme:r, prism:i}) => {
  const s = e.toLowerCase(), o = rW(r, s), a = XU(o), l = JU(o), c = i.languages[s], u = tW({prism:i, language:s, code:n, grammar:c});
  return t({tokens:u, className:`prism-code language-${s}`, style:o != null ? o.root : {}, getLineProps:a, getTokenProps:l});
}, sW = t => (0,require$react.createElement)(iW, Ag(Ps({}, t), {prism:t.prism || Ne, theme:t.theme || SA, code:t.code, language:t.language}));
const oW = {monokai:Uu.vsDark, "night-owl":Uu.nightOwl, "proxy-console":Uu.vsDark}, B_ = {".ts":"typescript", ".tsx":"tsx", ".js":"javascript", ".jsx":"jsx", ".mjs":"javascript", ".cjs":"javascript", ".py":"python", ".rs":"rust", ".go":"go", ".clj":"clojure", ".cljs":"clojure", ".cljc":"clojure", ".edn":"clojure", ".java":"java", ".kt":"kotlin", ".swift":"swift", ".scala":"scala", ".rb":"ruby", ".php":"php", ".c":"c", ".cpp":"cpp", ".h":"c", ".hpp":"cpp", ".cs":"csharp", ".html":"markup", ".htm":"markup", 
".css":"css", ".scss":"scss", ".less":"less", ".json":"json", ".yaml":"yaml", ".yml":"yaml", ".toml":"toml", ".xml":"markup", ".sql":"sql", ".sh":"bash", ".bash":"bash", ".zsh":"bash", ".dockerfile":"docker", ".makefile":"makefile", ".md":"markdown", ".mdx":"mdx", ".graphql":"graphql", ".gql":"graphql", ".proto":"protobuf", ".diff":"diff", ".patch":"diff"}, $_ = {node:"javascript", python:"python", python3:"python", bash:"bash", sh:"bash", zsh:"bash", ruby:"ruby", perl:"perl", php:"php"};
function aW(t, e, n) {
  var i;
  if (n) {
    return n;
  }
  if (e) {
    const s = "." + ((i = e.split(".").pop()) == null ? void 0 : i.toLowerCase());
    if (B_[s]) {
      return B_[s];
    }
  }
  const r = t.split(`
`)[0];
  if (r.startsWith("#!")) {
    const s = r.match(/#!\s*(?:\/usr\/bin\/env\s+)?(\w+)/);
    if (s && $_[s[1]]) {
      return $_[s[1]];
    }
  }
  return "text";
}
const lW = {typescript:"typescript", tsx:"tsx", javascript:"javascript", jsx:"jsx", python:"python", rust:"rust", go:"go", clojure:"clojure", java:"java", kotlin:"kotlin", swift:"swift", scala:"scala", ruby:"ruby", php:"php", c:"c", cpp:"cpp", csharp:"csharp", markup:"markup", html:"markup", css:"css", scss:"scss", json:"json", yaml:"yaml", bash:"bash", sql:"sql", graphql:"graphql", markdown:"markdown", diff:"diff"}, cW = ({code:t, language:e, filename:n, theme:r = "dark", lineNumbers:i = !0, highlightLines:s = 
[], startLine:o = 1, maxLines:a, showCopy:l = !0, showLanguage:c = !0, collapsible:u = !1, defaultCollapsed:h = !1, wrap:f = !1, diff:p = "none", onCopy:g, className:m}) => {
  const [b, x] = (0,require$react.useState)(!1), [w, v] = (0,require$react.useState)(h), [T, I] = (0,require$react.useState)(!1), _ = (0,require$react.useMemo)(() => aW(t, n, e), [t, n, e]), N = (0,require$react.useMemo)(() => lW[_] || _, [_]), E = _c(r), C = E.colors, k = (0,require$react.useMemo)(() => oW[E.name] ?? Uu.vsDark, [E.name]), A = (0,require$react.useMemo)(() => t.split(`
`), [t]), P = (0,require$react.useMemo)(() => !a || T ? A : A.slice(0, a), [A, a, T]), W = (0,require$react.useCallback)(async() => {
    try {
      await navigator.clipboard.writeText(t), x(!0), g == null || g(), setTimeout(() => x(!1), 2e3);
    } catch (B) {
      console.error("Failed to copy:", B);
    }
  }, [t, g]), F = (0,require$react.useMemo)(() => p === "add" ? {backgroundColor:C.alpha.blue._15, borderLeft:`3px solid ${C.accent.cyan}`} : p === "remove" ? {backgroundColor:C.alpha.red._15, borderLeft:`3px solid ${C.accent.red}`} : {}, [p, C]);
  return w ? (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:m, "data-component":"code-block", "data-language":_, "data-collapsed":!0, onClick:() => v(!1), style:{background:C.background.elevated, padding:"8px 12px", borderRadius:O.radius.md, cursor:"pointer", display:"flex", alignItems:"center", gap:"8px", fontFamily:O.fontFamily.mono, fontSize:13, color:C.text.muted, ...F}, children:[(0,require$react_SLASH_jsx_runtime.jsx)("span", {children:"\u25b6"}), (0,require$react_SLASH_jsx_runtime.jsx)("span", 
  {children:n || _}), (0,require$react_SLASH_jsx_runtime.jsxs)("span", {style:{marginLeft:"auto", opacity:0.5}, children:[A.length, " lines"]})]}) : (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:m, "data-component":"code-block", "data-language":_, "data-diff":p, style:{background:C.background.elevated, borderRadius:O.radius.md, overflow:"hidden", position:"relative", ...F}, children:[(c || l || u) && (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{display:"flex", alignItems:"center", 
  justifyContent:"space-between", padding:"8px 12px", background:ce(C.text.default, 0.02), borderBottom:`1px solid ${C.border.subtle}`}, children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{display:"flex", alignItems:"center", gap:8}, children:[u && (0,require$react_SLASH_jsx_runtime.jsx)("button", {onClick:() => v(!0), style:{background:"none", border:"none", color:C.text.muted, cursor:"pointer", padding:0, fontSize:12}, children:"\u25bc"}), c && (0,require$react_SLASH_jsx_runtime.jsx)("span", 
  {style:{fontSize:12, color:C.text.muted, textTransform:"uppercase", letterSpacing:"0.5px"}, children:n || _})]}), l && (0,require$react_SLASH_jsx_runtime.jsx)("button", {onClick:W, style:{background:"none", border:"none", color:b ? C.accent.cyan : C.text.muted, cursor:"pointer", fontSize:12, padding:"4px 8px", borderRadius:O.radius.xs, transition:"color 0.2s"}, children:b ? "\u2713 Copied" : "Copy"})]}), (0,require$react_SLASH_jsx_runtime.jsx)(sW, {theme:k, code:P.join(`
`), language:N, children:({className:B, style:z, tokens:j, getLineProps:V, getTokenProps:ne}) => (0,require$react_SLASH_jsx_runtime.jsx)("pre", {className:B, style:{...z, margin:0, padding:O.spacing[4], overflow:"auto", maxHeight:a ? `${a * 20 + 32}px` : void 0, whiteSpace:f ? "pre-wrap" : "pre", wordBreak:f ? "break-all" : void 0, background:"transparent"}, children:j.map((D, ie) => {
    const ee = o + ie, M = s.includes(ee);
    return (0,require$react_SLASH_jsx_runtime.jsxs)("div", {...V({line:D}), style:{display:"flex", backgroundColor:M ? ce(C.accent.cyan, 0.1) : "transparent", borderLeft:M ? `2px solid ${C.accent.cyan}` : "2px solid transparent"}, children:[i && (0,require$react_SLASH_jsx_runtime.jsx)("span", {style:{display:"inline-block", width:40, marginRight:16, textAlign:"right", color:C.text.subtle, userSelect:"none", opacity:0.5}, children:ee}), (0,require$react_SLASH_jsx_runtime.jsx)("span", {style:{flex:1}, 
    children:D.map((X, ge) => (0,require$react_SLASH_jsx_runtime.jsx)("span", {...ne({token:X})}, ge))})]}, ie);
  })})}), a && A.length > a && !T && (0,require$react_SLASH_jsx_runtime.jsxs)("button", {onClick:() => I(!0), style:{width:"100%", padding:"8px", background:ce(C.text.default, 0.02), border:"none", borderTop:`1px solid ${C.border.subtle}`, color:C.text.muted, cursor:"pointer", fontSize:12}, children:["Show ", A.length - a, " more lines"]})]});
}, uW = {1:32, 2:24, 3:20, 4:18, 5:16, 6:14};
function kb(t) {
  return typeof t == "string" || typeof t == "number" ? String(t) : Array.isArray(t) ? t.map(kb).join("") : default$$require$react.default.isValidElement(t) ? kb(t.props.children) : "";
}
function dW(t) {
  return t.trim().toLowerCase().replace(/[^\w\s-]/g, "").replace(/\s+/g, "-");
}
function hW(t) {
  const e = t == null ? void 0 : t.match(/language-([^\s]+)/);
  return e == null ? void 0 : e[1];
}
function xl(t, e, n) {
  return ({children:r, ...i}) => {
    const s = `h${t}`, o = kb(r), a = dW(o);
    return (0,require$react_SLASH_jsx_runtime.jsx)(s, {...i, id:a, style:{marginTop:t === 1 ? 0 : 24, marginBottom:16, fontSize:uW[t], fontWeight:t === 1 ? 700 : 600, color:e.text.default, cursor:n ? "pointer" : void 0}, onClick:n ? () => n(a, o) : void 0, children:r});
  };
}
const mr = ({content:t, variant:e = "default", theme:n = "dark", lineNumbers:r = !0, copyButton:i = !0, linkTarget:s = "_blank", sanitize:o = !0, maxLines:a, onLinkClick:l, onHeadingClick:c, className:u}) => {
  const f = _c(n).colors, p = (0,require$react.useCallback)((b, x) => {
    l && (x.preventDefault(), l(b, x));
  }, [l]), g = (0,require$react.useMemo)(() => o ? [] : [tU], [o]), m = (0,require$react.useMemo)(() => ({h1:xl(1, f, c), h2:xl(2, f, c), h3:xl(3, f, c), h4:xl(4, f, c), h5:xl(5, f, c), h6:xl(6, f, c), p:({children:b, ...x}) => (0,require$react_SLASH_jsx_runtime.jsx)("p", {...x, style:{marginTop:0, marginBottom:16, lineHeight:1.7, color:f.text.default}, children:b}), a:({href:b, children:x, ...w}) => (0,require$react_SLASH_jsx_runtime.jsx)("a", {...w, href:b, style:{color:f.accent.cyan, textDecoration:"none"}, 
  target:s, rel:s === "_blank" ? "noopener noreferrer" : void 0, onClick:b && l ? v => p(b, v) : void 0, children:x}), code:({className:b, children:x, ...w}) => (0,require$react_SLASH_jsx_runtime.jsx)("code", {...w, className:b, style:{background:ce(f.text.default, 0.05), padding:"2px 6px", borderRadius:O.radius.xs, fontFamily:O.fontFamily.mono, fontSize:"0.9em"}, children:x}), pre:({children:b}) => {
    if (default$$require$react.default.isValidElement(b)) {
      const x = String(b.props.children ?? "").replace(/\n$/, "");
      return (0,require$react_SLASH_jsx_runtime.jsx)(cW, {code:x, language:hW(b.props.className), lineNumbers:r, showCopy:i, maxLines:a, theme:n, showLanguage:!0});
    }
    return (0,require$react_SLASH_jsx_runtime.jsx)("pre", {children:b});
  }, blockquote:({children:b, ...x}) => (0,require$react_SLASH_jsx_runtime.jsx)("blockquote", {...x, style:{margin:"16px 0", padding:"8px 16px", borderLeft:`4px solid ${f.accent.cyan}`, background:ce(f.accent.cyan, 0.05), color:f.text.muted}, children:b}), ul:({children:b, ...x}) => (0,require$react_SLASH_jsx_runtime.jsx)("ul", {...x, style:{marginTop:0, marginBottom:16, paddingLeft:24, lineHeight:1.7, color:f.text.default}, children:b}), ol:({children:b, ...x}) => (0,require$react_SLASH_jsx_runtime.jsx)("ol", 
  {...x, style:{marginTop:0, marginBottom:16, paddingLeft:24, lineHeight:1.7, color:f.text.default}, children:b}), li:({children:b, ...x}) => (0,require$react_SLASH_jsx_runtime.jsx)("li", {...x, style:{marginBottom:4}, children:b}), hr:b => (0,require$react_SLASH_jsx_runtime.jsx)("hr", {...b, style:{border:"none", height:1, background:f.border.default, margin:"24px 0"}}), img:({src:b, alt:x, ...w}) => (0,require$react_SLASH_jsx_runtime.jsx)("img", {...w, src:b || "", alt:x || "", style:{maxWidth:"100%", 
  height:"auto", borderRadius:O.radius.md}}), table:({children:b, ...x}) => (0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{overflowX:"auto", margin:"16px 0"}, children:(0,require$react_SLASH_jsx_runtime.jsx)("table", {...x, style:{width:"100%", borderCollapse:"collapse", fontSize:e === "compact" ? 13 : 14}, children:b})}), th:({children:b, ...x}) => (0,require$react_SLASH_jsx_runtime.jsx)("th", {...x, style:{padding:"8px 12px", textAlign:"left", borderBottom:`2px solid ${f.border.default}`, 
  color:f.text.default, fontWeight:600}, children:b}), td:({children:b, ...x}) => (0,require$react_SLASH_jsx_runtime.jsx)("td", {...x, style:{padding:"8px 12px", borderBottom:`1px solid ${f.border.subtle}`, color:f.text.default}, children:b})}), [i, p, r, s, a, c, l, n, f, e]);
  return (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:u, "data-component":"markdown", "data-variant":e, role:"article", "aria-label":"Markdown content", style:{fontFamily:"inherit", fontSize:e === "compact" ? 13 : 14, lineHeight:1.6, maxWidth:e === "full" ? "100%" : "65ch"}, children:(0,require$react_SLASH_jsx_runtime.jsx)(Mu, {remarkPlugins:[Wz], rehypePlugins:g, skipHtml:o, components:m, children:t})});
};
function fW(t) {
  return typeof t == "number" ? `${t}px` : t ?? "8px 12px";
}
function pW({items:t, className:e, background:n = O.colors.background.surface, borderColor:r = O.colors.border.subtle, textColor:i = O.colors.text.default, padding:s, gap:o = 4, wrap:a = !0}) {
  return (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:e, "data-component":"editor-toolbar", style:{display:"flex", alignItems:"center", gap:o, padding:fW(s), background:n, borderBottom:`1px solid ${r}`, flexWrap:a ? "wrap" : "nowrap"}, children:t.map((l, c) => {
    if (l.type === "divider") {
      return (0,require$react_SLASH_jsx_runtime.jsx)("div", {"data-testid":l.testId, style:{width:1, height:20, background:r, margin:"0 4px"}}, l.key ?? `divider-${c}`);
    }
    const u = l.ariaLabel ?? (typeof l.label == "string" ? l.label : void 0) ?? l.title ?? l.key ?? "Toolbar action";
    return (0,require$react_SLASH_jsx_runtime.jsx)("button", {type:"button", "data-testid":l.testId, "aria-label":u, onClick:l.onClick, disabled:l.disabled, title:l.title, style:{background:"none", border:"none", padding:"4px 8px", borderRadius:4, color:i, cursor:l.disabled ? "not-allowed" : "pointer", fontFamily:"inherit", fontSize:13, opacity:l.disabled ? 0.5 : 1, ...l.buttonStyle}, children:l.label}, l.key ?? `button-${c}`);
  })});
}
function gW(t) {
  return typeof t == "number" ? `${t}px` : t ?? "4px 12px";
}
function mW({items:t, className:e, background:n = O.colors.background.surface, borderColor:r = O.colors.border.subtle, textColor:i = O.colors.text.muted, padding:s, gap:o = 16}) {
  const a = t.findIndex(l => l.align === "end");
  return (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:e, "data-component":"editor-status-bar", style:{display:"flex", alignItems:"center", gap:o, padding:gW(s), background:n, borderTop:`1px solid ${r}`, fontSize:12, color:i}, children:t.map((l, c) => {
    const u = c === a;
    return (0,require$react_SLASH_jsx_runtime.jsx)("span", {"data-testid":l.testId, style:u ? {marginLeft:"auto"} : void 0, children:l.label}, l.key ?? `status-${c}`);
  })});
}
O.colors.background.surface, `${O.colors.border.default}`, `${O.colors.border.default}`, O.colors.background.elevated, O.shadow.md, O.colors.background.elevated, O.shadow.md;
O.fontFamily.sans;
`${O.colors.border.default}`;
const bW = 50 * 1024 * 1024, yW = {"image/*":[".png", ".jpg", ".jpeg", ".gif", ".webp", ".svg"], "audio/*":[".mp3", ".wav", ".ogg", ".m4a", ".flac", ".aac"], "video/*":[".mp4", ".webm", ".mov", ".avi", ".mkv"], "application/pdf":[".pdf"], "text/*":[".txt", ".md", ".json", ".csv"]};
function xW(t) {
  return t.type.startsWith("image/") ? "image" : t.type.startsWith("audio/") ? "audio" : t.type.startsWith("video/") ? "video" : "document";
}
function F_() {
  return `${Date.now()}-${Math.random().toString(36).slice(2, 11)}`;
}
async function vW(t, e) {
  if (e === "image") {
    return new Promise(n => {
      const r = new FileReader();
      r.onload = () => n(r.result), r.onerror = () => n(void 0), r.readAsDataURL(t);
    });
  }
  if (e === "audio" || e === "video") {
    return URL.createObjectURL(t);
  }
}
function wW({attachments:t, onAttachmentsChange:e, maxSizeBytes:n = bW, accept:r = yW, disabled:i = !1, hidePreviews:s = !1}) {
  const [o, a] = (0,require$react.useState)(!1), [l, c] = (0,require$react.useState)(0), u = (0,require$react.useRef)(null), h = (0,require$react.useRef)(null), f = (0,require$react.useCallback)(async E => {
    const C = Array.from(E), k = [];
    for (const A of C) {
      const P = xW(A);
      if (A.size > n) {
        k.push({id:F_(), file:A, type:P, error:`File too large (${(A.size / 1024 / 1024).toFixed(1)}MB). Max: ${(n / 1024 / 1024).toFixed(0)}MB`});
        continue;
      }
      const W = await vW(A, P);
      k.push({id:F_(), file:A, preview:W, type:P});
    }
    e([...t, ...k]);
  }, [t, n, e]), p = (0,require$react.useCallback)(E => {
    E.target.files && E.target.files.length > 0 && (f(E.target.files), E.target.value = "");
  }, [f]), g = (0,require$react.useCallback)(E => {
    E.preventDefault(), E.stopPropagation(), c(C => C + 1), a(!0);
  }, []), m = (0,require$react.useCallback)(E => {
    E.preventDefault(), E.stopPropagation(), c(C => {
      const k = C - 1;
      return k === 0 && a(!1), k;
    });
  }, []), b = (0,require$react.useCallback)(E => {
    E.preventDefault(), E.stopPropagation();
  }, []), x = (0,require$react.useCallback)(E => {
    E.preventDefault(), E.stopPropagation(), a(!1), c(0), E.dataTransfer.files && E.dataTransfer.files.length > 0 && f(E.dataTransfer.files);
  }, [f]), w = (0,require$react.useCallback)(async E => {
    var A;
    const C = (A = E.clipboardData) == null ? void 0 : A.items;
    if (!C) {
      return;
    }
    const k = [];
    for (const P of Array.from(C)) {
      if (P.kind === "file") {
        const W = P.getAsFile();
        W && k.push(W);
      }
    }
    k.length > 0 && await f(k);
  }, [f]);
  (0,require$react.useState)(() => {
    if (typeof window < "u") {
      return window.addEventListener("paste", w), () => window.removeEventListener("paste", w);
    }
  });
  const v = (0,require$react.useCallback)(E => {
    const C = t.find(k => k.id === E);
    C != null && C.preview && (C.type === "audio" || C.type === "video") && URL.revokeObjectURL(C.preview), e(t.filter(k => k.id !== E));
  }, [t, e]), T = (0,require$react.useCallback)(() => {
    var E;
    (E = u.current) == null || E.click();
  }, []), I = E => E < 1024 ? `${E}B` : E < 1024 * 1024 ? `${(E / 1024).toFixed(1)}KB` : `${(E / 1024 / 1024).toFixed(1)}MB`, _ = {image:"var(--token-colors-alpha-green-_30)", audio:"var(--token-colors-alpha-purple-_30)", video:"var(--token-colors-alpha-blue-_30)", document:"var(--token-colors-alpha-orange-_30)"}, N = {image:"\ud83d\uddbc\ufe0f", audio:"\ud83c\udfb5", video:"\ud83c\udfac", document:"\ud83d\udcc4"};
  return (0,require$react_SLASH_jsx_runtime.jsxs)("div", {ref:h, onDragEnter:g, onDragLeave:m, onDragOver:b, onDrop:x, style:{position:"relative"}, children:[(0,require$react_SLASH_jsx_runtime.jsx)("input", {ref:u, type:"file", multiple:!0, accept:Object.entries(r).flatMap(([E, C]) => C).join(","), onChange:p, style:{display:"none"}, disabled:i}), o && (0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{position:"absolute", inset:0, background:"rgba(0, 150, 255, 0.1)", border:"2px dashed var(--token-colors-alpha-blue-_50)", 
  borderRadius:8, display:"flex", alignItems:"center", justifyContent:"center", zIndex:10, pointerEvents:"none"}, children:(0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{fontSize:16, fontWeight:600, color:"var(--token-colors-text-default)"}, children:"Drop files here"})}), (0,require$react_SLASH_jsx_runtime.jsx)(Ke, {variant:"ghost", size:"sm", onClick:T, disabled:i, title:"Attach files (images, audio, video, documents)", children:"\ud83d\udcce"}), !s && t.length > 0 && (0,require$react_SLASH_jsx_runtime.jsx)("div", 
  {style:{display:"flex", flexWrap:"wrap", gap:8, marginTop:8, padding:8, background:"var(--token-colors-background-elevated)", borderRadius:8}, children:t.map(E => (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{position:"relative", border:`1px solid ${_[E.type]}`, borderRadius:8, overflow:"hidden", background:"var(--token-colors-background-surface)"}, children:[E.type === "image" && E.preview && (0,require$react_SLASH_jsx_runtime.jsx)("img", {src:E.preview, alt:E.file.name, style:{width:100, 
  height:100, objectFit:"cover", display:"block"}}), E.type === "audio" && (0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{width:200, height:60, display:"flex", alignItems:"center", justifyContent:"center", background:"var(--token-colors-background-canvas)"}, children:(0,require$react_SLASH_jsx_runtime.jsx)("audio", {src:E.preview, controls:!0, style:{width:"100%", height:40}})}), E.type === "video" && (0,require$react_SLASH_jsx_runtime.jsx)("video", {src:E.preview, controls:!0, style:{width:160, 
  height:100, display:"block"}}), E.type === "document" && (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{width:100, height:100, display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", padding:8}, children:[(0,require$react_SLASH_jsx_runtime.jsx)("span", {style:{fontSize:24}, children:N[E.type]}), (0,require$react_SLASH_jsx_runtime.jsx)("span", {style:{fontSize:10, textAlign:"center", wordBreak:"break-all", marginTop:4, color:"var(--token-colors-text-muted)"}, 
  children:E.file.name.slice(0, 20)})]}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{position:"absolute", bottom:0, left:0, right:0, background:"rgba(0,0,0,0.7)", padding:"2px 4px", fontSize:9, color:"white", display:"flex", justifyContent:"space-between", alignItems:"center"}, children:[(0,require$react_SLASH_jsx_runtime.jsx)("span", {style:{overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap"}, children:I(E.file.size)}), (0,require$react_SLASH_jsx_runtime.jsx)(ct, {size:"sm", 
  variant:"default", children:E.type})]}), (0,require$react_SLASH_jsx_runtime.jsx)("button", {type:"button", onClick:() => v(E.id), style:{position:"absolute", top:2, right:2, width:20, height:20, borderRadius:"50%", border:"none", background:"rgba(0,0,0,0.7)", color:"white", cursor:"pointer", fontSize:12, display:"flex", alignItems:"center", justifyContent:"center"}, title:"Remove", children:"\u00d7"}), E.error && (0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{position:"absolute", inset:0, 
  background:"rgba(255,0,0,0.2)", display:"flex", alignItems:"center", justifyContent:"center", padding:4}, children:(0,require$react_SLASH_jsx_runtime.jsx)("span", {style:{fontSize:10, color:"var(--token-colors-status-eating)", textAlign:"center"}, children:E.error})}), E.uploading && (0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{position:"absolute", inset:0, background:"rgba(0,0,0,0.5)", display:"flex", alignItems:"center", justifyContent:"center"}, children:(0,require$react_SLASH_jsx_runtime.jsx)("span", 
  {style:{fontSize:12, color:"white"}, children:"Uploading..."})})]}, E.id))})]});
}
const _W = {}, so = _W, us = (so == null ? void 0 : so.VITE_API_BASE) ?? "", up = "knoxx_user_email", dp = "knoxx_org_slug";
var pT;
const kA = ((pT = so == null ? void 0 : so.VITE_KNOXX_DEV_USER_EMAIL) == null ? void 0 : pT.trim()) ?? "";
var gT;
const EA = ((gT = so == null ? void 0 : so.VITE_KNOXX_DEV_ORG_SLUG) == null ? void 0 : gT.trim()) ?? "";
function hp(t) {
  var e;
  if (typeof window > "u") {
    return null;
  }
  try {
    const n = (e = localStorage.getItem(t)) == null ? void 0 : e.trim();
    return n || null;
  } catch {
    return null;
  }
}
function TA() {
  return {userEmail:hp(up) ?? kA, orgSlug:hp(dp) ?? EA};
}
function CA(t) {
  const e = {userEmail:t.userEmail.trim(), orgSlug:t.orgSlug.trim()};
  if (typeof window < "u") {
    try {
      e.userEmail ? localStorage.setItem(up, e.userEmail) : localStorage.removeItem(up), e.orgSlug ? localStorage.setItem(dp, e.orgSlug) : localStorage.removeItem(dp);
    } catch {
    }
  }
  return e;
}
function Xn(t) {
  const e = new Headers(t || {}), n = hp(up) ?? kA, r = hp(dp) ?? EA;
  return n && !e.has("x-knoxx-user-email") && e.set("x-knoxx-user-email", n), r && !e.has("x-knoxx-org-slug") && e.set("x-knoxx-org-slug", r), e;
}
function SW(t) {
  if (!t || typeof t != "object") {
    return null;
  }
  const e = t, n = [typeof e.error == "string" ? e.error : null, typeof e.detail == "string" ? e.detail : null, typeof e.message == "string" ? e.message : null, typeof e.error_code == "string" ? `code=${e.error_code}` : null, typeof e.model_error == "string" ? e.model_error : null].filter(Boolean);
  return n.length > 0 ? n.join(" | ") : null;
}
async function Ie(t, e) {
  let n;
  try {
    const r = (e == null ? void 0 : e.body) != null;
    n = await fetch(`${us}${t}`, {credentials:"include", headers:{...Object.fromEntries(Xn({...(r ? {"Content-Type":"application/json"} : {}), ...((e == null ? void 0 : e.headers) ?? {})}).entries())}, ...e});
  } catch (r) {
    const i = r instanceof Error ? r.message : String(r);
    throw new Error(`Request to ${t} failed before the server responded. This usually means the reverse proxy or upstream service reset the connection. ${i}`);
  }
  if (!n.ok) {
    const r = await n.text();
    let i = r;
    try {
      i = SW(JSON.parse(r)) ?? r;
    } catch {
    }
    throw new Error(`${n.status} ${n.statusText}${i ? ` - ${i}` : ""}`);
  }
  return await n.json();
}
function Js(t) {
  return typeof t == "object" && t !== null;
}
function zn(t) {
  return typeof t == "string" ? t : void 0;
}
function kW(t) {
  return typeof t == "number" && Number.isFinite(t) ? t : void 0;
}
function fi(t, e) {
  for (const n of e) {
    if (t[n] !== void 0) {
      return t[n];
    }
  }
}
function EW(t) {
  var m;
  if (typeof t == "string") {
    return {type:"text", text:t};
  }
  if (!Js(t)) {
    return null;
  }
  const e = (m = zn(fi(t, ["type", "partType", "part_type", "part-type"]))) == null ? void 0 : m.toLowerCase(), n = zn(fi(t, ["filename", "fileName", "file_name", "file-name", "name"])), r = kW(fi(t, ["size", "bytes", "byteSize", "byte_size", "byte-size"])), i = fi(t, ["image_url", "imageUrl"]), s = fi(t, ["video_url", "videoUrl"]), o = fi(t, ["audio_url", "audioUrl"]), a = Js(t.source) ? t.source : null, l = Js(t.input_audio) ? t.input_audio : null, c = Js(t.output_audio) ? t.output_audio : null, 
  u = zn(fi(t, ["url", "file_url", "fileUrl"])) ?? (Js(i) ? zn(i.url) : zn(i)) ?? (Js(s) ? zn(s.url) : zn(s)) ?? (Js(o) ? zn(o.url) : zn(o)) ?? (a && typeof a.type == "string" && a.type.toLowerCase() === "url" ? zn(a.url) : void 0), h = zn(fi(t, ["data", "b64_json", "result"])) ?? zn(l == null ? void 0 : l.data) ?? zn(c == null ? void 0 : c.data) ?? (a && typeof a.type == "string" && a.type.toLowerCase() === "base64" ? zn(a.data) : void 0), f = zn(fi(t, ["mimeType", "mime_type", "mime-type", "mediaType", 
  "media_type", "media-type"])) ?? zn(a == null ? void 0 : a.media_type) ?? zn(a == null ? void 0 : a.mime_type) ?? (typeof(l == null ? void 0 : l.format) == "string" ? `audio/${l.format}` : void 0) ?? (typeof(c == null ? void 0 : c.format) == "string" ? `audio/${c.format}` : void 0), p = (() => {
    if (!e && typeof f == "string") {
      return f.startsWith("image/") ? "image" : f.startsWith("audio/") ? "audio" : f.startsWith("video/") ? "video" : "document";
    }
    switch(e) {
      case "text":
      case "input_text":
      case "output_text":
      case "refusal":
      case "summary_text":
        return "text";
      case "image":
      case "image_url":
      case "input_image":
      case "output_image":
        return "image";
      case "audio":
      case "audio_url":
      case "input_audio":
      case "output_audio":
        return "audio";
      case "video":
      case "video_url":
      case "input_video":
      case "output_video":
        return "video";
      case "document":
      case "file":
      case "input_file":
      case "output_file":
        return "document";
      default:
        return null;
    }
  })();
  if (p === "text") {
    const b = zn(fi(t, ["text", "refusal", "content"]));
    return b !== void 0 ? {type:p, text:b, filename:n, size:r} : null;
  }
  if (!p) {
    return null;
  }
  const g = h ? h.startsWith("data:") ? h : f ? `data:${f};base64,${h}` : h : void 0;
  return !u && !g ? null : {type:p, url:u, data:g, mimeType:f, filename:n, size:r};
}
function Vx(t) {
  return Array.isArray(t) ? t.map(n => EW(n)).filter(n => n !== null).filter(n => n.type !== "text") : void 0;
}
function TW(...t) {
  const e = [], n = new Set();
  for (const r of t) {
    if (Array.isArray(r)) {
      for (const i of r) {
        const s = JSON.stringify([i.type, i.url ?? null, i.data ?? null, i.mimeType ?? null, i.filename ?? null, i.size ?? null]);
        n.has(s) || (n.add(s), e.push(i));
      }
    }
  }
  return e.length > 0 ? e : void 0;
}
function CW(t) {
  return Array.isArray(t) ? t.filter(Js).map(e => ({role:zn(e.role) ?? "user", content:zn(e.content) ?? "", contentParts:Vx(fi(e, ["contentParts", "content_parts", "content-parts"]))})) : [];
}
function AW(t) {
  return Js(t) ? {...t, id:zn(t.id) ?? "tool-receipt", contentParts:Vx(fi(t, ["contentParts", "content_parts", "content-parts"]))} : null;
}
function NW(t) {
  const e = Array.isArray(t.tool_receipts) ? t.tool_receipts.map(r => AW(r)).filter(r => r !== null) : [], n = e.filter(r => r.tool_name === "workspace_media.attach").flatMap(r => r.contentParts ?? []);
  return {...t, answer:typeof t.answer == "string" ? t.answer : null, contentParts:TW(Vx(fi(t, ["contentParts", "content_parts", "content-parts"])), n), request_messages:CW(t.request_messages), events:Array.isArray(t.events) ? t.events : [], trace_blocks:Array.isArray(t.trace_blocks) ? t.trace_blocks : [], tool_receipts:e, sources:Array.isArray(t.sources) ? t.sources : []};
}
async function IW() {
  return (await Ie("/api/models")).models;
}
async function OW(t) {
  return Ie("/api/chat", {method:"POST", body:JSON.stringify(t)});
}
async function PW(t = 100) {
  return (await Ie(`/api/runs?limit=${t}`)).runs;
}
async function hd(t) {
  const e = await Ie(`/api/runs/${t}`);
  return NW(e);
}
async function Eb(t = 25) {
  return (await Ie(`/api/knoxx/agents/active?limit=${t}`)).runs;
}
async function AA(t = 200) {
  return (await Ie(`/api/admin/agents/active?limit=${t}`)).runs;
}
async function NA(t) {
  return Ie("/api/admin/agents/abort", {method:"POST", body:JSON.stringify(t)});
}
async function Ua(t = {}) {
  const e = new URLSearchParams();
  return e.set("limit", String(t.limit ?? 12)), typeof t.offset == "number" && t.offset > 0 && e.set("offset", String(t.offset)), t.actorId && e.set("actorId", t.actorId), t.excludeActorIds && t.excludeActorIds.length > 0 && e.set("excludeActorIds", t.excludeActorIds.join(",")), t.contractId && e.set("contractId", t.contractId), Ie(`/api/memory/sessions?${e.toString()}`);
}
async function IA(t) {
  return Ie(`/api/memory/sessions/${encodeURIComponent(t)}`);
}
async function RW(t = {}) {
  const e = new URLSearchParams();
  return e.set("project", "knoxx-session"), e.set("limit", String(t.limit ?? 50)), typeof t.offset == "number" && t.offset > 0 && e.set("offset", String(t.offset)), Ie(`/api/openplanner/v1/sessions?${e.toString()}`);
}
async function qx(t) {
  return Ie(`/api/openplanner/v1/sessions/${encodeURIComponent(t)}?project=knoxx-session&mode=full`);
}
async function Yx(t) {
  return Ie("/api/memory/search", {method:"POST", body:JSON.stringify(t)});
}
async function DW() {
  return (await Ie("/api/lounge/messages")).messages;
}
async function LW(t) {
  return Ie("/api/lounge/messages", {method:"POST", body:JSON.stringify(t)});
}
async function OA() {
  return Ie("/api/config");
}
async function PA() {
  return Ie("/api/auth/context");
}
async function MW(t) {
  return Ie("/api/query/answer", {method:"POST", body:JSON.stringify(t)});
}
async function BW(t) {
  const e = new URLSearchParams({project:t.project});
  return t.status && t.status !== "all" && e.set("status", t.status), t.target_lang && e.set("target_lang", t.target_lang), t.source_lang && e.set("source_lang", t.source_lang), t.domain && e.set("domain", t.domain), typeof t.limit == "number" && e.set("limit", String(t.limit)), typeof t.offset == "number" && e.set("offset", String(t.offset)), Ie(`/api/translations/segments?${e.toString()}`);
}
async function $W(t) {
  return Ie(`/api/translations/segments/${encodeURIComponent(t)}`);
}
async function FW(t, e) {
  return Ie(`/api/translations/segments/${encodeURIComponent(t)}/labels`, {method:"POST", body:JSON.stringify(e)});
}
async function zW(t) {
  return Ie(`/api/translations/export/manifest?project=${encodeURIComponent(t)}`);
}
async function HW(t) {
  const e = new URLSearchParams({project:t.project});
  t.targetLang && e.set("target_lang", t.targetLang), typeof t.includeCorrected == "boolean" && e.set("include_corrected", String(t.includeCorrected));
  const n = await fetch(`/api/translations/export/sft?${e.toString()}`, {headers:Xn()});
  if (!n.ok) {
    throw new Error(await n.text() || `Failed to export SFT: ${n.status}`);
  }
  return n.text();
}
async function UW(t) {
  const e = new URLSearchParams({project:t.project});
  return t.target_lang && e.set("target_lang", t.target_lang), t.source_lang && e.set("source_lang", t.source_lang), t.garden_id && e.set("garden_id", t.garden_id), Ie(`/api/translations/documents?${e.toString()}`);
}
async function WW(t, e) {
  return Ie(`/api/translations/documents/${encodeURIComponent(t)}/${encodeURIComponent(e)}`);
}
async function jW(t, e, n) {
  return Ie(`/api/translations/documents/${encodeURIComponent(t)}/${encodeURIComponent(e)}/review`, {method:"POST", body:JSON.stringify(n)});
}
async function VW(t) {
  const e = new URLSearchParams();
  t != null && t.status && e.set("status", t.status), t != null && t.garden_id && e.set("garden_id", t.garden_id), t != null && t.target_lang && e.set("target_lang", t.target_lang);
  const n = e.toString();
  return Ie(`/api/translations/batches${n ? `?${n}` : ""}`);
}
async function qW(t) {
  return Ie("/api/translations/batches", {method:"POST", body:JSON.stringify(t)});
}
function _n(t) {
  return t != null && typeof t == "object" && !Array.isArray(t) ? t : {};
}
function cn(t, ...e) {
  for (const n of e) {
    if (Object.prototype.hasOwnProperty.call(t, n)) {
      return t[n];
    }
  }
}
function Ht(t, e, n = "") {
  const r = cn(t, ...e);
  return typeof r == "string" ? r : n;
}
function rr(t, e) {
  const n = cn(t, ...e);
  return typeof n == "string" ? n : void 0;
}
function Gx(t, e) {
  const n = cn(t, ...e);
  return n === null ? null : typeof n == "string" ? n : void 0;
}
function fp(t, e) {
  const n = cn(t, ...e);
  return typeof n == "boolean" ? n : void 0;
}
function Rm(t, e) {
  const n = cn(t, ...e);
  return typeof n == "number" ? n : void 0;
}
function RA(t) {
  return Array.isArray(t) ? t.filter(e => typeof e == "string") : [];
}
function co(t) {
  return Array.isArray(t) ? t.map(_n) : [];
}
function Qx(t, e) {
  const n = cn(t, ...e), r = _n(n);
  return Object.keys(r).length > 0 ? r : void 0;
}
function YW(t) {
  return t.split(".")[0] || "misc";
}
function GW(t) {
  const e = t.split(".");
  return e[e.length - 1] || "read";
}
function QW(t) {
  const e = _n(t), n = Ht(e, ["code"]);
  return {id:Ht(e, ["id"], n), code:n, resourceKind:Ht(e, ["resourceKind", "resource-kind", "resource_kind"], YW(n)), action:Ht(e, ["action"], GW(n)), description:Ht(e, ["description"], n)};
}
function KW(t) {
  const e = _n(t), n = Ht(e, ["id"]);
  return {id:n, label:Ht(e, ["label"], n), description:Ht(e, ["description"]), riskLevel:Ht(e, ["riskLevel", "risk-level", "risk_level"], "standard")};
}
function XW(t) {
  const e = _n(t), n = Ht(e, ["toolId", "tool-id", "tool_id"]), r = cn(e, "effect");
  if (!n || r !== "allow" && r !== "deny") {
    return null;
  }
  const i = Qx(e, ["constraints"]);
  return i ? {toolId:n, effect:r, constraints:i} : {toolId:n, effect:r};
}
function DA(t) {
  return Array.isArray(t) ? t.map(XW).filter(e => e !== null) : [];
}
function LA(t) {
  const e = _n(t);
  return {id:Ht(e, ["id"]), slug:Ht(e, ["slug"]), name:Ht(e, ["name"]), kind:Ht(e, ["kind"], "customer"), isPrimary:fp(e, ["isPrimary", "is-primary", "is_primary"]) ?? !1, status:Ht(e, ["status"], "active"), memberCount:Rm(e, ["memberCount", "member-count", "member_count"]), roleCount:Rm(e, ["roleCount", "role-count", "role_count"]), dataLakeCount:Rm(e, ["dataLakeCount", "data-lake-count", "data_lake_count"]), createdAt:rr(e, ["createdAt", "created-at", "created_at"]), updatedAt:rr(e, ["updatedAt", 
  "updated-at", "updated_at"])};
}
function Ng(t) {
  const e = _n(t);
  return {id:Ht(e, ["id"]), slug:Ht(e, ["slug"]), name:Ht(e, ["name"]), scopeKind:rr(e, ["scopeKind", "scope-kind", "scope_kind"]), orgId:Gx(e, ["orgId", "org-id", "org_id"]), builtIn:fp(e, ["builtIn", "built-in", "built_in"]), systemManaged:fp(e, ["systemManaged", "system-managed", "system_managed"]), createdAt:rr(e, ["createdAt", "created-at", "created_at"]), updatedAt:rr(e, ["updatedAt", "updated-at", "updated_at"]), permissions:RA(cn(e, "permissions")), toolPolicies:DA(cn(e, "toolPolicies", "tool-policies", 
  "tool_policies"))};
}
function Kx(t) {
  const e = _n(t);
  return {id:Ht(e, ["id"]), userId:rr(e, ["userId"]), orgId:Ht(e, ["orgId"]), actorId:rr(e, ["actorId"]), orgName:rr(e, ["orgName"]), orgSlug:rr(e, ["orgSlug"]), status:Ht(e, ["status"], "active"), isDefault:fp(e, ["isDefault"]), createdAt:rr(e, ["createdAt"]), updatedAt:rr(e, ["updatedAt"]), roles:co(cn(e, "roles")).map(Ng), toolPolicies:DA(cn(e, "toolPolicies"))};
}
function JW(t) {
  const e = _n(t), n = Qx(e, ["secretJson"]);
  return {id:Ht(e, ["id"]), provider:Ht(e, ["provider"]), label:rr(e, ["label"]), kind:Ht(e, ["kind"], "credential"), accountIdentifier:Gx(e, ["accountIdentifier"]), status:Ht(e, ["status"], "active"), configuredFields:RA(cn(e, "configuredFields")), secretJson:n ? Object.fromEntries(Object.entries(n).map(([r, i]) => [r, String(i ?? "")])) : void 0, createdAt:rr(e, ["createdAt"]), updatedAt:rr(e, ["updatedAt"])};
}
function Xx(t) {
  const e = _n(t);
  return {id:Ht(e, ["id"]), email:Ht(e, ["email"]), displayName:Ht(e, ["displayName"], Ht(e, ["email"])), authProvider:rr(e, ["authProvider"]), externalSubject:Gx(e, ["externalSubject"]), status:Ht(e, ["status"], "active"), createdAt:rr(e, ["createdAt"]), updatedAt:rr(e, ["updatedAt"]), credentials:co(cn(e, "credentials")).map(JW), memberships:co(cn(e, "memberships")).map(Kx)};
}
function MA(t) {
  const e = _n(t);
  return {id:Ht(e, ["id"]), orgId:Ht(e, ["orgId", "org-id", "org_id"]), name:Ht(e, ["name"]), slug:Ht(e, ["slug"]), kind:Ht(e, ["kind"], "workspace_docs"), config:Qx(e, ["config"]) ?? {}, status:Ht(e, ["status"], "active"), createdAt:rr(e, ["createdAt", "created-at", "created_at"]), updatedAt:rr(e, ["updatedAt", "updated-at", "updated_at"])};
}
async function BA() {
  return Ie("/api/admin/bootstrap");
}
async function $A() {
  const t = _n(await Ie("/api/admin/permissions"));
  return {permissions:co(cn(t, "permissions")).map(QW)};
}
async function FA() {
  const t = _n(await Ie("/api/admin/tools"));
  return {tools:co(cn(t, "tools")).map(KW)};
}
async function zA() {
  const t = _n(await Ie("/api/admin/orgs"));
  return {orgs:co(cn(t, "orgs")).map(LA)};
}
async function HA(t) {
  const e = _n(await Ie("/api/admin/orgs", {method:"POST", body:JSON.stringify(t)}));
  return {org:LA(cn(e, "org"))};
}
async function ZW(t) {
  const e = _n(await Ie(`/api/admin/orgs/${encodeURIComponent(t)}/actors`));
  return {users:co(cn(e, "users")).map(Xx)};
}
async function ej(t, e) {
  const n = _n(await Ie(`/api/admin/orgs/${encodeURIComponent(t)}/actors`, {method:"POST", body:JSON.stringify(e)})), r = cn(n, "user");
  return {user:r == null ? null : Xx(r)};
}
async function tj(t, e) {
  const n = _n(await Ie(`/api/admin/actors/${encodeURIComponent(t)}`, {method:"PATCH", body:JSON.stringify(e)})), r = cn(n, "user");
  return {user:r == null ? null : Xx(r)};
}
async function nj(t, e, n) {
  return Ie(`/api/admin/actors/${encodeURIComponent(t)}/credentials/${encodeURIComponent(e)}`, {method:"PUT", body:JSON.stringify(n)});
}
async function rj(t) {
  const e = _n(await Ie(`/api/admin/orgs/${encodeURIComponent(t)}/roles`));
  return {roles:co(cn(e, "roles")).map(Ng)};
}
async function ij(t, e) {
  const n = _n(await Ie(`/api/admin/orgs/${encodeURIComponent(t)}/roles`, {method:"POST", body:JSON.stringify(e)})), r = cn(n, "role");
  return {role:r == null ? null : Ng(r)};
}
async function sj(t, e) {
  const n = _n(await Ie(`/api/admin/roles/${encodeURIComponent(t)}/tool-policies`, {method:"PATCH", body:JSON.stringify({toolPolicies:e})})), r = cn(n, "role");
  return {role:r == null ? null : Ng(r)};
}
async function oj(t, e) {
  const n = _n(await Ie(`/api/admin/memberships/${encodeURIComponent(t)}/roles`, {method:"PATCH", body:JSON.stringify({roleSlugs:e, replace:!0})})), r = cn(n, "membership");
  return {membership:r == null ? null : Kx(r)};
}
async function aj(t, e) {
  const n = _n(await Ie(`/api/admin/memberships/${encodeURIComponent(t)}/tool-policies`, {method:"PATCH", body:JSON.stringify({toolPolicies:e})})), r = cn(n, "membership");
  return {membership:r == null ? null : Kx(r)};
}
async function lj(t) {
  const e = _n(await Ie(`/api/admin/orgs/${encodeURIComponent(t)}/data-lakes`));
  return {dataLakes:co(cn(e, "dataLakes", "data-lakes", "data_lakes")).map(MA)};
}
async function cj(t, e) {
  const n = _n(await Ie(`/api/admin/orgs/${encodeURIComponent(t)}/data-lakes`, {method:"POST", body:JSON.stringify(e)}));
  return {dataLake:MA(cn(n, "dataLake", "data-lake", "data_lake"))};
}
async function uj() {
  const t = await fetch("http://127.0.0.1:7777/v1/graph/monitoring", {headers:{Authorization:"Bearer change-me"}});
  if (!t.ok) {
    throw new Error(`Graph monitoring request failed: ${t.status}`);
  }
  return t.json();
}
async function dj() {
  return Ie("/api/admin/config/discord");
}
async function hj(t) {
  return Ie("/api/admin/config/discord", {method:"PUT", body:JSON.stringify({discordBotToken:t})});
}
async function UA() {
  return Ie("/api/admin/config/events");
}
async function fj(t) {
  return Ie("/api/admin/config/events", {method:"PUT", body:JSON.stringify(t)});
}
async function pj(t) {
  return Ie(`/api/admin/config/events/jobs/${encodeURIComponent(t)}/run`, {method:"POST"});
}
async function gj(t) {
  return Ie(`/api/admin/triggers/${encodeURIComponent(t)}/fire`, {method:"POST"});
}
async function mj(t) {
  return Ie("/api/admin/config/events/dispatch", {method:"POST", body:JSON.stringify(t)});
}
async function bj() {
  return Ie("/api/admin/config/events/runtime/stop", {method:"POST"});
}
async function yj() {
  return Ie("/api/admin/config/events/runtime/start", {method:"POST"});
}
async function xj() {
  return Ie("/api/admin/config/events/runtime/reset", {method:"POST"});
}
function al(t) {
  return typeof t == "object" && t !== null;
}
function Kt(t) {
  return typeof t == "string" ? t : void 0;
}
function Wa(t) {
  return typeof t == "boolean" ? t : void 0;
}
function Xc(t) {
  return al(t) ? t : {};
}
function WA(t) {
  if (!al(t)) {
    return null;
  }
  const e = Kt(t.id);
  return e ? {id:e, kind:Kt(t.kind) ?? "actor-message", status:Kt(t.status) ?? "pending", source:Xc(t.source), target:Xc(t.target), delivery:Xc(t.delivery), contentRef:Xc(t.contentRef), metadata:Xc(t.metadata), preview:Kt(t.preview), lastError:Kt(t.lastError), createdAt:Kt(t.createdAt), updatedAt:Kt(t.updatedAt), deliveredAt:Kt(t.deliveredAt), acknowledgedAt:Kt(t.acknowledgedAt), expiresAt:Kt(t.expiresAt)} : null;
}
function vj(t, e) {
  const n = al(t) ? t : {}, r = Array.isArray(n.entries) ? n.entries.map(WA).filter(i => i !== null) : [];
  return {ok:Wa(n.ok) ?? !0, box:Kt(n.box) === "outbox" ? "outbox" : Kt(n.box) === "inbox" ? "inbox" : e, actorId:Kt(n.actorId), durable:Wa(n.durable) ?? Wa(n.durable_), entries:r};
}
function Nh(t) {
  if (Array.isArray(t)) {
    return t.filter(e => typeof e == "string");
  }
}
function z_(t, e) {
  if (!al(t)) {
    return typeof e == "string" ? {id:e, label:e, description:"", enabled:!0} : null;
  }
  const n = Kt(t.id) ?? e;
  return n ? {id:n, label:Kt(t.label) ?? n, description:Kt(t.description) ?? "", enabled:Wa(t.enabled) ?? !0} : null;
}
function wj(t) {
  return Array.isArray(t) ? t.map(e => z_(e)).filter(e => e !== null) : al(t) ? Object.entries(t).map(([e, n]) => z_(n, e)).filter(e => e !== null) : [];
}
function _j(t) {
  const e = al(t) ? t : {};
  return {role:Kt(e.role) ?? "", actor_id:Kt(e.actor_id) ?? Kt(e.actorId) ?? null, agent_id:Kt(e.agent_id) ?? Kt(e.agentId) ?? null, agent_label:Kt(e.agent_label) ?? Kt(e.agentLabel) ?? null, agent_trigger_kind:Kt(e.agent_trigger_kind) ?? Kt(e.agentTriggerKind) ?? null, role_slugs:Nh(e.role_slugs) ?? Nh(e.roleSlugs), capability_ids:Nh(e.capability_ids) ?? Nh(e.capabilityIds), system_prompt:Kt(e.system_prompt) ?? Kt(e.systemPrompt) ?? null, actor_system_prompt:Kt(e.actor_system_prompt) ?? Kt(e.actorSystemPrompt) ?? 
  null, agent_system_prompt:Kt(e.agent_system_prompt) ?? Kt(e.agentSystemPrompt) ?? null, task_prompt:Kt(e.task_prompt) ?? Kt(e.taskPrompt) ?? null, tools:wj(e.tools), email_enabled:Wa(e.email_enabled) ?? Wa(e.emailEnabled) ?? !1};
}
function jA(t) {
  return {answer:typeof t.answer == "string" ? t.answer : "", run_id:typeof t.run_id == "string" ? t.run_id : typeof t.runId == "string" ? t.runId : typeof t["run-id"] == "string" ? t["run-id"] : null, conversation_id:typeof t.conversation_id == "string" ? t.conversation_id : typeof t.conversationId == "string" ? t.conversationId : typeof t["conversation-id"] == "string" ? t["conversation-id"] : null, session_id:typeof t.session_id == "string" ? t.session_id : typeof t.sessionId == "string" ? t.sessionId : 
  typeof t["session-id"] == "string" ? t["session-id"] : null, model:typeof t.model == "string" ? t.model : null};
}
async function VA() {
  return (await Ie("/api/proxx/models")).models.sort((e, n) => e.id.localeCompare(n.id));
}
async function qA() {
  return Ie("/api/proxx/health");
}
async function Sj(t) {
  return Ie("/api/proxx/chat", {method:"POST", body:JSON.stringify(t)});
}
async function YA(t, e, n) {
  const r = new URLSearchParams();
  t && r.set("role", t), e && r.set("agent", e), n && r.set("actor", n);
  const i = r.toString(), s = await Ie(`/api/tools/catalog${i ? `?${i}` : ""}`);
  return _j(s);
}
async function Jx(t) {
  const e = new URLSearchParams();
  return t && e.set("actor", t), Ie(`/api/knoxx/agents/catalog${e.toString() ? `?${e.toString()}` : ""}`);
}
async function kj(t, e) {
  const n = new URLSearchParams();
  n.set("box", t), n.set("limit", "100"), e && e !== "all" && n.set("status", e);
  const r = await Ie(`/api/actors/mailbox?${n.toString()}`);
  return vj(r, t);
}
async function Ej(t) {
  const e = await Ie(`/api/actors/mailbox/${encodeURIComponent(t)}/ack`, {method:"POST"}), n = al(e) ? e : {}, r = WA(n.entry);
  return {ok:Wa(n.ok) ?? !0, ...(r ? {entry:r} : {})};
}
async function pp(t, e = "audio.webm") {
  const n = new FormData();
  n.append("file", t, e);
  const r = await fetch(`${us}/api/voice/stt`, {method:"POST", headers:Xn(), body:n});
  if (!r.ok) {
    const i = await r.text();
    throw new Error(`${r.status} ${r.statusText}${i ? ` - ${i}` : ""}`);
  }
  return await r.json();
}
async function Zx(t) {
  const e = await fetch(`${us}/api/voice/tts`, {method:"POST", headers:{...Xn(), "Content-Type":"application/json"}, body:JSON.stringify(t)});
  if (!e.ok) {
    const n = await e.text();
    throw new Error(`${e.status} ${e.statusText}${n ? ` - ${n}` : ""}`);
  }
  return await e.blob();
}
async function GA(t) {
  return Ie("/api/tools/email/send", {method:"POST", body:JSON.stringify(t)});
}
async function Tj(t) {
  return Ie("/api/tools/read", {method:"POST", body:JSON.stringify(t)});
}
async function QA(t) {
  return Ie("/api/tools/write", {method:"POST", body:JSON.stringify(t)});
}
async function Cj(t) {
  return Ie("/api/tools/edit", {method:"POST", body:JSON.stringify(t)});
}
async function Aj(t) {
  return Ie("/api/tools/bash", {method:"POST", body:JSON.stringify(t)});
}
async function Nj() {
  return Ie("/api/knoxx/health");
}
async function Ij(t) {
  const e = t.direct ? "/api/knoxx/direct" : "/api/knoxx/chat";
  return Ie(e, {method:"POST", body:JSON.stringify({message:t.message, conversation_id:t.conversation_id, session_id:t.session_id, model:t.model, thinkingLevel:t.thinkingLevel, contentParts:t.contentParts, agentSpec:t.agentSpec})}).then(n => ({...jA(n), sources:Array.isArray(n.sources) ? n.sources : [], compare:n.compare}));
}
async function Tb(t) {
  const e = t.kind === "follow_up" ? "/api/knoxx/follow-up" : "/api/knoxx/steer";
  return Ie(e, {method:"POST", body:JSON.stringify({message:t.message, conversation_id:t.conversation_id, session_id:t.session_id, run_id:t.run_id, actor_id:t.actor_id})}).then(n => ({ok:!!n.ok, conversation_id:typeof n.conversation_id == "string" ? n.conversation_id : null, session_id:typeof n.session_id == "string" ? n.session_id : null, run_id:typeof n.run_id == "string" ? n.run_id : null, kind:typeof n.kind == "string" ? n.kind : null}));
}
async function KA(t) {
  return Ie("/api/knoxx/abort", {method:"POST", body:JSON.stringify({conversation_id:t.conversation_id, session_id:t.session_id, run_id:t.run_id, actor_id:t.actor_id, reason:t.reason})}).then(e => ({ok:!!e.ok, conversation_id:typeof e.conversation_id == "string" ? e.conversation_id : null, session_id:typeof e.session_id == "string" ? e.session_id : null, run_id:typeof e.run_id == "string" ? e.run_id : null, error:typeof e.error == "string" ? e.error : null}));
}
async function XA(t) {
  return Ie("/api/knoxx/session/undo", {method:"POST", body:JSON.stringify({session_id:t.session_id, conversation_id:t.conversation_id, actor_id:t.actor_id, turns:t.turns})}).then(e => ({ok:!!e.ok, session_id:typeof e.session_id == "string" ? e.session_id : null, conversation_id:typeof e.conversation_id == "string" ? e.conversation_id : null, removed_count:typeof e.removed_count == "number" ? e.removed_count : void 0, remaining_messages:typeof e.remaining_messages == "number" ? e.remaining_messages : 
  void 0, error:typeof e.error == "string" ? e.error : null}));
}
async function JA(t) {
  const e = t.direct ? "/api/knoxx/direct/start" : "/api/knoxx/chat/start";
  return Ie(e, {method:"POST", body:JSON.stringify({message:t.message, conversation_id:t.conversation_id, session_id:t.session_id, run_id:t.run_id, model:t.model, thinkingLevel:t.thinkingLevel, contentParts:t.contentParts, agentSpec:t.agentSpec, templateContext:t.templateContext})}).then(n => ({ok:!!n.ok, queued:!!n.queued, ...jA(n)}));
}
async function e1(t, e) {
  const n = new URLSearchParams({session_id:t});
  return e && n.set("conversation_id", e), Ie(`/api/knoxx/session/status?${n.toString()}`);
}
async function t1(t, e) {
  const n = new URLSearchParams();
  e && n.set("since", e);
  const r = n.toString();
  return Ie(`/api/knoxx/run/${encodeURIComponent(t)}/events${r ? `?${r}` : ""}`);
}
async function Oj(t) {
  return Ie("/api/shibboleth/handoff", {method:"POST", body:JSON.stringify(t)});
}
async function ZA(t) {
  const e = new URLSearchParams();
  t != null && t.path && e.set("path", t.path), (t == null ? void 0 : t.depth) != null && e.set("depth", String(t.depth));
  const n = e.toString();
  return Ie(`/api/studio/audio-library${n ? `?${n}` : ""}`);
}
async function Pj(t) {
  return Ie("/api/studio/audio-library/ensure-dir", {method:"POST", body:JSON.stringify({path:t})});
}
async function Rj(t, e) {
  return Ie("/api/studio/audio-library/rename", {method:"POST", body:JSON.stringify({from:t, to:e})});
}
function Ul(t) {
  const e = new URLSearchParams({path:t});
  return `${us}/api/studio/stream?${e.toString()}`;
}
async function eN(t, e) {
  return Ie("/api/studio/save-m3u", {method:"POST", body:JSON.stringify({name:t, items:e})});
}
function Dj() {
  return `${us}/api/studio/download-m3u`;
}
async function Lj(t) {
  return Ie(`/api/studio/labels?path=${encodeURIComponent(t)}`);
}
async function Mj() {
  return Ie("/api/studio/labels?all\x3dtrue");
}
async function Bj(t, e) {
  return Ie("/api/studio/labels/add", {method:"POST", body:JSON.stringify({path:t, label:e})});
}
async function $j(t, e) {
  return Ie("/api/studio/labels/remove", {method:"POST", body:JSON.stringify({path:t, label:e})});
}
async function Fj(t) {
  return Ie(`/api/studio/labels/by-label?label=${encodeURIComponent(t)}`);
}
async function zj() {
  return Ie("/api/studio/sync-symlinks", {method:"POST"});
}
async function tN(t) {
  return Ie(`/api/studio/load-m3u?path=${encodeURIComponent(t)}`);
}
async function If() {
  return Ie("/api/studio/playlists");
}
async function Hj(t, e) {
  return `${us}/api/studio/audio-asset?path=${encodeURIComponent(t)}&type=${e}`;
}
async function nN(t, e, n, r, i, s) {
  return Ie("/api/studio/audio-asset", {method:"POST", body:JSON.stringify({path:t, type:e, imageData:n, mimeType:r, width:i, height:s})});
}
async function rN(t) {
  return Ie("/api/studio/discord-audio-scan", {method:"POST", body:JSON.stringify(t ?? {})});
}
async function iN(t) {
  return Ie("/api/studio/discord-image-scan", {method:"POST", body:JSON.stringify(t ?? {})});
}
async function Uj() {
  return await Ie("/api/translations/config");
}
async function Wj(t) {
  return await Ie("/api/translations/config", {method:"PATCH", body:JSON.stringify({model:t})});
}
async function sN(t = "daily") {
  return Ie(`/api/proxx/observability/dashboard/overview?window=${encodeURIComponent(t)}`);
}
async function oN(t) {
  const e = new URLSearchParams();
  t != null && t.limit && e.set("limit", String(t.limit)), t != null && t.providerId && e.set("providerId", t.providerId), t != null && t.accountId && e.set("accountId", t.accountId), t != null && t.before && e.set("before", t.before);
  const n = e.toString();
  return Ie(`/api/proxx/observability/request-logs${n ? `?${n}` : ""}`);
}
async function aN(t = "daily") {
  return Ie(`/api/proxx/observability/analytics/provider-model?window=${encodeURIComponent(t)}`);
}
const jj = 0.015, Vj = 1800, qj = 800, Yj = 3e4, Gj = 100, H_ = 10, Qj = 1, Kj = 44100;
function Xj() {
  const t = ["audio/webm;codecs\x3dopus", "audio/webm", "audio/ogg;codecs\x3dopus", "audio/ogg"];
  if (!(typeof MediaRecorder > "u")) {
    for (const e of t) {
      try {
        if (MediaRecorder.isTypeSupported(e)) {
          return e;
        }
      } catch {
      }
    }
  }
}
function Jj(t) {
  let e = 0;
  for (let n = 0; n < t.length; n++) {
    const r = (t[n] - 128) / 128;
    e += r * r;
  }
  return Math.sqrt(e / t.length);
}
function Zj(t, e) {
  const n = new ArrayBuffer(44), r = new DataView(n);
  r.setUint32(0, 1380533830, !1), r.setUint32(4, 36 + t.length * 4, !0), r.setUint32(8, 1279478612, !1), r.setUint32(12, 6712692, !1), r.setUint32(16, 16, !0), r.setUint16(20, 1, !0), r.setUint16(22, 1, !0), r.setUint32(24, e, !0), r.setUint32(28, e * 4, !0), r.setUint16(32, 4, !0), r.setUint16(34, 32, !0), r.setUint32(36, 6386785, !1), r.setUint32(40, t.length * 4, !0);
  const i = new ArrayBuffer(t.length * 4);
  return (new Float32Array(i)).set(t), new Blob([n, i], {type:"audio/wav"});
}
function eV(t, e) {
  const n = Math.min(t.length, e.length);
  for (let r = n; r > 0; r--) {
    if (t.slice(-r) === e.slice(0, r)) {
      return r;
    }
  }
  return 0;
}
function lN({onTranscript:t, conversationMode:e = !1, silenceThreshold:n = jj}) {
  const [r, i] = (0,require$react.useState)({status:"idle"}), s = (0,require$react.useRef)(null), o = (0,require$react.useRef)(null), a = (0,require$react.useRef)([]), l = (0,require$react.useRef)(null), c = (0,require$react.useRef)(null), u = (0,require$react.useRef)(null), h = (0,require$react.useRef)(null), f = (0,require$react.useRef)(null), p = (0,require$react.useRef)(t), g = (0,require$react.useRef)(0), m = (0,require$react.useRef)(new Float32Array(0)), b = (0,require$react.useRef)(null), 
  x = (0,require$react.useRef)(null), w = (0,require$react.useRef)(""), v = (0,require$react.useRef)(!1);
  p.current = t;
  const T = (0,require$react.useCallback)(() => {
    if (h.current && (clearInterval(h.current), h.current = null), f.current && (clearTimeout(f.current), f.current = null), x.current && (clearInterval(x.current), x.current = null), b.current && (b.current.disconnect(), b.current = null), l.current) {
      try {
        l.current.close();
      } catch {
      }
      l.current = null;
    }
    c.current = null, u.current = null, m.current = new Float32Array(0), w.current = "", v.current = !1;
  }, []), I = (0,require$react.useCallback)(() => {
    s.current = null;
    const A = o.current;
    if (o.current = null, a.current = [], A) {
      for (const P of A.getTracks()) {
        try {
          P.stop();
        } catch {
        }
      }
    }
  }, []), _ = (0,require$react.useCallback)(() => {
    T(), I();
  }, [T, I]);
  (0,require$react.useEffect)(() => _, [_]);
  const N = (0,require$react.useCallback)(() => {
    const A = s.current;
    if (A) {
      try {
        A.stop();
      } catch (P) {
        const W = P instanceof Error ? P.message : String(P);
        i({status:"error", message:W}), _();
      }
    }
  }, [_]), E = (0,require$react.useCallback)(async() => {
    var V;
    if (v.current) {
      return;
    }
    const A = m.current;
    if (A.length === 0) {
      return;
    }
    const P = ((V = l.current) == null ? void 0 : V.sampleRate) || Kj, W = H_ * P, F = Qj * P, B = A.length, z = Math.max(0, B - W), j = A.slice(z, B);
    m.current = A.slice(Math.max(0, B - F)), v.current = !0;
    try {
      const ne = Zj(j, P), ie = ((await pp(ne, "voice-chunk.wav")).text ?? "").trim();
      if (ie) {
        const ee = eV(w.current, ie), M = ie.slice(ee).trim();
        M && (w.current += (M.startsWith(" ") ? "" : " ") + M);
      }
    } catch (ne) {
      console.warn("Chunk transcription background failure:", ne);
    } finally {
      v.current = !1;
    }
  }, []), C = (0,require$react.useCallback)(async() => {
    var A;
    if (typeof navigator > "u" || !((A = navigator.mediaDevices) != null && A.getUserMedia)) {
      i({status:"error", message:"Microphone recording is not available in this browser."});
      return;
    }
    try {
      const P = await navigator.mediaDevices.getUserMedia({audio:{echoCancellation:!0, noiseSuppression:!0, autoGainControl:!0}});
      o.current = P, a.current = [], m.current = new Float32Array(0), w.current = "";
      const W = Xj(), F = W ? new MediaRecorder(P, {mimeType:W}) : new MediaRecorder(P);
      s.current = F, F.ondataavailable = ne => {
        ne.data && ne.data.size > 0 && a.current.push(ne.data);
      }, F.onstop = () => {
        T();
        const ne = new Blob(a.current, {type:F.mimeType || "audio/webm"});
        (async() => {
          try {
            i({status:"transcribing"});
            const ie = ((await pp(ne, "voice-input.webm")).text ?? "").trim();
            if (!ie) {
              i({status:"error", message:"Transcription returned empty text."});
              return;
            }
            i({status:"idle"}), p.current(ie);
          } catch (D) {
            const ie = D instanceof Error ? D.message : String(D);
            i({status:"error", message:ie});
          } finally {
            I();
          }
        })();
      }, F.onerror = ne => {
        const D = ne.error instanceof Error ? ne.error.message : "Recording error";
        i({status:"error", message:D}), _();
      }, F.start();
      const B = Date.now();
      i({status:"recording", startedAt:B}), f.current = window.setTimeout(() => {
        var ne;
        ((ne = s.current) == null ? void 0 : ne.state) === "recording" && N();
      }, Yj);
      const z = new AudioContext();
      l.current = z;
      const j = z.createMediaStreamSource(P), V = z.createScriptProcessor(4096, 1, 1);
      if (V.onaudioprocess = ne => {
        const D = ne.inputBuffer.getChannelData(0), ie = new Float32Array(m.current.length + D.length);
        ie.set(m.current), ie.set(D, m.current.length), m.current = ie;
      }, j.connect(V), V.connect(z.destination), b.current = V, x.current = window.setInterval(E, H_ * 1e3), e) {
        const ne = z.createAnalyser();
        ne.fftSize = 512, ne.smoothingTimeConstant = 0.3, j.connect(ne), c.current = ne, u.current = null;
        const D = new Uint8Array(ne.fftSize);
        h.current = window.setInterval(() => {
          var X;
          const ie = c.current;
          if (!ie || ((X = s.current) == null ? void 0 : X.state) !== "recording") {
            return;
          }
          ie.getByteTimeDomainData(D);
          const ee = Jj(D), M = Date.now() - B;
          g.current = ee, ee < n && M >= qj ? u.current === null ? u.current = Date.now() : Date.now() - u.current >= Vj && N() : u.current = null;
        }, Gj);
      }
    } catch (P) {
      const W = P instanceof Error ? P.message : String(P);
      i({status:"error", message:W}), _();
    }
  }, [_, T, I, e, n, N, E]), k = (0,require$react.useCallback)(() => {
    if (r.status === "recording") {
      N();
      return;
    }
    r.status !== "transcribing" && C();
  }, [C, r.status, N]);
  return {state:r, toggle:k, startRecording:C, stopRecording:N, audioLevelRef:g};
}
function tV({disabled:t, onTranscript:e, idleLabel:n = "Reply by voice", recordingLabel:r = "Stop recording", transcribingLabel:i = "Transcribing\u2026", iconOnly:s = !1, title:o}) {
  const {state:a, toggle:l} = lN({onTranscript:e, conversationMode:!1}), c = (0,require$react.useCallback)(f => {
    f.preventDefault(), f.stopPropagation(), l();
  }, [l]), u = a.status === "recording" ? "\u23f9\ufe0f" : a.status === "transcribing" ? "\u23f3" : "\ud83c\udfa4", h = a.status === "recording" ? r : a.status === "transcribing" ? i : n;
  return s ? (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{display:"flex", alignItems:"center", gap:4}, children:[(0,require$react_SLASH_jsx_runtime.jsx)("button", {type:"button", title:o || h, onClick:c, disabled:t || a.status === "transcribing", style:{width:28, height:28, borderRadius:6, border:"1px solid var(--token-colors-border-default)", background:a.status === "recording" ? "var(--token-colors-alpha-red-_20)" : "var(--token-colors-button-ghost-bg)", color:a.status === "recording" ? 
  "var(--token-colors-accent-red)" : "var(--token-colors-text-muted)", cursor:"pointer", fontSize:14, display:"flex", alignItems:"center", justifyContent:"center", padding:0, lineHeight:1}, children:u}), a.status === "recording" ? (0,require$react_SLASH_jsx_runtime.jsx)(ct, {size:"sm", variant:"warning", children:"rec"}) : null, a.status === "error" ? (0,require$react_SLASH_jsx_runtime.jsx)(ct, {size:"sm", variant:"error", children:a.message}) : null]}) : (0,require$react_SLASH_jsx_runtime.jsxs)("div", 
  {style:{display:"flex", alignItems:"center", gap:8, flexWrap:"wrap"}, children:[(0,require$react_SLASH_jsx_runtime.jsx)(Ke, {type:"button", variant:"ghost", size:"sm", onClick:c, disabled:t || a.status === "transcribing", children:h}), a.status === "recording" ? (0,require$react_SLASH_jsx_runtime.jsx)(ct, {size:"sm", variant:"warning", children:"recording"}) : null, a.status === "error" ? (0,require$react_SLASH_jsx_runtime.jsx)(ct, {size:"sm", variant:"error", children:a.message}) : null]});
}
function nV() {
  const t = ["audio/webm;codecs\x3dopus", "audio/webm", "audio/ogg;codecs\x3dopus", "audio/ogg"];
  if (!(typeof MediaRecorder > "u")) {
    for (const e of t) {
      try {
        if (MediaRecorder.isTypeSupported(e)) {
          return e;
        }
      } catch {
      }
    }
  }
}
function rV(t) {
  let e = 0;
  for (let n = 0; n < t.length; n++) {
    const r = (t[n] - 128) / 128;
    e += r * r;
  }
  return Math.sqrt(e / t.length);
}
const iV = 0.015, sV = 1800, oV = 800, aV = 3e4, lV = 100;
function U_({disabled:t, onTranscript:e, title:n = "Voice (auto-send on pause)", silenceThreshold:r = iV}) {
  const [i, s] = (0,require$react.useState)({status:"idle"}), o = (0,require$react.useRef)(null), a = (0,require$react.useRef)(null), l = (0,require$react.useRef)([]), c = (0,require$react.useRef)(null), u = (0,require$react.useRef)(null), h = (0,require$react.useRef)(null), f = (0,require$react.useRef)(null), p = (0,require$react.useRef)(null), g = (0,require$react.useRef)(e);
  g.current = e;
  const m = (0,require$react.useCallback)(() => {
    if (f.current && (clearInterval(f.current), f.current = null), p.current && (clearTimeout(p.current), p.current = null), c.current) {
      try {
        c.current.close();
      } catch {
      }
      c.current = null;
    }
    u.current = null, h.current = null;
  }, []), b = (0,require$react.useCallback)(() => {
    o.current = null;
    const _ = a.current;
    if (a.current = null, l.current = [], _) {
      for (const N of _.getTracks()) {
        try {
          N.stop();
        } catch {
        }
      }
    }
  }, []), x = (0,require$react.useCallback)(() => {
    m(), b();
  }, [m, b]);
  (0,require$react.useEffect)(() => x, [x]);
  const w = (0,require$react.useCallback)(() => {
    const _ = o.current;
    if (_) {
      try {
        _.stop();
      } catch (N) {
        const E = N instanceof Error ? N.message : String(N);
        s({status:"error", message:E}), x();
      }
    }
  }, [x]), v = (0,require$react.useCallback)(async() => {
    var _;
    if (typeof navigator > "u" || !((_ = navigator.mediaDevices) != null && _.getUserMedia)) {
      s({status:"error", message:"Microphone not available in this browser."});
      return;
    }
    try {
      const N = await navigator.mediaDevices.getUserMedia({audio:{echoCancellation:!0, noiseSuppression:!0, autoGainControl:!0}});
      a.current = N, l.current = [];
      const E = nV(), C = E ? new MediaRecorder(N, {mimeType:E}) : new MediaRecorder(N);
      o.current = C, C.ondataavailable = B => {
        B.data && B.data.size > 0 && l.current.push(B.data);
      }, C.onstop = () => {
        m();
        const B = new Blob(l.current, {type:C.mimeType || "audio/webm"});
        (async() => {
          try {
            s({status:"transcribing"});
            const j = ((await pp(B, "voice-input.webm")).text ?? "").trim();
            if (!j) {
              s({status:"error", message:"Transcription returned empty text."});
              return;
            }
            s({status:"idle"}), g.current(j);
          } catch (z) {
            const j = z instanceof Error ? z.message : String(z);
            s({status:"error", message:j});
          } finally {
            b();
          }
        })();
      }, C.onerror = B => {
        const z = B.error instanceof Error ? B.error.message : "Recording error";
        s({status:"error", message:z}), x();
      }, C.start();
      const k = Date.now();
      s({status:"recording", startedAt:k}), p.current = window.setTimeout(() => {
        var B;
        ((B = o.current) == null ? void 0 : B.state) === "recording" && w();
      }, aV);
      const A = new AudioContext();
      c.current = A;
      const P = A.createMediaStreamSource(N), W = A.createAnalyser();
      W.fftSize = 512, W.smoothingTimeConstant = 0.3, P.connect(W), u.current = W, h.current = null;
      const F = new Uint8Array(W.fftSize);
      f.current = window.setInterval(() => {
        var V;
        const B = u.current;
        if (!B || ((V = o.current) == null ? void 0 : V.state) !== "recording") {
          return;
        }
        B.getByteTimeDomainData(F);
        const z = rV(F), j = Date.now() - k;
        z < r && j >= oV ? h.current === null ? h.current = Date.now() : Date.now() - h.current >= sV && w() : h.current = null;
      }, lV);
    } catch (N) {
      const E = N instanceof Error ? N.message : String(N);
      s({status:"error", message:E}), x();
    }
  }, [x, m, b, r, w]), T = (0,require$react.useCallback)(_ => {
    if (_.preventDefault(), _.stopPropagation(), i.status === "recording") {
      w();
      return;
    }
    i.status !== "transcribing" && v();
  }, [v, i.status, w]), I = i.status === "recording" ? "\u23f9\ufe0f" : i.status === "transcribing" ? "\u23f3" : "\ud83c\udf99\ufe0f";
  return (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{display:"flex", alignItems:"center", gap:4}, children:[(0,require$react_SLASH_jsx_runtime.jsx)("button", {type:"button", title:n, onClick:T, disabled:t || i.status === "transcribing", style:{width:28, height:28, borderRadius:6, border:"1px solid var(--token-colors-border-default)", background:i.status === "recording" ? "var(--token-colors-alpha-red-_20)" : "var(--token-colors-button-ghost-bg)", color:i.status === "recording" ? "var(--token-colors-accent-red)" : 
  "var(--token-colors-text-muted)", cursor:t || i.status === "transcribing" ? "not-allowed" : "pointer", opacity:t || i.status === "transcribing" ? 0.4 : 1, fontSize:14, display:"flex", alignItems:"center", justifyContent:"center", padding:0, lineHeight:1, transition:"background-color 120ms, color 120ms, opacity 120ms"}, children:I}), i.status === "recording" ? (0,require$react_SLASH_jsx_runtime.jsx)(ct, {size:"sm", variant:"warning", children:"rec"}) : null, i.status === "error" ? (0,require$react_SLASH_jsx_runtime.jsx)("div", 
  {style:{fontSize:11, color:"var(--token-colors-accent-red)"}, title:i.message, children:"err"}) : null]});
}
function cV({text:t, disabled:e, iconOnly:n = !1, title:r}) {
  const [i, s] = (0,require$react.useState)({status:"idle"}), o = (0,require$react.useRef)(null), a = (0,require$react.useRef)(null), l = (0,require$react.useCallback)(() => {
    const p = o.current;
    if (o.current = null, p) {
      try {
        p.pause();
      } catch {
      }
    }
    const g = a.current;
    if (a.current = null, g) {
      try {
        URL.revokeObjectURL(g);
      } catch {
      }
    }
  }, []), c = (0,require$react.useCallback)(() => {
    l(), s({status:"idle"});
  }, [l]);
  (0,require$react.useEffect)(() => l, [l]);
  const u = (0,require$react.useCallback)(async() => {
    if (e) {
      return;
    }
    if (i.status === "loading" || i.status === "playing") {
      c();
      return;
    }
    const p = (t ?? "").trim();
    if (!p) {
      s({status:"error", message:"Nothing to speak."});
      return;
    }
    try {
      s({status:"loading"});
      const g = await Zx({text:p}), m = URL.createObjectURL(g);
      a.current = m;
      const b = new Audio(m);
      o.current = b, b.onended = () => c(), b.onerror = () => {
        l(), s({status:"error", message:"Audio playback failed."});
      }, await b.play(), s({status:"playing"});
    } catch (g) {
      const m = g instanceof Error ? g.message : String(g);
      l(), s({status:"error", message:m});
    }
  }, [e, i.status, c, t]), h = i.status === "playing" ? "\ud83d\udd07" : i.status === "loading" ? "\u23f3" : "\ud83d\udd0a", f = i.status === "playing" ? "Stop" : i.status === "loading" ? "Speaking\u2026" : "Speak";
  return n ? (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{display:"flex", alignItems:"center", gap:4}, children:[(0,require$react_SLASH_jsx_runtime.jsx)("button", {type:"button", title:r || f, onClick:() => void u(), disabled:e || i.status === "loading", style:{width:28, height:28, borderRadius:6, border:"1px solid var(--token-colors-border-default)", background:i.status === "playing" ? "var(--token-colors-alpha-green-_20)" : "var(--token-colors-button-ghost-bg)", color:i.status === "playing" ? 
  "var(--token-colors-accent-green)" : "var(--token-colors-text-muted)", cursor:"pointer", fontSize:14, display:"flex", alignItems:"center", justifyContent:"center", padding:0, lineHeight:1}, children:h}), i.status === "error" ? (0,require$react_SLASH_jsx_runtime.jsx)(ct, {size:"sm", variant:"error", children:i.message}) : null]}) : (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{display:"flex", alignItems:"center", gap:8, flexWrap:"wrap"}, children:[(0,require$react_SLASH_jsx_runtime.jsx)(Ke, 
  {variant:"ghost", size:"sm", onClick:() => void u(), disabled:e || i.status === "loading", children:f}), i.status === "error" ? (0,require$react_SLASH_jsx_runtime.jsx)(ct, {size:"sm", variant:"error", children:i.message}) : null]});
}
function uV(t) {
  return new Promise(e => {
    const n = t.type, r = {type:n, mimeType:t.file.type, filename:t.file.name, size:t.file.size};
    if (t.preview) {
      if (n === "image" && t.preview.startsWith("data:")) {
        e({...r, data:t.preview});
        return;
      }
      if ((n === "audio" || n === "video") && t.preview.startsWith("blob:")) {
        fetch(t.preview).then(s => s.blob()).then(s => {
          const o = new FileReader();
          o.onload = () => {
            e({...r, data:o.result});
          }, o.onerror = () => {
            e({...r, url:t.preview});
          }, o.readAsDataURL(s);
        }).catch(() => {
          e({...r, url:t.preview});
        });
        return;
      }
      e({...r, url:t.preview});
      return;
    }
    const i = new FileReader();
    i.onload = () => {
      e({...r, data:i.result});
    }, i.onerror = () => {
      e({...r});
    }, i.readAsDataURL(t.file);
  });
}
function ma({glyph:t, title:e, onClick:n, disabled:r, active:i, type:s = "button"}) {
  return (0,require$react_SLASH_jsx_runtime.jsx)("button", {type:s, title:e, onClick:n, disabled:r, style:{width:28, height:28, borderRadius:6, border:"1px solid var(--token-colors-border-default)", background:i ? "var(--token-colors-alpha-green-_20)" : "var(--token-colors-button-ghost-bg)", color:i ? "var(--token-colors-accent-green)" : "var(--token-colors-text-muted)", cursor:r ? "not-allowed" : "pointer", opacity:r ? 0.4 : 1, fontSize:14, display:"flex", alignItems:"center", justifyContent:"center", 
  padding:0, lineHeight:1, transition:"background-color 120ms, color 120ms, opacity 120ms"}, children:t});
}
function dV({audioLevelRef:t, threshold:e, onThresholdChange:n}) {
  const [r, i] = (0,require$react.useState)(0);
  (0,require$react.useEffect)(() => {
    let l;
    const c = () => {
      i(t.current), l = requestAnimationFrame(c);
    };
    return l = requestAnimationFrame(c), () => cancelAnimationFrame(l);
  }, [t]);
  const s = 0.06, o = Math.min(100, r / s * 100), a = Math.min(100, e / s * 100);
  return (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{display:"flex", alignItems:"center", gap:6}, title:`Level: ${r.toFixed(4)} | Threshold: ${e.toFixed(3)}`, children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{width:8, height:8, borderRadius:"50%", background:"var(--token-colors-accent-red)", boxShadow:"0 0 6px var(--token-colors-accent-red)"}}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{position:"relative", width:72, height:14}, children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", 
  {style:{position:"absolute", inset:0, background:"var(--token-colors-surface-input)", borderRadius:3, overflow:"hidden", border:"1px solid var(--token-colors-border-subtle)"}, children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{width:`${o}%`, height:"100%", background:r > e ? "var(--token-colors-accent-green)" : "var(--token-colors-accent-yellow)", transition:"width 40ms linear"}}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{position:"absolute", left:`${a}%`, top:0, bottom:0, 
  width:2, background:"var(--token-colors-accent-red)", transform:"translateX(-50%)", opacity:0.9}})]}), (0,require$react_SLASH_jsx_runtime.jsx)("input", {type:"range", min:1e-3, max:0.06, step:1e-3, value:e, onChange:l => n(parseFloat(l.target.value)), style:{position:"absolute", inset:0, width:"100%", height:"100%", opacity:0, cursor:"pointer", margin:0, padding:0}})]}), (0,require$react_SLASH_jsx_runtime.jsx)("span", {style:{fontSize:9, color:"var(--token-colors-text-muted)", minWidth:28, fontVariantNumeric:"tabular-nums"}, 
  children:e.toFixed(3)})]});
}
function hV({onSend:t, isSending:e, multimodalEnabled:n = !0, voiceInputEnabled:r = !1, liveControlEnabled:i = !1, liveControlText:s = "", onLiveControlTextChange:o, queueingControl:a = null, onQueueLiveControl:l, abortingTurn:c = !1, onAbortTurn:u, onVoiceSteer:h, latestAssistantContent:f, autoConversationEnabled:p = !1, onToggleAutoConversation:g, ttsEnabled:m = !1, ttsStatus:b = "idle", ttsError:x = null, autoRecording:w = !1, voiceThreshold:v = 0.015, onVoiceThresholdChange:T, audioLevelRef:I, 
onUndoMessages:_, undoDisabled:N = !1, onNewChat:E}) {
  const [C, k] = (0,require$react.useState)(""), [A, P] = (0,require$react.useState)([]), W = (0,require$react.useRef)(null), F = (0,require$react.useCallback)(async V => {
    V.preventDefault();
    const ne = C.trim();
    if (!ne && A.length === 0 || e) {
      return;
    }
    let D;
    A.length > 0 && (D = await Promise.all(A.map(uV)), ne && D.unshift({type:"text", text:ne})), t(ne, D), k(""), P([]);
  }, [C, A, e, t]), B = (0,require$react.useCallback)(V => {
    if (V.key === "Enter" && !V.shiftKey) {
      if (V.preventDefault(), i) {
        if (!s.trim() || a !== null) {
          return;
        }
        V.ctrlKey ? l == null || l("follow_up") : l == null || l("steer");
        return;
      }
      (C.trim() || A.length > 0) && !e && F(V);
    }
  }, [i, s, a, l, C, A, e, F]);
  (0,require$react.useEffect)(() => {
    if (typeof window > "u" || !n) {
      return;
    }
    const V = () => {
      setTimeout(() => {
        var ne;
        return (ne = W.current) == null ? void 0 : ne.focus();
      }, 0);
    };
    return window.addEventListener("paste", V), () => window.removeEventListener("paste", V);
  }, [n]);
  const z = (C.trim() || A.length > 0) && !e, j = s.trim().length > 0 && a === null;
  return (0,require$react_SLASH_jsx_runtime.jsxs)("form", {onSubmit:F, children:[A.length > 0 && !i && (0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{display:"flex", flexWrap:"wrap", gap:8, marginBottom:8, padding:8, background:"var(--token-colors-background-elevated, #1a1a2e)", borderRadius:8, border:"1px solid var(--token-colors-border-default, #333)"}, children:A.map(V => (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{position:"relative", borderRadius:6, overflow:"hidden", border:"1px solid var(--token-colors-border-subtle, #444)", 
  background:"var(--token-colors-background-surface, #16213e)"}, children:[V.type === "image" && V.preview && (0,require$react_SLASH_jsx_runtime.jsx)("img", {src:V.preview, alt:V.file.name, style:{width:80, height:80, objectFit:"cover", display:"block"}}), V.type === "audio" && (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{width:160, height:60, display:"flex", alignItems:"center", padding:"0 8px", gap:8}, children:[(0,require$react_SLASH_jsx_runtime.jsx)("span", {style:{fontSize:20}, children:"\ud83c\udfb5"}), 
  (0,require$react_SLASH_jsx_runtime.jsx)("span", {style:{fontSize:11, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap", color:"var(--token-colors-text-muted)"}, children:V.file.name.slice(0, 20)})]}), V.type === "video" && V.preview && (0,require$react_SLASH_jsx_runtime.jsx)("video", {src:V.preview, style:{width:120, height:80, display:"block", objectFit:"cover"}}), V.type === "document" && (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{width:80, height:80, display:"flex", 
  flexDirection:"column", alignItems:"center", justifyContent:"center", gap:4}, children:[(0,require$react_SLASH_jsx_runtime.jsx)("span", {style:{fontSize:24}, children:"\ud83d\udcc4"}), (0,require$react_SLASH_jsx_runtime.jsx)("span", {style:{fontSize:9, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap", maxWidth:72, color:"var(--token-colors-text-muted)"}, children:V.file.name.slice(0, 16)})]}), (0,require$react_SLASH_jsx_runtime.jsx)("button", {type:"button", onClick:() => P(ne => 
  ne.filter(D => D.id !== V.id)), style:{position:"absolute", top:2, right:2, width:18, height:18, borderRadius:"50%", border:"none", background:"rgba(0, 0, 0, 0.7)", color:"white", cursor:"pointer", fontSize:12, lineHeight:1, display:"flex", alignItems:"center", justifyContent:"center"}, title:"Remove attachment", children:"\u00d7"})]}, V.id))}), (0,require$react_SLASH_jsx_runtime.jsx)("textarea", {ref:W, rows:i ? 2 : 3, className:`input resize-y w-full ${i ? "min-h-14" : "min-h-20"}`, value:i ? 
  s : C, onChange:V => {
    i ? o == null || o(V.target.value) : k(V.target.value);
  }, onKeyDown:B, disabled:i ? a !== null : e, placeholder:i ? "Steer the current turn (Enter) or queue a follow-up (Ctrl+Enter)..." : n ? "Send a message, or drag/paste images, audio, video..." : "Send a prompt, test edge cases, compare behavior..."}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{display:"flex", alignItems:"center", gap:6, flexWrap:"wrap", marginTop:8}, children:[!i && n && (0,require$react_SLASH_jsx_runtime.jsx)(wW, {attachments:A, onAttachmentsChange:P, disabled:e, 
  hidePreviews:!0}), r && (i ? (0,require$react_SLASH_jsx_runtime.jsx)(U_, {disabled:a !== null, onTranscript:V => void(h == null ? void 0 : h(V)), title:"Voice steer (auto-send on pause)", silenceThreshold:v}) : p ? (0,require$react_SLASH_jsx_runtime.jsx)(U_, {disabled:e || w, onTranscript:V => t(V), title:"Voice reply (auto-send on pause)", silenceThreshold:v}) : (0,require$react_SLASH_jsx_runtime.jsx)(tV, {disabled:e, onTranscript:V => t(V), idleLabel:"Speak", recordingLabel:"Stop", transcribingLabel:"Transcribing\u2026", 
  iconOnly:!0, title:"Voice input (sends immediately)"})), f && f.trim().length > 0 && (0,require$react_SLASH_jsx_runtime.jsx)(cV, {text:f, iconOnly:!0, title:"Speak latest assistant reply"}), (0,require$react_SLASH_jsx_runtime.jsx)(ma, {glyph:"\u21a9\ufe0f", title:"Undo last turn", onClick:() => void(_ == null ? void 0 : _()), disabled:N}), (0,require$react_SLASH_jsx_runtime.jsx)(ma, {glyph:"\ud83d\uddd1\ufe0f", title:"New chat", onClick:() => E == null ? void 0 : E()}), (0,require$react_SLASH_jsx_runtime.jsx)("div", 
  {style:{flex:1}}), m && (0,require$react_SLASH_jsx_runtime.jsx)(ma, {glyph:"\ud83d\udd0a", title:p ? "Auto voice on" : "Auto voice off", onClick:() => g == null ? void 0 : g(), active:p}), w && I && T ? (0,require$react_SLASH_jsx_runtime.jsx)(dV, {audioLevelRef:I, threshold:v, onThresholdChange:T}) : null, b !== "idle" ? (0,require$react_SLASH_jsx_runtime.jsx)(ct, {size:"sm", variant:b === "error" ? "error" : b === "playing" || b === "streaming" ? "success" : "warning", children:b}) : null, x ? 
  (0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{fontSize:11, color:"var(--token-colors-text-muted)"}, children:x}) : null, i ? (0,require$react_SLASH_jsx_runtime.jsxs)(require$react_SLASH_jsx_runtime.Fragment, {children:[(0,require$react_SLASH_jsx_runtime.jsx)(ma, {glyph:"\u27a4", title:"Steer (Enter)", onClick:() => void(l == null ? void 0 : l("steer")), disabled:!j}), (0,require$react_SLASH_jsx_runtime.jsx)(ma, {glyph:"\u23ed", title:"Queue follow-up (Ctrl+Enter)", onClick:() => void(l == 
  null ? void 0 : l("follow_up")), disabled:!j}), (0,require$react_SLASH_jsx_runtime.jsx)(ma, {glyph:"\u2715", title:"Abort turn", onClick:() => void(u == null ? void 0 : u()), disabled:c || a !== null})]}) : (0,require$react_SLASH_jsx_runtime.jsx)(ma, {glyph:"\u27a4", title:"Send", type:"submit", disabled:!z})]})]});
}
function fV({lines:t}) {
  return (0,require$react_SLASH_jsx_runtime.jsxs)("section", {className:"panel flex h-full min-h-0 flex-col", children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"mb-2 flex items-center justify-between", children:[(0,require$react_SLASH_jsx_runtime.jsx)("h2", {className:"panel-title", children:"Console Stream"}), (0,require$react_SLASH_jsx_runtime.jsxs)("span", {style:{fontSize:12, color:"var(--token-colors-text-muted)"}, children:[t.length, " lines"]})]}), (0,require$react_SLASH_jsx_runtime.jsx)("div", 
  {style:{minHeight:0, flex:1, overflow:"auto", borderRadius:8, background:"var(--token-colors-alpha-bg-_88b)", border:"1px solid var(--token-colors-border-default)", padding:8, fontFamily:"var(--token-fontFamily-mono)", fontSize:12, color:"var(--token-colors-accent-green)"}, children:t.length === 0 ? (0,require$react_SLASH_jsx_runtime.jsx)("p", {style:{color:"var(--token-colors-alpha-green-_55)"}, children:"Waiting for logs..."}) : t.map((e, n) => (0,require$react_SLASH_jsx_runtime.jsx)("div", {children:e}, 
  `${n}-${e}`))})]});
}
function pV({src:t, alt:e, onClose:n}) {
  const r = (0,require$react.useCallback)(i => {
    i.target === i.currentTarget && n();
  }, [n]);
  return (0,require$react.useEffect)(() => {
    const i = s => {
      s.key === "Escape" && n();
    };
    return window.addEventListener("keydown", i), () => window.removeEventListener("keydown", i);
  }, [n]), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {onClick:r, style:{position:"fixed", inset:0, background:"rgba(0, 0, 0, 0.9)", display:"flex", alignItems:"center", justifyContent:"center", zIndex:1e3, padding:40}, children:[(0,require$react_SLASH_jsx_runtime.jsx)("button", {onClick:n, style:{position:"absolute", top:20, right:20, width:40, height:40, borderRadius:"50%", border:"none", background:"rgba(255,255,255,0.1)", color:"white", fontSize:24, cursor:"pointer"}, children:"\u00d7"}), 
  (0,require$react_SLASH_jsx_runtime.jsx)("img", {src:t, alt:e || "Image preview", style:{maxWidth:"100%", maxHeight:"100%", objectFit:"contain", borderRadius:8}})]});
}
function Ig(t) {
  return t < 1024 ? `${t}B` : t < 1024 * 1024 ? `${(t / 1024).toFixed(1)}KB` : `${(t / 1024 / 1024).toFixed(1)}MB`;
}
function gV({part:t, onOpenInLightbox:e, maxWidth:n = 400, maxHeight:r = 300}) {
  const i = t.data || t.url;
  return i ? (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{marginTop:8, borderRadius:8, overflow:"hidden", border:"1px solid var(--token-colors-border-default)"}, children:[(0,require$react_SLASH_jsx_runtime.jsx)("img", {src:i, alt:t.filename || "Image", onClick:() => e == null ? void 0 : e(i), style:{maxWidth:n, maxHeight:r, display:"block", cursor:e ? "pointer" : "default"}}), t.filename && (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{padding:"4px 8px", fontSize:11, color:"var(--token-colors-text-muted)", 
  background:"var(--token-colors-background-elevated)"}, children:[t.filename, t.size && ` \u2022 ${Ig(t.size)}`]})]}) : null;
}
function mV({part:t}) {
  const e = t.data || t.url;
  return e ? (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{marginTop:8, borderRadius:8, overflow:"hidden", border:"1px solid var(--token-colors-border-default)", background:"var(--token-colors-background-elevated)", padding:12}, children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{display:"flex", alignItems:"center", gap:8, marginBottom:8}, children:[(0,require$react_SLASH_jsx_runtime.jsx)("span", {style:{fontSize:20}, children:"\ud83c\udfb5"}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", 
  {style:{flex:1, minWidth:0}, children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{fontSize:12, fontWeight:600, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap"}, children:t.filename || "Audio file"}), t.size && (0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{fontSize:10, color:"var(--token-colors-text-muted)"}, children:Ig(t.size)})]})]}), (0,require$react_SLASH_jsx_runtime.jsx)("audio", {src:e, controls:!0, style:{width:"100%"}, preload:"metadata"})]}) : null;
}
function bV({part:t, maxWidth:e = 480, maxHeight:n = 360}) {
  const r = t.data || t.url;
  return r ? (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{marginTop:8, borderRadius:8, overflow:"hidden", border:"1px solid var(--token-colors-border-default)"}, children:[(0,require$react_SLASH_jsx_runtime.jsx)("video", {src:r, controls:!0, preload:"metadata", style:{maxWidth:e, maxHeight:n, display:"block"}}), t.filename && (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{padding:"4px 8px", fontSize:11, color:"var(--token-colors-text-muted)", background:"var(--token-colors-background-elevated)"}, 
  children:[t.filename, t.size && ` \u2022 ${Ig(t.size)}`]})]}) : null;
}
function yV({part:t}) {
  var r;
  const e = t.data || t.url, n = t.mimeType === "application/pdf" || ((r = t.filename) == null ? void 0 : r.endsWith(".pdf"));
  return (0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{marginTop:8, borderRadius:8, overflow:"hidden", border:"1px solid var(--token-colors-border-default)", background:"var(--token-colors-background-elevated)", padding:12}, children:(0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{display:"flex", alignItems:"center", gap:12}, children:[(0,require$react_SLASH_jsx_runtime.jsx)("span", {style:{fontSize:32}, children:"\ud83d\udcc4"}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{flex:1, 
  minWidth:0}, children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{fontSize:13, fontWeight:600, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap"}, children:t.filename || "Document"}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{display:"flex", gap:8, marginTop:2}, children:[t.mimeType && (0,require$react_SLASH_jsx_runtime.jsx)(ct, {size:"sm", variant:"default", children:t.mimeType}), t.size && (0,require$react_SLASH_jsx_runtime.jsx)("span", {style:{fontSize:10, 
  color:"var(--token-colors-text-muted)"}, children:Ig(t.size)})]})]}), e && (0,require$react_SLASH_jsx_runtime.jsx)(Ke, {variant:"ghost", size:"sm", onClick:() => window.open(e, "_blank"), children:n ? "Open PDF" : "Download"})]})});
}
function Ra({parts:t, onOpenInLightbox:e, maxPreviewWidth:n = 400, maxPreviewHeight:r = 300}) {
  const [i, s] = (0,require$react.useState)(null), o = (0,require$react.useCallback)(l => {
    e ? e(l) : s(l);
  }, [e]), a = (0,require$react.useCallback)(() => {
    s(null);
  }, []);
  return (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"multimodal-content", children:[t.map((l, c) => {
    switch(l.type) {
      case "text":
        return (0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{whiteSpace:"pre-wrap"}, children:l.text}, c);
      case "image":
        return (0,require$react_SLASH_jsx_runtime.jsx)(gV, {part:l, onOpenInLightbox:o, maxWidth:n, maxHeight:r}, c);
      case "audio":
        return (0,require$react_SLASH_jsx_runtime.jsx)(mV, {part:l}, c);
      case "video":
        return (0,require$react_SLASH_jsx_runtime.jsx)(bV, {part:l, maxWidth:n * 1.2, maxHeight:r * 1.2}, c);
      case "document":
        return (0,require$react_SLASH_jsx_runtime.jsx)(yV, {part:l}, c);
      default:
        return null;
    }
  }), i && (0,require$react_SLASH_jsx_runtime.jsx)(pV, {src:i, onClose:a})]});
}
const xV = 5, vV = 32, wV = 24, _V = 12e3;
function W_(t) {
  if (typeof t != "string") {
    return null;
  }
  const e = t.trim();
  if (!e) {
    return null;
  }
  const n = e.toLowerCase();
  return n === "null" || n === "undefined" ? null : e;
}
function SV(t, e = 240) {
  return t.length <= e ? t : `${t.slice(0, e).trimEnd()}\u2026`;
}
function Wu(t, e = _V) {
  return t.length <= e ? {text:t, truncated:!1} : {text:`${t.slice(0, e).trimEnd()}\u2026`, truncated:!0};
}
function ju(t) {
  const e = t.trim();
  return e ? /^(```|#{1,6}\s|>\s|[-*+]\s|\d+\.\s)/m.test(e) ? t : t.includes(`
`) ? `\`\`\`text
${t}
\`\`\`` : t : "";
}
function n1(t) {
  const e = t.trim();
  if (!e.startsWith("{") && !e.startsWith("[")) {
    return null;
  }
  try {
    return JSON.parse(e);
  } catch {
    return null;
  }
}
function kV(t) {
  return !Array.isArray(t) || t.length === 0 ? !1 : t.every(e => {
    if (!e || typeof e != "object" || Array.isArray(e)) {
      return !1;
    }
    const n = e;
    return typeof n.text == "string" && (n.type === "text" || n.type === "output_text" || n.type === void 0);
  });
}
function EV(t) {
  return t.replace(/\\n/g, `
`).replace(/\\t/g, "\t").replace(/\\r/g, "\r").replace(/\\"/g, '"').replace(/\\\\/g, "\\");
}
function cN(t) {
  const e = t.trim();
  if (!e.startsWith("{") && !e.startsWith("[")) {
    return null;
  }
  const n = [], r = /"text"\s*:\s*"/g;
  let i;
  for (; (i = r.exec(e)) !== null && n.length < 4;) {
    let s = i.index + i[0].length, o = "", a = !1;
    for (; s < e.length; s += 1) {
      const c = e[s];
      if (a) {
        o += `\\${c}`, a = !1;
        continue;
      }
      if (c === "\\") {
        a = !0;
        continue;
      }
      if (c === '"') {
        break;
      }
      o += c;
    }
    const l = EV(o).trim();
    l && n.push(l);
  }
  return n.length > 0 ? n.join(`

`) : null;
}
function Of(t) {
  if (typeof t == "string") {
    return t.trim() ? t : null;
  }
  if (Array.isArray(t)) {
    if (kV(t)) {
      const i = t.map(s => typeof s.text == "string" ? s.text : "").map(s => s.trim()).filter(Boolean).join(`

`);
      return i.trim() ? i : null;
    }
    const r = t.map(i => Of(i)).filter(i => !!i).slice(0, 8);
    return r.length > 0 ? r.map(i => `- ${i}`).join(`
`) : null;
  }
  if (!t || typeof t != "object") {
    return null;
  }
  const e = t, n = ["content", "text", "answer", "message", "result", "output", "preview", "summary", "translated_text", "corrected_text", "snippet"];
  for (const r of n) {
    const i = Of(e[r]);
    if (i) {
      return i;
    }
  }
  for (const r of ["rows", "hits", "results", "sources", "items", "documents"]) {
    const i = Of(e[r]);
    if (i) {
      return i;
    }
  }
  return null;
}
function TV(t) {
  const e = n1(t);
  if (!e || typeof e != "object" || Array.isArray(e)) {
    return t.trim() && !t.trim().startsWith("{") ? t : null;
  }
  const n = e, r = [n.query, n.q, n.path, n.url, n.document_id].filter(i => typeof i == "string" && i.trim().length > 0).slice(0, 2);
  return r.length > 0 ? r.join(" \u2022 ") : null;
}
function Dm(t) {
  return !!t && typeof t == "object" && !Array.isArray(t);
}
function CV(t) {
  const e = t.match(/`+/g), n = e ? Math.max(...e.map(r => r.length)) : 0;
  return "`".repeat(n + 1);
}
function AV(t, e = "text") {
  const r = (t.match(/`+/g) ?? []).reduce((s, o) => Math.max(s, o.length), 0), i = "`".repeat(Math.max(3, r + 1));
  return `${i}${e}
${t}
${i}`;
}
function Wl(t) {
  const e = CV(t);
  return `${e}${t}${e}`;
}
function Lm(t) {
  if (t === null) {
    return "null";
  }
  if (t === void 0) {
    return "undefined";
  }
  if (typeof t == "number" || typeof t == "boolean") {
    return String(t);
  }
  if (typeof t == "string") {
    const e = t.trim();
    return e ? e.includes(`
`) ? `

${AV(e, "text")}` : e.length > 180 ? Wl(SV(e, 180)) : Wl(e) : Wl("");
  }
  return Wl(String(t));
}
function ac(t, e = 0) {
  if (e >= xV) {
    return "- \u2026 (max depth)";
  }
  if (!Dm(t) && !Array.isArray(t)) {
    return Lm(t);
  }
  if (Array.isArray(t)) {
    if (t.length === 0) {
      return "- (empty)";
    }
    const o = t.slice(0, wV), a = [];
    for (const c of o) {
      if (Dm(c) || Array.isArray(c)) {
        const u = ac(c, e + 1).split(`
`).map(h => `  ${h}`).join(`
`);
        a.push(`-
${u}`);
      } else {
        a.push(`- ${Lm(c)}`);
      }
    }
    const l = t.length - o.length;
    return l > 0 && a.push(`- \u2026 (${l} more item(s))`), a.join(`
`);
  }
  const n = Object.keys(t);
  if (n.length === 0) {
    return "- (empty)";
  }
  const r = n.slice(0, vV), i = [];
  for (const o of r) {
    const a = t[o];
    if (Dm(a) || Array.isArray(a)) {
      const l = ac(a, e + 1).split(`
`).map(c => `  ${c}`).join(`
`);
      i.push(`- ${Wl(o)}:
${l}`);
    } else {
      i.push(`- ${Wl(o)}: ${Lm(a)}`);
    }
  }
  const s = n.length - r.length;
  return s > 0 && i.push(`- \u2026 (${s} more key(s))`), i.join(`
`);
}
function j_(t) {
  const e = n1(t);
  if (e) {
    return ac(e);
  }
  const n = cN(t);
  if (n) {
    const s = Wu(n), o = ju(s.text);
    return s.truncated ? `${o}

_(truncated)_` : o;
  }
  const r = Wu(t), i = ju(r.text);
  return r.truncated ? `${i}

_(truncated)_` : i;
}
function Mm(t) {
  const e = n1(t);
  if (e) {
    const s = Of(e);
    if (s && s.trim().length > 0) {
      const o = Wu(s), a = ju(o.text);
      return o.truncated ? `${a}

_(truncated)_` : a;
    }
    return ac(e);
  }
  const n = cN(t);
  if (n) {
    const s = Wu(n), o = ju(s.text);
    return s.truncated ? `${o}

_(truncated)_` : o;
  }
  const r = Wu(t), i = ju(r.text);
  return r.truncated ? `${i}

_(truncated)_` : i;
}
function gp({receipt:t, isLive:e, defaultExpanded:n = !1}) {
  const r = t.status ?? "running", i = r === "running", s = t.is_error || r === "failed", o = t.tool_name ?? t.id ?? "tool", a = W_(t.input_preview), l = W_(t.result_preview), c = t.input, u = t.result, h = a ? TV(a) : null, f = c != null ? typeof c == "string" ? j_(c) : ac(c) : a ? j_(a) : "_(inputs unavailable)_", p = u != null ? typeof u == "string" ? Mm(u) : ac(u) : l ? Mm(l) : "", g = Array.isArray(t.contentParts) ? t.contentParts : [], m = !p && t.updates && t.updates.length > 0 ? Mm(t.updates[t.updates.length - 
  1]) : "", b = i ? "warning" : s ? "error" : "success", x = i ? "running" : s ? "failed" : "completed", w = i ? "1px solid var(--token-colors-accent-cyan)" : s ? "1px solid var(--token-colors-accent-red)" : "1px solid var(--token-colors-accent-green)", v = i ? "var(--token-colors-alpha-cyan-_08)" : s ? "var(--token-colors-alpha-red-_08)" : "var(--token-colors-alpha-green-_08)", T = {border:"1px solid var(--token-colors-border-default)", borderRadius:8, padding:8, background:"var(--token-colors-background-surface)"};
  return (0,require$react_SLASH_jsx_runtime.jsxs)(Mn, {variant:"outlined", padding:"sm", style:{border:w, background:v, marginBottom:8}, children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{display:"flex", alignItems:"center", gap:8, marginBottom:8}, children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{fontSize:12, fontWeight:600, color:"var(--token-colors-text-default)"}, children:o}), (0,require$react_SLASH_jsx_runtime.jsx)(ct, {size:"sm", variant:b, children:e && i ? "streaming..." : 
  x}), i && (0,require$react_SLASH_jsx_runtime.jsx)("span", {style:{width:8, height:8, borderRadius:"50%", background:"var(--token-colors-accent-cyan)", animation:"pulse 1.5s infinite"}})]}), h ? (0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{marginBottom:8, fontSize:11, color:"var(--token-colors-text-muted)"}, children:h}) : null, (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{...T, marginBottom:8}, children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{fontSize:11, fontWeight:600, 
  color:"var(--token-colors-text-muted)", marginBottom:6}, children:"Inputs"}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{fontSize:12, color:"var(--token-colors-text-default)", maxHeight:n ? 420 : 160, overflow:"auto"}, children:(0,require$react_SLASH_jsx_runtime.jsx)(mr, {content:f, theme:"dark", variant:"compact", lineNumbers:!1, copyButton:!1})})]}), p ? (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{...T, marginBottom:8}, children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", 
  {style:{fontSize:11, fontWeight:600, color:"var(--token-colors-text-muted)", marginBottom:6}, children:"Output"}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{fontSize:12, color:"var(--token-colors-text-default)", maxHeight:n ? 520 : 320, overflow:"auto"}, children:(0,require$react_SLASH_jsx_runtime.jsx)(mr, {content:p, theme:"dark", variant:"compact", lineNumbers:!1, copyButton:!1})})]}) : null, !p && m ? (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{...T, marginBottom:8}, 
  children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{fontSize:11, fontWeight:600, color:"var(--token-colors-text-muted)", marginBottom:6}, children:"Output (streaming)"}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{fontSize:12, color:"var(--token-colors-text-default)", maxHeight:n ? 420 : 220, overflow:"auto"}, children:(0,require$react_SLASH_jsx_runtime.jsx)(mr, {content:m, theme:"dark", variant:"compact", lineNumbers:!1, copyButton:!1})})]}) : null, g.length > 0 ? (0,require$react_SLASH_jsx_runtime.jsxs)("div", 
  {style:{...T, marginBottom:8}, children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{fontSize:11, fontWeight:600, color:"var(--token-colors-text-muted)", marginBottom:6}, children:"Attachments"}), (0,require$react_SLASH_jsx_runtime.jsx)(Ra, {parts:g, maxPreviewWidth:n ? 480 : 320, maxPreviewHeight:n ? 360 : 240})]}) : null, i && !p && !m ? (0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{fontSize:11, color:"var(--token-colors-text-muted)", marginTop:4}, children:"Waiting for tool output\u2026"}) : 
  null]});
}
function V_({receipts:t, liveEvents:e, defaultExpanded:n = !1}) {
  const r = new Map();
  if (e) {
    for (const s of e) {
      s.type === "tool_start" && s.tool_name ? r.set(s.tool_name, {status:"running", preview:s.preview}) : s.type === "tool_end" && s.tool_name && r.set(s.tool_name, {status:s.is_error ? "failed" : "completed", preview:s.preview});
    }
  }
  const i = t.filter(s => s.status === "completed" || s.status === "failed" || s.status === "running");
  return i.length === 0 ? null : (0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{marginBottom:12}, children:i.map(s => (0,require$react_SLASH_jsx_runtime.jsx)(gp, {receipt:s, isLive:s.status === "running", defaultExpanded:n}, s.id))});
}
function NV(t) {
  return t === "done" ? "success" : t === "error" ? "error" : "warning";
}
function IV({block:t}) {
  const e = t.kind === "reasoning" ? "Reasoning" : "Agent message";
  return (0,require$react_SLASH_jsx_runtime.jsxs)(Mn, {variant:"outlined", padding:"sm", style:{border:t.kind === "reasoning" ? "1px solid var(--token-colors-accent-orange)" : "1px solid var(--token-colors-accent-cyan)", background:t.kind === "reasoning" ? "var(--token-colors-alpha-orange-_12)" : "var(--token-colors-alpha-blue-_15)", marginBottom:8}, children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{display:"flex", alignItems:"center", gap:8, marginBottom:8, flexWrap:"wrap"}, children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", 
  {style:{fontSize:12, fontWeight:600, color:"var(--token-colors-text-default)"}, children:e}), (0,require$react_SLASH_jsx_runtime.jsx)(ct, {size:"sm", variant:NV(t.status), children:t.status ?? "streaming"})]}), (0,require$react_SLASH_jsx_runtime.jsx)(mr, {content:t.content || "", theme:"dark", variant:"compact", lineNumbers:!1, copyButton:!1})]});
}
function OV({blocks:t}) {
  return t.length === 0 ? null : (0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{display:"grid", gap:8, marginBottom:8}, children:t.map(e => e.kind === "tool_call" ? (0,require$react_SLASH_jsx_runtime.jsx)(gp, {receipt:{id:e.toolCallId ?? e.id, tool_name:e.toolName, status:e.status === "done" ? "completed" : e.status === "error" ? "failed" : "running", input_preview:e.inputPreview, result_preview:e.outputPreview, updates:e.updates, is_error:e.isError}, isLive:e.status === "streaming", defaultExpanded:!0}, 
  e.id) : (0,require$react_SLASH_jsx_runtime.jsx)(IV, {block:e}, e.id))});
}
const PV = {".png":{kind:"image", mimeType:"image/png"}, ".apng":{kind:"image", mimeType:"image/png"}, ".jpg":{kind:"image", mimeType:"image/jpeg"}, ".jpeg":{kind:"image", mimeType:"image/jpeg"}, ".gif":{kind:"image", mimeType:"image/gif"}, ".webp":{kind:"image", mimeType:"image/webp"}, ".svg":{kind:"image", mimeType:"image/svg+xml"}, ".mp3":{kind:"audio", mimeType:"audio/mpeg"}, ".wav":{kind:"audio", mimeType:"audio/wav"}, ".ogg":{kind:"audio", mimeType:"audio/ogg"}, ".m4a":{kind:"audio", mimeType:"audio/mp4"}, 
".flac":{kind:"audio", mimeType:"audio/flac"}, ".aac":{kind:"audio", mimeType:"audio/aac"}, ".mp4":{kind:"video", mimeType:"video/mp4"}, ".webm":{kind:"video", mimeType:"video/webm"}, ".mov":{kind:"video", mimeType:"video/quicktime"}, ".avi":{kind:"video", mimeType:"video/x-msvideo"}, ".pdf":{kind:"document", mimeType:"application/pdf"}};
function uN(t) {
  return t.split(/[?#]/, 1)[0] ?? t;
}
function RV(t) {
  const e = uN(t).trim(), n = e.lastIndexOf(".");
  return n < 0 ? null : e.slice(n).toLowerCase();
}
function DV(t) {
  const e = uN(t).replace(/\\/g, "/");
  return e.split("/").filter(Boolean).at(-1) ?? e;
}
function LV(t) {
  return /^https?:\/\//i.test(t);
}
function q_(t) {
  const e = t.trim();
  if (!e) {
    return e;
  }
  const n = e.startsWith("\x3c") && e.endsWith("\x3e") ? e.slice(1, -1) : e;
  return n.split(/\s+/, 1)[0] ?? n;
}
function MV(t) {
  const e = t.replace(/^@/, "").trim();
  return `/api/workspace-media/raw?path=${encodeURIComponent(e)}`;
}
function Y_(t, e) {
  const n = RV(t);
  if (!n) {
    return null;
  }
  const r = PV[n];
  if (!r) {
    return null;
  }
  const i = LV(t) ? null : t.startsWith("/") ? t : MV(t);
  if (!i) {
    return null;
  }
  const s = (e ?? "").trim() || DV(t);
  return {type:r.kind, url:i, filename:s, mimeType:r.mimeType};
}
function BV(t) {
  const e = [];
  return {masked:t.replace(/```[\s\S]*?```/g, r => {
    const i = e.length;
    return e.push(r), `@@CODEBLOCK_${i}@@`;
  }), blocks:e};
}
function $V(t, e) {
  let n = t;
  for (let r = 0; r < e.length; r += 1) {
    const i = `@@CODEBLOCK_${r}@@`;
    n = n.split(i).join(e[r] ?? "");
  }
  return n;
}
function FV(t) {
  if (!t) {
    return {markdown:t, contentParts:[]};
  }
  const {masked:e, blocks:n} = BV(t), r = [], i = new Set(), s = e.replace(/!\[([^\]]*)\]\(([^)]+)\)/g, (o, a, l) => {
    const c = q_(l), u = Y_(c, a);
    if (!u || !u.url) {
      return o;
    }
    const h = `${u.type}:${u.url}`;
    return i.has(h) || (i.add(h), r.push(u)), `${(a ?? "").trim() || u.filename || "media"} (embedded below)`;
  }).replace(/\[([^\]]+)\]\(([^)]+)\)/g, (o, a, l, c) => {
    if (c > 0 && e[c - 1] === "!") {
      return o;
    }
    const u = q_(l), h = Y_(u, a);
    if (!h || !h.url) {
      return o;
    }
    const f = `${h.type}:${h.url}`;
    return i.has(f) || (i.add(f), r.push(h)), `${(a ?? "").trim() || h.filename || "media"} (embedded below)`;
  });
  return {markdown:$V(s, n), contentParts:r};
}
function dN(t) {
  return t.source_path ?? t.message ?? t.source ?? t.id;
}
function Cb(t) {
  const e = t.config ?? {};
  if (e.workspace_source === !0 || e.workspaceSource === !0) {
    return !0;
  }
  const n = (t.name ?? "").trim().toLowerCase();
  return n === "workspace" || n.endsWith(" workspace");
}
function zV(t) {
  const e = t.split("/").filter(Boolean);
  return e.length <= 1 ? "" : e.slice(0, -1).join("/");
}
function HV(t) {
  const n = (t.content.split(`
`).find(r => r.trim()) ?? "Draft").slice(0, 80);
  return {title:n, subject:n, content:t.content};
}
function Bm(t) {
  return t.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "").slice(0, 64) || "draft";
}
function Da(t) {
  const e = t.split("/").filter(Boolean);
  return e[e.length - 1] || t;
}
function G_(t) {
  const e = Da(t.path).replace(/\.[^.]+$/, "") || "Scratchpad";
  return {title:e, subject:e, content:t.content, path:t.path};
}
function Ab(t) {
  if (!t) {
    return "";
  }
  try {
    const e = new URL(t, window.location.origin);
    return decodeURIComponent(e.pathname.replace(/^\/+/, "")).split("?")[0].split("#")[0];
  } catch {
    return decodeURIComponent(t.replace(/^\/+/, "")).split("?")[0].split("#")[0];
  }
}
function UV(t) {
  if (t.length === 0) {
    return null;
  }
  const e = [...t].sort((i, s) => {
    const o = Date.parse(s.started_at || s.created_at || s.completed_at || "") || 0, a = Date.parse(i.started_at || i.created_at || i.completed_at || "") || 0;
    return o - a;
  }), n = e.find(i => i.status === "running" || i.status === "pending");
  if (n) {
    return n;
  }
  const r = e.find(i => i.status === "completed");
  return r || (e[0] ?? null);
}
function WV(t) {
  if (!t) {
    return null;
  }
  const e = Date.parse(t);
  return Number.isNaN(e) ? t : (new Date(e)).toLocaleString();
}
function io(t, e = 240) {
  return t.length <= e ? t : `${t.slice(0, e).trimEnd()}\u2026`;
}
function jl(t) {
  const e = t.trim();
  return e ? /^(```|#{1,6}\s|>\s|[-*+]\s|\d+\.\s)/m.test(e) ? t : e.startsWith("{") || e.startsWith("[") || t.includes(`
`) ? `\`\`\`text
${t}
\`\`\`` : t : "";
}
function jV(t) {
  const e = t.result_preview;
  if (typeof e != "string" || e.trim().length === 0) {
    return null;
  }
  try {
    const n = JSON.parse(e), r = n == null ? void 0 : n.details;
    return r && typeof r == "object" && !Array.isArray(r) ? r : null;
  } catch {
    return null;
  }
}
function VV(t) {
  const e = jV(t);
  return !e || e.canvas !== !0 ? null : {title:typeof e.title == "string" ? e.title : void 0, path:typeof e.path == "string" ? e.path : void 0, content:typeof e.content == "string" ? e.content : void 0};
}
function $m(t) {
  return t === "system" || t === "user" || t === "assistant";
}
function ja(t) {
  if (!t.extra) {
    return null;
  }
  if (typeof t.extra == "object" && !Array.isArray(t.extra)) {
    return t.extra;
  }
  if (typeof t.extra == "string") {
    try {
      const e = JSON.parse(t.extra);
      return e && typeof e == "object" && !Array.isArray(e) ? e : null;
    } catch {
      return null;
    }
  }
  return null;
}
function Vu(t) {
  const e = ja(t), n = (e == null ? void 0 : e.run_id) ?? (e == null ? void 0 : e.runId);
  return typeof n == "string" ? n : null;
}
function hN(t) {
  return t === "streaming" || t === "done" || t === "error" ? t : void 0;
}
function qV(t) {
  const e = ja(t), n = (e == null ? void 0 : e.trace_blocks) ?? (e == null ? void 0 : e.traceBlocks);
  if (!Array.isArray(n)) {
    return;
  }
  const r = n.flatMap((i, s) => {
    if (!i || typeof i != "object") {
      return [];
    }
    const o = i, a = typeof o.kind == "string" ? o.kind : null;
    return a !== "agent_message" && a !== "reasoning" && a !== "tool_call" ? [] : [{id:typeof o.id == "string" && o.id ? o.id : `${a}:${s}`, kind:a, status:hN(o.status), at:typeof o.at == "string" ? o.at : void 0, content:typeof o.content == "string" ? o.content : void 0, toolName:typeof o.toolName == "string" ? o.toolName : void 0, toolCallId:typeof o.toolCallId == "string" ? o.toolCallId : void 0, inputPreview:typeof o.inputPreview == "string" ? o.inputPreview : void 0, outputPreview:typeof o.outputPreview == 
    "string" ? o.outputPreview : void 0, updates:Array.isArray(o.updates) ? o.updates.filter(l => typeof l == "string") : void 0, isError:typeof o.isError == "boolean" ? o.isError : void 0}];
  });
  return r.length > 0 ? r : void 0;
}
function YV(t) {
  const e = new Map(), n = (r, i) => {
    const s = e.get(r) ?? [];
    s.push(i), e.set(r, s);
  };
  return t.forEach((r, i) => {
    const s = Vu(r);
    if (s) {
      if (r.kind === "knoxx.reasoning" && typeof r.text == "string" && r.text.trim()) {
        n(s, {id:r.id || `reasoning:${i}`, kind:"reasoning", status:"done", at:typeof r.ts == "string" ? r.ts : void 0, content:r.text});
        return;
      }
      if (r.kind === "knoxx.tool_receipt") {
        const o = ja(r), a = o == null ? void 0 : o.receipt, l = a && typeof a == "object" && !Array.isArray(a) ? a : null;
        n(s, {id:typeof(l == null ? void 0 : l.id) == "string" && l.id || r.id || `tool:${i}`, kind:"tool_call", status:hN(typeof(l == null ? void 0 : l.status) == "string" ? l.status === "completed" ? "done" : l.status === "failed" ? "error" : "streaming" : "done"), at:typeof r.ts == "string" ? r.ts : void 0, toolName:typeof(l == null ? void 0 : l.tool_name) == "string" ? l.tool_name : void 0, toolCallId:typeof(l == null ? void 0 : l.id) == "string" ? l.id : void 0, inputPreview:typeof(l == null ? 
        void 0 : l.input_preview) == "string" ? l.input_preview : void 0, outputPreview:typeof(l == null ? void 0 : l.result_preview) == "string" ? l.result_preview : typeof r.text == "string" ? r.text : void 0, updates:Array.isArray(l == null ? void 0 : l.updates) ? l.updates.filter(c => typeof c == "string") : void 0, isError:typeof(l == null ? void 0 : l.is_error) == "boolean" ? l.is_error : void 0});
      }
    }
  }), e;
}
function Q_(t) {
  const e = YV(t), n = t.some(i => i.kind === "knoxx.message" && $m(i.role) && typeof i.text == "string" && i.text.trim().length > 0), r = new Set();
  for (const i of t) {
    if (i.kind === "knoxx.message" && i.role === "assistant") {
      const s = Vu(i);
      s && r.add(s);
    }
  }
  return t.flatMap((i, s) => {
    if (i.kind === "knoxx.run") {
      const u = Vu(i), h = u ? e.get(u) : void 0;
      if (u && !r.has(u) && h && h.length > 0) {
        const f = ja(i), p = typeof(f == null ? void 0 : f.status) == "string" ? f.status : void 0;
        return [{id:i.id || `${u}:run`, role:"assistant", content:typeof i.text == "string" ? i.text : "", model:typeof i.model == "string" ? i.model : null, runId:u, status:p === "failed" ? "error" : "done", traceBlocks:h}];
      }
      return [];
    }
    const o = typeof i.text == "string" ? i.text : "", a = i.kind === "knoxx.message", l = !n && !a && $m(i.role) && o.trim().length > 0;
    if (!a && !l || !$m(i.role) || o.trim().length === 0) {
      return [];
    }
    const c = Vu(i);
    return [{id:i.id || `${i.session ?? "memory"}:${s}`, role:i.role, content:o, model:typeof i.model == "string" ? i.model : null, runId:c, status:i.role === "assistant" || i.role === "system" ? "done" : void 0, traceBlocks:i.role === "assistant" ? qV(i) ?? (c ? e.get(c) : void 0) : void 0}];
  });
}
function GV(t, e = 1) {
  var i;
  let n = [...t], r = Math.max(1, e);
  for (; r > 0 && n.length > 0;) {
    const s = (i = [...n].map((o, a) => ({message:o, index:a})).reverse().find(({message:o}) => o.role === "user")) == null ? void 0 : i.index;
    if (s == null) {
      break;
    }
    n = n.slice(0, s), r -= 1;
  }
  return n;
}
function uu(t) {
  const e = String(t.type ?? ""), n = typeof t.preview == "string" ? t.preview.trim() : "", r = typeof t.run_id == "string" ? t.run_id : null, i = typeof t.error == "string" ? t.error.trim() : "", s = {steer_queued:"Steer queued", follow_up_queued:"Follow-up queued", steer_failed:"Steer failed", follow_up_failed:"Follow-up failed"}[e];
  if (!s) {
    return null;
  }
  const o = `control:${e}:${r ?? ""}:${n || i}`, a = [`### ${s}`];
  return n && a.push("", n), i && a.push("", `Error: ${i}`), r && a.push("", `Run: \`${r.slice(0, 8)}\``), {id:o, role:"system", content:a.join(`
`), runId:r, status:e.endsWith("failed") ? "error" : "done"};
}
function QV(t) {
  const e = typeof t.tool_call_id == "string" && t.tool_call_id.trim().length > 0 ? t.tool_call_id : null;
  return e ? `tool:${e}` : `tool:${typeof t.tool_name == "string" && t.tool_name.trim().length > 0 ? t.tool_name : "tool"}:${t.at ?? ""}`;
}
function Nb(t, e) {
  if (e.length === 0) {
    return "";
  }
  if (t.length === 0) {
    return e;
  }
  if (e === t) {
    return "";
  }
  if (e.startsWith(t)) {
    const r = e.slice(t.length);
    return /^\S+$/.test(t) && r.startsWith(t) && /^[\s\p{P}\p{S}]/u.test(r.slice(t.length)) ? r.slice(t.length) : r;
  }
  const n = Math.min(t.length, e.length);
  for (let r = n; r > 0; r -= 1) {
    if (t.endsWith(e.slice(0, r))) {
      return e.slice(r);
    }
  }
  return e;
}
function Ih(t, e, n, r) {
  if (n.length === 0) {
    return t;
  }
  const i = [...t], s = i[i.length - 1];
  if (s && s.kind === e && s.status === "streaming") {
    const o = Nb(s.content ?? "", n);
    return o.length === 0 || (i[i.length - 1] = {...s, content:`${s.content ?? ""}${o}`, at:s.at}), i;
  }
  return i.push({id:crypto.randomUUID(), kind:e, status:"streaming", content:n, at:r}), i;
}
function KV(t, e) {
  const n = String(e.type ?? ""), r = QV(e), i = [...t], s = i.findIndex(a => a.id === r), o = s >= 0 ? i[s] : null;
  if (n === "tool_start") {
    const a = {id:r, kind:"tool_call", toolName:e.tool_name, toolCallId:e.tool_call_id, inputPreview:typeof e.preview == "string" ? e.preview : void 0, status:"streaming", at:typeof e.at == "string" ? e.at : void 0, updates:[]};
    return s >= 0 ? i[s] = {...o, ...a} : i.push(a), i;
  }
  if (n === "tool_update") {
    const a = typeof e.preview == "string" ? e.preview : void 0;
    return s >= 0 ? i[s] = {...o, status:"streaming", at:typeof e.at == "string" ? e.at : o == null ? void 0 : o.at, updates:a ? [...((o == null ? void 0 : o.updates) ?? []).slice(-7), a] : o == null ? void 0 : o.updates} : i.push({id:r, kind:"tool_call", toolName:e.tool_name, toolCallId:e.tool_call_id, status:"streaming", at:typeof e.at == "string" ? e.at : void 0, updates:a ? [a] : []}), i;
  }
  if (n === "tool_end") {
    const a = {id:r, kind:"tool_call", toolName:e.tool_name, toolCallId:e.tool_call_id, status:e.is_error ? "error" : "done", outputPreview:typeof e.preview == "string" ? e.preview : void 0, isError:!!e.is_error, at:typeof e.at == "string" ? e.at : void 0};
    return s >= 0 ? i[s] = {...o, ...a, updates:o == null ? void 0 : o.updates, inputPreview:o == null ? void 0 : o.inputPreview} : i.push({...a, updates:[]}), i;
  }
  return t;
}
function XV(t, e) {
  return t.map(n => n.status === "streaming" ? {...n, status:e, isError:e === "error" ? n.isError ?? n.kind === "tool_call" : n.isError} : n);
}
function JV(t) {
  var n;
  const e = (n = t == null ? void 0 : t.resources) == null ? void 0 : n.passiveHydration;
  return !e || !Array.isArray(e.results) ? [] : e.results.flatMap(r => {
    const i = typeof r.path == "string" ? r.path : "";
    if (!i) {
      return [];
    }
    const s = {title:typeof r.name == "string" && r.name.trim().length > 0 ? r.name : Da(i), path:i};
    return typeof r.snippet == "string" && (s.section = r.snippet), [s];
  });
}
const ZV = [], eq = [], tq = ["\u2705", "\u274c", "\u2b50", "\ud83d\udc40", "\ud83d\ude02"];
function nq(t, e = {}) {
  var l, c;
  const n = t.traceBlocks ?? [], r = n.length > 0 && n.every(u => u.status === "done"), i = t.role === "assistant" && t.status === "streaming" && r && ((l = t.content) != null && l.trim()) ? "done" : t.status, s = t.role === "assistant" && i === "done" && n.length > 0 && !!((c = t.content) != null && c.trim()), a = n.some(u => u.kind === "tool_call") && !e.hasSeparateToolReceipts;
  return {effectiveStatus:i, visibleTraceBlocks:s && !a ? [] : n, showAssistantFinalCard:s};
}
function rq(t) {
  return t.runId && t.role === "assistant" ? `${t.runId}:assistant` : t.runId && t.role === "user" ? `${t.runId}:user` : t.id;
}
async function iq(t, e) {
  await Ie(`/api/data/op/labels/records/${encodeURIComponent(t)}/reaction`, {method:"POST", body:JSON.stringify({emoji:e, source:"knoxx-chat-ui"})});
}
const fN = (0,require$react.memo)(function({message:e, latestRun:n, latestToolReceipts:r, liveToolReceipts:i, liveToolEvents:s, assistantSurfaceBackground:o, assistantSurfaceBorder:a, assistantSurfaceText:l, onOpenMessageInCanvas:c, onOpenSourceInPreview:u, onPinAssistantSource:h, onAppendToScratchpad:f, onPinMessageContext:p}) {
  var C, k, A, P, W, F;
  const [g, m] = (0,require$react.useState)(null), b = (B, z) => {
    const j = rq(B);
    m(`${z} saving\u2026`), iq(j, z).then(() => m(`${z} saved`)).catch(V => m(`${z} failed: ${V.message}`));
  }, x = B => (0,require$react_SLASH_jsx_runtime.jsxs)("div", {role:"group", "aria-label":"Label message output", style:{display:"flex", alignItems:"center", gap:6, flexWrap:"wrap", marginTop:10}, children:[tq.map(z => (0,require$react_SLASH_jsx_runtime.jsx)(Ke, {variant:"ghost", size:"sm", title:z === "\u2705" ? "good output" : z === "\u274c" ? "bad output" : "reaction label", onClick:() => b(B, z), children:z}, z)), g ? (0,require$react_SLASH_jsx_runtime.jsx)("span", {style:{fontSize:11, color:"var(--token-colors-text-muted)"}, 
  children:g}) : null]}), w = B => (0,require$react_SLASH_jsx_runtime.jsxs)("div", {role:"group", "aria-label":"Assistant message actions", style:{display:"flex", alignItems:"center", gap:8, flexWrap:"wrap", marginTop:12, paddingTop:10, borderTop:"1px solid var(--token-colors-border-subtle, var(--token-colors-border-default))"}, children:[(0,require$react_SLASH_jsx_runtime.jsx)(Ke, {variant:"ghost", size:"sm", onClick:() => c(B), children:"Open in Scratchpad"}), x(B)]}), v = e.role === "assistant" && 
  !!e.runId && (n == null ? void 0 : n.run_id) === e.runId && r.length > 0, {effectiveStatus:T, visibleTraceBlocks:I, showAssistantFinalCard:_} = (0,require$react.useMemo)(() => nq(e, {hasSeparateToolReceipts:v}), [v, e]), {embeddedMarkdown:N, mergedContentParts:E} = (0,require$react.useMemo)(() => {
    const {markdown:B, contentParts:z} = FV(e.content || "");
    return {embeddedMarkdown:B, mergedContentParts:(e.contentParts ?? []).concat(z)};
  }, [e.content, e.contentParts]);
  return (0,require$react_SLASH_jsx_runtime.jsxs)(Mn, {variant:"outlined", padding:"sm", style:{borderColor:e.role === "user" ? "var(--token-colors-alpha-green-_30)" : e.role === "system" ? "var(--token-colors-alpha-cyan-_30)" : "var(--token-colors-border-default)", background:e.role === "user" ? "var(--token-colors-alpha-green-_08)" : e.role === "system" ? "var(--token-colors-alpha-cyan-_08)" : "var(--token-colors-background-surface)", alignSelf:e.role === "user" ? "flex-end" : "flex-start", maxWidth:e.role === 
  "user" ? "80%" : "100%"}, children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{display:"flex", alignItems:"center", justifyContent:"space-between", gap:8, marginBottom:6}, children:(0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{display:"flex", alignItems:"center", gap:8}, children:[(0,require$react_SLASH_jsx_runtime.jsx)("span", {style:{fontSize:11, fontWeight:600, textTransform:"uppercase", color:"var(--token-colors-text-muted)"}, children:e.role}), e.model ? (0,require$react_SLASH_jsx_runtime.jsx)(ct, 
  {size:"sm", variant:"info", children:e.model}) : null, T ? (0,require$react_SLASH_jsx_runtime.jsx)(ct, {size:"sm", variant:T === "done" ? "success" : T === "error" ? "error" : "warning", children:T}) : null, e.runId ? (0,require$react_SLASH_jsx_runtime.jsx)(ct, {size:"sm", variant:"default", children:e.runId.slice(0, 8)}) : null, e.role === "assistant" ? (0,require$react_SLASH_jsx_runtime.jsx)(ct, {size:"sm", variant:(C = e.sources) != null && C.length || (k = e.contextRows) != null && k.length ? 
  "success" : "warning", children:(A = e.sources) != null && A.length ? `${e.sources.length} source(s)` : (P = e.contextRows) != null && P.length ? `${e.contextRows.length} context row(s)` : "No grounding metadata"}) : null]})}), e.role === "assistant" && I.length > 0 ? (0,require$react_SLASH_jsx_runtime.jsx)(OV, {blocks:I}) : null, e.role === "assistant" && I.length === 0 && T === "streaming" && i.length > 0 && (0,require$react_SLASH_jsx_runtime.jsx)(V_, {receipts:i, liveEvents:s, defaultExpanded:!1}), 
  e.role === "assistant" && I.length === 0 && T === "done" && e.runId && (n == null ? void 0 : n.run_id) === e.runId && r.length > 0 && (0,require$react_SLASH_jsx_runtime.jsxs)("details", {style:{marginTop:8, marginBottom:8}, open:!1, children:[(0,require$react_SLASH_jsx_runtime.jsxs)("summary", {style:{cursor:"pointer", fontSize:11, fontWeight:600, color:"var(--token-colors-text-muted)"}, children:["Tool calls (", r.length, ")"]}), (0,require$react_SLASH_jsx_runtime.jsx)(V_, {receipts:r, defaultExpanded:!1})]}), 
  _ ? (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{border:"1px solid var(--token-colors-border-strong, var(--token-colors-border-default))", background:"var(--token-colors-background-canvas)", borderRadius:10, padding:12, marginTop:4}, children:[(0,require$react_SLASH_jsx_runtime.jsx)(mr, {content:N, theme:"dark", variant:"full"}), E.length > 0 ? (0,require$react_SLASH_jsx_runtime.jsx)(Ra, {parts:E}) : null, w(e)]}) : e.role === "assistant" || e.role === "system" ? (0,require$react_SLASH_jsx_runtime.jsxs)(require$react_SLASH_jsx_runtime.Fragment, 
  {children:[(0,require$react_SLASH_jsx_runtime.jsx)(mr, {content:N, theme:"dark", variant:"full"}), E.length > 0 ? (0,require$react_SLASH_jsx_runtime.jsx)(Ra, {parts:E}) : null, e.role === "assistant" ? w(e) : null]}) : (0,require$react_SLASH_jsx_runtime.jsxs)(require$react_SLASH_jsx_runtime.Fragment, {children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{fontSize:14, whiteSpace:"pre-wrap", lineHeight:1.6}, children:N}), E.length > 0 ? (0,require$react_SLASH_jsx_runtime.jsx)(Ra, {parts:E}) : 
  null, e.attachments && e.attachments.length > 0 && (0,require$react_SLASH_jsx_runtime.jsx)(Ra, {parts:e.attachments.map(B => ({type:B.type, url:B.url, data:B.data, mimeType:B.mimeType, filename:B.filename, size:B.size}))})]}), (W = e.sources) != null && W.length ? (0,require$react_SLASH_jsx_runtime.jsxs)("details", {style:{marginTop:12}, open:!0, children:[(0,require$react_SLASH_jsx_runtime.jsxs)("summary", {style:{cursor:"pointer", fontSize:12, fontWeight:600, color:"var(--token-colors-text-muted)"}, 
  children:["Grounding sources (", e.sources.length, ")"]}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{display:"grid", gap:8, marginTop:10}, children:e.sources.map((B, z) => {
    const j = Ab(B.url);
    return (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{border:`1px solid ${a}`, borderRadius:8, padding:10, background:o, color:l}, children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{display:"flex", alignItems:"center", justifyContent:"space-between", gap:8, marginBottom:6}, children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{minWidth:0}, children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{fontSize:12, fontWeight:600, color:"var(--token-colors-text-default)", 
    overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap"}, children:B.title || Da(j)}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{fontSize:10, color:l, opacity:0.84, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap"}, children:j || B.url})]}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{display:"flex", gap:6, flexWrap:"wrap"}, children:[j ? (0,require$react_SLASH_jsx_runtime.jsx)(Ke, {variant:"ghost", size:"sm", onClick:() => void u(B), children:"Open"}) : 
    null, (0,require$react_SLASH_jsx_runtime.jsx)(Ke, {variant:"ghost", size:"sm", onClick:() => h(B), children:"Pin"}), (0,require$react_SLASH_jsx_runtime.jsx)(Ke, {variant:"ghost", size:"sm", onClick:() => f(B.section || j || B.title, B.title), children:"Insert"})]})]}), B.section ? (0,require$react_SLASH_jsx_runtime.jsx)(mr, {content:jl(B.section), theme:"dark", variant:"compact", lineNumbers:!1, copyButton:!1}) : null]}, `${B.title}:${z}`);
  })})]}) : null, (F = e.contextRows) != null && F.length ? (0,require$react_SLASH_jsx_runtime.jsxs)("details", {style:{marginTop:12}, children:[(0,require$react_SLASH_jsx_runtime.jsxs)("summary", {style:{cursor:"pointer", fontSize:12, fontWeight:600, color:"var(--token-colors-text-muted)"}, children:["Auto-injected context (", e.contextRows.length, ")"]}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{display:"grid", gap:8, marginTop:10}, children:e.contextRows.map(B => (0,require$react_SLASH_jsx_runtime.jsxs)("div", 
  {style:{border:`1px solid ${a}`, borderRadius:8, padding:10, background:o, color:l}, children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{display:"flex", alignItems:"center", gap:6, flexWrap:"wrap", marginBottom:6}, children:[(0,require$react_SLASH_jsx_runtime.jsx)(ct, {size:"sm", variant:"default", children:B.project ?? "unknown-project"}), (0,require$react_SLASH_jsx_runtime.jsx)(ct, {size:"sm", variant:"default", children:B.kind ?? "unknown-kind"})]}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", 
  {style:{display:"flex", alignItems:"center", justifyContent:"space-between", gap:8, marginBottom:4}, children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{fontSize:12, fontWeight:600, color:"var(--token-colors-text-default)", overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap"}, children:dN(B)}), (0,require$react_SLASH_jsx_runtime.jsx)(Ke, {variant:"ghost", size:"sm", onClick:() => p(B), children:"Pin"})]}), (0,require$react_SLASH_jsx_runtime.jsx)(mr, {content:jl(B.snippet ?? 
  B.text ?? ""), theme:"dark", variant:"compact", lineNumbers:!1, copyButton:!1})]}, B.id))})]}) : null]});
});
fN.displayName = "ChatMessageCard";
function sq({messages:t, latestRun:e, latestToolReceipts:n, liveToolReceipts:r, liveToolEvents:i, assistantSurfaceBackground:s, assistantSurfaceBorder:o, assistantSurfaceText:a, onOpenMessageInCanvas:l, onOpenSourceInPreview:c, onPinAssistantSource:u, onAppendToScratchpad:h, onPinMessageContext:f}) {
  return (0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{display:"flex", flexDirection:"column", gap:12, width:"100%"}, children:t.map(p => {
    const g = p.role === "assistant" && p.status === "streaming";
    return (0,require$react_SLASH_jsx_runtime.jsx)(fN, {message:p, latestRun:e, latestToolReceipts:n, liveToolReceipts:g ? r : ZV, liveToolEvents:g ? i : eq, assistantSurfaceBackground:s, assistantSurfaceBorder:o, assistantSurfaceText:a, onOpenMessageInCanvas:l, onOpenSourceInPreview:c, onPinAssistantSource:u, onAppendToScratchpad:h, onPinMessageContext:f}, p.id);
  })});
}
function oq({wsStatus:t, isRecovering:e, latestRun:n, isSending:r, selectedModel:i, conversationId:s, activeRunId:o, hydrationSources:a, runtimeEvents:l, latestToolReceipts:c, assistantSurfaceBackground:u, assistantSurfaceBorder:h, assistantSurfaceText:f, onOpenHydrationSource:p, onPinHydrationSource:g, onAppendToScratchpad:m}) {
  return (0,require$react_SLASH_jsx_runtime.jsxs)(Mn, {variant:"outlined", padding:"sm", style:{marginBottom:12, background:"var(--token-colors-alpha-bg-_08)"}, children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{display:"flex", alignItems:"center", justifyContent:"space-between", gap:8, marginBottom:10, flexWrap:"wrap"}, children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{fontSize:12, fontWeight:700}, children:"Agent Runtime"}), 
  (0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{fontSize:11, color:"var(--token-colors-text-muted)"}, children:"Presence, witness thread, and receipt river for the active Knoxx turn."})]}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{display:"flex", gap:6, flexWrap:"wrap"}, children:[(0,require$react_SLASH_jsx_runtime.jsx)(ct, {size:"sm", variant:t === "connected" ? "success" : t === "connecting" ? "warning" : "error", children:t}), e && (0,require$react_SLASH_jsx_runtime.jsx)(ct, 
  {size:"sm", variant:"warning", children:"recovering"}), (0,require$react_SLASH_jsx_runtime.jsx)(ct, {size:"sm", variant:(n == null ? void 0 : n.status) === "completed" ? "success" : (n == null ? void 0 : n.status) === "failed" ? "error" : r ? "warning" : "default", children:(n == null ? void 0 : n.status) ?? (r ? "running" : "idle")}), (0,require$react_SLASH_jsx_runtime.jsx)(ct, {size:"sm", variant:"info", children:i || "no-model"})]})]}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{display:"grid", 
  gap:12, gridTemplateColumns:"repeat(auto-fit, minmax(220px, 1fr))"}, children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{display:"grid", gap:6}, children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{fontSize:11, fontWeight:700, textTransform:"uppercase", color:"var(--token-colors-text-muted)"}, children:"Presence"}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{fontSize:11, color:"var(--token-colors-text-subtle)"}, children:"Conversation"}), (0,require$react_SLASH_jsx_runtime.jsx)("div", 
  {style:{fontFamily:"var(--token-fontFamily-mono)", fontSize:11, borderRadius:8, border:"1px solid var(--token-colors-border-default)", padding:"6px 8px"}, children:s ?? "new / not started"}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{fontSize:11, color:"var(--token-colors-text-subtle)"}, children:"Latest run"}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{fontFamily:"var(--token-fontFamily-mono)", fontSize:11, borderRadius:8, border:"1px solid var(--token-colors-border-default)", 
  padding:"6px 8px"}, children:(n == null ? void 0 : n.run_id) ?? o ?? "waiting for first turn"}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{fontSize:11, color:"var(--token-colors-text-muted)"}, children:[(n == null ? void 0 : n.ttft_ms) != null ? `TTFT ${Math.round(n.ttft_ms)}ms` : "No token timing yet", (n == null ? void 0 : n.total_time_ms) != null ? ` \u2022 total ${Math.round(n.total_time_ms)}ms` : ""]})]}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{display:"grid", 
  gap:8}, children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{fontSize:11, fontWeight:700, textTransform:"uppercase", color:"var(--token-colors-text-muted)"}, children:"Witness Thread"}), a.length === 0 ? (0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{fontSize:11, color:"var(--token-colors-text-muted)", lineHeight:1.5}, children:"Passive hydration has not surfaced corpus witnesses for the latest run yet."}) : a.slice(0, 3).map(b => (0,require$react_SLASH_jsx_runtime.jsxs)("div", 
  {style:{border:`1px solid ${h}`, borderRadius:8, padding:8, background:u, color:f}, children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{fontSize:11, fontWeight:600, color:f}, children:b.title}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{fontSize:10, color:f, opacity:0.84, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap"}, children:b.path}), b.section ? (0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{marginTop:6}, children:(0,require$react_SLASH_jsx_runtime.jsx)(mr, 
  {content:jl(io(b.section, 180)), theme:"dark", variant:"compact", lineNumbers:!1, copyButton:!1})}) : null, (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{display:"flex", gap:6, marginTop:8, flexWrap:"wrap"}, children:[(0,require$react_SLASH_jsx_runtime.jsx)(Ke, {variant:"ghost", size:"sm", onClick:() => void p(b), children:"Open"}), (0,require$react_SLASH_jsx_runtime.jsx)(Ke, {variant:"ghost", size:"sm", onClick:() => g(b), children:"Pin"}), (0,require$react_SLASH_jsx_runtime.jsx)(Ke, 
  {variant:"ghost", size:"sm", onClick:() => m(b.section || b.path, b.title), children:"Insert"})]})]}, b.path))]}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{display:"grid", gap:8}, children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{fontSize:11, fontWeight:700, textTransform:"uppercase", color:"var(--token-colors-text-muted)"}, children:"Receipt River"}), l.length === 0 ? (0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{fontSize:11, color:"var(--token-colors-text-muted)"}, 
  children:"No live runtime events yet."}) : l.slice(-6).reverse().map((b, x) => (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{borderLeft:"2px solid var(--token-colors-accent-cyan)", padding:"8px 10px", borderRadius:8, background:u, color:f}, children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{fontSize:11, fontWeight:600, color:f}, children:[b.type ?? "event", b.tool_name ? ` \u2022 ${b.tool_name}` : ""]}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{fontSize:10, 
  color:f, opacity:0.84}, children:WV(b.at) ?? b.at ?? "just now"}), typeof b.preview == "string" && b.preview.trim().length > 0 ? (0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{marginTop:6}, children:(0,require$react_SLASH_jsx_runtime.jsx)(mr, {content:jl(io(b.preview, 300)), theme:"dark", variant:"compact", lineNumbers:!1, copyButton:!1})}) : null]}, `${b.type ?? "event"}:${b.at ?? ""}:${x}`))]})]}), c.length ? (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{marginTop:12, paddingTop:12, 
  borderTop:"1px solid var(--token-colors-border-default)", display:"grid", gap:8}, children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{fontSize:11, fontWeight:700, textTransform:"uppercase", color:"var(--token-colors-text-muted)"}, children:"Tool Receipts"}), c.slice(0, 4).map(b => (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{border:`1px solid ${h}`, borderRadius:8, padding:8, background:u, color:f}, children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{display:"flex", 
  alignItems:"center", justifyContent:"space-between", gap:8}, children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{fontSize:11, fontWeight:600, color:f}, children:b.tool_name ?? b.id}), (0,require$react_SLASH_jsx_runtime.jsx)(ct, {size:"sm", variant:b.status === "completed" ? "success" : b.status === "failed" ? "error" : "warning", children:b.status ?? "running"})]}), typeof b.input == "string" && String(b.input).trim().length > 0 || typeof b.input_preview == "string" && b.input_preview.trim().length > 
  0 ? (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{marginTop:6}, children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{fontSize:10, fontWeight:600, color:f, opacity:0.84, marginBottom:4}, children:"input"}), (0,require$react_SLASH_jsx_runtime.jsx)(mr, {content:jl(io(String(b.input ?? b.input_preview ?? ""), 800)), theme:"dark", variant:"compact", lineNumbers:!1, copyButton:!1})]}) : null, typeof b.result == "string" && String(b.result).trim().length > 0 || typeof b.result_preview == 
  "string" && b.result_preview.trim().length > 0 ? (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{marginTop:6}, children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{fontSize:10, fontWeight:600, color:f, opacity:0.84, marginBottom:4}, children:"output"}), (0,require$react_SLASH_jsx_runtime.jsx)(mr, {content:jl(io(String(b.result ?? b.result_preview ?? ""), 800)), theme:"dark", variant:"compact", lineNumbers:!1, copyButton:!1})]}) : null]}, b.id))]}) : null]});
}
function aq({canvasTitle:t, onCanvasTitleChange:e, canvasPath:n, onCanvasPathChange:r, canvasSubject:i, onCanvasSubjectChange:s, canvasRecipients:o, onCanvasRecipientsChange:a, canvasCc:l, onCanvasCcChange:c, canvasContent:u, onCanvasContentChange:h, canvasStatus:f, savingCanvas:p, savingCanvasFile:g, sendingCanvas:m, toolCatalog:b, onUseLatestAssistantInCanvas:x, onHide:w, onSaveCanvasDraft:v, onSaveCanvasFile:T, onClearScratchpad:I, onSendCanvasEmailAction:_}) {
  return (0,require$react_SLASH_jsx_runtime.jsxs)(Mn, {variant:"default", padding:"none", style:{width:420, flexShrink:0, borderLeft:"1px solid var(--token-colors-border-default)", display:"flex", flexDirection:"column", minHeight:0}, children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{padding:12, borderBottom:"1px solid var(--token-colors-border-default)", display:"flex", alignItems:"center", justifyContent:"space-between", gap:8}, children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", 
  {children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{fontSize:14, fontWeight:600}, children:"Canvas"}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{fontSize:11, color:"var(--token-colors-text-muted)"}, children:"Your active editor surface. Draft artifacts, open files, revise content, and save publishable documents from here."})]}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{display:"flex", gap:6}, children:[(0,require$react_SLASH_jsx_runtime.jsx)(Ke, {variant:"ghost", 
  size:"sm", onClick:x, children:"Use Latest"}), (0,require$react_SLASH_jsx_runtime.jsx)(Ke, {variant:"ghost", size:"sm", onClick:w, children:"Hide"})]})]}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{height:"100%", minHeight:0, display:"flex", flexDirection:"column", overflowY:"auto"}, children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{padding:12, display:"grid", gap:10, borderBottom:"1px solid var(--token-colors-border-default)", flexShrink:0}, children:[(0,require$react_SLASH_jsx_runtime.jsx)(Cn, 
  {value:t, onChange:N => e(N.target.value), placeholder:"Canvas title", size:"sm"}), (0,require$react_SLASH_jsx_runtime.jsx)(Cn, {value:n, onChange:N => r(N.target.value), placeholder:"Workspace path for the artifact file", size:"sm"}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{display:"flex", gap:8, flexWrap:"wrap"}, children:[(0,require$react_SLASH_jsx_runtime.jsx)(Ke, {variant:"secondary", size:"sm", loading:p, onClick:() => void v(), children:"Save document"}), (0,require$react_SLASH_jsx_runtime.jsx)(Ke, 
  {variant:"secondary", size:"sm", loading:g, onClick:() => void T(), children:"Write file"}), (0,require$react_SLASH_jsx_runtime.jsx)(Ke, {variant:"ghost", size:"sm", onClick:I, children:"New canvas"})]}), (0,require$react_SLASH_jsx_runtime.jsxs)("details", {children:[(0,require$react_SLASH_jsx_runtime.jsx)("summary", {style:{cursor:"pointer", fontSize:11, fontWeight:600, color:"var(--token-colors-text-muted)"}, children:"Optional delivery actions"}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", 
  {style:{display:"grid", gap:10, marginTop:10}, children:[(0,require$react_SLASH_jsx_runtime.jsx)(Cn, {value:i, onChange:N => s(N.target.value), placeholder:"Email subject", size:"sm"}), (0,require$react_SLASH_jsx_runtime.jsx)(Cn, {value:o, onChange:N => a(N.target.value), placeholder:"To: comma-separated emails", size:"sm"}), (0,require$react_SLASH_jsx_runtime.jsx)(Cn, {value:l, onChange:N => c(N.target.value), placeholder:"Cc: comma-separated emails", size:"sm"}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", 
  {style:{display:"flex", gap:8, flexWrap:"wrap"}, children:[(0,require$react_SLASH_jsx_runtime.jsx)(Ke, {variant:"primary", size:"sm", loading:m, disabled:!(b != null && b.email_enabled), onClick:() => void _(), children:"Send Email"}), b != null && b.email_enabled ? null : (0,require$react_SLASH_jsx_runtime.jsx)("span", {style:{fontSize:11, color:"var(--token-colors-text-muted)"}, children:"Email is optional and currently unavailable."})]})]})]}), f ? (0,require$react_SLASH_jsx_runtime.jsx)("div", 
  {style:{fontSize:11, color:"var(--token-colors-text-subtle)"}, children:f}) : null]}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{flex:1, minHeight:0, padding:12, display:"flex"}, children:(0,require$react_SLASH_jsx_runtime.jsx)("textarea", {value:u, onChange:N => h(N.target.value), placeholder:"Work here like a canvas editor: specs, notes, drafts, document revisions, publishable markdown, implementation plans, or excerpts from pinned context...", style:{width:"100%", height:"100%", 
  minHeight:280, borderRadius:8, border:"1px solid var(--token-colors-border-subtle)", padding:12, fontSize:13, lineHeight:1.6, resize:"none", fontFamily:"var(--token-fontFamily-mono)", background:"var(--token-colors-surface-input)", color:"var(--token-colors-text-default)"}})})]})]});
}
function lq({systemPrompt:t, onSystemPromptChange:e, conversationId:n, activeRole:r, activeActorId:i, activeAgentId:s, availableAgents:o, onActiveAgentChange:a, toolCatalog:l}) {
  const c = Array.isArray(l == null ? void 0 : l.tools) ? l.tools : [], u = c.filter(m => m.enabled), h = c.filter(m => !m.enabled), f = Array.isArray(l == null ? void 0 : l.capability_ids) ? l.capability_ids : [], p = {borderRadius:8, border:"1px solid var(--token-colors-border-subtle)", background:"var(--token-colors-surface-input)"}, g = {display:"block", fontSize:11, fontWeight:600, marginBottom:6, color:"var(--token-colors-text-muted)", textTransform:"uppercase", letterSpacing:0.4};
  return (0,require$react_SLASH_jsx_runtime.jsx)(Mn, {variant:"default", padding:"sm", style:{margin:8, flexShrink:0, maxHeight:"min(70vh, 40rem)", overflow:"hidden", minHeight:0}, children:(0,require$react_SLASH_jsx_runtime.jsxs)("div", {"data-testid":"chat-settings-scroll-region", style:{display:"grid", gap:16, maxHeight:"min(70vh, 40rem)", overflowY:"auto", overflowX:"hidden", paddingRight:4}, children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{display:"grid", gap:8}, children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", 
  {style:{fontSize:14, fontWeight:700}, children:"Runtime prompt"}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{fontSize:12, color:"var(--token-colors-text-muted)"}, children:"The effective system prompt is shown as its own full-width section so you can actually read the contract the agent is running with."}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{...p, padding:12}, children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{...g, marginBottom:8}, children:"Effective system prompt"}), 
  (0,require$react_SLASH_jsx_runtime.jsx)("pre", {style:{margin:0, whiteSpace:"pre-wrap", wordBreak:"break-word", fontSize:12, lineHeight:1.5, fontFamily:"var(--token-fontFamily-mono)", maxHeight:320, overflow:"auto"}, children:(l == null ? void 0 : l.system_prompt) ?? "No effective system prompt available for this runtime yet."})]}), l != null && l.actor_system_prompt || l != null && l.agent_system_prompt || l != null && l.task_prompt ? (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{display:"grid", 
  gap:8, gridTemplateColumns:"repeat(auto-fit, minmax(220px, 1fr))"}, children:[l != null && l.actor_system_prompt ? (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{...p, padding:10}, children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {style:g, children:"Actor prompt"}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{fontSize:12, lineHeight:1.4, wordBreak:"break-word"}, children:l.actor_system_prompt})]}) : null, l != null && l.agent_system_prompt ? (0,require$react_SLASH_jsx_runtime.jsxs)("div", 
  {style:{...p, padding:10}, children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {style:g, children:"Agent prompt"}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{fontSize:12, lineHeight:1.4, wordBreak:"break-word"}, children:l.agent_system_prompt})]}) : null, l != null && l.task_prompt ? (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{...p, padding:10}, children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {style:g, children:"Task prompt"}), (0,require$react_SLASH_jsx_runtime.jsx)("div", 
  {style:{fontSize:12, lineHeight:1.4, wordBreak:"break-word"}, children:l.task_prompt})]}) : null]}) : null]}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{display:"grid", gap:12, gridTemplateColumns:"repeat(auto-fit, minmax(240px, 1fr))", alignItems:"start"}, children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {children:[(0,require$react_SLASH_jsx_runtime.jsx)("label", {style:g, children:"Session steering note"}), (0,require$react_SLASH_jsx_runtime.jsx)("textarea", {value:t, onChange:m => 
  e(m.target.value), rows:5, style:{width:"100%", borderRadius:8, border:"1px solid var(--token-colors-border-subtle)", padding:10, fontSize:13, lineHeight:1.5, resize:"vertical", background:"var(--token-colors-surface-input)", color:"var(--token-colors-text-default)"}, placeholder:"Optional: steer the agent toward a specific outcome for upcoming turns..."}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{marginTop:6, fontSize:11, color:"var(--token-colors-text-muted)"}, children:"Appended as a lightweight steering note for future turns."})]}), 
  (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{display:"grid", gap:12}, children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {children:[(0,require$react_SLASH_jsx_runtime.jsx)("label", {style:g, children:"Conversation"}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{...p, padding:"10px 12px", fontSize:12, minHeight:40, color:"var(--token-colors-text-default)", fontFamily:"var(--token-fontFamily-mono)", wordBreak:"break-word"}, children:n ?? "new / not started"}), (0,require$react_SLASH_jsx_runtime.jsx)("div", 
  {style:{marginTop:6, fontSize:11, color:"var(--token-colors-text-muted)"}, children:"Multi-turn memory is preserved per conversation id."})]}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {children:[(0,require$react_SLASH_jsx_runtime.jsx)("label", {style:g, children:"Active agent"}), (0,require$react_SLASH_jsx_runtime.jsxs)("select", {value:s, onChange:m => a(m.target.value), style:{width:"100%", borderRadius:8, border:"1px solid var(--token-colors-border-subtle)", padding:"8px 10px", fontSize:12, 
  background:"var(--token-colors-surface-input)", color:"var(--token-colors-text-default)"}, children:[o.length === 0 ? (0,require$react_SLASH_jsx_runtime.jsx)("option", {value:"", children:"No agents available"}) : null, o.map(m => (0,require$react_SLASH_jsx_runtime.jsx)("option", {value:m.id, children:m.id}, m.id))]}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{marginTop:6, fontSize:11, color:"var(--token-colors-text-muted)"}, children:["Actor: ", i || "(default)"]}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", 
  {style:{marginTop:4, fontSize:11, color:"var(--token-colors-text-muted)"}, children:["Role: ", r]})]})]})]}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{display:"grid", gap:12, gridTemplateColumns:"repeat(auto-fit, minmax(260px, 1fr))", alignItems:"start"}, children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{...p, padding:12}, children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {style:g, children:"Capabilities"}), f.length > 0 ? (0,require$react_SLASH_jsx_runtime.jsx)("div", 
  {style:{display:"flex", flexWrap:"wrap", gap:6, maxHeight:124, overflow:"auto", paddingRight:4}, children:f.map((m, b) => (0,require$react_SLASH_jsx_runtime.jsx)(ct, {size:"sm", variant:"default", children:m}, `${m}:${b}`))}) : (0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{fontSize:12, color:"var(--token-colors-text-muted)"}, children:"No runtime capabilities reported."})]}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{...p, padding:12}, children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", 
  {style:g, children:"Tools"}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{display:"grid", gap:8}, children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{fontSize:11, color:"var(--token-colors-text-muted)", marginBottom:6}, children:["Enabled (", u.length, ")"]}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{display:"flex", flexWrap:"wrap", gap:6, maxHeight:96, overflow:"auto", paddingRight:4}, children:u.length > 
  0 ? u.map((m, b) => (0,require$react_SLASH_jsx_runtime.jsx)(ct, {size:"sm", variant:"default", children:m.label}, `${m.id}:${b}`)) : (0,require$react_SLASH_jsx_runtime.jsx)("span", {style:{fontSize:12, color:"var(--token-colors-text-muted)"}, children:"None"})})]}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{fontSize:11, color:"var(--token-colors-text-muted)", marginBottom:6}, children:["Disabled (", h.length, ")"]}), (0,require$react_SLASH_jsx_runtime.jsx)("div", 
  {style:{display:"flex", flexWrap:"wrap", gap:6, maxHeight:96, overflow:"auto", paddingRight:4}, children:h.length > 0 ? h.map((m, b) => (0,require$react_SLASH_jsx_runtime.jsx)(ct, {size:"sm", variant:"warning", children:m.label}, `${m.id}:${b}`)) : (0,require$react_SLASH_jsx_runtime.jsx)("span", {style:{fontSize:12, color:"var(--token-colors-text-muted)"}, children:"None"})})]})]})]})]})]})});
}
function cq({enabled:t, available:e, messages:n, defaultVoiceId:r, onPlaybackEnded:i}) {
  const [s, o] = (0,require$react.useState)("idle"), [a, l] = (0,require$react.useState)(null), c = (0,require$react.useRef)(null), u = (0,require$react.useRef)(null), h = (0,require$react.useRef)(new Set()), f = (0,require$react.useRef)(!1), p = (0,require$react.useCallback)(() => {
    const g = c.current;
    if (c.current = null, g) {
      try {
        g.pause();
      } catch {
      }
    }
    const m = u.current;
    if (u.current = null, m) {
      try {
        URL.revokeObjectURL(m);
      } catch {
      }
    }
  }, []);
  return (0,require$react.useEffect)(() => p, [p]), (0,require$react.useEffect)(() => {
    if (!t || !e) {
      p(), !e && t ? (o("error"), l("TTS is not configured.")) : (o("idle"), l(null));
      return;
    }
    if (t && !f.current) {
      for (const b of n) {
        b.role === "assistant" && b.status === "done" && b.id && h.current.add(b.id);
      }
    }
    f.current = t;
    const g = [...n].reverse().find(b => {
      var x;
      return b.role === "assistant" && b.status === "done" && !!((x = b.content) != null && x.trim()) && b.id;
    });
    if (!g || h.current.has(g.id)) {
      return;
    }
    h.current.add(g.id), p(), o("loading"), l(null);
    const m = g.content.trim();
    Zx({text:m, voice_id:r || void 0}).then(b => {
      const x = URL.createObjectURL(b);
      u.current = x;
      const w = new Audio(x);
      return c.current = w, w.onended = () => {
        c.current === w && (p(), o("idle"), i == null || i());
      }, w.onerror = () => {
        c.current === w && (p(), o("error"), l("Audio playback failed."));
      }, w.play();
    }).then(() => {
      o("playing");
    }).catch(b => {
      p(), o("error"), l(b instanceof Error ? b.message : String(b));
    });
  }, [e, t, n, r, p]), {status:s, error:a};
}
async function uq(t) {
  return Ie("/api/admin/contracts");
}
async function dq(t, e = "agents") {
  return Ie(`/api/admin/contracts/${encodeURIComponent(t)}?kind=${encodeURIComponent(e)}`);
}
async function hq(t, e, n = "agents") {
  return Ie(`/api/admin/contracts/${encodeURIComponent(t)}`, {method:"PUT", body:JSON.stringify({ednText:e, kind:n})});
}
async function fq(t, e = "agents") {
  return Ie("/api/admin/contracts/validate", {method:"POST", body:JSON.stringify({ednText:t, kind:e})});
}
async function pq(t, e, n = "agents") {
  return Ie(`/api/admin/contracts/${encodeURIComponent(t)}/copy`, {method:"POST", body:JSON.stringify({newId:e, kind:n})});
}
const Fm = `{:contract/id "new-agent"
 :contract/kind :agent
 :contract/version 1
 :enabled true
 :trigger-kind :event
 :source-kind :discord
 :source-mode :patrol
 :cadence-min 5

 :agent
 {:role :system_admin
  :model "glm-5"
  :thinking :off}

 :prompts
 {:system "Observe configured Discord channels, detect fresh human signals, and queue structured events without speaking publicly."
  :task   "Read recent channel messages, update freshness state, and dispatch normalized Discord events for worthy human signals."}

 :events
 {:always [:discord.mention]
  :maybe  [:discord.message :discord.reaction]}

 :data
 {:source  {:max-messages 25}
  :filters {:channels []
            :keywords []}
  :tools   []}

 :hooks
 {:before {}
  :after  {}}}
`, gq = ["discord.mention", "discord.message", "discord.message.keyword", "discord.message.mention", "discord.reaction", "discord.image-attachment", "discord.text-attachment", "github.issues.opened", "github.issues.closed", "github.pr.opened", "github.pr.merged", "github.push", "cron.tick", "manual.invoke"], mq = ["glm-5", "glm-5-plus", "gpt-5.5", "gpt-5.4", "gpt-5.4-mini", "claude-4-sonnet", "claude-4-opus", "kimi-k2.5"], bq = ["system_admin", "knowledge_worker", "executive", "analyst", "editor", 
"contract_librarian"], yq = ["event", "cron", "manual"], xq = ["discord", "github", "cron", "manual"], pN = ["off", "minimal", "low", "medium", "high", "xhigh"], zm = {title:"Chat", body:"Ask Knoxx anything about devel, your client work, or the artifact you are actively building.", detail:"Use the context bar like an IDE explorer, pin the context that matters, and use the canvas as your live working surface."};
function vq({showFiles:t, showSettings:e, showCanvas:n, showConsole:r, onShowFiles:i, showCanvasToggle:s = !0, showFilesToggle:o = !0, filesLabel:a = "Files", onToggleSettings:l, onToggleCanvas:c, onToggleConsole:u, selectedModel:h, onSelectedModelChange:f, selectedThinkingLevel:p, onSelectedThinkingLevelChange:g, proxxModels:m, proxxReachable:b, proxxConfigured:x, onNewChat:w, onUndoMessages:v, undoDisabled:T, systemPrompt:I, onSystemPromptChange:_, conversationId:N, activeRole:E, activeActorId:C, 
activeAgentId:k, availableAgents:A, onActiveAgentChange:P, toolCatalog:W, wsStatus:F, isRecovering:B, latestRun:z, isSending:j, liveControlEnabled:V, liveControlText:ne, onLiveControlTextChange:D, queueingControl:ie, onQueueLiveControl:ee, onVoiceSteer:M, abortingTurn:X, onAbortTurn:ge, activeRunId:me, hydrationSources:te, runtimeEvents:q, latestToolReceipts:R, liveToolReceipts:$, liveToolEvents:G, assistantSurfaceBackground:J, assistantSurfaceBorder:U, assistantSurfaceText:le, messages:be, consoleLines:je, 
onSend:Ae, composerDisabled:ue, onOpenHydrationSource:Le, onPinHydrationSource:$e, onAppendToScratchpad:Ye, onOpenMessageInCanvas:Me, onOpenSourceInPreview:Xe, onPinAssistantSource:it, onPinMessageContext:se, canvasTitle:oe, onCanvasTitleChange:we, canvasPath:ke, onCanvasPathChange:fe, canvasSubject:Oe, onCanvasSubjectChange:We, canvasRecipients:rt, onCanvasRecipientsChange:st, canvasCc:ft, onCanvasCcChange:St, canvasContent:ht, onCanvasContentChange:xe, canvasStatus:de, savingCanvas:qe, savingCanvasFile:dt, 
sendingCanvas:gt, onUseLatestAssistantInCanvas:ze, onSaveCanvasDraft:kt, onSaveCanvasFile:Dt, onClearScratchpad:Et, onSendCanvasEmailAction:Tt, sttEnabled:yt = !1, ttsEnabled:Ut = !1, ttsDefaultVoiceId:en = ""}) {
  var Jn;
  const Fn = (0,require$react.useRef)(null), Sn = (0,require$react.useRef)(null), Lt = (0,require$react.useRef)(!0), [Wt, wr] = (0,require$react.useState)(!1), [kn, Ct] = (0,require$react.useState)(!1), [un, Je] = (0,require$react.useState)(() => {
    if (typeof window < "u") {
      const tt = localStorage.getItem("knoxx_voice_threshold");
      if (tt) {
        const Qt = parseFloat(tt);
        if (!isNaN(Qt)) {
          return Math.max(1e-3, Math.min(0.1, Qt));
        }
      }
    }
    return 0.015;
  });
  (0,require$react.useEffect)(() => {
    localStorage.setItem("knoxx_voice_threshold", String(un));
  }, [un]);
  const ut = (0,require$react.useCallback)(tt => {
    const Qt = tt.scrollHeight - tt.scrollTop - tt.clientHeight;
    Lt.current = Qt <= 96;
  }, []), at = (0,require$react.useCallback)(() => {
    const tt = Fn.current;
    if (tt) {
      if (typeof tt.scrollTo == "function") {
        tt.scrollTo({top:tt.scrollHeight, behavior:"auto"});
        return;
      }
      tt.scrollTop = tt.scrollHeight;
    }
  }, []);
  (0,require$react.useLayoutEffect)(() => {
    Lt.current && at();
  }, [be, R, $, G, j, at]);
  const Nt = cq({enabled:Wt, available:Ut, messages:be, defaultVoiceId:en, onPlaybackEnded:() => {
    yt && Ct(!0);
  }});
  (0,require$react.useEffect)(() => {
    !Ut && Wt && wr(!1);
  }, [Wt, Ut]), (0,require$react.useEffect)(() => {
    !Wt && kn && Ct(!1);
  }, [Wt, kn]);
  const jt = (0,require$react.useRef)(!1), {state:rn, startRecording:mn, stopRecording:vn, audioLevelRef:xt} = lN({onTranscript:tt => {
    Ct(!1), Ae(tt);
  }, conversationMode:!0, silenceThreshold:un});
  return (0,require$react.useEffect)(() => {
    !jt.current && Wt && yt && !j && Ct(!0), jt.current = Wt;
  }, [Wt, yt, j]), (0,require$react.useEffect)(() => {
    j && kn && Ct(!1);
  }, [j, kn]), (0,require$react.useEffect)(() => {
    kn && rn.status === "idle" && mn();
  }, [kn, rn.status, mn]), (0,require$react.useEffect)(() => {
    !kn && rn.status === "recording" && vn();
  }, [kn, rn.status, vn]), (0,require$react.useEffect)(() => {
    const tt = Fn.current, Qt = Sn.current;
    if (!tt || !Qt || typeof ResizeObserver > "u") {
      return;
    }
    const Vt = new ResizeObserver(() => {
      Lt.current && at();
    });
    return Vt.observe(Qt), () => Vt.disconnect();
  }, [at]), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{flex:1, display:"flex", minWidth:0, minHeight:0, overflow:"hidden"}, children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{flex:1, display:"flex", flexDirection:"column", minWidth:0, minHeight:0, overflow:"hidden", background:"var(--token-monokai-bg-default)"}, children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{display:"flex", alignItems:"center", gap:8, padding:"6px 12px", borderBottom:"1px solid var(--token-colors-border-default)", 
  flexShrink:0}, children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{flex:1}}), (0,require$react_SLASH_jsx_runtime.jsx)(ct, {variant:b ? "success" : x ? "warning" : "error", size:"sm", dot:!0, children:b ? "online" : x ? "offline" : "not configured"})]}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{display:"flex", alignItems:"center", gap:8, padding:"6px 12px", borderBottom:"1px solid var(--token-colors-border-default)", flexShrink:0}, children:[(0,require$react_SLASH_jsx_runtime.jsx)(Ke, 
  {variant:e ? "primary" : "ghost", size:"sm", onClick:l, children:"Settings"}), (0,require$react_SLASH_jsx_runtime.jsx)(Ke, {variant:r ? "primary" : "ghost", size:"sm", onClick:u, children:"Console"})]}), e ? (0,require$react_SLASH_jsx_runtime.jsx)(lq, {systemPrompt:I, onSystemPromptChange:_, conversationId:N, activeRole:E, activeActorId:C, activeAgentId:k, availableAgents:A, onActiveAgentChange:P, toolCatalog:W}) : null, (0,require$react_SLASH_jsx_runtime.jsx)("div", {ref:Fn, "data-testid":"chat-scroll-region", 
  onScroll:tt => ut(tt.currentTarget), style:{flex:1, overflow:"auto", padding:16}, children:(0,require$react_SLASH_jsx_runtime.jsxs)("div", {ref:Sn, children:[(0,require$react_SLASH_jsx_runtime.jsx)(oq, {wsStatus:F, isRecovering:B, latestRun:z, isSending:j, selectedModel:h, conversationId:N, activeRunId:me, hydrationSources:te, runtimeEvents:q, latestToolReceipts:R, assistantSurfaceBackground:J, assistantSurfaceBorder:U, assistantSurfaceText:le, onOpenHydrationSource:Le, onPinHydrationSource:$e, 
  onAppendToScratchpad:Ye}), be.length === 0 ? (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", height:"100%", color:"var(--token-colors-text-muted)", gap:8}, children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{fontSize:20, fontWeight:600}, children:zm.title}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{fontSize:14}, children:zm.body}), (0,require$react_SLASH_jsx_runtime.jsx)("div", 
  {style:{fontSize:13}, children:zm.detail})]}) : (0,require$react_SLASH_jsx_runtime.jsx)(sq, {messages:be, latestRun:z, latestToolReceipts:R, liveToolReceipts:$, liveToolEvents:G, assistantSurfaceBackground:J, assistantSurfaceBorder:U, assistantSurfaceText:le, onOpenMessageInCanvas:Me, onOpenSourceInPreview:Xe, onPinAssistantSource:it, onAppendToScratchpad:Ye, onPinMessageContext:se})]})}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{display:"flex", flexWrap:"wrap", alignItems:"center", 
  gap:8, padding:"8px 12px", borderTop:"1px solid var(--token-colors-border-default)", flexShrink:0}, children:[(0,require$react_SLASH_jsx_runtime.jsxs)("select", {value:k, onChange:tt => P(tt.target.value), style:{minWidth:140, borderRadius:6, border:"1px solid var(--token-colors-border-subtle)", padding:"6px 8px", fontSize:12, background:"var(--token-colors-surface-input)", color:"var(--token-colors-text-default)"}, title:"Active agent contract", children:[A.length === 0 ? (0,require$react_SLASH_jsx_runtime.jsx)("option", 
  {value:"", children:"No agents"}) : null, A.map(tt => (0,require$react_SLASH_jsx_runtime.jsx)("option", {value:tt.id, children:tt.id}, tt.id))]}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{minWidth:160, position:"relative", zIndex:20}, children:(0,require$react_SLASH_jsx_runtime.jsx)(n6, {options:m.map(tt => tt.id), value:h, onChange:f, placeholder:m.length === 0 ? "No models" : "Select model", disabled:m.length === 0, size:"sm"})}), (0,require$react_SLASH_jsx_runtime.jsxs)("label", 
  {style:{display:"flex", alignItems:"center", gap:6, fontSize:12, color:"var(--token-colors-text-muted)"}, title:"Thinking level", children:[(0,require$react_SLASH_jsx_runtime.jsx)("span", {children:"Thinking"}), (0,require$react_SLASH_jsx_runtime.jsx)("select", {"aria-label":"Thinking level", value:p, onChange:tt => g(tt.target.value), style:{minWidth:90, borderRadius:6, border:"1px solid var(--token-colors-border-subtle)", padding:"6px 8px", fontSize:12, background:"var(--token-colors-surface-input)", 
  color:"var(--token-colors-text-default)"}, children:pN.map(tt => (0,require$react_SLASH_jsx_runtime.jsx)("option", {value:tt, children:tt}, `thinking-${tt}`))})]})]}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{padding:12, borderTop:"1px solid var(--token-colors-border-default)", flexShrink:0}, children:[(0,require$react_SLASH_jsx_runtime.jsx)(hV, {onSend:Ae, isSending:ue, voiceInputEnabled:yt, liveControlEnabled:V, liveControlText:ne, onLiveControlTextChange:D, queueingControl:ie, 
  onQueueLiveControl:ee, onVoiceSteer:M, abortingTurn:X, onAbortTurn:ge, latestAssistantContent:(Jn = be.filter(tt => tt.role === "assistant" && tt.status === "done").slice(-1)[0]) == null ? void 0 : Jn.content, autoConversationEnabled:Wt, onToggleAutoConversation:() => wr(tt => !tt), ttsEnabled:Ut, ttsStatus:Nt.status, ttsError:Nt.error, onUndoMessages:v, undoDisabled:T, onNewChat:w, autoRecording:kn, voiceThreshold:un, onVoiceThresholdChange:Je, audioLevelRef:xt}), Wt && Nt.error ? (0,require$react_SLASH_jsx_runtime.jsxs)("div", 
  {style:{marginTop:8, fontSize:12, color:"var(--token-colors-text-muted)"}, children:["Auto voice error: ", Nt.error]}) : null]}), r ? (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{height:220, borderTop:"1px solid var(--token-colors-border-default)", flexShrink:0}, children:[(0,require$react_SLASH_jsx_runtime.jsx)(fV, {lines:je}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{padding:"6px 12px", borderTop:"1px solid var(--token-colors-border-default)", fontSize:11, color:"var(--token-colors-text-muted)"}, 
  children:["WebSocket: ", F]})]}) : null]}), s && !n ? (0,require$react_SLASH_jsx_runtime.jsx)(Fa, {label:"Canvas", edge:"right", onExpand:c, title:"Show Canvas panel"}) : null, s && n ? (0,require$react_SLASH_jsx_runtime.jsx)(aq, {canvasTitle:oe, onCanvasTitleChange:we, canvasPath:ke, onCanvasPathChange:fe, canvasSubject:Oe, onCanvasSubjectChange:We, canvasRecipients:rt, onCanvasRecipientsChange:st, canvasCc:ft, onCanvasCcChange:St, canvasContent:ht, onCanvasContentChange:xe, canvasStatus:de, savingCanvas:qe, 
  savingCanvasFile:dt, sendingCanvas:gt, toolCatalog:W, onUseLatestAssistantInCanvas:ze, onHide:c, onSaveCanvasDraft:kt, onSaveCanvasFile:Dt, onClearScratchpad:Et, onSendCanvasEmailAction:Tt}) : null]});
}
function fd({controller:t, showFiles:e, onShowFiles:n, showFilesToggle:r = !0, filesLabel:i = "Files", showCanvasToggle:s = !0, onOpenHydrationSource:o, onOpenSourceInPreview:a}) {
  var l;
  return (0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{flex:1, width:"100%", height:"100%", minWidth:0, minHeight:0, display:"flex", overflow:"hidden"}, children:(0,require$react_SLASH_jsx_runtime.jsx)(vq, {showFiles:e, showSettings:t.showSettings, showCanvas:t.showCanvas, showCanvasToggle:s, showConsole:t.showConsole, onShowFiles:n, showFilesToggle:r, filesLabel:i, onToggleSettings:t.toggleSettings, onToggleCanvas:t.toggleCanvas, onToggleConsole:t.toggleConsole, selectedModel:t.selectedModel, 
  onSelectedModelChange:t.setSelectedModel, selectedThinkingLevel:t.selectedThinkingLevel, onSelectedThinkingLevelChange:t.setSelectedThinkingLevel, proxxModels:t.proxxModels, proxxReachable:t.proxxReachable, proxxConfigured:t.proxxConfigured, onNewChat:t.handleNewChat, onUndoMessages:t.handleUndoLastTurn, undoDisabled:t.isSending || t.isRecovering || !t.messages.some(c => c.role === "user"), systemPrompt:t.systemPrompt, onSystemPromptChange:t.setSystemPrompt, conversationId:t.conversationId, activeRole:t.activeRole, 
  activeActorId:t.activeActorId, activeAgentId:t.activeAgentId, availableAgents:t.availableAgents, onActiveAgentChange:t.setActiveAgentId, toolCatalog:t.toolCatalog, wsStatus:t.wsStatus, isRecovering:t.isRecovering, latestRun:t.latestRun, isSending:t.isSending, liveControlEnabled:t.liveControlEnabled, liveControlText:t.liveControlText, onLiveControlTextChange:t.setLiveControlText, queueingControl:t.queueingControl, onQueueLiveControl:t.queueLiveControl, onVoiceSteer:t.voiceSteer, abortingTurn:t.abortingTurn, 
  onAbortTurn:t.abortTurn, activeRunId:((l = t.latestRun) == null ? void 0 : l.run_id) ?? null, hydrationSources:t.hydrationSources, runtimeEvents:t.runtimeEvents, latestToolReceipts:t.latestToolReceipts, liveToolReceipts:t.liveToolReceipts, liveToolEvents:t.liveToolEvents, assistantSurfaceBackground:t.assistantSurfaceBackground, assistantSurfaceBorder:t.assistantSurfaceBorder, assistantSurfaceText:t.assistantSurfaceText, messages:t.messages, consoleLines:t.consoleLines, onSend:t.handleSend, composerDisabled:t.isSending || 
  t.isRecovering || !t.selectedModel, onOpenHydrationSource:o ?? t.openHydrationSource, onPinHydrationSource:t.pinHydrationSource, onAppendToScratchpad:t.appendToScratchpad, onOpenMessageInCanvas:t.openMessageInCanvas, onOpenSourceInPreview:a ?? t.openSourceInPreview, onPinAssistantSource:t.pinAssistantSource, onPinMessageContext:t.pinMessageContext, canvasTitle:t.canvasTitle, onCanvasTitleChange:t.setCanvasTitle, canvasPath:t.canvasPath, onCanvasPathChange:t.setCanvasPath, canvasSubject:t.canvasSubject, 
  onCanvasSubjectChange:t.setCanvasSubject, canvasRecipients:t.canvasRecipients, onCanvasRecipientsChange:t.setCanvasRecipients, canvasCc:t.canvasCc, onCanvasCcChange:t.setCanvasCc, canvasContent:t.canvasContent, onCanvasContentChange:t.setCanvasContent, canvasStatus:t.canvasStatus, savingCanvas:t.savingCanvas, savingCanvasFile:t.savingCanvasFile, sendingCanvas:t.sendingCanvas, onUseLatestAssistantInCanvas:t.useLatestAssistantInCanvas, onSaveCanvasDraft:t.saveCanvasDraft, onSaveCanvasFile:t.saveCanvasFile, 
  onClearScratchpad:t.clearScratchpad, onSendCanvasEmailAction:t.sendCanvasEmailAction, sttEnabled:t.sttEnabled, ttsEnabled:t.ttsEnabled, ttsDefaultVoiceId:t.ttsDefaultVoiceId})});
}
const du = 1;
function ks() {
  if (typeof window > "u") {
    return null;
  }
  try {
    return window.localStorage;
  } catch {
    try {
      return window.sessionStorage;
    } catch {
      return null;
    }
  }
}
function K_() {
  if (typeof window > "u") {
    return null;
  }
  try {
    return window.sessionStorage;
  } catch {
    return null;
  }
}
function wq({sessionStateKey:t, store:e, legacy:n}) {
  if (!(!e || !n) && e !== n) {
    try {
      for (let r = 0; r < n.length; r += 1) {
        const i = n.key(r);
        if (i && (i === t || i.startsWith(`${t}:`))) {
          if (e.getItem(i) != null) {
            continue;
          }
          const s = n.getItem(i);
          s != null && e.setItem(i, s);
        }
      }
    } catch {
    }
  }
}
function gN(t, e) {
  return `${t}:${e}`;
}
function mN(t) {
  return `${t}:index`;
}
function _q(t) {
  return typeof t == "string" && t.trim().length > 0 ? t.trim() : null;
}
function Sq(t) {
  var n, r;
  const e = (r = (n = t == null ? void 0 : t.find(i => i.role === "user" && i.content.trim().length > 0)) == null ? void 0 : n.content) == null ? void 0 : r.trim();
  return e ? e.length > 72 ? `${e.slice(0, 72).trimEnd()}\u2026` : e : "New chat";
}
function kq(t) {
  var n;
  const e = typeof((n = t.latestRun) == null ? void 0 : n.updated_at) == "string" ? t.latestRun.updated_at : null;
  return e || (new Date()).toISOString();
}
function Eq(t, e) {
  var a, l, c, u;
  const n = _q(e.conversationId) ?? t, r = (a = e.latestRun) == null ? void 0 : a.status, i = !!((l = e.messages) != null && l.some(h => h.role === "assistant" && h.status === "streaming")), s = r === "running" || r === "queued" || e.isSending === !0 || i, o = s ? "running" : r === "completed" || r === "failed" ? r : (((c = e.messages) == null ? void 0 : c.length) ?? 0) > 0 ? "waiting_input" : "inactive";
  return {session:n, title:Sq(e.messages), title_model:null, last_ts:kq(e), event_count:((u = e.messages) == null ? void 0 : u.length) ?? 0, is_active:s || o === "waiting_input", active_status:o, has_active_stream:s, active_session_id:t, local_only:!0};
}
function bN(t, e) {
  if (!t) {
    return {version:du, sessions:[]};
  }
  try {
    const n = t.getItem(mN(e));
    if (!n) {
      return {version:du, sessions:[]};
    }
    const r = JSON.parse(n), i = Array.isArray(r.sessions) ? r.sessions : [];
    return {version:du, sessions:i};
  } catch {
    return {version:du, sessions:[]};
  }
}
function Tq(t, e, n) {
  t && t.setItem(mN(e), JSON.stringify(n));
}
function Og(t, e) {
  const n = ks();
  if (!n || !e) {
    return null;
  }
  try {
    const r = n.getItem(gN(t, e));
    return r ? JSON.parse(r) : null;
  } catch {
    return null;
  }
}
function Ib(t, e, n) {
  const r = ks();
  if (!r || !e) {
    return;
  }
  const i = {...n, sessionId:e};
  r.setItem(gN(t, e), JSON.stringify(i));
  const s = bN(r, t), a = [Eq(e, i), ...s.sessions.filter(l => l.active_session_id !== e)];
  Tq(r, t, {version:du, sessions:a});
}
function yN(t, e, n, r) {
  Ib(t, e, {sessionId:e, conversationId:n, selectedModel:r == null ? void 0 : r.selectedModel, selectedThinkingLevel:r == null ? void 0 : r.selectedThinkingLevel, systemPrompt:r == null ? void 0 : r.systemPrompt, activeActorId:r == null ? void 0 : r.activeActorId, activeAgentId:r == null ? void 0 : r.activeAgentId, messages:[], latestRun:null, runtimeEvents:[], isSending:!1});
}
function Ob(t) {
  const e = ks();
  return [...bN(e, t).sessions].sort((r, i) => {
    const s = Date.parse(r.last_ts ?? "") || 0;
    return (Date.parse(i.last_ts ?? "") || 0) - s;
  });
}
function Cq(t, e) {
  return Ob(t).find(n => n.session === e) ?? null;
}
function Ui(t, e) {
  t(n => [...n.slice(-400), e]);
}
function Aq({makeId:t, sessionId:e, setSessionId:n, systemPrompt:r, setSystemPrompt:i, selectedModel:s, setSelectedModel:o, selectedThinkingLevel:a, setSelectedThinkingLevel:l, activeActorId:c, setActiveActorId:u, activeAgentId:h, setActiveAgentId:f, conversationId:p, setConversationId:g, messages:m, setMessages:b, latestRun:x, setLatestRun:w, runtimeEvents:v, setRuntimeEvents:T, isSending:I, setIsSending:_, sidebarWidthPx:N, setSidebarWidthPx:E, pendingAssistantIdRef:C, activeRunIdRef:k, sessionIdKey:A, 
sessionStateKey:P, sidebarWidthKey:W}) {
  (0,require$react.useEffect)(() => {
    try {
      const F = ks(), B = K_();
      wq({sessionStateKey:P, store:F, legacy:B});
      let z = (F == null ? void 0 : F.getItem(A)) || "";
      !z && B && B !== F && (z = B.getItem(A) || ""), z || (z = t(), yN(P, z, t())), F == null || F.setItem(A, z), n(z);
    } catch {
      n(t());
    }
  }, [t, A, P, n]), (0,require$react.useEffect)(() => {
    if (e) {
      try {
        const F = ks();
        F == null || F.setItem(A, e);
      } catch {
      }
    }
  }, [e, A]), (0,require$react.useEffect)(() => {
    var F;
    try {
      const B = (F = ks()) == null ? void 0 : F.getItem(W);
      if (!B) {
        return;
      }
      const z = Number(B);
      Number.isFinite(z) && E(Math.min(640, Math.max(260, z)));
    } catch {
    }
  }, [E, W]), (0,require$react.useEffect)(() => {
    var F;
    try {
      (F = ks()) == null || F.setItem(W, String(N));
    } catch {
    }
  }, [W, N]), (0,require$react.useEffect)(() => {
    if (e) {
      try {
        const F = ks(), B = K_();
        let z = Og(P, e);
        if (!z) {
          let j = (F == null ? void 0 : F.getItem(P)) || "";
          !j && B && B !== F && (j = B.getItem(P) || ""), j && (z = JSON.parse(j), Ib(P, e, z), F == null || F.removeItem(P), B && B !== F && B.removeItem(P));
        }
        if (!z) {
          return;
        }
        if (typeof z.systemPrompt == "string" && i(z.systemPrompt), typeof z.selectedModel == "string" && o(z.selectedModel), typeof z.selectedThinkingLevel == "string" && l(z.selectedThinkingLevel), typeof z.activeActorId == "string" && u(z.activeActorId), typeof z.activeAgentId == "string" && f(z.activeAgentId), (typeof z.conversationId == "string" || z.conversationId === null) && g(z.conversationId ?? null), Array.isArray(z.messages)) {
          b(z.messages.slice(-80));
          const j = [...z.messages].reverse().find(V => V.role === "assistant" && V.status === "streaming");
          C.current = (j == null ? void 0 : j.id) ?? null, !k.current && typeof(j == null ? void 0 : j.runId) == "string" && (k.current = j.runId);
        }
        z.latestRun && typeof z.latestRun == "object" && (w(z.latestRun), typeof z.latestRun.run_id == "string" && (k.current = z.latestRun.run_id)), Array.isArray(z.runtimeEvents) && T(z.runtimeEvents.slice(-80)), _(!1);
      } catch {
      }
    }
  }, [k, C, e, P, g, _, w, b, T, o, l, u, f, i]), (0,require$react.useEffect)(() => {
    var F;
    if (e) {
      try {
        Ib(P, e, {sessionId:e, systemPrompt:r, selectedModel:s, selectedThinkingLevel:a, activeActorId:c, activeAgentId:h, conversationId:p, messages:m.slice(-80), latestRun:x, runtimeEvents:v.slice(-80), isSending:!1}), (F = ks()) == null || F.removeItem(P);
      } catch {
      }
    }
  }, [P, e, r, s, a, c, h, p, m, x, v, I]);
}
function Nq({sessionId:t, sessionStateKey:e, pendingAssistantIdRef:n, activeRunIdRef:r, setConversationId:i, setIsSending:s, setLatestRun:o, setConsoleLines:a}) {
  const [l, c] = (0,require$react.useState)(!1);
  return (0,require$react.useEffect)(() => {
    if (!t) {
      return;
    }
    const u = Og(e, t);
    if (!u || !u.conversationId) {
      return;
    }
    let h = !1;
    const f = async() => {
      var g;
      c(!0), Ui(a, "[session] checking session status...");
      try {
        const m = await e1(t, u.conversationId);
        if (h) {
          return;
        }
        if (Ui(a, `[session] status: ${m.status}, streaming: ${m.has_active_stream}, can_send: ${m.can_send}`), m.status === "running" && m.has_active_stream) {
          i(m.conversation_id ?? null), s(!0), Ui(a, "[session] reconnecting to active stream...");
          return;
        }
        if (m.status === "running") {
          i(m.conversation_id ?? null), s(!0), Ui(a, "[session] agent still processing; waiting for resume or first token");
          return;
        }
        if (m.status === "completed" || m.status === "failed") {
          s(!1), n.current = null, Ui(a, `[session] session ${m.status}, ready for new message`);
          return;
        }
        if (m.status === "not_found" || m.status === "unknown") {
          n.current = null;
          const b = (g = u.messages) == null ? void 0 : g.filter(x => x.runId).map(x => x.runId).pop();
          if (b) {
            Ui(a, `[session] session not in Redis, checking run ${b.slice(0, 8)}...`);
            try {
              const x = await hd(b);
              if (h) {
                return;
              }
              x.status === "running" || x.status === "queued" ? (o(x), i(x.conversation_id ?? null), s(!0), r.current = b, Ui(a, "[session] run still active, polling...")) : (s(!1), n.current = null, Ui(a, `[session] run ${x.status}, ready for new message`));
            } catch {
              if (h) {
                return;
              }
              Ui(a, "[session] run not found or fetch failed, starting fresh"), s(!1), n.current = null;
            }
          } else {
            s(!1), Ui(a, "[session] no active run, starting fresh");
          }
        }
      } catch (m) {
        if (h) {
          return;
        }
        Ui(a, `[session] recovery failed: ${m.message}`), s(!1), n.current = null;
      } finally {
        h || c(!1);
      }
    }, p = window.setTimeout(f, 500);
    return () => {
      h = !0, window.clearTimeout(p);
    };
  }, [r, n, t, e, a, i, s, o]), l;
}
function Iq({storageKey:t, canvasTitle:e, setCanvasTitle:n, canvasSubject:r, setCanvasSubject:i, canvasPath:s, setCanvasPath:o, canvasRecipients:a, setCanvasRecipients:l, canvasCc:c, setCanvasCc:u, canvasContent:h, setCanvasContent:f}) {
  (0,require$react.useEffect)(() => {
    if (!(typeof window > "u")) {
      try {
        const p = window.localStorage.getItem(t);
        if (!p) {
          return;
        }
        const g = JSON.parse(p);
        typeof g.title == "string" && n(g.title), typeof g.subject == "string" && i(g.subject), typeof g.path == "string" && o(g.path), typeof g.recipients == "string" && l(g.recipients), typeof g.cc == "string" && u(g.cc), typeof g.content == "string" && f(g.content);
      } catch {
      }
    }
  }, [u, f, o, l, i, n, t]), (0,require$react.useEffect)(() => {
    if (!(typeof window > "u")) {
      try {
        window.localStorage.setItem(t, JSON.stringify({title:e, subject:r, path:s, recipients:a, cc:c, content:h}));
      } catch {
      }
    }
  }, [t, e, r, s, a, c, h]);
}
function Oq({storageKey:t, pinnedContext:e, setPinnedContext:n}) {
  (0,require$react.useEffect)(() => {
    if (!(typeof window > "u")) {
      try {
        const r = window.localStorage.getItem(t);
        if (!r) {
          return;
        }
        const i = JSON.parse(r);
        Array.isArray(i) && n(i.slice(0, 24));
      } catch {
      }
    }
  }, [n, t]), (0,require$react.useEffect)(() => {
    if (!(typeof window > "u")) {
      try {
        window.localStorage.setItem(t, JSON.stringify(e.slice(0, 24)));
      } catch {
      }
    }
  }, [t, e]);
}
function Pq({selectedModel:t, setSelectedModel:e, setProxxReachable:n, setProxxConfigured:r, setProxxModels:i}) {
  (0,require$react.useEffect)(() => {
    let s = null;
    const o = async() => {
      var a;
      try {
        const l = await qA();
        n(!!l.reachable), r(!!l.configured);
        const c = await VA();
        if (i(c), !t) {
          const u = c.find(h => h.id === l.default_model);
          e((u == null ? void 0 : u.id) ?? ((a = c[0]) == null ? void 0 : a.id) ?? "");
        }
      } catch {
        n(!1);
      }
    };
    return o(), s = window.setInterval(() => {
      o();
    }, 5e3), () => {
      s !== null && window.clearInterval(s);
    };
  }, [t, r, i, n, e]);
}
function Rq({makeId:t, sessionId:e, setSessionId:n, systemPrompt:r, setSystemPrompt:i, selectedModel:s, setSelectedModel:o, selectedThinkingLevel:a, setSelectedThinkingLevel:l, activeActorId:c, setActiveActorId:u, activeAgentId:h, setActiveAgentId:f, conversationId:p, setConversationId:g, messages:m, setMessages:b, latestRun:x, setLatestRun:w, runtimeEvents:v, setRuntimeEvents:T, isSending:I, setIsSending:_, sidebarWidthPx:N, setSidebarWidthPx:E, pendingAssistantIdRef:C, activeRunIdRef:k, sessionIdKey:A, 
sessionStateKey:P, sidebarWidthKey:W, scratchpadStorageKey:F, canvasTitle:B, setCanvasTitle:z, canvasSubject:j, setCanvasSubject:V, canvasPath:ne, setCanvasPath:D, canvasRecipients:ie, setCanvasRecipients:ee, canvasCc:M, setCanvasCc:X, canvasContent:ge, setCanvasContent:me, pinnedContextStorageKey:te, pinnedContext:q, setPinnedContext:R, setProxxReachable:$, setProxxConfigured:G, setProxxModels:J}) {
  Aq({makeId:t, sessionId:e, setSessionId:n, systemPrompt:r, setSystemPrompt:i, selectedModel:s, setSelectedModel:o, selectedThinkingLevel:a, setSelectedThinkingLevel:l, activeActorId:c, setActiveActorId:u, activeAgentId:h, setActiveAgentId:f, conversationId:p, setConversationId:g, messages:m, setMessages:b, latestRun:x, setLatestRun:w, runtimeEvents:v, setRuntimeEvents:T, isSending:I, setIsSending:_, sidebarWidthPx:N, setSidebarWidthPx:E, pendingAssistantIdRef:C, activeRunIdRef:k, sessionIdKey:A, 
  sessionStateKey:P, sidebarWidthKey:W}), Iq({storageKey:F, canvasTitle:B, setCanvasTitle:z, canvasSubject:j, setCanvasSubject:V, canvasPath:ne, setCanvasPath:D, canvasRecipients:ie, setCanvasRecipients:ee, canvasCc:M, setCanvasCc:X, canvasContent:ge, setCanvasContent:me}), Oq({storageKey:te, pinnedContext:q, setPinnedContext:R}), Pq({selectedModel:s, setSelectedModel:o, setProxxReachable:$, setProxxConfigured:G, setProxxModels:J});
}
function Dq({makeId:t, systemPrompt:e, activeRole:n, activeActorId:r, activeAgentId:i, sessionId:s, setSessionId:o, conversationId:a, setConversationId:l, selectedModel:c, selectedThinkingLevel:u, liveControlEnabled:h, liveControlText:f, setLiveControlText:p, setMessages:g, setLatestRun:m, setRuntimeEvents:b, setIsSending:x, setConsoleLines:w, setQueueingControl:v, setAbortingTurn:T, pendingAssistantIdRef:I, activeRunIdRef:_, sessionIdKey:N, sessionStateKey:E}) {
  const C = D => {
    w(ie => [...ie.slice(-400), D]);
  }, k = (D, ie) => {
    g(ee => ee.map(M => M.id === D ? ie(M) : M));
  }, A = (D, ie) => {
    k(D, ee => ({...ee, traceBlocks:ie([...(ee.traceBlocks ?? [])])}));
  }, P = D => {
    g(ie => ie.some(ee => ee.id === D.id) ? ie : [...ie, D]);
  }, W = async(D, ie = 0) => {
    try {
      const ee = await hd(D);
      if (_.current === D) {
        m(ee);
        const M = I.current;
        M && (k(M, X => ({...X, content:typeof ee.answer == "string" && ee.answer.length > 0 ? ee.answer : ee.status === "failed" && typeof ee.error == "string" && ee.error.length > 0 ? `Agent request failed.

${ee.error}` : X.content, contentParts:ee.contentParts ?? X.contentParts, model:ee.model ?? X.model, sources:Array.isArray(ee.sources) ? ee.sources : X.sources, runId:D, status:ee.status === "completed" ? "done" : ee.status === "failed" ? "error" : X.status})), (ee.status === "completed" || ee.status === "failed") && (I.current = null));
      }
    } catch (ee) {
      const M = ee.message;
      if (_.current === D && M.includes("404") && ie < 6) {
        window.setTimeout(() => {
          W(D, ie + 1);
        }, 250 * (ie + 1));
        return;
      }
      C(`[runs] failed to load ${D}: ${M}`);
    }
  };
  return {appendMessageIfMissing:P, handleNewChat:() => {
    const D = t(), ie = t();
    try {
      const ee = ks();
      ee == null || ee.setItem(N, D), ee == null || ee.removeItem(E), yN(E, D, ie, {selectedModel:c, selectedThinkingLevel:u, systemPrompt:e, activeActorId:r, activeAgentId:i});
    } catch {
    }
    o(D), g([]), l(ie), m(null), b([]), p(""), _.current = null, I.current = null, x(!1);
  }, handleSend:async(D, ie, ee) => {
    if (!s) {
      C("[chat] session not ready, retry in a second");
      return;
    }
    if (!c) {
      C("[chat] no model selected");
      return;
    }
    const M = {id:t(), role:"user", content:D, contentParts:ie}, X = t(), ge = {id:X, role:"assistant", content:"", model:c, sources:[], traceBlocks:[], status:"streaming"}, me = e.trim();
    I.current = X, _.current = null, m(null), b([]), g(te => [...te, M, ge]), x(!0);
    try {
      const te = await JA({message:D, conversation_id:a, session_id:s, run_id:_.current, model:c, thinkingLevel:u, direct:ee == null ? void 0 : ee.direct, contentParts:ie, templateContext:ee == null ? void 0 : ee.templateContext, agentSpec:{actor_id:r || void 0, contract_id:i || void 0, role:n, system_prompt:ee != null && ee.omitSystemPrompt ? void 0 : me || void 0}}), q = te.run_id ?? _.current;
      q && (_.current = q, W(q)), l(te.conversation_id ?? a ?? null), k(X, R => ({...R, model:te.model ?? c, runId:q, status:"streaming"})), C(`[agent] queued model=${te.model ?? c} conversation=${te.conversation_id ?? a ?? "new"} run=${q ?? "pending"}`);
    } catch (te) {
      const q = te.message, R = q.includes("409") || q.includes("agent_already_processing") || q.includes("already processing");
      k(X, $ => ({...$, content:R ? `Agent is already processing a turn. Use steer or follow-up to queue your message, or wait for the current turn to finish.

${q}` : `Agent request failed.

${q}`, status:R ? "streaming" : "error"})), R || (I.current = null), x(!1), C(`[chat] failed: ${q}`);
    }
  }, handleUndoLastTurn:async() => {
    if (!s) {
      C("[undo] session not ready");
      return;
    }
    if (I.current) {
      C("[undo] wait for the active turn to finish or abort it first");
      return;
    }
    try {
      const D = await XA({session_id:s, conversation_id:a, actor_id:r || null, turns:1});
      if (!D.ok) {
        throw new Error(D.error || "Undo failed");
      }
      g(ie => GV(ie, 1)), m(null), b([]), p(""), x(!1), l(D.conversation_id ?? a ?? null), I.current = null, _.current = null, C(`[undo] removed ${D.removed_count ?? 0} message(s) from the latest turn`);
    } catch (D) {
      C(`[undo] failed: ${D.message}`);
    }
  }, loadRunDetail:W, queueLiveControl:async D => {
    const ie = f.trim();
    if (!(!ie || !a || !h)) {
      v(D);
      try {
        const ee = await Tb({kind:D, message:ie, conversation_id:a, session_id:s, run_id:_.current, actor_id:r || null}), M = uu({type:D === "follow_up" ? "follow_up_queued" : "steer_queued", preview:io(ie, 240), run_id:ee.run_id ?? _.current ?? void 0});
        M && P(M), p(""), C(`[agent:${D}] queued for conversation=${ee.conversation_id ?? a} run=${ee.run_id ?? _.current ?? "pending"}`);
      } catch (ee) {
        const M = uu({type:D === "follow_up" ? "follow_up_failed" : "steer_failed", preview:io(ie, 240), run_id:_.current ?? void 0, error:ee.message});
        M && P(M), C(`[agent:${D}] failed: ${ee.message}`);
      } finally {
        v(null);
      }
    }
  }, voiceSteer:async D => {
    const ie = D.trim();
    if (!(!ie || !a || !h)) {
      v("steer");
      try {
        const ee = await Tb({kind:"steer", message:ie, conversation_id:a, session_id:s, run_id:_.current, actor_id:r || null}), M = uu({type:"steer_queued", preview:io(ie, 240), run_id:ee.run_id ?? _.current ?? void 0});
        M && P(M), p(""), C(`[agent:steer] queued for conversation=${ee.conversation_id ?? a} run=${ee.run_id ?? _.current ?? "pending"}`);
      } catch (ee) {
        const M = uu({type:"steer_failed", preview:io(ie, 240), run_id:_.current ?? void 0, error:ee.message});
        M && P(M), C(`[agent:steer] failed: ${ee.message}`);
      } finally {
        v(null);
      }
    }
  }, abortTurn:async() => {
    if (!a) {
      C("[abort] missing conversation id");
      return;
    }
    T(!0);
    try {
      const D = await KA({conversation_id:a, session_id:s, run_id:_.current, actor_id:r || null, reason:"aborted_by_user"});
      C(`[abort] ${D.ok ? "requested" : "failed"}${D.error ? `: ${D.error}` : ""}`);
    } catch (D) {
      C(`[abort] failed: ${D.message}`);
    } finally {
      T(!1);
    }
  }, updateMessageById:k, updateTraceBlocksByMessageId:A};
}
function Lq(t, e, n) {
  const r = new URLSearchParams();
  e && r.set("session_id", e), n && r.set("conversation_id", n);
  const i = r.toString() ? `?${r.toString()}` : "";
  if (!t) {
    return `${window.location.protocol === "https:" ? "wss" : "ws"}://${window.location.host}/ws/stream${i}`;
  }
  const s = new URL(t);
  return s.protocol = s.protocol === "https:" ? "wss:" : "ws:", s.pathname = "/ws/stream", s.search = i, s.toString();
}
function xN(t, e, n) {
  let r = null, i = n ?? null, s = !1, o = null, a = 1e3;
  const l = 3e4;
  let c = 0;
  const u = () => {
    if (s) {
      return;
    }
    const g = ++c, m = Lq(us, e, i);
    console.log(`[ws] connecting #${g} to ${m}`), r = new WebSocket(m), r.addEventListener("open", () => {
      var b;
      console.log(`[ws] #${g} open`), a = 1e3, (b = t.onStatus) == null || b.call(t, "connected");
    }), r.addEventListener("close", b => {
      var x;
      console.log(`[ws] #${g} close code=${b.code} reason=${b.reason}`), (x = t.onStatus) == null || x.call(t, "closed"), s || (console.log(`[ws] #${g} reconnecting in ${a}ms`), o = setTimeout(u, a), a = Math.min(a * 2, l));
    }), r.addEventListener("error", b => {
      var x;
      console.log(`[ws] #${g} error`, b), (x = t.onStatus) == null || x.call(t, "error");
    }), r.addEventListener("message", b => {
      var x, w, v, T, I, _;
      try {
        const N = JSON.parse(b.data), E = N.payload ?? {};
        N.channel === "tokens" ? (x = t.onToken) == null || x.call(t, String(E.token ?? ""), {runId:E.run_id, kind:typeof E.kind == "string" ? E.kind : void 0}) : N.channel === "stats" ? (w = t.onStats) == null || w.call(t, E) : N.channel === "console" ? (v = t.onConsole) == null || v.call(t, `[${String(E.stream ?? "log")}] ${String(E.line ?? "")}`) : N.channel === "events" ? (T = t.onEvent) == null || T.call(t, E) : N.channel === "lounge" && ((I = t.onLounge) == null || I.call(t, E));
      } catch {
        (_ = t.onConsole) == null || _.call(t, "Malformed websocket packet");
      }
    });
  };
  u();
  const h = () => {
    console.log(`[ws] dispose (was #${c})`), s = !0, o && clearTimeout(o), r == null || r.close();
  };
  return Object.assign(h, {disconnect:h, setConversationId:g => {
    if (g !== i) {
      if (i = g, !r) {
        u();
        return;
      }
      r.readyState === WebSocket.OPEN ? r.send(JSON.stringify({type:"set_conversation", conversation_id:g})) : r.readyState === WebSocket.CLOSED && u();
    }
  }});
}
function Mq({sessionId:t, conversationId:e, isSending:n, latestRun:r, semanticQuery:i, currentPath:s, sendUiGuardTimeoutMs:o, sendTimeoutRef:a, pendingAssistantIdRef:l, activeRunIdRef:c, setWsStatus:u, setIsSending:h, setLatestRun:f, setRuntimeEvents:p, setConsoleLines:g, setSemanticResults:m, setSemanticProjects:b, updateMessageById:x, updateTraceBlocksByMessageId:w, appendMessageIfMissing:v, loadRunDetail:T, loadDirectory:I, refreshWorkspaceStatus:_, refreshRecentSessions:N, runSemanticSearch:E}) {
  const C = (0,require$react.useRef)(null), k = (0,require$react.useRef)(null), A = (0,require$react.useRef)(e), P = (0,require$react.useRef)([]), W = (0,require$react.useRef)(!1), F = (0,require$react.useRef)(0), B = (0,require$react.useRef)({appendMessageIfMissing:v, loadDirectory:I, loadRunDetail:T, refreshRecentSessions:N, refreshWorkspaceStatus:_, runSemanticSearch:E, updateMessageById:x, updateTraceBlocksByMessageId:w});
  B.current = {appendMessageIfMissing:v, loadDirectory:I, loadRunDetail:T, refreshRecentSessions:N, refreshWorkspaceStatus:_, runSemanticSearch:E, updateMessageById:x, updateTraceBlocksByMessageId:w}, A.current = e, (0,require$react.useEffect)(() => {
    if (!t) {
      return;
    }
    console.log("[chat-runtime-effects] WS effect \u2014 sessionId:", t);
    let z = !1, j = null;
    const V = window.setTimeout(() => {
      z || (j = xN({onStatus:ne => {
        if (u(ne), ne === "connected") {
          const D = c.current;
          if (D && n) {
            const ie = k.current;
            t1(D, ie).then(ee => {
              if (ee.count > 0) {
                p(X => {
                  const ge = new Set(X.map(te => `${te.type}:${te.at}`)), me = ee.events.filter(te => !ge.has(`${te.type}:${te.at}`));
                  return [...X.slice(-79), ...me];
                }), g(X => [...X.slice(-400), `[ws] caught up ${ee.count} events since reconnect`]);
                const M = ee.events[ee.events.length - 1];
                M != null && M.at && (k.current = String(M.at));
              }
            }).catch(() => {
            });
          }
        }
      }, onToken:(ne, D) => {
        l.current && (P.current.push({token:ne, meta:D}), W.current || (W.current = !0, requestAnimationFrame(() => {
          const ee = l.current;
          if (!ee) {
            W.current = !1;
            return;
          }
          const M = P.current;
          if (P.current = [], W.current = !1, M.length === 0) {
            return;
          }
          const X = M[M.length - 1].meta, ge = X == null ? void 0 : X.runId;
          ge && (c.current = ge);
          let me = "", te = "";
          for (const {token:q, meta:R} of M) {
            (R == null ? void 0 : R.kind) === "reasoning" ? te += q : me += q;
          }
          me && (B.current.updateTraceBlocksByMessageId(ee, q => Ih(q, "agent_message", me)), B.current.updateMessageById(ee, q => ({...q, runId:ge ?? q.runId ?? null, status:"streaming", content:`${q.content}${Nb(q.content, me)}`}))), te && B.current.updateTraceBlocksByMessageId(ee, q => Ih(q, "reasoning", te));
        })));
      }, onEvent:ne => {
        const D = ne;
        typeof D.at == "string" && (k.current = D.at), p(te => [...te.slice(-79), D]);
        const ie = uu(D);
        ie && B.current.appendMessageIfMissing(ie);
        const ee = l.current;
        if (ee && ["tool_start", "tool_update", "tool_end"].includes(String(D.type ?? "")) && B.current.updateTraceBlocksByMessageId(ee, te => KV(te, D)), typeof D.run_id == "string" && (c.current = D.run_id, D.type === "run_started" && f(null), D.type === "run_completed" || D.type === "run_failed")) {
          if (ee) {
            if (P.current.length > 0) {
              const te = P.current;
              P.current = [];
              let q = "", R = "";
              for (const {token:$, meta:G} of te) {
                (G == null ? void 0 : G.kind) === "reasoning" ? R += $ : q += $;
              }
              q && (B.current.updateTraceBlocksByMessageId(ee, $ => Ih($, "agent_message", q)), B.current.updateMessageById(ee, $ => ({...$, status:"streaming", content:`${$.content}${Nb($.content, q)}`}))), R && B.current.updateTraceBlocksByMessageId(ee, $ => Ih($, "reasoning", R));
            }
            B.current.updateTraceBlocksByMessageId(ee, te => XV(te, D.type === "run_failed" ? "error" : "done")), B.current.updateMessageById(ee, te => ({...te, runId:D.run_id ?? te.runId ?? null, status:D.type === "run_failed" ? "error" : "done"})), l.current = null;
          }
          h(!1), B.current.loadRunDetail(D.run_id);
        }
        const M = D.type ?? "event", X = typeof D.tool_name == "string" ? ` ${D.tool_name}` : "", ge = typeof D.preview == "string" && D.preview.trim().length > 0 ? ` :: ${io(D.preview, 120)}` : "", me = Date.now();
        me - F.current > 200 && (F.current = me, g(te => [...te.slice(-400), `[agent:${M}]${X}${ge}`]));
      }}, t, A.current), C.current = j);
    }, 0);
    return () => {
      z = !0, window.clearTimeout(V), j == null || j.disconnect(), C.current = null;
    };
  }, [c, l, t, g, h, f, p, u]), (0,require$react.useEffect)(() => {
    C.current && C.current.setConversationId(e);
  }, [e]), (0,require$react.useEffect)(() => {
    if (!n) {
      a.current !== null && (window.clearTimeout(a.current), a.current = null);
      return;
    }
    return a.current = window.setTimeout(() => {
      h(!1), g(z => [...z.slice(-400), `[chat] still running after ${Math.round(o / 6e4)}m; UI unlocked but the backend may still be working`]);
    }, o), () => {
      a.current !== null && (window.clearTimeout(a.current), a.current = null);
    };
  }, [n, a, o, g, h]), (0,require$react.useEffect)(() => {
    if (!n) {
      return;
    }
    const z = window.setInterval(() => {
      const j = c.current;
      j && B.current.loadRunDetail(j);
    }, 4e3);
    return () => window.clearInterval(z);
  }, [n, c]), (0,require$react.useEffect)(() => {
    B.current.loadDirectory("docs"), B.current.refreshWorkspaceStatus(), B.current.refreshRecentSessions();
  }, []), (0,require$react.useEffect)(() => {
    const z = window.setInterval(() => {
      B.current.refreshRecentSessions();
    }, 3e4);
    return () => window.clearInterval(z);
  }, []), (0,require$react.useEffect)(() => {
    r != null && r.run_id && (r.status === "completed" || r.status === "failed") && B.current.refreshRecentSessions();
  }, [r == null ? void 0 : r.run_id, r == null ? void 0 : r.status]), (0,require$react.useEffect)(() => {
    const z = window.setInterval(() => {
      B.current.refreshWorkspaceStatus();
    }, 1e4);
    return () => window.clearInterval(z);
  }, []), (0,require$react.useEffect)(() => {
    i.trim() && B.current.runSemanticSearch(i, s);
  }, [s, i]), (0,require$react.useEffect)(() => {
    const z = i.trim();
    if (!z) {
      m([]), b([]);
      return;
    }
    const j = window.setTimeout(() => {
      B.current.runSemanticSearch(z, s);
    }, 300);
    return () => window.clearTimeout(j);
  }, [s, i, m, b]);
}
function Bq({defaultRole:t, defaultActorId:e, activeRole:n, activeActorId:r, activeAgentId:i, setActiveRole:s, setActiveActorId:o, setAvailableActors:a, setActiveAgentId:l, setAvailableAgents:c, setToolCatalog:u, setConsoleLines:h, setSttEnabled:f, setTtsEnabled:p, setTtsDefaultVoiceId:g}) {
  const m = (0,require$react.useRef)(i);
  m.current = i, (0,require$react.useEffect)(() => {
    const b = r || e;
    Promise.all([OA(), Jx(b)]).then(([x, w]) => {
      var C;
      f(!!x.stt_enabled), p(!!x.tts_enabled), g(x.tts_default_voice_id || "");
      const v = w.actor_id || b || x.default_actor_id || e;
      v && v !== r && o(v);
      const T = w.agents ?? [];
      a(w.actors ?? []);
      const I = w.default_agent_contract || x.default_agent_contract || ((C = T[0]) == null ? void 0 : C.id) || "";
      c(T);
      const _ = m.current, N = T.some(k => k.id === _) ? _ : I;
      N && N !== _ && l(N);
      const E = T.find(k => k.id === N) ?? T[0];
      s((E == null ? void 0 : E.role) || x.default_role || t);
    }).catch(x => {
      h(w => [...w.slice(-400), `[agents] failed: ${x.message}`]);
    });
  }, [r, i, e, t, o, l, s, a, c, h, f, g, p]), (0,require$react.useEffect)(() => {
    YA(n, i || void 0, r || void 0).then(u).catch(b => {
      h(x => [...x.slice(-400), `[tools] failed: ${b.message}`]);
    });
  }, [r, i, n, h, u]);
}
const $q = new Set(["ts", "tsx", "js", "jsx", "mjs", "cjs", "py", "clj", "cljs", "cljc", "rs", "go", "java", "rb", "php"]), Fq = new Set(["md", "mdx", "txt", "rst", "adoc"]), zq = new Set(["json", "yaml", "yml", "toml", "ini", "env", "conf"]), Hq = new Set(["csv", "tsv", "sql", "xml"]);
function Uq(t) {
  const e = t.toLowerCase().split(".");
  return e.length > 1 ? e[e.length - 1] ?? "" : "";
}
function Wq(t) {
  const e = Uq(t.path || t.name);
  return $q.has(e) ? "code" : zq.has(e) ? "config" : Hq.has(e) ? "data" : (Fq.has(e), "docs");
}
function jq(t, e, n, r) {
  const i = e.trim().toLowerCase();
  return t.filter(s => {
    if (!(!i || s.name.toLowerCase().includes(i) || s.path.toLowerCase().includes(i))) {
      return !1;
    }
    if (s.type === "dir") {
      return !0;
    }
    const a = n === "all" || s.visibility === n, l = r === "all" || Wq(s) === r;
    return a && l;
  });
}
function Vq(t) {
  const e = t.filter(r => r.type === "file"), n = e.reduce((r, i) => {
    const s = i.visibility ?? "internal";
    return r[s] = (r[s] ?? 0) + 1, r;
  }, {});
  return {total:e.length, byVisibility:n};
}
function qq({browseData:t, entryFilter:e, visibilityFilter:n, kindFilter:r, semanticQuery:i, semanticResults:s, workspaceJob:o, latestRun:a, isSending:l, runtimeEvents:c, pendingAssistantId:u, conversationId:h}) {
  const f = (t == null ? void 0 : t.current_path) ?? "", p = (0,require$react.useMemo)(() => zV(f), [f]), g = (0,require$react.useMemo)(() => Vq((t == null ? void 0 : t.entries) ?? []), [t == null ? void 0 : t.entries]), m = (0,require$react.useMemo)(() => {
    const E = (t == null ? void 0 : t.entries) ?? [];
    return jq(E, e, n, r);
  }, [t == null ? void 0 : t.entries, e, n, r]), b = i.trim().length > 0, x = b ? s.length : m.length, w = o && o.total_files > 0 ? Math.min(100, Math.round((o.processed_files + o.failed_files) / o.total_files * 100)) : 0, v = (0,require$react.useMemo)(() => (a == null ? void 0 : a.tool_receipts) ?? [], [a]), T = (0,require$react.useMemo)(() => l && u ? v : [], [l, v, u]), I = (0,require$react.useMemo)(() => l ? c.filter(E => ["tool_start", "tool_update", "tool_end"].includes(String(E.type ?? ""))) : 
  [], [l, c]), _ = !!(l && h && c.some(E => ["run_started", "passive_hydration", "assistant_first_token", "tool_start"].includes(String(E.type ?? "")))), N = (0,require$react.useMemo)(() => JV(a), [a]);
  return {activeEntryCount:x, assistantSurfaceBackground:"var(--token-colors-background-surface)", assistantSurfaceBorder:"var(--token-colors-border-default)", assistantSurfaceText:"var(--token-colors-text-default)", currentParentPath:p, currentPath:f, filteredEntries:m, hydrationSources:N, latestToolReceipts:v, liveControlEnabled:_, liveToolEvents:I, liveToolReceipts:T, semanticMode:b, statsByVisibility:g.byVisibility, statsTotal:g.total, workspaceProgressPercent:w};
}
function Hm() {
  const t = globalThis.crypto;
  return t && typeof t.randomUUID == "function" ? t.randomUUID() : `id-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
}
function Yq({activeRole:t, activeAgentId:e, messages:n, previewData:r, setPreviewData:i, canvasTitle:s, setCanvasTitle:o, canvasSubject:a, setCanvasSubject:l, canvasPath:c, setCanvasPath:u, canvasRecipients:h, canvasCc:f, canvasContent:p, setCanvasContent:g, setCanvasStatus:m, setPinnedContext:b, setShowCanvas:x, setSavingCanvas:w, setSavingCanvasFile:v, setSendingCanvas:T, setConsoleLines:I}) {
  const _ = te => {
    I(q => [...q.slice(-400), te]);
  }, N = te => {
    const q = HV(te);
    o(q.title), l(q.subject), u(`notes/canvas/${Bm(q.title)}.md`), g(q.content), m(null), x(!0);
  }, E = te => {
    var $, G;
    const q = (($ = te.title) == null ? void 0 : $.trim()) || s || "Untitled canvas", R = ((G = te.path) == null ? void 0 : G.trim()) || c || `notes/canvas/${Bm(q)}.md`;
    o(q), l(q), u(R), g(typeof te.content == "string" ? te.content : p), m(te.statusMessage ?? `Opened ${R} in canvas.`), x(!0);
  }, C = async te => {
    const q = new URLSearchParams({path:te}), R = await fetch(`/api/ingestion/file?${q.toString()}`);
    if (!R.ok) {
      throw new Error(`Preview failed: ${R.status}`);
    }
    return await R.json();
  }, k = te => {
    b(q => [te, ...q.filter($ => $.path !== te.path)].slice(0, 24)), m(`Pinned ${te.title}`);
  }, A = te => {
    b(q => q.filter(R => R.path !== te));
  }, P = () => {
    r && k({id:r.path, title:Da(r.path), path:r.path, snippet:r.content.slice(0, 240), kind:"file"});
  }, W = te => {
    k({id:te.id, title:Da(te.path), path:te.path, snippet:te.snippet, kind:"semantic"});
  }, F = te => {
    const q = dN(te);
    k({id:te.id, title:Da(q), path:q, snippet:te.snippet ?? te.text ?? "", kind:"message"});
  }, B = te => {
    const q = Ab(te.url);
    q && k({id:q, title:te.title || Da(q), path:q, snippet:te.section, kind:"message"});
  }, z = (te, q) => {
    g(R => `${R.trim().length > 0 ? `${R.trimEnd()}

` : ""}${q ? `## ${q}

` : ""}${te}`), x(!0);
  }, j = te => {
    const q = G_(te);
    o(q.title), l(q.subject), u(q.path), g(q.content), m(`Loaded ${q.path} into canvas.`), x(!0);
  };
  return {appendToScratchpad:z, clearScratchpad:() => {
    o("Untitled canvas"), l(""), u(`notes/canvas/${Bm(`canvas-${Date.now()}`)}.md`), g(""), m("Created a fresh canvas.");
  }, fetchPreviewData:C, insertPinnedIntoCanvas:te => {
    z(te.snippet || te.path, `${te.title} (${te.kind})`), m(`Inserted pinned context from ${te.title}.`);
  }, openCanvasArtifact:E, openMessageInCanvas:N, openPinnedInCanvas:async te => {
    try {
      const q = await C(te.path);
      i(q);
      const R = G_(q);
      o(R.title), l(R.subject), u(R.path), g(R.content), m(`Loaded ${te.path} into canvas.`), x(!0);
    } catch (q) {
      z(te.snippet || te.path, te.title), m(`Loaded pinned context excerpt for ${te.title}.`), _(`[canvas] preview load failed for ${te.path}: ${q.message}`);
    }
  }, openPreviewInCanvas:async() => {
    r && j(r);
  }, openSourceInPreview:async te => {
    const q = Ab(te.url);
    if (!q) {
      return;
    }
    const R = await C(q);
    i(R);
  }, pinAssistantSource:B, pinContextItem:k, pinMessageContext:F, pinPreviewContext:P, pinSemanticResult:W, previewFileInCanvas:j, saveCanvasDraft:async() => {
    w(!0), m(null);
    try {
      const te = await fetch("/api/cms/documents", {method:"POST", headers:{"Content-Type":"application/json"}, body:JSON.stringify({title:s || "Untitled draft", content:p, domain:"outbox"})});
      if (!te.ok) {
        throw new Error(`Draft save failed: ${te.status}`);
      }
      m("Saved draft to CMS.");
    } catch (te) {
      m(`Save failed: ${te.message}`);
    } finally {
      w(!1);
    }
  }, saveCanvasFile:async() => {
    v(!0), m(null);
    try {
      const te = await QA({role:t, agentContractId:e || void 0, path:c, content:p, create_parents:!0, overwrite:!0});
      m(`Saved file to ${te.path}`);
    } catch (te) {
      m(`File save failed: ${te.message}`);
    } finally {
      v(!1);
    }
  }, sendCanvasEmailAction:async() => {
    T(!0), m(null);
    try {
      const te = h.split(",").map($ => $.trim()).filter(Boolean), q = f.split(",").map($ => $.trim()).filter(Boolean);
      if (te.length === 0) {
        throw new Error("At least one recipient is required");
      }
      const R = await GA({role:t, agentContractId:e || void 0, to:te, cc:q, subject:a || s || "Untitled draft", markdown:p});
      m(`Sent to ${R.sent_to.join(", ")}`);
    } catch (te) {
      m(`Email failed: ${te.message}`);
    } finally {
      T(!1);
    }
  }, unpinContextItem:A, useLatestAssistantInCanvas:() => {
    const te = [...n].reverse().find(q => q.role === "assistant");
    te && N(te);
  }};
}
const Oh = 20, mp = "eta-mu";
function Ph(t, e) {
  const n = o => {
    if (o.has_active_stream) {
      return 50;
    }
    const a = typeof o.active_status == "string" ? o.active_status : "";
    return a === "running" ? 40 : a === "queued" ? 35 : a === "waiting_input" ? 30 : a === "failed" ? 20 : a === "completed" ? 10 : o.is_active ? 5 : 0;
  }, r = o => {
    if (!o) {
      return 0;
    }
    const a = Date.parse(o);
    return Number.isFinite(a) ? a : 0;
  }, i = (o, a) => {
    const l = n(o), c = n(a), u = l >= c ? o : a, h = r(o.last_ts ?? null) >= r(a.last_ts ?? null) ? o.last_ts : a.last_ts;
    return {session:o.session, title:o.title || a.title, title_model:o.title_model ?? a.title_model ?? null, last_ts:h, event_count:Math.max(o.event_count ?? 0, a.event_count ?? 0), is_active:!!u.is_active, active_status:u.active_status ?? o.active_status ?? a.active_status, has_active_stream:!!u.has_active_stream, active_session_id:u.active_session_id ?? o.active_session_id ?? a.active_session_id ?? null, local_only:!!o.local_only && !!a.local_only};
  }, s = new Map();
  for (const o of t) {
    s.set(o.session, o);
  }
  for (const o of e) {
    const a = s.get(o.session);
    s.set(o.session, a ? i(a, o) : o);
  }
  return [...s.values()];
}
function X_(t) {
  return [...t].sort((e, n) => {
    const r = Date.parse(e.last_ts ?? "") || 0, i = Date.parse(n.last_ts ?? "") || 0;
    return i !== r ? i - r : e.is_active !== n.is_active ? e.is_active ? -1 : 1 : (e.title ?? e.session).localeCompare(n.title ?? n.session);
  });
}
function J_(t, e) {
  var i;
  const n = typeof(t == null ? void 0 : t.selectedModel) == "string" ? t.selectedModel.trim() : "";
  if (n) {
    return n;
  }
  const r = (i = [...e].reverse().find(s => s.role === "assistant" && typeof s.model == "string" && s.model.trim().length > 0)) == null ? void 0 : i.model;
  return typeof r == "string" ? r.trim() : "";
}
function qu(t) {
  const e = t.trim();
  return e.length > 0 && e !== "all" ? e : null;
}
function Um(t, e) {
  return e ? qu(t) === mp ? [] : [mp] : [];
}
function Z_(t, e, n, r, i) {
  const s = e.active_session_id ? Og(t, e.active_session_id) : null, o = qu(n), a = e.actor_id ?? (typeof(s == null ? void 0 : s.activeActorId) == "string" && s.activeActorId.trim().length > 0 ? s.activeActorId.trim() : "chat_primary");
  if (r && o !== mp && a === mp) {
    return !1;
  }
  if (!o) {
    return !0;
  }
  const l = typeof(s == null ? void 0 : s.activeAgentId) == "string" ? s.activeAgentId.trim() : "";
  return l && i.size > 0 ? i.has(l) : a === o;
}
function Gq({visibleAgentIds:t, currentPath:e, showFiles:n, browseData:r, semanticQuery:i, sessionActorFilter:s, excludeEtaMuSessions:o, setBrowseData:a, setPreviewData:l, setLoadingBrowse:c, setLoadingPreview:u, setSemanticResults:h, setSemanticProjects:f, setSemanticSearching:p, setSessionSearchHits:g, setSessionSearchMode:m, setSyncingWorkspace:b, setWorkspaceSourceId:x, setWorkspaceJob:w, recentSessionsRef:v, remoteRecentSessionsRef:T, setRecentSessions:I, setRecentSessionsHasMore:_, setRecentSessionsTotal:N, 
setLoadingRecentSessions:E, setLoadingMoreRecentSessions:C, setLoadingMemorySessionId:k, setMessages:A, setSelectedModel:P, setSessionId:W, setConversationId:F, setLatestRun:B, setRuntimeEvents:z, setLiveControlText:j, setIsSending:V, setConsoleLines:ne, pendingAssistantIdRef:D, activeRunIdRef:ie, makeId:ee, sessionStateKey:M, fetchPreviewData:X, loadRunDetail:ge, defaultSyncIntervalMinutes:me, defaultFileTypes:te, defaultExcludePatterns:q}) {
  const R = ue => {
    ne(Le => [...Le.slice(-400), ue]);
  }, $ = async(ue = "") => {
    c(!0);
    try {
      const Le = new URLSearchParams();
      ue && Le.set("path", ue);
      const $e = await fetch(`/api/ingestion/browse?${Le.toString()}`);
      if (!$e.ok) {
        throw new Error(`Browse failed: ${$e.status}`);
      }
      const Ye = await $e.json();
      a(Ye), l(null);
    } catch (Le) {
      R(`[browse] failed: ${Le.message}`);
    } finally {
      c(!1);
    }
  }, G = async() => {
    try {
      const ue = await fetch("/api/ingestion/sources");
      if (!ue.ok) {
        return;
      }
      const $e = (await ue.json()).find(Cb) ?? null;
      if (x(($e == null ? void 0 : $e.source_id) ?? null), !$e) {
        w(null);
        return;
      }
      const Ye = await fetch(`/api/ingestion/jobs?source_id=${encodeURIComponent($e.source_id)}&limit=10`);
      if (!Ye.ok) {
        return;
      }
      const Me = await Ye.json();
      w(UV(Me)), n && r && $(e);
    } catch (ue) {
      R(`[ingestion] status failed: ${ue.message}`);
    }
  };
  return {ensureWorkspaceSync:async() => {
    b(!0);
    try {
      let ue = r;
      if (!ue) {
        const se = await fetch("/api/ingestion/browse");
        se.ok && (ue = await se.json(), a(ue));
      }
      const Le = ue == null ? void 0 : ue.workspace_root, $e = await fetch("/api/ingestion/sources");
      if (!$e.ok) {
        throw new Error(`Failed to list sources: ${$e.status}`);
      }
      let Me = (await $e.json()).find(Cb);
      if (!Me) {
        const se = await fetch("/api/ingestion/sources", {method:"POST", headers:{"Content-Type":"application/json"}, body:JSON.stringify({driver_type:"local", name:"workspace", config:{root_path:Le || "/app/workspace", sync_interval_minutes:me, workspace_source:!0}, collections:["devel"], file_types:te, exclude_patterns:q})});
        if (!se.ok) {
          throw new Error(`Failed to create source: ${se.status}`);
        }
        const oe = await se.json();
        Me = oe, R(`[ingestion] created workspace source ${oe.source_id} (root ${Le || "unknown"})`);
      }
      if (!Me) {
        throw new Error("Failed to resolve workspace source");
      }
      x(Me.source_id);
      const Xe = await fetch("/api/ingestion/jobs", {method:"POST", headers:{"Content-Type":"application/json"}, body:JSON.stringify({source_id:Me.source_id})});
      if (!Xe.ok) {
        throw new Error(`Failed to start sync: ${Xe.status}`);
      }
      const it = await Xe.json();
      R(`[ingestion] queued workspace sync job ${it.job_id} (interval ${me}m)`), G();
    } catch (ue) {
      R(`[ingestion] sync failed: ${ue.message}`);
    } finally {
      b(!1);
    }
  }, loadDirectory:$, loadMoreRecentSessions:async() => {
    C(!0);
    try {
      const ue = await Ua({limit:Oh, offset:T.current.length, actorId:qu(s) ?? void 0, excludeActorIds:Um(s, o)}), Le = Ph(T.current, ue.rows);
      T.current = Le;
      const $e = Ob(M).filter(Xe => Z_(M, Xe, s, o, t)), Ye = X_(Ph(Le, $e));
      v.current = Ye, I(Ye);
      const Me = typeof ue.total == "number" ? ue.total : Le.length;
      N(Math.max(Me, Ye.length)), _(typeof ue.total == "number" ? Le.length < ue.total : !!(ue.has_more ?? ue.rows.length >= Oh));
    } catch (ue) {
      R(`[memory] failed to load more sessions: ${ue.message}`);
    } finally {
      C(!1);
    }
  }, previewFile:async ue => {
    u(!0);
    try {
      const Le = await X(ue);
      l(Le);
    } catch (Le) {
      R(`[preview] failed: ${Le.message}`);
    } finally {
      u(!1);
    }
  }, refreshRecentSessions:async() => {
    E(!0);
    try {
      const ue = await Ua({limit:Oh, offset:0, actorId:qu(s) ?? void 0, excludeActorIds:Um(s, o)}), Le = T.current.filter(it => !ue.rows.some(se => se.session === it.session)), $e = Ph(ue.rows, Le);
      T.current = $e;
      const Ye = Ob(M).filter(it => Z_(M, it, s, o, t)), Me = X_(Ph($e, Ye));
      v.current = Me, I(Me);
      const Xe = typeof ue.total == "number" ? ue.total : $e.length;
      N(Math.max(Xe, Me.length)), _(typeof ue.total == "number" ? $e.length < ue.total : !!(ue.has_more ?? ue.rows.length >= Oh));
    } catch (ue) {
      R(`[memory] failed to load recent sessions: ${ue.message}`);
    } finally {
      E(!1);
    }
  }, refreshWorkspaceStatus:G, resumeMemorySession:async ue => {
    k(ue);
    try {
      const Le = Cq(M, ue), $e = v.current.find(ke => ke.session === ue) ?? null, Ye = (Le == null ? void 0 : Le.active_session_id) ?? ($e == null ? void 0 : $e.active_session_id) ?? ee(), Me = Og(M, Ye), Xe = J_(Me, []);
      if (A([]), F(ue), W(Ye), Xe && P(Xe), B(null), z([]), j(""), V(!1), D.current = null, ie.current = null, Le != null && Le.local_only) {
        R(`[memory] resumed local draft ${ue}`);
        return;
      }
      let it = await IA(ue), se = Q_(it.rows).slice(-80);
      if (se.length === 0) {
        try {
          const ke = await qx(ue), fe = Q_(ke.rows).slice(-80);
          fe.length > 0 && (it = ke, se = fe, R(`[memory] fallback loaded ${ke.session} from agent history API`));
        } catch {
        }
      }
      const oe = J_(Me, se), we = [...it.rows].reverse().map(Vu).find(ke => !!ke) ?? null;
      A(se), oe && P(oe), F(it.session), B(null), z([]), j(""), V(!1), D.current = null, ie.current = we, we && ge(we), R(`[memory] resumed ${it.session} with ${se.length} transcript message${se.length === 1 ? "" : "s"}`);
    } catch (Le) {
      R(`[memory] failed to resume ${ue}: ${Le.message}`);
    } finally {
      k(null);
    }
  }, runSemanticSearch:async(ue, Le = e) => {
    const $e = ue.trim();
    if (!$e) {
      h([]), f([]), g([]), m("none");
      return;
    }
    p(!0);
    const Ye = qu(s) ?? void 0, Me = Um(s, o);
    try {
      const [Xe, it] = await Promise.all([(async() => {
        const se = await fetch("/api/ingestion/search", {method:"POST", headers:{"Content-Type":"application/json"}, body:JSON.stringify({q:$e, role:"workspace", path:Le, limit:30})});
        if (!se.ok) {
          throw new Error(`Semantic search failed: ${se.status}`);
        }
        return await se.json();
      })(), Yx({query:$e, k:8, actorId:Ye, excludeActorIds:Me})]);
      h(Xe.rows), f(Xe.projects), g(it.hits), m(it.mode);
    } catch (Xe) {
      R(`[semantic] failed: ${Xe.message}`);
    } finally {
      p(!1);
    }
  }, semanticQuery:i};
}
function vN({sidebarSplitContainerRef:t, sidebarWidthPx:e, setSidebarPaneSplitPct:n, setSidebarWidthPx:r}) {
  return {startSidebarPaneResize:o => {
    o.preventDefault();
    const a = t.current;
    if (!a) {
      return;
    }
    const l = a.getBoundingClientRect();
    document.body.style.cursor = "row-resize", document.body.style.userSelect = "none";
    const c = h => {
      const f = h.clientY - l.top, p = Math.min(75, Math.max(25, f / l.height * 100));
      n(p);
    }, u = () => {
      window.removeEventListener("mousemove", c), window.removeEventListener("mouseup", u), document.body.style.cursor = "", document.body.style.userSelect = "";
    };
    window.addEventListener("mousemove", c), window.addEventListener("mouseup", u);
  }, startSidebarWidthResize:o => {
    o.preventDefault();
    const a = o.clientX, l = e;
    document.body.style.cursor = "col-resize", document.body.style.userSelect = "none";
    const c = h => {
      const f = h.clientX - a, p = Math.min(640, Math.floor(window.innerWidth * 0.55)), g = Math.min(p, Math.max(260, l + f));
      r(g);
    }, u = () => {
      window.removeEventListener("mousemove", c), window.removeEventListener("mouseup", u), document.body.style.cursor = "", document.body.style.userSelect = "";
    };
    window.addEventListener("mousemove", c), window.addEventListener("mouseup", u);
  }};
}
const Qq = 30, Kq = [".md", ".markdown", ".txt", ".rst", ".org", ".adoc", ".json", ".jsonl", ".yaml", ".yml", ".toml", ".ini", ".cfg", ".conf", ".env", ".xml", ".csv", ".tsv", ".html", ".htm", ".css", ".js", ".jsx", ".ts", ".tsx", ".py", ".rb", ".php", ".java", ".kt", ".go", ".rs", ".c", ".cc", ".cpp", ".h", ".hpp", ".clj", ".cljs", ".cljc", ".edn", ".sql", ".sh", ".bash", ".zsh", ".fish", ".tex", ".bib", ".nix", ".dockerfile", ".gradle", ".properties"], Xq = ["**/.git/**", "**/node_modules/**", 
"**/dist/**", "**/coverage/**", "**/.next/**", "**/.venv/**", "**/venv/**", "**/__pycache__/**", "**/*.png", "**/*.jpg", "**/*.jpeg", "**/*.gif", "**/*.pdf", "**/*.zip", "**/*.tar.gz"], Jq = "knoxx_session_id", Zq = "knoxx_scratchpad_state", eY = "knoxx_pinned_context", tY = "knoxx_chat_session_state", nY = "knoxx_chat_sidebar_width_px", eS = "knoxx_session_actor_filter", tS = "knoxx_exclude_eta_mu_sessions", wN = "knoxx_last_chat_settings", rY = "executive", iY = 30 * 60 * 1e3;
function sY() {
  try {
    const t = window.localStorage.getItem(wN);
    return t ? JSON.parse(t) : {};
  } catch {
    return {};
  }
}
function oY(t) {
  try {
    window.localStorage.setItem(wN, JSON.stringify(t));
  } catch {
  }
}
function aY(t, e) {
  try {
    const n = window.localStorage.getItem(t);
    return n && n.trim().length > 0 ? n : e;
  } catch {
    return e;
  }
}
function lY(t, e) {
  try {
    const n = window.localStorage.getItem(t);
    return n === "true" ? !0 : n === "false" ? !1 : e;
  } catch {
    return e;
  }
}
function cY({activeAgentId:t, previousAgentId:e, selectedModel:n, agentModel:r}) {
  return !t || !r ? !1 : e === null ? !n : e !== t;
}
function Pg(t = {}) {
  const {initialShowCanvas:e = !0, initialShowConsole:n = !1, initialShowSettings:r = !1, initialSidebarWidthPx:i = 320, defaultRole:s = rY, defaultActorId:o = "chat_primary", sessionIdKey:a = Jq, scratchpadStorageKey:l = Zq, pinnedContextStorageKey:c = eY, sessionStateKey:u = tY, sidebarWidthKey:h = nY, sendUiGuardTimeoutMs:f = iY} = t, [p, g] = (0,require$react.useState)(s), [m, b] = (0,require$react.useState)(o), [x, w] = (0,require$react.useState)([]), v = sY(), [T, I] = (0,require$react.useState)(v.activeAgentId ?? 
  ""), [_, N] = (0,require$react.useState)([]), [E, C] = (0,require$react.useState)(null), [k, A] = (0,require$react.useState)(""), [P, W] = (0,require$react.useState)(""), [F, B] = (0,require$react.useState)([]), [z, j] = (0,require$react.useState)([]), [V, ne] = (0,require$react.useState)(!1), [D, ie] = (0,require$react.useState)(n), [ee, M] = (0,require$react.useState)(r), [X, ge] = (0,require$react.useState)(e), [me, te] = (0,require$react.useState)("connecting"), [q, R] = (0,require$react.useState)(null), 
  [$, G] = (0,require$react.useState)(null), [J, U] = (0,require$react.useState)([]), [le, be] = (0,require$react.useState)(""), [je, Ae] = (0,require$react.useState)(null), [ue, Le] = (0,require$react.useState)(!1), [$e, Ye] = (0,require$react.useState)([]), [Me, Xe] = (0,require$react.useState)(v.selectedModel ?? ""), [it, se] = (0,require$react.useState)(v.selectedThinkingLevel ?? "off"), [oe, we] = (0,require$react.useState)(!1), [ke, fe] = (0,require$react.useState)(!1), [Oe, We] = (0,require$react.useState)(!1), 
  [rt, st] = (0,require$react.useState)(!1), [ft, St] = (0,require$react.useState)(""), [ht, xe] = (0,require$react.useState)(null), [de, qe] = (0,require$react.useState)(null), [dt, gt] = (0,require$react.useState)(!1), [ze, kt] = (0,require$react.useState)(!1), [Dt, Et] = (0,require$react.useState)(""), [Tt, yt] = (0,require$react.useState)(""), [Ut, en] = (0,require$react.useState)([]), [Fn, Sn] = (0,require$react.useState)([]), [Lt, Wt] = (0,require$react.useState)(!1), [wr, kn] = (0,require$react.useState)([]), 
  [Ct, un] = (0,require$react.useState)("none"), [Je, ut] = (0,require$react.useState)(!1), [at, Nt] = (0,require$react.useState)(null), [jt, rn] = (0,require$react.useState)(null), [mn, vn] = (0,require$react.useState)("Untitled canvas"), [xt, Jn] = (0,require$react.useState)(""), [tt, Qt] = (0,require$react.useState)("notes/canvas/untitled-canvas.md"), [Vt, wi] = (0,require$react.useState)(""), [qt, Zn] = (0,require$react.useState)(""), [On, ps] = (0,require$react.useState)(""), [hl, fl] = (0,require$react.useState)(null), 
  [wo, _o] = (0,require$react.useState)(!1), [_i, So] = (0,require$react.useState)(!1), [ha, Si] = (0,require$react.useState)(!1), [Vr, fa] = (0,require$react.useState)([]), [ko, _e] = (0,require$react.useState)([]), De = (0,require$react.useRef)([]), lt = (0,require$react.useRef)([]);
  De.current = ko;
  const [vt, Mt] = (0,require$react.useState)(!1), [Pn, En] = (0,require$react.useState)(0), [bn, Rr] = (0,require$react.useState)(!1), [ai, xh] = (0,require$react.useState)(!1), [vh, lm] = (0,require$react.useState)(null), wh = (0,require$react.useRef)(new Set()), [cm, qr] = (0,require$react.useState)(50), [pl, jc] = (0,require$react.useState)(i), [Dr, _h] = (0,require$react.useState)("all"), [Vc, qc] = (0,require$react.useState)("docs"), [Eo, H] = (0,require$react.useState)(() => aY(eS, "all")), 
  [pe, Pe] = (0,require$react.useState)(() => lY(tS, !0)), He = (0,require$react.useRef)(null), ot = (0,require$react.useRef)(null), Bt = (0,require$react.useRef)(null), qn = (0,require$react.useRef)(null), Yr = (0,require$react.useRef)(null), um = Nq({sessionId:P, sessionStateKey:u, pendingAssistantIdRef:ot, activeRunIdRef:Bt, setConversationId:R, setIsSending:ne, setLatestRun:G, setConsoleLines:j}), {activeEntryCount:ki, assistantSurfaceBackground:Hs, assistantSurfaceBorder:gl, assistantSurfaceText:Us, 
  currentParentPath:zi, currentPath:pa, filteredEntries:ml, hydrationSources:LD, latestToolReceipts:MD, liveControlEnabled:ow, liveToolEvents:BD, liveToolReceipts:$D, semanticMode:FD, statsByVisibility:zD, statsTotal:HD, workspaceProgressPercent:UD} = qq({browseData:ht, entryFilter:Dt, visibilityFilter:Dr, kindFilter:Vc, semanticQuery:Tt, semanticResults:Ut, workspaceJob:jt, latestRun:$, isSending:V, runtimeEvents:J, pendingAssistantId:ot.current, conversationId:q}), {startSidebarPaneResize:WD, startSidebarWidthResize:jD} = 
  vN({sidebarSplitContainerRef:Yr, sidebarWidthPx:pl, setSidebarPaneSplitPct:qr, setSidebarWidthPx:jc});
  Rq({makeId:Hm, sessionId:P, setSessionId:W, systemPrompt:k, setSystemPrompt:A, selectedModel:Me, setSelectedModel:Xe, selectedThinkingLevel:it, setSelectedThinkingLevel:se, activeActorId:m, setActiveActorId:b, activeAgentId:T, setActiveAgentId:I, conversationId:q, setConversationId:R, messages:F, setMessages:B, latestRun:$, setLatestRun:G, runtimeEvents:J, setRuntimeEvents:U, isSending:V, setIsSending:ne, sidebarWidthPx:pl, setSidebarWidthPx:jc, pendingAssistantIdRef:ot, activeRunIdRef:Bt, sessionIdKey:a, 
  sessionStateKey:u, sidebarWidthKey:h, scratchpadStorageKey:l, canvasTitle:mn, setCanvasTitle:vn, canvasSubject:xt, setCanvasSubject:Jn, canvasPath:tt, setCanvasPath:Qt, canvasRecipients:Vt, setCanvasRecipients:wi, canvasCc:qt, setCanvasCc:Zn, canvasContent:On, setCanvasContent:ps, pinnedContextStorageKey:c, pinnedContext:Vr, setPinnedContext:fa, setProxxReachable:we, setProxxConfigured:fe, setProxxModels:Ye});
  const {appendToScratchpad:VD, clearScratchpad:qD, fetchPreviewData:YD, insertPinnedIntoCanvas:GD, openCanvasArtifact:dm, openMessageInCanvas:QD, openPinnedInCanvas:KD, openPreviewInCanvas:XD, openSourceInPreview:JD, pinAssistantSource:ZD, pinContextItem:aw, pinMessageContext:eL, pinPreviewContext:tL, pinSemanticResult:nL, saveCanvasDraft:rL, saveCanvasFile:iL, sendCanvasEmailAction:sL, unpinContextItem:oL, useLatestAssistantInCanvas:aL} = Yq({activeRole:p, activeAgentId:T, messages:F, previewData:de, 
  setPreviewData:qe, canvasTitle:mn, setCanvasTitle:vn, canvasSubject:xt, setCanvasSubject:Jn, canvasPath:tt, setCanvasPath:Qt, canvasRecipients:Vt, canvasCc:qt, canvasContent:On, setCanvasContent:ps, setCanvasStatus:fl, setPinnedContext:fa, setShowCanvas:ge, setSavingCanvas:_o, setSavingCanvasFile:So, setSendingCanvas:Si, setConsoleLines:j}), {appendMessageIfMissing:lL, handleNewChat:cL, handleSend:uL, handleUndoLastTurn:dL, loadRunDetail:lw, queueLiveControl:hL, voiceSteer:fL, abortTurn:pL, updateMessageById:gL, 
  updateTraceBlocksByMessageId:mL} = Dq({makeId:Hm, systemPrompt:k, activeRole:p, activeActorId:m, activeAgentId:T, sessionId:P, setSessionId:W, conversationId:q, setConversationId:R, selectedModel:Me, selectedThinkingLevel:it, liveControlEnabled:ow, liveControlText:le, setLiveControlText:be, setMessages:B, setLatestRun:G, setRuntimeEvents:U, setIsSending:ne, setConsoleLines:j, setQueueingControl:Ae, setAbortingTurn:Le, pendingAssistantIdRef:ot, activeRunIdRef:Bt, sessionIdKey:a, sessionStateKey:u}), 
  {loadDirectory:cw, loadMoreRecentSessions:bL, previewFile:uw, refreshRecentSessions:hm, refreshWorkspaceStatus:yL, resumeMemorySession:xL, runSemanticSearch:fm} = Gq({visibleAgentIds:new Set(_.map(Rn => Rn.id)), currentPath:pa, showFiles:!0, browseData:ht, semanticQuery:Tt, sessionActorFilter:Eo, excludeEtaMuSessions:pe, setBrowseData:xe, setPreviewData:qe, setLoadingBrowse:gt, setLoadingPreview:kt, setSemanticResults:en, setSemanticProjects:Sn, setSemanticSearching:Wt, setSessionSearchHits:kn, 
  setSessionSearchMode:un, setSyncingWorkspace:ut, setWorkspaceSourceId:Nt, setWorkspaceJob:rn, recentSessionsRef:De, remoteRecentSessionsRef:lt, setRecentSessions:_e, setRecentSessionsHasMore:Mt, setRecentSessionsTotal:En, setLoadingRecentSessions:Rr, setLoadingMoreRecentSessions:xh, setLoadingMemorySessionId:lm, setMessages:B, setSelectedModel:Xe, setSessionId:W, setConversationId:R, setLatestRun:G, setRuntimeEvents:U, setLiveControlText:be, setIsSending:ne, setConsoleLines:j, pendingAssistantIdRef:ot, 
  activeRunIdRef:Bt, makeId:Hm, sessionStateKey:u, fetchPreviewData:YD, loadRunDetail:lw, defaultSyncIntervalMinutes:Qq, defaultFileTypes:Kq, defaultExcludePatterns:Xq});
  (0,require$react.useEffect)(() => {
    hm();
  }, [P, m, _, Eo, pe]), (0,require$react.useEffect)(() => {
    Tt.trim() || (kn([]), un("none"));
  }, [Tt]), (0,require$react.useEffect)(() => {
    Tt.trim() && fm(Tt);
  }, [Eo, pe]), (0,require$react.useEffect)(() => {
    try {
      window.localStorage.setItem(eS, Eo), window.localStorage.setItem(tS, String(pe));
    } catch {
    }
  }, [pe, Eo]), Bq({defaultRole:s, defaultActorId:o, activeRole:p, activeActorId:m, activeAgentId:T, setActiveRole:g, setActiveActorId:b, setAvailableActors:w, setActiveAgentId:I, setAvailableAgents:N, setToolCatalog:C, setConsoleLines:j, setSttEnabled:We, setTtsEnabled:st, setTtsDefaultVoiceId:St}), (0,require$react.useEffect)(() => {
    if (!T) {
      return;
    }
    const Rn = _.find(bl => bl.id === T);
    if (!Rn) {
      return;
    }
    const Hi = Rn.model ?? void 0;
    Rn.role && Rn.role !== p && g(Rn.role), Hi && cY({activeAgentId:T, previousAgentId:qn.current, selectedModel:Me, agentModel:Hi}) && Hi !== Me && Xe(Hi), qn.current = T;
  }, [T, p, _, Me, g, Xe]), Mq({sessionId:P, conversationId:q, isSending:V, latestRun:$, semanticQuery:Tt, currentPath:pa, sendUiGuardTimeoutMs:f, sendTimeoutRef:He, pendingAssistantIdRef:ot, activeRunIdRef:Bt, setWsStatus:te, setIsSending:ne, setLatestRun:G, setRuntimeEvents:U, setConsoleLines:j, setSemanticResults:en, setSemanticProjects:Sn, updateMessageById:gL, updateTraceBlocksByMessageId:mL, appendMessageIfMissing:lL, loadRunDetail:lw, loadDirectory:cw, refreshWorkspaceStatus:yL, refreshRecentSessions:hm, 
  runSemanticSearch:fm});
  const vL = Rn => {
    aw({id:Rn.path, title:Rn.title, path:Rn.path, snippet:Rn.section, kind:"semantic"});
  }, wL = async Rn => {
    await uw(Rn.path);
  };
  return (0,require$react.useEffect)(() => {
    const Rn = ($ == null ? void 0 : $.tool_receipts) ?? [];
    for (const Hi of Rn) {
      if (!(Hi != null && Hi.id) || wh.current.has(Hi.id)) {
        continue;
      }
      const bl = VV(Hi);
      bl && (wh.current.add(Hi.id), dm({...bl, statusMessage:bl.path ? `Opened ${bl.path} in canvas.` : "Opened tool result in canvas."}));
    }
  }, [$ == null ? void 0 : $.tool_receipts, dm]), (0,require$react.useEffect)(() => {
    oY({activeAgentId:T, selectedModel:Me, selectedThinkingLevel:it});
  }, [T, Me, it]), {activeRole:p, activeActorId:m, setActiveActorId:b, availableActors:x, activeAgentId:T, setActiveAgentId:I, availableAgents:_, toolCatalog:E, systemPrompt:k, setSystemPrompt:A, sessionId:P, messages:F, consoleLines:z, isSending:V, showConsole:D, showSettings:ee, showCanvas:X, wsStatus:me, conversationId:q, latestRun:$, runtimeEvents:J, liveControlText:le, setLiveControlText:be, queueingControl:je, abortingTurn:ue, proxxModels:$e, selectedModel:Me, setSelectedModel:Xe, selectedThinkingLevel:it, 
  setSelectedThinkingLevel:se, proxxReachable:oe, proxxConfigured:ke, sttEnabled:Oe, ttsEnabled:rt, ttsDefaultVoiceId:ft, isRecovering:um, browseData:ht, previewData:de, loadingBrowse:dt, loadingPreview:ze, entryFilter:Dt, setEntryFilter:Et, semanticQuery:Tt, setSemanticQuery:yt, semanticResults:Ut, setSemanticResults:en, semanticProjects:Fn, setSemanticProjects:Sn, semanticSearching:Lt, sessionSearchHits:wr, setSessionSearchHits:kn, sessionSearchMode:Ct, setSessionSearchMode:un, workspaceSourceId:at, 
  workspaceJob:jt, recentSessions:ko, recentSessionsHasMore:vt, recentSessionsTotal:Pn, loadingRecentSessions:bn, loadingMoreRecentSessions:ai, loadingMemorySessionId:vh, sidebarPaneSplitPct:cm, sidebarWidthPx:pl, sidebarSplitContainerRef:Yr, visibilityFilter:Dr, setVisibilityFilter:_h, kindFilter:Vc, setKindFilter:qc, sessionActorFilter:Eo, setSessionActorFilter:H, excludeEtaMuSessions:pe, setExcludeEtaMuSessions:Pe, statsTotal:HD, statsByVisibility:zD, syncingWorkspace:Je, canvasTitle:mn, setCanvasTitle:vn, 
  canvasSubject:xt, setCanvasSubject:Jn, canvasPath:tt, setCanvasPath:Qt, canvasRecipients:Vt, setCanvasRecipients:wi, canvasCc:qt, setCanvasCc:Zn, canvasContent:On, setCanvasContent:ps, canvasStatus:hl, savingCanvas:wo, savingCanvasFile:_i, sendingCanvas:ha, pinnedContext:Vr, activeEntryCount:ki, assistantSurfaceBackground:Hs, assistantSurfaceBorder:gl, assistantSurfaceText:Us, currentParentPath:zi, currentPath:pa, filteredEntries:ml, hydrationSources:LD, latestToolReceipts:MD, liveControlEnabled:ow, 
  liveToolEvents:BD, liveToolReceipts:$D, semanticMode:FD, workspaceProgressPercent:UD, startSidebarPaneResize:WD, startSidebarWidthResize:jD, toggleConsole:() => ie(Rn => !Rn), toggleSettings:() => M(Rn => !Rn), toggleCanvas:() => ge(Rn => !Rn), handleNewChat:cL, handleSend:uL, handleUndoLastTurn:dL, queueLiveControl:hL, voiceSteer:fL, abortTurn:pL, openHydrationSource:wL, pinHydrationSource:vL, loadDirectory:cw, loadMoreRecentSessions:bL, previewFile:uw, refreshRecentSessions:hm, resumeMemorySession:xL, 
  runSemanticSearch:fm, appendToScratchpad:VD, clearScratchpad:qD, insertPinnedIntoCanvas:GD, openCanvasArtifact:dm, openMessageInCanvas:QD, openPinnedInCanvas:KD, openPreviewInCanvas:XD, openSourceInPreview:JD, pinAssistantSource:ZD, pinContextItem:aw, pinMessageContext:eL, pinPreviewContext:tL, pinSemanticResult:nL, saveCanvasDraft:rL, saveCanvasFile:iL, sendCanvasEmailAction:sL, unpinContextItem:oL, useLatestAssistantInCanvas:aL};
}
const uY = {internal:"\ud83d\udd12", review:"\ud83d\udc40", public:"\ud83c\udf10", archived:"\ud83d\udce6"};
function dY({semanticMode:t, activeEntryCount:e, currentPath:n, currentParentPath:r, semanticProjects:i, loadingBrowse:s, browseData:o, semanticResults:a, filteredEntries:l, previewData:c, loadingPreview:u, onPreviewFile:h, onOpenFile:f, onLoadDirectory:p, onPinSemanticResult:g, onAppendToScratchpad:m, onPinPreviewContext:b, onOpenPreviewInCanvas:x}) {
  return (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{flex:1, minHeight:0, display:"flex", flexDirection:"column", overflow:"hidden"}, children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{padding:"4px 8px", fontSize:10, color:"var(--token-colors-text-muted)", borderBottom:"1px solid var(--token-colors-border-default)", flexShrink:0, display:"flex", alignItems:"center", justifyContent:"space-between"}, children:(0,require$react_SLASH_jsx_runtime.jsxs)("span", {children:[t ? 
  "Semantic Results" : "Files", " \u2022 ", e, t && i.length ? ` in ${i.join(", ")}` : ""]})}), !t && (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{padding:"4px 8px", borderBottom:"1px solid var(--token-colors-border-default)", display:"flex", alignItems:"center", justifyContent:"space-between", gap:8, flexShrink:0}, children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{fontSize:10, color:"var(--token-colors-text-muted)", overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap", 
  minWidth:0}, title:`/${n || ""}`, children:["/", n || ""]}), (0,require$react_SLASH_jsx_runtime.jsx)(Ke, {variant:"ghost", size:"sm", onClick:() => void p(r), children:"Up"})]}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{flex:1, minHeight:0, overflowY:"auto"}, children:s && !o ? (0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{display:"flex", justifyContent:"center", padding:16}, children:(0,require$react_SLASH_jsx_runtime.jsx)(tp, {size:"sm"})}) : t ? (0,require$react_SLASH_jsx_runtime.jsx)("div", 
  {children:a.map(w => (0,require$react_SLASH_jsx_runtime.jsxs)("button", {type:"button", onClick:() => {
    f ? f({name:w.path.split("/").pop() ?? w.path, path:w.path, type:"file", previewable:!0}) : h && h(w.path);
  }, style:{width:"100%", textAlign:"left", padding:"4px 8px", border:"none", borderBottom:"1px solid var(--token-colors-alpha-bg-_08)", background:(c == null ? void 0 : c.path) === w.path ? "var(--token-colors-alpha-blue-_15)" : "transparent", cursor:"pointer"}, children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{display:"flex", alignItems:"center", gap:4, minWidth:0}, children:[(0,require$react_SLASH_jsx_runtime.jsx)("span", {style:{fontSize:10}, children:"\u26a1"}), (0,require$react_SLASH_jsx_runtime.jsx)("span", 
  {style:{fontSize:11, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap"}, children:w.path.split("/").pop()}), w.distance != null && (0,require$react_SLASH_jsx_runtime.jsx)(ct, {size:"sm", variant:"info", children:(1 - w.distance).toFixed(2)})]}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{fontSize:9, color:"var(--token-colors-text-muted)", marginLeft:14, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap"}, children:w.path}), w.snippet && (0,require$react_SLASH_jsx_runtime.jsxs)("div", 
  {style:{fontSize:9, color:"var(--token-colors-text-subtle)", marginLeft:14, marginTop:2, lineHeight:1.4}, children:[w.snippet.slice(0, 100), "..."]})]}, `semantic:${w.id}`))}) : (0,require$react_SLASH_jsx_runtime.jsxs)("div", {children:[l.map(w => (0,require$react_SLASH_jsx_runtime.jsxs)("button", {type:"button", onClick:() => {
    w.type === "dir" ? p(w.path) : f ? f(w) : w.previewable && h && h(w.path);
  }, style:{width:"100%", textAlign:"left", padding:"3px 8px", border:"none", borderBottom:"1px solid var(--token-colors-alpha-bg-_08)", background:(c == null ? void 0 : c.path) === w.path ? "var(--token-colors-alpha-blue-_15)" : "transparent", cursor:"pointer"}, title:w.last_error ?? w.path, children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{display:"flex", alignItems:"center", gap:4, minWidth:0}, children:[(0,require$react_SLASH_jsx_runtime.jsx)("span", {style:{fontSize:10, color:"var(--token-colors-text-subtle)", 
  width:10, flexShrink:0}, children:w.type === "dir" ? "\u25b8" : "\u00b7"}), (0,require$react_SLASH_jsx_runtime.jsx)("span", {style:{width:5, height:5, borderRadius:999, background:w.ingestion_status === "failed" ? "var(--token-colors-accent-red)" : w.ingestion_status === "ingested" ? "var(--token-colors-accent-green)" : w.ingestion_status === "partial" ? "var(--token-colors-accent-cyan)" : "var(--token-colors-text-subtle)", flexShrink:0}}), (0,require$react_SLASH_jsx_runtime.jsx)("span", {style:{fontSize:11, 
  fontWeight:500, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap", flex:1}, children:w.name}), w.visibility && (0,require$react_SLASH_jsx_runtime.jsx)("span", {style:{fontSize:9}, title:w.visibility, children:uY[w.visibility] || ""}), w.ingested_count && w.ingested_count > 0 && (0,require$react_SLASH_jsx_runtime.jsx)("span", {style:{fontSize:9, color:"var(--token-colors-text-muted)", flexShrink:0}, children:w.ingested_count})]}), w.last_error && (0,require$react_SLASH_jsx_runtime.jsxs)("div", 
  {style:{fontSize:9, color:"var(--token-colors-accent-red)", marginLeft:19, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap"}, children:["\u26a0 ", w.last_error.slice(0, 50)]})]}, `${w.type}:${w.path}`)), l.length === 0 && !s && (0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{padding:16, textAlign:"center", color:"var(--token-colors-text-muted)", fontSize:11}, children:"No files found"})]})}), !f && (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{minHeight:80, maxHeight:120, 
  overflowY:"auto", padding:6, background:"var(--token-colors-alpha-bg-_08)", borderTop:"1px solid var(--token-colors-border-default)", flexShrink:0}, children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{display:"flex", alignItems:"center", justifyContent:"space-between", gap:8, marginBottom:4}, children:[(0,require$react_SLASH_jsx_runtime.jsx)("span", {style:{fontSize:10, fontWeight:600}, children:"Preview"}), c && (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{display:"flex", 
  gap:4}, children:[(0,require$react_SLASH_jsx_runtime.jsx)(Ke, {variant:"ghost", size:"sm", onClick:b, children:"Pin"}), (0,require$react_SLASH_jsx_runtime.jsx)(Ke, {variant:"ghost", size:"sm", onClick:() => void x(), children:"Open"})]})]}), u ? (0,require$react_SLASH_jsx_runtime.jsx)(tp, {size:"sm"}) : c ? (0,require$react_SLASH_jsx_runtime.jsxs)(require$react_SLASH_jsx_runtime.Fragment, {children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{fontSize:9, color:"var(--token-colors-text-muted)", 
  marginBottom:4}, children:c.path}), (0,require$react_SLASH_jsx_runtime.jsxs)("pre", {style:{margin:0, whiteSpace:"pre-wrap", fontSize:9, lineHeight:1.4, color:"var(--token-colors-text-subtle)", maxHeight:60, overflow:"hidden"}, children:[c.content.slice(0, 300), c.content.length > 300 ? "..." : ""]})]}) : (0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{fontSize:10, color:"var(--token-colors-text-muted)"}, children:"Select a file to preview"})]})]});
}
const hY = [{value:"all", label:"All"}, {value:"internal", label:"\ud83d\udd12 Internal"}, {value:"review", label:"\ud83d\udc40 Review"}, {value:"public", label:"\ud83c\udf10 Public"}, {value:"archived", label:"\ud83d\udce6 Archived"}], fY = [{value:"all", label:"All kinds"}, {value:"docs", label:"Docs"}, {value:"code", label:"Code"}, {value:"config", label:"Config"}, {value:"data", label:"Data"}];
function _N({sidebarWidthPx:t, sidebarPaneSplitPct:e, sidebarSplitContainerRef:n, onHide:r, onStartSidebarPaneResize:i, onStartSidebarWidthResize:s, visibilityFilter:o, kindFilter:a, statsTotal:l, statsByVisibility:c, onVisibilityFilterChange:u, onKindFilterChange:h, sourceFilter:f, domainFilter:p, pathPrefixFilter:g, onSourceFilterChange:m, onDomainFilterChange:b, onPathPrefixFilterChange:x, onNewDocument:w, onNewVisualDraft:v, currentPath:T, currentParentPath:I, browseData:_, previewData:N, loadingBrowse:E, 
loadingPreview:C, entryFilter:k, semanticQuery:A, semanticResults:P, semanticProjects:W, semanticSearching:F, sessionSearchHits:B, sessionSearchMode:z, semanticMode:j, filteredEntries:V, activeEntryCount:ne, workspaceSourceId:D, workspaceJob:ie, workspaceProgressPercent:ee, pinnedContext:M, recentSessions:X, recentSessionsHasMore:ge, recentSessionsTotal:me, loadingRecentSessions:te, loadingMoreRecentSessions:q, loadingMemorySessionId:R, sessionId:$, conversationId:G, availableActors:J, sessionActorFilter:U, 
excludeEtaMuSessions:le, onLoadDirectory:be, onEntryFilterChange:je, onSemanticQueryChange:Ae, onSemanticSearch:ue, onClearSemanticSearch:Le, onSessionActorFilterChange:$e, onExcludeEtaMuSessionsChange:Ye, onRefreshRecentSessions:Me, onLoadMoreRecentSessions:Xe, onResumeMemorySession:it, onPreviewFile:se, onOpenFile:oe, onPinSemanticResult:we, onAppendToScratchpad:ke, onPinPreviewContext:fe, onOpenPreviewInCanvas:Oe, onOpenPinnedInCanvas:We, onInsertPinnedIntoCanvas:rt, onUnpinContextItem:st}) {
  const ft = ie == null ? void 0 : ie.status, St = ft === "running" ? "var(--token-colors-accent-cyan)" : ft === "completed" ? "var(--token-colors-accent-green)" : ft === "failed" ? "var(--token-colors-accent-red)" : "var(--token-colors-text-muted)", ht = X && X.length > 0 || _ || V && V.length > 0, xe = _ || V && V.length > 0, de = !!(A ?? "").trim(), qe = [{id:"all", label:"All actors"}, ...(J ?? []).map(ze => ({id:ze.id, label:ze.id}))].filter((ze, kt, Dt) => Dt.findIndex(Et => Et.id === ze.id) === 
  kt), dt = (() => {
    var kt, Dt;
    const ze = new Map();
    for (const Et of B ?? []) {
      const Tt = typeof Et.session == "string" ? Et.session : typeof((kt = Et.metadata) == null ? void 0 : kt.session) == "string" ? Et.metadata.session : "";
      if (!Tt) {
        continue;
      }
      const yt = typeof Et.snippet == "string" ? Et.snippet : typeof Et.text == "string" ? Et.text : typeof Et.document == "string" ? Et.document : "", Ut = ((Dt = X == null ? void 0 : X.find(Fn => Fn.session === Tt)) == null ? void 0 : Dt.title) ?? void 0, en = ze.get(Tt);
      en ? (en.hitCount += 1, !en.snippet && yt && (en.snippet = yt)) : ze.set(Tt, {session:Tt, snippet:yt, hitCount:1, title:Ut});
    }
    return [...ze.values()];
  })(), gt = ze => {
    if (!ge || q || te || !Xe) {
      return;
    }
    const kt = ze.currentTarget;
    kt.scrollHeight - kt.scrollTop - kt.clientHeight <= 120 && Xe();
  };
  return (0,require$react_SLASH_jsx_runtime.jsxs)(require$react_SLASH_jsx_runtime.Fragment, {children:[(0,require$react_SLASH_jsx_runtime.jsxs)(Mn, {variant:"default", padding:"none", style:{width:t, minWidth:0, flexShrink:0, display:"flex", flexDirection:"column", borderRight:"1px solid var(--token-colors-border-default)", minHeight:0, overflow:"hidden"}, children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{padding:"6px 10px", borderBottom:"1px solid var(--token-colors-border-default)", 
  display:"flex", alignItems:"center", justifyContent:"space-between", gap:8}, children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{display:"flex", alignItems:"center", gap:8, minWidth:0}, children:[(0,require$react_SLASH_jsx_runtime.jsx)("span", {style:{fontSize:12, fontWeight:600}, children:"Explorer"}), l > 0 && (0,require$react_SLASH_jsx_runtime.jsx)(ct, {size:"sm", variant:"default", children:l}), ie && ft === "running" && (0,require$react_SLASH_jsx_runtime.jsxs)(ct, {size:"sm", 
  variant:"info", children:[ee, "%"]})]}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{display:"flex", gap:4}, children:(0,require$react_SLASH_jsx_runtime.jsx)(Ke, {variant:"ghost", size:"sm", onClick:r, children:"\u2715"})})]}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{height:"100%", minHeight:0, display:"flex", flexDirection:"column", overflow:"hidden"}, children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{padding:8, borderBottom:"1px solid var(--token-colors-border-default)", 
  display:"flex", flexDirection:"column", gap:6, flexShrink:0}, children:[je && (0,require$react_SLASH_jsx_runtime.jsx)(Cn, {value:k ?? "", onChange:ze => je(ze.target.value), placeholder:"Filter...", size:"sm"}), Ae && (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{display:"flex", gap:4}, children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{flex:1}, children:(0,require$react_SLASH_jsx_runtime.jsx)(Cn, {value:A ?? "", onChange:ze => Ae(ze.target.value), placeholder:"Semantic search...", 
  size:"sm"})}), j ? (0,require$react_SLASH_jsx_runtime.jsx)(Ke, {variant:"ghost", size:"sm", onClick:Le ?? (() => {
  }), children:"\u2715"}) : (0,require$react_SLASH_jsx_runtime.jsx)(Ke, {variant:"secondary", size:"sm", loading:F, onClick:() => ue && void ue(), children:"\u26b2"})]}), $e && (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{display:"flex", gap:4, alignItems:"center"}, children:[(0,require$react_SLASH_jsx_runtime.jsx)("select", {value:U ?? "all", onChange:ze => $e(ze.target.value), style:{flex:1, fontSize:11, padding:"4px 6px", borderRadius:4, border:"1px solid var(--token-colors-border-default)", 
  background:"var(--token-colors-background-canvas)", color:"var(--token-colors-text-default)"}, children:qe.map(ze => (0,require$react_SLASH_jsx_runtime.jsx)("option", {value:ze.id, children:ze.label}, ze.id))}), Ye ? (0,require$react_SLASH_jsx_runtime.jsx)(Ke, {variant:le ? "secondary" : "ghost", size:"sm", onClick:() => Ye(!le), title:le ? "Show eta-mu sessions" : "Hide eta-mu sessions", children:le ? "eta-mu off" : "eta-mu on"}) : null]}), m && (0,require$react_SLASH_jsx_runtime.jsx)(Cn, {value:f ?? 
  "", onChange:ze => m(ze.target.value), placeholder:"Source filter...", size:"sm"}), b && (0,require$react_SLASH_jsx_runtime.jsx)(Cn, {value:p ?? "", onChange:ze => b(ze.target.value), placeholder:"Domain filter...", size:"sm"}), x && (0,require$react_SLASH_jsx_runtime.jsx)(Cn, {value:g ?? "", onChange:ze => x(ze.target.value), placeholder:"Path prefix...", size:"sm"}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{display:"flex", gap:4}, children:[(0,require$react_SLASH_jsx_runtime.jsx)("select", 
  {value:o, onChange:ze => u(ze.target.value), style:{flex:1, fontSize:11, padding:"4px 6px", borderRadius:4, border:"1px solid var(--token-colors-border-default)", background:"var(--token-colors-background-canvas)", color:"var(--token-colors-text-default)"}, children:hY.map(ze => (0,require$react_SLASH_jsx_runtime.jsxs)("option", {value:ze.value, children:[ze.label, c[ze.value] !== void 0 ? ` (${c[ze.value]})` : ""]}, ze.value))}), (0,require$react_SLASH_jsx_runtime.jsx)("select", {value:a, onChange:ze => 
  h(ze.target.value), style:{flex:1, fontSize:11, padding:"4px 6px", borderRadius:4, border:"1px solid var(--token-colors-border-default)", background:"var(--token-colors-background-canvas)", color:"var(--token-colors-text-default)"}, children:fY.map(ze => (0,require$react_SLASH_jsx_runtime.jsx)("option", {value:ze.value, children:ze.label}, ze.value))})]}), w && (0,require$react_SLASH_jsx_runtime.jsx)(Ke, {variant:"primary", size:"sm", fullWidth:!0, onClick:w, children:"+ New Document"}), v && (0,require$react_SLASH_jsx_runtime.jsx)(Ke, 
  {variant:"secondary", size:"sm", fullWidth:!0, onClick:v, children:"+ New Visual Draft"}), ie && (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{display:"flex", alignItems:"center", gap:6, fontSize:10, color:"var(--token-colors-text-muted)"}, children:[(0,require$react_SLASH_jsx_runtime.jsx)("span", {style:{width:6, height:6, borderRadius:999, background:St, flexShrink:0}}), (0,require$react_SLASH_jsx_runtime.jsx)("span", {children:ft === "running" ? `${ie.processed_files}/${ie.total_files || 
  0} files` : ft === "completed" ? `${ie.chunks_created} chunks indexed` : ft === "failed" ? "Ingestion failed" : "Ready"})]})]}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {ref:n, style:{flex:1, minHeight:0, display:"flex", flexDirection:"column", overflow:"hidden"}, children:[ht && X && (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{flex:`0 0 ${e}%`, minHeight:0, display:"flex", flexDirection:"column", overflow:"hidden"}, children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", 
  {style:{padding:"6px 8px", borderBottom:"1px solid var(--token-colors-border-default)", flex:1, minHeight:0, display:"flex", flexDirection:"column", overflow:"hidden"}, children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{display:"flex", alignItems:"center", justifyContent:"space-between", gap:8, marginBottom:6, flexShrink:0}, children:[(0,require$react_SLASH_jsx_runtime.jsx)("span", {style:{fontSize:10, fontWeight:600, textTransform:"uppercase", color:"var(--token-colors-text-muted)"}, 
  children:de ? "Session matches" : "Sessions"}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{display:"flex", gap:4, alignItems:"center"}, children:[(0,require$react_SLASH_jsx_runtime.jsx)(ct, {size:"sm", variant:"default", children:de ? dt.length : (me ?? 0) > 0 ? `${X.length}/${me}` : X.length}), de && z && z !== "none" ? (0,require$react_SLASH_jsx_runtime.jsx)(ct, {size:"sm", variant:"info", children:z}) : null, Me && (0,require$react_SLASH_jsx_runtime.jsx)(Ke, {variant:"ghost", size:"sm", 
  loading:te, onClick:() => void Me(), children:"\u21bb"})]})]}), de ? dt.length === 0 ? (0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{fontSize:10, color:"var(--token-colors-text-muted)"}, children:"No session matches"}) : (0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{display:"flex", flexDirection:"column", gap:4, flex:1, minHeight:0, overflowY:"auto", overflowX:"hidden"}, children:dt.map(ze => {
    var Dt;
    const kt = $ && ((Dt = X == null ? void 0 : X.find(Et => Et.session === ze.session)) == null ? void 0 : Dt.active_session_id) === $ || G && G === ze.session;
    return (0,require$react_SLASH_jsx_runtime.jsxs)("button", {type:"button", onClick:() => it && void it(ze.session), style:{width:"100%", textAlign:"left", padding:"6px", border:"none", borderRadius:4, background:kt ? "var(--token-colors-alpha-blue-_15)" : "transparent", cursor:"pointer", display:"grid", gap:2}, children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{display:"flex", alignItems:"center", justifyContent:"space-between", gap:4}, children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", 
    {style:{minWidth:0, fontSize:11, fontWeight:500, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap"}, children:ze.title || ze.session.slice(0, 8)}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{display:"flex", gap:4, flexShrink:0}, children:[kt ? (0,require$react_SLASH_jsx_runtime.jsx)(ct, {size:"sm", variant:"info", children:"Current"}) : null, (0,require$react_SLASH_jsx_runtime.jsx)(ct, {size:"sm", variant:"default", children:ze.hitCount})]})]}), ze.snippet ? (0,require$react_SLASH_jsx_runtime.jsx)("div", 
    {style:{fontSize:10, color:"var(--token-colors-text-muted)", lineHeight:1.35, overflow:"hidden", textOverflow:"ellipsis", display:"-webkit-box", WebkitLineClamp:2, WebkitBoxOrient:"vertical"}, children:ze.snippet}) : null]}, ze.session);
  })}) : X.length === 0 ? (0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{fontSize:10, color:"var(--token-colors-text-muted)"}, children:"No sessions"}) : (0,require$react_SLASH_jsx_runtime.jsxs)("div", {onScroll:gt, style:{display:"flex", flexDirection:"column", gap:4, flex:1, minHeight:0, overflowY:"auto", overflowX:"hidden"}, children:[X.map(ze => {
    const kt = $ && ze.active_session_id === $ || G && G === ze.session, Dt = !!ze.is_active, Et = ze.local_only && !ze.event_count ? "Draft" : ze.has_active_stream ? "Live" : ze.active_status === "waiting_input" ? "Waiting" : Dt ? "Active" : "Idle", Tt = ze.has_active_stream ? "warning" : Dt ? "success" : (ze.local_only, "default");
    return (0,require$react_SLASH_jsx_runtime.jsxs)("button", {type:"button", onClick:() => it && void it(ze.session), style:{width:"100%", textAlign:"left", padding:"4px 6px", border:"none", borderRadius:4, background:kt ? "var(--token-colors-alpha-blue-_15)" : Dt ? "var(--token-colors-alpha-green-_14)" : "transparent", cursor:"pointer", display:"flex", alignItems:"center", justifyContent:"space-between", gap:4}, children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{minWidth:0, flex:1}, 
    children:(0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{fontSize:11, fontWeight:500, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap"}, children:ze.title || ze.session.slice(0, 8)})}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{display:"flex", gap:4, flexShrink:0}, children:[kt && (0,require$react_SLASH_jsx_runtime.jsx)(ct, {size:"sm", variant:"info", children:"Current"}), (0,require$react_SLASH_jsx_runtime.jsx)(ct, {size:"sm", variant:Tt, children:Et})]})]}, 
    ze.session);
  }), q && (0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{fontSize:10, color:"var(--token-colors-text-muted)", padding:4}, children:"Loading..."})]})]}), M && M.length > 0 && (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{padding:"6px 8px", borderTop:"1px solid var(--token-colors-border-default)", maxHeight:100, overflow:"hidden"}, children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{display:"flex", alignItems:"center", justifyContent:"space-between", gap:8, marginBottom:4}, 
  children:[(0,require$react_SLASH_jsx_runtime.jsx)("span", {style:{fontSize:10, fontWeight:600, textTransform:"uppercase", color:"var(--token-colors-text-muted)"}, children:"Pinned"}), (0,require$react_SLASH_jsx_runtime.jsx)(ct, {size:"sm", variant:"default", children:M.length})]}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{display:"flex", flexWrap:"wrap", gap:4}, children:[M.slice(0, 6).map(ze => (0,require$react_SLASH_jsx_runtime.jsx)("button", {type:"button", onClick:() => We && 
  void We(ze), title:ze.path, style:{padding:"2px 6px", fontSize:10, borderRadius:4, border:"1px solid var(--token-colors-border-default)", background:"var(--token-colors-alpha-bg-_08)", cursor:"pointer", maxWidth:100, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap"}, children:ze.title}, `${ze.kind}:${ze.path}`)), M.length > 6 && (0,require$react_SLASH_jsx_runtime.jsxs)("span", {style:{fontSize:10, color:"var(--token-colors-text-muted)"}, children:["+", M.length - 6]})]})]})]}), ht && 
  (0,require$react_SLASH_jsx_runtime.jsx)("div", {role:"separator", "aria-orientation":"horizontal", onMouseDown:i, style:{height:4, cursor:"row-resize", display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0}, children:(0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{height:2, width:40, borderRadius:999, background:"var(--token-colors-border-default)"}})}), xe && (0,require$react_SLASH_jsx_runtime.jsx)(dY, {semanticMode:j ?? !1, activeEntryCount:ne ?? 0, currentPath:T ?? 
  "", currentParentPath:I ?? "", semanticProjects:W ?? [], loadingBrowse:E ?? !1, browseData:_ ?? null, semanticResults:P ?? [], filteredEntries:V ?? [], previewData:N ?? null, loadingPreview:C ?? !1, onPreviewFile:se, onOpenFile:oe, onLoadDirectory:be ?? (() => {
  }), onPinSemanticResult:we ?? (() => {
  }), onAppendToScratchpad:ke ?? (() => {
  }), onPinPreviewContext:fe ?? (() => {
  }), onOpenPreviewInCanvas:Oe ?? (() => {
  })})]})]})]}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {role:"separator", "aria-orientation":"vertical", "aria-label":"Resize context bar", onMouseDown:s, style:{width:6, cursor:"col-resize", flexShrink:0, display:"flex", alignItems:"stretch", justifyContent:"center", background:"transparent"}, children:(0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{width:1, background:"var(--token-colors-border-default)", margin:"4px 0"}})})]});
}
function pY({children:t, className:e = "", style:n}) {
  return (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:e, style:{...n, display:"flex", flex:"1 1 0%", width:"100%", height:"100%", minWidth:0, minHeight:0, overflow:"hidden", gap:0}, children:t});
}
const gY = "chat_primary", mY = "knoxx_chat_page_session_id", bY = "knoxx_chat_page_scratchpad_state", yY = "knoxx_chat_page_pinned_context", xY = "knoxx_chat_page_session_state", vY = "knoxx_chat_page_sidebar_width_px";
function Vhe() {
  const t = Pg({initialShowCanvas:!1, defaultActorId:gY, sessionIdKey:mY, scratchpadStorageKey:bY, pinnedContextStorageKey:yY, sessionStateKey:xY, sidebarWidthKey:vY}), [e, n] = (0,require$react.useState)(!0);
  return (0,require$react_SLASH_jsx_runtime.jsxs)(pY, {style:{background:"radial-gradient(circle at top left, var(--token-colors-alpha-green-_14) 0%, transparent 28%), radial-gradient(circle at bottom right, var(--token-colors-alpha-orange-_12) 0%, transparent 24%), linear-gradient(180deg, var(--token-monokai-bg-default) 0%, var(--token-monokai-bg-darker) 100%)"}, children:[e ? (0,require$react_SLASH_jsx_runtime.jsx)(_N, {sidebarWidthPx:t.sidebarWidthPx, sidebarPaneSplitPct:t.sidebarPaneSplitPct, 
  sidebarSplitContainerRef:t.sidebarSplitContainerRef, currentPath:t.currentPath, currentParentPath:t.currentParentPath, browseData:t.browseData, previewData:t.previewData, loadingBrowse:t.loadingBrowse, loadingPreview:t.loadingPreview, entryFilter:t.entryFilter, semanticQuery:t.semanticQuery, semanticResults:t.semanticResults, semanticProjects:t.semanticProjects, semanticSearching:t.semanticSearching, sessionSearchHits:t.sessionSearchHits, sessionSearchMode:t.sessionSearchMode, semanticMode:t.semanticMode, 
  filteredEntries:t.filteredEntries, activeEntryCount:t.activeEntryCount, workspaceSourceId:t.workspaceSourceId, workspaceJob:t.workspaceJob, workspaceProgressPercent:t.workspaceProgressPercent, pinnedContext:t.pinnedContext, recentSessions:t.recentSessions, recentSessionsHasMore:t.recentSessionsHasMore, recentSessionsTotal:t.recentSessionsTotal, loadingRecentSessions:t.loadingRecentSessions, loadingMoreRecentSessions:t.loadingMoreRecentSessions, loadingMemorySessionId:t.loadingMemorySessionId, sessionId:t.sessionId, 
  conversationId:t.conversationId, availableActors:t.availableActors, sessionActorFilter:t.sessionActorFilter, excludeEtaMuSessions:t.excludeEtaMuSessions, visibilityFilter:t.visibilityFilter, kindFilter:t.kindFilter, statsTotal:t.statsTotal, statsByVisibility:t.statsByVisibility, onHide:() => n(!1), onLoadDirectory:t.loadDirectory, onEntryFilterChange:t.setEntryFilter, onSemanticQueryChange:t.setSemanticQuery, onSemanticSearch:() => t.runSemanticSearch(t.semanticQuery), onClearSemanticSearch:() => 
  {
    t.setSemanticQuery(""), t.setSemanticResults([]), t.setSemanticProjects([]), t.setSessionSearchMode("none");
  }, onRefreshRecentSessions:t.refreshRecentSessions, onLoadMoreRecentSessions:t.loadMoreRecentSessions, onResumeMemorySession:t.resumeMemorySession, onPreviewFile:t.previewFile, onPinSemanticResult:t.pinSemanticResult, onAppendToScratchpad:t.appendToScratchpad, onPinPreviewContext:t.pinPreviewContext, onOpenPreviewInCanvas:t.openPreviewInCanvas, onOpenPinnedInCanvas:t.openPinnedInCanvas, onInsertPinnedIntoCanvas:t.insertPinnedIntoCanvas, onUnpinContextItem:t.unpinContextItem, onStartSidebarPaneResize:t.startSidebarPaneResize, 
  onStartSidebarWidthResize:t.startSidebarWidthResize, onVisibilityFilterChange:t.setVisibilityFilter, onKindFilterChange:t.setKindFilter, onSessionActorFilterChange:t.setSessionActorFilter, onExcludeEtaMuSessionsChange:t.setExcludeEtaMuSessions}) : (0,require$react_SLASH_jsx_runtime.jsx)(Fa, {label:"Files", edge:"left", onExpand:() => n(!0), title:"Show Files panel"}), (0,require$react_SLASH_jsx_runtime.jsx)(fd, {controller:t, showFiles:e, onShowFiles:() => n(!0)})]});
}
function wY(t) {
  return t.title ?? t.name ?? t.path.split("/").pop() ?? t.path;
}
function _Y(t) {
  switch(t) {
    case ".mp3":
      return "\ud83c\udfb5";
    case ".wav":
      return "\ud83d\udd0a";
    case ".ogg":
      return "\ud83c\udfb6";
    case ".flac":
      return "\ud83c\udfbc";
    case ".m4a":
      return "\ud83c\udfa4";
    default:
      return "\ud83c\udfa7";
  }
}
function SN({title:t, description:e, track:n, trackCount:r, playerState:i = "idle", playingFrom:s = "library", permissions:o = {}, volume:a = 1, fileIcon:l = _Y, onPrevious:c, onTogglePlayPause:u, onNext:h, onEditLabels:f, onVolumeChange:p, onGenerateSpectrogram:g, onGenerateWaveform:m, onRemoveFromQueue:b, waveform:x, progress:w, heardDescription:v, currentLabels:T, agentActions:I, graphLabelControls:_, emptyState:N}) {
  const E = {canGoPrevious:o.canGoPrevious ?? !1, canPlayPause:o.canPlayPause ?? !1, canGoNext:o.canGoNext ?? !1, canEditLabels:o.canEditLabels ?? !1, canAdjustVolume:o.canAdjustVolume ?? !1, canGenerateAssets:o.canGenerateAssets ?? !1, canRemoveFromQueue:o.canRemoveFromQueue ?? !1};
  return (0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{flex:1, display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", padding:24, background:"var(--token-colors-background-base)"}, children:n ? (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{width:"100%", maxWidth:600, display:"flex", flexDirection:"column", alignItems:"center", gap:16}, children:[t || e || typeof r == "number" ? (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{width:"100%", 
  display:"flex", alignItems:"flex-start", justifyContent:"space-between", gap:12}, children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{minWidth:0}, children:[t ? (0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{fontSize:O.fontSize.lg, fontWeight:700, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap"}, children:t}) : null, e ? (0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{fontSize:O.fontSize.sm, color:"var(--token-colors-text-muted)", marginTop:4}, children:e}) : 
  null]}), typeof r == "number" ? (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{flexShrink:0, padding:"4px 10px", borderRadius:999, border:"1px solid var(--token-colors-border-default)", color:"var(--token-colors-text-muted)", fontSize:12}, children:[r, " track", r === 1 ? "" : "s"]}) : null]}) : null, (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{display:"flex", alignItems:"center", gap:24, width:"100%"}, children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{width:120, 
  height:120, borderRadius:12, background:"linear-gradient(135deg, var(--token-colors-accent-blue), var(--token-colors-accent-purple))", display:"flex", alignItems:"center", justifyContent:"center", fontSize:48, boxShadow:"0 4px 16px rgba(0,0,0,0.2)", flexShrink:0}, children:l(n.ext ?? "")}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{flex:1, minWidth:0}, children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{fontSize:O.fontSize.lg, fontWeight:600, overflow:"hidden", textOverflow:"ellipsis", 
  whiteSpace:"nowrap"}, children:wY(n)}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{fontSize:O.fontSize.xs, color:"var(--token-colors-text-muted)", marginTop:4, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap"}, children:n.path}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{fontSize:O.fontSize.xs, color:"var(--token-colors-accent-blue)", marginTop:4}, children:s === "playlist" ? "\ud83c\udfb5 Playing from queue" : "\ud83d\udcc1 Playing from library"})]})]}), 
  x, w, E.canGoPrevious || E.canPlayPause || E.canGoNext || E.canEditLabels ? (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{display:"flex", alignItems:"center", gap:12}, children:[E.canGoPrevious ? (0,require$react_SLASH_jsx_runtime.jsx)(Ke, {variant:"ghost", onClick:c, children:"\u23ee"}) : null, E.canPlayPause ? (0,require$react_SLASH_jsx_runtime.jsx)("button", {onClick:u, style:{width:48, height:48, borderRadius:"50%", background:"var(--token-colors-accent-blue)", border:"none", cursor:"pointer", 
  fontSize:20, color:"white", display:"flex", alignItems:"center", justifyContent:"center", boxShadow:"0 2px 8px rgba(0,0,0,0.2)"}, children:i === "playing" ? "\u275a\u275a" : "\u25b6"}) : null, E.canGoNext ? (0,require$react_SLASH_jsx_runtime.jsx)(Ke, {variant:"ghost", onClick:h, children:"\u23ed"}) : null, E.canEditLabels ? (0,require$react_SLASH_jsx_runtime.jsx)(Ke, {variant:"ghost", onClick:f, title:"Labels", children:"\ud83c\udff7"}) : null]}) : null, v, T, E.canAdjustVolume ? (0,require$react_SLASH_jsx_runtime.jsxs)("div", 
  {style:{display:"flex", alignItems:"center", gap:8, width:200}, children:[(0,require$react_SLASH_jsx_runtime.jsx)("span", {style:{fontSize:14}, children:a === 0 ? "\ud83d\udd07" : a < 0.5 ? "\ud83d\udd09" : "\ud83d\udd0a"}), (0,require$react_SLASH_jsx_runtime.jsx)("input", {type:"range", min:0, max:1, step:0.01, value:a, onChange:C => p == null ? void 0 : p(parseFloat(C.target.value)), style:{flex:1, accentColor:"var(--token-colors-accent-blue)"}})]}) : null, E.canGenerateAssets || E.canRemoveFromQueue ? 
  (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{display:"flex", gap:8, flexWrap:"wrap", justifyContent:"center"}, children:[E.canGenerateAssets ? (0,require$react_SLASH_jsx_runtime.jsx)(Ke, {variant:"ghost", size:"sm", onClick:g, children:"\ud83d\udcca Spectrogram"}) : null, E.canGenerateAssets ? (0,require$react_SLASH_jsx_runtime.jsx)(Ke, {variant:"ghost", size:"sm", onClick:m, children:"\ud83d\udcc8 Waveform"}) : null, E.canRemoveFromQueue ? (0,require$react_SLASH_jsx_runtime.jsx)(Ke, 
  {variant:"ghost", size:"sm", onClick:b, children:"\u2796 Remove from queue"}) : null]}) : null, I, _]}) : N ?? (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{textAlign:"center", color:"var(--token-colors-text-muted)"}, children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{fontSize:48, marginBottom:12}, children:"\ud83c\udfa7"}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{fontSize:O.fontSize.lg}, children:"Select a file to play"}), (0,require$react_SLASH_jsx_runtime.jsx)("div", 
  {style:{fontSize:O.fontSize.sm, marginTop:8}, children:"Browse the audio library on the left, or ask the studio agent"})]})});
}
function SY(t) {
  if (typeof t != "number" || !Number.isFinite(t) || t <= 0) {
    return null;
  }
  const e = Math.floor(t / 60), n = Math.floor(t % 60);
  return `${e}:${n.toString().padStart(2, "0")}`;
}
function kY(t) {
  return t.title ?? t.name ?? t.path.split("/").pop() ?? t.path;
}
function EY({items:t, selectedIndex:e = -1, readOnly:n = !1, showLabels:r = !0, showDuration:i = !0, maxVisible:s = Number.POSITIVE_INFINITY, onSelect:o, onRemove:a}) {
  const l = Number.isFinite(s) ? t.slice(0, s) : t, c = Math.max(0, t.length - l.length);
  return t.length === 0 ? (0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{padding:24, textAlign:"center", color:"var(--token-colors-text-muted)", fontSize:O.fontSize.sm}, children:"No tracks in this playlist."}) : (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{display:"flex", flexDirection:"column", gap:4, minHeight:0, maxHeight:n ? 420 : void 0, overflowY:n ? "auto" : void 0}, children:[c > 0 ? (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{padding:"6px 8px", color:"var(--token-colors-text-muted)", 
  fontSize:O.fontSize.xs}, children:["Showing first ", l.length, " of ", t.length, " tracks here. The full playlist snapshot is stored in the CMS publication."]}) : null, l.map((u, h) => {
    const f = h === e, p = SY(u.duration);
    return (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{display:"flex", flexDirection:"column", gap:4, padding:"6px 8px", borderRadius:6, fontSize:O.fontSize.sm, background:f ? "var(--token-colors-alpha-blue-10)" : "transparent", border:f ? "1px solid var(--token-colors-accent-blue)" : "1px solid transparent"}, children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{display:"flex", alignItems:"center", gap:8}, children:[(0,require$react_SLASH_jsx_runtime.jsx)("span", {style:{color:"var(--token-colors-text-muted)", 
    width:28, textAlign:"right", fontSize:O.fontSize.xs}, children:h + 1}), (0,require$react_SLASH_jsx_runtime.jsx)("button", {type:"button", onClick:() => o == null ? void 0 : o(u, h), style:{flex:1, minWidth:0, padding:0, border:"none", background:"transparent", color:"inherit", textAlign:"left", cursor:"pointer", overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap", fontWeight:600}, children:kY(u)}), i && p ? (0,require$react_SLASH_jsx_runtime.jsx)("span", {style:{color:"var(--token-colors-text-muted)", 
    fontSize:O.fontSize.xs, minWidth:32, textAlign:"right"}, children:p}) : null, !n && a ? (0,require$react_SLASH_jsx_runtime.jsx)("button", {type:"button", onClick:() => a(u, h), style:{background:"none", border:"none", cursor:"pointer", padding:4, fontSize:14, color:"var(--token-colors-accent-red)"}, title:"Remove", children:"\u00d7"}) : null]}), r && u.labels && u.labels.length > 0 ? (0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{display:"flex", flexWrap:"wrap", gap:3, paddingLeft:36}, 
    children:u.labels.map(g => (0,require$react_SLASH_jsx_runtime.jsx)("span", {style:{padding:"1px 6px", borderRadius:8, fontSize:10, background:"var(--token-colors-alpha-blue-10)", color:"var(--token-colors-text-muted)"}, children:g}, g))}) : null]}, `${u.path}:${h}`);
  })]});
}
const TY = "4.5.4", r1 = Math.PI, vl = 2 * r1, Wm = r1 / 2, nS = 8.17579892, rS = "dual-combined", Rh = "dual-horizontal", Xs = "single", gs = "dual-vertical", iS = "bar-index", sS = "bar-level", Pf = "gradient", oS = 60, aS = "click", CY = "fullscreenchange", kN = "resize", AY = "#111", EN = "", lS = "A", cS = "B", uS = "C", dS = "D", hS = "468", Dh = "sans-serif", NY = "#0f0", IY = "#7f7f7f22", wl = 10, fS = "create", pS = "fschange", OY = "lores", PY = kN, jm = "user", RY = "#000c", gS = "#fff", 
DY = "#4f4", mS = "#888", LY = "#555", Vm = "bark", Jc = "linear", Cl = "log", qm = "mel", bS = ["#a35", "#c66", "#e94", "#ed0", "#9d5", "#4d8", "#2cb", "#0bc", "#09c", "#36b"], TN = [["classic", {colorStops:["red", {color:"yellow", level:0.85, pos:0.6}, {color:"lime", level:0.475}]}], ["prism", {colorStops:bS}], ["rainbow", {dir:"h", colorStops:["#817", ...bS, "#639"]}], ["orangered", {bgColor:"#3e2f29", colorStops:["OrangeRed"]}], ["steelblue", {bgColor:"#222c35", colorStops:["SteelBlue"]}]], Zc = 
{alphaBars:!1, ansiBands:!1, barSpace:0.1, bgAlpha:0.7, channelLayout:Xs, colorMode:Pf, fadePeaks:!1, fftSize:8192, fillAlpha:1, frequencyScale:Cl, gradient:TN[0][0], gravity:3.8, height:void 0, ledBars:!1, linearAmplitude:!1, linearBoost:1, lineWidth:0, loRes:!1, lumiBars:!1, maxDecibels:-25, maxFPS:0, maxFreq:22e3, minDecibels:-85, minFreq:20, mirror:0, mode:0, noteLabels:!1, outlineBars:!1, overlay:!1, peakFadeTime:750, peakHoldTime:500, peakLine:!1, radial:!1, radialInvert:!1, radius:0.3, reflexAlpha:0.15, 
reflexBright:1, reflexFit:!0, reflexRatio:0, roundBars:!1, showBgColor:!0, showFPS:!1, showPeaks:!0, showScaleX:!0, showScaleY:!1, smoothing:0.5, spinSpeed:0, splitGradient:!1, start:!0, trueLeds:!1, useCanvas:!0, volume:1, weightingFilter:EN, width:void 0}, MY = ["ERR_AUDIO_CONTEXT_FAIL", "Could not create audio context. Web Audio API not supported?"], BY = ["ERR_INVALID_AUDIO_CONTEXT", "Provided audio context is not valid"], $Y = ["ERR_UNKNOWN_GRADIENT", "Unknown gradient"], Ym = ["ERR_FREQUENCY_TOO_LOW", 
"Frequency values must be \x3e\x3d 1"], FY = ["ERR_INVALID_MODE", "Invalid mode"], zY = ["ERR_REFLEX_OUT_OF_RANGE", "Reflex ratio must be \x3e\x3d 0 and \x3c 1"], HY = ["ERR_INVALID_AUDIO_SOURCE", "Audio source must be an instance of HTMLMediaElement or AudioNode"], UY = ["ERR_GRADIENT_INVALID_NAME", "Gradient name must be a non-empty string"], WY = ["ERR_GRADIENT_NOT_AN_OBJECT", "Gradient options must be an object"], jY = ["ERR_GRADIENT_MISSING_COLOR", "Gradient colorStops must be a non-empty array"];
class Ei extends Error {
  constructor(e, n) {
    const [r, i] = e;
    super(i + (n !== void 0 ? `: ${n}` : "")), this.name = "AudioMotionError", this.code = r;
  }
}
const yS = (t, e) => console.warn(`${t} is deprecated. Use ${e} instead.`), xS = t => {
  for (const e in t) {
    return !1;
  }
  return !0;
}, Lh = (t, e, n = "toLowerCase") => e[Math.max(0, e.indexOf(("" + t)[n]()))], VY = (t, e, n, r, i) => e + (r - e) * (i - t) / (n - t);
Array.prototype.findLastIndex || (Array.prototype.findLastIndex = function(t) {
  let e = this.length;
  for (; e-- > 0;) {
    if (t(this[e])) {
      return e;
    }
  }
  return -1;
});
class qY {
  constructor(e, n = {}) {
    this._ready = !1, this._aux = {}, this._canvasGradients = [], this._destroyed = !1, this._energy = {val:0, peak:0, hold:0}, this._flg = {}, this._fps = 0, this._gradients = {}, this._last = 0, this._outNodes = [], this._ownContext = !1, this._selectedGrads = [], this._sources = [], e instanceof Element || (xS(n) && !xS(e) && (n = e), e = null), this._ownCanvas = !(n.canvas instanceof HTMLCanvasElement);
    const r = this._ownCanvas ? document.createElement("canvas") : n.canvas;
    r.style = "max-width: 100%;", this._ctx = r.getContext("2d");
    for (const [h, f] of TN) {
      this.registerGradient(h, f);
    }
    this._container = e || !this._ownCanvas && r.parentElement || document.body, this._defaultWidth = this._container.clientWidth || 640, this._defaultHeight = this._container.clientHeight || 270;
    let i;
    if (!(n.source && (i = n.source.context))) {
      if (!(i = n.audioCtx)) {
        try {
          i = new (window.AudioContext || window.webkitAudioContext)(), this._ownContext = !0;
        } catch {
          throw new Ei(MY);
        }
      }
    }
    if (!i.createGain) {
      throw new Ei(BY);
    }
    const s = this._analyzer = [i.createAnalyser(), i.createAnalyser()], o = this._splitter = i.createChannelSplitter(2), a = this._merger = i.createChannelMerger(2);
    this._input = i.createGain(), this._output = i.createGain(), n.source && this.connectInput(n.source);
    for (const h of [0, 1]) {
      o.connect(s[h], h);
    }
    a.connect(this._output), n.connectSpeakers !== !1 && this.connectOutput();
    for (const h of ["_scaleX", "_scaleR"]) {
      this[h] = document.createElement("canvas").getContext("2d");
    }
    this._fsEl = n.fsElement || r;
    const l = () => {
      this._fsTimeout || (this._fsTimeout = window.setTimeout(() => {
        this._fsChanging || (this._setCanvas(PY), this._fsTimeout = 0);
      }, oS));
    };
    window.ResizeObserver && (this._observer = new ResizeObserver(l), this._observer.observe(this._container)), this._controller = new AbortController();
    const c = this._controller.signal;
    window.addEventListener(kN, l, {signal:c}), r.addEventListener(CY, () => {
      this._fsChanging = !0, this._fsTimeout && window.clearTimeout(this._fsTimeout), this._setCanvas(pS), this._fsTimeout = window.setTimeout(() => {
        this._fsChanging = !1, this._fsTimeout = 0;
      }, oS);
    }, {signal:c});
    const u = () => {
      i.state == "suspended" && i.resume().then(() => window.removeEventListener(aS, u));
    };
    window.addEventListener(aS, u), document.addEventListener("visibilitychange", () => {
      document.visibilityState != "hidden" && (this._frames = 0, this._time = performance.now());
    }, {signal:c}), this._setProps(n, !0), this.useCanvas && this._ownCanvas && this._container.appendChild(r), this._ready = !0, this._setCanvas(fS);
  }
  get alphaBars() {
    return this._alphaBars;
  }
  set alphaBars(e) {
    this._alphaBars = !!e, this._calcBars();
  }
  get ansiBands() {
    return this._ansiBands;
  }
  set ansiBands(e) {
    this._ansiBands = !!e, this._calcBars();
  }
  get barSpace() {
    return this._barSpace;
  }
  set barSpace(e) {
    this._barSpace = +e || 0, this._calcBars();
  }
  get channelLayout() {
    return this._chLayout;
  }
  set channelLayout(e) {
    this._chLayout = Lh(e, [Xs, Rh, gs, rS]), this._input.disconnect(), this._input.connect(this._chLayout != Xs ? this._splitter : this._analyzer[0]), this._analyzer[0].disconnect(), this._outNodes.length && this._analyzer[0].connect(this._chLayout != Xs ? this._merger : this._output), this._calcBars(), this._makeGrad();
  }
  get colorMode() {
    return this._colorMode;
  }
  set colorMode(e) {
    this._colorMode = Lh(e, [Pf, iS, sS]);
  }
  get fadePeaks() {
    return this._fadePeaks;
  }
  set fadePeaks(e) {
    this._fadePeaks = !!e;
  }
  get fftSize() {
    return this._analyzer[0].fftSize;
  }
  set fftSize(e) {
    for (const r of [0, 1]) {
      this._analyzer[r].fftSize = e;
    }
    const n = this._analyzer[0].frequencyBinCount;
    this._fftData = [new Float32Array(n), new Float32Array(n)], this._calcBars();
  }
  get frequencyScale() {
    return this._frequencyScale;
  }
  set frequencyScale(e) {
    this._frequencyScale = Lh(e, [Cl, Vm, qm, Jc]), this._calcBars();
  }
  get gradient() {
    return this._selectedGrads[0];
  }
  set gradient(e) {
    this._setGradient(e);
  }
  get gradientLeft() {
    return this._selectedGrads[0];
  }
  set gradientLeft(e) {
    this._setGradient(e, 0);
  }
  get gradientRight() {
    return this._selectedGrads[1];
  }
  set gradientRight(e) {
    this._setGradient(e, 1);
  }
  get gravity() {
    return this._gravity;
  }
  set gravity(e) {
    this._gravity = e > 0 ? +e : this._gravity || Zc.gravity;
  }
  get height() {
    return this._height;
  }
  set height(e) {
    this._height = e, this._setCanvas(jm);
  }
  get ledBars() {
    return this._showLeds;
  }
  set ledBars(e) {
    this._showLeds = !!e, this._calcBars();
  }
  get linearAmplitude() {
    return this._linearAmplitude;
  }
  set linearAmplitude(e) {
    this._linearAmplitude = !!e;
  }
  get linearBoost() {
    return this._linearBoost;
  }
  set linearBoost(e) {
    this._linearBoost = e >= 1 ? +e : 1;
  }
  get lineWidth() {
    return this._lineWidth;
  }
  set lineWidth(e) {
    this._lineWidth = +e || 0;
  }
  get loRes() {
    return this._loRes;
  }
  set loRes(e) {
    this._loRes = !!e, this._setCanvas(OY);
  }
  get lumiBars() {
    return this._lumiBars;
  }
  set lumiBars(e) {
    this._lumiBars = !!e, this._calcBars(), this._makeGrad();
  }
  get maxDecibels() {
    return this._analyzer[0].maxDecibels;
  }
  set maxDecibels(e) {
    for (const n of [0, 1]) {
      this._analyzer[n].maxDecibels = e;
    }
  }
  get maxFPS() {
    return this._maxFPS;
  }
  set maxFPS(e) {
    this._maxFPS = e < 0 ? 0 : +e || 0;
  }
  get maxFreq() {
    return this._maxFreq;
  }
  set maxFreq(e) {
    if (e < 1) {
      throw new Ei(Ym);
    }
    this._maxFreq = Math.min(e, this.audioCtx.sampleRate / 2), this._calcBars();
  }
  get minDecibels() {
    return this._analyzer[0].minDecibels;
  }
  set minDecibels(e) {
    for (const n of [0, 1]) {
      this._analyzer[n].minDecibels = e;
    }
  }
  get minFreq() {
    return this._minFreq;
  }
  set minFreq(e) {
    if (e < 1) {
      throw new Ei(Ym);
    }
    this._minFreq = +e, this._calcBars();
  }
  get mirror() {
    return this._mirror;
  }
  set mirror(e) {
    this._mirror = Math.sign(e) | 0, this._calcBars(), this._makeGrad();
  }
  get mode() {
    return this._mode;
  }
  set mode(e) {
    const n = e | 0;
    if (n >= 0 && n <= 10 && n != 9) {
      this._mode = n, this._calcBars(), this._makeGrad();
    } else {
      throw new Ei(FY, e);
    }
  }
  get noteLabels() {
    return this._noteLabels;
  }
  set noteLabels(e) {
    this._noteLabels = !!e, this._createScales();
  }
  get outlineBars() {
    return this._outlineBars;
  }
  set outlineBars(e) {
    this._outlineBars = !!e, this._calcBars();
  }
  get peakFadeTime() {
    return this._peakFadeTime;
  }
  set peakFadeTime(e) {
    this._peakFadeTime = e >= 0 ? +e : this._peakFadeTime || Zc.peakFadeTime;
  }
  get peakHoldTime() {
    return this._peakHoldTime;
  }
  set peakHoldTime(e) {
    this._peakHoldTime = +e || 0;
  }
  get peakLine() {
    return this._peakLine;
  }
  set peakLine(e) {
    this._peakLine = !!e;
  }
  get radial() {
    return this._radial;
  }
  set radial(e) {
    this._radial = !!e, this._calcBars(), this._makeGrad();
  }
  get radialInvert() {
    return this._radialInvert;
  }
  set radialInvert(e) {
    this._radialInvert = !!e, this._calcBars(), this._makeGrad();
  }
  get radius() {
    return this._radius;
  }
  set radius(e) {
    this._radius = +e || 0, this._calcBars(), this._makeGrad();
  }
  get reflexRatio() {
    return this._reflexRatio;
  }
  set reflexRatio(e) {
    if (e = +e || 0, e < 0 || e >= 1) {
      throw new Ei(zY);
    }
    this._reflexRatio = e, this._calcBars(), this._makeGrad();
  }
  get roundBars() {
    return this._roundBars;
  }
  set roundBars(e) {
    this._roundBars = !!e, this._calcBars();
  }
  get smoothing() {
    return this._analyzer[0].smoothingTimeConstant;
  }
  set smoothing(e) {
    for (const n of [0, 1]) {
      this._analyzer[n].smoothingTimeConstant = e;
    }
  }
  get spinSpeed() {
    return this._spinSpeed;
  }
  set spinSpeed(e) {
    e = +e || 0, (this._spinSpeed === void 0 || e == 0) && (this._spinAngle = -Wm), this._spinSpeed = e;
  }
  get splitGradient() {
    return this._splitGradient;
  }
  set splitGradient(e) {
    this._splitGradient = !!e, this._makeGrad();
  }
  get stereo() {
    return yS("stereo", "channelLayout"), this._chLayout != Xs;
  }
  set stereo(e) {
    yS("stereo", "channelLayout"), this.channelLayout = e ? gs : Xs;
  }
  get trueLeds() {
    return this._trueLeds;
  }
  set trueLeds(e) {
    this._trueLeds = !!e;
  }
  get volume() {
    return this._output.gain.value;
  }
  set volume(e) {
    this._output.gain.value = e;
  }
  get weightingFilter() {
    return this._weightingFilter;
  }
  set weightingFilter(e) {
    this._weightingFilter = Lh(e, [EN, lS, cS, uS, dS, hS], "toUpperCase");
  }
  get width() {
    return this._width;
  }
  set width(e) {
    this._width = e, this._setCanvas(jm);
  }
  get audioCtx() {
    return this._input.context;
  }
  get canvas() {
    return this._ctx.canvas;
  }
  get canvasCtx() {
    return this._ctx;
  }
  get connectedSources() {
    return this._sources;
  }
  get connectedTo() {
    return this._outNodes;
  }
  get fps() {
    return this._fps;
  }
  get fsHeight() {
    return this._fsHeight;
  }
  get fsWidth() {
    return this._fsWidth;
  }
  get isAlphaBars() {
    return this._flg.isAlpha;
  }
  get isBandsMode() {
    return this._flg.isBands;
  }
  get isDestroyed() {
    return this._destroyed;
  }
  get isFullscreen() {
    return this._fsEl && (document.fullscreenElement || document.webkitFullscreenElement) === this._fsEl;
  }
  get isLedBars() {
    return this._flg.isLeds;
  }
  get isLumiBars() {
    return this._flg.isLumi;
  }
  get isOctaveBands() {
    return this._flg.isOctaves;
  }
  get isOn() {
    return !!this._runId;
  }
  get isOutlineBars() {
    return this._flg.isOutline;
  }
  get pixelRatio() {
    return this._pixelRatio;
  }
  get isRoundBars() {
    return this._flg.isRound;
  }
  static get version() {
    return TY;
  }
  connectInput(e) {
    const n = e instanceof HTMLMediaElement;
    if (!(n || e.connect)) {
      throw new Ei(HY);
    }
    const r = n ? this.audioCtx.createMediaElementSource(e) : e;
    return this._sources.includes(r) || (r.connect(this._input), this._sources.push(r)), r;
  }
  connectOutput(e = this.audioCtx.destination) {
    if (!this._outNodes.includes(e) && (this._output.connect(e), this._outNodes.push(e), this._outNodes.length == 1)) {
      for (const n of [0, 1]) {
        this._analyzer[n].connect(this._chLayout == Xs && !n ? this._output : this._merger, 0, n);
      }
    }
  }
  destroy() {
    if (!this._ready) {
      return;
    }
    const {audioCtx:e, canvas:n, _controller:r, _input:i, _merger:s, _observer:o, _ownCanvas:a, _ownContext:l, _splitter:c} = this;
    this._destroyed = !0, this._ready = !1, this.stop(), r.abort(), o && o.disconnect(), this.onCanvasResize = null, this.onCanvasDraw = null, this._fsEl = null, this.disconnectInput(), this.disconnectOutput(), i.disconnect(), c.disconnect(), s.disconnect(), l && e.close(), a && n.remove(), this._calcBars();
  }
  disconnectInput(e, n) {
    e ? Array.isArray(e) || (e = [e]) : e = Array.from(this._sources);
    for (const r of e) {
      const i = this._sources.indexOf(r);
      if (n && r.mediaStream) {
        for (const s of r.mediaStream.getAudioTracks()) {
          s.stop();
        }
      }
      i >= 0 && (r.disconnect(this._input), this._sources.splice(i, 1));
    }
  }
  disconnectOutput(e) {
    if (!(e && !this._outNodes.includes(e)) && (this._output.disconnect(e), this._outNodes = e ? this._outNodes.filter(n => n !== e) : [], this._outNodes.length == 0)) {
      for (const n of [0, 1]) {
        this._analyzer[n].disconnect();
      }
    }
  }
  getBars() {
    return Array.from(this._bars, ({posX:e, freq:n, freqLo:r, freqHi:i, hold:s, peak:o, value:a}) => ({posX:e, freq:n, freqLo:r, freqHi:i, hold:s, peak:o, value:a}));
  }
  getEnergy(e, n) {
    if (e === void 0) {
      return this._energy.val;
    }
    if (e != +e) {
      if (e == "peak") {
        return this._energy.peak;
      }
      const a = {bass:[20, 250], lowMid:[250, 500], mid:[500, 2e3], highMid:[2e3, 4e3], treble:[4e3, 16e3]};
      if (!a[e]) {
        return null;
      }
      [e, n] = a[e];
    }
    const r = this._freqToBin(e), i = n ? this._freqToBin(n) : r, s = this._chLayout == Xs ? 1 : 2;
    let o = 0;
    for (let a = 0; a < s; a++) {
      for (let l = r; l <= i; l++) {
        o += this._normalizedB(this._fftData[a][l]);
      }
    }
    return o / (i - r + 1) / s;
  }
  getOptions(e) {
    Array.isArray(e) || (e = [e]);
    let n = {};
    for (const r of Object.keys(Zc)) {
      e.includes(r) || (r == "gradient" && this.gradientLeft != this.gradientRight ? (n.gradientLeft = this.gradientLeft, n.gradientRight = this.gradientRight) : r != "start" && (n[r] = this[r]));
    }
    return n;
  }
  registerGradient(e, n) {
    if (typeof e != "string" || e.trim().length == 0) {
      throw new Ei(UY);
    }
    if (typeof n != "object") {
      throw new Ei(WY);
    }
    const {colorStops:r} = n;
    if (!Array.isArray(r) || !r.length) {
      throw new Ei(jY);
    }
    const i = r.length, s = o => +o != o || o < 0 || o > 1;
    r.forEach((o, a) => {
      const l = a / Math.max(1, i - 1);
      typeof o != "object" ? r[a] = {pos:l, color:o} : s(o.pos) && (o.pos = l), s(o.level) && (r[a].level = 1 - a / i);
    }), r.sort((o, a) => o.level < a.level ? 1 : o.level > a.level ? -1 : 0), r[0].level = 1, this._gradients[e] = {bgColor:n.bgColor || AY, dir:n.dir, colorStops:r}, this._selectedGrads.includes(e) && this._makeGrad();
  }
  setCanvasSize(e, n) {
    this._width = e, this._height = n, this._setCanvas(jm);
  }
  setFreqRange(e, n) {
    if (e < 1 || n < 1) {
      throw new Ei(Ym);
    }
    this._minFreq = Math.min(e, n), this.maxFreq = Math.max(e, n);
  }
  setLedParams(e) {
    let n, r, i;
    e && (n = e.maxLeds | 0, r = +e.spaceV, i = +e.spaceH), this._ledParams = n > 0 && r > 0 && i >= 0 ? [n, r, i] : void 0, this._calcBars();
  }
  setOptions(e) {
    this._setProps(e);
  }
  setSensitivity(e, n) {
    for (const r of [0, 1]) {
      this._analyzer[r].minDecibels = Math.min(e, n), this._analyzer[r].maxDecibels = Math.max(e, n);
    }
  }
  start() {
    this.toggleAnalyzer(!0);
  }
  stop() {
    this.toggleAnalyzer(!1);
  }
  toggleAnalyzer(e) {
    const n = this.isOn;
    return e === void 0 && (e = !n), n && !e ? (cancelAnimationFrame(this._runId), this._runId = 0) : !n && e && !this._destroyed && (this._frames = 0, this._time = performance.now(), this._runId = requestAnimationFrame(r => this._draw(r))), this.isOn;
  }
  toggleFullscreen() {
    if (this.isFullscreen) {
      document.exitFullscreen ? document.exitFullscreen() : document.webkitExitFullscreen && document.webkitExitFullscreen();
    } else {
      const e = this._fsEl;
      if (!e) {
        return;
      }
      e.requestFullscreen ? e.requestFullscreen() : e.webkitRequestFullscreen && e.webkitRequestFullscreen();
    }
  }
  _binToFreq(e) {
    return e * this.audioCtx.sampleRate / this.fftSize || 1;
  }
  _calcBars() {
    const e = this._bars = [];
    if (!this._ready) {
      this._flg = {isAlpha:!1, isBands:!1, isLeds:!1, isLumi:!1, isOctaves:!1, isOutline:!1, isRound:!1, noLedGap:!1};
      return;
    }
    const {_ansiBands:n, _barSpace:r, canvas:i, _chLayout:s, _maxFreq:o, _minFreq:a, _mirror:l, _mode:c, _radial:u, _radialInvert:h, _reflexRatio:f} = this, p = i.width >> 1, g = i.height >> 1, m = s == gs && !u, b = s == Rh, x = c % 10 != 0, w = x && this._frequencyScale == Cl, v = this._showLeds && x && !u, T = this._lumiBars && x && !u, I = this._alphaBars && !T && c != wl, _ = this._outlineBars && x && !T && !v, N = this._roundBars && x && !T && !v, E = s != gs || f > 0 && !T, C = i.height - 
    (m && !v ? 0.5 : 0) >> m, k = C * (T || u ? 1 : 1 - f) | 0, A = i.width - p * (b || l != 0), P = m ? i.height - C * 2 : 0, W = p * (l == -1 && !b && !u);
    let F = Math.min(i.width, i.height) * 0.375 * (s == gs ? 1 : this._radius) | 0, B = Math.min(p, g);
    h && s != gs && ([F, B] = [B, F]);
    const z = ge => e.push({...ge, peak:[0, 0], hold:[0], alpha:[0], value:[0]}), j = ge => {
      const me = this._freqToBin(ge, "floor"), te = this._binToFreq(me), q = this._binToFreq(me + 1), R = Math.log2(ge / te) / Math.log2(q / te);
      return [me, R];
    };
    let V, ne, D;
    if (w) {
      const ge = (U, le, be) => +U.toPrecision(be ? Math.max(le, 1 + Math.log10(U) | 0) : le), me = U => {
        const le = [1, 1.12, 1.25, 1.4, 1.6, 1.8, 2, 2.24, 2.5, 2.8, 3.15, 3.55, 4, 4.5, 5, 5.6, 6.3, 7.1, 8, 9, 10], be = Math.log10(U) | 0, je = U / 10 ** be;
        let Ae = 1;
        for (; Ae < le.length && je > le[Ae];) {
          Ae++;
        }
        return je - le[Ae - 1] < le[Ae] - je && Ae--, (le[Ae] * 10 ** (be + 5) | 0) / 1e5;
      }, te = [0, 24, 12, 8, 6, 4, 3, 2, 1][c], q = n ? 10 ** (3 / (te * 10)) : 2 ** (1 / te), R = q ** 0.5;
      let $ = n ? 7.94328235 / (te % 2 ? 1 : R) : nS;
      do {
        let U = $;
        const le = ge(U / R, 4, !0), be = ge(U * R, 4, !0), [je, Ae] = j(le), [ue, Le] = j(be);
        n ? U = te < 4 ? me(U) : ge(U, U.toString()[0] < 5 ? 3 : 2) : U = ge(U, 4, !0), U >= a && z({posX:0, freq:U, freqLo:le, freqHi:be, binLo:je, binHi:ue, ratioLo:Ae, ratioHi:Le}), $ *= q;
      } while ($ <= o);
      V = A / e.length, e.forEach((U, le) => U.posX = W + le * V);
      const G = e[0], J = e[e.length - 1];
      ne = this._freqScaling(G.freqLo), D = A / (this._freqScaling(J.freqHi) - ne), G.freqLo < a && (G.freqLo = a, [G.binLo, G.ratioLo] = j(a)), J.freqHi > o && (J.freqHi = o, [J.binHi, J.ratioHi] = j(o));
    } else if (x) {
      const ge = [0, 24, 12, 8, 6, 4, 3, 2, 1][c] * 10, me = te => {
        switch(this._frequencyScale) {
          case Vm:
            return 1960 / (26.81 / (te + 0.53) - 1);
          case qm:
            return 700 * (2 ** te - 1);
          case Jc:
            return te;
        }
      };
      V = A / ge, ne = this._freqScaling(a), D = A / (this._freqScaling(o) - ne);
      for (let te = 0, q = 0; te < ge; te++, q += V) {
        const R = me(ne + q / D), $ = me(ne + (q + V / 2) / D), G = me(ne + (q + V) / D), [J, U] = j(R), [le, be] = j(G);
        z({posX:W + q, freq:$, freqLo:R, freqHi:G, binLo:J, binHi:le, ratioLo:U, ratioHi:be});
      }
    } else {
      V = 1, ne = this._freqScaling(a), D = A / (this._freqScaling(o) - ne);
      const ge = this._freqToBin(a, "floor"), me = this._freqToBin(o);
      let te = -999;
      for (let q = ge; q <= me; q++) {
        const R = this._binToFreq(q), $ = W + Math.round(D * (this._freqScaling(R) - ne));
        if ($ > te) {
          z({posX:$, freq:R, freqLo:R, freqHi:R, binLo:q, binHi:q, ratioLo:0, ratioHi:0}), te = $;
        } else if (e.length) {
          const G = e[e.length - 1];
          G.binHi = q, G.freqHi = R, G.freq = (G.freqLo * R) ** 0.5;
        }
      }
    }
    let ie = 0, ee = 0;
    if (v) {
      const ge = this._pixelRatio / (window.devicePixelRatio > 1 && window.screen.height <= 540 ? 2 : 1), me = [[], [128, 3, 0.45], [128, 4, 0.225], [96, 6, 0.225], [80, 6, 0.225], [80, 6, 0.125], [64, 6, 0.125], [48, 8, 0.125], [24, 16, 0.125]], te = this._ledParams, [q, R, $] = te || me[c];
      let G, J = k;
      if (te) {
        const U = 2 * ge;
        let le;
        G = q + 1;
        do {
          G--, le = J / G / (1 + R), ee = le * R;
        } while ((le < U || ee < U) && G > 1);
      } else {
        const U = 540 / R;
        ee = Math.min(R * ge, Math.max(2, J / U + 0.1 | 0));
      }
      E && (J += ee), te || (G = Math.min(q, J / (ee * 2) | 0)), ie = $ >= 1 ? $ : V * $, this._leds = [G, ie, ee, J / G - ee];
    }
    const M = Math.min(V - 1, r * (r > 0 && r < 1 ? V : 1));
    x && (V -= Math.max(v ? ie : 0, M)), e.forEach((ge, me) => {
      let te = ge.posX, q = V;
      x && (r == 0 && !v ? (te |= 0, q |= 0, me > 0 && te > e[me - 1].posX + e[me - 1].width && (te--, q++)) : te += Math.max(v ? ie : 0, M) / 2, ge.posX = te), ge.barCenter = te + (V == 1 ? 0 : q / 2), ge.width = q;
    });
    const X = [];
    for (const ge of [0, 1]) {
      const me = s == gs ? (C + P) * ge : 0, te = me + C, q = me + k - (!v || E ? 0 : ee);
      X.push({channelTop:me, channelBottom:te, analyzerBottom:q});
    }
    this._aux = {analyzerHeight:k, analyzerWidth:A, centerX:p, centerY:g, channelCoords:X, channelHeight:C, channelGap:P, initialX:W, innerRadius:F, outerRadius:B, scaleMin:ne, unitWidth:D}, this._flg = {isAlpha:I, isBands:x, isLeds:v, isLumi:T, isOctaves:w, isOutline:_, isRound:N, noLedGap:E}, this._createScales();
  }
  _createScales() {
    if (!this._ready) {
      return;
    }
    const {analyzerWidth:e, initialX:n, innerRadius:r, scaleMin:i, unitWidth:s} = this._aux, {canvas:o, _frequencyScale:a, _mirror:l, _noteLabels:c, _radial:u, _scaleX:h, _scaleR:f} = this, p = h.canvas, g = f.canvas, m = [], b = this._chLayout == Rh, x = this._chLayout == gs, w = Math.min(o.width, o.height), v = ["C", , "D", , "E", "F", , "G", , "A", , "B"], T = w / 34 | 0, I = p.height >> 1, _ = T >> 1, N = I * (c ? 0.7 : 1.5), E = _ * (c ? 1 : 2), C = 2 ** (1 / 12);
    if (!c && (this._ansiBands || a != Cl)) {
      m.push(16, 31.5, 63, 125, 250, 500, 1e3, 2e3, 4e3), a == Jc ? m.push(6e3, 8e3, 1e4, 12e3, 14e3, 16e3, 18e3, 2e4, 22e3) : m.push(8e3, 16e3);
    } else {
      let B = nS;
      for (let z = -1; z < 11; z++) {
        for (let j = 0; j < 12; j++) {
          if (B >= this._minFreq && B <= this._maxFreq) {
            const V = v[j], ne = V == "C";
            (V && c && !l && !b || ne) && m.push(c ? [B, V + (ne ? z : "")] : B);
          }
          B *= C;
        }
      }
    }
    g.width = g.height = Math.max(w * 0.15, (r << 1) + x * T);
    const k = g.width >> 1, A = k - T * 0.7, P = (B, z) => {
      const j = vl * (B / o.width), V = j - Wm, ne = A * Math.cos(V), D = A * Math.sin(V);
      f.save(), f.translate(k + ne, k + D), f.rotate(j), f.fillText(z, 0, 0), f.restore();
    };
    p.width |= 0, h.fillStyle = f.strokeStyle = RY, h.fillRect(0, 0, p.width, p.height), f.arc(k, k, k - T / 2, 0, vl), f.lineWidth = T, f.stroke(), h.fillStyle = f.fillStyle = gS, h.font = `${I}px ${Dh}`, f.font = `${_}px ${Dh}`, h.textAlign = f.textAlign = "center";
    let W = -N / 4, F = -E;
    for (const B of m) {
      const [z, j] = Array.isArray(B) ? B : [B, B < 1e3 ? B | 0 : `${(B / 100 | 0) / 10}k`], V = s * (this._freqScaling(z) - i), ne = p.height * 0.75, D = j[0] == "C", ie = I * (c && !l && !b ? D ? 1.2 : 0.6 : 3);
      if (h.fillStyle = f.fillStyle = D && !l && !b ? DY : gS, c) {
        const ee = a == Cl, M = a == Jc;
        let X = ["C"];
        if ((ee || z > 2e3 || !M && z > 250 || (!u || x) && (!M && z > 125 || z > 1e3)) && X.push("G"), (ee || z > 4e3 || !M && z > 500 || (!u || x) && (!M && z > 250 || z > 2e3)) && X.push("E"), (M && z > 4e3 || (!u || x) && (ee || z > 2e3 || !M && z > 500)) && X.push("D", "F", "A", "B"), !X.includes(j[0])) {
          continue;
        }
      }
      V >= W + N / 2 && V <= e && (h.fillText(j, b && l == -1 ? e - V : n + V, ne, ie), (b || l && (V > N || l == 1)) && h.fillText(j, b && l != 1 ? e + V : (n || o.width) - V, ne, ie), W = V + Math.min(ie, h.measureText(j).width) / 2), V >= F + E && V < e - E && (P(b && l == 1 ? e - V : V, j), (b || l && (V > E || l == 1)) && P(b && l != -1 ? e + V : -V, j), F = V);
    }
  }
  _draw(e) {
    this._runId = requestAnimationFrame(de => this._draw(de));
    const n = e - this._time, r = e - this._last, i = this._maxFPS ? 975 / this._maxFPS : 0;
    if (r < i) {
      return;
    }
    this._last = e - (i ? r % i : 0), this._frames++, n >= 1e3 && (this._fps = this._frames / n * 1e3, this._frames = 0, this._time = e);
    const {isAlpha:s, isBands:o, isLeds:a, isLumi:l, isOctaves:c, isOutline:u, isRound:h, noLedGap:f} = this._flg, {analyzerHeight:p, centerX:g, centerY:m, channelCoords:b, channelHeight:x, channelGap:w, initialX:v, innerRadius:T, outerRadius:I} = this._aux, {_bars:_, canvas:N, _canvasGradients:E, _chLayout:C, _colorMode:k, _ctx:A, _energy:P, _fadePeaks:W, fillAlpha:F, _fps:B, _linearAmplitude:z, _lineWidth:j, maxDecibels:V, minDecibels:ne, _mirror:D, _mode:ie, overlay:ee, _radial:M, showBgColor:X, 
    showPeaks:ge, useCanvas:me, _weightingFilter:te} = this, q = this._scaleX.canvas, R = this._scaleR.canvas, $ = B * this._peakFadeTime / 1e3, G = B ** 2, J = this._gravity * 1e3, U = B * this._peakHoldTime / 1e3, le = C == rS, be = C == Rh, je = C == gs, Ae = C == Xs, ue = a && this._trueLeds && k == Pf, Le = M ? N.width : this._aux.analyzerWidth, $e = v + Le, Ye = ge && this._peakLine && ie == wl, Me = M ? I - T : p, Xe = Me / this._pixelRatio, [it, se, oe, we] = this._leds || [];
    P.val > 0 && B > 0 && (this._spinAngle += this._spinSpeed * vl / 60 / B);
    const ke = de => {
      if (this._reflexRatio > 0 && !l && !M) {
        let qe, dt;
        this.reflexFit || je ? (qe = je && de == 0 ? x + w : 0, dt = x - p) : (qe = N.height - p * 2, dt = p), A.save(), A.globalAlpha = this.reflexAlpha, this.reflexBright != 1 && (A.filter = `brightness(${this.reflexBright})`), A.setTransform(1, 0, 0, -1, 0, N.height), A.drawImage(N, 0, b[de].channelTop, N.width, p, 0, qe, N.width, dt), A.restore();
      }
    }, fe = () => {
      this.showScaleX && (M ? (A.save(), A.translate(g, m), this._spinSpeed && A.rotate(this._spinAngle + Wm), A.drawImage(R, -R.width >> 1, -R.width >> 1), A.restore()) : A.drawImage(q, 0, N.height - q.height));
    }, Oe = de => {
      const qe = de ** 2, dt = 424.36, gt = 11599.29, ze = 25122.25, kt = 544496.41, Dt = 148693636, Et = Tt => 20 * Math.log10(Tt);
      switch(te) {
        case lS:
          const Tt = Dt * qe ** 2 / ((qe + dt) * Math.sqrt((qe + gt) * (qe + kt)) * (qe + Dt));
          return 2 + Et(Tt);
        case cS:
          const yt = Dt * qe * de / ((qe + dt) * Math.sqrt(qe + ze) * (qe + Dt));
          return 0.17 + Et(yt);
        case uS:
          const Ut = Dt * qe / ((qe + dt) * (qe + Dt));
          return 0.06 + Et(Ut);
        case dS:
          const en = ((103791848e-2 - qe) ** 2 + 108076816e-2 * qe) / ((9837328 - qe) ** 2 + 11723776 * qe), Fn = de / 68966888496476e-18 * Math.sqrt(en / ((qe + 79919.29) * (qe + 1345600)));
          return Et(Fn);
        case hS:
          const Sn = -4737338981378384e-39 * de ** 6 + 2043828333606125e-30 * de ** 4 - 1363894795463638e-22 * qe + 1, Lt = 1306612257412824e-34 * de ** 5 - 2118150887518656e-26 * de ** 3 + 5559488023498642e-19 * de, Wt = 1246332637532143e-19 * de / Math.hypot(Sn, Lt);
          return 18.2 + Et(Wt);
      }
      return 0;
    }, We = (de, qe, dt) => {
      A.beginPath(), A.moveTo(de, qe), A.lineTo(de, dt), A.stroke();
    }, rt = de => {
      if (de && j) {
        const qe = A.globalAlpha;
        A.globalAlpha = 1, A.stroke(), A.globalAlpha = qe;
      }
    }, st = de => Math.max(0, (de * it | 0) * (we + oe) - oe), ft = de => {
      P.val = de, P.peak > 0 && (P.hold--, P.hold < 0 && (P.peak += P.hold * J / G / N.height * this._pixelRatio)), de >= P.peak && (P.peak = de, P.hold = U);
    };
    ee && A.clearRect(0, 0, N.width, N.height);
    let St = 0;
    const ht = _.length, xe = Ae ? 1 : 2;
    for (let de = 0; de < xe; de++) {
      const {channelTop:qe, channelBottom:dt, analyzerBottom:gt} = b[de], ze = this._gradients[this._selectedGrads[de]], kt = ze.colorStops, Dt = kt.length, Et = !X || a && !ee ? "#000" : ze.bgColor, Tt = je && M && de ? -1 : 1, yt = !de && D == -1 || de && D == 1, Ut = !be || de && D != 1 ? 0 : Le >> (de || !yt), en = be && yt ? -1 : 1, Fn = () => {
        const Je = q.height, ut = Je >> 1, at = z ? 100 : V, Nt = z ? 0 : ne, jt = z ? 20 : 5, rn = p / (at - Nt), mn = D != -1 && (!be || de == 0 || D == 1), vn = D != 1 && (!be || de != D);
        A.save(), A.fillStyle = mS, A.font = `${ut}px ${Dh}`, A.textAlign = "right", A.lineWidth = 1;
        for (let xt = at; xt > Nt; xt -= jt) {
          const Jn = qe + (at - xt) * rn, tt = xt % 2 == 0 | 0;
          if (tt) {
            const Qt = Jn + ut * (Jn == qe ? 0.8 : 0.35);
            mn && A.fillText(xt, Je * 0.85, Qt), vn && A.fillText(xt, (be ? Le : N.width) - Je * 0.1, Qt), A.strokeStyle = mS, A.setLineDash([2, 4]), A.lineDashOffset = 0;
          } else {
            A.strokeStyle = LY, A.setLineDash([2, 8]), A.lineDashOffset = 1;
          }
          A.beginPath(), A.moveTo(v + Je * tt * mn, ~~Jn + 0.5), A.lineTo($e - Je * tt * vn, ~~Jn + 0.5), A.stroke();
        }
        A.restore();
      }, Sn = (Je, ut) => {
        const at = Ct[Je] + (Je < Ct.length - 1 ? (Ct[Je + 1] - Ct[Je]) * ut : 0);
        return isNaN(at) ? -1 / 0 : at;
      }, Lt = (Je, ut = en) => ut * vl * ((Je + Ut) / N.width) + this._spinAngle, Wt = (Je, ut, at) => {
        const Nt = T + ut * Tt, jt = Lt(Je, at);
        return [g + Nt * Math.cos(jt), m + Nt * Math.sin(jt)];
      }, wr = (Je, ut, at, Nt, jt) => {
        A.beginPath();
        for (const rn of D && !be ? [1, -1] : [en]) {
          const [mn, vn] = h ? [Lt(Je, rn), Lt(Je + at, rn)] : [];
          A.moveTo(...Wt(Je, ut, rn)), A.lineTo(...Wt(Je, ut + Nt, rn)), h ? A.arc(g, m, T + (ut + Nt) * Tt, mn, vn, rn != 1) : A.lineTo(...Wt(Je + at, ut + Nt, rn)), A.lineTo(...Wt(Je + at, ut, rn)), h && !jt && A.arc(g, m, T + ut * Tt, vn, mn, rn == 1);
        }
        rt(jt), A.fill();
      }, kn = (Je = 0, ut = 0) => {
        let at;
        if (k == Pf && !ue || ie == wl) {
          at = E[de];
        } else {
          const Nt = k == iS ? ut % Dt : kt.findLastIndex(jt => a ? st(Je) <= st(jt.level) : Je <= jt.level);
          at = kt[Nt].color;
        }
        A.fillStyle = A.strokeStyle = at;
      };
      if (me) {
        if (be && !M) {
          const Je = Le * (de + yt), ut = yt ? -1 : 1;
          A.setTransform(ut, 0, 0, 1, Je, 0);
        }
        if ((!ee || X) && (ee && (A.globalAlpha = this.bgAlpha), A.fillStyle = Et, (de == 0 || !M && !le) && A.fillRect(v, qe - w, Le, (ee && this.reflexAlpha == 1 ? p : x) + w), A.globalAlpha = 1), this.showScaleY && !l && !M && (de == 0 || !le) && Fn(), a ? (A.setLineDash([we, oe]), A.lineWidth = _[0].width) : A.lineWidth = u ? Math.min(j, _[0].width / 2) : j, A.save(), !M) {
          const Je = new Path2D();
          Je.rect(0, qe, N.width, p), A.clip(Je);
        }
      }
      let Ct = this._fftData[de];
      this._analyzer[de].getFloatFrequencyData(Ct), te && (Ct = Ct.map((Je, ut) => Je + Oe(this._binToFreq(ut)))), A.beginPath();
      let un = [];
      for (let Je = 0; Je < ht; Je++) {
        const ut = _[Je], {posX:at, barCenter:Nt, width:jt, freq:rn, binLo:mn, binHi:vn, ratioLo:xt, ratioHi:Jn} = ut;
        let tt = Math.max(Sn(mn, xt), Sn(vn, Jn));
        for (let qt = mn + 1; qt < vn; qt++) {
          Ct[qt] > tt && (tt = Ct[qt]);
        }
        if (tt = this._normalizedB(tt), ut.value[de] = tt, St += tt, ut.peak[de] > 0 && ut.alpha[de] > 0 && (ut.hold[de]--, ut.hold[de] < 0)) {
          if (W && !Ye) {
            const qt = !s || u && j > 0 ? 1 : s ? ut.peak[de] : F;
            ut.alpha[de] = qt * (1 + ut.hold[de] / $);
          } else {
            ut.peak[de] += ut.hold[de] * J / G / Math.abs(Xe);
          }
          ut.alpha[de] <= 0 && (ut.peak[de] = 0);
        }
        if (tt >= ut.peak[de] && (ut.peak[de] = tt, ut.hold[de] = U, ut.alpha[de] = !s || u && j > 0 ? 1 : s ? tt : F), !me) {
          continue;
        }
        A.globalAlpha = l || s ? tt : u ? F : 1, kn(tt, Je);
        const Qt = l ? Me : a ? st(tt) : tt * Me | 0;
        if (ie == wl) {
          const qt = Je ? 0 : (this._normalizedB(Ct[_[1].binLo]) * Me + Qt) / 2;
          if (M) {
            if (Je == 0 && (be && A.moveTo(...Wt(0, 0)), A.lineTo(...Wt(0, at < 0 ? qt : Qt))), at >= 0) {
              const Zn = [at, Qt];
              A.lineTo(...Wt(...Zn)), un.push(Zn);
            }
          } else {
            if (Je == 0) {
              if (D == -1 && !be) {
                A.moveTo(v, gt - (at < v ? qt : Qt));
              } else {
                const Zn = mn ? this._normalizedB(Ct[mn - 1]) * Me : Qt;
                A.moveTo(v - j, gt - Zn);
              }
            }
            (be || D != -1 || at >= v) && A.lineTo(at, gt - Qt);
          }
        } else if (a) {
          if (X && !ee && (de == 0 || !le)) {
            const qt = A.globalAlpha;
            A.strokeStyle = IY, A.globalAlpha = 1, We(Nt, qe, gt), A.strokeStyle = A.fillStyle, A.globalAlpha = qt;
          }
          if (ue) {
            const qt = l ? 0 : kt.findLastIndex(On => st(tt) <= st(On.level));
            let Zn = gt;
            for (let On = Dt - 1; On >= qt; On--) {
              A.strokeStyle = kt[On].color;
              let ps = gt - (On == qt ? Qt : st(kt[On].level));
              We(Nt, Zn, ps), Zn = ps - oe;
            }
          } else {
            We(Nt, gt, gt - Qt);
          }
        } else if (at >= v) {
          if (M) {
            wr(at, 0, jt, Qt, u);
          } else if (h) {
            const qt = jt / 2, Zn = gt + qt;
            A.beginPath(), A.moveTo(at, Zn), A.lineTo(at, Zn - Qt), A.arc(Nt, Zn - Qt, qt, r1, vl), A.lineTo(at + jt, Zn), rt(u), A.fill();
          } else {
            const qt = u ? A.lineWidth : 0;
            A.beginPath(), A.rect(at, gt + qt, jt, -Qt - qt), rt(u), A.fill();
          }
        }
        const Vt = ut.peak[de], wi = ut.alpha[de];
        if (Vt > 0 && wi > 0 && ge && !Ye && !l && at >= v && at < $e) {
          if (W ? A.globalAlpha = wi : u && j > 0 ? A.globalAlpha = 1 : s && (A.globalAlpha = Vt), (k == sS || ue) && kn(Vt), a) {
            const qt = st(Vt);
            qt >= oe && A.fillRect(at, gt - qt, jt, we);
          } else if (!M) {
            A.fillRect(at, gt - Vt * Me, jt, 2);
          } else if (ie != wl) {
            const qt = Vt * Me;
            wr(at, qt, jt, !this._radialInvert || je || qt + T >= 2 ? -2 : 2);
          }
        }
      }
      if (me) {
        if (A.globalAlpha = 1, ie == wl) {
          if (kn(), M && !be) {
            if (D) {
              let Je;
              for (; Je = un.pop();) {
                A.lineTo(...Wt(...Je, -1));
              }
            }
            A.closePath();
          }
          if (j > 0 && A.stroke(), F > 0) {
            if (M) {
              const Je = be ? Lt(Le >> 1) : 0, ut = be ? Lt(Le) : vl;
              A.moveTo(...Wt(be ? Le >> 1 : 0, 0)), A.arc(g, m, T, Je, ut, be ? !yt : !0);
            } else {
              A.lineTo($e, gt), A.lineTo(v, gt);
            }
            A.globalAlpha = F, A.fill(), A.globalAlpha = 1;
          }
          if ((Ye || M && ge) && (un = [], A.beginPath(), _.forEach((Je, ut) => {
            let at = Je.posX, Nt = Je.peak[de], jt = ut ? "lineTo" : "moveTo";
            if (M && at < 0) {
              const rn = _[ut + 1];
              Nt = VY(at, Nt, rn.posX, rn.peak[de], 0), at = 0;
            }
            Nt *= Me, Ye ? (A[jt](...(M ? Wt(at, Nt) : [at, gt - Nt])), M && D && !be && un.push([at, Nt])) : Je.peak[de] > 0 && (W && (A.globalAlpha = Je.alpha[de]), wr(at, Nt, 1, -2));
          }), Ye)) {
            let Je;
            for (; Je = un.pop();) {
              A.lineTo(...Wt(...Je, -1));
            }
            A.lineWidth = 1, A.stroke();
          }
        }
        A.restore(), be && !M && A.setTransform(1, 0, 0, 1, 0, 0), (!be && !le || de) && ke(de);
      }
    }
    if (ft(St / (ht << xe - 1)), me && (D && !M && !be && (A.setTransform(-1, 0, 0, 1, N.width - v, 0), A.drawImage(N, v, 0, g, N.height, 0, 0, g, N.height), A.setTransform(1, 0, 0, 1, 0, 0)), A.setLineDash([]), fe()), this.showFPS) {
      const de = q.height;
      A.font = `bold ${de}px ${Dh}`, A.fillStyle = NY, A.textAlign = "right", A.fillText(Math.round(B), N.width - de, de * 2);
    }
    this.onCanvasDraw && (A.save(), A.fillStyle = A.strokeStyle = E[0], this.onCanvasDraw(this, {timestamp:e, canvasGradients:E}), A.restore());
  }
  _freqScaling(e) {
    switch(this._frequencyScale) {
      case Cl:
        return Math.log2(e);
      case Vm:
        return 26.81 * e / (1960 + e) - 0.53;
      case qm:
        return Math.log2(1 + e / 700);
      case Jc:
        return e;
    }
  }
  _freqToBin(e, n = "round") {
    const r = this._analyzer[0].frequencyBinCount - 1, i = Math[n](e * this.fftSize / this.audioCtx.sampleRate);
    return i < r ? i : r;
  }
  _makeGrad() {
    if (!this._ready) {
      return;
    }
    const {canvas:e, _ctx:n, _radial:r, _reflexRatio:i} = this, {analyzerWidth:s, centerX:o, centerY:a, initialX:l, innerRadius:c, outerRadius:u} = this._aux, {isLumi:h} = this._flg, f = this._chLayout == gs, p = 1 - i, g = h ? e.height : e.height * (1 - i * !f) | 0;
    for (const m of [0, 1]) {
      const b = this._gradients[this._selectedGrads[m]], x = b.colorStops, w = b.dir == "h";
      let v;
      if (r ? v = n.createRadialGradient(o, a, u, o, a, c - (u - c) * f) : v = n.createLinearGradient(...(w ? [l, 0, l + s, 0] : [0, 0, 0, g])), x) {
        const T = f && !this._splitGradient && (!w || r);
        for (let I = 0; I < 1 + T; I++) {
          const _ = x.length - 1;
          x.forEach((N, E) => {
            let C = N.pos;
            if (T && (C /= 2), f && !h && !r && !w && (C *= p, !T && C > 0.5 * p && (C += 0.5 * i)), I == 1) {
              if (r || h) {
                const k = _ - E;
                N = x[k], C = 1 - N.pos / 2;
              } else {
                E == 0 && C > 0 && v.addColorStop(0.5, N.color), C += 0.5;
              }
            }
            v.addColorStop(C, N.color), f && E == _ && C < 0.5 && v.addColorStop(0.5, N.color);
          });
        }
      }
      this._canvasGradients[m] = v;
    }
  }
  _normalizedB(e) {
    const n = this._linearAmplitude, r = n ? 1 / this._linearBoost : 1, i = (l, c, u) => l <= c ? c : l >= u ? u : l, s = l => 10 ** (l / 20);
    let o = this.maxDecibels, a = this.minDecibels;
    return n && (o = s(o), a = s(a), e = s(e) ** r), i((e - a) / (o - a) ** r, 0, 1);
  }
  _setCanvas(e) {
    if (!this._ready) {
      return;
    }
    const {canvas:n, _ctx:r} = this, i = this._scaleX.canvas, s = window.devicePixelRatio / (this._loRes + 1);
    let o = window.screen.width * s, a = window.screen.height * s;
    Math.abs(window.orientation) == 90 && o < a && ([o, a] = [a, o]);
    const l = this.isFullscreen, c = l && this._fsEl == n, u = c ? o : (this._width || this._container.clientWidth || this._defaultWidth) * s | 0, h = c ? a : (this._height || this._container.clientHeight || this._defaultHeight) * s | 0;
    this._pixelRatio = s, this._fsWidth = o, this._fsHeight = a, !(e != fS && n.width == u && n.height == h) && (n.width = u, n.height = h, this.overlay || (r.fillStyle = "#000", r.fillRect(0, 0, u, h)), r.lineJoin = "bevel", i.width = u, i.height = Math.max(20 * s, Math.min(u, h) / 32 | 0), this._calcBars(), this._makeGrad(), this._fsStatus !== void 0 && this._fsStatus !== l && (e = pS), this._fsStatus = l, this.onCanvasResize && this.onCanvasResize(e, this));
  }
  _setGradient(e, n) {
    if (!this._gradients.hasOwnProperty(e)) {
      throw new Ei($Y, e);
    }
    [0, 1].includes(n) || (this._selectedGrads[1] = e, n = 0), this._selectedGrads[n] = e, this._makeGrad();
  }
  _setProps(e, n) {
    const r = ["onCanvasDraw", "onCanvasResize"], i = ["gradientLeft", "gradientRight", "stereo"], s = Object.keys(Zc).filter(o => o != "start").concat(r, i);
    (n || e === void 0) && (e = {...Zc, ...e});
    for (const o of Object.keys(e)) {
      r.includes(o) && typeof e[o] != "function" ? this[o] = void 0 : s.includes(o) && (this[o] = e[o]);
    }
    e.start !== void 0 && this.toggleAnalyzer(e.start);
  }
}
function vS(t) {
  if (typeof t != "number" || !Number.isFinite(t) || t <= 0) {
    return "0:00";
  }
  const e = Math.floor(t / 60), n = Math.floor(t % 60);
  return `${e}:${n.toString().padStart(2, "0")}`;
}
function CN({analyserRef:t, isPlaying:e}) {
  const n = (0,require$react.useRef)(null), r = (0,require$react.useRef)(null);
  return (0,require$react.useEffect)(() => {
    const i = n.current, s = t.current;
    if (!(!i || !s || !e || r.current)) {
      return r.current = new qY(i, {source:s, width:i.clientWidth, height:50, mode:2, gradient:"classic", showScaleX:!1, showScaleY:!1, smoothing:0.7}), () => {
        var o;
        (o = r.current) == null || o.destroy(), r.current = null;
      };
    }
  }, [t, e]), (0,require$react.useEffect)(() => {
    var i;
    e || ((i = r.current) == null || i.destroy(), r.current = null);
  }, [e]), (0,require$react.useEffect)(() => () => {
    var i;
    (i = r.current) == null || i.destroy(), r.current = null;
  }, []), (0,require$react_SLASH_jsx_runtime.jsx)("div", {ref:n, "data-testid":"studio-audio-visualizer", style:{width:"100%", height:50, borderRadius:8, overflow:"hidden", background:"rgba(0,0,0,0.2)"}});
}
function AN({audioRef:t, duration:e, initialTime:n = 0, onPersistTime:r}) {
  const [i, s] = (0,require$react.useState)(n);
  (0,require$react.useEffect)(() => {
    s(n);
  }, [n]), (0,require$react.useEffect)(() => {
    const a = t.current;
    if (!a) {
      return;
    }
    let l = 0;
    const c = () => {
      const u = a.currentTime;
      r == null || r(u);
      const h = performance.now();
      h - l < 100 || (l = h, s(f => Math.abs(f - u) < 0.05 ? f : u));
    };
    return a.addEventListener("timeupdate", c), a.addEventListener("seeking", c), a.addEventListener("seeked", c), () => {
      a.removeEventListener("timeupdate", c), a.removeEventListener("seeking", c), a.removeEventListener("seeked", c);
    };
  }, [t, r]);
  const o = (0,require$react.useCallback)(a => {
    const l = t.current;
    if (!l) {
      return;
    }
    const c = parseFloat(a.target.value);
    l.currentTime = c, s(c), r == null || r(c);
  }, [t, r]);
  return (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{width:"100%", display:"flex", flexDirection:"column", gap:4}, children:[(0,require$react_SLASH_jsx_runtime.jsx)("input", {"aria-label":"Playback position", type:"range", min:0, max:e || 0, value:i, onChange:o, style:{width:"100%", accentColor:"var(--token-colors-accent-blue)"}}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{display:"flex", justifyContent:"space-between", fontSize:O.fontSize.xs, color:"var(--token-colors-text-muted)"}, 
  children:[(0,require$react_SLASH_jsx_runtime.jsx)("span", {children:vS(i)}), (0,require$react_SLASH_jsx_runtime.jsx)("span", {children:vS(e)})]})]});
}
function YY() {
  if (!(typeof window > "u")) {
    return window.AudioContext ?? window.webkitAudioContext;
  }
}
function GY({title:t, description:e, tracks:n, getAudioUrl:r, maxVisible:i = Number.POSITIVE_INFINITY, showLabels:s = !0, showDescription:o = !0, showDuration:a = !0}) {
  const [l, c] = (0,require$react.useState)(0), [u, h] = (0,require$react.useState)("idle"), [f, p] = (0,require$react.useState)(0), [g, m] = (0,require$react.useState)(1), b = (0,require$react.useRef)(null), x = (0,require$react.useRef)(null), w = (0,require$react.useRef)(null), v = (0,require$react.useRef)(null), T = (0,require$react.useRef)(l);
  T.current = l;
  const I = n[Math.min(l, Math.max(0, n.length - 1))] ?? null, _ = (0,require$react.useCallback)(() => {
    const P = b.current;
    if (!P || v.current) {
      return;
    }
    const W = YY();
    if (!W) {
      return;
    }
    const F = new W(), B = F.createAnalyser();
    B.fftSize = 256;
    const z = F.createMediaElementSource(P);
    z.connect(B), B.connect(F.destination), x.current = F, w.current = B, v.current = z;
  }, []), N = (0,require$react.useCallback)(P => {
    const W = n[P], F = b.current;
    if (!W || !F || !r) {
      return;
    }
    _();
    const B = x.current;
    (B == null ? void 0 : B.state) === "suspended" && B.resume();
    const z = r(W.path);
    F.getAttribute("src") !== z && (F.src = z, F.load()), c(P), p(W.duration ?? 0), h("loading"), F.play().then(() => h("playing")).catch(() => h("paused"));
  }, [r, _, n]), E = (0,require$react.useCallback)(() => {
    n.length !== 0 && N((T.current + 1) % n.length);
  }, [N, n.length]), C = (0,require$react.useCallback)(() => {
    n.length !== 0 && N(T.current <= 0 ? n.length - 1 : T.current - 1);
  }, [N, n.length]), k = (0,require$react.useCallback)(() => {
    const P = b.current;
    if (!(!P || !I)) {
      if (u === "playing") {
        P.pause(), h("paused");
        return;
      }
      N(T.current);
    }
  }, [N, u, I]), A = (0,require$react.useCallback)((P, W) => {
    N(W);
  }, [N]);
  return (0,require$react.useEffect)(() => {
    const P = b.current;
    if (!P) {
      return;
    }
    const W = () => p(Number.isFinite(P.duration) ? P.duration : (I == null ? void 0 : I.duration) ?? 0), F = () => E(), B = () => m(P.volume), z = () => h(V => V === "playing" ? "paused" : V), j = () => h("playing");
    return P.addEventListener("loadedmetadata", W), P.addEventListener("ended", F), P.addEventListener("volumechange", B), P.addEventListener("pause", z), P.addEventListener("play", j), () => {
      P.removeEventListener("loadedmetadata", W), P.removeEventListener("ended", F), P.removeEventListener("volumechange", B), P.removeEventListener("pause", z), P.removeEventListener("play", j);
    };
  }, [E, I == null ? void 0 : I.duration]), (0,require$react.useEffect)(() => {
    b.current && (b.current.volume = g);
  }, [g]), (0,require$react.useEffect)(() => () => {
    var P, W, F, B;
    (P = b.current) == null || P.pause(), (W = v.current) == null || W.disconnect(), (F = w.current) == null || F.disconnect(), (B = x.current) == null || B.close();
  }, []), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {"data-testid":"studio-playlist-player", style:{display:"flex", flexDirection:"column", gap:12}, children:[(0,require$react_SLASH_jsx_runtime.jsx)("audio", {ref:b, preload:"auto", crossOrigin:"anonymous", src:I && r ? r(I.path) : void 0}), (0,require$react_SLASH_jsx_runtime.jsx)(SN, {title:t, description:e, track:I, trackCount:n.length, playerState:u, playingFrom:"playlist", permissions:{canGoPrevious:n.length > 1, canPlayPause:!!(I && r), 
  canGoNext:n.length > 1, canAdjustVolume:!0}, volume:g, onPrevious:C, onTogglePlayPause:k, onNext:E, onVolumeChange:m, waveform:(0,require$react_SLASH_jsx_runtime.jsx)(CN, {analyserRef:w, isPlaying:u === "playing"}), progress:(0,require$react_SLASH_jsx_runtime.jsx)(AN, {audioRef:b, duration:f || (I == null ? void 0 : I.duration) || 0}), heardDescription:o && (I != null && I.description) ? (0,require$react_SLASH_jsx_runtime.jsx)("p", {className:"publication-blocks__track-description", children:I.description}) : 
  null, currentLabels:s && (I != null && I.labels) && I.labels.length > 0 ? (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"publication-blocks__labels", children:I.labels.map(P => (0,require$react_SLASH_jsx_runtime.jsx)("span", {children:P}, P))}) : null}), (0,require$react_SLASH_jsx_runtime.jsx)(EY, {items:n, selectedIndex:l, readOnly:!0, showLabels:s, showDuration:a, maxVisible:i, onSelect:A})]});
}
function i1(t) {
  return typeof t == "object" && t !== null && !Array.isArray(t);
}
function Hn(t) {
  return typeof t == "string" && t.trim().length > 0 ? t : void 0;
}
function QY(t) {
  return typeof t == "number" && Number.isFinite(t) ? t : void 0;
}
function KY(t) {
  return Array.isArray(t) ? t.filter(e => typeof e == "string" && e.trim().length > 0) : void 0;
}
function wS(t) {
  if (!i1(t)) {
    return null;
  }
  const e = Hn(t.path), n = Hn(t.title) ?? e;
  return !e || !n ? null : {path:e, title:n, artist:Hn(t.artist), duration:QY(t.duration), mime:Hn(t.mime), labels:KY(t.labels), description:Hn(t.description), source_url:Hn(t.source_url)};
}
function XY(t, e) {
  if (!i1(t)) {
    return null;
  }
  const n = Hn(t.type), r = Hn(t.id) ?? `block-${e}`, i = t.hidden === !0;
  switch(n) {
    case "hero":
      {
        const s = Hn(t.title);
        return s ? {id:r, type:n, hidden:i, title:s, subtitle:Hn(t.subtitle), image_path:Hn(t.image_path), audio_path:Hn(t.audio_path)} : null;
      }
    case "heading":
      {
        const s = Hn(t.text), o = t.level === 3 || t.level === 4 ? t.level : 2;
        return s ? {id:r, type:n, hidden:i, level:o, text:s} : null;
      }
    case "rich_text":
      {
        const s = Hn(t.markdown) ?? "";
        return {id:r, type:n, hidden:i, markdown:s};
      }
    case "callout":
      {
        const s = Hn(t.markdown) ?? "", o = t.tone === "tip" || t.tone === "warning" || t.tone === "promo" ? t.tone : "note";
        return {id:r, type:n, hidden:i, tone:o, title:Hn(t.title), markdown:s};
      }
    case "playlist":
      {
        const s = Array.isArray(t.tracks) ? t.tracks.map(wS).filter(a => a !== null) : [], o = t.layout === "cards" || t.layout === "broadcast" ? t.layout : "compact";
        return {id:r, type:n, hidden:i, title:Hn(t.title), description:Hn(t.description), layout:o, tracks:s, show_labels:t.show_labels === !0, show_descriptions:t.show_descriptions === !0, show_duration:t.show_duration === !0};
      }
    case "track":
      {
        const s = wS(t.track);
        return s ? {id:r, type:n, hidden:i, track:s, commentary:Hn(t.commentary), show_player:t.show_player !== !1} : null;
      }
    case "divider":
      return {id:r, type:n, hidden:i};
    case "cta":
      {
        const s = Hn(t.label), o = Hn(t.href);
        return !s || !o ? null : {id:r, type:n, hidden:i, label:s, href:o, tone:t.tone === "secondary" ? "secondary" : "primary"};
      }
    default:
      return null;
  }
}
function JY(t) {
  return !i1(t) || !Array.isArray(t.blocks) ? [] : t.blocks.map(XY).filter(e => e !== null && e.hidden !== !0);
}
function ZY(t) {
  if (typeof t != "number" || !Number.isFinite(t) || t <= 0) {
    return null;
  }
  const e = Math.floor(t / 60), n = Math.floor(t % 60);
  return `${e}:${n.toString().padStart(2, "0")}`;
}
function eG({track:t, showDescription:e, showLabels:n, showDuration:r, getAudioUrl:i}) {
  const s = ZY(t.duration);
  return (0,require$react_SLASH_jsx_runtime.jsxs)("article", {className:"publication-blocks__track-card", children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"publication-blocks__track-main", children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"publication-blocks__track-title", children:t.title}), t.artist ? (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"publication-blocks__track-artist", children:t.artist}) : 
  null, e && t.description ? (0,require$react_SLASH_jsx_runtime.jsx)("p", {className:"publication-blocks__track-description", children:t.description}) : null]}), r && s ? (0,require$react_SLASH_jsx_runtime.jsx)("span", {className:"publication-blocks__duration", children:s}) : null]}), i ? (0,require$react_SLASH_jsx_runtime.jsx)("audio", {className:"publication-blocks__audio", controls:!0, preload:"none", src:i(t.path)}) : null, n && t.labels && t.labels.length > 0 ? (0,require$react_SLASH_jsx_runtime.jsx)("div", 
  {className:"publication-blocks__labels", children:t.labels.map(o => (0,require$react_SLASH_jsx_runtime.jsx)("span", {children:o}, o))}) : null]});
}
function tG({block:t, maxVisible:e, getAudioUrl:n}) {
  return (0,require$react_SLASH_jsx_runtime.jsx)(GY, {title:t.title, description:t.description, tracks:t.tracks, getAudioUrl:n, maxVisible:e, showLabels:t.show_labels, showDescription:t.show_descriptions, showDuration:t.show_duration});
}
function nG(t) {
  return t.level === 4 ? (0,require$react_SLASH_jsx_runtime.jsx)("h4", {className:"publication-blocks__heading", children:t.text}) : t.level === 3 ? (0,require$react_SLASH_jsx_runtime.jsx)("h3", {className:"publication-blocks__heading", children:t.text}) : (0,require$react_SLASH_jsx_runtime.jsx)("h2", {className:"publication-blocks__heading", children:t.text});
}
function rG({blocks:t, getAudioUrl:e, maxInitialPlaylistTracks:n = Number.POSITIVE_INFINITY}) {
  if (t.length === 0) {
    return null;
  }
  const r = t.some(i => i.type === "playlist");
  return (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"publication-blocks", "data-testid":"publication-blocks-renderer", children:[(0,require$react_SLASH_jsx_runtime.jsx)("style", {children:`
        .publication-blocks { display: flex; flex-direction: column; gap: 16px; color: var(--token-colors-text-primary); }
        .publication-blocks__hero { padding: 20px; border: 1px solid var(--token-colors-border-default); border-radius: 16px; background: linear-gradient(135deg, var(--token-colors-surface-secondary), var(--token-colors-surface-tertiary)); }
        .publication-blocks__hero h1 { margin: 0 0 8px; font-size: 28px; line-height: 1.1; }
        .publication-blocks__hero p { margin: 0; color: var(--token-colors-text-muted); }
        .publication-blocks__heading { margin: 8px 0 0; line-height: 1.2; }
        .publication-blocks__rich-text p { line-height: 1.6; }
        .publication-blocks__callout { padding: 12px 14px; border-radius: 12px; border: 1px solid var(--token-colors-border-default); background: var(--token-colors-surface-secondary); }
        .publication-blocks__callout[data-tone="warning"] { border-color: var(--token-colors-accent-amber); }
        .publication-blocks__callout[data-tone="promo"] { border-color: var(--token-colors-accent-cyan); }
        .publication-blocks__callout-title { font-weight: 700; margin-bottom: 6px; }
        .publication-blocks__playlist { padding: 14px; border: 1px solid var(--token-colors-border-default); border-radius: 14px; background: var(--token-colors-surface-secondary); }
        .publication-blocks__playlist--broadcast { gap: 12px; display: flex; flex-direction: column; }
        .publication-blocks__playlist-header { margin-bottom: 12px; }
        .publication-blocks__playlist-title { font-weight: 700; font-size: 18px; }
        .publication-blocks__playlist-description, .publication-blocks__empty-queue { color: var(--token-colors-text-muted); margin-top: 4px; }
        .publication-blocks__broadcast-hero { display: grid; grid-template-columns: minmax(0, 1.4fr) minmax(260px, 0.8fr); gap: 14px; padding: 16px; border: 1px solid var(--token-colors-border-default); border-radius: 16px; background: linear-gradient(135deg, var(--token-colors-surface-tertiary), var(--token-colors-surface-secondary)); }
        .publication-blocks__broadcast-copy h2 { margin: 0 0 6px; font-size: 24px; line-height: 1.1; }
        .publication-blocks__broadcast-copy p { color: var(--token-colors-text-muted); margin: 0 0 10px; }
        .publication-blocks__eyebrow { color: var(--token-colors-accent-cyan); font-size: 11px; font-weight: 800; letter-spacing: 0.08em; text-transform: uppercase; margin-bottom: 6px; }
        .publication-blocks__now-card { padding: 12px; border-radius: 12px; background: var(--token-colors-surface-primary); border: 1px solid var(--token-colors-border-subtle); }
        .publication-blocks__broadcast-player { display: flex; flex-direction: column; justify-content: flex-end; gap: 10px; }
        .publication-blocks__queue-count { align-self: flex-start; padding: 4px 10px; border-radius: 999px; border: 1px solid var(--token-colors-border-default); color: var(--token-colors-text-muted); font-size: 12px; }
        .publication-blocks__queue { display: flex; flex-direction: column; gap: 4px; max-height: 420px; overflow: auto; padding-right: 4px; }
        .publication-blocks__queue-row { display: grid; grid-template-columns: 34px minmax(0, 1fr) auto; align-items: center; gap: 8px; width: 100%; padding: 8px 10px; border-radius: 10px; border: 1px solid transparent; background: transparent; color: var(--token-colors-text-secondary); text-align: left; cursor: pointer; }
        .publication-blocks__queue-row:hover, .publication-blocks__queue-row[data-active="true"] { border-color: var(--token-colors-border-default); background: var(--token-colors-surface-primary); color: var(--token-colors-text-primary); }
        .publication-blocks__queue-index { color: var(--token-colors-text-muted); font-size: 12px; text-align: right; }
        .publication-blocks__queue-title { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; font-weight: 600; }
        .publication-blocks__track-list { display: flex; flex-direction: column; gap: 10px; }
        .publication-blocks__track-card { padding: 10px; border: 1px solid var(--token-colors-border-subtle); border-radius: 10px; background: var(--token-colors-surface-primary); }
        .publication-blocks__track-main { display: flex; justify-content: space-between; gap: 12px; }
        .publication-blocks__track-title { font-weight: 650; }
        .publication-blocks__track-artist, .publication-blocks__track-description, .publication-blocks__duration { color: var(--token-colors-text-muted); font-size: 13px; }
        .publication-blocks__audio { width: 100%; margin-top: 8px; }
        .publication-blocks__labels { display: flex; flex-wrap: wrap; gap: 6px; margin-top: 8px; }
        .publication-blocks__labels span { padding: 2px 7px; border-radius: 999px; background: var(--token-colors-surface-tertiary); color: var(--token-colors-text-muted); font-size: 12px; }
        .publication-blocks__divider { border: 0; border-top: 1px solid var(--token-colors-border-default); width: 100%; }
        .publication-blocks__cta { display: inline-flex; align-self: flex-start; padding: 8px 12px; border-radius: 10px; text-decoration: none; background: var(--token-colors-accent-cyan); color: white; font-weight: 700; }
        .publication-blocks__cta[data-tone="secondary"] { background: var(--token-colors-surface-tertiary); color: var(--token-colors-text-primary); border: 1px solid var(--token-colors-border-default); }
        @media (max-width: 840px) { .publication-blocks__broadcast-hero { grid-template-columns: 1fr; } }
      `}), t.map(i => {
    switch(i.type) {
      case "hero":
        return (0,require$react_SLASH_jsx_runtime.jsxs)("section", {className:"publication-blocks__hero", children:[(0,require$react_SLASH_jsx_runtime.jsx)("h1", {children:i.title}), i.subtitle ? (0,require$react_SLASH_jsx_runtime.jsx)("p", {children:i.subtitle}) : null, !r && i.audio_path && e ? (0,require$react_SLASH_jsx_runtime.jsx)("audio", {className:"publication-blocks__audio", controls:!0, preload:"none", src:e(i.audio_path)}) : null]}, i.id);
      case "heading":
        return (0,require$react_SLASH_jsx_runtime.jsx)("section", {children:nG(i)}, i.id);
      case "rich_text":
        return (0,require$react_SLASH_jsx_runtime.jsx)("section", {className:"publication-blocks__rich-text", children:(0,require$react_SLASH_jsx_runtime.jsx)(Mu, {children:i.markdown})}, i.id);
      case "callout":
        return (0,require$react_SLASH_jsx_runtime.jsxs)("aside", {className:"publication-blocks__callout", "data-tone":i.tone, children:[i.title ? (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"publication-blocks__callout-title", children:i.title}) : null, (0,require$react_SLASH_jsx_runtime.jsx)(Mu, {children:i.markdown})]}, i.id);
      case "playlist":
        return (0,require$react_SLASH_jsx_runtime.jsx)("section", {className:"publication-blocks__playlist", "data-layout":i.layout, children:(0,require$react_SLASH_jsx_runtime.jsx)(tG, {block:i, maxVisible:n, getAudioUrl:e})}, i.id);
      case "track":
        return (0,require$react_SLASH_jsx_runtime.jsxs)("section", {children:[(0,require$react_SLASH_jsx_runtime.jsx)(eG, {track:i.track, showDescription:!0, showDuration:!0, showLabels:!0, getAudioUrl:i.show_player === !1 ? void 0 : e}), i.commentary ? (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"publication-blocks__rich-text", children:(0,require$react_SLASH_jsx_runtime.jsx)(Mu, {children:i.commentary})}) : null]}, i.id);
      case "divider":
        return (0,require$react_SLASH_jsx_runtime.jsx)("hr", {className:"publication-blocks__divider"}, i.id);
      case "cta":
        return (0,require$react_SLASH_jsx_runtime.jsx)("a", {className:"publication-blocks__cta", "data-tone":i.tone ?? "primary", href:i.href, children:i.label}, i.id);
      default:
        return null;
    }
  })]});
}
function NN(t) {
  return t.trim().replace(/\s+/g, " ") || "Broadcast Playlist";
}
function iG(t) {
  return NN(t).toLowerCase().normalize("NFKD").replace(/[\u0300-\u036f]/g, "").replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "").slice(0, 80) || "broadcast-playlist";
}
function sG(t) {
  return (t.title ?? t.name ?? t.path.split("/").pop() ?? t.path).replace(/\.[a-z0-9]{2,5}$/i, "").trim() || t.path;
}
function oG(t) {
  return Array.from(new Set(t.filter(e => typeof e == "string" && e.trim().length > 0).map(e => e.trim())));
}
function aG(t) {
  var e, n, r;
  return t.path.trim() ? {path:t.path, title:sG(t), duration:typeof t.duration == "number" && Number.isFinite(t.duration) ? t.duration : void 0, labels:oG(t.labels ?? []), description:((e = t.description) == null ? void 0 : e.trim()) || void 0, mime:((n = t.mime) == null ? void 0 : n.trim()) || void 0, source_url:((r = t.source_url) == null ? void 0 : r.trim()) || void 0} : null;
}
function lG(t, e, n) {
  const r = n.slice(0, 40), i = Math.max(0, n.length - r.length);
  return [`# ${t}`, "", (e == null ? void 0 : e.trim()) || `A Broadcast Studio playlist with ${n.length} track${n.length === 1 ? "" : "s"}.`, "", "## Playlist summary", "", `This block publication contains ${n.length} track${n.length === 1 ? "" : "s"}. The complete track snapshot is stored in structured publication metadata.`, "", ...r.map((o, a) => {
    const l = [`${a + 1}. ${o.title}`];
    return o.description && l.push(` \u2014 ${o.description}`), l.join("");
  }), i > 0 ? `\u2026and ${i} more tracks in the structured playlist block.` : "", ""].join(`
`);
}
function cG(t) {
  var u;
  const e = NN(t.title), n = iG(e), s = `cms/playlists/${(t.now ?? new Date()).toISOString().slice(0, 10)}-${n}.md`, o = t.tracks.map(aG).filter(h => h !== null), a = ((u = t.description) == null ? void 0 : u.trim()) || void 0, l = lG(e, a, o), c = [{id:"hero", type:"hero", title:e, subtitle:a ?? `${o.length} track${o.length === 1 ? "" : "s"} from Broadcast Studio`}, {id:"intro", type:"rich_text", markdown:a ?? "A curated audio publication drafted from the Broadcast Studio queue."}, {id:"playlist", 
  type:"playlist", title:e, description:a, layout:"cards", tracks:o, show_labels:!0, show_descriptions:!0, show_duration:!0}];
  return {title:e, slug:n, sourcePath:s, content:l, metadata:{publication_kind:"playlist", block_schema_version:1, source_audio_paths:o.map(h => h.path), blocks:c}};
}
const uG = "knoxx_studio_session_id", dG = "knoxx_studio_scratchpad", hG = "knoxx_studio_pinned_context", fG = "knoxx_studio_session_state", Pb = "knoxx_studio_sidebar_width", go = "/api/openplanner/v1", pG = "broadcast_studio", gG = "broadcast_studio_audio_labeler", mG = 250, bG = "workspace", Rb = `${bG}:file:`;
function s1(t) {
  return `${Rb}${t}`;
}
async function IN(t = "") {
  return (await Ie(`${go}/graph/labels?search=${encodeURIComponent(t)}&limit=200`)).labels ?? [];
}
async function yG(t) {
  const e = t.trim();
  return (await Ie(`${go}/graph/labels`, {method:"POST", body:JSON.stringify({label:e, slug:e, tenant_id:"default", description:"Created from Broadcast Studio"})})).label;
}
async function xG(t) {
  return ((await Ie(`${go}/graph/edges/query`, {method:"POST", body:JSON.stringify({nodeIds:[t], edgeKinds:["has_label"], includeBoundaryEdges:!0, limit:500})})).edges ?? []).filter(n => n.edgeKind === "has_label" && n.source === t).map(n => n.target);
}
async function Gm(t, e) {
  const [n, r] = await Promise.all([e ? Promise.resolve(e) : IN(), xG(s1(t))]), i = new Set(r);
  return n.filter(s => i.has(s.label_id));
}
async function vG(t, e) {
  await Ie(`${go}/graph/labels/${encodeURIComponent(e)}/apply`, {method:"POST", body:JSON.stringify({node_id:s1(t)})});
}
async function wG(t, e) {
  await Ie(`${go}/graph/labels/${encodeURIComponent(e)}/remove`, {method:"POST", body:JSON.stringify({node_id:s1(t)})});
}
async function _G(t) {
  return ((await Ie(`${go}/graph/labels/${encodeURIComponent(t)}/nodes?limit=10000`)).nodes ?? []).map(n => n.node_id).filter(n => n.startsWith(Rb)).map(n => n.slice(Rb.length));
}
function Db(t) {
  const e = t.trim().replace(/^[-*\u2022\d.()\s]+/, "").replace(/^labels?:\s*/i, "").replace(/^`|`$/g, "").replace(/^"|"$/g, "").replace(/^'|'$/g, "").trim();
  return !e || e.length > 64 ? null : e;
}
function _S(t) {
  const e = [], n = t.match(/(?:^|\n)\s*\(?3\)?[.)]?\s*([^\n]+)/i), r = t.match(/(?:reusable\s+)?labels?\s*[:\-]\s*([^\n]+)/i);
  for (const i of [n == null ? void 0 : n[1], r == null ? void 0 : r[1]]) {
    if (i) {
      for (const s of i.split(/[,|]/g)) {
        const o = Db(s);
        o && e.push(o);
      }
    }
  }
  return Array.from(new Set(e)).slice(0, 16);
}
function SG(t) {
  const e = t.split(/\r?\n/), n = [];
  for (const r of e) {
    const i = r.trim();
    if (i) {
      if (/^[-*\u2022]|^\d+[.)]/.test(i)) {
        const s = i.split(/[,|]/g);
        for (const o of s) {
          const a = Db(o);
          a && n.push(a);
        }
        continue;
      }
      if (/labels?/i.test(i) && /[:,]/.test(i)) {
        const o = (i.split(/:/, 2)[1] ?? i).split(/[,|]/g);
        for (const a of o) {
          const l = Db(a);
          l && n.push(l);
        }
      }
    }
  }
  return Array.from(new Set(n)).slice(0, 16);
}
async function ON(t) {
  return Ie(`/api/ingestion/audio-context?source_id=${encodeURIComponent("workspace-audio")}&path=${encodeURIComponent(t)}`);
}
async function kG(t) {
  try {
    return (await Ie(`/api/studio/state?kind=${encodeURIComponent(t)}`)).state ?? {};
  } catch {
    return {};
  }
}
async function EG(t, e) {
  try {
    await Ie("/api/studio/state", {method:"PUT", body:JSON.stringify({kind:t, state:e})});
  } catch {
  }
}
async function TG() {
  try {
    return (await Ie("/api/studio/playlist")).playlist ?? [];
  } catch {
    return [];
  }
}
async function CG(t) {
  try {
    await Ie("/api/studio/playlist", {method:"PUT", body:JSON.stringify({items:t})});
  } catch {
  }
}
async function AG(t) {
  const e = s => (s ?? "").replace(/^\/+/, ""), n = new URLSearchParams({path_prefix:t, limit:"20"}), r = await fetch(`${us}${go}/cms/documents?${n.toString()}`, {credentials:"include", headers:Xn()});
  return r.ok ? ((await r.json()).documents ?? []).find(s => e(s.source_path) === e(t)) ?? null : null;
}
async function NG(t) {
  const e = await fetch(`${us}${go}/cms/documents`, {method:"POST", credentials:"include", headers:Xn({"Content-Type":"application/json"}), body:JSON.stringify(t)});
  if (e.ok) {
    return await e.json();
  }
  const n = await e.text();
  if (e.status === 503) {
    try {
      if (JSON.parse(n).persisted) {
        const i = await AG(t.source_path);
        if (i) {
          return i;
        }
        throw new Error("CMS saved the draft but indexing timed out and the document could not be refetched yet. Try opening CMS again in a moment.");
      }
    } catch {
    }
  }
  throw new Error(n || `${e.status} ${e.statusText}`);
}
function IG(t) {
  return t < 1024 ? `${t} B` : t < 1024 * 1024 ? `${(t / 1024).toFixed(1)} KB` : `${(t / (1024 * 1024)).toFixed(1)} MB`;
}
function SS(t) {
  if (!isFinite(t)) {
    return "0:00";
  }
  const e = Math.floor(t / 60), n = Math.floor(t % 60);
  return `${e}:${n.toString().padStart(2, "0")}`;
}
const kS = new Map();
function ES(t) {
  const e = kS.get(t);
  return e !== void 0 ? Promise.resolve(e) : new Promise(n => {
    const r = new Audio();
    r.preload = "metadata";
    const i = a => {
      kS.set(t, a), r.removeEventListener("loadedmetadata", s), r.removeEventListener("error", o), r.pause(), r.removeAttribute("src"), r.load(), n(a);
    }, s = () => i(r.duration), o = () => i(0);
    r.addEventListener("loadedmetadata", s, {once:!0}), r.addEventListener("error", o, {once:!0}), r.src = Ul(t);
  });
}
function TS(t) {
  switch(t) {
    case ".mp3":
      return "\ud83c\udfb5";
    case ".wav":
      return "\ud83d\udd0a";
    case ".ogg":
      return "\ud83c\udfb6";
    case ".flac":
      return "\ud83c\udfbc";
    case ".m4a":
      return "\ud83c\udfa4";
    default:
      return "\ud83c\udfa7";
  }
}
const OG = (0,require$react.memo)(fd);
function PG({currentFile:t, width:e, onShowFiles:n, onHide:r, launchRequest:i, onApplySuggestedLabel:s}) {
  const o = Pg({initialShowCanvas:!1, defaultActorId:"broadcast_studio", sessionIdKey:uG, scratchpadStorageKey:dG, pinnedContextStorageKey:hG, sessionStateKey:fG, sidebarWidthKey:Pb}), a = (0,require$react.useRef)(o);
  a.current = o;
  const l = (0,require$react.useRef)(null), [c, u] = (0,require$react.useState)(null), h = (0,require$react.useRef)([]), f = (0,require$react.useCallback)(async m => {
    const b = a.current, x = h.current;
    if (x.length > 0 && (x.forEach(w => b.unpinContextItem(w)), h.current = []), !!m) {
      try {
        const w = await ON(m.path), v = `${m.path}#song-title`, T = `${m.path}#song-description`;
        b.pinContextItem({id:v, title:`Song: ${w.song_title}`, path:v, snippet:w.song_title, kind:"message"}), b.pinContextItem({id:T, title:`Description: ${m.name}`, path:T, snippet:w.description, kind:"message"}), h.current = [v, T];
      } catch (w) {
        console.error("Failed to pin audio chat context:", w);
      }
    }
  }, []);
  (0,require$react.useEffect)(() => {
    f(t);
  }, [t, f]), (0,require$react.useEffect)(() => {
    !i || i.id === l.current || (l.current = i.id, o.setSelectedModel(i.model), o.setActiveActorId(i.actorId), o.setActiveAgentId(i.contractId), o.handleNewChat(), u(i));
  }, [o, i]), (0,require$react.useEffect)(() => {
    c && o.activeAgentId === c.contractId && o.selectedModel === c.model && (!o.conversationId || o.isSending || (u(null), o.handleSend("", c.contentParts, {direct:c.direct, omitSystemPrompt:!0, templateContext:c.templateContext})));
  }, [o.activeAgentId, o.conversationId, o.handleSend, o.isSending, o.selectedModel, c]);
  const p = [...o.messages].reverse().find(m => {
    var b;
    return m.role === "assistant" && (((b = m.content) == null ? void 0 : b.trim()) || m.status === "done");
  }) ?? null, g = (0,require$react.useMemo)(() => o.activeAgentId !== gG ? [] : p != null && p.content ? SG(p.content) : [], [o.activeAgentId, p == null ? void 0 : p.content]);
  return (0,require$react_SLASH_jsx_runtime.jsxs)("aside", {style:{width:e, minWidth:300, maxWidth:800, display:"flex", flexDirection:"column", minHeight:0, overflow:"hidden", background:"var(--token-colors-background-surface)"}, children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{padding:"8px 10px", borderBottom:"1px solid var(--token-colors-border-default)", display:"flex", alignItems:"center", justifyContent:"space-between", gap:8, background:"var(--token-colors-background-surface)", 
  flexShrink:0}, children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{fontSize:O.fontSize.sm, fontWeight:600}, children:"Studio Chat"}), (0,require$react_SLASH_jsx_runtime.jsx)(Ke, {variant:"ghost", size:"sm", onClick:r, title:"Collapse Studio Chat panel", children:"Collapse"})]}), t && g.length > 0 && (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{padding:"8px 10px", borderBottom:"1px solid var(--token-colors-border-subtle)", background:"var(--token-colors-background-base)", 
  display:"flex", flexDirection:"column", gap:6}, children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{fontSize:O.fontSize.xs, color:"var(--token-colors-text-muted)"}, children:["Suggested labels from the labeler agent for ", t.name, ":"]}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{display:"flex", flexWrap:"wrap", gap:6}, children:g.map(m => (0,require$react_SLASH_jsx_runtime.jsxs)("button", {onClick:() => void s(m), style:{padding:"4px 8px", borderRadius:10, fontSize:O.fontSize.xs, 
  background:"var(--token-colors-alpha-white-05)", border:"1px solid var(--token-colors-border-default)", cursor:"pointer"}, children:["+ ", m]}, m))})]}), (0,require$react_SLASH_jsx_runtime.jsx)(OG, {controller:o, showFiles:!1, showFilesToggle:!1, showCanvasToggle:!1, onShowFiles:n})]});
}
function qhe() {
  const t = (0,require$react_router_dom.useNavigate)(), [e, n] = (0,require$react.useState)(null), [r, i] = (0,require$react.useState)(!0), [s, o] = (0,require$react.useState)("."), [a, l] = (0,require$react.useState)(""), [c, u] = (0,require$react.useState)(null), [h, f] = (0,require$react.useState)("idle"), [p, g] = (0,require$react.useState)(0), [m, b] = (0,require$react.useState)(0), x = (0,require$react.useRef)(0), [w, v] = (0,require$react.useState)(1), [T, I] = (0,require$react.useState)("library"), 
  _ = (0,require$react.useRef)(null), N = (0,require$react.useRef)(null), E = (0,require$react.useRef)(null), [C, k] = (0,require$react.useState)([]), A = (0,require$react.useRef)(-1), [P, W] = (0,require$react.useState)(!0), [F, B] = (0,require$react.useState)(!0), [z, j] = (0,require$react.useState)(!0), [V, ne] = (0,require$react.useState)(() => {
    const H = localStorage.getItem(Pb);
    return H ? parseInt(H, 10) : 280;
  }), [D, ie] = (0,require$react.useState)(() => {
    const H = localStorage.getItem("knoxx_studio_bottom_height");
    return H ? parseInt(H, 10) : 300;
  }), [ee, M] = (0,require$react.useState)(() => {
    const H = localStorage.getItem("knoxx_studio_chat_width");
    return H ? parseInt(H, 10) : 460;
  }), [X, ge] = (0,require$react.useState)(!1), [me, te] = (0,require$react.useState)(null), [q, R] = (0,require$react.useState)(null), [$, G] = (0,require$react.useState)(!1), [J, U] = (0,require$react.useState)(!1), [le, be] = (0,require$react.useState)([]);
  (0,require$react.useEffect)(() => {
    let H = !1;
    return Ie(`/api/contracts/ui-actions?actor=${encodeURIComponent(pG)}&surface=${encodeURIComponent("broadcast-studio/now-playing")}`).then(pe => {
      H || be((pe.actions ?? []).filter(Pe => {
        var He;
        return Pe.enabled !== !1 && Pe.intent === "agent.run" && ((He = Pe.agent) == null ? void 0 : He.contractId);
      }));
    }).catch(pe => {
      console.error("Failed to load Broadcast Studio UI actions:", pe), H || be([]);
    }), () => {
      H = !0;
    };
  }, []);
  const je = (0,require$react.useCallback)(async() => {
    try {
      i(!0);
      const H = await ZA({path:s, depth:16});
      n(H);
    } catch {
    } finally {
      i(!1);
    }
  }, [s]);
  (0,require$react.useEffect)(() => {
    je();
  }, [je]);
  const Ae = (0,require$react.useCallback)(async() => {
    try {
      G(!0);
      const H = await rN({since_hours:24 * 14, pages_per_channel:2, limit_per_page:100, max_channels:50, import_root:"discord/audio"});
      te(H), await je();
    } catch (H) {
      console.error("Failed to scan Discord audio:", H);
    } finally {
      G(!1);
    }
  }, [je]), ue = (0,require$react.useCallback)(async() => {
    try {
      U(!0);
      const H = await iN({since_hours:24 * 14, pages_per_channel:2, limit_per_page:100, max_channels:50, import_root:"discord/images"});
      R(H);
    } catch (H) {
      console.error("Failed to scan Discord images:", H);
    } finally {
      U(!1);
    }
  }, []);
  (0,require$react.useEffect)(() => {
    e && !X && (async() => {
      try {
        const [pe, Pe] = await Promise.all([kG("player"), TG()]);
        if ((pe == null ? void 0 : pe.volume) != null && v(pe.volume), Pe.length > 0 && k(Pe), pe != null && pe.currentPath && (e != null && e.files)) {
          const He = e.files.find(ot => ot.path === pe.currentPath);
          if (He && (u(He), pe.currentTime)) {
            const ot = pe.currentTime;
            x.current = ot, b(ot);
          }
        }
      } catch {
      }
      ge(!0);
    })();
  }, [e, X]), (0,require$react.useEffect)(() => {
    if (!X) {
      return;
    }
    const H = window.setInterval(() => {
      EG("player", {currentPath:(c == null ? void 0 : c.path) ?? null, currentTime:x.current, volume:w});
    }, 1e3);
    return () => window.clearInterval(H);
  }, [c == null ? void 0 : c.path, w, X]), (0,require$react.useEffect)(() => {
    if (!X) {
      return;
    }
    const H = setTimeout(() => {
      CG(C);
    }, 500);
    return () => clearTimeout(H);
  }, [C, X]);
  const Le = (0,require$react.useRef)(null), $e = (0,require$react.useCallback)(() => {
    if (N.current) {
      return;
    }
    const H = _.current;
    if (!H) {
      return;
    }
    const pe = new AudioContext(), Pe = pe.createAnalyser();
    Pe.fftSize = 128;
    const He = pe.createMediaElementSource(H);
    He.connect(Pe), Pe.connect(pe.destination), N.current = pe, E.current = Pe, Le.current = He;
  }, []);
  (0,require$react.useEffect)(() => () => {
    N.current && (N.current.close(), N.current = null, E.current = null, Le.current = null);
  }, []);
  const Ye = (0,require$react.useCallback)((H, pe = "library") => {
    const Pe = _.current;
    Pe && ($e(), Pe.src = Ul(H.path), Pe.load(), x.current = 0, b(0), g(0), u(H), f("loading"), I(pe), Pe.play().then(() => f("playing")).catch(() => f("idle")));
  }, [$e]), Me = (0,require$react.useCallback)(() => {
    const H = _.current;
    !H || !c || (h === "playing" ? (H.pause(), f("paused")) : H.play().then(() => f("playing")).catch(() => {
    }));
  }, [c, h]), Xe = (0,require$react.useCallback)((H, pe) => {
    A.current = pe;
    const Pe = _.current;
    if (!Pe) {
      return;
    }
    $e(), Pe.src = Ul(H.path), Pe.load();
    const He = {name:H.name, path:H.path, size:0, ext:H.path.split(".").pop() ?? "", modified:0, mime:"audio/mpeg"};
    x.current = 0, b(0), g(0), u(He), f("loading"), I("playlist"), Pe.play().then(() => f("playing")).catch(() => f("idle"));
  }, [$e]), it = (0,require$react.useCallback)(H => {
    if (H < 0 || H >= C.length) {
      return;
    }
    const pe = C[H];
    pe && Xe(pe, H);
  }, [Xe, C]), se = (0,require$react.useCallback)(() => {
    if (C.length === 0) {
      f("idle"), u(null), I("library");
      return;
    }
    const H = (A.current + 1) % C.length;
    it(H);
  }, [C, it]), oe = (0,require$react.useCallback)(() => {
    if (C.length === 0) {
      return;
    }
    const H = A.current <= 0 ? C.length - 1 : A.current - 1;
    it(H);
  }, [C, it]);
  (0,require$react.useEffect)(() => {
    const H = _.current;
    if (!H) {
      return;
    }
    const pe = () => {
      g(H.duration), m > 0 && (H.currentTime = Math.min(m, H.duration || m), x.current = H.currentTime);
    }, Pe = () => se(), He = () => v(H.volume);
    return H.addEventListener("loadedmetadata", pe), H.addEventListener("ended", Pe), H.addEventListener("volumechange", He), () => {
      H.removeEventListener("loadedmetadata", pe), H.removeEventListener("ended", Pe), H.removeEventListener("volumechange", He);
    };
  }, [m, se]), (0,require$react.useEffect)(() => {
    _.current && (_.current.volume = w);
  }, [w]);
  const we = (0,require$react.useCallback)(async H => {
    const [pe, Pe] = await Promise.all([ES(H.path), Gm(H.path).catch(() => [])]);
    k(He => [...He, {id:`${H.path}-${Date.now()}`, path:H.path, name:H.name, addedAt:Date.now(), duration:pe, labels:Pe.map(ot => ot.label)}]);
  }, []), ke = (0,require$react.useCallback)(H => {
    k(pe => pe.filter(Pe => Pe.id !== H));
  }, []), fe = (0,require$react.useCallback)(() => {
    var ot;
    const H = A.current;
    if (T !== "playlist" || H < 0 || H >= C.length) {
      return;
    }
    const pe = C.filter((Bt, qn) => qn !== H);
    if (k(pe), pe.length === 0) {
      A.current = -1, (ot = _.current) == null || ot.pause(), u(null), en([]), f("idle"), I("library");
      return;
    }
    const Pe = H >= pe.length ? 0 : H, He = pe[Pe];
    He && Xe(He, Pe);
  }, [T, Xe, C]), Oe = (0,require$react.useCallback)(() => {
    k([]), A.current = -1;
  }, []), We = (0,require$react.useCallback)(() => {
    k(H => {
      const pe = [...H];
      for (let Pe = pe.length - 1; Pe > 0; Pe--) {
        const He = Math.floor(Math.random() * (Pe + 1));
        [pe[Pe], pe[He]] = [pe[He], pe[Pe]];
      }
      return pe;
    }), A.current = -1;
  }, []);
  (0,require$react.useCallback)((H, pe) => {
    k(Pe => {
      const He = [...Pe], [ot] = He.splice(H, 1);
      return He.splice(pe, 0, ot), He;
    });
  }, []);
  const [rt, st] = (0,require$react.useState)(!1), [ft, St] = (0,require$react.useState)(""), [ht, xe] = (0,require$react.useState)(""), [de, qe] = (0,require$react.useState)([]), [dt, gt] = (0,require$react.useState)(""), [ze, kt] = (0,require$react.useState)(!1), [Dt, Et] = (0,require$react.useState)(null), [Tt, yt] = (0,require$react.useState)("queue"), [Ut, en] = (0,require$react.useState)([]), [Fn, Sn] = (0,require$react.useState)([]), [Lt, Wt] = (0,require$react.useState)([]), [wr, kn] = (0,require$react.useState)(""), 
  [Ct, un] = (0,require$react.useState)(""), [Je, ut] = (0,require$react.useState)(null), [at, Nt] = (0,require$react.useState)(null), [jt, rn] = (0,require$react.useState)(!1), [mn, vn] = (0,require$react.useState)(null), [xt, Jn] = (0,require$react.useState)(null), [tt, Qt] = (0,require$react.useState)([]), [Vt, wi] = (0,require$react.useState)(null), [qt, Zn] = (0,require$react.useState)(null), [On, ps] = (0,require$react.useState)({}), [hl, fl] = (0,require$react.useState)(() => new Set()), wo = 
  (0,require$react.useRef)({}), _o = (0,require$react.useCallback)(async H => {
    if (!H) {
      return null;
    }
    const pe = wo.current[H];
    if (pe) {
      return pe;
    }
    const Pe = (async() => {
      fl(He => (new Set(He)).add(H));
      try {
        const He = await ON(H);
        return ps(ot => ({...ot, [H]:He})), He;
      } catch (He) {
        return console.error("Failed to load audio description:", He), null;
      } finally {
        delete wo.current[H], fl(He => {
          const ot = new Set(He);
          return ot.delete(H), ot;
        });
      }
    })();
    return wo.current[H] = Pe, Pe;
  }, []), _i = (0,require$react.useCallback)(async() => {
    try {
      const H = await IN();
      return Wt(H), H;
    } catch (H) {
      return console.error("Failed to load graph labels:", H), Wt([]), [];
    }
  }, []), So = (0,require$react.useCallback)(async H => {
    try {
      const pe = await Gm(H, Lt.length > 0 ? Lt : void 0);
      return (c == null ? void 0 : c.path) === H && en(pe), (xt == null ? void 0 : xt.path) === H && Sn(pe), k(Pe => Pe.map(He => He.path === H ? {...He, labels:pe.map(ot => ot.label)} : He)), pe;
    } catch (pe) {
      return console.error("Failed to load labels for audio path:", pe), (c == null ? void 0 : c.path) === H && en([]), (xt == null ? void 0 : xt.path) === H && Sn([]), [];
    }
  }, [Lt, c == null ? void 0 : c.path, xt == null ? void 0 : xt.path]);
  (0,require$react.useEffect)(() => {
    _i(), If().then(H => Qt(H.playlists)).catch(() => {
    });
  }, [_i]), (0,require$react.useEffect)(() => {
    let H = !1;
    return fetch(`${us}${go}/gardens`, {credentials:"include", headers:Xn()}).then(async pe => pe.ok ? await pe.json() : {gardens:[]}).then(pe => {
      if (H) {
        return;
      }
      const Pe = (pe.gardens ?? []).filter(He => He.status !== "archived");
      qe(Pe), gt(He => {
        var ot;
        return He || ((ot = Pe[0]) == null ? void 0 : ot.garden_id) || "";
      });
    }).catch(pe => {
      console.error("Failed to load gardens for publication draft:", pe), H || qe([]);
    }), () => {
      H = !0;
    };
  }, []), (0,require$react.useEffect)(() => {
    if (!(c != null && c.path)) {
      en([]);
      return;
    }
    So(c.path), On[c.path] || _o(c.path);
  }, [On, c == null ? void 0 : c.path, _o, So]), (0,require$react.useEffect)(() => {
    if (!Je) {
      vn(null);
      return;
    }
    let H = !1;
    return _G(Je).then(pe => {
      H || vn(new Set(pe));
    }).catch(pe => {
      console.error("Failed to load label-filtered paths:", pe), H || vn(new Set());
    }), () => {
      H = !0;
    };
  }, [Je]);
  const ha = (0,require$react.useCallback)(async H => {
    Jn(H), yt("labels"), On[H.path] || _o(H.path);
    try {
      const pe = await Gm(H.path, Lt.length > 0 ? Lt : void 0);
      Sn(pe);
    } catch {
      Sn([]);
    }
  }, [Lt, On, _o]), Si = (0,require$react.useCallback)(async(H, pe) => {
    const Pe = (c == null ? void 0 : c.path) === H.path && Ut.some(He => He.label_id === pe.label_id) || (xt == null ? void 0 : xt.path) === H.path && Fn.some(He => He.label_id === pe.label_id);
    try {
      Nt(pe.label_id), Pe ? await wG(H.path, pe.label_id) : await vG(H.path, pe.label_id), await So(H.path);
    } catch (He) {
      console.error("Failed to toggle graph label:", He);
    } finally {
      Nt(null);
    }
  }, [c == null ? void 0 : c.path, Ut, Fn, xt == null ? void 0 : xt.path, So]), Vr = (0,require$react.useCallback)(async(H, pe) => {
    const Pe = pe.trim();
    if (Pe) {
      try {
        rn(!0);
        const He = Lt.find(Bt => Bt.label.toLowerCase() === Pe.toLowerCase()), ot = He ?? await yG(Pe);
        if (He) {
          await Si(H, ot);
        } else {
          const qn = (await _i()).find(Yr => Yr.label_id === ot.label_id) ?? ot;
          await Si(H, qn);
        }
        un(""), kn("");
      } catch (He) {
        console.error("Failed to create/apply graph label:", He);
      } finally {
        rn(!1);
      }
    }
  }, [Lt, _i, Si]), fa = (0,require$react.useCallback)(async H => {
    c && await Vr(c, H);
  }, [c, Vr]), ko = (0,require$react.useCallback)(async(H, pe) => {
    await Vr(H, pe);
  }, [Vr]), _e = (0,require$react.useCallback)(async(H, pe) => {
    try {
      const Pe = document.createElement("canvas");
      Pe.width = 800, Pe.height = 200;
      const He = Pe.getContext("2d");
      if (!He) {
        return;
      }
      const ot = new Audio();
      ot.crossOrigin = "anonymous", ot.src = Ul(H), await new Promise((ki, Hs) => {
        ot.addEventListener("loadeddata", () => ki()), ot.addEventListener("error", Hs);
      });
      const Bt = new AudioContext(), qn = Bt.createMediaElementSource(ot), Yr = Bt.createAnalyser();
      if (Yr.fftSize = 2048, qn.connect(Yr), Yr.connect(Bt.destination), pe === "waveform") {
        const ki = Yr.frequencyBinCount, Hs = new Uint8Array(ki);
        Yr.getByteTimeDomainData(Hs), He.fillStyle = "#1a1a2e", He.fillRect(0, 0, Pe.width, Pe.height), He.lineWidth = 2, He.strokeStyle = "#6382ff", He.beginPath();
        const gl = Pe.width / ki;
        let Us = 0;
        for (let zi = 0; zi < ki; zi++) {
          const ml = Hs[zi] / 128 * Pe.height / 2;
          zi === 0 ? He.moveTo(Us, ml) : He.lineTo(Us, ml), Us += gl;
        }
        He.lineTo(Pe.width, Pe.height / 2), He.stroke();
      } else {
        const ki = Yr.frequencyBinCount, Hs = new Uint8Array(ki);
        He.fillStyle = "#1a1a2e", He.fillRect(0, 0, Pe.width, Pe.height);
        const gl = Pe.width / ki * 2.5;
        let Us = 0;
        for (let zi = 0; zi < ki; zi++) {
          Yr.getByteFrequencyData(Hs);
          const pa = Hs[zi] / 255 * Pe.height, ml = zi / ki * 60 + 200;
          if (He.fillStyle = `hsla(${ml}, 80%, 60%, 0.8)`, He.fillRect(Us, Pe.height - pa, gl, pa), Us += gl + 1, Us > Pe.width) {
            break;
          }
        }
      }
      const um = Pe.toDataURL("image/png").split(",")[1];
      await nN(H, pe, um, "image/png", Pe.width, Pe.height), Bt.close(), alert(`${pe === "waveform" ? "Waveform" : "Spectrogram"} generated and saved!`);
    } catch (Pe) {
      console.error(`Failed to generate ${pe}:`, Pe), alert(`Failed to generate ${pe}`);
    }
  }, []), De = (0,require$react.useCallback)(async(H, pe) => {
    try {
      const Pe = await tN(H);
      if (Pe.ok) {
        const He = await Promise.all(Pe.items.map(async ot => {
          const Bt = await ES(ot.path);
          return {...ot, duration:Bt};
        }));
        wi({name:pe, items:He});
      }
    } catch (Pe) {
      console.error("Failed to load M3U:", Pe);
    }
  }, []), lt = (0,require$react.useCallback)(() => {
    if (!Vt) {
      return;
    }
    const H = Vt.items.map(pe => ({id:`${pe.path}-${Date.now()}-${Math.random()}`, path:pe.path, name:pe.name, addedAt:Date.now(), duration:pe.duration}));
    k(H), wi(null);
  }, [Vt]), vt = (0,require$react.useCallback)(() => {
    if (!Vt) {
      return;
    }
    const H = Vt.items.map(pe => ({id:`${pe.path}-${Date.now()}-${Math.random()}`, path:pe.path, name:pe.name, addedAt:Date.now(), duration:pe.duration}));
    k(pe => [...pe, ...H]), wi(null);
  }, [Vt]), Mt = (0,require$react.useCallback)(async() => {
    if (C.length !== 0) {
      try {
        st(!0);
        const H = ft || `playlist-${(new Date()).toISOString().slice(0, 10)}`;
        await eN(H, C.map(Pe => ({path:Pe.path, name:Pe.name}))), St("");
        const pe = await If();
        Qt(pe.playlists);
      } catch (H) {
        console.error("Failed to save playlist:", H);
      } finally {
        st(!1);
      }
    }
  }, [C, ft]), Pn = (0,require$react.useCallback)(async() => {
    if (!(C.length === 0 || !dt)) {
      kt(!0), Et(null);
      try {
        const H = ft.trim() || `Broadcast playlist ${(new Date()).toISOString().slice(0, 10)}`, pe = de.find(Bt => Bt.garden_id === dt);
        Et(`Creating ${(pe == null ? void 0 : pe.title) ?? dt} CMS draft from cached queue data\u2026`);
        const Pe = C.map(Bt => {
          var qn;
          return {path:Bt.path, name:Bt.name, title:Bt.name, duration:Bt.duration, labels:Bt.labels ?? [], description:(qn = On[Bt.path]) == null ? void 0 : qn.description};
        }), He = cG({title:H, description:ht, tracks:Pe});
        Et(`Creating CMS block document in ${(pe == null ? void 0 : pe.title) ?? dt}\u2026`);
        const ot = await NG({title:He.title, content:He.content, source_path:He.sourcePath, visibility:"review", garden_id:dt, defer_index:!0, metadata:{...He.metadata, garden_id:dt}});
        if (!(ot != null && ot.doc_id)) {
          throw new Error("CMS did not return a document id for the draft.");
        }
        Et(`Created ${(pe == null ? void 0 : pe.title) ?? dt} CMS draft: ${ot.title}`), t(`/cms?doc=${encodeURIComponent(ot.doc_id)}`);
      } catch (H) {
        console.error("Failed to create publication draft:", H), Et(`Failed to create publication draft: ${H instanceof Error ? H.message : "unknown error"}`);
      } finally {
        kt(!1);
      }
    }
  }, [On, t, C, ft, ht, de, dt]), En = (0,require$react.useCallback)(H => {
    x.current = H;
  }, []), bn = (0,require$react.useMemo)(() => {
    const H = (e == null ? void 0 : e.files) ?? [], pe = new Set();
    for (const Pe of H) {
      const He = Pe.path.split("/");
      for (let ot = 1; ot < He.length; ot++) {
        const Bt = He.slice(0, ot).join("/");
        Bt && pe.add(Bt);
      }
    }
    return Array.from(pe).sort();
  }, [e == null ? void 0 : e.files]), Rr = s === "." ? "" : `${s}/`, ai = (0,require$react.useMemo)(() => ((e == null ? void 0 : e.files) ?? []).filter(H => H.path.startsWith(Rr) ? !H.path.slice(Rr.length).includes("/") : !1), [Rr, e == null ? void 0 : e.files]), xh = (0,require$react.useMemo)(() => bn.filter(H => s === "." ? !H.includes("/") : H.startsWith(s + "/") && H.slice(s.length + 1).split("/").length === 1).map(H => H.split("/").pop()), [bn, s]), vh = (0,require$react.useMemo)(() => {
    const H = a ? ((e == null ? void 0 : e.files) ?? []).filter(pe => pe.name.toLowerCase().includes(a.toLowerCase())) : ai;
    return !Je || !mn ? H : H.filter(pe => mn.has(pe.path));
  }, [ai, a, Je, mn, e == null ? void 0 : e.files]), lm = (0,require$react.useCallback)(H => {
    H.preventDefault();
    const pe = H.clientX, Pe = V, He = Bt => {
      const qn = Math.max(200, Math.min(500, Pe + (Bt.clientX - pe)));
      ne(qn);
    }, ot = () => {
      document.removeEventListener("mousemove", He), document.removeEventListener("mouseup", ot), localStorage.setItem(Pb, String(V));
    };
    document.addEventListener("mousemove", He), document.addEventListener("mouseup", ot);
  }, [V]), wh = (0,require$react.useCallback)(H => {
    H.preventDefault();
    const pe = H.clientY, Pe = D, He = Bt => {
      const qn = Math.max(150, Math.min(600, Pe - (Bt.clientY - pe)));
      ie(qn);
    }, ot = () => {
      document.removeEventListener("mousemove", He), document.removeEventListener("mouseup", ot), localStorage.setItem("knoxx_studio_bottom_height", String(D));
    };
    document.addEventListener("mousemove", He), document.addEventListener("mouseup", ot);
  }, [D]), cm = (0,require$react.useCallback)(H => {
    H.preventDefault();
    const pe = H.clientX, Pe = ee, He = Bt => {
      const qn = Math.max(300, Math.min(800, Pe - (Bt.clientX - pe)));
      M(qn);
    }, ot = () => {
      document.removeEventListener("mousemove", He), document.removeEventListener("mouseup", ot), localStorage.setItem("knoxx_studio_chat_width", String(ee));
    };
    document.addEventListener("mousemove", He), document.addEventListener("mouseup", ot);
  }, [ee]), qr = c != null && c.path ? On[c.path] : void 0, pl = (0,require$react.useMemo)(() => qr != null && qr.description ? _S(qr.description) : [], [qr == null ? void 0 : qr.description]), jc = !!(c != null && c.path && hl.has(c.path)), Dr = xt != null && xt.path ? On[xt.path] : void 0, _h = (0,require$react.useMemo)(() => Dr != null && Dr.description ? _S(Dr.description) : [], [Dr == null ? void 0 : Dr.description]), Vc = !!(xt != null && xt.path && hl.has(xt.path)), qc = (0,require$react.useMemo)(() => 
  C.slice(0, mG), [C]), Eo = Math.max(0, C.length - qc.length);
  return (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{display:"flex", height:"100%", overflow:"hidden"}, children:[(0,require$react_SLASH_jsx_runtime.jsx)("audio", {ref:_, preload:"auto", crossOrigin:"anonymous"}), !P && (0,require$react_SLASH_jsx_runtime.jsx)(Fa, {label:"Audio Library", edge:"left", onExpand:() => W(!0), title:"Show Audio Library panel"}), P && (0,require$react_SLASH_jsx_runtime.jsxs)("aside", {style:{width:V, minWidth:200, maxWidth:500, borderRight:"1px solid var(--token-colors-border-default)", 
  display:"flex", flexDirection:"column", background:"var(--token-colors-background-surface)", overflow:"hidden"}, children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{padding:"12px 16px", borderBottom:"1px solid var(--token-colors-border-default)", display:"flex", alignItems:"center", justifyContent:"space-between"}, children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{fontSize:O.fontSize.sm, fontWeight:600}, children:"Audio Library"}), (0,require$react_SLASH_jsx_runtime.jsx)(Ke, 
  {variant:"ghost", size:"sm", onClick:() => W(!1), title:"Collapse Audio Library panel", children:"Collapse"})]}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{padding:"8px 16px", borderBottom:"1px solid var(--token-colors-border-subtle)"}, children:(0,require$react_SLASH_jsx_runtime.jsx)("input", {type:"text", value:s, onChange:H => o(H.target.value), placeholder:"Scan path...", style:{width:"100%", padding:"4px 8px", fontSize:O.fontSize.xs, borderRadius:4, border:"1px solid var(--token-colors-border-default)", 
  background:"var(--token-colors-background-input)"}})}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{padding:"8px 16px", borderBottom:"1px solid var(--token-colors-border-subtle)", display:"flex", gap:6}, children:[(0,require$react_SLASH_jsx_runtime.jsx)("input", {type:"text", value:a, onChange:H => l(H.target.value), placeholder:"\ud83d\udd0d Search files...", style:{flex:1, padding:"4px 8px", fontSize:O.fontSize.xs, borderRadius:4, border:"1px solid var(--token-colors-border-default)", 
  background:"var(--token-colors-background-input)"}}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{position:"relative"}, children:[(0,require$react_SLASH_jsx_runtime.jsx)(Ke, {variant:Je ? "primary" : "ghost", size:"sm", onClick:() => {
    const H = document.getElementById("label-filter-dropdown");
    H && (H.style.display = H.style.display === "none" ? "block" : "none");
  }, title:"Filter by label", children:"\ud83c\udff7"}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {id:"label-filter-dropdown", style:{display:"none", position:"absolute", top:"100%", right:0, zIndex:100, background:"var(--token-colors-background-surface)", border:"1px solid var(--token-colors-border-default)", borderRadius:6, padding:8, minWidth:150, maxHeight:200, overflowY:"auto", boxShadow:"0 4px 12px rgba(0,0,0,0.15)"}, children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {onClick:() => 
  {
    ut(null), document.getElementById("label-filter-dropdown").style.display = "none";
  }, style:{padding:"4px 8px", fontSize:O.fontSize.xs, cursor:"pointer", borderRadius:4, background:Je ? "transparent" : "var(--token-colors-alpha-blue-10)"}, children:"All files"}), Lt.map(H => (0,require$react_SLASH_jsx_runtime.jsxs)("div", {onClick:() => {
    ut(H.label_id), document.getElementById("label-filter-dropdown").style.display = "none";
  }, style:{padding:"4px 8px", fontSize:O.fontSize.xs, cursor:"pointer", borderRadius:4, background:Je === H.label_id ? "var(--token-colors-alpha-blue-10)" : "transparent"}, children:[H.emoji ? `${H.emoji} ` : "", H.label]}, H.label_id))]})]})]}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{padding:"6px 16px", borderBottom:"1px solid var(--token-colors-border-subtle)", display:"flex", alignItems:"center", gap:4, fontSize:O.fontSize.xs, color:"var(--token-colors-text-muted)", flexWrap:"wrap"}, 
  children:[(0,require$react_SLASH_jsx_runtime.jsx)("button", {onClick:() => o("."), style:{background:"none", border:"none", cursor:"pointer", color:s === "." ? "var(--token-colors-text-default)" : "var(--token-colors-accent-blue)", padding:0, fontSize:O.fontSize.xs}, children:"~"}), s !== "." && s.split("/").map((H, pe, Pe) => (0,require$react_SLASH_jsx_runtime.jsxs)("span", {style:{display:"flex", alignItems:"center", gap:4}, children:[(0,require$react_SLASH_jsx_runtime.jsx)("span", {children:"/"}), 
  (0,require$react_SLASH_jsx_runtime.jsx)("button", {onClick:() => o(Pe.slice(0, pe + 1).join("/")), style:{background:"none", border:"none", cursor:"pointer", color:pe === Pe.length - 1 ? "var(--token-colors-text-default)" : "var(--token-colors-accent-blue)", padding:0, fontSize:O.fontSize.xs}, children:H})]}, pe))]}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{flex:1, overflowY:"auto", padding:"8px"}, children:r ? (0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{padding:16, textAlign:"center", 
  color:"var(--token-colors-text-muted)", fontSize:O.fontSize.sm}, children:"Loading..."}) : (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{display:"flex", flexDirection:"column", gap:2}, children:[s !== "." && (0,require$react_SLASH_jsx_runtime.jsxs)("div", {onClick:() => {
    const H = s.split("/");
    H.length > 1 ? o(H.slice(0, -1).join("/")) : o(".");
  }, style:{display:"flex", alignItems:"center", gap:8, padding:"6px 8px", borderRadius:6, cursor:"pointer", transition:"all 0.15s"}, onMouseEnter:H => H.currentTarget.style.background = "var(--token-colors-alpha-white-05)", onMouseLeave:H => H.currentTarget.style.background = "transparent", children:[(0,require$react_SLASH_jsx_runtime.jsx)("span", {style:{fontSize:16}, children:"\ud83d\udcc1"}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{fontSize:O.fontSize.xs, fontWeight:500}, children:".."})]}), 
  !a && xh.map(H => (0,require$react_SLASH_jsx_runtime.jsxs)("div", {onClick:() => o(s + "/" + H), style:{display:"flex", alignItems:"center", gap:8, padding:"6px 8px", borderRadius:6, cursor:"pointer", transition:"all 0.15s"}, onMouseEnter:pe => pe.currentTarget.style.background = "var(--token-colors-alpha-white-05)", onMouseLeave:pe => pe.currentTarget.style.background = "transparent", children:[(0,require$react_SLASH_jsx_runtime.jsx)("span", {style:{fontSize:16}, children:"\ud83d\udcc1"}), (0,require$react_SLASH_jsx_runtime.jsx)("div", 
  {style:{fontSize:O.fontSize.xs, fontWeight:500}, children:H})]}, H)), vh.length === 0 && xh.length === 0 && (0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{padding:16, textAlign:"center", color:"var(--token-colors-text-muted)", fontSize:O.fontSize.sm}, children:a ? `No files matching "${a}"` : `No audio files in "${s}"`}), vh.map(H => (0,require$react_SLASH_jsx_runtime.jsxs)("div", {onClick:() => Ye(H), style:{display:"flex", alignItems:"center", gap:8, padding:"6px 8px", borderRadius:6, 
  cursor:"pointer", background:(c == null ? void 0 : c.path) === H.path ? "var(--token-colors-alpha-blue-10)" : "transparent", border:(c == null ? void 0 : c.path) === H.path ? "1px solid var(--token-colors-accent-blue)" : "1px solid transparent", transition:"all 0.15s"}, onMouseEnter:pe => {
    (c == null ? void 0 : c.path) !== H.path && (pe.currentTarget.style.background = "var(--token-colors-alpha-white-05)");
  }, onMouseLeave:pe => {
    (c == null ? void 0 : c.path) !== H.path && (pe.currentTarget.style.background = "transparent");
  }, children:[(0,require$react_SLASH_jsx_runtime.jsx)("span", {style:{fontSize:16}, children:TS(H.ext)}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{flex:1, minWidth:0}, children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{fontSize:O.fontSize.xs, fontWeight:500, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap"}, children:H.name}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{fontSize:10, color:"var(--token-colors-text-muted)"}, children:IG(H.size)})]}), 
  (0,require$react_SLASH_jsx_runtime.jsx)(Ke, {variant:"ghost", size:"sm", onClick:pe => {
    pe.stopPropagation(), ha(H);
  }, title:"Labels", children:"\ud83c\udff7"}), (0,require$react_SLASH_jsx_runtime.jsx)(Ke, {variant:"ghost", size:"sm", onClick:pe => {
    pe.stopPropagation(), we(H);
  }, title:"Add to queue", children:"+"})]}, H.path))]})}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{borderTop:"1px solid var(--token-colors-border-default)", display:"flex", flexDirection:"column", flex:1, minHeight:0}, children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{padding:"8px 16px", display:"flex", alignItems:"center", justifyContent:"space-between", borderBottom:"1px solid var(--token-colors-border-subtle)"}, children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", 
  {style:{fontSize:O.fontSize.xs, fontWeight:600}, children:["Playlists ", (0,require$react_SLASH_jsx_runtime.jsx)(ct, {size:"sm", children:tt.length})]}), (0,require$react_SLASH_jsx_runtime.jsx)(Ke, {variant:"ghost", size:"sm", onClick:() => void If().then(H => Qt(H.playlists)).catch(() => {
  }), children:"\u21bb"})]}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{flex:1, overflowY:"auto", padding:"4px 8px"}, children:tt.length === 0 ? (0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{padding:8, textAlign:"center", color:"var(--token-colors-text-muted)", fontSize:O.fontSize.xs}, children:"No saved playlists"}) : (0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{display:"flex", flexDirection:"column", gap:1}, children:tt.map(H => (0,require$react_SLASH_jsx_runtime.jsxs)("div", 
  {onClick:() => void De(H.path, H.name), style:{display:"flex", alignItems:"center", gap:6, padding:"4px 8px", borderRadius:4, fontSize:O.fontSize.xs, cursor:"pointer", background:(Vt == null ? void 0 : Vt.name) === H.name ? "var(--token-colors-alpha-blue-10)" : "transparent"}, onMouseEnter:pe => {
    (Vt == null ? void 0 : Vt.name) !== H.name && (pe.currentTarget.style.background = "var(--token-colors-alpha-white-05)");
  }, onMouseLeave:pe => {
    (Vt == null ? void 0 : Vt.name) !== H.name && (pe.currentTarget.style.background = "transparent");
  }, children:[(0,require$react_SLASH_jsx_runtime.jsx)("span", {children:"\ud83c\udfb5"}), (0,require$react_SLASH_jsx_runtime.jsx)("span", {style:{flex:1, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap"}, children:H.name})]}, H.path))})})]}), Vt && (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{borderTop:"1px solid var(--token-colors-border-default)", display:"flex", flexDirection:"column", maxHeight:"40%"}, children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{padding:"8px 16px", 
  display:"flex", alignItems:"center", justifyContent:"space-between", borderBottom:"1px solid var(--token-colors-border-subtle)"}, children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{fontSize:O.fontSize.xs, fontWeight:600}, children:["Preview: ", Vt.name]}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{display:"flex", gap:4}, children:[(0,require$react_SLASH_jsx_runtime.jsx)(Ke, {size:"sm", onClick:lt, children:"Load"}), (0,require$react_SLASH_jsx_runtime.jsx)(Ke, {variant:"ghost", 
  size:"sm", onClick:vt, children:"Append"}), (0,require$react_SLASH_jsx_runtime.jsx)(Ke, {variant:"ghost", size:"sm", onClick:() => wi(null), children:"\u2715"})]})]}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{flex:1, overflowY:"auto", padding:"4px 8px"}, children:(0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{display:"flex", flexDirection:"column", gap:1}, children:Vt.items.map((H, pe) => (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{display:"flex", alignItems:"center", 
  gap:6, padding:"3px 6px", borderRadius:4, fontSize:O.fontSize.xs}, onMouseEnter:Pe => Pe.currentTarget.style.background = "var(--token-colors-alpha-white-05)", onMouseLeave:Pe => Pe.currentTarget.style.background = "transparent", children:[(0,require$react_SLASH_jsx_runtime.jsx)("span", {style:{width:16, textAlign:"center", color:"var(--token-colors-text-muted)"}, children:pe + 1}), (0,require$react_SLASH_jsx_runtime.jsx)("span", {style:{flex:1, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap"}, 
  children:H.name}), H.duration !== void 0 && H.duration > 0 && (0,require$react_SLASH_jsx_runtime.jsx)("span", {style:{color:"var(--token-colors-text-muted)", fontSize:10, minWidth:28, textAlign:"right"}, children:SS(H.duration)}), (0,require$react_SLASH_jsx_runtime.jsx)("button", {onClick:() => {
    const Pe = [H].map(He => ({id:`${He.path}-${Date.now()}-${Math.random()}`, path:He.path, name:He.name, addedAt:Date.now(), duration:He.duration}));
    k(He => [...He, ...Pe]);
  }, style:{background:"none", border:"none", cursor:"pointer", padding:2, fontSize:12}, title:"Add to queue", children:"+"})]}, `${H.path}-${pe}`))})})]})]}), P && (0,require$react_SLASH_jsx_runtime.jsx)("div", {onMouseDown:lm, style:{width:4, cursor:"col-resize", background:"var(--token-colors-border-default)", transition:"background 0.15s"}, onMouseEnter:H => H.currentTarget.style.background = "var(--token-colors-accent-blue)", onMouseLeave:H => H.currentTarget.style.background = "var(--token-colors-border-default)"}), 
  (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{flex:1, display:"flex", flexDirection:"column", minWidth:400, overflow:"hidden", position:"relative"}, children:[(0,require$react_SLASH_jsx_runtime.jsxs)("header", {style:{padding:"8px 16px", borderBottom:"1px solid var(--token-colors-border-default)", display:"flex", alignItems:"center", gap:12, background:"var(--token-colors-background-surface)", flexWrap:"wrap"}, children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{fontSize:O.fontSize.lg, 
  fontWeight:600}, children:"Broadcast Studio"}), (0,require$react_SLASH_jsx_runtime.jsxs)(ct, {variant:"default", children:[(e == null ? void 0 : e.count) ?? 0, " files"]}), (0,require$react_SLASH_jsx_runtime.jsx)(Ke, {variant:"ghost", size:"sm", onClick:() => void Ae(), disabled:$, children:$ ? "Scanning Discord audio\u2026" : "Scan Discord audio"}), (0,require$react_SLASH_jsx_runtime.jsx)(Ke, {variant:"ghost", size:"sm", onClick:() => void ue(), disabled:J, children:J ? "Scanning Discord images\u2026" : 
  "Scan Discord images"}), me && (0,require$react_SLASH_jsx_runtime.jsxs)(ct, {variant:"default", children:["Audio ", me.imported_count, " imported / ", me.attachments_found, " found"]}), q && (0,require$react_SLASH_jsx_runtime.jsxs)(ct, {variant:"default", children:["Images ", q.imported_count, " imported / ", q.attachments_found, " found"]}), c && (0,require$react_SLASH_jsx_runtime.jsx)(ct, {variant:h === "playing" ? "success" : "default", children:h === "playing" ? "\u25cf Live" : h === "paused" ? 
  "\u275a\u275a Paused" : "Ready"})]}), (me || q) && (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{padding:"8px 16px", borderBottom:"1px solid var(--token-colors-border-subtle)", background:"var(--token-colors-background-surface)", fontSize:O.fontSize.xs, color:"var(--token-colors-text-muted)", display:"flex", gap:12, flexWrap:"wrap"}, children:[me && (0,require$react_SLASH_jsx_runtime.jsxs)(require$react_SLASH_jsx_runtime.Fragment, {children:[(0,require$react_SLASH_jsx_runtime.jsxs)("span", 
  {children:["Audio channels: ", me.channels_scanned]}), (0,require$react_SLASH_jsx_runtime.jsxs)("span", {children:["Audio messages: ", me.messages_scanned]}), (0,require$react_SLASH_jsx_runtime.jsxs)("span", {children:["Audio imported: ", me.imported_count]}), (0,require$react_SLASH_jsx_runtime.jsxs)("span", {children:["Audio skipped: ", me.skipped_count]}), (0,require$react_SLASH_jsx_runtime.jsxs)("span", {children:["Audio failed: ", me.failed_count]}), me.manifest_path && (0,require$react_SLASH_jsx_runtime.jsxs)("span", 
  {children:["Audio manifest: ", me.manifest_path]})]}), q && (0,require$react_SLASH_jsx_runtime.jsxs)(require$react_SLASH_jsx_runtime.Fragment, {children:[(0,require$react_SLASH_jsx_runtime.jsxs)("span", {children:["Image channels: ", q.channels_scanned]}), (0,require$react_SLASH_jsx_runtime.jsxs)("span", {children:["Image messages: ", q.messages_scanned]}), (0,require$react_SLASH_jsx_runtime.jsxs)("span", {children:["Image imported: ", q.imported_count]}), (0,require$react_SLASH_jsx_runtime.jsxs)("span", 
  {children:["Image skipped: ", q.skipped_count]}), (0,require$react_SLASH_jsx_runtime.jsxs)("span", {children:["Image failed: ", q.failed_count]}), q.manifest_path && (0,require$react_SLASH_jsx_runtime.jsxs)("span", {children:["Image manifest: ", q.manifest_path]})]})]}), (0,require$react_SLASH_jsx_runtime.jsx)(SN, {track:c, playerState:h, playingFrom:T, permissions:{canGoPrevious:!0, canPlayPause:!0, canGoNext:!0, canEditLabels:!0, canAdjustVolume:!0, canGenerateAssets:!0, canRemoveFromQueue:T === 
  "playlist" && A.current >= 0}, volume:w, fileIcon:TS, onPrevious:oe, onTogglePlayPause:Me, onNext:se, onEditLabels:() => c && void ha(c), onVolumeChange:v, onGenerateSpectrogram:() => c && _e(c.path, "spectrogram"), onGenerateWaveform:() => c && _e(c.path, "waveform"), onRemoveFromQueue:fe, waveform:(0,require$react_SLASH_jsx_runtime.jsx)(CN, {analyserRef:E, isPlaying:h === "playing"}), progress:(0,require$react_SLASH_jsx_runtime.jsx)(AN, {audioRef:_, duration:p, initialTime:m, onPersistTime:En}), 
  heardDescription:c && (qr || jc) ? (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{width:"100%", maxWidth:720, padding:"8px 10px", borderRadius:10, background:"var(--token-colors-background-surface)", border:"1px solid var(--token-colors-border-subtle)", fontSize:O.fontSize.xs, color:"var(--token-colors-text-muted)"}, children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{fontWeight:600, color:"var(--token-colors-text-default)", marginBottom:4}, children:"Heard description"}), 
  (0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{lineHeight:1.4}, children:jc && !qr ? "Listening for description..." : qr == null ? void 0 : qr.description}), pl.length > 0 && (0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{display:"flex", flexWrap:"wrap", gap:6, marginTop:8}, children:pl.map(H => (0,require$react_SLASH_jsx_runtime.jsxs)("button", {onClick:() => void ko(c, H), style:{padding:"2px 8px", borderRadius:10, fontSize:O.fontSize.xs, background:"var(--token-colors-alpha-white-05)", 
  border:"1px solid var(--token-colors-border-default)", cursor:"pointer"}, title:"Create/apply this heard label through OpenPlanner graph labels", children:["+ ", H]}, H))})]}) : null, currentLabels:Ut.length > 0 ? (0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{display:"flex", flexWrap:"wrap", gap:6, justifyContent:"center"}, children:Ut.map(H => (0,require$react_SLASH_jsx_runtime.jsxs)("button", {onClick:() => c && void Si(c, H), disabled:at === H.label_id, style:{padding:"2px 8px", borderRadius:10, 
  fontSize:O.fontSize.xs, background:H.color ?? "var(--token-colors-alpha-blue-10)", border:`1px solid ${H.color ?? "var(--token-colors-alpha-blue-20)"}`, color:"white", cursor:"pointer", opacity:at === H.label_id ? 0.6 : 1}, title:"Click to remove label", children:[H.emoji ? `${H.emoji} ` : "", H.label, " \u00d7"]}, H.label_id))}) : null, agentActions:c ? (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{width:"100%", maxWidth:640}, children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", 
  {style:{fontSize:O.fontSize.xs, color:"var(--token-colors-text-muted)", marginBottom:6, textAlign:"center"}, children:"Analyze in chat pane with a dedicated contract:"}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{display:"flex", flexWrap:"wrap", gap:8, justifyContent:"center"}, children:le.map(H => {
    var ot, Bt, qn;
    const pe = (ot = H.agent) == null ? void 0 : ot.contractId, Pe = (Bt = H.agent) == null ? void 0 : Bt.actorId, He = (qn = H.agent) == null ? void 0 : qn.model;
    return !pe || !Pe || !He ? null : (0,require$react_SLASH_jsx_runtime.jsx)(Ke, {variant:"ghost", size:"sm", onClick:() => {
      j(!0), Zn({id:`${H.id}:${c.path}:${Date.now()}`, actorId:Pe, contractId:pe, model:He, contentParts:[{type:"audio", url:Ul(c.path), mimeType:c.mime || void 0, filename:c.name}], direct:H.mode === "direct", templateContext:{media:{filename:c.name, path:c.path, mimeType:c.mime || null, labels:Ut.map(Yr => Yr.label), labelCount:Ut.length, size:c.size}}});
    }, children:H.label}, H.id);
  })})]}) : null, graphLabelControls:Lt.length > 0 && c ? (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{width:"100%", maxWidth:640}, children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{fontSize:O.fontSize.xs, color:"var(--token-colors-text-muted)", marginBottom:6, textAlign:"center"}, children:"Graph labels (click to toggle):"}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{display:"flex", gap:8, marginBottom:10}, children:[(0,require$react_SLASH_jsx_runtime.jsx)("input", 
  {type:"text", value:Ct, onChange:H => un(H.target.value), onKeyDown:H => {
    H.key === "Enter" && Vr(c, Ct);
  }, placeholder:"Create or toggle any text label...", style:{flex:1, padding:"6px 10px", fontSize:O.fontSize.sm, borderRadius:6, border:"1px solid var(--token-colors-border-default)", background:"var(--token-colors-background-input)"}}), (0,require$react_SLASH_jsx_runtime.jsx)(Ke, {size:"sm", onClick:() => void Vr(c, Ct), disabled:jt || !Ct.trim(), children:jt ? "..." : "Add label"})]}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{display:"flex", flexWrap:"wrap", gap:6, justifyContent:"center"}, 
  children:Lt.slice(0, 16).map(H => {
    const pe = Ut.some(Pe => Pe.label_id === H.label_id);
    return (0,require$react_SLASH_jsx_runtime.jsxs)("button", {onClick:() => void Si(c, H), disabled:at === H.label_id, style:{padding:"4px 10px", borderRadius:12, fontSize:O.fontSize.xs, background:pe ? H.color ?? "var(--token-colors-alpha-blue-20)" : "var(--token-colors-alpha-white-05)", border:`1px solid ${pe ? H.color ?? "var(--token-colors-accent-blue)" : "var(--token-colors-border-default)"}`, cursor:"pointer", color:pe ? "white" : "inherit", opacity:at === H.label_id ? 0.6 : 1}, title:H.description || 
    H.label, children:[H.emoji ? `${H.emoji} ` : "", H.label]}, H.label_id);
  })})]}) : null}), !F && (0,require$react_SLASH_jsx_runtime.jsx)(Fa, {label:"Queue \x26 Labels", edge:"bottom", onExpand:() => B(!0), title:"Show Queue and Labels panel"}), F && (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{borderTop:"1px solid var(--token-colors-border-default)", display:"flex", flexDirection:"column", height:D, minHeight:150}, children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {onMouseDown:wh, style:{height:4, cursor:"row-resize", background:"var(--token-colors-border-default)", 
  transition:"background 0.15s", position:"absolute", top:0, left:0, right:0, zIndex:10}, onMouseEnter:H => H.currentTarget.style.background = "var(--token-colors-accent-blue)", onMouseLeave:H => H.currentTarget.style.background = "var(--token-colors-border-default)"}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{display:"flex", alignItems:"center", borderBottom:"1px solid var(--token-colors-border-subtle)", background:"var(--token-colors-background-surface)"}, children:[(0,require$react_SLASH_jsx_runtime.jsxs)("button", 
  {onClick:() => yt("queue"), style:{padding:"8px 16px", fontSize:O.fontSize.xs, fontWeight:600, background:Tt === "queue" ? "var(--token-colors-alpha-blue-10)" : "transparent", border:"none", borderBottom:Tt === "queue" ? "2px solid var(--token-colors-accent-blue)" : "2px solid transparent", cursor:"pointer", color:Tt === "queue" ? "var(--token-colors-text-default)" : "var(--token-colors-text-muted)"}, children:["Now Playing ", (0,require$react_SLASH_jsx_runtime.jsx)(ct, {size:"sm", children:C.length})]}), 
  (0,require$react_SLASH_jsx_runtime.jsx)("button", {onClick:() => yt("labels"), style:{padding:"8px 16px", fontSize:O.fontSize.xs, fontWeight:600, background:Tt === "labels" ? "var(--token-colors-alpha-blue-10)" : "transparent", border:"none", borderBottom:Tt === "labels" ? "2px solid var(--token-colors-accent-blue)" : "2px solid transparent", cursor:"pointer", color:Tt === "labels" ? "var(--token-colors-text-default)" : "var(--token-colors-text-muted)"}, children:"\ud83c\udff7 Labels"}), (0,require$react_SLASH_jsx_runtime.jsx)("div", 
  {style:{flex:1}}), (0,require$react_SLASH_jsx_runtime.jsx)(Ke, {variant:"ghost", size:"sm", onClick:() => B(!1), title:"Collapse Queue and Labels panel", children:"Collapse Queue \x26 Labels"})]}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{flex:1, overflowY:"auto", display:"flex"}, children:Tt === "queue" ? (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{flex:1, display:"flex", flexDirection:"column"}, children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{padding:"8px 16px", 
  display:"flex", alignItems:"center", justifyContent:"space-between", borderBottom:"1px solid var(--token-colors-border-subtle)"}, children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{fontSize:O.fontSize.xs, color:"var(--token-colors-text-muted)"}, children:C.length === 0 ? "Add files from the library" : "Click \u25b6 to play from queue"}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{display:"flex", gap:4}, children:C.length > 0 && (0,require$react_SLASH_jsx_runtime.jsxs)(require$react_SLASH_jsx_runtime.Fragment, 
  {children:[(0,require$react_SLASH_jsx_runtime.jsx)("input", {type:"text", value:ft, onChange:H => St(H.target.value), placeholder:"Playlist name...", style:{width:120, padding:"2px 6px", fontSize:O.fontSize.xs, borderRadius:4, border:"1px solid var(--token-colors-border-default)", background:"var(--token-colors-background-input)"}}), (0,require$react_SLASH_jsx_runtime.jsx)("input", {type:"text", value:ht, onChange:H => xe(H.target.value), placeholder:"Publication intro...", style:{width:180, padding:"2px 6px", 
  fontSize:O.fontSize.xs, borderRadius:4, border:"1px solid var(--token-colors-border-default)", background:"var(--token-colors-background-input)"}}), (0,require$react_SLASH_jsx_runtime.jsxs)("select", {value:dt, onChange:H => gt(H.target.value), title:"Garden/CMS destination", style:{width:160, padding:"2px 6px", fontSize:O.fontSize.xs, borderRadius:4, border:"1px solid var(--token-colors-border-default)", background:"var(--token-colors-background-input)"}, children:[(0,require$react_SLASH_jsx_runtime.jsx)("option", 
  {value:"", children:"Select garden\u2026"}), de.map(H => (0,require$react_SLASH_jsx_runtime.jsx)("option", {value:H.garden_id, children:H.title || H.garden_id}, H.garden_id))]}), (0,require$react_SLASH_jsx_runtime.jsx)(Ke, {variant:"ghost", size:"sm", onClick:() => void Mt(), disabled:rt, children:rt ? "..." : "\ud83d\udcbe Save"}), (0,require$react_SLASH_jsx_runtime.jsx)(Ke, {variant:"ghost", size:"sm", onClick:() => void Pn(), disabled:ze || !dt, title:dt ? "Create a review draft in this garden CMS" : 
  "Select a garden first", children:ze ? "Drafting\u2026" : "Create garden draft"}), (0,require$react_SLASH_jsx_runtime.jsx)(Ke, {variant:"ghost", size:"sm", onClick:We, children:"\ud83d\udd00"}), (0,require$react_SLASH_jsx_runtime.jsx)(Ke, {variant:"ghost", size:"sm", onClick:Oe, children:"Clear"})]})})]}), Dt && (0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{padding:"6px 16px", borderBottom:"1px solid var(--token-colors-border-subtle)", fontSize:O.fontSize.xs, color:Dt.startsWith("Created") ? 
  "var(--token-colors-accent-green)" : Dt.startsWith("Failed") || Dt.includes("Error") ? "var(--token-colors-accent-red)" : "var(--token-colors-text-muted)"}, children:Dt}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{flex:1, overflowY:"auto", padding:"8px"}, children:C.length === 0 ? (0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{padding:24, textAlign:"center", color:"var(--token-colors-text-muted)", fontSize:O.fontSize.sm}, children:"Click + on any file to add it to the queue"}) : 
  (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{display:"flex", flexDirection:"column", gap:2}, children:[Eo > 0 && (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{padding:"6px 8px", color:"var(--token-colors-text-muted)", fontSize:O.fontSize.xs}, children:["Large queue mode: showing first ", qc.length, " of ", C.length, " tracks here. The publication draft still includes the full queue snapshot."]}), qc.map((H, pe) => (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{display:"flex", 
  flexDirection:"column", gap:4, padding:"6px 8px", borderRadius:6, fontSize:O.fontSize.sm, background:A.current === pe ? "var(--token-colors-alpha-blue-10)" : "transparent", border:A.current === pe ? "1px solid var(--token-colors-accent-blue)" : "1px solid transparent"}, children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{display:"flex", alignItems:"center", gap:8}, children:[(0,require$react_SLASH_jsx_runtime.jsx)("span", {style:{color:"var(--token-colors-text-muted)", width:20, textAlign:"center", 
  fontSize:O.fontSize.xs}, children:pe + 1}), (0,require$react_SLASH_jsx_runtime.jsx)("span", {style:{flex:1, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap"}, children:H.name}), H.duration !== void 0 && H.duration > 0 && (0,require$react_SLASH_jsx_runtime.jsx)("span", {style:{color:"var(--token-colors-text-muted)", fontSize:O.fontSize.xs, minWidth:32, textAlign:"right"}, children:SS(H.duration)}), (0,require$react_SLASH_jsx_runtime.jsx)("button", {onClick:() => it(pe), style:{background:"none", 
  border:"none", cursor:"pointer", padding:4, fontSize:14}, title:"Play now", children:"\u25b6"}), (0,require$react_SLASH_jsx_runtime.jsx)("button", {onClick:() => ke(H.id), style:{background:"none", border:"none", cursor:"pointer", padding:4, fontSize:14, color:"var(--token-colors-accent-red)"}, title:"Remove", children:"\u00d7"})]}), H.labels && H.labels.length > 0 && (0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{display:"flex", flexWrap:"wrap", gap:3, paddingLeft:28}, children:H.labels.map(Pe => 
  (0,require$react_SLASH_jsx_runtime.jsx)("span", {style:{padding:"1px 6px", borderRadius:8, fontSize:10, background:"var(--token-colors-alpha-blue-10)", color:"var(--token-colors-text-muted)"}, children:Pe}, Pe))})]}, H.id))]})})]}) : (0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{flex:1, padding:"16px", overflowY:"auto"}, children:xt ? (0,require$react_SLASH_jsx_runtime.jsxs)(require$react_SLASH_jsx_runtime.Fragment, {children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{fontSize:O.fontSize.sm, 
  fontWeight:600, marginBottom:12}, children:["Graph labels for: ", xt.name]}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{fontSize:O.fontSize.xs, color:"var(--token-colors-text-muted)", marginBottom:12}, children:"These labels apply through the same OpenPlanner graph-label pipeline used by LabelsPage."}), (Dr || Vc) && (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{padding:12, marginBottom:16, borderRadius:10, background:"var(--token-colors-background-surface)", border:"1px solid var(--token-colors-border-subtle)"}, 
  children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{fontSize:O.fontSize.xs, fontWeight:700, marginBottom:6}, children:"Heard audio description"}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{fontSize:O.fontSize.sm, lineHeight:1.45, color:"var(--token-colors-text-muted)", whiteSpace:"pre-wrap"}, children:Vc && !Dr ? "Listening for description..." : Dr == null ? void 0 : Dr.description}), _h.length > 0 && (0,require$react_SLASH_jsx_runtime.jsxs)(require$react_SLASH_jsx_runtime.Fragment, 
  {children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{fontSize:O.fontSize.xs, color:"var(--token-colors-text-muted)", marginTop:10, marginBottom:6}, children:"Suggested from description (click to create/apply as graph labels):"}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{display:"flex", flexWrap:"wrap", gap:6}, children:_h.map(H => (0,require$react_SLASH_jsx_runtime.jsxs)("button", {onClick:() => void ko(xt, H), style:{padding:"4px 8px", borderRadius:10, fontSize:O.fontSize.xs, 
  background:"var(--token-colors-alpha-white-05)", border:"1px solid var(--token-colors-border-default)", cursor:"pointer"}, children:["+ ", H]}, H))})]})]}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{display:"flex", flexWrap:"wrap", gap:6, marginBottom:16}, children:Fn.length === 0 ? (0,require$react_SLASH_jsx_runtime.jsx)("span", {style:{fontSize:O.fontSize.xs, color:"var(--token-colors-text-muted)", fontStyle:"italic"}, children:"No graph labels applied yet"}) : Fn.map(H => (0,require$react_SLASH_jsx_runtime.jsxs)("button", 
  {onClick:() => void Si(xt, H), disabled:at === H.label_id, style:{display:"inline-flex", alignItems:"center", gap:4, padding:"4px 10px", borderRadius:12, fontSize:O.fontSize.xs, background:H.color ?? "var(--token-colors-alpha-blue-10)", border:`1px solid ${H.color ?? "var(--token-colors-alpha-blue-20)"}`, color:"white", cursor:"pointer", opacity:at === H.label_id ? 0.6 : 1}, title:"Click to remove label", children:[H.emoji ? `${H.emoji} ` : "", H.label, " \u00d7"]}, H.label_id))}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", 
  {style:{display:"flex", gap:8, marginBottom:12}, children:[(0,require$react_SLASH_jsx_runtime.jsx)("input", {type:"text", value:wr, onChange:H => kn(H.target.value), placeholder:"Filter available labels...", style:{flex:1, padding:"6px 10px", fontSize:O.fontSize.sm, borderRadius:6, border:"1px solid var(--token-colors-border-default)", background:"var(--token-colors-background-input)"}}), (0,require$react_SLASH_jsx_runtime.jsx)("input", {type:"text", value:Ct, onChange:H => un(H.target.value), 
  onKeyDown:H => {
    H.key === "Enter" && Vr(xt, Ct);
  }, placeholder:"New text label...", style:{flex:1, padding:"6px 10px", fontSize:O.fontSize.sm, borderRadius:6, border:"1px solid var(--token-colors-border-default)", background:"var(--token-colors-background-input)"}}), (0,require$react_SLASH_jsx_runtime.jsx)(Ke, {size:"sm", onClick:() => void Vr(xt, Ct), disabled:jt || !Ct.trim(), children:jt ? "..." : "Create"})]}), Lt.length > 0 && (0,require$react_SLASH_jsx_runtime.jsxs)(require$react_SLASH_jsx_runtime.Fragment, {children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", 
  {style:{fontSize:O.fontSize.xs, color:"var(--token-colors-text-muted)", marginBottom:6}, children:"Toggle as many labels as you want:"}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{display:"flex", flexWrap:"wrap", gap:6}, children:Lt.filter(H => H.label.toLowerCase().includes(wr.toLowerCase())).slice(0, 60).map(H => {
    const pe = Fn.some(Pe => Pe.label_id === H.label_id);
    return (0,require$react_SLASH_jsx_runtime.jsxs)("button", {onClick:() => void Si(xt, H), disabled:at === H.label_id, style:{padding:"4px 8px", borderRadius:10, fontSize:O.fontSize.xs, background:pe ? H.color ?? "var(--token-colors-alpha-blue-20)" : "var(--token-colors-alpha-white-05)", border:`1px solid ${pe ? H.color ?? "var(--token-colors-accent-blue)" : "var(--token-colors-border-default)"}`, cursor:"pointer", color:pe ? "white" : "inherit", opacity:at === H.label_id ? 0.6 : 1}, title:H.description || 
    H.label, children:[H.emoji ? `${H.emoji} ` : "", H.label]}, H.label_id);
  })})]})]}) : (0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{padding:24, textAlign:"center", color:"var(--token-colors-text-muted)", fontSize:O.fontSize.sm}, children:"Click \ud83c\udff7 on a file in the library to edit OpenPlanner graph labels"})})})]})]}), z && (0,require$react_SLASH_jsx_runtime.jsx)("div", {onMouseDown:cm, style:{width:4, cursor:"col-resize", background:"var(--token-colors-border-default)", transition:"background 0.15s"}, onMouseEnter:H => H.currentTarget.style.background = 
  "var(--token-colors-accent-blue)", onMouseLeave:H => H.currentTarget.style.background = "var(--token-colors-border-default)"}), z ? (0,require$react_SLASH_jsx_runtime.jsx)(PG, {currentFile:c, width:ee, onShowFiles:() => W(!0), onHide:() => j(!1), launchRequest:qt, onApplySuggestedLabel:fa}) : (0,require$react_SLASH_jsx_runtime.jsx)(Fa, {label:"Studio Chat", edge:"right", onExpand:() => j(!0), title:"Show Studio Chat panel"})]});
}
let Lb = [], PN = [];
(() => {
  let t = "lc,34,7n,7,7b,19,,,,2,,2,,,20,b,1c,l,g,,2t,7,2,6,2,2,,4,z,,u,r,2j,b,1m,9,9,,o,4,,9,,3,,5,17,3,3b,f,,w,1j,,,,4,8,4,,3,7,a,2,t,,1m,,,,2,4,8,,9,,a,2,q,,2,2,1l,,4,2,4,2,2,3,3,,u,2,3,,b,2,1l,,4,5,,2,4,,k,2,m,6,,,1m,,,2,,4,8,,7,3,a,2,u,,1n,,,,c,,9,,14,,3,,1l,3,5,3,,4,7,2,b,2,t,,1m,,2,,2,,3,,5,2,7,2,b,2,s,2,1l,2,,,2,4,8,,9,,a,2,t,,20,,4,,2,3,,,8,,29,,2,7,c,8,2q,,2,9,b,6,22,2,r,,,,,,1j,e,,5,,2,5,b,,10,9,,2u,4,,6,,2,2,2,p,2,4,3,g,4,d,,2,2,6,,f,,jj,3,qa,3,t,3,t,2,u,2,1s,2,,7,8,,2,b,9,,19,3,3b,2,y,,3a,3,4,2,9,,6,3,63,2,2,,1m,,,7,,,,,2,8,6,a,2,,1c,h,1r,4,1c,7,,,5,,14,9,c,2,w,4,2,2,,3,1k,,,2,3,,,3,1m,8,2,2,48,3,,d,,7,4,,6,,3,2,5i,1m,,5,ek,,5f,x,2da,3,3x,,2o,w,fe,6,2x,2,n9w,4,,a,w,2,28,2,7k,,3,,4,,p,2,5,,47,2,q,i,d,,12,8,p,b,1a,3,1c,,2,4,2,2,13,,1v,6,2,2,2,2,c,,8,,1b,,1f,,,3,2,2,5,2,,,16,2,8,,6m,,2,,4,,fn4,,kh,g,g,g,a6,2,gt,,6a,,45,5,1ae,3,,2,5,4,14,3,4,,4l,2,fx,4,ar,2,49,b,4w,,1i,f,1k,3,1d,4,2,2,1x,3,10,5,,8,1q,,c,2,1g,9,a,4,2,,2n,3,2,,,2,6,,4g,,3,8,l,2,1l,2,,,,,m,,e,7,3,5,5f,8,2,3,,,n,,29,,2,6,,,2,,,2,,2,6j,,2,4,6,2,,2,r,2,2d,8,2,,,2,2y,,,,2,6,,,2t,3,2,4,,5,77,9,,2,6t,,a,2,,,4,,40,4,2,2,4,,w,a,14,6,2,4,8,,9,6,2,3,1a,d,,2,ba,7,,6,,,2a,m,2,7,,2,,2,3e,6,3,,,2,,7,,,20,2,3,,,,9n,2,f0b,5,1n,7,t4,,1r,4,29,,f5k,2,43q,,,3,4,5,8,8,2,7,u,4,44,3,1iz,1j,4,1e,8,,e,,m,5,,f,11s,7,,h,2,7,,2,,5,79,7,c5,4,15s,7,31,7,240,5,gx7k,2o,3k,6o".split(",").map(e => 
  e ? parseInt(e, 36) : 1);
  for (let e = 0, n = 0; e < t.length; e++) {
    (e % 2 ? PN : Lb).push(n = n + t[e]);
  }
})();
function RG(t) {
  if (t < 768) {
    return !1;
  }
  for (let e = 0, n = Lb.length;;) {
    let r = e + n >> 1;
    if (t < Lb[r]) {
      n = r;
    } else if (t >= PN[r]) {
      e = r + 1;
    } else {
      return !0;
    }
    if (e == n) {
      return !1;
    }
  }
}
function CS(t) {
  return t >= 127462 && t <= 127487;
}
const AS = 8205;
function DG(t, e, n = !0, r = !0) {
  return (n ? RN : LG)(t, e, r);
}
function RN(t, e, n) {
  if (e == t.length) {
    return e;
  }
  e && DN(t.charCodeAt(e)) && LN(t.charCodeAt(e - 1)) && e--;
  let r = Qm(t, e);
  for (e += NS(r); e < t.length;) {
    let i = Qm(t, e);
    if (r == AS || i == AS || n && RG(i)) {
      e += NS(i), r = i;
    } else if (CS(i)) {
      let s = 0, o = e - 2;
      for (; o >= 0 && CS(Qm(t, o));) {
        s++, o -= 2;
      }
      if (s % 2 == 0) {
        break;
      }
      e += 2;
    } else {
      break;
    }
  }
  return e;
}
function LG(t, e, n) {
  for (; e > 0;) {
    let r = RN(t, e - 2, n);
    if (r < e) {
      return r;
    }
    e--;
  }
  return 0;
}
function Qm(t, e) {
  let n = t.charCodeAt(e);
  if (!LN(n) || e + 1 == t.length) {
    return n;
  }
  let r = t.charCodeAt(e + 1);
  return DN(r) ? (n - 55296 << 10) + (r - 56320) + 65536 : n;
}
function DN(t) {
  return t >= 56320 && t < 57344;
}
function LN(t) {
  return t >= 55296 && t < 56320;
}
function NS(t) {
  return t < 65536 ? 1 : 2;
}
class Xt {
  lineAt(e) {
    if (e < 0 || e > this.length) {
      throw new RangeError(`Invalid position ${e} in document of length ${this.length}`);
    }
    return this.lineInner(e, !1, 1, 0);
  }
  line(e) {
    if (e < 1 || e > this.lines) {
      throw new RangeError(`Invalid line number ${e} in ${this.lines}-line document`);
    }
    return this.lineInner(e, !0, 1, 0);
  }
  replace(e, n, r) {
    [e, n] = lc(this, e, n);
    let i = [];
    return this.decompose(0, e, i, 2), r.length && r.decompose(0, r.length, i, 3), this.decompose(n, this.length, i, 1), Es.from(i, this.length - (n - e) + r.length);
  }
  append(e) {
    return this.replace(this.length, this.length, e);
  }
  slice(e, n = this.length) {
    [e, n] = lc(this, e, n);
    let r = [];
    return this.decompose(e, n, r, 0), Es.from(r, n - e);
  }
  eq(e) {
    if (e == this) {
      return !0;
    }
    if (e.length != this.length || e.lines != this.lines) {
      return !1;
    }
    let n = this.scanIdentical(e, 1), r = this.length - this.scanIdentical(e, -1), i = new Yu(this), s = new Yu(e);
    for (let o = n, a = n;;) {
      if (i.next(o), s.next(o), o = 0, i.lineBreak != s.lineBreak || i.done != s.done || i.value != s.value) {
        return !1;
      }
      if (a += i.value.length, i.done || a >= r) {
        return !0;
      }
    }
  }
  iter(e = 1) {
    return new Yu(this, e);
  }
  iterRange(e, n = this.length) {
    return new MN(this, e, n);
  }
  iterLines(e, n) {
    let r;
    if (e == null) {
      r = this.iter();
    } else {
      n == null && (n = this.lines + 1);
      let i = this.line(e).from;
      r = this.iterRange(i, Math.max(i, n == this.lines + 1 ? this.length : n <= 1 ? 0 : this.line(n - 1).to));
    }
    return new BN(r);
  }
  toString() {
    return this.sliceString(0);
  }
  toJSON() {
    let e = [];
    return this.flatten(e), e;
  }
  constructor() {
  }
  static of(e) {
    if (e.length == 0) {
      throw new RangeError("A document must have at least one line");
    }
    return e.length == 1 && !e[0] ? Xt.empty : e.length <= 32 ? new Un(e) : Es.from(Un.split(e, []));
  }
}
class Un extends Xt {
  constructor(e, n = MG(e)) {
    super(), this.text = e, this.length = n;
  }
  get lines() {
    return this.text.length;
  }
  get children() {
    return null;
  }
  lineInner(e, n, r, i) {
    for (let s = 0;; s++) {
      let o = this.text[s], a = i + o.length;
      if ((n ? r : a) >= e) {
        return new BG(i, a, r, o);
      }
      i = a + 1, r++;
    }
  }
  decompose(e, n, r, i) {
    let s = e <= 0 && n >= this.length ? this : new Un(IS(this.text, e, n), Math.min(n, this.length) - Math.max(0, e));
    if (i & 1) {
      let o = r.pop(), a = Rf(s.text, o.text.slice(), 0, s.length);
      if (a.length <= 32) {
        r.push(new Un(a, o.length + s.length));
      } else {
        let l = a.length >> 1;
        r.push(new Un(a.slice(0, l)), new Un(a.slice(l)));
      }
    } else {
      r.push(s);
    }
  }
  replace(e, n, r) {
    if (!(r instanceof Un)) {
      return super.replace(e, n, r);
    }
    [e, n] = lc(this, e, n);
    let i = Rf(this.text, Rf(r.text, IS(this.text, 0, e)), n), s = this.length + r.length - (n - e);
    return i.length <= 32 ? new Un(i, s) : Es.from(Un.split(i, []), s);
  }
  sliceString(e, n = this.length, r = `
`) {
    [e, n] = lc(this, e, n);
    let i = "";
    for (let s = 0, o = 0; s <= n && o < this.text.length; o++) {
      let a = this.text[o], l = s + a.length;
      s > e && o && (i += r), e < l && n > s && (i += a.slice(Math.max(0, e - s), n - s)), s = l + 1;
    }
    return i;
  }
  flatten(e) {
    for (let n of this.text) {
      e.push(n);
    }
  }
  scanIdentical() {
    return 0;
  }
  static split(e, n) {
    let r = [], i = -1;
    for (let s of e) {
      r.push(s), i += s.length + 1, r.length == 32 && (n.push(new Un(r, i)), r = [], i = -1);
    }
    return i > -1 && n.push(new Un(r, i)), n;
  }
}
class Es extends Xt {
  constructor(e, n) {
    super(), this.children = e, this.length = n, this.lines = 0;
    for (let r of e) {
      this.lines += r.lines;
    }
  }
  lineInner(e, n, r, i) {
    for (let s = 0;; s++) {
      let o = this.children[s], a = i + o.length, l = r + o.lines - 1;
      if ((n ? l : a) >= e) {
        return o.lineInner(e, n, r, i);
      }
      i = a + 1, r = l + 1;
    }
  }
  decompose(e, n, r, i) {
    for (let s = 0, o = 0; o <= n && s < this.children.length; s++) {
      let a = this.children[s], l = o + a.length;
      if (e <= l && n >= o) {
        let c = i & ((o <= e ? 1 : 0) | (l >= n ? 2 : 0));
        o >= e && l <= n && !c ? r.push(a) : a.decompose(e - o, n - o, r, c);
      }
      o = l + 1;
    }
  }
  replace(e, n, r) {
    if ([e, n] = lc(this, e, n), r.lines < this.lines) {
      for (let i = 0, s = 0; i < this.children.length; i++) {
        let o = this.children[i], a = s + o.length;
        if (e >= s && n <= a) {
          let l = o.replace(e - s, n - s, r), c = this.lines - o.lines + l.lines;
          if (l.lines < c >> 4 && l.lines > c >> 6) {
            let u = this.children.slice();
            return u[i] = l, new Es(u, this.length - (n - e) + r.length);
          }
          return super.replace(s, a, l);
        }
        s = a + 1;
      }
    }
    return super.replace(e, n, r);
  }
  sliceString(e, n = this.length, r = `
`) {
    [e, n] = lc(this, e, n);
    let i = "";
    for (let s = 0, o = 0; s < this.children.length && o <= n; s++) {
      let a = this.children[s], l = o + a.length;
      o > e && s && (i += r), e < l && n > o && (i += a.sliceString(e - o, n - o, r)), o = l + 1;
    }
    return i;
  }
  flatten(e) {
    for (let n of this.children) {
      n.flatten(e);
    }
  }
  scanIdentical(e, n) {
    if (!(e instanceof Es)) {
      return 0;
    }
    let r = 0, [i, s, o, a] = n > 0 ? [0, 0, this.children.length, e.children.length] : [this.children.length - 1, e.children.length - 1, -1, -1];
    for (;; i += n, s += n) {
      if (i == o || s == a) {
        return r;
      }
      let l = this.children[i], c = e.children[s];
      if (l != c) {
        return r + l.scanIdentical(c, n);
      }
      r += l.length + 1;
    }
  }
  static from(e, n = e.reduce((r, i) => r + i.length + 1, -1)) {
    let r = 0;
    for (let p of e) {
      r += p.lines;
    }
    if (r < 32) {
      let p = [];
      for (let g of e) {
        g.flatten(p);
      }
      return new Un(p, n);
    }
    let i = Math.max(32, r >> 5), s = i << 1, o = i >> 1, a = [], l = 0, c = -1, u = [];
    function h(p) {
      let g;
      if (p.lines > s && p instanceof Es) {
        for (let m of p.children) {
          h(m);
        }
      } else {
        p.lines > o && (l > o || !l) ? (f(), a.push(p)) : p instanceof Un && l && (g = u[u.length - 1]) instanceof Un && p.lines + g.lines <= 32 ? (l += p.lines, c += p.length + 1, u[u.length - 1] = new Un(g.text.concat(p.text), g.length + 1 + p.length)) : (l + p.lines > i && f(), l += p.lines, c += p.length + 1, u.push(p));
      }
    }
    function f() {
      l != 0 && (a.push(u.length == 1 ? u[0] : Es.from(u, c)), c = -1, l = u.length = 0);
    }
    for (let p of e) {
      h(p);
    }
    return f(), a.length == 1 ? a[0] : new Es(a, n);
  }
}
Xt.empty = new Un([""], 0);
function MG(t) {
  let e = -1;
  for (let n of t) {
    e += n.length + 1;
  }
  return e;
}
function Rf(t, e, n = 0, r = 1e9) {
  for (let i = 0, s = 0, o = !0; s < t.length && i <= r; s++) {
    let a = t[s], l = i + a.length;
    l >= n && (l > r && (a = a.slice(0, r - i)), i < n && (a = a.slice(n - i)), o ? (e[e.length - 1] += a, o = !1) : e.push(a)), i = l + 1;
  }
  return e;
}
function IS(t, e, n) {
  return Rf(t, [""], e, n);
}
class Yu {
  constructor(e, n = 1) {
    this.dir = n, this.done = !1, this.lineBreak = !1, this.value = "", this.nodes = [e], this.offsets = [n > 0 ? 1 : (e instanceof Un ? e.text.length : e.children.length) << 1];
  }
  nextInner(e, n) {
    for (this.done = this.lineBreak = !1;;) {
      let r = this.nodes.length - 1, i = this.nodes[r], s = this.offsets[r], o = s >> 1, a = i instanceof Un ? i.text.length : i.children.length;
      if (o == (n > 0 ? a : 0)) {
        if (r == 0) {
          return this.done = !0, this.value = "", this;
        }
        n > 0 && this.offsets[r - 1]++, this.nodes.pop(), this.offsets.pop();
      } else if ((s & 1) == (n > 0 ? 0 : 1)) {
        if (this.offsets[r] += n, e == 0) {
          return this.lineBreak = !0, this.value = `
`, this;
        }
        e--;
      } else if (i instanceof Un) {
        let l = i.text[o + (n < 0 ? -1 : 0)];
        if (this.offsets[r] += n, l.length > Math.max(0, e)) {
          return this.value = e == 0 ? l : n > 0 ? l.slice(e) : l.slice(0, l.length - e), this;
        }
        e -= l.length;
      } else {
        let l = i.children[o + (n < 0 ? -1 : 0)];
        e > l.length ? (e -= l.length, this.offsets[r] += n) : (n < 0 && this.offsets[r]--, this.nodes.push(l), this.offsets.push(n > 0 ? 1 : (l instanceof Un ? l.text.length : l.children.length) << 1));
      }
    }
  }
  next(e = 0) {
    return e < 0 && (this.nextInner(-e, -this.dir), e = this.value.length), this.nextInner(e, this.dir);
  }
}
class MN {
  constructor(e, n, r) {
    this.value = "", this.done = !1, this.cursor = new Yu(e, n > r ? -1 : 1), this.pos = n > r ? e.length : 0, this.from = Math.min(n, r), this.to = Math.max(n, r);
  }
  nextInner(e, n) {
    if (n < 0 ? this.pos <= this.from : this.pos >= this.to) {
      return this.value = "", this.done = !0, this;
    }
    e += Math.max(0, n < 0 ? this.pos - this.to : this.from - this.pos);
    let r = n < 0 ? this.pos - this.from : this.to - this.pos;
    e > r && (e = r), r -= e;
    let {value:i} = this.cursor.next(e);
    return this.pos += (i.length + e) * n, this.value = i.length <= r ? i : n < 0 ? i.slice(i.length - r) : i.slice(0, r), this.done = !this.value, this;
  }
  next(e = 0) {
    return e < 0 ? e = Math.max(e, this.from - this.pos) : e > 0 && (e = Math.min(e, this.to - this.pos)), this.nextInner(e, this.cursor.dir);
  }
  get lineBreak() {
    return this.cursor.lineBreak && this.value != "";
  }
}
class BN {
  constructor(e) {
    this.inner = e, this.afterBreak = !0, this.value = "", this.done = !1;
  }
  next(e = 0) {
    let {done:n, lineBreak:r, value:i} = this.inner.next(e);
    return n && this.afterBreak ? (this.value = "", this.afterBreak = !1) : n ? (this.done = !0, this.value = "") : r ? this.afterBreak ? this.value = "" : (this.afterBreak = !0, this.next()) : (this.value = i, this.afterBreak = !1), this;
  }
  get lineBreak() {
    return !1;
  }
}
typeof Symbol < "u" && (Xt.prototype[Symbol.iterator] = function() {
  return this.iter();
}, Yu.prototype[Symbol.iterator] = MN.prototype[Symbol.iterator] = BN.prototype[Symbol.iterator] = function() {
  return this;
});
class BG {
  constructor(e, n, r, i) {
    this.from = e, this.to = n, this.number = r, this.text = i;
  }
  get length() {
    return this.to - this.from;
  }
}
function lc(t, e, n) {
  return e = Math.max(0, Math.min(t.length, e)), [e, Math.max(e, Math.min(t.length, n))];
}
function cr(t, e, n = !0, r = !0) {
  return DG(t, e, n, r);
}
function $G(t) {
  return t >= 56320 && t < 57344;
}
function FG(t) {
  return t >= 55296 && t < 56320;
}
function aa(t, e) {
  let n = t.charCodeAt(e);
  if (!FG(n) || e + 1 == t.length) {
    return n;
  }
  let r = t.charCodeAt(e + 1);
  return $G(r) ? (n - 55296 << 10) + (r - 56320) + 65536 : n;
}
function $N(t) {
  return t <= 65535 ? String.fromCharCode(t) : (t -= 65536, String.fromCharCode((t >> 10) + 55296, (t & 1023) + 56320));
}
function Kd(t) {
  return t < 65536 ? 1 : 2;
}
const Mb = /\r\n?|\n/;
var zr = function(t) {
  return t[t.Simple = 0] = "Simple", t[t.TrackDel = 1] = "TrackDel", t[t.TrackBefore = 2] = "TrackBefore", t[t.TrackAfter = 3] = "TrackAfter", t;
}(zr || (zr = {}));
class Rs {
  constructor(e) {
    this.sections = e;
  }
  get length() {
    let e = 0;
    for (let n = 0; n < this.sections.length; n += 2) {
      e += this.sections[n];
    }
    return e;
  }
  get newLength() {
    let e = 0;
    for (let n = 0; n < this.sections.length; n += 2) {
      let r = this.sections[n + 1];
      e += r < 0 ? this.sections[n] : r;
    }
    return e;
  }
  get empty() {
    return this.sections.length == 0 || this.sections.length == 2 && this.sections[1] < 0;
  }
  iterGaps(e) {
    for (let n = 0, r = 0, i = 0; n < this.sections.length;) {
      let s = this.sections[n++], o = this.sections[n++];
      o < 0 ? (e(r, i, s), i += s) : i += o, r += s;
    }
  }
  iterChangedRanges(e, n = !1) {
    Bb(this, e, n);
  }
  get invertedDesc() {
    let e = [];
    for (let n = 0; n < this.sections.length;) {
      let r = this.sections[n++], i = this.sections[n++];
      i < 0 ? e.push(r, i) : e.push(i, r);
    }
    return new Rs(e);
  }
  composeDesc(e) {
    return this.empty ? e : e.empty ? this : FN(this, e);
  }
  mapDesc(e, n = !1) {
    return e.empty ? this : $b(this, e, n);
  }
  mapPos(e, n = -1, r = zr.Simple) {
    let i = 0, s = 0;
    for (let o = 0; o < this.sections.length;) {
      let a = this.sections[o++], l = this.sections[o++], c = i + a;
      if (l < 0) {
        if (c > e) {
          return s + (e - i);
        }
        s += a;
      } else {
        if (r != zr.Simple && c >= e && (r == zr.TrackDel && i < e && c > e || r == zr.TrackBefore && i < e || r == zr.TrackAfter && c > e)) {
          return null;
        }
        if (c > e || c == e && n < 0 && !a) {
          return e == i || n < 0 ? s : s + l;
        }
        s += l;
      }
      i = c;
    }
    if (e > i) {
      throw new RangeError(`Position ${e} is out of range for changeset of length ${i}`);
    }
    return s;
  }
  touchesRange(e, n = e) {
    for (let r = 0, i = 0; r < this.sections.length && i <= n;) {
      let s = this.sections[r++], o = this.sections[r++], a = i + s;
      if (o >= 0 && i <= n && a >= e) {
        return i < e && a > n ? "cover" : !0;
      }
      i = a;
    }
    return !1;
  }
  toString() {
    let e = "";
    for (let n = 0; n < this.sections.length;) {
      let r = this.sections[n++], i = this.sections[n++];
      e += (e ? " " : "") + r + (i >= 0 ? ":" + i : "");
    }
    return e;
  }
  toJSON() {
    return this.sections;
  }
  static fromJSON(e) {
    if (!Array.isArray(e) || e.length % 2 || e.some(n => typeof n != "number")) {
      throw new RangeError("Invalid JSON representation of ChangeDesc");
    }
    return new Rs(e);
  }
  static create(e) {
    return new Rs(e);
  }
}
class nr extends Rs {
  constructor(e, n) {
    super(e), this.inserted = n;
  }
  apply(e) {
    if (this.length != e.length) {
      throw new RangeError("Applying change set to a document with the wrong length");
    }
    return Bb(this, (n, r, i, s, o) => e = e.replace(i, i + (r - n), o), !1), e;
  }
  mapDesc(e, n = !1) {
    return $b(this, e, n, !0);
  }
  invert(e) {
    let n = this.sections.slice(), r = [];
    for (let i = 0, s = 0; i < n.length; i += 2) {
      let o = n[i], a = n[i + 1];
      if (a >= 0) {
        n[i] = a, n[i + 1] = o;
        let l = i >> 1;
        for (; r.length < l;) {
          r.push(Xt.empty);
        }
        r.push(o ? e.slice(s, s + o) : Xt.empty);
      }
      s += o;
    }
    return new nr(n, r);
  }
  compose(e) {
    return this.empty ? e : e.empty ? this : FN(this, e, !0);
  }
  map(e, n = !1) {
    return e.empty ? this : $b(this, e, n, !0);
  }
  iterChanges(e, n = !1) {
    Bb(this, e, n);
  }
  get desc() {
    return Rs.create(this.sections);
  }
  filter(e) {
    let n = [], r = [], i = [], s = new pd(this);
    e: for (let o = 0, a = 0;;) {
      let l = o == e.length ? 1e9 : e[o++];
      for (; a < l || a == l && s.len == 0;) {
        if (s.done) {
          break e;
        }
        let u = Math.min(s.len, l - a);
        Er(i, u, -1);
        let h = s.ins == -1 ? -1 : s.off == 0 ? s.ins : 0;
        Er(n, u, h), h > 0 && Wo(r, n, s.text), s.forward(u), a += u;
      }
      let c = e[o++];
      for (; a < c;) {
        if (s.done) {
          break e;
        }
        let u = Math.min(s.len, c - a);
        Er(n, u, -1), Er(i, u, s.ins == -1 ? -1 : s.off == 0 ? s.ins : 0), s.forward(u), a += u;
      }
    }
    return {changes:new nr(n, r), filtered:Rs.create(i)};
  }
  toJSON() {
    let e = [];
    for (let n = 0; n < this.sections.length; n += 2) {
      let r = this.sections[n], i = this.sections[n + 1];
      i < 0 ? e.push(r) : i == 0 ? e.push([r]) : e.push([r].concat(this.inserted[n >> 1].toJSON()));
    }
    return e;
  }
  static of(e, n, r) {
    let i = [], s = [], o = 0, a = null;
    function l(u = !1) {
      if (!u && !i.length) {
        return;
      }
      o < n && Er(i, n - o, -1);
      let h = new nr(i, s);
      a = a ? a.compose(h.map(a)) : h, i = [], s = [], o = 0;
    }
    function c(u) {
      if (Array.isArray(u)) {
        for (let h of u) {
          c(h);
        }
      } else if (u instanceof nr) {
        if (u.length != n) {
          throw new RangeError(`Mismatched change set length (got ${u.length}, expected ${n})`);
        }
        l(), a = a ? a.compose(u.map(a)) : u;
      } else {
        let {from:h, to:f = h, insert:p} = u;
        if (h > f || h < 0 || f > n) {
          throw new RangeError(`Invalid change range ${h} to ${f} (in doc of length ${n})`);
        }
        let g = p ? typeof p == "string" ? Xt.of(p.split(r || Mb)) : p : Xt.empty, m = g.length;
        if (h == f && m == 0) {
          return;
        }
        h < o && l(), h > o && Er(i, h - o, -1), Er(i, f - h, m), Wo(s, i, g), o = f;
      }
    }
    return c(e), l(!a), a;
  }
  static empty(e) {
    return new nr(e ? [e, -1] : [], []);
  }
  static fromJSON(e) {
    if (!Array.isArray(e)) {
      throw new RangeError("Invalid JSON representation of ChangeSet");
    }
    let n = [], r = [];
    for (let i = 0; i < e.length; i++) {
      let s = e[i];
      if (typeof s == "number") {
        n.push(s, -1);
      } else {
        if (!Array.isArray(s) || typeof s[0] != "number" || s.some((o, a) => a && typeof o != "string")) {
          throw new RangeError("Invalid JSON representation of ChangeSet");
        }
        if (s.length == 1) {
          n.push(s[0], 0);
        } else {
          for (; r.length < i;) {
            r.push(Xt.empty);
          }
          r[i] = Xt.of(s.slice(1)), n.push(s[0], r[i].length);
        }
      }
    }
    return new nr(n, r);
  }
  static createSet(e, n) {
    return new nr(e, n);
  }
}
function Er(t, e, n, r = !1) {
  if (e == 0 && n <= 0) {
    return;
  }
  let i = t.length - 2;
  i >= 0 && n <= 0 && n == t[i + 1] ? t[i] += e : i >= 0 && e == 0 && t[i] == 0 ? t[i + 1] += n : r ? (t[i] += e, t[i + 1] += n) : t.push(e, n);
}
function Wo(t, e, n) {
  if (n.length == 0) {
    return;
  }
  let r = e.length - 2 >> 1;
  if (r < t.length) {
    t[t.length - 1] = t[t.length - 1].append(n);
  } else {
    for (; t.length < r;) {
      t.push(Xt.empty);
    }
    t.push(n);
  }
}
function Bb(t, e, n) {
  let r = t.inserted;
  for (let i = 0, s = 0, o = 0; o < t.sections.length;) {
    let a = t.sections[o++], l = t.sections[o++];
    if (l < 0) {
      i += a, s += a;
    } else {
      let c = i, u = s, h = Xt.empty;
      for (; c += a, u += l, l && r && (h = h.append(r[o - 2 >> 1])), !(n || o == t.sections.length || t.sections[o + 1] < 0);) {
        a = t.sections[o++], l = t.sections[o++];
      }
      e(i, c, s, u, h), i = c, s = u;
    }
  }
}
function $b(t, e, n, r = !1) {
  let i = [], s = r ? [] : null, o = new pd(t), a = new pd(e);
  for (let l = -1;;) {
    if (o.done && a.len || a.done && o.len) {
      throw new Error("Mismatched change set lengths");
    }
    if (o.ins == -1 && a.ins == -1) {
      let c = Math.min(o.len, a.len);
      Er(i, c, -1), o.forward(c), a.forward(c);
    } else if (a.ins >= 0 && (o.ins < 0 || l == o.i || o.off == 0 && (a.len < o.len || a.len == o.len && !n))) {
      let c = a.len;
      for (Er(i, a.ins, -1); c;) {
        let u = Math.min(o.len, c);
        o.ins >= 0 && l < o.i && o.len <= u && (Er(i, 0, o.ins), s && Wo(s, i, o.text), l = o.i), o.forward(u), c -= u;
      }
      a.next();
    } else if (o.ins >= 0) {
      let c = 0, u = o.len;
      for (; u;) {
        if (a.ins == -1) {
          let h = Math.min(u, a.len);
          c += h, u -= h, a.forward(h);
        } else if (a.ins == 0 && a.len < u) {
          u -= a.len, a.next();
        } else {
          break;
        }
      }
      Er(i, c, l < o.i ? o.ins : 0), s && l < o.i && Wo(s, i, o.text), l = o.i, o.forward(o.len - u);
    } else {
      if (o.done && a.done) {
        return s ? nr.createSet(i, s) : Rs.create(i);
      }
      throw new Error("Mismatched change set lengths");
    }
  }
}
function FN(t, e, n = !1) {
  let r = [], i = n ? [] : null, s = new pd(t), o = new pd(e);
  for (let a = !1;;) {
    if (s.done && o.done) {
      return i ? nr.createSet(r, i) : Rs.create(r);
    }
    if (s.ins == 0) {
      Er(r, s.len, 0, a), s.next();
    } else if (o.len == 0 && !o.done) {
      Er(r, 0, o.ins, a), i && Wo(i, r, o.text), o.next();
    } else {
      if (s.done || o.done) {
        throw new Error("Mismatched change set lengths");
      }
      {
        let l = Math.min(s.len2, o.len), c = r.length;
        if (s.ins == -1) {
          let u = o.ins == -1 ? -1 : o.off ? 0 : o.ins;
          Er(r, l, u, a), i && u && Wo(i, r, o.text);
        } else {
          o.ins == -1 ? (Er(r, s.off ? 0 : s.len, l, a), i && Wo(i, r, s.textBit(l))) : (Er(r, s.off ? 0 : s.len, o.off ? 0 : o.ins, a), i && !o.off && Wo(i, r, o.text));
        }
        a = (s.ins > l || o.ins >= 0 && o.len > l) && (a || r.length > c), s.forward2(l), o.forward(l);
      }
    }
  }
}
class pd {
  constructor(e) {
    this.set = e, this.i = 0, this.next();
  }
  next() {
    let {sections:e} = this.set;
    this.i < e.length ? (this.len = e[this.i++], this.ins = e[this.i++]) : (this.len = 0, this.ins = -2), this.off = 0;
  }
  get done() {
    return this.ins == -2;
  }
  get len2() {
    return this.ins < 0 ? this.len : this.ins;
  }
  get text() {
    let {inserted:e} = this.set, n = this.i - 2 >> 1;
    return n >= e.length ? Xt.empty : e[n];
  }
  textBit(e) {
    let {inserted:n} = this.set, r = this.i - 2 >> 1;
    return r >= n.length && !e ? Xt.empty : n[r].slice(this.off, e == null ? void 0 : this.off + e);
  }
  forward(e) {
    e == this.len ? this.next() : (this.len -= e, this.off += e);
  }
  forward2(e) {
    this.ins == -1 ? this.forward(e) : e == this.ins ? this.next() : (this.ins -= e, this.off += e);
  }
}
class La {
  constructor(e, n, r) {
    this.from = e, this.to = n, this.flags = r;
  }
  get anchor() {
    return this.flags & 32 ? this.to : this.from;
  }
  get head() {
    return this.flags & 32 ? this.from : this.to;
  }
  get empty() {
    return this.from == this.to;
  }
  get assoc() {
    return this.flags & 8 ? -1 : this.flags & 16 ? 1 : 0;
  }
  get bidiLevel() {
    let e = this.flags & 7;
    return e == 7 ? null : e;
  }
  get goalColumn() {
    let e = this.flags >> 6;
    return e == 16777215 ? void 0 : e;
  }
  map(e, n = -1) {
    let r, i;
    return this.empty ? r = i = e.mapPos(this.from, n) : (r = e.mapPos(this.from, 1), i = e.mapPos(this.to, -1)), r == this.from && i == this.to ? this : new La(r, i, this.flags);
  }
  extend(e, n = e, r = 0) {
    if (e <= this.anchor && n >= this.anchor) {
      return Ce.range(e, n, void 0, void 0, r);
    }
    let i = Math.abs(e - this.anchor) > Math.abs(n - this.anchor) ? e : n;
    return Ce.range(this.anchor, i, void 0, void 0, r);
  }
  eq(e, n = !1) {
    return this.anchor == e.anchor && this.head == e.head && this.goalColumn == e.goalColumn && (!n || !this.empty || this.assoc == e.assoc);
  }
  toJSON() {
    return {anchor:this.anchor, head:this.head};
  }
  static fromJSON(e) {
    if (!e || typeof e.anchor != "number" || typeof e.head != "number") {
      throw new RangeError("Invalid JSON representation for SelectionRange");
    }
    return Ce.range(e.anchor, e.head);
  }
  static create(e, n, r) {
    return new La(e, n, r);
  }
}
class Ce {
  constructor(e, n) {
    this.ranges = e, this.mainIndex = n;
  }
  map(e, n = -1) {
    return e.empty ? this : Ce.create(this.ranges.map(r => r.map(e, n)), this.mainIndex);
  }
  eq(e, n = !1) {
    if (this.ranges.length != e.ranges.length || this.mainIndex != e.mainIndex) {
      return !1;
    }
    for (let r = 0; r < this.ranges.length; r++) {
      if (!this.ranges[r].eq(e.ranges[r], n)) {
        return !1;
      }
    }
    return !0;
  }
  get main() {
    return this.ranges[this.mainIndex];
  }
  asSingle() {
    return this.ranges.length == 1 ? this : new Ce([this.main], 0);
  }
  addRange(e, n = !0) {
    return Ce.create([e].concat(this.ranges), n ? 0 : this.mainIndex + 1);
  }
  replaceRange(e, n = this.mainIndex) {
    let r = this.ranges.slice();
    return r[n] = e, Ce.create(r, this.mainIndex);
  }
  toJSON() {
    return {ranges:this.ranges.map(e => e.toJSON()), main:this.mainIndex};
  }
  static fromJSON(e) {
    if (!e || !Array.isArray(e.ranges) || typeof e.main != "number" || e.main >= e.ranges.length) {
      throw new RangeError("Invalid JSON representation for EditorSelection");
    }
    return new Ce(e.ranges.map(n => La.fromJSON(n)), e.main);
  }
  static single(e, n = e) {
    return new Ce([Ce.range(e, n)], 0);
  }
  static create(e, n = 0) {
    if (e.length == 0) {
      throw new RangeError("A selection needs at least one range");
    }
    for (let r = 0, i = 0; i < e.length; i++) {
      let s = e[i];
      if (s.empty ? s.from <= r : s.from < r) {
        return Ce.normalized(e.slice(), n);
      }
      r = s.to;
    }
    return new Ce(e, n);
  }
  static cursor(e, n = 0, r, i) {
    return La.create(e, e, (n == 0 ? 0 : n < 0 ? 8 : 16) | (r == null ? 7 : Math.min(6, r)) | (i ?? 16777215) << 6);
  }
  static range(e, n, r, i, s) {
    let o = (r ?? 16777215) << 6 | (i == null ? 7 : Math.min(6, i));
    return !s && e != n && (s = n < e ? 1 : -1), n < e ? La.create(n, e, 48 | o) : La.create(e, n, (s ? s < 0 ? 8 : 16 : 0) | o);
  }
  static normalized(e, n = 0) {
    let r = e[n];
    e.sort((i, s) => i.from - s.from), n = e.indexOf(r);
    for (let i = 1; i < e.length; i++) {
      let s = e[i], o = e[i - 1];
      if (s.empty ? s.from <= o.to : s.from < o.to) {
        let a = o.from, l = Math.max(s.to, o.to);
        i <= n && n--, e.splice(--i, 2, s.anchor > s.head ? Ce.range(l, a) : Ce.range(a, l));
      }
    }
    return new Ce(e, n);
  }
}
function zN(t, e) {
  for (let n of t.ranges) {
    if (n.to > e) {
      throw new RangeError("Selection points outside of document");
    }
  }
}
let o1 = 0;
class et {
  constructor(e, n, r, i, s) {
    this.combine = e, this.compareInput = n, this.compare = r, this.isStatic = i, this.id = o1++, this.default = e([]), this.extensions = typeof s == "function" ? s(this) : s;
  }
  get reader() {
    return this;
  }
  static define(e = {}) {
    return new et(e.combine || (n => n), e.compareInput || ((n, r) => n === r), e.compare || (e.combine ? (n, r) => n === r : a1), !!e.static, e.enables);
  }
  of(e) {
    return new Df([], this, 0, e);
  }
  compute(e, n) {
    if (this.isStatic) {
      throw new Error("Can't compute a static facet");
    }
    return new Df(e, this, 1, n);
  }
  computeN(e, n) {
    if (this.isStatic) {
      throw new Error("Can't compute a static facet");
    }
    return new Df(e, this, 2, n);
  }
  from(e, n) {
    return n || (n = r => r), this.compute([e], r => n(r.field(e)));
  }
}
function a1(t, e) {
  return t == e || t.length == e.length && t.every((n, r) => n === e[r]);
}
class Df {
  constructor(e, n, r, i) {
    this.dependencies = e, this.facet = n, this.type = r, this.value = i, this.id = o1++;
  }
  dynamicSlot(e) {
    var n;
    let r = this.value, i = this.facet.compareInput, s = this.id, o = e[s] >> 1, a = this.type == 2, l = !1, c = !1, u = [];
    for (let h of this.dependencies) {
      h == "doc" ? l = !0 : h == "selection" ? c = !0 : ((n = e[h.id]) !== null && n !== void 0 ? n : 1) & 1 || u.push(e[h.id]);
    }
    return {create(h) {
      return h.values[o] = r(h), 1;
    }, update(h, f) {
      if (l && f.docChanged || c && (f.docChanged || f.selection) || Fb(h, u)) {
        let p = r(h);
        if (a ? !OS(p, h.values[o], i) : !i(p, h.values[o])) {
          return h.values[o] = p, 1;
        }
      }
      return 0;
    }, reconfigure:(h, f) => {
      let p, g = f.config.address[s];
      if (g != null) {
        let m = yp(f, g);
        if (this.dependencies.every(b => b instanceof et ? f.facet(b) === h.facet(b) : b instanceof ii ? f.field(b, !1) == h.field(b, !1) : !0) || (a ? OS(p = r(h), m, i) : i(p = r(h), m))) {
          return h.values[o] = m, 0;
        }
      } else {
        p = r(h);
      }
      return h.values[o] = p, 1;
    }};
  }
}
function OS(t, e, n) {
  if (t.length != e.length) {
    return !1;
  }
  for (let r = 0; r < t.length; r++) {
    if (!n(t[r], e[r])) {
      return !1;
    }
  }
  return !0;
}
function Fb(t, e) {
  let n = !1;
  for (let r of e) {
    Gu(t, r) & 1 && (n = !0);
  }
  return n;
}
function zG(t, e, n) {
  let r = n.map(l => t[l.id]), i = n.map(l => l.type), s = r.filter(l => !(l & 1)), o = t[e.id] >> 1;
  function a(l) {
    let c = [];
    for (let u = 0; u < r.length; u++) {
      let h = yp(l, r[u]);
      if (i[u] == 2) {
        for (let f of h) {
          c.push(f);
        }
      } else {
        c.push(h);
      }
    }
    return e.combine(c);
  }
  return {create(l) {
    for (let c of r) {
      Gu(l, c);
    }
    return l.values[o] = a(l), 1;
  }, update(l, c) {
    if (!Fb(l, s)) {
      return 0;
    }
    let u = a(l);
    return e.compare(u, l.values[o]) ? 0 : (l.values[o] = u, 1);
  }, reconfigure(l, c) {
    let u = Fb(l, r), h = c.config.facets[e.id], f = c.facet(e);
    if (h && !u && a1(n, h)) {
      return l.values[o] = f, 0;
    }
    let p = a(l);
    return e.compare(p, f) ? (l.values[o] = f, 0) : (l.values[o] = p, 1);
  }};
}
const Mh = et.define({static:!0});
class ii {
  constructor(e, n, r, i, s) {
    this.id = e, this.createF = n, this.updateF = r, this.compareF = i, this.spec = s, this.provides = void 0;
  }
  static define(e) {
    let n = new ii(o1++, e.create, e.update, e.compare || ((r, i) => r === i), e);
    return e.provide && (n.provides = e.provide(n)), n;
  }
  create(e) {
    let n = e.facet(Mh).find(r => r.field == this);
    return ((n == null ? void 0 : n.create) || this.createF)(e);
  }
  slot(e) {
    let n = e[this.id] >> 1;
    return {create:r => (r.values[n] = this.create(r), 1), update:(r, i) => {
      let s = r.values[n], o = this.updateF(s, i);
      return this.compareF(s, o) ? 0 : (r.values[n] = o, 1);
    }, reconfigure:(r, i) => {
      let s = r.facet(Mh), o = i.facet(Mh), a;
      return (a = s.find(l => l.field == this)) && a != o.find(l => l.field == this) ? (r.values[n] = a.create(r), 1) : i.config.address[this.id] != null ? (r.values[n] = i.field(this), 0) : (r.values[n] = this.create(r), 1);
    }};
  }
  init(e) {
    return [this, Mh.of({field:this, create:e})];
  }
  get extension() {
    return this;
  }
}
const Aa = {lowest:4, low:3, default:2, high:1, highest:0};
function eu(t) {
  return e => new HN(e, t);
}
const Xd = {highest:eu(Aa.highest), high:eu(Aa.high), default:eu(Aa.default), low:eu(Aa.low), lowest:eu(Aa.lowest)};
class HN {
  constructor(e, n) {
    this.inner = e, this.prec = n;
  }
}
class Jd {
  of(e) {
    return new zb(this, e);
  }
  reconfigure(e) {
    return Jd.reconfigure.of({compartment:this, extension:e});
  }
  get(e) {
    return e.config.compartments.get(this);
  }
}
class zb {
  constructor(e, n) {
    this.compartment = e, this.inner = n;
  }
}
class bp {
  constructor(e, n, r, i, s, o) {
    for (this.base = e, this.compartments = n, this.dynamicSlots = r, this.address = i, this.staticValues = s, this.facets = o, this.statusTemplate = []; this.statusTemplate.length < r.length;) {
      this.statusTemplate.push(0);
    }
  }
  staticFacet(e) {
    let n = this.address[e.id];
    return n == null ? e.default : this.staticValues[n >> 1];
  }
  static resolve(e, n, r) {
    let i = [], s = Object.create(null), o = new Map();
    for (let f of HG(e, n, o)) {
      f instanceof ii ? i.push(f) : (s[f.facet.id] || (s[f.facet.id] = [])).push(f);
    }
    let a = Object.create(null), l = [], c = [];
    for (let f of i) {
      a[f.id] = c.length << 1, c.push(p => f.slot(p));
    }
    let u = r == null ? void 0 : r.config.facets;
    for (let f in s) {
      let p = s[f], g = p[0].facet, m = u && u[f] || [];
      if (p.every(b => b.type == 0)) {
        if (a[g.id] = l.length << 1 | 1, a1(m, p)) {
          l.push(r.facet(g));
        } else {
          let b = g.combine(p.map(x => x.value));
          l.push(r && g.compare(b, r.facet(g)) ? r.facet(g) : b);
        }
      } else {
        for (let b of p) {
          b.type == 0 ? (a[b.id] = l.length << 1 | 1, l.push(b.value)) : (a[b.id] = c.length << 1, c.push(x => b.dynamicSlot(x)));
        }
        a[g.id] = c.length << 1, c.push(b => zG(b, g, p));
      }
    }
    let h = c.map(f => f(a));
    return new bp(e, o, h, a, l, s);
  }
}
function HG(t, e, n) {
  let r = [[], [], [], [], []], i = new Map();
  function s(o, a) {
    let l = i.get(o);
    if (l != null) {
      if (l <= a) {
        return;
      }
      let c = r[l].indexOf(o);
      c > -1 && r[l].splice(c, 1), o instanceof zb && n.delete(o.compartment);
    }
    if (i.set(o, a), Array.isArray(o)) {
      for (let c of o) {
        s(c, a);
      }
    } else if (o instanceof zb) {
      if (n.has(o.compartment)) {
        throw new RangeError("Duplicate use of compartment in extensions");
      }
      let c = e.get(o.compartment) || o.inner;
      n.set(o.compartment, c), s(c, a);
    } else if (o instanceof HN) {
      s(o.inner, o.prec);
    } else if (o instanceof ii) {
      r[a].push(o), o.provides && s(o.provides, a);
    } else if (o instanceof Df) {
      r[a].push(o), o.facet.extensions && s(o.facet.extensions, Aa.default);
    } else {
      let c = o.extension;
      if (!c) {
        throw new Error(`Unrecognized extension value in extension set (${o}). This sometimes happens because multiple instances of @codemirror/state are loaded, breaking instanceof checks.`);
      }
      s(c, a);
    }
  }
  return s(t, Aa.default), r.reduce((o, a) => o.concat(a));
}
function Gu(t, e) {
  if (e & 1) {
    return 2;
  }
  let n = e >> 1, r = t.status[n];
  if (r == 4) {
    throw new Error("Cyclic dependency between fields and/or facets");
  }
  if (r & 2) {
    return r;
  }
  t.status[n] = 4;
  let i = t.computeSlot(t, t.config.dynamicSlots[n]);
  return t.status[n] = 2 | i;
}
function yp(t, e) {
  return e & 1 ? t.config.staticValues[e >> 1] : t.values[e >> 1];
}
const UN = et.define(), Hb = et.define({combine:t => t.some(e => e), static:!0}), WN = et.define({combine:t => t.length ? t[0] : void 0, static:!0}), jN = et.define(), VN = et.define(), qN = et.define(), YN = et.define({combine:t => t.length ? t[0] : !1});
class la {
  constructor(e, n) {
    this.type = e, this.value = n;
  }
  static define() {
    return new UG();
  }
}
class UG {
  of(e) {
    return new la(this, e);
  }
}
class WG {
  constructor(e) {
    this.map = e;
  }
  of(e) {
    return new zt(this, e);
  }
}
class zt {
  constructor(e, n) {
    this.type = e, this.value = n;
  }
  map(e) {
    let n = this.type.map(this.value, e);
    return n === void 0 ? void 0 : n == this.value ? this : new zt(this.type, n);
  }
  is(e) {
    return this.type == e;
  }
  static define(e = {}) {
    return new WG(e.map || (n => n));
  }
  static mapEffects(e, n) {
    if (!e.length) {
      return e;
    }
    let r = [];
    for (let i of e) {
      let s = i.map(n);
      s && r.push(s);
    }
    return r;
  }
}
zt.reconfigure = zt.define();
zt.appendConfig = zt.define();
class ir {
  constructor(e, n, r, i, s, o) {
    this.startState = e, this.changes = n, this.selection = r, this.effects = i, this.annotations = s, this.scrollIntoView = o, this._doc = null, this._state = null, r && zN(r, n.newLength), s.some(a => a.type == ir.time) || (this.annotations = s.concat(ir.time.of(Date.now())));
  }
  static create(e, n, r, i, s, o) {
    return new ir(e, n, r, i, s, o);
  }
  get newDoc() {
    return this._doc || (this._doc = this.changes.apply(this.startState.doc));
  }
  get newSelection() {
    return this.selection || this.startState.selection.map(this.changes);
  }
  get state() {
    return this._state || this.startState.applyTransaction(this), this._state;
  }
  annotation(e) {
    for (let n of this.annotations) {
      if (n.type == e) {
        return n.value;
      }
    }
  }
  get docChanged() {
    return !this.changes.empty;
  }
  get reconfigured() {
    return this.startState.config != this.state.config;
  }
  isUserEvent(e) {
    let n = this.annotation(ir.userEvent);
    return !!(n && (n == e || n.length > e.length && n.slice(0, e.length) == e && n[e.length] == "."));
  }
}
ir.time = la.define();
ir.userEvent = la.define();
ir.addToHistory = la.define();
ir.remote = la.define();
function jG(t, e) {
  let n = [];
  for (let r = 0, i = 0;;) {
    let s, o;
    if (r < t.length && (i == e.length || e[i] >= t[r])) {
      s = t[r++], o = t[r++];
    } else if (i < e.length) {
      s = e[i++], o = e[i++];
    } else {
      return n;
    }
    !n.length || n[n.length - 1] < s ? n.push(s, o) : n[n.length - 1] < o && (n[n.length - 1] = o);
  }
}
function GN(t, e, n) {
  var r;
  let i, s, o;
  return n ? (i = e.changes, s = nr.empty(e.changes.length), o = t.changes.compose(e.changes)) : (i = e.changes.map(t.changes), s = t.changes.mapDesc(e.changes, !0), o = t.changes.compose(i)), {changes:o, selection:e.selection ? e.selection.map(s) : (r = t.selection) === null || r === void 0 ? void 0 : r.map(i), effects:zt.mapEffects(t.effects, i).concat(zt.mapEffects(e.effects, s)), annotations:t.annotations.length ? t.annotations.concat(e.annotations) : e.annotations, scrollIntoView:t.scrollIntoView || 
  e.scrollIntoView};
}
function Ub(t, e, n) {
  let r = e.selection, i = Kl(e.annotations);
  return e.userEvent && (i = i.concat(ir.userEvent.of(e.userEvent))), {changes:e.changes instanceof nr ? e.changes : nr.of(e.changes || [], n, t.facet(WN)), selection:r && (r instanceof Ce ? r : Ce.single(r.anchor, r.head)), effects:Kl(e.effects), annotations:i, scrollIntoView:!!e.scrollIntoView};
}
function QN(t, e, n) {
  let r = Ub(t, e.length ? e[0] : {}, t.doc.length);
  e.length && e[0].filter === !1 && (n = !1);
  for (let s = 1; s < e.length; s++) {
    e[s].filter === !1 && (n = !1);
    let o = !!e[s].sequential;
    r = GN(r, Ub(t, e[s], o ? r.changes.newLength : t.doc.length), o);
  }
  let i = ir.create(t, r.changes, r.selection, r.effects, r.annotations, r.scrollIntoView);
  return qG(n ? VG(i) : i);
}
function VG(t) {
  let e = t.startState, n = !0;
  for (let i of e.facet(jN)) {
    let s = i(t);
    if (s === !1) {
      n = !1;
      break;
    }
    Array.isArray(s) && (n = n === !0 ? s : jG(n, s));
  }
  if (n !== !0) {
    let i, s;
    if (n === !1) {
      s = t.changes.invertedDesc, i = nr.empty(e.doc.length);
    } else {
      let o = t.changes.filter(n);
      i = o.changes, s = o.filtered.mapDesc(o.changes).invertedDesc;
    }
    t = ir.create(e, i, t.selection && t.selection.map(s), zt.mapEffects(t.effects, s), t.annotations, t.scrollIntoView);
  }
  let r = e.facet(VN);
  for (let i = r.length - 1; i >= 0; i--) {
    let s = r[i](t);
    s instanceof ir ? t = s : Array.isArray(s) && s.length == 1 && s[0] instanceof ir ? t = s[0] : t = QN(e, Kl(s), !1);
  }
  return t;
}
function qG(t) {
  let e = t.startState, n = e.facet(qN), r = t;
  for (let i = n.length - 1; i >= 0; i--) {
    let s = n[i](t);
    s && Object.keys(s).length && (r = GN(r, Ub(e, s, t.changes.newLength), !0));
  }
  return r == t ? t : ir.create(e, t.changes, t.selection, r.effects, r.annotations, r.scrollIntoView);
}
const YG = [];
function Kl(t) {
  return t == null ? YG : Array.isArray(t) ? t : [t];
}
var An = function(t) {
  return t[t.Word = 0] = "Word", t[t.Space = 1] = "Space", t[t.Other = 2] = "Other", t;
}(An || (An = {}));
const GG = /[\u00df\u0587\u0590-\u05f4\u0600-\u06ff\u3040-\u309f\u30a0-\u30ff\u3400-\u4db5\u4e00-\u9fcc\uac00-\ud7af]/;
let Wb;
try {
  Wb = new RegExp("[\\p{Alphabetic}\\p{Number}_]", "u");
} catch {
}
function QG(t) {
  if (Wb) {
    return Wb.test(t);
  }
  for (let e = 0; e < t.length; e++) {
    let n = t[e];
    if (/\w/.test(n) || n > "\u0080" && (n.toUpperCase() != n.toLowerCase() || GG.test(n))) {
      return !0;
    }
  }
  return !1;
}
function KG(t) {
  return e => {
    if (!/\S/.test(e)) {
      return An.Space;
    }
    if (QG(e)) {
      return An.Word;
    }
    for (let n = 0; n < t.length; n++) {
      if (e.indexOf(t[n]) > -1) {
        return An.Word;
      }
    }
    return An.Other;
  };
}
class Yt {
  constructor(e, n, r, i, s, o) {
    this.config = e, this.doc = n, this.selection = r, this.values = i, this.status = e.statusTemplate.slice(), this.computeSlot = s, o && (o._state = this);
    for (let a = 0; a < this.config.dynamicSlots.length; a++) {
      Gu(this, a << 1);
    }
    this.computeSlot = null;
  }
  field(e, n = !0) {
    let r = this.config.address[e.id];
    if (r == null) {
      if (n) {
        throw new RangeError("Field is not present in this state");
      }
      return;
    }
    return Gu(this, r), yp(this, r);
  }
  update(...e) {
    return QN(this, e, !0);
  }
  applyTransaction(e) {
    let n = this.config, {base:r, compartments:i} = n;
    for (let a of e.effects) {
      a.is(Jd.reconfigure) ? (n && (i = new Map(), n.compartments.forEach((l, c) => i.set(c, l)), n = null), i.set(a.value.compartment, a.value.extension)) : a.is(zt.reconfigure) ? (n = null, r = a.value) : a.is(zt.appendConfig) && (n = null, r = Kl(r).concat(a.value));
    }
    let s;
    n ? s = e.startState.values.slice() : (n = bp.resolve(r, i, this), s = (new Yt(n, this.doc, this.selection, n.dynamicSlots.map(() => null), (l, c) => c.reconfigure(l, this), null)).values);
    let o = e.startState.facet(Hb) ? e.newSelection : e.newSelection.asSingle();
    new Yt(n, e.newDoc, o, s, (a, l) => l.update(a, e), e);
  }
  replaceSelection(e) {
    return typeof e == "string" && (e = this.toText(e)), this.changeByRange(n => ({changes:{from:n.from, to:n.to, insert:e}, range:Ce.cursor(n.from + e.length)}));
  }
  changeByRange(e) {
    let n = this.selection, r = e(n.ranges[0]), i = this.changes(r.changes), s = [r.range], o = Kl(r.effects);
    for (let a = 1; a < n.ranges.length; a++) {
      let l = e(n.ranges[a]), c = this.changes(l.changes), u = c.map(i);
      for (let f = 0; f < a; f++) {
        s[f] = s[f].map(u);
      }
      let h = i.mapDesc(c, !0);
      s.push(l.range.map(h)), i = i.compose(u), o = zt.mapEffects(o, u).concat(zt.mapEffects(Kl(l.effects), h));
    }
    return {changes:i, selection:Ce.create(s, n.mainIndex), effects:o};
  }
  changes(e = []) {
    return e instanceof nr ? e : nr.of(e, this.doc.length, this.facet(Yt.lineSeparator));
  }
  toText(e) {
    return Xt.of(e.split(this.facet(Yt.lineSeparator) || Mb));
  }
  sliceDoc(e = 0, n = this.doc.length) {
    return this.doc.sliceString(e, n, this.lineBreak);
  }
  facet(e) {
    let n = this.config.address[e.id];
    return n == null ? e.default : (Gu(this, n), yp(this, n));
  }
  toJSON(e) {
    let n = {doc:this.sliceDoc(), selection:this.selection.toJSON()};
    if (e) {
      for (let r in e) {
        let i = e[r];
        i instanceof ii && this.config.address[i.id] != null && (n[r] = i.spec.toJSON(this.field(e[r]), this));
      }
    }
    return n;
  }
  static fromJSON(e, n = {}, r) {
    if (!e || typeof e.doc != "string") {
      throw new RangeError("Invalid JSON representation for EditorState");
    }
    let i = [];
    if (r) {
      for (let s in r) {
        if (Object.prototype.hasOwnProperty.call(e, s)) {
          let o = r[s], a = e[s];
          i.push(o.init(l => o.spec.fromJSON(a, l)));
        }
      }
    }
    return Yt.create({doc:e.doc, selection:Ce.fromJSON(e.selection), extensions:n.extensions ? i.concat([n.extensions]) : i});
  }
  static create(e = {}) {
    let n = bp.resolve(e.extensions || [], new Map()), r = e.doc instanceof Xt ? e.doc : Xt.of((e.doc || "").split(n.staticFacet(Yt.lineSeparator) || Mb)), i = e.selection ? e.selection instanceof Ce ? e.selection : Ce.single(e.selection.anchor, e.selection.head) : Ce.single(0);
    return zN(i, r.length), n.staticFacet(Hb) || (i = i.asSingle()), new Yt(n, r, i, n.dynamicSlots.map(() => null), (s, o) => o.create(s), null);
  }
  get tabSize() {
    return this.facet(Yt.tabSize);
  }
  get lineBreak() {
    return this.facet(Yt.lineSeparator) || `
`;
  }
  get readOnly() {
    return this.facet(YN);
  }
  phrase(e, ...n) {
    for (let r of this.facet(Yt.phrases)) {
      if (Object.prototype.hasOwnProperty.call(r, e)) {
        e = r[e];
        break;
      }
    }
    return n.length && (e = e.replace(/\$(\$|\d*)/g, (r, i) => {
      if (i == "$") {
        return "$";
      }
      let s = +(i || 1);
      return !s || s > n.length ? r : n[s - 1];
    })), e;
  }
  languageDataAt(e, n, r = -1) {
    let i = [];
    for (let s of this.facet(UN)) {
      for (let o of s(this, n, r)) {
        Object.prototype.hasOwnProperty.call(o, e) && i.push(o[e]);
      }
    }
    return i;
  }
  charCategorizer(e) {
    let n = this.languageDataAt("wordChars", e);
    return KG(n.length ? n[0] : "");
  }
  wordAt(e) {
    let {text:n, from:r, length:i} = this.doc.lineAt(e), s = this.charCategorizer(e), o = e - r, a = e - r;
    for (; o > 0;) {
      let l = cr(n, o, !1);
      if (s(n.slice(l, o)) != An.Word) {
        break;
      }
      o = l;
    }
    for (; a < i;) {
      let l = cr(n, a);
      if (s(n.slice(a, l)) != An.Word) {
        break;
      }
      a = l;
    }
    return o == a ? null : Ce.range(o + r, a + r);
  }
}
Yt.allowMultipleSelections = Hb;
Yt.tabSize = et.define({combine:t => t.length ? t[0] : 4});
Yt.lineSeparator = WN;
Yt.readOnly = YN;
Yt.phrases = et.define({compare(t, e) {
  let n = Object.keys(t), r = Object.keys(e);
  return n.length == r.length && n.every(i => t[i] == e[i]);
}});
Yt.languageData = UN;
Yt.changeFilter = jN;
Yt.transactionFilter = VN;
Yt.transactionExtender = qN;
Jd.reconfigure = zt.define();
function mo(t, e, n = {}) {
  let r = {};
  for (let i of t) {
    for (let s of Object.keys(i)) {
      let o = i[s], a = r[s];
      if (a === void 0) {
        r[s] = o;
      } else if (!(a === o || o === void 0)) {
        if (Object.hasOwnProperty.call(n, s)) {
          r[s] = n[s](a, o);
        } else {
          throw new Error("Config merge conflict for field " + s);
        }
      }
    }
  }
  for (let i in e) {
    r[i] === void 0 && (r[i] = e[i]);
  }
  return r;
}
class Jo {
  eq(e) {
    return this == e;
  }
  range(e, n = e) {
    return jb.create(e, n, this);
  }
}
Jo.prototype.startSide = Jo.prototype.endSide = 0;
Jo.prototype.point = !1;
Jo.prototype.mapMode = zr.TrackDel;
function l1(t, e) {
  return t == e || t.constructor == e.constructor && t.eq(e);
}
let jb = class KN {
  constructor(e, n, r) {
    this.from = e, this.to = n, this.value = r;
  }
  static create(e, n, r) {
    return new KN(e, n, r);
  }
};
function Vb(t, e) {
  return t.from - e.from || t.value.startSide - e.value.startSide;
}
class c1 {
  constructor(e, n, r, i) {
    this.from = e, this.to = n, this.value = r, this.maxPoint = i;
  }
  get length() {
    return this.to[this.to.length - 1];
  }
  findIndex(e, n, r, i = 0) {
    let s = r ? this.to : this.from;
    for (let o = i, a = s.length;;) {
      if (o == a) {
        return o;
      }
      let l = o + a >> 1, c = s[l] - e || (r ? this.value[l].endSide : this.value[l].startSide) - n;
      if (l == o) {
        return c >= 0 ? o : a;
      }
      c >= 0 ? a = l : o = l + 1;
    }
  }
  between(e, n, r, i) {
    for (let s = this.findIndex(n, -1e9, !0), o = this.findIndex(r, 1e9, !1, s); s < o; s++) {
      if (i(this.from[s] + e, this.to[s] + e, this.value[s]) === !1) {
        return !1;
      }
    }
  }
  map(e, n) {
    let r = [], i = [], s = [], o = -1, a = -1;
    for (let l = 0; l < this.value.length; l++) {
      let c = this.value[l], u = this.from[l] + e, h = this.to[l] + e, f, p;
      if (u == h) {
        let g = n.mapPos(u, c.startSide, c.mapMode);
        if (g == null || (f = p = g, c.startSide != c.endSide && (p = n.mapPos(u, c.endSide), p < f))) {
          continue;
        }
      } else if (f = n.mapPos(u, c.startSide), p = n.mapPos(h, c.endSide), f > p || f == p && c.startSide > 0 && c.endSide <= 0) {
        continue;
      }
      (p - f || c.endSide - c.startSide) < 0 || (o < 0 && (o = f), c.point && (a = Math.max(a, p - f)), r.push(c), i.push(f - o), s.push(p - o));
    }
    return {mapped:r.length ? new c1(i, s, r, a) : null, pos:o};
  }
}
class $t {
  constructor(e, n, r, i) {
    this.chunkPos = e, this.chunk = n, this.nextLayer = r, this.maxPoint = i;
  }
  static create(e, n, r, i) {
    return new $t(e, n, r, i);
  }
  get length() {
    let e = this.chunk.length - 1;
    return e < 0 ? 0 : Math.max(this.chunkEnd(e), this.nextLayer.length);
  }
  get size() {
    if (this.isEmpty) {
      return 0;
    }
    let e = this.nextLayer.size;
    for (let n of this.chunk) {
      e += n.value.length;
    }
    return e;
  }
  chunkEnd(e) {
    return this.chunkPos[e] + this.chunk[e].length;
  }
  update(e) {
    let {add:n = [], sort:r = !1, filterFrom:i = 0, filterTo:s = this.length} = e, o = e.filter;
    if (n.length == 0 && !o) {
      return this;
    }
    if (r && (n = n.slice().sort(Vb)), this.isEmpty) {
      return n.length ? $t.of(n) : this;
    }
    let a = (new XN(this, null, -1)).goto(0), l = 0, c = [], u = new uo();
    for (; a.value || l < n.length;) {
      if (l < n.length && (a.from - n[l].from || a.startSide - n[l].value.startSide) >= 0) {
        let h = n[l++];
        u.addInner(h.from, h.to, h.value) || c.push(h);
      } else {
        a.rangeIndex == 1 && a.chunkIndex < this.chunk.length && (l == n.length || this.chunkEnd(a.chunkIndex) < n[l].from) && (!o || i > this.chunkEnd(a.chunkIndex) || s < this.chunkPos[a.chunkIndex]) && u.addChunk(this.chunkPos[a.chunkIndex], this.chunk[a.chunkIndex]) ? a.nextChunk() : ((!o || i > a.to || s < a.from || o(a.from, a.to, a.value)) && (u.addInner(a.from, a.to, a.value) || c.push(jb.create(a.from, a.to, a.value))), a.next());
      }
    }
    return u.finishInner(this.nextLayer.isEmpty && !c.length ? $t.empty : this.nextLayer.update({add:c, filter:o, filterFrom:i, filterTo:s}));
  }
  map(e) {
    if (e.empty || this.isEmpty) {
      return this;
    }
    let n = [], r = [], i = -1;
    for (let o = 0; o < this.chunk.length; o++) {
      let a = this.chunkPos[o], l = this.chunk[o], c = e.touchesRange(a, a + l.length);
      if (c === !1) {
        i = Math.max(i, l.maxPoint), n.push(l), r.push(e.mapPos(a));
      } else if (c === !0) {
        let {mapped:u, pos:h} = l.map(a, e);
        u && (i = Math.max(i, u.maxPoint), n.push(u), r.push(h));
      }
    }
    let s = this.nextLayer.map(e);
    return n.length == 0 ? s : new $t(r, n, s || $t.empty, i);
  }
  between(e, n, r) {
    if (!this.isEmpty) {
      for (let i = 0; i < this.chunk.length; i++) {
        let s = this.chunkPos[i], o = this.chunk[i];
        if (n >= s && e <= s + o.length && o.between(s, e - s, n - s, r) === !1) {
          return;
        }
      }
      this.nextLayer.between(e, n, r);
    }
  }
  iter(e = 0) {
    return gd.from([this]).goto(e);
  }
  get isEmpty() {
    return this.nextLayer == this;
  }
  static iter(e, n = 0) {
    return gd.from(e).goto(n);
  }
  static compare(e, n, r, i, s = -1) {
    let o = e.filter(h => h.maxPoint > 0 || !h.isEmpty && h.maxPoint >= s), a = n.filter(h => h.maxPoint > 0 || !h.isEmpty && h.maxPoint >= s), l = PS(o, a, r), c = new tu(o, l, s), u = new tu(a, l, s);
    r.iterGaps((h, f, p) => RS(c, h, u, f, p, i)), r.empty && r.length == 0 && RS(c, 0, u, 0, 0, i);
  }
  static eq(e, n, r = 0, i) {
    i == null && (i = 999999999);
    let s = e.filter(u => !u.isEmpty && n.indexOf(u) < 0), o = n.filter(u => !u.isEmpty && e.indexOf(u) < 0);
    if (s.length != o.length) {
      return !1;
    }
    if (!s.length) {
      return !0;
    }
    let a = PS(s, o), l = (new tu(s, a, 0)).goto(r), c = (new tu(o, a, 0)).goto(r);
    for (;;) {
      if (l.to != c.to || !qb(l.active, c.active) || l.point && (!c.point || !l1(l.point, c.point))) {
        return !1;
      }
      if (l.to > i) {
        return !0;
      }
      l.next(), c.next();
    }
  }
  static spans(e, n, r, i, s = -1) {
    let o = (new tu(e, null, s)).goto(n), a = n, l = o.openStart;
    for (;;) {
      let c = Math.min(o.to, r);
      if (o.point) {
        let u = o.activeForPoint(o.to), h = o.pointFrom < n ? u.length + 1 : o.point.startSide < 0 ? u.length : Math.min(u.length, l);
        i.point(a, c, o.point, u, h, o.pointRank), l = Math.min(o.openEnd(c), u.length);
      } else {
        c > a && (i.span(a, c, o.active, l), l = o.openEnd(c));
      }
      if (o.to > r) {
        return l + (o.point && o.to > r ? 1 : 0);
      }
      a = o.to, o.next();
    }
  }
  static of(e, n = !1) {
    let r = new uo();
    for (let i of e instanceof jb ? [e] : n ? XG(e) : e) {
      r.add(i.from, i.to, i.value);
    }
    return r.finish();
  }
  static join(e) {
    if (!e.length) {
      return $t.empty;
    }
    let n = e[e.length - 1];
    for (let r = e.length - 2; r >= 0; r--) {
      for (let i = e[r]; i != $t.empty; i = i.nextLayer) {
        n = new $t(i.chunkPos, i.chunk, n, Math.max(i.maxPoint, n.maxPoint));
      }
    }
    return n;
  }
}
$t.empty = new $t([], [], null, -1);
function XG(t) {
  if (t.length > 1) {
    for (let e = t[0], n = 1; n < t.length; n++) {
      let r = t[n];
      if (Vb(e, r) > 0) {
        return t.slice().sort(Vb);
      }
      e = r;
    }
  }
  return t;
}
$t.empty.nextLayer = $t.empty;
class uo {
  finishChunk(e) {
    this.chunks.push(new c1(this.from, this.to, this.value, this.maxPoint)), this.chunkPos.push(this.chunkStart), this.chunkStart = -1, this.setMaxPoint = Math.max(this.setMaxPoint, this.maxPoint), this.maxPoint = -1, e && (this.from = [], this.to = [], this.value = []);
  }
  constructor() {
    this.chunks = [], this.chunkPos = [], this.chunkStart = -1, this.last = null, this.lastFrom = -1e9, this.lastTo = -1e9, this.from = [], this.to = [], this.value = [], this.maxPoint = -1, this.setMaxPoint = -1, this.nextLayer = null;
  }
  add(e, n, r) {
    this.addInner(e, n, r) || (this.nextLayer || (this.nextLayer = new uo())).add(e, n, r);
  }
  addInner(e, n, r) {
    let i = e - this.lastTo || r.startSide - this.last.endSide;
    if (i <= 0 && (e - this.lastFrom || r.startSide - this.last.startSide) < 0) {
      throw new Error("Ranges must be added sorted by `from` position and `startSide`");
    }
    return i < 0 ? !1 : (this.from.length == 250 && this.finishChunk(!0), this.chunkStart < 0 && (this.chunkStart = e), this.from.push(e - this.chunkStart), this.to.push(n - this.chunkStart), this.last = r, this.lastFrom = e, this.lastTo = n, this.value.push(r), r.point && (this.maxPoint = Math.max(this.maxPoint, n - e)), !0);
  }
  addChunk(e, n) {
    if ((e - this.lastTo || n.value[0].startSide - this.last.endSide) < 0) {
      return !1;
    }
    this.from.length && this.finishChunk(!0), this.setMaxPoint = Math.max(this.setMaxPoint, n.maxPoint), this.chunks.push(n), this.chunkPos.push(e);
    let r = n.value.length - 1;
    return this.last = n.value[r], this.lastFrom = n.from[r] + e, this.lastTo = n.to[r] + e, !0;
  }
  finish() {
    return this.finishInner($t.empty);
  }
  finishInner(e) {
    if (this.from.length && this.finishChunk(!1), this.chunks.length == 0) {
      return e;
    }
    let n = $t.create(this.chunkPos, this.chunks, this.nextLayer ? this.nextLayer.finishInner(e) : e, this.setMaxPoint);
    return this.from = null, n;
  }
}
function PS(t, e, n) {
  let r = new Map();
  for (let s of t) {
    for (let o = 0; o < s.chunk.length; o++) {
      s.chunk[o].maxPoint <= 0 && r.set(s.chunk[o], s.chunkPos[o]);
    }
  }
  let i = new Set();
  for (let s of e) {
    for (let o = 0; o < s.chunk.length; o++) {
      let a = r.get(s.chunk[o]);
      a != null && (n ? n.mapPos(a) : a) == s.chunkPos[o] && !(n != null && n.touchesRange(a, a + s.chunk[o].length)) && i.add(s.chunk[o]);
    }
  }
  return i;
}
class XN {
  constructor(e, n, r, i = 0) {
    this.layer = e, this.skip = n, this.minPoint = r, this.rank = i;
  }
  get startSide() {
    return this.value ? this.value.startSide : 0;
  }
  get endSide() {
    return this.value ? this.value.endSide : 0;
  }
  goto(e, n = -1e9) {
    return this.chunkIndex = this.rangeIndex = 0, this.gotoInner(e, n, !1), this;
  }
  gotoInner(e, n, r) {
    for (; this.chunkIndex < this.layer.chunk.length;) {
      let i = this.layer.chunk[this.chunkIndex];
      if (!(this.skip && this.skip.has(i) || this.layer.chunkEnd(this.chunkIndex) < e || i.maxPoint < this.minPoint)) {
        break;
      }
      this.chunkIndex++, r = !1;
    }
    if (this.chunkIndex < this.layer.chunk.length) {
      let i = this.layer.chunk[this.chunkIndex].findIndex(e - this.layer.chunkPos[this.chunkIndex], n, !0);
      (!r || this.rangeIndex < i) && this.setRangeIndex(i);
    }
    this.next();
  }
  forward(e, n) {
    (this.to - e || this.endSide - n) < 0 && this.gotoInner(e, n, !0);
  }
  next() {
    for (;;) {
      if (this.chunkIndex == this.layer.chunk.length) {
        this.from = this.to = 1e9, this.value = null;
        break;
      } else {
        let e = this.layer.chunkPos[this.chunkIndex], n = this.layer.chunk[this.chunkIndex], r = e + n.from[this.rangeIndex];
        if (this.from = r, this.to = e + n.to[this.rangeIndex], this.value = n.value[this.rangeIndex], this.setRangeIndex(this.rangeIndex + 1), this.minPoint < 0 || this.value.point && this.to - this.from >= this.minPoint) {
          break;
        }
      }
    }
  }
  setRangeIndex(e) {
    if (e == this.layer.chunk[this.chunkIndex].value.length) {
      if (this.chunkIndex++, this.skip) {
        for (; this.chunkIndex < this.layer.chunk.length && this.skip.has(this.layer.chunk[this.chunkIndex]);) {
          this.chunkIndex++;
        }
      }
      this.rangeIndex = 0;
    } else {
      this.rangeIndex = e;
    }
  }
  nextChunk() {
    this.chunkIndex++, this.rangeIndex = 0, this.next();
  }
  compare(e) {
    return this.from - e.from || this.startSide - e.startSide || this.rank - e.rank || this.to - e.to || this.endSide - e.endSide;
  }
}
class gd {
  constructor(e) {
    this.heap = e;
  }
  static from(e, n = null, r = -1) {
    let i = [];
    for (let s = 0; s < e.length; s++) {
      for (let o = e[s]; !o.isEmpty; o = o.nextLayer) {
        o.maxPoint >= r && i.push(new XN(o, n, r, s));
      }
    }
    return i.length == 1 ? i[0] : new gd(i);
  }
  get startSide() {
    return this.value ? this.value.startSide : 0;
  }
  goto(e, n = -1e9) {
    for (let r of this.heap) {
      r.goto(e, n);
    }
    for (let r = this.heap.length >> 1; r >= 0; r--) {
      Km(this.heap, r);
    }
    return this.next(), this;
  }
  forward(e, n) {
    for (let r of this.heap) {
      r.forward(e, n);
    }
    for (let r = this.heap.length >> 1; r >= 0; r--) {
      Km(this.heap, r);
    }
    (this.to - e || this.value.endSide - n) < 0 && this.next();
  }
  next() {
    if (this.heap.length == 0) {
      this.from = this.to = 1e9, this.value = null, this.rank = -1;
    } else {
      let e = this.heap[0];
      this.from = e.from, this.to = e.to, this.value = e.value, this.rank = e.rank, e.value && e.next(), Km(this.heap, 0);
    }
  }
}
function Km(t, e) {
  for (let n = t[e];;) {
    let r = (e << 1) + 1;
    if (r >= t.length) {
      break;
    }
    let i = t[r];
    if (r + 1 < t.length && i.compare(t[r + 1]) >= 0 && (i = t[r + 1], r++), n.compare(i) < 0) {
      break;
    }
    t[r] = n, t[e] = i, e = r;
  }
}
class tu {
  constructor(e, n, r) {
    this.minPoint = r, this.active = [], this.activeTo = [], this.activeRank = [], this.minActive = -1, this.point = null, this.pointFrom = 0, this.pointRank = 0, this.to = -1e9, this.endSide = 0, this.openStart = -1, this.cursor = gd.from(e, n, r);
  }
  goto(e, n = -1e9) {
    return this.cursor.goto(e, n), this.active.length = this.activeTo.length = this.activeRank.length = 0, this.minActive = -1, this.to = e, this.endSide = n, this.openStart = -1, this.next(), this;
  }
  forward(e, n) {
    for (; this.minActive > -1 && (this.activeTo[this.minActive] - e || this.active[this.minActive].endSide - n) < 0;) {
      this.removeActive(this.minActive);
    }
    this.cursor.forward(e, n);
  }
  removeActive(e) {
    Bh(this.active, e), Bh(this.activeTo, e), Bh(this.activeRank, e), this.minActive = DS(this.active, this.activeTo);
  }
  addActive(e) {
    let n = 0, {value:r, to:i, rank:s} = this.cursor;
    for (; n < this.activeRank.length && (s - this.activeRank[n] || i - this.activeTo[n]) > 0;) {
      n++;
    }
    $h(this.active, n, r), $h(this.activeTo, n, i), $h(this.activeRank, n, s), e && $h(e, n, this.cursor.from), this.minActive = DS(this.active, this.activeTo);
  }
  next() {
    let e = this.to, n = this.point;
    this.point = null;
    let r = this.openStart < 0 ? [] : null;
    for (;;) {
      let i = this.minActive;
      if (i > -1 && (this.activeTo[i] - this.cursor.from || this.active[i].endSide - this.cursor.startSide) < 0) {
        if (this.activeTo[i] > e) {
          this.to = this.activeTo[i], this.endSide = this.active[i].endSide;
          break;
        }
        this.removeActive(i), r && Bh(r, i);
      } else if (this.cursor.value) {
        if (this.cursor.from > e) {
          this.to = this.cursor.from, this.endSide = this.cursor.startSide;
          break;
        } else {
          let s = this.cursor.value;
          if (!s.point) {
            this.addActive(r), this.cursor.next();
          } else if (n && this.cursor.to == this.to && this.cursor.from < this.cursor.to) {
            this.cursor.next();
          } else {
            this.point = s, this.pointFrom = this.cursor.from, this.pointRank = this.cursor.rank, this.to = this.cursor.to, this.endSide = s.endSide, this.cursor.next(), this.forward(this.to, this.endSide);
            break;
          }
        }
      } else {
        this.to = this.endSide = 1e9;
        break;
      }
    }
    if (r) {
      this.openStart = 0;
      for (let i = r.length - 1; i >= 0 && r[i] < e; i--) {
        this.openStart++;
      }
    }
  }
  activeForPoint(e) {
    if (!this.active.length) {
      return this.active;
    }
    let n = [];
    for (let r = this.active.length - 1; r >= 0 && !(this.activeRank[r] < this.pointRank); r--) {
      (this.activeTo[r] > e || this.activeTo[r] == e && this.active[r].endSide >= this.point.endSide) && n.push(this.active[r]);
    }
    return n.reverse();
  }
  openEnd(e) {
    let n = 0;
    for (let r = this.activeTo.length - 1; r >= 0 && this.activeTo[r] > e; r--) {
      n++;
    }
    return n;
  }
}
function RS(t, e, n, r, i, s) {
  t.goto(e), n.goto(r);
  let o = r + i, a = r, l = r - e, c = !!s.boundChange;
  for (let u = !1;;) {
    let h = t.to + l - n.to, f = h || t.endSide - n.endSide, p = f < 0 ? t.to + l : n.to, g = Math.min(p, o);
    if (t.point || n.point ? (t.point && n.point && l1(t.point, n.point) && qb(t.activeForPoint(t.to), n.activeForPoint(n.to)) || s.comparePoint(a, g, t.point, n.point), u = !1) : (u && s.boundChange(a), g > a && !qb(t.active, n.active) && s.compareRange(a, g, t.active, n.active), c && g < o && (h || t.openEnd(p) != n.openEnd(p)) && (u = !0)), p > o) {
      break;
    }
    a = p, f <= 0 && t.next(), f >= 0 && n.next();
  }
}
function qb(t, e) {
  if (t.length != e.length) {
    return !1;
  }
  for (let n = 0; n < t.length; n++) {
    if (t[n] != e[n] && !l1(t[n], e[n])) {
      return !1;
    }
  }
  return !0;
}
function Bh(t, e) {
  for (let n = e, r = t.length - 1; n < r; n++) {
    t[n] = t[n + 1];
  }
  t.pop();
}
function $h(t, e, n) {
  for (let r = t.length - 1; r >= e; r--) {
    t[r + 1] = t[r];
  }
  t[e] = n;
}
function DS(t, e) {
  let n = -1, r = 1e9;
  for (let i = 0; i < e.length; i++) {
    (e[i] - r || t[i].endSide - t[n].endSide) < 0 && (n = i, r = e[i]);
  }
  return n;
}
function Ac(t, e, n = t.length) {
  let r = 0;
  for (let i = 0; i < n && i < t.length;) {
    t.charCodeAt(i) == 9 ? (r += e - r % e, i++) : (r++, i = cr(t, i));
  }
  return r;
}
function Yb(t, e, n, r) {
  for (let i = 0, s = 0;;) {
    if (s >= e) {
      return i;
    }
    if (i == t.length) {
      break;
    }
    s += t.charCodeAt(i) == 9 ? n - s % n : 1, i = cr(t, i);
  }
  return r === !0 ? -1 : t.length;
}
const Gb = "\u037c", LS = typeof Symbol > "u" ? "__" + Gb : Symbol.for(Gb), Qb = typeof Symbol > "u" ? "__styleSet" + Math.floor(Math.random() * 1e8) : Symbol("styleSet"), MS = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : {};
class Zo {
  constructor(e, n) {
    this.rules = [];
    let {finish:r} = n || {};
    function i(o) {
      return /^@/.test(o) ? [o] : o.split(/,\s*/);
    }
    function s(o, a, l, c) {
      let u = [], h = /^@(\w+)\b/.exec(o[0]), f = h && h[1] == "keyframes";
      if (h && a == null) {
        return l.push(o[0] + ";");
      }
      for (let p in a) {
        let g = a[p];
        if (/&/.test(p)) {
          s(p.split(/,\s*/).map(m => o.map(b => m.replace(/&/, b))).reduce((m, b) => m.concat(b)), g, l);
        } else if (g && typeof g == "object") {
          if (!h) {
            throw new RangeError("The value of a property (" + p + ") should be a primitive value.");
          }
          s(i(p), g, u, f);
        } else {
          g != null && u.push(p.replace(/_.*/, "").replace(/[A-Z]/g, m => "-" + m.toLowerCase()) + ": " + g + ";");
        }
      }
      (u.length || f) && l.push((r && !h && !c ? o.map(r) : o).join(", ") + " {" + u.join(" ") + "}");
    }
    for (let o in e) {
      s(i(o), e[o], this.rules);
    }
  }
  getRules() {
    return this.rules.join(`
`);
  }
  static newName() {
    let e = MS[LS] || 1;
    return MS[LS] = e + 1, Gb + e.toString(36);
  }
  static mount(e, n, r) {
    let i = e[Qb], s = r && r.nonce;
    i ? s && i.setNonce(s) : i = new JG(e, s), i.mount(Array.isArray(n) ? n : [n], e);
  }
}
let BS = new Map();
class JG {
  constructor(e, n) {
    let r = e.ownerDocument || e, i = r.defaultView;
    if (!e.head && e.adoptedStyleSheets && i.CSSStyleSheet) {
      let s = BS.get(r);
      if (s) {
        return e[Qb] = s;
      }
      this.sheet = new i.CSSStyleSheet(), BS.set(r, this);
    } else {
      this.styleTag = r.createElement("style"), n && this.styleTag.setAttribute("nonce", n);
    }
    this.modules = [], e[Qb] = this;
  }
  mount(e, n) {
    let r = this.sheet, i = 0, s = 0;
    for (let o = 0; o < e.length; o++) {
      let a = e[o], l = this.modules.indexOf(a);
      if (l < s && l > -1 && (this.modules.splice(l, 1), s--, l = -1), l == -1) {
        if (this.modules.splice(s++, 0, a), r) {
          for (let c = 0; c < a.rules.length; c++) {
            r.insertRule(a.rules[c], i++);
          }
        }
      } else {
        for (; s < l;) {
          i += this.modules[s++].rules.length;
        }
        i += a.rules.length, s++;
      }
    }
    if (r) {
      n.adoptedStyleSheets.indexOf(this.sheet) < 0 && (n.adoptedStyleSheets = [this.sheet, ...n.adoptedStyleSheets]);
    } else {
      let o = "";
      for (let l = 0; l < this.modules.length; l++) {
        o += this.modules[l].getRules() + `
`;
      }
      this.styleTag.textContent = o;
      let a = n.head || n;
      this.styleTag.parentNode != a && a.insertBefore(this.styleTag, a.firstChild);
    }
  }
  setNonce(e) {
    this.styleTag && this.styleTag.getAttribute("nonce") != e && this.styleTag.setAttribute("nonce", e);
  }
}
var ea = {8:"Backspace", 9:"Tab", 10:"Enter", 12:"NumLock", 13:"Enter", 16:"Shift", 17:"Control", 18:"Alt", 20:"CapsLock", 27:"Escape", 32:" ", 33:"PageUp", 34:"PageDown", 35:"End", 36:"Home", 37:"ArrowLeft", 38:"ArrowUp", 39:"ArrowRight", 40:"ArrowDown", 44:"PrintScreen", 45:"Insert", 46:"Delete", 59:";", 61:"\x3d", 91:"Meta", 92:"Meta", 106:"*", 107:"+", 108:",", 109:"-", 110:".", 111:"/", 144:"NumLock", 145:"ScrollLock", 160:"Shift", 161:"Shift", 162:"Control", 163:"Control", 164:"Alt", 165:"Alt", 
173:"-", 186:";", 187:"\x3d", 188:",", 189:"-", 190:".", 191:"/", 192:"`", 219:"[", 220:"\\", 221:"]", 222:"'"}, md = {48:")", 49:"!", 50:"@", 51:"#", 52:"$", 53:"%", 54:"^", 55:"\x26", 56:"*", 57:"(", 59:":", 61:"+", 173:"_", 186:":", 187:"+", 188:"\x3c", 189:"_", 190:"\x3e", 191:"?", 192:"~", 219:"{", 220:"|", 221:"}", 222:'"'}, ZG = typeof navigator < "u" && /Mac/.test(navigator.platform), eQ = typeof navigator < "u" && /MSIE \d|Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
for (var pr = 0; pr < 10; pr++) {
  ea[48 + pr] = ea[96 + pr] = String(pr);
}
for (var pr = 1; pr <= 24; pr++) {
  ea[pr + 111] = "F" + pr;
}
for (var pr = 65; pr <= 90; pr++) {
  ea[pr] = String.fromCharCode(pr + 32), md[pr] = String.fromCharCode(pr);
}
for (var Xm in ea) {
  md.hasOwnProperty(Xm) || (md[Xm] = ea[Xm]);
}
function tQ(t) {
  var e = ZG && t.metaKey && t.shiftKey && !t.ctrlKey && !t.altKey || eQ && t.shiftKey && t.key && t.key.length == 1 || t.key == "Unidentified", n = !e && t.key || (t.shiftKey ? md : ea)[t.keyCode] || t.key || "Unidentified";
  return n == "Esc" && (n = "Escape"), n == "Del" && (n = "Delete"), n == "Left" && (n = "ArrowLeft"), n == "Up" && (n = "ArrowUp"), n == "Right" && (n = "ArrowRight"), n == "Down" && (n = "ArrowDown"), n;
}
function ln() {
  var t = arguments[0];
  typeof t == "string" && (t = document.createElement(t));
  var e = 1, n = arguments[1];
  if (n && typeof n == "object" && n.nodeType == null && !Array.isArray(n)) {
    for (var r in n) {
      if (Object.prototype.hasOwnProperty.call(n, r)) {
        var i = n[r];
        typeof i == "string" ? t.setAttribute(r, i) : i != null && (t[r] = i);
      }
    }
    e++;
  }
  for (; e < arguments.length; e++) {
    JN(t, arguments[e]);
  }
  return t;
}
function JN(t, e) {
  if (typeof e == "string") {
    t.appendChild(document.createTextNode(e));
  } else if (e != null) {
    if (e.nodeType != null) {
      t.appendChild(e);
    } else if (Array.isArray(e)) {
      for (var n = 0; n < e.length; n++) {
        JN(t, e[n]);
      }
    } else {
      throw new RangeError("Unsupported child node: " + e);
    }
  }
}
let Mr = typeof navigator < "u" ? navigator : {userAgent:"", vendor:"", platform:""}, Kb = typeof document < "u" ? document : {documentElement:{style:{}}};
const Xb = /Edge\/(\d+)/.exec(Mr.userAgent), ZN = /MSIE \d/.test(Mr.userAgent), Jb = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(Mr.userAgent), Rg = !!(ZN || Jb || Xb), $S = !Rg && /gecko\/(\d+)/i.test(Mr.userAgent), Jm = !Rg && /Chrome\/(\d+)/.exec(Mr.userAgent), FS = "webkitFontSmoothing" in Kb.documentElement.style, Zb = !Rg && /Apple Computer/.test(Mr.vendor), zS = Zb && (/Mobile\/\w+/.test(Mr.userAgent) || Mr.maxTouchPoints > 2);
var Ze = {mac:zS || /Mac/.test(Mr.platform), windows:/Win/.test(Mr.platform), linux:/Linux|X11/.test(Mr.platform), ie:Rg, ie_version:ZN ? Kb.documentMode || 6 : Jb ? +Jb[1] : Xb ? +Xb[1] : 0, gecko:$S, gecko_version:$S ? +(/Firefox\/(\d+)/.exec(Mr.userAgent) || [0, 0])[1] : 0, chrome:!!Jm, chrome_version:Jm ? +Jm[1] : 0, ios:zS, android:/Android\b/.test(Mr.userAgent), webkit:FS, webkit_version:FS ? +(/\bAppleWebKit\/(\d+)/.exec(Mr.userAgent) || [0, 0])[1] : 0, safari:Zb, safari_version:Zb ? +(/\bVersion\/(\d+(\.\d+)?)/.exec(Mr.userAgent) || 
[0, 0])[1] : 0, tabSize:Kb.documentElement.style.tabSize != null ? "tab-size" : "-moz-tab-size"};
function u1(t, e) {
  for (let n in t) {
    n == "class" && e.class ? e.class += " " + t.class : n == "style" && e.style ? e.style += ";" + t.style : e[n] = t[n];
  }
  return e;
}
const xp = Object.create(null);
function d1(t, e, n) {
  if (t == e) {
    return !0;
  }
  t || (t = xp), e || (e = xp);
  let r = Object.keys(t), i = Object.keys(e);
  if (r.length - 0 != i.length - 0) {
    return !1;
  }
  for (let s of r) {
    if (s != n && (i.indexOf(s) == -1 || t[s] !== e[s])) {
      return !1;
    }
  }
  return !0;
}
function nQ(t, e) {
  for (let n = t.attributes.length - 1; n >= 0; n--) {
    let r = t.attributes[n].name;
    e[r] == null && t.removeAttribute(r);
  }
  for (let n in e) {
    let r = e[n];
    n == "style" ? t.style.cssText = r : t.getAttribute(n) != r && t.setAttribute(n, r);
  }
}
function HS(t, e, n) {
  let r = !1;
  if (e) {
    for (let i in e) {
      n && i in n || (r = !0, i == "style" ? t.style.cssText = "" : t.removeAttribute(i));
    }
  }
  if (n) {
    for (let i in n) {
      e && e[i] == n[i] || (r = !0, i == "style" ? t.style.cssText = n[i] : t.setAttribute(i, n[i]));
    }
  }
  return r;
}
function rQ(t) {
  let e = Object.create(null);
  for (let n = 0; n < t.attributes.length; n++) {
    let r = t.attributes[n];
    e[r.name] = r.value;
  }
  return e;
}
class Fs {
  eq(e) {
    return !1;
  }
  updateDOM(e, n, r) {
    return !1;
  }
  compare(e) {
    return this == e || this.constructor == e.constructor && this.eq(e);
  }
  get estimatedHeight() {
    return -1;
  }
  get lineBreaks() {
    return 0;
  }
  ignoreEvent(e) {
    return !0;
  }
  coordsAt(e, n, r) {
    return null;
  }
  get isHidden() {
    return !1;
  }
  get editable() {
    return !1;
  }
  destroy(e) {
  }
}
var br = function(t) {
  return t[t.Text = 0] = "Text", t[t.WidgetBefore = 1] = "WidgetBefore", t[t.WidgetAfter = 2] = "WidgetAfter", t[t.WidgetRange = 3] = "WidgetRange", t;
}(br || (br = {}));
class pt extends Jo {
  constructor(e, n, r, i) {
    super(), this.startSide = e, this.endSide = n, this.widget = r, this.spec = i;
  }
  get heightRelevant() {
    return !1;
  }
  static mark(e) {
    return new Zd(e);
  }
  static widget(e) {
    let n = Math.max(-1e4, Math.min(1e4, e.side || 0)), r = !!e.block;
    return n += r && !e.inlineOrder ? n > 0 ? 3e8 : -4e8 : n > 0 ? 1e8 : -1e8, new Za(e, n, n, r, e.widget || null, !1);
  }
  static replace(e) {
    let n = !!e.block, r, i;
    if (e.isBlockGap) {
      r = -5e8, i = 4e8;
    } else {
      let {start:s, end:o} = eI(e, n);
      r = (s ? n ? -3e8 : -1 : 5e8) - 1, i = (o ? n ? 2e8 : 1 : -6e8) + 1;
    }
    return new Za(e, r, i, n, e.widget || null, !0);
  }
  static line(e) {
    return new eh(e);
  }
  static set(e, n = !1) {
    return $t.of(e, n);
  }
  hasHeight() {
    return this.widget ? this.widget.estimatedHeight > -1 : !1;
  }
}
pt.none = $t.empty;
class Zd extends pt {
  constructor(e) {
    let {start:n, end:r} = eI(e);
    super(n ? -1 : 5e8, r ? 1 : -6e8, null, e), this.tagName = e.tagName || "span", this.attrs = e.class && e.attributes ? u1(e.attributes, {class:e.class}) : e.class ? {class:e.class} : e.attributes || xp;
  }
  eq(e) {
    return this == e || e instanceof Zd && this.tagName == e.tagName && d1(this.attrs, e.attrs);
  }
  range(e, n = e) {
    if (e >= n) {
      throw new RangeError("Mark decorations may not be empty");
    }
    return super.range(e, n);
  }
}
Zd.prototype.point = !1;
class eh extends pt {
  constructor(e) {
    super(-2e8, -2e8, null, e);
  }
  eq(e) {
    return e instanceof eh && this.spec.class == e.spec.class && d1(this.spec.attributes, e.spec.attributes);
  }
  range(e, n = e) {
    if (n != e) {
      throw new RangeError("Line decoration ranges must be zero-length");
    }
    return super.range(e, n);
  }
}
eh.prototype.mapMode = zr.TrackBefore;
eh.prototype.point = !0;
class Za extends pt {
  constructor(e, n, r, i, s, o) {
    super(n, r, s, e), this.block = i, this.isReplace = o, this.mapMode = i ? n <= 0 ? zr.TrackBefore : zr.TrackAfter : zr.TrackDel;
  }
  get type() {
    return this.startSide != this.endSide ? br.WidgetRange : this.startSide <= 0 ? br.WidgetBefore : br.WidgetAfter;
  }
  get heightRelevant() {
    return this.block || !!this.widget && (this.widget.estimatedHeight >= 5 || this.widget.lineBreaks > 0);
  }
  eq(e) {
    return e instanceof Za && iQ(this.widget, e.widget) && this.block == e.block && this.startSide == e.startSide && this.endSide == e.endSide;
  }
  range(e, n = e) {
    if (this.isReplace && (e > n || e == n && this.startSide > 0 && this.endSide <= 0)) {
      throw new RangeError("Invalid range for replacement decoration");
    }
    if (!this.isReplace && n != e) {
      throw new RangeError("Widget decorations can only have zero-length ranges");
    }
    return super.range(e, n);
  }
}
Za.prototype.point = !0;
function eI(t, e = !1) {
  let {inclusiveStart:n, inclusiveEnd:r} = t;
  return n == null && (n = t.inclusive), r == null && (r = t.inclusive), {start:n ?? e, end:r ?? e};
}
function iQ(t, e) {
  return t == e || !!(t && e && t.compare(e));
}
function Xl(t, e, n, r = 0) {
  let i = n.length - 1;
  i >= 0 && n[i] + r >= t ? n[i] = Math.max(n[i], e) : n.push(t, e);
}
class bd extends Jo {
  constructor(e, n, r) {
    super(), this.tagName = e, this.attributes = n, this.rank = r;
  }
  eq(e) {
    return e == this || e instanceof bd && this.tagName == e.tagName && d1(this.attributes, e.attributes);
  }
  static create(e) {
    return new bd(e.tagName, e.attributes || xp, e.rank == null ? 50 : Math.max(0, Math.min(e.rank, 100)));
  }
  static set(e, n = !1) {
    return $t.of(e, n);
  }
}
bd.prototype.startSide = bd.prototype.endSide = -1;
function yd(t) {
  let e;
  return t.nodeType == 11 ? e = t.getSelection ? t : t.ownerDocument : e = t, e.getSelection();
}
function ey(t, e) {
  return e ? t == e || t.contains(e.nodeType != 1 ? e.parentNode : e) : !1;
}
function Qu(t, e) {
  if (!e.anchorNode) {
    return !1;
  }
  try {
    return ey(t, e.anchorNode);
  } catch {
    return !1;
  }
}
function Ku(t) {
  return t.nodeType == 3 ? vd(t, 0, t.nodeValue.length).getClientRects() : t.nodeType == 1 ? t.getClientRects() : [];
}
function Xu(t, e, n, r) {
  return n ? US(t, e, n, r, -1) || US(t, e, n, r, 1) : !1;
}
function ta(t) {
  for (var e = 0;; e++) {
    if (t = t.previousSibling, !t) {
      return e;
    }
  }
}
function vp(t) {
  return t.nodeType == 1 && /^(DIV|P|LI|UL|OL|BLOCKQUOTE|DD|DT|H\d|SECTION|PRE)$/.test(t.nodeName);
}
function US(t, e, n, r, i) {
  for (;;) {
    if (t == n && e == r) {
      return !0;
    }
    if (e == (i < 0 ? 0 : ho(t))) {
      if (t.nodeName == "DIV") {
        return !1;
      }
      let s = t.parentNode;
      if (!s || s.nodeType != 1) {
        return !1;
      }
      e = ta(t) + (i < 0 ? 0 : 1), t = s;
    } else if (t.nodeType == 1) {
      if (t = t.childNodes[e + (i < 0 ? -1 : 0)], t.nodeType == 1 && t.contentEditable == "false") {
        return !1;
      }
      e = i < 0 ? ho(t) : 0;
    } else {
      return !1;
    }
  }
}
function ho(t) {
  return t.nodeType == 3 ? t.nodeValue.length : t.childNodes.length;
}
function xd(t, e) {
  let n = e ? t.left : t.right;
  return {left:n, right:n, top:t.top, bottom:t.bottom};
}
function sQ(t) {
  let e = t.visualViewport;
  return e ? {left:0, right:e.width, top:0, bottom:e.height} : {left:0, right:t.innerWidth, top:0, bottom:t.innerHeight};
}
function tI(t, e) {
  let n = e.width / t.offsetWidth, r = e.height / t.offsetHeight;
  return (n > 0.995 && n < 1.005 || !isFinite(n) || Math.abs(e.width - t.offsetWidth) < 1) && (n = 1), (r > 0.995 && r < 1.005 || !isFinite(r) || Math.abs(e.height - t.offsetHeight) < 1) && (r = 1), {scaleX:n, scaleY:r};
}
function oQ(t, e, n, r, i, s, o, a) {
  let l = t.ownerDocument, c = l.defaultView || window;
  for (let u = t, h = !1; u && !h;) {
    if (u.nodeType == 1) {
      let f, p = u == l.body, g = 1, m = 1;
      if (p) {
        f = sQ(c);
      } else {
        if (/^(fixed|sticky)$/.test(getComputedStyle(u).position) && (h = !0), u.scrollHeight <= u.clientHeight && u.scrollWidth <= u.clientWidth) {
          u = u.assignedSlot || u.parentNode;
          continue;
        }
        let w = u.getBoundingClientRect();
        ({scaleX:g, scaleY:m} = tI(u, w)), f = {left:w.left, right:w.left + u.clientWidth * g, top:w.top, bottom:w.top + u.clientHeight * m};
      }
      let b = 0, x = 0;
      if (i == "nearest") {
        e.top < f.top + o ? (x = e.top - (f.top + o), n > 0 && e.bottom > f.bottom + x && (x = e.bottom - f.bottom + o)) : e.bottom > f.bottom - o && (x = e.bottom - f.bottom + o, n < 0 && e.top - x < f.top && (x = e.top - (f.top + o)));
      } else {
        let w = e.bottom - e.top, v = f.bottom - f.top;
        x = (i == "center" && w <= v ? e.top + w / 2 - v / 2 : i == "start" || i == "center" && n < 0 ? e.top - o : e.bottom - v + o) - f.top;
      }
      if (r == "nearest" ? e.left < f.left + s ? (b = e.left - (f.left + s), n > 0 && e.right > f.right + b && (b = e.right - f.right + s)) : e.right > f.right - s && (b = e.right - f.right + s, n < 0 && e.left < f.left + b && (b = e.left - (f.left + s))) : b = (r == "center" ? e.left + (e.right - e.left) / 2 - (f.right - f.left) / 2 : r == "start" == a ? e.left - s : e.right - (f.right - f.left) + s) - f.left, b || x) {
        if (p) {
          c.scrollBy(b, x);
        } else {
          let w = 0, v = 0;
          if (x) {
            let T = u.scrollTop;
            u.scrollTop += x / m, v = (u.scrollTop - T) * m;
          }
          if (b) {
            let T = u.scrollLeft;
            u.scrollLeft += b / g, w = (u.scrollLeft - T) * g;
          }
          e = {left:e.left - w, top:e.top - v, right:e.right - w, bottom:e.bottom - v}, w && Math.abs(w - b) < 1 && (r = "nearest"), v && Math.abs(v - x) < 1 && (i = "nearest");
        }
      }
      if (p) {
        break;
      }
      (e.top < f.top || e.bottom > f.bottom || e.left < f.left || e.right > f.right) && (e = {left:Math.max(e.left, f.left), right:Math.min(e.right, f.right), top:Math.max(e.top, f.top), bottom:Math.min(e.bottom, f.bottom)}), u = u.assignedSlot || u.parentNode;
    } else if (u.nodeType == 11) {
      u = u.host;
    } else {
      break;
    }
  }
}
function nI(t, e = !0) {
  let n = t.ownerDocument, r = null, i = null;
  for (let s = t.parentNode; s && !(s == n.body || (!e || r) && i);) {
    if (s.nodeType == 1) {
      !i && s.scrollHeight > s.clientHeight && (i = s), e && !r && s.scrollWidth > s.clientWidth && (r = s), s = s.assignedSlot || s.parentNode;
    } else if (s.nodeType == 11) {
      s = s.host;
    } else {
      break;
    }
  }
  return {x:r, y:i};
}
class aQ {
  constructor() {
    this.anchorNode = null, this.anchorOffset = 0, this.focusNode = null, this.focusOffset = 0;
  }
  eq(e) {
    return this.anchorNode == e.anchorNode && this.anchorOffset == e.anchorOffset && this.focusNode == e.focusNode && this.focusOffset == e.focusOffset;
  }
  setRange(e) {
    let {anchorNode:n, focusNode:r} = e;
    this.set(n, Math.min(e.anchorOffset, n ? ho(n) : 0), r, Math.min(e.focusOffset, r ? ho(r) : 0));
  }
  set(e, n, r, i) {
    this.anchorNode = e, this.anchorOffset = n, this.focusNode = r, this.focusOffset = i;
  }
}
let va = null;
Ze.safari && Ze.safari_version >= 26 && (va = !1);
function rI(t) {
  if (t.setActive) {
    return t.setActive();
  }
  if (va) {
    return t.focus(va);
  }
  let e = [];
  for (let n = t; n && (e.push(n, n.scrollTop, n.scrollLeft), n != n.ownerDocument); n = n.parentNode) {
  }
  if (t.focus(va == null ? {get preventScroll() {
    return va = {preventScroll:!0}, !0;
  }} : void 0), !va) {
    va = !1;
    for (let n = 0; n < e.length;) {
      let r = e[n++], i = e[n++], s = e[n++];
      r.scrollTop != i && (r.scrollTop = i), r.scrollLeft != s && (r.scrollLeft = s);
    }
  }
}
let WS;
function vd(t, e, n = e) {
  let r = WS || (WS = document.createRange());
  return r.setEnd(t, n), r.setStart(t, e), r;
}
function Jl(t, e, n, r) {
  let i = {key:e, code:e, keyCode:n, which:n, cancelable:!0};
  r && ({altKey:i.altKey, ctrlKey:i.ctrlKey, shiftKey:i.shiftKey, metaKey:i.metaKey} = r);
  let s = new KeyboardEvent("keydown", i);
  s.synthetic = !0, t.dispatchEvent(s);
  let o = new KeyboardEvent("keyup", i);
  return o.synthetic = !0, t.dispatchEvent(o), s.defaultPrevented || o.defaultPrevented;
}
function lQ(t) {
  for (; t;) {
    if (t && (t.nodeType == 9 || t.nodeType == 11 && t.host)) {
      return t;
    }
    t = t.assignedSlot || t.parentNode;
  }
  return null;
}
function cQ(t, e) {
  let n = e.focusNode, r = e.focusOffset;
  if (!n || e.anchorNode != n || e.anchorOffset != r) {
    return !1;
  }
  for (r = Math.min(r, ho(n));;) {
    if (r) {
      if (n.nodeType != 1) {
        return !1;
      }
      let i = n.childNodes[r - 1];
      i.contentEditable == "false" ? r-- : (n = i, r = ho(n));
    } else {
      if (n == t) {
        return !0;
      }
      r = ta(n), n = n.parentNode;
    }
  }
}
function iI(t) {
  return t instanceof Window ? t.pageYOffset > Math.max(0, t.document.documentElement.scrollHeight - t.innerHeight - 4) : t.scrollTop > Math.max(1, t.scrollHeight - t.clientHeight - 4);
}
function sI(t, e) {
  for (let n = t, r = e;;) {
    if (n.nodeType == 3 && r > 0) {
      return {node:n, offset:r};
    }
    if (n.nodeType == 1 && r > 0) {
      if (n.contentEditable == "false") {
        return null;
      }
      n = n.childNodes[r - 1], r = ho(n);
    } else if (n.parentNode && !vp(n)) {
      r = ta(n), n = n.parentNode;
    } else {
      return null;
    }
  }
}
function oI(t, e) {
  for (let n = t, r = e;;) {
    if (n.nodeType == 3 && r < n.nodeValue.length) {
      return {node:n, offset:r};
    }
    if (n.nodeType == 1 && r < n.childNodes.length) {
      if (n.contentEditable == "false") {
        return null;
      }
      n = n.childNodes[r], r = 0;
    } else if (n.parentNode && !vp(n)) {
      r = ta(n) + 1, n = n.parentNode;
    } else {
      return null;
    }
  }
}
class Xi {
  constructor(e, n, r = !0) {
    this.node = e, this.offset = n, this.precise = r;
  }
  static before(e, n) {
    return new Xi(e.parentNode, ta(e), n);
  }
  static after(e, n) {
    return new Xi(e.parentNode, ta(e) + 1, n);
  }
}
var xn = function(t) {
  return t[t.LTR = 0] = "LTR", t[t.RTL = 1] = "RTL", t;
}(xn || (xn = {}));
const el = xn.LTR, h1 = xn.RTL;
function aI(t) {
  let e = [];
  for (let n = 0; n < t.length; n++) {
    e.push(1 << +t[n]);
  }
  return e;
}
const uQ = aI("88888888888888888888888888888888888666888888787833333333337888888000000000000000000000000008888880000000000000000000000000088888888888888888888888888888888888887866668888088888663380888308888800000000000000000000000800000000000000000000000000000008"), dQ = aI("4444448826627288999999999992222222222222222222222222222222222222222222222229999999999999999999994444444444644222822222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222999999949999999229989999223333333333"), 
ty = Object.create(null), ms = [];
for (let t of ["()", "[]", "{}"]) {
  let e = t.charCodeAt(0), n = t.charCodeAt(1);
  ty[e] = n, ty[n] = -e;
}
function lI(t) {
  return t <= 247 ? uQ[t] : 1424 <= t && t <= 1524 ? 2 : 1536 <= t && t <= 1785 ? dQ[t - 1536] : 1774 <= t && t <= 2220 ? 4 : 8192 <= t && t <= 8204 ? 256 : 64336 <= t && t <= 65023 ? 4 : 1;
}
const hQ = /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac\ufb50-\ufdff]/;
class Cs {
  get dir() {
    return this.level % 2 ? h1 : el;
  }
  constructor(e, n, r) {
    this.from = e, this.to = n, this.level = r;
  }
  side(e, n) {
    return this.dir == n == e ? this.to : this.from;
  }
  forward(e, n) {
    return e == (this.dir == n);
  }
  static find(e, n, r, i) {
    let s = -1;
    for (let o = 0; o < e.length; o++) {
      let a = e[o];
      if (a.from <= n && a.to >= n) {
        if (a.level == r) {
          return o;
        }
        (s < 0 || (i != 0 ? i < 0 ? a.from < n : a.to > n : e[s].level > a.level)) && (s = o);
      }
    }
    if (s < 0) {
      throw new RangeError("Index out of range");
    }
    return s;
  }
}
function cI(t, e) {
  if (t.length != e.length) {
    return !1;
  }
  for (let n = 0; n < t.length; n++) {
    let r = t[n], i = e[n];
    if (r.from != i.from || r.to != i.to || r.direction != i.direction || !cI(r.inner, i.inner)) {
      return !1;
    }
  }
  return !0;
}
const fn = [];
function fQ(t, e, n, r, i) {
  for (let s = 0; s <= r.length; s++) {
    let o = s ? r[s - 1].to : e, a = s < r.length ? r[s].from : n, l = s ? 256 : i;
    for (let c = o, u = l, h = l; c < a; c++) {
      let f = lI(t.charCodeAt(c));
      f == 512 ? f = u : f == 8 && h == 4 && (f = 16), fn[c] = f == 4 ? 2 : f, f & 7 && (h = f), u = f;
    }
    for (let c = o, u = l, h = l; c < a; c++) {
      let f = fn[c];
      if (f == 128) {
        c < a - 1 && u == fn[c + 1] && u & 24 ? f = fn[c] = u : fn[c] = 256;
      } else if (f == 64) {
        let p = c + 1;
        for (; p < a && fn[p] == 64;) {
          p++;
        }
        let g = c && u == 8 || p < n && fn[p] == 8 ? h == 1 ? 1 : 8 : 256;
        for (let m = c; m < p; m++) {
          fn[m] = g;
        }
        c = p - 1;
      } else {
        f == 8 && h == 1 && (fn[c] = 1);
      }
      u = f, f & 7 && (h = f);
    }
  }
}
function pQ(t, e, n, r, i) {
  let s = i == 1 ? 2 : 1;
  for (let o = 0, a = 0, l = 0; o <= r.length; o++) {
    let c = o ? r[o - 1].to : e, u = o < r.length ? r[o].from : n;
    for (let h = c, f, p, g; h < u; h++) {
      if (p = ty[f = t.charCodeAt(h)]) {
        if (p < 0) {
          for (let m = a - 3; m >= 0; m -= 3) {
            if (ms[m + 1] == -p) {
              let b = ms[m + 2], x = b & 2 ? i : b & 4 ? b & 1 ? s : i : 0;
              x && (fn[h] = fn[ms[m]] = x), a = m;
              break;
            }
          }
        } else {
          if (ms.length == 189) {
            break;
          }
          ms[a++] = h, ms[a++] = f, ms[a++] = l;
        }
      } else if ((g = fn[h]) == 2 || g == 1) {
        let m = g == i;
        l = m ? 0 : 1;
        for (let b = a - 3; b >= 0; b -= 3) {
          let x = ms[b + 2];
          if (x & 2) {
            break;
          }
          if (m) {
            ms[b + 2] |= 2;
          } else {
            if (x & 4) {
              break;
            }
            ms[b + 2] |= 4;
          }
        }
      }
    }
  }
}
function gQ(t, e, n, r) {
  for (let i = 0, s = r; i <= n.length; i++) {
    let o = i ? n[i - 1].to : t, a = i < n.length ? n[i].from : e;
    for (let l = o; l < a;) {
      let c = fn[l];
      if (c == 256) {
        let u = l + 1;
        for (;;) {
          if (u == a) {
            if (i == n.length) {
              break;
            }
            u = n[i++].to, a = i < n.length ? n[i].from : e;
          } else if (fn[u] == 256) {
            u++;
          } else {
            break;
          }
        }
        let h = s == 1, f = (u < e ? fn[u] : r) == 1, p = h == f ? h ? 1 : 2 : r;
        for (let g = u, m = i, b = m ? n[m - 1].to : t; g > l;) {
          g == b && (g = n[--m].from, b = m ? n[m - 1].to : t), fn[--g] = p;
        }
        l = u;
      } else {
        s = c, l++;
      }
    }
  }
}
function ny(t, e, n, r, i, s, o) {
  let a = r % 2 ? 2 : 1;
  if (r % 2 == i % 2) {
    for (let l = e, c = 0; l < n;) {
      let u = !0, h = !1;
      if (c == s.length || l < s[c].from) {
        let m = fn[l];
        m != a && (u = !1, h = m == 16);
      }
      let f = !u && a == 1 ? [] : null, p = u ? r : r + 1, g = l;
      e: for (;;) {
        if (c < s.length && g == s[c].from) {
          if (h) {
            break e;
          }
          let m = s[c];
          if (!u) {
            for (let b = m.to, x = c + 1;;) {
              if (b == n) {
                break e;
              }
              if (x < s.length && s[x].from == b) {
                b = s[x++].to;
              } else {
                if (fn[b] == a) {
                  break e;
                }
                break;
              }
            }
          }
          if (c++, f) {
            f.push(m);
          } else {
            m.from > l && o.push(new Cs(l, m.from, p));
            let b = m.direction == el != !(p % 2);
            ry(t, b ? r + 1 : r, i, m.inner, m.from, m.to, o), l = m.to;
          }
          g = m.to;
        } else {
          if (g == n || (u ? fn[g] != a : fn[g] == a)) {
            break;
          }
          g++;
        }
      }
      f ? ny(t, l, g, r + 1, i, f, o) : l < g && o.push(new Cs(l, g, p)), l = g;
    }
  } else {
    for (let l = n, c = s.length; l > e;) {
      let u = !0, h = !1;
      if (!c || l > s[c - 1].to) {
        let m = fn[l - 1];
        m != a && (u = !1, h = m == 16);
      }
      let f = !u && a == 1 ? [] : null, p = u ? r : r + 1, g = l;
      e: for (;;) {
        if (c && g == s[c - 1].to) {
          if (h) {
            break e;
          }
          let m = s[--c];
          if (!u) {
            for (let b = m.from, x = c;;) {
              if (b == e) {
                break e;
              }
              if (x && s[x - 1].to == b) {
                b = s[--x].from;
              } else {
                if (fn[b - 1] == a) {
                  break e;
                }
                break;
              }
            }
          }
          if (f) {
            f.push(m);
          } else {
            m.to < l && o.push(new Cs(m.to, l, p));
            let b = m.direction == el != !(p % 2);
            ry(t, b ? r + 1 : r, i, m.inner, m.from, m.to, o), l = m.from;
          }
          g = m.from;
        } else {
          if (g == e || (u ? fn[g - 1] != a : fn[g - 1] == a)) {
            break;
          }
          g--;
        }
      }
      f ? ny(t, g, l, r + 1, i, f, o) : g < l && o.push(new Cs(g, l, p)), l = g;
    }
  }
}
function ry(t, e, n, r, i, s, o) {
  let a = e % 2 ? 2 : 1;
  fQ(t, i, s, r, a), pQ(t, i, s, r, a), gQ(i, s, r, a), ny(t, i, s, e, n, r, o);
}
function mQ(t, e, n) {
  if (!t) {
    return [new Cs(0, 0, e == h1 ? 1 : 0)];
  }
  if (e == el && !n.length && !hQ.test(t)) {
    return uI(t.length);
  }
  if (n.length) {
    for (; t.length > fn.length;) {
      fn[fn.length] = 256;
    }
  }
  let r = [], i = e == el ? 0 : 1;
  return ry(t, i, i, n, 0, t.length, r), r;
}
function uI(t) {
  return [new Cs(0, t, 0)];
}
let dI = "";
function bQ(t, e, n, r, i) {
  var s;
  let o = r.head - t.from, a = Cs.find(e, o, (s = r.bidiLevel) !== null && s !== void 0 ? s : -1, r.assoc), l = e[a], c = l.side(i, n);
  if (o == c) {
    let f = a += i ? 1 : -1;
    if (f < 0 || f >= e.length) {
      return null;
    }
    l = e[a = f], o = l.side(!i, n), c = l.side(i, n);
  }
  let u = cr(t.text, o, l.forward(i, n));
  (u < l.from || u > l.to) && (u = c), dI = t.text.slice(Math.min(o, u), Math.max(o, u));
  let h = a == (i ? e.length - 1 : 0) ? null : e[a + (i ? 1 : -1)];
  return h && u == c && h.level + (i ? 0 : 1) < l.level ? Ce.cursor(h.side(!i, n) + t.from, h.forward(i, n) ? 1 : -1, h.level) : Ce.cursor(u + t.from, l.forward(i, n) ? -1 : 1, l.level);
}
function yQ(t, e, n) {
  for (let r = e; r < n; r++) {
    let i = lI(t.charCodeAt(r));
    if (i == 1) {
      return el;
    }
    if (i == 2 || i == 4) {
      return h1;
    }
  }
  return el;
}
const hI = et.define(), fI = et.define(), pI = et.define(), gI = et.define(), iy = et.define(), mI = et.define(), bI = et.define(), f1 = et.define(), p1 = et.define(), yI = et.define({combine:t => t.some(e => e)}), xI = et.define({combine:t => t.some(e => e)}), vI = et.define();
class Zl {
  constructor(e, n, r, i, s, o = !1) {
    this.range = e, this.y = n, this.x = r, this.yMargin = i, this.xMargin = s, this.isSnapshot = o;
  }
  map(e) {
    return e.empty ? this : new Zl(this.range.map(e), this.y, this.x, this.yMargin, this.xMargin, this.isSnapshot);
  }
  clip(e) {
    return this.range.to <= e.doc.length ? this : new Zl(Ce.cursor(e.doc.length), this.y, this.x, this.yMargin, this.xMargin, this.isSnapshot);
  }
}
const Fh = zt.define({map:(t, e) => t.map(e)}), wI = zt.define();
function Pi(t, e, n) {
  let r = t.facet(gI);
  r.length ? r[0](e) : window.onerror && window.onerror(String(e), n, void 0, void 0, e) || (n ? console.error(n + ":", e) : console.error(e));
}
const no = et.define({combine:t => t.length ? t[0] : !0});
let xQ = 0;
const Vl = et.define({combine(t) {
  return t.filter((e, n) => {
    for (let r = 0; r < n; r++) {
      if (t[r].plugin == e.plugin) {
        return !1;
      }
    }
    return !0;
  });
}});
class Kn {
  constructor(e, n, r, i, s) {
    this.id = e, this.create = n, this.domEventHandlers = r, this.domEventObservers = i, this.baseExtensions = s(this), this.extension = this.baseExtensions.concat(Vl.of({plugin:this, arg:void 0}));
  }
  of(e) {
    return this.baseExtensions.concat(Vl.of({plugin:this, arg:e}));
  }
  static define(e, n) {
    const {eventHandlers:r, eventObservers:i, provide:s, decorations:o} = n || {};
    return new Kn(xQ++, e, r, i, a => {
      let l = [];
      return o && l.push(Dg.of(c => {
        let u = c.plugin(a);
        return u ? o(u) : pt.none;
      })), s && l.push(s(a)), l;
    });
  }
  static fromClass(e, n) {
    return Kn.define((r, i) => new e(r, i), n);
  }
}
class Zm {
  constructor(e) {
    this.spec = e, this.mustUpdate = null, this.value = null;
  }
  get plugin() {
    return this.spec && this.spec.plugin;
  }
  update(e) {
    if (this.value) {
      if (this.mustUpdate) {
        let n = this.mustUpdate;
        if (this.mustUpdate = null, this.value.update) {
          try {
            this.value.update(n);
          } catch (r) {
            if (Pi(n.state, r, "CodeMirror plugin crashed"), this.value.destroy) {
              try {
                this.value.destroy();
              } catch {
              }
            }
            this.deactivate();
          }
        }
      }
    } else if (this.spec) {
      try {
        this.value = this.spec.plugin.create(e, this.spec.arg);
      } catch (n) {
        Pi(e.state, n, "CodeMirror plugin crashed"), this.deactivate();
      }
    }
    return this;
  }
  destroy(e) {
    var n;
    if (!((n = this.value) === null || n === void 0) && n.destroy) {
      try {
        this.value.destroy();
      } catch (r) {
        Pi(e.state, r, "CodeMirror plugin crashed");
      }
    }
  }
  deactivate() {
    this.spec = this.value = null;
  }
}
const _I = et.define(), g1 = et.define(), Dg = et.define(), SI = et.define(), m1 = et.define(), th = et.define(), kI = et.define();
function jS(t, e) {
  let n = t.state.facet(kI);
  if (!n.length) {
    return n;
  }
  let r = n.map(s => s instanceof Function ? s(t) : s), i = [];
  return $t.spans(r, e.from, e.to, {point() {
  }, span(s, o, a, l) {
    let c = s - e.from, u = o - e.from, h = i;
    for (let f = a.length - 1; f >= 0; f--, l--) {
      let p = a[f].spec.bidiIsolate, g;
      if (p == null && (p = yQ(e.text, c, u)), l > 0 && h.length && (g = h[h.length - 1]).to == c && g.direction == p) {
        g.to = u, h = g.inner;
      } else {
        let m = {from:c, to:u, direction:p, inner:[]};
        h.push(m), h = m.inner;
      }
    }
  }}), i;
}
const EI = et.define();
function b1(t) {
  let e = 0, n = 0, r = 0, i = 0;
  for (let s of t.state.facet(EI)) {
    let o = s(t);
    o && (o.left != null && (e = Math.max(e, o.left)), o.right != null && (n = Math.max(n, o.right)), o.top != null && (r = Math.max(r, o.top)), o.bottom != null && (i = Math.max(i, o.bottom)));
  }
  return {left:e, right:n, top:r, bottom:i};
}
const hu = et.define();
class Ri {
  constructor(e, n, r, i) {
    this.fromA = e, this.toA = n, this.fromB = r, this.toB = i;
  }
  join(e) {
    return new Ri(Math.min(this.fromA, e.fromA), Math.max(this.toA, e.toA), Math.min(this.fromB, e.fromB), Math.max(this.toB, e.toB));
  }
  addToSet(e) {
    let n = e.length, r = this;
    for (; n > 0; n--) {
      let i = e[n - 1];
      if (!(i.fromA > r.toA)) {
        if (i.toA < r.fromA) {
          break;
        }
        r = r.join(i), e.splice(n - 1, 1);
      }
    }
    return e.splice(n, 0, r), e;
  }
  static extendWithRanges(e, n) {
    if (n.length == 0) {
      return e;
    }
    let r = [];
    for (let i = 0, s = 0, o = 0;;) {
      let a = i < e.length ? e[i].fromB : 1e9, l = s < n.length ? n[s] : 1e9, c = Math.min(a, l);
      if (c == 1e9) {
        break;
      }
      let u = c + o, h = c, f = u;
      for (;;) {
        if (s < n.length && n[s] <= h) {
          let p = n[s + 1];
          s += 2, h = Math.max(h, p);
          for (let g = i; g < e.length && e[g].fromB <= h; g++) {
            o = e[g].toA - e[g].toB;
          }
          f = Math.max(f, p + o);
        } else if (i < e.length && e[i].fromB <= h) {
          let p = e[i++];
          h = Math.max(h, p.toB), f = Math.max(f, p.toA), o = p.toA - p.toB;
        } else {
          break;
        }
      }
      r.push(new Ri(u, f, c, h));
    }
    return r;
  }
}
class wp {
  constructor(e, n, r) {
    this.view = e, this.state = n, this.transactions = r, this.flags = 0, this.startState = e.state, this.changes = nr.empty(this.startState.doc.length);
    for (let s of r) {
      this.changes = this.changes.compose(s.changes);
    }
    let i = [];
    this.changes.iterChangedRanges((s, o, a, l) => i.push(new Ri(s, o, a, l))), this.changedRanges = i;
  }
  static create(e, n, r) {
    return new wp(e, n, r);
  }
  get viewportChanged() {
    return (this.flags & 4) > 0;
  }
  get viewportMoved() {
    return (this.flags & 8) > 0;
  }
  get heightChanged() {
    return (this.flags & 2) > 0;
  }
  get geometryChanged() {
    return this.docChanged || (this.flags & 18) > 0;
  }
  get focusChanged() {
    return (this.flags & 1) > 0;
  }
  get docChanged() {
    return !this.changes.empty;
  }
  get selectionSet() {
    return this.transactions.some(e => e.selection);
  }
  get empty() {
    return this.flags == 0 && this.transactions.length == 0;
  }
}
const vQ = [];
class Bn {
  constructor(e, n, r = 0) {
    this.dom = e, this.length = n, this.flags = r, this.parent = null, e.cmTile = this;
  }
  get breakAfter() {
    return this.flags & 1;
  }
  get children() {
    return vQ;
  }
  isWidget() {
    return !1;
  }
  get isHidden() {
    return !1;
  }
  isComposite() {
    return !1;
  }
  isLine() {
    return !1;
  }
  isText() {
    return !1;
  }
  isBlock() {
    return !1;
  }
  get domAttrs() {
    return null;
  }
  sync(e) {
    if (this.flags |= 2, this.flags & 4) {
      this.flags &= -5;
      let n = this.domAttrs;
      n && nQ(this.dom, n);
    }
  }
  toString() {
    return this.constructor.name + (this.children.length ? `(${this.children})` : "") + (this.breakAfter ? "#" : "");
  }
  destroy() {
    this.parent = null;
  }
  setDOM(e) {
    this.dom = e, e.cmTile = this;
  }
  get posAtStart() {
    return this.parent ? this.parent.posBefore(this) : 0;
  }
  get posAtEnd() {
    return this.posAtStart + this.length;
  }
  posBefore(e, n = this.posAtStart) {
    let r = n;
    for (let i of this.children) {
      if (i == e) {
        return r;
      }
      r += i.length + i.breakAfter;
    }
    throw new RangeError("Invalid child in posBefore");
  }
  posAfter(e) {
    return this.posBefore(e) + e.length;
  }
  covers(e) {
    return !0;
  }
  coordsIn(e, n) {
    return null;
  }
  domPosFor(e, n) {
    let r = ta(this.dom), i = this.length ? e > 0 : n > 0;
    return new Xi(this.parent.dom, r + (i ? 1 : 0), e == 0 || e == this.length);
  }
  markDirty(e) {
    this.flags &= -3, e && (this.flags |= 4), this.parent && this.parent.flags & 2 && this.parent.markDirty(!1);
  }
  get overrideDOMText() {
    return null;
  }
  get root() {
    for (let e = this; e; e = e.parent) {
      if (e instanceof Mg) {
        return e;
      }
    }
    return null;
  }
  static get(e) {
    return e.cmTile;
  }
}
class Lg extends Bn {
  constructor(e) {
    super(e, 0), this._children = [];
  }
  isComposite() {
    return !0;
  }
  get children() {
    return this._children;
  }
  get lastChild() {
    return this.children.length ? this.children[this.children.length - 1] : null;
  }
  append(e) {
    this.children.push(e), e.parent = this;
  }
  sync(e) {
    if (this.flags & 2) {
      return;
    }
    super.sync(e);
    let n = this.dom, r = null, i, s = (e == null ? void 0 : e.node) == n ? e : null, o = 0;
    for (let a of this.children) {
      if (a.sync(e), o += a.length + a.breakAfter, i = r ? r.nextSibling : n.firstChild, s && i != a.dom && (s.written = !0), a.dom.parentNode == n) {
        for (; i && i != a.dom;) {
          i = VS(i);
        }
      } else {
        n.insertBefore(a.dom, i);
      }
      r = a.dom;
    }
    for (i = r ? r.nextSibling : n.firstChild, s && i && (s.written = !0); i;) {
      i = VS(i);
    }
    this.length = o;
  }
}
function VS(t) {
  let e = t.nextSibling;
  return t.parentNode.removeChild(t), e;
}
class Mg extends Lg {
  constructor(e, n) {
    super(n), this.view = e;
  }
  owns(e) {
    for (; e; e = e.parent) {
      if (e == this) {
        return !0;
      }
    }
    return !1;
  }
  isBlock() {
    return !0;
  }
  nearest(e) {
    for (;;) {
      if (!e) {
        return null;
      }
      let n = Bn.get(e);
      if (n && this.owns(n)) {
        return n;
      }
      e = e.parentNode;
    }
  }
  blockTiles(e) {
    for (let n = [], r = this, i = 0, s = 0;;) {
      if (i == r.children.length) {
        if (!n.length) {
          return;
        }
        r = r.parent, r.breakAfter && s++, i = n.pop();
      } else {
        let o = r.children[i++];
        if (o instanceof oo) {
          n.push(i), r = o, i = 0;
        } else {
          let a = s + o.length, l = e(o, s);
          if (l !== void 0) {
            return l;
          }
          s = a + o.breakAfter;
        }
      }
    }
  }
  resolveBlock(e, n) {
    let r, i = -1, s, o = -1;
    if (this.blockTiles((a, l) => {
      let c = l + a.length;
      if (e >= l && e <= c) {
        if (a.isWidget() && n >= -1 && n <= 1) {
          if (a.flags & 32) {
            return !0;
          }
          a.flags & 16 && (r = void 0);
        }
        (l < e || e == c && (n < -1 ? a.length : a.covers(1))) && (!r || !a.isWidget() && r.isWidget()) && (r = a, i = e - l), (c > e || e == l && (n > 1 ? a.length : a.covers(-1))) && (!s || !a.isWidget() && s.isWidget()) && (s = a, o = e - l);
      }
    }), !r && !s) {
      throw new Error("No tile at position " + e);
    }
    return r && n < 0 || !s ? {tile:r, offset:i} : {tile:s, offset:o};
  }
}
class oo extends Lg {
  constructor(e, n) {
    super(e), this.wrapper = n;
  }
  isBlock() {
    return !0;
  }
  covers(e) {
    return this.children.length ? e < 0 ? this.children[0].covers(-1) : this.lastChild.covers(1) : !1;
  }
  get domAttrs() {
    return this.wrapper.attributes;
  }
  static of(e, n) {
    let r = new oo(n || document.createElement(e.tagName), e);
    return n || (r.flags |= 4), r;
  }
}
class cc extends Lg {
  constructor(e, n) {
    super(e), this.attrs = n;
  }
  isLine() {
    return !0;
  }
  static start(e, n, r) {
    let i = new cc(n || document.createElement("div"), e);
    return (!n || !r) && (i.flags |= 4), i;
  }
  get domAttrs() {
    return this.attrs;
  }
  resolveInline(e, n, r) {
    let i = null, s = -1, o = null, a = -1;
    function l(u, h) {
      for (let f = 0, p = 0; f < u.children.length && p <= h; f++) {
        let g = u.children[f], m = p + g.length;
        m >= h && (g.isComposite() ? l(g, h - p) : (!o || o.isHidden && (n > 0 || r && _Q(o, g))) && (m > h || g.flags & 32) ? (o = g, a = h - p) : (p < h || g.flags & 16 && !g.isHidden) && (i = g, s = h - p)), p = m;
      }
    }
    l(this, e);
    let c = (n < 0 ? i : o) || i || o;
    return c ? {tile:c, offset:c == i ? s : a} : null;
  }
  coordsIn(e, n) {
    let r = this.resolveInline(e, n, !0);
    return r ? r.tile.coordsIn(Math.max(0, r.offset), n) : wQ(this);
  }
  domIn(e, n) {
    let r = this.resolveInline(e, n);
    if (r) {
      let {tile:i, offset:s} = r;
      if (this.dom.contains(i.dom)) {
        return i.isText() ? new Xi(i.dom, Math.min(i.dom.nodeValue.length, s)) : i.domPosFor(s, i.flags & 16 ? 1 : i.flags & 32 ? -1 : n);
      }
      let o = r.tile.parent, a = !1;
      for (let l of o.children) {
        if (a) {
          return new Xi(l.dom, 0);
        }
        l == r.tile && (a = !0);
      }
    }
    return new Xi(this.dom, 0);
  }
}
function wQ(t) {
  let e = t.dom.lastChild;
  if (!e) {
    return t.dom.getBoundingClientRect();
  }
  let n = Ku(e);
  return n[n.length - 1] || null;
}
function _Q(t, e) {
  let n = t.coordsIn(0, 1), r = e.coordsIn(0, 1);
  return n && r && r.top < n.bottom;
}
class Jr extends Lg {
  constructor(e, n) {
    super(e), this.mark = n;
  }
  get domAttrs() {
    return this.mark.attrs;
  }
  static of(e, n) {
    let r = new Jr(n || document.createElement(e.tagName), e);
    return n || (r.flags |= 4), r;
  }
}
class Ma extends Bn {
  constructor(e, n) {
    super(e, n.length), this.text = n;
  }
  sync(e) {
    this.flags & 2 || (super.sync(e), this.dom.nodeValue != this.text && (e && e.node == this.dom && (e.written = !0), this.dom.nodeValue = this.text));
  }
  isText() {
    return !0;
  }
  toString() {
    return JSON.stringify(this.text);
  }
  coordsIn(e, n) {
    let r = this.dom.nodeValue.length;
    e > r && (e = r);
    let i = e, s = e, o = 0;
    e == 0 && n < 0 || e == r && n >= 0 ? Ze.chrome || Ze.gecko || (e ? (i--, o = 1) : s < r && (s++, o = -1)) : n < 0 ? i-- : s < r && s++;
    let a = vd(this.dom, i, s).getClientRects();
    if (!a.length) {
      return null;
    }
    let l = a[(o ? o < 0 : n >= 0) ? 0 : a.length - 1];
    return Ze.safari && !o && l.width == 0 && (l = Array.prototype.find.call(a, c => c.width) || l), o ? xd(l, o < 0) : l || null;
  }
  static of(e, n) {
    let r = new Ma(n || document.createTextNode(e), e);
    return n || (r.flags |= 2), r;
  }
}
class tl extends Bn {
  constructor(e, n, r, i) {
    super(e, n, i), this.widget = r;
  }
  isWidget() {
    return !0;
  }
  get isHidden() {
    return this.widget.isHidden;
  }
  covers(e) {
    return this.flags & 48 ? !1 : (this.flags & (e < 0 ? 64 : 128)) > 0;
  }
  coordsIn(e, n) {
    return this.coordsInWidget(e, n, !1);
  }
  coordsInWidget(e, n, r) {
    let i = this.widget.coordsAt(this.dom, e, n);
    if (i) {
      return i;
    }
    if (r) {
      return xd(this.dom.getBoundingClientRect(), this.length ? e == 0 : n <= 0);
    }
    {
      let s = this.dom.getClientRects(), o = null;
      if (!s.length) {
        return null;
      }
      let a = this.flags & 16 ? !0 : this.flags & 32 ? !1 : e > 0;
      for (let l = a ? s.length - 1 : 0; o = s[l], !(e > 0 ? l == 0 : l == s.length - 1 || o.top < o.bottom); l += a ? -1 : 1) {
      }
      return xd(o, !a);
    }
  }
  get overrideDOMText() {
    if (!this.length) {
      return Xt.empty;
    }
    let {root:e} = this;
    if (!e) {
      return Xt.empty;
    }
    let n = this.posAtStart;
    return e.view.state.doc.slice(n, n + this.length);
  }
  destroy() {
    super.destroy(), this.widget.destroy(this.dom);
  }
  static of(e, n, r, i, s) {
    return s || (s = e.toDOM(n), e.editable || (s.contentEditable = "false")), new tl(s, r, e, i);
  }
}
class _p extends Bn {
  constructor(e) {
    let n = document.createElement("img");
    n.className = "cm-widgetBuffer", n.setAttribute("aria-hidden", "true"), super(n, 0, e);
  }
  get isHidden() {
    return !0;
  }
  get overrideDOMText() {
    return Xt.empty;
  }
  coordsIn(e) {
    return this.dom.getBoundingClientRect();
  }
}
class SQ {
  constructor(e) {
    this.index = 0, this.beforeBreak = !1, this.parents = [], this.tile = e;
  }
  advance(e, n, r) {
    let {tile:i, index:s, beforeBreak:o, parents:a} = this;
    for (; e || n > 0;) {
      if (i.isComposite()) {
        if (o) {
          if (!e) {
            break;
          }
          r && r.break(), e--, o = !1;
        } else if (s == i.children.length) {
          if (!e && !a.length) {
            break;
          }
          r && r.leave(i), o = !!i.breakAfter, {tile:i, index:s} = a.pop(), s++;
        } else {
          let l = i.children[s], c = l.breakAfter;
          (n > 0 ? l.length <= e : l.length < e) && (!r || r.skip(l, 0, l.length) !== !1 || !l.isComposite) ? (o = !!c, s++, e -= l.length) : (a.push({tile:i, index:s}), i = l, s = 0, r && l.isComposite() && r.enter(l));
        }
      } else if (s == i.length) {
        o = !!i.breakAfter, {tile:i, index:s} = a.pop(), s++;
      } else if (e) {
        let l = Math.min(e, i.length - s);
        r && r.skip(i, s, s + l), e -= l, s += l;
      } else {
        break;
      }
    }
    return this.tile = i, this.index = s, this.beforeBreak = o, this;
  }
  get root() {
    return this.parents.length ? this.parents[0].tile : this.tile;
  }
}
class kQ {
  constructor(e, n, r, i) {
    this.from = e, this.to = n, this.wrapper = r, this.rank = i;
  }
}
class EQ {
  constructor(e, n, r) {
    this.cache = e, this.root = n, this.blockWrappers = r, this.curLine = null, this.lastBlock = null, this.afterWidget = null, this.pos = 0, this.wrappers = [], this.wrapperPos = 0;
  }
  addText(e, n, r, i) {
    var s;
    this.flushBuffer();
    let o = this.ensureMarks(n, r), a = o.lastChild;
    if (a && a.isText() && !(a.flags & 8) && a.length + e.length < 512) {
      this.cache.reused.set(a, 2);
      let l = o.children[o.children.length - 1] = new Ma(a.dom, a.text + e);
      l.parent = o;
    } else {
      o.append(i || Ma.of(e, (s = this.cache.find(Ma)) === null || s === void 0 ? void 0 : s.dom));
    }
    this.pos += e.length, this.afterWidget = null;
  }
  addComposition(e, n) {
    let r = this.curLine;
    r.dom != n.line.dom && (r.setDOM(this.cache.reused.has(n.line) ? e0(n.line.dom) : n.line.dom), this.cache.reused.set(n.line, 2));
    let i = r;
    for (let a = n.marks.length - 1; a >= 0; a--) {
      let l = n.marks[a], c = i.lastChild;
      if (c instanceof Jr && c.mark.eq(l.mark)) {
        c.dom != l.dom && c.setDOM(e0(l.dom)), i = c;
      } else {
        if (this.cache.reused.get(l)) {
          let h = Bn.get(l.dom);
          h && h.setDOM(e0(l.dom));
        }
        let u = Jr.of(l.mark, l.dom);
        i.append(u), i = u;
      }
      this.cache.reused.set(l, 2);
    }
    let s = Bn.get(e.text);
    s && this.cache.reused.set(s, 2);
    let o = new Ma(e.text, e.text.nodeValue);
    o.flags |= 8, this.pos = e.range.toB, i.append(o);
  }
  addInlineWidget(e, n, r) {
    let i = this.afterWidget && e.flags & 48 && (this.afterWidget.flags & 48) == (e.flags & 48);
    i || this.flushBuffer();
    let s = this.ensureMarks(n, r);
    !i && !(e.flags & 16) && s.append(this.getBuffer(1)), s.append(e), this.pos += e.length, this.afterWidget = e;
  }
  addMark(e, n, r) {
    this.flushBuffer(), this.ensureMarks(n, r).append(e), this.pos += e.length, this.afterWidget = null;
  }
  addBlockWidget(e) {
    this.getBlockPos().append(e), this.pos += e.length, this.lastBlock = e, this.endLine();
  }
  continueWidget(e) {
    let n = this.afterWidget || this.lastBlock;
    n.length += e, this.pos += e;
  }
  addLineStart(e, n) {
    var r;
    e || (e = TI);
    let i = cc.start(e, n || ((r = this.cache.find(cc)) === null || r === void 0 ? void 0 : r.dom), !!n);
    this.getBlockPos().append(this.lastBlock = this.curLine = i);
  }
  addLine(e) {
    this.getBlockPos().append(e), this.pos += e.length, this.lastBlock = e, this.endLine();
  }
  addBreak() {
    this.lastBlock.flags |= 1, this.endLine(), this.pos++;
  }
  addLineStartIfNotCovered(e) {
    this.blockPosCovered() || this.addLineStart(e);
  }
  ensureLine(e) {
    this.curLine || this.addLineStart(e);
  }
  ensureMarks(e, n) {
    var r;
    let i = this.curLine;
    for (let s = e.length - 1; s >= 0; s--) {
      let o = e[s], a;
      if (n > 0 && (a = i.lastChild) && a instanceof Jr && a.mark.eq(o)) {
        i = a, n--;
      } else {
        let l = Jr.of(o, (r = this.cache.find(Jr, c => c.mark.eq(o))) === null || r === void 0 ? void 0 : r.dom);
        i.append(l), i = l, n = 0;
      }
    }
    return i;
  }
  endLine() {
    if (this.curLine) {
      this.flushBuffer();
      let e = this.curLine.lastChild;
      (!e || !qS(this.curLine, !1) || e.dom.nodeName != "BR" && e.isWidget() && !(Ze.ios && qS(this.curLine, !0))) && this.curLine.append(this.cache.findWidget(t0, 0, 32) || new tl(t0.toDOM(), 0, t0, 32)), this.curLine = this.afterWidget = null;
    }
  }
  updateBlockWrappers() {
    this.wrapperPos > this.pos + 1e4 && (this.blockWrappers.goto(this.pos), this.wrappers.length = 0);
    for (let e = this.wrappers.length - 1; e >= 0; e--) {
      this.wrappers[e].to < this.pos && this.wrappers.splice(e, 1);
    }
    for (let e = this.blockWrappers; e.value && e.from <= this.pos; e.next()) {
      if (e.to >= this.pos) {
        let n = e.rank * 102 + e.value.rank, r = new kQ(e.from, e.to, e.value, n), i = this.wrappers.length;
        for (; i > 0 && (this.wrappers[i - 1].rank - r.rank || this.wrappers[i - 1].to - r.to) < 0;) {
          i--;
        }
        this.wrappers.splice(i, 0, r);
      }
    }
    this.wrapperPos = this.pos;
  }
  getBlockPos() {
    var e;
    this.updateBlockWrappers();
    let n = this.root;
    for (let r of this.wrappers) {
      let i = n.lastChild;
      if (r.from < this.pos && i instanceof oo && i.wrapper.eq(r.wrapper)) {
        n = i;
      } else {
        let s = oo.of(r.wrapper, (e = this.cache.find(oo, o => o.wrapper.eq(r.wrapper))) === null || e === void 0 ? void 0 : e.dom);
        n.append(s), n = s;
      }
    }
    return n;
  }
  blockPosCovered() {
    let e = this.lastBlock;
    return e != null && !e.breakAfter && (!e.isWidget() || (e.flags & 160) > 0);
  }
  getBuffer(e) {
    let n = 2 | (e < 0 ? 16 : 32), r = this.cache.find(_p, void 0, 1);
    return r && (r.flags = n), r || new _p(n);
  }
  flushBuffer() {
    this.afterWidget && !(this.afterWidget.flags & 32) && (this.afterWidget.parent.append(this.getBuffer(-1)), this.afterWidget = null);
  }
}
class TQ {
  constructor(e) {
    this.skipCount = 0, this.text = "", this.textOff = 0, this.cursor = e.iter();
  }
  skip(e) {
    this.textOff + e <= this.text.length ? this.textOff += e : (this.skipCount += e - (this.text.length - this.textOff), this.text = "", this.textOff = 0);
  }
  next(e) {
    if (this.textOff == this.text.length) {
      let {value:i, lineBreak:s, done:o} = this.cursor.next(this.skipCount);
      if (this.skipCount = 0, o) {
        throw new Error("Ran out of text content when drawing inline views");
      }
      this.text = i;
      let a = this.textOff = Math.min(e, i.length);
      return s ? null : i.slice(0, a);
    }
    let n = Math.min(this.text.length, this.textOff + e), r = this.text.slice(this.textOff, n);
    return this.textOff = n, r;
  }
}
const Sp = [tl, cc, Ma, Jr, _p, oo, Mg];
for (let t = 0; t < Sp.length; t++) {
  Sp[t].bucket = t;
}
class CQ {
  constructor(e) {
    this.view = e, this.buckets = Sp.map(() => []), this.index = Sp.map(() => 0), this.reused = new Map();
  }
  add(e) {
    let n = e.constructor.bucket, r = this.buckets[n];
    r.length < 6 ? r.push(e) : r[this.index[n] = (this.index[n] + 1) % 6] = e;
  }
  find(e, n, r = 2) {
    let i = e.bucket, s = this.buckets[i], o = this.index[i];
    for (let a = s.length - 1; a >= 0; a--) {
      let l = (a + o) % s.length, c = s[l];
      if ((!n || n(c)) && !this.reused.has(c)) {
        return s.splice(l, 1), l < o && this.index[i]--, this.reused.set(c, r), c;
      }
    }
    return null;
  }
  findWidget(e, n, r) {
    let i = this.buckets[0];
    if (i.length) {
      for (let s = 0, o = 0;; s++) {
        if (s == i.length) {
          if (o) {
            return null;
          }
          o = 1, s = 0;
        }
        let a = i[s];
        if (!this.reused.has(a) && (o == 0 ? a.widget.compare(e) : a.widget.constructor == e.constructor && e.updateDOM(a.dom, this.view, a.widget))) {
          return i.splice(s, 1), s < this.index[0] && this.index[0]--, a.widget == e && a.length == n && (a.flags & 497) == r ? (this.reused.set(a, 1), a) : (this.reused.set(a, 2), new tl(a.dom, n, e, a.flags & -498 | r));
        }
      }
    }
  }
  reuse(e) {
    return this.reused.set(e, 1), e;
  }
  maybeReuse(e, n = 2) {
    if (!this.reused.has(e)) {
      return this.reused.set(e, n), e.dom;
    }
  }
  clear() {
    for (let e = 0; e < this.buckets.length; e++) {
      this.buckets[e].length = this.index[e] = 0;
    }
  }
}
class AQ {
  constructor(e, n, r, i, s) {
    this.view = e, this.decorations = i, this.disallowBlockEffectsFor = s, this.openWidget = !1, this.openMarks = 0, this.cache = new CQ(e), this.text = new TQ(e.state.doc), this.builder = new EQ(this.cache, new Mg(e, e.contentDOM), $t.iter(r)), this.cache.reused.set(n, 2), this.old = new SQ(n), this.reuseWalker = {skip:(o, a, l) => {
      if (this.cache.add(o), o.isComposite()) {
        return !1;
      }
    }, enter:o => this.cache.add(o), leave:() => {
    }, break:() => {
    }};
  }
  run(e, n) {
    let r = n && this.getCompositionContext(n.text);
    for (let i = 0, s = 0, o = 0;;) {
      let a = o < e.length ? e[o++] : null, l = a ? a.fromA : this.old.root.length;
      if (l > i) {
        let c = l - i;
        this.preserve(c, !o, !a), i = l, s += c;
      }
      if (!a) {
        break;
      }
      n && a.fromA <= n.range.fromA && a.toA >= n.range.toA ? (this.forward(a.fromA, n.range.fromA, n.range.fromA < n.range.toA ? 1 : -1), this.emit(s, n.range.fromB), this.cache.clear(), this.builder.addComposition(n, r), this.text.skip(n.range.toB - n.range.fromB), this.forward(n.range.fromA, a.toA), this.emit(n.range.toB, a.toB)) : (this.forward(a.fromA, a.toA), this.emit(s, a.toB)), s = a.toB, i = a.toA;
    }
    return this.builder.curLine && this.builder.endLine(), this.builder.root;
  }
  preserve(e, n, r) {
    let i = OQ(this.old), s = this.openMarks;
    this.old.advance(e, r ? 1 : -1, {skip:(o, a, l) => {
      if (o.isWidget()) {
        if (this.openWidget) {
          this.builder.continueWidget(l - a);
        } else {
          let c = l > 0 || a < o.length ? tl.of(o.widget, this.view, l - a, o.flags & 496, this.cache.maybeReuse(o)) : this.cache.reuse(o);
          c.flags & 256 ? (c.flags &= -2, this.builder.addBlockWidget(c)) : (this.builder.ensureLine(null), this.builder.addInlineWidget(c, i, s), s = i.length);
        }
      } else if (o.isText()) {
        this.builder.ensureLine(null), !a && l == o.length && !this.cache.reused.has(o) ? this.builder.addText(o.text, i, s, this.cache.reuse(o)) : (this.cache.add(o), this.builder.addText(o.text.slice(a, l), i, s)), s = i.length;
      } else if (o.isLine()) {
        o.flags &= -2, this.cache.reused.set(o, 1), this.builder.addLine(o);
      } else if (o instanceof _p) {
        this.cache.add(o);
      } else if (o instanceof Jr) {
        this.builder.ensureLine(null), this.builder.addMark(o, i, s), this.cache.reused.set(o, 1), s = i.length;
      } else {
        return !1;
      }
      this.openWidget = !1;
    }, enter:o => {
      o.isLine() ? this.builder.addLineStart(o.attrs, this.cache.maybeReuse(o)) : (this.cache.add(o), o instanceof Jr && i.unshift(o.mark)), this.openWidget = !1;
    }, leave:o => {
      o.isLine() ? i.length && (i.length = s = 0) : o instanceof Jr && (i.shift(), s = Math.min(s, i.length));
    }, break:() => {
      this.builder.addBreak(), this.openWidget = !1;
    }}), this.text.skip(e);
  }
  emit(e, n) {
    let r = null, i = this.builder, s = 0, o = $t.spans(this.decorations, e, n, {point:(a, l, c, u, h, f) => {
      if (c instanceof Za) {
        if (this.disallowBlockEffectsFor[f]) {
          if (c.block) {
            throw new RangeError("Block decorations may not be specified via plugins");
          }
          if (l > this.view.state.doc.lineAt(a).to) {
            throw new RangeError("Decorations that replace line breaks may not be specified via plugins");
          }
        }
        if (s = u.length, h > u.length) {
          i.continueWidget(l - a);
        } else {
          let p = c.widget || (c.block ? uc.block : uc.inline), g = NQ(c), m = this.cache.findWidget(p, l - a, g) || tl.of(p, this.view, l - a, g);
          c.block ? (c.startSide > 0 && i.addLineStartIfNotCovered(r), i.addBlockWidget(m)) : (i.ensureLine(r), i.addInlineWidget(m, u, h));
        }
        r = null;
      } else {
        r = IQ(r, c);
      }
      l > a && this.text.skip(l - a);
    }, span:(a, l, c, u) => {
      for (let h = a; h < l;) {
        let f = this.text.next(Math.min(512, l - h));
        f == null ? (i.addLineStartIfNotCovered(r), i.addBreak(), h++) : (i.ensureLine(r), i.addText(f, c, h == a ? u : c.length), h += f.length), r = null;
      }
    }});
    i.addLineStartIfNotCovered(r), this.openWidget = o > s, this.openMarks = o;
  }
  forward(e, n, r = 1) {
    n - e <= 10 ? this.old.advance(n - e, r, this.reuseWalker) : (this.old.advance(5, -1, this.reuseWalker), this.old.advance(n - e - 10, -1), this.old.advance(5, r, this.reuseWalker));
  }
  getCompositionContext(e) {
    let n = [], r = null;
    for (let i = e.parentNode;; i = i.parentNode) {
      let s = Bn.get(i);
      if (i == this.view.contentDOM) {
        break;
      }
      s instanceof Jr ? n.push(s) : s != null && s.isLine() ? r = s : s instanceof oo || (i.nodeName == "DIV" && !r && i != this.view.contentDOM ? r = new cc(i, TI) : r || n.push(Jr.of(new Zd({tagName:i.nodeName.toLowerCase(), attributes:rQ(i)}), i)));
    }
    return {line:r, marks:n};
  }
}
function qS(t, e) {
  let n = r => {
    for (let i of r.children) {
      if ((e ? i.isText() : i.length) || n(i)) {
        return !0;
      }
    }
    return !1;
  };
  return n(t);
}
function NQ(t) {
  let e = t.isReplace ? (t.startSide < 0 ? 64 : 0) | (t.endSide > 0 ? 128 : 0) : t.startSide > 0 ? 32 : 16;
  return t.block && (e |= 256), e;
}
const TI = {class:"cm-line"};
function IQ(t, e) {
  let n = e.spec.attributes, r = e.spec.class;
  return !n && !r || (t || (t = {class:"cm-line"}), n && u1(n, t), r && (t.class += " " + r)), t;
}
function OQ(t) {
  let e = [];
  for (let n = t.parents.length; n > 1; n--) {
    let r = n == t.parents.length ? t.tile : t.parents[n].tile;
    r instanceof Jr && e.push(r.mark);
  }
  return e;
}
function e0(t) {
  let e = Bn.get(t);
  return e && e.setDOM(t.cloneNode()), t;
}
class uc extends Fs {
  constructor(e) {
    super(), this.tag = e;
  }
  eq(e) {
    return e.tag == this.tag;
  }
  toDOM() {
    return document.createElement(this.tag);
  }
  updateDOM(e) {
    return e.nodeName.toLowerCase() == this.tag;
  }
  get isHidden() {
    return !0;
  }
}
uc.inline = new uc("span");
uc.block = new uc("div");
const t0 = new class extends Fs {
  toDOM() {
    return document.createElement("br");
  }
  get isHidden() {
    return !0;
  }
  get editable() {
    return !0;
  }
}();
class YS {
  constructor(e) {
    this.view = e, this.decorations = [], this.blockWrappers = [], this.dynamicDecorationMap = [!1], this.domChanged = null, this.hasComposition = null, this.editContextFormatting = pt.none, this.lastCompositionAfterCursor = !1, this.minWidth = 0, this.minWidthFrom = 0, this.minWidthTo = 0, this.impreciseAnchor = null, this.impreciseHead = null, this.forceSelection = !1, this.lastUpdate = Date.now(), this.updateDeco(), this.tile = new Mg(e, e.contentDOM), this.updateInner([new Ri(0, 0, 0, e.state.doc.length)], 
    null);
  }
  update(e) {
    var n;
    let r = e.changedRanges;
    this.minWidth > 0 && r.length && (r.every(({fromA:u, toA:h}) => h < this.minWidthFrom || u > this.minWidthTo) ? (this.minWidthFrom = e.changes.mapPos(this.minWidthFrom, 1), this.minWidthTo = e.changes.mapPos(this.minWidthTo, 1)) : this.minWidth = this.minWidthFrom = this.minWidthTo = 0), this.updateEditContextFormatting(e);
    let i = -1;
    this.view.inputState.composing >= 0 && !this.view.observer.editContext && (!((n = this.domChanged) === null || n === void 0) && n.newSel ? i = this.domChanged.newSel.head : !zQ(e.changes, this.hasComposition) && !e.selectionSet && (i = e.state.selection.main.head));
    let s = i > -1 ? RQ(this.view, e.changes, i) : null;
    if (this.domChanged = null, this.hasComposition) {
      let {from:u, to:h} = this.hasComposition;
      r = (new Ri(u, h, e.changes.mapPos(u, -1), e.changes.mapPos(h, 1))).addToSet(r.slice());
    }
    this.hasComposition = s ? {from:s.range.fromB, to:s.range.toB} : null, (Ze.ie || Ze.chrome) && !s && e && e.state.doc.lines != e.startState.doc.lines && (this.forceSelection = !0);
    let o = this.decorations, a = this.blockWrappers;
    this.updateDeco();
    let l = MQ(o, this.decorations, e.changes);
    l.length && (r = Ri.extendWithRanges(r, l));
    let c = $Q(a, this.blockWrappers, e.changes);
    return c.length && (r = Ri.extendWithRanges(r, c)), s && !r.some(u => u.fromA <= s.range.fromA && u.toA >= s.range.toA) && (r = s.range.addToSet(r.slice())), this.tile.flags & 2 && r.length == 0 ? !1 : (this.updateInner(r, s), e.transactions.length && (this.lastUpdate = Date.now()), !0);
  }
  updateInner(e, n) {
    this.view.viewState.mustMeasureContent = !0;
    let {observer:r} = this.view;
    r.ignore(() => {
      if (n || e.length) {
        let o = this.tile, a = new AQ(this.view, o, this.blockWrappers, this.decorations, this.dynamicDecorationMap);
        n && Bn.get(n.text) && a.cache.reused.set(Bn.get(n.text), 2), this.tile = a.run(e, n), sy(o, a.cache.reused);
      }
      this.tile.dom.style.height = this.view.viewState.contentHeight / this.view.scaleY + "px", this.tile.dom.style.flexBasis = this.minWidth ? this.minWidth + "px" : "";
      let s = Ze.chrome || Ze.ios ? {node:r.selectionRange.focusNode, written:!1} : void 0;
      this.tile.sync(s), s && (s.written || r.selectionRange.focusNode != s.node || !this.tile.dom.contains(s.node)) && (this.forceSelection = !0), this.tile.dom.style.height = "";
    });
    let i = [];
    if (this.view.viewport.from || this.view.viewport.to < this.view.state.doc.length) {
      for (let s of this.tile.children) {
        s.isWidget() && s.widget instanceof n0 && i.push(s.dom);
      }
    }
    r.updateGaps(i);
  }
  updateEditContextFormatting(e) {
    this.editContextFormatting = this.editContextFormatting.map(e.changes);
    for (let n of e.transactions) {
      for (let r of n.effects) {
        r.is(wI) && (this.editContextFormatting = r.value);
      }
    }
  }
  updateSelection(e = !1, n = !1) {
    (e || !this.view.observer.selectionRange.focusNode) && this.view.observer.readSelectionRange();
    let {dom:r} = this.tile, i = this.view.root.activeElement, s = i == r, o = !s && !(this.view.state.facet(no) || r.tabIndex > -1) && Qu(r, this.view.observer.selectionRange) && !(i && r.contains(i));
    if (!(s || n || o)) {
      return;
    }
    let a = this.forceSelection;
    this.forceSelection = !1;
    let l = this.view.state.selection.main, c, u;
    if (l.empty ? u = c = this.inlineDOMNearPos(l.anchor, l.assoc || 1) : (u = this.inlineDOMNearPos(l.head, l.head == l.from ? 1 : -1), c = this.inlineDOMNearPos(l.anchor, l.anchor == l.from ? 1 : -1)), Ze.gecko && l.empty && !this.hasComposition && PQ(c)) {
      let f = document.createTextNode("");
      this.view.observer.ignore(() => c.node.insertBefore(f, c.node.childNodes[c.offset] || null)), c = u = new Xi(f, 0), a = !0;
    }
    let h = this.view.observer.selectionRange;
    (a || !h.focusNode || (!Xu(c.node, c.offset, h.anchorNode, h.anchorOffset) || !Xu(u.node, u.offset, h.focusNode, h.focusOffset)) && !this.suppressWidgetCursorChange(h, l)) && (this.view.observer.ignore(() => {
      Ze.android && Ze.chrome && r.contains(h.focusNode) && FQ(h.focusNode, r) && (r.blur(), r.focus({preventScroll:!0}));
      let f = yd(this.view.root);
      if (f) {
        if (l.empty) {
          if (Ze.gecko) {
            let p = DQ(c.node, c.offset);
            if (p && p != 3) {
              let g = (p == 1 ? sI : oI)(c.node, c.offset);
              g && (c = new Xi(g.node, g.offset));
            }
          }
          f.collapse(c.node, c.offset), l.bidiLevel != null && f.caretBidiLevel !== void 0 && (f.caretBidiLevel = l.bidiLevel);
        } else if (f.extend) {
          f.collapse(c.node, c.offset);
          try {
            f.extend(u.node, u.offset);
          } catch {
          }
        } else {
          let p = document.createRange();
          l.anchor > l.head && ([c, u] = [u, c]), p.setEnd(u.node, u.offset), p.setStart(c.node, c.offset), f.removeAllRanges(), f.addRange(p);
        }
      }
      o && this.view.root.activeElement == r && (r.blur(), i && i.focus());
    }), this.view.observer.setSelectionRange(c, u)), this.impreciseAnchor = c.precise ? null : new Xi(h.anchorNode, h.anchorOffset), this.impreciseHead = u.precise ? null : new Xi(h.focusNode, h.focusOffset);
  }
  suppressWidgetCursorChange(e, n) {
    return this.hasComposition && n.empty && Xu(e.focusNode, e.focusOffset, e.anchorNode, e.anchorOffset) && this.posFromDOM(e.focusNode, e.focusOffset) == n.head;
  }
  enforceCursorAssoc() {
    if (this.hasComposition) {
      return;
    }
    let {view:e} = this, n = e.state.selection.main, r = yd(e.root), {anchorNode:i, anchorOffset:s} = e.observer.selectionRange;
    if (!r || !n.empty || !n.assoc || !r.modify) {
      return;
    }
    let o = this.lineAt(n.head, n.assoc);
    if (!o) {
      return;
    }
    let a = o.posAtStart;
    if (n.head == a || n.head == a + o.length) {
      return;
    }
    let l = this.coordsAt(n.head, -1), c = this.coordsAt(n.head, 1);
    if (!l || !c || l.bottom > c.top) {
      return;
    }
    let u = this.domAtPos(n.head + n.assoc, n.assoc);
    r.collapse(u.node, u.offset), r.modify("move", n.assoc < 0 ? "forward" : "backward", "lineboundary"), e.observer.readSelectionRange();
    let h = e.observer.selectionRange;
    e.docView.posFromDOM(h.anchorNode, h.anchorOffset) != n.from && r.collapse(i, s);
  }
  posFromDOM(e, n) {
    let r = this.tile.nearest(e);
    if (!r) {
      return this.tile.dom.compareDocumentPosition(e) & 2 ? 0 : this.view.state.doc.length;
    }
    let i = r.posAtStart;
    if (r.isComposite()) {
      let s;
      if (e == r.dom) {
        s = r.dom.childNodes[n];
      } else {
        let o = ho(e) == 0 ? 0 : n == 0 ? -1 : 1;
        for (;;) {
          let a = e.parentNode;
          if (a == r.dom) {
            break;
          }
          o == 0 && a.firstChild != a.lastChild && (e == a.firstChild ? o = -1 : o = 1), e = a;
        }
        o < 0 ? s = e : s = e.nextSibling;
      }
      if (s == r.dom.firstChild) {
        return i;
      }
      for (; s && !Bn.get(s);) {
        s = s.nextSibling;
      }
      if (!s) {
        return i + r.length;
      }
      for (let o = 0, a = i;; o++) {
        let l = r.children[o];
        if (l.dom == s) {
          return a;
        }
        a += l.length + l.breakAfter;
      }
    } else {
      return r.isText() ? e == r.dom ? i + n : i + (n ? r.length : 0) : i;
    }
  }
  domAtPos(e, n) {
    let {tile:r, offset:i} = this.tile.resolveBlock(e, n);
    return r.isWidget() ? r.domPosFor(e, n) : r.domIn(i, n);
  }
  inlineDOMNearPos(e, n) {
    let r, i = -1, s = !1, o, a = -1, l = !1;
    return this.tile.blockTiles((c, u) => {
      if (c.isWidget()) {
        if (c.flags & 32 && u >= e) {
          return !0;
        }
        c.flags & 16 && (s = !0);
      } else {
        let h = u + c.length;
        if (u <= e && (r = c, i = e - u, s = h < e), h >= e && !o && (o = c, a = e - u, l = u > e), u > e && o) {
          return !0;
        }
      }
    }), !r && !o ? this.domAtPos(e, n) : (s && o ? r = null : l && r && (o = null), r && n < 0 || !o ? r.domIn(i, n) : o.domIn(a, n));
  }
  coordsAt(e, n) {
    let {tile:r, offset:i} = this.tile.resolveBlock(e, n);
    return r.isWidget() ? r.widget instanceof n0 ? null : r.coordsInWidget(i, n, !0) : r.coordsIn(i, n);
  }
  lineAt(e, n) {
    let {tile:r} = this.tile.resolveBlock(e, n);
    return r.isLine() ? r : null;
  }
  coordsForChar(e) {
    let {tile:n, offset:r} = this.tile.resolveBlock(e, 1);
    if (!n.isLine()) {
      return null;
    }
    function i(s, o) {
      if (s.isComposite()) {
        for (let a of s.children) {
          if (a.length >= o) {
            let l = i(a, o);
            if (l) {
              return l;
            }
          }
          if (o -= a.length, o < 0) {
            break;
          }
        }
      } else if (s.isText() && o < s.length) {
        let a = cr(s.text, o);
        if (a == o) {
          return null;
        }
        let l = vd(s.dom, o, a).getClientRects();
        for (let c = 0; c < l.length; c++) {
          let u = l[c];
          if (c == l.length - 1 || u.top < u.bottom && u.left < u.right) {
            return u;
          }
        }
      }
      return null;
    }
    return i(n, r);
  }
  measureVisibleLineHeights(e) {
    let n = [], {from:r, to:i} = e, s = this.view.contentDOM.clientWidth, o = s > Math.max(this.view.scrollDOM.clientWidth, this.minWidth) + 1, a = -1, l = this.view.textDirection == xn.LTR, c = 0, u = (h, f, p) => {
      for (let g = 0; g < h.children.length && !(f > i); g++) {
        let m = h.children[g], b = f + m.length, x = m.dom.getBoundingClientRect(), {height:w} = x;
        if (p && !g && (c += x.top - p.top), m instanceof oo) {
          b > r && u(m, f, x);
        } else if (f >= r && (c > 0 && n.push(-c), n.push(w + c), c = 0, o)) {
          let v = m.dom.lastChild, T = v ? Ku(v) : [];
          if (T.length) {
            let I = T[T.length - 1], _ = l ? I.right - x.left : x.right - I.left;
            _ > a && (a = _, this.minWidth = s, this.minWidthFrom = f, this.minWidthTo = b);
          }
        }
        p && g == h.children.length - 1 && (c += p.bottom - x.bottom), f = b + m.breakAfter;
      }
    };
    return u(this.tile, 0, null), n;
  }
  textDirectionAt(e) {
    let {tile:n} = this.tile.resolveBlock(e, 1);
    return getComputedStyle(n.dom).direction == "rtl" ? xn.RTL : xn.LTR;
  }
  measureTextSize() {
    let e = this.tile.blockTiles(o => {
      if (o.isLine() && o.children.length && o.length <= 20) {
        let a = 0, l;
        for (let c of o.children) {
          if (!c.isText() || /[^ -~]/.test(c.text)) {
            return;
          }
          let u = Ku(c.dom);
          if (u.length != 1) {
            return;
          }
          a += u[0].width, l = u[0].height;
        }
        if (a) {
          return {lineHeight:o.dom.getBoundingClientRect().height, charWidth:a / o.length, textHeight:l};
        }
      }
    });
    if (e) {
      return e;
    }
    let n = document.createElement("div"), r, i, s;
    return n.className = "cm-line", n.style.width = "99999px", n.style.position = "absolute", n.textContent = "abc def ghi jkl mno pqr stu", this.view.observer.ignore(() => {
      this.tile.dom.appendChild(n);
      let o = Ku(n.firstChild)[0];
      r = n.getBoundingClientRect().height, i = o && o.width ? o.width / 27 : 7, s = o && o.height ? o.height : r, n.remove();
    }), {lineHeight:r, charWidth:i, textHeight:s};
  }
  computeBlockGapDeco() {
    let e = [], n = this.view.viewState;
    for (let r = 0, i = 0;; i++) {
      let s = i == n.viewports.length ? null : n.viewports[i], o = s ? s.from - 1 : this.view.state.doc.length;
      if (o > r) {
        let a = (n.lineBlockAt(o).bottom - n.lineBlockAt(r).top) / this.view.scaleY;
        e.push(pt.replace({widget:new n0(a), block:!0, inclusive:!0, isBlockGap:!0}).range(r, o));
      }
      if (!s) {
        break;
      }
      r = s.to + 1;
    }
    return pt.set(e);
  }
  updateDeco() {
    let e = 1, n = this.view.state.facet(Dg).map(s => (this.dynamicDecorationMap[e++] = typeof s == "function") ? s(this.view) : s), r = !1, i = this.view.state.facet(m1).map((s, o) => {
      let a = typeof s == "function";
      return a && (r = !0), a ? s(this.view) : s;
    });
    for (i.length && (this.dynamicDecorationMap[e++] = r, n.push($t.join(i))), this.decorations = [this.editContextFormatting, ...n, this.computeBlockGapDeco(), this.view.viewState.lineGapDeco]; e < this.decorations.length;) {
      this.dynamicDecorationMap[e++] = !1;
    }
    this.blockWrappers = this.view.state.facet(SI).map(s => typeof s == "function" ? s(this.view) : s);
  }
  scrollIntoView(e) {
    var n;
    if (e.isSnapshot) {
      let u = this.view.viewState.lineBlockAt(e.range.head);
      this.view.scrollDOM.scrollTop = u.top - e.yMargin, this.view.scrollDOM.scrollLeft = e.xMargin;
      return;
    }
    for (let u of this.view.state.facet(vI)) {
      try {
        if (u(this.view, e.range, e)) {
          return !0;
        }
      } catch (h) {
        Pi(this.view.state, h, "scroll handler");
      }
    }
    let {range:r} = e, i = this.coordsAt(r.head, (n = r.assoc) !== null && n !== void 0 ? n : r.empty ? 0 : r.head > r.anchor ? -1 : 1), s;
    if (!i) {
      return;
    }
    !r.empty && (s = this.coordsAt(r.anchor, r.anchor > r.head ? -1 : 1)) && (i = {left:Math.min(i.left, s.left), top:Math.min(i.top, s.top), right:Math.max(i.right, s.right), bottom:Math.max(i.bottom, s.bottom)});
    let o = b1(this.view), a = {left:i.left - o.left, top:i.top - o.top, right:i.right + o.right, bottom:i.bottom + o.bottom}, {offsetWidth:l, offsetHeight:c} = this.view.scrollDOM;
    if (oQ(this.view.scrollDOM, a, r.head < r.anchor ? -1 : 1, e.x, e.y, Math.max(Math.min(e.xMargin, l), -l), Math.max(Math.min(e.yMargin, c), -c), this.view.textDirection == xn.LTR), window.visualViewport && window.innerHeight - window.visualViewport.height > 1 && (i.top > window.pageYOffset + window.visualViewport.offsetTop + window.visualViewport.height || i.bottom < window.pageYOffset + window.visualViewport.offsetTop)) {
      let u = this.view.docView.lineAt(r.head, 1);
      u && u.dom.scrollIntoView({block:"nearest"});
    }
  }
  lineHasWidget(e) {
    let n = r => r.isWidget() || r.children.some(n);
    return n(this.tile.resolveBlock(e, 1).tile);
  }
  destroy() {
    sy(this.tile);
  }
}
function sy(t, e) {
  let n = e == null ? void 0 : e.get(t);
  if (n != 1) {
    n == null && t.destroy();
    for (let r of t.children) {
      sy(r, e);
    }
  }
}
function PQ(t) {
  return t.node.nodeType == 1 && t.node.firstChild && (t.offset == 0 || t.node.childNodes[t.offset - 1].contentEditable == "false") && (t.offset == t.node.childNodes.length || t.node.childNodes[t.offset].contentEditable == "false");
}
function CI(t, e) {
  let n = t.observer.selectionRange;
  if (!n.focusNode) {
    return null;
  }
  let r = sI(n.focusNode, n.focusOffset), i = oI(n.focusNode, n.focusOffset), s = r || i;
  if (i && r && i.node != r.node) {
    let a = Bn.get(i.node);
    if (!a || a.isText() && a.text != i.node.nodeValue) {
      s = i;
    } else if (t.docView.lastCompositionAfterCursor) {
      let l = Bn.get(r.node);
      !l || l.isText() && l.text != r.node.nodeValue || (s = i);
    }
  }
  if (t.docView.lastCompositionAfterCursor = s != r, !s) {
    return null;
  }
  let o = e - s.offset;
  return {from:o, to:o + s.node.nodeValue.length, node:s.node};
}
function RQ(t, e, n) {
  let r = CI(t, n);
  if (!r) {
    return null;
  }
  let {node:i, from:s, to:o} = r, a = i.nodeValue;
  if (/[\n\r]/.test(a) || t.state.doc.sliceString(r.from, r.to) != a) {
    return null;
  }
  let l = e.invertedDesc;
  return {range:new Ri(l.mapPos(s), l.mapPos(o), s, o), text:i};
}
function DQ(t, e) {
  return t.nodeType != 1 ? 0 : (e && t.childNodes[e - 1].contentEditable == "false" ? 1 : 0) | (e < t.childNodes.length && t.childNodes[e].contentEditable == "false" ? 2 : 0);
}
let LQ = class {
  constructor() {
    this.changes = [];
  }
  compareRange(e, n) {
    Xl(e, n, this.changes);
  }
  comparePoint(e, n) {
    Xl(e, n, this.changes);
  }
  boundChange(e) {
    Xl(e, e, this.changes);
  }
};
function MQ(t, e, n) {
  let r = new LQ();
  return $t.compare(t, e, n, r), r.changes;
}
class BQ {
  constructor() {
    this.changes = [];
  }
  compareRange(e, n) {
    Xl(e, n, this.changes);
  }
  comparePoint() {
  }
  boundChange(e) {
    Xl(e, e, this.changes);
  }
}
function $Q(t, e, n) {
  let r = new BQ();
  return $t.compare(t, e, n, r), r.changes;
}
function FQ(t, e) {
  for (let n = t; n && n != e; n = n.assignedSlot || n.parentNode) {
    if (n.nodeType == 1 && n.contentEditable == "false") {
      return !0;
    }
  }
  return !1;
}
function zQ(t, e) {
  let n = !1;
  return e && t.iterChangedRanges((r, i) => {
    r < e.to && i > e.from && (n = !0);
  }), n;
}
class n0 extends Fs {
  constructor(e) {
    super(), this.height = e;
  }
  toDOM() {
    let e = document.createElement("div");
    return e.className = "cm-gap", this.updateDOM(e), e;
  }
  eq(e) {
    return e.height == this.height;
  }
  updateDOM(e) {
    return e.style.height = this.height + "px", !0;
  }
  get editable() {
    return !0;
  }
  get estimatedHeight() {
    return this.height;
  }
  ignoreEvent() {
    return !1;
  }
}
function HQ(t, e, n = 1) {
  let r = t.charCategorizer(e), i = t.doc.lineAt(e), s = e - i.from;
  if (i.length == 0) {
    return Ce.cursor(e);
  }
  s == 0 ? n = 1 : s == i.length && (n = -1);
  let o = s, a = s;
  n < 0 ? o = cr(i.text, s, !1) : a = cr(i.text, s);
  let l = r(i.text.slice(o, a));
  for (; o > 0;) {
    let c = cr(i.text, o, !1);
    if (r(i.text.slice(c, o)) != l) {
      break;
    }
    o = c;
  }
  for (; a < i.length;) {
    let c = cr(i.text, a);
    if (r(i.text.slice(a, c)) != l) {
      break;
    }
    a = c;
  }
  return Ce.range(o + i.from, a + i.from);
}
function UQ(t, e, n, r, i) {
  let s = Math.round((r - e.left) * t.defaultCharacterWidth);
  if (t.lineWrapping && n.height > t.defaultLineHeight * 1.5) {
    let a = t.viewState.heightOracle.textHeight, l = Math.floor((i - n.top - (t.defaultLineHeight - a) * 0.5) / a);
    s += l * t.viewState.heightOracle.lineLength;
  }
  let o = t.state.sliceDoc(n.from, n.to);
  return n.from + Yb(o, s, t.state.tabSize);
}
function oy(t, e, n) {
  let r = t.lineBlockAt(e);
  if (Array.isArray(r.type)) {
    let i;
    for (let s of r.type) {
      if (s.from > e) {
        break;
      }
      if (!(s.to < e)) {
        if (s.from < e && s.to > e) {
          return s;
        }
        (!i || s.type == br.Text && (i.type != s.type || (n < 0 ? s.from < e : s.to > e))) && (i = s);
      }
    }
    return i || r;
  }
  return r;
}
function WQ(t, e, n, r) {
  let i = oy(t, e.head, e.assoc || -1), s = !r || i.type != br.Text || !(t.lineWrapping || i.widgetLineBreaks) ? null : t.coordsAtPos(e.assoc < 0 && e.head > i.from ? e.head - 1 : e.head);
  if (s) {
    let o = t.dom.getBoundingClientRect(), a = t.textDirectionAt(i.from), l = t.posAtCoords({x:n == (a == xn.LTR) ? o.right - 1 : o.left + 1, y:(s.top + s.bottom) / 2});
    if (l != null) {
      return Ce.cursor(l, n ? -1 : 1);
    }
  }
  return Ce.cursor(n ? i.to : i.from, n ? -1 : 1);
}
function GS(t, e, n, r) {
  let i = t.state.doc.lineAt(e.head), s = t.bidiSpans(i), o = t.textDirectionAt(i.from);
  for (let a = e, l = null;;) {
    let c = bQ(i, s, o, a, n), u = dI;
    if (!c) {
      if (i.number == (n ? t.state.doc.lines : 1)) {
        return a;
      }
      u = `
`, i = t.state.doc.line(i.number + (n ? 1 : -1)), s = t.bidiSpans(i), c = t.visualLineSide(i, !n);
    }
    if (l) {
      if (!l(u)) {
        return a;
      }
    } else {
      if (!r) {
        return c;
      }
      l = r(u);
    }
    a = c;
  }
}
function jQ(t, e, n) {
  let r = t.state.charCategorizer(e), i = r(n);
  return s => {
    let o = r(s);
    return i == An.Space && (i = o), i == o;
  };
}
function VQ(t, e, n, r) {
  let i = e.head, s = n ? 1 : -1;
  if (i == (n ? t.state.doc.length : 0)) {
    return Ce.cursor(i, e.assoc);
  }
  let o = e.goalColumn, a, l = t.contentDOM.getBoundingClientRect(), c = t.coordsAtPos(i, e.assoc || ((e.empty ? n : e.head == e.from) ? 1 : -1)), u = t.documentTop;
  if (c) {
    o == null && (o = c.left - l.left), a = s < 0 ? c.top : c.bottom;
  } else {
    let g = t.viewState.lineBlockAt(i);
    o == null && (o = Math.min(l.right - l.left, t.defaultCharacterWidth * (i - g.from))), a = (s < 0 ? g.top : g.bottom) + u;
  }
  let h = l.left + o, f = t.viewState.heightOracle.textHeight >> 1, p = r ?? f;
  for (let g = 0;; g += f) {
    let m = a + (p + g) * s, b = ay(t, {x:h, y:m}, !1, s);
    if (n ? m > l.bottom : m < l.top) {
      return Ce.cursor(b.pos, b.assoc);
    }
    let x = t.coordsAtPos(b.pos, b.assoc), w = x ? (x.top + x.bottom) / 2 : 0;
    if (!x || (n ? w > a : w < a)) {
      return Ce.cursor(b.pos, b.assoc, void 0, o);
    }
  }
}
function Ju(t, e, n) {
  for (;;) {
    let r = 0;
    for (let i of t) {
      i.between(e - 1, e + 1, (s, o, a) => {
        if (e > s && e < o) {
          let l = r || n || (e - s < o - e ? -1 : 1);
          e = l < 0 ? s : o, r = l;
        }
      });
    }
    if (!r) {
      return e;
    }
  }
}
function AI(t, e) {
  let n = null;
  for (let r = 0; r < e.ranges.length; r++) {
    let i = e.ranges[r], s = null;
    if (i.empty) {
      let o = Ju(t, i.from, 0);
      o != i.from && (s = Ce.cursor(o, -1));
    } else {
      let o = Ju(t, i.from, -1), a = Ju(t, i.to, 1);
      (o != i.from || a != i.to) && (s = Ce.range(i.from == i.anchor ? o : a, i.from == i.head ? o : a));
    }
    s && (n || (n = e.ranges.slice()), n[r] = s);
  }
  return n ? Ce.create(n, e.mainIndex) : e;
}
function r0(t, e, n) {
  let r = Ju(t.state.facet(th).map(i => i(t)), n.from, e.head > n.from ? -1 : 1);
  return r == n.from ? n : Ce.cursor(r, r < n.from ? 1 : -1);
}
class Ts {
  constructor(e, n) {
    this.pos = e, this.assoc = n;
  }
}
function ay(t, e, n, r) {
  let i = t.contentDOM.getBoundingClientRect(), s = i.top + t.viewState.paddingTop, {x:o, y:a} = e, l = a - s, c;
  for (;;) {
    if (l < 0) {
      return new Ts(0, 1);
    }
    if (l > t.viewState.docHeight) {
      return new Ts(t.state.doc.length, -1);
    }
    if (c = t.elementAtHeight(l), r == null) {
      break;
    }
    if (c.type == br.Text) {
      if (r < 0 ? c.to < t.viewport.from : c.from > t.viewport.to) {
        break;
      }
      let f = t.docView.coordsAt(r < 0 ? c.from : c.to, r > 0 ? -1 : 1);
      if (f && (r < 0 ? f.top <= l + s : f.bottom >= l + s)) {
        break;
      }
    }
    let h = t.viewState.heightOracle.textHeight / 2;
    l = r > 0 ? c.bottom + h : c.top - h;
  }
  if (t.viewport.from >= c.to || t.viewport.to <= c.from) {
    if (n) {
      return null;
    }
    if (c.type == br.Text) {
      let h = UQ(t, i, c, o, a);
      return new Ts(h, h == c.from ? 1 : -1);
    }
  }
  if (c.type != br.Text) {
    return l < (c.top + c.bottom) / 2 ? new Ts(c.from, 1) : new Ts(c.to, -1);
  }
  let u = t.docView.lineAt(c.from, 2);
  return (!u || u.length != c.length) && (u = t.docView.lineAt(c.from, -2)), (new qQ(t, o, a, t.textDirectionAt(c.from))).scanTile(u, c.from);
}
class qQ {
  constructor(e, n, r, i) {
    this.view = e, this.x = n, this.y = r, this.baseDir = i, this.line = null, this.spans = null;
  }
  bidiSpansAt(e) {
    return (!this.line || this.line.from > e || this.line.to < e) && (this.line = this.view.state.doc.lineAt(e), this.spans = this.view.bidiSpans(this.line)), this;
  }
  baseDirAt(e, n) {
    let {line:r, spans:i} = this.bidiSpansAt(e);
    return i[Cs.find(i, e - r.from, -1, n)].level == this.baseDir;
  }
  dirAt(e, n) {
    let {line:r, spans:i} = this.bidiSpansAt(e);
    return i[Cs.find(i, e - r.from, -1, n)].dir;
  }
  bidiIn(e, n) {
    let {spans:r, line:i} = this.bidiSpansAt(e);
    return r.length > 1 || r.length && (r[0].level != this.baseDir || r[0].to + i.from < n);
  }
  scan(e, n, r = !1) {
    let i = 0, s = e.length - 1, o = new Set(), a = this.bidiIn(e[0], e[s]), l, c, u = -1, h = 1e9, f;
    e: for (; i < s;) {
      let g = s - i, m = i + s >> 1;
      t: if (o.has(m)) {
        let x = i + Math.floor(Math.random() * g);
        for (let w = 0; w < g; w++) {
          if (!o.has(x)) {
            m = x;
            break t;
          }
          x++, x == s && (x = i);
        }
        break e;
      }
      o.add(m);
      let b = n(m);
      if (b) {
        for (let x = 0; x < b.length; x++) {
          let w = b[x], v = 0;
          if (!(w.width == 0 && b.length > 1)) {
            if (w.bottom < this.y) {
              (!l || l.bottom < w.bottom) && (l = w), v = 1;
            } else if (w.top > this.y) {
              (!c || c.top > w.top) && (c = w), v = -1;
            } else {
              let T = w.left > this.x ? this.x - w.left : w.right < this.x ? this.x - w.right : 0, I = Math.abs(T);
              I < h && (u = m, h = I, f = w), T && (v = T < 0 == (this.baseDir == xn.LTR) ? -1 : 1);
            }
            v == -1 && (!a || this.baseDirAt(e[m], 1)) ? s = m : v == 1 && (!a || this.baseDirAt(e[m + 1], -1)) && (i = m + 1);
          }
        }
      }
    }
    if (!f) {
      let g = l && (!c || this.y - l.bottom < c.top - this.y) ? l : c;
      return this.y = (g.top + g.bottom) / 2, this.scan(e, n, !0);
    }
    if (h && !r) {
      let {top:g, bottom:m} = f;
      if (l && l.bottom > (g + g + m) / 3) {
        return this.y = l.bottom - 1, this.scan(e, n, !0);
      }
      if (c && c.top < (g + m + m) / 3) {
        return this.y = c.top + 1, this.scan(e, n, !0);
      }
    }
    let p = (a ? this.dirAt(e[u], 1) : this.baseDir) == xn.LTR;
    return {i:u, after:this.x > (f.left + f.right) / 2 == p};
  }
  scanText(e, n) {
    let r = [];
    for (let s = 0; s < e.length; s = cr(e.text, s)) {
      r.push(n + s);
    }
    r.push(n + e.length);
    let i = this.scan(r, s => {
      let o = r[s] - n, a = r[s + 1] - n;
      return vd(e.dom, o, a).getClientRects();
    });
    return i.after ? new Ts(r[i.i + 1], -1) : new Ts(r[i.i], 1);
  }
  scanTile(e, n) {
    if (!e.length) {
      return new Ts(n, 1);
    }
    if (e.children.length == 1) {
      let a = e.children[0];
      if (a.isText()) {
        return this.scanText(a, n);
      }
      if (a.isComposite()) {
        return this.scanTile(a, n);
      }
    }
    let r = [n];
    for (let a = 0, l = n; a < e.children.length; a++) {
      r.push(l += e.children[a].length);
    }
    let i = this.scan(r, a => {
      let l = e.children[a];
      return l.flags & 48 ? null : (l.dom.nodeType == 1 ? l.dom : vd(l.dom, 0, l.length)).getClientRects();
    }), s = e.children[i.i], o = r[i.i];
    return s.isText() ? this.scanText(s, o) : s.isComposite() ? this.scanTile(s, o) : i.after ? new Ts(r[i.i + 1], -1) : new Ts(o, 1);
  }
}
const Al = "\uffff";
class YQ {
  constructor(e, n) {
    this.points = e, this.view = n, this.text = "", this.lineSeparator = n.state.facet(Yt.lineSeparator);
  }
  append(e) {
    this.text += e;
  }
  lineBreak() {
    this.text += Al;
  }
  readRange(e, n) {
    if (!e) {
      return this;
    }
    let r = e.parentNode;
    for (let i = e;;) {
      this.findPointBefore(r, i);
      let s = this.text.length;
      this.readNode(i);
      let o = Bn.get(i), a = i.nextSibling;
      if (a == n) {
        o != null && o.breakAfter && !a && r != this.view.contentDOM && this.lineBreak();
        break;
      }
      let l = Bn.get(a);
      (o && l ? o.breakAfter : (o ? o.breakAfter : vp(i)) || vp(a) && (i.nodeName != "BR" || o != null && o.isWidget()) && this.text.length > s) && !QQ(a, n) && this.lineBreak(), i = a;
    }
    return this.findPointBefore(r, n), this;
  }
  readTextNode(e) {
    let n = e.nodeValue;
    for (let r of this.points) {
      r.node == e && (r.pos = this.text.length + Math.min(r.offset, n.length));
    }
    for (let r = 0, i = this.lineSeparator ? null : /\r\n?|\n/g;;) {
      let s = -1, o = 1, a;
      if (this.lineSeparator ? (s = n.indexOf(this.lineSeparator, r), o = this.lineSeparator.length) : (a = i.exec(n)) && (s = a.index, o = a[0].length), this.append(n.slice(r, s < 0 ? n.length : s)), s < 0) {
        break;
      }
      if (this.lineBreak(), o > 1) {
        for (let l of this.points) {
          l.node == e && l.pos > this.text.length && (l.pos -= o - 1);
        }
      }
      r = s + o;
    }
  }
  readNode(e) {
    let n = Bn.get(e), r = n && n.overrideDOMText;
    if (r != null) {
      this.findPointInside(e, r.length);
      for (let i = r.iter(); !i.next().done;) {
        i.lineBreak ? this.lineBreak() : this.append(i.value);
      }
    } else {
      e.nodeType == 3 ? this.readTextNode(e) : e.nodeName == "BR" ? e.nextSibling && this.lineBreak() : e.nodeType == 1 && this.readRange(e.firstChild, null);
    }
  }
  findPointBefore(e, n) {
    for (let r of this.points) {
      r.node == e && e.childNodes[r.offset] == n && (r.pos = this.text.length);
    }
  }
  findPointInside(e, n) {
    for (let r of this.points) {
      (e.nodeType == 3 ? r.node == e : e.contains(r.node)) && (r.pos = this.text.length + (GQ(e, r.node, r.offset) ? n : 0));
    }
  }
}
function GQ(t, e, n) {
  for (;;) {
    if (!e || n < ho(e)) {
      return !1;
    }
    if (e == t) {
      return !0;
    }
    n = ta(e) + 1, e = e.parentNode;
  }
}
function QQ(t, e) {
  let n;
  for (; !(t == e || !t); t = t.nextSibling) {
    let r = Bn.get(t);
    if (!(r != null && r.isWidget())) {
      return !1;
    }
    r && (n || (n = [])).push(r);
  }
  if (n) {
    for (let r of n) {
      let i = r.overrideDOMText;
      if (i != null && i.length) {
        return !1;
      }
    }
  }
  return !0;
}
class QS {
  constructor(e, n) {
    this.node = e, this.offset = n, this.pos = -1;
  }
}
class KQ {
  constructor(e, n, r, i) {
    this.typeOver = i, this.bounds = null, this.text = "", this.domChanged = n > -1;
    let {impreciseHead:s, impreciseAnchor:o} = e.docView, a = e.state.selection;
    if (e.state.readOnly && n > -1) {
      this.newSel = null;
    } else if (n > -1 && (this.bounds = NI(e.docView.tile, n, r, 0))) {
      let l = s || o ? [] : JQ(e), c = new YQ(l, e);
      c.readRange(this.bounds.startDOM, this.bounds.endDOM), this.text = c.text, this.newSel = ZQ(l, this.bounds.from);
    } else {
      let l = e.observer.selectionRange, c = s && s.node == l.focusNode && s.offset == l.focusOffset || !ey(e.contentDOM, l.focusNode) ? a.main.head : e.docView.posFromDOM(l.focusNode, l.focusOffset), u = o && o.node == l.anchorNode && o.offset == l.anchorOffset || !ey(e.contentDOM, l.anchorNode) ? a.main.anchor : e.docView.posFromDOM(l.anchorNode, l.anchorOffset), h = e.viewport;
      if ((Ze.ios || Ze.chrome) && a.main.empty && c != u && (h.from > 0 || h.to < e.state.doc.length)) {
        let f = Math.min(c, u), p = Math.max(c, u), g = h.from - f, m = h.to - p;
        (g == 0 || g == 1 || f == 0) && (m == 0 || m == -1 || p == e.state.doc.length) && (c = 0, u = e.state.doc.length);
      }
      if (e.inputState.composing > -1 && a.ranges.length > 1) {
        this.newSel = a.replaceRange(Ce.range(u, c));
      } else if (e.lineWrapping && u == c && !(a.main.empty && a.main.head == c) && e.inputState.lastTouchTime > Date.now() - 100) {
        let f = e.coordsAtPos(c, -1), p = 0;
        f && (p = e.inputState.lastTouchY <= f.bottom ? -1 : 1), this.newSel = Ce.create([Ce.cursor(c, p)]);
      } else {
        this.newSel = Ce.single(u, c);
      }
    }
  }
}
function NI(t, e, n, r) {
  if (t.isComposite()) {
    let i = -1, s = -1, o = -1, a = -1;
    for (let l = 0, c = r, u = r; l < t.children.length; l++) {
      let h = t.children[l], f = c + h.length;
      if (c < e && f > n) {
        return NI(h, e, n, c);
      }
      if (f >= e && i == -1 && (i = l, s = c), c > n && h.dom.parentNode == t.dom) {
        o = l, a = u;
        break;
      }
      u = f, c = f + h.breakAfter;
    }
    return {from:s, to:a < 0 ? r + t.length : a, startDOM:(i ? t.children[i - 1].dom.nextSibling : null) || t.dom.firstChild, endDOM:o < t.children.length && o >= 0 ? t.children[o].dom : null};
  } else {
    return t.isText() ? {from:r, to:r + t.length, startDOM:t.dom, endDOM:t.dom.nextSibling} : null;
  }
}
function II(t, e) {
  let n, {newSel:r} = e, {state:i} = t, s = i.selection.main, o = t.inputState.lastKeyTime > Date.now() - 100 ? t.inputState.lastKeyCode : -1;
  if (e.bounds) {
    let {from:a, to:l} = e.bounds, c = s.from, u = null;
    (o === 8 || Ze.android && e.text.length < l - a) && (c = s.to, u = "end");
    let h = i.doc.sliceString(a, l, Al), f, p;
    !s.empty && s.from >= a && s.to <= l && (e.typeOver || h != e.text) && h.slice(0, s.from - a) == e.text.slice(0, s.from - a) && h.slice(s.to - a) == e.text.slice(f = e.text.length - (h.length - (s.to - a))) ? n = {from:s.from, to:s.to, insert:Xt.of(e.text.slice(s.from - a, f).split(Al))} : (p = OI(h, e.text, c - a, u)) && (Ze.chrome && o == 13 && p.toB == p.from + 2 && e.text.slice(p.from, p.toB) == Al + Al && p.toB--, n = {from:a + p.from, to:a + p.toA, insert:Xt.of(e.text.slice(p.from, p.toB).split(Al))});
  } else {
    r && (!t.hasFocus && i.facet(no) || kp(r, s)) && (r = null);
  }
  if (!n && !r) {
    return !1;
  }
  if ((Ze.mac || Ze.android) && n && n.from == n.to && n.from == s.head - 1 && /^\. ?$/.test(n.insert.toString()) && t.contentDOM.getAttribute("autocorrect") == "off" ? (r && n.insert.length == 2 && (r = Ce.single(r.main.anchor - 1, r.main.head - 1)), n = {from:n.from, to:n.to, insert:Xt.of([n.insert.toString().replace(".", " ")])}) : i.doc.lineAt(s.from).to < s.to && t.docView.lineHasWidget(s.to) && t.inputState.insertingTextAt > Date.now() - 50 ? n = {from:s.from, to:s.to, insert:i.toText(t.inputState.insertingText)} : 
  Ze.chrome && n && n.from == n.to && n.from == s.head && n.insert.toString() == `
 ` && t.lineWrapping && (r && (r = Ce.single(r.main.anchor - 1, r.main.head - 1)), n = {from:s.from, to:s.to, insert:Xt.of([" "])}), n) {
    return y1(t, n, r, o);
  }
  if (r && !kp(r, s)) {
    let a = !1, l = "select";
    return t.inputState.lastSelectionTime > Date.now() - 50 && (t.inputState.lastSelectionOrigin == "select" && (a = !0), l = t.inputState.lastSelectionOrigin, l == "select.pointer" && (r = AI(i.facet(th).map(c => c(t)), r))), t.dispatch({selection:r, scrollIntoView:a, userEvent:l}), !0;
  } else {
    return !1;
  }
}
function y1(t, e, n, r = -1) {
  if (Ze.ios && t.inputState.flushIOSKey(e)) {
    return !0;
  }
  let i = t.state.selection.main;
  if (Ze.android && (e.to == i.to && (e.from == i.from || e.from == i.from - 1 && t.state.sliceDoc(e.from, i.from) == " ") && e.insert.length == 1 && e.insert.lines == 2 && Jl(t.contentDOM, "Enter", 13) || (e.from == i.from - 1 && e.to == i.to && e.insert.length == 0 || r == 8 && e.insert.length < e.to - e.from && e.to > i.head) && Jl(t.contentDOM, "Backspace", 8) || e.from == i.from && e.to == i.to + 1 && e.insert.length == 0 && Jl(t.contentDOM, "Delete", 46))) {
    return !0;
  }
  let s = e.insert.toString();
  t.inputState.composing >= 0 && t.inputState.composing++;
  let o, a = () => o || (o = XQ(t, e, n));
  return t.state.facet(mI).some(l => l(t, e.from, e.to, s, a)) || t.dispatch(a()), !0;
}
function XQ(t, e, n) {
  let r, i = t.state, s = i.selection.main, o = -1;
  if (e.from == e.to && e.from < s.from || e.from > s.to) {
    let l = e.from < s.from ? -1 : 1, c = l < 0 ? s.from : s.to, u = Ju(i.facet(th).map(h => h(t)), c, l);
    e.from == u && (o = u);
  }
  if (o > -1) {
    r = {changes:e, selection:Ce.cursor(e.from + e.insert.length, -1)};
  } else if (e.from >= s.from && e.to <= s.to && e.to - e.from >= (s.to - s.from) / 3 && (!n || n.main.empty && n.main.from == e.from + e.insert.length) && t.inputState.composing < 0) {
    let l = s.from < e.from ? i.sliceDoc(s.from, e.from) : "", c = s.to > e.to ? i.sliceDoc(e.to, s.to) : "";
    r = i.replaceSelection(t.state.toText(l + e.insert.sliceString(0, void 0, t.state.lineBreak) + c));
  } else {
    let l = i.changes(e), c = n && n.main.to <= l.newLength ? n.main : void 0;
    if (i.selection.ranges.length > 1 && (t.inputState.composing >= 0 || t.inputState.compositionPendingChange) && e.to <= s.to + 10 && e.to >= s.to - 10) {
      let u = t.state.sliceDoc(e.from, e.to), h, f = n && CI(t, n.main.head);
      if (f) {
        let g = e.insert.length - (e.to - e.from);
        h = {from:f.from, to:f.to - g};
      } else {
        h = t.state.doc.lineAt(s.head);
      }
      let p = s.to - e.to;
      r = i.changeByRange(g => {
        if (g.from == s.from && g.to == s.to) {
          return {changes:l, range:c || g.map(l)};
        }
        let m = g.to - p, b = m - u.length;
        if (t.state.sliceDoc(b, m) != u || m >= h.from && b <= h.to) {
          return {range:g};
        }
        let x = i.changes({from:b, to:m, insert:e.insert}), w = g.to - s.to;
        return {changes:x, range:c ? Ce.range(Math.max(0, c.anchor + w), Math.max(0, c.head + w)) : g.map(x)};
      });
    } else {
      r = {changes:l, selection:c && i.selection.replaceRange(c)};
    }
  }
  let a = "input.type";
  return (t.composing || t.inputState.compositionPendingChange && t.inputState.compositionEndedAt > Date.now() - 50) && (t.inputState.compositionPendingChange = !1, a += ".compose", t.inputState.compositionFirstChange && (a += ".start", t.inputState.compositionFirstChange = !1)), i.update(r, {userEvent:a, scrollIntoView:!0});
}
function OI(t, e, n, r) {
  let i = Math.min(t.length, e.length), s = 0;
  for (; s < i && t.charCodeAt(s) == e.charCodeAt(s);) {
    s++;
  }
  if (s == i && t.length == e.length) {
    return null;
  }
  let o = t.length, a = e.length;
  for (; o > 0 && a > 0 && t.charCodeAt(o - 1) == e.charCodeAt(a - 1);) {
    o--, a--;
  }
  if (r == "end") {
    let l = Math.max(0, s - Math.min(o, a));
    n -= o + l - s;
  }
  if (o < s && t.length < e.length) {
    let l = n <= s && n >= o ? s - n : 0;
    s -= l, a = s + (a - o), o = s;
  } else if (a < s) {
    let l = n <= s && n >= a ? s - n : 0;
    s -= l, o = s + (o - a), a = s;
  }
  return {from:s, toA:o, toB:a};
}
function JQ(t) {
  let e = [];
  if (t.root.activeElement != t.contentDOM) {
    return e;
  }
  let {anchorNode:n, anchorOffset:r, focusNode:i, focusOffset:s} = t.observer.selectionRange;
  return n && (e.push(new QS(n, r)), (i != n || s != r) && e.push(new QS(i, s))), e;
}
function ZQ(t, e) {
  if (t.length == 0) {
    return null;
  }
  let n = t[0].pos, r = t.length == 2 ? t[1].pos : n;
  return n > -1 && r > -1 ? Ce.single(n + e, r + e) : null;
}
function kp(t, e) {
  return e.head == t.main.head && e.anchor == t.main.anchor;
}
class eK {
  setSelectionOrigin(e) {
    this.lastSelectionOrigin = e, this.lastSelectionTime = Date.now();
  }
  constructor(e) {
    this.view = e, this.lastKeyCode = 0, this.lastKeyTime = 0, this.lastTouchTime = 0, this.lastTouchX = 0, this.lastTouchY = 0, this.lastFocusTime = 0, this.lastScrollTop = 0, this.lastScrollLeft = 0, this.lastWheelEvent = 0, this.pendingIOSKey = void 0, this.tabFocusMode = -1, this.lastSelectionOrigin = null, this.lastSelectionTime = 0, this.lastContextMenu = 0, this.scrollHandlers = [], this.handlers = Object.create(null), this.composing = -1, this.compositionFirstChange = null, this.compositionEndedAt = 
    0, this.compositionPendingKey = !1, this.compositionPendingChange = !1, this.insertingText = "", this.insertingTextAt = 0, this.mouseSelection = null, this.draggedContent = null, this.handleEvent = this.handleEvent.bind(this), this.notifiedFocused = e.hasFocus, Ze.safari && e.contentDOM.addEventListener("input", () => null), Ze.gecko && gK(e.contentDOM.ownerDocument);
  }
  handleEvent(e) {
    !lK(this.view, e) || this.ignoreDuringComposition(e) || e.type == "keydown" && this.keydown(e) || (this.view.updateState != 0 ? Promise.resolve().then(() => this.runHandlers(e.type, e)) : this.runHandlers(e.type, e));
  }
  runHandlers(e, n) {
    let r = this.handlers[e];
    if (r) {
      for (let i of r.observers) {
        i(this.view, n);
      }
      for (let i of r.handlers) {
        if (n.defaultPrevented) {
          break;
        }
        if (i(this.view, n)) {
          n.preventDefault();
          break;
        }
      }
    }
  }
  ensureHandlers(e) {
    let n = tK(e), r = this.handlers, i = this.view.contentDOM;
    for (let s in n) {
      if (s != "scroll") {
        let o = !n[s].handlers.length, a = r[s];
        a && o != !a.handlers.length && (i.removeEventListener(s, this.handleEvent), a = null), a || i.addEventListener(s, this.handleEvent, {passive:o});
      }
    }
    for (let s in r) {
      s != "scroll" && !n[s] && i.removeEventListener(s, this.handleEvent);
    }
    this.handlers = n;
  }
  keydown(e) {
    if (this.lastKeyCode = e.keyCode, this.lastKeyTime = Date.now(), e.keyCode == 9 && this.tabFocusMode > -1 && (!this.tabFocusMode || Date.now() <= this.tabFocusMode)) {
      return !0;
    }
    if (this.tabFocusMode > 0 && e.keyCode != 27 && RI.indexOf(e.keyCode) < 0 && (this.tabFocusMode = -1), Ze.android && Ze.chrome && !e.synthetic && (e.keyCode == 13 || e.keyCode == 8)) {
      return this.view.observer.delayAndroidKey(e.key, e.keyCode), !0;
    }
    let n;
    return Ze.ios && !e.synthetic && !e.altKey && !e.metaKey && !e.shiftKey && ((n = PI.find(r => r.keyCode == e.keyCode)) && !e.ctrlKey || nK.indexOf(e.key) > -1 && e.ctrlKey) ? (this.pendingIOSKey = n || e, setTimeout(() => this.flushIOSKey(), 250), !0) : (e.keyCode != 229 && this.view.observer.forceFlush(), !1);
  }
  flushIOSKey(e) {
    let n = this.pendingIOSKey;
    return !n || n.key == "Enter" && e && e.from < e.to && /^\S+$/.test(e.insert.toString()) ? !1 : (this.pendingIOSKey = void 0, Jl(this.view.contentDOM, n.key, n.keyCode, n instanceof KeyboardEvent ? n : void 0));
  }
  ignoreDuringComposition(e) {
    return !/^key/.test(e.type) || e.synthetic ? !1 : this.composing > 0 ? !0 : Ze.safari && !Ze.ios && this.compositionPendingKey && Date.now() - this.compositionEndedAt < 100 ? (this.compositionPendingKey = !1, !0) : !1;
  }
  startMouseSelection(e) {
    this.mouseSelection && this.mouseSelection.destroy(), this.mouseSelection = e;
  }
  update(e) {
    this.view.observer.update(e), this.mouseSelection && this.mouseSelection.update(e), this.draggedContent && e.docChanged && (this.draggedContent = this.draggedContent.map(e.changes)), e.transactions.length && (this.lastKeyCode = this.lastSelectionTime = 0);
  }
  destroy() {
    this.mouseSelection && this.mouseSelection.destroy();
  }
}
function KS(t, e) {
  return (n, r) => {
    try {
      return e.call(t, r, n);
    } catch (i) {
      Pi(n.state, i);
    }
  };
}
function tK(t) {
  let e = Object.create(null);
  function n(r) {
    return e[r] || (e[r] = {observers:[], handlers:[]});
  }
  for (let r of t) {
    let i = r.spec, s = i && i.plugin.domEventHandlers, o = i && i.plugin.domEventObservers;
    if (s) {
      for (let a in s) {
        let l = s[a];
        l && n(a).handlers.push(KS(r.value, l));
      }
    }
    if (o) {
      for (let a in o) {
        let l = o[a];
        l && n(a).observers.push(KS(r.value, l));
      }
    }
  }
  for (let r in os) {
    n(r).handlers.push(os[r]);
  }
  for (let r in ei) {
    n(r).observers.push(ei[r]);
  }
  return e;
}
const PI = [{key:"Backspace", keyCode:8, inputType:"deleteContentBackward"}, {key:"Enter", keyCode:13, inputType:"insertParagraph"}, {key:"Enter", keyCode:13, inputType:"insertLineBreak"}, {key:"Delete", keyCode:46, inputType:"deleteContentForward"}], nK = "dthko", RI = [16, 17, 18, 20, 91, 92, 224, 225], zh = 6;
function Hh(t) {
  return Math.max(0, t) * 0.7 + 8;
}
function rK(t, e) {
  return Math.max(Math.abs(t.clientX - e.clientX), Math.abs(t.clientY - e.clientY));
}
class iK {
  constructor(e, n, r, i) {
    this.view = e, this.startEvent = n, this.style = r, this.mustSelect = i, this.scrollSpeed = {x:0, y:0}, this.scrolling = -1, this.lastEvent = n, this.scrollParents = nI(e.contentDOM), this.atoms = e.state.facet(th).map(o => o(e));
    let s = e.contentDOM.ownerDocument;
    s.addEventListener("mousemove", this.move = this.move.bind(this)), s.addEventListener("mouseup", this.up = this.up.bind(this)), this.extend = n.shiftKey, this.multiple = e.state.facet(Yt.allowMultipleSelections) && sK(e, n), this.dragging = aK(e, n) && MI(n) == 1 ? null : !1;
  }
  start(e) {
    this.dragging === !1 && this.select(e);
  }
  move(e) {
    if (e.buttons == 0) {
      return this.destroy();
    }
    if (this.dragging || this.dragging == null && rK(this.startEvent, e) < 10) {
      return;
    }
    this.select(this.lastEvent = e);
    let n = 0, r = 0, i = 0, s = 0, o = this.view.win.innerWidth, a = this.view.win.innerHeight;
    this.scrollParents.x && ({left:i, right:o} = this.scrollParents.x.getBoundingClientRect()), this.scrollParents.y && ({top:s, bottom:a} = this.scrollParents.y.getBoundingClientRect());
    let l = b1(this.view);
    e.clientX - l.left <= i + zh ? n = -Hh(i - e.clientX) : e.clientX + l.right >= o - zh && (n = Hh(e.clientX - o)), e.clientY - l.top <= s + zh ? r = -Hh(s - e.clientY) : e.clientY + l.bottom >= a - zh && (r = Hh(e.clientY - a)), this.setScrollSpeed(n, r);
  }
  up(e) {
    this.dragging == null && this.select(this.lastEvent), this.dragging || e.preventDefault(), this.destroy();
  }
  destroy() {
    this.setScrollSpeed(0, 0);
    let e = this.view.contentDOM.ownerDocument;
    e.removeEventListener("mousemove", this.move), e.removeEventListener("mouseup", this.up), this.view.inputState.mouseSelection = this.view.inputState.draggedContent = null;
  }
  setScrollSpeed(e, n) {
    this.scrollSpeed = {x:e, y:n}, e || n ? this.scrolling < 0 && (this.scrolling = setInterval(() => this.scroll(), 50)) : this.scrolling > -1 && (clearInterval(this.scrolling), this.scrolling = -1);
  }
  scroll() {
    let {x:e, y:n} = this.scrollSpeed;
    e && this.scrollParents.x && (this.scrollParents.x.scrollLeft += e, e = 0), n && this.scrollParents.y && (this.scrollParents.y.scrollTop += n, n = 0), (e || n) && this.view.win.scrollBy(e, n), this.dragging === !1 && this.select(this.lastEvent);
  }
  select(e) {
    let {view:n} = this, r = AI(this.atoms, this.style.get(e, this.extend, this.multiple));
    (this.mustSelect || !r.eq(n.state.selection, this.dragging === !1)) && this.view.dispatch({selection:r, userEvent:"select.pointer"}), this.mustSelect = !1;
  }
  update(e) {
    e.transactions.some(n => n.isUserEvent("input.type")) ? this.destroy() : this.style.update(e) && setTimeout(() => this.select(this.lastEvent), 20);
  }
}
function sK(t, e) {
  let n = t.state.facet(hI);
  return n.length ? n[0](e) : Ze.mac ? e.metaKey : e.ctrlKey;
}
function oK(t, e) {
  let n = t.state.facet(fI);
  return n.length ? n[0](e) : Ze.mac ? !e.altKey : !e.ctrlKey;
}
function aK(t, e) {
  let {main:n} = t.state.selection;
  if (n.empty) {
    return !1;
  }
  let r = yd(t.root);
  if (!r || r.rangeCount == 0) {
    return !0;
  }
  let i = r.getRangeAt(0).getClientRects();
  for (let s = 0; s < i.length; s++) {
    let o = i[s];
    if (o.left <= e.clientX && o.right >= e.clientX && o.top <= e.clientY && o.bottom >= e.clientY) {
      return !0;
    }
  }
  return !1;
}
function lK(t, e) {
  if (!e.bubbles) {
    return !0;
  }
  if (e.defaultPrevented) {
    return !1;
  }
  for (let n = e.target, r; n != t.contentDOM; n = n.parentNode) {
    if (!n || n.nodeType == 11 || (r = Bn.get(n)) && r.isWidget() && !r.isHidden && r.widget.ignoreEvent(e)) {
      return !1;
    }
  }
  return !0;
}
const os = Object.create(null), ei = Object.create(null), DI = Ze.ie && Ze.ie_version < 15 || Ze.ios && Ze.webkit_version < 604;
function cK(t) {
  let e = t.dom.parentNode;
  if (!e) {
    return;
  }
  let n = e.appendChild(document.createElement("textarea"));
  n.style.cssText = "position: fixed; left: -10000px; top: 10px", n.focus(), setTimeout(() => {
    t.focus(), n.remove(), LI(t, n.value);
  }, 50);
}
function Bg(t, e, n) {
  for (let r of t.facet(e)) {
    n = r(n, t);
  }
  return n;
}
function LI(t, e) {
  e = Bg(t.state, f1, e);
  let {state:n} = t, r, i = 1, s = n.toText(e), o = s.lines == n.selection.ranges.length;
  if (ly != null && n.selection.ranges.every(l => l.empty) && ly == s.toString()) {
    let l = -1;
    r = n.changeByRange(c => {
      let u = n.doc.lineAt(c.from);
      if (u.from == l) {
        return {range:c};
      }
      l = u.from;
      let h = n.toText((o ? s.line(i++).text : e) + n.lineBreak);
      return {changes:{from:u.from, insert:h}, range:Ce.cursor(c.from + h.length)};
    });
  } else {
    o ? r = n.changeByRange(l => {
      let c = s.line(i++);
      return {changes:{from:l.from, to:l.to, insert:c.text}, range:Ce.cursor(l.from + c.length)};
    }) : r = n.replaceSelection(s);
  }
  t.dispatch(r, {userEvent:"input.paste", scrollIntoView:!0});
}
ei.scroll = t => {
  t.inputState.lastScrollTop = t.scrollDOM.scrollTop, t.inputState.lastScrollLeft = t.scrollDOM.scrollLeft;
};
ei.wheel = ei.mousewheel = t => {
  t.inputState.lastWheelEvent = Date.now();
};
os.keydown = (t, e) => (t.inputState.setSelectionOrigin("select"), e.keyCode == 27 && t.inputState.tabFocusMode != 0 && (t.inputState.tabFocusMode = Date.now() + 2e3), !1);
ei.touchstart = (t, e) => {
  let n = t.inputState, r = e.targetTouches[0];
  n.lastTouchTime = Date.now(), r && (n.lastTouchX = r.clientX, n.lastTouchY = r.clientY), n.setSelectionOrigin("select.pointer");
};
ei.touchmove = t => {
  t.inputState.setSelectionOrigin("select.pointer");
};
os.mousedown = (t, e) => {
  if (t.observer.flush(), t.inputState.lastTouchTime > Date.now() - 2e3) {
    return !1;
  }
  let n = null;
  for (let r of t.state.facet(pI)) {
    if (n = r(t, e), n) {
      break;
    }
  }
  if (!n && e.button == 0 && (n = dK(t, e)), n) {
    let r = !t.hasFocus;
    t.inputState.startMouseSelection(new iK(t, e, n, r)), r && t.observer.ignore(() => {
      rI(t.contentDOM);
      let s = t.root.activeElement;
      s && !s.contains(t.contentDOM) && s.blur();
    });
    let i = t.inputState.mouseSelection;
    if (i) {
      return i.start(e), i.dragging === !1;
    }
  } else {
    t.inputState.setSelectionOrigin("select.pointer");
  }
  return !1;
};
function XS(t, e, n, r) {
  if (r == 1) {
    return Ce.cursor(e, n);
  }
  if (r == 2) {
    return HQ(t.state, e, n);
  }
  {
    let i = t.docView.lineAt(e, n), s = t.state.doc.lineAt(i ? i.posAtEnd : e), o = i ? i.posAtStart : s.from, a = i ? i.posAtEnd : s.to;
    return a < t.state.doc.length && a == s.to && a++, Ce.range(o, a);
  }
}
const uK = Ze.ie && Ze.ie_version <= 11;
let JS = null, ZS = 0, ek = 0;
function MI(t) {
  if (!uK) {
    return t.detail;
  }
  let e = JS, n = ek;
  return JS = t, ek = Date.now(), ZS = !e || n > Date.now() - 400 && Math.abs(e.clientX - t.clientX) < 2 && Math.abs(e.clientY - t.clientY) < 2 ? (ZS + 1) % 3 : 1;
}
function dK(t, e) {
  let n = t.posAndSideAtCoords({x:e.clientX, y:e.clientY}, !1), r = MI(e), i = t.state.selection;
  return {update(s) {
    s.docChanged && (n.pos = s.changes.mapPos(n.pos), i = i.map(s.changes));
  }, get(s, o, a) {
    let l = t.posAndSideAtCoords({x:s.clientX, y:s.clientY}, !1), c, u = XS(t, l.pos, l.assoc, r);
    if (n.pos != l.pos && !o) {
      let h = XS(t, n.pos, n.assoc, r), f = Math.min(h.from, u.from), p = Math.max(h.to, u.to);
      u = f < u.from ? Ce.range(f, p, u.assoc) : Ce.range(p, f, u.assoc);
    }
    return o ? i.replaceRange(i.main.extend(u.from, u.to, u.assoc)) : a && r == 1 && i.ranges.length > 1 && (c = hK(i, l.pos)) ? c : a ? i.addRange(u) : Ce.create([u]);
  }};
}
function hK(t, e) {
  for (let n = 0; n < t.ranges.length; n++) {
    let {from:r, to:i} = t.ranges[n];
    if (r <= e && i >= e) {
      return Ce.create(t.ranges.slice(0, n).concat(t.ranges.slice(n + 1)), t.mainIndex == n ? 0 : t.mainIndex - (t.mainIndex > n ? 1 : 0));
    }
  }
  return null;
}
os.dragstart = (t, e) => {
  let {selection:{main:n}} = t.state;
  if (e.target.draggable) {
    let i = t.docView.tile.nearest(e.target);
    if (i && i.isWidget()) {
      let s = i.posAtStart, o = s + i.length;
      (s >= n.to || o <= n.from) && (n = Ce.range(s, o));
    }
  }
  let {inputState:r} = t;
  return r.mouseSelection && (r.mouseSelection.dragging = !0), r.draggedContent = n, e.dataTransfer && (e.dataTransfer.setData("Text", Bg(t.state, p1, t.state.sliceDoc(n.from, n.to))), e.dataTransfer.effectAllowed = "copyMove"), !1;
};
os.dragend = t => (t.inputState.draggedContent = null, !1);
function tk(t, e, n, r) {
  if (n = Bg(t.state, f1, n), !n) {
    return;
  }
  let i = t.posAtCoords({x:e.clientX, y:e.clientY}, !1), {draggedContent:s} = t.inputState, o = r && s && oK(t, e) ? {from:s.from, to:s.to} : null, a = {from:i, insert:n}, l = t.state.changes(o ? [o, a] : a);
  t.focus(), t.dispatch({changes:l, selection:{anchor:l.mapPos(i, -1), head:l.mapPos(i, 1)}, userEvent:o ? "move.drop" : "input.drop"}), t.inputState.draggedContent = null;
}
os.drop = (t, e) => {
  if (!e.dataTransfer) {
    return !1;
  }
  if (t.state.readOnly) {
    return !0;
  }
  let n = e.dataTransfer.files;
  if (n && n.length) {
    let r = Array(n.length), i = 0, s = () => {
      ++i == n.length && tk(t, e, r.filter(o => o != null).join(t.state.lineBreak), !1);
    };
    for (let o = 0; o < n.length; o++) {
      let a = new FileReader();
      a.onerror = s, a.onload = () => {
        /[\x00-\x08\x0e-\x1f]{2}/.test(a.result) || (r[o] = a.result), s();
      }, a.readAsText(n[o]);
    }
    return !0;
  } else {
    let r = e.dataTransfer.getData("Text");
    if (r) {
      return tk(t, e, r, !0), !0;
    }
  }
  return !1;
};
os.paste = (t, e) => {
  if (t.state.readOnly) {
    return !0;
  }
  t.observer.flush();
  let n = DI ? null : e.clipboardData;
  return n ? (LI(t, n.getData("text/plain") || n.getData("text/uri-list")), !0) : (cK(t), !1);
};
function fK(t, e) {
  let n = t.dom.parentNode;
  if (!n) {
    return;
  }
  let r = n.appendChild(document.createElement("textarea"));
  r.style.cssText = "position: fixed; left: -10000px; top: 10px", r.value = e, r.focus(), r.selectionEnd = e.length, r.selectionStart = 0, setTimeout(() => {
    r.remove(), t.focus();
  }, 50);
}
function pK(t) {
  let e = [], n = [], r = !1;
  for (let i of t.selection.ranges) {
    i.empty || (e.push(t.sliceDoc(i.from, i.to)), n.push(i));
  }
  if (!e.length) {
    let i = -1;
    for (let {from:s} of t.selection.ranges) {
      let o = t.doc.lineAt(s);
      o.number > i && (e.push(o.text), n.push({from:o.from, to:Math.min(t.doc.length, o.to + 1)})), i = o.number;
    }
    r = !0;
  }
  return {text:Bg(t, p1, e.join(t.lineBreak)), ranges:n, linewise:r};
}
let ly = null;
os.copy = os.cut = (t, e) => {
  if (!Qu(t.contentDOM, t.observer.selectionRange)) {
    return !1;
  }
  let {text:n, ranges:r, linewise:i} = pK(t.state);
  if (!n && !i) {
    return !1;
  }
  ly = i ? n : null, e.type == "cut" && !t.state.readOnly && t.dispatch({changes:r, scrollIntoView:!0, userEvent:"delete.cut"});
  let s = DI ? null : e.clipboardData;
  return s ? (s.clearData(), s.setData("text/plain", n), !0) : (fK(t, n), !1);
};
const BI = la.define();
function $I(t, e) {
  let n = [];
  for (let r of t.facet(bI)) {
    let i = r(t, e);
    i && n.push(i);
  }
  return n.length ? t.update({effects:n, annotations:BI.of(!0)}) : null;
}
function FI(t) {
  setTimeout(() => {
    let e = t.hasFocus;
    if (e != t.inputState.notifiedFocused) {
      let n = $I(t.state, e);
      n ? t.dispatch(n) : t.update([]);
    }
  }, 10);
}
ei.focus = t => {
  t.inputState.lastFocusTime = Date.now(), !t.scrollDOM.scrollTop && (t.inputState.lastScrollTop || t.inputState.lastScrollLeft) && (t.scrollDOM.scrollTop = t.inputState.lastScrollTop, t.scrollDOM.scrollLeft = t.inputState.lastScrollLeft), FI(t);
};
ei.blur = t => {
  t.observer.clearSelectionRange(), FI(t);
};
ei.compositionstart = ei.compositionupdate = t => {
  t.observer.editContext || (t.inputState.compositionFirstChange == null && (t.inputState.compositionFirstChange = !0), t.inputState.composing < 0 && (t.inputState.composing = 0));
};
ei.compositionend = t => {
  t.observer.editContext || (t.inputState.composing = -1, t.inputState.compositionEndedAt = Date.now(), t.inputState.compositionPendingKey = !0, t.inputState.compositionPendingChange = t.observer.pendingRecords().length > 0, t.inputState.compositionFirstChange = null, Ze.chrome && Ze.android ? t.observer.flushSoon() : t.inputState.compositionPendingChange ? Promise.resolve().then(() => t.observer.flush()) : setTimeout(() => {
    t.inputState.composing < 0 && t.docView.hasComposition && t.update([]);
  }, 50));
};
ei.contextmenu = t => {
  t.inputState.lastContextMenu = Date.now();
};
os.beforeinput = (t, e) => {
  var n, r;
  if ((e.inputType == "insertText" || e.inputType == "insertCompositionText") && (t.inputState.insertingText = e.data, t.inputState.insertingTextAt = Date.now()), e.inputType == "insertReplacementText" && t.observer.editContext) {
    let s = (n = e.dataTransfer) === null || n === void 0 ? void 0 : n.getData("text/plain"), o = e.getTargetRanges();
    if (s && o.length) {
      let a = o[0], l = t.posAtDOM(a.startContainer, a.startOffset), c = t.posAtDOM(a.endContainer, a.endOffset);
      return y1(t, {from:l, to:c, insert:t.state.toText(s)}, null), !0;
    }
  }
  let i;
  if (Ze.chrome && Ze.android && (i = PI.find(s => s.inputType == e.inputType)) && (t.observer.delayAndroidKey(i.key, i.keyCode), i.key == "Backspace" || i.key == "Delete")) {
    let s = ((r = window.visualViewport) === null || r === void 0 ? void 0 : r.height) || 0;
    setTimeout(() => {
      var o;
      (((o = window.visualViewport) === null || o === void 0 ? void 0 : o.height) || 0) > s + 10 && t.hasFocus && (t.contentDOM.blur(), t.focus());
    }, 100);
  }
  return Ze.ios && e.inputType == "deleteContentForward" && t.observer.flushSoon(), Ze.safari && e.inputType == "insertText" && t.inputState.composing >= 0 && setTimeout(() => ei.compositionend(t, e), 20), !1;
};
const nk = new Set();
function gK(t) {
  nk.has(t) || (nk.add(t), t.addEventListener("copy", () => {
  }), t.addEventListener("cut", () => {
  }));
}
const rk = ["pre-wrap", "normal", "pre-line", "break-spaces"];
let dc = !1;
function ik() {
  dc = !1;
}
class mK {
  constructor(e) {
    this.lineWrapping = e, this.doc = Xt.empty, this.heightSamples = {}, this.lineHeight = 14, this.charWidth = 7, this.textHeight = 14, this.lineLength = 30;
  }
  heightForGap(e, n) {
    let r = this.doc.lineAt(n).number - this.doc.lineAt(e).number + 1;
    return this.lineWrapping && (r += Math.max(0, Math.ceil((n - e - r * this.lineLength * 0.5) / this.lineLength))), this.lineHeight * r;
  }
  heightForLine(e) {
    return this.lineWrapping ? (1 + Math.max(0, Math.ceil((e - this.lineLength) / Math.max(1, this.lineLength - 5)))) * this.lineHeight : this.lineHeight;
  }
  setDoc(e) {
    return this.doc = e, this;
  }
  mustRefreshForWrapping(e) {
    return rk.indexOf(e) > -1 != this.lineWrapping;
  }
  mustRefreshForHeights(e) {
    let n = !1;
    for (let r = 0; r < e.length; r++) {
      let i = e[r];
      i < 0 ? r++ : this.heightSamples[Math.floor(i * 10)] || (n = !0, this.heightSamples[Math.floor(i * 10)] = !0);
    }
    return n;
  }
  refresh(e, n, r, i, s, o) {
    let a = rk.indexOf(e) > -1, l = Math.abs(n - this.lineHeight) > 0.3 || this.lineWrapping != a;
    if (this.lineWrapping = a, this.lineHeight = n, this.charWidth = r, this.textHeight = i, this.lineLength = s, l) {
      this.heightSamples = {};
      for (let c = 0; c < o.length; c++) {
        let u = o[c];
        u < 0 ? c++ : this.heightSamples[Math.floor(u * 10)] = !0;
      }
    }
    return l;
  }
}
class bK {
  constructor(e, n) {
    this.from = e, this.heights = n, this.index = 0;
  }
  get more() {
    return this.index < this.heights.length;
  }
}
class Gi {
  constructor(e, n, r, i, s) {
    this.from = e, this.length = n, this.top = r, this.height = i, this._content = s;
  }
  get type() {
    return typeof this._content == "number" ? br.Text : Array.isArray(this._content) ? this._content : this._content.type;
  }
  get to() {
    return this.from + this.length;
  }
  get bottom() {
    return this.top + this.height;
  }
  get widget() {
    return this._content instanceof Za ? this._content.widget : null;
  }
  get widgetLineBreaks() {
    return typeof this._content == "number" ? this._content : 0;
  }
  join(e) {
    let n = (Array.isArray(this._content) ? this._content : [this]).concat(Array.isArray(e._content) ? e._content : [e]);
    return new Gi(this.from, this.length + e.length, this.top, this.height + e.height, n);
  }
}
var yn = function(t) {
  return t[t.ByPos = 0] = "ByPos", t[t.ByHeight = 1] = "ByHeight", t[t.ByPosNoHeight = 2] = "ByPosNoHeight", t;
}(yn || (yn = {}));
const Lf = 1e-3;
class Hr {
  constructor(e, n, r = 2) {
    this.length = e, this.height = n, this.flags = r;
  }
  get outdated() {
    return (this.flags & 2) > 0;
  }
  set outdated(e) {
    this.flags = (e ? 2 : 0) | this.flags & -3;
  }
  setHeight(e) {
    this.height != e && (Math.abs(this.height - e) > Lf && (dc = !0), this.height = e);
  }
  replace(e, n, r) {
    return Hr.of(r);
  }
  decomposeLeft(e, n) {
    n.push(this);
  }
  decomposeRight(e, n) {
    n.push(this);
  }
  applyChanges(e, n, r, i) {
    let s = this, o = r.doc;
    for (let a = i.length - 1; a >= 0; a--) {
      let {fromA:l, toA:c, fromB:u, toB:h} = i[a], f = s.lineAt(l, yn.ByPosNoHeight, r.setDoc(n), 0, 0), p = f.to >= c ? f : s.lineAt(c, yn.ByPosNoHeight, r, 0, 0);
      for (h += p.to - c, c = p.to; a > 0 && f.from <= i[a - 1].toA;) {
        l = i[a - 1].fromA, u = i[a - 1].fromB, a--, l < f.from && (f = s.lineAt(l, yn.ByPosNoHeight, r, 0, 0));
      }
      u += f.from - l, l = f.from;
      let g = x1.build(r.setDoc(o), e, u, h);
      s = Ep(s, s.replace(l, c, g));
    }
    return s.updateHeight(r, 0);
  }
  static empty() {
    return new pi(0, 0, 0);
  }
  static of(e) {
    if (e.length == 1) {
      return e[0];
    }
    let n = 0, r = e.length, i = 0, s = 0;
    for (;;) {
      if (n == r) {
        if (i > s * 2) {
          let a = e[n - 1];
          a.break ? e.splice(--n, 1, a.left, null, a.right) : e.splice(--n, 1, a.left, a.right), r += 1 + a.break, i -= a.size;
        } else if (s > i * 2) {
          let a = e[r];
          a.break ? e.splice(r, 1, a.left, null, a.right) : e.splice(r, 1, a.left, a.right), r += 2 + a.break, s -= a.size;
        } else {
          break;
        }
      } else if (i < s) {
        let a = e[n++];
        a && (i += a.size);
      } else {
        let a = e[--r];
        a && (s += a.size);
      }
    }
    let o = 0;
    return e[n - 1] == null ? (o = 1, n--) : e[n] == null && (o = 1, r++), new xK(Hr.of(e.slice(0, n)), o, Hr.of(e.slice(r)));
  }
}
function Ep(t, e) {
  return t == e ? t : (t.constructor != e.constructor && (dc = !0), e);
}
Hr.prototype.size = 1;
const yK = pt.replace({});
class zI extends Hr {
  constructor(e, n, r) {
    super(e, n), this.deco = r, this.spaceAbove = 0;
  }
  mainBlock(e, n) {
    return new Gi(n, this.length, e + this.spaceAbove, this.height - this.spaceAbove, this.deco || 0);
  }
  blockAt(e, n, r, i) {
    return this.spaceAbove && e < r + this.spaceAbove ? new Gi(i, 0, r, this.spaceAbove, yK) : this.mainBlock(r, i);
  }
  lineAt(e, n, r, i, s) {
    let o = this.mainBlock(i, s);
    return this.spaceAbove ? this.blockAt(0, r, i, s).join(o) : o;
  }
  forEachLine(e, n, r, i, s, o) {
    e <= s + this.length && n >= s && o(this.lineAt(0, yn.ByPos, r, i, s));
  }
  setMeasuredHeight(e) {
    let n = e.heights[e.index++];
    n < 0 ? (this.spaceAbove = -n, n = e.heights[e.index++]) : this.spaceAbove = 0, this.setHeight(n);
  }
  updateHeight(e, n = 0, r = !1, i) {
    return i && i.from <= n && i.more && this.setMeasuredHeight(i), this.outdated = !1, this;
  }
  toString() {
    return `block(${this.length})`;
  }
}
class pi extends zI {
  constructor(e, n, r) {
    super(e, n, null), this.collapsed = 0, this.widgetHeight = 0, this.breaks = 0, this.spaceAbove = r;
  }
  mainBlock(e, n) {
    return new Gi(n, this.length, e + this.spaceAbove, this.height - this.spaceAbove, this.breaks);
  }
  replace(e, n, r) {
    let i = r[0];
    return r.length == 1 && (i instanceof pi || i instanceof dr && i.flags & 4) && Math.abs(this.length - i.length) < 10 ? (i instanceof dr ? i = new pi(i.length, this.height, this.spaceAbove) : i.height = this.height, this.outdated || (i.outdated = !1), i) : Hr.of(r);
  }
  updateHeight(e, n = 0, r = !1, i) {
    return i && i.from <= n && i.more ? this.setMeasuredHeight(i) : (r || this.outdated) && (this.spaceAbove = 0, this.setHeight(Math.max(this.widgetHeight, e.heightForLine(this.length - this.collapsed)) + this.breaks * e.lineHeight)), this.outdated = !1, this;
  }
  toString() {
    return `line(${this.length}${this.collapsed ? -this.collapsed : ""}${this.widgetHeight ? ":" + this.widgetHeight : ""})`;
  }
}
class dr extends Hr {
  constructor(e) {
    super(e, 0);
  }
  heightMetrics(e, n) {
    let r = e.doc.lineAt(n).number, i = e.doc.lineAt(n + this.length).number, s = i - r + 1, o, a = 0;
    if (e.lineWrapping) {
      let l = Math.min(this.height, e.lineHeight * s);
      o = l / s, this.length > s + 1 && (a = (this.height - l) / (this.length - s - 1));
    } else {
      o = this.height / s;
    }
    return {firstLine:r, lastLine:i, perLine:o, perChar:a};
  }
  blockAt(e, n, r, i) {
    let {firstLine:s, lastLine:o, perLine:a, perChar:l} = this.heightMetrics(n, i);
    if (n.lineWrapping) {
      let c = i + (e < n.lineHeight ? 0 : Math.round(Math.max(0, Math.min(1, (e - r) / this.height)) * this.length)), u = n.doc.lineAt(c), h = a + u.length * l, f = Math.max(r, e - h / 2);
      return new Gi(u.from, u.length, f, h, 0);
    } else {
      let c = Math.max(0, Math.min(o - s, Math.floor((e - r) / a))), {from:u, length:h} = n.doc.line(s + c);
      return new Gi(u, h, r + a * c, a, 0);
    }
  }
  lineAt(e, n, r, i, s) {
    if (n == yn.ByHeight) {
      return this.blockAt(e, r, i, s);
    }
    if (n == yn.ByPosNoHeight) {
      let {from:p, to:g} = r.doc.lineAt(e);
      return new Gi(p, g - p, 0, 0, 0);
    }
    let {firstLine:o, perLine:a, perChar:l} = this.heightMetrics(r, s), c = r.doc.lineAt(e), u = a + c.length * l, h = c.number - o, f = i + a * h + l * (c.from - s - h);
    return new Gi(c.from, c.length, Math.max(i, Math.min(f, i + this.height - u)), u, 0);
  }
  forEachLine(e, n, r, i, s, o) {
    e = Math.max(e, s), n = Math.min(n, s + this.length);
    let {firstLine:a, perLine:l, perChar:c} = this.heightMetrics(r, s);
    for (let u = e, h = i; u <= n;) {
      let f = r.doc.lineAt(u);
      if (u == e) {
        let g = f.number - a;
        h += l * g + c * (e - s - g);
      }
      let p = l + c * f.length;
      o(new Gi(f.from, f.length, h, p, 0)), h += p, u = f.to + 1;
    }
  }
  replace(e, n, r) {
    let i = this.length - n;
    if (i > 0) {
      let s = r[r.length - 1];
      s instanceof dr ? r[r.length - 1] = new dr(s.length + i) : r.push(null, new dr(i - 1));
    }
    if (e > 0) {
      let s = r[0];
      s instanceof dr ? r[0] = new dr(e + s.length) : r.unshift(new dr(e - 1), null);
    }
    return Hr.of(r);
  }
  decomposeLeft(e, n) {
    n.push(new dr(e - 1), null);
  }
  decomposeRight(e, n) {
    n.push(null, new dr(this.length - e - 1));
  }
  updateHeight(e, n = 0, r = !1, i) {
    let s = n + this.length;
    if (i && i.from <= n + this.length && i.more) {
      let o = [], a = Math.max(n, i.from), l = -1;
      for (i.from > n && o.push((new dr(i.from - n - 1)).updateHeight(e, n)); a <= s && i.more;) {
        let u = e.doc.lineAt(a).length;
        o.length && o.push(null);
        let h = i.heights[i.index++], f = 0;
        h < 0 && (f = -h, h = i.heights[i.index++]), l == -1 ? l = h : Math.abs(h - l) >= Lf && (l = -2);
        let p = new pi(u, h, f);
        p.outdated = !1, o.push(p), a += u + 1;
      }
      a <= s && o.push(null, (new dr(s - a)).updateHeight(e, a));
      let c = Hr.of(o);
      return (l < 0 || Math.abs(c.height - this.height) >= Lf || Math.abs(l - this.heightMetrics(e, n).perLine) >= Lf) && (dc = !0), Ep(this, c);
    } else {
      (r || this.outdated) && (this.setHeight(e.heightForGap(n, n + this.length)), this.outdated = !1);
    }
    return this;
  }
  toString() {
    return `gap(${this.length})`;
  }
}
class xK extends Hr {
  constructor(e, n, r) {
    super(e.length + n + r.length, e.height + r.height, n | (e.outdated || r.outdated ? 2 : 0)), this.left = e, this.right = r, this.size = e.size + r.size;
  }
  get break() {
    return this.flags & 1;
  }
  blockAt(e, n, r, i) {
    let s = r + this.left.height;
    return e < s ? this.left.blockAt(e, n, r, i) : this.right.blockAt(e, n, s, i + this.left.length + this.break);
  }
  lineAt(e, n, r, i, s) {
    let o = i + this.left.height, a = s + this.left.length + this.break, l = n == yn.ByHeight ? e < o : e < a, c = l ? this.left.lineAt(e, n, r, i, s) : this.right.lineAt(e, n, r, o, a);
    if (this.break || (l ? c.to < a : c.from > a)) {
      return c;
    }
    let u = n == yn.ByPosNoHeight ? yn.ByPosNoHeight : yn.ByPos;
    return l ? c.join(this.right.lineAt(a, u, r, o, a)) : this.left.lineAt(a, u, r, i, s).join(c);
  }
  forEachLine(e, n, r, i, s, o) {
    let a = i + this.left.height, l = s + this.left.length + this.break;
    if (this.break) {
      e < l && this.left.forEachLine(e, n, r, i, s, o), n >= l && this.right.forEachLine(e, n, r, a, l, o);
    } else {
      let c = this.lineAt(l, yn.ByPos, r, i, s);
      e < c.from && this.left.forEachLine(e, c.from - 1, r, i, s, o), c.to >= e && c.from <= n && o(c), n > c.to && this.right.forEachLine(c.to + 1, n, r, a, l, o);
    }
  }
  replace(e, n, r) {
    let i = this.left.length + this.break;
    if (n < i) {
      return this.balanced(this.left.replace(e, n, r), this.right);
    }
    if (e > this.left.length) {
      return this.balanced(this.left, this.right.replace(e - i, n - i, r));
    }
    let s = [];
    e > 0 && this.decomposeLeft(e, s);
    let o = s.length;
    for (let a of r) {
      s.push(a);
    }
    if (e > 0 && sk(s, o - 1), n < this.length) {
      let a = s.length;
      this.decomposeRight(n, s), sk(s, a);
    }
    return Hr.of(s);
  }
  decomposeLeft(e, n) {
    let r = this.left.length;
    if (e <= r) {
      return this.left.decomposeLeft(e, n);
    }
    n.push(this.left), this.break && (r++, e >= r && n.push(null)), e > r && this.right.decomposeLeft(e - r, n);
  }
  decomposeRight(e, n) {
    let r = this.left.length, i = r + this.break;
    if (e >= i) {
      return this.right.decomposeRight(e - i, n);
    }
    e < r && this.left.decomposeRight(e, n), this.break && e < i && n.push(null), n.push(this.right);
  }
  balanced(e, n) {
    return e.size > 2 * n.size || n.size > 2 * e.size ? Hr.of(this.break ? [e, null, n] : [e, n]) : (this.left = Ep(this.left, e), this.right = Ep(this.right, n), this.setHeight(e.height + n.height), this.outdated = e.outdated || n.outdated, this.size = e.size + n.size, this.length = e.length + this.break + n.length, this);
  }
  updateHeight(e, n = 0, r = !1, i) {
    let {left:s, right:o} = this, a = n + s.length + this.break, l = null;
    return i && i.from <= n + s.length && i.more ? l = s = s.updateHeight(e, n, r, i) : s.updateHeight(e, n, r), i && i.from <= a + o.length && i.more ? l = o = o.updateHeight(e, a, r, i) : o.updateHeight(e, a, r), l ? this.balanced(s, o) : (this.height = this.left.height + this.right.height, this.outdated = !1, this);
  }
  toString() {
    return this.left + (this.break ? " " : "-") + this.right;
  }
}
function sk(t, e) {
  let n, r;
  t[e] == null && (n = t[e - 1]) instanceof dr && (r = t[e + 1]) instanceof dr && t.splice(e - 1, 3, new dr(n.length + 1 + r.length));
}
const vK = 5;
class x1 {
  constructor(e, n) {
    this.pos = e, this.oracle = n, this.nodes = [], this.lineStart = -1, this.lineEnd = -1, this.covering = null, this.writtenTo = e;
  }
  get isCovered() {
    return this.covering && this.nodes[this.nodes.length - 1] == this.covering;
  }
  span(e, n) {
    if (this.lineStart > -1) {
      let r = Math.min(n, this.lineEnd), i = this.nodes[this.nodes.length - 1];
      i instanceof pi ? i.length += r - this.pos : (r > this.pos || !this.isCovered) && this.nodes.push(new pi(r - this.pos, -1, 0)), this.writtenTo = r, n > r && (this.nodes.push(null), this.writtenTo++, this.lineStart = -1);
    }
    this.pos = n;
  }
  point(e, n, r) {
    if (e < n || r.heightRelevant) {
      let i = r.widget ? r.widget.estimatedHeight : 0, s = r.widget ? r.widget.lineBreaks : 0;
      i < 0 && (i = this.oracle.lineHeight);
      let o = n - e;
      r.block ? this.addBlock(new zI(o, i, r)) : (o || s || i >= vK) && this.addLineDeco(i, s, o);
    } else {
      n > e && this.span(e, n);
    }
    this.lineEnd > -1 && this.lineEnd < this.pos && (this.lineEnd = this.oracle.doc.lineAt(this.pos).to);
  }
  enterLine() {
    if (this.lineStart > -1) {
      return;
    }
    let {from:e, to:n} = this.oracle.doc.lineAt(this.pos);
    this.lineStart = e, this.lineEnd = n, this.writtenTo < e && ((this.writtenTo < e - 1 || this.nodes[this.nodes.length - 1] == null) && this.nodes.push(this.blankContent(this.writtenTo, e - 1)), this.nodes.push(null)), this.pos > e && this.nodes.push(new pi(this.pos - e, -1, 0)), this.writtenTo = this.pos;
  }
  blankContent(e, n) {
    let r = new dr(n - e);
    return this.oracle.doc.lineAt(e).to == n && (r.flags |= 4), r;
  }
  ensureLine() {
    this.enterLine();
    let e = this.nodes.length ? this.nodes[this.nodes.length - 1] : null;
    if (e instanceof pi) {
      return e;
    }
    let n = new pi(0, -1, 0);
    return this.nodes.push(n), n;
  }
  addBlock(e) {
    this.enterLine();
    let n = e.deco;
    n && n.startSide > 0 && !this.isCovered && this.ensureLine(), this.nodes.push(e), this.writtenTo = this.pos = this.pos + e.length, n && n.endSide > 0 && (this.covering = e);
  }
  addLineDeco(e, n, r) {
    let i = this.ensureLine();
    i.length += r, i.collapsed += r, i.widgetHeight = Math.max(i.widgetHeight, e), i.breaks += n, this.writtenTo = this.pos = this.pos + r;
  }
  finish(e) {
    let n = this.nodes.length == 0 ? null : this.nodes[this.nodes.length - 1];
    this.lineStart > -1 && !(n instanceof pi) && !this.isCovered ? this.nodes.push(new pi(0, -1, 0)) : (this.writtenTo < this.pos || n == null) && this.nodes.push(this.blankContent(this.writtenTo, this.pos));
    let r = e;
    for (let i of this.nodes) {
      i instanceof pi && i.updateHeight(this.oracle, r), r += i ? i.length : 1;
    }
    return this.nodes;
  }
  static build(e, n, r, i) {
    let s = new x1(r, e);
    return $t.spans(n, r, i, s, 0), s.finish(r);
  }
}
function wK(t, e, n) {
  let r = new _K();
  return $t.compare(t, e, n, r, 0), r.changes;
}
class _K {
  constructor() {
    this.changes = [];
  }
  compareRange() {
  }
  comparePoint(e, n, r, i) {
    (e < n || r && r.heightRelevant || i && i.heightRelevant) && Xl(e, n, this.changes, 5);
  }
}
function SK(t, e) {
  let n = t.getBoundingClientRect(), r = t.ownerDocument, i = r.defaultView || window, s = Math.max(0, n.left), o = Math.min(i.innerWidth, n.right), a = Math.max(0, n.top), l = Math.min(i.innerHeight, n.bottom);
  for (let c = t.parentNode; c && c != r.body;) {
    if (c.nodeType == 1) {
      let u = c, h = window.getComputedStyle(u);
      if ((u.scrollHeight > u.clientHeight || u.scrollWidth > u.clientWidth) && h.overflow != "visible") {
        let f = u.getBoundingClientRect();
        s = Math.max(s, f.left), o = Math.min(o, f.right), a = Math.max(a, f.top), l = Math.min(c == t.parentNode ? i.innerHeight : l, f.bottom);
      }
      c = h.position == "absolute" || h.position == "fixed" ? u.offsetParent : u.parentNode;
    } else if (c.nodeType == 11) {
      c = c.host;
    } else {
      break;
    }
  }
  return {left:s - n.left, right:Math.max(s, o) - n.left, top:a - (n.top + e), bottom:Math.max(a, l) - (n.top + e)};
}
function kK(t) {
  let e = t.getBoundingClientRect(), n = t.ownerDocument.defaultView || window;
  return e.left < n.innerWidth && e.right > 0 && e.top < n.innerHeight && e.bottom > 0;
}
function EK(t, e) {
  let n = t.getBoundingClientRect();
  return {left:0, right:n.right - n.left, top:e, bottom:n.bottom - (n.top + e)};
}
class i0 {
  constructor(e, n, r, i) {
    this.from = e, this.to = n, this.size = r, this.displaySize = i;
  }
  static same(e, n) {
    if (e.length != n.length) {
      return !1;
    }
    for (let r = 0; r < e.length; r++) {
      let i = e[r], s = n[r];
      if (i.from != s.from || i.to != s.to || i.size != s.size) {
        return !1;
      }
    }
    return !0;
  }
  draw(e, n) {
    return pt.replace({widget:new TK(this.displaySize * (n ? e.scaleY : e.scaleX), n)}).range(this.from, this.to);
  }
}
class TK extends Fs {
  constructor(e, n) {
    super(), this.size = e, this.vertical = n;
  }
  eq(e) {
    return e.size == this.size && e.vertical == this.vertical;
  }
  toDOM() {
    let e = document.createElement("div");
    return this.vertical ? e.style.height = this.size + "px" : (e.style.width = this.size + "px", e.style.height = "2px", e.style.display = "inline-block"), e;
  }
  get estimatedHeight() {
    return this.vertical ? this.size : -1;
  }
}
class ok {
  constructor(e, n) {
    this.view = e, this.state = n, this.pixelViewport = {left:0, right:window.innerWidth, top:0, bottom:0}, this.inView = !0, this.paddingTop = 0, this.paddingBottom = 0, this.contentDOMWidth = 0, this.contentDOMHeight = 0, this.editorHeight = 0, this.editorWidth = 0, this.scaleX = 1, this.scaleY = 1, this.scrollOffset = 0, this.scrolledToBottom = !1, this.scrollAnchorPos = 0, this.scrollAnchorHeight = -1, this.scaler = ak, this.scrollTarget = null, this.printing = !1, this.mustMeasureContent = !0, 
    this.defaultTextDirection = xn.LTR, this.visibleRanges = [], this.mustEnforceCursorAssoc = !1;
    let r = n.facet(g1).some(i => typeof i != "function" && i.class == "cm-lineWrapping");
    this.heightOracle = new mK(r), this.stateDeco = lk(n), this.heightMap = Hr.empty().applyChanges(this.stateDeco, Xt.empty, this.heightOracle.setDoc(n.doc), [new Ri(0, 0, 0, n.doc.length)]);
    for (let i = 0; i < 2 && (this.viewport = this.getViewport(0, null), !!this.updateForViewport()); i++) {
    }
    this.updateViewportLines(), this.lineGaps = this.ensureLineGaps([]), this.lineGapDeco = pt.set(this.lineGaps.map(i => i.draw(this, !1))), this.scrollParent = e.scrollDOM, this.computeVisibleRanges();
  }
  updateForViewport() {
    let e = [this.viewport], {main:n} = this.state.selection;
    for (let r = 0; r <= 1; r++) {
      let i = r ? n.head : n.anchor;
      if (!e.some(({from:s, to:o}) => i >= s && i <= o)) {
        let {from:s, to:o} = this.lineBlockAt(i);
        e.push(new Uh(s, o));
      }
    }
    return this.viewports = e.sort((r, i) => r.from - i.from), this.updateScaler();
  }
  updateScaler() {
    let e = this.scaler;
    return this.scaler = this.heightMap.height <= 7e6 ? ak : new v1(this.heightOracle, this.heightMap, this.viewports), e.eq(this.scaler) ? 0 : 2;
  }
  updateViewportLines() {
    this.viewportLines = [], this.heightMap.forEachLine(this.viewport.from, this.viewport.to, this.heightOracle.setDoc(this.state.doc), 0, 0, e => {
      this.viewportLines.push(fu(e, this.scaler));
    });
  }
  update(e, n = null) {
    this.state = e.state;
    let r = this.stateDeco;
    this.stateDeco = lk(this.state);
    let i = e.changedRanges, s = Ri.extendWithRanges(i, wK(r, this.stateDeco, e ? e.changes : nr.empty(this.state.doc.length))), o = this.heightMap.height, a = this.scrolledToBottom ? null : this.scrollAnchorAt(this.scrollOffset);
    ik(), this.heightMap = this.heightMap.applyChanges(this.stateDeco, e.startState.doc, this.heightOracle.setDoc(this.state.doc), s), (this.heightMap.height != o || dc) && (e.flags |= 2), a ? (this.scrollAnchorPos = e.changes.mapPos(a.from, -1), this.scrollAnchorHeight = a.top) : (this.scrollAnchorPos = -1, this.scrollAnchorHeight = o);
    let l = s.length ? this.mapViewport(this.viewport, e.changes) : this.viewport;
    (n && (n.range.head < l.from || n.range.head > l.to) || !this.viewportIsAppropriate(l)) && (l = this.getViewport(0, n));
    let c = l.from != this.viewport.from || l.to != this.viewport.to;
    this.viewport = l, e.flags |= this.updateForViewport(), (c || !e.changes.empty || e.flags & 2) && this.updateViewportLines(), (this.lineGaps.length || this.viewport.to - this.viewport.from > 4e3) && this.updateLineGaps(this.ensureLineGaps(this.mapLineGaps(this.lineGaps, e.changes))), e.flags |= this.computeVisibleRanges(e.changes), n && (this.scrollTarget = n), !this.mustEnforceCursorAssoc && (e.selectionSet || e.focusChanged) && e.view.lineWrapping && e.state.selection.main.empty && e.state.selection.main.assoc && 
    !e.state.facet(xI) && (this.mustEnforceCursorAssoc = !0);
  }
  measure() {
    let {view:e} = this, n = e.contentDOM, r = window.getComputedStyle(n), i = this.heightOracle, s = r.whiteSpace;
    this.defaultTextDirection = r.direction == "rtl" ? xn.RTL : xn.LTR;
    let o = this.heightOracle.mustRefreshForWrapping(s) || this.mustMeasureContent === "refresh", a = n.getBoundingClientRect(), l = o || this.mustMeasureContent || this.contentDOMHeight != a.height;
    this.contentDOMHeight = a.height, this.mustMeasureContent = !1;
    let c = 0, u = 0;
    if (a.width && a.height) {
      let {scaleX:I, scaleY:_} = tI(n, a);
      (I > 5e-3 && Math.abs(this.scaleX - I) > 5e-3 || _ > 5e-3 && Math.abs(this.scaleY - _) > 5e-3) && (this.scaleX = I, this.scaleY = _, c |= 16, o = l = !0);
    }
    let h = (parseInt(r.paddingTop) || 0) * this.scaleY, f = (parseInt(r.paddingBottom) || 0) * this.scaleY;
    (this.paddingTop != h || this.paddingBottom != f) && (this.paddingTop = h, this.paddingBottom = f, c |= 18), this.editorWidth != e.scrollDOM.clientWidth && (i.lineWrapping && (l = !0), this.editorWidth = e.scrollDOM.clientWidth, c |= 16);
    let p = nI(this.view.contentDOM, !1).y;
    p != this.scrollParent && (this.scrollParent = p, this.scrollAnchorHeight = -1, this.scrollOffset = 0);
    let g = this.getScrollOffset();
    this.scrollOffset != g && (this.scrollAnchorHeight = -1, this.scrollOffset = g), this.scrolledToBottom = iI(this.scrollParent || e.win);
    let m = (this.printing ? EK : SK)(n, this.paddingTop), b = m.top - this.pixelViewport.top, x = m.bottom - this.pixelViewport.bottom;
    this.pixelViewport = m;
    let w = this.pixelViewport.bottom > this.pixelViewport.top && this.pixelViewport.right > this.pixelViewport.left;
    if (w != this.inView && (this.inView = w, w && (l = !0)), !this.inView && !this.scrollTarget && !kK(e.dom)) {
      return 0;
    }
    let v = a.width;
    if ((this.contentDOMWidth != v || this.editorHeight != e.scrollDOM.clientHeight) && (this.contentDOMWidth = a.width, this.editorHeight = e.scrollDOM.clientHeight, c |= 16), l) {
      let I = e.docView.measureVisibleLineHeights(this.viewport);
      if (i.mustRefreshForHeights(I) && (o = !0), o || i.lineWrapping && Math.abs(v - this.contentDOMWidth) > i.charWidth) {
        let {lineHeight:_, charWidth:N, textHeight:E} = e.docView.measureTextSize();
        o = _ > 0 && i.refresh(s, _, N, E, Math.max(5, v / N), I), o && (e.docView.minWidth = 0, c |= 16);
      }
      b > 0 && x > 0 ? u = Math.max(b, x) : b < 0 && x < 0 && (u = Math.min(b, x)), ik();
      for (let _ of this.viewports) {
        let N = _.from == this.viewport.from ? I : e.docView.measureVisibleLineHeights(_);
        this.heightMap = (o ? Hr.empty().applyChanges(this.stateDeco, Xt.empty, this.heightOracle, [new Ri(0, 0, 0, e.state.doc.length)]) : this.heightMap).updateHeight(i, 0, o, new bK(_.from, N));
      }
      dc && (c |= 2);
    }
    let T = !this.viewportIsAppropriate(this.viewport, u) || this.scrollTarget && (this.scrollTarget.range.head < this.viewport.from || this.scrollTarget.range.head > this.viewport.to);
    return T && (c & 2 && (c |= this.updateScaler()), this.viewport = this.getViewport(u, this.scrollTarget), c |= this.updateForViewport()), (c & 2 || T) && this.updateViewportLines(), (this.lineGaps.length || this.viewport.to - this.viewport.from > 4e3) && this.updateLineGaps(this.ensureLineGaps(o ? [] : this.lineGaps, e)), c |= this.computeVisibleRanges(), this.mustEnforceCursorAssoc && (this.mustEnforceCursorAssoc = !1, e.docView.enforceCursorAssoc()), c;
  }
  get visibleTop() {
    return this.scaler.fromDOM(this.pixelViewport.top);
  }
  get visibleBottom() {
    return this.scaler.fromDOM(this.pixelViewport.bottom);
  }
  getViewport(e, n) {
    let r = 0.5 - Math.max(-0.5, Math.min(0.5, e / 1e3 / 2)), i = this.heightMap, s = this.heightOracle, {visibleTop:o, visibleBottom:a} = this, l = new Uh(i.lineAt(o - r * 1e3, yn.ByHeight, s, 0, 0).from, i.lineAt(a + (1 - r) * 1e3, yn.ByHeight, s, 0, 0).to);
    if (n) {
      let {head:c} = n.range;
      if (c < l.from || c > l.to) {
        let u = Math.min(this.editorHeight, this.pixelViewport.bottom - this.pixelViewport.top), h = i.lineAt(c, yn.ByPos, s, 0, 0), f;
        n.y == "center" ? f = (h.top + h.bottom) / 2 - u / 2 : n.y == "start" || n.y == "nearest" && c < l.from ? f = h.top : f = h.bottom - u, l = new Uh(i.lineAt(f - 1e3 / 2, yn.ByHeight, s, 0, 0).from, i.lineAt(f + u + 1e3 / 2, yn.ByHeight, s, 0, 0).to);
      }
    }
    return l;
  }
  mapViewport(e, n) {
    let r = n.mapPos(e.from, -1), i = n.mapPos(e.to, 1);
    return new Uh(this.heightMap.lineAt(r, yn.ByPos, this.heightOracle, 0, 0).from, this.heightMap.lineAt(i, yn.ByPos, this.heightOracle, 0, 0).to);
  }
  viewportIsAppropriate({from:e, to:n}, r = 0) {
    if (!this.inView) {
      return !0;
    }
    let {top:i} = this.heightMap.lineAt(e, yn.ByPos, this.heightOracle, 0, 0), {bottom:s} = this.heightMap.lineAt(n, yn.ByPos, this.heightOracle, 0, 0), {visibleTop:o, visibleBottom:a} = this;
    return (e == 0 || i <= o - Math.max(10, Math.min(-r, 250))) && (n == this.state.doc.length || s >= a + Math.max(10, Math.min(r, 250))) && i > o - 2 * 1e3 && s < a + 2 * 1e3;
  }
  mapLineGaps(e, n) {
    if (!e.length || n.empty) {
      return e;
    }
    let r = [];
    for (let i of e) {
      n.touchesRange(i.from, i.to) || r.push(new i0(n.mapPos(i.from), n.mapPos(i.to), i.size, i.displaySize));
    }
    return r;
  }
  ensureLineGaps(e, n) {
    let r = this.heightOracle.lineWrapping, i = r ? 1e4 : 2e3, s = i >> 1, o = i << 1;
    if (this.defaultTextDirection != xn.LTR && !r) {
      return [];
    }
    let a = [], l = (u, h, f, p) => {
      if (h - u < s) {
        return;
      }
      let g = this.state.selection.main, m = [g.from];
      g.empty || m.push(g.to);
      for (let x of m) {
        if (x > u && x < h) {
          l(u, x - 10, f, p), l(x + 10, h, f, p);
          return;
        }
      }
      let b = AK(e, x => x.from >= f.from && x.to <= f.to && Math.abs(x.from - u) < s && Math.abs(x.to - h) < s && !m.some(w => x.from < w && x.to > w));
      if (!b) {
        if (h < f.to && n && r && n.visibleRanges.some(v => v.from <= h && v.to >= h)) {
          let v = n.moveToLineBoundary(Ce.cursor(h), !1, !0).head;
          v > u && (h = v);
        }
        let x = this.gapSize(f, u, h, p), w = r || x < 2e6 ? x : 2e6;
        b = new i0(u, h, x, w);
      }
      a.push(b);
    }, c = u => {
      if (u.length < o || u.type != br.Text) {
        return;
      }
      let h = CK(u.from, u.to, this.stateDeco);
      if (h.total < o) {
        return;
      }
      let f = this.scrollTarget ? this.scrollTarget.range.head : null, p, g;
      if (r) {
        let m = i / this.heightOracle.lineLength * this.heightOracle.lineHeight, b, x;
        if (f != null) {
          let w = jh(h, f), v = ((this.visibleBottom - this.visibleTop) / 2 + m) / u.height;
          b = w - v, x = w + v;
        } else {
          b = (this.visibleTop - u.top - m) / u.height, x = (this.visibleBottom - u.top + m) / u.height;
        }
        p = Wh(h, b), g = Wh(h, x);
      } else {
        let m = h.total * this.heightOracle.charWidth, b = i * this.heightOracle.charWidth, x = 0;
        if (m > 2e6) {
          for (let _ of e) {
            _.from >= u.from && _.from < u.to && _.size != _.displaySize && _.from * this.heightOracle.charWidth + x < this.pixelViewport.left && (x = _.size - _.displaySize);
          }
        }
        let w = this.pixelViewport.left + x, v = this.pixelViewport.right + x, T, I;
        if (f != null) {
          let _ = jh(h, f), N = ((v - w) / 2 + b) / m;
          T = _ - N, I = _ + N;
        } else {
          T = (w - b) / m, I = (v + b) / m;
        }
        p = Wh(h, T), g = Wh(h, I);
      }
      p > u.from && l(u.from, p, u, h), g < u.to && l(g, u.to, u, h);
    };
    for (let u of this.viewportLines) {
      Array.isArray(u.type) ? u.type.forEach(c) : c(u);
    }
    return a;
  }
  gapSize(e, n, r, i) {
    let s = jh(i, r) - jh(i, n);
    return this.heightOracle.lineWrapping ? e.height * s : i.total * this.heightOracle.charWidth * s;
  }
  updateLineGaps(e) {
    i0.same(e, this.lineGaps) || (this.lineGaps = e, this.lineGapDeco = pt.set(e.map(n => n.draw(this, this.heightOracle.lineWrapping))));
  }
  computeVisibleRanges(e) {
    let n = this.stateDeco;
    this.lineGaps.length && (n = n.concat(this.lineGapDeco));
    let r = [];
    $t.spans(n, this.viewport.from, this.viewport.to, {span(s, o) {
      r.push({from:s, to:o});
    }, point() {
    }}, 20);
    let i = 0;
    if (r.length != this.visibleRanges.length) {
      i = 12;
    } else {
      for (let s = 0; s < r.length && !(i & 8); s++) {
        let o = this.visibleRanges[s], a = r[s];
        (o.from != a.from || o.to != a.to) && (i |= 4, e && e.mapPos(o.from, -1) == a.from && e.mapPos(o.to, 1) == a.to || (i |= 8));
      }
    }
    return this.visibleRanges = r, i;
  }
  lineBlockAt(e) {
    return e >= this.viewport.from && e <= this.viewport.to && this.viewportLines.find(n => n.from <= e && n.to >= e) || fu(this.heightMap.lineAt(e, yn.ByPos, this.heightOracle, 0, 0), this.scaler);
  }
  lineBlockAtHeight(e) {
    return e >= this.viewportLines[0].top && e <= this.viewportLines[this.viewportLines.length - 1].bottom && this.viewportLines.find(n => n.top <= e && n.bottom >= e) || fu(this.heightMap.lineAt(this.scaler.fromDOM(e), yn.ByHeight, this.heightOracle, 0, 0), this.scaler);
  }
  getScrollOffset() {
    return (this.scrollParent == this.view.scrollDOM ? this.scrollParent.scrollTop : (this.scrollParent ? this.scrollParent.getBoundingClientRect().top : 0) - this.view.contentDOM.getBoundingClientRect().top) * this.scaleY;
  }
  scrollAnchorAt(e) {
    let n = this.lineBlockAtHeight(e + 8);
    return n.from >= this.viewport.from || this.viewportLines[0].top - e > 200 ? n : this.viewportLines[0];
  }
  elementAtHeight(e) {
    return fu(this.heightMap.blockAt(this.scaler.fromDOM(e), this.heightOracle, 0, 0), this.scaler);
  }
  get docHeight() {
    return this.scaler.toDOM(this.heightMap.height);
  }
  get contentHeight() {
    return this.docHeight + this.paddingTop + this.paddingBottom;
  }
}
class Uh {
  constructor(e, n) {
    this.from = e, this.to = n;
  }
}
function CK(t, e, n) {
  let r = [], i = t, s = 0;
  return $t.spans(n, t, e, {span() {
  }, point(o, a) {
    o > i && (r.push({from:i, to:o}), s += o - i), i = a;
  }}, 20), i < e && (r.push({from:i, to:e}), s += e - i), {total:s, ranges:r};
}
function Wh({total:t, ranges:e}, n) {
  if (n <= 0) {
    return e[0].from;
  }
  if (n >= 1) {
    return e[e.length - 1].to;
  }
  let r = Math.floor(t * n);
  for (let i = 0;; i++) {
    let {from:s, to:o} = e[i], a = o - s;
    if (r <= a) {
      return s + r;
    }
    r -= a;
  }
}
function jh(t, e) {
  let n = 0;
  for (let {from:r, to:i} of t.ranges) {
    if (e <= i) {
      n += e - r;
      break;
    }
    n += i - r;
  }
  return n / t.total;
}
function AK(t, e) {
  for (let n of t) {
    if (e(n)) {
      return n;
    }
  }
}
const ak = {toDOM(t) {
  return t;
}, fromDOM(t) {
  return t;
}, scale:1, eq(t) {
  return t == this;
}};
function lk(t) {
  let e = t.facet(Dg).filter(r => typeof r != "function"), n = t.facet(m1).filter(r => typeof r != "function");
  return n.length && e.push($t.join(n)), e;
}
class v1 {
  constructor(e, n, r) {
    let i = 0, s = 0, o = 0;
    this.viewports = r.map(({from:a, to:l}) => {
      let c = n.lineAt(a, yn.ByPos, e, 0, 0).top, u = n.lineAt(l, yn.ByPos, e, 0, 0).bottom;
      return i += u - c, {from:a, to:l, top:c, bottom:u, domTop:0, domBottom:0};
    }), this.scale = (7e6 - i) / (n.height - i);
    for (let a of this.viewports) {
      a.domTop = o + (a.top - s) * this.scale, o = a.domBottom = a.domTop + (a.bottom - a.top), s = a.bottom;
    }
  }
  toDOM(e) {
    for (let n = 0, r = 0, i = 0;; n++) {
      let s = n < this.viewports.length ? this.viewports[n] : null;
      if (!s || e < s.top) {
        return i + (e - r) * this.scale;
      }
      if (e <= s.bottom) {
        return s.domTop + (e - s.top);
      }
      r = s.bottom, i = s.domBottom;
    }
  }
  fromDOM(e) {
    for (let n = 0, r = 0, i = 0;; n++) {
      let s = n < this.viewports.length ? this.viewports[n] : null;
      if (!s || e < s.domTop) {
        return r + (e - i) / this.scale;
      }
      if (e <= s.domBottom) {
        return s.top + (e - s.domTop);
      }
      r = s.bottom, i = s.domBottom;
    }
  }
  eq(e) {
    return e instanceof v1 ? this.scale == e.scale && this.viewports.length == e.viewports.length && this.viewports.every((n, r) => n.from == e.viewports[r].from && n.to == e.viewports[r].to) : !1;
  }
}
function fu(t, e) {
  if (e.scale == 1) {
    return t;
  }
  let n = e.toDOM(t.top), r = e.toDOM(t.bottom);
  return new Gi(t.from, t.length, n, r - n, Array.isArray(t._content) ? t._content.map(i => fu(i, e)) : t._content);
}
const Vh = et.define({combine:t => t.join(" ")}), cy = et.define({combine:t => t.indexOf(!0) > -1}), uy = Zo.newName(), HI = Zo.newName(), UI = Zo.newName(), WI = {"\x26light":"." + HI, "\x26dark":"." + UI};
function dy(t, e, n) {
  return new Zo(e, {finish(r) {
    return /&/.test(r) ? r.replace(/&\w*/, i => {
      if (i == "\x26") {
        return t;
      }
      if (!n || !n[i]) {
        throw new RangeError(`Unsupported selector: ${i}`);
      }
      return n[i];
    }) : t + " " + r;
  }});
}
const NK = dy("." + uy, {"\x26":{position:"relative !important", boxSizing:"border-box", "\x26.cm-focused":{outline:"1px dotted #212121"}, display:"flex !important", flexDirection:"column"}, ".cm-scroller":{display:"flex !important", alignItems:"flex-start !important", fontFamily:"monospace", lineHeight:1.4, height:"100%", overflowX:"auto", position:"relative", zIndex:0, overflowAnchor:"none"}, ".cm-content":{margin:0, flexGrow:2, flexShrink:0, display:"block", whiteSpace:"pre", wordWrap:"normal", 
boxSizing:"border-box", minHeight:"100%", padding:"4px 0", outline:"none", "\x26[contenteditable\x3dtrue]":{WebkitUserModify:"read-write-plaintext-only"}}, ".cm-lineWrapping":{whiteSpace_fallback:"pre-wrap", whiteSpace:"break-spaces", wordBreak:"break-word", overflowWrap:"anywhere", flexShrink:1}, "\x26light .cm-content":{caretColor:"black"}, "\x26dark .cm-content":{caretColor:"white"}, ".cm-line":{display:"block", padding:"0 2px 0 6px"}, ".cm-layer":{position:"absolute", left:0, top:0, contain:"size style", 
"\x26 \x3e *":{position:"absolute"}}, "\x26light .cm-selectionBackground":{background:"#d9d9d9"}, "\x26dark .cm-selectionBackground":{background:"#222"}, "\x26light.cm-focused \x3e .cm-scroller \x3e .cm-selectionLayer .cm-selectionBackground":{background:"#d7d4f0"}, "\x26dark.cm-focused \x3e .cm-scroller \x3e .cm-selectionLayer .cm-selectionBackground":{background:"#233"}, ".cm-cursorLayer":{pointerEvents:"none"}, "\x26.cm-focused \x3e .cm-scroller \x3e .cm-cursorLayer":{animation:"steps(1) cm-blink 1.2s infinite"}, 
"@keyframes cm-blink":{"0%":{}, "50%":{opacity:0}, "100%":{}}, "@keyframes cm-blink2":{"0%":{}, "50%":{opacity:0}, "100%":{}}, ".cm-cursor, .cm-dropCursor":{borderLeft:"1.2px solid black", marginLeft:"-0.6px", pointerEvents:"none"}, ".cm-cursor":{display:"none"}, "\x26dark .cm-cursor":{borderLeftColor:"#ddd"}, ".cm-selectionHandle":{backgroundColor:"currentColor", width:"1.5px"}, ".cm-selectionHandle-start::before, .cm-selectionHandle-end::before":{content:'""', backgroundColor:"inherit", borderRadius:"50%", 
width:"8px", height:"8px", position:"absolute", left:"-3.25px"}, ".cm-selectionHandle-start::before":{top:"-8px"}, ".cm-selectionHandle-end::before":{bottom:"-8px"}, ".cm-dropCursor":{position:"absolute"}, "\x26.cm-focused \x3e .cm-scroller \x3e .cm-cursorLayer .cm-cursor":{display:"block"}, ".cm-iso":{unicodeBidi:"isolate"}, ".cm-announced":{position:"fixed", top:"-10000px"}, "@media print":{".cm-announced":{display:"none"}}, "\x26light .cm-activeLine":{backgroundColor:"#cceeff44"}, "\x26dark .cm-activeLine":{backgroundColor:"#99eeff33"}, 
"\x26light .cm-specialChar":{color:"red"}, "\x26dark .cm-specialChar":{color:"#f78"}, ".cm-gutters":{flexShrink:0, display:"flex", height:"100%", boxSizing:"border-box", zIndex:200}, ".cm-gutters-before":{insetInlineStart:0}, ".cm-gutters-after":{insetInlineEnd:0}, "\x26light .cm-gutters":{backgroundColor:"#f5f5f5", color:"#6c6c6c", border:"0px solid #ddd", "\x26.cm-gutters-before":{borderRightWidth:"1px"}, "\x26.cm-gutters-after":{borderLeftWidth:"1px"}}, "\x26dark .cm-gutters":{backgroundColor:"#333338", 
color:"#ccc"}, ".cm-gutter":{display:"flex !important", flexDirection:"column", flexShrink:0, boxSizing:"border-box", minHeight:"100%", overflow:"hidden"}, ".cm-gutterElement":{boxSizing:"border-box"}, ".cm-lineNumbers .cm-gutterElement":{padding:"0 3px 0 5px", minWidth:"20px", textAlign:"right", whiteSpace:"nowrap"}, "\x26light .cm-activeLineGutter":{backgroundColor:"#e2f2ff"}, "\x26dark .cm-activeLineGutter":{backgroundColor:"#222227"}, ".cm-panels":{boxSizing:"border-box", position:"sticky", left:0, 
right:0, zIndex:300}, "\x26light .cm-panels":{backgroundColor:"#f5f5f5", color:"black"}, "\x26light .cm-panels-top":{borderBottom:"1px solid #ddd"}, "\x26light .cm-panels-bottom":{borderTop:"1px solid #ddd"}, "\x26dark .cm-panels":{backgroundColor:"#333338", color:"white"}, ".cm-dialog":{padding:"2px 19px 4px 6px", position:"relative", "\x26 label":{fontSize:"80%"}}, ".cm-dialog-close":{position:"absolute", top:"3px", right:"4px", backgroundColor:"inherit", border:"none", font:"inherit", fontSize:"14px", 
padding:"0"}, ".cm-tab":{display:"inline-block", overflow:"hidden", verticalAlign:"bottom"}, ".cm-widgetBuffer":{verticalAlign:"text-top", height:"1em", width:0, display:"inline"}, ".cm-placeholder":{color:"#888", display:"inline-block", verticalAlign:"top", userSelect:"none"}, ".cm-highlightSpace":{backgroundImage:"radial-gradient(circle at 50% 55%, #aaa 20%, transparent 5%)", backgroundPosition:"center"}, ".cm-highlightTab":{backgroundImage:`url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="200" height="20"><path stroke="%23888" stroke-width="1" fill="none" d="M1 10H196L190 5M190 15L196 10M197 4L197 16"/></svg>')`, 
backgroundSize:"auto 100%", backgroundPosition:"right 90%", backgroundRepeat:"no-repeat"}, ".cm-trailingSpace":{backgroundColor:"#ff332255"}, ".cm-button":{verticalAlign:"middle", color:"inherit", fontSize:"70%", padding:".2em 1em", borderRadius:"1px"}, "\x26light .cm-button":{backgroundImage:"linear-gradient(#eff1f5, #d9d9df)", border:"1px solid #888", "\x26:active":{backgroundImage:"linear-gradient(#b4b4b4, #d0d3d6)"}}, "\x26dark .cm-button":{backgroundImage:"linear-gradient(#393939, #111)", border:"1px solid #888", 
"\x26:active":{backgroundImage:"linear-gradient(#111, #333)"}}, ".cm-textfield":{verticalAlign:"middle", color:"inherit", fontSize:"70%", border:"1px solid silver", padding:".2em .5em"}, "\x26light .cm-textfield":{backgroundColor:"white"}, "\x26dark .cm-textfield":{border:"1px solid #555", backgroundColor:"inherit"}}, WI), IK = {childList:!0, characterData:!0, subtree:!0, attributes:!0, characterDataOldValue:!0}, s0 = Ze.ie && Ze.ie_version <= 11;
class OK {
  constructor(e) {
    this.view = e, this.active = !1, this.editContext = null, this.selectionRange = new aQ(), this.selectionChanged = !1, this.delayedFlush = -1, this.resizeTimeout = -1, this.queue = [], this.delayedAndroidKey = null, this.flushingAndroidKey = -1, this.lastChange = 0, this.scrollTargets = [], this.intersection = null, this.resizeScroll = null, this.intersecting = !1, this.gapIntersection = null, this.gaps = [], this.printQuery = null, this.parentCheck = -1, this.dom = e.contentDOM, this.observer = 
    new MutationObserver(n => {
      for (let r of n) {
        this.queue.push(r);
      }
      (Ze.ie && Ze.ie_version <= 11 || Ze.ios && e.composing) && n.some(r => r.type == "childList" && r.removedNodes.length || r.type == "characterData" && r.oldValue.length > r.target.nodeValue.length) ? this.flushSoon() : this.flush();
    }), window.EditContext && Ze.android && e.constructor.EDIT_CONTEXT !== !1 && !(Ze.chrome && Ze.chrome_version < 126) && (this.editContext = new RK(e), e.state.facet(no) && (e.contentDOM.editContext = this.editContext.editContext)), s0 && (this.onCharData = n => {
      this.queue.push({target:n.target, type:"characterData", oldValue:n.prevValue}), this.flushSoon();
    }), this.onSelectionChange = this.onSelectionChange.bind(this), this.onResize = this.onResize.bind(this), this.onPrint = this.onPrint.bind(this), this.onScroll = this.onScroll.bind(this), window.matchMedia && (this.printQuery = window.matchMedia("print")), typeof ResizeObserver == "function" && (this.resizeScroll = new ResizeObserver(() => {
      var n;
      ((n = this.view.docView) === null || n === void 0 ? void 0 : n.lastUpdate) < Date.now() - 75 && this.onResize();
    }), this.resizeScroll.observe(e.scrollDOM)), this.addWindowListeners(this.win = e.win), this.start(), typeof IntersectionObserver == "function" && (this.intersection = new IntersectionObserver(n => {
      this.parentCheck < 0 && (this.parentCheck = setTimeout(this.listenForScroll.bind(this), 1e3)), n.length > 0 && n[n.length - 1].intersectionRatio > 0 != this.intersecting && (this.intersecting = !this.intersecting, this.intersecting != this.view.inView && this.onScrollChanged(document.createEvent("Event")));
    }, {threshold:[0, 1e-3]}), this.intersection.observe(this.dom), this.gapIntersection = new IntersectionObserver(n => {
      n.length > 0 && n[n.length - 1].intersectionRatio > 0 && this.onScrollChanged(document.createEvent("Event"));
    }, {})), this.listenForScroll(), this.readSelectionRange();
  }
  onScrollChanged(e) {
    this.view.inputState.runHandlers("scroll", e), this.intersecting && this.view.measure();
  }
  onScroll(e) {
    this.intersecting && this.flush(!1), this.editContext && this.view.requestMeasure(this.editContext.measureReq), this.onScrollChanged(e);
  }
  onResize() {
    this.resizeTimeout < 0 && (this.resizeTimeout = setTimeout(() => {
      this.resizeTimeout = -1, this.view.requestMeasure();
    }, 50));
  }
  onPrint(e) {
    (e.type == "change" || !e.type) && !e.matches || (this.view.viewState.printing = !0, this.view.measure(), setTimeout(() => {
      this.view.viewState.printing = !1, this.view.requestMeasure();
    }, 500));
  }
  updateGaps(e) {
    if (this.gapIntersection && (e.length != this.gaps.length || this.gaps.some((n, r) => n != e[r]))) {
      this.gapIntersection.disconnect();
      for (let n of e) {
        this.gapIntersection.observe(n);
      }
      this.gaps = e;
    }
  }
  onSelectionChange(e) {
    let n = this.selectionChanged;
    if (!this.readSelectionRange() || this.delayedAndroidKey) {
      return;
    }
    let {view:r} = this, i = this.selectionRange;
    if (r.state.facet(no) ? r.root.activeElement != this.dom : !Qu(this.dom, i)) {
      return;
    }
    let s = i.anchorNode && r.docView.tile.nearest(i.anchorNode);
    if (s && s.isWidget() && s.widget.ignoreEvent(e)) {
      n || (this.selectionChanged = !1);
      return;
    }
    (Ze.ie && Ze.ie_version <= 11 || Ze.android && Ze.chrome) && !r.state.selection.main.empty && i.focusNode && Xu(i.focusNode, i.focusOffset, i.anchorNode, i.anchorOffset) ? this.flushSoon() : this.flush(!1);
  }
  readSelectionRange() {
    let {view:e} = this, n = yd(e.root);
    if (!n) {
      return !1;
    }
    let r = Ze.safari && e.root.nodeType == 11 && e.root.activeElement == this.dom && PK(this.view, n) || n;
    if (!r || this.selectionRange.eq(r)) {
      return !1;
    }
    let i = Qu(this.dom, r);
    return i && !this.selectionChanged && e.inputState.lastFocusTime > Date.now() - 200 && e.inputState.lastTouchTime < Date.now() - 300 && cQ(this.dom, r) ? (this.view.inputState.lastFocusTime = 0, e.docView.updateSelection(), !1) : (this.selectionRange.setRange(r), i && (this.selectionChanged = !0), !0);
  }
  setSelectionRange(e, n) {
    this.selectionRange.set(e.node, e.offset, n.node, n.offset), this.selectionChanged = !1;
  }
  clearSelectionRange() {
    this.selectionRange.set(null, 0, null, 0);
  }
  listenForScroll() {
    this.parentCheck = -1;
    let e = 0, n = null;
    for (let r = this.dom; r;) {
      if (r.nodeType == 1) {
        !n && e < this.scrollTargets.length && this.scrollTargets[e] == r ? e++ : n || (n = this.scrollTargets.slice(0, e)), n && n.push(r), r = r.assignedSlot || r.parentNode;
      } else if (r.nodeType == 11) {
        r = r.host;
      } else {
        break;
      }
    }
    if (e < this.scrollTargets.length && !n && (n = this.scrollTargets.slice(0, e)), n) {
      for (let r of this.scrollTargets) {
        r.removeEventListener("scroll", this.onScroll);
      }
      for (let r of this.scrollTargets = n) {
        r.addEventListener("scroll", this.onScroll);
      }
    }
  }
  ignore(e) {
    if (!this.active) {
      return e();
    }
    try {
      return this.stop(), e();
    } finally {
      this.start(), this.clear();
    }
  }
  start() {
    this.active || (this.observer.observe(this.dom, IK), s0 && this.dom.addEventListener("DOMCharacterDataModified", this.onCharData), this.active = !0);
  }
  stop() {
    this.active && (this.active = !1, this.observer.disconnect(), s0 && this.dom.removeEventListener("DOMCharacterDataModified", this.onCharData));
  }
  clear() {
    this.processRecords(), this.queue.length = 0, this.selectionChanged = !1;
  }
  delayAndroidKey(e, n) {
    var r;
    if (!this.delayedAndroidKey) {
      let i = () => {
        let s = this.delayedAndroidKey;
        s && (this.clearDelayedAndroidKey(), this.view.inputState.lastKeyCode = s.keyCode, this.view.inputState.lastKeyTime = Date.now(), !this.flush() && s.force && Jl(this.dom, s.key, s.keyCode));
      };
      this.flushingAndroidKey = this.view.win.requestAnimationFrame(i);
    }
    (!this.delayedAndroidKey || e == "Enter") && (this.delayedAndroidKey = {key:e, keyCode:n, force:this.lastChange < Date.now() - 50 || !!(!((r = this.delayedAndroidKey) === null || r === void 0) && r.force)});
  }
  clearDelayedAndroidKey() {
    this.win.cancelAnimationFrame(this.flushingAndroidKey), this.delayedAndroidKey = null, this.flushingAndroidKey = -1;
  }
  flushSoon() {
    this.delayedFlush < 0 && (this.delayedFlush = this.view.win.requestAnimationFrame(() => {
      this.delayedFlush = -1, this.flush();
    }));
  }
  forceFlush() {
    this.delayedFlush >= 0 && (this.view.win.cancelAnimationFrame(this.delayedFlush), this.delayedFlush = -1), this.flush();
  }
  pendingRecords() {
    for (let e of this.observer.takeRecords()) {
      this.queue.push(e);
    }
    return this.queue;
  }
  processRecords() {
    let e = this.pendingRecords();
    e.length && (this.queue = []);
    let n = -1, r = -1, i = !1;
    for (let s of e) {
      let o = this.readMutation(s);
      o && (o.typeOver && (i = !0), n == -1 ? {from:n, to:r} = o : (n = Math.min(o.from, n), r = Math.max(o.to, r)));
    }
    return {from:n, to:r, typeOver:i};
  }
  readChange() {
    let {from:e, to:n, typeOver:r} = this.processRecords(), i = this.selectionChanged && Qu(this.dom, this.selectionRange);
    if (e < 0 && !i) {
      return null;
    }
    e > -1 && (this.lastChange = Date.now()), this.view.inputState.lastFocusTime = 0, this.selectionChanged = !1;
    let s = new KQ(this.view, e, n, r);
    return this.view.docView.domChanged = {newSel:s.newSel ? s.newSel.main : null}, s;
  }
  flush(e = !0) {
    if (this.delayedFlush >= 0 || this.delayedAndroidKey) {
      return !1;
    }
    e && this.readSelectionRange();
    let n = this.readChange();
    if (!n) {
      return this.view.requestMeasure(), !1;
    }
    let r = this.view.state, i = II(this.view, n);
    return this.view.state == r && (n.domChanged || n.newSel && !kp(this.view.state.selection, n.newSel.main)) && this.view.update([]), i;
  }
  readMutation(e) {
    let n = this.view.docView.tile.nearest(e.target);
    if (!n || n.isWidget()) {
      return null;
    }
    if (n.markDirty(e.type == "attributes"), e.type == "childList") {
      let r = ck(n, e.previousSibling || e.target.previousSibling, -1), i = ck(n, e.nextSibling || e.target.nextSibling, 1);
      return {from:r ? n.posAfter(r) : n.posAtStart, to:i ? n.posBefore(i) : n.posAtEnd, typeOver:!1};
    } else {
      return e.type == "characterData" ? {from:n.posAtStart, to:n.posAtEnd, typeOver:e.target.nodeValue == e.oldValue} : null;
    }
  }
  setWindow(e) {
    e != this.win && (this.removeWindowListeners(this.win), this.win = e, this.addWindowListeners(this.win));
  }
  addWindowListeners(e) {
    e.addEventListener("resize", this.onResize), this.printQuery ? this.printQuery.addEventListener ? this.printQuery.addEventListener("change", this.onPrint) : this.printQuery.addListener(this.onPrint) : e.addEventListener("beforeprint", this.onPrint), e.addEventListener("scroll", this.onScroll), e.document.addEventListener("selectionchange", this.onSelectionChange);
  }
  removeWindowListeners(e) {
    e.removeEventListener("scroll", this.onScroll), e.removeEventListener("resize", this.onResize), this.printQuery ? this.printQuery.removeEventListener ? this.printQuery.removeEventListener("change", this.onPrint) : this.printQuery.removeListener(this.onPrint) : e.removeEventListener("beforeprint", this.onPrint), e.document.removeEventListener("selectionchange", this.onSelectionChange);
  }
  update(e) {
    this.editContext && (this.editContext.update(e), e.startState.facet(no) != e.state.facet(no) && (e.view.contentDOM.editContext = e.state.facet(no) ? this.editContext.editContext : null));
  }
  destroy() {
    var e, n, r;
    this.stop(), (e = this.intersection) === null || e === void 0 || e.disconnect(), (n = this.gapIntersection) === null || n === void 0 || n.disconnect(), (r = this.resizeScroll) === null || r === void 0 || r.disconnect();
    for (let i of this.scrollTargets) {
      i.removeEventListener("scroll", this.onScroll);
    }
    this.removeWindowListeners(this.win), clearTimeout(this.parentCheck), clearTimeout(this.resizeTimeout), this.win.cancelAnimationFrame(this.delayedFlush), this.win.cancelAnimationFrame(this.flushingAndroidKey), this.editContext && (this.view.contentDOM.editContext = null, this.editContext.destroy());
  }
}
function ck(t, e, n) {
  for (; e;) {
    let r = Bn.get(e);
    if (r && r.parent == t) {
      return r;
    }
    let i = e.parentNode;
    e = i != t.dom ? i : n > 0 ? e.nextSibling : e.previousSibling;
  }
  return null;
}
function uk(t, e) {
  let n = e.startContainer, r = e.startOffset, i = e.endContainer, s = e.endOffset, o = t.docView.domAtPos(t.state.selection.main.anchor, 1);
  return Xu(o.node, o.offset, i, s) && ([n, r, i, s] = [i, s, n, r]), {anchorNode:n, anchorOffset:r, focusNode:i, focusOffset:s};
}
function PK(t, e) {
  if (e.getComposedRanges) {
    let i = e.getComposedRanges(t.root)[0];
    if (i) {
      return uk(t, i);
    }
  }
  let n = null;
  function r(i) {
    i.preventDefault(), i.stopImmediatePropagation(), n = i.getTargetRanges()[0];
  }
  return t.contentDOM.addEventListener("beforeinput", r, !0), t.dom.ownerDocument.execCommand("indent"), t.contentDOM.removeEventListener("beforeinput", r, !0), n ? uk(t, n) : null;
}
class RK {
  constructor(e) {
    this.from = 0, this.to = 0, this.pendingContextChange = null, this.handlers = Object.create(null), this.composing = null, this.resetRange(e.state);
    let n = this.editContext = new window.EditContext({text:e.state.doc.sliceString(this.from, this.to), selectionStart:this.toContextPos(Math.max(this.from, Math.min(this.to, e.state.selection.main.anchor))), selectionEnd:this.toContextPos(e.state.selection.main.head)});
    this.handlers.textupdate = r => {
      let i = e.state.selection.main, {anchor:s, head:o} = i, a = this.toEditorPos(r.updateRangeStart), l = this.toEditorPos(r.updateRangeEnd);
      e.inputState.composing >= 0 && !this.composing && (this.composing = {contextBase:r.updateRangeStart, editorBase:a, drifted:!1});
      let c = l - a > r.text.length;
      a == this.from && s < this.from ? a = s : l == this.to && s > this.to && (l = s);
      let u = OI(e.state.sliceDoc(a, l), r.text, (c ? i.from : i.to) - a, c ? "end" : null);
      if (!u) {
        let f = Ce.single(this.toEditorPos(r.selectionStart), this.toEditorPos(r.selectionEnd));
        kp(f, i) || e.dispatch({selection:f, userEvent:"select"});
        return;
      }
      let h = {from:u.from + a, to:u.toA + a, insert:Xt.of(r.text.slice(u.from, u.toB).split(`
`))};
      if ((Ze.mac || Ze.android) && h.from == o - 1 && /^\. ?$/.test(r.text) && e.contentDOM.getAttribute("autocorrect") == "off" && (h = {from:a, to:l, insert:Xt.of([r.text.replace(".", " ")])}), this.pendingContextChange = h, !e.state.readOnly) {
        let f = this.to - this.from + (h.to - h.from + h.insert.length);
        y1(e, h, Ce.single(this.toEditorPos(r.selectionStart, f), this.toEditorPos(r.selectionEnd, f)));
      }
      this.pendingContextChange && (this.revertPending(e.state), this.setSelection(e.state)), h.from < h.to && !h.insert.length && e.inputState.composing >= 0 && !/[\\p{Alphabetic}\\p{Number}_]/.test(n.text.slice(Math.max(0, r.updateRangeStart - 1), Math.min(n.text.length, r.updateRangeStart + 1))) && this.handlers.compositionend(r);
    }, this.handlers.characterboundsupdate = r => {
      let i = [], s = null;
      for (let o = this.toEditorPos(r.rangeStart), a = this.toEditorPos(r.rangeEnd); o < a; o++) {
        let l = e.coordsForChar(o);
        s = l && new DOMRect(l.left, l.top, l.right - l.left, l.bottom - l.top) || s || new DOMRect(), i.push(s);
      }
      n.updateCharacterBounds(r.rangeStart, i);
    }, this.handlers.textformatupdate = r => {
      let i = [];
      for (let s of r.getTextFormats()) {
        let o = s.underlineStyle, a = s.underlineThickness;
        if (!/none/i.test(o) && !/none/i.test(a)) {
          let l = this.toEditorPos(s.rangeStart), c = this.toEditorPos(s.rangeEnd);
          if (l < c) {
            let u = `text-decoration: underline ${/^[a-z]/.test(o) ? o + " " : o == "Dashed" ? "dashed " : o == "Squiggle" ? "wavy " : ""}${/thin/i.test(a) ? 1 : 2}px`;
            i.push(pt.mark({attributes:{style:u}}).range(l, c));
          }
        }
      }
      e.dispatch({effects:wI.of(pt.set(i))});
    }, this.handlers.compositionstart = () => {
      e.inputState.composing < 0 && (e.inputState.composing = 0, e.inputState.compositionFirstChange = !0);
    }, this.handlers.compositionend = () => {
      if (e.inputState.composing = -1, e.inputState.compositionFirstChange = null, this.composing) {
        let {drifted:r} = this.composing;
        this.composing = null, r && this.reset(e.state);
      }
    };
    for (let r in this.handlers) {
      n.addEventListener(r, this.handlers[r]);
    }
    this.measureReq = {read:r => {
      this.editContext.updateControlBounds(r.contentDOM.getBoundingClientRect());
      let i = yd(r.root);
      i && i.rangeCount && this.editContext.updateSelectionBounds(i.getRangeAt(0).getBoundingClientRect());
    }};
  }
  applyEdits(e) {
    let n = 0, r = !1, i = this.pendingContextChange;
    return e.changes.iterChanges((s, o, a, l, c) => {
      if (r) {
        return;
      }
      let u = c.length - (o - s);
      if (i && o >= i.to) {
        if (i.from == s && i.to == o && i.insert.eq(c)) {
          i = this.pendingContextChange = null, n += u, this.to += u;
          return;
        } else {
          i = null, this.revertPending(e.state);
        }
      }
      if (s += n, o += n, o <= this.from) {
        this.from += u, this.to += u;
      } else if (s < this.to) {
        if (s < this.from || o > this.to || this.to - this.from + c.length > 3e4) {
          r = !0;
          return;
        }
        this.editContext.updateText(this.toContextPos(s), this.toContextPos(o), c.toString()), this.to += u;
      }
      n += u;
    }), i && !r && this.revertPending(e.state), !r;
  }
  update(e) {
    let n = this.pendingContextChange, r = e.startState.selection.main;
    this.composing && (this.composing.drifted || !e.changes.touchesRange(r.from, r.to) && e.transactions.some(i => !i.isUserEvent("input.type") && i.changes.touchesRange(this.from, this.to))) ? (this.composing.drifted = !0, this.composing.editorBase = e.changes.mapPos(this.composing.editorBase)) : !this.applyEdits(e) || !this.rangeIsValid(e.state) ? (this.pendingContextChange = null, this.reset(e.state)) : (e.docChanged || e.selectionSet || n) && this.setSelection(e.state), (e.geometryChanged || 
    e.docChanged || e.selectionSet) && e.view.requestMeasure(this.measureReq);
  }
  resetRange(e) {
    let {head:n} = e.selection.main;
    this.from = Math.max(0, n - 1e4), this.to = Math.min(e.doc.length, n + 1e4);
  }
  reset(e) {
    this.resetRange(e), this.editContext.updateText(0, this.editContext.text.length, e.doc.sliceString(this.from, this.to)), this.setSelection(e);
  }
  revertPending(e) {
    let n = this.pendingContextChange;
    this.pendingContextChange = null, this.editContext.updateText(this.toContextPos(n.from), this.toContextPos(n.from + n.insert.length), e.doc.sliceString(n.from, n.to));
  }
  setSelection(e) {
    let {main:n} = e.selection, r = this.toContextPos(Math.max(this.from, Math.min(this.to, n.anchor))), i = this.toContextPos(n.head);
    (this.editContext.selectionStart != r || this.editContext.selectionEnd != i) && this.editContext.updateSelection(r, i);
  }
  rangeIsValid(e) {
    let {head:n} = e.selection.main;
    return !(this.from > 0 && n - this.from < 500 || this.to < e.doc.length && this.to - n < 500 || this.to - this.from > 1e4 * 3);
  }
  toEditorPos(e, n = this.to - this.from) {
    e = Math.min(e, n);
    let r = this.composing;
    return r && r.drifted ? r.editorBase + (e - r.contextBase) : e + this.from;
  }
  toContextPos(e) {
    let n = this.composing;
    return n && n.drifted ? n.contextBase + (e - n.editorBase) : e - this.from;
  }
  destroy() {
    for (let e in this.handlers) {
      this.editContext.removeEventListener(e, this.handlers[e]);
    }
  }
}
class nt {
  get state() {
    return this.viewState.state;
  }
  get viewport() {
    return this.viewState.viewport;
  }
  get visibleRanges() {
    return this.viewState.visibleRanges;
  }
  get inView() {
    return this.viewState.inView;
  }
  get composing() {
    return !!this.inputState && this.inputState.composing > 0;
  }
  get compositionStarted() {
    return !!this.inputState && this.inputState.composing >= 0;
  }
  get root() {
    return this._root;
  }
  get win() {
    return this.dom.ownerDocument.defaultView || window;
  }
  constructor(e = {}) {
    var n;
    this.plugins = [], this.pluginMap = new Map(), this.editorAttrs = {}, this.contentAttrs = {}, this.bidiCache = [], this.destroyed = !1, this.updateState = 2, this.measureScheduled = -1, this.measureRequests = [], this.contentDOM = document.createElement("div"), this.scrollDOM = document.createElement("div"), this.scrollDOM.tabIndex = -1, this.scrollDOM.className = "cm-scroller", this.scrollDOM.appendChild(this.contentDOM), this.announceDOM = document.createElement("div"), this.announceDOM.className = 
    "cm-announced", this.announceDOM.setAttribute("aria-live", "polite"), this.dom = document.createElement("div"), this.dom.appendChild(this.announceDOM), this.dom.appendChild(this.scrollDOM), e.parent && e.parent.appendChild(this.dom);
    let {dispatch:r} = e;
    this.dispatchTransactions = e.dispatchTransactions || r && (i => i.forEach(s => r(s, this))) || (i => this.update(i)), this.dispatch = this.dispatch.bind(this), this._root = e.root || lQ(e.parent) || document, this.viewState = new ok(this, e.state || Yt.create(e)), e.scrollTo && e.scrollTo.is(Fh) && (this.viewState.scrollTarget = e.scrollTo.value.clip(this.viewState.state)), this.plugins = this.state.facet(Vl).map(i => new Zm(i));
    for (let i of this.plugins) {
      i.update(this);
    }
    this.observer = new OK(this), this.inputState = new eK(this), this.inputState.ensureHandlers(this.plugins), this.docView = new YS(this), this.mountStyles(), this.updateAttrs(), this.updateState = 0, this.requestMeasure(), !((n = document.fonts) === null || n === void 0) && n.ready && document.fonts.ready.then(() => {
      this.viewState.mustMeasureContent = "refresh", this.requestMeasure();
    });
  }
  dispatch(...e) {
    let n = e.length == 1 && e[0] instanceof ir ? e : e.length == 1 && Array.isArray(e[0]) ? e[0] : [this.state.update(...e)];
    this.dispatchTransactions(n, this);
  }
  update(e) {
    if (this.updateState != 0) {
      throw new Error("Calls to EditorView.update are not allowed while an update is in progress");
    }
    let n = !1, r = !1, i, s = this.state;
    for (let f of e) {
      if (f.startState != s) {
        throw new RangeError("Trying to update state with a transaction that doesn't start from the previous state.");
      }
      s = f.state;
    }
    if (this.destroyed) {
      this.viewState.state = s;
      return;
    }
    let o = this.hasFocus, a = 0, l = null;
    e.some(f => f.annotation(BI)) ? (this.inputState.notifiedFocused = o, a = 1) : o != this.inputState.notifiedFocused && (this.inputState.notifiedFocused = o, l = $I(s, o), l || (a = 1));
    let c = this.observer.delayedAndroidKey, u = null;
    if (c ? (this.observer.clearDelayedAndroidKey(), u = this.observer.readChange(), (u && !this.state.doc.eq(s.doc) || !this.state.selection.eq(s.selection)) && (u = null)) : this.observer.clear(), s.facet(Yt.phrases) != this.state.facet(Yt.phrases)) {
      return this.setState(s);
    }
    i = wp.create(this, s, e), i.flags |= a;
    let h = this.viewState.scrollTarget;
    try {
      this.updateState = 2;
      for (let f of e) {
        if (h && (h = h.map(f.changes)), f.scrollIntoView) {
          let {main:p} = f.state.selection, {x:g, y:m} = this.state.facet(nt.cursorScrollMargin);
          h = new Zl(p.empty ? p : Ce.cursor(p.head, p.head > p.anchor ? -1 : 1), "nearest", "nearest", m, g);
        }
        for (let p of f.effects) {
          p.is(Fh) && (h = p.value.clip(this.state));
        }
      }
      this.viewState.update(i, h), this.bidiCache = Tp.update(this.bidiCache, i.changes), i.empty || (this.updatePlugins(i), this.inputState.update(i)), n = this.docView.update(i), this.state.facet(hu) != this.styleModules && this.mountStyles(), r = this.updateAttrs(), this.showAnnouncements(e), this.docView.updateSelection(n, e.some(f => f.isUserEvent("select.pointer")));
    } finally {
      this.updateState = 0;
    }
    if (i.startState.facet(Vh) != i.state.facet(Vh) && (this.viewState.mustMeasureContent = !0), (n || r || h || this.viewState.mustEnforceCursorAssoc || this.viewState.mustMeasureContent) && this.requestMeasure(), n && this.docViewUpdate(), !i.empty) {
      for (let f of this.state.facet(iy)) {
        try {
          f(i);
        } catch (p) {
          Pi(this.state, p, "update listener");
        }
      }
    }
    (l || u) && Promise.resolve().then(() => {
      l && this.state == l.startState && this.dispatch(l), u && !II(this, u) && c.force && Jl(this.contentDOM, c.key, c.keyCode);
    });
  }
  setState(e) {
    if (this.updateState != 0) {
      throw new Error("Calls to EditorView.setState are not allowed while an update is in progress");
    }
    if (this.destroyed) {
      this.viewState.state = e;
      return;
    }
    this.updateState = 2;
    let n = this.hasFocus;
    try {
      for (let r of this.plugins) {
        r.destroy(this);
      }
      this.viewState = new ok(this, e), this.plugins = e.facet(Vl).map(r => new Zm(r)), this.pluginMap.clear();
      for (let r of this.plugins) {
        r.update(this);
      }
      this.docView.destroy(), this.docView = new YS(this), this.inputState.ensureHandlers(this.plugins), this.mountStyles(), this.updateAttrs(), this.bidiCache = [];
    } finally {
      this.updateState = 0;
    }
    n && this.focus(), this.requestMeasure();
  }
  updatePlugins(e) {
    let n = e.startState.facet(Vl), r = e.state.facet(Vl);
    if (n != r) {
      let i = [];
      for (let s of r) {
        let o = n.indexOf(s);
        if (o < 0) {
          i.push(new Zm(s));
        } else {
          let a = this.plugins[o];
          a.mustUpdate = e, i.push(a);
        }
      }
      for (let s of this.plugins) {
        s.mustUpdate != e && s.destroy(this);
      }
      this.plugins = i, this.pluginMap.clear();
    } else {
      for (let i of this.plugins) {
        i.mustUpdate = e;
      }
    }
    for (let i = 0; i < this.plugins.length; i++) {
      this.plugins[i].update(this);
    }
    n != r && this.inputState.ensureHandlers(this.plugins);
  }
  docViewUpdate() {
    for (let e of this.plugins) {
      let n = e.value;
      if (n && n.docViewUpdate) {
        try {
          n.docViewUpdate(this);
        } catch (r) {
          Pi(this.state, r, "doc view update listener");
        }
      }
    }
  }
  measure(e = !0) {
    if (this.destroyed) {
      return;
    }
    if (this.measureScheduled > -1 && this.win.cancelAnimationFrame(this.measureScheduled), this.observer.delayedAndroidKey) {
      this.measureScheduled = -1, this.requestMeasure();
      return;
    }
    this.measureScheduled = 0, e && this.observer.forceFlush();
    let n = null, r = this.viewState.scrollParent, i = this.viewState.getScrollOffset(), {scrollAnchorPos:s, scrollAnchorHeight:o} = this.viewState;
    Math.abs(i - this.viewState.scrollOffset) > 1 && (o = -1), this.viewState.scrollAnchorHeight = -1;
    try {
      for (let a = 0;; a++) {
        if (o < 0) {
          if (iI(r || this.win)) {
            s = -1, o = this.viewState.heightMap.height;
          } else {
            let p = this.viewState.scrollAnchorAt(i);
            s = p.from, o = p.top;
          }
        }
        this.updateState = 1;
        let l = this.viewState.measure();
        if (!l && !this.measureRequests.length && this.viewState.scrollTarget == null) {
          break;
        }
        if (a > 5) {
          console.warn(this.measureRequests.length ? "Measure loop restarted more than 5 times" : "Viewport failed to stabilize");
          break;
        }
        let c = [];
        l & 4 || ([this.measureRequests, c] = [c, this.measureRequests]);
        let u = c.map(p => {
          try {
            return p.read(this);
          } catch (g) {
            return Pi(this.state, g), dk;
          }
        }), h = wp.create(this, this.state, []), f = !1;
        h.flags |= l, n ? n.flags |= l : n = h, this.updateState = 2, h.empty || (this.updatePlugins(h), this.inputState.update(h), this.updateAttrs(), f = this.docView.update(h), f && this.docViewUpdate());
        for (let p = 0; p < c.length; p++) {
          if (u[p] != dk) {
            try {
              let g = c[p];
              g.write && g.write(u[p], this);
            } catch (g) {
              Pi(this.state, g);
            }
          }
        }
        if (f && this.docView.updateSelection(!0), !h.viewportChanged && this.measureRequests.length == 0) {
          if (this.viewState.editorHeight) {
            if (this.viewState.scrollTarget) {
              this.docView.scrollIntoView(this.viewState.scrollTarget), this.viewState.scrollTarget = null, o = -1;
              continue;
            } else {
              let g = ((s < 0 ? this.viewState.heightMap.height : this.viewState.lineBlockAt(s).top) - o) / this.scaleY;
              if ((g > 1 || g < -1) && (r == this.scrollDOM || this.hasFocus || Math.max(this.inputState.lastWheelEvent, this.inputState.lastTouchTime) > Date.now() - 100)) {
                i = i + g, r ? r.scrollTop += g : this.win.scrollBy(0, g), o = -1;
                continue;
              }
            }
          }
          break;
        }
      }
    } finally {
      this.updateState = 0, this.measureScheduled = -1;
    }
    if (n && !n.empty) {
      for (let a of this.state.facet(iy)) {
        a(n);
      }
    }
  }
  get themeClasses() {
    return uy + " " + (this.state.facet(cy) ? UI : HI) + " " + this.state.facet(Vh);
  }
  updateAttrs() {
    let e = hk(this, _I, {class:"cm-editor" + (this.hasFocus ? " cm-focused " : " ") + this.themeClasses}), n = {spellcheck:"false", autocorrect:"off", autocapitalize:"off", writingsuggestions:"false", translate:"no", contenteditable:this.state.facet(no) ? "true" : "false", class:"cm-content", style:`${Ze.tabSize}: ${this.state.tabSize}`, role:"textbox", "aria-multiline":"true"};
    this.state.readOnly && (n["aria-readonly"] = "true"), hk(this, g1, n);
    let r = this.observer.ignore(() => {
      let i = HS(this.contentDOM, this.contentAttrs, n), s = HS(this.dom, this.editorAttrs, e);
      return i || s;
    });
    return this.editorAttrs = e, this.contentAttrs = n, r;
  }
  showAnnouncements(e) {
    let n = !0;
    for (let r of e) {
      for (let i of r.effects) {
        if (i.is(nt.announce)) {
          n && (this.announceDOM.textContent = ""), n = !1;
          let s = this.announceDOM.appendChild(document.createElement("div"));
          s.textContent = i.value;
        }
      }
    }
  }
  mountStyles() {
    this.styleModules = this.state.facet(hu);
    let e = this.state.facet(nt.cspNonce);
    Zo.mount(this.root, this.styleModules.concat(NK).reverse(), e ? {nonce:e} : void 0);
  }
  readMeasured() {
    if (this.updateState == 2) {
      throw new Error("Reading the editor layout isn't allowed during an update");
    }
    this.updateState == 0 && this.measureScheduled > -1 && this.measure(!1);
  }
  requestMeasure(e) {
    if (this.measureScheduled < 0 && (this.measureScheduled = this.win.requestAnimationFrame(() => this.measure())), e) {
      if (this.measureRequests.indexOf(e) > -1) {
        return;
      }
      if (e.key != null) {
        for (let n = 0; n < this.measureRequests.length; n++) {
          if (this.measureRequests[n].key === e.key) {
            this.measureRequests[n] = e;
            return;
          }
        }
      }
      this.measureRequests.push(e);
    }
  }
  plugin(e) {
    let n = this.pluginMap.get(e);
    return (n === void 0 || n && n.plugin != e) && this.pluginMap.set(e, n = this.plugins.find(r => r.plugin == e) || null), n && n.update(this).value;
  }
  get documentTop() {
    return this.contentDOM.getBoundingClientRect().top + this.viewState.paddingTop;
  }
  get documentPadding() {
    return {top:this.viewState.paddingTop, bottom:this.viewState.paddingBottom};
  }
  get scaleX() {
    return this.viewState.scaleX;
  }
  get scaleY() {
    return this.viewState.scaleY;
  }
  elementAtHeight(e) {
    return this.readMeasured(), this.viewState.elementAtHeight(e);
  }
  lineBlockAtHeight(e) {
    return this.readMeasured(), this.viewState.lineBlockAtHeight(e);
  }
  get viewportLineBlocks() {
    return this.viewState.viewportLines;
  }
  lineBlockAt(e) {
    return this.viewState.lineBlockAt(e);
  }
  get contentHeight() {
    return this.viewState.contentHeight;
  }
  moveByChar(e, n, r) {
    return r0(this, e, GS(this, e, n, r));
  }
  moveByGroup(e, n) {
    return r0(this, e, GS(this, e, n, r => jQ(this, e.head, r)));
  }
  visualLineSide(e, n) {
    let r = this.bidiSpans(e), i = this.textDirectionAt(e.from), s = r[n ? r.length - 1 : 0];
    return Ce.cursor(s.side(n, i) + e.from, s.forward(!n, i) ? 1 : -1);
  }
  moveToLineBoundary(e, n, r = !0) {
    return WQ(this, e, n, r);
  }
  moveVertically(e, n, r) {
    return r0(this, e, VQ(this, e, n, r));
  }
  domAtPos(e, n = 1) {
    return this.docView.domAtPos(e, n);
  }
  posAtDOM(e, n = 0) {
    return this.docView.posFromDOM(e, n);
  }
  posAtCoords(e, n = !0) {
    this.readMeasured();
    let r = ay(this, e, n);
    return r && r.pos;
  }
  posAndSideAtCoords(e, n = !0) {
    return this.readMeasured(), ay(this, e, n);
  }
  coordsAtPos(e, n = 1) {
    this.readMeasured();
    let r = this.docView.coordsAt(e, n);
    if (!r || r.left == r.right) {
      return r;
    }
    let i = this.state.doc.lineAt(e), s = this.bidiSpans(i), o = s[Cs.find(s, e - i.from, -1, n)];
    return xd(r, o.dir == xn.LTR == n > 0);
  }
  coordsForChar(e) {
    return this.readMeasured(), this.docView.coordsForChar(e);
  }
  get defaultCharacterWidth() {
    return this.viewState.heightOracle.charWidth;
  }
  get defaultLineHeight() {
    return this.viewState.heightOracle.lineHeight;
  }
  get textDirection() {
    return this.viewState.defaultTextDirection;
  }
  textDirectionAt(e) {
    return !this.state.facet(yI) || e < this.viewport.from || e > this.viewport.to ? this.textDirection : (this.readMeasured(), this.docView.textDirectionAt(e));
  }
  get lineWrapping() {
    return this.viewState.heightOracle.lineWrapping;
  }
  bidiSpans(e) {
    if (e.length > DK) {
      return uI(e.length);
    }
    let n = this.textDirectionAt(e.from), r;
    for (let s of this.bidiCache) {
      if (s.from == e.from && s.dir == n && (s.fresh || cI(s.isolates, r = jS(this, e)))) {
        return s.order;
      }
    }
    r || (r = jS(this, e));
    let i = mQ(e.text, n, r);
    return this.bidiCache.push(new Tp(e.from, e.to, n, r, !0, i)), i;
  }
  get hasFocus() {
    var e;
    return (this.dom.ownerDocument.hasFocus() || Ze.safari && ((e = this.inputState) === null || e === void 0 ? void 0 : e.lastContextMenu) > Date.now() - 3e4) && this.root.activeElement == this.contentDOM;
  }
  focus() {
    this.observer.ignore(() => {
      rI(this.contentDOM), this.docView.updateSelection();
    });
  }
  setRoot(e) {
    this._root != e && (this._root = e, this.observer.setWindow((e.nodeType == 9 ? e : e.ownerDocument).defaultView || window), this.mountStyles());
  }
  destroy() {
    this.root.activeElement == this.contentDOM && this.contentDOM.blur();
    for (let e of this.plugins) {
      e.destroy(this);
    }
    this.plugins = [], this.inputState.destroy(), this.docView.destroy(), this.dom.remove(), this.observer.destroy(), this.measureScheduled > -1 && this.win.cancelAnimationFrame(this.measureScheduled), this.destroyed = !0;
  }
  static scrollIntoView(e, n = {}) {
    var r, i, s, o;
    return Fh.of(new Zl(typeof e == "number" ? Ce.cursor(e) : e, (r = n.y) !== null && r !== void 0 ? r : "nearest", (i = n.x) !== null && i !== void 0 ? i : "nearest", (s = n.yMargin) !== null && s !== void 0 ? s : 5, (o = n.xMargin) !== null && o !== void 0 ? o : 5));
  }
  scrollSnapshot() {
    let {scrollTop:e, scrollLeft:n} = this.scrollDOM, r = this.viewState.scrollAnchorAt(e);
    return Fh.of(new Zl(Ce.cursor(r.from), "start", "start", r.top - e, n, !0));
  }
  setTabFocusMode(e) {
    e == null ? this.inputState.tabFocusMode = this.inputState.tabFocusMode < 0 ? 0 : -1 : typeof e == "boolean" ? this.inputState.tabFocusMode = e ? 0 : -1 : this.inputState.tabFocusMode != 0 && (this.inputState.tabFocusMode = Date.now() + e);
  }
  static domEventHandlers(e) {
    return Kn.define(() => ({}), {eventHandlers:e});
  }
  static domEventObservers(e) {
    return Kn.define(() => ({}), {eventObservers:e});
  }
  static theme(e, n) {
    let r = Zo.newName(), i = [Vh.of(r), hu.of(dy(`.${r}`, e))];
    return n && n.dark && i.push(cy.of(!0)), i;
  }
  static baseTheme(e) {
    return Xd.lowest(hu.of(dy("." + uy, e, WI)));
  }
  static findFromDOM(e) {
    var n;
    let r = e.querySelector(".cm-content"), i = r && Bn.get(r) || Bn.get(e);
    return ((n = i == null ? void 0 : i.root) === null || n === void 0 ? void 0 : n.view) || null;
  }
}
nt.styleModule = hu;
nt.inputHandler = mI;
nt.clipboardInputFilter = f1;
nt.clipboardOutputFilter = p1;
nt.scrollHandler = vI;
nt.focusChangeEffect = bI;
nt.perLineTextDirection = yI;
nt.exceptionSink = gI;
nt.updateListener = iy;
nt.editable = no;
nt.mouseSelectionStyle = pI;
nt.dragMovesSelection = fI;
nt.clickAddsSelectionRange = hI;
nt.decorations = Dg;
nt.blockWrappers = SI;
nt.outerDecorations = m1;
nt.atomicRanges = th;
nt.bidiIsolatedRanges = kI;
nt.cursorScrollMargin = et.define({combine:t => {
  let e = 5, n = 5;
  for (let r of t) {
    typeof r == "number" ? e = n = r : {x:e, y:n} = r;
  }
  return {x:e, y:n};
}});
nt.scrollMargins = EI;
nt.darkTheme = cy;
nt.cspNonce = et.define({combine:t => t.length ? t[0] : ""});
nt.contentAttributes = g1;
nt.editorAttributes = _I;
nt.lineWrapping = nt.contentAttributes.of({class:"cm-lineWrapping"});
nt.announce = zt.define();
const DK = 4096, dk = {};
class Tp {
  constructor(e, n, r, i, s, o) {
    this.from = e, this.to = n, this.dir = r, this.isolates = i, this.fresh = s, this.order = o;
  }
  static update(e, n) {
    if (n.empty && !e.some(s => s.fresh)) {
      return e;
    }
    let r = [], i = e.length ? e[e.length - 1].dir : xn.LTR;
    for (let s = Math.max(0, e.length - 10); s < e.length; s++) {
      let o = e[s];
      o.dir == i && !n.touchesRange(o.from, o.to) && r.push(new Tp(n.mapPos(o.from, 1), n.mapPos(o.to, -1), o.dir, o.isolates, !1, o.order));
    }
    return r;
  }
}
function hk(t, e, n) {
  for (let r = t.state.facet(e), i = r.length - 1; i >= 0; i--) {
    let s = r[i], o = typeof s == "function" ? s(t) : s;
    o && u1(o, n);
  }
  return n;
}
const LK = Ze.mac ? "mac" : Ze.windows ? "win" : Ze.linux ? "linux" : "key";
function MK(t, e) {
  const n = t.split(/-(?!$)/);
  let r = n[n.length - 1];
  r == "Space" && (r = " ");
  let i, s, o, a;
  for (let l = 0; l < n.length - 1; ++l) {
    const c = n[l];
    if (/^(cmd|meta|m)$/i.test(c)) {
      a = !0;
    } else if (/^a(lt)?$/i.test(c)) {
      i = !0;
    } else if (/^(c|ctrl|control)$/i.test(c)) {
      s = !0;
    } else if (/^s(hift)?$/i.test(c)) {
      o = !0;
    } else if (/^mod$/i.test(c)) {
      e == "mac" ? a = !0 : s = !0;
    } else {
      throw new Error("Unrecognized modifier name: " + c);
    }
  }
  return i && (r = "Alt-" + r), s && (r = "Ctrl-" + r), a && (r = "Meta-" + r), o && (r = "Shift-" + r), r;
}
function qh(t, e, n) {
  return e.altKey && (t = "Alt-" + t), e.ctrlKey && (t = "Ctrl-" + t), e.metaKey && (t = "Meta-" + t), n !== !1 && e.shiftKey && (t = "Shift-" + t), t;
}
const BK = Xd.default(nt.domEventHandlers({keydown(t, e) {
  return qI(VI(e.state), t, e, "editor");
}})), jI = et.define({enables:BK}), fk = new WeakMap();
function VI(t) {
  let e = t.facet(jI), n = fk.get(e);
  return n || fk.set(e, n = zK(e.reduce((r, i) => r.concat(i), []))), n;
}
function $K(t, e, n) {
  return qI(VI(t.state), e, t, n);
}
let zo = null;
const FK = 4e3;
function zK(t, e = LK) {
  let n = Object.create(null), r = Object.create(null), i = (o, a) => {
    let l = r[o];
    if (l == null) {
      r[o] = a;
    } else if (l != a) {
      throw new Error("Key binding " + o + " is used both as a regular binding and as a multi-stroke prefix");
    }
  }, s = (o, a, l, c, u) => {
    var h, f;
    let p = n[o] || (n[o] = Object.create(null)), g = a.split(/ (?!$)/).map(x => MK(x, e));
    for (let x = 1; x < g.length; x++) {
      let w = g.slice(0, x).join(" ");
      i(w, !0), p[w] || (p[w] = {preventDefault:!0, stopPropagation:!1, run:[v => {
        let T = zo = {view:v, prefix:w, scope:o};
        return setTimeout(() => {
          zo == T && (zo = null);
        }, FK), !0;
      }]});
    }
    let m = g.join(" ");
    i(m, !1);
    let b = p[m] || (p[m] = {preventDefault:!1, stopPropagation:!1, run:((f = (h = p._any) === null || h === void 0 ? void 0 : h.run) === null || f === void 0 ? void 0 : f.slice()) || []});
    l && b.run.push(l), c && (b.preventDefault = !0), u && (b.stopPropagation = !0);
  };
  for (let o of t) {
    let a = o.scope ? o.scope.split(" ") : ["editor"];
    if (o.any) {
      for (let c of a) {
        let u = n[c] || (n[c] = Object.create(null));
        u._any || (u._any = {preventDefault:!1, stopPropagation:!1, run:[]});
        let {any:h} = o;
        for (let f in u) {
          u[f].run.push(p => h(p, hy));
        }
      }
    }
    let l = o[e] || o.key;
    if (l) {
      for (let c of a) {
        s(c, l, o.run, o.preventDefault, o.stopPropagation), o.shift && s(c, "Shift-" + l, o.shift, o.preventDefault, o.stopPropagation);
      }
    }
  }
  return n;
}
let hy = null;
function qI(t, e, n, r) {
  hy = e;
  let i = tQ(e), s = aa(i, 0), o = Kd(s) == i.length && i != " ", a = "", l = !1, c = !1, u = !1;
  zo && zo.view == n && zo.scope == r && (a = zo.prefix + " ", RI.indexOf(e.keyCode) < 0 && (c = !0, zo = null));
  let h = new Set(), f = b => {
    if (b) {
      for (let x of b.run) {
        if (!h.has(x) && (h.add(x), x(n))) {
          return b.stopPropagation && (u = !0), !0;
        }
      }
      b.preventDefault && (b.stopPropagation && (u = !0), c = !0);
    }
    return !1;
  }, p = t[r], g, m;
  return p && (f(p[a + qh(i, e, !o)]) ? l = !0 : o && (e.altKey || e.metaKey || e.ctrlKey) && !(Ze.windows && e.ctrlKey && e.altKey) && !(Ze.mac && e.altKey && !(e.ctrlKey || e.metaKey)) && (g = ea[e.keyCode]) && g != i ? (f(p[a + qh(g, e, !0)]) || e.shiftKey && (m = md[e.keyCode]) != i && m != g && f(p[a + qh(m, e, !1)])) && (l = !0) : o && e.shiftKey && f(p[a + qh(i, e, !0)]) && (l = !0), !l && f(p._any) && (l = !0)), c && (l = !0), l && u && e.stopPropagation(), hy = null, l;
}
class Va {
  constructor(e, n, r, i, s) {
    this.className = e, this.left = n, this.top = r, this.width = i, this.height = s;
  }
  draw() {
    let e = document.createElement("div");
    return e.className = this.className, this.adjust(e), e;
  }
  update(e, n) {
    return n.className != this.className ? !1 : (this.adjust(e), !0);
  }
  adjust(e) {
    e.style.left = this.left + "px", e.style.top = this.top + "px", this.width != null && (e.style.width = this.width + "px"), e.style.height = this.height + "px";
  }
  eq(e) {
    return this.left == e.left && this.top == e.top && this.width == e.width && this.height == e.height && this.className == e.className;
  }
  static forRange(e, n, r) {
    if (r.empty) {
      let i = e.coordsAtPos(r.head, r.assoc || 1);
      if (!i) {
        return [];
      }
      let s = YI(e);
      return [new Va(n, i.left - s.left, i.top - s.top, null, i.bottom - i.top)];
    } else {
      return HK(e, n, r);
    }
  }
}
function YI(t) {
  let e = t.scrollDOM.getBoundingClientRect();
  return {left:(t.textDirection == xn.LTR ? e.left : e.right - t.scrollDOM.clientWidth * t.scaleX) - t.scrollDOM.scrollLeft * t.scaleX, top:e.top - t.scrollDOM.scrollTop * t.scaleY};
}
function pk(t, e, n, r) {
  let i = t.coordsAtPos(e, n * 2);
  if (!i) {
    return r;
  }
  let s = t.dom.getBoundingClientRect(), o = (i.top + i.bottom) / 2, a = t.posAtCoords({x:s.left + 1, y:o}), l = t.posAtCoords({x:s.right - 1, y:o});
  return a == null || l == null ? r : {from:Math.max(r.from, Math.min(a, l)), to:Math.min(r.to, Math.max(a, l))};
}
function HK(t, e, n) {
  if (n.to <= t.viewport.from || n.from >= t.viewport.to) {
    return [];
  }
  let r = Math.max(n.from, t.viewport.from), i = Math.min(n.to, t.viewport.to), s = t.textDirection == xn.LTR, o = t.contentDOM, a = o.getBoundingClientRect(), l = YI(t), c = o.querySelector(".cm-line"), u = c && window.getComputedStyle(c), h = a.left + (u ? parseInt(u.paddingLeft) + Math.min(0, parseInt(u.textIndent)) : 0), f = a.right - (u ? parseInt(u.paddingRight) : 0), p = oy(t, r, 1), g = oy(t, i, -1), m = p.type == br.Text ? p : null, b = g.type == br.Text ? g : null;
  if (m && (t.lineWrapping || p.widgetLineBreaks) && (m = pk(t, r, 1, m)), b && (t.lineWrapping || g.widgetLineBreaks) && (b = pk(t, i, -1, b)), m && b && m.from == b.from && m.to == b.to) {
    return w(v(n.from, n.to, m));
  }
  {
    let I = m ? v(n.from, null, m) : T(p, !1), _ = b ? v(null, n.to, b) : T(g, !0), N = [];
    return (m || p).to < (b || g).from - (m && b ? 1 : 0) || p.widgetLineBreaks > 1 && I.bottom + t.defaultLineHeight / 2 < _.top ? N.push(x(h, I.bottom, f, _.top)) : I.bottom < _.top && t.elementAtHeight((I.bottom + _.top) / 2).type == br.Text && (I.bottom = _.top = (I.bottom + _.top) / 2), w(I).concat(N).concat(w(_));
  }
  function x(I, _, N, E) {
    return new Va(e, I - l.left, _ - l.top, Math.max(0, N - I), E - _);
  }
  function w({top:I, bottom:_, horizontal:N}) {
    let E = [];
    for (let C = 0; C < N.length; C += 2) {
      E.push(x(N[C], I, N[C + 1], _));
    }
    return E;
  }
  function v(I, _, N) {
    let E = 1e9, C = -1e9, k = [];
    function A(F, B, z, j, V) {
      let ne = t.coordsAtPos(F, F == N.to ? -2 : 2), D = t.coordsAtPos(z, z == N.from ? 2 : -2);
      !ne || !D || (E = Math.min(ne.top, D.top, E), C = Math.max(ne.bottom, D.bottom, C), V == xn.LTR ? k.push(s && B ? h : ne.left, s && j ? f : D.right) : k.push(!s && j ? h : D.left, !s && B ? f : ne.right));
    }
    let P = I ?? N.from, W = _ ?? N.to;
    for (let F of t.visibleRanges) {
      if (F.to > P && F.from < W) {
        for (let B = Math.max(F.from, P), z = Math.min(F.to, W);;) {
          let j = t.state.doc.lineAt(B);
          for (let V of t.bidiSpans(j)) {
            let ne = V.from + j.from, D = V.to + j.from;
            if (ne >= z) {
              break;
            }
            D > B && A(Math.max(ne, B), I == null && ne <= P, Math.min(D, z), _ == null && D >= W, V.dir);
          }
          if (B = j.to + 1, B >= z) {
            break;
          }
        }
      }
    }
    return k.length == 0 && A(P, I == null, W, _ == null, t.textDirection), {top:E, bottom:C, horizontal:k};
  }
  function T(I, _) {
    let N = a.top + (_ ? I.top : I.bottom);
    return {top:N, bottom:N, horizontal:[]};
  }
}
function UK(t, e) {
  return t.constructor == e.constructor && t.eq(e);
}
class WK {
  constructor(e, n) {
    this.view = e, this.layer = n, this.drawn = [], this.scaleX = 1, this.scaleY = 1, this.measureReq = {read:this.measure.bind(this), write:this.draw.bind(this)}, this.dom = e.scrollDOM.appendChild(document.createElement("div")), this.dom.classList.add("cm-layer"), n.above && this.dom.classList.add("cm-layer-above"), n.class && this.dom.classList.add(n.class), this.scale(), this.dom.setAttribute("aria-hidden", "true"), this.setOrder(e.state), e.requestMeasure(this.measureReq), n.mount && n.mount(this.dom, 
    e);
  }
  update(e) {
    e.startState.facet(Mf) != e.state.facet(Mf) && this.setOrder(e.state), (this.layer.update(e, this.dom) || e.geometryChanged) && (this.scale(), e.view.requestMeasure(this.measureReq));
  }
  docViewUpdate(e) {
    this.layer.updateOnDocViewUpdate !== !1 && e.requestMeasure(this.measureReq);
  }
  setOrder(e) {
    let n = 0, r = e.facet(Mf);
    for (; n < r.length && r[n] != this.layer;) {
      n++;
    }
    this.dom.style.zIndex = String((this.layer.above ? 150 : -1) - n);
  }
  measure() {
    return this.layer.markers(this.view);
  }
  scale() {
    let {scaleX:e, scaleY:n} = this.view;
    (e != this.scaleX || n != this.scaleY) && (this.scaleX = e, this.scaleY = n, this.dom.style.transform = `scale(${1 / e}, ${1 / n})`);
  }
  draw(e) {
    if (e.length != this.drawn.length || e.some((n, r) => !UK(n, this.drawn[r]))) {
      let n = this.dom.firstChild, r = 0;
      for (let i of e) {
        i.update && n && i.constructor && this.drawn[r].constructor && i.update(n, this.drawn[r]) ? (n = n.nextSibling, r++) : this.dom.insertBefore(i.draw(), n);
      }
      for (; n;) {
        let i = n.nextSibling;
        n.remove(), n = i;
      }
      this.drawn = e, Ze.webkit && (this.dom.style.display = this.dom.firstChild ? "" : "none");
    }
  }
  destroy() {
    this.layer.destroy && this.layer.destroy(this.dom, this.view), this.dom.remove();
  }
}
const Mf = et.define();
function GI(t) {
  return [Kn.define(e => new WK(e, t)), Mf.of(t)];
}
const hc = et.define({combine(t) {
  return mo(t, {cursorBlinkRate:1200, drawRangeCursor:!0, iosSelectionHandles:!0}, {cursorBlinkRate:(e, n) => Math.min(e, n), drawRangeCursor:(e, n) => e || n});
}});
function jK(t = {}) {
  return [hc.of(t), VK, qK, YK, xI.of(!0)];
}
function QI(t) {
  return t.startState.facet(hc) != t.state.facet(hc);
}
const VK = GI({above:!0, markers(t) {
  let {state:e} = t, n = e.facet(hc), r = [];
  for (let i of e.selection.ranges) {
    let s = i == e.selection.main;
    if (i.empty || n.drawRangeCursor && !(s && Ze.ios && n.iosSelectionHandles)) {
      let o = s ? "cm-cursor cm-cursor-primary" : "cm-cursor cm-cursor-secondary", a = i.empty ? i : Ce.cursor(i.head, i.assoc);
      for (let l of Va.forRange(t, o, a)) {
        r.push(l);
      }
    }
  }
  return r;
}, update(t, e) {
  t.transactions.some(r => r.selection) && (e.style.animationName = e.style.animationName == "cm-blink" ? "cm-blink2" : "cm-blink");
  let n = QI(t);
  return n && gk(t.state, e), t.docChanged || t.selectionSet || n;
}, mount(t, e) {
  gk(e.state, t);
}, class:"cm-cursorLayer"});
function gk(t, e) {
  e.style.animationDuration = t.facet(hc).cursorBlinkRate + "ms";
}
const qK = GI({above:!1, markers(t) {
  let e = [], {main:n, ranges:r} = t.state.selection;
  for (let i of r) {
    if (!i.empty) {
      for (let s of Va.forRange(t, "cm-selectionBackground", i)) {
        e.push(s);
      }
    }
  }
  if (Ze.ios && !n.empty && t.state.facet(hc).iosSelectionHandles) {
    for (let i of Va.forRange(t, "cm-selectionHandle cm-selectionHandle-start", Ce.cursor(n.from, 1))) {
      e.push(i);
    }
    for (let i of Va.forRange(t, "cm-selectionHandle cm-selectionHandle-end", Ce.cursor(n.to, 1))) {
      e.push(i);
    }
  }
  return e;
}, update(t, e) {
  return t.docChanged || t.selectionSet || t.viewportChanged || QI(t);
}, class:"cm-selectionLayer"}), YK = Xd.highest(nt.theme({".cm-line":{"\x26 ::selection, \x26::selection":{backgroundColor:"transparent !important"}, caretColor:"transparent !important"}, ".cm-content":{caretColor:"transparent !important", "\x26 :focus":{caretColor:"initial !important", "\x26::selection, \x26 ::selection":{backgroundColor:"Highlight !important"}}}}));
function mk(t, e, n, r, i) {
  e.lastIndex = 0;
  for (let s = t.iterRange(n, r), o = n, a; !s.next().done; o += s.value.length) {
    if (!s.lineBreak) {
      for (; a = e.exec(s.value);) {
        i(o + a.index, a);
      }
    }
  }
}
function GK(t, e) {
  let n = t.visibleRanges;
  if (n.length == 1 && n[0].from == t.viewport.from && n[0].to == t.viewport.to) {
    return n;
  }
  let r = [];
  for (let {from:i, to:s} of n) {
    i = Math.max(t.state.doc.lineAt(i).from, i - e), s = Math.min(t.state.doc.lineAt(s).to, s + e), r.length && r[r.length - 1].to >= i ? r[r.length - 1].to = s : r.push({from:i, to:s});
  }
  return r;
}
class QK {
  constructor(e) {
    const {regexp:n, decoration:r, decorate:i, boundary:s, maxLength:o = 1e3} = e;
    if (!n.global) {
      throw new RangeError("The regular expression given to MatchDecorator should have its 'g' flag set");
    }
    if (this.regexp = n, i) {
      this.addMatch = (a, l, c, u) => i(u, c, c + a[0].length, a, l);
    } else if (typeof r == "function") {
      this.addMatch = (a, l, c, u) => {
        let h = r(a, l, c);
        h && u(c, c + a[0].length, h);
      };
    } else if (r) {
      this.addMatch = (a, l, c, u) => u(c, c + a[0].length, r);
    } else {
      throw new RangeError("Either 'decorate' or 'decoration' should be provided to MatchDecorator");
    }
    this.boundary = s, this.maxLength = o;
  }
  createDeco(e) {
    let n = new uo(), r = n.add.bind(n);
    for (let {from:i, to:s} of GK(e, this.maxLength)) {
      mk(e.state.doc, this.regexp, i, s, (o, a) => this.addMatch(a, e, o, r));
    }
    return n.finish();
  }
  updateDeco(e, n) {
    let r = 1e9, i = -1;
    return e.docChanged && e.changes.iterChanges((s, o, a, l) => {
      l >= e.view.viewport.from && a <= e.view.viewport.to && (r = Math.min(a, r), i = Math.max(l, i));
    }), e.viewportMoved || i - r > 1e3 ? this.createDeco(e.view) : i > -1 ? this.updateRange(e.view, n.map(e.changes), r, i) : n;
  }
  updateRange(e, n, r, i) {
    for (let s of e.visibleRanges) {
      let o = Math.max(s.from, r), a = Math.min(s.to, i);
      if (a >= o) {
        let l = e.state.doc.lineAt(o), c = l.to < a ? e.state.doc.lineAt(a) : l, u = Math.max(s.from, l.from), h = Math.min(s.to, c.to);
        if (this.boundary) {
          for (; o > l.from; o--) {
            if (this.boundary.test(l.text[o - 1 - l.from])) {
              u = o;
              break;
            }
          }
          for (; a < c.to; a++) {
            if (this.boundary.test(c.text[a - c.from])) {
              h = a;
              break;
            }
          }
        }
        let f = [], p, g = (m, b, x) => f.push(x.range(m, b));
        if (l == c) {
          for (this.regexp.lastIndex = u - l.from; (p = this.regexp.exec(l.text)) && p.index < h - l.from;) {
            this.addMatch(p, e, p.index + l.from, g);
          }
        } else {
          mk(e.state.doc, this.regexp, u, h, (m, b) => this.addMatch(b, e, m, g));
        }
        n = n.update({filterFrom:u, filterTo:h, filter:(m, b) => m < u || b > h, add:f});
      }
    }
    return n;
  }
}
const fy = /x/.unicode != null ? "gu" : "g", KK = new RegExp(`[\0-\b
-\u001f\u007f-\u009f\u00ad\u061c\u200b\u200e\u200f\u2028\u2029\u202d\u202e\u2066\u2067\u2069\uFEFF\ufff9-\ufffc]`, fy), XK = {0:"null", 7:"bell", 8:"backspace", 10:"newline", 11:"vertical tab", 13:"carriage return", 27:"escape", 8203:"zero width space", 8204:"zero width non-joiner", 8205:"zero width joiner", 8206:"left-to-right mark", 8207:"right-to-left mark", 8232:"line separator", 8237:"left-to-right override", 8238:"right-to-left override", 8294:"left-to-right isolate", 8295:"right-to-left isolate", 
8297:"pop directional isolate", 8233:"paragraph separator", 65279:"zero width no-break space", 65532:"object replacement"};
let o0 = null;
function JK() {
  var t;
  if (o0 == null && typeof document < "u" && document.body) {
    let e = document.body.style;
    o0 = ((t = e.tabSize) !== null && t !== void 0 ? t : e.MozTabSize) != null;
  }
  return o0 || !1;
}
const Bf = et.define({combine(t) {
  let e = mo(t, {render:null, specialChars:KK, addSpecialChars:null});
  return (e.replaceTabs = !JK()) && (e.specialChars = new RegExp("\t|" + e.specialChars.source, fy)), e.addSpecialChars && (e.specialChars = new RegExp(e.specialChars.source + "|" + e.addSpecialChars.source, fy)), e;
}});
function ZK(t = {}) {
  return [Bf.of(t), eX()];
}
let bk = null;
function eX() {
  return bk || (bk = Kn.fromClass(class {
    constructor(t) {
      this.view = t, this.decorations = pt.none, this.decorationCache = Object.create(null), this.decorator = this.makeDecorator(t.state.facet(Bf)), this.decorations = this.decorator.createDeco(t);
    }
    makeDecorator(t) {
      return new QK({regexp:t.specialChars, decoration:(e, n, r) => {
        let {doc:i} = n.state, s = aa(e[0], 0);
        if (s == 9) {
          let o = i.lineAt(r), a = n.state.tabSize, l = Ac(o.text, a, r - o.from);
          return pt.replace({widget:new iX((a - l % a) * this.view.defaultCharacterWidth / this.view.scaleX)});
        }
        return this.decorationCache[s] || (this.decorationCache[s] = pt.replace({widget:new rX(t, s)}));
      }, boundary:t.replaceTabs ? void 0 : /[^]/});
    }
    update(t) {
      let e = t.state.facet(Bf);
      t.startState.facet(Bf) != e ? (this.decorator = this.makeDecorator(e), this.decorations = this.decorator.createDeco(t.view)) : this.decorations = this.decorator.updateDeco(t, this.decorations);
    }
  }, {decorations:t => t.decorations}));
}
const tX = "\u2022";
function nX(t) {
  return t >= 32 ? tX : t == 10 ? "\u2424" : String.fromCharCode(9216 + t);
}
class rX extends Fs {
  constructor(e, n) {
    super(), this.options = e, this.code = n;
  }
  eq(e) {
    return e.code == this.code;
  }
  toDOM(e) {
    let n = nX(this.code), r = e.state.phrase("Control character") + " " + (XK[this.code] || "0x" + this.code.toString(16)), i = this.options.render && this.options.render(this.code, r, n);
    if (i) {
      return i;
    }
    let s = document.createElement("span");
    return s.textContent = n, s.title = r, s.setAttribute("aria-label", r), s.className = "cm-specialChar", s;
  }
  ignoreEvent() {
    return !1;
  }
}
class iX extends Fs {
  constructor(e) {
    super(), this.width = e;
  }
  eq(e) {
    return e.width == this.width;
  }
  toDOM() {
    let e = document.createElement("span");
    return e.textContent = "\t", e.className = "cm-tab", e.style.width = this.width + "px", e;
  }
  ignoreEvent() {
    return !1;
  }
}
function sX() {
  return aX;
}
const oX = pt.line({class:"cm-activeLine"}), aX = Kn.fromClass(class {
  constructor(t) {
    this.decorations = this.getDeco(t);
  }
  update(t) {
    (t.docChanged || t.selectionSet) && (this.decorations = this.getDeco(t.view));
  }
  getDeco(t) {
    let e = -1, n = [];
    for (let r of t.state.selection.ranges) {
      let i = t.lineBlockAt(r.head);
      i.from > e && (n.push(oX.range(i.from)), e = i.from);
    }
    return pt.set(n);
  }
}, {decorations:t => t.decorations});
class lX extends Fs {
  constructor(e) {
    super(), this.content = e;
  }
  toDOM(e) {
    let n = document.createElement("span");
    return n.className = "cm-placeholder", n.style.pointerEvents = "none", n.appendChild(typeof this.content == "string" ? document.createTextNode(this.content) : typeof this.content == "function" ? this.content(e) : this.content.cloneNode(!0)), n.setAttribute("aria-hidden", "true"), n;
  }
  coordsAt(e) {
    let n = e.firstChild ? Ku(e.firstChild) : [];
    if (!n.length) {
      return null;
    }
    let r = window.getComputedStyle(e.parentNode), i = xd(n[0], r.direction != "rtl"), s = parseInt(r.lineHeight);
    return i.bottom - i.top > s * 1.5 ? {left:i.left, right:i.right, top:i.top, bottom:i.top + s} : i;
  }
  ignoreEvent() {
    return !1;
  }
}
function cX(t) {
  let e = Kn.fromClass(class {
    constructor(n) {
      this.view = n, this.placeholder = t ? pt.set([pt.widget({widget:new lX(t), side:1}).range(0)]) : pt.none;
    }
    get decorations() {
      return this.view.state.doc.length ? pt.none : this.placeholder;
    }
  }, {decorations:n => n.decorations});
  return typeof t == "string" ? [e, nt.contentAttributes.of({"aria-placeholder":t})] : e;
}
const py = 2e3;
function uX(t, e, n) {
  let r = Math.min(e.line, n.line), i = Math.max(e.line, n.line), s = [];
  if (e.off > py || n.off > py || e.col < 0 || n.col < 0) {
    let o = Math.min(e.off, n.off), a = Math.max(e.off, n.off);
    for (let l = r; l <= i; l++) {
      let c = t.doc.line(l);
      c.length <= a && s.push(Ce.range(c.from + o, c.to + a));
    }
  } else {
    let o = Math.min(e.col, n.col), a = Math.max(e.col, n.col);
    for (let l = r; l <= i; l++) {
      let c = t.doc.line(l), u = Yb(c.text, o, t.tabSize, !0);
      if (u < 0) {
        s.push(Ce.cursor(c.to));
      } else {
        let h = Yb(c.text, a, t.tabSize);
        s.push(Ce.range(c.from + u, c.from + h));
      }
    }
  }
  return s;
}
function dX(t, e) {
  let n = t.coordsAtPos(t.viewport.from);
  return n ? Math.round(Math.abs((n.left - e) / t.defaultCharacterWidth)) : -1;
}
function yk(t, e) {
  let n = t.posAtCoords({x:e.clientX, y:e.clientY}, !1), r = t.state.doc.lineAt(n), i = n - r.from, s = i > py ? -1 : i == r.length ? dX(t, e.clientX) : Ac(r.text, t.state.tabSize, n - r.from);
  return {line:r.number, col:s, off:i};
}
function hX(t, e) {
  let n = yk(t, e), r = t.state.selection;
  return n ? {update(i) {
    if (i.docChanged) {
      let s = i.changes.mapPos(i.startState.doc.line(n.line).from), o = i.state.doc.lineAt(s);
      n = {line:o.number, col:n.col, off:Math.min(n.off, o.length)}, r = r.map(i.changes);
    }
  }, get(i, s, o) {
    let a = yk(t, i);
    if (!a) {
      return r;
    }
    let l = uX(t.state, n, a);
    return l.length ? o ? Ce.create(l.concat(r.ranges)) : Ce.create(l) : r;
  }} : null;
}
function fX(t) {
  let e = n => n.altKey && n.button == 0;
  return nt.mouseSelectionStyle.of((n, r) => e(r) ? hX(n, r) : null);
}
const Yh = "-10000px";
class KI {
  constructor(e, n, r, i) {
    this.facet = n, this.createTooltipView = r, this.removeTooltipView = i, this.input = e.state.facet(n), this.tooltips = this.input.filter(o => o);
    let s = null;
    this.tooltipViews = this.tooltips.map(o => s = r(o, s));
  }
  update(e, n) {
    var r;
    let i = e.state.facet(this.facet), s = i.filter(l => l);
    if (i === this.input) {
      for (let l of this.tooltipViews) {
        l.update && l.update(e);
      }
      return !1;
    }
    let o = [], a = n ? [] : null;
    for (let l = 0; l < s.length; l++) {
      let c = s[l], u = -1;
      if (c) {
        for (let h = 0; h < this.tooltips.length; h++) {
          let f = this.tooltips[h];
          f && f.create == c.create && (u = h);
        }
        if (u < 0) {
          o[l] = this.createTooltipView(c, l ? o[l - 1] : null), a && (a[l] = !!c.above);
        } else {
          let h = o[l] = this.tooltipViews[u];
          a && (a[l] = n[u]), h.update && h.update(e);
        }
      }
    }
    for (let l of this.tooltipViews) {
      o.indexOf(l) < 0 && (this.removeTooltipView(l), (r = l.destroy) === null || r === void 0 || r.call(l));
    }
    return n && (a.forEach((l, c) => n[c] = l), n.length = a.length), this.input = i, this.tooltips = s, this.tooltipViews = o, !0;
  }
}
function pX(t) {
  let e = t.dom.ownerDocument.documentElement;
  return {top:0, left:0, bottom:e.clientHeight, right:e.clientWidth};
}
const a0 = et.define({combine:t => {
  var e, n, r;
  return {position:Ze.ios ? "absolute" : ((e = t.find(i => i.position)) === null || e === void 0 ? void 0 : e.position) || "fixed", parent:((n = t.find(i => i.parent)) === null || n === void 0 ? void 0 : n.parent) || null, tooltipSpace:((r = t.find(i => i.tooltipSpace)) === null || r === void 0 ? void 0 : r.tooltipSpace) || pX};
}}), xk = new WeakMap(), XI = Kn.fromClass(class {
  constructor(t) {
    this.view = t, this.above = [], this.inView = !0, this.madeAbsolute = !1, this.lastTransaction = 0, this.measureTimeout = -1;
    let e = t.state.facet(a0);
    this.position = e.position, this.parent = e.parent, this.classes = t.themeClasses, this.createContainer(), this.measureReq = {read:this.readMeasure.bind(this), write:this.writeMeasure.bind(this), key:this}, this.resizeObserver = typeof ResizeObserver == "function" ? new ResizeObserver(() => this.measureSoon()) : null, this.manager = new KI(t, JI, (n, r) => this.createTooltip(n, r), n => {
      this.resizeObserver && this.resizeObserver.unobserve(n.dom), n.dom.remove();
    }), this.above = this.manager.tooltips.map(n => !!n.above), this.intersectionObserver = typeof IntersectionObserver == "function" ? new IntersectionObserver(n => {
      Date.now() > this.lastTransaction - 50 && n.length > 0 && n[n.length - 1].intersectionRatio < 1 && this.measureSoon();
    }, {threshold:[1]}) : null, this.observeIntersection(), t.win.addEventListener("resize", this.measureSoon = this.measureSoon.bind(this)), this.maybeMeasure();
  }
  createContainer() {
    this.parent ? (this.container = document.createElement("div"), this.container.style.position = "relative", this.container.className = this.view.themeClasses, this.parent.appendChild(this.container)) : this.container = this.view.dom;
  }
  observeIntersection() {
    if (this.intersectionObserver) {
      this.intersectionObserver.disconnect();
      for (let t of this.manager.tooltipViews) {
        this.intersectionObserver.observe(t.dom);
      }
    }
  }
  measureSoon() {
    this.measureTimeout < 0 && (this.measureTimeout = setTimeout(() => {
      this.measureTimeout = -1, this.maybeMeasure();
    }, 50));
  }
  update(t) {
    t.transactions.length && (this.lastTransaction = Date.now());
    let e = this.manager.update(t, this.above);
    e && this.observeIntersection();
    let n = e || t.geometryChanged, r = t.state.facet(a0);
    if (r.position != this.position && !this.madeAbsolute) {
      this.position = r.position;
      for (let i of this.manager.tooltipViews) {
        i.dom.style.position = this.position;
      }
      n = !0;
    }
    if (r.parent != this.parent) {
      this.parent && this.container.remove(), this.parent = r.parent, this.createContainer();
      for (let i of this.manager.tooltipViews) {
        this.container.appendChild(i.dom);
      }
      n = !0;
    } else {
      this.parent && this.view.themeClasses != this.classes && (this.classes = this.container.className = this.view.themeClasses);
    }
    n && this.maybeMeasure();
  }
  createTooltip(t, e) {
    let n = t.create(this.view), r = e ? e.dom : null;
    if (n.dom.classList.add("cm-tooltip"), t.arrow && !n.dom.querySelector(".cm-tooltip \x3e .cm-tooltip-arrow")) {
      let i = document.createElement("div");
      i.className = "cm-tooltip-arrow", n.dom.appendChild(i);
    }
    return n.dom.style.position = this.position, n.dom.style.top = Yh, n.dom.style.left = "0px", this.container.insertBefore(n.dom, r), n.mount && n.mount(this.view), this.resizeObserver && this.resizeObserver.observe(n.dom), n;
  }
  destroy() {
    var t, e, n;
    this.view.win.removeEventListener("resize", this.measureSoon);
    for (let r of this.manager.tooltipViews) {
      r.dom.remove(), (t = r.destroy) === null || t === void 0 || t.call(r);
    }
    this.parent && this.container.remove(), (e = this.resizeObserver) === null || e === void 0 || e.disconnect(), (n = this.intersectionObserver) === null || n === void 0 || n.disconnect(), clearTimeout(this.measureTimeout);
  }
  readMeasure() {
    let t = 1, e = 1, n = !1;
    if (this.position == "fixed" && this.manager.tooltipViews.length) {
      let {dom:s} = this.manager.tooltipViews[0];
      if (Ze.safari) {
        let o = s.getBoundingClientRect();
        n = Math.abs(o.top + 1e4) > 1 || Math.abs(o.left) > 1;
      } else {
        n = !!s.offsetParent && s.offsetParent != this.container.ownerDocument.body;
      }
    }
    if (n || this.position == "absolute") {
      if (this.parent) {
        let s = this.parent.getBoundingClientRect();
        s.width && s.height && (t = s.width / this.parent.offsetWidth, e = s.height / this.parent.offsetHeight);
      } else {
        ({scaleX:t, scaleY:e} = this.view.viewState);
      }
    }
    let r = this.view.scrollDOM.getBoundingClientRect(), i = b1(this.view);
    return {visible:{left:r.left + i.left, top:r.top + i.top, right:r.right - i.right, bottom:r.bottom - i.bottom}, parent:this.parent ? this.container.getBoundingClientRect() : this.view.dom.getBoundingClientRect(), pos:this.manager.tooltips.map((s, o) => {
      let a = this.manager.tooltipViews[o];
      return a.getCoords ? a.getCoords(s.pos) : this.view.coordsAtPos(s.pos);
    }), size:this.manager.tooltipViews.map(({dom:s}) => s.getBoundingClientRect()), space:this.view.state.facet(a0).tooltipSpace(this.view), scaleX:t, scaleY:e, makeAbsolute:n};
  }
  writeMeasure(t) {
    var e;
    if (t.makeAbsolute) {
      this.madeAbsolute = !0, this.position = "absolute";
      for (let a of this.manager.tooltipViews) {
        a.dom.style.position = "absolute";
      }
    }
    let {visible:n, space:r, scaleX:i, scaleY:s} = t, o = [];
    for (let a = 0; a < this.manager.tooltips.length; a++) {
      let l = this.manager.tooltips[a], c = this.manager.tooltipViews[a], {dom:u} = c, h = t.pos[a], f = t.size[a];
      if (!h || l.clip !== !1 && (h.bottom <= Math.max(n.top, r.top) || h.top >= Math.min(n.bottom, r.bottom) || h.right < Math.max(n.left, r.left) - 0.1 || h.left > Math.min(n.right, r.right) + 0.1)) {
        u.style.top = Yh;
        continue;
      }
      let p = l.arrow ? c.dom.querySelector(".cm-tooltip-arrow") : null, g = p ? 7 : 0, m = f.right - f.left, b = (e = xk.get(c)) !== null && e !== void 0 ? e : f.bottom - f.top, x = c.offset || mX, w = this.view.textDirection == xn.LTR, v = f.width > r.right - r.left ? w ? r.left : r.right - f.width : w ? Math.max(r.left, Math.min(h.left - (p ? 14 : 0) + x.x, r.right - m)) : Math.min(Math.max(r.left, h.left - m + (p ? 14 : 0) - x.x), r.right - m), T = this.above[a];
      !l.strictSide && (T ? h.top - b - g - x.y < r.top : h.bottom + b + g + x.y > r.bottom) && T == r.bottom - h.bottom > h.top - r.top && (T = this.above[a] = !T);
      let I = (T ? h.top - r.top : r.bottom - h.bottom) - g;
      if (I < b && c.resize !== !1) {
        if (I < this.view.defaultLineHeight) {
          u.style.top = Yh;
          continue;
        }
        xk.set(c, b), u.style.height = (b = I) / s + "px";
      } else {
        u.style.height && (u.style.height = "");
      }
      let _ = T ? h.top - b - g - x.y : h.bottom + g + x.y, N = v + m;
      if (c.overlap !== !0) {
        for (let E of o) {
          E.left < N && E.right > v && E.top < _ + b && E.bottom > _ && (_ = T ? E.top - b - 2 - g : E.bottom + g + 2);
        }
      }
      if (this.position == "absolute" ? (u.style.top = (_ - t.parent.top) / s + "px", vk(u, (v - t.parent.left) / i)) : (u.style.top = _ / s + "px", vk(u, v / i)), p) {
        let E = h.left + (w ? x.x : -x.x) - (v + 14 - 7);
        p.style.left = E / i + "px";
      }
      c.overlap !== !0 && o.push({left:v, top:_, right:N, bottom:_ + b}), u.classList.toggle("cm-tooltip-above", T), u.classList.toggle("cm-tooltip-below", !T), c.positioned && c.positioned(t.space);
    }
  }
  maybeMeasure() {
    if (this.manager.tooltips.length && (this.view.inView && this.view.requestMeasure(this.measureReq), this.inView != this.view.inView && (this.inView = this.view.inView, !this.inView))) {
      for (let t of this.manager.tooltipViews) {
        t.dom.style.top = Yh;
      }
    }
  }
}, {eventObservers:{scroll() {
  this.maybeMeasure();
}}});
function vk(t, e) {
  let n = parseInt(t.style.left, 10);
  (isNaN(n) || Math.abs(e - n) > 1) && (t.style.left = e + "px");
}
const gX = nt.baseTheme({".cm-tooltip":{zIndex:500, boxSizing:"border-box"}, "\x26light .cm-tooltip":{border:"1px solid #bbb", backgroundColor:"#f5f5f5"}, "\x26light .cm-tooltip-section:not(:first-child)":{borderTop:"1px solid #bbb"}, "\x26dark .cm-tooltip":{backgroundColor:"#333338", color:"white"}, ".cm-tooltip-arrow":{height:"7px", width:`${7 * 2}px`, position:"absolute", zIndex:-1, overflow:"hidden", "\x26:before, \x26:after":{content:"''", position:"absolute", width:0, height:0, borderLeft:"7px solid transparent", 
borderRight:"7px solid transparent"}, ".cm-tooltip-above \x26":{bottom:"-7px", "\x26:before":{borderTop:"7px solid #bbb"}, "\x26:after":{borderTop:"7px solid #f5f5f5", bottom:"1px"}}, ".cm-tooltip-below \x26":{top:"-7px", "\x26:before":{borderBottom:"7px solid #bbb"}, "\x26:after":{borderBottom:"7px solid #f5f5f5", top:"1px"}}}, "\x26dark .cm-tooltip .cm-tooltip-arrow":{"\x26:before":{borderTopColor:"#333338", borderBottomColor:"#333338"}, "\x26:after":{borderTopColor:"transparent", borderBottomColor:"transparent"}}}), 
mX = {x:0, y:0}, JI = et.define({enables:[XI, gX]}), Cp = et.define({combine:t => t.reduce((e, n) => e.concat(n), [])});
class $g {
  static create(e) {
    return new $g(e);
  }
  constructor(e) {
    this.view = e, this.mounted = !1, this.dom = document.createElement("div"), this.dom.classList.add("cm-tooltip-hover"), this.manager = new KI(e, Cp, (n, r) => this.createHostedView(n, r), n => n.dom.remove());
  }
  createHostedView(e, n) {
    let r = e.create(this.view);
    return r.dom.classList.add("cm-tooltip-section"), this.dom.insertBefore(r.dom, n ? n.dom.nextSibling : this.dom.firstChild), this.mounted && r.mount && r.mount(this.view), r;
  }
  mount(e) {
    for (let n of this.manager.tooltipViews) {
      n.mount && n.mount(e);
    }
    this.mounted = !0;
  }
  positioned(e) {
    for (let n of this.manager.tooltipViews) {
      n.positioned && n.positioned(e);
    }
  }
  update(e) {
    this.manager.update(e);
  }
  destroy() {
    var e;
    for (let n of this.manager.tooltipViews) {
      (e = n.destroy) === null || e === void 0 || e.call(n);
    }
  }
  passProp(e) {
    let n;
    for (let r of this.manager.tooltipViews) {
      let i = r[e];
      if (i !== void 0) {
        if (n === void 0) {
          n = i;
        } else if (n !== i) {
          return;
        }
      }
    }
    return n;
  }
  get offset() {
    return this.passProp("offset");
  }
  get getCoords() {
    return this.passProp("getCoords");
  }
  get overlap() {
    return this.passProp("overlap");
  }
  get resize() {
    return this.passProp("resize");
  }
}
const bX = JI.compute([Cp], t => {
  let e = t.facet(Cp);
  return e.length === 0 ? null : {pos:Math.min(...e.map(n => n.pos)), end:Math.max(...e.map(n => {
    var r;
    return (r = n.end) !== null && r !== void 0 ? r : n.pos;
  })), create:$g.create, above:e[0].above, arrow:e.some(n => n.arrow)};
}), yX = et.define();
class xX {
  constructor(e, n, r, i, s, o) {
    this.view = e, this.source = n, this.field = r, this.locked = i, this.setHover = s, this.hoverTime = o, this.hoverTimeout = -1, this.restartTimeout = -1, this.pending = null, this.lastMove = {x:0, y:0, target:e.dom, time:0}, this.checkHover = this.checkHover.bind(this), e.dom.addEventListener("mouseleave", this.mouseleave = this.mouseleave.bind(this)), e.dom.addEventListener("mousemove", this.mousemove = this.mousemove.bind(this));
  }
  update(e) {
    this.pending && (this.pending = null, clearTimeout(this.restartTimeout), this.restartTimeout = setTimeout(() => this.startHover(), 20));
  }
  get active() {
    return this.view.state.field(this.field);
  }
  checkHover() {
    if (this.hoverTimeout = -1, this.active.length) {
      return;
    }
    let e = Date.now() - this.lastMove.time;
    e < this.hoverTime ? this.hoverTimeout = setTimeout(this.checkHover, this.hoverTime - e) : this.startHover();
  }
  startHover() {
    clearTimeout(this.restartTimeout);
    let {view:e, lastMove:n} = this, r = e.docView.tile.nearest(n.target);
    if (!r) {
      return;
    }
    let i, s = 1;
    if (r.isWidget()) {
      i = r.posAtStart;
    } else {
      if (i = e.posAtCoords(n), i == null) {
        return;
      }
      let o = e.coordsAtPos(i);
      if (!o || n.y < o.top || n.y > o.bottom || n.x < o.left - e.defaultCharacterWidth || n.x > o.right + e.defaultCharacterWidth) {
        return;
      }
      let a = e.bidiSpans(e.state.doc.lineAt(i)).find(c => c.from <= i && c.to >= i), l = a && a.dir == xn.RTL ? -1 : 1;
      s = n.x < o.left ? -l : l;
    }
    this.activateHover(e, i, s);
  }
  activateHover(e, n, r, i) {
    let s = this.source(e, n, r), o = a => {
      if (a && !(Array.isArray(a) && !a.length)) {
        let l = Array.isArray(a) ? a : [a];
        i && this.locked.set(l, i), e.dispatch({effects:this.setHover.of(l)});
      }
    };
    if (s && "then" in s) {
      let a = this.pending = {pos:n};
      s.then(l => {
        this.pending == a && (this.pending = null, o(l));
      }, l => Pi(e.state, l, "hover tooltip"));
    } else {
      o(s);
    }
  }
  get tooltip() {
    let e = this.view.plugin(XI), n = e ? e.manager.tooltips.findIndex(r => r.create == $g.create) : -1;
    return n > -1 ? e.manager.tooltipViews[n] : null;
  }
  mousemove(e) {
    var n, r;
    this.lastMove = {x:e.clientX, y:e.clientY, target:e.target, time:Date.now()}, this.hoverTimeout < 0 && (this.hoverTimeout = setTimeout(this.checkHover, this.hoverTime));
    let {active:i, tooltip:s} = this;
    if (i.length && !this.locked.has(i) && s && !vX(s.dom, e) || this.pending) {
      let {pos:o} = i[0] || this.pending, a = (r = (n = i[0]) === null || n === void 0 ? void 0 : n.end) !== null && r !== void 0 ? r : o;
      (o == a ? this.view.posAtCoords(this.lastMove) != o : !wX(this.view, o, a, e.clientX, e.clientY)) && (this.view.dispatch({effects:this.setHover.of([])}), this.pending = null);
    }
  }
  mouseleave(e) {
    clearTimeout(this.hoverTimeout), this.hoverTimeout = -1;
    let {active:n} = this;
    if (n.length && !this.locked.has(n)) {
      let {tooltip:r} = this;
      r && r.dom.contains(e.relatedTarget) ? this.watchTooltipLeave(r.dom) : this.view.dispatch({effects:this.setHover.of([])});
    }
  }
  watchTooltipLeave(e) {
    let n = r => {
      e.removeEventListener("mouseleave", n);
      let {active:i} = this;
      i.length && !this.locked.has(i) && !this.view.dom.contains(r.relatedTarget) && this.view.dispatch({effects:this.setHover.of([])});
    };
    e.addEventListener("mouseleave", n);
  }
  destroy() {
    clearTimeout(this.hoverTimeout), clearTimeout(this.restartTimeout), this.view.dom.removeEventListener("mouseleave", this.mouseleave), this.view.dom.removeEventListener("mousemove", this.mousemove);
  }
}
const Gh = 4;
function vX(t, e) {
  let {left:n, right:r, top:i, bottom:s} = t.getBoundingClientRect(), o;
  if (o = t.querySelector(".cm-tooltip-arrow")) {
    let a = o.getBoundingClientRect();
    i = Math.min(a.top, i), s = Math.max(a.bottom, s);
  }
  return e.clientX >= n - Gh && e.clientX <= r + Gh && e.clientY >= i - Gh && e.clientY <= s + Gh;
}
function wX(t, e, n, r, i, s) {
  let o = t.scrollDOM.getBoundingClientRect(), a = t.documentTop + t.documentPadding.top + t.contentHeight;
  if (o.left > r || o.right < r || o.top > i || Math.min(o.bottom, a) < i) {
    return !1;
  }
  let l = t.posAtCoords({x:r, y:i}, !1);
  return l >= e && l <= n;
}
function _X(t, e = {}) {
  let n = zt.define(), r = new WeakMap(), i = ii.define({create() {
    return [];
  }, update(o, a) {
    let l = r.get(o);
    if (o.length && (e.hideOnChange && (a.docChanged || a.selection) ? o = [] : l && l(a) ? o = [] : e.hideOn && (o = o.filter(c => !e.hideOn(a, c)))), a.docChanged && o.length) {
      let c = [];
      for (let u of o) {
        let h = a.changes.mapPos(u.pos, -1, zr.TrackDel);
        if (h != null) {
          let f = Object.assign(Object.create(null), u);
          f.pos = h, f.end != null && (f.end = a.changes.mapPos(f.end)), c.push(f);
        }
      }
      o = c;
    }
    for (let c of a.effects) {
      c.is(n) && (o = c.value, l = void 0), (c.is(SX) && !c.value || c.value == i) && (o = []);
    }
    return o.length && l && r.set(o, l), o;
  }, provide:o => Cp.from(o)});
  const s = Kn.define(o => new xX(o, t, i, r, n, e.hoverTime || 300));
  return {active:i, extension:[i, s, yX.of(s), bX]};
}
const SX = zt.define(), wk = et.define({combine(t) {
  let e, n;
  for (let r of t) {
    e = e || r.topContainer, n = n || r.bottomContainer;
  }
  return {topContainer:e, bottomContainer:n};
}});
function ZI(t, e) {
  let n = t.plugin(eO), r = n ? n.specs.indexOf(e) : -1;
  return r > -1 ? n.panels[r] : null;
}
const eO = Kn.fromClass(class {
  constructor(t) {
    this.input = t.state.facet(wd), this.specs = this.input.filter(n => n), this.panels = this.specs.map(n => n(t));
    let e = t.state.facet(wk);
    this.top = new Qh(t, !0, e.topContainer), this.bottom = new Qh(t, !1, e.bottomContainer), this.top.sync(this.panels.filter(n => n.top)), this.bottom.sync(this.panels.filter(n => !n.top));
    for (let n of this.panels) {
      n.dom.classList.add("cm-panel"), n.mount && n.mount();
    }
  }
  update(t) {
    let e = t.state.facet(wk);
    this.top.container != e.topContainer && (this.top.sync([]), this.top = new Qh(t.view, !0, e.topContainer)), this.bottom.container != e.bottomContainer && (this.bottom.sync([]), this.bottom = new Qh(t.view, !1, e.bottomContainer)), this.top.syncClasses(), this.bottom.syncClasses();
    let n = t.state.facet(wd);
    if (n != this.input) {
      let r = n.filter(l => l), i = [], s = [], o = [], a = [];
      for (let l of r) {
        let c = this.specs.indexOf(l), u;
        c < 0 ? (u = l(t.view), a.push(u)) : (u = this.panels[c], u.update && u.update(t)), i.push(u), (u.top ? s : o).push(u);
      }
      this.specs = r, this.panels = i, this.top.sync(s), this.bottom.sync(o);
      for (let l of a) {
        l.dom.classList.add("cm-panel"), l.mount && l.mount();
      }
    } else {
      for (let r of this.panels) {
        r.update && r.update(t);
      }
    }
  }
  destroy() {
    this.top.sync([]), this.bottom.sync([]);
  }
}, {provide:t => nt.scrollMargins.of(e => {
  let n = e.plugin(t);
  return n && {top:n.top.scrollMargin(), bottom:n.bottom.scrollMargin()};
})});
class Qh {
  constructor(e, n, r) {
    this.view = e, this.top = n, this.container = r, this.dom = void 0, this.classes = "", this.panels = [], this.syncClasses();
  }
  sync(e) {
    for (let n of this.panels) {
      n.destroy && e.indexOf(n) < 0 && n.destroy();
    }
    this.panels = e, this.syncDOM();
  }
  syncDOM() {
    if (this.panels.length == 0) {
      this.dom && (this.dom.remove(), this.dom = void 0);
      return;
    }
    if (!this.dom) {
      this.dom = document.createElement("div"), this.dom.className = this.top ? "cm-panels cm-panels-top" : "cm-panels cm-panels-bottom", this.dom.style[this.top ? "top" : "bottom"] = "0";
      let n = this.container || this.view.dom;
      n.insertBefore(this.dom, this.top ? n.firstChild : null);
    }
    let e = this.dom.firstChild;
    for (let n of this.panels) {
      if (n.dom.parentNode == this.dom) {
        for (; e != n.dom;) {
          e = _k(e);
        }
        e = e.nextSibling;
      } else {
        this.dom.insertBefore(n.dom, e);
      }
    }
    for (; e;) {
      e = _k(e);
    }
  }
  scrollMargin() {
    return !this.dom || this.container ? 0 : Math.max(0, this.top ? this.dom.getBoundingClientRect().bottom - Math.max(0, this.view.scrollDOM.getBoundingClientRect().top) : Math.min(innerHeight, this.view.scrollDOM.getBoundingClientRect().bottom) - this.dom.getBoundingClientRect().top);
  }
  syncClasses() {
    if (!(!this.container || this.classes == this.view.themeClasses)) {
      for (let e of this.classes.split(" ")) {
        e && this.container.classList.remove(e);
      }
      for (let e of (this.classes = this.view.themeClasses).split(" ")) {
        e && this.container.classList.add(e);
      }
    }
  }
}
function _k(t) {
  let e = t.nextSibling;
  return t.remove(), e;
}
const wd = et.define({enables:eO});
function kX(t, e) {
  let n, r = new Promise(o => n = o), i = o => EX(o, e, n);
  t.state.field(l0, !1) ? t.dispatch({effects:tO.of(i)}) : t.dispatch({effects:zt.appendConfig.of(l0.init(() => [i]))});
  let s = nO.of(i);
  return {close:s, result:r.then(o => ((t.win.queueMicrotask || (l => t.win.setTimeout(l, 10)))(() => {
    t.state.field(l0).indexOf(i) > -1 && t.dispatch({effects:s});
  }), o))};
}
const l0 = ii.define({create() {
  return [];
}, update(t, e) {
  for (let n of e.effects) {
    n.is(tO) ? t = [n.value].concat(t) : n.is(nO) && (t = t.filter(r => r != n.value));
  }
  return t;
}, provide:t => wd.computeN([t], e => e.field(t))}), tO = zt.define(), nO = zt.define();
function EX(t, e, n) {
  let r = e.content ? e.content(t, () => o(null)) : null;
  if (!r) {
    if (r = ln("form"), e.input) {
      let a = ln("input", e.input);
      /^(text|password|number|email|tel|url)$/.test(a.type) && a.classList.add("cm-textfield"), a.name || (a.name = "input"), r.appendChild(ln("label", (e.label || "") + ": ", a));
    } else {
      r.appendChild(document.createTextNode(e.label || ""));
    }
    r.appendChild(document.createTextNode(" ")), r.appendChild(ln("button", {class:"cm-button", type:"submit"}, e.submitLabel || "OK"));
  }
  let i = r.nodeName == "FORM" ? [r] : r.querySelectorAll("form");
  for (let a = 0; a < i.length; a++) {
    let l = i[a];
    l.addEventListener("keydown", c => {
      c.keyCode == 27 ? (c.preventDefault(), o(null)) : c.keyCode == 13 && (c.preventDefault(), o(l));
    }), l.addEventListener("submit", c => {
      c.preventDefault(), o(l);
    });
  }
  let s = ln("div", r, ln("button", {onclick:() => o(null), "aria-label":t.state.phrase("close"), class:"cm-dialog-close", type:"button"}, ["\u00d7"]));
  e.class && (s.className = e.class), s.classList.add("cm-dialog");
  function o(a) {
    s.contains(s.ownerDocument.activeElement) && t.focus(), n(a);
  }
  return {dom:s, top:e.top, mount:() => {
    if (e.focus) {
      let a;
      typeof e.focus == "string" ? a = r.querySelector(e.focus) : a = r.querySelector("input") || r.querySelector("button"), a && "select" in a ? a.select() : a && "focus" in a && a.focus();
    }
  }};
}
class fo extends Jo {
  compare(e) {
    return this == e || this.constructor == e.constructor && this.eq(e);
  }
  eq(e) {
    return !1;
  }
  destroy(e) {
  }
}
fo.prototype.elementClass = "";
fo.prototype.toDOM = void 0;
fo.prototype.mapMode = zr.TrackBefore;
fo.prototype.startSide = fo.prototype.endSide = -1;
fo.prototype.point = !0;
const $f = et.define(), TX = et.define(), CX = {class:"", renderEmptyElements:!1, elementStyle:"", markers:() => $t.empty, lineMarker:() => null, widgetMarker:() => null, lineMarkerChange:null, initialSpacer:null, updateSpacer:null, domEventHandlers:{}, side:"before"}, Zu = et.define();
function AX(t) {
  return [rO(), Zu.of({...CX, ...t})];
}
const Sk = et.define({combine:t => t.some(e => e)});
function rO(t) {
  return [NX];
}
const NX = Kn.fromClass(class {
  constructor(t) {
    this.view = t, this.domAfter = null, this.prevViewport = t.viewport, this.dom = document.createElement("div"), this.dom.className = "cm-gutters cm-gutters-before", this.dom.setAttribute("aria-hidden", "true"), this.dom.style.minHeight = this.view.contentHeight / this.view.scaleY + "px", this.gutters = t.state.facet(Zu).map(e => new Ek(t, e)), this.fixed = !t.state.facet(Sk);
    for (let e of this.gutters) {
      e.config.side == "after" ? this.getDOMAfter().appendChild(e.dom) : this.dom.appendChild(e.dom);
    }
    this.fixed && (this.dom.style.position = "sticky"), this.syncGutters(!1), t.scrollDOM.insertBefore(this.dom, t.contentDOM);
  }
  getDOMAfter() {
    return this.domAfter || (this.domAfter = document.createElement("div"), this.domAfter.className = "cm-gutters cm-gutters-after", this.domAfter.setAttribute("aria-hidden", "true"), this.domAfter.style.minHeight = this.view.contentHeight / this.view.scaleY + "px", this.domAfter.style.position = this.fixed ? "sticky" : "", this.view.scrollDOM.appendChild(this.domAfter)), this.domAfter;
  }
  update(t) {
    if (this.updateGutters(t)) {
      let e = this.prevViewport, n = t.view.viewport, r = Math.min(e.to, n.to) - Math.max(e.from, n.from);
      this.syncGutters(r < (n.to - n.from) * 0.8);
    }
    if (t.geometryChanged) {
      let e = this.view.contentHeight / this.view.scaleY + "px";
      this.dom.style.minHeight = e, this.domAfter && (this.domAfter.style.minHeight = e);
    }
    this.view.state.facet(Sk) != !this.fixed && (this.fixed = !this.fixed, this.dom.style.position = this.fixed ? "sticky" : "", this.domAfter && (this.domAfter.style.position = this.fixed ? "sticky" : "")), this.prevViewport = t.view.viewport;
  }
  syncGutters(t) {
    let e = this.dom.nextSibling;
    t && (this.dom.remove(), this.domAfter && this.domAfter.remove());
    let n = $t.iter(this.view.state.facet($f), this.view.viewport.from), r = [], i = this.gutters.map(s => new IX(s, this.view.viewport, -this.view.documentPadding.top));
    for (let s of this.view.viewportLineBlocks) {
      if (r.length && (r = []), Array.isArray(s.type)) {
        let o = !0;
        for (let a of s.type) {
          if (a.type == br.Text && o) {
            gy(n, r, a.from);
            for (let l of i) {
              l.line(this.view, a, r);
            }
            o = !1;
          } else if (a.widget) {
            for (let l of i) {
              l.widget(this.view, a);
            }
          }
        }
      } else if (s.type == br.Text) {
        gy(n, r, s.from);
        for (let o of i) {
          o.line(this.view, s, r);
        }
      } else if (s.widget) {
        for (let o of i) {
          o.widget(this.view, s);
        }
      }
    }
    for (let s of i) {
      s.finish();
    }
    t && (this.view.scrollDOM.insertBefore(this.dom, e), this.domAfter && this.view.scrollDOM.appendChild(this.domAfter));
  }
  updateGutters(t) {
    let e = t.startState.facet(Zu), n = t.state.facet(Zu), r = t.docChanged || t.heightChanged || t.viewportChanged || !$t.eq(t.startState.facet($f), t.state.facet($f), t.view.viewport.from, t.view.viewport.to);
    if (e == n) {
      for (let i of this.gutters) {
        i.update(t) && (r = !0);
      }
    } else {
      r = !0;
      let i = [];
      for (let s of n) {
        let o = e.indexOf(s);
        o < 0 ? i.push(new Ek(this.view, s)) : (this.gutters[o].update(t), i.push(this.gutters[o]));
      }
      for (let s of this.gutters) {
        s.dom.remove(), i.indexOf(s) < 0 && s.destroy();
      }
      for (let s of i) {
        s.config.side == "after" ? this.getDOMAfter().appendChild(s.dom) : this.dom.appendChild(s.dom);
      }
      this.gutters = i;
    }
    return r;
  }
  destroy() {
    for (let t of this.gutters) {
      t.destroy();
    }
    this.dom.remove(), this.domAfter && this.domAfter.remove();
  }
}, {provide:t => nt.scrollMargins.of(e => {
  let n = e.plugin(t);
  if (!n || n.gutters.length == 0 || !n.fixed) {
    return null;
  }
  let r = n.dom.offsetWidth * e.scaleX, i = n.domAfter ? n.domAfter.offsetWidth * e.scaleX : 0;
  return e.textDirection == xn.LTR ? {left:r, right:i} : {right:r, left:i};
})});
function kk(t) {
  return Array.isArray(t) ? t : [t];
}
function gy(t, e, n) {
  for (; t.value && t.from <= n;) {
    t.from == n && e.push(t.value), t.next();
  }
}
class IX {
  constructor(e, n, r) {
    this.gutter = e, this.height = r, this.i = 0, this.cursor = $t.iter(e.markers, n.from);
  }
  addElement(e, n, r) {
    let {gutter:i} = this, s = (n.top - this.height) / e.scaleY, o = n.height / e.scaleY;
    if (this.i == i.elements.length) {
      let a = new iO(e, o, s, r);
      i.elements.push(a), i.dom.appendChild(a.dom);
    } else {
      i.elements[this.i].update(e, o, s, r);
    }
    this.height = n.bottom, this.i++;
  }
  line(e, n, r) {
    let i = [];
    gy(this.cursor, i, n.from), r.length && (i = i.concat(r));
    let s = this.gutter.config.lineMarker(e, n, i);
    s && i.unshift(s);
    let o = this.gutter;
    i.length == 0 && !o.config.renderEmptyElements || this.addElement(e, n, i);
  }
  widget(e, n) {
    let r = this.gutter.config.widgetMarker(e, n.widget, n), i = r ? [r] : null;
    for (let s of e.state.facet(TX)) {
      let o = s(e, n.widget, n);
      o && (i || (i = [])).push(o);
    }
    i && this.addElement(e, n, i);
  }
  finish() {
    let e = this.gutter;
    for (; e.elements.length > this.i;) {
      let n = e.elements.pop();
      e.dom.removeChild(n.dom), n.destroy();
    }
  }
}
class Ek {
  constructor(e, n) {
    this.view = e, this.config = n, this.elements = [], this.spacer = null, this.dom = document.createElement("div"), this.dom.className = "cm-gutter" + (this.config.class ? " " + this.config.class : "");
    for (let r in n.domEventHandlers) {
      this.dom.addEventListener(r, i => {
        let s = i.target, o;
        if (s != this.dom && this.dom.contains(s)) {
          for (; s.parentNode != this.dom;) {
            s = s.parentNode;
          }
          let l = s.getBoundingClientRect();
          o = (l.top + l.bottom) / 2;
        } else {
          o = i.clientY;
        }
        let a = e.lineBlockAtHeight(o - e.documentTop);
        n.domEventHandlers[r](e, a, i) && i.preventDefault();
      });
    }
    this.markers = kk(n.markers(e)), n.initialSpacer && (this.spacer = new iO(e, 0, 0, [n.initialSpacer(e)]), this.dom.appendChild(this.spacer.dom), this.spacer.dom.style.cssText += "visibility: hidden; pointer-events: none");
  }
  update(e) {
    let n = this.markers;
    if (this.markers = kk(this.config.markers(e.view)), this.spacer && this.config.updateSpacer) {
      let i = this.config.updateSpacer(this.spacer.markers[0], e);
      i != this.spacer.markers[0] && this.spacer.update(e.view, 0, 0, [i]);
    }
    let r = e.view.viewport;
    return !$t.eq(this.markers, n, r.from, r.to) || (this.config.lineMarkerChange ? this.config.lineMarkerChange(e) : !1);
  }
  destroy() {
    for (let e of this.elements) {
      e.destroy();
    }
  }
}
class iO {
  constructor(e, n, r, i) {
    this.height = -1, this.above = 0, this.markers = [], this.dom = document.createElement("div"), this.dom.className = "cm-gutterElement", this.update(e, n, r, i);
  }
  update(e, n, r, i) {
    this.height != n && (this.height = n, this.dom.style.height = n + "px"), this.above != r && (this.dom.style.marginTop = (this.above = r) ? r + "px" : ""), OX(this.markers, i) || this.setMarkers(e, i);
  }
  setMarkers(e, n) {
    let r = "cm-gutterElement", i = this.dom.firstChild;
    for (let s = 0, o = 0;;) {
      let a = o, l = s < n.length ? n[s++] : null, c = !1;
      if (l) {
        let u = l.elementClass;
        u && (r += " " + u);
        for (let h = o; h < this.markers.length; h++) {
          if (this.markers[h].compare(l)) {
            a = h, c = !0;
            break;
          }
        }
      } else {
        a = this.markers.length;
      }
      for (; o < a;) {
        let u = this.markers[o++];
        if (u.toDOM) {
          u.destroy(i);
          let h = i.nextSibling;
          i.remove(), i = h;
        }
      }
      if (!l) {
        break;
      }
      l.toDOM && (c ? i = i.nextSibling : this.dom.insertBefore(l.toDOM(e), i)), c && o++;
    }
    this.dom.className = r, this.markers = n;
  }
  destroy() {
    this.setMarkers(null, []);
  }
}
function OX(t, e) {
  if (t.length != e.length) {
    return !1;
  }
  for (let n = 0; n < t.length; n++) {
    if (!t[n].compare(e[n])) {
      return !1;
    }
  }
  return !0;
}
const PX = et.define(), RX = et.define(), ql = et.define({combine(t) {
  return mo(t, {formatNumber:String, domEventHandlers:{}}, {domEventHandlers(e, n) {
    let r = Object.assign({}, e);
    for (let i in n) {
      let s = r[i], o = n[i];
      r[i] = s ? (a, l, c) => s(a, l, c) || o(a, l, c) : o;
    }
    return r;
  }});
}});
class c0 extends fo {
  constructor(e) {
    super(), this.number = e;
  }
  eq(e) {
    return this.number == e.number;
  }
  toDOM() {
    return document.createTextNode(this.number);
  }
}
function u0(t, e) {
  return t.state.facet(ql).formatNumber(e, t.state);
}
const DX = Zu.compute([ql], t => ({class:"cm-lineNumbers", renderEmptyElements:!1, markers(e) {
  return e.state.facet(PX);
}, lineMarker(e, n, r) {
  return r.some(i => i.toDOM) ? null : new c0(u0(e, e.state.doc.lineAt(n.from).number));
}, widgetMarker:(e, n, r) => {
  for (let i of e.state.facet(RX)) {
    let s = i(e, n, r);
    if (s) {
      return s;
    }
  }
  return null;
}, lineMarkerChange:e => e.startState.facet(ql) != e.state.facet(ql), initialSpacer(e) {
  return new c0(u0(e, Tk(e.state.doc.lines)));
}, updateSpacer(e, n) {
  let r = u0(n.view, Tk(n.view.state.doc.lines));
  return r == e.number ? e : new c0(r);
}, domEventHandlers:t.facet(ql).domEventHandlers, side:"before"}));
function LX(t = {}) {
  return [ql.of(t), rO(), DX];
}
function Tk(t) {
  let e = 9;
  for (; e < t;) {
    e = e * 10 + 9;
  }
  return e;
}
const MX = new class extends fo {
  constructor() {
    super(...arguments), this.elementClass = "cm-activeLineGutter";
  }
}(), BX = $f.compute(["selection"], t => {
  let e = [], n = -1;
  for (let r of t.selection.ranges) {
    let i = t.doc.lineAt(r.head).from;
    i > n && (n = i, e.push(MX.range(i)));
  }
  return $t.of(e);
});
function $X() {
  return BX;
}
const sO = 1024;
let FX = 0;
class d0 {
  constructor(e, n) {
    this.from = e, this.to = n;
  }
}
class Ot {
  constructor(e = {}) {
    this.id = FX++, this.perNode = !!e.perNode, this.deserialize = e.deserialize || (() => {
      throw new Error("This node type doesn't define a deserialize function");
    }), this.combine = e.combine || null;
  }
  add(e) {
    if (this.perNode) {
      throw new RangeError("Can't add per-node props to node types");
    }
    return typeof e != "function" && (e = ti.match(e)), n => {
      let r = e(n);
      return r === void 0 ? null : [this, r];
    };
  }
}
Ot.closedBy = new Ot({deserialize:t => t.split(" ")});
Ot.openedBy = new Ot({deserialize:t => t.split(" ")});
Ot.group = new Ot({deserialize:t => t.split(" ")});
Ot.isolate = new Ot({deserialize:t => {
  if (t && t != "rtl" && t != "ltr" && t != "auto") {
    throw new RangeError("Invalid value for isolate: " + t);
  }
  return t || "auto";
}});
Ot.contextHash = new Ot({perNode:!0});
Ot.lookAhead = new Ot({perNode:!0});
Ot.mounted = new Ot({perNode:!0});
class ed {
  constructor(e, n, r, i = !1) {
    this.tree = e, this.overlay = n, this.parser = r, this.bracketed = i;
  }
  static get(e) {
    return e && e.props && e.props[Ot.mounted.id];
  }
}
const zX = Object.create(null);
class ti {
  constructor(e, n, r, i = 0) {
    this.name = e, this.props = n, this.id = r, this.flags = i;
  }
  static define(e) {
    let n = e.props && e.props.length ? Object.create(null) : zX, r = (e.top ? 1 : 0) | (e.skipped ? 2 : 0) | (e.error ? 4 : 0) | (e.name == null ? 8 : 0), i = new ti(e.name || "", n, e.id, r);
    if (e.props) {
      for (let s of e.props) {
        if (Array.isArray(s) || (s = s(i)), s) {
          if (s[0].perNode) {
            throw new RangeError("Can't store a per-node prop on a node type");
          }
          n[s[0].id] = s[1];
        }
      }
    }
    return i;
  }
  prop(e) {
    return this.props[e.id];
  }
  get isTop() {
    return (this.flags & 1) > 0;
  }
  get isSkipped() {
    return (this.flags & 2) > 0;
  }
  get isError() {
    return (this.flags & 4) > 0;
  }
  get isAnonymous() {
    return (this.flags & 8) > 0;
  }
  is(e) {
    if (typeof e == "string") {
      if (this.name == e) {
        return !0;
      }
      let n = this.prop(Ot.group);
      return n ? n.indexOf(e) > -1 : !1;
    }
    return this.id == e;
  }
  static match(e) {
    let n = Object.create(null);
    for (let r in e) {
      for (let i of r.split(" ")) {
        n[i] = e[r];
      }
    }
    return r => {
      for (let i = r.prop(Ot.group), s = -1; s < (i ? i.length : 0); s++) {
        let o = n[s < 0 ? r.name : i[s]];
        if (o) {
          return o;
        }
      }
    };
  }
}
ti.none = new ti("", Object.create(null), 0, 8);
class w1 {
  constructor(e) {
    this.types = e;
    for (let n = 0; n < e.length; n++) {
      if (e[n].id != n) {
        throw new RangeError("Node type ids should correspond to array positions when creating a node set");
      }
    }
  }
  extend(...e) {
    let n = [];
    for (let r of this.types) {
      let i = null;
      for (let s of e) {
        let o = s(r);
        if (o) {
          i || (i = Object.assign({}, r.props));
          let a = o[1], l = o[0];
          l.combine && l.id in i && (a = l.combine(i[l.id], a)), i[l.id] = a;
        }
      }
      n.push(i ? new ti(r.name, i, r.id, r.flags) : r);
    }
    return new w1(n);
  }
}
const Kh = new WeakMap(), Ck = new WeakMap();
var Ln;
(function(t) {
  t[t.ExcludeBuffers = 1] = "ExcludeBuffers", t[t.IncludeAnonymous = 2] = "IncludeAnonymous", t[t.IgnoreMounts = 4] = "IgnoreMounts", t[t.IgnoreOverlays = 8] = "IgnoreOverlays", t[t.EnterBracketed = 16] = "EnterBracketed";
})(Ln || (Ln = {}));
class Vn {
  constructor(e, n, r, i, s) {
    if (this.type = e, this.children = n, this.positions = r, this.length = i, this.props = null, s && s.length) {
      this.props = Object.create(null);
      for (let [o, a] of s) {
        this.props[typeof o == "number" ? o : o.id] = a;
      }
    }
  }
  toString() {
    let e = ed.get(this);
    if (e && !e.overlay) {
      return e.tree.toString();
    }
    let n = "";
    for (let r of this.children) {
      let i = r.toString();
      i && (n && (n += ","), n += i);
    }
    return this.type.name ? (/\W/.test(this.type.name) && !this.type.isError ? JSON.stringify(this.type.name) : this.type.name) + (n.length ? "(" + n + ")" : "") : n;
  }
  cursor(e = 0) {
    return new by(this.topNode, e);
  }
  cursorAt(e, n = 0, r = 0) {
    let i = Kh.get(this) || this.topNode, s = new by(i);
    return s.moveTo(e, n), Kh.set(this, s._tree), s;
  }
  get topNode() {
    return new Bi(this, 0, 0, null);
  }
  resolve(e, n = 0) {
    let r = _d(Kh.get(this) || this.topNode, e, n, !1);
    return Kh.set(this, r), r;
  }
  resolveInner(e, n = 0) {
    let r = _d(Ck.get(this) || this.topNode, e, n, !0);
    return Ck.set(this, r), r;
  }
  resolveStack(e, n = 0) {
    return WX(this, e, n);
  }
  iterate(e) {
    let {enter:n, leave:r, from:i = 0, to:s = this.length} = e, o = e.mode || 0, a = (o & Ln.IncludeAnonymous) > 0;
    for (let l = this.cursor(o | Ln.IncludeAnonymous);;) {
      let c = !1;
      if (l.from <= s && l.to >= i && (!a && l.type.isAnonymous || n(l) !== !1)) {
        if (l.firstChild()) {
          continue;
        }
        c = !0;
      }
      for (; c && r && (a || !l.type.isAnonymous) && r(l), !l.nextSibling();) {
        if (!l.parent()) {
          return;
        }
        c = !0;
      }
    }
  }
  prop(e) {
    return e.perNode ? this.props ? this.props[e.id] : void 0 : this.type.prop(e);
  }
  get propValues() {
    let e = [];
    if (this.props) {
      for (let n in this.props) {
        e.push([+n, this.props[n]]);
      }
    }
    return e;
  }
  balance(e = {}) {
    return this.children.length <= 8 ? this : k1(ti.none, this.children, this.positions, 0, this.children.length, 0, this.length, (n, r, i) => new Vn(this.type, n, r, i, this.propValues), e.makeTree || ((n, r, i) => new Vn(ti.none, n, r, i)));
  }
  static build(e) {
    return jX(e);
  }
}
Vn.empty = new Vn(ti.none, [], [], 0);
class _1 {
  constructor(e, n) {
    this.buffer = e, this.index = n;
  }
  get id() {
    return this.buffer[this.index - 4];
  }
  get start() {
    return this.buffer[this.index - 3];
  }
  get end() {
    return this.buffer[this.index - 2];
  }
  get size() {
    return this.buffer[this.index - 1];
  }
  get pos() {
    return this.index;
  }
  next() {
    this.index -= 4;
  }
  fork() {
    return new _1(this.buffer, this.index);
  }
}
class na {
  constructor(e, n, r) {
    this.buffer = e, this.length = n, this.set = r;
  }
  get type() {
    return ti.none;
  }
  toString() {
    let e = [];
    for (let n = 0; n < this.buffer.length;) {
      e.push(this.childString(n)), n = this.buffer[n + 3];
    }
    return e.join(",");
  }
  childString(e) {
    let n = this.buffer[e], r = this.buffer[e + 3], i = this.set.types[n], s = i.name;
    if (/\W/.test(s) && !i.isError && (s = JSON.stringify(s)), e += 4, r == e) {
      return s;
    }
    let o = [];
    for (; e < r;) {
      o.push(this.childString(e)), e = this.buffer[e + 3];
    }
    return s + "(" + o.join(",") + ")";
  }
  findChild(e, n, r, i, s) {
    let {buffer:o} = this, a = -1;
    for (let l = e; l != n && !(oO(s, i, o[l + 1], o[l + 2]) && (a = l, r > 0)); l = o[l + 3]) {
    }
    return a;
  }
  slice(e, n, r) {
    let i = this.buffer, s = new Uint16Array(n - e), o = 0;
    for (let a = e, l = 0; a < n;) {
      s[l++] = i[a++], s[l++] = i[a++] - r;
      let c = s[l++] = i[a++] - r;
      s[l++] = i[a++] - e, o = Math.max(o, c);
    }
    return new na(s, o, this.set);
  }
}
function oO(t, e, n, r) {
  switch(t) {
    case -2:
      return n < e;
    case -1:
      return r >= e && n < e;
    case 0:
      return n < e && r > e;
    case 1:
      return n <= e && r > e;
    case 2:
      return r > e;
    case 4:
      return !0;
  }
}
function _d(t, e, n, r) {
  for (var i; t.from == t.to || (n < 1 ? t.from >= e : t.from > e) || (n > -1 ? t.to <= e : t.to < e);) {
    let o = !r && t instanceof Bi && t.index < 0 ? null : t.parent;
    if (!o) {
      return t;
    }
    t = o;
  }
  let s = r ? 0 : Ln.IgnoreOverlays;
  if (r) {
    for (let o = t, a = o.parent; a; o = a, a = o.parent) {
      o instanceof Bi && o.index < 0 && ((i = a.enter(e, n, s)) === null || i === void 0 ? void 0 : i.from) != o.from && (t = a);
    }
  }
  for (;;) {
    let o = t.enter(e, n, s);
    if (!o) {
      return t;
    }
    t = o;
  }
}
class aO {
  cursor(e = 0) {
    return new by(this, e);
  }
  getChild(e, n = null, r = null) {
    let i = Ak(this, e, n, r);
    return i.length ? i[0] : null;
  }
  getChildren(e, n = null, r = null) {
    return Ak(this, e, n, r);
  }
  resolve(e, n = 0) {
    return _d(this, e, n, !1);
  }
  resolveInner(e, n = 0) {
    return _d(this, e, n, !0);
  }
  matchContext(e) {
    return my(this.parent, e);
  }
  enterUnfinishedNodesBefore(e) {
    let n = this.childBefore(e), r = this;
    for (; n;) {
      let i = n.lastChild;
      if (!i || i.to != n.to) {
        break;
      }
      i.type.isError && i.from == i.to ? (r = n, n = i.prevSibling) : n = i;
    }
    return r;
  }
  get node() {
    return this;
  }
  get next() {
    return this.parent;
  }
}
class Bi extends aO {
  constructor(e, n, r, i) {
    super(), this._tree = e, this.from = n, this.index = r, this._parent = i;
  }
  get type() {
    return this._tree.type;
  }
  get name() {
    return this._tree.type.name;
  }
  get to() {
    return this.from + this._tree.length;
  }
  nextChild(e, n, r, i, s = 0) {
    for (let o = this;;) {
      for (let {children:a, positions:l} = o._tree, c = n > 0 ? a.length : -1; e != c; e += n) {
        let u = a[e], h = l[e] + o.from, f;
        if (!(!(s & Ln.EnterBracketed && u instanceof Vn && (f = ed.get(u)) && !f.overlay && f.bracketed && r >= h && r <= h + u.length) && !oO(i, r, h, h + u.length))) {
          if (u instanceof na) {
            if (s & Ln.ExcludeBuffers) {
              continue;
            }
            let p = u.findChild(0, u.buffer.length, n, r - h, i);
            if (p > -1) {
              return new jo(new HX(o, u, e, h), null, p);
            }
          } else if (s & Ln.IncludeAnonymous || !u.type.isAnonymous || S1(u)) {
            let p;
            if (!(s & Ln.IgnoreMounts) && (p = ed.get(u)) && !p.overlay) {
              return new Bi(p.tree, h, e, o);
            }
            let g = new Bi(u, h, e, o);
            return s & Ln.IncludeAnonymous || !g.type.isAnonymous ? g : g.nextChild(n < 0 ? u.children.length - 1 : 0, n, r, i, s);
          }
        }
      }
      if (s & Ln.IncludeAnonymous || !o.type.isAnonymous || (o.index >= 0 ? e = o.index + n : e = n < 0 ? -1 : o._parent._tree.children.length, o = o._parent, !o)) {
        return null;
      }
    }
  }
  get firstChild() {
    return this.nextChild(0, 1, 0, 4);
  }
  get lastChild() {
    return this.nextChild(this._tree.children.length - 1, -1, 0, 4);
  }
  childAfter(e) {
    return this.nextChild(0, 1, e, 2);
  }
  childBefore(e) {
    return this.nextChild(this._tree.children.length - 1, -1, e, -2);
  }
  prop(e) {
    return this._tree.prop(e);
  }
  enter(e, n, r = 0) {
    let i;
    if (!(r & Ln.IgnoreOverlays) && (i = ed.get(this._tree)) && i.overlay) {
      let s = e - this.from, o = r & Ln.EnterBracketed && i.bracketed;
      for (let {from:a, to:l} of i.overlay) {
        if ((n > 0 || o ? a <= s : a < s) && (n < 0 || o ? l >= s : l > s)) {
          return new Bi(i.tree, i.overlay[0].from + this.from, -1, this);
        }
      }
    }
    return this.nextChild(0, 1, e, n, r);
  }
  nextSignificantParent() {
    let e = this;
    for (; e.type.isAnonymous && e._parent;) {
      e = e._parent;
    }
    return e;
  }
  get parent() {
    return this._parent ? this._parent.nextSignificantParent() : null;
  }
  get nextSibling() {
    return this._parent && this.index >= 0 ? this._parent.nextChild(this.index + 1, 1, 0, 4) : null;
  }
  get prevSibling() {
    return this._parent && this.index >= 0 ? this._parent.nextChild(this.index - 1, -1, 0, 4) : null;
  }
  get tree() {
    return this._tree;
  }
  toTree() {
    return this._tree;
  }
  toString() {
    return this._tree.toString();
  }
}
function Ak(t, e, n, r) {
  let i = t.cursor(), s = [];
  if (!i.firstChild()) {
    return s;
  }
  if (n != null) {
    for (let o = !1; !o;) {
      if (o = i.type.is(n), !i.nextSibling()) {
        return s;
      }
    }
  }
  for (;;) {
    if (r != null && i.type.is(r)) {
      return s;
    }
    if (i.type.is(e) && s.push(i.node), !i.nextSibling()) {
      return r == null ? s : [];
    }
  }
}
function my(t, e, n = e.length - 1) {
  for (let r = t; n >= 0; r = r.parent) {
    if (!r) {
      return !1;
    }
    if (!r.type.isAnonymous) {
      if (e[n] && e[n] != r.name) {
        return !1;
      }
      n--;
    }
  }
  return !0;
}
class HX {
  constructor(e, n, r, i) {
    this.parent = e, this.buffer = n, this.index = r, this.start = i;
  }
}
class jo extends aO {
  get name() {
    return this.type.name;
  }
  get from() {
    return this.context.start + this.context.buffer.buffer[this.index + 1];
  }
  get to() {
    return this.context.start + this.context.buffer.buffer[this.index + 2];
  }
  constructor(e, n, r) {
    super(), this.context = e, this._parent = n, this.index = r, this.type = e.buffer.set.types[e.buffer.buffer[r]];
  }
  child(e, n, r) {
    let {buffer:i} = this.context, s = i.findChild(this.index + 4, i.buffer[this.index + 3], e, n - this.context.start, r);
    return s < 0 ? null : new jo(this.context, this, s);
  }
  get firstChild() {
    return this.child(1, 0, 4);
  }
  get lastChild() {
    return this.child(-1, 0, 4);
  }
  childAfter(e) {
    return this.child(1, e, 2);
  }
  childBefore(e) {
    return this.child(-1, e, -2);
  }
  prop(e) {
    return this.type.prop(e);
  }
  enter(e, n, r = 0) {
    if (r & Ln.ExcludeBuffers) {
      return null;
    }
    let {buffer:i} = this.context, s = i.findChild(this.index + 4, i.buffer[this.index + 3], n > 0 ? 1 : -1, e - this.context.start, n);
    return s < 0 ? null : new jo(this.context, this, s);
  }
  get parent() {
    return this._parent || this.context.parent.nextSignificantParent();
  }
  externalSibling(e) {
    return this._parent ? null : this.context.parent.nextChild(this.context.index + e, e, 0, 4);
  }
  get nextSibling() {
    let {buffer:e} = this.context, n = e.buffer[this.index + 3];
    return n < (this._parent ? e.buffer[this._parent.index + 3] : e.buffer.length) ? new jo(this.context, this._parent, n) : this.externalSibling(1);
  }
  get prevSibling() {
    let {buffer:e} = this.context, n = this._parent ? this._parent.index + 4 : 0;
    return this.index == n ? this.externalSibling(-1) : new jo(this.context, this._parent, e.findChild(n, this.index, -1, 0, 4));
  }
  get tree() {
    return null;
  }
  toTree() {
    let e = [], n = [], {buffer:r} = this.context, i = this.index + 4, s = r.buffer[this.index + 3];
    if (s > i) {
      let o = r.buffer[this.index + 1];
      e.push(r.slice(i, s, o)), n.push(0);
    }
    return new Vn(this.type, e, n, this.to - this.from);
  }
  toString() {
    return this.context.buffer.childString(this.index);
  }
}
function lO(t) {
  if (!t.length) {
    return null;
  }
  let e = 0, n = t[0];
  for (let s = 1; s < t.length; s++) {
    let o = t[s];
    (o.from > n.from || o.to < n.to) && (n = o, e = s);
  }
  let r = n instanceof Bi && n.index < 0 ? null : n.parent, i = t.slice();
  return r ? i[e] = r : i.splice(e, 1), new UX(i, n);
}
class UX {
  constructor(e, n) {
    this.heads = e, this.node = n;
  }
  get next() {
    return lO(this.heads);
  }
}
function WX(t, e, n) {
  let r = t.resolveInner(e, n), i = null;
  for (let s = r instanceof Bi ? r : r.context.parent; s; s = s.parent) {
    if (s.index < 0) {
      let o = s.parent;
      (i || (i = [r])).push(o.resolve(e, n)), s = o;
    } else {
      let o = ed.get(s.tree);
      if (o && o.overlay && o.overlay[0].from <= e && o.overlay[o.overlay.length - 1].to >= e) {
        let a = new Bi(o.tree, o.overlay[0].from + s.from, -1, s);
        (i || (i = [r])).push(_d(a, e, n, !1));
      }
    }
  }
  return i ? lO(i) : r;
}
class by {
  get name() {
    return this.type.name;
  }
  constructor(e, n = 0) {
    if (this.buffer = null, this.stack = [], this.index = 0, this.bufferNode = null, this.mode = n & ~Ln.EnterBracketed, e instanceof Bi) {
      this.yieldNode(e);
    } else {
      this._tree = e.context.parent, this.buffer = e.context;
      for (let r = e._parent; r; r = r._parent) {
        this.stack.unshift(r.index);
      }
      this.bufferNode = e, this.yieldBuf(e.index);
    }
  }
  yieldNode(e) {
    return e ? (this._tree = e, this.type = e.type, this.from = e.from, this.to = e.to, !0) : !1;
  }
  yieldBuf(e, n) {
    this.index = e;
    let {start:r, buffer:i} = this.buffer;
    return this.type = n || i.set.types[i.buffer[e]], this.from = r + i.buffer[e + 1], this.to = r + i.buffer[e + 2], !0;
  }
  yield(e) {
    return e ? e instanceof Bi ? (this.buffer = null, this.yieldNode(e)) : (this.buffer = e.context, this.yieldBuf(e.index, e.type)) : !1;
  }
  toString() {
    return this.buffer ? this.buffer.buffer.childString(this.index) : this._tree.toString();
  }
  enterChild(e, n, r) {
    if (!this.buffer) {
      return this.yield(this._tree.nextChild(e < 0 ? this._tree._tree.children.length - 1 : 0, e, n, r, this.mode));
    }
    let {buffer:i} = this.buffer, s = i.findChild(this.index + 4, i.buffer[this.index + 3], e, n - this.buffer.start, r);
    return s < 0 ? !1 : (this.stack.push(this.index), this.yieldBuf(s));
  }
  firstChild() {
    return this.enterChild(1, 0, 4);
  }
  lastChild() {
    return this.enterChild(-1, 0, 4);
  }
  childAfter(e) {
    return this.enterChild(1, e, 2);
  }
  childBefore(e) {
    return this.enterChild(-1, e, -2);
  }
  enter(e, n, r = this.mode) {
    return this.buffer ? r & Ln.ExcludeBuffers ? !1 : this.enterChild(1, e, n) : this.yield(this._tree.enter(e, n, r));
  }
  parent() {
    if (!this.buffer) {
      return this.yieldNode(this.mode & Ln.IncludeAnonymous ? this._tree._parent : this._tree.parent);
    }
    if (this.stack.length) {
      return this.yieldBuf(this.stack.pop());
    }
    let e = this.mode & Ln.IncludeAnonymous ? this.buffer.parent : this.buffer.parent.nextSignificantParent();
    return this.buffer = null, this.yieldNode(e);
  }
  sibling(e) {
    if (!this.buffer) {
      return this._tree._parent ? this.yield(this._tree.index < 0 ? null : this._tree._parent.nextChild(this._tree.index + e, e, 0, 4, this.mode)) : !1;
    }
    let {buffer:n} = this.buffer, r = this.stack.length - 1;
    if (e < 0) {
      let i = r < 0 ? 0 : this.stack[r] + 4;
      if (this.index != i) {
        return this.yieldBuf(n.findChild(i, this.index, -1, 0, 4));
      }
    } else {
      let i = n.buffer[this.index + 3];
      if (i < (r < 0 ? n.buffer.length : n.buffer[this.stack[r] + 3])) {
        return this.yieldBuf(i);
      }
    }
    return r < 0 ? this.yield(this.buffer.parent.nextChild(this.buffer.index + e, e, 0, 4, this.mode)) : !1;
  }
  nextSibling() {
    return this.sibling(1);
  }
  prevSibling() {
    return this.sibling(-1);
  }
  atLastNode(e) {
    let n, r, {buffer:i} = this;
    if (i) {
      if (e > 0) {
        if (this.index < i.buffer.buffer.length) {
          return !1;
        }
      } else {
        for (let s = 0; s < this.index; s++) {
          if (i.buffer.buffer[s + 3] < this.index) {
            return !1;
          }
        }
      }
      ({index:n, parent:r} = i);
    } else {
      ({index:n, _parent:r} = this._tree);
    }
    for (; r; {index:n, _parent:r} = r) {
      if (n > -1) {
        for (let s = n + e, o = e < 0 ? -1 : r._tree.children.length; s != o; s += e) {
          let a = r._tree.children[s];
          if (this.mode & Ln.IncludeAnonymous || a instanceof na || !a.type.isAnonymous || S1(a)) {
            return !1;
          }
        }
      }
    }
    return !0;
  }
  move(e, n) {
    if (n && this.enterChild(e, 0, 4)) {
      return !0;
    }
    for (;;) {
      if (this.sibling(e)) {
        return !0;
      }
      if (this.atLastNode(e) || !this.parent()) {
        return !1;
      }
    }
  }
  next(e = !0) {
    return this.move(1, e);
  }
  prev(e = !0) {
    return this.move(-1, e);
  }
  moveTo(e, n = 0) {
    for (; (this.from == this.to || (n < 1 ? this.from >= e : this.from > e) || (n > -1 ? this.to <= e : this.to < e)) && this.parent();) {
    }
    for (; this.enterChild(1, e, n);) {
    }
    return this;
  }
  get node() {
    if (!this.buffer) {
      return this._tree;
    }
    let e = this.bufferNode, n = null, r = 0;
    if (e && e.context == this.buffer) {
      e: for (let i = this.index, s = this.stack.length; s >= 0;) {
        for (let o = e; o; o = o._parent) {
          if (o.index == i) {
            if (i == this.index) {
              return o;
            }
            n = o, r = s + 1;
            break e;
          }
        }
        i = this.stack[--s];
      }
    }
    for (let i = r; i < this.stack.length; i++) {
      n = new jo(this.buffer, n, this.stack[i]);
    }
    return this.bufferNode = new jo(this.buffer, n, this.index);
  }
  get tree() {
    return this.buffer ? null : this._tree._tree;
  }
  iterate(e, n) {
    for (let r = 0;;) {
      let i = !1;
      if (this.type.isAnonymous || e(this) !== !1) {
        if (this.firstChild()) {
          r++;
          continue;
        }
        this.type.isAnonymous || (i = !0);
      }
      for (;;) {
        if (i && n && n(this), i = this.type.isAnonymous, !r) {
          return;
        }
        if (this.nextSibling()) {
          break;
        }
        this.parent(), r--, i = !0;
      }
    }
  }
  matchContext(e) {
    if (!this.buffer) {
      return my(this.node.parent, e);
    }
    let {buffer:n} = this.buffer, {types:r} = n.set;
    for (let i = e.length - 1, s = this.stack.length - 1; i >= 0; s--) {
      if (s < 0) {
        return my(this._tree, e, i);
      }
      let o = r[n.buffer[this.stack[s]]];
      if (!o.isAnonymous) {
        if (e[i] && e[i] != o.name) {
          return !1;
        }
        i--;
      }
    }
    return !0;
  }
}
function S1(t) {
  return t.children.some(e => e instanceof na || !e.type.isAnonymous || S1(e));
}
function jX(t) {
  var e;
  let {buffer:n, nodeSet:r, maxBufferLength:i = sO, reused:s = [], minRepeatType:o = r.types.length} = t, a = Array.isArray(n) ? new _1(n, n.length) : n, l = r.types, c = 0, u = 0;
  function h(I, _, N, E, C, k) {
    let {id:A, start:P, end:W, size:F} = a, B = u, z = c;
    if (F < 0) {
      if (a.next(), F == -1) {
        let ie = s[A];
        N.push(ie), E.push(P - I);
        return;
      } else if (F == -3) {
        c = A;
        return;
      } else if (F == -4) {
        u = A;
        return;
      } else {
        throw new RangeError(`Unrecognized record size: ${F}`);
      }
    }
    let j = l[A], V, ne, D = P - I;
    if (W - P <= i && (ne = b(a.pos - _, C))) {
      let ie = new Uint16Array(ne.size - ne.skip), ee = a.pos - ne.size, M = ie.length;
      for (; a.pos > ee;) {
        M = x(ne.start, ie, M);
      }
      V = new na(ie, W - ne.start, r), D = ne.start - I;
    } else {
      let ie = a.pos - F;
      a.next();
      let ee = [], M = [], X = A >= o ? A : -1, ge = 0, me = W;
      for (; a.pos > ie;) {
        X >= 0 && a.id == X && a.size >= 0 ? (a.end <= me - i && (g(ee, M, P, ge, a.end, me, X, B, z), ge = ee.length, me = a.end), a.next()) : k > 2500 ? f(P, ie, ee, M) : h(P, ie, ee, M, X, k + 1);
      }
      if (X >= 0 && ge > 0 && ge < ee.length && g(ee, M, P, ge, P, me, X, B, z), ee.reverse(), M.reverse(), X > -1 && ge > 0) {
        let te = p(j, z);
        V = k1(j, ee, M, 0, ee.length, 0, W - P, te, te);
      } else {
        V = m(j, ee, M, W - P, B - W, z);
      }
    }
    N.push(V), E.push(D);
  }
  function f(I, _, N, E) {
    let C = [], k = 0, A = -1;
    for (; a.pos > _;) {
      let {id:P, start:W, end:F, size:B} = a;
      if (B > 4) {
        a.next();
      } else {
        if (A > -1 && W < A) {
          break;
        }
        A < 0 && (A = F - i), C.push(P, W, F), k++, a.next();
      }
    }
    if (k) {
      let P = new Uint16Array(k * 4), W = C[C.length - 2];
      for (let F = C.length - 3, B = 0; F >= 0; F -= 3) {
        P[B++] = C[F], P[B++] = C[F + 1] - W, P[B++] = C[F + 2] - W, P[B++] = B;
      }
      N.push(new na(P, C[2] - W, r)), E.push(W - I);
    }
  }
  function p(I, _) {
    return (N, E, C) => {
      let k = 0, A = N.length - 1, P, W;
      if (A >= 0 && (P = N[A]) instanceof Vn) {
        if (!A && P.type == I && P.length == C) {
          return P;
        }
        (W = P.prop(Ot.lookAhead)) && (k = E[A] + P.length + W);
      }
      return m(I, N, E, C, k, _);
    };
  }
  function g(I, _, N, E, C, k, A, P, W) {
    let F = [], B = [];
    for (; I.length > E;) {
      F.push(I.pop()), B.push(_.pop() + N - C);
    }
    I.push(m(r.types[A], F, B, k - C, P - k, W)), _.push(C - N);
  }
  function m(I, _, N, E, C, k, A) {
    if (k) {
      let P = [Ot.contextHash, k];
      A = A ? [P].concat(A) : [P];
    }
    if (C > 25) {
      let P = [Ot.lookAhead, C];
      A = A ? [P].concat(A) : [P];
    }
    return new Vn(I, _, N, E, A);
  }
  function b(I, _) {
    let N = a.fork(), E = 0, C = 0, k = 0, A = N.end - i, P = {size:0, start:0, skip:0};
    e: for (let W = N.pos - I; N.pos > W;) {
      let F = N.size;
      if (N.id == _ && F >= 0) {
        P.size = E, P.start = C, P.skip = k, k += 4, E += 4, N.next();
        continue;
      }
      let B = N.pos - F;
      if (F < 0 || B < W || N.start < A) {
        break;
      }
      let z = N.id >= o ? 4 : 0, j = N.start;
      for (N.next(); N.pos > B;) {
        if (N.size < 0) {
          if (N.size == -3 || N.size == -4) {
            z += 4;
          } else {
            break e;
          }
        } else {
          N.id >= o && (z += 4);
        }
        N.next();
      }
      C = j, E += F, k += z;
    }
    return (_ < 0 || E == I) && (P.size = E, P.start = C, P.skip = k), P.size > 4 ? P : void 0;
  }
  function x(I, _, N) {
    let {id:E, start:C, end:k, size:A} = a;
    if (a.next(), A >= 0 && E < o) {
      let P = N;
      if (A > 4) {
        let W = a.pos - (A - 4);
        for (; a.pos > W;) {
          N = x(I, _, N);
        }
      }
      _[--N] = P, _[--N] = k - I, _[--N] = C - I, _[--N] = E;
    } else {
      A == -3 ? c = E : A == -4 && (u = E);
    }
    return N;
  }
  let w = [], v = [];
  for (; a.pos > 0;) {
    h(t.start || 0, t.bufferStart || 0, w, v, -1, 0);
  }
  let T = (e = t.length) !== null && e !== void 0 ? e : w.length ? v[0] + w[0].length : 0;
  return new Vn(l[t.topID], w.reverse(), v.reverse(), T);
}
const Nk = new WeakMap();
function Ff(t, e) {
  if (!t.isAnonymous || e instanceof na || e.type != t) {
    return 1;
  }
  let n = Nk.get(e);
  if (n == null) {
    n = 1;
    for (let r of e.children) {
      if (r.type != t || !(r instanceof Vn)) {
        n = 1;
        break;
      }
      n += Ff(t, r);
    }
    Nk.set(e, n);
  }
  return n;
}
function k1(t, e, n, r, i, s, o, a, l) {
  let c = 0;
  for (let g = r; g < i; g++) {
    c += Ff(t, e[g]);
  }
  let u = Math.ceil(c * 1.5 / 8), h = [], f = [];
  function p(g, m, b, x, w) {
    for (let v = b; v < x;) {
      let T = v, I = m[v], _ = Ff(t, g[v]);
      for (v++; v < x; v++) {
        let N = Ff(t, g[v]);
        if (_ + N >= u) {
          break;
        }
        _ += N;
      }
      if (v == T + 1) {
        if (_ > u) {
          let N = g[T];
          p(N.children, N.positions, 0, N.children.length, m[T] + w);
          continue;
        }
        h.push(g[T]);
      } else {
        let N = m[v - 1] + g[v - 1].length - I;
        h.push(k1(t, g, m, T, v, I, N, null, l));
      }
      f.push(I + w - s);
    }
  }
  return p(e, n, r, i, 0), (a || l)(h, f, o);
}
class qa {
  constructor(e, n, r, i, s = !1, o = !1) {
    this.from = e, this.to = n, this.tree = r, this.offset = i, this.open = (s ? 1 : 0) | (o ? 2 : 0);
  }
  get openStart() {
    return (this.open & 1) > 0;
  }
  get openEnd() {
    return (this.open & 2) > 0;
  }
  static addTree(e, n = [], r = !1) {
    let i = [new qa(0, e.length, e, 0, !1, r)];
    for (let s of n) {
      s.to > e.length && i.push(s);
    }
    return i;
  }
  static applyChanges(e, n, r = 128) {
    if (!n.length) {
      return e;
    }
    let i = [], s = 1, o = e.length ? e[0] : null;
    for (let a = 0, l = 0, c = 0;; a++) {
      let u = a < n.length ? n[a] : null, h = u ? u.fromA : 1e9;
      if (h - l >= r) {
        for (; o && o.from < h;) {
          let f = o;
          if (l >= f.from || h <= f.to || c) {
            let p = Math.max(f.from, l) - c, g = Math.min(f.to, h) - c;
            f = p >= g ? null : new qa(p, g, f.tree, f.offset + c, a > 0, !!u);
          }
          if (f && i.push(f), o.to > h) {
            break;
          }
          o = s < e.length ? e[s++] : null;
        }
      }
      if (!u) {
        break;
      }
      l = u.toA, c = u.toA - u.toB;
    }
    return i;
  }
}
class cO {
  startParse(e, n, r) {
    return typeof e == "string" && (e = new VX(e)), r = r ? r.length ? r.map(i => new d0(i.from, i.to)) : [new d0(0, 0)] : [new d0(0, e.length)], this.createParse(e, n || [], r);
  }
  parse(e, n, r) {
    let i = this.startParse(e, n, r);
    for (;;) {
      let s = i.advance();
      if (s) {
        return s;
      }
    }
  }
}
class VX {
  constructor(e) {
    this.string = e;
  }
  get length() {
    return this.string.length;
  }
  chunk(e) {
    return this.string.slice(e);
  }
  get lineChunks() {
    return !1;
  }
  read(e, n) {
    return this.string.slice(e, n);
  }
}
new Ot({perNode:!0});
let qX = 0;
class Ii {
  constructor(e, n, r, i) {
    this.name = e, this.set = n, this.base = r, this.modified = i, this.id = qX++;
  }
  toString() {
    let {name:e} = this;
    for (let n of this.modified) {
      n.name && (e = `${n.name}(${e})`);
    }
    return e;
  }
  static define(e, n) {
    let r = typeof e == "string" ? e : "?";
    if (e instanceof Ii && (n = e), n != null && n.base) {
      throw new Error("Can not derive from a modified tag");
    }
    let i = new Ii(r, [], null, []);
    if (i.set.push(i), n) {
      for (let s of n.set) {
        i.set.push(s);
      }
    }
    return i;
  }
  static defineModifier(e) {
    let n = new Ik(e);
    return r => r.modified.indexOf(n) > -1 ? r : Ik.get(r.base || r, r.modified.concat(n).sort((i, s) => i.id - s.id));
  }
}
let YX = 0, Ik = class uO {
  constructor(e) {
    this.name = e, this.instances = [], this.id = YX++;
  }
  static get(e, n) {
    if (!n.length) {
      return e;
    }
    let r = n[0].instances.find(a => a.base == e && GX(n, a.modified));
    if (r) {
      return r;
    }
    let i = [], s = new Ii(e.name, i, e, n);
    for (let a of n) {
      a.instances.push(s);
    }
    let o = QX(n);
    for (let a of e.set) {
      if (!a.modified.length) {
        for (let l of o) {
          i.push(uO.get(a, l));
        }
      }
    }
    return s;
  }
};
function GX(t, e) {
  return t.length == e.length && t.every((n, r) => n == e[r]);
}
function QX(t) {
  let e = [[]];
  for (let n = 0; n < t.length; n++) {
    for (let r = 0, i = e.length; r < i; r++) {
      e.push(e[r].concat(t[n]));
    }
  }
  return e.sort((n, r) => r.length - n.length);
}
function dO(t) {
  let e = Object.create(null);
  for (let n in t) {
    let r = t[n];
    Array.isArray(r) || (r = [r]);
    for (let i of n.split(" ")) {
      if (i) {
        let s = [], o = 2, a = i;
        for (let h = 0;;) {
          if (a == "..." && h > 0 && h + 3 == i.length) {
            o = 1;
            break;
          }
          let f = /^"(?:[^"\\]|\\.)*?"|[^\/!]+/.exec(a);
          if (!f) {
            throw new RangeError("Invalid path: " + i);
          }
          if (s.push(f[0] == "*" ? "" : f[0][0] == '"' ? JSON.parse(f[0]) : f[0]), h += f[0].length, h == i.length) {
            break;
          }
          let p = i[h++];
          if (h == i.length && p == "!") {
            o = 0;
            break;
          }
          if (p != "/") {
            throw new RangeError("Invalid path: " + i);
          }
          a = i.slice(h);
        }
        let l = s.length - 1, c = s[l];
        if (!c) {
          throw new RangeError("Invalid path: " + i);
        }
        let u = new Sd(r, o, l > 0 ? s.slice(0, l) : null);
        e[c] = u.sort(e[c]);
      }
    }
  }
  return hO.add(e);
}
const hO = new Ot({combine(t, e) {
  let n, r, i;
  for (; t || e;) {
    if (!t || e && t.depth >= e.depth ? (i = e, e = e.next) : (i = t, t = t.next), n && n.mode == i.mode && !i.context && !n.context) {
      continue;
    }
    let s = new Sd(i.tags, i.mode, i.context);
    n ? n.next = s : r = s, n = s;
  }
  return r;
}});
class Sd {
  constructor(e, n, r, i) {
    this.tags = e, this.mode = n, this.context = r, this.next = i;
  }
  get opaque() {
    return this.mode == 0;
  }
  get inherit() {
    return this.mode == 1;
  }
  sort(e) {
    return !e || e.depth < this.depth ? (this.next = e, this) : (e.next = this.sort(e.next), e);
  }
  get depth() {
    return this.context ? this.context.length : 0;
  }
}
Sd.empty = new Sd([], 2, null);
function fO(t, e) {
  let n = Object.create(null);
  for (let s of t) {
    if (!Array.isArray(s.tag)) {
      n[s.tag.id] = s.class;
    } else {
      for (let o of s.tag) {
        n[o.id] = s.class;
      }
    }
  }
  let {scope:r, all:i = null} = e || {};
  return {style:s => {
    let o = i;
    for (let a of s) {
      for (let l of a.set) {
        let c = n[l.id];
        if (c) {
          o = o ? o + " " + c : c;
          break;
        }
      }
    }
    return o;
  }, scope:r};
}
function KX(t, e) {
  let n = null;
  for (let r of t) {
    let i = r.style(e);
    i && (n = n ? n + " " + i : i);
  }
  return n;
}
function XX(t, e, n, r = 0, i = t.length) {
  let s = new JX(r, Array.isArray(e) ? e : [e], n);
  s.highlightRange(t.cursor(), r, i, "", s.highlighters), s.flush(i);
}
class JX {
  constructor(e, n, r) {
    this.at = e, this.highlighters = n, this.span = r, this.class = "";
  }
  startSpan(e, n) {
    n != this.class && (this.flush(e), e > this.at && (this.at = e), this.class = n);
  }
  flush(e) {
    e > this.at && this.class && this.span(this.at, e, this.class);
  }
  highlightRange(e, n, r, i, s) {
    let {type:o, from:a, to:l} = e;
    if (a >= r || l <= n) {
      return;
    }
    o.isTop && (s = this.highlighters.filter(p => !p.scope || p.scope(o)));
    let c = i, u = ZX(e) || Sd.empty, h = KX(s, u.tags);
    if (h && (c && (c += " "), c += h, u.mode == 1 && (i += (i ? " " : "") + h)), this.startSpan(Math.max(n, a), c), u.opaque) {
      return;
    }
    let f = e.tree && e.tree.prop(Ot.mounted);
    if (f && f.overlay) {
      let p = e.node.enter(f.overlay[0].from + a, 1), g = this.highlighters.filter(b => !b.scope || b.scope(f.tree.type)), m = e.firstChild();
      for (let b = 0, x = a;; b++) {
        let w = b < f.overlay.length ? f.overlay[b] : null, v = w ? w.from + a : l, T = Math.max(n, x), I = Math.min(r, v);
        if (T < I && m) {
          for (; e.from < I && (this.highlightRange(e, T, I, i, s), this.startSpan(Math.min(I, e.to), c), !(e.to >= v || !e.nextSibling()));) {
          }
        }
        if (!w || v > r) {
          break;
        }
        x = w.to + a, x > n && (this.highlightRange(p.cursor(), Math.max(n, w.from + a), Math.min(r, x), "", g), this.startSpan(Math.min(r, x), c));
      }
      m && e.parent();
    } else if (e.firstChild()) {
      f && (i = "");
      do {
        if (!(e.to <= n)) {
          if (e.from >= r) {
            break;
          }
          this.highlightRange(e, n, r, i, s), this.startSpan(Math.min(r, e.to), c);
        }
      } while (e.nextSibling());
      e.parent();
    }
  }
}
function ZX(t) {
  let e = t.type.prop(hO);
  for (; e && e.context && !t.matchContext(e.context);) {
    e = e.next;
  }
  return e || null;
}
const Qe = Ii.define, Xh = Qe(), Mo = Qe(), Ok = Qe(Mo), Pk = Qe(Mo), Bo = Qe(), Jh = Qe(Bo), h0 = Qe(Bo), vs = Qe(), ba = Qe(vs), bs = Qe(), ys = Qe(), yy = Qe(), nu = Qe(yy), Zh = Qe(), Re = {comment:Xh, lineComment:Qe(Xh), blockComment:Qe(Xh), docComment:Qe(Xh), name:Mo, variableName:Qe(Mo), typeName:Ok, tagName:Qe(Ok), propertyName:Pk, attributeName:Qe(Pk), className:Qe(Mo), labelName:Qe(Mo), namespace:Qe(Mo), macroName:Qe(Mo), literal:Bo, string:Jh, docString:Qe(Jh), character:Qe(Jh), attributeValue:Qe(Jh), 
number:h0, integer:Qe(h0), float:Qe(h0), bool:Qe(Bo), regexp:Qe(Bo), escape:Qe(Bo), color:Qe(Bo), url:Qe(Bo), keyword:bs, self:Qe(bs), null:Qe(bs), atom:Qe(bs), unit:Qe(bs), modifier:Qe(bs), operatorKeyword:Qe(bs), controlKeyword:Qe(bs), definitionKeyword:Qe(bs), moduleKeyword:Qe(bs), operator:ys, derefOperator:Qe(ys), arithmeticOperator:Qe(ys), logicOperator:Qe(ys), bitwiseOperator:Qe(ys), compareOperator:Qe(ys), updateOperator:Qe(ys), definitionOperator:Qe(ys), typeOperator:Qe(ys), controlOperator:Qe(ys), 
punctuation:yy, separator:Qe(yy), bracket:nu, angleBracket:Qe(nu), squareBracket:Qe(nu), paren:Qe(nu), brace:Qe(nu), content:vs, heading:ba, heading1:Qe(ba), heading2:Qe(ba), heading3:Qe(ba), heading4:Qe(ba), heading5:Qe(ba), heading6:Qe(ba), contentSeparator:Qe(vs), list:Qe(vs), quote:Qe(vs), emphasis:Qe(vs), strong:Qe(vs), link:Qe(vs), monospace:Qe(vs), strikethrough:Qe(vs), inserted:Qe(), deleted:Qe(), changed:Qe(), invalid:Qe(), meta:Zh, documentMeta:Qe(Zh), annotation:Qe(Zh), processingInstruction:Qe(Zh), 
definition:Ii.defineModifier("definition"), constant:Ii.defineModifier("constant"), function:Ii.defineModifier("function"), standard:Ii.defineModifier("standard"), local:Ii.defineModifier("local"), special:Ii.defineModifier("special")};
for (let t in Re) {
  let e = Re[t];
  e instanceof Ii && (e.name = t);
}
fO([{tag:Re.link, class:"tok-link"}, {tag:Re.heading, class:"tok-heading"}, {tag:Re.emphasis, class:"tok-emphasis"}, {tag:Re.strong, class:"tok-strong"}, {tag:Re.keyword, class:"tok-keyword"}, {tag:Re.atom, class:"tok-atom"}, {tag:Re.bool, class:"tok-bool"}, {tag:Re.url, class:"tok-url"}, {tag:Re.labelName, class:"tok-labelName"}, {tag:Re.inserted, class:"tok-inserted"}, {tag:Re.deleted, class:"tok-deleted"}, {tag:Re.literal, class:"tok-literal"}, {tag:Re.string, class:"tok-string"}, {tag:Re.number, 
class:"tok-number"}, {tag:[Re.regexp, Re.escape, Re.special(Re.string)], class:"tok-string2"}, {tag:Re.variableName, class:"tok-variableName"}, {tag:Re.local(Re.variableName), class:"tok-variableName tok-local"}, {tag:Re.definition(Re.variableName), class:"tok-variableName tok-definition"}, {tag:Re.special(Re.variableName), class:"tok-variableName2"}, {tag:Re.definition(Re.propertyName), class:"tok-propertyName tok-definition"}, {tag:Re.typeName, class:"tok-typeName"}, {tag:Re.namespace, class:"tok-namespace"}, 
{tag:Re.className, class:"tok-className"}, {tag:Re.macroName, class:"tok-macroName"}, {tag:Re.propertyName, class:"tok-propertyName"}, {tag:Re.operator, class:"tok-operator"}, {tag:Re.comment, class:"tok-comment"}, {tag:Re.meta, class:"tok-meta"}, {tag:Re.invalid, class:"tok-invalid"}, {tag:Re.punctuation, class:"tok-punctuation"}]);
var f0;
const Yl = new Ot();
function eJ(t) {
  return et.define({combine:t ? e => e.concat(t) : void 0});
}
const tJ = new Ot();
class Ji {
  constructor(e, n, r = [], i = "") {
    this.data = e, this.name = i, Yt.prototype.hasOwnProperty("tree") || Object.defineProperty(Yt.prototype, "tree", {get() {
      return Ur(this);
    }}), this.parser = n, this.extension = [ra.of(this), Yt.languageData.of((s, o, a) => {
      let l = Rk(s, o, a), c = l.type.prop(Yl);
      if (!c) {
        return [];
      }
      let u = s.facet(c), h = l.type.prop(tJ);
      if (h) {
        let f = l.resolve(o - l.from, a);
        for (let p of h) {
          if (p.test(f, s)) {
            let g = s.facet(p.facet);
            return p.type == "replace" ? g : g.concat(u);
          }
        }
      }
      return u;
    })].concat(r);
  }
  isActiveAt(e, n, r = -1) {
    return Rk(e, n, r).type.prop(Yl) == this.data;
  }
  findRegions(e) {
    let n = e.facet(ra);
    if ((n == null ? void 0 : n.data) == this.data) {
      return [{from:0, to:e.doc.length}];
    }
    if (!n || !n.allowsNesting) {
      return [];
    }
    let r = [], i = (s, o) => {
      if (s.prop(Yl) == this.data) {
        r.push({from:o, to:o + s.length});
        return;
      }
      let a = s.prop(Ot.mounted);
      if (a) {
        if (a.tree.prop(Yl) == this.data) {
          if (a.overlay) {
            for (let l of a.overlay) {
              r.push({from:l.from + o, to:l.to + o});
            }
          } else {
            r.push({from:o, to:o + s.length});
          }
          return;
        } else if (a.overlay) {
          let l = r.length;
          if (i(a.tree, a.overlay[0].from + o), r.length > l) {
            return;
          }
        }
      }
      for (let l = 0; l < s.children.length; l++) {
        let c = s.children[l];
        c instanceof Vn && i(c, s.positions[l] + o);
      }
    };
    return i(Ur(e), 0), r;
  }
  get allowsNesting() {
    return !0;
  }
}
Ji.setState = zt.define();
function Rk(t, e, n) {
  let r = t.facet(ra), i = Ur(t).topNode;
  if (!r || r.allowsNesting) {
    for (let s = i; s; s = s.enter(e, n, Ln.ExcludeBuffers | Ln.EnterBracketed)) {
      s.type.isTop && (i = s);
    }
  }
  return i;
}
class Ap extends Ji {
  constructor(e, n, r) {
    super(e, n, [], r), this.parser = n;
  }
  static define(e) {
    let n = eJ(e.languageData);
    return new Ap(n, e.parser.configure({props:[Yl.add(r => r.isTop ? n : void 0)]}), e.name);
  }
  configure(e, n) {
    return new Ap(this.data, this.parser.configure(e), n || this.name);
  }
  get allowsNesting() {
    return this.parser.hasWrappers();
  }
}
function Ur(t) {
  let e = t.field(Ji.state, !1);
  return e ? e.tree : Vn.empty;
}
class nJ {
  constructor(e) {
    this.doc = e, this.cursorPos = 0, this.string = "", this.cursor = e.iter();
  }
  get length() {
    return this.doc.length;
  }
  syncTo(e) {
    return this.string = this.cursor.next(e - this.cursorPos).value, this.cursorPos = e + this.string.length, this.cursorPos - this.string.length;
  }
  chunk(e) {
    return this.syncTo(e), this.string;
  }
  get lineChunks() {
    return !0;
  }
  read(e, n) {
    let r = this.cursorPos - this.string.length;
    return e < r || n >= this.cursorPos ? this.doc.sliceString(e, n) : this.string.slice(e - r, n - r);
  }
}
let ru = null;
class Np {
  constructor(e, n, r = [], i, s, o, a, l) {
    this.parser = e, this.state = n, this.fragments = r, this.tree = i, this.treeLen = s, this.viewport = o, this.skipped = a, this.scheduleOn = l, this.parse = null, this.tempSkipped = [];
  }
  static create(e, n, r) {
    return new Np(e, n, [], Vn.empty, 0, r, [], null);
  }
  startParse() {
    return this.parser.startParse(new nJ(this.state.doc), this.fragments);
  }
  work(e, n) {
    return n != null && n >= this.state.doc.length && (n = void 0), this.tree != Vn.empty && this.isDone(n ?? this.state.doc.length) ? (this.takeTree(), !0) : this.withContext(() => {
      var r;
      if (typeof e == "number") {
        let i = Date.now() + e;
        e = () => Date.now() > i;
      }
      for (this.parse || (this.parse = this.startParse()), n != null && (this.parse.stoppedAt == null || this.parse.stoppedAt > n) && n < this.state.doc.length && this.parse.stopAt(n);;) {
        let i = this.parse.advance();
        if (i) {
          if (this.fragments = this.withoutTempSkipped(qa.addTree(i, this.fragments, this.parse.stoppedAt != null)), this.treeLen = (r = this.parse.stoppedAt) !== null && r !== void 0 ? r : this.state.doc.length, this.tree = i, this.parse = null, this.treeLen < (n ?? this.state.doc.length)) {
            this.parse = this.startParse();
          } else {
            return !0;
          }
        }
        if (e()) {
          return !1;
        }
      }
    });
  }
  takeTree() {
    let e, n;
    this.parse && (e = this.parse.parsedPos) >= this.treeLen && ((this.parse.stoppedAt == null || this.parse.stoppedAt > e) && this.parse.stopAt(e), this.withContext(() => {
      for (; !(n = this.parse.advance());) {
      }
    }), this.treeLen = e, this.tree = n, this.fragments = this.withoutTempSkipped(qa.addTree(this.tree, this.fragments, !0)), this.parse = null);
  }
  withContext(e) {
    let n = ru;
    ru = this;
    try {
      return e();
    } finally {
      ru = n;
    }
  }
  withoutTempSkipped(e) {
    for (let n; n = this.tempSkipped.pop();) {
      e = Dk(e, n.from, n.to);
    }
    return e;
  }
  changes(e, n) {
    let {fragments:r, tree:i, treeLen:s, viewport:o, skipped:a} = this;
    if (this.takeTree(), !e.empty) {
      let l = [];
      if (e.iterChangedRanges((c, u, h, f) => l.push({fromA:c, toA:u, fromB:h, toB:f})), r = qa.applyChanges(r, l), i = Vn.empty, s = 0, o = {from:e.mapPos(o.from, -1), to:e.mapPos(o.to, 1)}, this.skipped.length) {
        a = [];
        for (let c of this.skipped) {
          let u = e.mapPos(c.from, 1), h = e.mapPos(c.to, -1);
          u < h && a.push({from:u, to:h});
        }
      }
    }
    return new Np(this.parser, n, r, i, s, o, a, this.scheduleOn);
  }
  updateViewport(e) {
    if (this.viewport.from == e.from && this.viewport.to == e.to) {
      return !1;
    }
    this.viewport = e;
    let n = this.skipped.length;
    for (let r = 0; r < this.skipped.length; r++) {
      let {from:i, to:s} = this.skipped[r];
      i < e.to && s > e.from && (this.fragments = Dk(this.fragments, i, s), this.skipped.splice(r--, 1));
    }
    return this.skipped.length >= n ? !1 : (this.reset(), !0);
  }
  reset() {
    this.parse && (this.takeTree(), this.parse = null);
  }
  skipUntilInView(e, n) {
    this.skipped.push({from:e, to:n});
  }
  static getSkippingParser(e) {
    return new class extends cO {
      createParse(n, r, i) {
        let s = i[0].from, o = i[i.length - 1].to;
        return {parsedPos:s, advance() {
          let l = ru;
          if (l) {
            for (let c of i) {
              l.tempSkipped.push(c);
            }
            e && (l.scheduleOn = l.scheduleOn ? Promise.all([l.scheduleOn, e]) : e);
          }
          return this.parsedPos = o, new Vn(ti.none, [], [], o - s);
        }, stoppedAt:null, stopAt() {
        }};
      }
    }();
  }
  isDone(e) {
    e = Math.min(e, this.state.doc.length);
    let n = this.fragments;
    return this.treeLen >= e && n.length && n[0].from == 0 && n[0].to >= e;
  }
  static get() {
    return ru;
  }
}
function Dk(t, e, n) {
  return qa.applyChanges(t, [{fromA:e, toA:n, fromB:e, toB:n}]);
}
class fc {
  constructor(e) {
    this.context = e, this.tree = e.tree;
  }
  apply(e) {
    if (!e.docChanged && this.tree == this.context.tree) {
      return this;
    }
    let n = this.context.changes(e.changes, e.state), r = this.context.treeLen == e.startState.doc.length ? void 0 : Math.max(e.changes.mapPos(this.context.treeLen), n.viewport.to);
    return n.work(20, r) || n.takeTree(), new fc(n);
  }
  static init(e) {
    let n = Math.min(3e3, e.doc.length), r = Np.create(e.facet(ra).parser, e, {from:0, to:n});
    return r.work(20, n) || r.takeTree(), new fc(r);
  }
}
Ji.state = ii.define({create:fc.init, update(t, e) {
  for (let n of e.effects) {
    if (n.is(Ji.setState)) {
      return n.value;
    }
  }
  return e.startState.facet(ra) != e.state.facet(ra) ? fc.init(e.state) : t.apply(e);
}});
let pO = t => {
  let e = setTimeout(() => t(), 500);
  return () => clearTimeout(e);
};
typeof requestIdleCallback < "u" && (pO = t => {
  let e = -1, n = setTimeout(() => {
    e = requestIdleCallback(t, {timeout:400});
  }, 100);
  return () => e < 0 ? clearTimeout(n) : cancelIdleCallback(e);
});
const p0 = typeof navigator < "u" && (!((f0 = navigator.scheduling) === null || f0 === void 0) && f0.isInputPending) ? () => navigator.scheduling.isInputPending() : null, rJ = Kn.fromClass(class {
  constructor(e) {
    this.view = e, this.working = null, this.workScheduled = 0, this.chunkEnd = -1, this.chunkBudget = -1, this.work = this.work.bind(this), this.scheduleWork();
  }
  update(e) {
    let n = this.view.state.field(Ji.state).context;
    (n.updateViewport(e.view.viewport) || this.view.viewport.to > n.treeLen) && this.scheduleWork(), (e.docChanged || e.selectionSet) && (this.view.hasFocus && (this.chunkBudget += 50), this.scheduleWork()), this.checkAsyncSchedule(n);
  }
  scheduleWork() {
    if (this.working) {
      return;
    }
    let {state:e} = this.view, n = e.field(Ji.state);
    (n.tree != n.context.tree || !n.context.isDone(e.doc.length)) && (this.working = pO(this.work));
  }
  work(e) {
    this.working = null;
    let n = Date.now();
    if (this.chunkEnd < n && (this.chunkEnd < 0 || this.view.hasFocus) && (this.chunkEnd = n + 3e4, this.chunkBudget = 3e3), this.chunkBudget <= 0) {
      return;
    }
    let {state:r, viewport:{to:i}} = this.view, s = r.field(Ji.state);
    if (s.tree == s.context.tree && s.context.isDone(i + 1e5)) {
      return;
    }
    let o = Date.now() + Math.min(this.chunkBudget, 100, e && !p0 ? Math.max(25, e.timeRemaining() - 5) : 1e9), a = s.context.treeLen < i && r.doc.length > i + 1e3, l = s.context.work(() => p0 && p0() || Date.now() > o, i + (a ? 0 : 1e5));
    this.chunkBudget -= Date.now() - n, (l || this.chunkBudget <= 0) && (s.context.takeTree(), this.view.dispatch({effects:Ji.setState.of(new fc(s.context))})), this.chunkBudget > 0 && !(l && !a) && this.scheduleWork(), this.checkAsyncSchedule(s.context);
  }
  checkAsyncSchedule(e) {
    e.scheduleOn && (this.workScheduled++, e.scheduleOn.then(() => this.scheduleWork()).catch(n => Pi(this.view.state, n)).then(() => this.workScheduled--), e.scheduleOn = null);
  }
  destroy() {
    this.working && this.working();
  }
  isWorking() {
    return !!(this.working || this.workScheduled > 0);
  }
}, {eventHandlers:{focus() {
  this.scheduleWork();
}}}), ra = et.define({combine(t) {
  return t.length ? t[0] : null;
}, enables:t => [Ji.state, rJ, nt.contentAttributes.compute([t], e => {
  let n = e.facet(t);
  return n && n.name ? {"data-language":n.name} : {};
})]});
class iJ {
  constructor(e, n = []) {
    this.language = e, this.support = n, this.extension = [e, n];
  }
}
const sJ = et.define(), E1 = et.define({combine:t => {
  if (!t.length) {
    return "  ";
  }
  let e = t[0];
  if (!e || /\S/.test(e) || Array.from(e).some(n => n != e[0])) {
    throw new Error("Invalid indent unit: " + JSON.stringify(t[0]));
  }
  return e;
}});
function Ip(t) {
  let e = t.facet(E1);
  return e.charCodeAt(0) == 9 ? t.tabSize * e.length : e.length;
}
function kd(t, e) {
  let n = "", r = t.tabSize, i = t.facet(E1)[0];
  if (i == "\t") {
    for (; e >= r;) {
      n += "\t", e -= r;
    }
    i = " ";
  }
  for (let s = 0; s < e; s++) {
    n += i;
  }
  return n;
}
function T1(t, e) {
  t instanceof Yt && (t = new Fg(t));
  for (let r of t.state.facet(sJ)) {
    let i = r(t, e);
    if (i !== void 0) {
      return i;
    }
  }
  let n = Ur(t.state);
  return n.length >= e ? oJ(t, n, e) : null;
}
class Fg {
  constructor(e, n = {}) {
    this.state = e, this.options = n, this.unit = Ip(e);
  }
  lineAt(e, n = 1) {
    let r = this.state.doc.lineAt(e), {simulateBreak:i, simulateDoubleBreak:s} = this.options;
    return i != null && i >= r.from && i <= r.to ? s && i == e ? {text:"", from:e} : (n < 0 ? i < e : i <= e) ? {text:r.text.slice(i - r.from), from:i} : {text:r.text.slice(0, i - r.from), from:r.from} : r;
  }
  textAfterPos(e, n = 1) {
    if (this.options.simulateDoubleBreak && e == this.options.simulateBreak) {
      return "";
    }
    let {text:r, from:i} = this.lineAt(e, n);
    return r.slice(e - i, Math.min(r.length, e + 100 - i));
  }
  column(e, n = 1) {
    let {text:r, from:i} = this.lineAt(e, n), s = this.countColumn(r, e - i), o = this.options.overrideIndentation ? this.options.overrideIndentation(i) : -1;
    return o > -1 && (s += o - this.countColumn(r, r.search(/\S|$/))), s;
  }
  countColumn(e, n = e.length) {
    return Ac(e, this.state.tabSize, n);
  }
  lineIndent(e, n = 1) {
    let {text:r, from:i} = this.lineAt(e, n), s = this.options.overrideIndentation;
    if (s) {
      let o = s(i);
      if (o > -1) {
        return o;
      }
    }
    return this.countColumn(r, r.search(/\S|$/));
  }
  get simulatedBreak() {
    return this.options.simulateBreak || null;
  }
}
const gO = new Ot();
function oJ(t, e, n) {
  let r = e.resolveStack(n), i = e.resolveInner(n, -1).resolve(n, 0).enterUnfinishedNodesBefore(n);
  if (i != r.node) {
    let s = [];
    for (let o = i; o && !(o.from < r.node.from || o.to > r.node.to || o.from == r.node.from && o.type == r.node.type); o = o.parent) {
      s.push(o);
    }
    for (let o = s.length - 1; o >= 0; o--) {
      r = {node:s[o], next:r};
    }
  }
  return mO(r, t, n);
}
function mO(t, e, n) {
  for (let r = t; r; r = r.next) {
    let i = lJ(r.node);
    if (i) {
      return i(C1.create(e, n, r));
    }
  }
  return 0;
}
function aJ(t) {
  return t.pos == t.options.simulateBreak && t.options.simulateDoubleBreak;
}
function lJ(t) {
  let e = t.type.prop(gO);
  if (e) {
    return e;
  }
  let n = t.firstChild, r;
  if (n && (r = n.type.prop(Ot.closedBy))) {
    let i = t.lastChild, s = i && r.indexOf(i.name) > -1;
    return o => hJ(o, !0, 1, void 0, s && !aJ(o) ? i.from : void 0);
  }
  return t.parent == null ? cJ : null;
}
function cJ() {
  return 0;
}
class C1 extends Fg {
  constructor(e, n, r) {
    super(e.state, e.options), this.base = e, this.pos = n, this.context = r;
  }
  get node() {
    return this.context.node;
  }
  static create(e, n, r) {
    return new C1(e, n, r);
  }
  get textAfter() {
    return this.textAfterPos(this.pos);
  }
  get baseIndent() {
    return this.baseIndentFor(this.node);
  }
  baseIndentFor(e) {
    let n = this.state.doc.lineAt(e.from);
    for (;;) {
      let r = e.resolve(n.from);
      for (; r.parent && r.parent.from == r.from;) {
        r = r.parent;
      }
      if (uJ(r, e)) {
        break;
      }
      n = this.state.doc.lineAt(r.from);
    }
    return this.lineIndent(n.from);
  }
  continue() {
    return mO(this.context.next, this.base, this.pos);
  }
}
function uJ(t, e) {
  for (let n = e; n; n = n.parent) {
    if (t == n) {
      return !0;
    }
  }
  return !1;
}
function dJ(t) {
  let e = t.node, n = e.childAfter(e.from), r = e.lastChild;
  if (!n) {
    return null;
  }
  let i = t.options.simulateBreak, s = t.state.doc.lineAt(n.from), o = i == null || i <= s.from ? s.to : Math.min(s.to, i);
  for (let a = n.to;;) {
    let l = e.childAfter(a);
    if (!l || l == r) {
      return null;
    }
    if (!l.type.isSkipped) {
      if (l.from >= o) {
        return null;
      }
      let c = /^ */.exec(s.text.slice(n.to - s.from))[0].length;
      return {from:n.from, to:n.to + c};
    }
    a = l.to;
  }
}
function hJ(t, e, n, r, i) {
  let s = t.textAfter, o = s.match(/^\s*/)[0].length, a = r && s.slice(o, o + r.length) == r || i == t.pos + o, l = dJ(t);
  return l ? a ? t.column(l.from) : t.column(l.to) : t.baseIndent + (a ? 0 : t.unit * n);
}
const fJ = 200;
function pJ() {
  return Yt.transactionFilter.of(t => {
    if (!t.docChanged || !t.isUserEvent("input.type") && !t.isUserEvent("input.complete")) {
      return t;
    }
    let e = t.startState.languageDataAt("indentOnInput", t.startState.selection.main.head);
    if (!e.length) {
      return t;
    }
    let n = t.newDoc, {head:r} = t.newSelection.main, i = n.lineAt(r);
    if (r > i.from + fJ) {
      return t;
    }
    let s = n.sliceString(i.from, r);
    if (!e.some(c => c.test(s))) {
      return t;
    }
    let {state:o} = t, a = -1, l = [];
    for (let {head:c} of o.selection.ranges) {
      let u = o.doc.lineAt(c);
      if (u.from == a) {
        continue;
      }
      a = u.from;
      let h = T1(o, u.from);
      if (h == null) {
        continue;
      }
      let f = /^\s*/.exec(u.text)[0], p = kd(o, h);
      f != p && l.push({from:u.from, to:u.from + f.length, insert:p});
    }
    return l.length ? [t, {changes:l, sequential:!0}] : t;
  });
}
const gJ = et.define(), bO = new Ot();
function mJ(t) {
  let e = t.firstChild, n = t.lastChild;
  return e && e.to < n.from ? {from:e.to, to:n.type.isError ? t.to : n.from} : null;
}
function bJ(t, e, n) {
  let r = Ur(t);
  if (r.length < n) {
    return null;
  }
  let i = r.resolveStack(n, 1), s = null;
  for (let o = i; o; o = o.next) {
    let a = o.node;
    if (a.to <= n || a.from > n) {
      continue;
    }
    if (s && a.from < e) {
      break;
    }
    let l = a.type.prop(bO);
    if (l && (a.to < r.length - 50 || r.length == t.doc.length || !yJ(a))) {
      let c = l(a, t);
      c && c.from <= n && c.from >= e && c.to > n && (s = c);
    }
  }
  return s;
}
function yJ(t) {
  let e = t.lastChild;
  return e && e.to == t.to && e.type.isError;
}
function Op(t, e, n) {
  for (let r of t.facet(gJ)) {
    let i = r(t, e, n);
    if (i) {
      return i;
    }
  }
  return bJ(t, e, n);
}
function yO(t, e) {
  let n = e.mapPos(t.from, 1), r = e.mapPos(t.to, -1);
  return n >= r ? void 0 : {from:n, to:r};
}
const zg = zt.define({map:yO}), nh = zt.define({map:yO});
function xO(t) {
  let e = [];
  for (let {head:n} of t.state.selection.ranges) {
    e.some(r => r.from <= n && r.to >= n) || e.push(t.lineBlockAt(n));
  }
  return e;
}
const nl = ii.define({create() {
  return pt.none;
}, update(t, e) {
  e.isUserEvent("delete") && e.changes.iterChangedRanges((n, r) => t = Lk(t, n, r)), t = t.map(e.changes);
  for (let n of e.effects) {
    if (n.is(zg) && !xJ(t, n.value.from, n.value.to)) {
      let {preparePlaceholder:r} = e.state.facet(_O), i = r ? pt.replace({widget:new TJ(r(e.state, n.value))}) : Mk;
      t = t.update({add:[i.range(n.value.from, n.value.to)]});
    } else {
      n.is(nh) && (t = t.update({filter:(r, i) => n.value.from != r || n.value.to != i, filterFrom:n.value.from, filterTo:n.value.to}));
    }
  }
  return e.selection && (t = Lk(t, e.selection.main.head)), t;
}, provide:t => nt.decorations.from(t), toJSON(t, e) {
  let n = [];
  return t.between(0, e.doc.length, (r, i) => {
    n.push(r, i);
  }), n;
}, fromJSON(t) {
  if (!Array.isArray(t) || t.length % 2) {
    throw new RangeError("Invalid JSON for fold state");
  }
  let e = [];
  for (let n = 0; n < t.length;) {
    let r = t[n++], i = t[n++];
    if (typeof r != "number" || typeof i != "number") {
      throw new RangeError("Invalid JSON for fold state");
    }
    e.push(Mk.range(r, i));
  }
  return pt.set(e, !0);
}});
function Lk(t, e, n = e) {
  let r = !1;
  return t.between(e, n, (i, s) => {
    i < n && s > e && (r = !0);
  }), r ? t.update({filterFrom:e, filterTo:n, filter:(i, s) => i >= n || s <= e}) : t;
}
function Pp(t, e, n) {
  var r;
  let i = null;
  return (r = t.field(nl, !1)) === null || r === void 0 || r.between(e, n, (s, o) => {
    (!i || i.from > s) && (i = {from:s, to:o});
  }), i;
}
function xJ(t, e, n) {
  let r = !1;
  return t.between(e, e, (i, s) => {
    i == e && s == n && (r = !0);
  }), r;
}
function vO(t, e) {
  return t.field(nl, !1) ? e : e.concat(zt.appendConfig.of(SO()));
}
const vJ = t => {
  for (let e of xO(t)) {
    let n = Op(t.state, e.from, e.to);
    if (n) {
      return t.dispatch({effects:vO(t.state, [zg.of(n), wO(t, n)])}), !0;
    }
  }
  return !1;
}, wJ = t => {
  if (!t.state.field(nl, !1)) {
    return !1;
  }
  let e = [];
  for (let n of xO(t)) {
    let r = Pp(t.state, n.from, n.to);
    r && e.push(nh.of(r), wO(t, r, !1));
  }
  return e.length && t.dispatch({effects:e}), e.length > 0;
};
function wO(t, e, n = !0) {
  let r = t.state.doc.lineAt(e.from).number, i = t.state.doc.lineAt(e.to).number;
  return nt.announce.of(`${t.state.phrase(n ? "Folded lines" : "Unfolded lines")} ${r} ${t.state.phrase("to")} ${i}.`);
}
const _J = t => {
  let {state:e} = t, n = [];
  for (let r = 0; r < e.doc.length;) {
    let i = t.lineBlockAt(r), s = Op(e, i.from, i.to);
    s && n.push(zg.of(s)), r = (s ? t.lineBlockAt(s.to) : i).to + 1;
  }
  return n.length && t.dispatch({effects:vO(t.state, n)}), !!n.length;
}, SJ = t => {
  let e = t.state.field(nl, !1);
  if (!e || !e.size) {
    return !1;
  }
  let n = [];
  return e.between(0, t.state.doc.length, (r, i) => {
    n.push(nh.of({from:r, to:i}));
  }), t.dispatch({effects:n}), !0;
}, kJ = [{key:"Ctrl-Shift-[", mac:"Cmd-Alt-[", run:vJ}, {key:"Ctrl-Shift-]", mac:"Cmd-Alt-]", run:wJ}, {key:"Ctrl-Alt-[", run:_J}, {key:"Ctrl-Alt-]", run:SJ}], EJ = {placeholderDOM:null, preparePlaceholder:null, placeholderText:"\u2026"}, _O = et.define({combine(t) {
  return mo(t, EJ);
}});
function SO(t) {
  return [nl, NJ];
}
function kO(t, e) {
  let {state:n} = t, r = n.facet(_O), i = o => {
    let a = t.lineBlockAt(t.posAtDOM(o.target)), l = Pp(t.state, a.from, a.to);
    l && t.dispatch({effects:nh.of(l)}), o.preventDefault();
  };
  if (r.placeholderDOM) {
    return r.placeholderDOM(t, i, e);
  }
  let s = document.createElement("span");
  return s.textContent = r.placeholderText, s.setAttribute("aria-label", n.phrase("folded code")), s.title = n.phrase("unfold"), s.className = "cm-foldPlaceholder", s.onclick = i, s;
}
const Mk = pt.replace({widget:new class extends Fs {
  toDOM(t) {
    return kO(t, null);
  }
}()});
class TJ extends Fs {
  constructor(e) {
    super(), this.value = e;
  }
  eq(e) {
    return this.value == e.value;
  }
  toDOM(e) {
    return kO(e, this.value);
  }
}
const CJ = {openText:"\u2304", closedText:"\u203a", markerDOM:null, domEventHandlers:{}, foldingChanged:() => !1};
class g0 extends fo {
  constructor(e, n) {
    super(), this.config = e, this.open = n;
  }
  eq(e) {
    return this.config == e.config && this.open == e.open;
  }
  toDOM(e) {
    if (this.config.markerDOM) {
      return this.config.markerDOM(this.open);
    }
    let n = document.createElement("span");
    return n.textContent = this.open ? this.config.openText : this.config.closedText, n.title = e.state.phrase(this.open ? "Fold line" : "Unfold line"), n;
  }
}
function AJ(t = {}) {
  let e = {...CJ, ...t}, n = new g0(e, !0), r = new g0(e, !1), i = Kn.fromClass(class {
    constructor(o) {
      this.from = o.viewport.from, this.markers = this.buildMarkers(o);
    }
    update(o) {
      (o.docChanged || o.viewportChanged || o.startState.facet(ra) != o.state.facet(ra) || o.startState.field(nl, !1) != o.state.field(nl, !1) || Ur(o.startState) != Ur(o.state) || e.foldingChanged(o)) && (this.markers = this.buildMarkers(o.view));
    }
    buildMarkers(o) {
      let a = new uo();
      for (let l of o.viewportLineBlocks) {
        let c = Pp(o.state, l.from, l.to) ? r : Op(o.state, l.from, l.to) ? n : null;
        c && a.add(l.from, l.from, c);
      }
      return a.finish();
    }
  }), {domEventHandlers:s} = e;
  return [i, AX({class:"cm-foldGutter", markers(o) {
    var a;
    return ((a = o.plugin(i)) === null || a === void 0 ? void 0 : a.markers) || $t.empty;
  }, initialSpacer() {
    return new g0(e, !1);
  }, domEventHandlers:{...s, click:(o, a, l) => {
    if (s.click && s.click(o, a, l)) {
      return !0;
    }
    let c = Pp(o.state, a.from, a.to);
    if (c) {
      return o.dispatch({effects:nh.of(c)}), !0;
    }
    let u = Op(o.state, a.from, a.to);
    return u ? (o.dispatch({effects:zg.of(u)}), !0) : !1;
  }}}), SO()];
}
const NJ = nt.baseTheme({".cm-foldPlaceholder":{backgroundColor:"#eee", border:"1px solid #ddd", color:"#888", borderRadius:".2em", margin:"0 1px", padding:"0 1px", cursor:"pointer"}, ".cm-foldGutter span":{padding:"0 1px", cursor:"pointer"}});
class Hg {
  constructor(e, n) {
    this.specs = e;
    let r;
    function i(a) {
      let l = Zo.newName();
      return (r || (r = Object.create(null)))["." + l] = a, l;
    }
    const s = typeof n.all == "string" ? n.all : n.all ? i(n.all) : void 0, o = n.scope;
    this.scope = o instanceof Ji ? a => a.prop(Yl) == o.data : o ? a => a == o : void 0, this.style = fO(e.map(a => ({tag:a.tag, class:a.class || i(Object.assign({}, a, {tag:null}))})), {all:s}).style, this.module = r ? new Zo(r) : null, this.themeType = n.themeType;
  }
  static define(e, n) {
    return new Hg(e, n || {});
  }
}
const xy = et.define(), IJ = et.define({combine(t) {
  return t.length ? [t[0]] : null;
}});
function m0(t) {
  let e = t.facet(xy);
  return e.length ? e : t.facet(IJ);
}
function OJ(t, e) {
  let n = [RJ], r;
  return t instanceof Hg && (t.module && n.push(nt.styleModule.of(t.module)), r = t.themeType), r ? n.push(xy.computeN([nt.darkTheme], i => i.facet(nt.darkTheme) == (r == "dark") ? [t] : [])) : n.push(xy.of(t)), n;
}
class PJ {
  constructor(e) {
    this.markCache = Object.create(null), this.tree = Ur(e.state), this.decorations = this.buildDeco(e, m0(e.state)), this.decoratedTo = e.viewport.to;
  }
  update(e) {
    let n = Ur(e.state), r = m0(e.state), i = r != m0(e.startState), {viewport:s} = e.view, o = e.changes.mapPos(this.decoratedTo, 1);
    n.length < s.to && !i && n.type == this.tree.type && o >= s.to ? (this.decorations = this.decorations.map(e.changes), this.decoratedTo = o) : (n != this.tree || e.viewportChanged || i) && (this.tree = n, this.decorations = this.buildDeco(e.view, r), this.decoratedTo = s.to);
  }
  buildDeco(e, n) {
    if (!n || !this.tree.length) {
      return pt.none;
    }
    let r = new uo();
    for (let {from:i, to:s} of e.visibleRanges) {
      XX(this.tree, n, (o, a, l) => {
        r.add(o, a, this.markCache[l] || (this.markCache[l] = pt.mark({class:l})));
      }, i, s);
    }
    return r.finish();
  }
}
const RJ = Xd.high(Kn.fromClass(PJ, {decorations:t => t.decorations})), DJ = nt.baseTheme({"\x26.cm-focused .cm-matchingBracket":{backgroundColor:"#328c8252"}, "\x26.cm-focused .cm-nonmatchingBracket":{backgroundColor:"#bb555544"}}), EO = 1e4, TO = "()[]{}", CO = et.define({combine(t) {
  return mo(t, {afterCursor:!0, brackets:TO, maxScanDistance:EO, renderMatch:BJ});
}}), LJ = pt.mark({class:"cm-matchingBracket"}), MJ = pt.mark({class:"cm-nonmatchingBracket"});
function BJ(t) {
  let e = [], n = t.matched ? LJ : MJ;
  return e.push(n.range(t.start.from, t.start.to)), t.end && e.push(n.range(t.end.from, t.end.to)), e;
}
function Bk(t) {
  let e = [], n = t.facet(CO);
  for (let r of t.selection.ranges) {
    if (!r.empty) {
      continue;
    }
    let i = As(t, r.head, -1, n) || r.head > 0 && As(t, r.head - 1, 1, n) || n.afterCursor && (As(t, r.head, 1, n) || r.head < t.doc.length && As(t, r.head + 1, -1, n));
    i && (e = e.concat(n.renderMatch(i, t)));
  }
  return pt.set(e, !0);
}
const $J = Kn.fromClass(class {
  constructor(t) {
    this.paused = !1, this.decorations = Bk(t.state);
  }
  update(t) {
    (t.docChanged || t.selectionSet || this.paused) && (t.view.composing ? (this.decorations = this.decorations.map(t.changes), this.paused = !0) : (this.decorations = Bk(t.state), this.paused = !1));
  }
}, {decorations:t => t.decorations}), FJ = [$J, DJ];
function zJ(t = {}) {
  return [CO.of(t), FJ];
}
const HJ = new Ot();
function vy(t, e, n) {
  let r = t.prop(e < 0 ? Ot.openedBy : Ot.closedBy);
  if (r) {
    return r;
  }
  if (t.name.length == 1) {
    let i = n.indexOf(t.name);
    if (i > -1 && i % 2 == (e < 0 ? 1 : 0)) {
      return [n[i + e]];
    }
  }
  return null;
}
function wy(t) {
  let e = t.type.prop(HJ);
  return e ? e(t.node) : t;
}
function As(t, e, n, r = {}) {
  let i = r.maxScanDistance || EO, s = r.brackets || TO, o = Ur(t), a = o.resolveInner(e, n);
  for (let l = a; l; l = l.parent) {
    let c = vy(l.type, n, s);
    if (c && l.from < l.to) {
      let u = wy(l);
      if (u && (n > 0 ? e >= u.from && e < u.to : e > u.from && e <= u.to)) {
        return UJ(t, e, n, l, u, c, s);
      }
    }
  }
  return WJ(t, e, n, o, a.type, i, s);
}
function UJ(t, e, n, r, i, s, o) {
  let a = r.parent, l = {from:i.from, to:i.to}, c = 0, u = a == null ? void 0 : a.cursor();
  if (u && (n < 0 ? u.childBefore(r.from) : u.childAfter(r.to))) {
    do {
      if (n < 0 ? u.to <= r.from : u.from >= r.to) {
        if (c == 0 && s.indexOf(u.type.name) > -1 && u.from < u.to) {
          let h = wy(u);
          return {start:l, end:h ? {from:h.from, to:h.to} : void 0, matched:!0};
        } else if (vy(u.type, n, o)) {
          c++;
        } else if (vy(u.type, -n, o)) {
          if (c == 0) {
            let h = wy(u);
            return {start:l, end:h && h.from < h.to ? {from:h.from, to:h.to} : void 0, matched:!1};
          }
          c--;
        }
      }
    } while (n < 0 ? u.prevSibling() : u.nextSibling());
  }
  return {start:l, matched:!1};
}
function WJ(t, e, n, r, i, s, o) {
  if (n < 0 ? !e : e == t.doc.length) {
    return null;
  }
  let a = n < 0 ? t.sliceDoc(e - 1, e) : t.sliceDoc(e, e + 1), l = o.indexOf(a);
  if (l < 0 || l % 2 == 0 != n > 0) {
    return null;
  }
  let c = {from:n < 0 ? e - 1 : e, to:n > 0 ? e + 1 : e}, u = t.doc.iterRange(e, n > 0 ? t.doc.length : 0), h = 0;
  for (let f = 0; !u.next().done && f <= s;) {
    let p = u.value;
    n < 0 && (f += p.length);
    let g = e + f * n;
    for (let m = n > 0 ? 0 : p.length - 1, b = n > 0 ? p.length : -1; m != b; m += n) {
      let x = o.indexOf(p[m]);
      if (!(x < 0 || r.resolveInner(g + m, 1).type != i)) {
        if (x % 2 == 0 == n > 0) {
          h++;
        } else {
          if (h == 1) {
            return {start:c, end:{from:g + m, to:g + m + 1}, matched:x >> 1 == l >> 1};
          }
          h--;
        }
      }
    }
    n > 0 && (f += p.length);
  }
  return u.done ? {start:c, matched:!1} : null;
}
const jJ = Object.create(null), $k = [ti.none], Fk = [], zk = Object.create(null), VJ = Object.create(null);
for (let [t, e] of [["variable", "variableName"], ["variable-2", "variableName.special"], ["string-2", "string.special"], ["def", "variableName.definition"], ["tag", "tagName"], ["attribute", "attributeName"], ["type", "typeName"], ["builtin", "variableName.standard"], ["qualifier", "modifier"], ["error", "invalid"], ["header", "heading"], ["property", "propertyName"]]) {
  VJ[t] = qJ(jJ, e);
}
function b0(t, e) {
  Fk.indexOf(t) > -1 || (Fk.push(t), console.warn(e));
}
function qJ(t, e) {
  let n = [];
  for (let a of e.split(" ")) {
    let l = [];
    for (let c of a.split(".")) {
      let u = t[c] || Re[c];
      u ? typeof u == "function" ? l.length ? l = l.map(u) : b0(c, `Modifier ${c} used at start of tag`) : l.length ? b0(c, `Tag ${c} used as modifier`) : l = Array.isArray(u) ? u : [u] : b0(c, `Unknown highlighting tag ${c}`);
    }
    for (let c of l) {
      n.push(c);
    }
  }
  if (!n.length) {
    return 0;
  }
  let r = e.replace(/ /g, "_"), i = r + " " + n.map(a => a.id), s = zk[i];
  if (s) {
    return s.id;
  }
  let o = zk[i] = ti.define({id:$k.length, name:r, props:[dO({[r]:n})]});
  return $k.push(o), o.id;
}
xn.RTL, xn.LTR;
const YJ = t => {
  let {state:e} = t, n = e.doc.lineAt(e.selection.main.from), r = N1(t.state, n.from);
  return r.line ? GJ(t) : r.block ? KJ(t) : !1;
};
function A1(t, e) {
  return ({state:n, dispatch:r}) => {
    if (n.readOnly) {
      return !1;
    }
    let i = t(e, n);
    return i ? (r(n.update(i)), !0) : !1;
  };
}
const GJ = A1(ZJ, 0), QJ = A1(AO, 0), KJ = A1((t, e) => AO(t, e, JJ(e)), 0);
function N1(t, e) {
  let n = t.languageDataAt("commentTokens", e, 1);
  return n.length ? n[0] : {};
}
const iu = 50;
function XJ(t, {open:e, close:n}, r, i) {
  let s = t.sliceDoc(r - iu, r), o = t.sliceDoc(i, i + iu), a = /\s*$/.exec(s)[0].length, l = /^\s*/.exec(o)[0].length, c = s.length - a;
  if (s.slice(c - e.length, c) == e && o.slice(l, l + n.length) == n) {
    return {open:{pos:r - a, margin:a && 1}, close:{pos:i + l, margin:l && 1}};
  }
  let u, h;
  i - r <= 2 * iu ? u = h = t.sliceDoc(r, i) : (u = t.sliceDoc(r, r + iu), h = t.sliceDoc(i - iu, i));
  let f = /^\s*/.exec(u)[0].length, p = /\s*$/.exec(h)[0].length, g = h.length - p - n.length;
  return u.slice(f, f + e.length) == e && h.slice(g, g + n.length) == n ? {open:{pos:r + f + e.length, margin:/\s/.test(u.charAt(f + e.length)) ? 1 : 0}, close:{pos:i - p - n.length, margin:/\s/.test(h.charAt(g - 1)) ? 1 : 0}} : null;
}
function JJ(t) {
  let e = [];
  for (let n of t.selection.ranges) {
    let r = t.doc.lineAt(n.from), i = n.to <= r.to ? r : t.doc.lineAt(n.to);
    i.from > r.from && i.from == n.to && (i = n.to == r.to + 1 ? r : t.doc.lineAt(n.to - 1));
    let s = e.length - 1;
    s >= 0 && e[s].to > r.from ? e[s].to = i.to : e.push({from:r.from + /^\s*/.exec(r.text)[0].length, to:i.to});
  }
  return e;
}
function AO(t, e, n = e.selection.ranges) {
  let r = n.map(s => N1(e, s.from).block);
  if (!r.every(s => s)) {
    return null;
  }
  let i = n.map((s, o) => XJ(e, r[o], s.from, s.to));
  if (t != 2 && !i.every(s => s)) {
    return {changes:e.changes(n.map((s, o) => i[o] ? [] : [{from:s.from, insert:r[o].open + " "}, {from:s.to, insert:" " + r[o].close}]))};
  }
  if (t != 1 && i.some(s => s)) {
    let s = [];
    for (let o = 0, a; o < i.length; o++) {
      if (a = i[o]) {
        let l = r[o], {open:c, close:u} = a;
        s.push({from:c.pos - l.open.length, to:c.pos + c.margin}, {from:u.pos - u.margin, to:u.pos + l.close.length});
      }
    }
    return {changes:s};
  }
  return null;
}
function ZJ(t, e, n = e.selection.ranges) {
  let r = [], i = -1;
  e: for (let {from:s, to:o} of n) {
    let a = r.length, l = 1e9, c;
    for (let u = s; u <= o;) {
      let h = e.doc.lineAt(u);
      if (c == null && (c = N1(e, h.from).line, !c)) {
        continue e;
      }
      if (h.from > i && (s == o || o > h.from)) {
        i = h.from;
        let f = /^\s*/.exec(h.text)[0].length, p = f == h.length, g = h.text.slice(f, f + c.length) == c ? f : -1;
        f < h.text.length && f < l && (l = f), r.push({line:h, comment:g, token:c, indent:f, empty:p, single:!1});
      }
      u = h.to + 1;
    }
    if (l < 1e9) {
      for (let u = a; u < r.length; u++) {
        r[u].indent < r[u].line.text.length && (r[u].indent = l);
      }
    }
    r.length == a + 1 && (r[a].single = !0);
  }
  if (t != 2 && r.some(s => s.comment < 0 && (!s.empty || s.single))) {
    let s = [];
    for (let {line:a, token:l, indent:c, empty:u, single:h} of r) {
      (h || !u) && s.push({from:a.from + c, insert:l + " "});
    }
    let o = e.changes(s);
    return {changes:o, selection:e.selection.map(o, 1)};
  } else if (t != 1 && r.some(s => s.comment >= 0)) {
    let s = [];
    for (let {line:o, comment:a, token:l} of r) {
      if (a >= 0) {
        let c = o.from + a, u = c + l.length;
        o.text[u - o.from] == " " && u++, s.push({from:c, to:u});
      }
    }
    return {changes:s};
  }
  return null;
}
const _y = la.define(), eZ = la.define(), tZ = et.define(), NO = et.define({combine(t) {
  return mo(t, {minDepth:100, newGroupDelay:500, joinToEvent:(e, n) => n}, {minDepth:Math.max, newGroupDelay:Math.min, joinToEvent:(e, n) => (r, i) => e(r, i) || n(r, i)});
}}), IO = ii.define({create() {
  return Ns.empty;
}, update(t, e) {
  let n = e.state.facet(NO), r = e.annotation(_y);
  if (r) {
    let l = Zr.fromTransaction(e, r.selection), c = r.side, u = c == 0 ? t.undone : t.done;
    return l ? u = Rp(u, u.length, n.minDepth, l) : u = RO(u, e.startState.selection), new Ns(c == 0 ? r.rest : u, c == 0 ? u : r.rest);
  }
  let i = e.annotation(eZ);
  if ((i == "full" || i == "before") && (t = t.isolate()), e.annotation(ir.addToHistory) === !1) {
    return e.changes.empty ? t : t.addMapping(e.changes.desc);
  }
  let s = Zr.fromTransaction(e), o = e.annotation(ir.time), a = e.annotation(ir.userEvent);
  return s ? t = t.addChanges(s, o, a, n, e) : e.selection && (t = t.addSelection(e.startState.selection, o, a, n.newGroupDelay)), (i == "full" || i == "after") && (t = t.isolate()), t;
}, toJSON(t) {
  return {done:t.done.map(e => e.toJSON()), undone:t.undone.map(e => e.toJSON())};
}, fromJSON(t) {
  return new Ns(t.done.map(Zr.fromJSON), t.undone.map(Zr.fromJSON));
}});
function nZ(t = {}) {
  return [IO, NO.of(t), nt.domEventHandlers({beforeinput(e, n) {
    let r = e.inputType == "historyUndo" ? OO : e.inputType == "historyRedo" ? Sy : null;
    return r ? (e.preventDefault(), r(n)) : !1;
  }})];
}
function Ug(t, e) {
  return function({state:n, dispatch:r}) {
    if (!e && n.readOnly) {
      return !1;
    }
    let i = n.field(IO, !1);
    if (!i) {
      return !1;
    }
    let s = i.pop(t, n, e);
    return s ? (r(s), !0) : !1;
  };
}
const OO = Ug(0, !1), Sy = Ug(1, !1), rZ = Ug(0, !0), iZ = Ug(1, !0);
class Zr {
  constructor(e, n, r, i, s) {
    this.changes = e, this.effects = n, this.mapped = r, this.startSelection = i, this.selectionsAfter = s;
  }
  setSelAfter(e) {
    return new Zr(this.changes, this.effects, this.mapped, this.startSelection, e);
  }
  toJSON() {
    var e, n, r;
    return {changes:(e = this.changes) === null || e === void 0 ? void 0 : e.toJSON(), mapped:(n = this.mapped) === null || n === void 0 ? void 0 : n.toJSON(), startSelection:(r = this.startSelection) === null || r === void 0 ? void 0 : r.toJSON(), selectionsAfter:this.selectionsAfter.map(i => i.toJSON())};
  }
  static fromJSON(e) {
    return new Zr(e.changes && nr.fromJSON(e.changes), [], e.mapped && Rs.fromJSON(e.mapped), e.startSelection && Ce.fromJSON(e.startSelection), e.selectionsAfter.map(Ce.fromJSON));
  }
  static fromTransaction(e, n) {
    let r = Di;
    for (let i of e.startState.facet(tZ)) {
      let s = i(e);
      s.length && (r = r.concat(s));
    }
    return !r.length && e.changes.empty ? null : new Zr(e.changes.invert(e.startState.doc), r, void 0, n || e.startState.selection, Di);
  }
  static selection(e) {
    return new Zr(void 0, Di, void 0, void 0, e);
  }
}
function Rp(t, e, n, r) {
  let i = e + 1 > n + 20 ? e - n - 1 : 0, s = t.slice(i, e);
  return s.push(r), s;
}
function sZ(t, e) {
  let n = [], r = !1;
  return t.iterChangedRanges((i, s) => n.push(i, s)), e.iterChangedRanges((i, s, o, a) => {
    for (let l = 0; l < n.length;) {
      let c = n[l++], u = n[l++];
      a >= c && o <= u && (r = !0);
    }
  }), r;
}
function oZ(t, e) {
  return t.ranges.length == e.ranges.length && t.ranges.filter((n, r) => n.empty != e.ranges[r].empty).length === 0;
}
function PO(t, e) {
  return t.length ? e.length ? t.concat(e) : t : e;
}
const Di = [], aZ = 200;
function RO(t, e) {
  if (t.length) {
    let n = t[t.length - 1], r = n.selectionsAfter.slice(Math.max(0, n.selectionsAfter.length - aZ));
    return r.length && r[r.length - 1].eq(e) ? t : (r.push(e), Rp(t, t.length - 1, 1e9, n.setSelAfter(r)));
  } else {
    return [Zr.selection([e])];
  }
}
function lZ(t) {
  let e = t[t.length - 1], n = t.slice();
  return n[t.length - 1] = e.setSelAfter(e.selectionsAfter.slice(0, e.selectionsAfter.length - 1)), n;
}
function y0(t, e) {
  if (!t.length) {
    return t;
  }
  let n = t.length, r = Di;
  for (; n;) {
    let i = cZ(t[n - 1], e, r);
    if (i.changes && !i.changes.empty || i.effects.length) {
      let s = t.slice(0, n);
      return s[n - 1] = i, s;
    } else {
      e = i.mapped, n--, r = i.selectionsAfter;
    }
  }
  return r.length ? [Zr.selection(r)] : Di;
}
function cZ(t, e, n) {
  let r = PO(t.selectionsAfter.length ? t.selectionsAfter.map(a => a.map(e)) : Di, n);
  if (!t.changes) {
    return Zr.selection(r);
  }
  let i = t.changes.map(e), s = e.mapDesc(t.changes, !0), o = t.mapped ? t.mapped.composeDesc(s) : s;
  return new Zr(i, zt.mapEffects(t.effects, e), o, t.startSelection.map(s), r);
}
const uZ = /^(input\.type|delete)($|\.)/;
class Ns {
  constructor(e, n, r = 0, i = void 0) {
    this.done = e, this.undone = n, this.prevTime = r, this.prevUserEvent = i;
  }
  isolate() {
    return this.prevTime ? new Ns(this.done, this.undone) : this;
  }
  addChanges(e, n, r, i, s) {
    let o = this.done, a = o[o.length - 1];
    return a && a.changes && !a.changes.empty && e.changes && (!r || uZ.test(r)) && (!a.selectionsAfter.length && n - this.prevTime < i.newGroupDelay && i.joinToEvent(s, sZ(a.changes, e.changes)) || r == "input.type.compose") ? o = Rp(o, o.length - 1, i.minDepth, new Zr(e.changes.compose(a.changes), PO(zt.mapEffects(e.effects, a.changes), a.effects), a.mapped, a.startSelection, Di)) : o = Rp(o, o.length, i.minDepth, e), new Ns(o, Di, n, r);
  }
  addSelection(e, n, r, i) {
    let s = this.done.length ? this.done[this.done.length - 1].selectionsAfter : Di;
    return s.length > 0 && n - this.prevTime < i && r == this.prevUserEvent && r && /^select($|\.)/.test(r) && oZ(s[s.length - 1], e) ? this : new Ns(RO(this.done, e), this.undone, n, r);
  }
  addMapping(e) {
    return new Ns(y0(this.done, e), y0(this.undone, e), this.prevTime, this.prevUserEvent);
  }
  pop(e, n, r) {
    let i = e == 0 ? this.done : this.undone;
    if (i.length == 0) {
      return null;
    }
    let s = i[i.length - 1], o = s.selectionsAfter[0] || (s.startSelection ? s.startSelection.map(s.changes.invertedDesc, 1) : n.selection);
    if (r && s.selectionsAfter.length) {
      return n.update({selection:s.selectionsAfter[s.selectionsAfter.length - 1], annotations:_y.of({side:e, rest:lZ(i), selection:o}), userEvent:e == 0 ? "select.undo" : "select.redo", scrollIntoView:!0});
    }
    if (s.changes) {
      let a = i.length == 1 ? Di : i.slice(0, i.length - 1);
      return s.mapped && (a = y0(a, s.mapped)), n.update({changes:s.changes, selection:s.startSelection, effects:s.effects, annotations:_y.of({side:e, rest:a, selection:o}), filter:!1, userEvent:e == 0 ? "undo" : "redo", scrollIntoView:!0});
    } else {
      return null;
    }
  }
}
Ns.empty = new Ns(Di, Di);
const dZ = [{key:"Mod-z", run:OO, preventDefault:!0}, {key:"Mod-y", mac:"Mod-Shift-z", run:Sy, preventDefault:!0}, {linux:"Ctrl-Shift-z", run:Sy, preventDefault:!0}, {key:"Mod-u", run:rZ, preventDefault:!0}, {key:"Alt-u", mac:"Mod-Shift-u", run:iZ, preventDefault:!0}];
function Nc(t, e) {
  return Ce.create(t.ranges.map(e), t.mainIndex);
}
function ds(t, e) {
  return t.update({selection:e, scrollIntoView:!0, userEvent:"select"});
}
function hs({state:t, dispatch:e}, n) {
  let r = Nc(t.selection, n);
  return r.eq(t.selection, !0) ? !1 : (e(ds(t, r)), !0);
}
function Wg(t, e) {
  return Ce.cursor(e ? t.to : t.from);
}
function DO(t, e) {
  return hs(t, n => n.empty ? t.moveByChar(n, e) : Wg(n, e));
}
function Pr(t) {
  return t.textDirectionAt(t.state.selection.main.head) == xn.LTR;
}
const LO = t => DO(t, !Pr(t)), MO = t => DO(t, Pr(t));
function BO(t, e) {
  return hs(t, n => n.empty ? t.moveByGroup(n, e) : Wg(n, e));
}
const hZ = t => BO(t, !Pr(t)), fZ = t => BO(t, Pr(t));
function pZ(t, e, n) {
  if (e.type.prop(n)) {
    return !0;
  }
  let r = e.to - e.from;
  return r && (r > 2 || /[^\s,.;:]/.test(t.sliceDoc(e.from, e.to))) || e.firstChild;
}
function jg(t, e, n) {
  let r = Ur(t).resolveInner(e.head), i = n ? Ot.closedBy : Ot.openedBy;
  for (let l = e.head;;) {
    let c = n ? r.childAfter(l) : r.childBefore(l);
    if (!c) {
      break;
    }
    pZ(t, c, i) ? r = c : l = n ? c.to : c.from;
  }
  let s = r.type.prop(i), o, a;
  return s && (o = n ? As(t, r.from, 1) : As(t, r.to, -1)) && o.matched ? a = n ? o.end.to : o.end.from : a = n ? r.to : r.from, Ce.cursor(a, n ? -1 : 1);
}
const gZ = t => hs(t, e => jg(t.state, e, !Pr(t))), mZ = t => hs(t, e => jg(t.state, e, Pr(t)));
function $O(t, e) {
  return hs(t, n => {
    if (!n.empty) {
      return Wg(n, e);
    }
    let r = t.moveVertically(n, e);
    return r.head != n.head ? r : t.moveToLineBoundary(n, e);
  });
}
const FO = t => $O(t, !1), zO = t => $O(t, !0);
function HO(t) {
  let e = t.scrollDOM.clientHeight < t.scrollDOM.scrollHeight - 2, n = 0, r = 0, i;
  if (e) {
    for (let s of t.state.facet(nt.scrollMargins)) {
      let o = s(t);
      o != null && o.top && (n = Math.max(o == null ? void 0 : o.top, n)), o != null && o.bottom && (r = Math.max(o == null ? void 0 : o.bottom, r));
    }
    i = t.scrollDOM.clientHeight - n - r;
  } else {
    i = (t.dom.ownerDocument.defaultView || window).innerHeight;
  }
  return {marginTop:n, marginBottom:r, selfScroll:e, height:Math.max(t.defaultLineHeight, i - 5)};
}
function UO(t, e) {
  let n = HO(t), {state:r} = t, i = Nc(r.selection, o => o.empty ? t.moveVertically(o, e, n.height) : Wg(o, e));
  if (i.eq(r.selection)) {
    return !1;
  }
  let s;
  if (n.selfScroll) {
    let o = t.coordsAtPos(r.selection.main.head), a = t.scrollDOM.getBoundingClientRect(), l = a.top + n.marginTop, c = a.bottom - n.marginBottom;
    o && o.top > l && o.bottom < c && (s = nt.scrollIntoView(i.main.head, {y:"start", yMargin:o.top - l}));
  }
  return t.dispatch(ds(r, i), {effects:s}), !0;
}
const Hk = t => UO(t, !1), ky = t => UO(t, !0);
function ca(t, e, n) {
  let r = t.lineBlockAt(e.head), i = t.moveToLineBoundary(e, n);
  if (i.head == e.head && i.head != (n ? r.to : r.from) && (i = t.moveToLineBoundary(e, n, !1)), !n && i.head == r.from && r.length) {
    let s = /^\s*/.exec(t.state.sliceDoc(r.from, Math.min(r.from + 100, r.to)))[0].length;
    s && e.head != r.from + s && (i = Ce.cursor(r.from + s));
  }
  return i;
}
const bZ = t => hs(t, e => ca(t, e, !0)), yZ = t => hs(t, e => ca(t, e, !1)), xZ = t => hs(t, e => ca(t, e, !Pr(t))), vZ = t => hs(t, e => ca(t, e, Pr(t))), wZ = t => hs(t, e => Ce.cursor(t.lineBlockAt(e.head).from, 1)), _Z = t => hs(t, e => Ce.cursor(t.lineBlockAt(e.head).to, -1));
function SZ(t, e, n) {
  let r = !1, i = Nc(t.selection, s => {
    let o = As(t, s.head, -1) || As(t, s.head, 1) || s.head > 0 && As(t, s.head - 1, 1) || s.head < t.doc.length && As(t, s.head + 1, -1);
    if (!o || !o.end) {
      return s;
    }
    r = !0;
    let a = o.start.from == s.head ? o.end.to : o.end.from;
    return Ce.cursor(a);
  });
  return r ? (e(ds(t, i)), !0) : !1;
}
const kZ = ({state:t, dispatch:e}) => SZ(t, e);
function Fi(t, e) {
  let n = Nc(t.state.selection, r => {
    let i = e(r);
    return Ce.range(r.anchor, i.head, i.goalColumn, i.bidiLevel || void 0, i.assoc);
  });
  return n.eq(t.state.selection) ? !1 : (t.dispatch(ds(t.state, n)), !0);
}
function WO(t, e) {
  return Fi(t, n => t.moveByChar(n, e));
}
const jO = t => WO(t, !Pr(t)), VO = t => WO(t, Pr(t));
function qO(t, e) {
  return Fi(t, n => t.moveByGroup(n, e));
}
const EZ = t => qO(t, !Pr(t)), TZ = t => qO(t, Pr(t)), CZ = t => Fi(t, e => jg(t.state, e, !Pr(t))), AZ = t => Fi(t, e => jg(t.state, e, Pr(t)));
function YO(t, e) {
  return Fi(t, n => t.moveVertically(n, e));
}
const GO = t => YO(t, !1), QO = t => YO(t, !0);
function KO(t, e) {
  return Fi(t, n => t.moveVertically(n, e, HO(t).height));
}
const Uk = t => KO(t, !1), Wk = t => KO(t, !0), NZ = t => Fi(t, e => ca(t, e, !0)), IZ = t => Fi(t, e => ca(t, e, !1)), OZ = t => Fi(t, e => ca(t, e, !Pr(t))), PZ = t => Fi(t, e => ca(t, e, Pr(t))), RZ = t => Fi(t, e => Ce.cursor(t.lineBlockAt(e.head).from)), DZ = t => Fi(t, e => Ce.cursor(t.lineBlockAt(e.head).to)), jk = ({state:t, dispatch:e}) => (e(ds(t, {anchor:0})), !0), Vk = ({state:t, dispatch:e}) => (e(ds(t, {anchor:t.doc.length})), !0), qk = ({state:t, dispatch:e}) => (e(ds(t, {anchor:t.selection.main.anchor, 
head:0})), !0), Yk = ({state:t, dispatch:e}) => (e(ds(t, {anchor:t.selection.main.anchor, head:t.doc.length})), !0), LZ = ({state:t, dispatch:e}) => (e(t.update({selection:{anchor:0, head:t.doc.length}, userEvent:"select"})), !0), MZ = ({state:t, dispatch:e}) => {
  let n = Vg(t).map(({from:r, to:i}) => Ce.range(r, Math.min(i + 1, t.doc.length)));
  return e(t.update({selection:Ce.create(n), userEvent:"select"})), !0;
}, BZ = ({state:t, dispatch:e}) => {
  let n = Nc(t.selection, r => {
    let i = Ur(t), s = i.resolveStack(r.from, 1);
    if (r.empty) {
      let o = i.resolveStack(r.from, -1);
      o.node.from >= s.node.from && o.node.to <= s.node.to && (s = o);
    }
    for (let o = s; o; o = o.next) {
      let {node:a} = o;
      if ((a.from < r.from && a.to >= r.to || a.to > r.to && a.from <= r.from) && o.next) {
        return Ce.range(a.to, a.from);
      }
    }
    return r;
  });
  return n.eq(t.selection) ? !1 : (e(ds(t, n)), !0);
};
function XO(t, e) {
  let {state:n} = t, r = n.selection, i = n.selection.ranges.slice();
  for (let s of n.selection.ranges) {
    let o = n.doc.lineAt(s.head);
    if (e ? o.to < t.state.doc.length : o.from > 0) {
      for (let a = s;;) {
        let l = t.moveVertically(a, e);
        if (l.head < o.from || l.head > o.to) {
          i.some(c => c.head == l.head) || i.push(l);
          break;
        } else {
          if (l.head == a.head) {
            break;
          }
          a = l;
        }
      }
    }
  }
  return i.length == r.ranges.length ? !1 : (t.dispatch(ds(n, Ce.create(i, i.length - 1))), !0);
}
const $Z = t => XO(t, !1), FZ = t => XO(t, !0), zZ = ({state:t, dispatch:e}) => {
  let n = t.selection, r = null;
  return n.ranges.length > 1 ? r = Ce.create([n.main]) : n.main.empty || (r = Ce.create([Ce.cursor(n.main.head)])), r ? (e(ds(t, r)), !0) : !1;
};
function rh(t, e) {
  if (t.state.readOnly) {
    return !1;
  }
  let n = "delete.selection", {state:r} = t, i = r.changeByRange(s => {
    let {from:o, to:a} = s;
    if (o == a) {
      let l = e(s);
      l < o ? (n = "delete.backward", l = ef(t, l, !1)) : l > o && (n = "delete.forward", l = ef(t, l, !0)), o = Math.min(o, l), a = Math.max(a, l);
    } else {
      o = ef(t, o, !1), a = ef(t, a, !0);
    }
    return o == a ? {range:s} : {changes:{from:o, to:a}, range:Ce.cursor(o, o < s.head ? -1 : 1)};
  });
  return i.changes.empty ? !1 : (t.dispatch(r.update(i, {scrollIntoView:!0, userEvent:n, effects:n == "delete.selection" ? nt.announce.of(r.phrase("Selection deleted")) : void 0})), !0);
}
function ef(t, e, n) {
  if (t instanceof nt) {
    for (let r of t.state.facet(nt.atomicRanges).map(i => i(t))) {
      r.between(e, e, (i, s) => {
        i < e && s > e && (e = n ? s : i);
      });
    }
  }
  return e;
}
const JO = (t, e, n) => rh(t, r => {
  let i = r.from, {state:s} = t, o = s.doc.lineAt(i), a, l;
  if (n && !e && i > o.from && i < o.from + 200 && !/[^ \t]/.test(a = o.text.slice(0, i - o.from))) {
    if (a[a.length - 1] == "\t") {
      return i - 1;
    }
    let c = Ac(a, s.tabSize), u = c % Ip(s) || Ip(s);
    for (let h = 0; h < u && a[a.length - 1 - h] == " "; h++) {
      i--;
    }
    l = i;
  } else {
    l = cr(o.text, i - o.from, e, e) + o.from, l == i && o.number != (e ? s.doc.lines : 1) ? l += e ? 1 : -1 : !e && /[\ufe00-\ufe0f]/.test(o.text.slice(l - o.from, i - o.from)) && (l = cr(o.text, l - o.from, !1, !1) + o.from);
  }
  return l;
}), Ey = t => JO(t, !1, !0), ZO = t => JO(t, !0, !1), e3 = (t, e) => rh(t, n => {
  let r = n.head, {state:i} = t, s = i.doc.lineAt(r), o = i.charCategorizer(r);
  for (let a = null;;) {
    if (r == (e ? s.to : s.from)) {
      r == n.head && s.number != (e ? i.doc.lines : 1) && (r += e ? 1 : -1);
      break;
    }
    let l = cr(s.text, r - s.from, e) + s.from, c = s.text.slice(Math.min(r, l) - s.from, Math.max(r, l) - s.from), u = o(c);
    if (a != null && u != a) {
      break;
    }
    (c != " " || r != n.head) && (a = u), r = l;
  }
  return r;
}), t3 = t => e3(t, !1), HZ = t => e3(t, !0), UZ = t => rh(t, e => {
  let n = t.lineBlockAt(e.head).to;
  return e.head < n ? n : Math.min(t.state.doc.length, e.head + 1);
}), WZ = t => rh(t, e => {
  let n = t.moveToLineBoundary(e, !1).head;
  return e.head > n ? n : Math.max(0, e.head - 1);
}), jZ = t => rh(t, e => {
  let n = t.moveToLineBoundary(e, !0).head;
  return e.head < n ? n : Math.min(t.state.doc.length, e.head + 1);
}), VZ = ({state:t, dispatch:e}) => {
  if (t.readOnly) {
    return !1;
  }
  let n = t.changeByRange(r => ({changes:{from:r.from, to:r.to, insert:Xt.of(["", ""])}, range:Ce.cursor(r.from)}));
  return e(t.update(n, {scrollIntoView:!0, userEvent:"input"})), !0;
}, qZ = ({state:t, dispatch:e}) => {
  if (t.readOnly) {
    return !1;
  }
  let n = t.changeByRange(r => {
    if (!r.empty || r.from == 0 || r.from == t.doc.length) {
      return {range:r};
    }
    let i = r.from, s = t.doc.lineAt(i), o = i == s.from ? i - 1 : cr(s.text, i - s.from, !1) + s.from, a = i == s.to ? i + 1 : cr(s.text, i - s.from, !0) + s.from;
    return {changes:{from:o, to:a, insert:t.doc.slice(i, a).append(t.doc.slice(o, i))}, range:Ce.cursor(a)};
  });
  return n.changes.empty ? !1 : (e(t.update(n, {scrollIntoView:!0, userEvent:"move.character"})), !0);
};
function Vg(t) {
  let e = [], n = -1;
  for (let r of t.selection.ranges) {
    let i = t.doc.lineAt(r.from), s = t.doc.lineAt(r.to);
    if (!r.empty && r.to == s.from && (s = t.doc.lineAt(r.to - 1)), n >= i.number) {
      let o = e[e.length - 1];
      o.to = s.to, o.ranges.push(r);
    } else {
      e.push({from:i.from, to:s.to, ranges:[r]});
    }
    n = s.number + 1;
  }
  return e;
}
function n3(t, e, n) {
  if (t.readOnly) {
    return !1;
  }
  let r = [], i = [];
  for (let s of Vg(t)) {
    if (n ? s.to == t.doc.length : s.from == 0) {
      continue;
    }
    let o = t.doc.lineAt(n ? s.to + 1 : s.from - 1), a = o.length + 1;
    if (n) {
      r.push({from:s.to, to:o.to}, {from:s.from, insert:o.text + t.lineBreak});
      for (let l of s.ranges) {
        i.push(Ce.range(Math.min(t.doc.length, l.anchor + a), Math.min(t.doc.length, l.head + a)));
      }
    } else {
      r.push({from:o.from, to:s.from}, {from:s.to, insert:t.lineBreak + o.text});
      for (let l of s.ranges) {
        i.push(Ce.range(l.anchor - a, l.head - a));
      }
    }
  }
  return r.length ? (e(t.update({changes:r, scrollIntoView:!0, selection:Ce.create(i, t.selection.mainIndex), userEvent:"move.line"})), !0) : !1;
}
const YZ = ({state:t, dispatch:e}) => n3(t, e, !1), GZ = ({state:t, dispatch:e}) => n3(t, e, !0);
function r3(t, e, n) {
  if (t.readOnly) {
    return !1;
  }
  let r = [];
  for (let s of Vg(t)) {
    n ? r.push({from:s.from, insert:t.doc.slice(s.from, s.to) + t.lineBreak}) : r.push({from:s.to, insert:t.lineBreak + t.doc.slice(s.from, s.to)});
  }
  let i = t.changes(r);
  return e(t.update({changes:i, selection:t.selection.map(i, n ? 1 : -1), scrollIntoView:!0, userEvent:"input.copyline"})), !0;
}
const QZ = ({state:t, dispatch:e}) => r3(t, e, !1), KZ = ({state:t, dispatch:e}) => r3(t, e, !0), XZ = t => {
  if (t.state.readOnly) {
    return !1;
  }
  let {state:e} = t, n = e.changes(Vg(e).map(({from:i, to:s}) => (i > 0 ? i-- : s < e.doc.length && s++, {from:i, to:s}))), r = Nc(e.selection, i => {
    let s;
    if (t.lineWrapping) {
      let o = t.lineBlockAt(i.head), a = t.coordsAtPos(i.head, i.assoc || 1);
      a && (s = o.bottom + t.documentTop - a.bottom + t.defaultLineHeight / 2);
    }
    return t.moveVertically(i, !0, s);
  }).map(n);
  return t.dispatch({changes:n, selection:r, scrollIntoView:!0, userEvent:"delete.line"}), !0;
};
function JZ(t, e) {
  if (/\(\)|\[\]|\{\}/.test(t.sliceDoc(e - 1, e + 1))) {
    return {from:e, to:e};
  }
  let n = Ur(t).resolveInner(e), r = n.childBefore(e), i = n.childAfter(e), s;
  return r && i && r.to <= e && i.from >= e && (s = r.type.prop(Ot.closedBy)) && s.indexOf(i.name) > -1 && t.doc.lineAt(r.to).from == t.doc.lineAt(i.from).from && !/\S/.test(t.sliceDoc(r.to, i.from)) ? {from:r.to, to:i.from} : null;
}
const Gk = i3(!1), ZZ = i3(!0);
function i3(t) {
  return ({state:e, dispatch:n}) => {
    if (e.readOnly) {
      return !1;
    }
    let r = e.changeByRange(i => {
      let {from:s, to:o} = i, a = e.doc.lineAt(s), l = !t && s == o && JZ(e, s);
      t && (s = o = (o <= a.to ? a : e.doc.lineAt(o)).to);
      let c = new Fg(e, {simulateBreak:s, simulateDoubleBreak:!!l}), u = T1(c, s);
      for (u == null && (u = Ac(/^\s*/.exec(e.doc.lineAt(s).text)[0], e.tabSize)); o < a.to && /\s/.test(a.text[o - a.from]);) {
        o++;
      }
      l ? {from:s, to:o} = l : s > a.from && s < a.from + 100 && !/\S/.test(a.text.slice(0, s)) && (s = a.from);
      let h = ["", kd(e, u)];
      return l && h.push(kd(e, c.lineIndent(a.from, -1))), {changes:{from:s, to:o, insert:Xt.of(h)}, range:Ce.cursor(s + 1 + h[1].length)};
    });
    return n(e.update(r, {scrollIntoView:!0, userEvent:"input"})), !0;
  };
}
function I1(t, e) {
  let n = -1;
  return t.changeByRange(r => {
    let i = [];
    for (let o = r.from; o <= r.to;) {
      let a = t.doc.lineAt(o);
      a.number > n && (r.empty || r.to > a.from) && (e(a, i, r), n = a.number), o = a.to + 1;
    }
    let s = t.changes(i);
    return {changes:i, range:Ce.range(s.mapPos(r.anchor, 1), s.mapPos(r.head, 1))};
  });
}
const eee = ({state:t, dispatch:e}) => {
  if (t.readOnly) {
    return !1;
  }
  let n = Object.create(null), r = new Fg(t, {overrideIndentation:s => {
    let o = n[s];
    return o ?? -1;
  }}), i = I1(t, (s, o, a) => {
    let l = T1(r, s.from);
    if (l == null) {
      return;
    }
    /\S/.test(s.text) || (l = 0);
    let c = /^\s*/.exec(s.text)[0], u = kd(t, l);
    (c != u || a.from < s.from + c.length) && (n[s.from] = l, o.push({from:s.from, to:s.from + c.length, insert:u}));
  });
  return i.changes.empty || e(t.update(i, {userEvent:"indent"})), !0;
}, s3 = ({state:t, dispatch:e}) => t.readOnly ? !1 : (e(t.update(I1(t, (n, r) => {
  r.push({from:n.from, insert:t.facet(E1)});
}), {userEvent:"input.indent"})), !0), o3 = ({state:t, dispatch:e}) => t.readOnly ? !1 : (e(t.update(I1(t, (n, r) => {
  let i = /^\s*/.exec(n.text)[0];
  if (!i) {
    return;
  }
  let s = Ac(i, t.tabSize), o = 0, a = kd(t, Math.max(0, s - Ip(t)));
  for (; o < i.length && o < a.length && i.charCodeAt(o) == a.charCodeAt(o);) {
    o++;
  }
  r.push({from:n.from + o, to:n.from + i.length, insert:a.slice(o)});
}), {userEvent:"delete.dedent"})), !0), tee = t => (t.setTabFocusMode(), !0), nee = [{key:"Ctrl-b", run:LO, shift:jO, preventDefault:!0}, {key:"Ctrl-f", run:MO, shift:VO}, {key:"Ctrl-p", run:FO, shift:GO}, {key:"Ctrl-n", run:zO, shift:QO}, {key:"Ctrl-a", run:wZ, shift:RZ}, {key:"Ctrl-e", run:_Z, shift:DZ}, {key:"Ctrl-d", run:ZO}, {key:"Ctrl-h", run:Ey}, {key:"Ctrl-k", run:UZ}, {key:"Ctrl-Alt-h", run:t3}, {key:"Ctrl-o", run:VZ}, {key:"Ctrl-t", run:qZ}, {key:"Ctrl-v", run:ky}], ree = [{key:"ArrowLeft", 
run:LO, shift:jO, preventDefault:!0}, {key:"Mod-ArrowLeft", mac:"Alt-ArrowLeft", run:hZ, shift:EZ, preventDefault:!0}, {mac:"Cmd-ArrowLeft", run:xZ, shift:OZ, preventDefault:!0}, {key:"ArrowRight", run:MO, shift:VO, preventDefault:!0}, {key:"Mod-ArrowRight", mac:"Alt-ArrowRight", run:fZ, shift:TZ, preventDefault:!0}, {mac:"Cmd-ArrowRight", run:vZ, shift:PZ, preventDefault:!0}, {key:"ArrowUp", run:FO, shift:GO, preventDefault:!0}, {mac:"Cmd-ArrowUp", run:jk, shift:qk}, {mac:"Ctrl-ArrowUp", run:Hk, 
shift:Uk}, {key:"ArrowDown", run:zO, shift:QO, preventDefault:!0}, {mac:"Cmd-ArrowDown", run:Vk, shift:Yk}, {mac:"Ctrl-ArrowDown", run:ky, shift:Wk}, {key:"PageUp", run:Hk, shift:Uk}, {key:"PageDown", run:ky, shift:Wk}, {key:"Home", run:yZ, shift:IZ, preventDefault:!0}, {key:"Mod-Home", run:jk, shift:qk}, {key:"End", run:bZ, shift:NZ, preventDefault:!0}, {key:"Mod-End", run:Vk, shift:Yk}, {key:"Enter", run:Gk, shift:Gk}, {key:"Mod-a", run:LZ}, {key:"Backspace", run:Ey, shift:Ey, preventDefault:!0}, 
{key:"Delete", run:ZO, preventDefault:!0}, {key:"Mod-Backspace", mac:"Alt-Backspace", run:t3, preventDefault:!0}, {key:"Mod-Delete", mac:"Alt-Delete", run:HZ, preventDefault:!0}, {mac:"Mod-Backspace", run:WZ, preventDefault:!0}, {mac:"Mod-Delete", run:jZ, preventDefault:!0}].concat(nee.map(t => ({mac:t.key, run:t.run, shift:t.shift}))), iee = [{key:"Alt-ArrowLeft", mac:"Ctrl-ArrowLeft", run:gZ, shift:CZ}, {key:"Alt-ArrowRight", mac:"Ctrl-ArrowRight", run:mZ, shift:AZ}, {key:"Alt-ArrowUp", run:YZ}, 
{key:"Shift-Alt-ArrowUp", run:QZ}, {key:"Alt-ArrowDown", run:GZ}, {key:"Shift-Alt-ArrowDown", run:KZ}, {key:"Mod-Alt-ArrowUp", run:$Z}, {key:"Mod-Alt-ArrowDown", run:FZ}, {key:"Escape", run:zZ}, {key:"Mod-Enter", run:ZZ}, {key:"Alt-l", mac:"Ctrl-l", run:MZ}, {key:"Mod-i", run:BZ, preventDefault:!0}, {key:"Mod-[", run:o3}, {key:"Mod-]", run:s3}, {key:"Mod-Alt-\\", run:eee}, {key:"Shift-Mod-k", run:XZ}, {key:"Shift-Mod-\\", run:kZ}, {key:"Mod-/", run:YJ}, {key:"Alt-A", run:QJ}, {key:"Ctrl-m", mac:"Shift-Alt-m", 
run:tee}].concat(ree), see = {key:"Tab", run:s3, shift:o3};
class Dp {
  constructor(e, n, r, i, s, o, a, l, c, u = 0, h) {
    this.p = e, this.stack = n, this.state = r, this.reducePos = i, this.pos = s, this.score = o, this.buffer = a, this.bufferBase = l, this.curContext = c, this.lookAhead = u, this.parent = h;
  }
  toString() {
    return `[${this.stack.filter((e, n) => n % 3 == 0).concat(this.state)}]@${this.pos}${this.score ? "!" + this.score : ""}`;
  }
  static start(e, n, r = 0) {
    let i = e.parser.context;
    return new Dp(e, [], n, r, r, 0, [], 0, i ? new Qk(i, i.start) : null, 0, null);
  }
  get context() {
    return this.curContext ? this.curContext.context : null;
  }
  pushState(e, n) {
    this.stack.push(this.state, n, this.bufferBase + this.buffer.length), this.state = e;
  }
  reduce(e) {
    var n;
    let r = e >> 19, i = e & 65535, {parser:s} = this.p, o = this.reducePos < this.pos - 25 && this.setLookAhead(this.pos), a = s.dynamicPrecedence(i);
    if (a && (this.score += a), r == 0) {
      i < s.minRepeatTerm && this.reducePos < this.pos && (this.reducePos = this.pos), this.pushState(s.getGoto(this.state, i, !0), this.reducePos), i < s.minRepeatTerm && this.storeNode(i, this.reducePos, this.reducePos, o ? 8 : 4, !0), this.reduceContext(i, this.reducePos);
      return;
    }
    let l = this.stack.length - (r - 1) * 3 - (e & 262144 ? 6 : 0), c = l ? this.stack[l - 2] : this.p.ranges[0].from;
    i < s.minRepeatTerm && c == this.reducePos && this.reducePos < this.pos && (this.reducePos = this.pos);
    let u = this.reducePos - c;
    u >= 2e3 && !(!((n = this.p.parser.nodeSet.types[i]) === null || n === void 0) && n.isAnonymous) && (c == this.p.lastBigReductionStart ? (this.p.bigReductionCount++, this.p.lastBigReductionSize = u) : this.p.lastBigReductionSize < u && (this.p.bigReductionCount = 1, this.p.lastBigReductionStart = c, this.p.lastBigReductionSize = u));
    let h = l ? this.stack[l - 1] : 0, f = this.bufferBase + this.buffer.length - h;
    if (i < s.minRepeatTerm || e & 131072) {
      let p = s.stateFlag(this.state, 1) ? this.pos : this.reducePos;
      this.storeNode(i, c, p, f + 4, !0);
    }
    if (e & 262144) {
      this.state = this.stack[l];
    } else {
      let p = this.stack[l - 3];
      this.state = s.getGoto(p, i, !0);
    }
    for (; this.stack.length > l;) {
      this.stack.pop();
    }
    this.reduceContext(i, c);
  }
  storeNode(e, n, r, i = 4, s = !1) {
    if (e == 0 && (!this.stack.length || this.stack[this.stack.length - 1] < this.buffer.length + this.bufferBase)) {
      let o = this.buffer.length;
      if (o > 0 && this.buffer[o - 4] == 0 && this.buffer[o - 1] > -1) {
        if (n == r) {
          return;
        }
        if (this.buffer[o - 2] >= n) {
          this.buffer[o - 2] = r;
          return;
        }
      }
    }
    if (!s || this.pos == r) {
      this.buffer.push(e, n, r, i);
    } else {
      let o = this.buffer.length;
      if (o > 0 && (this.buffer[o - 4] != 0 || this.buffer[o - 1] < 0)) {
        let a = !1;
        for (let l = o; l > 0 && this.buffer[l - 2] > r; l -= 4) {
          if (this.buffer[l - 1] >= 0) {
            a = !0;
            break;
          }
        }
        if (a) {
          for (; o > 0 && this.buffer[o - 2] > r;) {
            this.buffer[o] = this.buffer[o - 4], this.buffer[o + 1] = this.buffer[o - 3], this.buffer[o + 2] = this.buffer[o - 2], this.buffer[o + 3] = this.buffer[o - 1], o -= 4, i > 4 && (i -= 4);
          }
        }
      }
      this.buffer[o] = e, this.buffer[o + 1] = n, this.buffer[o + 2] = r, this.buffer[o + 3] = i;
    }
  }
  shift(e, n, r, i) {
    if (e & 131072) {
      this.pushState(e & 65535, this.pos);
    } else if (e & 262144) {
      this.pos = i, this.shiftContext(n, r), n <= this.p.parser.maxNode && this.buffer.push(n, r, i, 4);
    } else {
      let s = e, {parser:o} = this.p;
      this.pos = i;
      let a = o.stateFlag(s, 1);
      !a && (i > r || n <= o.maxNode) && (this.reducePos = i), this.pushState(s, a ? r : Math.min(r, this.reducePos)), this.shiftContext(n, r), n <= o.maxNode && this.buffer.push(n, r, i, 4);
    }
  }
  apply(e, n, r, i) {
    e & 65536 ? this.reduce(e) : this.shift(e, n, r, i);
  }
  useNode(e, n) {
    let r = this.p.reused.length - 1;
    (r < 0 || this.p.reused[r] != e) && (this.p.reused.push(e), r++);
    let i = this.pos;
    this.reducePos = this.pos = i + e.length, this.pushState(n, i), this.buffer.push(r, i, this.reducePos, -1), this.curContext && this.updateContext(this.curContext.tracker.reuse(this.curContext.context, e, this, this.p.stream.reset(this.pos - e.length)));
  }
  split() {
    let e = this, n = e.buffer.length;
    for (n && e.buffer[n - 4] == 0 && (n -= 4); n > 0 && e.buffer[n - 2] > e.reducePos;) {
      n -= 4;
    }
    let r = e.buffer.slice(n), i = e.bufferBase + n;
    for (; e && i == e.bufferBase;) {
      e = e.parent;
    }
    return new Dp(this.p, this.stack.slice(), this.state, this.reducePos, this.pos, this.score, r, i, this.curContext, this.lookAhead, e);
  }
  recoverByDelete(e, n) {
    let r = e <= this.p.parser.maxNode;
    r && this.storeNode(e, this.pos, n, 4), this.storeNode(0, this.pos, n, r ? 8 : 4), this.pos = this.reducePos = n, this.score -= 190;
  }
  canShift(e) {
    for (let n = new oee(this);;) {
      let r = this.p.parser.stateSlot(n.state, 4) || this.p.parser.hasAction(n.state, e);
      if (r == 0) {
        return !1;
      }
      if (!(r & 65536)) {
        return !0;
      }
      n.reduce(r);
    }
  }
  recoverByInsert(e) {
    if (this.stack.length >= 300) {
      return [];
    }
    let n = this.p.parser.nextStates(this.state);
    if (n.length > 8 || this.stack.length >= 120) {
      let i = [];
      for (let s = 0, o; s < n.length; s += 2) {
        (o = n[s + 1]) != this.state && this.p.parser.hasAction(o, e) && i.push(n[s], o);
      }
      if (this.stack.length < 120) {
        for (let s = 0; i.length < 8 && s < n.length; s += 2) {
          let o = n[s + 1];
          i.some((a, l) => l & 1 && a == o) || i.push(n[s], o);
        }
      }
      n = i;
    }
    let r = [];
    for (let i = 0; i < n.length && r.length < 4; i += 2) {
      let s = n[i + 1];
      if (s == this.state) {
        continue;
      }
      let o = this.split();
      o.pushState(s, this.pos), o.storeNode(0, o.pos, o.pos, 4, !0), o.shiftContext(n[i], this.pos), o.reducePos = this.pos, o.score -= 200, r.push(o);
    }
    return r;
  }
  forceReduce() {
    let {parser:e} = this.p, n = e.stateSlot(this.state, 5);
    if (!(n & 65536)) {
      return !1;
    }
    if (!e.validAction(this.state, n)) {
      let r = n >> 19, i = n & 65535, s = this.stack.length - r * 3;
      if (s < 0 || e.getGoto(this.stack[s], i, !1) < 0) {
        let o = this.findForcedReduction();
        if (o == null) {
          return !1;
        }
        n = o;
      }
      this.storeNode(0, this.pos, this.pos, 4, !0), this.score -= 100;
    }
    return this.reducePos = this.pos, this.reduce(n), !0;
  }
  findForcedReduction() {
    let {parser:e} = this.p, n = [], r = (i, s) => {
      if (!n.includes(i)) {
        return n.push(i), e.allActions(i, o => {
          if (!(o & 393216)) {
            if (o & 65536) {
              let a = (o >> 19) - s;
              if (a > 1) {
                let l = o & 65535, c = this.stack.length - a * 3;
                if (c >= 0 && e.getGoto(this.stack[c], l, !1) >= 0) {
                  return a << 19 | 65536 | l;
                }
              }
            } else {
              let a = r(o, s + 1);
              if (a != null) {
                return a;
              }
            }
          }
        });
      }
    };
    return r(this.state, 0);
  }
  forceAll() {
    for (; !this.p.parser.stateFlag(this.state, 2);) {
      if (!this.forceReduce()) {
        this.storeNode(0, this.pos, this.pos, 4, !0);
        break;
      }
    }
    return this;
  }
  get deadEnd() {
    if (this.stack.length != 3) {
      return !1;
    }
    let {parser:e} = this.p;
    return e.data[e.stateSlot(this.state, 1)] == 65535 && !e.stateSlot(this.state, 4);
  }
  restart() {
    this.storeNode(0, this.pos, this.pos, 4, !0), this.state = this.stack[0], this.stack.length = 0;
  }
  sameState(e) {
    if (this.state != e.state || this.stack.length != e.stack.length) {
      return !1;
    }
    for (let n = 0; n < this.stack.length; n += 3) {
      if (this.stack[n] != e.stack[n]) {
        return !1;
      }
    }
    return !0;
  }
  get parser() {
    return this.p.parser;
  }
  dialectEnabled(e) {
    return this.p.parser.dialect.flags[e];
  }
  shiftContext(e, n) {
    this.curContext && this.updateContext(this.curContext.tracker.shift(this.curContext.context, e, this, this.p.stream.reset(n)));
  }
  reduceContext(e, n) {
    this.curContext && this.updateContext(this.curContext.tracker.reduce(this.curContext.context, e, this, this.p.stream.reset(n)));
  }
  emitContext() {
    let e = this.buffer.length - 1;
    (e < 0 || this.buffer[e] != -3) && this.buffer.push(this.curContext.hash, this.pos, this.pos, -3);
  }
  emitLookAhead() {
    let e = this.buffer.length - 1;
    (e < 0 || this.buffer[e] != -4) && this.buffer.push(this.lookAhead, this.pos, this.pos, -4);
  }
  updateContext(e) {
    if (e != this.curContext.context) {
      let n = new Qk(this.curContext.tracker, e);
      n.hash != this.curContext.hash && this.emitContext(), this.curContext = n;
    }
  }
  setLookAhead(e) {
    return e <= this.lookAhead ? !1 : (this.emitLookAhead(), this.lookAhead = e, !0);
  }
  close() {
    this.curContext && this.curContext.tracker.strict && this.emitContext(), this.lookAhead > 0 && this.emitLookAhead();
  }
}
class Qk {
  constructor(e, n) {
    this.tracker = e, this.context = n, this.hash = e.strict ? e.hash(n) : 0;
  }
}
class oee {
  constructor(e) {
    this.start = e, this.state = e.state, this.stack = e.stack, this.base = this.stack.length;
  }
  reduce(e) {
    let n = e & 65535, r = e >> 19;
    r == 0 ? (this.stack == this.start.stack && (this.stack = this.stack.slice()), this.stack.push(this.state, 0, 0), this.base += 3) : this.base -= (r - 1) * 3;
    let i = this.start.p.parser.getGoto(this.stack[this.base - 3], n, !0);
    this.state = i;
  }
}
class Lp {
  constructor(e, n, r) {
    this.stack = e, this.pos = n, this.index = r, this.buffer = e.buffer, this.index == 0 && this.maybeNext();
  }
  static create(e, n = e.bufferBase + e.buffer.length) {
    return new Lp(e, n, n - e.bufferBase);
  }
  maybeNext() {
    let e = this.stack.parent;
    e != null && (this.index = this.stack.bufferBase - e.bufferBase, this.stack = e, this.buffer = e.buffer);
  }
  get id() {
    return this.buffer[this.index - 4];
  }
  get start() {
    return this.buffer[this.index - 3];
  }
  get end() {
    return this.buffer[this.index - 2];
  }
  get size() {
    return this.buffer[this.index - 1];
  }
  next() {
    this.index -= 4, this.pos -= 4, this.index == 0 && this.maybeNext();
  }
  fork() {
    return new Lp(this.stack, this.pos, this.index);
  }
}
function tf(t, e = Uint16Array) {
  if (typeof t != "string") {
    return t;
  }
  let n = null;
  for (let r = 0, i = 0; r < t.length;) {
    let s = 0;
    for (;;) {
      let o = t.charCodeAt(r++), a = !1;
      if (o == 126) {
        s = 65535;
        break;
      }
      o >= 92 && o--, o >= 34 && o--;
      let l = o - 32;
      if (l >= 46 && (l -= 46, a = !0), s += l, a) {
        break;
      }
      s *= 46;
    }
    n ? n[i++] = s : n = new e(s);
  }
  return n;
}
class zf {
  constructor() {
    this.start = -1, this.value = -1, this.end = -1, this.extended = -1, this.lookAhead = 0, this.mask = 0, this.context = 0;
  }
}
const Kk = new zf();
class aee {
  constructor(e, n) {
    this.input = e, this.ranges = n, this.chunk = "", this.chunkOff = 0, this.chunk2 = "", this.chunk2Pos = 0, this.next = -1, this.token = Kk, this.rangeIndex = 0, this.pos = this.chunkPos = n[0].from, this.range = n[0], this.end = n[n.length - 1].to, this.readNext();
  }
  resolveOffset(e, n) {
    let r = this.range, i = this.rangeIndex, s = this.pos + e;
    for (; s < r.from;) {
      if (!i) {
        return null;
      }
      let o = this.ranges[--i];
      s -= r.from - o.to, r = o;
    }
    for (; n < 0 ? s > r.to : s >= r.to;) {
      if (i == this.ranges.length - 1) {
        return null;
      }
      let o = this.ranges[++i];
      s += o.from - r.to, r = o;
    }
    return s;
  }
  clipPos(e) {
    if (e >= this.range.from && e < this.range.to) {
      return e;
    }
    for (let n of this.ranges) {
      if (n.to > e) {
        return Math.max(e, n.from);
      }
    }
    return this.end;
  }
  peek(e) {
    let n = this.chunkOff + e, r, i;
    if (n >= 0 && n < this.chunk.length) {
      r = this.pos + e, i = this.chunk.charCodeAt(n);
    } else {
      let s = this.resolveOffset(e, 1);
      if (s == null) {
        return -1;
      }
      if (r = s, r >= this.chunk2Pos && r < this.chunk2Pos + this.chunk2.length) {
        i = this.chunk2.charCodeAt(r - this.chunk2Pos);
      } else {
        let o = this.rangeIndex, a = this.range;
        for (; a.to <= r;) {
          a = this.ranges[++o];
        }
        this.chunk2 = this.input.chunk(this.chunk2Pos = r), r + this.chunk2.length > a.to && (this.chunk2 = this.chunk2.slice(0, a.to - r)), i = this.chunk2.charCodeAt(0);
      }
    }
    return r >= this.token.lookAhead && (this.token.lookAhead = r + 1), i;
  }
  acceptToken(e, n = 0) {
    let r = n ? this.resolveOffset(n, -1) : this.pos;
    if (r == null || r < this.token.start) {
      throw new RangeError("Token end out of bounds");
    }
    this.token.value = e, this.token.end = r;
  }
  acceptTokenTo(e, n) {
    this.token.value = e, this.token.end = n;
  }
  getChunk() {
    if (this.pos >= this.chunk2Pos && this.pos < this.chunk2Pos + this.chunk2.length) {
      let {chunk:e, chunkPos:n} = this;
      this.chunk = this.chunk2, this.chunkPos = this.chunk2Pos, this.chunk2 = e, this.chunk2Pos = n, this.chunkOff = this.pos - this.chunkPos;
    } else {
      this.chunk2 = this.chunk, this.chunk2Pos = this.chunkPos;
      let e = this.input.chunk(this.pos), n = this.pos + e.length;
      this.chunk = n > this.range.to ? e.slice(0, this.range.to - this.pos) : e, this.chunkPos = this.pos, this.chunkOff = 0;
    }
  }
  readNext() {
    return this.chunkOff >= this.chunk.length && (this.getChunk(), this.chunkOff == this.chunk.length) ? this.next = -1 : this.next = this.chunk.charCodeAt(this.chunkOff);
  }
  advance(e = 1) {
    for (this.chunkOff += e; this.pos + e >= this.range.to;) {
      if (this.rangeIndex == this.ranges.length - 1) {
        return this.setDone();
      }
      e -= this.range.to - this.pos, this.range = this.ranges[++this.rangeIndex], this.pos = this.range.from;
    }
    return this.pos += e, this.pos >= this.token.lookAhead && (this.token.lookAhead = this.pos + 1), this.readNext();
  }
  setDone() {
    return this.pos = this.chunkPos = this.end, this.range = this.ranges[this.rangeIndex = this.ranges.length - 1], this.chunk = "", this.next = -1;
  }
  reset(e, n) {
    if (n ? (this.token = n, n.start = e, n.lookAhead = e + 1, n.value = n.extended = -1) : this.token = Kk, this.pos != e) {
      if (this.pos = e, e == this.end) {
        return this.setDone(), this;
      }
      for (; e < this.range.from;) {
        this.range = this.ranges[--this.rangeIndex];
      }
      for (; e >= this.range.to;) {
        this.range = this.ranges[++this.rangeIndex];
      }
      e >= this.chunkPos && e < this.chunkPos + this.chunk.length ? this.chunkOff = e - this.chunkPos : (this.chunk = "", this.chunkOff = 0), this.readNext();
    }
    return this;
  }
  read(e, n) {
    if (e >= this.chunkPos && n <= this.chunkPos + this.chunk.length) {
      return this.chunk.slice(e - this.chunkPos, n - this.chunkPos);
    }
    if (e >= this.chunk2Pos && n <= this.chunk2Pos + this.chunk2.length) {
      return this.chunk2.slice(e - this.chunk2Pos, n - this.chunk2Pos);
    }
    if (e >= this.range.from && n <= this.range.to) {
      return this.input.read(e, n);
    }
    let r = "";
    for (let i of this.ranges) {
      if (i.from >= n) {
        break;
      }
      i.to > e && (r += this.input.read(Math.max(i.from, e), Math.min(i.to, n)));
    }
    return r;
  }
}
class ec {
  constructor(e, n) {
    this.data = e, this.id = n;
  }
  token(e, n) {
    let {parser:r} = n.p;
    lee(this.data, e, n, this.id, r.data, r.tokenPrecTable);
  }
}
ec.prototype.contextual = ec.prototype.fallback = ec.prototype.extend = !1;
ec.prototype.fallback = ec.prototype.extend = !1;
function lee(t, e, n, r, i, s) {
  let o = 0, a = 1 << r, {dialect:l} = n.p.parser;
  e: for (; a & t[o];) {
    let c = t[o + 1];
    for (let p = o + 3; p < c; p += 2) {
      if ((t[p + 1] & a) > 0) {
        let g = t[p];
        if (l.allows(g) && (e.token.value == -1 || e.token.value == g || cee(g, e.token.value, i, s))) {
          e.acceptToken(g);
          break;
        }
      }
    }
    let u = e.next, h = 0, f = t[o + 2];
    if (e.next < 0 && f > h && t[c + f * 3 - 3] == 65535) {
      o = t[c + f * 3 - 1];
      continue e;
    }
    for (; h < f;) {
      let p = h + f >> 1, g = c + p + (p << 1), m = t[g], b = t[g + 1] || 65536;
      if (u < m) {
        f = p;
      } else if (u >= b) {
        h = p + 1;
      } else {
        o = t[g + 2], e.advance();
        continue e;
      }
    }
    break;
  }
}
function Xk(t, e, n) {
  for (let r = e, i; (i = t[r]) != 65535; r++) {
    if (i == n) {
      return r - e;
    }
  }
  return -1;
}
function cee(t, e, n, r) {
  let i = Xk(n, r, e);
  return i < 0 || Xk(n, r, t) < i;
}
const ci = typeof process < "u" && process.env && /\bparse\b/.test(process.env.LOG);
let x0 = null;
function Jk(t, e, n) {
  let r = t.cursor(Ln.IncludeAnonymous);
  for (r.moveTo(e);;) {
    if (!(n < 0 ? r.childBefore(e) : r.childAfter(e))) {
      for (;;) {
        if ((n < 0 ? r.to < e : r.from > e) && !r.type.isError) {
          return n < 0 ? Math.max(0, Math.min(r.to - 1, e - 25)) : Math.min(t.length, Math.max(r.from + 1, e + 25));
        }
        if (n < 0 ? r.prevSibling() : r.nextSibling()) {
          break;
        }
        if (!r.parent()) {
          return n < 0 ? 0 : t.length;
        }
      }
    }
  }
}
class uee {
  constructor(e, n) {
    this.fragments = e, this.nodeSet = n, this.i = 0, this.fragment = null, this.safeFrom = -1, this.safeTo = -1, this.trees = [], this.start = [], this.index = [], this.nextFragment();
  }
  nextFragment() {
    let e = this.fragment = this.i == this.fragments.length ? null : this.fragments[this.i++];
    if (e) {
      for (this.safeFrom = e.openStart ? Jk(e.tree, e.from + e.offset, 1) - e.offset : e.from, this.safeTo = e.openEnd ? Jk(e.tree, e.to + e.offset, -1) - e.offset : e.to; this.trees.length;) {
        this.trees.pop(), this.start.pop(), this.index.pop();
      }
      this.trees.push(e.tree), this.start.push(-e.offset), this.index.push(0), this.nextStart = this.safeFrom;
    } else {
      this.nextStart = 1e9;
    }
  }
  nodeAt(e) {
    if (e < this.nextStart) {
      return null;
    }
    for (; this.fragment && this.safeTo <= e;) {
      this.nextFragment();
    }
    if (!this.fragment) {
      return null;
    }
    for (;;) {
      let n = this.trees.length - 1;
      if (n < 0) {
        return this.nextFragment(), null;
      }
      let r = this.trees[n], i = this.index[n];
      if (i == r.children.length) {
        this.trees.pop(), this.start.pop(), this.index.pop();
        continue;
      }
      let s = r.children[i], o = this.start[n] + r.positions[i];
      if (o > e) {
        return this.nextStart = o, null;
      }
      if (s instanceof Vn) {
        if (o == e) {
          if (o < this.safeFrom) {
            return null;
          }
          let a = o + s.length;
          if (a <= this.safeTo) {
            let l = s.prop(Ot.lookAhead);
            if (!l || a + l < this.fragment.to) {
              return s;
            }
          }
        }
        this.index[n]++, o + s.length >= Math.max(this.safeFrom, e) && (this.trees.push(s), this.start.push(o), this.index.push(0));
      } else {
        this.index[n]++, this.nextStart = o + s.length;
      }
    }
  }
}
class dee {
  constructor(e, n) {
    this.stream = n, this.tokens = [], this.mainToken = null, this.actions = [], this.tokens = e.tokenizers.map(r => new zf());
  }
  getActions(e) {
    let n = 0, r = null, {parser:i} = e.p, {tokenizers:s} = i, o = i.stateSlot(e.state, 3), a = e.curContext ? e.curContext.hash : 0, l = 0;
    for (let c = 0; c < s.length; c++) {
      if (!(1 << c & o)) {
        continue;
      }
      let u = s[c], h = this.tokens[c];
      if (!(r && !u.fallback) && ((u.contextual || h.start != e.pos || h.mask != o || h.context != a) && (this.updateCachedToken(h, u, e), h.mask = o, h.context = a), h.lookAhead > h.end + 25 && (l = Math.max(h.lookAhead, l)), h.value != 0)) {
        let f = n;
        if (h.extended > -1 && (n = this.addActions(e, h.extended, h.end, n)), n = this.addActions(e, h.value, h.end, n), !u.extend && (r = h, n > f)) {
          break;
        }
      }
    }
    for (; this.actions.length > n;) {
      this.actions.pop();
    }
    return l && e.setLookAhead(l), !r && e.pos == this.stream.end && (r = new zf(), r.value = e.p.parser.eofTerm, r.start = r.end = e.pos, n = this.addActions(e, r.value, r.end, n)), this.mainToken = r, this.actions;
  }
  getMainToken(e) {
    if (this.mainToken) {
      return this.mainToken;
    }
    let n = new zf(), {pos:r, p:i} = e;
    return n.start = r, n.end = Math.min(r + 1, i.stream.end), n.value = r == i.stream.end ? i.parser.eofTerm : 0, n;
  }
  updateCachedToken(e, n, r) {
    let i = this.stream.clipPos(r.pos);
    if (n.token(this.stream.reset(i, e), r), e.value > -1) {
      let {parser:s} = r.p;
      for (let o = 0; o < s.specialized.length; o++) {
        if (s.specialized[o] == e.value) {
          let a = s.specializers[o](this.stream.read(e.start, e.end), r);
          if (a >= 0 && r.p.parser.dialect.allows(a >> 1)) {
            a & 1 ? e.extended = a >> 1 : e.value = a >> 1;
            break;
          }
        }
      }
    } else {
      e.value = 0, e.end = this.stream.clipPos(i + 1);
    }
  }
  putAction(e, n, r, i) {
    for (let s = 0; s < i; s += 3) {
      if (this.actions[s] == e) {
        return i;
      }
    }
    return this.actions[i++] = e, this.actions[i++] = n, this.actions[i++] = r, i;
  }
  addActions(e, n, r, i) {
    let {state:s} = e, {parser:o} = e.p, {data:a} = o;
    for (let l = 0; l < 2; l++) {
      for (let c = o.stateSlot(s, l ? 2 : 1);; c += 3) {
        if (a[c] == 65535) {
          if (a[c + 1] == 1) {
            c = Zs(a, c + 2);
          } else {
            i == 0 && a[c + 1] == 2 && (i = this.putAction(Zs(a, c + 2), n, r, i));
            break;
          }
        }
        a[c] == n && (i = this.putAction(Zs(a, c + 1), n, r, i));
      }
    }
    return i;
  }
}
class hee {
  constructor(e, n, r, i) {
    this.parser = e, this.input = n, this.ranges = i, this.recovering = 0, this.nextStackID = 9812, this.minStackPos = 0, this.reused = [], this.stoppedAt = null, this.lastBigReductionStart = -1, this.lastBigReductionSize = 0, this.bigReductionCount = 0, this.stream = new aee(n, i), this.tokens = new dee(e, this.stream), this.topTerm = e.top[1];
    let {from:s} = i[0];
    this.stacks = [Dp.start(this, e.top[0], s)], this.fragments = r.length && this.stream.end - s > e.bufferLength * 4 ? new uee(r, e.nodeSet) : null;
  }
  get parsedPos() {
    return this.minStackPos;
  }
  advance() {
    let e = this.stacks, n = this.minStackPos, r = this.stacks = [], i, s;
    if (this.bigReductionCount > 300 && e.length == 1) {
      let [o] = e;
      for (; o.forceReduce() && o.stack.length && o.stack[o.stack.length - 2] >= this.lastBigReductionStart;) {
      }
      this.bigReductionCount = this.lastBigReductionSize = 0;
    }
    for (let o = 0; o < e.length; o++) {
      let a = e[o];
      for (;;) {
        if (this.tokens.mainToken = null, a.pos > n) {
          r.push(a);
        } else {
          if (this.advanceStack(a, r, e)) {
            continue;
          }
          {
            i || (i = [], s = []), i.push(a);
            let l = this.tokens.getMainToken(a);
            s.push(l.value, l.end);
          }
        }
        break;
      }
    }
    if (!r.length) {
      let o = i && pee(i);
      if (o) {
        return ci && console.log("Finish with " + this.stackID(o)), this.stackToTree(o);
      }
      if (this.parser.strict) {
        throw ci && i && console.log("Stuck with token " + (this.tokens.mainToken ? this.parser.getName(this.tokens.mainToken.value) : "none")), new SyntaxError("No parse at " + n);
      }
      this.recovering || (this.recovering = 5);
    }
    if (this.recovering && i) {
      let o = this.stoppedAt != null && i[0].pos > this.stoppedAt ? i[0] : this.runRecovery(i, s, r);
      if (o) {
        return ci && console.log("Force-finish " + this.stackID(o)), this.stackToTree(o.forceAll());
      }
    }
    if (this.recovering) {
      let o = this.recovering == 1 ? 1 : this.recovering * 3;
      if (r.length > o) {
        for (r.sort((a, l) => l.score - a.score); r.length > o;) {
          r.pop();
        }
      }
      r.some(a => a.reducePos > n) && this.recovering--;
    } else if (r.length > 1) {
      e: for (let o = 0; o < r.length - 1; o++) {
        let a = r[o];
        for (let l = o + 1; l < r.length; l++) {
          let c = r[l];
          if (a.sameState(c) || a.buffer.length > 500 && c.buffer.length > 500) {
            if ((a.score - c.score || a.buffer.length - c.buffer.length) > 0) {
              r.splice(l--, 1);
            } else {
              r.splice(o--, 1);
              continue e;
            }
          }
        }
      }
      r.length > 12 && (r.sort((o, a) => a.score - o.score), r.splice(12, r.length - 12));
    }
    this.minStackPos = r[0].pos;
    for (let o = 1; o < r.length; o++) {
      r[o].pos < this.minStackPos && (this.minStackPos = r[o].pos);
    }
    return null;
  }
  stopAt(e) {
    if (this.stoppedAt != null && this.stoppedAt < e) {
      throw new RangeError("Can't move stoppedAt forward");
    }
    this.stoppedAt = e;
  }
  advanceStack(e, n, r) {
    let i = e.pos, {parser:s} = this, o = ci ? this.stackID(e) + " -\x3e " : "";
    if (this.stoppedAt != null && i > this.stoppedAt) {
      return e.forceReduce() ? e : null;
    }
    if (this.fragments) {
      let c = e.curContext && e.curContext.tracker.strict, u = c ? e.curContext.hash : 0;
      for (let h = this.fragments.nodeAt(i); h;) {
        let f = this.parser.nodeSet.types[h.type.id] == h.type ? s.getGoto(e.state, h.type.id) : -1;
        if (f > -1 && h.length && (!c || (h.prop(Ot.contextHash) || 0) == u)) {
          return e.useNode(h, f), ci && console.log(o + this.stackID(e) + ` (via reuse of ${s.getName(h.type.id)})`), !0;
        }
        if (!(h instanceof Vn) || h.children.length == 0 || h.positions[0] > 0) {
          break;
        }
        let p = h.children[0];
        if (p instanceof Vn && h.positions[0] == 0) {
          h = p;
        } else {
          break;
        }
      }
    }
    let a = s.stateSlot(e.state, 4);
    if (a > 0) {
      return e.reduce(a), ci && console.log(o + this.stackID(e) + ` (via always-reduce ${s.getName(a & 65535)})`), !0;
    }
    if (e.stack.length >= 8400) {
      for (; e.stack.length > 6e3 && e.forceReduce();) {
      }
    }
    let l = this.tokens.getActions(e);
    for (let c = 0; c < l.length;) {
      let u = l[c++], h = l[c++], f = l[c++], p = c == l.length || !r, g = p ? e : e.split(), m = this.tokens.mainToken;
      if (g.apply(u, h, m ? m.start : g.pos, f), ci && console.log(o + this.stackID(g) + ` (via ${u & 65536 ? `reduce of ${s.getName(u & 65535)}` : "shift"} for ${s.getName(h)} @ ${i}${g == e ? "" : ", split"})`), p) {
        return !0;
      }
      g.pos > i ? n.push(g) : r.push(g);
    }
    return !1;
  }
  advanceFully(e, n) {
    let r = e.pos;
    for (;;) {
      if (!this.advanceStack(e, null, null)) {
        return !1;
      }
      if (e.pos > r) {
        return Zk(e, n), !0;
      }
    }
  }
  runRecovery(e, n, r) {
    let i = null, s = !1;
    for (let o = 0; o < e.length; o++) {
      let a = e[o], l = n[o << 1], c = n[(o << 1) + 1], u = ci ? this.stackID(a) + " -\x3e " : "";
      if (a.deadEnd && (s || (s = !0, a.restart(), ci && console.log(u + this.stackID(a) + " (restarted)"), this.advanceFully(a, r)))) {
        continue;
      }
      let h = a.split(), f = u;
      for (let p = 0; p < 10 && h.forceReduce() && (ci && console.log(f + this.stackID(h) + " (via force-reduce)"), !this.advanceFully(h, r)); p++) {
        ci && (f = this.stackID(h) + " -\x3e ");
      }
      for (let p of a.recoverByInsert(l)) {
        ci && console.log(u + this.stackID(p) + " (via recover-insert)"), this.advanceFully(p, r);
      }
      this.stream.end > a.pos ? (c == a.pos && (c++, l = 0), a.recoverByDelete(l, c), ci && console.log(u + this.stackID(a) + ` (via recover-delete ${this.parser.getName(l)})`), Zk(a, r)) : (!i || i.score < h.score) && (i = h);
    }
    return i;
  }
  stackToTree(e) {
    return e.close(), Vn.build({buffer:Lp.create(e), nodeSet:this.parser.nodeSet, topID:this.topTerm, maxBufferLength:this.parser.bufferLength, reused:this.reused, start:this.ranges[0].from, length:e.pos - this.ranges[0].from, minRepeatType:this.parser.minRepeatTerm});
  }
  stackID(e) {
    let n = (x0 || (x0 = new WeakMap())).get(e);
    return n || x0.set(e, n = String.fromCodePoint(this.nextStackID++)), n + e;
  }
}
function Zk(t, e) {
  for (let n = 0; n < e.length; n++) {
    let r = e[n];
    if (r.pos == t.pos && r.sameState(t)) {
      e[n].score < t.score && (e[n] = t);
      return;
    }
  }
  e.push(t);
}
class fee {
  constructor(e, n, r) {
    this.source = e, this.flags = n, this.disabled = r;
  }
  allows(e) {
    return !this.disabled || this.disabled[e] == 0;
  }
}
class Mp extends cO {
  constructor(e) {
    if (super(), this.wrappers = [], e.version != 14) {
      throw new RangeError(`Parser version (${e.version}) doesn't match runtime version (14)`);
    }
    let n = e.nodeNames.split(" ");
    this.minRepeatTerm = n.length;
    for (let a = 0; a < e.repeatNodeCount; a++) {
      n.push("");
    }
    let r = Object.keys(e.topRules).map(a => e.topRules[a][1]), i = [];
    for (let a = 0; a < n.length; a++) {
      i.push([]);
    }
    function s(a, l, c) {
      i[a].push([l, l.deserialize(String(c))]);
    }
    if (e.nodeProps) {
      for (let a of e.nodeProps) {
        let l = a[0];
        typeof l == "string" && (l = Ot[l]);
        for (let c = 1; c < a.length;) {
          let u = a[c++];
          if (u >= 0) {
            s(u, l, a[c++]);
          } else {
            let h = a[c + -u];
            for (let f = -u; f > 0; f--) {
              s(a[c++], l, h);
            }
            c++;
          }
        }
      }
    }
    this.nodeSet = new w1(n.map((a, l) => ti.define({name:l >= this.minRepeatTerm ? void 0 : a, id:l, props:i[l], top:r.indexOf(l) > -1, error:l == 0, skipped:e.skippedNodes && e.skippedNodes.indexOf(l) > -1}))), e.propSources && (this.nodeSet = this.nodeSet.extend(...e.propSources)), this.strict = !1, this.bufferLength = sO;
    let o = tf(e.tokenData);
    this.context = e.context, this.specializerSpecs = e.specialized || [], this.specialized = new Uint16Array(this.specializerSpecs.length);
    for (let a = 0; a < this.specializerSpecs.length; a++) {
      this.specialized[a] = this.specializerSpecs[a].term;
    }
    this.specializers = this.specializerSpecs.map(e2), this.states = tf(e.states, Uint32Array), this.data = tf(e.stateData), this.goto = tf(e.goto), this.maxTerm = e.maxTerm, this.tokenizers = e.tokenizers.map(a => typeof a == "number" ? new ec(o, a) : a), this.topRules = e.topRules, this.dialects = e.dialects || {}, this.dynamicPrecedences = e.dynamicPrecedences || null, this.tokenPrecTable = e.tokenPrec, this.termNames = e.termNames || null, this.maxNode = this.nodeSet.types.length - 1, this.dialect = 
    this.parseDialect(), this.top = this.topRules[Object.keys(this.topRules)[0]];
  }
  createParse(e, n, r) {
    let i = new hee(this, e, n, r);
    for (let s of this.wrappers) {
      i = s(i, e, n, r);
    }
    return i;
  }
  getGoto(e, n, r = !1) {
    let i = this.goto;
    if (n >= i[0]) {
      return -1;
    }
    for (let s = i[n + 1];;) {
      let o = i[s++], a = o & 1, l = i[s++];
      if (a && r) {
        return l;
      }
      for (let c = s + (o >> 1); s < c; s++) {
        if (i[s] == e) {
          return l;
        }
      }
      if (a) {
        return -1;
      }
    }
  }
  hasAction(e, n) {
    let r = this.data;
    for (let i = 0; i < 2; i++) {
      for (let s = this.stateSlot(e, i ? 2 : 1), o;; s += 3) {
        if ((o = r[s]) == 65535) {
          if (r[s + 1] == 1) {
            o = r[s = Zs(r, s + 2)];
          } else {
            if (r[s + 1] == 2) {
              return Zs(r, s + 2);
            }
            break;
          }
        }
        if (o == n || o == 0) {
          return Zs(r, s + 1);
        }
      }
    }
    return 0;
  }
  stateSlot(e, n) {
    return this.states[e * 6 + n];
  }
  stateFlag(e, n) {
    return (this.stateSlot(e, 0) & n) > 0;
  }
  validAction(e, n) {
    return !!this.allActions(e, r => r == n ? !0 : null);
  }
  allActions(e, n) {
    let r = this.stateSlot(e, 4), i = r ? n(r) : void 0;
    for (let s = this.stateSlot(e, 1); i == null; s += 3) {
      if (this.data[s] == 65535) {
        if (this.data[s + 1] == 1) {
          s = Zs(this.data, s + 2);
        } else {
          break;
        }
      }
      i = n(Zs(this.data, s + 1));
    }
    return i;
  }
  nextStates(e) {
    let n = [];
    for (let r = this.stateSlot(e, 1);; r += 3) {
      if (this.data[r] == 65535) {
        if (this.data[r + 1] == 1) {
          r = Zs(this.data, r + 2);
        } else {
          break;
        }
      }
      if (!(this.data[r + 2] & 1)) {
        let i = this.data[r + 1];
        n.some((s, o) => o & 1 && s == i) || n.push(this.data[r], i);
      }
    }
    return n;
  }
  configure(e) {
    let n = Object.assign(Object.create(Mp.prototype), this);
    if (e.props && (n.nodeSet = this.nodeSet.extend(...e.props)), e.top) {
      let r = this.topRules[e.top];
      if (!r) {
        throw new RangeError(`Invalid top rule name ${e.top}`);
      }
      n.top = r;
    }
    return e.tokenizers && (n.tokenizers = this.tokenizers.map(r => {
      let i = e.tokenizers.find(s => s.from == r);
      return i ? i.to : r;
    })), e.specializers && (n.specializers = this.specializers.slice(), n.specializerSpecs = this.specializerSpecs.map((r, i) => {
      let s = e.specializers.find(a => a.from == r.external);
      if (!s) {
        return r;
      }
      let o = Object.assign(Object.assign({}, r), {external:s.to});
      return n.specializers[i] = e2(o), o;
    })), e.contextTracker && (n.context = e.contextTracker), e.dialect && (n.dialect = this.parseDialect(e.dialect)), e.strict != null && (n.strict = e.strict), e.wrap && (n.wrappers = n.wrappers.concat(e.wrap)), e.bufferLength != null && (n.bufferLength = e.bufferLength), n;
  }
  hasWrappers() {
    return this.wrappers.length > 0;
  }
  getName(e) {
    return this.termNames ? this.termNames[e] : String(e <= this.maxNode && this.nodeSet.types[e].name || e);
  }
  get eofTerm() {
    return this.maxNode + 1;
  }
  get topNode() {
    return this.nodeSet.types[this.top[1]];
  }
  dynamicPrecedence(e) {
    let n = this.dynamicPrecedences;
    return n == null ? 0 : n[e] || 0;
  }
  parseDialect(e) {
    let n = Object.keys(this.dialects), r = n.map(() => !1);
    if (e) {
      for (let s of e.split(" ")) {
        let o = n.indexOf(s);
        o >= 0 && (r[o] = !0);
      }
    }
    let i = null;
    for (let s = 0; s < n.length; s++) {
      if (!r[s]) {
        for (let o = this.dialects[n[s]], a; (a = this.data[o++]) != 65535;) {
          (i || (i = new Uint8Array(this.maxTerm + 1)))[a] = 1;
        }
      }
    }
    return new fee(e, r, i);
  }
  static deserialize(e) {
    return new Mp(e);
  }
}
function Zs(t, e) {
  return t[e] | t[e + 1] << 16;
}
function pee(t) {
  let e = null;
  for (let n of t) {
    let r = n.p.stoppedAt;
    (n.pos == n.p.stream.end || r != null && n.pos > r) && n.p.parser.stateFlag(n.state, 2) && (!e || e.score < n.score) && (e = n);
  }
  return e;
}
function e2(t) {
  if (t.external) {
    let e = t.extend ? 1 : 0;
    return (n, r) => t.external(n, r) << 1 | e;
  }
  return t.get;
}
let ih = () => new Ot({deserialize:t => !0});
const a3 = ih(), l3 = ih(), c3 = ih(), u3 = ih(), d3 = ih();
var gee = Object.freeze({__proto__:null, coll:a3, prefixColl:l3, prefixEdge:c3, sameEdge:u3, prefixContainer:d3});
const mee = {__proto__:null, true:136, false:136, nil:138, def:147, defn:147, "defn-":147, defmacro:147, definline:147, defonce:147, deftest:147, defcard:147, ns:155}, bee = Mp.deserialize({version:14, states:"-zQ]QPOOP!pOPOOOOQO'#C`'#C`OOQO'#Cb'#CbO]QPO'#CcO]QPO'#CeO]QPO'#CgO]QPO'#CiO]QPO'#CkO]OPO'#CtO]OPO'#CvO!uOQO'#C|OOQO'#Dm'#DmQ]QPOOO$hQPO'#CqO$oQPO'#DUO$vQPO'#DXO$}OSO'#DZO%cOPO'#D]O%hOPO'#D`O%mOPO'#DbO%uOWO'#DdO]QPO'#DgO]QPO'#DhO%zQPO'#DjOOQO'#Dq'#DqP\x26SQPO'#C^POOO)C?e)C?eOOQO,58},58}OOQO,59P,59POOQO,59R,59ROOQO,59T,59TOOQO,59V,59VOOQO,59`,59`OOQO,59b,59bOOQO,59h,59hO'gOPO,59hOOQO-E7k-E7kOOQO'#Cr'#CrO!}QPO'#CsOOQO'#Dv'#DvO'lQPO'#D|O'sQPO'#DuOOQO'#DO'#DOOOQO'#Dz'#DzO'sQPO'#DyOOQO'#DQ'#DQOOQO'#D}'#D}O'lQPO'#D|OOQO'#Dt'#DtO(OQPO,59]O(TQPO,59pOOQO,59p,59pO([QPO,59sOOQO,59s,59sOOQO,59u,59uOOOO,59x,59xOOQO,59y,59yOOQO,5:Q,5:QOOQO,5:T,5:TOOQO,5:V,5:VOOQO,59w,59wOOQO,59z,59zOOQO,59|,59|OOQO,5:O,5:OOOQO,5:R,5:ROOQO,5:S,5:SOOQO,5:U,5:UPOOO,58x,58xOOQO1G/S1G/SOOQO,59_,59_OOQO,59k,59kOOQO,59m,59mOOQO'#Cx'#CxO'sQPO'#CyOOQO'#Dx'#DxO(cQPO,5:aO(jQPO,5:eO(qQPO,5:hOOQO1G.w1G.wOOQO1G/[1G/[OOQO1G/_1G/_OOQO,59e,59eO(xQPO'#CzO*`QPO1G/{O]QPO1G/{OOQO'#Cz'#CzO*gQPO1G0PO*gQPO1G0PO*nQPO7+%gO*uQPO7+%kP\x26SQPO'#CcP\x26SQPO'#CeP\x26SQPO'#CgP\x26SQPO'#CiP\x26SQPO'#CkP*|OPO'#DbP\x26SQPO'#DgP\x26SQPO'#Dh", 
stateData:"+[~O!dOSPOSRPQ~OTiOWSOYTO[UO^VO`WOaiObiOd^OiXOkYOoZOw_Oz`O|iO!OaO!TcO!VdO!XeO!fQO!gRO~ORjO~OosOqtO~OT!OOWSOYTO[UO^VO`WOaiObiOd^OiXOkYOoZOw_Oz`O|iO!OaO!TcO!VdO!XeO!fQO!gRO!kvO!o{O~Oc!pP~P!}Ov!UO~P]Oy!WO~P]Od^OoZOz`O!r!YO!t!]O!u!^O~Oz`O~OT!`O~OWSOd^O~O!s!bO~Ow_Oz`O~OTiOW!}OY#OO[#PO^#QO`#ROaiObiOd^OiXOkYOoZOw_Oz`O|iO!OaO!TcO!V#SO!XeO!fQO!gRO~Oo!gO~Oc!pX~P]OT!kOiXOkYO~Oc!qO~Ov!rO~P]Oy!sO~P]Oc!ia~P]Oc!ma~P]Oc!pa~P]OTnXWnXYnX[nX^nX`nXanXbnXc!eXdnXinXknXonXwnXznX|nX!OnX!TnX!VnX!XnX!fnX!gnX~Oc!ii~P]Oc!mi~P]Oc!iq~P]Oc!mq~P]OW!}Od^O~Oa!u!tT!t~", 
goto:"/]!rPP!sP!vP!v#nP!vP!vP!vP!vPPPPP$j%i%i%mP%mP\x26n\x26n\x26sP\x26yP'x'x'|'|PP(QPP({P!vP!v)|!v!vP!vP!vP!v!v!v*t!v+nP,fPPP-^PP.j.m.pP.v.m/PP.m/VRkP!kiOSTUVWXY]^_`fgjwy!Q!T!V!n!o!p!v!w!y!z!{!|!}#O#P#Q#R#T#U!jiOSTUVWXY]^_`fgjwy!Q!T!V!n!o!p!v!w!y!z!{!|!}#O#P#Q#R#T#UT!ad#S!jiOSTUVWXY]^_`fgjwy!Q!T!V!n!o!p!v!w!y!z!{!|!}#O#P#Q#R#T#UQ![aT!ad#STx^w!UfOSTUVWXY]_`fgy!Q!T!V!n!o!p!v!w!y!z!{!|Sw^wU!lz}!la#Tj!}#O#P#Q#R#T#UV!mz}!lQ!w!nR!z!o!fiOSTUVWXY]^_`fgjwy!Q!T!V!p!v!w!y!z!{!|!}#O#P#Q#R#T#UQ!ZaQ!u!nR!x!oT|^wT!P^w!jiOSTUVWXY]^_`fgjwy!Q!T!V!n!o!p!v!w!y!z!{!|!}#O#P#Q#R#T#UR!eh!jiOSTUVWXY]^_`fgjwy!Q!T!V!n!o!p!v!w!y!z!{!|!}#O#P#Q#R#T#UQ!XaQ!_bR!eh!kbOSTUVWXY]^_`fgjwy!Q!T!V!n!o!p!v!w!y!z!{!|!}#O#P#Q#R#T#U!YgOSTUVWXY]^_`fgwy!Q!T!V!n!o!p!v!w!y!z!{!|a#Uj!}#O#P#Q#R#T#U!khOSTUVWXY]^_`fgjwy!Q!T!V!n!o!p!v!w!y!z!{!|!}#O#P#Q#R#T#UQ]Obu]y!T!V!p!v!y!{!|Qy^Q!T_Q!V`Q!p!QQ!v!nQ!y!oQ!{!wR!|!zt[O]^_`y!Q!T!V!n!o!p!v!w!y!z!{!|SlS!}SmT#OSnU#PSoV#QSpW#RQqXQrYU!cfw#TS!dg#UR!fjR!S^R!R^Qz^R!hwQ!nzQ!o}R!t!lQ}^R!iwQ!Q^R!jw", 
nodeNames:"\u26a0 LineComment Discard #_ Boolean Symbol Nil Deref @ Quote ' SyntaxQuote ` Unquote ~ UnquoteSplice ~@ Number Keyword ) ( List DefLike Meta Metadata ^ ReaderMetadata #^ VarName Meta DocString \" String StringContent NS Meta Operator Meta ] [ Vector } { Map Character Set # NamespacedMap KeywordPrefix RegExp Var #' ReaderConditional #? SymbolicValue ## AnonymousFunction Meta TaggedLiteral ReaderTag ConstructorCall ConstructorPrefix Program", maxTerm:83, nodeProps:[[c3, -14, 3, 8, 10, 
12, 14, 16, 25, 27, 46, 48, 51, 53, 55, 61, ""], [l3, -13, 7, 9, 11, 13, 15, 24, 26, 45, 47, 49, 50, 52, 56, ""], ["openedBy", 19, "(", 31, '"', 38, "[", 41, "{"], ["closedBy", 20, ")", 31, '"', 39, "]", 42, "}"], [a3, -3, 21, 40, 43, ""], [d3, -7, 23, 29, 35, 37, 57, 58, 60, ""], [u3, 31, ""]], skippedNodes:[0, 1, 2, 3], repeatNodeCount:1, tokenData:"#6x~R![OX$wX^%n^p$wpq%nqr'grs,Tst,Ytu/Yuv'gvw'gwx6Vxy6jyz6}z{'g{|7b|}%n}!O7b!O!P9t!P!Q)v!Q!R!8[!R![!\x3et![!]!Cp!]!^!J]!^!_'g!_!`'g!`!a'g!a!b'g!b!c!Kr!c!}/Y!}#O!LV#O#P!Lj#P#Q#3w#Q#R#4[#R#S/Y#S#T#4o#T#o/Y#o#p#5S#p#q$w#q#r#5g#r#s#5z#s#y$w#y#z%n#z$f$w$f$g%n$g##l/Y##l#BY$w#BY#BZ%n#BZ$IS$w$IS$I_%n$I_$I|$w$I|$JO%n$JO$JT$w$JT$JU%n$JU$KV$w$KV$KW%n$KW\x26FU$w\x26FU\x26FV%n\x26FV~$wQ$|SqQOr$ws#O$w#O#P%Y#P~$wQ%_TqQOr$wrs$ws#O$w#O#P%Y#P~$wR%ujqQ!dPOX$wX^%n^p$wpq%nqr$ws|$w|}%n}#O$w#O#P%Y#P#y$w#y#z%n#z$f$w$f$g%n$g#BY$w#BY#BZ%n#BZ$IS$w$IS$I_%n$I_$I|$w$I|$JO%n$JO$JT$w$JT$JU%n$JU$KV$w$KV$KW%n$KW\x26FU$w\x26FU\x26FV%n\x26FV~$w_'rpqQ!sW!tSTPOq$wqr'gst)vtu'guv'gvw'gwx)vxz$wz{'g{|'g|}$w}!O'g!O!P)v!P!Q'g!Q!['g![!])v!]!^$w!^!_'g!_!`'g!`!a'g!a!b'g!b!c$w!c!}'g!}#O$w#O#P%Y#P#R$w#R#S'g#S#T$w#T#o'g#o$g$w$g##l'g##l~$wZ*PpqQ!sWTPOq$wqr)vst)vtu)vuv)vvw)vwx)vxz$wz{)v{|)v|}$w}!O)v!O!P)v!P!Q)v!Q![)v![!])v!]!^$w!^!_)v!_!`)v!`!a)v!a!b)v!b!c$w!c!})v!}#O$w#O#P%Y#P#R$w#R#S)v#S#T$w#T#o)v#o$g$w$g##l)v##l~$w~,YOo~R,a[!OPqQOr$wst-Vtw$wwx-jx!a$w!a!b-}!b#O$w#O#P%Y#P#Q$w#Q#R.b#R#S.u#S~$wR-^S!XPqQOr$ws#O$w#O#P%Y#P~$wR-qS!TPqQOr$ws#O$w#O#P%Y#P~$wR.US!VPqQOr$ws#O$w#O#P%Y#P~$wR.iSkPqQOr$ws#O$w#O#P%Y#P~$wR.|SRPqQOr$ws#O$w#O#P%Y#P~$w_/epqQ!sW!tSTPOq$wqr'gst)vtu/Yuv'gvw'gwx)vxz$wz{'g{|'g|}$w}!O'g!O!P1i!P!Q'g!Q![/Y![!])v!]!^$w!^!_'g!_!`'g!`!a'g!a!b'g!b!c$w!c!}/Y!}#O$w#O#P%Y#P#R$w#R#S/Y#S#T$w#T#o/Y#o$g$w$g##l/Y##l~$w_1rpqQ!sWTPOq$wqr)vst)vtu3vuv)vvw)vwx)vxz$wz{)v{|)v|}$w}!O)v!O!P)v!P!Q)v!Q![)v![!])v!]!^$w!^!_)v!_!`)v!`!a)v!a!b)v!b!c$w!c!}3v!}#O$w#O#P%Y#P#R$w#R#S3v#S#T$w#T#o3v#o$g$w$g##l3v##l~$w_4RpqQ!sW!uSTPOq$wqr)vst)vtu3vuv)vvw)vwx)vxz$wz{)v{|)v|}$w}!O)v!O!P1i!P!Q)v!Q![3v![!])v!]!^$w!^!_)v!_!`)v!`!a)v!a!b)v!b!c$w!c!}3v!}#O$w#O#P%Y#P#R$w#R#S3v#S#T$w#T#o3v#o$g$w$g##l3v##l~$wR6^SYPqQOr$ws#O$w#O#P%Y#P~$wV6qSdTqQOr$ws#O$w#O#P%Y#P~$wR7UScPqQOr$ws#O$w#O#P%Y#P~$w_7mqqQ!sW!tSTPOq$wqr'gst)vtu'guv'gvw'gwx)vxz$wz{'g{|'g|}$w}!O'g!O!P9t!P!Q'g!Q!RHO!R![!\x26|![!])v!]!^$w!^!_'g!_!`'g!`!a'g!a!b'g!b!c$w!c!}'g!}#O$w#O#P%Y#P#R$w#R#S'g#S#T$w#T#o'g#o$g$w$g##l'g##l~$wZ9}pqQ!sWTPOq$wqr)vst)vtu)vuv)vvw)vwx)vxz$wz{)v{|)v|}$w}!O)v!O!P)v!P!Q)v!Q![\x3cR![!])v!]!^$w!^!_)v!_!`)v!`!a)v!a!b)v!b!c$w!c!})v!}#O$w#O#P%Y#P#R$w#R#S)v#S#T$w#T#o)v#o$g$w$g##l)v##l~$wZ\x3c^tqQ!sWaPTPOq$wqr)vst)vtu)vuv)vvw)vwx)vxz$wz{)v{|)v|}$w}!O)v!O!P)v!P!Q)v!Q![\x3cR![!])v!]!^$w!^!_)v!_!`)v!`!a)v!a!b)v!b!c$w!c!g)v!g!h\x3en!h!})v!}#O$w#O#P%Y#P#R$w#R#S)v#S#T$w#T#X)v#X#Y\x3en#Y#o)v#o$g$w$g##l)v##l~$wZ\x3ewpqQ!sWTPOq$wqr)vst)vtu)vuv)vvw)vwx)vxz$wz{)v{|@{|}$w}!O@{!O!P)v!P!Q)v!Q![CY![!])v!]!^$w!^!_)v!_!`)v!`!a)v!a!b)v!b!c$w!c!})v!}#O$w#O#P%Y#P#R$w#R#S)v#S#T$w#T#o)v#o$g$w$g##l)v##l~$wZAUpqQ!sWTPOq$wqr)vst)vtu)vuv)vvw)vwx)vxz$wz{)v{|)v|}$w}!O)v!O!P)v!P!Q)v!Q![CY![!])v!]!^$w!^!_)v!_!`)v!`!a)v!a!b)v!b!c$w!c!})v!}#O$w#O#P%Y#P#R$w#R#S)v#S#T$w#T#o)v#o$g$w$g##l)v##l~$wZCerqQ!sWaPTPOq$wqr)vst)vtu)vuv)vvw)vwx)vxz$wz{)v{|)v|}$w}!O)v!O!P)v!P!Q)v!Q![CY![!])v!]!^$w!^!_)v!_!`)v!`!a)v!a!b)v!b!c$w!c!o)v!o!pEo!p!})v!}#O$w#O#P%Y#P#R$w#R#S)v#S#T$w#T#o)v#o$g$w$g##l)v##l~$wZEzpqQ!sWaPTPOq$wqr)vst)vtu)vuv)vvw)vwx)vxz$wz{)v{|)v|}$w}!O)v!O!P)v!P!Q)v!Q![)v![!])v!]!^$w!^!_)v!_!`)v!`!a)v!a!b)v!b!c$w!c!})v!}#O$w#O#P%Y#P#R$w#R#S)v#S#T$w#T#o)v#o$g$w$g##l)v##l~$w_H]yqQ!sWaP!tSTPOq$wqr'gst)vtu'guv'gvw'gwx)vxz$wz{'g{|'g|}$w}!O'g!O!PJ|!P!Q!![!Q![!\x26|![!])v!]!^$w!^!_'g!_!`'g!`!a'g!a!b'g!b!c$w!c!g'g!g!h!)t!h!o'g!o!p!0{!p!q!0{!q!}'g!}#O$w#O#P%Y#P#R$w#R#S'g#S#T$w#T#X'g#X#Y!)t#Y#l'g#l#m!3^#m#o'g#o$g$w$g##l'g##l~$wZKXvqQ!sWaPTPOq$wqr)vst)vtu)vuv)vvw)vwx)vxz$wz{)v{|)v|}$w}!O)v!O!P)v!P!Q)v!Q![J|![!])v!]!^$w!^!_)v!_!`)v!`!a)v!a!b)v!b!c$w!c!g)v!g!h\x3en!h!o)v!o!pMo!p!})v!}#O$w#O#P%Y#P#R$w#R#S)v#S#T$w#T#X)v#X#Y\x3en#Y#o)v#o$g$w$g##l)v##l~$wZMztqQ!sWaPTPOq$wqr)vst)vtu)vuv)vvw)vwx)vxz$wz{)v{|)v|}$w}!O)v!O!P)v!P!Q)v!Q![)v![!])v!]!^$w!^!_)v!_!`)v!`!a)v!a!b)v!b!c$w!c!g)v!g!h\x3en!h!})v!}#O$w#O#P%Y#P#R$w#R#S)v#S#T$w#T#X)v#X#Y\x3en#Y#o)v#o$g$w$g##l)v##l~$w_!!gpqQ!sW!tSTPOq$wqr'gst)vtu'guv'gvw'gwx)vxz$wz{'g{|'g|}$w}!O'g!O!P)v!P!Q'g!Q![!$k![!])v!]!^$w!^!_'g!_!`'g!`!a'g!a!b'g!b!c$w!c!}'g!}#O$w#O#P%Y#P#R$w#R#S'g#S#T$w#T#o'g#o$g$w$g##l'g##l~$w_!$xpqQ!sWaP!tSTPOq$wqr'gst)vtu'guv'gvw'gwx)vxz$wz{'g{|'g|}$w}!O'g!O!P)v!P!Q'g!Q![!$k![!])v!]!^$w!^!_'g!_!`'g!`!a'g!a!b'g!b!c$w!c!}'g!}#O$w#O#P%Y#P#R$w#R#S'g#S#T$w#T#o'g#o$g$w$g##l'g##l~$w_!'ZwqQ!sWaP!tSTPOq$wqr'gst)vtu'guv'gvw'gwx)vxz$wz{'g{|'g|}$w}!O'g!O!PJ|!P!Q!![!Q![!\x26|![!])v!]!^$w!^!_'g!_!`'g!`!a'g!a!b'g!b!c$w!c!g'g!g!h!)t!h!o'g!o!p!0{!p!q!0{!q!}'g!}#O$w#O#P%Y#P#R$w#R#S'g#S#T$w#T#X'g#X#Y!)t#Y#o'g#o$g$w$g##l'g##l~$w_!*PpqQ!sW!tSTPOq$wqr'gst)vtu'guv'gvw'gwx)vxz$wz{'g{|!,T|}$w}!O!,T!O!P)v!P!Q'g!Q![!.d![!])v!]!^$w!^!_'g!_!`'g!`!a'g!a!b'g!b!c$w!c!}'g!}#O$w#O#P%Y#P#R$w#R#S'g#S#T$w#T#o'g#o$g$w$g##l'g##l~$w_!,`pqQ!sW!tSTPOq$wqr'gst)vtu'guv'gvw'gwx)vxz$wz{'g{|'g|}$w}!O'g!O!P)v!P!Q'g!Q![!.d![!])v!]!^$w!^!_'g!_!`'g!`!a'g!a!b'g!b!c$w!c!}'g!}#O$w#O#P%Y#P#R$w#R#S'g#S#T$w#T#o'g#o$g$w$g##l'g##l~$w_!.qrqQ!sWaP!tSTPOq$wqr'gst)vtu'guv'gvw'gwx)vxz$wz{'g{|'g|}$w}!O'g!O!P)v!P!Q'g!Q![!.d![!])v!]!^$w!^!_'g!_!`'g!`!a'g!a!b'g!b!c$w!c!o'g!o!p!0{!p!}'g!}#O$w#O#P%Y#P#R$w#R#S'g#S#T$w#T#o'g#o$g$w$g##l'g##l~$w_!1YpqQ!sWaP!tSTPOq$wqr'gst)vtu'guv'gvw'gwx)vxz$wz{'g{|'g|}$w}!O'g!O!P)v!P!Q'g!Q!['g![!])v!]!^$w!^!_'g!_!`'g!`!a'g!a!b'g!b!c$w!c!}'g!}#O$w#O#P%Y#P#R$w#R#S'g#S#T$w#T#o'g#o$g$w$g##l'g##l~$w_!3irqQ!sW!tSTPOq$wqr'gst)vtu'guv'gvw'gwx)vxz$wz{'g{|'g|}$w}!O'g!O!P)v!P!Q'g!Q![!5s![!])v!]!^$w!^!_'g!_!`'g!`!a'g!a!b'g!b!c$w!c!i!5s!i!}'g!}#O$w#O#P%Y#P#R$w#R#S'g#S#T$w#T#Z!5s#Z#o'g#o$g$w$g##l'g##l~$w_!6QrqQ!sWaP!tSTPOq$wqr'gst)vtu'guv'gvw'gwx)vxz$wz{'g{|'g|}$w}!O'g!O!P)v!P!Q'g!Q![!5s![!])v!]!^$w!^!_'g!_!`'g!`!a'g!a!b'g!b!c$w!c!i!5s!i!}'g!}#O$w#O#P%Y#P#R$w#R#S'g#S#T$w#T#Z!5s#Z#o'g#o$g$w$g##l'g##l~$wR!8ceqQaPOr$ws!O$w!O!P!9t!P!Q!\x3dr!Q![!\x3et![!g$w!g!h!:q!h!o$w!o!p!\x3cn!p!q!\x3cn!q#O$w#O#P%Y#P#U$w#U#V!?z#V#X$w#X#Y!:q#Y#c$w#c#d!AS#d#l$w#l#m!BU#m~$wR!9{[qQaPOr$ws!Q$w!Q![!9t![!g$w!g!h!:q!h!o$w!o!p!\x3dR!p#O$w#O#P%Y#P#X$w#X#Y!:q#Y~$wR!:vYqQOr$ws{$w{|!;f|}$w}!O!;f!O!Q$w!Q![!;}![#O$w#O#P%Y#P~$wR!;kUqQOr$ws!Q$w!Q![!;}![#O$w#O#P%Y#P~$wR!\x3cUWqQaPOr$ws!Q$w!Q![!;}![!o$w!o!p!\x3cn!p#O$w#O#P%Y#P~$wR!\x3cuSqQaPOr$ws#O$w#O#P%Y#P~$wR!\x3dYWqQaPOr$ws!g$w!g!h!:q!h#O$w#O#P%Y#P#X$w#X#Y!:q#Y~$wR!\x3dwUqQOr$ws!Q$w!Q![!\x3eZ![#O$w#O#P%Y#P~$wR!\x3ebUqQaPOr$ws!Q$w!Q![!\x3eZ![#O$w#O#P%Y#P~$wR!\x3e{_qQaPOr$ws!O$w!O!P!9t!P!Q!\x3dr!Q![!\x3et![!g$w!g!h!:q!h!o$w!o!p!\x3cn!p!q!\x3cn!q#O$w#O#P%Y#P#X$w#X#Y!:q#Y~$wR!@PVqQOr$ws!Q$w!Q!R!@f!R!S!@f!S#O$w#O#P%Y#P~$wR!@mVqQaPOr$ws!Q$w!Q!R!@f!R!S!@f!S#O$w#O#P%Y#P~$wR!AXUqQOr$ws!Q$w!Q!Y!Ak!Y#O$w#O#P%Y#P~$wR!ArUqQaPOr$ws!Q$w!Q!Y!Ak!Y#O$w#O#P%Y#P~$wR!BZYqQOr$ws!Q$w!Q![!By![!c$w!c!i!By!i#O$w#O#P%Y#P#T$w#T#Z!By#Z~$wR!CQYqQaPOr$ws!Q$w!Q![!By![!c$w!c!i!By!i#O$w#O#P%Y#P#T$w#T#Z!By#Z~$wV!CyobPqQ!rSOq$wqr!Ezst$wtu!Ezuv!Ezvw!Ezwz$wz{!Ez{|!Ez|}$w}!O!Ez!O!P!Ez!P!Q!Ez!Q![$w![!]!HX!]!^$w!^!_!Ez!_!`!Ez!`!a!Ez!a!b!Ez!b!c$w!c!}!Ez!}#O$w#O#P%Y#P#R$w#R#S!Ez#S#T$w#T#o!Ez#o$g$w$g##l!Ez##l~$wV!FTpbPqQ!rSOq$wqr!Ezst!Eztu!Ezuv!Ezvw!Ezwx!Ezxz$wz{!Ez{|!Ez|}$w}!O!Ez!O!P!Ez!P!Q!Ez!Q![!Ez![!]!Ez!]!^$w!^!_!Ez!_!`!Ez!`!a!Ez!a!b!Ez!b!c$w!c!}!Ez!}#O$w#O#P%Y#P#R$w#R#S!Ez#S#T$w#T#o!Ez#o$g$w$g##l!Ez##l~$wV!HbmbPqQ!rSOq$wqr!Ezst$wtu!Ezuv!Ezvw!Ezwz$wz{!Ez{|!Ez|}$w}!O!Ez!O!P!Ez!P!Q!Ez!Q!^$w!^!_!Ez!_!`!Ez!`!a!Ez!a!b!Ez!b!c$w!c!}!Ez!}#O$w#O#P%Y#P#R$w#R#S!Ez#S#T$w#T#o!Ez#o$g$w$g##l!Ez##l~$wR!JdVPPqQOY!J]YZ$wZr!J]rs!Jys#O!J]#O#P!KU#P~!J]P!KOQPPOY!JyZ~!JyR!K]VPPqQOY!J]YZ$wZr!J]rs!J]s#O!J]#O#P!KU#P~!J]R!KySWPqQOr$ws#O$w#O#P%Y#P~$wR!L^SwPqQOr$ws#O$w#O#P%Y#P~$wR!LocqQOY!MzYZ$wZr!Mzrs!Mzs#O!Mz#O#P!N_#P#U!Mz#U#V!Nu#V#Y!Mz#Y#Z#$w#Z#b!Mz#b#c#(b#c#d#*{#d#f!Mz#f#g#,m#g#h#/W#h#i#/q#i#j#0s#j~!MzR!NRS|PqQOr$ws#O$w#O#P%Y#P~$wR!NfT|PqQOr$wrs$ws#O$w#O#P%Y#P~$wR!N|U|PqQOr$ws#O$w#O#P%Y#P#T$w#T#U# `#U~$wR# eUqQOr$ws#O$w#O#P%Y#P#V$w#V#W# w#W~$wR# |UqQOr$ws#O$w#O#P%Y#P#_$w#_#`#!`#`~$wR#!eUqQOr$ws#O$w#O#P%Y#P#g$w#g#h#!w#h~$wR#!|UqQOr$ws#O$w#O#P%Y#P#d$w#d#e##`#e~$wR##eUqQOr$ws#O$w#O#P%Y#P#T$w#T#U##w#U~$wR##|UqQOr$ws#O$w#O#P%Y#P#V$w#V#W#$`#W~$wR#$eUqQOr$ws#O$w#O#P%Y#P#X$w#X#Y!Mz#Y~$wR#%OU|PqQOr$ws#O$w#O#P%Y#P#c$w#c#d#%b#d~$wR#%gUqQOr$ws#O$w#O#P%Y#P#f$w#f#g#%y#g~$wR#\x26OUqQOr$ws#O$w#O#P%Y#P#a$w#a#b#\x26b#b~$wR#\x26gUqQOr$ws#O$w#O#P%Y#P#Y$w#Y#Z#\x26y#Z~$wR#'OUqQOr$ws#O$w#O#P%Y#P#X$w#X#Y#'b#Y~$wR#'gUqQOr$ws#O$w#O#P%Y#P#X$w#X#Y#'y#Y~$wR#(OUqQOr$ws#O$w#O#P%Y#P#W$w#W#X!Mz#X~$wR#(iU|PqQOr$ws#O$w#O#P%Y#P#X$w#X#Y#({#Y~$wR#)QUqQOr$ws#O$w#O#P%Y#P#k$w#k#l#)d#l~$wR#)iUqQOr$ws#O$w#O#P%Y#P#`$w#`#a#){#a~$wR#*QUqQOr$ws#O$w#O#P%Y#P#]$w#]#^#*d#^~$wR#*iUqQOr$ws#O$w#O#P%Y#P#b$w#b#c#$`#c~$wR#+SV|PqQOr$ws!Q$w!Q!U#+i!U!Y#,S!Y#O$w#O#P%Y#P~$wR#+pU|PqQOr$ws!Q$w!Q!Y#,S!Y#O$w#O#P%Y#P~$wR#,ZU|PqQOr$ws!Q$w!Q!Y!Mz!Y#O$w#O#P%Y#P~$wR#,tU|PqQOr$ws#O$w#O#P%Y#P#X$w#X#Y#-W#Y~$wR#-]UqQOr$ws#O$w#O#P%Y#P#h$w#h#i#-o#i~$wR#-tUqQOr$ws#O$w#O#P%Y#P#i$w#i#j#.W#j~$wR#.]UqQOr$ws#O$w#O#P%Y#P#f$w#f#g#.o#g~$wR#.tUqQOr$ws#O$w#O#P%Y#P#b$w#b#c!Mz#c~$wR#/_U|PqQOr$ws#O$w#O#P%Y#P#d$w#d#e##`#e~$wR#/xU|PqQOr$ws#O$w#O#P%Y#P#T$w#T#U#0[#U~$wR#0aUqQOr$ws#O$w#O#P%Y#P#U$w#U#V!Mz#V~$wR#0zY|PqQOr$ws!Q$w!Q![#1j![!c$w!c!i#1j!i#O$w#O#P%Y#P#T$w#T#Z#1j#Z~$wR#1oYqQOr$ws!Q$w!Q![#2_![!c$w!c!i#2_!i#O$w#O#P%Y#P#T$w#T#Z#2_#Z~$wR#2dYqQOr$ws!Q$w!Q![#3S![!c$w!c!i#3S!i#O$w#O#P%Y#P#T$w#T#Z#3S#Z~$wR#3XYqQOr$ws!Q$w!Q![!Mz![!c$w!c!i!Mz!i#O$w#O#P%Y#P#T$w#T#Z!Mz#Z~$wR#4OSvPqQOr$ws#O$w#O#P%Y#P~$wR#4cSiPqQOr$ws#O$w#O#P%Y#P~$wR#4vS[PqQOr$ws#O$w#O#P%Y#P~$wV#5ZSzTqQOr$ws#O$w#O#P%Y#P~$wR#5nSyPqQOr$ws#O$w#O#P%Y#P~$wR#6RU^PqQOr$ws!b$w!b!c#6e!c#O$w#O#P%Y#P~$wR#6lS`PqQOr$ws#O$w#O#P%Y#P~$w", 
tokenizers:[0, 1, 2, 3], topRules:{Program:[0, 62]}, dynamicPrecedences:{22:1, 34:2}, specialized:[{term:5, get:t => mee[t] || -1}], tokenPrec:466}), {coll:yee} = gee, xee = Ap.define({parser:bee.configure({props:[dO({NS:Re.keyword, DefLike:Re.keyword, "Operator/Symbol":Re.keyword, "VarName/Symbol":Re.definition(Re.variableName), Boolean:Re.atom, "DocString/...":Re.emphasis, "Discard!":Re.comment, Number:Re.number, StringContent:Re.string, '"\\""':Re.string, Keyword:Re.atom, Nil:Re.null, LineComment:Re.lineComment, 
RegExp:Re.regexp}), gO.add(t => e => {
  let {pos:n, unit:r, node:i, state:s, baseIndent:o, textAfter:a} = e;
  if (t.prop(yee)) {
    let l = e.column(i.firstChild.to);
    return t.name == "List" && ["NS", "DefLike", "Operator"].includes(i.firstChild.nextSibling.type.name) ? l + 1 : l;
  } else {
    return 0;
  }
}), bO.add({"Vector Map List":mJ})]}), languageData:{commentTokens:{line:";;"}}});
function vee() {
  return new iJ(xee);
}
const Ed = {brackets:["(", "[", "{", "'", '"'], before:")]}:;\x3e", stringPrefixes:[]}, Ba = zt.define({map(t, e) {
  let n = e.mapPos(t, -1, zr.TrackAfter);
  return n ?? void 0;
}}), O1 = new class extends Jo {
}();
O1.startSide = 1;
O1.endSide = -1;
const h3 = ii.define({create() {
  return $t.empty;
}, update(t, e) {
  if (t = t.map(e.changes), e.selection) {
    let n = e.state.doc.lineAt(e.selection.main.head);
    t = t.update({filter:r => r >= n.from && r <= n.to});
  }
  for (let n of e.effects) {
    n.is(Ba) && (t = t.update({add:[O1.range(n.value, n.value + 1)]}));
  }
  return t;
}});
function wee() {
  return [See, h3];
}
const v0 = "()[]{}\x3c\x3e\u00ab\u00bb\u00bb\u00ab\uff3b\uff3d\uff5b\uff5d";
function f3(t) {
  for (let e = 0; e < v0.length; e += 2) {
    if (v0.charCodeAt(e) == t) {
      return v0.charAt(e + 1);
    }
  }
  return $N(t < 128 ? t : t + 1);
}
function p3(t, e) {
  return t.languageDataAt("closeBrackets", e)[0] || Ed;
}
const _ee = typeof navigator == "object" && /Android\b/.test(navigator.userAgent), See = nt.inputHandler.of((t, e, n, r) => {
  if ((_ee ? t.composing : t.compositionStarted) || t.state.readOnly) {
    return !1;
  }
  let i = t.state.selection.main;
  if (r.length > 2 || r.length == 2 && Kd(aa(r, 0)) == 1 || e != i.from || n != i.to) {
    return !1;
  }
  let s = Tee(t.state, r);
  return s ? (t.dispatch(s), !0) : !1;
}), kee = ({state:t, dispatch:e}) => {
  if (t.readOnly) {
    return !1;
  }
  let r = p3(t, t.selection.main.head).brackets || Ed.brackets, i = null, s = t.changeByRange(o => {
    if (o.empty) {
      let a = Cee(t.doc, o.head);
      for (let l of r) {
        if (l == a && qg(t.doc, o.head) == f3(aa(l, 0))) {
          return {changes:{from:o.head - l.length, to:o.head + l.length}, range:Ce.cursor(o.head - l.length)};
        }
      }
    }
    return {range:i = o};
  });
  return i || e(t.update(s, {scrollIntoView:!0, userEvent:"delete.backward"})), !i;
}, Eee = [{key:"Backspace", run:kee}];
function Tee(t, e) {
  let n = p3(t, t.selection.main.head), r = n.brackets || Ed.brackets;
  for (let i of r) {
    let s = f3(aa(i, 0));
    if (e == i) {
      return s == i ? Iee(t, i, r.indexOf(i + i + i) > -1, n) : Aee(t, i, s, n.before || Ed.before);
    }
    if (e == s && g3(t, t.selection.main.from)) {
      return Nee(t, i, s);
    }
  }
  return null;
}
function g3(t, e) {
  let n = !1;
  return t.field(h3).between(0, t.doc.length, r => {
    r == e && (n = !0);
  }), n;
}
function qg(t, e) {
  let n = t.sliceString(e, e + 2);
  return n.slice(0, Kd(aa(n, 0)));
}
function Cee(t, e) {
  let n = t.sliceString(e - 2, e);
  return Kd(aa(n, 0)) == n.length ? n : n.slice(1);
}
function Aee(t, e, n, r) {
  let i = null, s = t.changeByRange(o => {
    if (!o.empty) {
      return {changes:[{insert:e, from:o.from}, {insert:n, from:o.to}], effects:Ba.of(o.to + e.length), range:Ce.range(o.anchor + e.length, o.head + e.length)};
    }
    let a = qg(t.doc, o.head);
    return !a || /\s/.test(a) || r.indexOf(a) > -1 ? {changes:{insert:e + n, from:o.head}, effects:Ba.of(o.head + e.length), range:Ce.cursor(o.head + e.length)} : {range:i = o};
  });
  return i ? null : t.update(s, {scrollIntoView:!0, userEvent:"input.type"});
}
function Nee(t, e, n) {
  let r = null, i = t.changeByRange(s => s.empty && qg(t.doc, s.head) == n ? {changes:{from:s.head, to:s.head + n.length, insert:n}, range:Ce.cursor(s.head + n.length)} : r = {range:s});
  return r ? null : t.update(i, {scrollIntoView:!0, userEvent:"input.type"});
}
function Iee(t, e, n, r) {
  let i = r.stringPrefixes || Ed.stringPrefixes, s = null, o = t.changeByRange(a => {
    if (!a.empty) {
      return {changes:[{insert:e, from:a.from}, {insert:e, from:a.to}], effects:Ba.of(a.to + e.length), range:Ce.range(a.anchor + e.length, a.head + e.length)};
    }
    let l = a.head, c = qg(t.doc, l), u;
    if (c == e) {
      if (t2(t, l)) {
        return {changes:{insert:e + e, from:l}, effects:Ba.of(l + e.length), range:Ce.cursor(l + e.length)};
      }
      if (g3(t, l)) {
        let f = n && t.sliceDoc(l, l + e.length * 3) == e + e + e ? e + e + e : e;
        return {changes:{from:l, to:l + f.length, insert:f}, range:Ce.cursor(l + f.length)};
      }
    } else {
      if (n && t.sliceDoc(l - 2 * e.length, l) == e + e && (u = n2(t, l - 2 * e.length, i)) > -1 && t2(t, u)) {
        return {changes:{insert:e + e + e + e, from:l}, effects:Ba.of(l + e.length), range:Ce.cursor(l + e.length)};
      }
      if (t.charCategorizer(l)(c) != An.Word && n2(t, l, i) > -1 && !Oee(t, l, e, i)) {
        return {changes:{insert:e + e, from:l}, effects:Ba.of(l + e.length), range:Ce.cursor(l + e.length)};
      }
    }
    return {range:s = a};
  });
  return s ? null : t.update(o, {scrollIntoView:!0, userEvent:"input.type"});
}
function t2(t, e) {
  let n = Ur(t).resolveInner(e + 1);
  return n.parent && n.from == e;
}
function Oee(t, e, n, r) {
  let i = Ur(t).resolveInner(e, -1), s = r.reduce((o, a) => Math.max(o, a.length), 0);
  for (let o = 0; o < 5; o++) {
    let a = t.sliceDoc(i.from, Math.min(i.to, i.from + n.length + s)), l = a.indexOf(n);
    if (!l || l > -1 && r.indexOf(a.slice(0, l)) > -1) {
      let u = i.firstChild;
      for (; u && u.from == i.from && u.to - u.from > n.length + l;) {
        if (t.sliceDoc(u.to - n.length, u.to) == n) {
          return !1;
        }
        u = u.firstChild;
      }
      return !0;
    }
    let c = i.to == e && i.parent;
    if (!c) {
      break;
    }
    i = c;
  }
  return !1;
}
function n2(t, e, n) {
  let r = t.charCategorizer(e);
  if (r(t.sliceDoc(e - 1, e)) != An.Word) {
    return e;
  }
  for (let i of n) {
    let s = e - i.length;
    if (t.sliceDoc(s, e) == i && r(t.sliceDoc(s - 1, s)) != An.Word) {
      return s;
    }
  }
  return -1;
}
class r2 {
  constructor(e, n, r) {
    this.from = e, this.to = n, this.diagnostic = r;
  }
}
class Na {
  constructor(e, n, r) {
    this.diagnostics = e, this.panel = n, this.selected = r;
  }
  static init(e, n, r) {
    let i = r.facet(Is).markerFilter;
    i && (e = i(e, r));
    let s = e.slice().sort((p, g) => p.from - g.from || p.to - g.to), o = new uo(), a = [], l = 0, c = r.doc.iter(), u = 0, h = r.doc.length;
    for (let p = 0;;) {
      let g = p == s.length ? null : s[p];
      if (!g && !a.length) {
        break;
      }
      let m, b;
      if (a.length) {
        m = l, b = a.reduce((v, T) => Math.min(v, T.to), g && g.from > m ? g.from : 1e8);
      } else {
        if (m = g.from, m > h) {
          break;
        }
        b = g.to, a.push(g), p++;
      }
      for (; p < s.length;) {
        let v = s[p];
        if (v.from == m && (v.to > v.from || v.to == m)) {
          a.push(v), p++, b = Math.min(v.to, b);
        } else {
          b = Math.min(v.from, b);
          break;
        }
      }
      b = Math.min(b, h);
      let x = !1;
      if (a.some(v => v.from == m && (v.to == b || b == h)) && (x = m == b, !x && b - m < 10)) {
        let v = m - (u + c.value.length);
        v > 0 && (c.next(v), u = m);
        for (let T = m;;) {
          if (T >= b) {
            x = !0;
            break;
          }
          if (!c.lineBreak && u + c.value.length > T) {
            break;
          }
          T = u + c.value.length, u += c.value.length, c.next();
        }
      }
      let w = jee(a);
      if (x) {
        o.add(m, m, pt.widget({widget:new zee(w), diagnostics:a.slice()}));
      } else {
        let v = a.reduce((T, I) => I.markClass ? T + " " + I.markClass : T, "");
        o.add(m, b, pt.mark({class:"cm-lintRange cm-lintRange-" + w + v, diagnostics:a.slice(), inclusiveEnd:a.some(T => T.to > b)}));
      }
      if (l = b, l == h) {
        break;
      }
      for (let v = 0; v < a.length; v++) {
        a[v].to <= l && a.splice(v--, 1);
      }
    }
    let f = o.finish();
    return new Na(f, n, pc(f));
  }
}
function pc(t, e = null, n = 0) {
  let r = null;
  return t.between(n, 1e9, (i, s, {spec:o}) => {
    if (!(e && o.diagnostics.indexOf(e) < 0)) {
      if (!r) {
        r = new r2(i, s, e || o.diagnostics[0]);
      } else {
        if (o.diagnostics.indexOf(r.diagnostic) < 0) {
          return !1;
        }
        r = new r2(r.from, s, r.diagnostic);
      }
    }
  }), r;
}
function Pee(t, e) {
  let n = e.pos, r = e.end || n, i = t.state.facet(Is).hideOn(t, n, r);
  if (i != null) {
    return i;
  }
  let s = t.startState.doc.lineAt(e.pos);
  return !!(t.effects.some(o => o.is(P1)) || t.changes.touchesRange(s.from, Math.max(s.to, r)));
}
function Ree(t, e) {
  return t.field(Zi, !1) ? e : e.concat(zt.appendConfig.of(w3));
}
function Dee(t, e) {
  return {effects:Ree(t, [P1.of(e)])};
}
const P1 = zt.define(), m3 = zt.define(), b3 = zt.define(), Zi = ii.define({create() {
  return new Na(pt.none, null, null);
}, update(t, e) {
  if (e.docChanged && t.diagnostics.size) {
    let n = t.diagnostics.map(e.changes), r = null, i = t.panel;
    if (t.selected) {
      let s = e.changes.mapPos(t.selected.from, 1);
      r = pc(n, t.selected.diagnostic, s) || pc(n, null, s);
    }
    !n.size && i && e.state.facet(Is).autoPanel && (i = null), t = new Na(n, i, r);
  }
  for (let n of e.effects) {
    if (n.is(P1)) {
      let r = e.state.facet(Is).autoPanel ? n.value.length ? Bp.open : null : t.panel;
      t = Na.init(n.value, r, e.state);
    } else {
      n.is(m3) ? t = new Na(t.diagnostics, n.value ? Bp.open : null, t.selected) : n.is(b3) && (t = new Na(t.diagnostics, t.panel, n.value));
    }
  }
  return t;
}, provide:t => [wd.from(t, e => e.panel), nt.decorations.from(t, e => e.diagnostics)]}), Lee = pt.mark({class:"cm-lintRange cm-lintRange-active"});
function Mee(t, e, n) {
  let {diagnostics:r} = t.state.field(Zi), i, s = -1, o = -1;
  r.between(e - (n < 0 ? 1 : 0), e + (n > 0 ? 1 : 0), (l, c, {spec:u}) => {
    if (e >= l && e <= c && (l == c || (e > l || n > 0) && (e < c || n < 0))) {
      return i = u.diagnostics, s = l, o = c, !1;
    }
  });
  let a = t.state.facet(Is).tooltipFilter;
  return i && a && (i = a(i, t.state)), i ? {pos:s, end:o, above:t.state.doc.lineAt(s).to < o, create() {
    return {dom:Bee(t, i)};
  }} : null;
}
function Bee(t, e) {
  return ln("ul", {class:"cm-tooltip-lint"}, e.map(n => v3(t, n, !1)));
}
const i2 = t => {
  let e = t.state.field(Zi, !1);
  return !e || !e.panel ? !1 : (t.dispatch({effects:m3.of(!1)}), !0);
}, $ee = Kn.fromClass(class {
  constructor(t) {
    this.view = t, this.timeout = -1, this.set = !0;
    let {delay:e} = t.state.facet(Is);
    this.lintTime = Date.now() + e, this.run = this.run.bind(this), this.timeout = setTimeout(this.run, e);
  }
  run() {
    clearTimeout(this.timeout);
    let t = Date.now();
    if (t < this.lintTime - 10) {
      this.timeout = setTimeout(this.run, this.lintTime - t);
    } else {
      this.set = !1;
      let {state:e} = this.view, {sources:n} = e.facet(Is);
      n.length && Fee(n.map(r => Promise.resolve(r(this.view))), r => {
        this.view.state.doc == e.doc && this.view.dispatch(Dee(this.view.state, r.reduce((i, s) => i.concat(s))));
      }, r => {
        Pi(this.view.state, r);
      });
    }
  }
  update(t) {
    let e = t.state.facet(Is);
    (t.docChanged || e != t.startState.facet(Is) || e.needsRefresh && e.needsRefresh(t)) && (this.lintTime = Date.now() + e.delay, this.set || (this.set = !0, this.timeout = setTimeout(this.run, e.delay)));
  }
  force() {
    this.set && (this.lintTime = Date.now(), this.run());
  }
  destroy() {
    clearTimeout(this.timeout);
  }
});
function Fee(t, e, n) {
  let r = [], i = -1;
  for (let s of t) {
    s.then(o => {
      r.push(o), clearTimeout(i), r.length == t.length ? e(r) : i = setTimeout(() => e(r), 200);
    }, n);
  }
}
const Is = et.define({combine(t) {
  return {sources:t.map(e => e.source).filter(e => e != null), ...mo(t.map(e => e.config), {delay:750, markerFilter:null, tooltipFilter:null, needsRefresh:null, hideOn:() => null}, {delay:Math.max, markerFilter:s2, tooltipFilter:s2, needsRefresh:(e, n) => e ? n ? r => e(r) || n(r) : e : n, hideOn:(e, n) => e ? n ? (r, i, s) => e(r, i, s) || n(r, i, s) : e : n, autoPanel:(e, n) => e || n})};
}});
function s2(t, e) {
  return t ? e ? (n, r) => e(t(n, r), r) : t : e;
}
function y3(t, e = {}) {
  return [Is.of({source:t, config:e}), $ee, w3];
}
function x3(t) {
  let e = [];
  if (t) {
    e: for (let {name:n} of t) {
      for (let r = 0; r < n.length; r++) {
        let i = n[r];
        if (/[a-zA-Z]/.test(i) && !e.some(s => s.toLowerCase() == i.toLowerCase())) {
          e.push(i);
          continue e;
        }
      }
      e.push("");
    }
  }
  return e;
}
function v3(t, e, n) {
  var r;
  let i = n ? x3(e.actions) : [];
  return ln("li", {class:"cm-diagnostic cm-diagnostic-" + e.severity}, ln("span", {class:"cm-diagnosticText"}, e.renderMessage ? e.renderMessage(t) : e.message), (r = e.actions) === null || r === void 0 ? void 0 : r.map((s, o) => {
    let a = !1, l = p => {
      if (p.preventDefault(), a) {
        return;
      }
      a = !0;
      let g = pc(t.state.field(Zi).diagnostics, e);
      g && s.apply(t, g.from, g.to);
    }, {name:c} = s, u = i[o] ? c.indexOf(i[o]) : -1, h = u < 0 ? c : [c.slice(0, u), ln("u", c.slice(u, u + 1)), c.slice(u + 1)], f = s.markClass ? " " + s.markClass : "";
    return ln("button", {type:"button", class:"cm-diagnosticAction" + f, onclick:l, onmousedown:l, "aria-label":` Action: ${c}${u < 0 ? "" : ` (access key "${i[o]})"`}.`}, h);
  }), e.source && ln("div", {class:"cm-diagnosticSource"}, e.source));
}
class zee extends Fs {
  constructor(e) {
    super(), this.sev = e;
  }
  eq(e) {
    return e.sev == this.sev;
  }
  toDOM() {
    return ln("span", {class:"cm-lintPoint cm-lintPoint-" + this.sev});
  }
}
class o2 {
  constructor(e, n) {
    this.diagnostic = n, this.id = "item_" + Math.floor(Math.random() * 4294967295).toString(16), this.dom = v3(e, n, !0), this.dom.id = this.id, this.dom.setAttribute("role", "option");
  }
}
class Bp {
  constructor(e) {
    this.view = e, this.items = [];
    let n = i => {
      if (!(i.ctrlKey || i.altKey || i.metaKey)) {
        if (i.keyCode == 27) {
          i2(this.view), this.view.focus();
        } else if (i.keyCode == 38 || i.keyCode == 33) {
          this.moveSelection((this.selectedIndex - 1 + this.items.length) % this.items.length);
        } else if (i.keyCode == 40 || i.keyCode == 34) {
          this.moveSelection((this.selectedIndex + 1) % this.items.length);
        } else if (i.keyCode == 36) {
          this.moveSelection(0);
        } else if (i.keyCode == 35) {
          this.moveSelection(this.items.length - 1);
        } else if (i.keyCode == 13) {
          this.view.focus();
        } else if (i.keyCode >= 65 && i.keyCode <= 90 && this.selectedIndex >= 0) {
          let {diagnostic:s} = this.items[this.selectedIndex], o = x3(s.actions);
          for (let a = 0; a < o.length; a++) {
            if (o[a].toUpperCase().charCodeAt(0) == i.keyCode) {
              let l = pc(this.view.state.field(Zi).diagnostics, s);
              l && s.actions[a].apply(e, l.from, l.to);
            }
          }
        } else {
          return;
        }
        i.preventDefault();
      }
    }, r = i => {
      for (let s = 0; s < this.items.length; s++) {
        this.items[s].dom.contains(i.target) && this.moveSelection(s);
      }
    };
    this.list = ln("ul", {tabIndex:0, role:"listbox", "aria-label":this.view.state.phrase("Diagnostics"), onkeydown:n, onclick:r}), this.dom = ln("div", {class:"cm-panel-lint"}, this.list, ln("button", {type:"button", name:"close", "aria-label":this.view.state.phrase("close"), onclick:() => i2(this.view)}, "\u00d7")), this.update();
  }
  get selectedIndex() {
    let e = this.view.state.field(Zi).selected;
    if (!e) {
      return -1;
    }
    for (let n = 0; n < this.items.length; n++) {
      if (this.items[n].diagnostic == e.diagnostic) {
        return n;
      }
    }
    return -1;
  }
  update() {
    let {diagnostics:e, selected:n} = this.view.state.field(Zi), r = 0, i = !1, s = null, o = new Set();
    for (e.between(0, this.view.state.doc.length, (a, l, {spec:c}) => {
      for (let u of c.diagnostics) {
        if (o.has(u)) {
          continue;
        }
        o.add(u);
        let h = -1, f;
        for (let p = r; p < this.items.length; p++) {
          if (this.items[p].diagnostic == u) {
            h = p;
            break;
          }
        }
        h < 0 ? (f = new o2(this.view, u), this.items.splice(r, 0, f), i = !0) : (f = this.items[h], h > r && (this.items.splice(r, h - r), i = !0)), n && f.diagnostic == n.diagnostic ? f.dom.hasAttribute("aria-selected") || (f.dom.setAttribute("aria-selected", "true"), s = f) : f.dom.hasAttribute("aria-selected") && f.dom.removeAttribute("aria-selected"), r++;
      }
    }); r < this.items.length && !(this.items.length == 1 && this.items[0].diagnostic.from < 0);) {
      i = !0, this.items.pop();
    }
    this.items.length == 0 && (this.items.push(new o2(this.view, {from:-1, to:-1, severity:"info", message:this.view.state.phrase("No diagnostics")})), i = !0), s ? (this.list.setAttribute("aria-activedescendant", s.id), this.view.requestMeasure({key:this, read:() => ({sel:s.dom.getBoundingClientRect(), panel:this.list.getBoundingClientRect()}), write:({sel:a, panel:l}) => {
      let c = l.height / this.list.offsetHeight;
      a.top < l.top ? this.list.scrollTop -= (l.top - a.top) / c : a.bottom > l.bottom && (this.list.scrollTop += (a.bottom - l.bottom) / c);
    }})) : this.selectedIndex < 0 && this.list.removeAttribute("aria-activedescendant"), i && this.sync();
  }
  sync() {
    let e = this.list.firstChild;
    function n() {
      let r = e;
      e = r.nextSibling, r.remove();
    }
    for (let r of this.items) {
      if (r.dom.parentNode == this.list) {
        for (; e != r.dom;) {
          n();
        }
        e = r.dom.nextSibling;
      } else {
        this.list.insertBefore(r.dom, e);
      }
    }
    for (; e;) {
      n();
    }
  }
  moveSelection(e) {
    if (this.selectedIndex < 0) {
      return;
    }
    let n = this.view.state.field(Zi), r = pc(n.diagnostics, this.items[e].diagnostic);
    r && this.view.dispatch({selection:{anchor:r.from, head:r.to}, scrollIntoView:!0, effects:b3.of(r)});
  }
  static open(e) {
    return new Bp(e);
  }
}
function Hee(t, e = 'viewBox\x3d"0 0 40 40"') {
  return `url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" ${e}>${encodeURIComponent(t)}</svg>')`;
}
function nf(t) {
  return Hee(`<path d="m0 2.5 l2 -1.5 l1 0 l2 1.5 l1 0" stroke="${t}" fill="none" stroke-width=".7"/>`, 'width\x3d"6" height\x3d"3"');
}
const Uee = nt.baseTheme({".cm-diagnostic":{padding:"3px 6px 3px 8px", marginLeft:"-1px", display:"block", whiteSpace:"pre-wrap"}, ".cm-diagnostic-error":{borderLeft:"5px solid #d11"}, ".cm-diagnostic-warning":{borderLeft:"5px solid orange"}, ".cm-diagnostic-info":{borderLeft:"5px solid #999"}, ".cm-diagnostic-hint":{borderLeft:"5px solid #66d"}, ".cm-diagnosticAction":{font:"inherit", border:"none", padding:"2px 4px", backgroundColor:"#444", color:"white", borderRadius:"3px", marginLeft:"8px", cursor:"pointer"}, 
".cm-diagnosticSource":{fontSize:"70%", opacity:0.7}, ".cm-lintRange":{backgroundPosition:"left bottom", backgroundRepeat:"repeat-x", paddingBottom:"0.7px"}, ".cm-lintRange-error":{backgroundImage:nf("#f11")}, ".cm-lintRange-warning":{backgroundImage:nf("orange")}, ".cm-lintRange-info":{backgroundImage:nf("#999")}, ".cm-lintRange-hint":{backgroundImage:nf("#66d")}, ".cm-lintRange-active":{backgroundColor:"#ffdd9980"}, ".cm-tooltip-lint":{padding:0, margin:0}, ".cm-lintPoint":{position:"relative", 
"\x26:after":{content:'""', position:"absolute", bottom:0, left:"-2px", borderLeft:"3px solid transparent", borderRight:"3px solid transparent", borderBottom:"4px solid #d11"}}, ".cm-lintPoint-warning":{"\x26:after":{borderBottomColor:"orange"}}, ".cm-lintPoint-info":{"\x26:after":{borderBottomColor:"#999"}}, ".cm-lintPoint-hint":{"\x26:after":{borderBottomColor:"#66d"}}, ".cm-panel.cm-panel-lint":{position:"relative", "\x26 ul":{maxHeight:"100px", overflowY:"auto", "\x26 [aria-selected]":{backgroundColor:"#ddd", 
"\x26 u":{textDecoration:"underline"}}, "\x26:focus [aria-selected]":{background_fallback:"#bdf", backgroundColor:"Highlight", color_fallback:"white", color:"HighlightText"}, "\x26 u":{textDecoration:"none"}, padding:0, margin:0}, "\x26 [name\x3dclose]":{position:"absolute", top:"0", right:"2px", background:"inherit", border:"none", font:"inherit", padding:0, margin:0}}, "\x26dark .cm-lintRange-active":{backgroundColor:"#86714a80"}, "\x26dark .cm-panel.cm-panel-lint ul":{"\x26 [aria-selected]":{backgroundColor:"#2e343e"}}});
function Wee(t) {
  return t == "error" ? 4 : t == "warning" ? 3 : t == "info" ? 2 : 1;
}
function jee(t) {
  let e = "hint", n = 1;
  for (let r of t) {
    let i = Wee(r.severity);
    i > n && (n = i, e = r.severity);
  }
  return e;
}
const Vee = _X(Mee, {hideOn:Pee}), w3 = [Zi, nt.decorations.compute([Zi], t => {
  let {selected:e, panel:n} = t.field(Zi);
  return !e || !n || e.from == e.to ? pt.none : pt.set([Lee.range(e.from, e.to)]);
}), Vee, Uee], a2 = typeof String.prototype.normalize == "function" ? t => t.normalize("NFKD") : t => t;
class gc {
  constructor(e, n, r = 0, i = e.length, s, o) {
    this.test = o, this.value = {from:0, to:0, precise:!1}, this.done = !1, this.matches = [], this.buffer = "", this.bufferPos = 0, this.iter = e.iterRange(r, i), this.bufferStart = r, this.normalize = s ? a => s(a2(a)) : a2, this.query = this.normalize(n);
  }
  peek() {
    if (this.bufferPos == this.buffer.length) {
      if (this.bufferStart += this.buffer.length, this.iter.next(), this.iter.done) {
        return -1;
      }
      this.bufferPos = 0, this.buffer = this.iter.value;
    }
    return aa(this.buffer, this.bufferPos);
  }
  next() {
    for (; this.matches.length;) {
      this.matches.pop();
    }
    return this.nextOverlapping();
  }
  nextOverlapping() {
    for (;;) {
      let e = this.peek();
      if (e < 0) {
        return this.done = !0, this;
      }
      let n = $N(e), r = this.bufferStart + this.bufferPos;
      this.bufferPos += Kd(e);
      let i = this.normalize(n);
      if (i.length) {
        for (let s = 0, o = r, a = !0;; s++) {
          let l = i.charCodeAt(s), c = this.match(l, o, a, this.bufferPos + this.bufferStart, s == i.length - 1);
          if (c) {
            return this.value = c, this;
          }
          if (s == i.length - 1) {
            break;
          }
          a && s < n.length && n.charCodeAt(s) == l ? o++ : a = !1;
        }
      }
    }
  }
  match(e, n, r, i, s) {
    let o = null;
    for (let a = 0; a < this.matches.length;) {
      let l = this.matches[a], c = !1;
      this.query.charCodeAt(l.index) == e && (l.index == this.query.length - 1 ? o = {from:l.from, to:i, precise:s && l.precise} : (l.index++, c = !0)), c ? a++ : this.matches.splice(a, 1);
    }
    return this.query.charCodeAt(0) == e && (this.query.length == 1 ? o = {from:n, to:i, precise:r && s} : this.matches.push({from:n, index:1, precise:r})), o && this.test && !this.test(o.from, o.to, this.buffer, this.bufferStart) && (o = null), o;
  }
}
typeof Symbol < "u" && (gc.prototype[Symbol.iterator] = function() {
  return this;
});
const _3 = {from:-1, to:-1, match:/.*/.exec(""), precise:!0}, R1 = "gm" + (/x/.unicode == null ? "" : "u");
class S3 {
  constructor(e, n, r, i = 0, s = e.length) {
    if (this.text = e, this.to = s, this.curLine = "", this.done = !1, this.value = _3, /\\[sWDnr]|\n|\r|\[\^/.test(n)) {
      return new k3(e, n, r, i, s);
    }
    this.re = new RegExp(n, R1 + (r != null && r.ignoreCase ? "i" : "")), this.test = r == null ? void 0 : r.test, this.iter = e.iter();
    let o = e.lineAt(i);
    this.curLineStart = o.from, this.matchPos = $p(e, i), this.getLine(this.curLineStart);
  }
  getLine(e) {
    this.iter.next(e), this.iter.lineBreak ? this.curLine = "" : (this.curLine = this.iter.value, this.curLineStart + this.curLine.length > this.to && (this.curLine = this.curLine.slice(0, this.to - this.curLineStart)), this.iter.next());
  }
  nextLine() {
    this.curLineStart = this.curLineStart + this.curLine.length + 1, this.curLineStart > this.to ? this.curLine = "" : this.getLine(0);
  }
  next() {
    for (let e = this.matchPos - this.curLineStart;;) {
      this.re.lastIndex = e;
      let n = this.matchPos <= this.to && this.re.exec(this.curLine);
      if (n) {
        let r = this.curLineStart + n.index, i = r + n[0].length;
        if (this.matchPos = $p(this.text, i + (r == i ? 1 : 0)), r == this.curLineStart + this.curLine.length && this.nextLine(), (r < i || r > this.value.to) && (!this.test || this.test(r, i, n))) {
          return this.value = {from:r, to:i, precise:!0, match:n}, this;
        }
        e = this.matchPos - this.curLineStart;
      } else if (this.curLineStart + this.curLine.length < this.to) {
        this.nextLine(), e = 0;
      } else {
        return this.done = !0, this;
      }
    }
  }
}
const w0 = new WeakMap();
class tc {
  constructor(e, n) {
    this.from = e, this.text = n;
  }
  get to() {
    return this.from + this.text.length;
  }
  static get(e, n, r) {
    let i = w0.get(e);
    if (!i || i.from >= r || i.to <= n) {
      let a = new tc(n, e.sliceString(n, r));
      return w0.set(e, a), a;
    }
    if (i.from == n && i.to == r) {
      return i;
    }
    let {text:s, from:o} = i;
    return o > n && (s = e.sliceString(n, o) + s, o = n), i.to < r && (s += e.sliceString(i.to, r)), w0.set(e, new tc(o, s)), new tc(n, s.slice(n - o, r - o));
  }
}
class k3 {
  constructor(e, n, r, i, s) {
    this.text = e, this.to = s, this.done = !1, this.value = _3, this.matchPos = $p(e, i), this.re = new RegExp(n, R1 + (r != null && r.ignoreCase ? "i" : "")), this.test = r == null ? void 0 : r.test, this.flat = tc.get(e, i, this.chunkEnd(i + 5e3));
  }
  chunkEnd(e) {
    return e >= this.to ? this.to : this.text.lineAt(e).to;
  }
  next() {
    for (;;) {
      let e = this.re.lastIndex = this.matchPos - this.flat.from, n = this.re.exec(this.flat.text);
      if (n && !n[0] && n.index == e && (this.re.lastIndex = e + 1, n = this.re.exec(this.flat.text)), n) {
        let r = this.flat.from + n.index, i = r + n[0].length;
        if ((this.flat.to >= this.to || n.index + n[0].length <= this.flat.text.length - 10) && (!this.test || this.test(r, i, n))) {
          return this.value = {from:r, to:i, precise:!0, match:n}, this.matchPos = $p(this.text, i + (r == i ? 1 : 0)), this;
        }
      }
      if (this.flat.to == this.to) {
        return this.done = !0, this;
      }
      this.flat = tc.get(this.text, this.flat.from, this.chunkEnd(this.flat.from + this.flat.text.length * 2));
    }
  }
}
typeof Symbol < "u" && (S3.prototype[Symbol.iterator] = k3.prototype[Symbol.iterator] = function() {
  return this;
});
function qee(t) {
  try {
    return new RegExp(t, R1), !0;
  } catch {
    return !1;
  }
}
function $p(t, e) {
  if (e >= t.length) {
    return e;
  }
  let n = t.lineAt(e), r;
  for (; e < n.to && (r = n.text.charCodeAt(e - n.from)) >= 56320 && r < 57344;) {
    e++;
  }
  return e;
}
const Yee = t => {
  let {state:e} = t, n = String(e.doc.lineAt(t.state.selection.main.head).number), {close:r, result:i} = kX(t, {label:e.phrase("Go to line"), input:{type:"text", name:"line", value:n}, focus:!0, submitLabel:e.phrase("go")});
  return i.then(s => {
    let o = s && /^([+-])?(\d+)?(:\d+)?(%)?$/.exec(s.elements.line.value);
    if (!o) {
      t.dispatch({effects:r});
      return;
    }
    let a = e.doc.lineAt(e.selection.main.head), [, l, c, u, h] = o, f = u ? +u.slice(1) : 0, p = c ? +c : a.number;
    if (c && h) {
      let b = p / 100;
      l && (b = b * (l == "-" ? -1 : 1) + a.number / e.doc.lines), p = Math.round(e.doc.lines * b);
    } else {
      c && l && (p = p * (l == "-" ? -1 : 1) + a.number);
    }
    let g = e.doc.line(Math.max(1, Math.min(e.doc.lines, p))), m = Ce.cursor(g.from + Math.max(0, Math.min(f, g.length)));
    t.dispatch({effects:[r, nt.scrollIntoView(m.from, {y:"center"})], selection:m});
  }), !0;
}, Gee = {highlightWordAroundCursor:!1, minSelectionLength:1, maxMatches:100, wholeWords:!1}, Qee = et.define({combine(t) {
  return mo(t, Gee, {highlightWordAroundCursor:(e, n) => e || n, minSelectionLength:Math.min, maxMatches:Math.min});
}});
function Kee(t) {
  return [tte, ete];
}
const Xee = pt.mark({class:"cm-selectionMatch"}), Jee = pt.mark({class:"cm-selectionMatch cm-selectionMatch-main"});
function l2(t, e, n, r) {
  return (n == 0 || t(e.sliceDoc(n - 1, n)) != An.Word) && (r == e.doc.length || t(e.sliceDoc(r, r + 1)) != An.Word);
}
function Zee(t, e, n, r) {
  return t(e.sliceDoc(n, n + 1)) == An.Word && t(e.sliceDoc(r - 1, r)) == An.Word;
}
const ete = Kn.fromClass(class {
  constructor(t) {
    this.decorations = this.getDeco(t);
  }
  update(t) {
    (t.selectionSet || t.docChanged || t.viewportChanged) && (this.decorations = this.getDeco(t.view));
  }
  getDeco(t) {
    let e = t.state.facet(Qee), {state:n} = t, r = n.selection;
    if (r.ranges.length > 1) {
      return pt.none;
    }
    let i = r.main, s, o = null;
    if (i.empty) {
      if (!e.highlightWordAroundCursor) {
        return pt.none;
      }
      let l = n.wordAt(i.head);
      if (!l) {
        return pt.none;
      }
      o = n.charCategorizer(i.head), s = n.sliceDoc(l.from, l.to);
    } else {
      let l = i.to - i.from;
      if (l < e.minSelectionLength || l > 200) {
        return pt.none;
      }
      if (e.wholeWords) {
        if (s = n.sliceDoc(i.from, i.to), o = n.charCategorizer(i.head), !(l2(o, n, i.from, i.to) && Zee(o, n, i.from, i.to))) {
          return pt.none;
        }
      } else if (s = n.sliceDoc(i.from, i.to), !s) {
        return pt.none;
      }
    }
    let a = [];
    for (let l of t.visibleRanges) {
      let c = new gc(n.doc, s, l.from, l.to);
      for (; !c.next().done;) {
        let {from:u, to:h} = c.value;
        if ((!o || l2(o, n, u, h)) && (i.empty && u <= i.from && h >= i.to ? a.push(Jee.range(u, h)) : (u >= i.to || h <= i.from) && a.push(Xee.range(u, h)), a.length > e.maxMatches)) {
          return pt.none;
        }
      }
    }
    return pt.set(a);
  }
}, {decorations:t => t.decorations}), tte = nt.baseTheme({".cm-selectionMatch":{backgroundColor:"#99ff7780"}, ".cm-searchMatch .cm-selectionMatch":{backgroundColor:"transparent"}}), nte = ({state:t, dispatch:e}) => {
  let {selection:n} = t, r = Ce.create(n.ranges.map(i => t.wordAt(i.head) || Ce.cursor(i.head)), n.mainIndex);
  return r.eq(n) ? !1 : (e(t.update({selection:r})), !0);
};
function rte(t, e) {
  let {main:n, ranges:r} = t.selection, i = t.wordAt(n.head), s = i && i.from == n.from && i.to == n.to;
  for (let o = !1, a = new gc(t.doc, e, r[r.length - 1].to);;) {
    if (a.next(), a.done) {
      if (o) {
        return null;
      }
      a = new gc(t.doc, e, 0, Math.max(0, r[r.length - 1].from - 1)), o = !0;
    } else {
      if (o && r.some(l => l.from == a.value.from)) {
        continue;
      }
      if (s) {
        let l = t.wordAt(a.value.from);
        if (!l || l.from != a.value.from || l.to != a.value.to) {
          continue;
        }
      }
      return a.value;
    }
  }
}
const ite = ({state:t, dispatch:e}) => {
  let {ranges:n} = t.selection;
  if (n.some(s => s.from === s.to)) {
    return nte({state:t, dispatch:e});
  }
  let r = t.sliceDoc(n[0].from, n[0].to);
  if (t.selection.ranges.some(s => t.sliceDoc(s.from, s.to) != r)) {
    return !1;
  }
  let i = rte(t, r);
  return i ? (e(t.update({selection:t.selection.addRange(Ce.range(i.from, i.to), !1), effects:nt.scrollIntoView(i.to)})), !0) : !1;
}, Ic = et.define({combine(t) {
  return mo(t, {top:!1, caseSensitive:!1, literal:!1, regexp:!1, wholeWord:!1, createPanel:e => new yte(e), scrollToMatch:e => nt.scrollIntoView(e)});
}});
class E3 {
  constructor(e) {
    this.search = e.search, this.caseSensitive = !!e.caseSensitive, this.literal = !!e.literal, this.regexp = !!e.regexp, this.replace = e.replace || "", this.valid = !!this.search && (!this.regexp || qee(this.search)), this.unquoted = this.unquote(this.search), this.wholeWord = !!e.wholeWord, this.test = e.test;
  }
  unquote(e) {
    return this.literal ? e : e.replace(/\\([nrt\\])/g, (n, r) => r == "n" ? `
` : r == "r" ? "\r" : r == "t" ? "\t" : "\\");
  }
  eq(e) {
    return this.search == e.search && this.replace == e.replace && this.caseSensitive == e.caseSensitive && this.regexp == e.regexp && this.wholeWord == e.wholeWord && this.test == e.test;
  }
  create() {
    return this.regexp ? new ute(this) : new ate(this);
  }
  getCursor(e, n = 0, r) {
    let i = e.doc ? e : Yt.create({doc:e});
    return r == null && (r = i.doc.length), this.regexp ? Il(this, i, n, r) : Nl(this, i, n, r);
  }
}
class T3 {
  constructor(e) {
    this.spec = e;
  }
}
function ste(t, e, n) {
  return (r, i, s, o) => {
    if (n && !n(r, i, s, o)) {
      return !1;
    }
    let a = r >= o && i <= o + s.length ? s.slice(r - o, i - o) : e.doc.sliceString(r, i);
    return t(a, e, r, i);
  };
}
function Nl(t, e, n, r) {
  let i;
  return t.wholeWord && (i = ote(e.doc, e.charCategorizer(e.selection.main.head))), t.test && (i = ste(t.test, e, i)), new gc(e.doc, t.unquoted, n, r, t.caseSensitive ? void 0 : s => s.toLowerCase(), i);
}
function ote(t, e) {
  return (n, r, i, s) => ((s > n || s + i.length < r) && (s = Math.max(0, n - 2), i = t.sliceString(s, Math.min(t.length, r + 2))), (e(Fp(i, n - s)) != An.Word || e(zp(i, n - s)) != An.Word) && (e(zp(i, r - s)) != An.Word || e(Fp(i, r - s)) != An.Word));
}
class ate extends T3 {
  constructor(e) {
    super(e);
  }
  nextMatch(e, n, r) {
    let i = Nl(this.spec, e, r, e.doc.length).nextOverlapping();
    if (i.done) {
      let s = Math.min(e.doc.length, n + this.spec.unquoted.length);
      i = Nl(this.spec, e, 0, s).nextOverlapping();
    }
    return i.done || i.value.from == n && i.value.to == r ? null : i.value;
  }
  prevMatchInRange(e, n, r) {
    for (let i = r;;) {
      let s = Math.max(n, i - 1e4 - this.spec.unquoted.length), o = Nl(this.spec, e, s, i), a = null;
      for (; !o.nextOverlapping().done;) {
        a = o.value;
      }
      if (a) {
        return a;
      }
      if (s == n) {
        return null;
      }
      i -= 1e4;
    }
  }
  prevMatch(e, n, r) {
    let i = this.prevMatchInRange(e, 0, n);
    return i || (i = this.prevMatchInRange(e, Math.max(0, r - this.spec.unquoted.length), e.doc.length)), i && (i.from != n || i.to != r) ? i : null;
  }
  getReplacement(e) {
    return this.spec.unquote(this.spec.replace);
  }
  matchAll(e, n) {
    let r = Nl(this.spec, e, 0, e.doc.length), i = [];
    for (; !r.next().done;) {
      if (i.length >= n) {
        return null;
      }
      i.push(r.value);
    }
    return i;
  }
  highlight(e, n, r, i) {
    let s = Nl(this.spec, e, Math.max(0, n - this.spec.unquoted.length), Math.min(r + this.spec.unquoted.length, e.doc.length));
    for (; !s.next().done;) {
      i(s.value.from, s.value.to);
    }
  }
}
function lte(t, e, n) {
  return (r, i, s) => (!n || n(r, i, s)) && t(s[0], e, r, i);
}
function Il(t, e, n, r) {
  let i;
  return t.wholeWord && (i = cte(e.charCategorizer(e.selection.main.head))), t.test && (i = lte(t.test, e, i)), new S3(e.doc, t.search, {ignoreCase:!t.caseSensitive, test:i}, n, r);
}
function Fp(t, e) {
  return t.slice(cr(t, e, !1), e);
}
function zp(t, e) {
  return t.slice(e, cr(t, e));
}
function cte(t) {
  return (e, n, r) => !r[0].length || (t(Fp(r.input, r.index)) != An.Word || t(zp(r.input, r.index)) != An.Word) && (t(zp(r.input, r.index + r[0].length)) != An.Word || t(Fp(r.input, r.index + r[0].length)) != An.Word);
}
class ute extends T3 {
  nextMatch(e, n, r) {
    let i = Il(this.spec, e, r, e.doc.length).next();
    return i.done && (i = Il(this.spec, e, 0, n).next()), i.done ? null : i.value;
  }
  prevMatchInRange(e, n, r) {
    for (let i = 1;; i++) {
      let s = Math.max(n, r - i * 1e4), o = Il(this.spec, e, s, r), a = null;
      for (; !o.next().done;) {
        a = o.value;
      }
      if (a && (s == n || a.from > s + 10)) {
        return a;
      }
      if (s == n) {
        return null;
      }
    }
  }
  prevMatch(e, n, r) {
    return this.prevMatchInRange(e, 0, n) || this.prevMatchInRange(e, r, e.doc.length);
  }
  getReplacement(e) {
    return this.spec.unquote(this.spec.replace).replace(/\$([$&]|\d+)/g, (n, r) => {
      if (r == "\x26") {
        return e.match[0];
      }
      if (r == "$") {
        return "$";
      }
      for (let i = r.length; i > 0; i--) {
        let s = +r.slice(0, i);
        if (s > 0 && s < e.match.length) {
          return e.match[s] + r.slice(i);
        }
      }
      return n;
    });
  }
  matchAll(e, n) {
    let r = Il(this.spec, e, 0, e.doc.length), i = [];
    for (; !r.next().done;) {
      if (i.length >= n) {
        return null;
      }
      i.push(r.value);
    }
    return i;
  }
  highlight(e, n, r, i) {
    let s = Il(this.spec, e, Math.max(0, n - 250), Math.min(r + 250, e.doc.length));
    for (; !s.next().done;) {
      i(s.value.from, s.value.to);
    }
  }
}
const Td = zt.define(), D1 = zt.define(), Qo = ii.define({create(t) {
  return new _0(Ty(t).create(), null);
}, update(t, e) {
  for (let n of e.effects) {
    n.is(Td) ? t = new _0(n.value.create(), t.panel) : n.is(D1) && (t = new _0(t.query, n.value ? L1 : null));
  }
  return t;
}, provide:t => wd.from(t, e => e.panel)});
class _0 {
  constructor(e, n) {
    this.query = e, this.panel = n;
  }
}
const dte = pt.mark({class:"cm-searchMatch"}), hte = pt.mark({class:"cm-searchMatch cm-searchMatch-selected"}), fte = Kn.fromClass(class {
  constructor(t) {
    this.view = t, this.decorations = this.highlight(t.state.field(Qo));
  }
  update(t) {
    let e = t.state.field(Qo);
    (e != t.startState.field(Qo) || t.docChanged || t.selectionSet || t.viewportChanged) && (this.decorations = this.highlight(e));
  }
  highlight({query:t, panel:e}) {
    if (!e || !t.spec.valid) {
      return pt.none;
    }
    let {view:n} = this, r = new uo();
    for (let i = 0, s = n.visibleRanges, o = s.length; i < o; i++) {
      let {from:a, to:l} = s[i];
      for (; i < o - 1 && l > s[i + 1].from - 2 * 250;) {
        l = s[++i].to;
      }
      t.highlight(n.state, a, l, (c, u) => {
        let h = n.state.selection.ranges.some(f => f.from == c && f.to == u);
        r.add(c, u, h ? hte : dte);
      });
    }
    return r.finish();
  }
}, {decorations:t => t.decorations});
function sh(t) {
  return e => {
    let n = e.state.field(Qo, !1);
    return n && n.query.spec.valid ? t(e, n) : N3(e);
  };
}
const Hp = sh((t, {query:e}) => {
  let {to:n} = t.state.selection.main, r = e.nextMatch(t.state, n, n);
  if (!r) {
    return !1;
  }
  let i = Ce.single(r.from, r.to), s = t.state.facet(Ic);
  return t.dispatch({selection:i, effects:[M1(t, r), s.scrollToMatch(i.main, t)], userEvent:"select.search"}), A3(t), !0;
}), Up = sh((t, {query:e}) => {
  let {state:n} = t, {from:r} = n.selection.main, i = e.prevMatch(n, r, r);
  if (!i) {
    return !1;
  }
  let s = Ce.single(i.from, i.to), o = t.state.facet(Ic);
  return t.dispatch({selection:s, effects:[M1(t, i), o.scrollToMatch(s.main, t)], userEvent:"select.search"}), A3(t), !0;
}), pte = sh((t, {query:e}) => {
  let n = e.matchAll(t.state, 1e3);
  return !n || !n.length ? !1 : (t.dispatch({selection:Ce.create(n.map(r => Ce.range(r.from, r.to))), userEvent:"select.search.matches"}), !0);
}), gte = ({state:t, dispatch:e}) => {
  let n = t.selection;
  if (n.ranges.length > 1 || n.main.empty) {
    return !1;
  }
  let {from:r, to:i} = n.main, s = [], o = 0;
  for (let a = new gc(t.doc, t.sliceDoc(r, i)); !a.next().done;) {
    if (s.length > 1e3) {
      return !1;
    }
    a.value.from == r && (o = s.length), s.push(Ce.range(a.value.from, a.value.to));
  }
  return e(t.update({selection:Ce.create(s, o), userEvent:"select.search.matches"})), !0;
}, c2 = sh((t, {query:e}) => {
  let {state:n} = t, {from:r, to:i} = n.selection.main;
  if (n.readOnly) {
    return !1;
  }
  let s = e.nextMatch(n, r, r);
  if (!s) {
    return !1;
  }
  let o = s, a = [], l, c, u = [];
  o.precise ? o.from == r && o.to == i && (c = n.toText(e.getReplacement(o)), a.push({from:o.from, to:o.to, insert:c}), u.push(nt.announce.of(n.phrase("replaced match on line $", n.doc.lineAt(r).number) + "."))) : o = e.nextMatch(n, o.from, o.to);
  let h = t.state.changes(a);
  return o && (l = Ce.single(o.from, o.to).map(h), u.push(M1(t, o)), u.push(n.facet(Ic).scrollToMatch(l.main, t))), t.dispatch({changes:h, selection:l, effects:u, userEvent:"input.replace"}), !0;
}), mte = sh((t, {query:e}) => {
  if (t.state.readOnly) {
    return !1;
  }
  let n = [];
  for (let i of e.matchAll(t.state, 1e9)) {
    let {from:s, to:o, precise:a} = i;
    a && n.push({from:s, to:o, insert:e.getReplacement(i)});
  }
  if (!n.length) {
    return !1;
  }
  let r = t.state.phrase("replaced $ matches", n.length) + ".";
  return t.dispatch({changes:n, effects:nt.announce.of(r), userEvent:"input.replace.all"}), !0;
});
function L1(t) {
  return t.state.facet(Ic).createPanel(t);
}
function Ty(t, e) {
  var n, r, i, s, o;
  let a = t.selection.main, l = a.empty || a.to > a.from + 100 ? "" : t.sliceDoc(a.from, a.to);
  if (e && !l) {
    return e;
  }
  let c = t.facet(Ic);
  return new E3({search:((n = e == null ? void 0 : e.literal) !== null && n !== void 0 ? n : c.literal) ? l : l.replace(/\n/g, "\\n"), caseSensitive:(r = e == null ? void 0 : e.caseSensitive) !== null && r !== void 0 ? r : c.caseSensitive, literal:(i = e == null ? void 0 : e.literal) !== null && i !== void 0 ? i : c.literal, regexp:(s = e == null ? void 0 : e.regexp) !== null && s !== void 0 ? s : c.regexp, wholeWord:(o = e == null ? void 0 : e.wholeWord) !== null && o !== void 0 ? o : c.wholeWord});
}
function C3(t) {
  let e = ZI(t, L1);
  return e && e.dom.querySelector("[main-field]");
}
function A3(t) {
  let e = C3(t);
  e && e == t.root.activeElement && e.select();
}
const N3 = t => {
  let e = t.state.field(Qo, !1);
  if (e && e.panel) {
    let n = C3(t);
    if (n && n != t.root.activeElement) {
      let r = Ty(t.state, e.query.spec);
      r.valid && t.dispatch({effects:Td.of(r)}), n.focus(), n.select();
    }
  } else {
    t.dispatch({effects:[D1.of(!0), e ? Td.of(Ty(t.state, e.query.spec)) : zt.appendConfig.of(vte)]});
  }
  return !0;
}, I3 = t => {
  let e = t.state.field(Qo, !1);
  if (!e || !e.panel) {
    return !1;
  }
  let n = ZI(t, L1);
  return n && n.dom.contains(t.root.activeElement) && t.focus(), t.dispatch({effects:D1.of(!1)}), !0;
}, bte = [{key:"Mod-f", run:N3, scope:"editor search-panel"}, {key:"F3", run:Hp, shift:Up, scope:"editor search-panel", preventDefault:!0}, {key:"Mod-g", run:Hp, shift:Up, scope:"editor search-panel", preventDefault:!0}, {key:"Escape", run:I3, scope:"editor search-panel"}, {key:"Mod-Shift-l", run:gte}, {key:"Mod-Alt-g", run:Yee}, {key:"Mod-d", run:ite, preventDefault:!0}];
class yte {
  constructor(e) {
    this.view = e;
    let n = this.query = e.state.field(Qo).query.spec;
    this.commit = this.commit.bind(this), this.searchField = ln("input", {value:n.search, placeholder:ui(e, "Find"), "aria-label":ui(e, "Find"), class:"cm-textfield", name:"search", form:"", "main-field":"true", onchange:this.commit, onkeyup:this.commit}), this.replaceField = ln("input", {value:n.replace, placeholder:ui(e, "Replace"), "aria-label":ui(e, "Replace"), class:"cm-textfield", name:"replace", form:"", onchange:this.commit, onkeyup:this.commit}), this.caseField = ln("input", {type:"checkbox", 
    name:"case", form:"", checked:n.caseSensitive, onchange:this.commit}), this.reField = ln("input", {type:"checkbox", name:"re", form:"", checked:n.regexp, onchange:this.commit}), this.wordField = ln("input", {type:"checkbox", name:"word", form:"", checked:n.wholeWord, onchange:this.commit});
    function r(i, s, o) {
      return ln("button", {class:"cm-button", name:i, onclick:s, type:"button"}, o);
    }
    this.dom = ln("div", {onkeydown:i => this.keydown(i), class:"cm-search"}, [this.searchField, r("next", () => Hp(e), [ui(e, "next")]), r("prev", () => Up(e), [ui(e, "previous")]), r("select", () => pte(e), [ui(e, "all")]), ln("label", null, [this.caseField, ui(e, "match case")]), ln("label", null, [this.reField, ui(e, "regexp")]), ln("label", null, [this.wordField, ui(e, "by word")]), ...(e.state.readOnly ? [] : [ln("br"), this.replaceField, r("replace", () => c2(e), [ui(e, "replace")]), r("replaceAll", 
    () => mte(e), [ui(e, "replace all")])]), ln("button", {name:"close", onclick:() => I3(e), "aria-label":ui(e, "close"), type:"button"}, ["\u00d7"])]);
  }
  commit() {
    let e = new E3({search:this.searchField.value, caseSensitive:this.caseField.checked, regexp:this.reField.checked, wholeWord:this.wordField.checked, replace:this.replaceField.value});
    e.eq(this.query) || (this.query = e, this.view.dispatch({effects:Td.of(e)}));
  }
  keydown(e) {
    $K(this.view, e, "search-panel") ? e.preventDefault() : e.keyCode == 13 && e.target == this.searchField ? (e.preventDefault(), (e.shiftKey ? Up : Hp)(this.view)) : e.keyCode == 13 && e.target == this.replaceField && (e.preventDefault(), c2(this.view));
  }
  update(e) {
    for (let n of e.transactions) {
      for (let r of n.effects) {
        r.is(Td) && !r.value.eq(this.query) && this.setQuery(r.value);
      }
    }
  }
  setQuery(e) {
    this.query = e, this.searchField.value = e.search, this.replaceField.value = e.replace, this.caseField.checked = e.caseSensitive, this.reField.checked = e.regexp, this.wordField.checked = e.wholeWord;
  }
  mount() {
    this.searchField.select();
  }
  get pos() {
    return 80;
  }
  get top() {
    return this.view.state.facet(Ic).top;
  }
}
function ui(t, e) {
  return t.state.phrase(e);
}
const rf = 30, sf = /[\s\.,:;?!]/;
function M1(t, {from:e, to:n}) {
  let r = t.state.doc.lineAt(e), i = t.state.doc.lineAt(n).to, s = Math.max(r.from, e - rf), o = Math.min(i, n + rf), a = t.state.sliceDoc(s, o);
  if (s != r.from) {
    for (let l = 0; l < rf; l++) {
      if (!sf.test(a[l + 1]) && sf.test(a[l])) {
        a = a.slice(l);
        break;
      }
    }
  }
  if (o != i) {
    for (let l = a.length - 1; l > a.length - rf; l--) {
      if (!sf.test(a[l - 1]) && sf.test(a[l])) {
        a = a.slice(0, l);
        break;
      }
    }
  }
  return nt.announce.of(`${t.state.phrase("current match")}. ${a} ${t.state.phrase("on line")} ${r.number}.`);
}
const xte = nt.baseTheme({".cm-panel.cm-search":{padding:"2px 6px 4px", position:"relative", "\x26 [name\x3dclose]":{position:"absolute", top:"0", right:"4px", backgroundColor:"inherit", border:"none", font:"inherit", padding:0, margin:0}, "\x26 input, \x26 button, \x26 label":{margin:".2em .6em .2em 0"}, "\x26 input[type\x3dcheckbox]":{marginRight:".2em"}, "\x26 label":{fontSize:"80%", whiteSpace:"pre"}}, "\x26light .cm-searchMatch":{backgroundColor:"#ffff0054"}, "\x26dark .cm-searchMatch":{backgroundColor:"#00ffff8a"}, 
"\x26light .cm-searchMatch-selected":{backgroundColor:"#ff6a0054"}, "\x26dark .cm-searchMatch-selected":{backgroundColor:"#ff00ff8a"}}), vte = [Qo, Xd.low(fte), xte];
function O3(t) {
  try {
    let e = 0, n = !1, r = !1, i = 1;
    for (let s = 0; s < t.length; s++) {
      const o = t[s];
      if (o === `
`) {
        i++, r = !1;
        continue;
      }
      if (!r) {
        if (n) {
          if (o === "\\") {
            s++;
            continue;
          }
          o === '"' && (n = !1);
          continue;
        }
        if (o === ";") {
          r = !0;
          continue;
        }
        if (o === '"') {
          n = !0;
          continue;
        }
        if ((o === "{" || o === "(" || o === "[") && e++, (o === "}" || o === ")" || o === "]") && e--, e < 0) {
          return {ok:!1, error:"Unexpected closing bracket", line:i};
        }
      }
    }
    return e > 0 ? {ok:!1, error:`Unclosed bracket(s): depth ${e}`, line:i} : n ? {ok:!1, error:"Unclosed string", line:i} : {ok:!0};
  } catch (e) {
    return {ok:!1, error:e instanceof Error ? e.message : String(e)};
  }
}
function wte() {
  return y3(t => {
    const e = t.state.doc.toString(), n = O3(e);
    if (n.ok) {
      return [];
    }
    const r = n.line ?? 1, i = t.state.doc.line(Math.min(r, t.state.doc.lines));
    return [{from:i.from, to:i.to, severity:"error", message:n.error}];
  });
}
function _te(t) {
  return Hg.define([{tag:Re.comment, color:t.accent.yellow, fontStyle:"italic"}, {tag:Re.lineComment, color:t.accent.yellow, fontStyle:"italic"}, {tag:Re.blockComment, color:t.accent.yellow, fontStyle:"italic"}, {tag:Re.docComment, color:t.accent.yellow, fontStyle:"italic"}, {tag:Re.string, color:t.accent.yellow}, {tag:Re.special(Re.string), color:t.accent.orange}, {tag:Re.keyword, color:t.accent.magenta}, {tag:Re.controlKeyword, color:t.accent.magenta}, {tag:Re.operatorKeyword, color:t.accent.magenta}, 
  {tag:Re.special(Re.keyword), color:t.accent.red}, {tag:Re.number, color:t.accent.orange}, {tag:Re.integer, color:t.accent.orange}, {tag:Re.float, color:t.accent.orange}, {tag:Re.bool, color:t.accent.red}, {tag:Re.null, color:t.accent.magenta}, {tag:Re.operator, color:t.accent.red}, {tag:Re.definitionOperator, color:t.accent.red}, {tag:Re.typeOperator, color:t.accent.magenta}, {tag:Re.function(Re.variableName), color:t.accent.green}, {tag:Re.definition(Re.function(Re.variableName)), color:t.accent.green}, 
  {tag:Re.variableName, color:t.fg.bright}, {tag:Re.definition(Re.variableName), color:t.accent.green}, {tag:Re.special(Re.variableName), color:t.accent.cyan}, {tag:Re.typeName, color:t.accent.cyan}, {tag:Re.className, color:t.accent.cyan}, {tag:Re.labelName, color:t.accent.cyan}, {tag:Re.namespace, color:t.accent.cyan}, {tag:Re.propertyName, color:t.accent.cyan}, {tag:Re.attributeName, color:t.accent.cyan}, {tag:Re.punctuation, color:t.fg.soft}, {tag:Re.separator, color:t.fg.soft}, {tag:Re.bracket, 
  color:t.fg.soft}, {tag:Re.angleBracket, color:t.fg.soft}, {tag:Re.meta, color:t.accent.red}, {tag:Re.processingInstruction, color:t.accent.red}, {tag:Re.special(Re.string), color:t.accent.red}, {tag:Re.content, color:t.fg.default}, {tag:Re.heading, color:t.accent.green, fontWeight:"bold"}, {tag:Re.link, color:t.accent.cyan, textDecoration:"underline"}, {tag:Re.emphasis, fontStyle:"italic"}, {tag:Re.strong, fontWeight:"bold"}, {tag:Re.strikethrough, textDecoration:"line-through"}, {tag:Re.inserted, 
  color:t.accent.green}, {tag:Re.deleted, color:t.accent.red}, {tag:Re.changed, color:t.accent.orange}]);
}
function Ste(t) {
  return nt.theme({"\x26":{backgroundColor:t.bg.default, color:t.fg.default, fontSize:Lr.sm, height:"100%"}, ".cm-content":{fontFamily:rc.mono, caretColor:t.accent.cyan, padding:"8px 0"}, ".cm-cursor":{borderLeftColor:t.accent.cyan, borderLeftWidth:"2px"}, ".cm-selectionBackground, \x26.cm-focused .cm-selectionBackground":{backgroundColor:ce(t.accent.cyan, 0.18)}, ".cm-gutters":{backgroundColor:t.bg.darker, color:t.fg.muted, border:"none", paddingRight:"4px"}, ".cm-activeLineGutter":{backgroundColor:ce(t.accent.cyan, 
  0.06), color:t.fg.soft}, ".cm-activeLine":{backgroundColor:ce(t.accent.cyan, 0.04)}, ".cm-matchingBracket":{backgroundColor:ce(t.accent.cyan, 0.25), outline:`1px solid ${ce(t.accent.cyan, 0.5)}`, color:t.fg.bright}, ".cm-nonmatchingBracket":{backgroundColor:ce(t.accent.red, 0.25), outline:`1px solid ${ce(t.accent.red, 0.5)}`}, ".cm-lintRange-error":{backgroundImage:"none", borderBottom:`2px wavy ${t.accent.red}`}, ".cm-lintRange-warning":{backgroundImage:"none", borderBottom:`2px wavy ${t.accent.orange}`}, 
  ".cm-tooltip":{backgroundColor:t.bg.darker, border:`1px solid ${t.fg.subtle}`, color:t.fg.default, borderRadius:Oa.md}, ".cm-tooltip.cm-tooltip-lint":{borderRadius:Oa.md}, ".cm-tooltip.cm-tooltip-autocomplete":{borderRadius:Oa.md, "\x26 \x3e ul \x3e li":{padding:"4px 8px"}, "\x26 \x3e ul \x3e li[aria-selected]":{backgroundColor:ce(t.accent.cyan, 0.15), color:t.fg.bright}}, ".cm-foldGutter":{width:"16px"}, ".cm-foldPlaceholder":{backgroundColor:t.bg.lighter, border:`1px solid ${t.fg.subtle}`, color:t.fg.muted, 
  padding:"0 4px", borderRadius:Oa.xs}, ".cm-scroller":{overflow:"auto"}, ".cm-searchMatch":{backgroundColor:ce(t.accent.yellow, 0.25), outline:`1px solid ${ce(t.accent.yellow, 0.4)}`}, ".cm-searchMatch.cm-searchMatch-selected":{backgroundColor:ce(t.accent.orange, 0.35)}, ".cm-panels":{backgroundColor:t.bg.darker, borderBottom:`1px solid ${t.fg.subtle}`, color:t.fg.default}, ".cm-panels input, .cm-panels button":{fontFamily:rc.sans, fontSize:Lr.xs}}, {dark:!0});
}
function kte({value:t, onChange:e, placeholder:n, readOnly:r = !1, className:i, height:s = "400px", externalErrors:o = [], onValidate:a, fileName:l}) {
  const c = (0,require$react.useRef)(null), u = (0,require$react.useRef)(null), h = (0,require$react.useRef)(e), f = (0,require$react.useRef)(new Jd()), p = _c(), g = p.palette, m = p.colors;
  (0,require$react.useEffect)(() => {
    h.current = e;
  }, [e]);
  const b = (0,require$react.useMemo)(() => y3(() => o.map(E => {
    var P;
    const C = E.line ?? 1, k = (P = u.current) == null ? void 0 : P.state.doc, A = k ? k.line(Math.min(C, k.lines)) : null;
    return {from:(A == null ? void 0 : A.from) ?? 0, to:(A == null ? void 0 : A.to) ?? 1, severity:"error", message:E.message};
  })), [o]);
  (0,require$react.useEffect)(() => {
    if (!c.current) {
      return;
    }
    const E = [Ste(g), OJ(_te(g)), nZ(), vee(), LX(), $X(), sX(), ZK(), jK(), fX(), pJ(), zJ(), wee(), Kee(), AJ(), wte(), b, jI.of([...Eee, ...iee, ...bte, ...dZ, ...kJ, see, {key:"Mod-Shift-v", run:() => (a == null || a(), !0)}]), f.current.of(Yt.readOnly.of(r)), nt.updateListener.of(A => {
      A.docChanged && h.current(A.state.doc.toString());
    })];
    n && E.push(cX(n));
    const C = Yt.create({doc:t, extensions:E}), k = new nt({state:C, parent:c.current});
    return u.current = k, () => {
      k.destroy(), u.current = null;
    };
  }, []);
  const x = (0,require$react.useRef)(t), w = (0,require$react.useRef)(0);
  (0,require$react.useEffect)(() => {
    if (!u.current || t === x.current) {
      return;
    }
    w.current = u.current.state.selection.main.head, x.current = t, u.current.dispatch({changes:{from:0, to:u.current.state.doc.length, insert:t}});
    const E = u.current.state.doc, C = Math.min(w.current, E.length);
    u.current.dispatch({selection:{anchor:C}});
  }, [t]), (0,require$react.useEffect)(() => {
    u.current && u.current.dispatch({effects:f.current.reconfigure(Yt.readOnly.of(r))});
  }, [r]);
  const [v, T] = (0,require$react.useState)([]);
  (0,require$react.useEffect)(() => {
    const E = u.current;
    if (!E) {
      return;
    }
    const C = E.state.doc, k = C.lines, A = C.length, P = E.state.selection.main.head, W = C.lineAt(P).number, F = P - C.lineAt(P).from + 1, B = o.length, j = O3(C.toString()).ok, V = [];
    l && V.push({key:"file", label:l}), B > 0 ? V.push({key:"errors", label:`\u2715 ${B} error${B > 1 ? "s" : ""}`}) : j && V.push({key:"valid", label:"\u2713 valid"}), V.push({key:"cursor", label:`Ln ${W}, Col ${F}`, align:"end"}), V.push({key:"lines", label:`${k} lines`}), V.push({key:"chars", label:`${A} chars`}), T(V);
  }, [t, o, l]);
  const I = (0,require$react.useMemo)(() => [{key:"lang-badge", label:"EDN", title:"Clojure/EDN mode", buttonStyle:{fontFamily:rc.mono, fontWeight:600, color:m.accent.cyan}}, {type:"divider", key:"div-lang"}, {key:"undo", label:"\u21b6", title:"Undo (Ctrl+Z)", onClick:() => {
    const E = u.current;
    E && E.dispatch({effects:[]});
  }}, {key:"redo", label:"\u21b7", title:"Redo (Ctrl+Shift+Z)", onClick:() => {
    const E = u.current;
    E && E.dispatch({effects:[]});
  }}, {type:"divider", key:"div-undo"}, {key:"fold", label:"\u25c3", title:"Fold all", onClick:() => {
  }}, {key:"format", label:"{}", title:"Reformat (coming soon)", disabled:!0}], [m.accent.cyan]), _ = (0,require$react.useMemo)(() => a ? [...I, {type:"divider", key:"div-validate"}, {key:"validate", label:"\u2713 Validate", title:"Validate EDN (Ctrl+Shift+V)", onClick:a, buttonStyle:{border:`1px solid ${m.accent.green}`, borderRadius:Oa.xs, color:m.accent.green, padding:"2px 8px"}}] : I, [I, a, m.accent.green]), N = (0,require$react.useMemo)(() => v.map(E => E.key === "errors" ? {...E, label:(0,require$react_SLASH_jsx_runtime.jsx)("span", 
  {style:{color:m.accent.red}, children:E.label})} : E.key === "valid" ? {...E, label:(0,require$react_SLASH_jsx_runtime.jsx)("span", {style:{color:m.accent.green}, children:E.label})} : E), [v, m.accent.red, m.accent.green]);
  return (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:i, style:{display:"flex", flexDirection:"column", height:s, background:g.bg.default, border:`1px solid ${m.border.subtle}`, borderRadius:Oa.md, overflow:"hidden"}, children:[(0,require$react_SLASH_jsx_runtime.jsx)(pW, {items:_, background:m.background.surface, borderColor:m.border.subtle, textColor:m.text.default, padding:"4px 8px", gap:2, wrap:!1}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {ref:c, style:{flex:1, overflow:"hidden"}}), 
  (0,require$react_SLASH_jsx_runtime.jsx)(mW, {items:N, background:m.background.surface, borderColor:m.border.subtle, textColor:m.text.muted, padding:"3px 12px", gap:16})]});
}
const Ete = "knoxx_contracts_session_id", Tte = "knoxx_contracts_scratchpad_state", Cte = "knoxx_contracts_pinned_context", Ate = "knoxx_contracts_chat_session_state", Nte = "knoxx_contracts_sidebar_width_px", u2 = "knoxx_contracts_auto_focus_contract", d2 = "knoxx_contracts_left_panel_open", Ite = 1100;
function Ote(t) {
  const [e, n] = (0,require$react.useState)(() => typeof window > "u" ? !1 : window.innerWidth <= t);
  return (0,require$react.useEffect)(() => {
    if (typeof window > "u") {
      return;
    }
    const r = window.matchMedia(`(max-width: ${t}px)`), i = s => n(s.matches);
    return n(r.matches), typeof r.addEventListener == "function" ? (r.addEventListener("change", i), () => r.removeEventListener("change", i)) : (r.addListener(i), () => r.removeListener(i));
  }, [t]), e;
}
function Pte(t) {
  return JSON.stringify(t ?? null, null, 2);
}
function h2(t) {
  return t.trim();
}
function Rte(t) {
  const e = t.match(/:contract\/id\s+"?([^"\s}]+)"?/);
  return (e == null ? void 0 : e[1]) ?? null;
}
function f2(t, e) {
  const n = new RegExp(`:events[\\s\\S]*?${e}\\s+\\[([^\\]]*)\\]`, "m"), r = t.match(n);
  return r != null && r[1] ? r[1].split(/[\s,]+/g).map(i => i.trim()).filter(Boolean).map(i => i.startsWith(":") ? i.slice(1) : i) : [];
}
function p2(t, e, n) {
  const r = n.map(s => s.startsWith(":") ? s : `:${s}`).join(" "), i = new RegExp(`(:events[\\s\\S]*?${e}\\s+\\[)([^\\]]*)(\\])`, "m");
  return i.test(t) ? t.replace(i, `$1${r}$3`) : t;
}
function Co(t, e) {
  const n = new RegExp(`(^\\s*:${e}\\s+)([^\\n\\r]+)$`, "m"), r = t.match(n);
  return r != null && r[2] ? r[2].trim() : null;
}
function js(t, e, n) {
  const r = new RegExp(`(^\\s*:${e}\\s+)([^\\n\\r]+)$`, "m");
  if (r.test(t)) {
    return t.replace(r, `$1${n}`);
  }
  const i = t.indexOf("{");
  if (i >= 0) {
    const s = i + 1;
    return `${t.slice(0, s)}
 :${e} ${n}${t.slice(s)}`;
  }
  return t;
}
function S0(t) {
  return t ? t.trim().replace(/^:/, "").replace(/^"|"$/g, "") : "";
}
function Dte(t) {
  return JSON.stringify(t);
}
function Lte(t) {
  const e = t.trim().replace(/^:/, "");
  return e ? `:${e}` : ":agent";
}
function k0(t, e) {
  const n = new RegExp(`(:agent[\\s\\S]{0,400}?:${e}\\s+)([^\\s\\n\\r}]+)`, "m"), r = t.match(n);
  return r != null && r[2] ? r[2].trim() : null;
}
function E0(t, e, n) {
  const r = new RegExp(`(:agent[\\s\\S]{0,400}?:${e}\\s+)([^\\s\\n\\r}]+)`, "m");
  return r.test(t) ? t.replace(r, `$1${n}`) : t;
}
function su({value:t, onChange:e, options:n, disabled:r, label:i, placeholder:s}) {
  const [o, a] = (0,require$react.useState)(!1), [l, c] = (0,require$react.useState)(""), u = (0,require$react.useMemo)(() => n.filter(f => f.toLowerCase().includes(l.toLowerCase())), [n, l]), h = _c().palette;
  return (0,require$react_SLASH_jsx_runtime.jsxs)("label", {style:{display:"flex", flexDirection:"column", gap:4}, children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{fontSize:O.fontSize.xs, fontWeight:600, textTransform:"uppercase", letterSpacing:"0.05em", color:h.fg.muted}, children:i}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{position:"relative"}, children:[(0,require$react_SLASH_jsx_runtime.jsx)("input", {value:o ? l : t, onChange:f => {
    c(f.target.value), o || a(!0);
  }, onFocus:() => {
    a(!0), c("");
  }, onBlur:() => setTimeout(() => a(!1), 150), disabled:r, style:{width:"100%", borderRadius:O.radius.md, border:`1px solid ${h.fg.subtle}`, background:h.bg.darker, padding:"6px 10px", fontSize:O.fontSize.sm, color:h.fg.default, outline:"none"}, placeholder:s ?? "Select\u2026"}), o && u.length > 0 ? (0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{position:"absolute", zIndex:20, marginTop:4, maxHeight:180, width:"100%", overflow:"auto", borderRadius:O.radius.md, border:`1px solid ${h.fg.subtle}`, 
  background:h.bg.darker, padding:"4px 0"}, children:u.map(f => (0,require$react_SLASH_jsx_runtime.jsx)("button", {type:"button", onMouseDown:() => {
    e(f), a(!1), c("");
  }, style:{width:"100%", padding:"6px 10px", textAlign:"left", fontSize:O.fontSize.sm, color:f === t ? h.accent.cyan : h.fg.default, background:f === t ? "rgba(102, 217, 239, 0.1)" : "transparent", border:"none", cursor:"pointer"}, children:f}, f))}) : null]})]});
}
function g2({label:t, value:e, onChange:n, suggestions:r, disabled:i}) {
  const [s, o] = (0,require$react.useState)(""), a = (0,require$react.useMemo)(() => s ? r.filter(u => u.toLowerCase().includes(s.toLowerCase()) && !e.includes(u)) : [], [s, r, e]), l = _c().palette, c = (0,require$react.useCallback)(u => {
    const h = u.trim();
    !h || e.includes(h) || (n([...e, h]), o(""));
  }, [n, e]);
  return (0,require$react_SLASH_jsx_runtime.jsxs)("label", {style:{display:"flex", flexDirection:"column", gap:4}, children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{fontSize:O.fontSize.xs, fontWeight:600, textTransform:"uppercase", letterSpacing:"0.05em", color:l.fg.muted}, children:t}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{display:"flex", flexWrap:"wrap", gap:4, borderRadius:O.radius.md, border:`1px solid ${l.fg.subtle}`, background:l.bg.darker, padding:6}, children:[e.map(u => 
  (0,require$react_SLASH_jsx_runtime.jsxs)("span", {style:{display:"inline-flex", alignItems:"center", gap:4, borderRadius:O.radius.xs, border:"1px solid rgba(102, 217, 239, 0.3)", background:"rgba(102, 217, 239, 0.1)", padding:"2px 8px", fontSize:O.fontSize.xs, color:l.accent.cyan}, children:[u, (0,require$react_SLASH_jsx_runtime.jsx)("button", {type:"button", onClick:() => n(e.filter(h => h !== u)), disabled:i, style:{background:"none", border:"none", color:l.accent.cyan, cursor:"pointer", padding:0, 
  fontSize:"14px", lineHeight:1}, children:"\u00d7"})]}, u)), (0,require$react_SLASH_jsx_runtime.jsx)("input", {value:s, onChange:u => o(u.target.value), onKeyDown:u => {
    u.key === "Enter" && s.trim() && (u.preventDefault(), c(s)), u.key === "Backspace" && !s && e.length > 0 && n(e.slice(0, -1));
  }, disabled:i, style:{minWidth:70, flex:1, background:"transparent", fontSize:O.fontSize.sm, color:l.fg.default, outline:"none", border:"none"}, placeholder:"Type + Enter\u2026"})]}), a.length > 0 ? (0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{maxHeight:120, overflow:"auto", borderRadius:O.radius.md, border:`1px solid ${l.fg.subtle}`, background:l.bg.darker, padding:"4px 0", fontSize:O.fontSize.xs}, children:a.slice(0, 8).map(u => (0,require$react_SLASH_jsx_runtime.jsx)("button", {type:"button", 
  onMouseDown:() => c(u), style:{width:"100%", padding:"4px 8px", textAlign:"left", color:l.fg.default, background:"transparent", border:"none", cursor:"pointer"}, children:u}, u))}) : null]});
}
function Mte(t, e) {
  switch(t) {
    case "running":
      return e.accent.green;
    case "idle":
      return e.accent.cyan;
    case "disabled":
      return e.fg.muted;
    case "error":
      return e.accent.red;
    default:
      return e.fg.soft;
  }
}
function Bte(t) {
  switch(t) {
    case "running":
      return "\u25cf";
    case "idle":
      return "\u25d0";
    case "disabled":
      return "\u25cb";
    case "error":
      return "\u2715";
    default:
      return "\u00b7";
  }
}
function Qhe() {
  const t = _c(), e = t.palette;
  t.colors;
  const [n, r] = (0,require$react.useState)([]), [i, s] = (0,require$react.useState)(!0), [o, a] = (0,require$react.useState)([]), [l, c] = (0,require$react.useState)(null), [u, h] = (0,require$react.useState)("agents"), [f, p] = (0,require$react.useState)(Fm), [g, m] = (0,require$react.useState)(null), [b, x] = (0,require$react.useState)(null), [w, v] = (0,require$react.useState)(null), [T, I] = (0,require$react.useState)(""), [_, N] = (0,require$react.useState)(!1), [E, C] = (0,require$react.useState)(!1), 
  [k, A] = (0,require$react.useState)(""), [P, W] = (0,require$react.useState)(!1), [F, B] = (0,require$react.useState)(!1), [z, j] = (0,require$react.useState)(null), [V, ne] = (0,require$react.useState)(!0), D = Ote(Ite), [ie, ee] = (0,require$react.useState)(() => {
    const xe = localStorage.getItem(d2);
    return xe !== null ? xe === "true" : !0;
  }), M = (0,require$react.useCallback)(() => {
    ee(xe => {
      const de = !xe;
      return localStorage.setItem(d2, String(de)), de;
    });
  }, []), [X, ge] = (0,require$react.useState)(() => {
    const xe = localStorage.getItem(u2);
    return xe !== null ? xe === "true" : !0;
  }), me = (0,require$react.useCallback)(() => {
    ge(xe => {
      const de = !xe;
      return localStorage.setItem(u2, String(de)), de;
    });
  }, []), te = Pg({initialShowCanvas:!1, initialSidebarWidthPx:420, defaultRole:"contract_librarian", defaultActorId:"contract_librarian", sessionIdKey:Ete, scratchpadStorageKey:Tte, pinnedContextStorageKey:Cte, sessionStateKey:Ate, sidebarWidthKey:Nte}), q = g == null ? f.trim().length > 0 : f !== g, R = (b == null ? void 0 : b.errors) ?? [], $ = (0,require$react.useCallback)(async() => {
    var xe, de, qe, dt;
    s(!0);
    try {
      const [gt, ze] = await Promise.all([uq().catch(() => ({contracts:[]})), UA().catch(() => null)]);
      a(gt.contracts);
      const kt = ((xe = ze == null ? void 0 : ze.runtime) == null ? void 0 : xe.jobs) ?? [], Dt = ((de = ze == null ? void 0 : ze.control) == null ? void 0 : de.jobs) ?? [], Et = [];
      for (const yt of gt.contracts) {
        const Ut = yt.contractClass === "agents" ? kt.find(Lt => Lt.id === yt.id) : void 0, en = yt.contractClass === "agents" ? Dt.find(Lt => Lt.id === yt.id) : void 0, Fn = (Ut == null ? void 0 : Ut.running) ?? !1, Sn = (en == null ? void 0 : en.enabled) ?? yt.enabled;
        Et.push({id:yt.id, contractClass:yt.contractClass, label:yt.id, title:yt.title, version:yt.version, status:Sn ? Fn ? "running" : "idle" : "disabled", triggerKind:((qe = en == null ? void 0 : en.trigger) == null ? void 0 : qe.kind) ?? yt.contractClass.slice(0, -1), sourceKind:((dt = en == null ? void 0 : en.source) == null ? void 0 : dt.kind) ?? yt.contractClass, model:void 0, lastStatus:Ut == null ? void 0 : Ut.lastStatus, isContract:!0, isRuntimeJob:!!Ut, enabled:Sn});
      }
      for (const yt of kt) {
        Et.some(Ut => Ut.id === yt.id && Ut.contractClass === "agents") || Et.push({id:yt.id, contractClass:"agents", label:yt.id, status:yt.running ? "running" : "idle", triggerKind:"event", sourceKind:"unknown", lastStatus:yt.lastStatus, isContract:!1, isRuntimeJob:!0, enabled:!0});
      }
      const Tt = Array.from((new Map(Et.map(yt => [`${yt.contractClass}:${yt.id}`, yt]))).values());
      r(Tt), !l && Tt.length > 0 && (c(Tt[0].id), h(Tt[0].contractClass));
    } catch (gt) {
      I(gt instanceof Error ? gt.message : String(gt));
    } finally {
      s(!1);
    }
  }, [l]), G = (0,require$react.useCallback)(async(xe, de) => {
    I("");
    try {
      const qe = await dq(xe, de);
      p(qe.ednText), m(qe.ednText), x({...qe.validation, contract:qe.contract}), j(qe.contract), te.pinContextItem({id:`contract:${xe}`, title:xe, path:`/ops/contracts/${de}/${xe}`, snippet:qe.ednText.slice(0, 240), kind:"file"});
    } catch (qe) {
      I(qe instanceof Error ? qe.message : String(qe)), p(""), m(null), x(null), j(null);
    }
  }, []);
  (0,require$react.useEffect)(() => {
    $();
  }, [$]), (0,require$react.useEffect)(() => {
    l ? G(l, u) : (p(Fm), m(null), x(null), j(null));
  }, [l, u, G]);
  const [J, U] = (0,require$react.useState)(""), [le, be] = (0,require$react.useState)(new Set()), je = (0,require$react.useCallback)(xe => {
    be(de => {
      const qe = new Set(de);
      return qe.has(xe) ? qe.delete(xe) : qe.add(xe), qe;
    });
  }, []), Ae = J.trim().length > 0, ue = (0,require$react.useMemo)(() => {
    const xe = J.toLowerCase(), de = new Map();
    for (const qe of n) {
      if (xe && !qe.id.toLowerCase().includes(xe)) {
        continue;
      }
      const dt = qe.contractClass;
      de.has(dt) || de.set(dt, []), de.get(dt).push(qe);
    }
    return Array.from(de.entries()).sort(([qe], [dt]) => qe.localeCompare(dt));
  }, [n, J]), Le = (0,require$react.useCallback)(async() => {
    C(!0), v(null), I("");
    try {
      const xe = await fq(f, u);
      x(xe), xe.contract && j(xe.contract), v(xe.ok ? {tone:"success", text:"Validation passed."} : {tone:"error", text:`Validation failed: ${xe.errors.length} error(s).`});
    } catch (xe) {
      v({tone:"error", text:xe instanceof Error ? xe.message : String(xe)});
    } finally {
      C(!1);
    }
  }, [f, u]), $e = (0,require$react.useCallback)(async() => {
    const xe = l ? h2(l) : null, qe = Rte(f) || xe;
    if (!qe) {
      v({tone:"error", text:"Missing contract id."});
      return;
    }
    N(!0), v(null), I("");
    try {
      const dt = await hq(qe, f, u);
      c(qe), h(u), p(dt.ednText), m(dt.ednText), x({...dt.validation, contract:dt.contract}), j(dt.contract), v(dt.validation.ok ? {tone:"success", text:`Saved ${qe}.`} : {tone:"error", text:`Saved ${qe}, but validation has ${dt.validation.errors.length} error(s).`}), await $();
    } catch (dt) {
      v({tone:"error", text:dt instanceof Error ? dt.message : String(dt)});
    } finally {
      N(!1);
    }
  }, [f, $, u, l]), Ye = (0,require$react.useCallback)(async() => {
    if (!l) {
      return;
    }
    const xe = h2(k);
    if (xe) {
      N(!0), v(null), I("");
      try {
        const de = await pq(l, xe, u);
        v({tone:"success", text:`Copied ${l} \u2192 ${xe}.`}), c(xe), p(de.ednText), m(de.ednText), x({...de.validation, contract:de.contract}), j(de.contract), A(""), W(!1), await $();
      } catch (de) {
        v({tone:"error", text:de instanceof Error ? de.message : String(de)});
      } finally {
        N(!1);
      }
    }
  }, [k, $, u, l]), Me = S0(Co(f, "contract/id")) || l || "new-agent", Xe = S0(Co(f, "contract/kind")) || u.slice(0, -1) || "agent", it = S0(Co(f, "contract/version")) || "1", se = Co(f, "enabled"), oe = Co(f, "trigger-kind") ?? ":event", we = Co(f, "source-kind") ?? ":discord", ke = Co(f, "source-mode") ?? ":patrol", fe = Co(f, "cadence-min") ?? "5", Oe = k0(f, "role") ?? ":system_admin", We = k0(f, "model") ?? '"glm-5"', rt = k0(f, "thinking") ?? ":off", st = (0,require$react.useMemo)(() => f2(f, 
  ":always"), [f]), ft = (0,require$react.useMemo)(() => f2(f, ":maybe"), [f]), St = (0,require$react.useMemo)(() => gq.map(xe => xe.startsWith(":") ? xe.slice(1) : xe), []), ht = (0,require$react.useMemo)(() => n.find(xe => xe.id === l && xe.contractClass === u) ?? null, [n, u, l]);
  return (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{display:"flex", flex:"1 1 0%", minHeight:0, minWidth:0, flexDirection:"column", background:e.bg.default, color:e.fg.default}, children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{display:"flex", flex:"1 1 0%", minHeight:0, minWidth:0, overflow:"hidden", position:"relative"}, children:[D && ie ? (0,require$react_SLASH_jsx_runtime.jsx)("button", {type:"button", "aria-label":"Close contracts panel", onClick:M, style:{position:"absolute", 
  inset:0, zIndex:14, border:"none", background:"rgba(0, 0, 0, 0.45)", padding:0, cursor:"pointer"}}) : null, ie ? (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{width:D ? "min(88vw, 360px)" : 360, minWidth:D ? "min(88vw, 320px)" : 300, maxWidth:D ? "calc(100vw - 40px)" : void 0, borderRight:`1px solid ${e.fg.subtle}`, display:"flex", flexDirection:"column", background:e.bg.darker, overflow:"hidden", position:D ? "absolute" : "relative", inset:D ? "0 auto 0 0" : void 0, zIndex:D ? 15 : void 0, 
  boxShadow:D ? "0 12px 36px rgba(0, 0, 0, 0.45)" : void 0}, children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{padding:"16px 16px 12px", borderBottom:`1px solid ${e.fg.subtle}`, display:"flex", alignItems:"center", justifyContent:"space-between", gap:10}, children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{minWidth:0}, children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{fontSize:O.fontSize.lg, fontWeight:600, color:e.fg.default}, children:"Contracts"}), 
  (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{fontSize:O.fontSize.xs, color:e.fg.muted, marginTop:4}, children:[n.length, " contract", n.length !== 1 ? "s" : "", " \u00b7 ", (new Set(n.map(xe => xe.contractClass))).size, " class", (new Set(n.map(xe => xe.contractClass))).size !== 1 ? "es" : ""]})]}), (0,require$react_SLASH_jsx_runtime.jsx)("button", {type:"button", onClick:M, style:{padding:"4px 10px", borderRadius:O.radius.sm, border:`1px solid ${e.fg.subtle}`, background:e.bg.default, 
  color:e.fg.soft, fontSize:O.fontSize.xs, cursor:"pointer", flexShrink:0}, children:"Hide"})]}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{flex:1, overflowY:"auto", padding:"10px 10px 12px"}, children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{marginBottom:12}, children:(0,require$react_SLASH_jsx_runtime.jsx)("input", {value:J, onChange:xe => U(xe.target.value), placeholder:"Search contracts...", style:{width:"100%", padding:"8px 10px", borderRadius:O.radius.md, border:`1px solid ${e.fg.subtle}`, 
  background:e.bg.default, color:e.fg.default, fontSize:O.fontSize.sm, outline:"none"}})}), i ? (0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{fontSize:O.fontSize.sm, color:e.fg.muted, padding:"8px"}, children:"Loading agents\u2026"}) : ue.length === 0 ? (0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{fontSize:O.fontSize.sm, color:e.fg.muted, padding:"8px"}, children:"No contracts found."}) : (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{display:"flex", flexDirection:"column", 
  gap:4}, children:[ue.map(([xe, de]) => {
    const qe = le.has(xe), dt = Ae || !qe;
    return (0,require$react_SLASH_jsx_runtime.jsxs)("div", {children:[(0,require$react_SLASH_jsx_runtime.jsxs)("button", {type:"button", onClick:() => !Ae && je(xe), disabled:Ae, style:{width:"100%", padding:"8px 10px", textAlign:"left", borderRadius:O.radius.sm, border:"none", background:"rgba(255,255,255,0.03)", color:e.fg.muted, fontSize:O.fontSize.xs, fontWeight:600, textTransform:"uppercase", letterSpacing:"0.05em", cursor:Ae ? "default" : "pointer", display:"flex", alignItems:"center", gap:6}, 
    children:[(0,require$react_SLASH_jsx_runtime.jsx)("span", {style:{transform:qe ? "rotate(-90deg)" : "rotate(0deg)", transition:"transform 0.15s"}, children:Ae || qe ? "\u25b8" : "\u25be"}), xe, " (", de.length, ")"]}), dt && de.map(gt => {
      const ze = gt.id === l && gt.contractClass === u;
      return (0,require$react_SLASH_jsx_runtime.jsxs)("button", {type:"button", onClick:() => {
        c(gt.id), h(gt.contractClass), D && ee(!1);
      }, style:{width:"100%", padding:"10px 12px", textAlign:"left", borderRadius:O.radius.md, border:`1px solid ${ze ? e.accent.cyan : "transparent"}`, background:ze ? "rgba(102, 217, 239, 0.08)" : "transparent", cursor:"pointer", transition:"background 0.1s, border-color 0.1s", marginLeft:8}, onMouseEnter:kt => {
        ze || (kt.currentTarget.style.background = "rgba(255,255,255,0.03)");
      }, onMouseLeave:kt => {
        ze || (kt.currentTarget.style.background = "transparent");
      }, children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{display:"flex", alignItems:"center", justifyContent:"space-between", gap:8}, children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{display:"flex", alignItems:"center", gap:6, minWidth:0}, children:(0,require$react_SLASH_jsx_runtime.jsx)("span", {style:{fontSize:O.fontSize.sm, fontWeight:500, color:ze ? e.accent.cyan : e.fg.default, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap"}, children:gt.title ?? 
      gt.id})}), (0,require$react_SLASH_jsx_runtime.jsx)("span", {style:{fontSize:O.fontSize.xs, padding:"1px 6px", borderRadius:O.radius.xs, background:gt.enabled ? "rgba(166, 226, 46, 0.1)" : "rgba(117, 113, 94, 0.15)", color:gt.enabled ? e.accent.green : e.fg.muted}, children:gt.enabled ? "on" : "off"})]}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{display:"flex", gap:8, marginTop:4, fontSize:O.fontSize.xs, color:e.fg.muted}, children:[(0,require$react_SLASH_jsx_runtime.jsx)("span", 
      {children:gt.contractClass}), (0,require$react_SLASH_jsx_runtime.jsx)("span", {children:"\u00b7"}), (0,require$react_SLASH_jsx_runtime.jsx)("span", {children:gt.version != null ? `v${gt.version}` : "runtime"})]})]}, `${gt.contractClass}:${gt.id}`);
    })]}, xe);
  }), (0,require$react_SLASH_jsx_runtime.jsx)("button", {type:"button", onClick:() => {
    c(null), h("agents"), p(Fm), m(null), D && ee(!1);
  }, style:{width:"100%", padding:"10px 12px", textAlign:"center", borderRadius:O.radius.md, border:`1px dashed ${e.fg.subtle}`, background:"transparent", cursor:"pointer", fontSize:O.fontSize.sm, color:e.fg.muted, marginTop:8}, children:"+ New contract"})]})]})]}) : D ? null : (0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{width:38, borderRight:`1px solid ${e.fg.subtle}`, background:e.bg.darker, display:"flex", alignItems:"center", justifyContent:"center"}, children:(0,require$react_SLASH_jsx_runtime.jsx)("button", 
  {type:"button", onClick:M, style:{writingMode:"vertical-rl", transform:"rotate(180deg)", padding:"10px 6px", borderRadius:O.radius.sm, border:`1px solid ${e.fg.subtle}`, background:e.bg.default, color:e.fg.soft, fontSize:O.fontSize.xs, cursor:"pointer"}, children:"Show"})}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{flex:1, display:"flex", flexDirection:"column", minWidth:0, overflow:"hidden"}, children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{padding:D ? "12px 14px" : 
  "12px 20px", borderBottom:`1px solid ${e.fg.subtle}`, display:"flex", alignItems:D ? "flex-start" : "center", justifyContent:"space-between", gap:16, flexDirection:D ? "column" : "row", background:e.bg.darker}, children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{display:"flex", alignItems:"center", gap:12, minWidth:0}, children:ht ? (0,require$react_SLASH_jsx_runtime.jsxs)(require$react_SLASH_jsx_runtime.Fragment, {children:[(0,require$react_SLASH_jsx_runtime.jsx)("span", {style:{color:Mte(ht.status, 
  e), fontSize:14}, children:Bte(ht.status)}), (0,require$react_SLASH_jsx_runtime.jsx)("span", {style:{fontSize:O.fontSize.base, fontWeight:600, color:e.fg.default}, children:ht.label}), (0,require$react_SLASH_jsx_runtime.jsxs)("span", {style:{fontSize:O.fontSize.xs, color:e.fg.muted}, children:[ht.contractClass, " \u00b7 ", ht.triggerKind, " \u00b7 ", ht.sourceKind]})]}) : (0,require$react_SLASH_jsx_runtime.jsx)("span", {style:{fontSize:O.fontSize.base, fontWeight:600, color:e.fg.default}, children:"New contract"})}), 
  (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{display:"flex", gap:6, flexWrap:"wrap", width:D ? "100%" : void 0}, children:[(0,require$react_SLASH_jsx_runtime.jsx)("button", {type:"button", onClick:M, style:{padding:"5px 12px", borderRadius:O.radius.sm, border:`1px solid ${ie ? e.accent.cyan : e.fg.subtle}`, background:ie ? "rgba(102, 217, 239, 0.08)" : e.bg.default, color:ie ? e.accent.cyan : e.fg.soft, fontSize:O.fontSize.xs, cursor:"pointer"}, children:ie ? "\u2715 Left" : "\u2630 Left"}), 
  (0,require$react_SLASH_jsx_runtime.jsx)("button", {type:"button", onClick:() => void $(), disabled:i, style:{padding:"5px 12px", borderRadius:O.radius.sm, border:`1px solid ${e.fg.subtle}`, background:e.bg.default, color:e.fg.soft, fontSize:O.fontSize.xs, cursor:"pointer"}, children:i ? "Loading\u2026" : "Refresh"}), (0,require$react_SLASH_jsx_runtime.jsx)("button", {type:"button", onClick:() => void Le(), disabled:E, style:{padding:"5px 12px", borderRadius:O.radius.sm, border:`1px solid ${e.accent.green}`, 
  background:"rgba(166, 226, 46, 0.08)", color:e.accent.green, fontSize:O.fontSize.xs, cursor:"pointer"}, children:E ? "Validating\u2026" : "\u2713 Validate"}), (0,require$react_SLASH_jsx_runtime.jsx)("button", {type:"button", onClick:() => void $e(), disabled:_ || !q, style:{padding:"5px 12px", borderRadius:O.radius.sm, border:"none", background:e.accent.cyan, color:e.bg.default, fontSize:O.fontSize.xs, fontWeight:600, cursor:"pointer", opacity:_ || !q ? 0.5 : 1}, children:_ ? "Saving\u2026" : "Save"}), 
  (0,require$react_SLASH_jsx_runtime.jsx)("button", {type:"button", onClick:() => W(xe => !xe), disabled:!l, style:{padding:"5px 12px", borderRadius:O.radius.sm, border:`1px solid ${e.fg.subtle}`, background:e.bg.default, color:e.fg.soft, fontSize:O.fontSize.xs, cursor:"pointer"}, children:"Clone"}), (0,require$react_SLASH_jsx_runtime.jsx)("button", {type:"button", onClick:() => B(xe => !xe), style:{padding:"5px 12px", borderRadius:O.radius.sm, border:`1px solid ${e.fg.subtle}`, background:e.bg.default, 
  color:e.fg.soft, fontSize:O.fontSize.xs, cursor:"pointer"}, children:F ? "Hide JSON" : "Show JSON"}), (0,require$react_SLASH_jsx_runtime.jsx)("button", {type:"button", onClick:() => ne(xe => !xe), style:{padding:"5px 12px", borderRadius:O.radius.sm, border:`1px solid ${V ? e.accent.cyan : e.fg.subtle}`, background:V ? "rgba(102, 217, 239, 0.08)" : e.bg.default, color:V ? e.accent.cyan : e.fg.soft, fontSize:O.fontSize.xs, cursor:"pointer"}, children:V ? "\u2715 Chat" : "\ud83d\udcac Chat"})]})]}), 
  P ? (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{padding:"8px 20px", display:"flex", alignItems:"center", gap:8, borderBottom:`1px solid ${e.fg.subtle}`, background:e.bg.darker}, children:[(0,require$react_SLASH_jsx_runtime.jsx)("span", {style:{fontSize:O.fontSize.xs, color:e.fg.muted}, children:"New ID"}), (0,require$react_SLASH_jsx_runtime.jsx)("input", {value:k, onChange:xe => A(xe.target.value), placeholder:"new-contract-id", style:{flex:1, padding:"4px 10px", borderRadius:O.radius.sm, 
  border:`1px solid ${e.fg.subtle}`, background:e.bg.default, color:e.fg.default, fontSize:O.fontSize.sm, outline:"none"}}), (0,require$react_SLASH_jsx_runtime.jsx)("button", {type:"button", onClick:() => void Ye(), disabled:!k.trim(), style:{padding:"4px 12px", borderRadius:O.radius.sm, border:"none", background:e.accent.cyan, color:e.bg.default, fontSize:O.fontSize.xs, fontWeight:600, cursor:"pointer"}, children:"Clone"})]}) : null, (0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{flexShrink:0, 
  padding:D ? "10px 14px" : "12px 20px", borderBottom:`1px solid ${e.fg.subtle}`, background:e.bg.default}, children:(0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{display:"grid", gridTemplateColumns:D ? "1fr" : "minmax(180px, 1.2fr) minmax(120px, 0.7fr) minmax(100px, 0.45fr) auto", gap:10, alignItems:"end"}, children:[(0,require$react_SLASH_jsx_runtime.jsxs)("label", {style:{display:"flex", flexDirection:"column", gap:4}, children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{fontSize:O.fontSize.xs, 
  fontWeight:600, textTransform:"uppercase", letterSpacing:"0.05em", color:e.fg.muted}, children:"Contract identity"}), (0,require$react_SLASH_jsx_runtime.jsx)("input", {value:Me, onChange:xe => p(de => js(de, "contract/id", Dte(xe.target.value))), disabled:_, style:{width:"100%", padding:"7px 10px", borderRadius:O.radius.md, border:`1px solid ${e.fg.subtle}`, background:e.bg.darker, color:e.fg.default, fontSize:O.fontSize.sm, outline:"none"}})]}), (0,require$react_SLASH_jsx_runtime.jsxs)("label", 
  {style:{display:"flex", flexDirection:"column", gap:4}, children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{fontSize:O.fontSize.xs, fontWeight:600, textTransform:"uppercase", letterSpacing:"0.05em", color:e.fg.muted}, children:"Kind"}), (0,require$react_SLASH_jsx_runtime.jsx)("select", {value:Xe, onChange:xe => p(de => js(de, "contract/kind", Lte(xe.target.value))), disabled:_, style:{width:"100%", padding:"7px 10px", borderRadius:O.radius.md, border:`1px solid ${e.fg.subtle}`, background:e.bg.darker, 
  color:e.fg.default, fontSize:O.fontSize.sm, outline:"none"}, children:["agent", "policy", "fulfillment", "tool-call", "trigger"].map(xe => (0,require$react_SLASH_jsx_runtime.jsx)("option", {value:xe, children:xe}, xe))})]}), (0,require$react_SLASH_jsx_runtime.jsxs)("label", {style:{display:"flex", flexDirection:"column", gap:4}, children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{fontSize:O.fontSize.xs, fontWeight:600, textTransform:"uppercase", letterSpacing:"0.05em", color:e.fg.muted}, 
  children:"Version"}), (0,require$react_SLASH_jsx_runtime.jsx)("input", {type:"number", min:1, value:it, onChange:xe => p(de => js(de, "contract/version", String(Math.max(1, Number(xe.target.value || 1))))), disabled:_, style:{width:"100%", padding:"7px 10px", borderRadius:O.radius.md, border:`1px solid ${e.fg.subtle}`, background:e.bg.darker, color:e.fg.default, fontSize:O.fontSize.sm, outline:"none"}})]}), (0,require$react_SLASH_jsx_runtime.jsxs)("label", {style:{display:"inline-flex", alignItems:"center", 
  gap:8, minHeight:34, padding:"0 4px", fontSize:O.fontSize.sm, color:e.fg.default}, children:[(0,require$react_SLASH_jsx_runtime.jsx)("input", {type:"checkbox", checked:se !== "false", onChange:xe => p(de => js(de, "enabled", xe.target.checked ? "true" : "false")), disabled:_}), "Enabled"]})]})}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{flex:1, display:"flex", minHeight:0, overflow:"hidden"}, children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{width:280, minWidth:240, 
  borderRight:`1px solid ${e.fg.subtle}`, background:e.bg.darker, padding:"16px 14px", overflowY:"auto", display:"none"}, children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{fontSize:O.fontSize.xs, fontWeight:600, textTransform:"uppercase", letterSpacing:"0.05em", color:e.fg.muted, marginBottom:4}, children:"Metadata"}), (0,require$react_SLASH_jsx_runtime.jsxs)("label", {style:{display:"flex", alignItems:"center", gap:8, fontSize:O.fontSize.sm, color:e.fg.default}, children:[(0,require$react_SLASH_jsx_runtime.jsx)("input", 
  {type:"checkbox", checked:se !== "false", onChange:xe => p(de => js(de, "enabled", xe.target.checked ? "true" : "false"))}), "Enabled"]}), (0,require$react_SLASH_jsx_runtime.jsx)(su, {label:"Trigger", value:oe.replace(/^:/, ""), onChange:xe => p(de => js(de, "trigger-kind", `:${xe}`)), options:Array.from(yq)}), (0,require$react_SLASH_jsx_runtime.jsx)(su, {label:"Source", value:we.replace(/^:/, ""), onChange:xe => p(de => js(de, "source-kind", `:${xe}`)), options:Array.from(xq)}), (0,require$react_SLASH_jsx_runtime.jsxs)("label", 
  {style:{display:"flex", flexDirection:"column", gap:4}, children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{fontSize:O.fontSize.xs, fontWeight:600, textTransform:"uppercase", letterSpacing:"0.05em", color:e.fg.muted}, children:"Source mode"}), (0,require$react_SLASH_jsx_runtime.jsx)("input", {value:ke.replace(/^:/, ""), onChange:xe => p(de => js(de, "source-mode", `:${xe.target.value}`)), style:{width:"100%", padding:"6px 10px", borderRadius:O.radius.md, border:`1px solid ${e.fg.subtle}`, 
  background:e.bg.default, color:e.fg.default, fontSize:O.fontSize.sm, outline:"none"}})]}), (0,require$react_SLASH_jsx_runtime.jsxs)("label", {style:{display:"flex", flexDirection:"column", gap:4}, children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{fontSize:O.fontSize.xs, fontWeight:600, textTransform:"uppercase", letterSpacing:"0.05em", color:e.fg.muted}, children:"Cadence (min)"}), (0,require$react_SLASH_jsx_runtime.jsx)("input", {type:"number", min:1, value:fe.replace(/[^0-9]/g, 
  "") || "1", onChange:xe => p(de => js(de, "cadence-min", String(Math.max(1, Number(xe.target.value || 1))))), style:{width:"100%", padding:"6px 10px", borderRadius:O.radius.md, border:`1px solid ${e.fg.subtle}`, background:e.bg.default, color:e.fg.default, fontSize:O.fontSize.sm, outline:"none"}})]}), (0,require$react_SLASH_jsx_runtime.jsx)(su, {label:"Role", value:Oe.replace(/^:/, "").replace(/"/g, ""), onChange:xe => p(de => E0(de, "role", `:${xe}`)), options:bq}), (0,require$react_SLASH_jsx_runtime.jsx)(su, 
  {label:"Model", value:We.replace(/^"|"$/g, ""), onChange:xe => p(de => E0(de, "model", `"${xe}"`)), options:mq}), (0,require$react_SLASH_jsx_runtime.jsx)(su, {label:"Thinking", value:rt.replace(/^:/, ""), onChange:xe => p(de => E0(de, "thinking", `:${xe}`)), options:Array.from(pN)}), (0,require$react_SLASH_jsx_runtime.jsx)(g2, {label:"Events (always)", value:st, onChange:xe => p(de => p2(de, ":always", xe)), suggestions:St}), (0,require$react_SLASH_jsx_runtime.jsx)(g2, {label:"Events (maybe)", 
  value:ft, onChange:xe => p(de => p2(de, ":maybe", xe)), suggestions:St}), b ? (0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{padding:"6px 10px", borderRadius:O.radius.md, fontSize:O.fontSize.xs, border:`1px solid ${b.ok ? "rgba(166, 226, 46, 0.3)" : "rgba(249, 38, 114, 0.3)"}`, background:b.ok ? "rgba(166, 226, 46, 0.08)" : "rgba(249, 38, 114, 0.08)", color:b.ok ? e.accent.green : e.accent.red}, children:b.ok ? "\u2713 Valid" : `\u2715 ${b.errors.length} error(s)`}) : null, q ? (0,require$react_SLASH_jsx_runtime.jsx)("div", 
  {style:{fontSize:O.fontSize.xs, color:e.accent.orange, padding:"4px 0"}, children:"\u25cf unsaved changes"}) : null]}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{flex:1, display:"flex", flexDirection:"column", minWidth:0, overflow:"hidden"}, children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{flex:1, minHeight:0}, children:(0,require$react_SLASH_jsx_runtime.jsx)(kte, {value:f, onChange:p, height:"100%", placeholder:"Enter EDN contract\u2026", externalErrors:R.map(xe => 
  ({message:xe.path.length ? `${xe.path.join(".")}: ${xe.message}` : xe.message})), onValidate:() => void Le(), fileName:l ?? "new-contract.edn"})}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{flexShrink:0}, children:[F ? (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{borderTop:`1px solid ${e.fg.subtle}`, padding:"12px 16px", background:e.bg.darker}, children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{fontSize:O.fontSize.xs, fontWeight:600, textTransform:"uppercase", 
  letterSpacing:"0.05em", color:e.fg.muted, marginBottom:8}, children:"Normalized view"}), (0,require$react_SLASH_jsx_runtime.jsx)("pre", {style:{maxHeight:200, overflow:"auto", padding:12, borderRadius:O.radius.md, background:e.bg.default, fontSize:O.fontSize.xs, color:e.fg.soft}, children:Pte(z)})]}) : null, w ? (0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{padding:"8px 16px", fontSize:O.fontSize.sm, borderTop:`1px solid ${w.tone === "success" ? "rgba(166, 226, 46, 0.3)" : "rgba(249, 38, 114, 0.3)"}`, 
  background:w.tone === "success" ? "rgba(166, 226, 46, 0.06)" : "rgba(249, 38, 114, 0.06)", color:w.tone === "success" ? e.accent.green : e.accent.red}, children:w.text}) : null, T ? (0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{padding:"8px 16px", fontSize:O.fontSize.sm, borderTop:"1px solid rgba(249, 38, 114, 0.3)", background:"rgba(249, 38, 114, 0.06)", color:e.accent.red}, children:T}) : null]})]})]})]}), !D && V ? (0,require$react_SLASH_jsx_runtime.jsxs)("aside", {style:{width:460, 
  minWidth:380, borderLeft:`1px solid ${e.fg.subtle}`, display:"flex", flexDirection:"column", minHeight:0, overflow:"hidden", background:e.bg.darker}, children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{padding:"6px 12px", borderBottom:`1px solid ${e.fg.subtle}`, display:"flex", alignItems:"center", justifyContent:"space-between", fontSize:O.fontSize.xs}, children:[(0,require$react_SLASH_jsx_runtime.jsx)("span", {style:{color:e.fg.muted, fontWeight:600, textTransform:"uppercase", letterSpacing:"0.05em"}, 
  children:"\ud83d\udccb Contract Librarian"}), (0,require$react_SLASH_jsx_runtime.jsxs)("label", {style:{display:"flex", alignItems:"center", gap:6, cursor:"pointer", color:X ? e.accent.cyan : e.fg.muted}, children:[(0,require$react_SLASH_jsx_runtime.jsx)("input", {type:"checkbox", checked:X, onChange:me, style:{cursor:"pointer"}}), "Auto-focus"]})]}), (0,require$react_SLASH_jsx_runtime.jsx)(fd, {controller:te, showFiles:!1, showCanvasToggle:!1, onShowFiles:() => {
  }, onOpenHydrationSource:xe => {
    if (X) {
      const de = xe.path.split("/").pop() ?? xe.path;
      de && (c(de), h("agents"));
    }
  }, onOpenSourceInPreview:xe => {
    if (X) {
      const de = xe.url.split("/").pop() ?? xe.url;
      de && (c(de), h("agents"));
    }
  }})]}) : null]}), D && V ? (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{height:"42dvh", minHeight:240, maxHeight:"60dvh", borderTop:`1px solid ${e.fg.subtle}`, background:e.bg.darker, display:"flex", flexDirection:"column", overflow:"hidden"}, children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{padding:"6px 12px", borderBottom:`1px solid ${e.fg.subtle}`, display:"flex", alignItems:"center", justifyContent:"space-between", fontSize:O.fontSize.xs}, children:[(0,require$react_SLASH_jsx_runtime.jsx)("span", 
  {style:{color:e.fg.muted, fontWeight:600, textTransform:"uppercase", letterSpacing:"0.05em"}, children:"\ud83d\udccb Contract Librarian"}), (0,require$react_SLASH_jsx_runtime.jsxs)("label", {style:{display:"flex", alignItems:"center", gap:6, cursor:"pointer", color:X ? e.accent.cyan : e.fg.muted}, children:[(0,require$react_SLASH_jsx_runtime.jsx)("input", {type:"checkbox", checked:X, onChange:me, style:{cursor:"pointer"}}), "Auto-focus"]})]}), (0,require$react_SLASH_jsx_runtime.jsx)(fd, {controller:te, 
  showFiles:!1, showCanvasToggle:!1, onShowFiles:() => {
  }, onOpenHydrationSource:xe => {
    if (X) {
      const de = xe.path.split("/").pop() ?? xe.path;
      de && (c(de), h("agents"));
    }
  }, onOpenSourceInPreview:xe => {
    if (X) {
      const de = xe.url.split("/").pop() ?? xe.url;
      de && (c(de), h("agents"));
    }
  }})]}) : null]});
}
const $te = `
  attribute vec2 aPos;
  attribute vec4 aColor;
  attribute float aPhase;

  uniform vec2 uResolution;
  uniform vec2 uPan;
  uniform float uScale;

  varying vec4 vColor;
  varying float vPhase;

  void main() {
    vec2 posPx = aPos * uScale + uPan + 0.5 * uResolution;
    vec2 clip = vec2(
      (posPx.x / max(1.0, uResolution.x)) * 2.0 - 1.0,
1.0 - (posPx.y / max(1.0, uResolution.y)) * 2.0
    );

    gl_Position = vec4(clip, 0.0, 1.0);
    vColor = aColor;
    vPhase = aPhase;
  }
`, Fte = `
  precision mediump float;

  varying vec4 vColor;
  varying float vPhase;

  uniform float uTime;
  uniform float uPulseSpeed;
  uniform float uPulseAmplitude;

  void main() {
    float wave = sin(uTime * uPulseSpeed + vPhase);
    float alpha = clamp(vColor.a * (1.0 + wave * uPulseAmplitude), 0.0, 1.0);
    gl_FragColor = vec4(vColor.rgb, alpha);
  }
`, zte = `
  attribute vec2 aPos;
  attribute float aSize;
  attribute vec4 aColor;

  uniform vec2 uResolution;
  uniform vec2 uPan;
  uniform float uScale;
  uniform float uPixelRatio;
  uniform float uSizeScale;
  uniform float uAlphaScale;

  varying vec4 vColor;

  void main() {
    vec2 posPx = aPos * uScale + uPan + 0.5 * uResolution;
    vec2 clip = vec2(
      (posPx.x / max(1.0, uResolution.x)) * 2.0 - 1.0,
1.0 - (posPx.y / max(1.0, uResolution.y)) * 2.0
    );

    gl_Position = vec4(clip, 0.0, 1.0);
    gl_PointSize = aSize * uPixelRatio * uSizeScale;
    vColor = vec4(aColor.rgb, aColor.a * uAlphaScale);
  }
`, Hte = `
  precision mediump float;
  varying vec4 vColor;

  void main() {
    vec2 p = gl_PointCoord * 2.0 - 1.0;
    float d2 = dot(p, p);
    if (d2 > 1.0) discard;

    float alpha = (1.0 - d2) * vColor.a;
    gl_FragColor = vec4(vColor.rgb, alpha);
  }
`;
function Cy(t, e, n) {
  return Math.max(e, Math.min(n, t));
}
function Wp(t) {
  let e = 2166136261;
  for (let n = 0; n < t.length; n += 1) {
    e ^= t.charCodeAt(n), e = Math.imul(e, 16777619);
  }
  return e >>> 0;
}
function Ute(t, e, n) {
  const r = (t % 1 + 1) % 1, i = (1 - Math.abs(2 * n - 1)) * e, s = r * 6, o = i * (1 - Math.abs(s % 2 - 1));
  let a = 0, l = 0, c = 0;
  s < 1 ? (a = i, l = o) : s < 2 ? (a = o, l = i) : s < 3 ? (l = i, c = o) : s < 4 ? (l = o, c = i) : s < 5 ? (a = o, c = i) : (a = i, c = o);
  const u = n - i / 2;
  return [a + u, l + u, c + u];
}
function Wte(t, e = 0.92) {
  const n = Wp(t) % 360 / 360, [r, i, s] = Ute(n, 0.62, 0.56);
  return [r, i, s, e];
}
function Tr(t, e, n, r) {
  return [t, e, n, r];
}
function m2(t, e, n) {
  const r = t.createShader(e);
  if (!r) {
    throw new Error("WebGL: createShader failed");
  }
  if (t.shaderSource(r, n), t.compileShader(r), !t.getShaderParameter(r, t.COMPILE_STATUS)) {
    const i = t.getShaderInfoLog(r) || "";
    throw t.deleteShader(r), new Error(`WebGL: shader compile failed: ${i}`);
  }
  return r;
}
function b2(t, e, n) {
  const r = m2(t, t.VERTEX_SHADER, e), i = m2(t, t.FRAGMENT_SHADER, n), s = t.createProgram();
  if (!s) {
    throw t.deleteShader(r), t.deleteShader(i), new Error("WebGL: createProgram failed");
  }
  if (t.attachShader(s, r), t.attachShader(s, i), t.linkProgram(s), !t.getProgramParameter(s, t.LINK_STATUS)) {
    const o = t.getProgramInfoLog(s) || "";
    throw t.deleteProgram(s), t.deleteShader(r), t.deleteShader(i), new Error(`WebGL: program link failed: ${o}`);
  }
  return {program:s, vs:r, fs:i};
}
const Ao = 7, Wi = 7;
function P3(t) {
  if (t.color && t.sizePx !== void 0) {
    return {color:t.color, sizePx:t.sizePx};
  }
  if (t.color) {
    return {color:t.color, sizePx:t.sizePx ?? 4.5};
  }
  const e = t.kind || "node";
  return e === "domain" ? {color:Wte(t.id, 0.95), sizePx:t.sizePx ?? 9.5} : e === "content" ? {color:Tr(0.34, 0.88, 0.56, 0.92), sizePx:t.sizePx ?? 6.5} : {color:Tr(0.48, 0.78, 0.98, 0.92), sizePx:t.sizePx ?? 4.8};
}
function jte(t) {
  if (t.color) {
    return {color:t.color, phase:Wp(`${t.source}|${t.target}`) % 628 / 100};
  }
  const e = t.kind || "edge";
  return e === "hyperlink" ? {color:Tr(0.38, 0.84, 0.96, 0.18)} : e === "canonical_redirect" ? {color:Tr(0.82, 0.52, 0.98, 0.22)} : e === "citation" ? {color:Tr(0.98, 0.64, 0.34, 0.24)} : e === "cross_reference" ? {color:Tr(0.92, 0.46, 0.84, 0.22)} : e === "paper_pdf" ? {color:Tr(0.42, 0.9, 0.9, 0.22)} : {color:Tr(0.56, 0.88, 0.66, 0.18)};
}
function Vte(t) {
  return {sizePx:P3(t).sizePx + 7, color:Tr(1, 0.94, 0.72, 0.28)};
}
function qte(t) {
  return {background:(t == null ? void 0 : t.background) ?? Tr(0.03, 0.06, 0.11, 0.98), nodeStyle:(t == null ? void 0 : t.nodeStyle) ?? P3, edgeStyle:(t == null ? void 0 : t.edgeStyle) ?? jte, haloStyle:(t == null ? void 0 : t.haloStyle) ?? Vte, pulseAmplitude:Cy((t == null ? void 0 : t.pulseAmplitude) ?? 0.35, 0, 1), pulseSpeed:(t == null ? void 0 : t.pulseSpeed) ?? 1 / 640, animate:(t == null ? void 0 : t.animate) ?? !0, interaction:(t == null ? void 0 : t.interaction) ?? !0, minScale:(t == null ? 
  void 0 : t.minScale) ?? 0.25, maxScale:(t == null ? void 0 : t.maxScale) ?? 6, zoomStep:(t == null ? void 0 : t.zoomStep) ?? 1.1, pickRadiusPx:(t == null ? void 0 : t.pickRadiusPx) ?? 12, denseNodeThreshold:(t == null ? void 0 : t.denseNodeThreshold) ?? 1e3, denseEdgeThreshold:(t == null ? void 0 : t.denseEdgeThreshold) ?? 2e3, dprCap:(t == null ? void 0 : t.dprCap) ?? {normal:2, dense:1.25}, frameIntervalMs:(t == null ? void 0 : t.frameIntervalMs) ?? {normal:33, dense:50}, onNodeClick:(t == null ? 
  void 0 : t.onNodeClick) ?? (() => {
  })};
}
class R3 {
  constructor(e, n) {
    It(this, "canvas");
    It(this, "gl");
    It(this, "opts");
    It(this, "nodes", []);
    It(this, "edges", []);
    It(this, "nodeIndexById", new Map());
    It(this, "edgeIndicesByNodeId", new Map());
    It(this, "overlay", []);
    It(this, "selectedNodeId", null);
    It(this, "view", {scale:1, offsetX:0, offsetY:0});
    It(this, "destroyed", !1);
    It(this, "raf", 0);
    It(this, "lastPaintAt", 0);
    It(this, "dragging", {active:!1, startX:0, startY:0, baseOffsetX:0, baseOffsetY:0});
    It(this, "lineProgram");
    It(this, "pointProgram");
    It(this, "edgeBuffer");
    It(this, "edgeHighlightBuffer");
    It(this, "nodeBuffer");
    It(this, "haloBuffer");
    It(this, "overlayBuffer");
    It(this, "edgeVertexCount", 0);
    It(this, "edgeHighlightVertexCount", 0);
    It(this, "nodeVertexCount", 0);
    It(this, "haloVertexCount", 0);
    It(this, "overlayVertexCount", 0);
    It(this, "lineLoc");
    It(this, "pointLoc");
    It(this, "draw", e => {
      this.destroyed || (this.render(e), this.opts.animate && (this.raf = window.requestAnimationFrame(this.draw)));
    });
    It(this, "onWheel");
    It(this, "onPointerDown");
    It(this, "onPointerMove");
    It(this, "onPointerUp");
    this.canvas = e, this.opts = qte(n);
    const r = e.getContext("webgl", {alpha:!1, antialias:!0});
    if (!r) {
      throw new Error("WebGL not available");
    }
    this.gl = r, this.lineProgram = b2(r, $te, Fte), this.pointProgram = b2(r, zte, Hte);
    const i = r.createBuffer(), s = r.createBuffer(), o = r.createBuffer(), a = r.createBuffer(), l = r.createBuffer();
    if (!i || !s || !o || !a || !l) {
      throw new Error("WebGL: createBuffer failed");
    }
    this.edgeBuffer = i, this.edgeHighlightBuffer = s, this.nodeBuffer = o, this.haloBuffer = a, this.overlayBuffer = l, this.lineLoc = {aPos:r.getAttribLocation(this.lineProgram.program, "aPos"), aColor:r.getAttribLocation(this.lineProgram.program, "aColor"), aPhase:r.getAttribLocation(this.lineProgram.program, "aPhase"), uResolution:r.getUniformLocation(this.lineProgram.program, "uResolution"), uPan:r.getUniformLocation(this.lineProgram.program, "uPan"), uScale:r.getUniformLocation(this.lineProgram.program, 
    "uScale"), uTime:r.getUniformLocation(this.lineProgram.program, "uTime"), uPulseSpeed:r.getUniformLocation(this.lineProgram.program, "uPulseSpeed"), uPulseAmplitude:r.getUniformLocation(this.lineProgram.program, "uPulseAmplitude")}, this.pointLoc = {aPos:r.getAttribLocation(this.pointProgram.program, "aPos"), aSize:r.getAttribLocation(this.pointProgram.program, "aSize"), aColor:r.getAttribLocation(this.pointProgram.program, "aColor"), uResolution:r.getUniformLocation(this.pointProgram.program, 
    "uResolution"), uPan:r.getUniformLocation(this.pointProgram.program, "uPan"), uScale:r.getUniformLocation(this.pointProgram.program, "uScale"), uPixelRatio:r.getUniformLocation(this.pointProgram.program, "uPixelRatio"), uSizeScale:r.getUniformLocation(this.pointProgram.program, "uSizeScale"), uAlphaScale:r.getUniformLocation(this.pointProgram.program, "uAlphaScale")}, r.enable(r.BLEND), r.blendFunc(r.SRC_ALPHA, r.ONE_MINUS_SRC_ALPHA), this.opts.interaction && this.attachInteraction(), this.opts.animate && 
    (this.raf = window.requestAnimationFrame(this.draw));
  }
  destroy() {
    if (this.destroyed) {
      return;
    }
    this.destroyed = !0, window.cancelAnimationFrame(this.raf), this.detachInteraction();
    const e = this.gl;
    e.deleteBuffer(this.edgeBuffer), e.deleteBuffer(this.edgeHighlightBuffer), e.deleteBuffer(this.nodeBuffer), e.deleteBuffer(this.haloBuffer), e.deleteBuffer(this.overlayBuffer), e.deleteProgram(this.lineProgram.program), e.deleteShader(this.lineProgram.vs), e.deleteShader(this.lineProgram.fs), e.deleteProgram(this.pointProgram.program), e.deleteShader(this.pointProgram.vs), e.deleteShader(this.pointProgram.fs);
  }
  setGraph(e) {
    this.nodes = e.nodes, this.edges = e.edges, this.nodeIndexById = new Map(this.nodes.map((n, r) => [n.id, r])), this.edgeIndicesByNodeId = new Map();
    for (let n = 0; n < this.edges.length; n += 1) {
      const r = this.edges[n], i = s => {
        const o = this.edgeIndicesByNodeId.get(s) ?? [];
        o.push(n), this.edgeIndicesByNodeId.set(s, o);
      };
      i(r.source), i(r.target);
    }
    this.rebuildNodeBuffer(), this.rebuildEdgeBuffer(), this.rebuildSelectionBuffers(), this.opts.animate || this.renderOnce();
  }
  setOverlayPoints(e) {
    this.overlay = e, this.rebuildOverlayBuffer(), this.opts.animate || this.renderOnce();
  }
  setView(e) {
    this.view = {scale:e.scale ?? this.view.scale, offsetX:e.offsetX ?? this.view.offsetX, offsetY:e.offsetY ?? this.view.offsetY}, this.opts.animate || this.renderOnce();
  }
  getView() {
    return {...this.view};
  }
  setSelectedNode(e) {
    this.selectedNodeId = e, this.rebuildSelectionBuffers(), this.opts.animate || this.renderOnce();
  }
  fitToGraph(e = 24) {
    if (this.nodes.length === 0) {
      return;
    }
    const n = this.canvas.getBoundingClientRect();
    if (n.width <= 0 || n.height <= 0) {
      return;
    }
    let r = Number.POSITIVE_INFINITY, i = Number.NEGATIVE_INFINITY, s = Number.POSITIVE_INFINITY, o = Number.NEGATIVE_INFINITY;
    for (const g of this.nodes) {
      r = Math.min(r, g.x), i = Math.max(i, g.x), s = Math.min(s, g.y), o = Math.max(o, g.y);
    }
    const a = Math.max(1e-6, i - r), l = Math.max(1e-6, o - s), c = (n.width - e * 2) / a, u = (n.height - e * 2) / l, h = Cy(Math.min(c, u), this.opts.minScale, this.opts.maxScale), f = (r + i) / 2, p = (s + o) / 2;
    this.view.scale = h, this.view.offsetX = -f * h, this.view.offsetY = -p * h, this.opts.animate || this.renderOnce();
  }
  rebuildNodeBuffer() {
    const e = new Float32Array(this.nodes.length * Wi);
    let n = 0;
    for (const i of this.nodes) {
      const s = this.opts.nodeStyle(i), o = s.color;
      e[n++] = i.x, e[n++] = i.y, e[n++] = s.sizePx, e[n++] = o[0], e[n++] = o[1], e[n++] = o[2], e[n++] = o[3];
    }
    const r = this.gl;
    r.bindBuffer(r.ARRAY_BUFFER, this.nodeBuffer), r.bufferData(r.ARRAY_BUFFER, e, r.DYNAMIC_DRAW), this.nodeVertexCount = this.nodes.length;
  }
  rebuildEdgeBuffer() {
    const e = this.gl;
    let n = 0;
    for (const s of this.edges) {
      this.nodeIndexById.has(s.source) && this.nodeIndexById.has(s.target) && (n += 1);
    }
    const r = new Float32Array(n * 2 * Ao);
    let i = 0;
    for (const s of this.edges) {
      const o = this.nodeIndexById.get(s.source), a = this.nodeIndexById.get(s.target);
      if (o === void 0 || a === void 0) {
        continue;
      }
      const l = this.nodes[o], c = this.nodes[a], u = this.opts.edgeStyle(s), h = u.color, f = u.phase ?? Wp(`${s.source}|${s.target}|${s.kind ?? ""}`) % 628 / 100;
      r[i++] = l.x, r[i++] = l.y, r[i++] = h[0], r[i++] = h[1], r[i++] = h[2], r[i++] = h[3], r[i++] = f, r[i++] = c.x, r[i++] = c.y, r[i++] = h[0], r[i++] = h[1], r[i++] = h[2], r[i++] = h[3], r[i++] = f;
    }
    e.bindBuffer(e.ARRAY_BUFFER, this.edgeBuffer), e.bufferData(e.ARRAY_BUFFER, r, e.DYNAMIC_DRAW), this.edgeVertexCount = n * 2;
  }
  rebuildSelectionBuffers() {
    const e = this.gl;
    this.haloVertexCount = 0, this.edgeHighlightVertexCount = 0;
    const n = this.selectedNodeId;
    if (!n) {
      e.bindBuffer(e.ARRAY_BUFFER, this.haloBuffer), e.bufferData(e.ARRAY_BUFFER, new Float32Array(0), e.DYNAMIC_DRAW), e.bindBuffer(e.ARRAY_BUFFER, this.edgeHighlightBuffer), e.bufferData(e.ARRAY_BUFFER, new Float32Array(0), e.DYNAMIC_DRAW);
      return;
    }
    const r = this.nodeIndexById.get(n), i = r === void 0 ? null : this.nodes[r];
    if (i) {
      const l = this.opts.haloStyle(i), c = l.color, u = new Float32Array([i.x, i.y, l.sizePx, c[0], c[1], c[2], c[3]]);
      e.bindBuffer(e.ARRAY_BUFFER, this.haloBuffer), e.bufferData(e.ARRAY_BUFFER, u, e.DYNAMIC_DRAW), this.haloVertexCount = 1;
    }
    const s = this.edgeIndicesByNodeId.get(n) ?? [];
    if (s.length === 0) {
      e.bindBuffer(e.ARRAY_BUFFER, this.edgeHighlightBuffer), e.bufferData(e.ARRAY_BUFFER, new Float32Array(0), e.DYNAMIC_DRAW);
      return;
    }
    const o = [];
    for (const l of s) {
      const c = this.edges[l];
      if (!c) {
        continue;
      }
      const u = this.nodeIndexById.get(c.source), h = this.nodeIndexById.get(c.target);
      if (u === void 0 || h === void 0) {
        continue;
      }
      const f = this.nodes[u], p = this.nodes[h], g = this.opts.edgeStyle(c), m = g.color, b = g.phase ?? Wp(`${c.source}|${c.target}|${c.kind ?? ""}`) % 628 / 100, x = Math.min(1, m[3] * 3.2);
      o.push(f.x, f.y, m[0], m[1], m[2], x, b), o.push(p.x, p.y, m[0], m[1], m[2], x, b);
    }
    const a = new Float32Array(o);
    e.bindBuffer(e.ARRAY_BUFFER, this.edgeHighlightBuffer), e.bufferData(e.ARRAY_BUFFER, a, e.DYNAMIC_DRAW), this.edgeHighlightVertexCount = a.length / Ao;
  }
  rebuildOverlayBuffer() {
    const e = this.gl, n = new Float32Array(this.overlay.length * Wi);
    let r = 0;
    for (const i of this.overlay) {
      const s = i.color;
      n[r++] = i.x, n[r++] = i.y, n[r++] = i.sizePx, n[r++] = s[0], n[r++] = s[1], n[r++] = s[2], n[r++] = s[3];
    }
    e.bindBuffer(e.ARRAY_BUFFER, this.overlayBuffer), e.bufferData(e.ARRAY_BUFFER, n, e.DYNAMIC_DRAW), this.overlayVertexCount = this.overlay.length;
  }
  renderOnce() {
    window.cancelAnimationFrame(this.raf), this.raf = window.requestAnimationFrame(e => this.render(e));
  }
  render(e) {
    const n = this.nodes.length > this.opts.denseNodeThreshold || this.edges.length > this.opts.denseEdgeThreshold, r = n ? this.opts.frameIntervalMs.dense : this.opts.frameIntervalMs.normal;
    if (e - this.lastPaintAt < r) {
      return;
    }
    this.lastPaintAt = e;
    const i = this.canvas.getBoundingClientRect();
    if (i.width <= 0 || i.height <= 0) {
      return;
    }
    const s = window.devicePixelRatio || 1, o = n ? this.opts.dprCap.dense : this.opts.dprCap.normal, a = Math.min(s, o), l = Math.max(1, Math.floor(i.width * a)), c = Math.max(1, Math.floor(i.height * a));
    (this.canvas.width !== l || this.canvas.height !== c) && (this.canvas.width = l, this.canvas.height = c);
    const u = this.gl;
    u.viewport(0, 0, l, c);
    const h = this.opts.background;
    u.clearColor(h[0], h[1], h[2], h[3]), u.clear(u.COLOR_BUFFER_BIT);
    const f = this.view.offsetX * a, p = this.view.offsetY * a, g = this.view.scale * a;
    this.edgeVertexCount > 0 && (u.useProgram(this.lineProgram.program), this.lineLoc.uResolution && u.uniform2f(this.lineLoc.uResolution, l, c), this.lineLoc.uPan && u.uniform2f(this.lineLoc.uPan, f, p), this.lineLoc.uScale && u.uniform1f(this.lineLoc.uScale, g), this.lineLoc.uTime && u.uniform1f(this.lineLoc.uTime, e), this.lineLoc.uPulseSpeed && u.uniform1f(this.lineLoc.uPulseSpeed, this.opts.pulseSpeed), this.lineLoc.uPulseAmplitude && u.uniform1f(this.lineLoc.uPulseAmplitude, this.opts.pulseAmplitude), 
    u.bindBuffer(u.ARRAY_BUFFER, this.edgeBuffer), this.lineLoc.aPos >= 0 && (u.enableVertexAttribArray(this.lineLoc.aPos), u.vertexAttribPointer(this.lineLoc.aPos, 2, u.FLOAT, !1, Ao * 4, 0)), this.lineLoc.aColor >= 0 && (u.enableVertexAttribArray(this.lineLoc.aColor), u.vertexAttribPointer(this.lineLoc.aColor, 4, u.FLOAT, !1, Ao * 4, 2 * 4)), this.lineLoc.aPhase >= 0 && (u.enableVertexAttribArray(this.lineLoc.aPhase), u.vertexAttribPointer(this.lineLoc.aPhase, 1, u.FLOAT, !1, Ao * 4, 6 * 4)), u.drawArrays(u.LINES, 
    0, this.edgeVertexCount)), this.edgeHighlightVertexCount > 0 && (u.useProgram(this.lineProgram.program), this.lineLoc.uResolution && u.uniform2f(this.lineLoc.uResolution, l, c), this.lineLoc.uPan && u.uniform2f(this.lineLoc.uPan, f, p), this.lineLoc.uScale && u.uniform1f(this.lineLoc.uScale, g), this.lineLoc.uTime && u.uniform1f(this.lineLoc.uTime, e), this.lineLoc.uPulseSpeed && u.uniform1f(this.lineLoc.uPulseSpeed, this.opts.pulseSpeed), this.lineLoc.uPulseAmplitude && u.uniform1f(this.lineLoc.uPulseAmplitude, 
    this.opts.pulseAmplitude), u.bindBuffer(u.ARRAY_BUFFER, this.edgeHighlightBuffer), this.lineLoc.aPos >= 0 && (u.enableVertexAttribArray(this.lineLoc.aPos), u.vertexAttribPointer(this.lineLoc.aPos, 2, u.FLOAT, !1, Ao * 4, 0)), this.lineLoc.aColor >= 0 && (u.enableVertexAttribArray(this.lineLoc.aColor), u.vertexAttribPointer(this.lineLoc.aColor, 4, u.FLOAT, !1, Ao * 4, 2 * 4)), this.lineLoc.aPhase >= 0 && (u.enableVertexAttribArray(this.lineLoc.aPhase), u.vertexAttribPointer(this.lineLoc.aPhase, 
    1, u.FLOAT, !1, Ao * 4, 6 * 4)), u.drawArrays(u.LINES, 0, this.edgeHighlightVertexCount)), this.haloVertexCount > 0 && (u.useProgram(this.pointProgram.program), this.pointLoc.uResolution && u.uniform2f(this.pointLoc.uResolution, l, c), this.pointLoc.uPan && u.uniform2f(this.pointLoc.uPan, f, p), this.pointLoc.uScale && u.uniform1f(this.pointLoc.uScale, g), this.pointLoc.uPixelRatio && u.uniform1f(this.pointLoc.uPixelRatio, a), this.pointLoc.uSizeScale && u.uniform1f(this.pointLoc.uSizeScale, 
    1), this.pointLoc.uAlphaScale && u.uniform1f(this.pointLoc.uAlphaScale, 1), u.bindBuffer(u.ARRAY_BUFFER, this.haloBuffer), this.pointLoc.aPos >= 0 && (u.enableVertexAttribArray(this.pointLoc.aPos), u.vertexAttribPointer(this.pointLoc.aPos, 2, u.FLOAT, !1, Wi * 4, 0)), this.pointLoc.aSize >= 0 && (u.enableVertexAttribArray(this.pointLoc.aSize), u.vertexAttribPointer(this.pointLoc.aSize, 1, u.FLOAT, !1, Wi * 4, 2 * 4)), this.pointLoc.aColor >= 0 && (u.enableVertexAttribArray(this.pointLoc.aColor), 
    u.vertexAttribPointer(this.pointLoc.aColor, 4, u.FLOAT, !1, Wi * 4, 3 * 4)), u.drawArrays(u.POINTS, 0, this.haloVertexCount)), this.nodeVertexCount > 0 && (u.useProgram(this.pointProgram.program), this.pointLoc.uResolution && u.uniform2f(this.pointLoc.uResolution, l, c), this.pointLoc.uPan && u.uniform2f(this.pointLoc.uPan, f, p), this.pointLoc.uScale && u.uniform1f(this.pointLoc.uScale, g), this.pointLoc.uPixelRatio && u.uniform1f(this.pointLoc.uPixelRatio, a), this.pointLoc.uSizeScale && u.uniform1f(this.pointLoc.uSizeScale, 
    1), this.pointLoc.uAlphaScale && u.uniform1f(this.pointLoc.uAlphaScale, 1), u.bindBuffer(u.ARRAY_BUFFER, this.nodeBuffer), this.pointLoc.aPos >= 0 && (u.enableVertexAttribArray(this.pointLoc.aPos), u.vertexAttribPointer(this.pointLoc.aPos, 2, u.FLOAT, !1, Wi * 4, 0)), this.pointLoc.aSize >= 0 && (u.enableVertexAttribArray(this.pointLoc.aSize), u.vertexAttribPointer(this.pointLoc.aSize, 1, u.FLOAT, !1, Wi * 4, 2 * 4)), this.pointLoc.aColor >= 0 && (u.enableVertexAttribArray(this.pointLoc.aColor), 
    u.vertexAttribPointer(this.pointLoc.aColor, 4, u.FLOAT, !1, Wi * 4, 3 * 4)), u.drawArrays(u.POINTS, 0, this.nodeVertexCount)), this.overlayVertexCount > 0 && (u.useProgram(this.pointProgram.program), this.pointLoc.uResolution && u.uniform2f(this.pointLoc.uResolution, l, c), this.pointLoc.uPan && u.uniform2f(this.pointLoc.uPan, f, p), this.pointLoc.uScale && u.uniform1f(this.pointLoc.uScale, g), this.pointLoc.uPixelRatio && u.uniform1f(this.pointLoc.uPixelRatio, a), this.pointLoc.uSizeScale && 
    u.uniform1f(this.pointLoc.uSizeScale, 1), this.pointLoc.uAlphaScale && u.uniform1f(this.pointLoc.uAlphaScale, 1), u.bindBuffer(u.ARRAY_BUFFER, this.overlayBuffer), this.pointLoc.aPos >= 0 && (u.enableVertexAttribArray(this.pointLoc.aPos), u.vertexAttribPointer(this.pointLoc.aPos, 2, u.FLOAT, !1, Wi * 4, 0)), this.pointLoc.aSize >= 0 && (u.enableVertexAttribArray(this.pointLoc.aSize), u.vertexAttribPointer(this.pointLoc.aSize, 1, u.FLOAT, !1, Wi * 4, 2 * 4)), this.pointLoc.aColor >= 0 && (u.enableVertexAttribArray(this.pointLoc.aColor), 
    u.vertexAttribPointer(this.pointLoc.aColor, 4, u.FLOAT, !1, Wi * 4, 3 * 4)), u.drawArrays(u.POINTS, 0, this.overlayVertexCount));
  }
  attachInteraction() {
    const e = this.canvas;
    this.onWheel = n => {
      n.preventDefault();
      const r = e.getBoundingClientRect(), i = n.clientX - r.left, s = n.clientY - r.top, o = r.width / 2, a = r.height / 2, l = (i - o - this.view.offsetX) / this.view.scale, c = (s - a - this.view.offsetY) / this.view.scale, h = (n.deltaY < 0 ? 1 : -1) > 0 ? this.opts.zoomStep : 1 / this.opts.zoomStep, f = Cy(this.view.scale * h, this.opts.minScale, this.opts.maxScale);
      this.view.scale = f, this.view.offsetX = i - o - l * f, this.view.offsetY = s - a - c * f, this.opts.animate || this.renderOnce();
    }, this.onPointerDown = n => {
      var r;
      this.dragging.active = !0, this.dragging.startX = n.clientX, this.dragging.startY = n.clientY, this.dragging.baseOffsetX = this.view.offsetX, this.dragging.baseOffsetY = this.view.offsetY, (r = e.setPointerCapture) == null || r.call(e, n.pointerId);
    }, this.onPointerMove = n => {
      this.dragging.active && (this.view.offsetX = this.dragging.baseOffsetX + (n.clientX - this.dragging.startX), this.view.offsetY = this.dragging.baseOffsetY + (n.clientY - this.dragging.startY), this.opts.animate || this.renderOnce());
    }, this.onPointerUp = n => {
      var b;
      const r = this.dragging.active, i = Math.hypot(n.clientX - this.dragging.startX, n.clientY - this.dragging.startY);
      if (this.dragging.active = !1, (b = e.releasePointerCapture) == null || b.call(e, n.pointerId), !r || i > 6) {
        return;
      }
      const s = e.getBoundingClientRect(), o = n.clientX - s.left, a = n.clientY - s.top, l = s.width / 2, c = s.height / 2, u = (o - l - this.view.offsetX) / this.view.scale, h = (a - c - this.view.offsetY) / this.view.scale, f = this.opts.pickRadiusPx / Math.max(1e-6, this.view.scale), p = f * f;
      let g = null, m = Number.POSITIVE_INFINITY;
      for (const x of this.nodes) {
        const w = x.x - u, v = x.y - h, T = w * w + v * v;
        T < m && (m = T, g = x);
      }
      g && m <= p && (this.setSelectedNode(g.id), this.opts.onNodeClick(g));
    }, e.addEventListener("wheel", this.onWheel, {passive:!1}), e.addEventListener("pointerdown", this.onPointerDown), e.addEventListener("pointermove", this.onPointerMove), e.addEventListener("pointerup", this.onPointerUp);
  }
  detachInteraction() {
    const e = this.canvas;
    this.onWheel && e.removeEventListener("wheel", this.onWheel), this.onPointerDown && e.removeEventListener("pointerdown", this.onPointerDown), this.onPointerMove && e.removeEventListener("pointermove", this.onPointerMove), this.onPointerUp && e.removeEventListener("pointerup", this.onPointerUp);
  }
}
const y2 = "knoxx_session_id";
class B1 extends Error {
  constructor(n, r) {
    super(r || `Proxy request failed: ${n}`);
    It(this, "status");
    It(this, "body");
    this.status = n, this.body = r, this.name = "ProxyApiError";
  }
}
function $1() {
  if (typeof window > "u") {
    return "";
  }
  let t = sessionStorage.getItem(y2);
  return t || (t = typeof crypto < "u" && typeof crypto.randomUUID == "function" ? crypto.randomUUID() : `sess-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`, sessionStorage.setItem(y2, t), t);
}
async function nn(t, e) {
  const n = Xn(e == null ? void 0 : e.headers);
  n.set("x-knoxx-session-id", $1());
  const r = await fetch(t, {...e, headers:n});
  if (!r.ok) {
    const i = await r.text();
    throw new B1(r.status, i || `Request failed: ${r.status}`);
  }
  return r.json();
}
async function Yte() {
  return nn("/api/documents");
}
async function Gte(t, e = !1) {
  const n = new FormData();
  t.forEach(s => n.append("files", s)), n.append("autoIngest", String(e));
  const r = Xn();
  r.set("x-knoxx-session-id", $1());
  const i = await fetch("/api/documents/upload", {method:"POST", headers:r, body:n});
  if (!i.ok) {
    throw new Error("Failed to upload documents");
  }
  return i.json();
}
async function Qte(t) {
  return nn(`/api/documents/${encodeURIComponent(t)}`, {method:"DELETE"});
}
async function Kte(t = {}) {
  return nn("/api/documents/ingest", {method:"POST", headers:{"Content-Type":"application/json"}, body:JSON.stringify(t)});
}
async function Xte(t = !1) {
  return nn("/api/documents/ingest/restart", {method:"POST", headers:{"Content-Type":"application/json"}, body:JSON.stringify({forceFresh:t})});
}
async function Jte() {
  return nn("/api/documents/ingestion-status");
}
async function D3() {
  return nn("/api/documents/ingestion-progress");
}
async function Zte() {
  const t = await fetch("/api/settings", {headers:Xn()});
  if (!t.ok) {
    throw new Error("Failed to load settings");
  }
  return t.json();
}
async function ene(t) {
  const e = await fetch("/api/settings", {method:"PUT", headers:Xn({"Content-Type":"application/json"}), body:JSON.stringify(t)});
  if (!e.ok) {
    throw new Error("Failed to update settings");
  }
  return e.json();
}
async function tne() {
  const t = await fetch("/api/settings/knoxx-status", {headers:Xn()});
  if (!t.ok) {
    throw new Error("Failed to load Knoxx status");
  }
  return t.json();
}
async function nne(t) {
  const e = await fetch("/api/knoxx/chat", {method:"POST", headers:Xn({"Content-Type":"application/json"}), body:JSON.stringify(t)});
  if (!e.ok) {
    throw new Error(await e.text() || "Knoxx chat failed");
  }
  return e.json();
}
async function rne(t) {
  const e = await fetch("/api/knoxx/direct", {method:"POST", headers:Xn({"Content-Type":"application/json"}), body:JSON.stringify(t)});
  if (!e.ok) {
    throw new Error(await e.text() || "Knoxx direct chat failed");
  }
  return e.json();
}
async function ine(t, e) {
  const n = new URLSearchParams({session_id:t});
  e && n.set("conversation_id", e);
  const r = await fetch(`/api/knoxx/session/status?${n.toString()}`, {headers:Xn()});
  if (!r.ok) {
    throw new Error("Failed to check session status");
  }
  return r.json();
}
async function sne() {
  const t = await fetch("/api/retrieval/stats", {headers:Xn()});
  if (!t.ok) {
    throw new Error("Failed to load retrieval stats");
  }
  return t.json();
}
async function one(t) {
  return nn("/api/chat/retrieval-debug", {method:"POST", headers:{"Content-Type":"application/json"}, body:JSON.stringify(t)});
}
async function ane(t) {
  const e = t.split("/").filter(Boolean).map(n => encodeURIComponent(n)).join("/");
  return nn(`/api/documents/content/${e}`);
}
async function lne() {
  return nn("/api/settings/databases");
}
async function cne(t) {
  return nn("/api/settings/databases", {method:"POST", headers:{"Content-Type":"application/json"}, body:JSON.stringify(t)});
}
async function une(t) {
  return nn(`/api/settings/databases/${encodeURIComponent(t)}/make-private`, {method:"POST"});
}
async function dne(t) {
  return nn("/api/settings/databases/activate", {method:"POST", headers:{"Content-Type":"application/json"}, body:JSON.stringify({id:t})});
}
async function hne(t, e) {
  return nn(`/api/settings/databases/${encodeURIComponent(t)}`, {method:"PATCH", headers:{"Content-Type":"application/json"}, body:JSON.stringify(e)});
}
async function fne(t) {
  return nn(`/api/settings/databases/${encodeURIComponent(t)}`, {method:"DELETE"});
}
async function pne() {
  return nn("/api/documents/ingestion-history");
}
async function Yg(t = {}) {
  const e = new URLSearchParams();
  return t.projects && t.projects.length > 0 && e.set("projects", t.projects.join(",")), t.nodeTypes && t.nodeTypes.length > 0 && e.set("nodeTypes", t.nodeTypes.join(",")), t.edgeTypes && t.edgeTypes.length > 0 && e.set("edgeTypes", t.edgeTypes.join(",")), nn(`/api/graph/export${e.size > 0 ? `?${e.toString()}` : ""}`);
}
async function oh(t, e) {
  const n = Xn(e == null ? void 0 : e.headers);
  n.set("x-knoxx-session-id", $1());
  const r = await fetch(`/api/ingestion-proxy/${t}`, {...e, headers:n});
  if (!r.ok) {
    const i = await r.text();
    throw new B1(r.status, i || `Ingestion request failed: ${r.status}`);
  }
  return r.json();
}
async function L3() {
  return oh("sources");
}
async function M3(t) {
  const e = t ? `?tenant_id=${encodeURIComponent(t)}` : "";
  return oh(`jobs${e}`);
}
async function B3(t) {
  return oh(`sources/${encodeURIComponent(t)}/audit`);
}
async function $3(t) {
  return oh("jobs", {method:"POST", headers:{"Content-Type":"application/json"}, body:JSON.stringify({source_id:t})});
}
async function gne(t) {
  await oh(`jobs/${encodeURIComponent(t)}/cancel`, {method:"POST"});
}
async function F3() {
  return nn("/api/data/health");
}
async function F1() {
  return nn("/api/data/mongo/collections");
}
async function Ay() {
  return nn("/api/data/mongo/list");
}
async function z1(t) {
  return nn("/api/data/mongo/query", {method:"POST", headers:{"Content-Type":"application/json"}, body:JSON.stringify(t)});
}
async function z3() {
  return nn("/api/data/pg/tables");
}
async function td(t) {
  return nn(`/api/data/op/${t}`);
}
async function nd(t, e) {
  return nn(`/api/data/op/${t}`, {method:"POST", headers:{"Content-Type":"application/json"}, body:JSON.stringify(e)});
}
async function H3(t = {}) {
  return nn("/api/data/jobs/build-semantic-edges", {method:"POST", headers:{"Content-Type":"application/json"}, body:JSON.stringify(t)});
}
async function mne(t) {
  return nn("/api/data/jobs/build-semantic-edges/incremental", {method:"POST", headers:{"Content-Type":"application/json"}, body:JSON.stringify(t)});
}
async function bne(t) {
  return nn(`/api/data/browse?path=${encodeURIComponent(t)}`);
}
async function yne(t) {
  return nn(`/api/data/file?path=${encodeURIComponent(t)}`);
}
async function Ny(t, e) {
  const n = await fetch("/api/data/graphql", {method:"POST", headers:{"Content-Type":"application/json", ...Xn()}, body:JSON.stringify({query:t, variables:e})});
  if (!n.ok) {
    throw new Error(`GraphQL request failed: ${n.status}`);
  }
  const r = await n.json();
  if (r.errors) {
    throw new Error(r.errors.map(i => i.message).join("; "));
  }
  return r.data;
}
async function xne() {
  return nn("/api/data/graph/status");
}
async function vne() {
  return nn("/api/data/graph/view-url");
}
async function U3() {
  return nn("/api/data/op/v1/graph/embedding-coverage");
}
const Qi = Object.freeze(Object.defineProperty({__proto__:null, API_BASE:us, ProxyApiError:B1, abortAdminActiveAgent:NA, acknowledgeActorMailboxEntry:Ej, activateDatabaseProfile:dne, addAudioLabel:Bj, browseFiles:bne, buildKnoxxAuthHeaders:Xn, buildSemanticEdges:H3, buildSemanticEdgesIncremental:mne, cancelIngestionJob:gne, createAdminOrg:HA, createChatRun:OW, createDatabaseProfile:cne, createOrgActor:ej, createOrgDataLake:cj, createOrgRole:ij, createTranslationBatch:qW, deleteDatabaseProfile:fne, 
deleteDocument:Qte, dispatchEventAgentEvent:mj, ensureAudioDirectory:Pj, fetchDataMongoCollections:F1, fetchDataMongoList:Ay, fetchDataPgTables:z3, fetchDocumentContent:ane, fetchDocuments:Yte, fetchEmbeddingCoverage:U3, fetchFileContent:yne, fetchGraphExport:Yg, fetchGraphViewUrl:vne, fetchGraphWeaverStatus:xne, fetchIngestionHistory:pne, fetchIngestionJobs:M3, fetchIngestionProgress:D3, fetchIngestionSources:L3, fetchIngestionStatus:Jte, fetchOpenPlannerProxy:td, fetchRetrievalStats:sne, fetchServiceHealth:F3, 
fetchSourceAudit:B3, fireTrigger:gj, getAdminBootstrap:BA, getAgentContractsCatalog:Jx, getAgentHistorySession:qx, getAllLabels:Mj, getAudioAssetUrl:Hj, getAudioLabels:Lj, getAudioLibrary:ZA, getAudioStreamUrl:Ul, getDiscordConfig:dj, getEventAgentControl:UA, getFilesByLabel:Fj, getFrontendConfig:OA, getGraphMonitoring:uj, getKnoxxAuthContext:PA, getKnoxxAuthIdentity:TA, getKnoxxStatus:tne, getM3UDownloadUrl:Dj, getMemorySession:IA, getProxxProviderModelAnalytics:aN, getProxxUsageOverview:sN, getRun:hd, 
getRunEvents:t1, getSessionStatus:e1, getSettings:Zte, getToolCatalog:YA, getTranslationDocument:WW, getTranslationManifest:zW, getTranslationPipelineConfig:Uj, getTranslationSegment:$W, getTranslationSftExport:HW, graphqlQuery:Ny, handoffToShibboleth:Oj, ingestDocuments:Kte, knoxxAbort:KA, knoxxChat:Ij, knoxxChatStart:JA, knoxxControl:Tb, knoxxDirectChat:rne, knoxxHealth:Nj, knoxxRagChat:nne, knoxxSessionStatus:ine, knoxxUndoSessionTurn:XA, listActiveAgents:Eb, listActorMailbox:kj, listAdminActiveAgents:AA, 
listAdminOrgs:zA, listAdminPermissions:$A, listAdminTools:FA, listAgentHistorySessions:RW, listDatabaseProfiles:lne, listLoungeMessages:DW, listMemorySessions:Ua, listModels:IW, listOrgActors:ZW, listOrgDataLakes:lj, listOrgRoles:rj, listPlaylists:If, listProxxModels:VA, listProxxRequestLogs:oN, listRuns:PW, listTranslationBatches:VW, listTranslationDocuments:UW, listTranslationSegments:BW, loadM3UPlaylist:tN, makeDatabasePrivate:une, postLoungeMessage:LW, postOpenPlannerProxy:nd, proxxChat:Sj, proxxHealth:qA, 
queryAnswer:MW, queryDataMongo:z1, removeAudioLabel:$j, renameAudioFile:Rj, request:Ie, resetEventAgentRuntime:xj, restartIngestion:Xte, reviewTranslationDocument:jW, runEventAgentJob:pj, runRetrievalDebug:one, saveAudioAsset:nN, savePlaylistAsM3U:eN, scanDiscordAudio:rN, scanDiscordImages:iN, searchMemory:Yx, sendEmailDraft:GA, setKnoxxAuthIdentity:CA, startEventAgentRuntime:yj, stopEventAgentRuntime:bj, submitTranslationLabel:FW, syncAudioSymlinks:zj, toolBash:Aj, toolEdit:Cj, toolRead:Tj, toolWrite:QA, 
triggerIngestionJob:$3, updateAdminActor:tj, updateDatabaseProfile:hne, updateDiscordConfig:hj, updateEventAgentControl:fj, updateMembershipRoles:oj, updateMembershipToolPolicies:aj, updateRoleToolPolicies:sj, updateSettings:ene, updateTranslationPipelineConfig:Wj, uploadDocuments:Gte, upsertAdminActorCredential:nj, voiceSttTranscribe:pp, voiceTtsSynthesize:Zx}, Symbol.toStringTag, {value:"Module"}));
function W3(t) {
  return !!t && typeof t == "object" && !Array.isArray(t);
}
function j3(t) {
  if (t === null) {
    return "null";
  }
  if (t === void 0) {
    return "undefined";
  }
  if (typeof t == "string") {
    const e = t.length > 120 ? `${t.slice(0, 117)}\u2026` : t;
    return JSON.stringify(e);
  }
  return typeof t == "number" || typeof t == "boolean" || typeof t == "bigint" ? String(t) : "";
}
function T0(t) {
  return Array.isArray(t) ? `Array(${t.length})` : W3(t) ? `Object(${Object.keys(t).length})` : j3(t);
}
function jp(t) {
  const e = t.depth ?? 0, n = t.path ?? t.label ?? "", r = e < t.defaultExpandDepth, i = t.label ? `${t.label}: ` : "";
  return (0,require$react.useMemo)(() => {
    const o = t.value;
    if (Array.isArray(o)) {
      return (0,require$react_SLASH_jsx_runtime.jsxs)("details", {className:"pl-2", open:r, children:[(0,require$react_SLASH_jsx_runtime.jsxs)("summary", {className:"cursor-pointer select-none text-xs text-slate-200", children:[(0,require$react_SLASH_jsx_runtime.jsx)("span", {className:"text-slate-400", children:i}), (0,require$react_SLASH_jsx_runtime.jsx)("span", {className:"text-slate-300", children:T0(o)})]}), (0,require$react_SLASH_jsx_runtime.jsx)("ol", {className:"pl-5 mt-1 space-y-1 list-decimal", 
      children:o.map((a, l) => (0,require$react_SLASH_jsx_runtime.jsx)("li", {className:"text-xs text-slate-300", children:(0,require$react_SLASH_jsx_runtime.jsx)(jp, {value:a, label:String(l), defaultExpandDepth:t.defaultExpandDepth, depth:e + 1, path:`${n}[${l}]`})}, `${n}[${l}]`))})]});
    }
    if (W3(o)) {
      const a = Object.entries(o);
      return a.sort(([l], [c]) => l.localeCompare(c)), (0,require$react_SLASH_jsx_runtime.jsxs)("details", {className:"pl-2", open:r, children:[(0,require$react_SLASH_jsx_runtime.jsxs)("summary", {className:"cursor-pointer select-none text-xs text-slate-200", children:[(0,require$react_SLASH_jsx_runtime.jsx)("span", {className:"text-slate-400", children:i}), (0,require$react_SLASH_jsx_runtime.jsx)("span", {className:"text-slate-300", children:T0(o)})]}), (0,require$react_SLASH_jsx_runtime.jsx)("div", 
      {className:"mt-1 space-y-1", children:a.map(([l, c]) => (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"border-l border-slate-700/30", children:(0,require$react_SLASH_jsx_runtime.jsx)(jp, {label:l, value:c, defaultExpandDepth:t.defaultExpandDepth, depth:e + 1, path:`${n}.${l}`})}, `${n}.${l}`))})]});
    }
    return (0,require$react_SLASH_jsx_runtime.jsxs)("details", {className:"pl-2", open:r, children:[(0,require$react_SLASH_jsx_runtime.jsxs)("summary", {className:"cursor-pointer select-none text-xs text-slate-200", children:[(0,require$react_SLASH_jsx_runtime.jsx)("span", {className:"text-slate-400", children:i}), (0,require$react_SLASH_jsx_runtime.jsx)("span", {className:"text-slate-300", children:T0(o)})]}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"mt-1 text-xs text-slate-300 font-mono whitespace-pre-wrap", 
    children:j3(o) || String(o)})]});
  }, [t.value, t.defaultExpandDepth, e, n, r, i]);
}
function of(t) {
  if (!t) {
    return null;
  }
  try {
    const e = JSON.parse(t);
    return e && typeof e == "object" && !Array.isArray(e) ? e : {value:e};
  } catch {
    return null;
  }
}
function V3(t) {
  return t.includes(":") && t.split(":", 1)[0] || "misc";
}
const x2 = {devel:[0.24, 0.72, 0.98, 0.96], web:[0.39, 0.92, 0.68, 0.96], bluesky:[0.31, 0.63, 0.98, 0.96], "knoxx-session":[0.98, 0.72, 0.34, 0.96], user:[0.92, 0.58, 0.98, 0.94], misc:[0.7, 0.74, 0.82, 0.94]};
function wne(t) {
  const e = t.data ?? {}, n = !!e.selected, r = typeof e.degree == "number" ? e.degree : 0, i = typeof e.lake == "string" ? e.lake : V3(t.id), s = x2[i] || x2.misc, o = Math.min(4.2, Math.log2(r + 1) * 0.9);
  return {sizePx:(n ? 9.2 : 6) + o, color:n ? Tr(s[0] + 0.12, s[1] + 0.12, s[2] + 0.12, 0.98) : s};
}
function _ne(t) {
  const n = !!(t.data ?? {}).selected;
  return {color:n ? Tr(0.82, 0.88, 0.98, 0.28) : Tr(0.75, 0.8, 0.92, 0.14), phase:n ? 0.9 : 0};
}
function v2(t) {
  const e = (t.label || "").trim();
  return e || t.id;
}
function Sne(t) {
  const e = JSON.stringify(t.rootId), n = Math.max(0, Math.floor(t.distance)), r = Math.max(1, Math.floor(t.maxNodes)), i = Math.max(1, Math.floor(t.maxEdges));
  return `{
  focusedGraphView(rootId: ${e}, distance: ${n}, maxNodes: ${r}, maxEdges: ${i}) {
    nodes { id kind label x y external loadedByDefault layer dataJson }
    edges { source target kind layer dataJson }
    meta { totalNodes totalEdges sampledNodes sampledEdges }
  }
}`;
}
function q3(t) {
  const e = (0,require$react.useRef)(null), n = (0,require$react.useRef)(null), r = (0,require$react.useMemo)(() => new Map(t.nodes.map(U => [U.id, U])), [t.nodes]), [i, s] = (0,require$react.useState)(""), [o, a] = (0,require$react.useState)(null), [l, c] = (0,require$react.useState)(null), [u, h] = (0,require$react.useState)(null), [f, p] = (0,require$react.useState)(t.defaultDistance ?? 2), [g, m] = (0,require$react.useState)(220), [b, x] = (0,require$react.useState)(520), [w, v] = (0,require$react.useState)(""), 
  [T, I] = (0,require$react.useState)(""), [_, N] = (0,require$react.useState)(""), [E, C] = (0,require$react.useState)(null), [k, A] = (0,require$react.useState)(2), [P, W] = (0,require$react.useState)(!1), [F, B] = (0,require$react.useState)(null), [z, j] = (0,require$react.useState)(!1), [V, ne] = (0,require$react.useState)(""), [D, ie] = (0,require$react.useState)(null), [ee, M] = (0,require$react.useState)(!1), [X, ge] = (0,require$react.useState)(""), me = (0,require$react.useMemo)(() => [...(new Set(t.nodes.map(U => 
  U.kind).filter(Boolean)))].sort(), [t.nodes]), te = (0,require$react.useMemo)(() => [...(new Set(t.nodes.map(U => U.lake).filter(Boolean)))].sort(), [t.nodes]), q = (0,require$react.useMemo)(() => {
    const U = i.trim().toLowerCase();
    let le = t.nodes;
    return o && (le = le.filter(be => be.kind === o)), l && (le = le.filter(be => be.lake === l)), U && (le = le.filter(be => [be.label, be.project, be.nodeType, be.id, be.kind, be.source, be.lake].filter(Boolean).join(" ").toLowerCase().includes(U) ? !0 : Object.values(be.data ?? {}).filter(ue => typeof ue == "string").join(" ").toLowerCase().includes(U))), le.slice(0, 250);
  }, [t.nodes, i, o, l]), R = (0,require$react.useMemo)(() => {
    if (!E) {
      return null;
    }
    const U = new Map();
    for (const Ae of E.edges) {
      U.set(Ae.source, (U.get(Ae.source) ?? 0) + 1), U.set(Ae.target, (U.get(Ae.target) ?? 0) + 1);
    }
    const le = E.nodes.map(Ae => {
      const ue = of(Ae.dataJson), Le = typeof(ue == null ? void 0 : ue.lake) == "string" ? ue.lake : V3(Ae.id);
      return {id:Ae.id, x:Ae.x, y:Ae.y, kind:Ae.kind, label:Ae.label, data:{lake:Le, selected:u === Ae.id, degree:U.get(Ae.id) ?? 0, layer:Ae.layer, data:ue}};
    }), be = new Set();
    u && be.add(u);
    const je = E.edges.map(Ae => ({source:Ae.source, target:Ae.target, kind:Ae.kind, data:{selected:be.has(Ae.source) || be.has(Ae.target), layer:Ae.layer, data:of(Ae.dataJson)}}));
    return {nodes:le, edges:je};
  }, [E, u]), $ = (0,require$react.useMemo)(() => {
    if (!E) {
      return null;
    }
    const U = E.nodes.map(be => ({...be, data:of(be.dataJson)})), le = E.edges.map(be => ({...be, data:of(be.dataJson)}));
    return {nodes:U, edges:le, meta:E.meta};
  }, [E]);
  (0,require$react.useEffect)(() => {
    if (!e.current) {
      return;
    }
    const U = new R3(e.current, {background:Tr(0.03, 0.06, 0.11, 0.98), pulseAmplitude:0.42, pulseSpeed:1 / 420, denseNodeThreshold:4e3, denseEdgeThreshold:16e3, dprCap:{normal:2.5, dense:2}, frameIntervalMs:{normal:16, dense:24}, minScale:0.03, maxScale:8, nodeStyle:wne, edgeStyle:_ne, onNodeClick:le => h(le.id)});
    return n.current = U, () => {
      U.destroy(), n.current = null;
    };
  }, []), (0,require$react.useEffect)(() => {
    const U = n.current;
    !U || !R || (U.setGraph(R), R.nodes.length > 0 && U.fitToGraph(96));
  }, [R]), (0,require$react.useEffect)(() => {
    u && v(Sne({rootId:u, distance:f, maxNodes:g, maxEdges:b}));
  }, [u, f, g, b]);
  const G = (0,require$react.useCallback)(async U => {
    const le = (U || "").trim();
    if (le) {
      N("");
      try {
        const be = await Ny(le);
        I(JSON.stringify(be, null, 2));
        const je = (be == null ? void 0 : be.focusedGraphView) ?? (be == null ? void 0 : be.graphView) ?? null;
        je && Array.isArray(je.nodes) && Array.isArray(je.edges) && C(je);
      } catch (be) {
        N(be.message || String(be));
      }
    }
  }, []);
  (0,require$react.useEffect)(() => {
    const U = setTimeout(() => {
      G(w);
    }, 450);
    return () => clearTimeout(U);
  }, [w, G]), (0,require$react.useEffect)(() => {
    if (!u) {
      B(null), j(!1), ne("");
      return;
    }
    let U = !1;
    return j(!0), ne(""), z1({collection:"events", filter:{kind:"graph.node", "extra.entity_key":u}, sort:{ts:-1}, limit:10}).then(le => {
      if (!U) {
        if (!le.ok) {
          B([]), ne(le.error || "failed to fetch source event");
          return;
        }
        B(le.rows || []);
      }
    }).catch(le => {
      U || (B([]), ne((le == null ? void 0 : le.message) || String(le)));
    }).finally(() => {
      U || j(!1);
    }), () => {
      U = !0;
    };
  }, [u]), (0,require$react.useEffect)(() => {
    if (!u) {
      ie(null), M(!1), ge("");
      return;
    }
    let U = !1;
    M(!0), ge("");
    const le = `{
  nodePreview(id: ${JSON.stringify(u)}, maxBytes: 2000000) {
    id kind format contentType language body truncated bytes error
  }
}`;
    return Ny(le).then(be => {
      U || ie((be == null ? void 0 : be.nodePreview) ?? null);
    }).catch(be => {
      U || (ie(null), ge((be == null ? void 0 : be.message) || String(be)));
    }).finally(() => {
      U || M(!1);
    }), () => {
      U = !0;
    };
  }, [u]);
  const J = u ? r.get(u) ?? null : null;
  return (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"flex gap-4 h-full min-h-[720px] p-6", children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"w-80 shrink-0 flex flex-col rounded-lg border border-slate-700/50 bg-slate-800/30 overflow-hidden", children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"shrink-0 p-3 border-b border-slate-700/30 space-y-2", children:[(0,require$react_SLASH_jsx_runtime.jsx)("input", {value:i, onChange:U => s(U.target.value), 
  placeholder:"Search nodes\u2026", className:"w-full bg-slate-900/50 border border-slate-700/50 rounded px-3 py-1.5 text-xs text-slate-200 placeholder-slate-600 focus:outline-none"}), (o || l) && (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"flex items-center gap-1.5", children:[o && (0,require$react_SLASH_jsx_runtime.jsxs)("button", {onClick:() => a(null), className:"text-[10px] px-1.5 py-0.5 rounded bg-blue-500/20 text-blue-300 hover:bg-blue-500/30", children:["kind:", o, " \u00d7"]}), 
  l && (0,require$react_SLASH_jsx_runtime.jsxs)("button", {onClick:() => c(null), className:"text-[10px] px-1.5 py-0.5 rounded bg-emerald-500/20 text-emerald-300 hover:bg-emerald-500/30", children:["lake:", l, " \u00d7"]}), (0,require$react_SLASH_jsx_runtime.jsx)("button", {onClick:() => {
    a(null), c(null);
  }, className:"text-[10px] text-slate-500 hover:text-slate-300 ml-auto", children:"clear"})]}), me.length > 0 && (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"space-y-1", children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"text-[10px] text-slate-500", children:"Kind"}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"flex flex-wrap gap-1", children:[me.slice(0, 12).map(U => (0,require$react_SLASH_jsx_runtime.jsx)("button", {onClick:() => a(o === U ? null : 
  U), className:`text-[10px] px-1.5 py-0.5 rounded border ${o === U ? "bg-blue-500/20 border-blue-500/30 text-blue-300" : "border-slate-700/50 text-slate-400 hover:bg-slate-700/20 hover:text-slate-300"}`, children:U}, U)), me.length > 12 && (0,require$react_SLASH_jsx_runtime.jsxs)("span", {className:"text-[10px] text-slate-600", children:["+", me.length - 12, " more"]})]})]}), te.length > 0 && (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"space-y-1", children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", 
  {className:"text-[10px] text-slate-500", children:"Lake"}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"flex flex-wrap gap-1", children:[te.slice(0, 8).map(U => (0,require$react_SLASH_jsx_runtime.jsx)("button", {onClick:() => c(l === U ? null : U), className:`text-[10px] px-1.5 py-0.5 rounded border ${l === U ? "bg-emerald-500/20 border-emerald-500/30 text-emerald-300" : "border-slate-700/50 text-slate-400 hover:bg-slate-700/20 hover:text-slate-300"}`, children:U}, U)), te.length > 
  8 && (0,require$react_SLASH_jsx_runtime.jsxs)("span", {className:"text-[10px] text-slate-600", children:["+", te.length - 8, " more"]})]})]}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"flex gap-2 items-end", children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"flex-1", children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"text-[10px] text-slate-500 mb-1", children:"Distance"}), (0,require$react_SLASH_jsx_runtime.jsx)("input", {type:"number", min:0, 
  max:12, value:f, onChange:U => p(Math.max(0, Math.min(12, parseInt(U.target.value || "0", 10) || 0))), className:"w-full bg-slate-900/50 border border-slate-700/50 rounded px-2 py-1 text-xs text-slate-200"})]}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"flex-1", children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"text-[10px] text-slate-500 mb-1", children:"Max nodes"}), (0,require$react_SLASH_jsx_runtime.jsx)("input", {type:"number", min:10, max:2e3, value:g, 
  onChange:U => m(Math.max(10, Math.min(2e3, parseInt(U.target.value || "200", 10) || 200))), className:"w-full bg-slate-900/50 border border-slate-700/50 rounded px-2 py-1 text-xs text-slate-200"})]}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"flex-1", children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"text-[10px] text-slate-500 mb-1", children:"Max edges"}), (0,require$react_SLASH_jsx_runtime.jsx)("input", {type:"number", min:10, max:8e3, value:b, onChange:U => 
  x(Math.max(10, Math.min(8e3, parseInt(U.target.value || "500", 10) || 500))), className:"w-full bg-slate-900/50 border border-slate-700/50 rounded px-2 py-1 text-xs text-slate-200"})]})]}), J && (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"pt-1 text-xs text-slate-400", children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"text-slate-500", children:"Selected"}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"text-slate-200 truncate", title:J.id, children:v2(J)}), 
  (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"text-slate-600", children:[J.project, " \u00b7 ", J.nodeType]})]})]}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"flex-1 overflow-y-auto", children:[q.map(U => (0,require$react_SLASH_jsx_runtime.jsxs)("button", {onClick:() => h(U.id), className:`w-full px-3 py-2 text-left border-b border-slate-700/20 hover:bg-slate-700/10 ${u === U.id ? "bg-slate-700/25" : ""}`, children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", 
  {className:"text-xs text-slate-200 truncate", children:v2(U)}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"text-[10px] text-slate-600 truncate", children:[(0,require$react_SLASH_jsx_runtime.jsx)("span", {className:"text-slate-500", children:U.kind}), (0,require$react_SLASH_jsx_runtime.jsx)("span", {className:"text-slate-700", children:" \u00b7 "}), U.project, " \u00b7 ", U.nodeType]})]}, U.id)), q.length === 0 && (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"p-4 text-xs text-slate-600", 
  children:"No matches"})]})]}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"flex-1 flex flex-col rounded-lg border border-slate-700/50 bg-slate-800/30 overflow-hidden", children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"shrink-0 px-3 py-2 border-b border-slate-700/30 flex items-center justify-between", children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"text-xs text-slate-500", children:"Rendered subgraph"}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", 
  {className:"flex items-center gap-2", children:[(0,require$react_SLASH_jsx_runtime.jsx)("button", {onClick:() => {
    const U = n.current;
    if (!U) {
      return;
    }
    const le = U.getView();
    U.setView({scale:le.scale * 0.8});
  }, className:"text-xs text-blue-400 hover:text-blue-300 px-2 py-1 rounded hover:bg-slate-700/40", title:"Zoom out", children:"\u2212"}), (0,require$react_SLASH_jsx_runtime.jsx)("button", {onClick:() => {
    const U = n.current;
    if (!U) {
      return;
    }
    const le = U.getView();
    U.setView({scale:le.scale * 1.25});
  }, className:"text-xs text-blue-400 hover:text-blue-300 px-2 py-1 rounded hover:bg-slate-700/40", title:"Zoom in", children:"+"}), (0,require$react_SLASH_jsx_runtime.jsx)("button", {onClick:() => {
    var U;
    return (U = n.current) == null ? void 0 : U.fitToGraph(96);
  }, className:"text-xs text-blue-400 hover:text-blue-300 px-2 py-1 rounded hover:bg-slate-700/40", children:"fit"})]})]}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"flex-1", children:(0,require$react_SLASH_jsx_runtime.jsx)("canvas", {ref:e, className:"w-full h-full"})})]}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"w-[520px] shrink-0 flex flex-col rounded-lg border border-slate-700/50 bg-slate-800/30 overflow-hidden", children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", 
  {className:"shrink-0 px-3 py-2 border-b border-slate-700/30 flex items-center justify-between", children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"text-xs text-slate-500", children:"GraphQL (debounced \u2192 updates graph)"}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"flex items-center gap-2", children:[(0,require$react_SLASH_jsx_runtime.jsxs)("label", {className:"text-[10px] text-slate-500 flex items-center gap-1", children:["JSON depth", (0,require$react_SLASH_jsx_runtime.jsx)("input", 
  {type:"number", min:0, max:10, value:k, onChange:U => A(Math.max(0, Math.min(10, parseInt(U.target.value || "2", 10) || 2))), className:"w-14 bg-slate-900/50 border border-slate-700/50 rounded px-2 py-1 text-xs text-slate-200"})]}), (0,require$react_SLASH_jsx_runtime.jsx)("button", {onClick:() => W(U => !U), className:"text-xs text-slate-400 hover:text-slate-200 px-2 py-1 rounded hover:bg-slate-700/40", title:"Toggle raw JSON", children:P ? "pretty" : "raw"}), (0,require$react_SLASH_jsx_runtime.jsx)("button", 
  {onClick:() => void G(w), className:"text-xs text-blue-400 hover:text-blue-300 px-2 py-1 rounded hover:bg-slate-700/40", children:"run"})]})]}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"p-3 border-b border-slate-700/30", children:[(0,require$react_SLASH_jsx_runtime.jsx)("textarea", {value:w, onChange:U => v(U.target.value), placeholder:'{ focusedGraphView(rootId: "...", distance: 2) { nodes { id } edges { source target } } }', className:"w-full bg-slate-900/50 border border-slate-700/50 rounded p-3 text-xs text-slate-200 font-mono resize-none focus:outline-none focus:border-slate-600 h-56", 
  spellCheck:!1}), _ && (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"mt-2 rounded bg-rose-500/10 border border-rose-500/20 px-3 py-2 text-xs text-rose-300", children:_})]}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"flex-1 overflow-auto p-3", children:T ? P ? (0,require$react_SLASH_jsx_runtime.jsx)("pre", {className:"text-xs text-slate-300 font-mono whitespace-pre-wrap", children:T}) : $ ? (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"space-y-4", children:[(() => 
  {
    const U = new Set($.nodes.map(je => je.id)), le = new Set();
    for (const je of $.edges) {
      U.has(je.source) || le.add(je.source), U.has(je.target) || le.add(je.target);
    }
    const be = [...le].slice(0, 12);
    return (0,require$react_SLASH_jsx_runtime.jsxs)(require$react_SLASH_jsx_runtime.Fragment, {children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"text-xs text-slate-400", children:["nodes\x3d", $.meta.totalNodes, " edges\x3d", $.meta.totalEdges, $.meta.sampledNodes ? " (sampled nodes)" : "", $.meta.sampledEdges ? " (sampled edges)" : ""]}), le.size > 0 && (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"rounded bg-amber-500/10 border border-amber-500/20 px-3 py-2 text-xs text-amber-200", 
    children:["Dangling edge endpoint(s): ", le.size, " referenced node id(s) are missing from the node list.", (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"mt-1 font-mono text-[10px] text-amber-300/90 break-words", children:[be.join(" \u00b7 "), le.size > be.length ? " \u2026" : ""]}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"mt-1 text-[10px] text-amber-300/80", children:"This usually means the edge references a devel path that is a directory or otherwise not ingested as a `devel:file:*` node."})]})]});
  })(), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"space-y-2", children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"text-xs text-slate-500", children:"Nodes"}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"overflow-auto rounded border border-slate-700/30", children:(0,require$react_SLASH_jsx_runtime.jsxs)("table", {className:"w-full text-xs", children:[(0,require$react_SLASH_jsx_runtime.jsx)("thead", {className:"bg-slate-900/40 text-slate-500", children:(0,require$react_SLASH_jsx_runtime.jsxs)("tr", 
  {children:[(0,require$react_SLASH_jsx_runtime.jsx)("th", {className:"text-left px-2 py-1", children:"id"}), (0,require$react_SLASH_jsx_runtime.jsx)("th", {className:"text-left px-2 py-1", children:"kind"}), (0,require$react_SLASH_jsx_runtime.jsx)("th", {className:"text-left px-2 py-1", children:"layer"}), (0,require$react_SLASH_jsx_runtime.jsx)("th", {className:"text-left px-2 py-1", children:"label"})]})}), (0,require$react_SLASH_jsx_runtime.jsx)("tbody", {children:$.nodes.map(U => (0,require$react_SLASH_jsx_runtime.jsxs)("tr", 
  {className:`border-t border-slate-700/20 hover:bg-slate-700/10 cursor-pointer ${u === U.id ? "bg-slate-700/20" : ""}`, onClick:() => h(U.id), title:U.id, children:[(0,require$react_SLASH_jsx_runtime.jsx)("td", {className:"px-2 py-1 font-mono text-slate-300 truncate max-w-[180px]", children:U.id}), (0,require$react_SLASH_jsx_runtime.jsx)("td", {className:"px-2 py-1 text-slate-300", children:U.kind}), (0,require$react_SLASH_jsx_runtime.jsx)("td", {className:"px-2 py-1 text-slate-400", children:U.layer}), 
  (0,require$react_SLASH_jsx_runtime.jsx)("td", {className:"px-2 py-1 text-slate-200 truncate max-w-[220px]", children:U.label})]}, U.id))})]})})]}), u && (() => {
    const U = $.nodes.find(le => le.id === u);
    return U ? (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"space-y-2", children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"text-xs text-slate-500", children:"Selected node data"}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"rounded border border-slate-700/30 bg-slate-900/30 p-2", children:(0,require$react_SLASH_jsx_runtime.jsx)(jp, {label:"data", value:U.data, defaultExpandDepth:k})})]}) : null;
  })(), u && (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"space-y-2", children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"text-xs text-slate-500", children:"Source data"}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"rounded border border-slate-700/30 bg-slate-900/20 p-2 space-y-2", children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"text-[10px] text-slate-500", children:"Graph-weaver preview (files/urls)"}), X && (0,require$react_SLASH_jsx_runtime.jsx)("div", 
  {className:"rounded bg-rose-500/10 border border-rose-500/20 px-2 py-1 text-xs text-rose-300", children:X}), ee ? (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"text-xs text-slate-600", children:"Loading preview\u2026"}) : D != null && D.body ? (0,require$react_SLASH_jsx_runtime.jsxs)("details", {open:!0, children:[(0,require$react_SLASH_jsx_runtime.jsxs)("summary", {className:"cursor-pointer text-xs text-slate-400", children:[D.format, D.truncated ? " (truncated)" : "", " \u00b7 ", 
  D.bytes, " bytes"]}), (0,require$react_SLASH_jsx_runtime.jsx)("pre", {className:"mt-2 text-xs text-slate-300 font-mono whitespace-pre-wrap", children:D.body})]}) : (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"text-xs text-slate-600", children:"No preview available for this node kind."})]}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"rounded border border-slate-700/30 bg-slate-900/20 p-2 space-y-2", children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"text-[10px] text-slate-500", 
  children:"OpenPlanner source event(s) (Mongo events by extra.entity_key)"}), V && (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"rounded bg-rose-500/10 border border-rose-500/20 px-2 py-1 text-xs text-rose-300", children:V}), z ? (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"text-xs text-slate-600", children:"Loading source event\u2026"}) : F && F.length > 0 ? (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"space-y-2", children:F.map(U => {
    const le = (U == null ? void 0 : U._id) ?? (U == null ? void 0 : U.id) ?? "event", be = (U == null ? void 0 : U.kind) ?? "unknown", je = (U == null ? void 0 : U.ts) ?? (U == null ? void 0 : U.createdAt) ?? (U == null ? void 0 : U.updatedAt) ?? null, Ae = typeof(U == null ? void 0 : U.text) == "string" ? U.text.length > 220 ? `${U.text.slice(0, 217)}\u2026` : U.text : null;
    return (0,require$react_SLASH_jsx_runtime.jsxs)("details", {className:"rounded border border-slate-700/30 bg-slate-900/30 px-2 py-1", open:!0, children:[(0,require$react_SLASH_jsx_runtime.jsxs)("summary", {className:"cursor-pointer text-xs text-slate-300", children:[(0,require$react_SLASH_jsx_runtime.jsx)("span", {className:"text-slate-500", children:be}), je ? (0,require$react_SLASH_jsx_runtime.jsxs)("span", {className:"text-slate-600", children:[" \u00b7 ", String(je)]}) : null, (0,require$react_SLASH_jsx_runtime.jsx)("span", 
    {className:"text-slate-700", children:" \u00b7 "}), (0,require$react_SLASH_jsx_runtime.jsx)("span", {className:"font-mono text-slate-400", children:String(le)})]}), Ae && (0,require$react_SLASH_jsx_runtime.jsx)("pre", {className:"mt-2 text-xs text-slate-300 font-mono whitespace-pre-wrap", children:Ae}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"mt-2", children:(0,require$react_SLASH_jsx_runtime.jsx)(jp, {value:U, defaultExpandDepth:k})})]}, String(le));
  })}) : (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"text-xs text-slate-600", children:["No matching Mongo event found yet. Try again after ingestion catches up.", (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"mt-1 text-[10px] text-slate-600 font-mono", children:["filter:", " ", JSON.stringify({kind:"graph.node", "extra.entity_key":u})]})]})]})]}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"space-y-2", children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", 
  {className:"text-xs text-slate-500", children:"Edges"}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"overflow-auto rounded border border-slate-700/30", children:(0,require$react_SLASH_jsx_runtime.jsxs)("table", {className:"w-full text-xs", children:[(0,require$react_SLASH_jsx_runtime.jsx)("thead", {className:"bg-slate-900/40 text-slate-500", children:(0,require$react_SLASH_jsx_runtime.jsxs)("tr", {children:[(0,require$react_SLASH_jsx_runtime.jsx)("th", {className:"text-left px-2 py-1", 
  children:"kind"}), (0,require$react_SLASH_jsx_runtime.jsx)("th", {className:"text-left px-2 py-1", children:"layer"}), (0,require$react_SLASH_jsx_runtime.jsx)("th", {className:"text-left px-2 py-1", children:"source"}), (0,require$react_SLASH_jsx_runtime.jsx)("th", {className:"text-left px-2 py-1", children:"target"}), (0,require$react_SLASH_jsx_runtime.jsx)("th", {className:"text-left px-2 py-1", children:"similarity"})]})}), (0,require$react_SLASH_jsx_runtime.jsx)("tbody", {children:$.edges.map((U, 
  le) => {
    var Ae;
    const be = (Ae = U.data) == null ? void 0 : Ae.similarity, je = typeof be == "number" ? be.toFixed(3) : "";
    return (0,require$react_SLASH_jsx_runtime.jsxs)("tr", {className:"border-t border-slate-700/20 hover:bg-slate-700/10", title:`${U.source} -> ${U.target}`, children:[(0,require$react_SLASH_jsx_runtime.jsx)("td", {className:"px-2 py-1 text-slate-300", children:U.kind}), (0,require$react_SLASH_jsx_runtime.jsx)("td", {className:"px-2 py-1 text-slate-400", children:U.layer}), (0,require$react_SLASH_jsx_runtime.jsx)("td", {className:"px-2 py-1 font-mono text-slate-300 truncate max-w-[150px]", children:U.source}), 
    (0,require$react_SLASH_jsx_runtime.jsx)("td", {className:"px-2 py-1 font-mono text-slate-300 truncate max-w-[150px]", children:U.target}), (0,require$react_SLASH_jsx_runtime.jsx)("td", {className:"px-2 py-1 text-slate-300", children:je})]}, `${U.source}|${U.target}|${U.kind}|${le}`);
  })})]})})]}), (0,require$react_SLASH_jsx_runtime.jsxs)("details", {children:[(0,require$react_SLASH_jsx_runtime.jsx)("summary", {className:"cursor-pointer text-xs text-slate-500", children:"Raw JSON"}), (0,require$react_SLASH_jsx_runtime.jsx)("pre", {className:"mt-2 text-xs text-slate-300 font-mono whitespace-pre-wrap", children:T})]})]}) : (0,require$react_SLASH_jsx_runtime.jsx)("pre", {className:"text-xs text-slate-300 font-mono whitespace-pre-wrap", children:T}) : (0,require$react_SLASH_jsx_runtime.jsx)("div", 
  {className:"text-xs text-slate-600", children:"Query results appear here"})})]})]});
}
function H1(t) {
  if (!t) {
    return "never";
  }
  const e = Date.now() - (new Date(t)).getTime(), n = Math.floor(e / 6e4);
  if (n < 1) {
    return "just now";
  }
  if (n < 60) {
    return `${n}m ago`;
  }
  const r = Math.floor(n / 60);
  return r < 24 ? `${r}h ago` : `${Math.floor(r / 24)}d ago`;
}
function Y3(t) {
  switch(t) {
    case "completed":
    case "ok":
      return "text-emerald-400";
    case "running":
      return "text-blue-400";
    case "pending":
      return "text-amber-400";
    case "failed":
      return "text-rose-400";
    default:
      return "text-slate-400";
  }
}
function G3(t) {
  switch(t) {
    case "completed":
    case "ok":
      return "bg-emerald-400";
    case "running":
      return "bg-blue-400 animate-pulse";
    case "pending":
      return "bg-amber-400";
    case "failed":
      return "bg-rose-400";
    default:
      return "bg-slate-600";
  }
}
function wn(t) {
  return t >= 1e6 ? `${(t / 1e6).toFixed(1)}M` : t >= 1e3 ? `${(t / 1e3).toFixed(1)}K` : String(t);
}
const w2 = [{id:"semantic_edges_full", title:"Build Semantic Edges (full)", path:"jobs/build-semantic-edges", defaultBody:{k:8, minSimilarity:0.3}, desc:"Mongot-native kNN semantic edge builder"}, {id:"semantic_edges_incremental", title:"Build Semantic Edges (incremental)", path:"jobs/build-semantic-edges/incremental", defaultBody:{}, desc:"Incremental semantic edge build (experimental)"}, {id:"strip_chunk_content", title:"Strip Chunk Content", path:"jobs/strip-chunk-content", defaultBody:{}, desc:"Reduce stored chunk payloads (space/safety)"}, 
{id:"seed_layout", title:"Seed Layout", path:"jobs/seed-layout", defaultBody:{}, desc:"Seed graph layout overrides for stability"}, {id:"backfill_embeddings", title:"Backfill Embeddings", path:"jobs/backfill/embeddings", defaultBody:{}, desc:"Rebuild embeddings across events"}, {id:"backfill_graph_node_embeddings", title:"Backfill Graph Node Embeddings", path:"jobs/backfill/graph-node-embeddings", defaultBody:{}, desc:"Populate graph_node_embeddings for graph.node events"}, {id:"backfill_graph_edges", 
title:"Backfill Graph Edges", path:"jobs/backfill/graph-edges", defaultBody:{}, desc:"Reproject historical graph.edge events into graph_edges"}, {id:"compact_semantic", title:"Semantic Compaction", path:"jobs/compact/semantic", defaultBody:{}, desc:"Semantic compaction job (async)"}];
function Cd({children:t, color:e}) {
  return (0,require$react_SLASH_jsx_runtime.jsx)("span", {className:`text-xs px-1.5 py-0.5 rounded ${e || "bg-slate-700/50 text-slate-400"}`, children:t});
}
function Q3({ok:t}) {
  return (0,require$react_SLASH_jsx_runtime.jsx)("span", {className:`inline-block h-2.5 w-2.5 rounded-full ${t ? "bg-emerald-400" : "bg-rose-400"}`});
}
function kne({active:t, onClick:e, icon:n, label:r}) {
  return (0,require$react_SLASH_jsx_runtime.jsxs)("button", {onClick:e, className:`shrink-0 rounded-md px-3 py-1.5 text-xs font-medium transition whitespace-nowrap ${t ? "bg-blue-500/15 text-blue-300" : "text-slate-400 hover:bg-slate-800 hover:text-slate-200"}`, children:[(0,require$react_SLASH_jsx_runtime.jsx)("span", {className:"mr-1", children:n}), r]});
}
function Ene({sources:t, jobs:e, health:n, graphStats:r, embeddingCoverage:i, onBuildEdges:s}) {
  var c, u, h;
  const o = e.filter(f => f.status === "running" || f.status === "pending"), a = (r == null ? void 0 : r.total) || 0, l = (n == null ? void 0 : n.services) || null;
  return (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"space-y-4", children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"grid grid-cols-3 gap-3", children:l && [{name:"OpenPlanner", key:"openplanner"}, {name:"Proxx", key:"proxx"}, {name:"Ingestion", key:"ingestion"}].map(({name:f, key:p}) => {
    const g = l[p];
    return g ? (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"rounded-lg border border-slate-700/50 bg-slate-800/30 px-4 py-3 flex items-center gap-3", children:[(0,require$react_SLASH_jsx_runtime.jsx)(Q3, {ok:g.ok}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"text-sm text-slate-200", children:f}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"text-xs text-slate-500", children:g.ok ? "healthy" : g.error || 
    "down"})]})]}, f) : null;
  })}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"grid grid-cols-2 lg:grid-cols-5 gap-3", children:[{l:"Sources", v:String(t.length), sub:`${t.filter(f => f.enabled).length} enabled`}, {l:"Active Jobs", v:String(o.length), color:o.length > 0 ? "text-blue-400" : void 0}, {l:"Documents", v:wn(a)}, {l:"Graph Nodes", v:r != null && r.stats ? wn(r.stats.nodes) : "\u2026"}, {l:"Semantic Edges", v:r != null && r.stats ? wn(r.stats.semanticEdges) : "\u2026", color:((c = r == null ? void 0 : 
  r.stats) == null ? void 0 : c.semanticEdges) === 0 ? "text-amber-400" : void 0}].map(f => (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"rounded-lg border border-slate-700/50 bg-slate-800/40 px-4 py-3", children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"text-xs text-slate-500 mb-1", children:f.l}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:`text-xl font-bold ${f.color || "text-slate-100"}`, children:f.v}), f.sub && (0,require$react_SLASH_jsx_runtime.jsx)("div", 
  {className:"text-xs text-slate-500 mt-0.5", children:f.sub})]}, f.l))}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"flex gap-2", children:(0,require$react_SLASH_jsx_runtime.jsx)("button", {onClick:s, className:"rounded-md border border-blue-500/30 bg-blue-500/10 px-3 py-1.5 text-xs text-blue-300 hover:bg-blue-500/20 transition", children:"\u26a1 Rebuild Semantic Edges"})}), (i == null ? void 0 : i.coverage) && (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"rounded-lg border border-slate-700/50 bg-slate-800/30 px-4 py-3 space-y-3", 
  children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"flex items-center justify-between", children:[(0,require$react_SLASH_jsx_runtime.jsx)("h3", {className:"text-xs font-semibold text-slate-400 uppercase tracking-wider", children:"Embedding Coverage"}), (0,require$react_SLASH_jsx_runtime.jsxs)("span", {className:`text-xs font-bold ${i.coverage.embeddingRate >= 0.8 ? "text-emerald-400" : i.coverage.embeddingRate >= 0.5 ? "text-amber-400" : "text-rose-400"}`, children:[(i.coverage.embeddingRate * 
  100).toFixed(1), "%"]})]}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"grid grid-cols-3 gap-3", children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"text-[10px] text-slate-500", children:"Total Events"}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"text-sm font-bold text-slate-200", children:wn(i.coverage.totalEvents)})]}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", 
  {className:"text-[10px] text-slate-500", children:"Graph Nodes"}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"text-sm font-bold text-slate-200", children:wn(i.coverage.totalGraphNodes)})]}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"text-[10px] text-slate-500", children:"Embeddings"}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"text-sm font-bold text-slate-200", children:wn(i.coverage.totalEmbeddings)})]})]}), 
  ((u = i.byNodeKind) == null ? void 0 : u.length) > 0 && (0,require$react_SLASH_jsx_runtime.jsxs)("div", {children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"text-[10px] text-slate-500 mb-1", children:"By Node Kind"}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"flex flex-wrap gap-1", children:i.byNodeKind.slice(0, 12).map(f => (0,require$react_SLASH_jsx_runtime.jsxs)(Cd, {children:[f.kind, ": ", wn(f.count)]}, f.kind))})]}), ((h = i.byModel) == null ? void 0 : h.length) > 
  0 && (0,require$react_SLASH_jsx_runtime.jsxs)("div", {children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"text-[10px] text-slate-500 mb-1", children:"By Model"}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"flex flex-wrap gap-1", children:i.byModel.slice(0, 6).map(f => (0,require$react_SLASH_jsx_runtime.jsxs)(Cd, {color:"bg-purple-500/10 text-purple-400", children:[f.model, ": ", wn(f.count)]}, f.model))})]})]}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {children:[(0,require$react_SLASH_jsx_runtime.jsx)("h3", 
  {className:"text-xs font-semibold text-slate-400 uppercase tracking-wider mb-2", children:"Recent Jobs"}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"rounded-lg border border-slate-700/50 bg-slate-800/30 overflow-hidden", children:(0,require$react_SLASH_jsx_runtime.jsxs)("table", {className:"w-full text-xs", children:[(0,require$react_SLASH_jsx_runtime.jsx)("thead", {children:(0,require$react_SLASH_jsx_runtime.jsxs)("tr", {className:"border-b border-slate-700/30", children:[(0,require$react_SLASH_jsx_runtime.jsx)("th", 
  {className:"text-left px-3 py-2 text-slate-500", children:"Status"}), (0,require$react_SLASH_jsx_runtime.jsx)("th", {className:"text-left px-3 py-2 text-slate-500", children:"Source"}), (0,require$react_SLASH_jsx_runtime.jsx)("th", {className:"text-right px-3 py-2 text-slate-500", children:"Files"}), (0,require$react_SLASH_jsx_runtime.jsx)("th", {className:"text-right px-3 py-2 text-slate-500", children:"Done"}), (0,require$react_SLASH_jsx_runtime.jsx)("th", {className:"text-right px-3 py-2 text-slate-500", 
  children:"Fail"}), (0,require$react_SLASH_jsx_runtime.jsx)("th", {className:"text-right px-3 py-2 text-slate-500", children:"When"})]})}), (0,require$react_SLASH_jsx_runtime.jsx)("tbody", {children:e.slice(0, 15).map(f => {
    const p = t.find(g => g.source_id === f.source_id);
    return (0,require$react_SLASH_jsx_runtime.jsxs)("tr", {className:"border-b border-slate-700/20 hover:bg-slate-700/10", children:[(0,require$react_SLASH_jsx_runtime.jsx)("td", {className:"px-3 py-1.5", children:(0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"flex items-center gap-1.5", children:[(0,require$react_SLASH_jsx_runtime.jsx)("span", {className:`h-2 w-2 rounded-full ${G3(f.status)}`}), (0,require$react_SLASH_jsx_runtime.jsx)("span", {className:Y3(f.status), children:f.status})]})}), 
    (0,require$react_SLASH_jsx_runtime.jsx)("td", {className:"px-3 py-1.5 text-slate-300 truncate max-w-[120px]", children:(p == null ? void 0 : p.name) || f.source_id.slice(0, 8)}), (0,require$react_SLASH_jsx_runtime.jsx)("td", {className:"px-3 py-1.5 text-right text-slate-400", children:wn(f.total_files)}), (0,require$react_SLASH_jsx_runtime.jsx)("td", {className:"px-3 py-1.5 text-right text-emerald-400", children:wn(f.processed_files)}), (0,require$react_SLASH_jsx_runtime.jsx)("td", {className:"px-3 py-1.5 text-right text-rose-400", 
    children:f.failed_files > 0 ? wn(f.failed_files) : "-"}), (0,require$react_SLASH_jsx_runtime.jsx)("td", {className:"px-3 py-1.5 text-right text-slate-500", children:H1(f.created_at)})]}, f.job_id);
  })})]})})]})]});
}
function Tne({sources:t, jobs:e, onSync:n}) {
  const [r, i] = (0,require$react.useState)(null), [s, o] = (0,require$react.useState)({}), a = async l => {
    if (r === l) {
      i(null);
      return;
    }
    if (i(l), !s[l]) {
      try {
        const c = await B3(l);
        o(u => ({...u, [l]:c}));
      } catch {
      }
    }
  };
  return (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"space-y-2", children:t.map(l => {
    var b, x, w;
    const c = e.filter(v => v.source_id === l.source_id), u = c.find(v => v.status === "running" || v.status === "pending"), h = c.sort((v, T) => (new Date(T.created_at)).getTime() - (new Date(v.created_at)).getTime())[0], f = (u == null ? void 0 : u.status) || (h == null ? void 0 : h.status) || "none", p = (b = l.config) == null ? void 0 : b.contract_source_id, g = ((x = l.config) == null ? void 0 : x.root_path) || ((w = l.config) == null ? void 0 : w["root-path"]), m = s[l.source_id];
    return (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"rounded-lg border border-slate-700/50 bg-slate-800/30 overflow-hidden", children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"flex items-center justify-between px-4 py-3", children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"flex items-center gap-3 min-w-0", children:[(0,require$react_SLASH_jsx_runtime.jsx)("span", {className:`h-2.5 w-2.5 rounded-full shrink-0 ${G3(f)}`}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", 
    {className:"min-w-0", children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"flex items-center gap-2", children:[(0,require$react_SLASH_jsx_runtime.jsx)("span", {className:"text-sm font-medium text-slate-200 truncate", children:l.name}), (0,require$react_SLASH_jsx_runtime.jsx)(Cd, {children:l.driver_type}), p && (0,require$react_SLASH_jsx_runtime.jsx)(Cd, {color:"bg-emerald-500/10 text-emerald-400", children:p})]}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"flex items-center gap-3 mt-0.5", 
    children:[(0,require$react_SLASH_jsx_runtime.jsx)("span", {className:"text-xs text-slate-500 truncate", children:g || "no path"}), (0,require$react_SLASH_jsx_runtime.jsxs)("span", {className:`text-xs ${Y3(f)}`, children:[f, h ? ` \u00b7 ${H1(h.created_at)}` : ""]})]})]})]}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"flex items-center gap-2 shrink-0", children:[u && (0,require$react_SLASH_jsx_runtime.jsxs)("span", {className:"text-xs text-blue-400", children:[wn(u.processed_files), 
    "/", wn(u.total_files)]}), (0,require$react_SLASH_jsx_runtime.jsxs)("button", {onClick:() => a(l.source_id), className:"text-xs text-slate-500 hover:text-slate-300 px-2 py-1 rounded hover:bg-slate-700/50", children:[r === l.source_id ? "\u25be" : "\u25b8", " audit"]}), (0,require$react_SLASH_jsx_runtime.jsx)("button", {onClick:() => n(l.source_id), disabled:f === "running", className:"text-xs text-blue-400 hover:text-blue-300 disabled:text-slate-600 disabled:cursor-not-allowed px-2 py-1 rounded hover:bg-slate-700/50", 
    children:"sync"})]})]}), r === l.source_id && m && (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"px-4 py-3 border-t border-slate-700/30 bg-slate-900/30", children:(0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"grid grid-cols-5 gap-2 text-center text-xs", children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"text-sm font-medium text-slate-300", children:wn(m.matching_files)}), (0,require$react_SLASH_jsx_runtime.jsx)("div", 
    {className:"text-slate-500", children:"matched"})]}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"text-sm font-medium text-emerald-400", children:wn(m.state_ingested_files)}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"text-slate-500", children:"ingested"})]}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"text-sm font-medium text-blue-400", 
    children:wn(m.openplanner_documents)}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"text-slate-500", children:"in OP"})]}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"text-sm font-medium text-amber-400", children:wn(m.state_failed_files)}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"text-slate-500", children:"failed"})]}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", 
    {className:`text-sm font-medium ${m.coverage_delta > 0 ? "text-amber-400" : "text-emerald-400"}`, children:m.coverage_delta > 0 ? `+${wn(m.coverage_delta)}` : "\u2713"}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"text-slate-500", children:"delta"})]})]})})]}, l.source_id);
  })});
}
function Cne() {
  const [t, e] = (0,require$react.useState)(null), [n, r] = (0,require$react.useState)(null), [i, s] = (0,require$react.useState)(!1), [o, a] = (0,require$react.useState)(""), l = async(m = "") => {
    s(!0), a(m), r(null);
    try {
      const b = new URLSearchParams();
      m && b.set("path", m);
      const x = await fetch(`/api/ingestion/browse?${b.toString()}`);
      if (!x.ok) {
        throw new Error(`Browse failed: ${x.status}`);
      }
      e(await x.json());
    } catch (b) {
      e(null), r({content:`Error: ${b.message}`});
    } finally {
      s(!1);
    }
  }, c = async m => {
    try {
      const b = await fetch(`/api/ingestion/file?path=${encodeURIComponent(m)}`);
      if (!b.ok) {
        throw new Error(`Preview failed: ${b.status}`);
      }
      r(await b.json());
    } catch (b) {
      r({content:`Error: ${b.message}`, path:m});
    }
  };
  (0,require$react.useEffect)(() => {
    l("");
  }, []);
  const u = (t == null ? void 0 : t.entries) || [], h = new Set(), f = u.filter(m => {
    if (m.type !== "dir") {
      return !1;
    }
    const b = m.path || m.name;
    return h.has(b) ? !1 : (h.add(b), !0);
  }), p = u.filter(m => {
    if (m.type === "dir") {
      return !1;
    }
    const b = m.path || m.name;
    return h.has(b) ? !1 : (h.add(b), !0);
  }), g = o.includes("/") ? o.split("/").slice(0, -1).join("/") : "";
  return (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"flex gap-4 h-[600px]", children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"w-1/2 flex flex-col rounded-lg border border-slate-700/50 bg-slate-800/30 overflow-hidden", children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"shrink-0 px-3 py-2 border-b border-slate-700/30 flex items-center gap-2 text-xs", children:[(t == null ? void 0 : t.workspace_root) && (0,require$react_SLASH_jsx_runtime.jsxs)("span", 
  {className:"text-slate-600 truncate shrink-0 max-w-[200px]", title:t.workspace_root, children:[t.workspace_root.split("/").pop(), "/"]}), (0,require$react_SLASH_jsx_runtime.jsx)("span", {className:"text-slate-400 truncate", children:o || "(root)"})]}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"flex-1 overflow-y-auto", children:i ? (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"p-4 text-xs text-slate-500", children:"Loading..."}) : (0,require$react_SLASH_jsx_runtime.jsxs)("div", 
  {className:"divide-y divide-slate-700/20", children:[o && (0,require$react_SLASH_jsx_runtime.jsxs)("button", {onClick:() => l(g), className:"w-full flex items-center gap-2 px-3 py-1.5 hover:bg-slate-700/20 text-left text-xs text-slate-500", children:[(0,require$react_SLASH_jsx_runtime.jsx)("span", {children:"\u25b8"}), " .."]}), f.map(m => (0,require$react_SLASH_jsx_runtime.jsxs)("button", {onClick:() => l(m.path), className:"w-full flex items-center gap-2 px-3 py-1.5 hover:bg-slate-700/20 text-left", 
  children:[(0,require$react_SLASH_jsx_runtime.jsx)("span", {className:"text-slate-400 shrink-0", children:"\u25b8"}), (0,require$react_SLASH_jsx_runtime.jsx)("span", {className:"text-xs text-slate-200 truncate", children:m.name}), m.ingestion_status && m.ingestion_status !== "not_ingested" && (0,require$react_SLASH_jsx_runtime.jsx)("span", {className:`text-xs shrink-0 ml-auto ${m.ingestion_status === "ingested" ? "text-emerald-500" : m.ingestion_status === "failed" ? "text-rose-500" : "text-amber-500"}`, 
  children:"\u25cf"})]}, m.path)), p.map(m => (0,require$react_SLASH_jsx_runtime.jsxs)("button", {onClick:() => c(m.path), className:`w-full flex items-center gap-2 px-3 py-1.5 hover:bg-slate-700/20 text-left ${(n == null ? void 0 : n.path) === m.path ? "bg-slate-700/30" : ""}`, children:[(0,require$react_SLASH_jsx_runtime.jsx)("span", {className:"text-slate-600 shrink-0", children:"\u00b7"}), (0,require$react_SLASH_jsx_runtime.jsx)("span", {className:"text-xs text-slate-300 truncate", children:m.name}), 
  m.size != null && (0,require$react_SLASH_jsx_runtime.jsx)("span", {className:"text-xs text-slate-600 ml-auto shrink-0", children:wn(m.size)}), m.ingestion_status && m.ingestion_status !== "not_ingested" && (0,require$react_SLASH_jsx_runtime.jsx)("span", {className:`text-xs shrink-0 ${m.ingestion_status === "ingested" ? "text-emerald-500" : m.ingestion_status === "failed" ? "text-rose-500" : "text-amber-500"}`, children:"\u25cf"})]}, m.path)), u.length === 0 && !i && (0,require$react_SLASH_jsx_runtime.jsx)("div", 
  {className:"p-4 text-xs text-slate-500 text-center", children:"Empty directory"})]})}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"shrink-0 px-3 py-1.5 border-t border-slate-700/30 text-xs text-slate-600", children:[f.length, " dirs, ", p.length, " files"]})]}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"w-1/2 flex flex-col rounded-lg border border-slate-700/50 bg-slate-800/30 overflow-hidden", children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"shrink-0 px-3 py-2 border-b border-slate-700/30 flex items-center justify-between", 
  children:[(0,require$react_SLASH_jsx_runtime.jsx)("span", {className:"text-xs text-slate-500 truncate", children:(n == null ? void 0 : n.path) || "Select a file"}), (n == null ? void 0 : n.size) != null && (0,require$react_SLASH_jsx_runtime.jsxs)("span", {className:"text-xs text-slate-600", children:[wn(n.size), n.truncated ? " (truncated)" : ""]})]}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"flex-1 overflow-auto p-3", children:n != null && n.content ? (0,require$react_SLASH_jsx_runtime.jsx)("pre", 
  {className:"text-xs text-slate-300 font-mono whitespace-pre-wrap break-words", children:n.content}) : n ? (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"text-xs text-slate-600", children:"No content"}) : (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"text-xs text-slate-600", children:"Click a file to preview"})})]})]});
}
function Ane() {
  const [t, e] = (0,require$react.useState)(null), [n, r] = (0,require$react.useState)(!0), [i, s] = (0,require$react.useState)(""), [o, a] = (0,require$react.useState)(""), l = (0,require$react.useCallback)(async() => {
    r(!0);
    try {
      const c = new URLSearchParams();
      i && c.set("project", i), o && c.set("kind", o), c.set("limit", "100");
      const u = await fetch(`/api/data/op/documents?${c.toString()}`);
      if (u.ok) {
        const h = await u.json();
        e({documents:h.rows || [], total:h.total || 0});
      } else {
        e(null);
      }
    } catch {
      e(null);
    } finally {
      r(!1);
    }
  }, [i, o]);
  return (0,require$react.useEffect)(() => {
    l();
  }, [l]), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"space-y-3", children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"flex gap-2", children:[(0,require$react_SLASH_jsx_runtime.jsx)("input", {value:i, onChange:c => s(c.target.value), placeholder:"Filter by project...", className:"bg-slate-900/50 border border-slate-700/50 rounded px-3 py-1.5 text-xs text-slate-200 placeholder-slate-600 focus:outline-none focus:border-slate-600 w-40"}), (0,require$react_SLASH_jsx_runtime.jsxs)("select", 
  {value:o, onChange:c => a(c.target.value), className:"bg-slate-900/50 border border-slate-700/50 rounded px-3 py-1.5 text-xs text-slate-200 focus:outline-none", children:[(0,require$react_SLASH_jsx_runtime.jsx)("option", {value:"", children:"All kinds"}), (0,require$react_SLASH_jsx_runtime.jsx)("option", {value:"docs", children:"docs"}), (0,require$react_SLASH_jsx_runtime.jsx)("option", {value:"code", children:"code"}), (0,require$react_SLASH_jsx_runtime.jsx)("option", {value:"config", children:"config"}), 
  (0,require$react_SLASH_jsx_runtime.jsx)("option", {value:"data", children:"data"})]}), (0,require$react_SLASH_jsx_runtime.jsx)("button", {onClick:l, className:"text-xs text-blue-400 px-3 py-1.5 rounded hover:bg-slate-700/50", children:"Search"})]}), n ? (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"text-xs text-slate-500", children:"Loading..."}) : t != null && t.documents ? (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"rounded-lg border border-slate-700/50 bg-slate-800/30 overflow-hidden", 
  children:(0,require$react_SLASH_jsx_runtime.jsxs)("table", {className:"w-full text-xs", children:[(0,require$react_SLASH_jsx_runtime.jsx)("thead", {children:(0,require$react_SLASH_jsx_runtime.jsxs)("tr", {className:"border-b border-slate-700/30", children:[(0,require$react_SLASH_jsx_runtime.jsx)("th", {className:"text-left px-3 py-2 text-slate-500", children:"Title"}), (0,require$react_SLASH_jsx_runtime.jsx)("th", {className:"text-left px-3 py-2 text-slate-500", children:"Kind"}), (0,require$react_SLASH_jsx_runtime.jsx)("th", 
  {className:"text-left px-3 py-2 text-slate-500", children:"Project"}), (0,require$react_SLASH_jsx_runtime.jsx)("th", {className:"text-left px-3 py-2 text-slate-500", children:"Source"}), (0,require$react_SLASH_jsx_runtime.jsx)("th", {className:"text-right px-3 py-2 text-slate-500", children:"When"})]})}), (0,require$react_SLASH_jsx_runtime.jsx)("tbody", {children:t.documents.map(c => (0,require$react_SLASH_jsx_runtime.jsxs)("tr", {className:"border-b border-slate-700/20 hover:bg-slate-700/10", 
  children:[(0,require$react_SLASH_jsx_runtime.jsx)("td", {className:"px-3 py-1.5 text-slate-300 truncate max-w-[200px]", children:c.title}), (0,require$react_SLASH_jsx_runtime.jsx)("td", {className:"px-3 py-1.5", children:(0,require$react_SLASH_jsx_runtime.jsx)(Cd, {children:c.kind})}), (0,require$react_SLASH_jsx_runtime.jsx)("td", {className:"px-3 py-1.5 text-slate-400", children:c.project}), (0,require$react_SLASH_jsx_runtime.jsx)("td", {className:"px-3 py-1.5 text-slate-500", children:c.source}), 
  (0,require$react_SLASH_jsx_runtime.jsx)("td", {className:"px-3 py-1.5 text-right text-slate-500", children:H1(c.ts)})]}, c.id))})]})}) : (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"text-xs text-slate-500", children:"No documents found"})]});
}
function Nne({health:t, sources:e, syncing:n, onSync:r, onBuildEdges:i}) {
  const [s, o] = (0,require$react.useState)(null), [a, l] = (0,require$react.useState)(!1), [c, u] = (0,require$react.useState)(null), [h, f] = (0,require$react.useState)(""), [p, g] = (0,require$react.useState)(null), [m, b] = (0,require$react.useState)({}), [x, w] = (0,require$react.useState)(() => Object.fromEntries(w2.map(E => [E.id, JSON.stringify(E.defaultBody ?? {}, null, 2)]))), v = (0,require$react.useCallback)(async() => {
    f("");
    try {
      const E = await td("jobs");
      u((E == null ? void 0 : E.jobs) || []);
    } catch (E) {
      u(null), f((E == null ? void 0 : E.message) || String(E));
    }
  }, []);
  (0,require$react.useEffect)(() => {
    v();
  }, [v]);
  const T = async E => {
    g(E.id);
    try {
      const C = (x[E.id] ?? "").trim(), k = C ? JSON.parse(C) : {}, A = await nd(E.path, k);
      b(P => ({...P, [E.id]:A})), v(), i();
    } catch (C) {
      b(k => ({...k, [E.id]:{error:(C == null ? void 0 : C.message) || String(C)}}));
    } finally {
      g(null);
    }
  }, I = async() => {
    l(!0);
    try {
      const E = await H3({k:8, minSimilarity:0.3});
      o(E), i();
    } catch (E) {
      o({error:String(E)});
    } finally {
      l(!1);
    }
  }, _ = (t == null ? void 0 : t.services) || {};
  return (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"space-y-4", children:[(0,require$react_SLASH_jsx_runtime.jsx)("h3", {className:"text-xs font-semibold text-slate-400 uppercase tracking-wider", children:"Service Health"}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"space-y-2", children:[{id:"openplanner", name:"OpenPlanner", desc:"Document store, graph, embeddings"}, {id:"proxx", name:"Proxx", desc:"LLM proxy, embedding provider"}, {id:"ingestion", name:"Ingestion", 
  desc:"File discovery, chunking, ingestion"}, {id:"graph-weaver", name:"Graph Weaver", desc:"GraphQL + focusedGraphView + WebGL vendor"}, {id:"eros-eris-field-app", name:"Eros-Eris Field App", desc:"Graph layout + semantic worker (always-on)"}, {id:"shuvcrawl", name:"ShuvCrawl", desc:"Browser crawler (web ingestion)"}, {id:"myrmex", name:"Myrmex", desc:"Crawler scheduler + ingestion into OpenPlanner"}, {id:"vexx", name:"Vexx", desc:"Optional acceleration service (NPU/GPU)"}].map(E => {
    const C = _[E.id], k = !!(C != null && C.ok), A = typeof(C == null ? void 0 : C.url) == "string" ? C.url : null, P = C == null ? void 0 : C.detail;
    return (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"rounded-lg border border-slate-700/50 bg-slate-800/30 overflow-hidden", children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"px-4 py-3 flex items-center justify-between", children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"flex items-center gap-3", children:[(0,require$react_SLASH_jsx_runtime.jsx)(Q3, {ok:k}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", 
    {className:"text-sm text-slate-200", children:E.name}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"text-xs text-slate-500", children:E.desc}), A && (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"text-[10px] text-slate-600 font-mono", children:A})]})]}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"text-xs text-slate-500", children:C ? k ? "healthy" : C.error || `status ${C.status}` : "unknown"})]}), P != null && (0,require$react_SLASH_jsx_runtime.jsxs)("details", 
    {className:"border-t border-slate-700/30 bg-slate-900/20", children:[(0,require$react_SLASH_jsx_runtime.jsx)("summary", {className:"cursor-pointer select-none px-4 py-2 text-xs text-slate-500 hover:text-slate-300", children:"details"}), (0,require$react_SLASH_jsx_runtime.jsx)("pre", {className:"px-4 pb-3 text-xs text-slate-300 font-mono whitespace-pre-wrap break-words", children:JSON.stringify(P, null, 2)})]})]}, E.id);
  })}), (0,require$react_SLASH_jsx_runtime.jsx)("h3", {className:"text-xs font-semibold text-slate-400 uppercase tracking-wider mt-6", children:"Ingestion Jobs"}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"rounded-lg border border-slate-700/50 bg-slate-800/30 overflow-hidden", children:(0,require$react_SLASH_jsx_runtime.jsxs)("table", {className:"w-full text-xs", children:[(0,require$react_SLASH_jsx_runtime.jsx)("thead", {className:"border-b border-slate-700/30", children:(0,require$react_SLASH_jsx_runtime.jsxs)("tr", 
  {children:[(0,require$react_SLASH_jsx_runtime.jsx)("th", {className:"text-left px-3 py-2 text-slate-500", children:"Source"}), (0,require$react_SLASH_jsx_runtime.jsx)("th", {className:"text-left px-3 py-2 text-slate-500", children:"Lake"}), (0,require$react_SLASH_jsx_runtime.jsx)("th", {className:"text-left px-3 py-2 text-slate-500", children:"Enabled"}), (0,require$react_SLASH_jsx_runtime.jsx)("th", {className:"text-right px-3 py-2 text-slate-500", children:"Action"})]})}), (0,require$react_SLASH_jsx_runtime.jsx)("tbody", 
  {children:e.map(E => {
    var C, k;
    return (0,require$react_SLASH_jsx_runtime.jsxs)("tr", {className:"border-b border-slate-700/20 hover:bg-slate-700/10", children:[(0,require$react_SLASH_jsx_runtime.jsx)("td", {className:"px-3 py-2 text-slate-200", children:E.name}), (0,require$react_SLASH_jsx_runtime.jsx)("td", {className:"px-3 py-2 text-slate-400", children:((C = E.config) == null ? void 0 : C.target_lake) || ((k = E.config) == null ? void 0 : k["target-lake"]) || "\u2014"}), (0,require$react_SLASH_jsx_runtime.jsx)("td", {className:"px-3 py-2 text-slate-400", 
    children:E.enabled ? "yes" : "no"}), (0,require$react_SLASH_jsx_runtime.jsx)("td", {className:"px-3 py-2 text-right", children:(0,require$react_SLASH_jsx_runtime.jsx)("button", {onClick:() => r(E.source_id), disabled:!E.enabled || !!n[E.source_id], className:"rounded-md border border-blue-500/30 bg-blue-500/10 px-3 py-1.5 text-xs text-blue-300 hover:bg-blue-500/20 disabled:opacity-50", children:n[E.source_id] ? "Running\u2026" : "Run"})})]}, E.source_id);
  })})]})}), (0,require$react_SLASH_jsx_runtime.jsx)("h3", {className:"text-xs font-semibold text-slate-400 uppercase tracking-wider mt-6", children:"OpenPlanner Job Triggers"}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"rounded-lg border border-slate-700/50 bg-slate-800/30 px-4 py-3 space-y-3", children:[w2.map(E => {
    const C = m[E.id], k = p === E.id;
    return (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"rounded border border-slate-700/30 bg-slate-900/20 p-3 space-y-2", children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"flex items-center justify-between gap-3", children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"text-sm text-slate-200", children:E.title}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"text-xs text-slate-500", 
    children:E.desc}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"text-[10px] text-slate-600 font-mono", children:["POST /v1/", E.path]})]}), (0,require$react_SLASH_jsx_runtime.jsx)("button", {onClick:() => void T(E), disabled:k, className:"rounded-md border border-blue-500/30 bg-blue-500/10 px-3 py-1.5 text-xs text-blue-300 hover:bg-blue-500/20 disabled:opacity-50", children:k ? "Running\u2026" : "Run"})]}), (0,require$react_SLASH_jsx_runtime.jsx)("textarea", {value:x[E.id] ?? "", 
    onChange:A => w(P => ({...P, [E.id]:A.target.value})), className:"w-full bg-slate-950/40 border border-slate-700/40 rounded p-2 text-xs text-slate-200 font-mono resize-y h-20", spellCheck:!1}), C && (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"text-xs bg-slate-950/40 rounded p-2 font-mono whitespace-pre-wrap", children:C.error ? (0,require$react_SLASH_jsx_runtime.jsx)("span", {className:"text-rose-400", children:String(C.error)}) : JSON.stringify(C, null, 2)})]}, E.id);
  }), (0,require$react_SLASH_jsx_runtime.jsxs)("details", {children:[(0,require$react_SLASH_jsx_runtime.jsx)("summary", {className:"cursor-pointer text-xs text-slate-500", children:"Legacy trigger: Build Semantic Edges (UI wrapper)"}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"mt-2 flex items-center justify-between", children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"text-sm text-slate-200", children:"Build Semantic Edges"}), 
  (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"text-xs text-slate-500", children:"UI wrapper around /v1/jobs/build-semantic-edges"})]}), (0,require$react_SLASH_jsx_runtime.jsx)("button", {onClick:I, disabled:a, className:"rounded-md border border-blue-500/30 bg-blue-500/10 px-3 py-1.5 text-xs text-blue-300 hover:bg-blue-500/20 disabled:opacity-50", children:a ? "Building..." : "Run"})]}), s && (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"mt-2 text-xs bg-slate-900/50 rounded p-2 font-mono", 
  children:s.error ? (0,require$react_SLASH_jsx_runtime.jsx)("span", {className:"text-rose-400", children:s.error}) : (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"space-y-0.5", children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"text-emerald-400", children:["OK \u2014 ", s.nodes, " nodes, ", s.cappedEdges || s.undirectedEdges, " edges (capped)"]}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"text-slate-500", children:["k\x3d", s.k, ", minSimilarity\x3d", 
  s.minSimilarity, ", maxDegree\x3d", s.maxDegree]})]})})]})]}), (0,require$react_SLASH_jsx_runtime.jsx)("h3", {className:"text-xs font-semibold text-slate-400 uppercase tracking-wider mt-6", children:"OpenPlanner Job Queue"}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"rounded-lg border border-slate-700/50 bg-slate-800/30 px-4 py-3 space-y-3", children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"flex items-center justify-between", children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", 
  {className:"text-xs text-slate-500", children:"/v1/jobs (live queue)"}), (0,require$react_SLASH_jsx_runtime.jsx)("button", {onClick:() => void v(), className:"rounded-md border border-slate-700 bg-slate-800 px-3 py-1 text-xs text-slate-300 hover:bg-slate-700", children:"refresh"})]}), h && (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"rounded bg-rose-500/10 border border-rose-500/20 px-3 py-2 text-xs text-rose-300", children:h}), c ? c.length === 0 ? (0,require$react_SLASH_jsx_runtime.jsx)("div", 
  {className:"text-xs text-slate-600", children:"No jobs in queue"}) : (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"overflow-auto rounded border border-slate-700/30", children:(0,require$react_SLASH_jsx_runtime.jsxs)("table", {className:"w-full text-xs", children:[(0,require$react_SLASH_jsx_runtime.jsx)("thead", {className:"bg-slate-900/40 text-slate-500", children:(0,require$react_SLASH_jsx_runtime.jsxs)("tr", {children:[(0,require$react_SLASH_jsx_runtime.jsx)("th", {className:"text-left px-2 py-1", 
  children:"id"}), (0,require$react_SLASH_jsx_runtime.jsx)("th", {className:"text-left px-2 py-1", children:"kind"}), (0,require$react_SLASH_jsx_runtime.jsx)("th", {className:"text-left px-2 py-1", children:"status"}), (0,require$react_SLASH_jsx_runtime.jsx)("th", {className:"text-left px-2 py-1", children:"updated"})]})}), (0,require$react_SLASH_jsx_runtime.jsx)("tbody", {children:c.slice(0, 50).map(E => (0,require$react_SLASH_jsx_runtime.jsxs)("tr", {className:"border-t border-slate-700/20 hover:bg-slate-700/10", 
  children:[(0,require$react_SLASH_jsx_runtime.jsx)("td", {className:"px-2 py-1 font-mono text-slate-300 truncate max-w-[160px]", children:String(E.id)}), (0,require$react_SLASH_jsx_runtime.jsx)("td", {className:"px-2 py-1 text-slate-300", children:String(E.kind || "")}), (0,require$react_SLASH_jsx_runtime.jsx)("td", {className:"px-2 py-1 text-slate-400", children:String(E.status || "")}), (0,require$react_SLASH_jsx_runtime.jsx)("td", {className:"px-2 py-1 text-slate-600", children:String(E.updated_at || 
  E.updatedAt || "")})]}, String(E.id)))})]})}) : (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"text-xs text-slate-600", children:"Loading\u2026"})]})]});
}
function Ine(t, e, n) {
  const r = (e || "").trim();
  if (!r) {
    return n;
  }
  try {
    return JSON.parse(r);
  } catch (i) {
    throw new Error(`${t} is not valid JSON: ${i.message}`);
  }
}
function One() {
  var G, J, U, le, be, je, Ae;
  const [t, e] = (0,require$react.useState)([]), [n, r] = (0,require$react.useState)(""), [i, s] = (0,require$react.useState)([]), [o, a] = (0,require$react.useState)(!1), [l, c] = (0,require$react.useState)(null), [u, h] = (0,require$react.useState)([]), [f, p] = (0,require$react.useState)(""), [g, m] = (0,require$react.useState)([]), [b, x] = (0,require$react.useState)(null), [w, v] = (0,require$react.useState)(!1), [T, I] = (0,require$react.useState)(""), [_, N] = (0,require$react.useState)(""), 
  [E, C] = (0,require$react.useState)("{}"), [k, A] = (0,require$react.useState)('{"_id": -1}'), [P, W] = (0,require$react.useState)(""), [F, B] = (0,require$react.useState)(50), [z, j] = (0,require$react.useState)(0), [V, ne] = (0,require$react.useState)(""), [D, ie] = (0,require$react.useState)(""), [ee, M] = (0,require$react.useState)("");
  (0,require$react.useEffect)(() => {
    z3().then(ue => e(ue.tables || [])).catch(() => {
    }), F1().then(c).catch(() => {
    }), Ay().then(ue => h(ue.collections || [])).catch(() => {
    });
  }, []);
  const X = async(ue, Le) => {
    a(!0), ie(""), s([]), M("");
    try {
      const $e = await fetch("/api/data/pg/query", {method:"POST", headers:{"Content-Type":"application/json"}, body:JSON.stringify(ue)}), Ye = await $e.json();
      !$e.ok || Ye.error ? ie(Ye.error || `Query failed (${$e.status})`) : (s(Ye.rows || []), M(`${Le} \u2014 ${Ye.count} rows`));
    } catch ($e) {
      ie($e.message);
    } finally {
      a(!1);
    }
  }, ge = ue => {
    r(ue), ne(""), X({table:ue, limit:100}, ue);
  }, me = () => {
    V.trim() && (r(""), X({sql:V, limit:200}, "raw query"));
  }, te = (0,require$react.useCallback)(async() => {
    try {
      const ue = await Ay();
      h(ue.collections || []);
    } catch {
    }
  }, []), q = (0,require$react.useCallback)(Ine, []), R = (0,require$react.useCallback)(async(ue, Le) => {
    if (ue) {
      v(!0), I(""), m([]), x(null), N("");
      try {
        const $e = q("Filter", E, {}), Ye = q("Sort", k, {_id:-1}), Me = q("Projection", P, void 0), Xe = await z1({collection:ue, filter:$e, sort:Ye, projection:Me, limit:F, skip:(Le == null ? void 0 : Le.skip) ?? z});
        !Xe.ok || Xe.error ? I(Xe.error || "Query failed") : (m(Xe.rows || []), N(`${ue} \u2014 ${Xe.count} rows (total ${Xe.total}, skip ${Xe.skip}, limit ${Xe.limit})`));
      } catch ($e) {
        I($e.message);
      } finally {
        v(!1);
      }
    }
  }, [E, k, P, F, z, q]), $ = ue => {
    p(ue), j(0), R(ue, {skip:0});
  };
  return (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"space-y-4", children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {children:[(0,require$react_SLASH_jsx_runtime.jsx)("h3", {className:"text-xs font-semibold text-slate-400 uppercase tracking-wider mb-2", children:"MongoDB (via OpenPlanner)"}), l ? (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"grid grid-cols-2 lg:grid-cols-4 gap-3", children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"rounded-lg border border-slate-700/50 bg-slate-800/40 px-4 py-3", 
  children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"text-xs text-slate-500", children:"Documents"}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"text-xl font-bold text-slate-100", children:wn(((G = l.documents) == null ? void 0 : G.total) || 0)})]}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"rounded-lg border border-slate-700/50 bg-slate-800/40 px-4 py-3", children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"text-xs text-slate-500", 
  children:"Graph Nodes"}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"text-xl font-bold text-slate-100", children:wn(((U = (J = l.graph) == null ? void 0 : J.stats) == null ? void 0 : U.nodes) || 0)})]}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"rounded-lg border border-slate-700/50 bg-slate-800/40 px-4 py-3", children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"text-xs text-slate-500", children:"Embeddings"}), (0,require$react_SLASH_jsx_runtime.jsx)("div", 
  {className:"text-xl font-bold text-slate-100", children:wn(((be = (le = l.graph) == null ? void 0 : le.stats) == null ? void 0 : be.embeddings) || 0)})]}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"rounded-lg border border-slate-700/50 bg-slate-800/40 px-4 py-3", children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"text-xs text-slate-500", children:"Semantic Edges"}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"text-xl font-bold text-slate-100", 
  children:wn(((Ae = (je = l.graph) == null ? void 0 : je.stats) == null ? void 0 : Ae.semanticEdges) || 0)})]})]}) : (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"text-xs text-slate-500", children:"Loading..."}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"mt-3 flex gap-4", children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"w-64 shrink-0", children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"flex items-center justify-between mb-2", 
  children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"text-xs text-slate-500", children:"Collections"}), (0,require$react_SLASH_jsx_runtime.jsx)("button", {onClick:te, className:"text-xs text-blue-400 hover:text-blue-300 px-2 py-1 rounded hover:bg-slate-700/40", children:"refresh"})]}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"rounded-lg border border-slate-700/50 bg-slate-800/30 overflow-hidden max-h-[360px] overflow-y-auto", children:[u.map(ue => (0,require$react_SLASH_jsx_runtime.jsxs)("button", 
  {onClick:() => $(ue.name), className:`w-full px-3 py-1.5 text-xs text-left hover:bg-slate-700/20 flex items-center justify-between gap-2 ${f === ue.name ? "bg-slate-700/30 text-blue-300" : "text-slate-400"}`, children:[(0,require$react_SLASH_jsx_runtime.jsx)("span", {className:"truncate", children:ue.name}), (0,require$react_SLASH_jsx_runtime.jsx)("span", {className:"text-slate-600 shrink-0", children:ue.count >= 0 ? wn(ue.count) : "?"})]}, ue.name)), u.length === 0 && (0,require$react_SLASH_jsx_runtime.jsx)("div", 
  {className:"p-3 text-xs text-slate-600", children:"No collections (or unavailable)"})]})]}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"flex-1 space-y-2", children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"grid grid-cols-1 lg:grid-cols-3 gap-2", children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"text-xs text-slate-500 mb-1", children:"Filter (JSON)"}), (0,require$react_SLASH_jsx_runtime.jsx)("textarea", 
  {value:E, onChange:ue => C(ue.target.value), onKeyDown:ue => {
    ue.key === "Enter" && (ue.metaKey || ue.ctrlKey) && R(f);
  }, className:"w-full bg-slate-900/50 border border-slate-700/50 rounded px-3 py-2 text-xs text-slate-200 font-mono resize-none h-20 focus:outline-none focus:border-slate-600"})]}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"text-xs text-slate-500 mb-1", children:"Sort (JSON)"}), (0,require$react_SLASH_jsx_runtime.jsx)("textarea", {value:k, onChange:ue => A(ue.target.value), onKeyDown:ue => {
    ue.key === "Enter" && (ue.metaKey || ue.ctrlKey) && R(f);
  }, className:"w-full bg-slate-900/50 border border-slate-700/50 rounded px-3 py-2 text-xs text-slate-200 font-mono resize-none h-20 focus:outline-none focus:border-slate-600"})]}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"text-xs text-slate-500 mb-1", children:"Projection (JSON, optional)"}), (0,require$react_SLASH_jsx_runtime.jsx)("textarea", {value:P, onChange:ue => W(ue.target.value), onKeyDown:ue => {
    ue.key === "Enter" && (ue.metaKey || ue.ctrlKey) && R(f);
  }, placeholder:'{ "title": 1, "kind": 1 }', className:"w-full bg-slate-900/50 border border-slate-700/50 rounded px-3 py-2 text-xs text-slate-200 placeholder-slate-600 font-mono resize-none h-20 focus:outline-none focus:border-slate-600"})]})]}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"flex items-end gap-2", children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"text-xs text-slate-500 mb-1", children:"Skip"}), 
  (0,require$react_SLASH_jsx_runtime.jsx)("input", {type:"number", value:z, min:0, onChange:ue => j(Math.max(0, parseInt(ue.target.value || "0", 10) || 0)), className:"w-24 bg-slate-900/50 border border-slate-700/50 rounded px-3 py-1.5 text-xs text-slate-200 focus:outline-none focus:border-slate-600"})]}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"text-xs text-slate-500 mb-1", children:"Limit"}), (0,require$react_SLASH_jsx_runtime.jsx)("input", 
  {type:"number", value:F, min:1, max:500, onChange:ue => B(Math.max(1, Math.min(500, parseInt(ue.target.value || "50", 10) || 50))), className:"w-24 bg-slate-900/50 border border-slate-700/50 rounded px-3 py-1.5 text-xs text-slate-200 focus:outline-none focus:border-slate-600"})]}), (0,require$react_SLASH_jsx_runtime.jsx)("button", {onClick:() => R(f), disabled:w || !f, className:"rounded-md border border-blue-500/30 bg-blue-500/10 px-3 py-1.5 text-xs text-blue-300 hover:bg-blue-500/20 disabled:opacity-50", 
  children:"Run Mongo Query"})]}), T && (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"rounded bg-rose-500/10 border border-rose-500/20 px-3 py-2 text-xs text-rose-300", children:T}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"rounded-lg border border-slate-700/50 bg-slate-800/30 overflow-hidden", children:w ? (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"p-4 text-xs text-slate-500", children:"Loading..."}) : g.length > 0 ? (0,require$react_SLASH_jsx_runtime.jsxs)("div", 
  {children:[_ && (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"px-3 py-1.5 text-xs text-slate-500 border-b border-slate-700/30", children:_}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"overflow-auto max-h-[360px]", children:(0,require$react_SLASH_jsx_runtime.jsxs)("table", {className:"w-full text-xs", children:[(0,require$react_SLASH_jsx_runtime.jsx)("thead", {children:(0,require$react_SLASH_jsx_runtime.jsx)("tr", {className:"border-b border-slate-700/30", children:Object.keys(g[0]).slice(0, 
  8).map(ue => (0,require$react_SLASH_jsx_runtime.jsx)("th", {className:"text-left px-3 py-2 text-slate-500 whitespace-nowrap", children:ue}, ue))})}), (0,require$react_SLASH_jsx_runtime.jsx)("tbody", {children:g.map((ue, Le) => (0,require$react_SLASH_jsx_runtime.jsx)("tr", {onClick:() => x(ue), className:`border-b border-slate-700/20 hover:bg-slate-700/10 cursor-pointer ${b === ue ? "bg-slate-700/20" : ""}`, children:Object.values(ue).slice(0, 8).map(($e, Ye) => (0,require$react_SLASH_jsx_runtime.jsx)("td", 
  {className:"px-3 py-1.5 text-slate-300 truncate max-w-[150px]", children:$e === null ? (0,require$react_SLASH_jsx_runtime.jsx)("span", {className:"text-slate-600", children:"null"}) : typeof $e == "object" ? JSON.stringify($e).slice(0, 60) : String($e)}, Ye))}, Le))})]})}), b && (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"border-t border-slate-700/30 bg-slate-900/40 p-3", children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"text-xs text-slate-500 mb-2", children:"Selected document"}), 
  (0,require$react_SLASH_jsx_runtime.jsx)("pre", {className:"text-xs text-slate-300 font-mono whitespace-pre-wrap break-words", children:JSON.stringify(b, null, 2)})]})]}) : (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"p-4 text-xs text-slate-500", children:"Select a collection to browse"})})]})]})]}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {children:[(0,require$react_SLASH_jsx_runtime.jsx)("h3", {className:"text-xs font-semibold text-slate-400 uppercase tracking-wider mb-2", 
  children:"PostgreSQL"}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"mb-3 flex gap-2", children:[(0,require$react_SLASH_jsx_runtime.jsx)("textarea", {value:V, onChange:ue => ne(ue.target.value), onKeyDown:ue => {
    ue.key === "Enter" && (ue.metaKey || ue.ctrlKey) && me();
  }, placeholder:"SELECT * FROM ingestion_sources WHERE enabled \x3d true...", className:"flex-1 bg-slate-900/50 border border-slate-700/50 rounded px-3 py-1.5 text-xs text-slate-200 placeholder-slate-600 focus:outline-none focus:border-slate-600 font-mono resize-none h-16"}), (0,require$react_SLASH_jsx_runtime.jsx)("button", {onClick:me, disabled:o || !V.trim(), className:"shrink-0 rounded-md border border-blue-500/30 bg-blue-500/10 px-3 py-1.5 text-xs text-blue-300 hover:bg-blue-500/20 disabled:opacity-50 self-end", 
  children:"Run SQL"})]}), D && (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"mb-3 rounded bg-rose-500/10 border border-rose-500/20 px-3 py-2 text-xs text-rose-300", children:D}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"flex gap-4", children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"w-48 shrink-0", children:(0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"rounded-lg border border-slate-700/50 bg-slate-800/30 overflow-hidden", children:t.map(ue => 
  (0,require$react_SLASH_jsx_runtime.jsx)("button", {onClick:() => ge(ue), className:`w-full px-3 py-1.5 text-xs text-left hover:bg-slate-700/20 ${n === ue ? "bg-slate-700/30 text-blue-300" : "text-slate-400"}`, children:ue}, ue))})}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"flex-1 rounded-lg border border-slate-700/50 bg-slate-800/30 overflow-hidden", children:o ? (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"p-4 text-xs text-slate-500", children:"Loading..."}) : 
  i.length > 0 ? (0,require$react_SLASH_jsx_runtime.jsxs)("div", {children:[ee && (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"px-3 py-1.5 text-xs text-slate-500 border-b border-slate-700/30", children:ee}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"overflow-auto max-h-[500px]", children:(0,require$react_SLASH_jsx_runtime.jsxs)("table", {className:"w-full text-xs", children:[(0,require$react_SLASH_jsx_runtime.jsx)("thead", {children:(0,require$react_SLASH_jsx_runtime.jsx)("tr", 
  {className:"border-b border-slate-700/30", children:Object.keys(i[0]).slice(0, 8).map(ue => (0,require$react_SLASH_jsx_runtime.jsx)("th", {className:"text-left px-3 py-2 text-slate-500 whitespace-nowrap", children:ue}, ue))})}), (0,require$react_SLASH_jsx_runtime.jsx)("tbody", {children:i.map((ue, Le) => (0,require$react_SLASH_jsx_runtime.jsx)("tr", {className:"border-b border-slate-700/20 hover:bg-slate-700/10", children:Object.values(ue).slice(0, 8).map(($e, Ye) => (0,require$react_SLASH_jsx_runtime.jsx)("td", 
  {className:"px-3 py-1.5 text-slate-300 truncate max-w-[150px]", children:$e === null ? (0,require$react_SLASH_jsx_runtime.jsx)("span", {className:"text-slate-600", children:"null"}) : typeof $e == "object" ? JSON.stringify($e).slice(0, 50) : String($e)}, Ye))}, Le))})]})})]}) : (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"p-4 text-xs text-slate-500", children:"Select a table or run a query"})})]})]})]});
}
function Pne() {
  const [t, e] = (0,require$react.useState)([]), [n, r] = (0,require$react.useState)(""), [i, s] = (0,require$react.useState)(!1), [o, a] = (0,require$react.useState)(null), [l, c] = (0,require$react.useState)([]), [u, h] = (0,require$react.useState)(!1), [f, p] = (0,require$react.useState)({label:"", slug:"", description:"", emoji:"", color:"#3b82f6"}), [g, m] = (0,require$react.useState)(""), b = (0,require$react.useCallback)(async() => {
    s(!0);
    try {
      const _ = await td(`graph/labels?search=${encodeURIComponent(n)}&limit=200`);
      e(_.labels ?? []);
    } catch (_) {
      console.error("Failed to load labels", _);
    } finally {
      s(!1);
    }
  }, [n]), x = (0,require$react.useCallback)(async _ => {
    try {
      const [N, E] = await Promise.all([td(`graph/labels/${encodeURIComponent(_)}`), td(`graph/labels/${encodeURIComponent(_)}/nodes?limit=100`)]);
      a(N.label), c(E.nodes ?? []);
    } catch (N) {
      console.error("Failed to load label detail", N);
    }
  }, []);
  (0,require$react.useEffect)(() => {
    b();
  }, [b]);
  const w = async() => {
    try {
      await nd("graph/labels", {label:f.label, slug:f.slug || f.label, description:f.description, emoji:f.emoji || void 0, color:f.color || void 0}), h(!1), p({label:"", slug:"", description:"", emoji:"", color:"#3b82f6"}), await b();
    } catch (_) {
      alert("Failed to create label: " + _.message);
    }
  }, v = async() => {
    if (!(!o || !g.trim())) {
      try {
        await nd(`graph/labels/${encodeURIComponent(o.label_id)}/apply`, {node_id:g.trim()}), m(""), await x(o.label_id);
      } catch (_) {
        alert("Failed to apply label: " + _.message);
      }
    }
  }, T = async _ => {
    if (o) {
      try {
        await nd(`graph/labels/${encodeURIComponent(o.label_id)}/remove`, {node_id:_}), await x(o.label_id);
      } catch (N) {
        alert("Failed to remove label: " + N.message);
      }
    }
  }, I = async() => {
    if (o && confirm(`Delete label "${o.label}"?`)) {
      try {
        const _ = await fetch(`/api/data/op/graph/labels/${encodeURIComponent(o.label_id)}`, {method:"DELETE", headers:{...Xn()}});
        if (!_.ok) {
          throw new Error(await _.text());
        }
        a(null), await b();
      } catch (_) {
        alert("Failed to delete label: " + _.message);
      }
    }
  };
  return (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"flex gap-4 h-[600px]", children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"w-80 flex flex-col rounded-lg border border-slate-700/50 bg-slate-800/30 overflow-hidden", children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"shrink-0 p-3 border-b border-slate-700/30 flex items-center justify-between", children:[(0,require$react_SLASH_jsx_runtime.jsx)("input", {type:"text", placeholder:"Search labels...", 
  value:n, onChange:_ => r(_.target.value), className:"flex-1 bg-slate-900/50 border border-slate-700/50 rounded px-3 py-1.5 text-xs text-slate-200 placeholder-slate-600 focus:outline-none"}), (0,require$react_SLASH_jsx_runtime.jsx)("button", {onClick:() => h(!u), className:"ml-2 text-xs text-blue-400 hover:text-blue-300", children:u ? "Cancel" : "+ New"})]}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"flex-1 overflow-y-auto", children:i ? (0,require$react_SLASH_jsx_runtime.jsx)("div", 
  {className:"p-4 text-xs text-slate-500", children:"Loading..."}) : t.length === 0 ? (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"p-4 text-xs text-slate-500", children:"No labels found"}) : (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"divide-y divide-slate-700/20", children:t.map(_ => (0,require$react_SLASH_jsx_runtime.jsxs)("button", {onClick:() => {
    h(!1), x(_.label_id);
  }, className:`w-full flex items-start gap-3 px-3 py-2.5 hover:bg-slate-700/20 text-left ${(o == null ? void 0 : o.label_id) === _.label_id ? "bg-blue-500/10" : ""}`, children:[(0,require$react_SLASH_jsx_runtime.jsx)("span", {className:"text-lg shrink-0 mt-0.5", children:_.emoji || "\ud83c\udff7\ufe0f"}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"flex-1 min-w-0", children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"text-xs font-medium text-slate-200", children:_.label}), 
  (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"text-[10px] text-slate-500 leading-relaxed mt-0.5 break-words", children:_.description || "No description"})]})]}, _.label_id))})})]}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"flex-1 rounded-lg border border-slate-700/50 bg-slate-800/30 overflow-hidden overflow-y-auto p-4", children:u ? (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"space-y-3", children:[(0,require$react_SLASH_jsx_runtime.jsx)("h3", {className:"text-sm font-semibold text-slate-200", 
  children:"Create New Label"}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"grid grid-cols-2 gap-3", children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {children:[(0,require$react_SLASH_jsx_runtime.jsx)("label", {className:"block text-xs text-slate-500 mb-1", children:"Label Name"}), (0,require$react_SLASH_jsx_runtime.jsx)("input", {value:f.label, onChange:_ => p({...f, label:_.target.value}), className:"w-full bg-slate-900/50 border border-slate-700/50 rounded px-3 py-1.5 text-xs text-slate-200"})]}), 
  (0,require$react_SLASH_jsx_runtime.jsxs)("div", {children:[(0,require$react_SLASH_jsx_runtime.jsx)("label", {className:"block text-xs text-slate-500 mb-1", children:"Slug (optional)"}), (0,require$react_SLASH_jsx_runtime.jsx)("input", {value:f.slug, onChange:_ => p({...f, slug:_.target.value}), className:"w-full bg-slate-900/50 border border-slate-700/50 rounded px-3 py-1.5 text-xs text-slate-200"})]})]}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {children:[(0,require$react_SLASH_jsx_runtime.jsx)("label", 
  {className:"block text-xs text-slate-500 mb-1", children:"Description"}), (0,require$react_SLASH_jsx_runtime.jsx)("textarea", {value:f.description, onChange:_ => p({...f, description:_.target.value}), rows:3, className:"w-full bg-slate-900/50 border border-slate-700/50 rounded px-3 py-1.5 text-xs text-slate-200 resize-none"})]}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"grid grid-cols-2 gap-3", children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {children:[(0,require$react_SLASH_jsx_runtime.jsx)("label", 
  {className:"block text-xs text-slate-500 mb-1", children:"Emoji"}), (0,require$react_SLASH_jsx_runtime.jsx)("input", {value:f.emoji, onChange:_ => p({...f, emoji:_.target.value}), className:"w-full bg-slate-900/50 border border-slate-700/50 rounded px-3 py-1.5 text-xs text-slate-200", placeholder:"\u2705"})]}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {children:[(0,require$react_SLASH_jsx_runtime.jsx)("label", {className:"block text-xs text-slate-500 mb-1", children:"Color"}), (0,require$react_SLASH_jsx_runtime.jsx)("input", 
  {type:"color", value:f.color, onChange:_ => p({...f, color:_.target.value}), className:"w-full h-8 rounded border border-slate-700/50"})]})]}), (0,require$react_SLASH_jsx_runtime.jsx)("button", {onClick:w, disabled:!f.label.trim(), className:"px-4 py-2 bg-blue-600 hover:bg-blue-700 disabled:bg-slate-600 text-white rounded text-xs font-medium", children:"Create Label"})]}) : o ? (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"space-y-4", children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", 
  {className:"flex items-start justify-between", children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"flex items-center gap-3", children:[(0,require$react_SLASH_jsx_runtime.jsx)("span", {className:"text-3xl", children:o.emoji || "\ud83c\udff7\ufe0f"}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {children:[(0,require$react_SLASH_jsx_runtime.jsx)("h3", {className:"text-sm font-bold text-slate-200", children:o.label}), (0,require$react_SLASH_jsx_runtime.jsx)("code", {className:"text-[10px] text-slate-500", 
  children:o.label_id})]})]}), (0,require$react_SLASH_jsx_runtime.jsx)("button", {onClick:I, className:"text-xs text-rose-400 hover:text-rose-300", children:"Delete"})]}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"bg-slate-900/30 rounded border border-slate-700/30 p-3", children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"text-xs text-slate-500 mb-1", children:"Description"}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"text-xs text-slate-300 leading-relaxed whitespace-pre-wrap", 
  children:o.description || "No description"})]}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"bg-slate-900/30 rounded border border-slate-700/30 p-3", children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"text-xs text-slate-500 mb-2", children:"Apply to Node"}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"flex gap-2", children:[(0,require$react_SLASH_jsx_runtime.jsx)("input", {type:"text", value:g, onChange:_ => m(_.target.value), placeholder:"node_id or event_id", 
  className:"flex-1 bg-slate-900/50 border border-slate-700/50 rounded px-3 py-1.5 text-xs text-slate-200"}), (0,require$react_SLASH_jsx_runtime.jsx)("button", {onClick:v, disabled:!g.trim(), className:"px-3 py-1.5 bg-green-600 hover:bg-green-700 disabled:bg-slate-600 text-white rounded text-xs", children:"Apply"})]})]}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"text-xs text-slate-500 mb-2", children:["Labeled Nodes (", 
  l.length, ")"]}), l.length === 0 ? (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"text-xs text-slate-600", children:"No nodes have this label yet"}) : (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"space-y-2", children:l.map(_ => {
    var F, B, z, j, V, ne, D;
    const N = _.event, E = (N == null ? void 0 : N.source) === "discord" || ((F = N == null ? void 0 : N.kind) == null ? void 0 : F.startsWith("discord")), C = (N == null ? void 0 : N.title) || ((B = N == null ? void 0 : N.data) == null ? void 0 : B.title) || (E ? `#${((z = N == null ? void 0 : N.extra) == null ? void 0 : z.channel_id) || "?"}` : _.node_id), k = (N == null ? void 0 : N.kind) || (N == null ? void 0 : N.type) || (N == null ? void 0 : N.event_type) || "unknown", A = (N == null ? void 0 : 
    N.text) || (N == null ? void 0 : N.message) || ((j = N == null ? void 0 : N.data) == null ? void 0 : j.message) || ((V = N == null ? void 0 : N.data) == null ? void 0 : V.content) || ((ne = N == null ? void 0 : N.data) == null ? void 0 : ne.text) || "", P = E ? ((D = N == null ? void 0 : N.extra) == null ? void 0 : D.author_username) || (N == null ? void 0 : N.author) || "unknown" : (N == null ? void 0 : N.author) || (N == null ? void 0 : N.role) || "", W = N != null && N.ts ? (new Date(N.ts)).toLocaleDateString() : 
    N != null && N.created_at ? (new Date(N.created_at)).toLocaleDateString() : "";
    return (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"p-3 bg-slate-900/20 rounded border border-slate-700/20", children:(0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"flex items-start justify-between gap-2", children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"flex-1 min-w-0", children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"text-xs font-medium text-slate-200 truncate", children:C}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", 
    {className:"flex items-center gap-2 mt-0.5", children:[(0,require$react_SLASH_jsx_runtime.jsx)("span", {className:"text-[10px] px-1.5 py-0.5 rounded bg-slate-700/50 text-slate-400", children:k}), P && (0,require$react_SLASH_jsx_runtime.jsxs)("span", {className:"text-[10px] text-slate-500", children:["@", P]}), W && (0,require$react_SLASH_jsx_runtime.jsx)("span", {className:"text-[10px] text-slate-500", children:W})]}), A && (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"text-[11px] text-slate-300 mt-1.5 leading-relaxed whitespace-pre-wrap", 
    children:A})]}), (0,require$react_SLASH_jsx_runtime.jsx)("button", {onClick:() => T(_.node_id), className:"shrink-0 text-xs text-rose-400 hover:text-rose-300", children:"Remove"})]})}, _.node_id);
  })})]})]}) : (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"h-full flex items-center justify-center text-xs text-slate-500", children:"Select a label to view details"})})]});
}
const _2 = [{id:"overview", label:"Overview", icon:"\u25c8"}, {id:"sources", label:"Sources", icon:"\u25c9"}, {id:"files", label:"Files", icon:"\ud83d\udcc1"}, {id:"documents", label:"Documents", icon:"\ud83d\udcc4"}, {id:"graph", label:"Graph", icon:"\u25c7"}, {id:"labels", label:"Labels", icon:"\ud83c\udff7\ufe0f"}, {id:"database", label:"Database", icon:"\u25a3"}, {id:"services", label:"Services", icon:"\u26a1"}];
function Khe() {
  var k;
  const {tab:t} = (0,require$react_router_dom.useParams)(), e = (0,require$react_router_dom.useNavigate)(), n = ((k = _2.find(A => A.id === t)) == null ? void 0 : k.id) ?? "overview", [r, i] = (0,require$react.useState)([]), [s, o] = (0,require$react.useState)([]), [a, l] = (0,require$react.useState)(null), [c, u] = (0,require$react.useState)(null), [h, f] = (0,require$react.useState)(null), [p, g] = (0,require$react.useState)(null), [m, b] = (0,require$react.useState)({}), [x, w] = (0,require$react.useState)(!0), 
  [v, T] = (0,require$react.useState)(""), I = (0,require$react.useCallback)(async() => {
    var A, P;
    try {
      const [W, F, B, z, j] = await Promise.allSettled([L3(), M3(), F3(), F1(), U3()]);
      i(W.status === "fulfilled" ? W.value : []), o(F.status === "fulfilled" ? F.value : []), l(B.status === "fulfilled" ? B.value : null), z.status === "fulfilled" && z.value && u({total:((A = z.value.documents) == null ? void 0 : A.total) || 0, ...z.value.documents}), j.status === "fulfilled" && ((P = j.value) != null && P.ok) && g(j.value);
    } catch (W) {
      T(String(W));
    } finally {
      w(!1);
    }
  }, []), _ = (0,require$react.useCallback)(async() => {
    try {
      const A = await Yg({});
      if (A.ok) {
        const P = new Map();
        for (const B of A.nodes) {
          P.set(B.id, B);
        }
        const W = new Map(), F = new Map();
        for (const B of A.edges) {
          W.has(B.source) || W.set(B.source, []), W.get(B.source).push(B), F.has(B.target) || F.set(B.target, []), F.get(B.target).push(B);
        }
        f({nodes:A.nodes, edges:A.edges, nodeIndex:P, edgesBySource:W, edgesByTarget:F});
      }
    } catch {
    }
  }, []);
  (0,require$react.useEffect)(() => {
    I();
  }, []), (0,require$react.useEffect)(() => {
    const A = setInterval(I, 15e3);
    return () => clearInterval(A);
  }, [I]), (0,require$react.useEffect)(() => {
    n === "graph" && !h && _();
  }, [n, h, _]);
  const N = async A => {
    b(P => ({...P, [A]:!0}));
    try {
      await $3(A), await I();
    } catch (P) {
      T(String(P));
    } finally {
      b(P => ({...P, [A]:!1}));
    }
  }, E = () => {
    _(), I();
  }, C = A => e(`/data/${A}`);
  return x ? (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"p-6 text-sm text-slate-400", children:"Loading data..."}) : (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"flex flex-1 flex-col overflow-hidden", children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"shrink-0 border-b border-slate-700/50 bg-slate-900/80 px-6 py-3", children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"flex items-center justify-between", children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", 
  {children:[(0,require$react_SLASH_jsx_runtime.jsx)("h1", {className:"text-base font-bold text-slate-100", children:"Data"}), (0,require$react_SLASH_jsx_runtime.jsx)("p", {className:"text-xs text-slate-500 mt-0.5", children:"Sources \u2192 Ingestion \u2192 OpenPlanner \u00b7 Files \u00b7 Documents \u00b7 Graph \u00b7 Database"})]}), (0,require$react_SLASH_jsx_runtime.jsx)("button", {onClick:() => {
    I(), n === "graph" && _();
  }, className:"rounded-md border border-slate-700 bg-slate-800 px-3 py-1 text-xs text-slate-300 hover:bg-slate-700", children:"Refresh All"})]}), (0,require$react_SLASH_jsx_runtime.jsx)("nav", {className:"mt-2 flex gap-1 overflow-x-auto", children:_2.map(A => (0,require$react_SLASH_jsx_runtime.jsx)(kne, {active:n === A.id, onClick:() => C(A.id), icon:A.icon, label:A.label}, A.id))})]}), v && (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"shrink-0 px-6 py-2", children:(0,require$react_SLASH_jsx_runtime.jsx)("div", 
  {className:"rounded-lg bg-rose-500/10 px-3 py-2 text-xs text-rose-300 border border-rose-500/20", children:v})}), (0,require$react_SLASH_jsx_runtime.jsxs)("main", {className:n === "graph" ? "flex-1 overflow-hidden p-0" : "flex-1 overflow-y-auto p-6", children:[n === "overview" && (0,require$react_SLASH_jsx_runtime.jsx)(Ene, {sources:r, jobs:s, health:a, graphStats:c, embeddingCoverage:p, onBuildEdges:E}), n === "sources" && (0,require$react_SLASH_jsx_runtime.jsx)(Tne, {sources:r, jobs:s, onSync:N}), 
  n === "files" && (0,require$react_SLASH_jsx_runtime.jsx)(Cne, {}), n === "documents" && (0,require$react_SLASH_jsx_runtime.jsx)(Ane, {}), n === "graph" && (0,require$react_SLASH_jsx_runtime.jsx)(q3, {nodes:(h == null ? void 0 : h.nodes) || []}), n === "labels" && (0,require$react_SLASH_jsx_runtime.jsx)(Pne, {}), n === "database" && (0,require$react_SLASH_jsx_runtime.jsx)(One, {}), n === "services" && (0,require$react_SLASH_jsx_runtime.jsx)(Nne, {health:a, sources:r, syncing:m, onSync:N, onBuildEdges:E})]})]});
}
const Vs = "/ops", Rne = "/agents", Dne = "/events", Lne = Dne;
function S2(t) {
  return t.replace(/^\/+|\/+$/g, "");
}
function qs(t, e = "") {
  const n = S2(t), r = S2(e);
  return !n && !r ? "/" : n ? r ? `/${n}/${r}` : `/${n}` : `/${r}`;
}
const ro = {documents:qs(Vs, "documents"), docsView:qs(Vs, "docs/view"), agents:qs(Vs, "agents"), studio:qs(Vs, "studio"), vectors:qs(Vs, "vectors"), labels:qs(Vs, "labels"), graphExportDebug:qs(Vs, "graph-export-debug"), settings:qs(Vs, "settings"), admin:qs(Vs, "admin")};
function k2() {
  const t = window.knoxx;
  if (!t) {
    return null;
  }
  const e = t.frontend;
  if (!e) {
    return null;
  }
  const n = e.pages;
  if (!n) {
    return null;
  }
  const r = n.settings;
  if (!r) {
    return null;
  }
  const i = r.view;
  return i ? i.settings_page ?? null : null;
}
let Mne = class extends default$$require$react.default.Component {
  constructor() {
    super(...arguments);
    It(this, "state", {error:null});
  }
  static getDerivedStateFromError(n) {
    return {error:n};
  }
  componentDidCatch(n) {
    this.props.onError(n);
  }
  render() {
    return this.state.error ? null : this.props.children;
  }
};
function Bne() {
  const [t, e] = (0,require$react.useState)(null), [n, r] = (0,require$react.useState)(null);
  return (0,require$react.useEffect)(() => {
    const i = k2();
    if (i) {
      e(() => i);
      return;
    }
    const s = setTimeout(() => {
      const o = k2();
      if (o) {
        e(() => o);
        return;
      }
      r("shadow-cljs SettingsPage export not found on window.knoxx.frontend.pages.settings.view.settings_page. This is an integration/compile problem (not a reason to silently render legacy TS).");
    }, 1500);
    return () => clearTimeout(s);
  }, []), n ? (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"m-6 rounded-lg border border-rose-500/30 bg-rose-500/10 p-4 text-sm text-rose-100", children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"font-semibold", children:"Settings (shadow-cljs) failed to load"}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"mt-2 font-mono text-xs whitespace-pre-wrap break-words", children:n})]}) : t ? (0,require$react_SLASH_jsx_runtime.jsx)(Mne, {onError:i => r(String((i == 
  null ? void 0 : i.message) ?? i)), children:(0,require$react_SLASH_jsx_runtime.jsx)(t, {})}) : (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"flex h-full items-center justify-center p-6 text-sm text-slate-400", children:"Loading settings\u2026"});
}
function E2() {
  const t = window.knoxx;
  if (!t) {
    return null;
  }
  const e = t.frontend;
  if (!e) {
    return null;
  }
  const n = e.pages;
  if (!n) {
    return null;
  }
  const r = n.documents;
  if (!r) {
    return null;
  }
  const i = r.page;
  return i ? i.documents_page ?? null : null;
}
let $ne = class extends default$$require$react.default.Component {
  constructor() {
    super(...arguments);
    It(this, "state", {error:null});
  }
  static getDerivedStateFromError(n) {
    return {error:n};
  }
  componentDidCatch(n) {
    this.props.onError(n);
  }
  render() {
    return this.state.error ? null : this.props.children;
  }
};
function Fne() {
  const [t, e] = (0,require$react.useState)(null), [n, r] = (0,require$react.useState)(null);
  return (0,require$react.useEffect)(() => {
    const i = E2();
    if (i) {
      e(() => i);
      return;
    }
    const s = setTimeout(() => {
      const o = E2();
      if (o) {
        e(() => o);
        return;
      }
      r("shadow-cljs DocumentsPage export not found on window.knoxx.frontend.pages.documents.page.documents_page. This is an integration/compile problem (not a reason to silently render legacy TS).");
    }, 1500);
    return () => clearTimeout(s);
  }, []), n ? (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"m-6 rounded-lg border border-rose-500/30 bg-rose-500/10 p-4 text-sm text-rose-100", children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"font-semibold", children:"Data Lakes (shadow-cljs) failed to load"}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"mt-2 font-mono text-xs whitespace-pre-wrap break-words", children:n})]}) : t ? (0,require$react_SLASH_jsx_runtime.jsx)($ne, {onError:i => r(String((i == 
  null ? void 0 : i.message) ?? i)), children:(0,require$react_SLASH_jsx_runtime.jsx)(t, {})}) : (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"flex h-full items-center justify-center p-6 text-sm text-slate-400", children:"Loading data lakes\u2026"});
}
const K3 = (...t) => t.filter((e, n, r) => !!e && e.trim() !== "" && r.indexOf(e) === n).join(" ").trim();
const zne = t => t.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
const Hne = t => t.replace(/^([A-Z])|[\s-_]+(\w)/g, (e, n, r) => r ? r.toUpperCase() : n.toLowerCase());
const T2 = t => {
  const e = Hne(t);
  return e.charAt(0).toUpperCase() + e.slice(1);
};
var Une = {xmlns:"http://www.w3.org/2000/svg", width:24, height:24, viewBox:"0 0 24 24", fill:"none", stroke:"currentColor", strokeWidth:2, strokeLinecap:"round", strokeLinejoin:"round"};
const Wne = t => {
  for (const e in t) {
    if (e.startsWith("aria-") || e === "role" || e === "title") {
      return !0;
    }
  }
  return !1;
};
const jne = (0,require$react.forwardRef)(({color:t = "currentColor", size:e = 24, strokeWidth:n = 2, absoluteStrokeWidth:r, className:i = "", children:s, iconNode:o, ...a}, l) => (0,require$react.createElement)("svg", {ref:l, ...Une, width:e, height:e, stroke:t, strokeWidth:r ? Number(n) * 24 / Number(e) : n, className:K3("lucide", i), ...(!s && !Wne(a) && {"aria-hidden":"true"}), ...a}, [...o.map(([c, u]) => (0,require$react.createElement)(c, u)), ...(Array.isArray(s) ? s : [s])]));
const Oc = (t, e) => {
  const n = (0,require$react.forwardRef)(({className:r, ...i}, s) => (0,require$react.createElement)(jne, {ref:s, iconNode:e, className:K3(`lucide-${zne(T2(t))}`, `lucide-${t}`, r), ...i}));
  return n.displayName = T2(t), n;
};
const Vne = [["path", {d:"M15 3h6v6", key:"1q9fwt"}], ["path", {d:"M10 14 21 3", key:"gplh6r"}], ["path", {d:"M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6", key:"a6xqqp"}]], qne = Oc("external-link", Vne);
const Yne = [["path", {d:"M10 20a1 1 0 0 0 .553.895l2 1A1 1 0 0 0 14 21v-7a2 2 0 0 1 .517-1.341L21.74 4.67A1 1 0 0 0 21 3H3a1 1 0 0 0-.742 1.67l7.225 7.989A2 2 0 0 1 10 14z", key:"sc7q7i"}]], Gne = Oc("funnel", Yne);
const Qne = [["path", {d:"M12 2v20", key:"t6zp3m"}], ["path", {d:"m15 19-3 3-3-3", key:"11eu04"}], ["path", {d:"m19 9 3 3-3 3", key:"1mg7y2"}], ["path", {d:"M2 12h20", key:"9i4pu4"}], ["path", {d:"m5 9-3 3 3 3", key:"j64kie"}], ["path", {d:"m9 5 3-3 3 3", key:"l8vdw6"}]], Kne = Oc("move", Qne);
const Xne = [["rect", {x:"16", y:"16", width:"6", height:"6", rx:"1", key:"4q2zg0"}], ["rect", {x:"2", y:"16", width:"6", height:"6", rx:"1", key:"8cvhb9"}], ["rect", {x:"9", y:"2", width:"6", height:"6", rx:"1", key:"1egb70"}], ["path", {d:"M5 16v-3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3", key:"1jsf9p"}], ["path", {d:"M12 12V8", key:"2874zd"}]], Jne = Oc("network", Xne);
const Zne = [["path", {d:"M20.341 6.484A10 10 0 0 1 10.266 21.85", key:"1enhxb"}], ["path", {d:"M3.659 17.516A10 10 0 0 1 13.74 2.152", key:"1crzgf"}], ["circle", {cx:"12", cy:"12", r:"3", key:"1v7zrd"}], ["circle", {cx:"19", cy:"5", r:"2", key:"mhkx31"}], ["circle", {cx:"5", cy:"19", r:"2", key:"v8kfzx"}]], ere = Oc("orbit", Zne);
const tre = [["path", {d:"M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8", key:"v9h5vc"}], ["path", {d:"M21 3v5h-5", key:"1q7to0"}], ["path", {d:"M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16", key:"3uifl3"}], ["path", {d:"M8 16H3v5", key:"1cv678"}]], X3 = Oc("refresh-cw", tre);
function nre() {
  const [t, e] = (0,require$react.useState)(!0), [n, r] = (0,require$react.useState)(""), [i, s] = (0,require$react.useState)([]), o = async() => {
    e(!0), r("");
    try {
      const a = await Yg({});
      s(a.nodes || []);
    } catch (a) {
      r(a.message || String(a));
    } finally {
      e(!1);
    }
  };
  return (0,require$react.useEffect)(() => {
    o();
  }, []), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"mx-auto w-full max-w-7xl p-6 md:p-8 text-slate-100", children:[(0,require$react_SLASH_jsx_runtime.jsxs)("header", {className:"mb-6 flex flex-col gap-4 md:flex-row md:items-start md:justify-between", children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {children:[(0,require$react_SLASH_jsx_runtime.jsxs)("h1", {className:"flex items-center gap-3 text-3xl font-bold text-slate-100", children:[(0,require$react_SLASH_jsx_runtime.jsx)(ere, 
  {className:"h-8 w-8 text-cyan-300"}), "Graph Explorer"]}), (0,require$react_SLASH_jsx_runtime.jsx)("p", {className:"mt-2 max-w-3xl text-sm text-slate-400", children:"Unified graph explorer: sidebar node list + WebGL render + a debounced GraphQL editor. No iframes."})]}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"flex flex-wrap items-center gap-2", children:[(0,require$react_SLASH_jsx_runtime.jsxs)("button", {type:"button", onClick:() => void o(), className:"inline-flex items-center gap-2 rounded-lg border border-slate-700 bg-slate-900 px-3 py-2 text-sm text-slate-100 hover:bg-slate-800", 
  children:[(0,require$react_SLASH_jsx_runtime.jsx)(X3, {className:"h-4 w-4"}), "Reload"]}), (0,require$react_SLASH_jsx_runtime.jsx)(require$react_router_dom.Link, {to:ro.graphExportDebug, className:"rounded-lg border border-slate-700 bg-slate-900 px-3 py-2 text-sm text-slate-100 hover:bg-slate-800", children:"Raw export debug"})]})]}), (0,require$react_SLASH_jsx_runtime.jsxs)("section", {className:"rounded-2xl border border-slate-800 bg-slate-900/80 p-3 shadow-2xl", children:[n && (0,require$react_SLASH_jsx_runtime.jsx)("div", 
  {className:"mb-3 rounded bg-rose-500/10 border border-rose-500/20 px-3 py-2 text-xs text-rose-300", children:n}), t ? (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"p-4 text-xs text-slate-500", children:"Loading graph export\u2026"}) : (0,require$react_SLASH_jsx_runtime.jsx)(q3, {nodes:i})]})]});
}
const Iy = ["devel", "web", "bluesky", "knoxx-session"], Ci = {devel:[0.24, 0.72, 0.98, 0.96], web:[0.39, 0.92, 0.68, 0.96], bluesky:[0.31, 0.63, 0.98, 0.96], "knoxx-session":[0.98, 0.72, 0.34, 0.96], misc:[0.7, 0.74, 0.82, 0.94]}, C2 = {docs:{size:6.2, tint:0.18}, code:{size:5.4, tint:-0.02}, config:{size:5.2, tint:0.1}, data:{size:6, tint:0.24}, visited:{size:5.6, tint:0.08}, unvisited:{size:4.8, tint:0.34}, user:{size:6.4, tint:-0.08}, post:{size:5.1, tint:0.22}, node:{size:4.8, tint:0}}, A2 = 
{local_markdown_link:[0.97, 0.79, 0.38, 0.24], external_web_link:[0.97, 0.55, 0.34, 0.28], code_dependency:[0.66, 0.52, 0.98, 0.24], visited_to_visited:[0.29, 0.92, 0.63, 0.16], visited_to_unvisited:[0.35, 0.82, 0.57, 0.22], follows_user:[0.41, 0.67, 1, 0.2], authored_post:[0.73, 0.57, 0.98, 0.24], shared_post:[0.98, 0.67, 0.41, 0.24], liked_post:[0.98, 0.41, 0.66, 0.24], post_links_visited_web:[0.28, 0.86, 0.94, 0.24], post_links_unvisited_web:[0.2, 0.78, 0.92, 0.3], relation:[0.74, 0.78, 0.9, 0.14]};
function N2(t) {
  let e = 2166136261;
  for (let n = 0; n < t.length; n += 1) {
    e ^= t.charCodeAt(n), e = Math.imul(e, 16777619);
  }
  return e >>> 0;
}
function J3(t) {
  var n;
  const e = (n = t.data) == null ? void 0 : n.lake;
  return typeof e == "string" && e.trim() ? e.trim() : t.id.includes(":") && t.id.split(":", 1)[0] || "misc";
}
function Z3(t) {
  var n;
  const e = (n = t.data) == null ? void 0 : n.node_type;
  return typeof e == "string" && e.trim() ? e.trim() : t.kind ? t.kind : "node";
}
function rre(t) {
  return `${J3(t)}::${Z3(t)}`;
}
function ire(t, e, n) {
  const r = Iy.indexOf(t);
  if (r >= 0) {
    return {x:(r - 1.5) * 1100, y:r === 3 ? 780 : 0};
  }
  const i = 1300, s = Math.PI * 2 * e / Math.max(1, n);
  return {x:Math.cos(s) * i, y:Math.sin(s) * i * 0.75};
}
function sre(t) {
  var c;
  const e = new Map(), n = new Map();
  for (const u of t.nodes) {
    const h = rre(u), f = e.get(h) ?? [];
    f.push(u.id), e.set(h, f), n.set(h, {lake:J3(u), subtype:Z3(u)});
  }
  const r = [...e.keys()].sort((u, h) => u.localeCompare(h)), i = [...(new Set(r.map(u => {
    var h;
    return ((h = n.get(u)) == null ? void 0 : h.lake) || "misc";
  })))].sort((u, h) => u.localeCompare(h)), s = new Map(), o = new Map();
  for (const u of r) {
    const h = ((c = n.get(u)) == null ? void 0 : c.lake) || "misc", f = o.get(h) ?? [];
    f.push(u), o.set(h, f);
  }
  i.forEach((u, h) => {
    const f = ire(u, h, i.length), p = (o.get(u) ?? []).sort((m, b) => m.localeCompare(b)), g = Math.max(1, p.length);
    p.forEach((m, b) => {
      const x = b - (g - 1) / 2;
      s.set(m, {x:f.x, y:f.y + x * 300});
    });
  });
  const a = new Map(), l = Math.PI * (3 - Math.sqrt(5));
  for (const [u, h] of e) {
    h.sort((x, w) => x.localeCompare(w));
    const f = s.get(u) ?? {x:0, y:0}, p = N2(u) % 628 / 100 * 0.85, g = Math.max(1, h.length), b = (40 + Math.min(900, Math.sqrt(g) * 10)) / Math.sqrt(g + 1);
    for (let x = 0; x < h.length; x += 1) {
      const w = h[x], v = N2(w), T = p + x * l, I = b * Math.sqrt(x + 1), _ = (v % 2e3 / 2e3 - 0.5) * b * 0.6;
      a.set(w, {x:f.x + Math.cos(T) * (I + _), y:f.y + Math.sin(T) * (I + _) * 0.86});
    }
  }
  return a;
}
function eo(t) {
  var e;
  return t.lake || (typeof((e = t.data) == null ? void 0 : e.lake) == "string" ? String(t.data.lake) : "misc");
}
function pu(t) {
  var e;
  return t.nodeType || (typeof((e = t.data) == null ? void 0 : e.node_type) == "string" ? String(t.data.node_type) : "node");
}
function Hf(t) {
  var e;
  return t.edgeType || t.kind || (typeof((e = t.data) == null ? void 0 : e.edge_type) == "string" ? String(t.data.edge_type) : "relation");
}
function mc(t) {
  return t.sourceLake !== t.targetLake;
}
function ore(t, e) {
  const [n, r, i, s] = t, o = a => e >= 0 ? a + (1 - a) * e : a * (1 + e);
  return [o(n), o(r), o(i), s];
}
function are(t) {
  const e = t.data, n = e == null ? void 0 : e.exportNode, r = n ? eo(n) : "misc", i = n ? pu(n) : t.kind || "node", s = Ci[r] || Ci.misc, o = C2[i] || C2.node, a = e ? Math.min(4.5, Math.log2(e.degree + 1) * 0.95) : 0;
  return {sizePx:o.size + a, color:ore(s, o.tint || 0)};
}
function lre(t) {
  const e = t.data, n = e == null ? void 0 : e.exportEdge, r = n ? Hf(n) : t.kind || "relation", i = A2[r] || A2.relation, s = n && mc(n) ? Math.min(0.34, i[3] + 0.08) : i[3];
  return {color:Tr(i[0], i[1], i[2], s), phase:n && mc(n) ? 1.2 : 0};
}
function xs(t) {
  return t.toLocaleString();
}
function cre(t, e, n, r) {
  const i = (n.get(e.id) ?? 0) - (n.get(t.id) ?? 0);
  if (i !== 0) {
    return i;
  }
  const s = Number(r.has(e.id)) - Number(r.has(t.id));
  if (s !== 0) {
    return s;
  }
  const o = eo(t).localeCompare(eo(e));
  return o !== 0 ? o : t.label.localeCompare(e.label);
}
function ure(t, e, n) {
  const r = Number(mc(e)) - Number(mc(t));
  if (r !== 0) {
    return r;
  }
  const i = (n.get(t.source) ?? 0) + (n.get(t.target) ?? 0), s = (n.get(e.source) ?? 0) + (n.get(e.target) ?? 0);
  return s !== i ? s - i : t.id.localeCompare(e.id);
}
function dre(t, e) {
  return t.includes(e) ? t.filter(n => n !== e) : [...t, e];
}
function hre() {
  const t = (0,require$react.useRef)(null), e = (0,require$react.useRef)(null), [n, r] = (0,require$react.useState)([...Iy]), [i, s] = (0,require$react.useState)(1400), [o, a] = (0,require$react.useState)(5200), [l, c] = (0,require$react.useState)(!1), [u, h] = (0,require$react.useState)(!0), [f, p] = (0,require$react.useState)(""), [g, m] = (0,require$react.useState)(null), [b, x] = (0,require$react.useState)(null), w = async C => {
    if (C.length === 0) {
      m({ok:!0, projects:[], nodes:[], edges:[]}), h(!1);
      return;
    }
    h(!0);
    try {
      const k = await Yg({projects:C});
      m(k), p("");
    } catch (k) {
      p(k instanceof Error ? k.message : String(k));
    } finally {
      h(!1);
    }
  };
  (0,require$react.useEffect)(() => {
    w(n);
  }, [n.join(",")]), (0,require$react.useEffect)(() => {
    if (!t.current) {
      return;
    }
    const C = new R3(t.current, {background:Tr(0.03, 0.06, 0.11, 0.98), pulseAmplitude:0.42, pulseSpeed:1 / 420, denseNodeThreshold:4e3, denseEdgeThreshold:16e3, dprCap:{normal:2.5, dense:2}, frameIntervalMs:{normal:16, dense:24}, nodeStyle:are, edgeStyle:lre, onNodeClick:k => x(k.id)});
    return e.current = C, () => {
      C.destroy(), e.current = null;
    };
  }, []);
  const v = (0,require$react.useMemo)(() => {
    const C = (g == null ? void 0 : g.nodes) ?? [], k = (g == null ? void 0 : g.edges) ?? [], A = new Set(n), P = C.filter(J => A.has(eo(J))), W = new Set(P.map(J => J.id)), F = new Map(), B = new Map();
    for (const J of P) {
      const U = eo(J);
      F.set(U, (F.get(U) ?? 0) + 1);
    }
    const z = k.filter(J => {
      const U = A.has(J.sourceLake), le = A.has(J.targetLake);
      return !(!U || !le || !W.has(J.source) || !W.has(J.target) || l && !mc(J));
    }), j = new Map(), V = new Set();
    for (const J of z) {
      j.set(J.source, (j.get(J.source) ?? 0) + 1), j.set(J.target, (j.get(J.target) ?? 0) + 1), mc(J) && (V.add(J.source), V.add(J.target));
    }
    const ne = [...P].sort((J, U) => cre(J, U, j, V)), D = new Set(ne.slice(0, i).map(J => J.id)), ee = z.filter(J => D.has(J.source) && D.has(J.target)).sort((J, U) => ure(J, U, j)).slice(0, o), M = new Set();
    for (const J of ee) {
      M.add(J.source), M.add(J.target);
    }
    const X = [], ge = new Set();
    for (const J of ne) {
      M.has(J.id) && !ge.has(J.id) && (X.push(J), ge.add(J.id));
    }
    for (const J of ne) {
      if (!ge.has(J.id)) {
        if (X.length >= i) {
          break;
        }
        X.push(J), ge.add(J.id);
      }
    }
    for (const J of X) {
      const U = eo(J);
      B.set(U, (B.get(U) ?? 0) + 1);
    }
    const me = X.map(J => ({id:J.id, kind:J.kind, label:J.label, data:{...(J.data ?? {}), lake:eo(J), node_type:pu(J)}}));
    ee.map(J => ({id:J.id, source:J.source, target:J.target, kind:Hf(J), data:{...(J.data ?? {}), edge_type:Hf(J), source_lake:J.sourceLake, target_lake:J.targetLake}}));
    const te = sre({nodes:me}), q = X.map(J => {
      const U = te.get(J.id) ?? {x:0, y:0};
      return {id:J.id, x:U.x, y:U.y, kind:pu(J), label:J.label, data:{exportNode:J, degree:j.get(J.id) ?? 0}};
    }), R = ee.map(J => ({source:J.source, target:J.target, kind:Hf(J), data:{exportEdge:J}})), $ = new Map(X.map(J => [J.id, J])), G = new Map();
    for (const J of ee) {
      const U = G.get(J.source) ?? [];
      U.push(J), G.set(J.source, U);
      const le = G.get(J.target) ?? [];
      le.push(J), G.set(J.target, le);
    }
    return {graph:{nodes:q, edges:R}, nodeMap:$, edgesByNode:G, degree:j, lakeCounts:F, renderedLakeCounts:B, rawNodeCount:C.length, rawEdgeCount:k.length, filteredNodeCount:P.length, filteredEdgeCount:z.length};
  }, [g, n, l, i, o]);
  (0,require$react.useEffect)(() => {
    b && (v.nodeMap.has(b) || x(null));
  }, [v.nodeMap, b]), (0,require$react.useEffect)(() => {
    const C = e.current;
    C && (C.setGraph(v.graph), v.graph.nodes.length > 0 && C.fitToGraph(48));
  }, [v.graph]);
  const T = b ? v.nodeMap.get(b) ?? null : null, I = b ? v.edgesByNode.get(b) ?? [] : [], _ = (T == null ? void 0 : T.data) ?? {}, N = typeof _.url == "string" ? _.url : "", E = typeof _.path == "string" ? _.path : typeof _.source_path == "string" ? _.source_path : "";
  return (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"mx-auto w-full max-w-7xl p-6 md:p-8 text-slate-100", children:[(0,require$react_SLASH_jsx_runtime.jsxs)("header", {className:"mb-6 flex flex-col gap-4 md:flex-row md:items-start md:justify-between", children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {children:[(0,require$react_SLASH_jsx_runtime.jsxs)("h1", {className:"flex items-center gap-3 text-3xl font-bold text-slate-100", children:[(0,require$react_SLASH_jsx_runtime.jsx)(Jne, 
  {className:"h-8 w-8 text-cyan-300"}), "Canonical Lake Graph"]}), (0,require$react_SLASH_jsx_runtime.jsxs)("p", {className:"mt-2 max-w-3xl text-sm text-slate-400", children:["WebGL projection of the current OpenPlanner graph export, filtered through Knoxx. The canonical lake model is one lake per source: ", (0,require$react_SLASH_jsx_runtime.jsx)("code", {className:"rounded bg-slate-800 px-1.5 py-0.5", children:"devel"}), ", ", (0,require$react_SLASH_jsx_runtime.jsx)("code", {className:"rounded bg-slate-800 px-1.5 py-0.5", 
  children:"web"}), ", ", (0,require$react_SLASH_jsx_runtime.jsx)("code", {className:"rounded bg-slate-800 px-1.5 py-0.5", children:"bluesky"}), ", and ", (0,require$react_SLASH_jsx_runtime.jsx)("code", {className:"rounded bg-slate-800 px-1.5 py-0.5", children:"knoxx-session"}), "."]})]}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"flex flex-wrap items-center gap-2", children:[(0,require$react_SLASH_jsx_runtime.jsxs)("button", {type:"button", onClick:() => void w(n), className:"inline-flex items-center gap-2 rounded-lg border border-slate-700 bg-slate-900 px-3 py-2 text-sm text-slate-100 hover:bg-slate-800", 
  children:[(0,require$react_SLASH_jsx_runtime.jsx)(X3, {className:"h-4 w-4"}), "Reload export"]}), (0,require$react_SLASH_jsx_runtime.jsxs)("button", {type:"button", onClick:() => {
    var C;
    return (C = e.current) == null ? void 0 : C.fitToGraph(48);
  }, className:"inline-flex items-center gap-2 rounded-lg border border-slate-700 bg-slate-900 px-3 py-2 text-sm text-slate-100 hover:bg-slate-800", children:[(0,require$react_SLASH_jsx_runtime.jsx)(Kne, {className:"h-4 w-4"}), "Fit graph"]}), (0,require$react_SLASH_jsx_runtime.jsx)(require$react_router_dom.Link, {to:ro.documents, className:"rounded-lg border border-slate-700 bg-slate-900 px-3 py-2 text-sm text-slate-100 hover:bg-slate-800", children:"Open Lakes"})]})]}), (0,require$react_SLASH_jsx_runtime.jsxs)("section", 
  {className:"mb-6 rounded-2xl border border-slate-800 bg-slate-900/80 p-4 shadow-xl", children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"flex flex-col gap-4 xl:flex-row xl:items-end xl:justify-between", children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"space-y-3", children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"mb-2 flex items-center gap-2 text-sm font-semibold text-slate-200", 
  children:[(0,require$react_SLASH_jsx_runtime.jsx)(Gne, {className:"h-4 w-4 text-cyan-300"}), "Lake filters"]}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"flex flex-wrap gap-2", children:Iy.map(C => {
    const k = n.includes(C), A = v.lakeCounts.get(C) ?? 0, P = Ci[C] || Ci.misc;
    return (0,require$react_SLASH_jsx_runtime.jsxs)("label", {className:`inline-flex items-center gap-2 rounded-full border px-3 py-1 text-xs ${k ? "border-cyan-400/40 bg-cyan-500/10 text-cyan-100" : "border-slate-700 bg-slate-950 text-slate-300"}`, children:[(0,require$react_SLASH_jsx_runtime.jsx)("input", {type:"checkbox", checked:k, onChange:() => r(W => dre(W, C)), className:"h-3.5 w-3.5 rounded border-slate-600 bg-slate-900 text-cyan-400"}), (0,require$react_SLASH_jsx_runtime.jsx)("span", {className:"inline-block h-2.5 w-2.5 rounded-full", 
    style:{backgroundColor:`rgba(${Math.round(P[0] * 255)}, ${Math.round(P[1] * 255)}, ${Math.round(P[2] * 255)}, ${P[3]})`}}), (0,require$react_SLASH_jsx_runtime.jsx)("span", {children:C}), (0,require$react_SLASH_jsx_runtime.jsx)("span", {className:"text-slate-400", children:xs(A)})]}, C);
  })})]}), (0,require$react_SLASH_jsx_runtime.jsxs)("label", {className:"inline-flex items-center gap-2 text-sm text-slate-300", children:[(0,require$react_SLASH_jsx_runtime.jsx)("input", {type:"checkbox", checked:l, onChange:C => c(C.target.checked), className:"h-4 w-4 rounded border-slate-600 bg-slate-900 text-cyan-400"}), "Show only cross-lake edges"]})]}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"grid gap-3 sm:grid-cols-2 xl:min-w-[320px]", children:[(0,require$react_SLASH_jsx_runtime.jsxs)("label", 
  {className:"block text-xs text-slate-400", children:["Render nodes ", (0,require$react_SLASH_jsx_runtime.jsx)("span", {className:"ml-1 text-slate-200", children:xs(i)}), (0,require$react_SLASH_jsx_runtime.jsx)("input", {type:"range", min:200, max:6e3, step:100, value:i, onChange:C => s(Number(C.target.value)), className:"mt-2 w-full"})]}), (0,require$react_SLASH_jsx_runtime.jsxs)("label", {className:"block text-xs text-slate-400", children:["Render edges ", (0,require$react_SLASH_jsx_runtime.jsx)("span", 
  {className:"ml-1 text-slate-200", children:xs(o)}), (0,require$react_SLASH_jsx_runtime.jsx)("input", {type:"range", min:200, max:24e3, step:200, value:o, onChange:C => a(Number(C.target.value)), className:"mt-2 w-full"})]})]})]}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"mt-4 grid gap-3 md:grid-cols-4", children:[(0,require$react_SLASH_jsx_runtime.jsx)(af, {label:"Raw export", value:`${xs(v.rawNodeCount)} nodes`, subvalue:`${xs(v.rawEdgeCount)} edges`}), (0,require$react_SLASH_jsx_runtime.jsx)(af, 
  {label:"Filtered lakes", value:`${xs(v.filteredNodeCount)} nodes`, subvalue:`${xs(v.filteredEdgeCount)} edges`}), (0,require$react_SLASH_jsx_runtime.jsx)(af, {label:"Rendered", value:`${xs(v.graph.nodes.length)} nodes`, subvalue:`${xs(v.graph.edges.length)} edges`}), (0,require$react_SLASH_jsx_runtime.jsx)(af, {label:"Selection", value:T ? T.label : "No node selected", subvalue:T ? `${eo(T)} / ${pu(T)}` : "Click a node"})]})]}), f ? (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"mb-6 rounded-xl border border-rose-500/30 bg-rose-500/10 p-4 text-rose-200", 
  children:f}) : null, (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"grid gap-6 xl:grid-cols-[minmax(0,1.6fr)_360px]", children:[(0,require$react_SLASH_jsx_runtime.jsx)("section", {className:"rounded-2xl border border-slate-800 bg-slate-900/80 p-3 shadow-2xl", children:(0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"relative h-[44rem] overflow-hidden rounded-xl border border-slate-800 bg-slate-950", children:[(0,require$react_SLASH_jsx_runtime.jsx)("canvas", {ref:t, className:"h-full w-full"}), 
  u ? (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"absolute inset-0 flex items-center justify-center bg-slate-950/80 text-sm text-slate-300", children:"Loading canonical graph export\u2026"}) : null, !u && v.graph.nodes.length === 0 ? (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"absolute inset-0 flex items-center justify-center bg-slate-950/70 px-6 text-center text-sm text-slate-400", children:"No nodes matched the current lake and edge filters."}) : null]})}), (0,require$react_SLASH_jsx_runtime.jsxs)("aside", 
  {className:"space-y-6", children:[(0,require$react_SLASH_jsx_runtime.jsxs)("section", {className:"rounded-2xl border border-slate-800 bg-slate-900/80 p-5 shadow-xl", children:[(0,require$react_SLASH_jsx_runtime.jsx)("h2", {className:"mb-3 text-lg font-semibold text-slate-100", children:"Selected node"}), T ? (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"space-y-3 text-sm", children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", 
  {className:"text-xs uppercase tracking-wide text-slate-500", children:"Label"}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"mt-1 font-medium text-slate-100", children:T.label})]}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"grid grid-cols-2 gap-3 text-xs", children:[(0,require$react_SLASH_jsx_runtime.jsx)(lf, {label:"Lake", value:eo(T)}), (0,require$react_SLASH_jsx_runtime.jsx)(lf, {label:"Node type", value:pu(T)}), (0,require$react_SLASH_jsx_runtime.jsx)(lf, {label:"Degree", 
  value:String(v.degree.get(T.id) ?? 0)}), (0,require$react_SLASH_jsx_runtime.jsx)(lf, {label:"Edges shown", value:String(I.length)})]}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"text-xs uppercase tracking-wide text-slate-500", children:"Node id"}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"mt-1 break-all rounded-lg border border-slate-800 bg-slate-950/70 px-3 py-2 font-mono text-xs text-slate-300", children:T.id})]}), 
  E ? (0,require$react_SLASH_jsx_runtime.jsxs)("div", {children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"text-xs uppercase tracking-wide text-slate-500", children:"Path"}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"mt-1 break-all rounded-lg border border-slate-800 bg-slate-950/70 px-3 py-2 font-mono text-xs text-slate-300", children:E})]}) : null, N ? (0,require$react_SLASH_jsx_runtime.jsxs)("div", {children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"text-xs uppercase tracking-wide text-slate-500", 
  children:"URL"}), (0,require$react_SLASH_jsx_runtime.jsxs)("a", {href:N, target:"_blank", rel:"noreferrer", className:"mt-1 inline-flex break-all text-cyan-300 hover:text-cyan-200", children:[(0,require$react_SLASH_jsx_runtime.jsx)("span", {children:N}), (0,require$react_SLASH_jsx_runtime.jsx)(qne, {className:"ml-1 mt-0.5 h-3.5 w-3.5 shrink-0"})]})]}) : null, (0,require$react_SLASH_jsx_runtime.jsxs)("div", {children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"text-xs uppercase tracking-wide text-slate-500", 
  children:"Node data"}), (0,require$react_SLASH_jsx_runtime.jsx)("pre", {className:"mt-1 max-h-80 overflow-auto rounded-lg border border-slate-800 bg-slate-950/70 p-3 text-[11px] text-slate-300", children:JSON.stringify(T.data ?? {}, null, 2)})]})]}) : (0,require$react_SLASH_jsx_runtime.jsx)("p", {className:"text-sm text-slate-400", children:"Click a node in the canvas to inspect its lake, type, and raw export payload."})]}), (0,require$react_SLASH_jsx_runtime.jsxs)("section", {className:"rounded-2xl border border-slate-800 bg-slate-900/80 p-5 shadow-xl", 
  children:[(0,require$react_SLASH_jsx_runtime.jsx)("h2", {className:"mb-3 text-lg font-semibold text-slate-100", children:"Rendered lake counts"}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"space-y-2 text-sm", children:n.map(C => (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"flex items-center justify-between rounded-lg border border-slate-800 bg-slate-950/60 px-3 py-2", children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"flex items-center gap-2", 
  children:[(0,require$react_SLASH_jsx_runtime.jsx)("span", {className:"inline-block h-2.5 w-2.5 rounded-full", style:{backgroundColor:`rgba(${Math.round((Ci[C] || Ci.misc)[0] * 255)}, ${Math.round((Ci[C] || Ci.misc)[1] * 255)}, ${Math.round((Ci[C] || Ci.misc)[2] * 255)}, ${(Ci[C] || Ci.misc)[3]})`}}), (0,require$react_SLASH_jsx_runtime.jsx)("span", {children:C})]}), (0,require$react_SLASH_jsx_runtime.jsx)("span", {className:"text-slate-300", children:xs(v.renderedLakeCounts.get(C) ?? 0)})]}, `rendered-${C}`))})]})]})]})]});
}
function af({label:t, value:e, subvalue:n}) {
  return (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"rounded-xl border border-slate-800 bg-slate-950/60 px-4 py-3", children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"text-xs uppercase tracking-wide text-slate-500", children:t}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"mt-1 text-sm font-semibold text-slate-100", children:e}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"mt-1 text-xs text-slate-400", children:n})]});
}
function lf({label:t, value:e}) {
  return (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"rounded-lg border border-slate-800 bg-slate-950/60 px-3 py-2", children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"text-[11px] uppercase tracking-wide text-slate-500", children:t}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"mt-1 text-sm text-slate-200", children:e})]});
}
function I2() {
  const t = window.knoxx;
  if (!t) {
    return null;
  }
  const e = t.frontend;
  if (!e) {
    return null;
  }
  const n = e.pages;
  if (!n) {
    return null;
  }
  const r = n.source_doc;
  if (!r) {
    return null;
  }
  const i = r.view;
  return i ? i.source_doc_page ?? null : null;
}
class fre extends default$$require$react.default.Component {
  constructor() {
    super(...arguments);
    It(this, "state", {error:null});
  }
  static getDerivedStateFromError(n) {
    return {error:n};
  }
  componentDidCatch(n) {
    this.props.onError(n);
  }
  render() {
    return this.state.error ? null : this.props.children;
  }
}
function pre() {
  const [t, e] = (0,require$react.useState)(null), [n, r] = (0,require$react.useState)(null);
  return (0,require$react.useEffect)(() => {
    const i = I2();
    if (i) {
      e(() => i);
      return;
    }
    const s = setTimeout(() => {
      const o = I2();
      if (o) {
        e(() => o);
        return;
      }
      r("shadow-cljs SourceDocPage export not found on window.knoxx.frontend.pages.source_doc.view.source_doc_page. This is an integration/compile problem (not a reason to silently render legacy TS).");
    }, 1500);
    return () => clearTimeout(s);
  }, []), n ? (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"m-6 rounded-lg border border-rose-500/30 bg-rose-500/10 p-4 text-sm text-rose-100", children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"font-semibold", children:"Document Viewer (shadow-cljs) failed to load"}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"mt-2 font-mono text-xs whitespace-pre-wrap break-words", children:n})]}) : t ? (0,require$react_SLASH_jsx_runtime.jsx)(fre, {onError:i => r(String((i == 
  null ? void 0 : i.message) ?? i)), children:(0,require$react_SLASH_jsx_runtime.jsx)(t, {})}) : (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"flex h-full items-center justify-center p-6 text-sm text-slate-400", children:"Loading document viewer\u2026"});
}
function Ki(t) {
  return t instanceof Error ? t.message : String(t);
}
function eP(t) {
  const e = t.reduce((n, r) => {
    const i = r.resourceKind || "misc";
    return n[i] || (n[i] = []), n[i].push(r), n;
  }, {});
  return Object.entries(e).map(([n, r]) => [n, [...r].sort((i, s) => i.code.localeCompare(s.code))]).sort(([n], [r]) => n.localeCompare(r));
}
function Ya(t, e) {
  return t.memberships.find(n => n.orgId === e) ?? null;
}
function ah(t) {
  return t.reduce((e, n) => (e[n.toolId] = n.effect, e), {});
}
function gre(t) {
  return Object.entries(t).flatMap(([e, n]) => n !== "allow" && n !== "deny" ? [] : [{toolId:e, effect:n}]);
}
function Ad(t, e) {
  return t.includes(e) ? t.filter(n => n !== e) : [...t, e];
}
function tP(t) {
  const e = {};
  for (const n of t) {
    e[n.id] = ah(n.toolPolicies);
  }
  return e;
}
function nP(t, e) {
  const n = {}, r = {};
  for (const i of t) {
    const s = Ya(i, e);
    s && (n[s.id] = s.roles.map(o => o.slug), r[s.id] = ah(s.toolPolicies));
  }
  return {roleDrafts:n, toolDrafts:r};
}
const rP = Object.freeze(Object.defineProperty({__proto__:null, errorMessage:Ki, groupPermissions:eP, hydrateMembershipDrafts:nP, hydrateRoleDrafts:tP, membershipForOrg:Ya, toggleListValue:Ad, toolDraftMap:ah, toolPoliciesFromDraft:gre}, Symbol.toStringTag, {value:"Module"}));
function Gg(...t) {
  return t.filter(Boolean).join(" ");
}
function bo({title:t, description:e, actions:n, className:r, children:i}) {
  const s = !!(t || e || n);
  return (0,require$react_SLASH_jsx_runtime.jsxs)("section", {className:Gg("rounded-2xl border border-slate-800 bg-slate-950/70 p-5 shadow-xl", r), children:[s ? (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"mb-4 flex flex-col gap-3 border-b border-slate-800 pb-4 md:flex-row md:items-start md:justify-between", children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {children:[t ? (0,require$react_SLASH_jsx_runtime.jsx)("h2", {className:"text-lg font-semibold text-slate-100", children:t}) : 
  null, e ? (0,require$react_SLASH_jsx_runtime.jsx)("p", {className:"mt-1 text-sm text-slate-400", children:e}) : null]}), n ? (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"shrink-0", children:n}) : null]}) : null, i]});
}
function In({children:t, tone:e = "default"}) {
  const n = {default:"border-slate-700 bg-slate-800 text-slate-200", success:"border-emerald-500/30 bg-emerald-500/10 text-emerald-200", warn:"border-amber-500/30 bg-amber-500/10 text-amber-200", danger:"border-rose-500/30 bg-rose-500/10 text-rose-200", info:"border-cyan-500/30 bg-cyan-500/10 text-cyan-200"}[e];
  return (0,require$react_SLASH_jsx_runtime.jsx)("span", {className:Gg("inline-flex items-center rounded-full border px-2 py-0.5 text-xs font-medium", n), children:t});
}
function mre({identityForm:t, setIdentityForm:e, context:n, onApplyIdentity:r}) {
  return (0,require$react_SLASH_jsx_runtime.jsxs)(bo, {title:"Current actor", description:"Header-based request identity for the live admin surface.", children:[(0,require$react_SLASH_jsx_runtime.jsxs)("form", {className:"grid gap-4 md:grid-cols-[1fr_1fr_auto]", onSubmit:r, children:[(0,require$react_SLASH_jsx_runtime.jsxs)("label", {className:"flex flex-col gap-2 text-sm text-slate-300", children:["User email", (0,require$react_SLASH_jsx_runtime.jsx)("input", {className:"rounded-lg border border-slate-700 bg-slate-900 px-3 py-2 text-slate-100", 
  value:t.userEmail, onChange:i => e(s => ({...s, userEmail:i.target.value})), placeholder:"system-admin@open-hax.local"})]}), (0,require$react_SLASH_jsx_runtime.jsxs)("label", {className:"flex flex-col gap-2 text-sm text-slate-300", children:["Org slug", (0,require$react_SLASH_jsx_runtime.jsx)("input", {className:"rounded-lg border border-slate-700 bg-slate-900 px-3 py-2 text-slate-100", value:t.orgSlug, onChange:i => e(s => ({...s, orgSlug:i.target.value})), placeholder:"open-hax"})]}), (0,require$react_SLASH_jsx_runtime.jsx)("div", 
  {className:"flex items-end", children:(0,require$react_SLASH_jsx_runtime.jsx)("button", {type:"submit", className:"w-full rounded-lg border border-cyan-500/30 bg-cyan-500/10 px-4 py-2 text-sm font-medium text-cyan-200 hover:bg-cyan-500/20", children:"Apply actor"})})]}), n ? (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"mt-5 grid gap-4 md:grid-cols-2 xl:grid-cols-4", children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"rounded-xl border border-slate-800 bg-slate-900/80 p-4", 
  children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"text-xs uppercase tracking-wide text-slate-500", children:"Resolved user"}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"mt-2 text-sm font-semibold text-slate-100", children:n.user.displayName}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"text-sm text-slate-400", children:n.user.email})]}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"rounded-xl border border-slate-800 bg-slate-900/80 p-4", 
  children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"text-xs uppercase tracking-wide text-slate-500", children:"Resolved org"}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"mt-2 text-sm font-semibold text-slate-100", children:n.org.name}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"text-sm text-slate-400", children:n.org.slug})]}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"rounded-xl border border-slate-800 bg-slate-900/80 p-4", children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", 
  {className:"text-xs uppercase tracking-wide text-slate-500", children:"Primary role"}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"mt-2 text-sm font-semibold text-slate-100", children:n.primaryRole}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"mt-2 flex flex-wrap gap-2", children:[n.isSystemAdmin ? (0,require$react_SLASH_jsx_runtime.jsx)(In, {tone:"warn", children:"system admin"}) : null, (0,require$react_SLASH_jsx_runtime.jsxs)(In, {tone:"info", children:[n.permissions.length, 
  " permissions"]})]})]}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"rounded-xl border border-slate-800 bg-slate-900/80 p-4", children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"text-xs uppercase tracking-wide text-slate-500", children:"Membership"}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"mt-2 text-sm font-semibold text-slate-100", children:n.membership.id}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"text-sm text-slate-400", 
  children:n.membership.status})]})]}) : null, n ? (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"mt-4 flex flex-wrap gap-2", children:n.roleSlugs.map(i => (0,require$react_SLASH_jsx_runtime.jsx)(In, {tone:i === "system_admin" ? "warn" : "default", children:i}, i))}) : null]});
}
function bre({orgs:t, toolsCount:e, permissionsCount:n, bootstrap:r}) {
  var i;
  return (0,require$react_SLASH_jsx_runtime.jsx)(bo, {title:"Control-plane summary", description:"What this actor can see right now.", children:(0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"grid gap-4 sm:grid-cols-2", children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"rounded-xl border border-slate-800 bg-slate-900/80 p-4", children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"text-xs uppercase tracking-wide text-slate-500", children:"Org scope"}), 
  (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"mt-2 text-2xl font-semibold text-slate-100", children:t.length}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"text-sm text-slate-400", children:"Visible org entries"})]}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"rounded-xl border border-slate-800 bg-slate-900/80 p-4", children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"text-xs uppercase tracking-wide text-slate-500", children:"Catalog"}), 
  (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"mt-2 text-2xl font-semibold text-slate-100", children:e}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"text-sm text-slate-400", children:"Tool definitions"})]}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"rounded-xl border border-slate-800 bg-slate-900/80 p-4", children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"text-xs uppercase tracking-wide text-slate-500", children:"Permission atoms"}), 
  (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"mt-2 text-2xl font-semibold text-slate-100", children:n}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"text-sm text-slate-400", children:"Available policy building blocks"})]}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"rounded-xl border border-slate-800 bg-slate-900/80 p-4", children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"text-xs uppercase tracking-wide text-slate-500", children:"Bootstrap"}), 
  r != null && r.primaryOrg ? (0,require$react_SLASH_jsx_runtime.jsxs)(require$react_SLASH_jsx_runtime.Fragment, {children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"mt-2 text-sm font-semibold text-slate-100", children:r.primaryOrg.name}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"text-sm text-slate-400", children:(i = r.bootstrapUser) == null ? void 0 : i.email})]}) : (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"mt-2 text-sm text-slate-400", children:"Platform bootstrap is only visible to platform-scoped admins."})]})]})});
}
function yre({context:t, orgs:e, selectedOrgId:n, setSelectedOrgId:r, canCreateOrgs:i, orgForm:s, setOrgForm:o, creatingOrg:a, onCreateOrg:l, orgKindOptions:c}) {
  return (0,require$react_SLASH_jsx_runtime.jsxs)(bo, {title:"Organizations", description:"Platform-wide org inventory for system admins, or the current scoped org for org admins.", actions:(0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"text-xs text-slate-500", children:t != null && t.isSystemAdmin ? "Platform scope" : "Org scope"}), children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"space-y-3", children:e.map(u => {
    const h = u.id === n;
    return (0,require$react_SLASH_jsx_runtime.jsxs)("button", {type:"button", onClick:() => r(u.id), className:Gg("w-full rounded-xl border p-4 text-left transition", h ? "border-cyan-500/40 bg-cyan-500/10" : "border-slate-800 bg-slate-900/70 hover:bg-slate-900"), children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"flex items-start justify-between gap-4", children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"text-sm font-semibold text-slate-100", 
    children:u.name}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"text-sm text-slate-400", children:u.slug})]}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"flex flex-wrap justify-end gap-2", children:[u.isPrimary ? (0,require$react_SLASH_jsx_runtime.jsx)(In, {tone:"warn", children:"primary"}) : null, (0,require$react_SLASH_jsx_runtime.jsx)(In, {children:u.kind})]})]}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"mt-3 flex flex-wrap gap-3 text-xs text-slate-400", 
    children:[typeof u.memberCount == "number" ? (0,require$react_SLASH_jsx_runtime.jsxs)("span", {children:[u.memberCount, " members"]}) : null, typeof u.roleCount == "number" ? (0,require$react_SLASH_jsx_runtime.jsxs)("span", {children:[u.roleCount, " roles"]}) : null, typeof u.dataLakeCount == "number" ? (0,require$react_SLASH_jsx_runtime.jsxs)("span", {children:[u.dataLakeCount, " lakes"]}) : null]})]}, u.id);
  })}), i ? (0,require$react_SLASH_jsx_runtime.jsxs)("form", {className:"mt-5 space-y-3 rounded-xl border border-slate-800 bg-slate-900/80 p-4", onSubmit:l, children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"text-sm font-semibold text-slate-100", children:"Create org"}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"grid gap-3 md:grid-cols-2", children:[(0,require$react_SLASH_jsx_runtime.jsx)("input", {className:"rounded-lg border border-slate-700 bg-slate-900 px-3 py-2 text-slate-100", 
  placeholder:"Org name", value:s.name, onChange:u => o(h => ({...h, name:u.target.value}))}), (0,require$react_SLASH_jsx_runtime.jsx)("input", {className:"rounded-lg border border-slate-700 bg-slate-900 px-3 py-2 text-slate-100", placeholder:"org-slug", value:s.slug, onChange:u => o(h => ({...h, slug:u.target.value}))})]}), (0,require$react_SLASH_jsx_runtime.jsx)("select", {className:"w-full rounded-lg border border-slate-700 bg-slate-900 px-3 py-2 text-slate-100", value:s.kind, onChange:u => o(h => 
  ({...h, kind:u.target.value})), children:c.map(u => (0,require$react_SLASH_jsx_runtime.jsx)("option", {value:u, children:u}, u))}), (0,require$react_SLASH_jsx_runtime.jsx)("button", {type:"submit", disabled:a || !s.name.trim(), className:"rounded-lg border border-emerald-500/30 bg-emerald-500/10 px-4 py-2 text-sm font-medium text-emerald-200 hover:bg-emerald-500/20 disabled:cursor-not-allowed disabled:opacity-50", children:a ? "Creating\u2026" : "Create org"})]}) : null]});
}
function xre({selectedOrg:t, context:e}) {
  return (0,require$react_SLASH_jsx_runtime.jsx)(bo, {title:t ? `Selected org: ${t.name}` : "Selected org", description:"Scoped management surface for memberships, roles, and data lakes.", children:t ? (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"grid gap-4 md:grid-cols-2 xl:grid-cols-4", children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"rounded-xl border border-slate-800 bg-slate-900/80 p-4", children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"text-xs uppercase tracking-wide text-slate-500", 
  children:"Slug"}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"mt-2 text-sm font-semibold text-slate-100", children:t.slug})]}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"rounded-xl border border-slate-800 bg-slate-900/80 p-4", children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"text-xs uppercase tracking-wide text-slate-500", children:"Kind"}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"mt-2 text-sm font-semibold text-slate-100", 
  children:t.kind})]}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"rounded-xl border border-slate-800 bg-slate-900/80 p-4", children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"text-xs uppercase tracking-wide text-slate-500", children:"Status"}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"mt-2 text-sm font-semibold text-slate-100", children:t.status})]}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"rounded-xl border border-slate-800 bg-slate-900/80 p-4", 
  children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"text-xs uppercase tracking-wide text-slate-500", children:"Current actor"}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"mt-2 text-sm font-semibold text-slate-100", children:(e == null ? void 0 : e.user.email) || "Unknown"})]})]}) : (0,require$react_SLASH_jsx_runtime.jsx)("p", {className:"text-sm text-slate-400", children:"No org is currently selected."})});
}
const O2 = [{provider:"bluesky", label:"Bluesky", kind:"app-password", accountPlaceholder:"handle.bsky.social", fields:[{key:"identifier", label:"Identifier / handle", placeholder:"handle.bsky.social"}, {key:"appPassword", label:"App password", secret:!0, placeholder:"xxxx-xxxx-xxxx-xxxx"}]}, {provider:"twitch", label:"Twitch", kind:"oauth-login", accountPlaceholder:"twitch username", fields:[{key:"username", label:"Username", placeholder:"channel_or_login"}, {key:"oauthToken", label:"OAuth token", 
secret:!0, placeholder:"oauth:\u2026 or raw token"}]}, {provider:"discord_bot", label:"Discord bot", kind:"bot-token", accountPlaceholder:"bot application/client id", fields:[{key:"botToken", label:"Bot token", secret:!0, placeholder:"Bot token"}, {key:"applicationId", label:"Application ID", placeholder:"Discord application id"}, {key:"publicKey", label:"Public key", placeholder:"Optional interactions public key"}]}, {provider:"discord_oauth", label:"Discord OAuth login", kind:"oauth-login", accountPlaceholder:"discord user id or username", 
fields:[{key:"clientId", label:"Client ID", placeholder:"OAuth client id"}, {key:"clientSecret", label:"Client secret", secret:!0, placeholder:"OAuth client secret"}, {key:"accessToken", label:"Access token", secret:!0, placeholder:"Optional current access token"}, {key:"refreshToken", label:"Refresh token", secret:!0, placeholder:"Optional refresh token"}]}];
function iP(t, e) {
  return (t == null ? void 0 : t.find(n => n.provider === e)) ?? null;
}
function C0(t, e) {
  return `${t}:${e}`;
}
function P2(t, e) {
  const n = Ya(t, e);
  return {actorId:(n == null ? void 0 : n.actorId) ?? "", displayName:t.displayName ?? "", email:t.email ?? "", status:t.status ?? "active"};
}
function R2(t, e) {
  const n = iP(t.credentials, e.provider);
  return {kind:(n == null ? void 0 : n.kind) || e.kind, accountIdentifier:(n == null ? void 0 : n.accountIdentifier) || "", secretJson:e.fields.reduce((r, i) => {
    var s;
    return r[i.key] = ((s = n == null ? void 0 : n.secretJson) == null ? void 0 : s[i.key]) || "", r;
  }, {})};
}
function vre(t, e) {
  return t != null && t.configuredFields.includes(e) ? "configured" : "not set";
}
function wre(t, e) {
  var r;
  const n = Ya(t, e);
  return [t.displayName, t.email, t.authProvider, t.externalSubject, t.status, n == null ? void 0 : n.actorId, n == null ? void 0 : n.status, ...((n == null ? void 0 : n.roles.map(i => `${i.slug} ${i.name}`)) ?? []), ...((n == null ? void 0 : n.toolPolicies.map(i => `${i.toolId} ${i.effect}`)) ?? []), ...(((r = t.credentials) == null ? void 0 : r.flatMap(i => [i.provider, i.label, i.kind, i.accountIdentifier, ...i.configuredFields])) ?? [])].filter(Boolean).join(" ").toLowerCase();
}
function _re({selectedOrgId:t, selectedOrgName:e, canCreateUsers:n, canUpdateMemberships:r, canUpdateUserPolicies:i, users:s, roles:o, tools:a, userForm:l, setUserForm:c, membershipRoleDrafts:u, setMembershipRoleDrafts:h, membershipToolDrafts:f, setMembershipToolDrafts:p, creatingUser:g, savingMembershipId:m, onCreateUser:b, onSaveActorProfile:x, onSaveActorCredential:w, onSaveMembershipRoles:v, onSaveMembershipPolicies:T}) {
  const [I, _] = (0,require$react.useState)({}), [N, E] = (0,require$react.useState)({}), [C, k] = (0,require$react.useState)(null), [A, P] = (0,require$react.useState)(null), [W, F] = (0,require$react.useState)(""), [B, z] = (0,require$react.useState)({});
  (0,require$react.useEffect)(() => {
    _(Object.fromEntries(s.map(M => [M.id, P2(M, t)]))), E(Object.fromEntries(s.flatMap(M => O2.map(X => [C0(M.id, X.provider), R2(M, X)]))));
  }, [t, s]);
  const j = (0,require$react.useMemo)(() => e || "selected org", [e]), V = (0,require$react.useMemo)(() => {
    const M = W.trim().toLowerCase();
    return s.filter(X => Ya(X, t) ? !M || wre(X, t).includes(M) : !1);
  }, [W, t, s]), ne = M => {
    z(X => ({...X, [M]:!X[M]}));
  }, D = M => {
    z(X => ({...X, ...Object.fromEntries(V.map(ge => [ge.id, M]))}));
  }, ie = async M => {
    const X = I[M];
    if (X) {
      k(M);
      try {
        await x(M, X);
      } finally {
        k(null);
      }
    }
  }, ee = async(M, X) => {
    const ge = C0(M, X), me = N[ge];
    if (me) {
      P(ge);
      try {
        await w(M, X, me);
      } finally {
        P(null);
      }
    }
  };
  return (0,require$react_SLASH_jsx_runtime.jsxs)(bo, {title:"Actors and credentials", description:"Create machine or human actors, bind actor IDs to memberships, and store per-actor Bluesky, Twitch, Discord bot, and Discord OAuth credentials. Secrets are write-only: saved fields are shown as configured, never echoed back.", children:[t && n ? (0,require$react_SLASH_jsx_runtime.jsxs)("form", {className:"mb-5 grid gap-3 rounded-xl border border-slate-800 bg-slate-900/80 p-4 md:grid-cols-4", onSubmit:b, 
  children:[(0,require$react_SLASH_jsx_runtime.jsx)("input", {className:"rounded-lg border border-slate-700 bg-slate-900 px-3 py-2 text-slate-100", placeholder:"actor id, e.g. discord_automation", value:l.actorId, onChange:M => c(X => ({...X, actorId:M.target.value}))}), (0,require$react_SLASH_jsx_runtime.jsx)("input", {className:"rounded-lg border border-slate-700 bg-slate-900 px-3 py-2 text-slate-100", placeholder:"email or leave blank for @actors.local", value:l.email, onChange:M => c(X => ({...X, 
  email:M.target.value}))}), (0,require$react_SLASH_jsx_runtime.jsx)("input", {className:"rounded-lg border border-slate-700 bg-slate-900 px-3 py-2 text-slate-100", placeholder:"Display name", value:l.displayName, onChange:M => c(X => ({...X, displayName:M.target.value}))}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"mb-2 text-xs uppercase tracking-wide text-slate-500", children:"Initial roles"}), (0,require$react_SLASH_jsx_runtime.jsx)("div", 
  {className:"flex flex-wrap gap-2", children:o.map(M => (0,require$react_SLASH_jsx_runtime.jsxs)("label", {className:"inline-flex items-center gap-2 rounded-full border border-slate-700 px-3 py-1 text-xs text-slate-200", children:[(0,require$react_SLASH_jsx_runtime.jsx)("input", {type:"checkbox", checked:l.roleSlugs.includes(M.slug), onChange:() => c(X => ({...X, roleSlugs:Ad(X.roleSlugs, M.slug)}))}), M.slug]}, M.id))})]}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"md:col-span-4 flex justify-end", 
  children:(0,require$react_SLASH_jsx_runtime.jsx)("button", {type:"submit", disabled:g || !l.email.trim() && !l.actorId.trim(), className:"rounded-lg border border-emerald-500/30 bg-emerald-500/10 px-4 py-2 text-sm font-medium text-emerald-200 hover:bg-emerald-500/20 disabled:cursor-not-allowed disabled:opacity-50", children:g ? "Creating\u2026" : `Create actor in ${j}`})})]}) : null, (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"mb-4 flex flex-col gap-3 rounded-xl border border-slate-800 bg-slate-950/70 p-4 lg:flex-row lg:items-center lg:justify-between", 
  children:[(0,require$react_SLASH_jsx_runtime.jsxs)("label", {className:"flex flex-1 flex-col gap-1 text-xs font-medium uppercase tracking-wide text-slate-500", children:["Search actors", (0,require$react_SLASH_jsx_runtime.jsx)("input", {className:"rounded-lg border border-slate-700 bg-slate-900 px-3 py-2 text-sm normal-case tracking-normal text-slate-100 placeholder:text-slate-600", placeholder:"Search actor id, email, display name, role, credential provider, tool\u2026", value:W, onChange:M => 
  F(M.target.value)})]}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"flex flex-wrap items-center gap-2 text-xs text-slate-400", children:[(0,require$react_SLASH_jsx_runtime.jsxs)("span", {children:[V.length, " of ", s.filter(M => Ya(M, t)).length, " actor(s)"]}), (0,require$react_SLASH_jsx_runtime.jsx)("button", {type:"button", onClick:() => D(!0), className:"rounded-lg border border-slate-700 px-3 py-1.5 text-slate-200 hover:bg-slate-800", children:"Expand filtered"}), (0,require$react_SLASH_jsx_runtime.jsx)("button", 
  {type:"button", onClick:() => D(!1), className:"rounded-lg border border-slate-700 px-3 py-1.5 text-slate-200 hover:bg-slate-800", children:"Collapse filtered"})]})]}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"space-y-4", children:s.length === 0 ? (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"rounded-xl border border-dashed border-slate-800 px-4 py-6 text-sm text-slate-400", children:"No actors are visible in this org."}) : V.length === 0 ? (0,require$react_SLASH_jsx_runtime.jsxs)("div", 
  {className:"rounded-xl border border-dashed border-slate-800 px-4 py-6 text-sm text-slate-400", children:["No actors match \u201c", W.trim(), "\u201d."]}) : V.map(M => {
    const X = Ya(M, t);
    if (!X) {
      return null;
    }
    const ge = u[X.id] || X.roles.map(R => R.slug), me = f[X.id] || ah(X.toolPolicies), te = I[M.id] || P2(M, t), q = !!B[M.id];
    return (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"rounded-xl border border-slate-800 bg-slate-900/80 p-4", children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"flex flex-col gap-3 lg:flex-row lg:items-start lg:justify-between", children:[(0,require$react_SLASH_jsx_runtime.jsxs)("button", {type:"button", "aria-expanded":q, onClick:() => ne(M.id), className:"flex min-w-0 flex-1 items-start gap-3 text-left", children:[(0,require$react_SLASH_jsx_runtime.jsx)("span", 
    {className:"mt-0.5 inline-flex h-6 w-6 shrink-0 items-center justify-center rounded-full border border-slate-700 text-xs text-slate-300", children:q ? "\u2212" : "+"}), (0,require$react_SLASH_jsx_runtime.jsxs)("span", {className:"min-w-0", children:[(0,require$react_SLASH_jsx_runtime.jsx)("span", {className:"block truncate text-sm font-semibold text-slate-100", children:M.displayName}), (0,require$react_SLASH_jsx_runtime.jsx)("span", {className:"block truncate text-sm text-slate-400", children:M.email}), 
    (0,require$react_SLASH_jsx_runtime.jsx)("span", {className:"mt-1 block text-xs text-slate-500", children:q ? "Click to collapse" : "Click to manage profile, credentials, roles, and tools"})]})]}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"min-w-0 flex-1 lg:flex-none", children:(0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"mt-2 flex flex-wrap gap-2", children:[(0,require$react_SLASH_jsx_runtime.jsxs)(In, {tone:"info", children:["actor:", X.actorId || "workspace_user"]}), 
    (0,require$react_SLASH_jsx_runtime.jsx)(In, {tone:X.status === "active" ? "success" : "danger", children:X.status}), X.isDefault ? (0,require$react_SLASH_jsx_runtime.jsx)(In, {tone:"info", children:"default membership"}) : null]})}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"flex flex-wrap gap-2", children:[X.roles.map(R => (0,require$react_SLASH_jsx_runtime.jsx)(In, {children:R.slug}, R.id)), (M.credentials || []).map(R => (0,require$react_SLASH_jsx_runtime.jsxs)(In, {tone:"warn", 
    children:[R.label || R.provider, ":", R.configuredFields.length, " fields"]}, R.id)), X.toolPolicies.map(R => (0,require$react_SLASH_jsx_runtime.jsxs)(In, {tone:R.effect === "deny" ? "danger" : "warn", children:[R.toolId, ":", R.effect]}, `${X.id}-${R.toolId}`))]})]}), q ? (0,require$react_SLASH_jsx_runtime.jsxs)(require$react_SLASH_jsx_runtime.Fragment, {children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"mt-4 grid gap-4 xl:grid-cols-2", children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", 
    {className:"rounded-xl border border-slate-800 bg-slate-950/70 p-4", children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"mb-3 text-sm font-semibold text-slate-100", children:"Actor profile"}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"grid gap-3 sm:grid-cols-2", children:[(0,require$react_SLASH_jsx_runtime.jsxs)("label", {className:"flex flex-col gap-1 text-xs text-slate-300", children:["Actor ID", (0,require$react_SLASH_jsx_runtime.jsx)("input", {className:"rounded-lg border border-slate-700 bg-slate-900 px-3 py-2 text-slate-100", 
    value:te.actorId, onChange:R => _($ => ({...$, [M.id]:{...te, actorId:R.target.value}}))})]}), (0,require$react_SLASH_jsx_runtime.jsxs)("label", {className:"flex flex-col gap-1 text-xs text-slate-300", children:["Display name", (0,require$react_SLASH_jsx_runtime.jsx)("input", {className:"rounded-lg border border-slate-700 bg-slate-900 px-3 py-2 text-slate-100", value:te.displayName, onChange:R => _($ => ({...$, [M.id]:{...te, displayName:R.target.value}}))})]}), (0,require$react_SLASH_jsx_runtime.jsxs)("label", 
    {className:"flex flex-col gap-1 text-xs text-slate-300", children:["Email / login identifier", (0,require$react_SLASH_jsx_runtime.jsx)("input", {className:"rounded-lg border border-slate-700 bg-slate-900 px-3 py-2 text-slate-100", value:te.email, onChange:R => _($ => ({...$, [M.id]:{...te, email:R.target.value}}))})]}), (0,require$react_SLASH_jsx_runtime.jsxs)("label", {className:"flex flex-col gap-1 text-xs text-slate-300", children:["Status", (0,require$react_SLASH_jsx_runtime.jsxs)("select", 
    {className:"rounded-lg border border-slate-700 bg-slate-900 px-3 py-2 text-slate-100", value:te.status, onChange:R => _($ => ({...$, [M.id]:{...te, status:R.target.value}})), children:[(0,require$react_SLASH_jsx_runtime.jsx)("option", {value:"active", children:"active"}), (0,require$react_SLASH_jsx_runtime.jsx)("option", {value:"disabled", children:"disabled"})]})]})]}), r ? (0,require$react_SLASH_jsx_runtime.jsx)("button", {type:"button", onClick:() => void ie(M.id), disabled:C === M.id || !te.actorId.trim() || 
    !te.email.trim(), className:"mt-4 rounded-lg border border-cyan-500/30 bg-cyan-500/10 px-4 py-2 text-sm font-medium text-cyan-200 hover:bg-cyan-500/20 disabled:cursor-not-allowed disabled:opacity-50", children:C === M.id ? "Saving\u2026" : "Save actor profile"}) : null]}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"rounded-xl border border-slate-800 bg-slate-950/70 p-4", children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"mb-3 text-sm font-semibold text-slate-100", 
    children:"Actor credentials"}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"space-y-4", children:O2.map(R => {
      const $ = C0(M.id, R.provider), G = N[$] || R2(M, R), J = iP(M.credentials, R.provider);
      return (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"rounded-lg border border-slate-800 bg-slate-900/70 p-3", children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"mb-2 flex items-center justify-between gap-3", children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"text-xs font-semibold uppercase tracking-wide text-slate-300", children:R.label}), (0,require$react_SLASH_jsx_runtime.jsx)("div", 
      {className:"text-[11px] text-slate-500", children:J ? `Saved ${J.configuredFields.length} field(s)` : "No credential saved yet"})]}), (0,require$react_SLASH_jsx_runtime.jsx)(In, {tone:J ? "success" : "default", children:J ? "configured" : "empty"})]}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"grid gap-2 sm:grid-cols-2", children:[(0,require$react_SLASH_jsx_runtime.jsxs)("label", {className:"flex flex-col gap-1 text-[11px] text-slate-400 sm:col-span-2", children:["Account identifier", 
      (0,require$react_SLASH_jsx_runtime.jsx)("input", {className:"rounded-lg border border-slate-700 bg-slate-950 px-3 py-2 text-xs text-slate-100", placeholder:R.accountPlaceholder, value:G.accountIdentifier, onChange:U => E(le => ({...le, [$]:{...G, accountIdentifier:U.target.value}}))})]}), R.fields.map(U => (0,require$react_SLASH_jsx_runtime.jsxs)("label", {className:"flex flex-col gap-1 text-[11px] text-slate-400", children:[(0,require$react_SLASH_jsx_runtime.jsxs)("span", {className:"flex items-center justify-between gap-2", 
      children:[U.label, (0,require$react_SLASH_jsx_runtime.jsx)("span", {className:"text-[10px] text-slate-500", children:vre(J, U.key)})]}), (0,require$react_SLASH_jsx_runtime.jsx)("input", {type:U.secret ? "password" : "text", className:"rounded-lg border border-slate-700 bg-slate-950 px-3 py-2 text-xs text-slate-100", placeholder:U.placeholder || (U.secret ? "leave blank to keep saved value" : ""), value:G.secretJson[U.key] || "", onChange:le => E(be => ({...be, [$]:{...G, secretJson:{...G.secretJson, 
      [U.key]:le.target.value}}}))})]}, U.key))]}), i ? (0,require$react_SLASH_jsx_runtime.jsx)("button", {type:"button", onClick:() => void ee(M.id, R.provider), disabled:A === $, className:"mt-3 rounded-lg border border-amber-500/30 bg-amber-500/10 px-3 py-1.5 text-xs font-medium text-amber-200 hover:bg-amber-500/20 disabled:cursor-not-allowed disabled:opacity-50", children:A === $ ? "Saving\u2026" : `Save ${R.label}`}) : null]}, R.provider);
    })})]})]}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"mt-4 grid gap-4 xl:grid-cols-2", children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"rounded-xl border border-slate-800 bg-slate-950/70 p-4", children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"mb-3 text-sm font-semibold text-slate-100", children:"Membership roles"}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"flex flex-wrap gap-2", children:o.map(R => (0,require$react_SLASH_jsx_runtime.jsxs)("label", 
    {className:"inline-flex items-center gap-2 rounded-full border border-slate-700 px-3 py-1 text-xs text-slate-200", children:[(0,require$react_SLASH_jsx_runtime.jsx)("input", {type:"checkbox", checked:ge.includes(R.slug), onChange:() => h($ => ({...$, [X.id]:Ad($[X.id] || [], R.slug)}))}), R.slug]}, `${X.id}-${R.id}`))}), r ? (0,require$react_SLASH_jsx_runtime.jsx)("button", {type:"button", onClick:() => void v(X.id), disabled:m === X.id, className:"mt-4 rounded-lg border border-cyan-500/30 bg-cyan-500/10 px-4 py-2 text-sm font-medium text-cyan-200 hover:bg-cyan-500/20 disabled:cursor-not-allowed disabled:opacity-50", 
    children:m === X.id ? "Saving\u2026" : "Save membership roles"}) : null]}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"rounded-xl border border-slate-800 bg-slate-950/70 p-4", children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"mb-3 text-sm font-semibold text-slate-100", children:"Membership tool overrides"}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"grid gap-3 sm:grid-cols-2", children:a.map(R => (0,require$react_SLASH_jsx_runtime.jsxs)("label", 
    {className:"flex flex-col gap-2 text-xs text-slate-300", children:[(0,require$react_SLASH_jsx_runtime.jsx)("span", {className:"font-medium text-slate-200", children:R.id}), (0,require$react_SLASH_jsx_runtime.jsxs)("select", {className:"rounded-lg border border-slate-700 bg-slate-900 px-3 py-2 text-slate-100", value:me[R.id] || "inherit", onChange:$ => p(G => ({...G, [X.id]:{...(G[X.id] || {}), [R.id]:$.target.value}})), children:[(0,require$react_SLASH_jsx_runtime.jsx)("option", {value:"inherit", 
    children:"inherit"}), (0,require$react_SLASH_jsx_runtime.jsx)("option", {value:"allow", children:"allow"}), (0,require$react_SLASH_jsx_runtime.jsx)("option", {value:"deny", children:"deny"})]})]}, `${X.id}-tool-${R.id}`))}), i ? (0,require$react_SLASH_jsx_runtime.jsx)("button", {type:"button", onClick:() => void T(X.id), disabled:m === X.id, className:"mt-4 rounded-lg border border-amber-500/30 bg-amber-500/10 px-4 py-2 text-sm font-medium text-amber-200 hover:bg-amber-500/20 disabled:cursor-not-allowed disabled:opacity-50", 
    children:m === X.id ? "Saving\u2026" : "Save tool overrides"}) : null]})]})]}) : null]}, M.id);
  })})]});
}
function Sre({selectedOrgId:t, selectedOrgName:e, canCreateRoles:n, canUpdateRolePolicies:r, roles:i, tools:s, permissionGroups:o, roleForm:a, setRoleForm:l, roleToolDrafts:c, setRoleToolDrafts:u, creatingRole:h, savingRoleId:f, onCreateRole:p, onSaveRolePolicies:g}) {
  return (0,require$react_SLASH_jsx_runtime.jsxs)(bo, {title:"Roles", description:"Seeded and custom org roles. Create roles from permission atoms, then refine tool policies.", children:[t && n ? (0,require$react_SLASH_jsx_runtime.jsxs)("form", {className:"mb-5 space-y-4 rounded-xl border border-slate-800 bg-slate-900/80 p-4", onSubmit:p, children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"grid gap-3 md:grid-cols-2", children:[(0,require$react_SLASH_jsx_runtime.jsx)("input", {className:"rounded-lg border border-slate-700 bg-slate-900 px-3 py-2 text-slate-100", 
  placeholder:"Role name", value:a.name, onChange:m => l(b => ({...b, name:m.target.value}))}), (0,require$react_SLASH_jsx_runtime.jsx)("input", {className:"rounded-lg border border-slate-700 bg-slate-900 px-3 py-2 text-slate-100", placeholder:"role-slug", value:a.slug, onChange:m => l(b => ({...b, slug:m.target.value}))})]}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"grid gap-4 xl:grid-cols-2", children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", 
  {className:"mb-2 text-xs uppercase tracking-wide text-slate-500", children:"Permission atoms"}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"max-h-72 space-y-3 overflow-auto rounded-xl border border-slate-800 bg-slate-950/70 p-3", children:o.map(([m, b]) => (0,require$react_SLASH_jsx_runtime.jsxs)("div", {children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"mb-2 text-xs font-semibold uppercase tracking-wide text-slate-400", children:m}), (0,require$react_SLASH_jsx_runtime.jsx)("div", 
  {className:"space-y-2", children:b.map(x => (0,require$react_SLASH_jsx_runtime.jsxs)("label", {className:"flex items-start gap-2 text-xs text-slate-300", children:[(0,require$react_SLASH_jsx_runtime.jsx)("input", {type:"checkbox", checked:a.permissionCodes.includes(x.code), onChange:() => l(w => ({...w, permissionCodes:Ad(w.permissionCodes, x.code)}))}), (0,require$react_SLASH_jsx_runtime.jsxs)("span", {children:[(0,require$react_SLASH_jsx_runtime.jsx)("span", {className:"block font-medium text-slate-200", 
  children:x.code}), (0,require$react_SLASH_jsx_runtime.jsx)("span", {className:"text-slate-500", children:x.description})]})]}, x.id))})]}, m))})]}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"mb-2 text-xs uppercase tracking-wide text-slate-500", children:"Allowed tools"}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"space-y-2 rounded-xl border border-slate-800 bg-slate-950/70 p-3", children:s.map(m => (0,require$react_SLASH_jsx_runtime.jsxs)("label", 
  {className:"flex items-start gap-2 text-xs text-slate-300", children:[(0,require$react_SLASH_jsx_runtime.jsx)("input", {type:"checkbox", checked:a.toolIds.includes(m.id), onChange:() => l(b => ({...b, toolIds:Ad(b.toolIds, m.id)}))}), (0,require$react_SLASH_jsx_runtime.jsxs)("span", {children:[(0,require$react_SLASH_jsx_runtime.jsx)("span", {className:"block font-medium text-slate-200", children:m.id}), (0,require$react_SLASH_jsx_runtime.jsx)("span", {className:"text-slate-500", children:m.description})]})]}, 
  `new-role-tool-${m.id}`))})]})]}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"flex justify-end", children:(0,require$react_SLASH_jsx_runtime.jsx)("button", {type:"submit", disabled:h || !a.name.trim(), className:"rounded-lg border border-emerald-500/30 bg-emerald-500/10 px-4 py-2 text-sm font-medium text-emerald-200 hover:bg-emerald-500/20 disabled:cursor-not-allowed disabled:opacity-50", children:h ? "Creating\u2026" : `Create role in ${e}`})})]}) : null, (0,require$react_SLASH_jsx_runtime.jsx)("div", 
  {className:"space-y-4", children:i.length === 0 ? (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"rounded-xl border border-dashed border-slate-800 px-4 py-6 text-sm text-slate-400", children:"No roles available in this org."}) : i.map(m => {
    const b = c[m.id] || ah(m.toolPolicies);
    return (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"rounded-xl border border-slate-800 bg-slate-900/80 p-4", children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"flex flex-col gap-3 lg:flex-row lg:items-start lg:justify-between", children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"text-sm font-semibold text-slate-100", children:m.name}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"text-sm text-slate-400", 
    children:m.slug})]}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"flex flex-wrap gap-2", children:[m.builtIn ? (0,require$react_SLASH_jsx_runtime.jsx)(In, {tone:"info", children:"built-in"}) : (0,require$react_SLASH_jsx_runtime.jsx)(In, {tone:"success", children:"custom"}), m.systemManaged ? (0,require$react_SLASH_jsx_runtime.jsx)(In, {tone:"warn", children:"system-managed"}) : null, (0,require$react_SLASH_jsx_runtime.jsxs)(In, {children:[m.permissions.length, " perms"]})]})]}), 
    (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"mt-3 flex flex-wrap gap-2", children:m.toolPolicies.map(x => (0,require$react_SLASH_jsx_runtime.jsxs)(In, {tone:x.effect === "deny" ? "danger" : "warn", children:[x.toolId, ":", x.effect]}, `${m.id}-${x.toolId}`))}), (0,require$react_SLASH_jsx_runtime.jsxs)("details", {className:"mt-4 rounded-xl border border-slate-800 bg-slate-950/70 p-4", children:[(0,require$react_SLASH_jsx_runtime.jsx)("summary", {className:"cursor-pointer text-sm font-medium text-slate-200", 
    children:"Inspect permissions and edit tool policy"}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"mt-4 grid gap-4 xl:grid-cols-2", children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"mb-2 text-xs uppercase tracking-wide text-slate-500", children:"Permissions"}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"max-h-56 space-y-2 overflow-auto rounded-lg border border-slate-800 bg-slate-900/70 p-3 text-xs text-slate-300", 
    children:m.permissions.map(x => (0,require$react_SLASH_jsx_runtime.jsx)("div", {children:x}, `${m.id}-perm-${x}`))})]}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"mb-2 text-xs uppercase tracking-wide text-slate-500", children:"Tool policy"}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"grid gap-3 sm:grid-cols-2", children:s.map(x => (0,require$react_SLASH_jsx_runtime.jsxs)("label", {className:"flex flex-col gap-2 text-xs text-slate-300", 
    children:[(0,require$react_SLASH_jsx_runtime.jsx)("span", {className:"font-medium text-slate-200", children:x.id}), (0,require$react_SLASH_jsx_runtime.jsxs)("select", {className:"rounded-lg border border-slate-700 bg-slate-900 px-3 py-2 text-slate-100", value:b[x.id] || "inherit", onChange:w => u(v => ({...v, [m.id]:{...(v[m.id] || {}), [x.id]:w.target.value}})), children:[(0,require$react_SLASH_jsx_runtime.jsx)("option", {value:"inherit", children:"inherit"}), (0,require$react_SLASH_jsx_runtime.jsx)("option", 
    {value:"allow", children:"allow"}), (0,require$react_SLASH_jsx_runtime.jsx)("option", {value:"deny", children:"deny"})]})]}, `${m.id}-tool-${x.id}`))}), r ? (0,require$react_SLASH_jsx_runtime.jsx)("button", {type:"button", onClick:() => void g(m.id), disabled:f === m.id, className:"mt-4 rounded-lg border border-cyan-500/30 bg-cyan-500/10 px-4 py-2 text-sm font-medium text-cyan-200 hover:bg-cyan-500/20 disabled:cursor-not-allowed disabled:opacity-50", children:f === m.id ? "Saving\u2026" : "Save role tool policy"}) : 
    null]})]})]})]}, m.id);
  })})]});
}
function kre(t) {
  const e = t.toLowerCase();
  return e === "docs" || e.startsWith("docs/") || e === "specs" || e.startsWith("specs/") || e === "inbox" || e.startsWith("inbox/") ? "docs" : e === "config" || e.startsWith("config/") || e === "configs" || e.startsWith("configs/") || e.includes("docker-compose") || e.endsWith(".env") ? "config" : e === "data" || e.startsWith("data/") || e === "datasets" || e.startsWith("datasets/") ? "data" : "code";
}
function D2(t) {
  switch(t) {
    case "docs":
      return ".md,.txt,.org,.rst,.adoc";
    case "config":
      return ".json,.jsonc,.yaml,.yml,.toml,.ini,.cfg,.conf,.env,.properties";
    case "data":
      return ".jsonl,.csv,.tsv,.parquet";
    default:
      return ".clj,.cljs,.cljc,.edn,.ts,.tsx,.js,.jsx,.py,.go,.rs,.java,.kt,.sh,.sql";
  }
}
function L2(t) {
  if (!t) {
    return "devel";
  }
  const e = t.split("/").filter(Boolean);
  return e[e.length - 1] || "devel";
}
function Ere({onCreateSource:t, onStartJob:e}) {
  const [n, r] = (0,require$react.useState)(""), [i, s] = (0,require$react.useState)(null), [o, a] = (0,require$react.useState)(null), [l, c] = (0,require$react.useState)(!1), [u, h] = (0,require$react.useState)(!1), [f, p] = (0,require$react.useState)(!1), [g, m] = (0,require$react.useState)(!1), [b, x] = (0,require$react.useState)("devel"), [w, v] = (0,require$react.useState)("docs"), [T, I] = (0,require$react.useState)(".md,.txt,.org,.rst,.adoc"), [_, N] = (0,require$react.useState)("**/.git/**,**/node_modules/**,**/dist/**,**/coverage/**,**/*.png,**/*.jpg,**/*.jpeg,**/*.gif,**/*.pdf,**/*.zip,**/*.tar.gz"), 
  [E, C] = (0,require$react.useState)(""), [k, A] = (0,require$react.useState)(!1), [P, W] = (0,require$react.useState)(!1), [F, B] = (0,require$react.useState)(null), z = (0,require$react.useMemo)(() => n.split("/").filter(Boolean), [n]), j = (0,require$react.useMemo)(() => {
    let X = (i == null ? void 0 : i.entries) || [];
    k || (X = X.filter(me => !me.name.startsWith("."))), P && (X = X.filter(me => me.type === "dir"));
    const ge = E.trim().toLowerCase();
    return ge ? X.filter(me => me.name.toLowerCase().includes(ge) || me.path.toLowerCase().includes(ge)) : X;
  }, [i == null ? void 0 : i.entries, E, k, P]), V = [{label:"docs", path:"docs"}, {label:"specs/drafts", path:"specs/drafts"}, {label:"packages", path:"packages"}, {label:"services", path:"services"}, {label:"orgs", path:"orgs"}], ne = (0,require$react.useCallback)(async(X = "") => {
    c(!0), B(null);
    try {
      const ge = new URLSearchParams();
      X && ge.set("path", X);
      const me = await fetch(`/api/ingestion/browse?${ge.toString()}`);
      if (!me.ok) {
        throw new Error(`Browse failed: ${me.status}`);
      }
      const te = await me.json();
      s(te), r(te.current_path || "");
      const q = kre(te.current_path || "");
      v(q), I(D2(q)), a(null);
    } catch (ge) {
      B(ge instanceof Error ? ge.message : String(ge));
    } finally {
      c(!1);
    }
  }, []);
  async function D(X) {
    h(!0), B(null);
    try {
      const ge = new URLSearchParams({path:X}), me = await fetch(`/api/ingestion/file?${ge.toString()}`);
      if (!me.ok) {
        throw new Error(`Preview failed: ${me.status}`);
      }
      const te = await me.json();
      a(te);
    } catch (ge) {
      B(ge instanceof Error ? ge.message : String(ge));
    } finally {
      h(!1);
    }
  }
  (0,require$react.useEffect)(() => {
    ne("docs");
  }, [ne]);
  async function ie() {
    p(!0), B(null);
    try {
      const X = (i == null ? void 0 : i.workspace_root) || "/app/workspace", ge = n ? `${X}/${n}` : X, me = b.split(",").map(te => te.trim()).filter(Boolean);
      await t({driver_type:"local", name:`${L2(n)} \u2192 ${me.join(",") || "devel"} (${w})`, config:{root_path:ge}, collections:me.length ? me : ["devel"], file_types:T.split(",").map(te => te.trim()).filter(Boolean), exclude_patterns:_.split(",").map(te => te.trim()).filter(Boolean)});
    } catch (X) {
      B(X instanceof Error ? X.message : String(X));
    } finally {
      p(!1);
    }
  }
  async function ee() {
    if (!e) {
      await ie();
      return;
    }
    m(!0), B(null);
    try {
      const X = (i == null ? void 0 : i.workspace_root) || "/app/workspace", ge = n ? `${X}/${n}` : X, me = b.split(",").map(q => q.trim()).filter(Boolean), te = await t({driver_type:"local", name:`${L2(n)} \u2192 ${me.join(",") || "devel"} (${w})`, config:{root_path:ge}, collections:me.length ? me : ["devel"], file_types:T.split(",").map(q => q.trim()).filter(Boolean), exclude_patterns:_.split(",").map(q => q.trim()).filter(Boolean)});
      te != null && te.source_id && await e(te.source_id);
    } catch (X) {
      B(X instanceof Error ? X.message : String(X));
    } finally {
      m(!1);
    }
  }
  const M = z.length > 0 ? z.slice(0, -1).join("/") : null;
  return (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"grid gap-4 xl:grid-cols-[minmax(320px,420px),minmax(0,1fr)]", children:[(0,require$react_SLASH_jsx_runtime.jsx)(Mn, {variant:"elevated", title:"Workspace Browser", extra:(0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"flex items-center gap-2 text-xs text-slate-500", children:(0,require$react_SLASH_jsx_runtime.jsx)("span", {children:n || "workspace/"})}), footer:(0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"flex w-full items-center gap-2", 
  children:[(0,require$react_SLASH_jsx_runtime.jsx)(Ke, {variant:"secondary", size:"sm", disabled:!M && n === "", onClick:() => ne(M ?? ""), children:"Up"}), (0,require$react_SLASH_jsx_runtime.jsx)(Ke, {variant:"primary", size:"sm", loading:f, onClick:ie, children:"Create Source Here"}), (0,require$react_SLASH_jsx_runtime.jsx)(Ke, {variant:"secondary", size:"sm", loading:g, onClick:ee, children:"Create + Start Sync"})]}), children:(0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"space-y-3", 
  children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"flex flex-wrap items-center gap-2 text-xs text-slate-500", children:[(0,require$react_SLASH_jsx_runtime.jsx)("span", {className:"font-medium text-slate-700 dark:text-slate-200", children:"Path:"}), (0,require$react_SLASH_jsx_runtime.jsx)("button", {type:"button", className:"underline-offset-2 hover:underline", onClick:() => ne(""), children:"workspace"}), z.map((X, ge) => {
    const me = z.slice(0, ge + 1).join("/");
    return (0,require$react_SLASH_jsx_runtime.jsxs)("span", {className:"flex items-center gap-2", children:[(0,require$react_SLASH_jsx_runtime.jsx)("span", {children:"/"}), (0,require$react_SLASH_jsx_runtime.jsx)("button", {type:"button", className:"underline-offset-2 hover:underline", onClick:() => ne(me), children:X})]}, me);
  })]}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"grid gap-3", children:[(0,require$react_SLASH_jsx_runtime.jsx)(Cn, {value:E, onChange:X => C(X.target.value), placeholder:"Filter entries..."}), (0,require$react_SLASH_jsx_runtime.jsx)(Cn, {value:b, onChange:X => x(X.target.value), placeholder:"Collections / projects (comma-separated)"}), (0,require$react_SLASH_jsx_runtime.jsx)(Cn, {value:w, onChange:X => {
    v(X.target.value), I(D2(X.target.value));
  }, placeholder:"Kind (docs/code/config/data)"}), (0,require$react_SLASH_jsx_runtime.jsx)(Cn, {value:T, onChange:X => I(X.target.value), placeholder:".md,.txt,.clj"}), (0,require$react_SLASH_jsx_runtime.jsx)(Cn, {value:_, onChange:X => N(X.target.value), placeholder:"Exclude globs"})]}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"flex flex-wrap gap-2", children:[V.map(X => (0,require$react_SLASH_jsx_runtime.jsx)(Ke, {size:"sm", variant:"ghost", onClick:() => ne(X.path), children:X.label}, 
  X.path)), (0,require$react_SLASH_jsx_runtime.jsx)(Ke, {size:"sm", variant:k ? "secondary" : "ghost", onClick:() => A(X => !X), children:k ? "Hide hidden" : "Show hidden"}), (0,require$react_SLASH_jsx_runtime.jsx)(Ke, {size:"sm", variant:P ? "secondary" : "ghost", onClick:() => W(X => !X), children:P ? "Show files" : "Dirs only"})]}), F ? (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"rounded-md border border-red-300 bg-red-50 px-3 py-2 text-sm text-red-700", children:F}) : null, (0,require$react_SLASH_jsx_runtime.jsx)("div", 
  {className:"max-h-[520px] overflow-auto rounded-md border border-slate-200 dark:border-slate-700", children:l && !i ? (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"flex items-center justify-center p-8", children:(0,require$react_SLASH_jsx_runtime.jsx)(tp, {label:"Loading files..."})}) : (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"divide-y divide-slate-100 dark:divide-slate-800", children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"px-3 py-2 text-xs text-slate-500", 
  children:[j.length, " item(s)"]}), j.map(X => (0,require$react_SLASH_jsx_runtime.jsxs)("button", {type:"button", onClick:() => X.type === "dir" ? ne(X.path) : X.previewable ? D(X.path) : void 0, className:"flex w-full items-center justify-between gap-3 px-3 py-2 text-left hover:bg-slate-50 dark:hover:bg-slate-900/40", children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"min-w-0", children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"truncate text-sm font-medium text-slate-800 dark:text-slate-100", 
  children:[X.type === "dir" ? "\ud83d\udcc1" : "\ud83d\udcc4", " ", X.name]}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"truncate text-xs text-slate-500", children:X.path})]}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"shrink-0 text-xs text-slate-500", children:X.type === "file" ? `${Math.max(1, Math.round((X.size || 0) / 1024))} KB` : "dir"})]}, `${X.type}:${X.path}`))]})})]})}), (0,require$react_SLASH_jsx_runtime.jsx)(Mn, {variant:"default", title:"File Preview", 
  children:u ? (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"flex items-center justify-center p-8", children:(0,require$react_SLASH_jsx_runtime.jsx)(tp, {label:"Loading preview..."})}) : o ? (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"space-y-3", children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"text-xs text-slate-500", children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {children:o.path}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {children:[Math.max(1, 
  Math.round(o.size / 1024)), " KB", o.truncated ? " \u2022 truncated" : ""]})]}), (0,require$react_SLASH_jsx_runtime.jsx)("pre", {className:"max-h-[620px] overflow-auto rounded-md bg-slate-950 px-4 py-3 text-xs leading-6 text-slate-100", children:o.content})]}) : (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"p-8 text-sm text-slate-500", children:"Select a previewable file to inspect its contents before creating an ingestion source."})})]});
}
function Tre({source:t, audit:e, jobs:n, onStartJob:r, onDelete:i}) {
  return (0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{flex:1, overflow:"auto", padding:24}, children:(0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{maxWidth:768, margin:"0 auto"}, children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{display:"flex", alignItems:"flex-start", justifyContent:"space-between", marginBottom:24}, children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {children:[(0,require$react_SLASH_jsx_runtime.jsx)("h1", {style:{fontSize:24, fontWeight:700}, 
  children:t.name}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{fontSize:14, color:"var(--token-colors-text-muted)", marginTop:4}, children:[t.driver_type, " \u2022 Created ", (new Date(t.created_at)).toLocaleDateString()]})]}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{display:"flex", gap:8}, children:[(0,require$react_SLASH_jsx_runtime.jsx)(Ke, {variant:"primary", onClick:r, children:"\u25b6 Start Sync"}), (0,require$react_SLASH_jsx_runtime.jsx)(Ke, {variant:"danger", 
  onClick:i, children:"Delete"})]})]}), (0,require$react_SLASH_jsx_runtime.jsxs)(Mn, {variant:"default", padding:"md", style:{marginBottom:24}, children:[(0,require$react_SLASH_jsx_runtime.jsx)("h3", {style:{fontWeight:600, marginBottom:12}, children:"Coverage Audit"}), e ? (0,require$react_SLASH_jsx_runtime.jsxs)(require$react_SLASH_jsx_runtime.Fragment, {children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{display:"grid", gridTemplateColumns:"repeat(4, 1fr)", gap:16, marginBottom:16}, 
  children:[(0,require$react_SLASH_jsx_runtime.jsx)(Vo, {label:"Matching Files", value:e.matching_files}), (0,require$react_SLASH_jsx_runtime.jsx)(Vo, {label:"In Lake", value:e.openplanner_documents, color:"var(--token-colors-accent-green)"}), (0,require$react_SLASH_jsx_runtime.jsx)(Vo, {label:"Pending Sync", value:e.new_files + e.changed_files, color:"var(--token-colors-accent-blue)"}), (0,require$react_SLASH_jsx_runtime.jsx)(Vo, {label:"Failed State", value:e.state_failed_files, color:"var(--token-colors-accent-red)"})]}), 
  (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{fontSize:14, color:"var(--token-colors-text-muted)", display:"grid", gap:6, marginBottom:12}, children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {children:[(0,require$react_SLASH_jsx_runtime.jsx)("strong", {children:"Root:"}), " ", e.root_path || "(none)"]}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {children:[(0,require$react_SLASH_jsx_runtime.jsx)("strong", {children:"Lakes:"}), " ", e.collections.join(", ") || "devel"]}), 
  (0,require$react_SLASH_jsx_runtime.jsxs)("div", {children:[(0,require$react_SLASH_jsx_runtime.jsx)("strong", {children:"Include:"}), " ", e.include_patterns.join(", ") || "(all matching text-like files)"]}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {children:[(0,require$react_SLASH_jsx_runtime.jsx)("strong", {children:"Exclude:"}), " ", e.exclude_patterns.join(", ") || "(none)"]}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {children:[(0,require$react_SLASH_jsx_runtime.jsx)("strong", 
  {children:"File types:"}), " ", e.file_types.join(", ") || "(driver default)"]}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {children:[(0,require$react_SLASH_jsx_runtime.jsx)("strong", {children:"State audit:"}), " ", e.state_ingested_files, " tracked as ingested, ", e.unchanged_files, " unchanged, ", e.changed_files, " changed, ", e.new_files, " new, ", e.skipped_files, " skipped"]}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {children:[(0,require$react_SLASH_jsx_runtime.jsx)("strong", 
  {children:"Lake delta:"}), " ", e.coverage_delta > 0 ? `${e.coverage_delta} matching files not yet represented in OpenPlanner` : e.coverage_delta < 0 ? `${Math.abs(e.coverage_delta)} more OpenPlanner docs than current matching files` : "source scan and OpenPlanner doc counts are aligned"]})]})]}) : (0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{fontSize:14, color:"var(--token-colors-text-muted)"}, children:"Loading coverage audit\u2026"})]}), (0,require$react_SLASH_jsx_runtime.jsxs)(Mn, 
  {variant:"default", padding:"md", style:{marginBottom:24}, children:[(0,require$react_SLASH_jsx_runtime.jsx)("h3", {style:{fontWeight:600, marginBottom:12}, children:"Configuration"}), (0,require$react_SLASH_jsx_runtime.jsx)("pre", {style:{fontSize:14, backgroundColor:"var(--token-colors-alpha-bg-_08)", padding:12, borderRadius:6, overflow:"auto"}, children:JSON.stringify(t.config, null, 2)})]}), (0,require$react_SLASH_jsx_runtime.jsxs)(Mn, {variant:"default", padding:"md", children:[(0,require$react_SLASH_jsx_runtime.jsx)("h3", 
  {style:{fontWeight:600, marginBottom:12}, children:"Recent Jobs"}), n.length === 0 ? (0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{fontSize:14, color:"var(--token-colors-text-muted)"}, children:"No jobs yet"}) : (0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{display:"flex", flexDirection:"column", gap:8}, children:n.slice(0, 5).map(s => (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{display:"flex", alignItems:"center", justifyContent:"space-between", padding:8, backgroundColor:"var(--token-colors-alpha-bg-_08)", 
  borderRadius:6}, children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{fontSize:14, fontWeight:500}, children:s.total_files > 0 ? `${s.processed_files}/${s.total_files} files` : "Pending..."}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{fontSize:12, color:"var(--token-colors-text-muted)"}, children:(new Date(s.created_at)).toLocaleString()})]}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{display:"flex", 
  alignItems:"center", gap:8}, children:[(0,require$react_SLASH_jsx_runtime.jsx)(ct, {variant:s.status === "completed" ? "success" : s.status === "failed" ? "error" : s.status === "running" ? "info" : "default", size:"sm", children:s.status}), (0,require$react_SLASH_jsx_runtime.jsxs)("span", {style:{fontSize:14, color:"var(--token-colors-text-subtle)"}, children:[s.chunks_created, " chunks"]})]})]}, s.job_id))})]})]})});
}
function Vo({label:t, value:e, color:n = "var(--token-colors-text-default)"}) {
  return (0,require$react_SLASH_jsx_runtime.jsxs)(Mn, {variant:"default", padding:"md", style:{textAlign:"center"}, children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{fontSize:24, fontWeight:700, color:n}, children:e.toLocaleString()}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{fontSize:14, color:"var(--token-colors-text-muted)"}, children:t})]});
}
function Cre({jobId:t, job:e, events:n, onCancel:r}) {
  const i = n.filter(p => p.type === "progress").slice(-1)[0], s = [...n].reverse().find(p => p.type === "job_complete" || p.type === "job_error"), o = e ? ["pending", "running"].includes(e.status) : !s, a = (i == null ? void 0 : i.total_files) ?? (e == null ? void 0 : e.total_files) ?? 0, l = (i == null ? void 0 : i.processed_files) ?? (e == null ? void 0 : e.processed_files) ?? 0, c = (i == null ? void 0 : i.failed_files) ?? (e == null ? void 0 : e.failed_files) ?? 0, u = (i == null ? void 0 : 
  i.chunks_created) ?? (e == null ? void 0 : e.chunks_created) ?? 0, h = a > 0 ? (l + c) / a * 100 : (i == null ? void 0 : i.percent_complete) ?? 0, f = (i == null ? void 0 : i.status) ?? (e == null ? void 0 : e.status) ?? "Starting...";
  return (0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{flex:1, overflow:"auto", padding:24}, children:(0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{maxWidth:768, margin:"0 auto"}, children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{display:"flex", alignItems:"center", justifyContent:"space-between", marginBottom:24}, children:[(0,require$react_SLASH_jsx_runtime.jsxs)("h1", {style:{fontSize:24, fontWeight:700}, children:["Ingestion Job", (0,require$react_SLASH_jsx_runtime.jsx)("span", 
  {style:{fontSize:18, color:"var(--token-colors-text-muted)", marginLeft:8, fontFamily:"monospace"}, children:t.slice(0, 8)})]}), o && (0,require$react_SLASH_jsx_runtime.jsx)(Ke, {variant:"danger", onClick:r, children:"Cancel"})]}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{marginBottom:24}, children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{display:"flex", justifyContent:"space-between", fontSize:14, marginBottom:8}, children:[(0,require$react_SLASH_jsx_runtime.jsx)("span", 
  {style:{fontWeight:500}, children:f}), (0,require$react_SLASH_jsx_runtime.jsxs)("span", {style:{color:"var(--token-colors-text-subtle)"}, children:[h.toFixed(1), "%"]})]}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{height:12, backgroundColor:"var(--token-colors-border-default)", borderRadius:9999, overflow:"hidden"}, children:(0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{height:"100%", width:`${h}%`, transition:"width 0.3s", backgroundColor:o ? "var(--token-colors-accent-blue)" : 
  "var(--token-colors-accent-green)"}})})]}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{display:"grid", gridTemplateColumns:"repeat(4, 1fr)", gap:16, marginBottom:24}, children:[(0,require$react_SLASH_jsx_runtime.jsx)(Vo, {label:"Total", value:a}), (0,require$react_SLASH_jsx_runtime.jsx)(Vo, {label:"Processed", value:l, color:"var(--token-colors-accent-green)"}), (0,require$react_SLASH_jsx_runtime.jsx)(Vo, {label:"Failed", value:c, color:"var(--token-colors-accent-red)"}), (0,require$react_SLASH_jsx_runtime.jsx)(Vo, 
  {label:"Chunks", value:u, color:"var(--token-colors-accent-blue)"})]}), e && n.length === 0 ? (0,require$react_SLASH_jsx_runtime.jsx)(Mn, {variant:"outlined", padding:"sm", style:{marginBottom:16}, children:(0,require$react_SLASH_jsx_runtime.jsx)("p", {style:{fontSize:14, color:"var(--token-colors-accent-blue)"}, children:"Live progress is being shown via polling. The activity log may remain empty for this job."})}) : null, (0,require$react_SLASH_jsx_runtime.jsxs)(Mn, {variant:"default", padding:"none", 
  children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{padding:12, borderBottom:"1px solid var(--token-colors-border-default)", fontWeight:600}, children:"Activity Log"}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{maxHeight:384, overflow:"auto", padding:8}, children:n.length === 0 ? (0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{fontSize:14, color:"var(--token-colors-text-muted)", textAlign:"center", padding:16}, children:"Waiting for events..."}) : (0,require$react_SLASH_jsx_runtime.jsx)("div", 
  {style:{display:"flex", flexDirection:"column", gap:4, fontFamily:"monospace", fontSize:14}, children:n.map((p, g) => (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{display:"flex", gap:8, padding:4, borderRadius:4, backgroundColor:p.type === "file_error" ? "var(--token-colors-alpha-red-_12)" : p.type === "file_complete" ? "var(--token-colors-alpha-green-_08)" : "transparent", color:p.type === "file_error" ? "var(--token-colors-accent-red)" : "inherit"}, children:[(0,require$react_SLASH_jsx_runtime.jsx)("span", 
  {style:{color:"var(--token-colors-text-muted)", flexShrink:0, width:80}, children:(new Date(p.timestamp)).toLocaleTimeString()}), (0,require$react_SLASH_jsx_runtime.jsx)("span", {style:{overflow:"hidden", textOverflow:"ellipsis"}, children:p.file_path ? (0,require$react_SLASH_jsx_runtime.jsxs)(require$react_SLASH_jsx_runtime.Fragment, {children:[p.file_path, p.file_chunks && (0,require$react_SLASH_jsx_runtime.jsxs)("span", {style:{color:"var(--token-colors-accent-green)", marginLeft:4}, children:["(", 
  p.file_chunks, " chunks)"]}), p.file_error && (0,require$react_SLASH_jsx_runtime.jsxs)("span", {style:{color:"var(--token-colors-accent-red)", marginLeft:4}, children:["\u2014 ", p.file_error]})]}) : p.type})]}, g))})})]})]})});
}
function Are({onClose:t, onCreate:e}) {
  const [n, r] = (0,require$react.useState)("local"), [i, s] = (0,require$react.useState)(""), [o, a] = (0,require$react.useState)("/app/workspace/docs"), [l, c] = (0,require$react.useState)("devel"), [u, h] = (0,require$react.useState)(".md,.txt,.clj,.cljs,.cljc,.edn,.json,.yml,.yaml,.ts,.tsx,.js,.html,.css"), [f, p] = (0,require$react.useState)(""), [g, m] = (0,require$react.useState)("**/node_modules/**,**/.git/**,**/dist/**,**/coverage/**,**/*.png,**/*.jpg,**/*.jpeg,**/*.gif,**/*.pdf,**/*.zip,**/*.tar.gz");
  return (0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{position:"fixed", inset:0, backgroundColor:"var(--token-colors-background-overlay)", display:"flex", alignItems:"center", justifyContent:"center", zIndex:50}, children:(0,require$react_SLASH_jsx_runtime.jsxs)(Mn, {variant:"elevated", padding:"lg", style:{width:"100%", maxWidth:448}, children:[(0,require$react_SLASH_jsx_runtime.jsx)("h2", {style:{fontSize:20, fontWeight:700, marginBottom:16}, children:"Add Data Source"}), (0,require$react_SLASH_jsx_runtime.jsxs)("form", 
  {onSubmit:x => {
    x.preventDefault(), e({driver_type:n, name:i || `${n} source`, config:n === "local" ? {root_path:o} : {}, collections:l.split(",").map(w => w.trim()).filter(Boolean), file_types:u.split(",").map(w => w.trim()).filter(Boolean), include_patterns:f.split(",").map(w => w.trim()).filter(Boolean), exclude_patterns:g.split(",").map(w => w.trim()).filter(Boolean)});
  }, style:{display:"flex", flexDirection:"column", gap:16}, children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {children:[(0,require$react_SLASH_jsx_runtime.jsx)("label", {style:{display:"block", fontSize:14, fontWeight:500, marginBottom:4}, children:"Source Type"}), (0,require$react_SLASH_jsx_runtime.jsxs)("select", {value:n, onChange:x => r(x.target.value), style:{width:"100%", padding:8, borderRadius:6, border:"1px solid var(--token-colors-border-subtle)"}, children:[(0,require$react_SLASH_jsx_runtime.jsx)("option", 
  {value:"local", children:"Local Filesystem"}), (0,require$react_SLASH_jsx_runtime.jsx)("option", {value:"github", disabled:!0, children:"GitHub (coming soon)"}), (0,require$react_SLASH_jsx_runtime.jsx)("option", {value:"google_drive", disabled:!0, children:"Google Drive (coming soon)"})]})]}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {children:[(0,require$react_SLASH_jsx_runtime.jsx)("label", {style:{display:"block", fontSize:14, fontWeight:500, marginBottom:4}, children:"Name"}), (0,require$react_SLASH_jsx_runtime.jsx)(Cn, 
  {value:i, onChange:x => s(x.target.value), placeholder:`${n} source`})]}), n === "local" ? (0,require$react_SLASH_jsx_runtime.jsxs)("div", {children:[(0,require$react_SLASH_jsx_runtime.jsx)("label", {style:{display:"block", fontSize:14, fontWeight:500, marginBottom:4}, children:"Root Path"}), (0,require$react_SLASH_jsx_runtime.jsx)(Cn, {value:o, onChange:x => a(x.target.value), placeholder:"/path/to/your/documents"}), (0,require$react_SLASH_jsx_runtime.jsx)("p", {style:{fontSize:12, color:"var(--token-colors-text-muted)", 
  marginTop:4}, children:"The root directory to scan for documents"})]}) : null, (0,require$react_SLASH_jsx_runtime.jsxs)("div", {children:[(0,require$react_SLASH_jsx_runtime.jsx)("label", {style:{display:"block", fontSize:14, fontWeight:500, marginBottom:4}, children:"File Types"}), (0,require$react_SLASH_jsx_runtime.jsx)(Cn, {value:u, onChange:x => h(x.target.value), placeholder:".md,.txt,.json"}), (0,require$react_SLASH_jsx_runtime.jsx)("p", {style:{fontSize:12, color:"var(--token-colors-text-muted)", 
  marginTop:4}, children:"Comma-separated extensions. Defaults to text-like files only."})]}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {children:[(0,require$react_SLASH_jsx_runtime.jsx)("label", {style:{display:"block", fontSize:14, fontWeight:500, marginBottom:4}, children:"Include Patterns"}), (0,require$react_SLASH_jsx_runtime.jsx)(Cn, {value:f, onChange:x => p(x.target.value), placeholder:"docs/**/*.md,specs/**/*.md"})]}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {children:[(0,require$react_SLASH_jsx_runtime.jsx)("label", 
  {style:{display:"block", fontSize:14, fontWeight:500, marginBottom:4}, children:"Exclude Patterns"}), (0,require$react_SLASH_jsx_runtime.jsx)(Cn, {value:g, onChange:x => m(x.target.value), placeholder:"**/node_modules/**,**/*.png"})]}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {children:[(0,require$react_SLASH_jsx_runtime.jsx)("label", {style:{display:"block", fontSize:14, fontWeight:500, marginBottom:4}, children:"Lakes"}), (0,require$react_SLASH_jsx_runtime.jsx)(Cn, {value:l, onChange:x => 
  c(x.target.value), placeholder:"devel"}), (0,require$react_SLASH_jsx_runtime.jsx)("p", {style:{fontSize:12, color:"var(--token-colors-text-muted)", marginTop:4}, children:"Comma-separated list of lake keys to ingest into"})]}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{display:"flex", gap:8, paddingTop:16}, children:[(0,require$react_SLASH_jsx_runtime.jsx)(Ke, {variant:"secondary", fullWidth:!0, onClick:t, children:"Cancel"}), (0,require$react_SLASH_jsx_runtime.jsx)(Ke, {variant:"primary", 
  fullWidth:!0, type:"submit", children:"Create Source"})]})]})]})});
}
const Ys = "/api/ingestion";
function Nre({selectedOrgName:t, canCreateDataLakes:e, lakeForm:n, setLakeForm:r, creatingLake:i, dataLakes:s, dataLakeKindOptions:o, onCreateLake:a}) {
  const [l, c] = (0,require$react.useState)([]), [u, h] = (0,require$react.useState)([]), [f, p] = (0,require$react.useState)(null), [g, m] = (0,require$react.useState)(null), [b, x] = (0,require$react.useState)(!1), [w, v] = (0,require$react.useState)(null), [T, I] = (0,require$react.useState)(null), [_, N] = (0,require$react.useState)([]), [E, C] = (0,require$react.useState)(!0), [k, A] = (0,require$react.useState)(!1), P = (0,require$react.useCallback)(async() => {
    try {
      const j = await fetch(`${Ys}/sources`);
      j.ok && c(await j.json());
    } catch (j) {
      console.error("Failed to load sources:", j);
    } finally {
      C(!1);
    }
  }, []), W = (0,require$react.useCallback)(async() => {
    try {
      const j = await fetch(`${Ys}/jobs?limit=20`);
      j.ok && h(await j.json());
    } catch (j) {
      console.error("Failed to load jobs:", j);
    }
  }, []);
  (0,require$react.useEffect)(() => {
    k && (P(), W());
  }, [k, P, W]), (0,require$react.useEffect)(() => {
    if (!f) {
      m(null);
      return;
    }
    (async() => {
      try {
        const j = await fetch(`${Ys}/sources/${f.source_id}/audit`);
        j.ok ? m(await j.json()) : m(null);
      } catch (j) {
        console.error("Failed to load source audit:", j), m(null);
      }
    })();
  }, [f]), (0,require$react.useEffect)(() => {
    if (!w) {
      return;
    }
    const j = new WebSocket(`${location.protocol === "https:" ? "wss:" : "ws:"}//${location.host}${Ys}/ws/jobs/${w}`);
    return j.onmessage = V => {
      const ne = JSON.parse(V.data);
      N(D => [...D.slice(-99), ne]), (ne.type === "job_complete" || ne.type === "job_error") && (W(), fetch(`${Ys}/jobs/${w}`).then(D => D.ok ? D.json() : null).then(D => {
        D && I(D);
      }).catch(() => {
      }), ne.type === "job_complete" && setTimeout(() => {
        v(null), I(null);
      }, 3e3));
    }, j.onerror = () => console.error("WebSocket error"), () => j.close();
  }, [w, W]);
  const F = async j => {
    try {
      const V = await fetch(`${Ys}/sources`, {method:"POST", headers:{"Content-Type":"application/json"}, body:JSON.stringify(j)});
      if (V.ok) {
        const ne = await V.json();
        return await P(), p(ne), x(!1), {source_id:ne.source_id, name:ne.name};
      } else {
        alert(`Failed to create source: ${await V.text()}`);
      }
    } catch (V) {
      console.error("Create source error:", V);
    }
    return null;
  }, B = async j => {
    try {
      const V = await fetch(`${Ys}/jobs`, {method:"POST", headers:{"Content-Type":"application/json"}, body:JSON.stringify({source_id:j})});
      if (V.ok) {
        const ne = await V.json();
        v(ne.job_id), I(ne), N([]), await W();
      } else {
        alert(`Failed to start job: ${await V.text()}`);
      }
    } catch (V) {
      console.error("Start job error:", V);
    }
  }, z = async j => {
    try {
      await fetch(`${Ys}/jobs/${j}/cancel`, {method:"POST"}), v(null), I(null), await W();
    } catch (V) {
      console.error("Cancel job error:", V);
    }
  };
  return (0,require$react_SLASH_jsx_runtime.jsxs)(bo, {title:"Data lakes \x26 ingestion", description:"Control-plane owned data-lake inventory and ingestion source management for the selected org.", children:[e ? (0,require$react_SLASH_jsx_runtime.jsxs)("form", {className:"mb-5 space-y-3 rounded-xl border border-slate-800 bg-slate-900/80 p-4", onSubmit:a, children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"grid gap-3 md:grid-cols-2", children:[(0,require$react_SLASH_jsx_runtime.jsx)("input", 
  {className:"rounded-lg border border-slate-700 bg-slate-900 px-3 py-2 text-slate-100", placeholder:"Lake name", value:n.name, onChange:j => r(V => ({...V, name:j.target.value}))}), (0,require$react_SLASH_jsx_runtime.jsx)("input", {className:"rounded-lg border border-slate-700 bg-slate-900 px-3 py-2 text-slate-100", placeholder:"lake-slug", value:n.slug, onChange:j => r(V => ({...V, slug:j.target.value}))})]}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"grid gap-3 md:grid-cols-2", 
  children:[(0,require$react_SLASH_jsx_runtime.jsx)("select", {className:"rounded-lg border border-slate-700 bg-slate-900 px-3 py-2 text-slate-100", value:n.kind, onChange:j => r(V => ({...V, kind:j.target.value})), children:o.map(j => (0,require$react_SLASH_jsx_runtime.jsx)("option", {value:j, children:j}, j))}), (0,require$react_SLASH_jsx_runtime.jsx)("input", {className:"rounded-lg border border-slate-700 bg-slate-900 px-3 py-2 text-slate-100", placeholder:"workspace root", value:n.workspaceRoot, 
  onChange:j => r(V => ({...V, workspaceRoot:j.target.value}))})]}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"flex justify-end", children:(0,require$react_SLASH_jsx_runtime.jsx)("button", {type:"submit", disabled:i || !n.name.trim(), className:"rounded-lg border border-emerald-500/30 bg-emerald-500/10 px-4 py-2 text-sm font-medium text-emerald-200 hover:bg-emerald-500/20 disabled:cursor-not-allowed disabled:opacity-50", children:i ? "Creating\u2026" : `Create data lake${t ? ` for ${t}` : 
  ""}`})})]}) : null, (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"space-y-4", children:s.length === 0 ? (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"rounded-xl border border-dashed border-slate-800 px-4 py-6 text-sm text-slate-400", children:"No org data lakes registered yet."}) : s.map(j => (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"rounded-xl border border-slate-800 bg-slate-900/80 p-4", children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"flex flex-col gap-3 lg:flex-row lg:items-start lg:justify-between", 
  children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"text-sm font-semibold text-slate-100", children:j.name}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"text-sm text-slate-400", children:j.slug})]}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"flex flex-wrap gap-2", children:[(0,require$react_SLASH_jsx_runtime.jsx)(In, {children:j.kind}), (0,require$react_SLASH_jsx_runtime.jsx)(In, {tone:j.status === 
  "active" ? "success" : "danger", children:j.status})]})]}), (0,require$react_SLASH_jsx_runtime.jsx)("pre", {className:"mt-3 overflow-auto rounded-lg border border-slate-800 bg-slate-950/70 p-3 text-xs text-slate-300", children:JSON.stringify(j.config, null, 2)})]}, j.id))}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"mt-6 border-t border-slate-800 pt-4", children:(0,require$react_SLASH_jsx_runtime.jsxs)("button", {type:"button", onClick:() => A(j => !j), className:"flex w-full items-center justify-between rounded-lg border border-slate-700 bg-slate-900/60 px-4 py-2.5 text-sm font-medium text-slate-200 hover:bg-slate-800 transition", 
  children:[(0,require$react_SLASH_jsx_runtime.jsxs)("span", {children:["Ingestion Sources (", l.length, ")"]}), (0,require$react_SLASH_jsx_runtime.jsx)("span", {className:"text-xs text-slate-500", children:k ? "\u25b2 collapse" : "\u25bc expand"})]})}), k ? (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"mt-4 space-y-4", children:[w ? (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"rounded-xl border border-slate-800 bg-slate-950/50 p-4", children:(0,require$react_SLASH_jsx_runtime.jsx)(Cre, 
  {jobId:w, job:T, events:_, onCancel:() => z(w)})}) : f ? (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"rounded-xl border border-slate-800 bg-slate-950/50 p-4", children:(0,require$react_SLASH_jsx_runtime.jsx)(Tre, {source:f, audit:g, jobs:u.filter(j => j.source_id === f.source_id), onStartJob:() => B(f.source_id), onDelete:async() => {
    confirm(`Delete source "${f.name}"?`) && (await fetch(`${Ys}/sources/${f.source_id}`, {method:"DELETE"}), p(null), await P());
  }})}) : null, E ? (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"text-sm text-slate-400 px-2", children:"Loading sources\u2026"}) : l.length === 0 ? (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"text-sm text-slate-400 px-2", children:"No ingestion sources configured."}) : (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"space-y-2", children:l.map(j => (0,require$react_SLASH_jsx_runtime.jsxs)("button", {type:"button", onClick:() => p(j), className:"w-full rounded-lg border border-slate-800 bg-slate-900/80 p-3 text-left hover:bg-slate-800 transition", 
  children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"text-sm font-medium text-slate-100", children:j.name}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"flex items-center gap-2 mt-1", children:[(0,require$react_SLASH_jsx_runtime.jsx)(In, {children:j.driver_type}), (0,require$react_SLASH_jsx_runtime.jsx)("span", {className:"inline-block h-2 w-2 rounded-full", style:{backgroundColor:j.enabled ? "var(--token-colors-accent-green)" : "var(--token-colors-text-muted)"}}), 
  (0,require$react_SLASH_jsx_runtime.jsx)("span", {className:"text-xs text-slate-500", children:j.enabled ? "active" : "disabled"})]}), j.last_error ? (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"mt-1 text-xs text-rose-400 truncate", children:["\u26a0 ", j.last_error]}) : null]}, j.source_id))}), !f && !w ? (0,require$react_SLASH_jsx_runtime.jsx)(Ere, {onCreateSource:F, onStartJob:B}) : null, (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"flex justify-end gap-2 pt-2", children:(0,require$react_SLASH_jsx_runtime.jsx)("button", 
  {type:"button", onClick:() => x(!0), className:"rounded-lg border border-sky-500/30 bg-sky-500/10 px-4 py-2 text-sm font-medium text-sky-200 hover:bg-sky-500/20 transition", children:"+ Add Source"})})]}) : null, b ? (0,require$react_SLASH_jsx_runtime.jsx)(Are, {onClose:() => x(!1), onCreate:F}) : null]});
}
function ji(t) {
  return typeof t != "number" || !Number.isFinite(t) ? "0" : Intl.NumberFormat().format(Math.round(t));
}
function A0(t) {
  return typeof t != "number" || !Number.isFinite(t) ? "$0" : `$${t.toFixed(4)}`;
}
function N0(t) {
  return typeof t != "number" || !Number.isFinite(t) ? "0%" : `${t.toFixed(2)}%`;
}
function Ire(t) {
  return t >= 500 ? "danger" : t >= 400 ? "warn" : t >= 200 && t < 300 ? "success" : "default";
}
function Ore(t) {
  const e = Ire(t);
  return (0,require$react_SLASH_jsx_runtime.jsx)(In, {tone:e === "default" ? "default" : e, children:t});
}
function Pre(t) {
  try {
    return (new Date(t)).toLocaleString();
  } catch {
    return String(t);
  }
}
function Rre(t, e) {
  return [...t].sort((n, r) => (r.requestCount ?? 0) - (n.requestCount ?? 0)).slice(0, e);
}
function Dre({canView:t}) {
  const [e, n] = (0,require$react.useState)("daily"), [r, i] = (0,require$react.useState)(!0), [s, o] = (0,require$react.useState)(null), [a, l] = (0,require$react.useState)(""), [c, u] = (0,require$react.useState)(null), [h, f] = (0,require$react.useState)(null), [p, g] = (0,require$react.useState)([]), [m, b] = (0,require$react.useState)(""), x = (0,require$react.useMemo)(() => {
    const _ = m.trim().toLowerCase();
    return _ ? p.filter(N => (N.model ?? "").toLowerCase().includes(_)) : p;
  }, [p, m]), w = (0,require$react.useCallback)(async() => {
    if (!t) {
      i(!1);
      return;
    }
    i(!0), l(""), o(null);
    try {
      const [_, N, E] = await Promise.all([sN(e), aN(e).catch(() => null), oN({limit:200}).catch(() => ({entries:[]}))]);
      u(_), f(N), g(E.entries ?? []), o({tone:"success", text:`Loaded Proxx observability (${e}).`});
    } catch (_) {
      l(_ instanceof Error ? _.message : String(_)), u(null), f(null), g([]);
    } finally {
      i(!1);
    }
  }, [t, e]);
  (0,require$react.useEffect)(() => {
    w();
  }, [w]);
  const v = c == null ? void 0 : c.summary, T = v == null ? void 0 : v.routingRequests24h, I = (0,require$react.useMemo)(() => h ? Rre(h.providerModels ?? [], 20) : [], [h]);
  return (0,require$react_SLASH_jsx_runtime.jsxs)(bo, {title:"Proxx observability", description:"Usage analytics + recent request logs for the Proxx instance Knoxx is configured to use.", actions:(0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"flex flex-col gap-2 md:flex-row md:items-center", children:[(0,require$react_SLASH_jsx_runtime.jsxs)("select", {value:e, onChange:_ => n(_.target.value), disabled:!t || r, className:"rounded-lg border border-slate-800 bg-slate-950/70 px-3 py-2 text-sm text-slate-100 disabled:opacity-60", 
  children:[(0,require$react_SLASH_jsx_runtime.jsx)("option", {value:"daily", children:"Daily (24h)"}), (0,require$react_SLASH_jsx_runtime.jsx)("option", {value:"weekly", children:"Weekly (7d)"}), (0,require$react_SLASH_jsx_runtime.jsx)("option", {value:"monthly", children:"Monthly (30d)"})]}), (0,require$react_SLASH_jsx_runtime.jsx)("button", {type:"button", onClick:() => void w(), disabled:!t || r, className:"inline-flex items-center justify-center rounded-lg border border-slate-700 bg-slate-900 px-4 py-2 text-sm font-medium text-slate-100 hover:bg-slate-800 disabled:opacity-60", 
  children:r ? "Loading\u2026" : "Refresh"})]}), children:[t ? null : (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"rounded-lg border border-amber-500/30 bg-amber-500/10 px-3 py-2 text-sm text-amber-200", children:["You do not have ", (0,require$react_SLASH_jsx_runtime.jsx)("code", {className:"font-mono", children:"org.proxx.observability.read"}), " permission."]}), s ? (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:s.tone === "success" ? "mb-4 rounded-lg border border-emerald-500/30 bg-emerald-500/10 px-3 py-2 text-sm text-emerald-200" : 
  "mb-4 rounded-lg border border-rose-500/30 bg-rose-500/10 px-3 py-2 text-sm text-rose-200", children:s.text}) : null, a ? (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"mb-4 rounded-lg border border-rose-500/30 bg-rose-500/10 px-3 py-2 text-sm text-rose-200", children:a}) : null, t ? (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"space-y-6", children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"grid gap-3 md:grid-cols-3", children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", 
  {className:"rounded-xl border border-slate-800 bg-slate-950/40 p-4", children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"text-xs font-semibold uppercase tracking-wide text-slate-500", children:"Requests (24h)"}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"mt-2 text-2xl font-semibold text-slate-100", children:ji(v == null ? void 0 : v.requests24h)}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"mt-1 text-xs text-slate-500", children:["Errors: ", N0(v == 
  null ? void 0 : v.errorRate24h)]})]}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"rounded-xl border border-slate-800 bg-slate-950/40 p-4", children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"text-xs font-semibold uppercase tracking-wide text-slate-500", children:"Tokens (24h)"}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"mt-2 text-2xl font-semibold text-slate-100", children:ji(v == null ? void 0 : v.tokens24h)}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", 
  {className:"mt-1 text-xs text-slate-500", children:["Cache hit rate: ", N0(v == null ? void 0 : v.cacheHitRate24h)]})]}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"rounded-xl border border-slate-800 bg-slate-950/40 p-4", children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"text-xs font-semibold uppercase tracking-wide text-slate-500", children:"Cost (24h)"}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"mt-2 text-2xl font-semibold text-slate-100", 
  children:A0(v == null ? void 0 : v.costUsd24h)}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"mt-1 text-xs text-slate-500", children:["Active accounts: ", ji(v == null ? void 0 : v.activeAccounts)]})]})]}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"grid gap-3 md:grid-cols-2", children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"rounded-xl border border-slate-800 bg-slate-950/40 p-4", children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"text-xs font-semibold uppercase tracking-wide text-slate-500", 
  children:"Top model"}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"mt-2 text-lg font-semibold text-slate-100", children:(v == null ? void 0 : v.topModel) ?? "(none)"}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"mt-1 text-xs text-slate-500", children:["Top provider: ", (v == null ? void 0 : v.topProvider) ?? "(none)"]})]}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"rounded-xl border border-slate-800 bg-slate-950/40 p-4", children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", 
  {className:"text-xs font-semibold uppercase tracking-wide text-slate-500", children:"Routing (24h)"}), T ? (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"mt-2 space-y-1 text-sm text-slate-200", children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {children:["Local: ", ji(T.local), " \u00b7 Federated: ", ji(T.federated), " \u00b7 Bridge: ", ji(T.bridge)]}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"text-xs text-slate-500", children:["Peers: ", ji(T.distinctPeers), 
  " \u00b7 Top peer: ", T.topPeer ?? "(none)"]})]}) : (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"mt-2 text-sm text-slate-500", children:"No routing data."})]})]}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"space-y-2", children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"flex flex-col gap-2 md:flex-row md:items-center md:justify-between", children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", 
  {className:"text-sm font-semibold text-slate-100", children:"Recent request logs"}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"text-xs text-slate-500", children:"Showing up to 200 newest entries (filters are applied client-side for model)."})]}), (0,require$react_SLASH_jsx_runtime.jsxs)("label", {className:"flex items-center gap-2 text-sm text-slate-200", children:[(0,require$react_SLASH_jsx_runtime.jsx)("span", {className:"text-xs text-slate-500", children:"Model filter"}), (0,require$react_SLASH_jsx_runtime.jsx)("input", 
  {value:m, onChange:_ => b(_.target.value), className:"w-60 rounded-lg border border-slate-800 bg-slate-950/70 px-3 py-2 text-sm text-slate-100 outline-none focus:border-sky-500", placeholder:"e.g. gemma4"})]})]}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"overflow-auto rounded-xl border border-slate-800", children:(0,require$react_SLASH_jsx_runtime.jsxs)("table", {className:"min-w-full divide-y divide-slate-800 text-sm", children:[(0,require$react_SLASH_jsx_runtime.jsx)("thead", 
  {className:"bg-slate-950/70 text-xs uppercase tracking-wide text-slate-400", children:(0,require$react_SLASH_jsx_runtime.jsxs)("tr", {children:[(0,require$react_SLASH_jsx_runtime.jsx)("th", {className:"px-3 py-2 text-left", children:"Time"}), (0,require$react_SLASH_jsx_runtime.jsx)("th", {className:"px-3 py-2 text-left", children:"Status"}), (0,require$react_SLASH_jsx_runtime.jsx)("th", {className:"px-3 py-2 text-left", children:"Model"}), (0,require$react_SLASH_jsx_runtime.jsx)("th", {className:"px-3 py-2 text-left", 
  children:"Provider"}), (0,require$react_SLASH_jsx_runtime.jsx)("th", {className:"px-3 py-2 text-right", children:"Latency"}), (0,require$react_SLASH_jsx_runtime.jsx)("th", {className:"px-3 py-2 text-right", children:"Tokens"}), (0,require$react_SLASH_jsx_runtime.jsx)("th", {className:"px-3 py-2 text-right", children:"Cost"}), (0,require$react_SLASH_jsx_runtime.jsx)("th", {className:"px-3 py-2 text-left", children:"Error"})]})}), (0,require$react_SLASH_jsx_runtime.jsx)("tbody", {className:"divide-y divide-slate-800 bg-slate-950/40", 
  children:x.length === 0 ? (0,require$react_SLASH_jsx_runtime.jsx)("tr", {children:(0,require$react_SLASH_jsx_runtime.jsx)("td", {className:"px-3 py-3 text-slate-500", colSpan:8, children:"No request logs."})}) : x.map(_ => (0,require$react_SLASH_jsx_runtime.jsxs)("tr", {className:"hover:bg-slate-900/40", children:[(0,require$react_SLASH_jsx_runtime.jsx)("td", {className:"whitespace-nowrap px-3 py-2 text-slate-200", children:Pre(_.timestamp)}), (0,require$react_SLASH_jsx_runtime.jsx)("td", {className:"whitespace-nowrap px-3 py-2", 
  children:Ore(_.status)}), (0,require$react_SLASH_jsx_runtime.jsx)("td", {className:"max-w-[22rem] truncate px-3 py-2 font-mono text-xs text-slate-200", title:_.model, children:_.model}), (0,require$react_SLASH_jsx_runtime.jsxs)("td", {className:"px-3 py-2 text-xs text-slate-200", children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"font-mono", children:_.providerId}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"font-mono text-slate-500", children:_.accountId})]}), 
  (0,require$react_SLASH_jsx_runtime.jsxs)("td", {className:"whitespace-nowrap px-3 py-2 text-right text-slate-200", children:[ji(_.latencyMs), " ms"]}), (0,require$react_SLASH_jsx_runtime.jsx)("td", {className:"whitespace-nowrap px-3 py-2 text-right text-slate-200", children:ji(_.totalTokens ?? 0)}), (0,require$react_SLASH_jsx_runtime.jsx)("td", {className:"whitespace-nowrap px-3 py-2 text-right text-slate-200", children:A0(_.costUsd ?? 0)}), (0,require$react_SLASH_jsx_runtime.jsx)("td", {className:"max-w-[24rem] px-3 py-2 text-xs text-slate-300", 
  children:_.error || _.upstreamErrorMessage || _.upstreamErrorCode ? (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:Gg("truncate", _.status >= 400 ? "text-rose-200" : "text-slate-300"), children:_.error || _.upstreamErrorMessage || _.upstreamErrorCode}) : (0,require$react_SLASH_jsx_runtime.jsx)("span", {className:"text-slate-600", children:"\u2014"})})]}, _.id))})]})})]}), I.length > 0 ? (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"space-y-2", children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", 
  {children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"text-sm font-semibold text-slate-100", children:"Top provider/model pairs"}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"text-xs text-slate-500", children:"From Proxx analytics (top 20 by request count)."})]}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"overflow-auto rounded-xl border border-slate-800", children:(0,require$react_SLASH_jsx_runtime.jsxs)("table", {className:"min-w-full divide-y divide-slate-800 text-sm", 
  children:[(0,require$react_SLASH_jsx_runtime.jsx)("thead", {className:"bg-slate-950/70 text-xs uppercase tracking-wide text-slate-400", children:(0,require$react_SLASH_jsx_runtime.jsxs)("tr", {children:[(0,require$react_SLASH_jsx_runtime.jsx)("th", {className:"px-3 py-2 text-left", children:"Provider"}), (0,require$react_SLASH_jsx_runtime.jsx)("th", {className:"px-3 py-2 text-left", children:"Model"}), (0,require$react_SLASH_jsx_runtime.jsx)("th", {className:"px-3 py-2 text-right", children:"Requests"}), 
  (0,require$react_SLASH_jsx_runtime.jsx)("th", {className:"px-3 py-2 text-right", children:"Error rate"}), (0,require$react_SLASH_jsx_runtime.jsx)("th", {className:"px-3 py-2 text-right", children:"Tokens"}), (0,require$react_SLASH_jsx_runtime.jsx)("th", {className:"px-3 py-2 text-right", children:"Cost"})]})}), (0,require$react_SLASH_jsx_runtime.jsx)("tbody", {className:"divide-y divide-slate-800 bg-slate-950/40", children:I.map(_ => (0,require$react_SLASH_jsx_runtime.jsxs)("tr", {className:"hover:bg-slate-900/40", 
  children:[(0,require$react_SLASH_jsx_runtime.jsx)("td", {className:"px-3 py-2 font-mono text-xs text-slate-200", children:_.providerId ?? "\u2014"}), (0,require$react_SLASH_jsx_runtime.jsx)("td", {className:"px-3 py-2 font-mono text-xs text-slate-200", children:_.model ?? "\u2014"}), (0,require$react_SLASH_jsx_runtime.jsx)("td", {className:"px-3 py-2 text-right text-slate-200", children:ji(_.requestCount)}), (0,require$react_SLASH_jsx_runtime.jsx)("td", {className:"px-3 py-2 text-right text-slate-200", 
  children:N0(_.errorRate)}), (0,require$react_SLASH_jsx_runtime.jsx)("td", {className:"px-3 py-2 text-right text-slate-200", children:ji(_.totalTokens)}), (0,require$react_SLASH_jsx_runtime.jsx)("td", {className:"px-3 py-2 text-right text-slate-200", children:A0(_.costUsd)})]}, `${_.providerId ?? ""}:${_.model ?? ""}`))})]})})]}) : null]}) : null]});
}
function Lre({permissionGroups:t, tools:e}) {
  return (0,require$react_SLASH_jsx_runtime.jsx)(bo, {title:"Permission and tool catalog", description:"Use this as the live reference when composing custom roles or membership overrides.", children:(0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"grid gap-4 xl:grid-cols-[1.2fr_0.8fr]", children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"rounded-xl border border-slate-800 bg-slate-900/80 p-4", children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"mb-3 text-sm font-semibold text-slate-100", 
  children:"Permission atoms"}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"max-h-[28rem] space-y-4 overflow-auto pr-1", children:t.map(([n, r]) => (0,require$react_SLASH_jsx_runtime.jsxs)("div", {children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"mb-2 text-xs font-semibold uppercase tracking-wide text-slate-400", children:n}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"space-y-2", children:r.map(i => (0,require$react_SLASH_jsx_runtime.jsxs)("div", 
  {className:"rounded-lg border border-slate-800 bg-slate-950/70 p-3", children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"text-sm font-medium text-slate-100", children:i.code}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"mt-1 text-xs text-slate-500", children:i.description})]}, `catalog-${i.id}`))})]}, `catalog-${n}`))})]}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"rounded-xl border border-slate-800 bg-slate-900/80 p-4", children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", 
  {className:"mb-3 text-sm font-semibold text-slate-100", children:"Tool definitions"}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"space-y-3", children:e.map(n => (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"rounded-lg border border-slate-800 bg-slate-950/70 p-3", children:(0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"flex items-start justify-between gap-3", children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", 
  {className:"text-sm font-medium text-slate-100", children:n.label}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"mt-1 text-[11px] font-mono text-slate-500", children:n.id}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"mt-1 text-xs text-slate-500", children:n.description})]}), (0,require$react_SLASH_jsx_runtime.jsx)(In, {tone:n.riskLevel === "high" ? "danger" : n.riskLevel === "medium" ? "warn" : "success", children:n.riskLevel})]})}, `tool-${n.id}`))})]})]})});
}
const Mre = ["platform_owner", "customer", "internal", "partner"], Bre = ["workspace_docs", "analytics", "notes", "uploads"], $re = [{label:"Overview", path:"overview", icon:"\u25c8"}, {label:"Orgs", path:"orgs", icon:"\u25c9"}, {label:"Actors", path:"actors", icon:"\u25c8"}, {label:"Roles", path:"roles", icon:"\u25ce"}, {label:"Lakes", path:"lakes", icon:"\u25a3"}, {label:"Integrations", path:"integrations", icon:"\u26a1"}, {label:"Catalog", path:"catalog", icon:"\u2630"}];
function Fre() {
  const [t, e] = (0,require$react.useState)(() => TA()), [n, r] = (0,require$react.useState)(null), [i, s] = (0,require$react.useState)(null), [o, a] = (0,require$react.useState)([]), [l, c] = (0,require$react.useState)([]), [u, h] = (0,require$react.useState)([]), [f, p] = (0,require$react.useState)(""), [g, m] = (0,require$react.useState)([]), [b, x] = (0,require$react.useState)([]), [w, v] = (0,require$react.useState)([]), [T, I] = (0,require$react.useState)(!0), [_, N] = (0,require$react.useState)(0), 
  [E, C] = (0,require$react.useState)(null), [k, A] = (0,require$react.useState)(""), [P, W] = (0,require$react.useState)(!1), [F, B] = (0,require$react.useState)(!1), [z, j] = (0,require$react.useState)(!1), [V, ne] = (0,require$react.useState)(!1), [D, ie] = (0,require$react.useState)(null), [ee, M] = (0,require$react.useState)(null), [X, ge] = (0,require$react.useState)({name:"", slug:"", kind:"customer"}), [me, te] = (0,require$react.useState)({actorId:"", email:"", displayName:"", roleSlugs:["basic-user"]}), 
  [q, R] = (0,require$react.useState)({name:"", slug:"", permissionCodes:[], toolIds:["read", "canvas"]}), [$, G] = (0,require$react.useState)({name:"", slug:"", kind:"workspace_docs", workspaceRoot:""}), [J, U] = (0,require$react.useState)({}), [le, be] = (0,require$react.useState)({}), [je, Ae] = (0,require$react.useState)({}), ue = (0,require$react.useMemo)(() => eP(o), [o]), Le = (0,require$react.useMemo)(() => u.find(Me => Me.id === f) ?? (n ? {id:n.org.id, slug:n.org.slug, name:n.org.name, 
  kind:n.org.kind || "customer", isPrimary:!!n.org.isPrimary, status:n.org.status} : null), [n, u, f]), $e = (0,require$react.useCallback)(Me => !!(n != null && n.isSystemAdmin || n != null && n.permissions.includes(Me)), [n]), Ye = (0,require$react.useCallback)(async() => {
    I(!0), A(""), C(null);
    try {
      const Me = await PA();
      r(Me), e({userEmail:Me.user.email, orgSlug:Me.org.slug});
      const [Xe, it, se, oe] = await Promise.allSettled([$A(), FA(), BA(), zA()]);
      a(Xe.status === "fulfilled" ? Xe.value.permissions : []), c(it.status === "fulfilled" ? it.value.tools : []), s(se.status === "fulfilled" ? se.value : null);
      const we = oe.status === "fulfilled" && oe.value.orgs.length > 0 ? oe.value.orgs : [{id:Me.org.id, slug:Me.org.slug, name:Me.org.name, kind:Me.org.kind || "customer", isPrimary:!!(n != null && n.org.isPrimary), status:Me.org.status}];
      h(we), p(ke => {
        var fe, Oe;
        return ke && we.some(We => We.id === ke) ? ke : ((fe = we.find(We => We.id === Me.org.id)) == null ? void 0 : fe.id) || ((Oe = we[0]) == null ? void 0 : Oe.id) || "";
      });
    } catch (Me) {
      A(Ki(Me)), r(null), a([]), c([]), s(null), h([]), p("");
    } finally {
      I(!1), N(Me => Me + 1);
    }
  }, []);
  return (0,require$react.useEffect)(() => {
    if (!f) {
      return;
    }
    let Me = !1;
    return (async() => {
      try {
        const [Xe, it, se] = await Promise.allSettled([Promise.resolve().then(() => Qi).then(oe => oe.listOrgRoles(f)).catch(() => ({roles:[]})), Promise.resolve().then(() => Qi).then(oe => oe.listOrgActors(f)).catch(() => ({users:[]})), Promise.resolve().then(() => Qi).then(oe => oe.listOrgDataLakes(f)).catch(() => ({dataLakes:[]}))]);
        if (Me) {
          return;
        }
        if (Xe.status === "fulfilled" && (m(Xe.value.roles), Ae(tP(Xe.value.roles))), it.status === "fulfilled") {
          x(it.value.users);
          const oe = nP(it.value.users, f);
          U(oe.roleDrafts), be(oe.toolDrafts);
        }
        se.status === "fulfilled" && v(se.value.dataLakes);
      } catch {
      }
    })(), () => {
      Me = !0;
    };
  }, [f, _]), (0,require$react.useEffect)(() => {
    Ye();
  }, [Ye]), (0,require$react.useEffect)(() => {
    Le && G(Me => ({...Me, workspaceRoot:Me.workspaceRoot || `orgs/${Le.slug}`}));
  }, [Le]), {identityForm:t, setIdentityForm:e, context:n, bootstrap:i, permissions:o, tools:l, orgs:u, selectedOrgId:f, setSelectedOrgId:p, selectedOrg:Le, roles:g, users:b, dataLakes:w, permissionGroups:ue, membershipRoleDrafts:J, setMembershipRoleDrafts:U, membershipToolDrafts:le, setMembershipToolDrafts:be, roleToolDrafts:je, setRoleToolDrafts:Ae, loading:T, notice:E, setNotice:C, error:k, setError:A, refresh:Ye, hasPermission:$e, orgForm:X, setOrgForm:ge, userForm:me, setUserForm:te, roleForm:q, 
  setRoleForm:R, lakeForm:$, setLakeForm:G, creatingOrg:P, setCreatingOrg:W, creatingUser:F, setCreatingUser:B, creatingRole:z, setCreatingRole:j, creatingLake:V, setCreatingLake:ne, savingMembershipId:D, setSavingMembershipId:ie, savingRoleId:ee, setSavingRoleId:M};
}
function M2({ctx:t}) {
  const e = async n => {
    n.preventDefault();
    const r = CA(t.identityForm);
    t.setIdentityForm(r), t.setNotice({tone:"success", text:`Switched to ${r.userEmail} in ${r.orgSlug}.`}), await t.refresh();
  };
  return (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"space-y-4", children:(0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"grid gap-4 lg:grid-cols-2", children:[(0,require$react_SLASH_jsx_runtime.jsx)(mre, {identityForm:t.identityForm, setIdentityForm:t.setIdentityForm, context:t.context, onApplyIdentity:e}), (0,require$react_SLASH_jsx_runtime.jsx)(bre, {orgs:t.orgs, toolsCount:t.tools.length, permissionsCount:t.permissions.length, bootstrap:t.bootstrap})]})});
}
function zre({ctx:t}) {
  const e = async n => {
    if (n.preventDefault(), !!t.hasPermission("platform.org.create")) {
      t.setCreatingOrg(!0), t.setNotice(null);
      try {
        const r = await HA({name:t.orgForm.name.trim(), slug:t.orgForm.slug.trim() || void 0, kind:t.orgForm.kind});
        t.setOrgForm({name:"", slug:"", kind:"customer"}), t.setNotice({tone:"success", text:`Created ${r.org.name}.`}), await t.refresh(), t.setSelectedOrgId(r.org.id);
      } catch (r) {
        t.setNotice({tone:"error", text:Ki(r)});
      } finally {
        t.setCreatingOrg(!1);
      }
    }
  };
  return (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"grid gap-4 lg:grid-cols-[1fr_1fr]", children:[(0,require$react_SLASH_jsx_runtime.jsx)(yre, {context:t.context, orgs:t.orgs, selectedOrgId:t.selectedOrgId, setSelectedOrgId:t.setSelectedOrgId, canCreateOrgs:t.hasPermission("platform.org.create"), orgForm:t.orgForm, setOrgForm:t.setOrgForm, creatingOrg:t.creatingOrg, onCreateOrg:e, orgKindOptions:Mre}), (0,require$react_SLASH_jsx_runtime.jsx)(xre, {selectedOrg:t.selectedOrg, context:t.context})]});
}
function Hre({ctx:t}) {
  var o;
  const e = async a => {
    if (a.preventDefault(), !!t.selectedOrgId) {
      t.setCreatingUser(!0), t.setNotice(null);
      try {
        const l = t.userForm.actorId.trim(), c = t.userForm.email.trim();
        await (await Promise.resolve().then(() => Qi)).createOrgActor(t.selectedOrgId, {actorId:l || void 0, email:c || void 0, displayName:t.userForm.displayName.trim() || l || c, roleSlugs:t.userForm.roleSlugs.length > 0 ? t.userForm.roleSlugs : ["basic-user"]}), t.setUserForm({actorId:"", email:"", displayName:"", roleSlugs:["basic-user"]}), t.setNotice({tone:"success", text:"Actor created."}), await t.refresh();
      } catch (l) {
        t.setNotice({tone:"error", text:Ki(l)});
      } finally {
        t.setCreatingUser(!1);
      }
    }
  }, n = async(a, l) => {
    t.setNotice(null);
    try {
      await (await Promise.resolve().then(() => Qi)).updateAdminActor(a, {orgId:t.selectedOrgId, actorId:l.actorId.trim(), displayName:l.displayName.trim(), email:l.email.trim(), status:l.status}), t.setNotice({tone:"success", text:"Actor profile updated."}), await t.refresh();
    } catch (c) {
      t.setNotice({tone:"error", text:Ki(c)});
    }
  }, r = async(a, l, c) => {
    t.setNotice(null);
    try {
      await (await Promise.resolve().then(() => Qi)).upsertAdminActorCredential(a, l, {orgId:t.selectedOrgId, kind:c.kind, accountIdentifier:c.accountIdentifier.trim() || void 0, secretJson:c.secretJson}), t.setNotice({tone:"success", text:"Actor credential saved."}), await t.refresh();
    } catch (u) {
      t.setNotice({tone:"error", text:Ki(u)});
    }
  }, i = async a => {
    t.setSavingMembershipId(a), t.setNotice(null);
    try {
      await (await Promise.resolve().then(() => Qi)).updateMembershipRoles(a, t.membershipRoleDrafts[a] || []), t.setNotice({tone:"success", text:"Roles updated."}), await t.refresh();
    } catch (l) {
      t.setNotice({tone:"error", text:Ki(l)});
    } finally {
      t.setSavingMembershipId(null);
    }
  }, s = async a => {
    t.setSavingMembershipId(a), t.setNotice(null);
    try {
      await (await Promise.resolve().then(() => Qi)).updateMembershipToolPolicies(a, (await Promise.resolve().then(() => rP)).toolPoliciesFromDraft(t.membershipToolDrafts[a] || {})), t.setNotice({tone:"success", text:"Policies updated."}), await t.refresh();
    } catch (l) {
      t.setNotice({tone:"error", text:Ki(l)});
    } finally {
      t.setSavingMembershipId(null);
    }
  };
  return (0,require$react_SLASH_jsx_runtime.jsx)(_re, {selectedOrgId:t.selectedOrgId, selectedOrgName:((o = t.selectedOrg) == null ? void 0 : o.name) || "", canCreateUsers:!!(t.selectedOrg && t.hasPermission("org.users.create")), canUpdateMemberships:t.hasPermission("org.members.update"), canUpdateUserPolicies:t.hasPermission("org.user_policy.update"), users:t.users, roles:t.roles, tools:t.tools, userForm:t.userForm, setUserForm:t.setUserForm, membershipRoleDrafts:t.membershipRoleDrafts, setMembershipRoleDrafts:t.setMembershipRoleDrafts, 
  membershipToolDrafts:t.membershipToolDrafts, setMembershipToolDrafts:t.setMembershipToolDrafts, creatingUser:t.creatingUser, savingMembershipId:t.savingMembershipId, onCreateUser:e, onSaveActorProfile:n, onSaveActorCredential:r, onSaveMembershipRoles:i, onSaveMembershipPolicies:s});
}
function Ure({ctx:t}) {
  var r;
  const e = async i => {
    if (i.preventDefault(), !!t.selectedOrgId) {
      t.setCreatingRole(!0), t.setNotice(null);
      try {
        await (await Promise.resolve().then(() => Qi)).createOrgRole(t.selectedOrgId, {name:t.roleForm.name.trim(), slug:t.roleForm.slug.trim() || void 0, permissionCodes:t.roleForm.permissionCodes, toolPolicies:t.roleForm.toolIds.map(s => ({toolId:s, effect:"allow"}))}), t.setRoleForm({name:"", slug:"", permissionCodes:[], toolIds:["read", "canvas"]}), t.setNotice({tone:"success", text:"Role created."}), await t.refresh();
      } catch (s) {
        t.setNotice({tone:"error", text:Ki(s)});
      } finally {
        t.setCreatingRole(!1);
      }
    }
  }, n = async i => {
    t.setSavingRoleId(i), t.setNotice(null);
    try {
      await (await Promise.resolve().then(() => Qi)).updateRoleToolPolicies(i, (await Promise.resolve().then(() => rP)).toolPoliciesFromDraft(t.roleToolDrafts[i] || {})), t.setNotice({tone:"success", text:"Policy updated."}), await t.refresh();
    } catch (s) {
      t.setNotice({tone:"error", text:Ki(s)});
    } finally {
      t.setSavingRoleId(null);
    }
  };
  return (0,require$react_SLASH_jsx_runtime.jsx)(Sre, {selectedOrgId:t.selectedOrgId, selectedOrgName:((r = t.selectedOrg) == null ? void 0 : r.name) || "", canCreateRoles:!!(t.selectedOrg && t.hasPermission("org.roles.create")), canUpdateRolePolicies:t.hasPermission("org.tool_policy.update"), roles:t.roles, tools:t.tools, permissionGroups:t.permissionGroups, roleForm:t.roleForm, setRoleForm:t.setRoleForm, roleToolDrafts:t.roleToolDrafts, setRoleToolDrafts:t.setRoleToolDrafts, creatingRole:t.creatingRole, 
  savingRoleId:t.savingRoleId, onCreateRole:e, onSaveRolePolicies:n});
}
function Wre({ctx:t}) {
  var n;
  const e = async r => {
    if (r.preventDefault(), !!t.selectedOrgId) {
      t.setCreatingLake(!0), t.setNotice(null);
      try {
        await (await Promise.resolve().then(() => Qi)).createOrgDataLake(t.selectedOrgId, {name:t.lakeForm.name.trim(), slug:t.lakeForm.slug.trim() || void 0, kind:t.lakeForm.kind, config:t.lakeForm.workspaceRoot.trim() ? {workspaceRoot:t.lakeForm.workspaceRoot.trim()} : {}}), t.setLakeForm({name:"", slug:"", kind:"workspace_docs", workspaceRoot:t.selectedOrg ? `orgs/${t.selectedOrg.slug}` : ""}), t.setNotice({tone:"success", text:"Lake created."}), await t.refresh();
      } catch (i) {
        t.setNotice({tone:"error", text:Ki(i)});
      } finally {
        t.setCreatingLake(!1);
      }
    }
  };
  return (0,require$react_SLASH_jsx_runtime.jsx)(Nre, {selectedOrgName:((n = t.selectedOrg) == null ? void 0 : n.name) || "", canCreateDataLakes:!!(t.selectedOrg && t.hasPermission("org.datalakes.create")), lakeForm:t.lakeForm, setLakeForm:t.setLakeForm, creatingLake:t.creatingLake, dataLakes:t.dataLakes, dataLakeKindOptions:Bre, onCreateLake:e});
}
function jre({ctx:t}) {
  return (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"space-y-4", children:(0,require$react_SLASH_jsx_runtime.jsx)(Dre, {canView:t.hasPermission("org.proxx.observability.read")})});
}
function Vre({ctx:t}) {
  return (0,require$react_SLASH_jsx_runtime.jsx)(Lre, {permissionGroups:t.permissionGroups, tools:t.tools});
}
function qre() {
  var n;
  const t = Fre();
  if ((0,require$react_router_dom.useLocation)(), t.loading) {
    return (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"p-6 text-sm text-slate-400", children:"Loading admin\u2026"});
  }
  const e = !!((n = t.context) != null && n.isSystemAdmin || t.hasPermission("org.users.read") || t.hasPermission("org.roles.read"));
  return (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"admin-layout flex flex-1 flex-col overflow-hidden", children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"shrink-0 border-b border-slate-700/50 bg-slate-900/80 px-4 py-2", children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"flex items-center justify-between", children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"flex items-center gap-3", children:[(0,require$react_SLASH_jsx_runtime.jsx)("h1", 
  {className:"text-base font-bold text-slate-100", children:"Admin"}), t.context ? (0,require$react_SLASH_jsx_runtime.jsxs)("span", {className:"text-xs text-slate-400", children:[(0,require$react_SLASH_jsx_runtime.jsx)(In, {children:t.context.org.name}), " \u00b7 ", t.context.user.email]}) : null]}), (0,require$react_SLASH_jsx_runtime.jsx)("button", {onClick:() => void t.refresh(), className:"rounded-md border border-slate-700 bg-slate-800 px-3 py-1 text-xs text-slate-300 hover:bg-slate-700 transition", 
  children:"Refresh"})]}), (0,require$react_SLASH_jsx_runtime.jsx)("nav", {className:"mt-2 flex gap-1 overflow-x-auto", children:$re.map(r => (0,require$react_SLASH_jsx_runtime.jsxs)(require$react_router_dom.NavLink, {to:r.path, end:r.path === "overview", className:({isActive:i}) => `shrink-0 rounded-md px-3 py-1.5 text-xs font-medium transition ${i ? "bg-blue-500/15 text-blue-300" : "text-slate-400 hover:bg-slate-800 hover:text-slate-200"}`, children:[(0,require$react_SLASH_jsx_runtime.jsx)("span", 
  {className:"mr-1", children:r.icon}), r.label]}, r.path))})]}), t.notice || t.error ? (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"shrink-0 px-4 py-2", children:[t.notice ? (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:`rounded-lg px-3 py-2 text-xs ${t.notice.tone === "success" ? "bg-emerald-500/10 text-emerald-300 border border-emerald-500/20" : "bg-rose-500/10 text-rose-300 border border-rose-500/20"}`, children:t.notice.text}) : null, t.error ? (0,require$react_SLASH_jsx_runtime.jsx)("div", 
  {className:"rounded-lg bg-rose-500/10 px-3 py-2 text-xs text-rose-300 border border-rose-500/20", children:t.error}) : null]}) : null, (0,require$react_SLASH_jsx_runtime.jsx)("main", {className:"flex-1 overflow-y-auto p-4", children:e ? (0,require$react_SLASH_jsx_runtime.jsxs)(require$react_router_dom.Routes, {children:[(0,require$react_SLASH_jsx_runtime.jsx)(require$react_router_dom.Route, {index:!0, element:(0,require$react_SLASH_jsx_runtime.jsx)(M2, {ctx:t})}), (0,require$react_SLASH_jsx_runtime.jsx)(require$react_router_dom.Route, 
  {path:"overview", element:(0,require$react_SLASH_jsx_runtime.jsx)(M2, {ctx:t})}), (0,require$react_SLASH_jsx_runtime.jsx)(require$react_router_dom.Route, {path:"orgs", element:(0,require$react_SLASH_jsx_runtime.jsx)(zre, {ctx:t})}), (0,require$react_SLASH_jsx_runtime.jsx)(require$react_router_dom.Route, {path:"actors", element:(0,require$react_SLASH_jsx_runtime.jsx)(Hre, {ctx:t})}), (0,require$react_SLASH_jsx_runtime.jsx)(require$react_router_dom.Route, {path:"users", element:(0,require$react_SLASH_jsx_runtime.jsx)(require$react_router_dom.Navigate, 
  {to:"../actors", replace:!0})}), (0,require$react_SLASH_jsx_runtime.jsx)(require$react_router_dom.Route, {path:"roles", element:(0,require$react_SLASH_jsx_runtime.jsx)(Ure, {ctx:t})}), (0,require$react_SLASH_jsx_runtime.jsx)(require$react_router_dom.Route, {path:"lakes", element:(0,require$react_SLASH_jsx_runtime.jsx)(Wre, {ctx:t})}), (0,require$react_SLASH_jsx_runtime.jsx)(require$react_router_dom.Route, {path:"integrations", element:(0,require$react_SLASH_jsx_runtime.jsx)(jre, {ctx:t})}), (0,require$react_SLASH_jsx_runtime.jsx)(require$react_router_dom.Route, 
  {path:"catalog", element:(0,require$react_SLASH_jsx_runtime.jsx)(Vre, {ctx:t})}), (0,require$react_SLASH_jsx_runtime.jsx)(require$react_router_dom.Route, {path:"*", element:(0,require$react_SLASH_jsx_runtime.jsx)(require$react_router_dom.Navigate, {to:ro.admin, replace:!0})})]}) : (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"rounded-xl border border-dashed border-slate-700 p-8 text-center text-sm text-slate-500", children:"Admin access required. Switch actor in Overview."})})]});
}
function I0(t, e, n) {
  if (t.length === 0) {
    return "";
  }
  const r = Math.max(1, ...t), i = Math.min(0, ...t), s = Math.max(1, r - i);
  return t.map((o, a) => {
    const l = a / Math.max(1, t.length - 1) * e, c = n - (o - i) / s * n;
    return `${a === 0 ? "M" : "L"} ${l.toFixed(1)} ${c.toFixed(1)}`;
  }).join(" ");
}
function Yre() {
  const [t, e] = (0,require$react.useState)([]), [n, r] = (0,require$react.useState)(null);
  (0,require$react.useEffect)(() => (console.log("[SidebarOpsStatus] mount \u2014 creating WS"), xN({onStats:c => {
    var p;
    const u = c, h = Array.isArray(u.gpu) && u.gpu.length > 0 ? Number(((p = u.gpu[0]) == null ? void 0 : p.util_gpu) || 0) : 0, f = {t:Date.now(), cpu:Number(u.cpu_percent || 0), ram:Number(u.memory_percent || 0), gpu:h};
    e(g => [...g, f].slice(-50));
  }})), []), (0,require$react.useEffect)(() => {
    const l = async() => {
      try {
        const u = await D3();
        r(u);
      } catch {
        r(null);
      }
    };
    l();
    const c = window.setInterval(() => {
      l();
    }, 2500);
    return () => window.clearInterval(c);
  }, []);
  const i = t[t.length - 1], s = (0,require$react.useMemo)(() => I0(t.map(l => l.cpu), 220, 56), [t]), o = (0,require$react.useMemo)(() => I0(t.map(l => l.ram), 220, 56), [t]), a = (0,require$react.useMemo)(() => I0(t.map(l => l.gpu), 220, 56), [t]);
  return (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"border-t border-slate-200 dark:border-slate-700/60 p-3 space-y-3 overflow-y-auto", children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {children:[(0,require$react_SLASH_jsx_runtime.jsx)("p", {className:"text-[11px] uppercase tracking-wide text-slate-500 dark:text-slate-400", children:"System Usage"}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"mt-2 space-y-1 text-xs text-slate-300", children:[(0,require$react_SLASH_jsx_runtime.jsx)(O0, 
  {label:"CPU", value:`${((i == null ? void 0 : i.cpu) ?? 0).toFixed(1)}%`, color:"text-cyan-300"}), (0,require$react_SLASH_jsx_runtime.jsx)(O0, {label:"RAM", value:`${((i == null ? void 0 : i.ram) ?? 0).toFixed(1)}%`, color:"text-amber-300"}), (0,require$react_SLASH_jsx_runtime.jsx)(O0, {label:"GPU", value:`${((i == null ? void 0 : i.gpu) ?? 0).toFixed(1)}%`, color:"text-violet-300"})]}), (0,require$react_SLASH_jsx_runtime.jsxs)("svg", {viewBox:"0 0 220 56", className:"mt-2 h-16 w-full rounded bg-slate-900/70", 
  children:[(0,require$react_SLASH_jsx_runtime.jsx)("path", {d:s, fill:"none", stroke:"var(--token-colors-accent-blue)", strokeWidth:"2"}), (0,require$react_SLASH_jsx_runtime.jsx)("path", {d:o, fill:"none", stroke:"var(--token-colors-accent-orange)", strokeWidth:"1.8"}), (0,require$react_SLASH_jsx_runtime.jsx)("path", {d:a, fill:"none", stroke:"var(--token-colors-accent-magenta)", strokeWidth:"1.8"})]})]}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {children:[(0,require$react_SLASH_jsx_runtime.jsx)("p", 
  {className:"text-[11px] uppercase tracking-wide text-slate-500 dark:text-slate-400", children:"Ingestion"}), n != null && n.active && (n != null && n.progress) ? (0,require$react_SLASH_jsx_runtime.jsxs)(require$react_SLASH_jsx_runtime.Fragment, {children:[(0,require$react_SLASH_jsx_runtime.jsxs)("p", {className:"mt-1 text-xs text-slate-200", children:[n.progress.processedChunks, " / ", n.progress.totalChunks, " (", Number(n.progress.percentPrecise ?? n.progress.percent ?? 0).toFixed(2), "%)"]}), 
  (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"mt-1 h-1.5 w-full rounded bg-slate-800", children:(0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"h-1.5 rounded bg-cyan-400", style:{width:`${Math.max(0, Math.min(100, Number(n.progress.percentPrecise ?? n.progress.percent ?? 0)))}%`}})}), (0,require$react_SLASH_jsx_runtime.jsx)("p", {className:"mt-1 truncate text-[11px] text-slate-400", children:n.progress.currentFile || "Working..."})]}) : n != null && n.canResumeForum && (n != 
  null && n.progress) ? (0,require$react_SLASH_jsx_runtime.jsxs)("p", {className:"mt-1 text-xs text-amber-300", children:["Paused at ", Number(n.progress.percentPrecise ?? n.progress.percent ?? 0).toFixed(2), "% (resumable)"]}) : (0,require$react_SLASH_jsx_runtime.jsx)("p", {className:"mt-1 text-xs text-slate-400", children:"No active ingestion"})]})]});
}
function O0({label:t, value:e, color:n}) {
  return (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"flex items-center justify-between rounded border border-slate-800 bg-slate-900/60 px-2 py-1", children:[(0,require$react_SLASH_jsx_runtime.jsx)("span", {className:"text-slate-400", children:t}), (0,require$react_SLASH_jsx_runtime.jsx)("span", {className:n, children:e})]});
}
const Gre = [{label:"Lakes", path:ro.documents}, {label:"Agents", path:ro.agents}, {label:"Graph", path:ro.vectors}, {label:"Settings", path:ro.settings}, {label:"Admin", path:ro.admin}];
function Zhe() {
  return (0,require$react.useEffect)(() => {
    document.documentElement.classList.add("dark");
  }, []), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"ops-root flex flex-1 w-full flex-col bg-slate-50 dark:bg-slate-900 overflow-hidden text-slate-900 dark:text-slate-100 border border-slate-200 dark:border-slate-800 rounded-xl shadow-lg transition-colors duration-200", children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"flex flex-1 overflow-hidden", children:[(0,require$react_SLASH_jsx_runtime.jsxs)("aside", {className:"w-64 min-h-0 overflow-hidden flex flex-col bg-white dark:bg-slate-800 border-r border-slate-200 dark:border-slate-700 transition-colors duration-200 h-full", 
  children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"shrink-0 p-4 border-b border-slate-100 dark:border-slate-700/50 flex items-center justify-between", children:[(0,require$react_SLASH_jsx_runtime.jsx)("h2", {className:"text-xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-blue-600 to-indigo-600 dark:from-blue-400 dark:to-indigo-400", children:"Knoxx Ops"}), (0,require$react_SLASH_jsx_runtime.jsx)("button", {onClick:() => document.documentElement.classList.toggle("dark"), 
  className:"p-1.5 rounded-md hover:bg-slate-100 dark:hover:bg-slate-700 text-slate-500 dark:text-slate-400 transition-colors", title:"Toggle Dark Mode", children:(0,require$react_SLASH_jsx_runtime.jsx)("svg", {xmlns:"http://www.w3.org/2000/svg", width:"18", height:"18", viewBox:"0 0 24 24", fill:"none", stroke:"currentColor", strokeWidth:"2", strokeLinecap:"round", strokeLinejoin:"round", children:(0,require$react_SLASH_jsx_runtime.jsx)("path", {d:"M12 3a6 6 0 0 0 9 9 9 9 0 1 1-9-9Z"})})})]}), (0,require$react_SLASH_jsx_runtime.jsx)("nav", 
  {className:"flex-1 overflow-y-auto py-4 min-h-0", children:(0,require$react_SLASH_jsx_runtime.jsx)("ul", {className:"space-y-1 px-3", children:Gre.map(t => (0,require$react_SLASH_jsx_runtime.jsx)("li", {children:(0,require$react_SLASH_jsx_runtime.jsx)(require$react_router_dom.NavLink, {to:t.path, className:({isActive:e}) => `block px-3 py-2 rounded-md font-medium text-sm transition-colors ${e ? "bg-blue-50 text-blue-700 dark:bg-blue-500/10 dark:text-blue-400" : "text-slate-600 hover:bg-slate-50 hover:text-slate-900 dark:text-slate-400 dark:hover:bg-slate-700/50 dark:hover:text-slate-200"}`, 
  children:t.label})}, t.path))})}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"min-h-0 shrink-0 overflow-y-auto max-h-72", children:(0,require$react_SLASH_jsx_runtime.jsx)(Yre, {})})]}), (0,require$react_SLASH_jsx_runtime.jsx)("main", {className:"flex-1 flex flex-col min-w-0 bg-slate-50/50 dark:bg-slate-900/50 relative overflow-y-auto p-0 transition-colors duration-200", children:(0,require$react_SLASH_jsx_runtime.jsxs)(require$react_router_dom.Routes, {children:[(0,require$react_SLASH_jsx_runtime.jsx)(require$react_router_dom.Route, 
  {path:"/", element:(0,require$react_SLASH_jsx_runtime.jsx)(require$react_router_dom.Navigate, {to:"documents", replace:!0})}), (0,require$react_SLASH_jsx_runtime.jsx)(require$react_router_dom.Route, {path:"documents", element:(0,require$react_SLASH_jsx_runtime.jsx)(Fne, {})}), (0,require$react_SLASH_jsx_runtime.jsx)(require$react_router_dom.Route, {path:"docs/view", element:(0,require$react_SLASH_jsx_runtime.jsx)(pre, {})}), (0,require$react_SLASH_jsx_runtime.jsx)(require$react_router_dom.Route, 
  {path:"vectors", element:(0,require$react_SLASH_jsx_runtime.jsx)(nre, {})}), (0,require$react_SLASH_jsx_runtime.jsx)(require$react_router_dom.Route, {path:"agents", element:(0,require$react_SLASH_jsx_runtime.jsx)(require$react_router_dom.Navigate, {to:`${Rne}?tab=audit`, replace:!0})}), (0,require$react_SLASH_jsx_runtime.jsx)(require$react_router_dom.Route, {path:"event-agents", element:(0,require$react_SLASH_jsx_runtime.jsx)(require$react_router_dom.Navigate, {to:Lne, replace:!0})}), (0,require$react_SLASH_jsx_runtime.jsx)(require$react_router_dom.Route, 
  {path:"graph-export-debug", element:(0,require$react_SLASH_jsx_runtime.jsx)(hre, {})}), (0,require$react_SLASH_jsx_runtime.jsx)(require$react_router_dom.Route, {path:"settings", element:(0,require$react_SLASH_jsx_runtime.jsx)(Bne, {})}), (0,require$react_SLASH_jsx_runtime.jsx)(require$react_router_dom.Route, {path:"admin/*", element:(0,require$react_SLASH_jsx_runtime.jsx)(qre, {})}), (0,require$react_SLASH_jsx_runtime.jsx)(require$react_router_dom.Route, {path:"*", element:(0,require$react_SLASH_jsx_runtime.jsx)(require$react_router_dom.Navigate, 
  {to:ro.documents, replace:!0})})]})})]}), (0,require$react_SLASH_jsx_runtime.jsxs)("footer", {className:"shrink-0 text-center py-3 bg-white dark:bg-slate-800 border-t border-slate-200 dark:border-slate-700 text-sm text-slate-500 dark:text-slate-400 transition-colors duration-200", children:["Prefer the previous interface?", " ", (0,require$react_SLASH_jsx_runtime.jsx)(require$react_router_dom.NavLink, {to:"/", className:"text-blue-600 dark:text-blue-400 hover:underline", children:"Open Legacy UI"})]})]});
}
async function Qre() {
  return await Ie("/api/cms/publications/documents");
}
async function Kre(t, e) {
  return await Ie(`/api/cms/publications/intents/${encodeURIComponent(t)}`, {method:"PATCH", body:JSON.stringify({state:e})});
}
function Xre(t) {
  return t ? t.publications.filter(e => e.desired === "published").map(e => e.garden) : [];
}
function Jre(t, e) {
  return t ? t.publications.find(n => n.garden === e) ?? null : null;
}
function Zre(t, e) {
  if (!t) {
    return null;
  }
  const n = i => i.replace(/^\/+/, ""), r = n(e);
  return t.documents.find(i => n(i.document.source.path) === r) ?? null;
}
function eie({open:t, onClose:e, onCreate:n, templates:r, isCreating:i = !1}) {
  var x;
  const [s, o] = (0,require$react.useState)(""), [a, l] = (0,require$react.useState)(""), [c, u] = (0,require$react.useState)(((x = r[0]) == null ? void 0 : x.value) ?? ""), [h, f] = (0,require$react.useState)(null), p = (0,require$react.useCallback)(w => {
    o(w), f(null);
  }, []), g = (0,require$react.useCallback)(w => {
    l(w), s || o(w.toLowerCase().replace(/[^a-z0-9\s]/g, "").replace(/\s+/g, "-").slice(0, 60)), f(null);
  }, [s]), m = (0,require$react.useCallback)(() => {
    const w = s.trim(), v = a.trim();
    if (!w) {
      f("Slug is required");
      return;
    }
    if (!/^[a-z0-9-]+$/.test(w)) {
      f("Slug must be lowercase letters, numbers, and hyphens only");
      return;
    }
    if (!v) {
      f("Title is required");
      return;
    }
    if (!c) {
      f("Template is required");
      return;
    }
    n({slug:w, title:v, template:c});
  }, [s, a, c, n]), b = (0,require$react.useCallback)(() => {
    var w;
    o(""), l(""), u(((w = r[0]) == null ? void 0 : w.value) ?? ""), f(null), e();
  }, [e, r]);
  return (0,require$react_SLASH_jsx_runtime.jsxs)(CT, {open:t, onClose:b, size:"md", children:[(0,require$react_SLASH_jsx_runtime.jsx)(x5, {children:"Create Visual Draft"}), (0,require$react_SLASH_jsx_runtime.jsx)(w5, {children:(0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{display:"flex", flexDirection:"column", gap:"16px"}, children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {children:[(0,require$react_SLASH_jsx_runtime.jsx)("label", {style:{display:"block", fontSize:"13px", fontWeight:500, 
  marginBottom:"6px", color:"var(--token-colors-text-default)"}, children:"Page Title"}), (0,require$react_SLASH_jsx_runtime.jsx)(Cn, {value:a, onChange:w => g(w.target.value), placeholder:"e.g., Error Coded Radio"})]}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {children:[(0,require$react_SLASH_jsx_runtime.jsx)("label", {style:{display:"block", fontSize:"13px", fontWeight:500, marginBottom:"6px", color:"var(--token-colors-text-default)"}, children:"URL Slug"}), (0,require$react_SLASH_jsx_runtime.jsx)(Cn, 
  {value:s, onChange:w => p(w.target.value), placeholder:"e.g., error-coded-radio"}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{fontSize:"11px", color:"var(--token-colors-text-muted)", marginTop:"4px"}, children:"Lowercase letters, numbers, and hyphens only."})]}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {children:[(0,require$react_SLASH_jsx_runtime.jsx)("label", {style:{display:"block", fontSize:"13px", fontWeight:500, marginBottom:"6px", color:"var(--token-colors-text-default)"}, 
  children:"Template"}), (0,require$react_SLASH_jsx_runtime.jsx)(AT, {value:c, onChange:w => u(w.target.value), options:r})]}), h && (0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{padding:"8px 12px", background:"rgba(239, 68, 68, 0.1)", borderLeft:"3px solid #ef4444", borderRadius:"0 4px 4px 0", fontSize:"13px", color:"#fca5a5"}, children:h})]})}), (0,require$react_SLASH_jsx_runtime.jsxs)(S5, {children:[(0,require$react_SLASH_jsx_runtime.jsx)(Ke, {variant:"ghost", onClick:b, disabled:i, children:"Cancel"}), 
  (0,require$react_SLASH_jsx_runtime.jsx)(Ke, {variant:"primary", onClick:m, disabled:i, children:i ? "Creating\u2026" : "Create Draft"})]})]});
}
const tie = {draft:{label:"Draft", color:"var(--token-colors-text-muted)"}, review:{label:"In Review", color:"var(--token-colors-accent-amber)"}, published:{label:"Published", color:"var(--token-colors-accent-green)"}}, nie = "_header_4j07c_8", rie = "_titleRow_4j07c_17", iie = "_pathEditor_4j07c_24", sie = "_pathPrefix_4j07c_36", oie = "_fileNameInput_4j07c_45", aie = "_dirtyIndicator_4j07c_61", lie = "_savedIndicator_4j07c_69", cie = "_actions_4j07c_77", uie = "_saveButton_4j07c_82", die = "_publishButton_4j07c_83", 
hie = "_metaBar_4j07c_123", fie = "_metaItem_4j07c_133", pie = "_metaSelect_4j07c_139", gie = "_cmsDocumentStrip_4j07c_155", mie = "_cmsDocumentStripHeader_4j07c_164", bie = "_inlineButton_4j07c_174", yie = "_cmsDocumentList_4j07c_188", xie = "_cmsDocumentChip_4j07c_195", vie = "_cmsDocumentChipActive_4j07c_220", wie = "_cmsDocumentEmpty_4j07c_226", _ie = "_editorLayout_4j07c_231", Sie = "_bodyEditor_4j07c_237", kie = "_bodyTextarea_4j07c_244", Eie = "_previewPane_4j07c_261", Tie = "_previewHeader_4j07c_271", 
Cie = "_previewBody_4j07c_283", Aie = "_markdownPreview_4j07c_289", Nie = "_emptyPreview_4j07c_313", tn = {header:nie, titleRow:rie, pathEditor:iie, pathPrefix:sie, fileNameInput:oie, dirtyIndicator:aie, savedIndicator:lie, actions:cie, saveButton:uie, publishButton:die, metaBar:hie, metaItem:fie, metaSelect:pie, cmsDocumentStrip:gie, cmsDocumentStripHeader:mie, inlineButton:bie, cmsDocumentList:yie, cmsDocumentChip:xie, cmsDocumentChipActive:vie, cmsDocumentEmpty:wie, editorLayout:_ie, bodyEditor:Sie, 
bodyTextarea:kie, previewPane:Eie, previewHeader:Tie, previewBody:Cie, markdownPreview:Aie, emptyPreview:Nie}, B2 = "knoxx_cms_sidebar_width_px", P0 = 10;
function $2(t, e) {
  const n = new Set(), r = [];
  for (const i of [...t, ...e]) {
    !(i != null && i.session) || n.has(i.session) || (n.add(i.session), r.push(i));
  }
  return r;
}
const Iie = "cms_chat", Oie = "knoxx_cms_chat_session_id", Pie = "knoxx_cms_chat_scratchpad_state", Rie = "knoxx_cms_chat_pinned_context", Die = "knoxx_cms_chat_session_state", Lie = "knoxx_cms_chat_sidebar_width_px";
function efe() {
  var ko;
  const t = (0,require$react_router_dom.useLocation)(), e = (0,require$react_router_dom.useNavigate)(), n = Pg({initialShowCanvas:!1, defaultActorId:Iie, sessionIdKey:Oie, scratchpadStorageKey:Pie, pinnedContextStorageKey:Rie, sessionStateKey:Die, sidebarWidthKey:Lie}), [r, i] = (0,require$react.useState)(""), [s, o] = (0,require$react.useState)(""), [a, l] = (0,require$react.useState)(null), [c, u] = (0,require$react.useState)("draft"), [h, f] = (0,require$react.useState)(!1), [p, g] = (0,require$react.useState)(!1), 
  [m, b] = (0,require$react.useState)(null), [x, w] = (0,require$react.useState)(null), [v, T] = (0,require$react.useState)(""), [I, _] = (0,require$react.useState)([]), [N, E] = (0,require$react.useState)(!1), [C, k] = (0,require$react.useState)(null), [A, P] = (0,require$react.useState)({}), [W, F] = (0,require$react.useState)(!1), [B, z] = (0,require$react.useState)([]), [j, V] = (0,require$react.useState)(!1), [ne, D] = (0,require$react.useState)(!0), [ie, ee] = (0,require$react.useState)(!0), 
  [M, X] = (0,require$react.useState)(() => {
    const _e = localStorage.getItem(B2);
    return _e ? parseInt(_e, 10) : 280;
  }), [ge, me] = (0,require$react.useState)(50), te = (0,require$react.useRef)(null), [q, R] = (0,require$react.useState)(null), [$, G] = (0,require$react.useState)(!1), [J, U] = (0,require$react.useState)(""), [le, be] = (0,require$react.useState)(""), [je, Ae] = (0,require$react.useState)([]), [ue, Le] = (0,require$react.useState)([]), [$e, Ye] = (0,require$react.useState)(!1), [Me, Xe] = (0,require$react.useState)(null), [it, se] = (0,require$react.useState)(null), [oe, we] = (0,require$react.useState)([]), 
  [ke, fe] = (0,require$react.useState)(!1), [Oe, We] = (0,require$react.useState)(0), [rt, st] = (0,require$react.useState)(!1), [ft, St] = (0,require$react.useState)(!1), [ht, xe] = (0,require$react.useState)(null), de = (0,require$react.useRef)([]);
  de.current = oe;
  const [qe, dt] = (0,require$react.useState)("all"), [gt, ze] = (0,require$react.useState)("docs"), [kt, Dt] = (0,require$react.useState)(""), [Et, Tt] = (0,require$react.useState)(""), [yt, Ut] = (0,require$react.useState)(""), {startSidebarPaneResize:en, startSidebarWidthResize:Fn} = vN({sidebarSplitContainerRef:te, sidebarWidthPx:M, setSidebarPaneSplitPct:me, setSidebarWidthPx:X});
  (0,require$react.useEffect)(() => {
    localStorage.setItem(B2, String(M));
  }, [M]), (0,require$react.useEffect)(() => {
    (async() => {
      G(!0);
      try {
        const De = new URLSearchParams();
        De.set("path", ".");
        const lt = await fetch(`/api/ingestion/browse?${De}`);
        lt.ok && R(await lt.json());
      } catch (De) {
        console.error("Failed to load browse data:", De);
      } finally {
        G(!1);
      }
    })();
  }, []), (0,require$react.useEffect)(() => {
    (async() => {
      st(!0);
      try {
        const De = await Ua({limit:P0, offset:0}), lt = De.rows ?? [];
        de.current = lt, we(lt), We(De.total ?? lt.length), fe(De.has_more ?? !1);
      } catch {
        de.current = [], we([]), We(0), fe(!1);
      } finally {
        st(!1);
      }
    })();
  }, []);
  const Sn = (0,require$react.useCallback)(async() => {
    try {
      const _e = await Qre();
      w(_e);
      const De = _e.gardens.filter(lt => lt.status === "active");
      !v && De.length > 0 && T(De[0].id);
    } catch {
      w(null);
    }
  }, [v]);
  (0,require$react.useEffect)(() => {
    Sn();
  }, [Sn]), (0,require$react.useEffect)(() => {
    (async() => {
      try {
        const De = await fetch("/api/ingestion/sources");
        if (!De.ok) {
          return;
        }
        const vt = (await De.json()).find(Cb);
        if (Xe((vt == null ? void 0 : vt.source_id) ?? null), !vt) {
          return;
        }
        const Mt = await fetch(`/api/ingestion/jobs?source_id=${encodeURIComponent(vt.source_id)}&limit=10`);
        if (Mt.ok) {
          const Pn = await Mt.json(), En = Pn.find(bn => bn.status === "running" || bn.status === "pending");
          se(En ?? Pn[0] ?? null);
        }
      } catch (De) {
        console.error("Failed to load workspace status:", De);
      }
    })();
  }, []), (0,require$react.useEffect)(() => {
    (async() => {
      try {
        const De = await fetch("/api/ingestion/file?path\x3dcontracts/cms-templates.edn");
        if (!De.ok) {
          return;
        }
        const vt = (await De.json()).content ?? "", Mt = [], Pn = vt.matchAll(/:([\w-]+)\s+\{[^}]*:label\s+"([^"]+)"/g);
        for (const En of Pn) {
          Mt.push({value:En[1], label:En[2]});
        }
        Mt.length === 0 && Mt.push({value:"article-page", label:"Article"}, {value:"studio-playlist-page", label:"Studio Playlist Page"}, {value:"landing-page", label:"Landing Page"}), z(Mt);
      } catch (De) {
        console.error("Failed to load CMS templates:", De), z([{value:"article-page", label:"Article"}, {value:"studio-playlist-page", label:"Studio Playlist Page"}, {value:"landing-page", label:"Landing Page"}]);
      }
    })();
  }, []);
  const Lt = a != null && a.includes("/") ? a.slice(0, a.lastIndexOf("/") + 1) : "", Wt = (0,require$react.useMemo)(() => a ? Zre(x, a) : null, [x, a]), wr = (0,require$react.useMemo)(() => Xre(Wt), [Wt]), kn = (0,require$react.useMemo)(() => Jre(Wt, v), [Wt, v]), Ct = (0,require$react.useMemo)(() => !!(v && wr.includes(v)), [wr, v]), un = (0,require$react.useCallback)(async _e => {
    const De = bn => (bn ?? "").replace(/^\/+/, ""), lt = new URLSearchParams({path_prefix:_e, limit:"20"}), vt = await fetch(`/api/openplanner/v1/cms/documents?${lt.toString()}`);
    if (!vt.ok) {
      return k(null), P({}), u("draft"), null;
    }
    const Mt = await vt.json(), Pn = De(_e), En = (Mt.documents ?? []).find(bn => De(bn.source_path) === Pn) ?? null;
    return En ? (k(En.doc_id), P(En.metadata ?? {}), En) : (k(null), P({}), u("draft"), null);
  }, []), Je = (0,require$react.useCallback)((_e, De) => {
    const lt = _e.source_path ?? De ?? `cms/${_e.doc_id}.md`;
    i(_e.title), o(_e.content ?? ""), l(lt), u(_e.visibility === "review" ? "review" : "draft"), k(_e.doc_id), P(_e.metadata ?? {}), f(!1), b("Loaded CMS draft"), n.pinContextItem({id:lt, title:_e.title, path:lt, snippet:(_e.content ?? "").slice(0, 240), kind:"file"});
  }, [n, v]), ut = (0,require$react.useCallback)(async() => {
    if (!v) {
      _([]);
      return;
    }
    E(!0);
    try {
      const _e = new URLSearchParams({garden_id:v, limit:"100"}), De = await fetch(`/api/openplanner/v1/cms/documents?${_e.toString()}`);
      if (!De.ok) {
        return;
      }
      const lt = await De.json();
      _(lt.documents ?? []);
    } catch (_e) {
      console.error("Failed to load CMS documents:", _e), _([]);
    } finally {
      E(!1);
    }
  }, [v]);
  (0,require$react.useEffect)(() => {
    ut();
  }, [ut]);
  const at = (0,require$react.useCallback)(async _e => {
    try {
      const De = await fetch(`/api/openplanner/v1/cms/documents/${encodeURIComponent(_e)}`);
      if (!De.ok) {
        return;
      }
      Je(await De.json());
    } catch (De) {
      console.error("Failed to open CMS document:", De);
    }
  }, [Je]), Nt = (0,require$react.useCallback)(async _e => {
    const De = await un(_e), lt = {title:r.trim() || _e.split("/").pop() || "Untitled", content:s, source_path:_e, visibility:De && wr.length > 0 ? "public" : "internal", metadata:(De == null ? void 0 : De.metadata) ?? A}, vt = De ? `/api/openplanner/v1/cms/documents/${encodeURIComponent(De.doc_id)}` : "/api/openplanner/v1/cms/documents", Pn = await fetch(vt, {method:De ? "PATCH" : "POST", headers:{"Content-Type":"application/json"}, body:JSON.stringify(lt)});
    if (!Pn.ok) {
      const bn = await Pn.text();
      if (Pn.status === 503) {
        try {
          if (JSON.parse(bn).persisted) {
            if (De != null && De.doc_id) {
              return k(De.doc_id), De.doc_id;
            }
            const ai = await un(_e);
            if (ai != null && ai.doc_id) {
              return ai.doc_id;
            }
          }
        } catch {
        }
      }
      throw new Error(bn);
    }
    const En = await Pn.json();
    return k(En.doc_id), P(En.metadata ?? {}), En.doc_id;
  }, [A, s, r, wr.length, un]), jt = (0,require$react.useCallback)(() => {
    const _e = r.trim().replace(/[\\/]+/g, "-");
    return `${Lt}${_e}`;
  }, [Lt, r]), rn = (0,require$react.useCallback)(async(_e = {}) => {
    if (!C) {
      return null;
    }
    g(!0), b(null);
    try {
      const De = _e.publishState === "published" ? "public" : _e.publishState === "draft" ? "internal" : c === "review" ? "review" : Ct ? "public" : "review", lt = await fetch(`/api/openplanner/v1/cms/documents/${encodeURIComponent(C)}`, {method:"PATCH", headers:{"Content-Type":"application/json"}, body:JSON.stringify({title:r.trim() || "Untitled", content:s, source_path:a, visibility:De, metadata:A})});
      if (lt.ok) {
        const vt = await lt.json();
        P(vt.metadata ?? {});
      } else {
        const vt = await lt.text();
        if (lt.status !== 503) {
          throw new Error(vt);
        }
        if (!JSON.parse(vt).persisted) {
          throw new Error(vt);
        }
      }
      return f(!1), b(_e.publishState === "published" ? "Published" : _e.publishState === "draft" ? "Unpublished" : "Saved CMS draft"), await ut(), C;
    } finally {
      g(!1);
    }
  }, [C, A, s, a, c, r, Ct, ut]), mn = (0,require$react.useCallback)(async(_e = {}) => {
    if (C) {
      return await rn(_e), a;
    }
    const De = jt();
    if (!De) {
      return null;
    }
    g(!0), b(null);
    try {
      const lt = await fetch("/api/ingestion/file", {method:"PUT", headers:{"Content-Type":"application/json"}, body:JSON.stringify({path:De, old_path:a && a !== De ? a : null, content:s})});
      if (!lt.ok) {
        throw new Error(await lt.text());
      }
      const vt = await lt.json(), Mt = typeof vt.path == "string" ? vt.path : De;
      return l(Mt), i(Mt.split("/").pop() ?? Mt), await Nt(Mt), f(!1), _e.publishState === "published" ? (u("published"), b("Published")) : _e.publishState === "draft" ? (u("draft"), b("Unpublished")) : b("Saved"), await vn(Lt.slice(0, -1) || void 0), Mt;
    } finally {
      g(!1);
    }
  }, [jt, C, s, Lt, a, rn, Nt]);
  (0,require$react.useEffect)(() => {
    u(Ct ? "published" : "draft");
  }, [Ct]);
  const vn = async _e => {
    G(!0);
    try {
      const De = new URLSearchParams();
      _e && De.set("path", _e);
      const lt = await fetch(`/api/ingestion/browse?${De}`);
      lt.ok && R(await lt.json());
    } finally {
      G(!1);
    }
  }, xt = async() => {
    if (le.trim()) {
      Ye(!0);
      try {
        const _e = await fetch("/api/ingestion/search", {method:"POST", headers:{"Content-Type":"application/json"}, body:JSON.stringify({q:le, role:"workspace", limit:30})});
        if (_e.ok) {
          const De = await _e.json();
          Ae(De.rows ?? []), Le(De.projects ?? []);
        }
      } finally {
        Ye(!1);
      }
    }
  }, Jn = async _e => {
    if (_e.type === "dir") {
      await vn(_e.path);
      return;
    }
    try {
      const De = new URLSearchParams({path:_e.path}), lt = await fetch(`/api/ingestion/file?${De}`);
      if (lt.ok) {
        const vt = await lt.json(), Mt = a;
        i(_e.name), o(vt.content), l(_e.path), u("draft"), f(!1), b(null), Mt && Mt !== _e.path && n.unpinContextItem(Mt), n.pinContextItem({id:_e.path, title:_e.name, path:_e.path, snippet:vt.content.slice(0, 240), kind:"file"}), await un(_e.path);
      }
    } catch (De) {
      console.error("Failed to load file:", De);
    }
  };
  (0,require$react.useEffect)(() => {
    const _e = new URLSearchParams(t.search), De = _e.get("doc"), lt = _e.get("path");
    if (De && C === De || !De && lt && a === lt) {
      return;
    }
    let vt = !1;
    return (async() => {
      try {
        if (De) {
          const bn = await fetch(`/api/openplanner/v1/cms/documents/${encodeURIComponent(De)}`);
          if (!bn.ok || vt) {
            return;
          }
          Je(await bn.json(), lt ?? void 0);
          return;
        }
        if (!lt) {
          return;
        }
        const Mt = await fetch(`/api/ingestion/file?${new URLSearchParams({path:lt})}`);
        if (!Mt.ok || vt) {
          return;
        }
        const Pn = await Mt.json(), En = lt.split("/").pop() ?? lt;
        i(En), o(Pn.content), l(lt), u("draft"), f(!1), b(null), n.pinContextItem({id:lt, title:En, path:lt, snippet:Pn.content.slice(0, 240), kind:"file"}), await un(lt);
      } catch (Mt) {
        console.error("Failed to load CMS document from URL:", Mt);
      }
    })(), () => {
      vt = !0;
    };
  }, [Je, n, C, a, t.search, un]);
  const tt = (0,require$react.useCallback)(_e => {
    i(_e.replace(/[\\/]+/g, "-")), u(De => De === "published" ? "draft" : De), f(!0), b(null);
  }, []), Qt = (0,require$react.useCallback)(_e => {
    o(_e), u(De => De === "published" ? "draft" : De), f(!0), b(null);
  }, []), Vt = (0,require$react.useCallback)(async() => {
    if (r.trim()) {
      try {
        await mn();
      } catch (_e) {
        console.error("Save failed:", _e), b("Save failed");
      }
    }
  }, [r, mn]), wi = (0,require$react.useCallback)(async _e => {
    V(!0);
    try {
      const De = `cms/drafts/${_e.slug}`, lt = `{:view/id "${_e.slug}"
 :view/title "${_e.title}"
 :view/kind :${_e.template}
 :view/schema-version 1
 :view/status :draft

 :source
 {:kind :manual
  :imported-at "${(new Date()).toISOString()}"}

 :layout
 {:template :${_e.template}
  :zones
  []}

 :blocks
 []

 :editor
 {:locked false
  :allowed-actions [:drag :drop :duplicate :hide :delete :edit-props]
  :default-panel :layout}

 :publishing
 {:last-published-at nil
  :defer-index false
  :skip-translation true}

 :settings
 {:language "en"
  :allow-comments true
  :chat-actor-id nil}}`, vt = await fetch("/api/ingestion/file", {method:"PUT", headers:{"Content-Type":"application/json"}, body:JSON.stringify({path:`${De}/view-contract.edn`, content:lt})});
      if (!vt.ok) {
        throw new Error(await vt.text());
      }
      const Mt = await fetch("/api/ingestion/file", {method:"PUT", headers:{"Content-Type":"application/json"}, body:JSON.stringify({path:`${De}/content.md`, content:"# " + _e.title + `

Start writing...`})});
      if (!Mt.ok) {
        throw new Error(await Mt.text());
      }
      F(!1), await vn("cms/drafts"), e(`/cms/editor/${encodeURIComponent(De)}`);
    } catch (De) {
      console.error("Failed to create visual draft:", De), b(De instanceof Error ? De.message : "Failed to create draft");
    } finally {
      V(!1);
    }
  }, [e, vn]), qt = (0,require$react.useCallback)(async() => {
    if (!r.trim() || !v) {
      b("Select a garden");
      return;
    }
    const _e = Ct ? "draft" : "published";
    try {
      const De = C ?? null;
      let lt = a, vt = De;
      if (vt) {
        h && await rn();
      } else if (A.block_schema_version === 1) {
        const bn = a ?? `cms/${r.trim().replace(/[\\/]+/g, "-") || "untitled"}.md`, Rr = await fetch("/api/openplanner/v1/cms/documents", {method:"POST", headers:{"Content-Type":"application/json"}, body:JSON.stringify({title:r.trim() || "Untitled", content:s, source_path:bn, visibility:"review", garden_id:v, defer_index:!0, metadata:{...A, garden_id:v}})});
        if (!Rr.ok) {
          throw new Error(await Rr.text());
        }
        const ai = await Rr.json();
        Je(ai, bn), vt = ai.doc_id, lt = bn;
      } else {
        if (lt = await mn(), !lt) {
          return;
        }
        vt = await Nt(lt);
      }
      const Mt = Ct ? "" : "?skip_translation\x3dtrue\x26defer_index\x3dtrue", Pn = `/api/openplanner/v1/cms/publish/${encodeURIComponent(vt)}/${encodeURIComponent(v)}${Mt}`, En = await fetch(Pn, {method:Ct ? "DELETE" : "POST", headers:{"Content-Type":"application/json"}, body:JSON.stringify({})});
      if (!En.ok) {
        const bn = await En.text();
        let Rr = !1;
        if (En.status === 503) {
          try {
            Rr = !!JSON.parse(bn).persisted, Rr && b(_e === "published" ? "Published (index pending)" : "Unpublished (index pending)");
          } catch {
            Rr = !1;
          }
        }
        if (!Rr) {
          throw new Error(bn);
        }
      }
      lt && await un(lt), vt && await at(vt), await ut(), kn && await Kre(kn.id, _e === "published" ? "published" : "withheld"), await Sn(), b(bn => bn ?? (_e === "published" ? "Published" : "Unpublished"));
    } catch (De) {
      console.error("Publish toggle failed:", De), b(_e === "published" ? "Publish failed" : "Unpublish failed");
    }
  }, [Je, C, A, s, r, Ct, Sn, kn, a, at, h, ut, rn, mn, v, un, Nt]), Zn = async() => {
    st(!0);
    try {
      const _e = await Ua({limit:P0, offset:0}), De = _e.rows ?? [], lt = de.current.filter(Mt => !De.some(Pn => Pn.session === Mt.session)), vt = $2(De, lt);
      de.current = vt, we(vt), We(_e.total ?? vt.length), fe(_e.has_more ?? !1);
    } catch {
      de.current = [], we([]), We(0), fe(!1);
    } finally {
      st(!1);
    }
  }, On = async() => {
    if (!(rt || ft || !ke)) {
      St(!0);
      try {
        const _e = await Ua({limit:P0, offset:de.current.length}), De = $2(de.current, _e.rows ?? []);
        de.current = De, we(De), We(_e.total ?? De.length), fe(_e.has_more ?? !1);
      } catch {
      } finally {
        St(!1);
      }
    }
  }, ps = async _e => {
    xe(_e);
    try {
      await n.resumeMemorySession(_e);
    } finally {
      xe(null);
    }
  }, hl = async _e => {
    const De = _e.url;
    if (/^https?:\/\//i.test(De)) {
      await n.openSourceInPreview(_e);
      return;
    }
    await Jn({name:_e.title || De.split("/").pop() || De, path:De, type:"file", previewable:!0});
  }, fl = le.trim().length > 0 && je.length > 0, wo = ((ko = q == null ? void 0 : q.entries) == null ? void 0 : ko.filter(_e => J ? _e.name.toLowerCase().includes(J.toLowerCase()) : !0)) ?? [], _o = wo.filter(_e => _e.type === "file").length, _i = (q == null ? void 0 : q.current_path) ?? "", So = _i.includes("/") ? _i.split("/").slice(0, -1).join("/") : "", ha = A.block_schema_version === 1 ? 1 : null, Si = (0,require$react.useMemo)(() => ha === 1 ? JY(A) : [], [ha, A]), Vr = Si.length > 0, fa = 
  typeof A.publication_kind == "string" ? A.publication_kind : null;
  return (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{display:"flex", flex:"1 1 0%", gap:0, minHeight:0}, children:[ne ? (0,require$react_SLASH_jsx_runtime.jsx)(_N, {sidebarWidthPx:M, sidebarPaneSplitPct:ge, sidebarSplitContainerRef:te, visibilityFilter:qe, kindFilter:gt, statsTotal:0, statsByVisibility:{}, sourceFilter:kt, domainFilter:Et, pathPrefixFilter:yt, onHide:() => D(!1), onVisibilityFilterChange:dt, onKindFilterChange:ze, onSourceFilterChange:Dt, onDomainFilterChange:Tt, onPathPrefixFilterChange:Ut, 
  onNewDocument:() => {
    i("untitled.md"), o(""), l(_i ? `${_i}/untitled.md` : "untitled.md"), u("draft"), k(null), P({}), f(!0), b(null);
  }, onNewVisualDraft:() => F(!0), onStartSidebarPaneResize:en, onStartSidebarWidthResize:Fn, currentPath:_i, currentParentPath:So, browseData:q, previewData:null, loadingBrowse:$, loadingPreview:!1, entryFilter:J, filteredEntries:wo, activeEntryCount:_o, workspaceSourceId:Me, workspaceJob:it, workspaceProgressPercent:it ? Math.round(it.processed_files / it.total_files * 100) : 0, onLoadDirectory:vn, onEntryFilterChange:U, onOpenFile:Jn, semanticQuery:le, semanticResults:je, semanticProjects:ue, 
  semanticSearching:$e, semanticMode:fl, onSemanticQueryChange:be, onSemanticSearch:xt, onClearSemanticSearch:() => {
    be(""), Ae([]), Le([]);
  }, recentSessions:oe, recentSessionsHasMore:ke, recentSessionsTotal:Oe, loadingRecentSessions:rt, loadingMoreRecentSessions:ft, loadingMemorySessionId:ht, onRefreshRecentSessions:Zn, onLoadMoreRecentSessions:On, onResumeMemorySession:ps, pinnedContext:n.pinnedContext, onUnpinContextItem:n.unpinContextItem, onPinSemanticResult:n.pinSemanticResult}) : (0,require$react_SLASH_jsx_runtime.jsx)(Fa, {label:"Files", edge:"left", onExpand:() => D(!0), title:"Show Files panel"}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", 
  {style:{flex:1, overflow:"hidden", display:"flex", flexDirection:"column", minWidth:0}, children:[(0,require$react_SLASH_jsx_runtime.jsxs)("header", {className:tn.header, children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:tn.titleRow, children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:tn.pathEditor, children:[(0,require$react_SLASH_jsx_runtime.jsx)("span", {className:tn.pathPrefix, children:a ? Lt || "./" : ""}), (0,require$react_SLASH_jsx_runtime.jsx)("input", 
  {type:"text", className:tn.fileNameInput, value:r, onChange:_e => tt(_e.target.value), placeholder:"Select a file from the explorer...", disabled:!a})]}), h ? (0,require$react_SLASH_jsx_runtime.jsx)("span", {className:tn.dirtyIndicator, children:"Unsaved changes"}) : null, !h && m ? (0,require$react_SLASH_jsx_runtime.jsx)("span", {className:tn.savedIndicator, children:m}) : null]}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:tn.actions, children:a ? (0,require$react_SLASH_jsx_runtime.jsxs)(require$react_SLASH_jsx_runtime.Fragment, 
  {children:[(0,require$react_SLASH_jsx_runtime.jsx)("button", {className:tn.saveButton, onClick:() => void Vt(), disabled:p || !h, children:p ? "Saving\u2026" : "Save"}), (0,require$react_SLASH_jsx_runtime.jsx)("button", {className:tn.publishButton, onClick:() => void qt(), disabled:p || !v, children:p ? Ct ? "Unpublishing\u2026" : "Publishing\u2026" : Ct ? "Unpublish" : "Publish"}), a != null && a.includes("view-contract.edn") ? (0,require$react_SLASH_jsx_runtime.jsx)("button", {className:tn.visualEditorButton, 
  onClick:() => e(`/cms/editor/${encodeURIComponent(a.replace(/\/view-contract\.edn$/, ""))}`), style:{marginLeft:"8px", padding:"6px 12px", background:"#8b5cf6", color:"#fff", border:"none", borderRadius:"6px", fontSize:"13px", cursor:"pointer"}, children:"Visual Editor"}) : null]}) : null})]}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:tn.metaBar, children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {className:tn.metaItem, children:(0,require$react_SLASH_jsx_runtime.jsx)(ct, 
  {variant:Ct ? "success" : c === "review" ? "warning" : "default", children:Ct ? "Published" : tie[c].label})}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:tn.metaItem, children:(0,require$react_SLASH_jsx_runtime.jsxs)("select", {value:v, onChange:_e => T(_e.target.value), className:tn.metaSelect, "aria-label":"Garden", children:[(0,require$react_SLASH_jsx_runtime.jsx)("option", {value:"", children:"Select garden\u2026"}), ((x == null ? void 0 : x.gardens) ?? []).filter(_e => _e.status === 
  "active").map(_e => (0,require$react_SLASH_jsx_runtime.jsx)("option", {value:_e.id, children:_e.title || _e.id}, _e.id))]})})]}), (0,require$react_SLASH_jsx_runtime.jsxs)("section", {className:tn.cmsDocumentStrip, children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:tn.cmsDocumentStripHeader, children:[(0,require$react_SLASH_jsx_runtime.jsx)("span", {children:"Garden CMS documents"}), (0,require$react_SLASH_jsx_runtime.jsx)("button", {type:"button", className:tn.inlineButton, onClick:() => 
  void ut(), disabled:N || !v, children:N ? "Loading\u2026" : "Refresh"})]}), v ? I.length === 0 ? (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:tn.cmsDocumentEmpty, children:"No CMS documents found for this garden yet."}) : (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:tn.cmsDocumentList, children:I.map(_e => (0,require$react_SLASH_jsx_runtime.jsxs)("button", {type:"button", className:`${tn.cmsDocumentChip} ${_e.doc_id === C ? tn.cmsDocumentChipActive : ""}`, onClick:() => 
  void at(_e.doc_id), title:_e.source_path ?? _e.title, children:[(0,require$react_SLASH_jsx_runtime.jsx)("span", {children:_e.title}), (0,require$react_SLASH_jsx_runtime.jsx)("small", {children:_e.visibility ?? "internal"})]}, _e.doc_id))}) : (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:tn.cmsDocumentEmpty, children:"Select a garden to see its CMS drafts and publications."})]}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:tn.editorLayout, children:[(0,require$react_SLASH_jsx_runtime.jsx)("main", 
  {className:tn.bodyEditor, children:a ? (0,require$react_SLASH_jsx_runtime.jsx)("textarea", {className:tn.bodyTextarea, value:s, onChange:_e => Qt(_e.target.value), placeholder:"Start writing..."}) : (0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{flex:1, display:"flex", alignItems:"center", justifyContent:"center", color:"var(--token-colors-text-muted)", fontSize:14}, children:(0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{textAlign:"center"}, children:[(0,require$react_SLASH_jsx_runtime.jsx)("p", 
  {style:{marginBottom:8}, children:"Select a file from the explorer to edit"}), (0,require$react_SLASH_jsx_runtime.jsx)("p", {style:{fontSize:12, color:"var(--token-colors-text-subtle)"}, children:"The file explorer is the content library."})]})})}), a ? (0,require$react_SLASH_jsx_runtime.jsxs)("aside", {className:tn.previewPane, children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:tn.previewHeader, children:[(0,require$react_SLASH_jsx_runtime.jsx)("span", {children:Vr ? "Rendered output: block publication" : 
  "Rendered output: markdown"}), fa ? (0,require$react_SLASH_jsx_runtime.jsx)(ct, {variant:"default", children:fa}) : null]}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:tn.previewBody, children:Vr ? (0,require$react_SLASH_jsx_runtime.jsx)(rG, {blocks:Si, getAudioUrl:_e => `/api/studio/stream?path=${encodeURIComponent(_e)}`, maxInitialPlaylistTracks:100}) : s.trim() ? (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:tn.markdownPreview, children:(0,require$react_SLASH_jsx_runtime.jsx)(Mu, 
  {children:s})}) : (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:tn.emptyPreview, children:"Preview appears here once the document has content."})})]}) : null]})]}), ie ? (0,require$react_SLASH_jsx_runtime.jsxs)("aside", {style:{width:460, minWidth:380, borderLeft:"1px solid var(--token-colors-border-default)", display:"flex", flexDirection:"column", minHeight:0, overflow:"hidden", background:"var(--token-colors-background-surface)"}, children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", 
  {style:{padding:"8px 10px", borderBottom:"1px solid var(--token-colors-border-default)", display:"flex", alignItems:"center", justifyContent:"space-between", gap:8, flexShrink:0}, children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{fontSize:14, fontWeight:600}, children:"CMS Chat"}), (0,require$react_SLASH_jsx_runtime.jsx)(Ke, {variant:"ghost", size:"sm", onClick:() => ee(!1), title:"Collapse CMS Chat panel", children:"Collapse"})]}), (0,require$react_SLASH_jsx_runtime.jsx)(fd, {controller:n, 
  showFiles:ne, showCanvasToggle:!1, onShowFiles:() => D(!0), onOpenHydrationSource:_e => Jn({name:_e.title || _e.path.split("/").pop() || _e.path, path:_e.path, type:"file", previewable:!0}), onOpenSourceInPreview:hl})]}) : (0,require$react_SLASH_jsx_runtime.jsx)(Fa, {label:"CMS Chat", edge:"right", onExpand:() => ee(!0), title:"Show CMS Chat panel"}), (0,require$react_SLASH_jsx_runtime.jsx)(eie, {open:W, onClose:() => F(!1), onCreate:wi, templates:B, isCreating:j})]});
}
var Mie = Nd;
Nd.flatten = Nd;
Nd.unflatten = aP;
function sP(t) {
  return t && t.constructor && typeof t.constructor.isBuffer == "function" && t.constructor.isBuffer(t);
}
function oP(t) {
  return t;
}
function Nd(t, e) {
  e = e || {};
  const n = e.delimiter || ".", r = e.maxDepth, i = e.transformKey || oP, s = {};
  function o(a, l, c) {
    c = c || 1, Object.keys(a).forEach(function(u) {
      const h = a[u], f = e.safe && Array.isArray(h), p = Object.prototype.toString.call(h), g = sP(h), m = p === "[object Object]" || p === "[object Array]", b = l ? l + n + i(u) : i(u);
      if (!f && !g && m && Object.keys(h).length && (!e.maxDepth || c < r)) {
        return o(h, b, c + 1);
      }
      s[b] = h;
    });
  }
  return o(t), s;
}
function aP(t, e) {
  e = e || {};
  const n = e.delimiter || ".", r = e.overwrite || !1, i = e.transformKey || oP, s = {};
  if (sP(t) || Object.prototype.toString.call(t) !== "[object Object]") {
    return t;
  }
  function a(u) {
    const h = Number(u);
    return isNaN(h) || u.indexOf(".") !== -1 || e.object ? u : h;
  }
  function l(u, h, f) {
    return Object.keys(f).reduce(function(p, g) {
      return p[u + n + g] = f[g], p;
    }, h);
  }
  function c(u) {
    const h = Object.prototype.toString.call(u), f = h === "[object Array]", p = h === "[object Object]";
    if (u) {
      if (f) {
        return !u.length;
      }
      if (p) {
        return !Object.keys(u).length;
      }
    } else {
      return !0;
    }
  }
  return t = Object.keys(t).reduce(function(u, h) {
    const f = Object.prototype.toString.call(t[h]);
    return !(f === "[object Object]" || f === "[object Array]") || c(t[h]) ? (u[h] = t[h], u) : l(h, u, Nd(t[h], e));
  }, {}), Object.keys(t).forEach(function(u) {
    const h = u.split(n).map(i);
    let f = a(h.shift()), p = a(h[0]), g = s;
    for (; p !== void 0;) {
      if (f === "__proto__") {
        return;
      }
      const m = Object.prototype.toString.call(g[f]), b = m === "[object Object]" || m === "[object Array]";
      if (!r && !b && typeof g[f] < "u") {
        return;
      }
      (r && !b || !r && g[f] == null) && (g[f] = typeof p == "number" && !e.object ? [] : {}), g = g[f], h.length > 0 && (f = a(h.shift()), p = a(h[0]));
    }
    g[f] = aP(t[u], e);
  }), s;
}
const Bie = Vd(Mie);
var $ie = function t(e, n) {
  if (e === n) {
    return !0;
  }
  if (e && n && typeof e == "object" && typeof n == "object") {
    if (e.constructor !== n.constructor) {
      return !1;
    }
    var r, i, s;
    if (Array.isArray(e)) {
      if (r = e.length, r != n.length) {
        return !1;
      }
      for (i = r; i-- !== 0;) {
        if (!t(e[i], n[i])) {
          return !1;
        }
      }
      return !0;
    }
    if (e.constructor === RegExp) {
      return e.source === n.source && e.flags === n.flags;
    }
    if (e.valueOf !== Object.prototype.valueOf) {
      return e.valueOf() === n.valueOf();
    }
    if (e.toString !== Object.prototype.toString) {
      return e.toString() === n.toString();
    }
    if (s = Object.keys(e), r = s.length, r !== Object.keys(n).length) {
      return !1;
    }
    for (i = r; i-- !== 0;) {
      if (!Object.prototype.hasOwnProperty.call(n, s[i])) {
        return !1;
      }
    }
    for (i = r; i-- !== 0;) {
      var o = s[i];
      if (!t(e[o], n[o])) {
        return !1;
      }
    }
    return !0;
  }
  return e !== e && n !== n;
};
const Vp = Vd($ie);
var Fie = Object.create, U1 = Object.defineProperty, zie = Object.defineProperties, Hie = Object.getOwnPropertyDescriptor, Uie = Object.getOwnPropertyDescriptors, W1 = Object.getOwnPropertyNames, qp = Object.getOwnPropertySymbols, Wie = Object.getPrototypeOf, j1 = Object.prototype.hasOwnProperty, lP = Object.prototype.propertyIsEnumerable, F2 = (t, e, n) => e in t ? U1(t, e, {enumerable:!0, configurable:!0, writable:!0, value:n}) : t[e] = n, K = (t, e) => {
  for (var n in e || (e = {})) {
    j1.call(e, n) && F2(t, n, e[n]);
  }
  if (qp) {
    for (var n of qp(e)) {
      lP.call(e, n) && F2(t, n, e[n]);
    }
  }
  return t;
}, ve = (t, e) => zie(t, Uie(e)), ua = (t, e) => {
  var n = {};
  for (var r in t) {
    j1.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
  }
  if (t != null && qp) {
    for (var r of qp(t)) {
      e.indexOf(r) < 0 && lP.call(t, r) && (n[r] = t[r]);
    }
  }
  return n;
}, jie = (t, e) => function() {
  return t && (e = (0,t[W1(t)[0]])(t = 0)), e;
}, Vie = (t, e) => function() {
  return e || (0,t[W1(t)[0]])((e = {exports:{}}).exports, e), e.exports;
}, qie = (t, e, n, r) => {
  if (e && typeof e == "object" || typeof e == "function") {
    for (let i of W1(e)) {
      !j1.call(t, i) && i !== n && U1(t, i, {get:() => e[i], enumerable:!(r = Hie(e, i)) || r.enumerable});
    }
  }
  return t;
}, Yie = (t, e, n) => (n = t != null ? Fie(Wie(t)) : {}, qie(!t || !t.__esModule ? U1(n, "default", {value:t, enumerable:!0}) : n, t)), Qn = (t, e, n) => new Promise((r, i) => {
  var s = l => {
    try {
      a(n.next(l));
    } catch (c) {
      i(c);
    }
  }, o = l => {
    try {
      a(n.throw(l));
    } catch (c) {
      i(c);
    }
  }, a = l => l.done ? r(l.value) : Promise.resolve(l.value).then(s, o);
  a((n = n.apply(t, e)).next());
}), re = jie({["../tsup-config/react-import.js"]() {
}});
re();
re();
re();
var V1 = (t, e) => Object.keys(e).reduce((n, r) => e[r].type === "slot" ? K({[r]:[]}, n) : n, t), q1 = t => !!t && typeof t.then == "function", z2 = t => t.reduce((e, n) => K(K({}, e), n), {}), Oy = t => t.some(q1), Yp = ({value:t, fields:e, mappers:n, propKey:r = "", propPath:i = "", id:s = "", config:o, recurseSlots:a = !1}) => {
  var l, c, u;
  const h = (l = e[r]) == null ? void 0 : l.type, f = n[h];
  if (f && h === "slot") {
    const p = t || [], g = a ? p.map(m => {
      var b;
      const x = o.components[m.type];
      if (!x) {
        throw new Error(`Could not find component config for ${m.type}`);
      }
      const w = (b = x.fields) != null ? b : {};
      return Yp({value:ve(K({}, m), {props:V1(m.props, w)}), fields:w, mappers:n, id:m.props.id, config:o, recurseSlots:a});
    }) : p;
    return Oy(g) ? Promise.all(g) : f({value:g, parentId:s, propName:i, field:e[r], propPath:i});
  } else if (f && e[r]) {
    return f({value:t, parentId:s, propName:r, field:e[r], propPath:i});
  }
  if (t && typeof t == "object") {
    if (Array.isArray(t)) {
      const p = ((c = e[r]) == null ? void 0 : c.type) === "array" ? e[r].arrayFields : null;
      if (!p) {
        return t;
      }
      const g = t.map((m, b) => Yp({value:m, fields:p, mappers:n, propKey:r, propPath:`${i}[${b}]`, id:s, config:o, recurseSlots:a}));
      return Oy(g) ? Promise.all(g) : g;
    } else {
      if ("$$typeof" in t) {
        return t;
      }
      {
        const p = ((u = e[r]) == null ? void 0 : u.type) === "object" ? e[r].objectFields : e;
        return cP({value:t, fields:p, mappers:n, id:s, getPropPath:g => `${i}.${g}`, config:o, recurseSlots:a});
      }
    }
  }
  return t;
}, cP = ({value:t, fields:e, mappers:n, id:r, getPropPath:i, config:s, recurseSlots:o}) => {
  const a = Object.entries(t).map(([l, c]) => {
    const u = {value:c, fields:e, mappers:n, propKey:l, propPath:i(l), id:r, config:s, recurseSlots:o}, h = Yp(u);
    return q1(h) ? h.then(f => ({[l]:f})) : {[l]:h};
  }, {});
  return Oy(a) ? Promise.all(a).then(z2) : z2(a);
};
function lh(t, e, n, r = !1) {
  var i, s, o, a, l;
  const c = "type" in t ? t.type : "root", u = c === "root" ? n.root : (i = n.components) == null ? void 0 : i[c], h = cP({value:V1((s = t.props) != null ? s : {}, (o = u == null ? void 0 : u.fields) != null ? o : {}), fields:(a = u == null ? void 0 : u.fields) != null ? a : {}, mappers:e, id:t.props && (l = t.props.id) != null ? l : "root", getPropPath:f => f, config:n, recurseSlots:r});
  return q1(h) ? h.then(f => ve(K({}, t), {props:f})) : ve(K({}, t), {props:h});
}
function uP(t, e, n) {
  var r, i;
  const s = c => lh(c, {slot:({value:u, parentId:h, propName:f}) => {
    var p;
    const g = u;
    return (p = n(g, {parentId:h, propName:f})) != null ? p : g;
  }}, e, !0);
  if ("props" in t) {
    return s(t);
  }
  const o = t, a = (r = o.zones) != null ? r : {}, l = o.content.map(s);
  return {root:s(o.root), content:(i = n(l, {parentId:"root", propName:"default-zone"})) != null ? i : l, zones:Object.keys(a).reduce((c, u) => ve(K({}, c), {[u]:a[u].map(s)}), {})};
}
re();
re();
re();
var Gp = [{width:360, height:"auto", icon:"Smartphone", label:"Small"}, {width:768, height:"auto", icon:"Tablet", label:"Medium"}, {width:1280, height:"auto", icon:"Monitor", label:"Large"}], Py = {data:{content:[], root:{}, zones:{}}, ui:{leftSideBarVisible:!0, rightSideBarVisible:!0, arrayState:{}, itemSelector:null, componentList:{}, isDragging:!1, previewMode:"edit", viewports:{current:{width:Gp[0].width, height:Gp[0].height || "auto"}, options:[], controlsVisible:!0}, field:{focus:null}}, indexes:{nodes:{}, 
zones:{}}};
re();
re();
re();
re();
var Y1 = "root", Ry = "default-zone", Cr = `${Y1}:${Ry}`, Gie = t => t ? t && t.indexOf(":") > -1 ? t.split(":") : [Cr, t] : [];
function Qie(t, e, n, r = []) {
  Object.entries(e.zones || {}).forEach(([i, s]) => {
    const [o] = Gie(i);
    o === t.props.id && n(r, i, s);
  });
}
re();
re();
var Kie = (t, e) => lh(t, {slot:() => null}, e), {flatten:Xie, unflatten:Jie} = Bie, Zie = (t, e) => ve(K({}, t), {props:Xie(Kie(t, e).props)}), ese = t => {
  const e = Jie(t.props);
  return ve(K({}, t), {props:e});
};
function xi(t, e, n = i => i, r = i => i) {
  var i;
  let s = {};
  const o = {}, a = {}, l = (w, v, T, I, _) => {
    var N;
    const [E] = v.split(":"), C = ((N = n(T, v, I)) != null ? N : T) || [], [k, A] = v.split(":"), P = `${_ || E}:${A}`, W = C.map((F, B) => u(F, [...w, P], B));
    return o[P] = {contentIds:W.map(F => F.props.id), type:I}, [P, W];
  }, c = (w, v, T) => {
    Qie(w, t.data, (I, _, N) => {
      const [E, C] = l(I, _, N, "dropzone", v);
      s[E] = C;
    }, T);
  }, u = (w, v, T) => {
    const I = r(w, v, T);
    if (!I) {
      return w;
    }
    const _ = I.props.id, N = ve(K({}, lh(I, {slot:({value:W, parentId:F, propPath:B}) => {
      const z = W, j = `${F}:${B}`, [V, ne] = l(v, j, z, "slot", F);
      return ne;
    }}, e).props), {id:_});
    c(w, _, v);
    const E = ve(K({}, w), {props:N}), C = v[v.length - 1], [k, A] = C ? C.split(":") : [null, ""];
    a[_] = {data:E, flatData:Zie(E, e), path:v, parentId:k, zone:A};
    const P = ve(K({}, E), {props:K({}, E.props)});
    return N.id === "root" && (delete P.type, delete P.props.id), P;
  }, h = t.data.zones || {}, [f, p] = l([], Cr, t.data.content, "root"), g = p, m = Object.keys(s);
  Object.keys(h || {}).forEach(w => {
    const [v] = w.split(":");
    if (m.includes(w)) {
      return;
    }
    const [T, I] = l([Cr], w, h[w], "dropzone", v);
    s[w] = I;
  }, s);
  const b = u({type:"root", props:ve(K({}, (i = t.data.root.props) != null ? i : t.data.root), {id:"root"})}, [], -1), x = ve(K({}, t.data.root), {props:b.props});
  return ve(K({}, t), {data:{root:x, content:g, zones:K(K({}, t.data.zones), s)}, indexes:{nodes:K(K({}, t.indexes.nodes), a), zones:K(K({}, t.indexes.zones), o)}});
}
re();
re();
re();
re();
re();
var G1 = (t, e) => t ? Object.keys(t.props || {}).reduce((n, r) => {
  const i = (t == null ? void 0 : t.props) || {}, s = (e == null ? void 0 : e.props) || {};
  return ve(K({}, n), {[r]:!Vp(s[r], i[r])});
}, {}) : {}, H2 = {lastChange:{}}, dP = (t, e, ...n) => Qn(void 0, [t, e, ...n], function*(r, i, s = {}, o, a, l = "replace") {
  const c = "type" in r && r.type !== "root" ? i.components[r.type] : i.root, u = K({}, r), h = (c == null ? void 0 : c.resolveData) && r.props, f = "id" in r.props ? r.props.id : "root";
  if (h) {
    const {item:g = null, resolved:m = {}} = H2.lastChange[f] || {};
    if (l !== "force" && r && Vp(r, g)) {
      return {node:m, didChange:!1};
    }
    const b = G1(r, g);
    o && o(r);
    const {props:x, readOnly:w = {}} = yield c.resolveData(r, {changed:b, lastData:g, metadata:K(K({}, s), c.metadata), trigger:l});
    u.props = K(K({}, r.props), x), Object.keys(w).length && (u.readOnly = w);
  }
  let p = yield lh(u, {slot:g => Qn(void 0, [g], function*({value:m}) {
    const b = m;
    return yield Promise.all(b.map(x => Qn(void 0, null, function*() {
      return (yield dP(x, i, s, o, a, l)).node;
    })));
  })}, i);
  return h && a && a(u), H2.lastChange[f] = {item:r, resolved:p}, {node:p, didChange:!Vp(r, p)};
});
re();
re();
var hP = (t, e) => {
  if (e === Cr) {
    return t;
  }
  const n = ve(K({}, t), {zones:t.zones ? K({}, t.zones) : {}});
  return n.zones[e] = n.zones[e] || [], n;
};
re();
function fP(t, e, n, r, i) {
  const s = (0,require$react.useMemo)(() => Object.keys(n).reduce((l, c) => {
    const u = c;
    return ve(K({}, l), {[u]:h => {
      var f = h, {parentId:p} = f, g = ua(f, ["parentId"]);
      const m = g.propPath.replace(/\[\d+\]/g, "[*]"), b = (r == null ? void 0 : r[g.propPath]) || (r == null ? void 0 : r[m]) || i || !1, x = n[u];
      return x == null ? void 0 : x(ve(K({}, g), {isReadOnly:b, componentId:p}));
    }});
  }, {}), [n, r, i]), o = (0,require$react.useMemo)(() => lh(e, s, t).props, [t, e, s]);
  return (0,require$react.useMemo)(() => K(K({}, e.props), o), [e.props, o]);
}
re();
var pP = (t, e = t) => ({slot:({value:n, propName:r, field:i, isReadOnly:s}) => {
  const o = s ? e : t;
  return l => o(ve(K({allow:(i == null ? void 0 : i.type) === "slot" ? i.allow : [], disallow:(i == null ? void 0 : i.type) === "slot" ? i.disallow : []}, l), {zone:r, content:n}));
}});
re();
function Qg(t, e, n, r = n, i, s) {
  return fP(t, e, pP(n, r), i, s);
}
re();
var Q1 = t => (0,require$react_SLASH_jsx_runtime.jsx)(gP, K({}, t)), tse = ({config:t, item:e, metadata:n}) => {
  const r = t.components[e.type], i = Qg(t, e, s => (0,require$react_SLASH_jsx_runtime.jsx)(Q1, ve(K({}, s), {config:t, metadata:n})));
  return (0,require$react_SLASH_jsx_runtime.jsx)(r.render, ve(K({}, i), {puck:ve(K({}, i.puck), {metadata:n || {}})}));
}, gP = (0,require$react.forwardRef)(function({className:e, style:n, content:r, config:i, metadata:s}, o) {
  return (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:e, style:n, ref:o, children:r.map(a => i.components[a.type] ? (0,require$react_SLASH_jsx_runtime.jsx)(tse, {config:i, item:a, metadata:s}, a.props.id) : null)});
});
let cf;
const nse = new Uint8Array(16);
function rse() {
  if (!cf && (cf = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !cf)) {
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  }
  return cf(nse);
}
const ur = [];
for (let t = 0; t < 256; ++t) {
  ur.push((t + 256).toString(16).slice(1));
}
function ise(t, e = 0) {
  return ur[t[e + 0]] + ur[t[e + 1]] + ur[t[e + 2]] + ur[t[e + 3]] + "-" + ur[t[e + 4]] + ur[t[e + 5]] + "-" + ur[t[e + 6]] + ur[t[e + 7]] + "-" + ur[t[e + 8]] + ur[t[e + 9]] + "-" + ur[t[e + 10]] + ur[t[e + 11]] + ur[t[e + 12]] + ur[t[e + 13]] + ur[t[e + 14]] + ur[t[e + 15]];
}
const sse = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), U2 = {randomUUID:sse};
function W2(t, e, n) {
  if (U2.randomUUID && !t) {
    return U2.randomUUID();
  }
  t = t || {};
  const r = t.random || (t.rng || rse)();
  return r[6] = r[6] & 15 | 64, r[8] = r[8] & 63 | 128, ise(r);
}
const j2 = t => {
  let e;
  const n = new Set(), r = (c, u) => {
    const h = typeof c == "function" ? c(e) : c;
    if (!Object.is(h, e)) {
      const f = e;
      e = u ?? (typeof h != "object" || h === null) ? h : Object.assign({}, e, h), n.forEach(p => p(e, f));
    }
  }, i = () => e, a = {setState:r, getState:i, getInitialState:() => l, subscribe:c => (n.add(c), () => n.delete(c))}, l = e = t(r, i, a);
  return a;
}, ch = t => t ? j2(t) : j2, ose = t => t;
function K1(t, e = ose) {
  const n = default$$require$react.default.useSyncExternalStore(t.subscribe, default$$require$react.default.useCallback(() => e(t.getState()), [t, e]), default$$require$react.default.useCallback(() => e(t.getInitialState()), [t, e]));
  return default$$require$react.default.useDebugValue(n), n;
}
const ase = t => {
  const e = ch(t), n = r => K1(e, r);
  return Object.assign(n, e), n;
}, mP = t => ase, lse = t => (e, n, r) => {
  const i = r.subscribe;
  return r.subscribe = (o, a, l) => {
    let c = o;
    if (a) {
      const u = (l == null ? void 0 : l.equalityFn) || Object.is;
      let h = o(r.getState());
      c = f => {
        const p = o(f);
        if (!u(h, p)) {
          const g = h;
          a(h = p, g);
        }
      }, l != null && l.fireImmediately && a(h, h);
    }
    return i(c);
  }, t(e, n, r);
}, bP = lse;
var cse = Symbol.for("preact-signals");
function Kg() {
  if (ao > 1) {
    ao--;
  } else {
    var t, e = !1;
    for (function() {
      var i = Kp;
      for (Kp = void 0; i !== void 0;) {
        i.S.v === i.v && (i.S.i = i.i), i = i.o;
      }
    }(); rd !== void 0;) {
      var n = rd;
      for (rd = void 0, Qp++; n !== void 0;) {
        var r = n.u;
        if (n.u = void 0, n.f &= -3, !(8 & n.f) && xP(n)) {
          try {
            n.c();
          } catch (i) {
            e || (t = i, e = !0);
          }
        }
        n = r;
      }
    }
    if (Qp = 0, ao--, e) {
      throw t;
    }
  }
}
function Wn(t) {
  if (ao > 0) {
    return t();
  }
  Dy = ++use, ao++;
  try {
    return t();
  } finally {
    Kg();
  }
}
var hn = void 0;
function on(t) {
  var e = hn;
  hn = void 0;
  try {
    return t();
  } finally {
    hn = e;
  }
}
var rd = void 0, ao = 0, Qp = 0, use = 0, Dy = 0, Kp = void 0, Xp = 0;
function yP(t) {
  if (hn !== void 0) {
    var e = t.n;
    if (e === void 0 || e.t !== hn) {
      return e = {i:0, S:t, p:hn.s, n:void 0, t:hn, e:void 0, x:void 0, r:e}, hn.s !== void 0 && (hn.s.n = e), hn.s = e, t.n = e, 32 & hn.f && t.S(e), e;
    }
    if (e.i === -1) {
      return e.i = 0, e.n !== void 0 && (e.n.p = e.p, e.p !== void 0 && (e.p.n = e.n), e.p = hn.s, e.n = void 0, hn.s.n = e, hn.s = e), e;
    }
  }
}
function jr(t, e) {
  this.v = t, this.i = 0, this.n = void 0, this.t = void 0, this.l = 0, this.W = e == null ? void 0 : e.watched, this.Z = e == null ? void 0 : e.unwatched, this.name = e == null ? void 0 : e.name;
}
jr.prototype.brand = cse;
jr.prototype.h = function() {
  return !0;
};
jr.prototype.S = function(t) {
  var e = this, n = this.t;
  n !== t && t.e === void 0 && (t.x = n, this.t = t, n !== void 0 ? n.e = t : on(function() {
    var r;
    (r = e.W) == null || r.call(e);
  }));
};
jr.prototype.U = function(t) {
  var e = this;
  if (this.t !== void 0) {
    var n = t.e, r = t.x;
    n !== void 0 && (n.x = r, t.e = void 0), r !== void 0 && (r.e = n, t.x = void 0), t === this.t && (this.t = r, r === void 0 && on(function() {
      var i;
      (i = e.Z) == null || i.call(e);
    }));
  }
};
jr.prototype.subscribe = function(t) {
  var e = this;
  return si(function() {
    var n = e.value, r = hn;
    hn = void 0;
    try {
      t(n);
    } finally {
      hn = r;
    }
  }, {name:"sub"});
};
jr.prototype.valueOf = function() {
  return this.value;
};
jr.prototype.toString = function() {
  return this.value + "";
};
jr.prototype.toJSON = function() {
  return this.value;
};
jr.prototype.peek = function() {
  var t = this;
  return on(function() {
    return t.value;
  });
};
Object.defineProperty(jr.prototype, "value", {get:function() {
  var t = yP(this);
  return t !== void 0 && (t.i = this.i), this.v;
}, set:function(t) {
  if (t !== this.v) {
    if (Qp > 100) {
      throw new Error("Cycle detected");
    }
    (function(n) {
      ao !== 0 && Qp === 0 && n.l !== Dy && (n.l = Dy, Kp = {S:n, v:n.v, i:n.i, o:Kp});
    })(this), this.v = t, this.i++, Xp++, ao++;
    try {
      for (var e = this.t; e !== void 0; e = e.x) {
        e.t.N();
      }
    } finally {
      Kg();
    }
  }
}});
function uh(t, e) {
  return new jr(t, e);
}
function xP(t) {
  for (var e = t.s; e !== void 0; e = e.n) {
    if (e.S.i !== e.i || !e.S.h() || e.S.i !== e.i) {
      return !0;
    }
  }
  return !1;
}
function vP(t) {
  for (var e = t.s; e !== void 0; e = e.n) {
    var n = e.S.n;
    if (n !== void 0 && (e.r = n), e.S.n = e, e.i = -1, e.n === void 0) {
      t.s = e;
      break;
    }
  }
}
function wP(t) {
  for (var e = t.s, n = void 0; e !== void 0;) {
    var r = e.p;
    e.i === -1 ? (e.S.U(e), r !== void 0 && (r.n = e.n), e.n !== void 0 && (e.n.p = r)) : n = e, e.S.n = e.r, e.r !== void 0 && (e.r = void 0), e = r;
  }
  t.s = n;
}
function ll(t, e) {
  jr.call(this, void 0), this.x = t, this.s = void 0, this.g = Xp - 1, this.f = 4, this.W = e == null ? void 0 : e.watched, this.Z = e == null ? void 0 : e.unwatched, this.name = e == null ? void 0 : e.name;
}
ll.prototype = new jr();
ll.prototype.h = function() {
  if (this.f &= -3, 1 & this.f) {
    return !1;
  }
  if ((36 & this.f) == 32 || (this.f &= -5, this.g === Xp)) {
    return !0;
  }
  if (this.g = Xp, this.f |= 1, this.i > 0 && !xP(this)) {
    return this.f &= -2, !0;
  }
  var t = hn;
  try {
    vP(this), hn = this;
    var e = this.x();
    (16 & this.f || this.v !== e || this.i === 0) && (this.v = e, this.f &= -17, this.i++);
  } catch (n) {
    this.v = n, this.f |= 16, this.i++;
  }
  return hn = t, wP(this), this.f &= -2, !0;
};
ll.prototype.S = function(t) {
  if (this.t === void 0) {
    this.f |= 36;
    for (var e = this.s; e !== void 0; e = e.n) {
      e.S.S(e);
    }
  }
  jr.prototype.S.call(this, t);
};
ll.prototype.U = function(t) {
  if (this.t !== void 0 && (jr.prototype.U.call(this, t), this.t === void 0)) {
    this.f &= -33;
    for (var e = this.s; e !== void 0; e = e.n) {
      e.S.U(e);
    }
  }
};
ll.prototype.N = function() {
  if (!(2 & this.f)) {
    this.f |= 6;
    for (var t = this.t; t !== void 0; t = t.x) {
      t.t.N();
    }
  }
};
Object.defineProperty(ll.prototype, "value", {get:function() {
  if (1 & this.f) {
    throw new Error("Cycle detected");
  }
  var t = yP(this);
  if (this.h(), t !== void 0 && (t.i = this.i), 16 & this.f) {
    throw this.v;
  }
  return this.v;
}});
function V2(t, e) {
  return new ll(t, e);
}
function _P(t) {
  var e = t.m;
  if (t.m = void 0, typeof e == "function") {
    ao++;
    var n = hn;
    hn = void 0;
    try {
      e();
    } catch (r) {
      throw t.f &= -2, t.f |= 8, X1(t), r;
    } finally {
      hn = n, Kg();
    }
  }
}
function X1(t) {
  for (var e = t.s; e !== void 0; e = e.n) {
    e.S.U(e);
  }
  t.x = void 0, t.s = void 0, _P(t);
}
function dse(t) {
  if (hn !== this) {
    throw new Error("Out-of-order effect");
  }
  wP(this), hn = t, this.f &= -2, 8 & this.f && X1(this), Kg();
}
function Pc(t, e) {
  this.x = t, this.m = void 0, this.s = void 0, this.u = void 0, this.f = 32, this.name = e == null ? void 0 : e.name;
}
Pc.prototype.c = function() {
  var t = this.S();
  try {
    if (8 & this.f || this.x === void 0) {
      return;
    }
    var e = this.x();
    typeof e == "function" && (this.m = e);
  } finally {
    t();
  }
};
Pc.prototype.S = function() {
  if (1 & this.f) {
    throw new Error("Cycle detected");
  }
  this.f |= 1, this.f &= -9, _P(this), vP(this), ao++;
  var t = hn;
  return hn = this, dse.bind(this, t);
};
Pc.prototype.N = function() {
  2 & this.f || (this.f |= 2, this.u = rd, rd = this);
};
Pc.prototype.d = function() {
  this.f |= 8, 1 & this.f || X1(this);
};
Pc.prototype.dispose = function() {
  this.d();
};
function si(t, e) {
  var n = new Pc(t, e);
  try {
    n.c();
  } catch (i) {
    throw n.d(), i;
  }
  var r = n.d.bind(n);
  return r[Symbol.dispose] = r, r;
}
var hse = Object.create, J1 = Object.defineProperty, fse = Object.defineProperties, pse = Object.getOwnPropertyDescriptor, gse = Object.getOwnPropertyDescriptors, q2 = Object.getOwnPropertySymbols, mse = Object.prototype.hasOwnProperty, bse = Object.prototype.propertyIsEnumerable, yse = (t, e) => (e = Symbol[t]) ? e : Symbol.for("Symbol." + t), Rc = t => {
  throw TypeError(t);
}, Ly = (t, e, n) => e in t ? J1(t, e, {enumerable:!0, configurable:!0, writable:!0, value:n}) : t[e] = n, xse = (t, e) => {
  for (var n in e || (e = {})) {
    mse.call(e, n) && Ly(t, n, e[n]);
  }
  if (q2) {
    for (var n of q2(e)) {
      bse.call(e, n) && Ly(t, n, e[n]);
    }
  }
  return t;
}, vse = (t, e) => fse(t, gse(e)), Y2 = (t, e) => J1(t, "name", {value:e, configurable:!0}), wse = t => {
  var e;
  return [, , , hse((e = void 0) != null ? e : null)];
}, SP = ["class", "method", "getter", "setter", "accessor", "field", "value", "get", "set"], gu = t => t !== void 0 && typeof t != "function" ? Rc("Function expected") : t, _se = (t, e, n, r, i) => ({kind:SP[t], name:e, metadata:r, addInitializer:s => n._ ? Rc("Already initialized") : i.push(gu(s || null))}), kP = (t, e) => Ly(e, yse("metadata"), t[3]), ya = (t, e, n, r) => {
  for (var i = 0, s = t[e >> 1], o = s && s.length; i < o; i++) {
    e & 1 ? s[i].call(n) : r = s[i].call(n, r);
  }
  return r;
}, Dc = (t, e, n, r, i, s) => {
  var o, a, l, c, u, h = e & 7, f = !!(e & 8), p = !!(e & 16), g = h > 3 ? t.length + 1 : h ? f ? 1 : 2 : 0, m = SP[h + 5], b = h > 3 && (t[g - 1] = []), x = t[g] || (t[g] = []), w = h && (!p && !f && (i = i.prototype), h < 5 && (h > 3 || !p) && pse(h < 4 ? i : {get [n]() {
    return Oi(this, s);
  }, set [n](T) {
    return $o(this, s, T);
  }}, n));
  h ? p && h < 4 && Y2(s, (h > 2 ? "set " : h > 1 ? "get " : "") + n) : Y2(i, n);
  for (var v = r.length - 1; v >= 0; v--) {
    c = _se(h, n, l = {}, t[3], x), h && (c.static = f, c.private = p, u = c.access = {has:p ? T => Sse(i, T) : T => n in T}, h ^ 3 && (u.get = p ? T => (h ^ 1 ? Oi : kse)(T, i, h ^ 4 ? s : w.get) : T => T[n]), h > 2 && (u.set = p ? (T, I) => $o(T, i, I, h ^ 4 ? s : w.set) : (T, I) => T[n] = I)), a = (0,r[v])(h ? h < 4 ? p ? s : w[m] : h > 4 ? void 0 : {get:w.get, set:w.set} : i, c), l._ = 1, h ^ 4 || a === void 0 ? gu(a) && (h > 4 ? b.unshift(a) : h ? p ? s = a : w[m] = a : i = a) : typeof a != 
    "object" || a === null ? Rc("Object expected") : (gu(o = a.get) && (w.get = o), gu(o = a.set) && (w.set = o), gu(o = a.init) && b.unshift(o));
  }
  return h || kP(t, i), w && J1(i, n, w), p ? h ^ 4 ? s : w : i;
}, Z1 = (t, e, n) => e.has(t) || Rc("Cannot " + n), Sse = (t, e) => Object(e) !== e ? Rc('Cannot use the "in" operator on this value') : t.has(e), Oi = (t, e, n) => (Z1(t, e, "read from private field"), n ? n.call(t) : e.get(t)), mu = (t, e, n) => e.has(t) ? Rc("Cannot add the same private member more than once") : e instanceof WeakSet ? e.add(t) : e.set(t, n), $o = (t, e, n, r) => (Z1(t, e, "write to private field"), r ? r.call(t, n) : e.set(t, n), n), kse = (t, e, n) => (Z1(t, e, "access private method"), 
n);
function Jp(t, e) {
  if (e) {
    let n;
    return V2(() => {
      const r = t();
      return r && n && e(n, r) ? n : (n = r, r);
    });
  }
  return V2(t);
}
function lo(t, e) {
  if (Object.is(t, e)) {
    return !0;
  }
  if (t === null || e === null) {
    return !1;
  }
  if (typeof t == "function" && typeof e == "function") {
    return t === e;
  }
  if (t instanceof Set && e instanceof Set) {
    if (t.size !== e.size) {
      return !1;
    }
    for (const n of t) {
      if (!e.has(n)) {
        return !1;
      }
    }
    return !0;
  }
  if (Array.isArray(t)) {
    return !Array.isArray(e) || t.length !== e.length ? !1 : !t.some((r, i) => !lo(r, e[i]));
  }
  if (typeof t == "object" && typeof e == "object") {
    const n = Object.keys(t), r = Object.keys(e);
    return n.length !== r.length ? !1 : !n.some(s => !lo(t[s], e[s]));
  }
  return !1;
}
function Jt({get:t}, e) {
  return {init(n) {
    return uh(n);
  }, get() {
    return t.call(this).value;
  }, set(n) {
    const r = t.call(this);
    r.peek() !== n && (r.value = n);
  }};
}
function or(t, e) {
  const n = new WeakMap();
  return function() {
    let r = n.get(this);
    return r || (r = Jp(t.bind(this)), n.set(this, r)), r.value;
  };
}
function R0(t = !0) {
  return function(e, n) {
    n.addInitializer(function() {
      const r = n.kind === "field" ? this : n.static ? this : Object.getPrototypeOf(this), i = Object.getOwnPropertyDescriptor(r, n.name);
      i && Object.defineProperty(r, n.name, vse(xse({}, i), {enumerable:t}));
    });
  };
}
function dh(...t) {
  const e = t.map(si);
  return () => e.forEach(n => n());
}
var EP, TP, CP, AP, NP, IP, Br, ev, D0, My, By, Sr, tv, L0, OP, $y, nv, M0, Fy, zy;
IP = [Jt], NP = [Jt], AP = [Jt], CP = [R0()], TP = [R0()], EP = [R0()];
var cl = class {
  constructor(t, e = Object.is) {
    this.defaultValue = t, this.equals = e, ya(Br, 5, this), mu(this, Sr), mu(this, ev, ya(Br, 8, this)), ya(Br, 11, this), mu(this, tv, ya(Br, 12, this)), ya(Br, 15, this), mu(this, nv, ya(Br, 16, this)), ya(Br, 19, this), this.reset = this.reset.bind(this), this.reset();
  }
  get current() {
    return Oi(this, Sr, Fy);
  }
  get initial() {
    return Oi(this, Sr, My);
  }
  get previous() {
    return Oi(this, Sr, OP);
  }
  set current(t) {
    const e = on(() => Oi(this, Sr, Fy));
    t && e && this.equals(e, t) || Wn(() => {
      Oi(this, Sr, My) || $o(this, Sr, t, By), $o(this, Sr, e, $y), $o(this, Sr, t, zy);
    });
  }
  reset(t = this.defaultValue) {
    Wn(() => {
      $o(this, Sr, void 0, $y), $o(this, Sr, t, By), $o(this, Sr, t, zy);
    });
  }
};
Br = wse();
ev = new WeakMap();
Sr = new WeakSet();
tv = new WeakMap();
nv = new WeakMap();
D0 = Dc(Br, 20, "#initial", IP, Sr, ev), My = D0.get, By = D0.set;
L0 = Dc(Br, 20, "#previous", NP, Sr, tv), OP = L0.get, $y = L0.set;
M0 = Dc(Br, 20, "#current", AP, Sr, nv), Fy = M0.get, zy = M0.set;
Dc(Br, 2, "current", CP, cl);
Dc(Br, 2, "initial", TP, cl);
Dc(Br, 2, "previous", EP, cl);
kP(Br, cl);
function B0(t) {
  return on(() => {
    const e = {};
    for (const n in t) {
      e[n] = t[n];
    }
    return e;
  });
}
var wa, Ese = class {
  constructor() {
    mu(this, wa, new WeakMap());
  }
  get(t, e) {
    var n;
    return t ? (n = Oi(this, wa).get(t)) == null ? void 0 : n.get(e) : void 0;
  }
  set(t, e, n) {
    var r;
    if (t) {
      return Oi(this, wa).has(t) || Oi(this, wa).set(t, new Map()), (r = Oi(this, wa).get(t)) == null ? void 0 : r.set(e, n);
    }
  }
  clear(t) {
    var e;
    return t ? (e = Oi(this, wa).get(t)) == null ? void 0 : e.clear() : void 0;
  }
};
wa = new WeakMap();
var Tse = Object.create, PP = Object.defineProperty, Cse = Object.getOwnPropertyDescriptor, G2 = Object.getOwnPropertySymbols, Ase = Object.prototype.hasOwnProperty, Nse = Object.prototype.propertyIsEnumerable, RP = (t, e) => (e = Symbol[t]) ? e : Symbol.for("Symbol." + t), Xg = t => {
  throw TypeError(t);
}, Q2 = Math.pow, Hy = (t, e, n) => e in t ? PP(t, e, {enumerable:!0, configurable:!0, writable:!0, value:n}) : t[e] = n, Ise = (t, e) => {
  for (var n in e || (e = {})) {
    Ase.call(e, n) && Hy(t, n, e[n]);
  }
  if (G2) {
    for (var n of G2(e)) {
      Nse.call(e, n) && Hy(t, n, e[n]);
    }
  }
  return t;
}, Ose = t => {
  var e;
  return [, , , Tse((e = t == null ? void 0 : t[RP("metadata")]) != null ? e : null)];
}, DP = ["class", "method", "getter", "setter", "accessor", "field", "value", "get", "set"], LP = t => t !== void 0 && typeof t != "function" ? Xg("Function expected") : t, Pse = (t, e, n, r, i) => ({kind:DP[t], name:e, metadata:r, addInitializer:s => n._ ? Xg("Already initialized") : i.push(LP(s || null))}), Rse = (t, e) => Hy(e, RP("metadata"), t[3]), Dse = (t, e, n, r) => {
  for (var i = 0, s = t[e >> 1], o = s && s.length; i < o; i++) {
    s[i].call(n);
  }
  return r;
}, MP = (t, e, n, r, i, s) => {
  for (var o, a, l, c, u = e & 7, h = !1, f = !1, p = 2, g = DP[u + 5], m = t[p] || (t[p] = []), b = (i = i.prototype, Cse(i, n)), x = r.length - 1; x >= 0; x--) {
    l = Pse(u, n, a = {}, t[3], m), l.static = h, l.private = f, c = l.access = {has:w => n in w}, c.get = w => w[n], o = (0,r[x])(b[g], l), a._ = 1, LP(o) && (b[g] = o);
  }
  return b && PP(i, n, b), i;
}, BP = (t, e, n) => e.has(t) || Xg("Cannot " + n), Lse = (t, e, n) => (BP(t, e, "read from private field"), e.get(t)), Mse = (t, e, n) => e.has(t) ? Xg("Cannot add the same private member more than once") : e instanceof WeakSet ? e.add(t) : e.set(t, n), Bse = (t, e, n, r) => (BP(t, e, "write to private field"), e.set(t, n), n), Ar = class Uy {
  constructor(e, n) {
    this.x = e, this.y = n;
  }
  static delta(e, n) {
    return new Uy(e.x - n.x, e.y - n.y);
  }
  static distance(e, n) {
    return Math.hypot(e.x - n.x, e.y - n.y);
  }
  static equals(e, n) {
    return e.x === n.x && e.y === n.y;
  }
  static from({x:e, y:n}) {
    return new Uy(e, n);
  }
}, as = class _a {
  constructor(e, n, r, i) {
    this.left = e, this.top = n, this.width = r, this.height = i, this.scale = {x:1, y:1};
  }
  get inverseScale() {
    return {x:1 / this.scale.x, y:1 / this.scale.y};
  }
  translate(e, n) {
    const {top:r, left:i, width:s, height:o, scale:a} = this, l = new _a(i + e, r + n, s, o);
    return l.scale = Ise({}, a), l;
  }
  get boundingRectangle() {
    const {width:e, height:n, left:r, top:i, right:s, bottom:o} = this;
    return {width:e, height:n, left:r, top:i, right:s, bottom:o};
  }
  get center() {
    const {left:e, top:n, right:r, bottom:i} = this;
    return new Ar((e + r) / 2, (n + i) / 2);
  }
  get area() {
    const {width:e, height:n} = this;
    return e * n;
  }
  equals(e) {
    if (!(e instanceof _a)) {
      return !1;
    }
    const {left:n, top:r, width:i, height:s} = this;
    return n === e.left && r === e.top && i === e.width && s === e.height;
  }
  containsPoint(e) {
    const {top:n, left:r, bottom:i, right:s} = this;
    return n <= e.y && e.y <= i && r <= e.x && e.x <= s;
  }
  intersectionArea(e) {
    return e instanceof _a ? $se(this, e) : 0;
  }
  intersectionRatio(e) {
    const {area:n} = this, r = this.intersectionArea(e);
    return r / (e.area + n - r);
  }
  get bottom() {
    const {top:e, height:n} = this;
    return e + n;
  }
  get right() {
    const {left:e, width:n} = this;
    return e + n;
  }
  get aspectRatio() {
    const {width:e, height:n} = this;
    return e / n;
  }
  get corners() {
    return [{x:this.left, y:this.top}, {x:this.right, y:this.top}, {x:this.left, y:this.bottom}, {x:this.right, y:this.bottom}];
  }
  static from({top:e, left:n, width:r, height:i}) {
    return new _a(n, e, r, i);
  }
  static delta(e, n, r = {x:"center", y:"center"}) {
    const i = (s, o) => {
      const a = r[o], l = o === "x" ? s.left : s.top, c = o === "x" ? s.width : s.height;
      return a == "start" ? l : a == "end" ? l + c : l + c / 2;
    };
    return Ar.delta({x:i(e, "x"), y:i(e, "y")}, {x:i(n, "x"), y:i(n, "y")});
  }
  static intersectionRatio(e, n) {
    return _a.from(e).intersectionRatio(_a.from(n));
  }
};
function $se(t, e) {
  const n = Math.max(e.top, t.top), r = Math.max(e.left, t.left), i = Math.min(e.left + e.width, t.left + t.width), s = Math.min(e.top + e.height, t.top + t.height), o = i - r, a = s - n;
  return r < i && n < s ? o * a : 0;
}
var $P, FP, Wy, Uf, hh, Jg = class extends(Wy = cl, FP = [or], $P = [or], Wy) {
  constructor(e) {
    const n = Ar.from(e);
    super(n, (r, i) => Ar.equals(r, i)), Dse(hh, 5, this), Mse(this, Uf, 0), this.velocity = {x:0, y:0};
  }
  get delta() {
    return Ar.delta(this.current, this.initial);
  }
  get direction() {
    const {current:e, previous:n} = this;
    if (!n) {
      return null;
    }
    const r = {x:e.x - n.x, y:e.y - n.y};
    return !r.x && !r.y ? null : Math.abs(r.x) > Math.abs(r.y) ? r.x > 0 ? "right" : "left" : r.y > 0 ? "down" : "up";
  }
  get current() {
    return super.current;
  }
  set current(e) {
    const {current:n} = this, r = Ar.from(e), i = {x:r.x - n.x, y:r.y - n.y}, s = Date.now(), o = s - Lse(this, Uf), a = l => Math.round(l / o * 100);
    Wn(() => {
      Bse(this, Uf, s), this.velocity = {x:a(i.x), y:a(i.y)}, super.current = r;
    });
  }
  reset(e = this.defaultValue) {
    super.reset(Ar.from(e)), this.velocity = {x:0, y:0};
  }
};
hh = Ose(Wy);
Uf = new WeakMap();
MP(hh, 2, "delta", FP, Jg);
MP(hh, 2, "direction", $P, Jg);
Rse(hh, Jg);
function $0({x:t, y:e}, n) {
  const r = Math.abs(t), i = Math.abs(e);
  return typeof n == "number" ? Math.sqrt(Q2(r, 2) + Q2(i, 2)) > n : "x" in n && "y" in n ? r > n.x && i > n.y : "x" in n ? r > n.x : "y" in n ? i > n.y : !1;
}
var zP = (t => (t.Horizontal = "x", t.Vertical = "y", t))(zP || {}), HP = Object.values(zP), Fse = Object.create, rv = Object.defineProperty, zse = Object.defineProperties, Hse = Object.getOwnPropertyDescriptor, Use = Object.getOwnPropertyDescriptors, Zp = Object.getOwnPropertySymbols, UP = Object.prototype.hasOwnProperty, WP = Object.prototype.propertyIsEnumerable, jP = (t, e) => (e = Symbol[t]) ? e : Symbol.for("Symbol." + t), Lc = t => {
  throw TypeError(t);
}, jy = (t, e, n) => e in t ? rv(t, e, {enumerable:!0, configurable:!0, writable:!0, value:n}) : t[e] = n, VP = (t, e) => {
  for (var n in e || (e = {})) {
    UP.call(e, n) && jy(t, n, e[n]);
  }
  if (Zp) {
    for (var n of Zp(e)) {
      WP.call(e, n) && jy(t, n, e[n]);
    }
  }
  return t;
}, qP = (t, e) => zse(t, Use(e)), K2 = (t, e) => rv(t, "name", {value:e, configurable:!0}), YP = (t, e) => {
  var n = {};
  for (var r in t) {
    UP.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
  }
  if (t != null && Zp) {
    for (var r of Zp(t)) {
      e.indexOf(r) < 0 && WP.call(t, r) && (n[r] = t[r]);
    }
  }
  return n;
}, Mc = t => {
  var e;
  return [, , , Fse((e = t == null ? void 0 : t[jP("metadata")]) != null ? e : null)];
}, GP = ["class", "method", "getter", "setter", "accessor", "field", "value", "get", "set"], bu = t => t !== void 0 && typeof t != "function" ? Lc("Function expected") : t, Wse = (t, e, n, r, i) => ({kind:GP[t], name:e, metadata:r, addInitializer:s => n._ ? Lc("Already initialized") : i.push(bu(s || null))}), ul = (t, e) => jy(e, jP("metadata"), t[3]), _t = (t, e, n, r) => {
  for (var i = 0, s = t[e >> 1], o = s && s.length; i < o; i++) {
    e & 1 ? s[i].call(n) : r = s[i].call(n, r);
  }
  return r;
}, Zt = (t, e, n, r, i, s) => {
  var o, a, l, c, u, h = e & 7, f = !!(e & 8), p = !!(e & 16), g = h > 3 ? t.length + 1 : h ? f ? 1 : 2 : 0, m = GP[h + 5], b = h > 3 && (t[g - 1] = []), x = t[g] || (t[g] = []), w = h && (!p && !f && (i = i.prototype), h < 5 && (h > 3 || !p) && Hse(h < 4 ? i : {get [n]() {
    return fr(this, s);
  }, set [n](T) {
    return es(this, s, T);
  }}, n));
  h ? p && h < 4 && K2(s, (h > 2 ? "set " : h > 1 ? "get " : "") + n) : K2(i, n);
  for (var v = r.length - 1; v >= 0; v--) {
    c = Wse(h, n, l = {}, t[3], x), h && (c.static = f, c.private = p, u = c.access = {has:p ? T => jse(i, T) : T => n in T}, h ^ 3 && (u.get = p ? T => (h ^ 1 ? fr : Vse)(T, i, h ^ 4 ? s : w.get) : T => T[n]), h > 2 && (u.set = p ? (T, I) => es(T, i, I, h ^ 4 ? s : w.set) : (T, I) => T[n] = I)), a = (0,r[v])(h ? h < 4 ? p ? s : w[m] : h > 4 ? void 0 : {get:w.get, set:w.set} : i, c), l._ = 1, h ^ 4 || a === void 0 ? bu(a) && (h > 4 ? b.unshift(a) : h ? p ? s = a : w[m] = a : i = a) : typeof a != 
    "object" || a === null ? Lc("Object expected") : (bu(o = a.get) && (w.get = o), bu(o = a.set) && (w.set = o), bu(o = a.init) && b.unshift(o));
  }
  return h || ul(t, i), w && rv(i, n, w), p ? h ^ 4 ? s : w : i;
}, iv = (t, e, n) => e.has(t) || Lc("Cannot " + n), jse = (t, e) => Object(e) !== e ? Lc('Cannot use the "in" operator on this value') : t.has(e), fr = (t, e, n) => (iv(t, e, "read from private field"), n ? n.call(t) : e.get(t)), pn = (t, e, n) => e.has(t) ? Lc("Cannot add the same private member more than once") : e instanceof WeakSet ? e.add(t) : e.set(t, n), es = (t, e, n, r) => (iv(t, e, "write to private field"), r ? r.call(t, n) : e.set(t, n), n), Vse = (t, e, n) => (iv(t, e, "access private method"), 
n);
function QP(t, e) {
  return {plugin:t, options:e};
}
function sv(t) {
  return e => QP(t, e);
}
function ov(t) {
  return typeof t == "function" ? {plugin:t, options:void 0} : t;
}
var KP, Id, av, Wf;
KP = [Jt];
var vr = class {
  constructor(t, e) {
    this.manager = t, this.options = e, pn(this, av, _t(Id, 8, this, !1)), _t(Id, 11, this), pn(this, Wf, new Set());
  }
  enable() {
    this.disabled = !1;
  }
  disable() {
    this.disabled = !0;
  }
  isDisabled() {
    return on(() => this.disabled);
  }
  configure(t) {
    this.options = t;
  }
  registerEffect(t) {
    const e = si(t.bind(this));
    return fr(this, Wf).add(e), e;
  }
  destroy() {
    fr(this, Wf).forEach(t => t());
  }
  static configure(t) {
    return QP(this, t);
  }
};
Id = Mc(null);
av = new WeakMap();
Wf = new WeakMap();
Zt(Id, 4, "disabled", KP, vr, av);
ul(Id, vr);
var Zg = class extends vr {
}, jf, F0 = class {
  constructor(t) {
    this.manager = t, this.instances = new Map(), pn(this, jf, []);
  }
  get values() {
    return Array.from(this.instances.values());
  }
  set values(t) {
    const e = t.map(ov).reduceRight((r, i) => r.some(({plugin:s}) => s === i.plugin) ? r : [i, ...r], []), n = e.map(({plugin:r}) => r);
    for (const r of fr(this, jf)) {
      if (!n.includes(r)) {
        if (r.prototype instanceof Zg) {
          continue;
        }
        this.unregister(r);
      }
    }
    for (const {plugin:r, options:i} of e) {
      this.register(r, i);
    }
    es(this, jf, n);
  }
  get(t) {
    return this.instances.get(t);
  }
  register(t, e) {
    const n = this.instances.get(t);
    if (n) {
      return n.options !== e && (n.options = e), n;
    }
    const r = new t(this.manager, e);
    return this.instances.set(t, r), r;
  }
  unregister(t) {
    const e = this.instances.get(t);
    e && (e.destroy(), this.instances.delete(t));
  }
  destroy() {
    for (const t of this.instances.values()) {
      t.destroy();
    }
    this.instances.clear();
  }
};
jf = new WeakMap();
function qse(t, e) {
  return t.priority === e.priority ? t.type === e.type ? e.value - t.value : e.type - t.type : e.priority - t.priority;
}
var uf = [], Ol, Pl, Yse = class extends vr {
  constructor(t) {
    super(t), pn(this, Ol), pn(this, Pl), this.computeCollisions = this.computeCollisions.bind(this), es(this, Pl, uh(uf)), this.destroy = dh(() => {
      const e = this.computeCollisions(), n = on(() => this.manager.dragOperation.position.current);
      if (e !== uf) {
        const r = fr(this, Ol);
        if (es(this, Ol, n), r && n.x == r.x && n.y == r.y) {
          return;
        }
      } else {
        es(this, Ol, void 0);
      }
      fr(this, Pl).value = e;
    }, () => {
      const {dragOperation:e} = this.manager;
      e.status.initialized && this.forceUpdate();
    });
  }
  forceUpdate(t = !0) {
    on(() => {
      t ? fr(this, Pl).value = this.computeCollisions() : es(this, Ol, void 0);
    });
  }
  computeCollisions(t, e) {
    const {registry:n, dragOperation:r} = this.manager, {source:i, shape:s, status:o} = r;
    if (!o.initialized || !s) {
      return uf;
    }
    const a = [], l = [];
    for (const c of t ?? n.droppables) {
      if (c.disabled || i && !c.accepts(i)) {
        continue;
      }
      const u = e ?? c.collisionDetector;
      if (!u) {
        continue;
      }
      l.push(c), c.shape;
      const h = on(() => u({droppable:c, dragOperation:r}));
      h && (c.collisionPriority != null && (h.priority = c.collisionPriority), a.push(h));
    }
    return l.length === 0 ? uf : (a.sort(qse), a);
  }
  get collisions() {
    return fr(this, Pl).value;
  }
};
Ol = new WeakMap();
Pl = new WeakMap();
var Gse = class {
  constructor() {
    this.registry = new Map();
  }
  addEventListener(e, n) {
    const {registry:r} = this, i = new Set(r.get(e));
    return i.add(n), r.set(e, i), () => this.removeEventListener(e, n);
  }
  removeEventListener(e, n) {
    const {registry:r} = this, i = new Set(r.get(e));
    i.delete(n), r.set(e, i);
  }
  dispatch(e, ...n) {
    const {registry:r} = this, i = r.get(e);
    if (i) {
      for (const s of i) {
        s(...n);
      }
    }
  }
}, Qse = class extends Gse {
  constructor(t) {
    super(), this.manager = t;
  }
  dispatch(t, e) {
    const n = [e, this.manager];
    super.dispatch(t, ...n);
  }
};
function Vf(t, e = !0) {
  let n = !1;
  return qP(VP({}, t), {cancelable:e, get defaultPrevented() {
    return n;
  }, preventDefault() {
    e && (n = !0);
  }});
}
var Kse = class extends Zg {
  constructor(t) {
    super(t);
    const e = (r, i) => r.map(({id:s}) => s).join("") === i.map(({id:s}) => s).join("");
    let n = [];
    this.destroy = dh(() => {
      const {dragOperation:r, collisionObserver:i} = t;
      r.status.initializing && (n = [], i.enable());
    }, () => {
      const {collisionObserver:r, monitor:i} = t, {collisions:s} = r;
      if (r.isDisabled()) {
        return;
      }
      const o = Vf({collisions:s});
      if (i.dispatch("collision", o), o.defaultPrevented || e(s, n)) {
        return;
      }
      n = s;
      const [a] = s;
      on(() => {
        var l;
        (a == null ? void 0 : a.id) !== ((l = t.dragOperation.target) == null ? void 0 : l.id) && (r.disable(), t.actions.setDropTarget(a == null ? void 0 : a.id).then(() => {
          r.enable();
        }));
      });
    });
  }
}, Li = (t => (t[t.Lowest = 0] = "Lowest", t[t.Low = 1] = "Low", t[t.Normal = 2] = "Normal", t[t.High = 3] = "High", t[t.Highest = 4] = "Highest", t))(Li || {}), zs = (t => (t[t.Collision = 0] = "Collision", t[t.ShapeIntersection = 1] = "ShapeIntersection", t[t.PointerIntersection = 2] = "PointerIntersection", t))(zs || {}), XP, JP, ZP, e4, t4, n4, r4, $i, lv;
r4 = [Jt], n4 = [or], t4 = [or], e4 = [or], ZP = [or], JP = [or], XP = [or];
var yo = class {
  constructor() {
    _t($i, 5, this), pn(this, lv, _t($i, 8, this, "idle")), _t($i, 11, this);
  }
  get current() {
    return this.value;
  }
  get idle() {
    return this.value === "idle";
  }
  get initializing() {
    return this.value === "initializing";
  }
  get initialized() {
    const {value:t} = this;
    return t !== "idle" && t !== "initialization-pending";
  }
  get dragging() {
    return this.value === "dragging";
  }
  get dropped() {
    return this.value === "dropped";
  }
  set(t) {
    this.value = t;
  }
};
$i = Mc(null);
lv = new WeakMap();
Zt($i, 4, "value", r4, yo, lv);
Zt($i, 2, "current", n4, yo);
Zt($i, 2, "idle", t4, yo);
Zt($i, 2, "initializing", e4, yo);
Zt($i, 2, "initialized", ZP, yo);
Zt($i, 2, "dragging", JP, yo);
Zt($i, 2, "dropped", XP, yo);
ul($i, yo);
var Xse = class {
  constructor(t) {
    this.manager = t;
  }
  setDragSource(t) {
    const {dragOperation:e} = this.manager;
    e.sourceIdentifier = typeof t == "string" || typeof t == "number" ? t : t.id;
  }
  setDropTarget(t) {
    return on(() => {
      const {dragOperation:e} = this.manager, n = t ?? null;
      if (e.targetIdentifier === n) {
        return Promise.resolve(!1);
      }
      e.targetIdentifier = n;
      const r = Vf({operation:e.snapshot()});
      return e.status.dragging && this.manager.monitor.dispatch("dragover", r), this.manager.renderer.rendering.then(() => r.defaultPrevented);
    });
  }
  start(t) {
    return on(() => {
      const {dragOperation:e} = this.manager;
      if (t.source != null && this.setDragSource(t.source), !e.source) {
        throw new Error("Cannot start a drag operation without a drag source");
      }
      if (!e.status.idle) {
        throw new Error("Cannot start a drag operation while another is active");
      }
      const r = new AbortController(), {event:i, coordinates:s} = t;
      Wn(() => {
        e.status.set("initialization-pending"), e.shape = null, e.canceled = !1, e.activatorEvent = i ?? null, e.position.reset(s);
      });
      const o = Vf({operation:e.snapshot()});
      return this.manager.monitor.dispatch("beforedragstart", o), o.defaultPrevented ? (e.reset(), r.abort(), r) : (e.status.set("initializing"), e.controller = r, this.manager.renderer.rendering.then(() => {
        if (r.signal.aborted) {
          return;
        }
        const {status:a} = e;
        a.current === "initializing" && (e.status.set("dragging"), this.manager.monitor.dispatch("dragstart", {nativeEvent:i, operation:e.snapshot(), cancelable:!1}));
      }), r);
    });
  }
  move(t) {
    return on(() => {
      var e, n;
      const {dragOperation:r} = this.manager, {status:i, controller:s} = r;
      if (!i.dragging || !s || s.signal.aborted) {
        return;
      }
      const o = Vf({nativeEvent:t.event, operation:r.snapshot(), by:t.by, to:t.to}, (e = t.cancelable) != null ? e : !0);
      ((n = t.propagate) == null || n) && this.manager.monitor.dispatch("dragmove", o), queueMicrotask(() => {
        var a, l, c, u, h;
        if (o.defaultPrevented) {
          return;
        }
        const f = (h = t.to) != null ? h : {x:r.position.current.x + ((l = (a = t.by) == null ? void 0 : a.x) != null ? l : 0), y:r.position.current.y + ((u = (c = t.by) == null ? void 0 : c.y) != null ? u : 0)};
        r.position.current = f;
      });
    });
  }
  stop(t = {}) {
    return on(() => {
      var e, n;
      const {dragOperation:r} = this.manager, {controller:i} = r;
      if (!i || i.signal.aborted) {
        return;
      }
      let s;
      const o = () => {
        const l = {resume:() => {
        }, abort:() => {
        }};
        return s = new Promise((c, u) => {
          l.resume = c, l.abort = u;
        }), l;
      };
      i.abort();
      const a = () => {
        this.manager.renderer.rendering.then(() => {
          r.status.set("dropped");
          const l = on(() => {
            var u;
            return ((u = r.source) == null ? void 0 : u.status) === "dropping";
          }), c = () => {
            r.controller === i && (r.controller = void 0), r.reset();
          };
          if (l) {
            const {source:u} = r, h = si(() => {
              (u == null ? void 0 : u.status) === "idle" && (h(), c());
            });
          } else {
            this.manager.renderer.rendering.then(c);
          }
        });
      };
      r.canceled = (e = t.canceled) != null ? e : !1, this.manager.monitor.dispatch("dragend", {nativeEvent:t.event, operation:r.snapshot(), canceled:(n = t.canceled) != null ? n : !1, suspend:o}), s ? s.then(a).catch(() => r.reset()) : a();
    });
  }
}, i4, s4, o4, a4, Xr, cv, uv, dv, hv;
a4 = [Jt], o4 = [Jt], s4 = [Jt], i4 = [Jt];
var da = class {
  constructor(t, e) {
    pn(this, cv, _t(Xr, 8, this)), _t(Xr, 11, this), pn(this, uv, _t(Xr, 12, this)), _t(Xr, 15, this), pn(this, dv, _t(Xr, 16, this)), _t(Xr, 19, this), pn(this, hv, _t(Xr, 20, this)), _t(Xr, 23, this);
    const {effects:n, id:r, data:i = {}, disabled:s = !1, register:o = !0} = t;
    let a = r;
    this.manager = e, this.id = r, this.data = i, this.disabled = s, this.effects = () => {
      var l;
      return [() => {
        const {id:c, manager:u} = this;
        if (c !== a) {
          return u == null || u.registry.register(this), () => u == null ? void 0 : u.registry.unregister(this);
        }
      }, ...((l = n == null ? void 0 : n()) != null ? l : [])];
    }, this.register = this.register.bind(this), this.unregister = this.unregister.bind(this), this.destroy = this.destroy.bind(this), e && o && queueMicrotask(this.register);
  }
  register() {
    var t;
    return (t = this.manager) == null ? void 0 : t.registry.register(this);
  }
  unregister() {
    var t;
    (t = this.manager) == null || t.registry.unregister(this);
  }
  destroy() {
    var t;
    (t = this.manager) == null || t.registry.unregister(this);
  }
};
Xr = Mc(null);
cv = new WeakMap();
uv = new WeakMap();
dv = new WeakMap();
hv = new WeakMap();
Zt(Xr, 4, "manager", a4, da, cv);
Zt(Xr, 4, "id", o4, da, uv);
Zt(Xr, 4, "data", s4, da, dv);
Zt(Xr, 4, "disabled", i4, da, hv);
ul(Xr, da);
var X2 = class {
  constructor() {
    this.map = uh(new Map()), this.cleanupFunctions = new WeakMap(), this.register = (t, e) => {
      const n = this.map.peek(), r = n.get(t), i = () => this.unregister(t, e);
      if (r === e) {
        return i;
      }
      if (r) {
        const a = this.cleanupFunctions.get(r);
        a == null || a(), this.cleanupFunctions.delete(r);
      }
      const s = new Map(n);
      s.set(t, e), this.map.value = s;
      const o = dh(...e.effects());
      return this.cleanupFunctions.set(e, o), i;
    }, this.unregister = (t, e) => {
      const n = this.map.peek();
      if (n.get(t) !== e) {
        return;
      }
      const r = this.cleanupFunctions.get(e);
      r == null || r(), this.cleanupFunctions.delete(e);
      const i = new Map(n);
      i.delete(t), this.map.value = i;
    };
  }
  [Symbol.iterator]() {
    return this.map.peek().values();
  }
  get value() {
    return this.map.value.values();
  }
  has(t) {
    return this.map.value.has(t);
  }
  get(t) {
    return this.map.value.get(t);
  }
  destroy() {
    for (const t of this) {
      const e = this.cleanupFunctions.get(t);
      e == null || e(), t.destroy();
    }
    this.map.value = new Map();
  }
}, l4, c4, u4, d4, h4, f4, Vy, $r, fv, pv, gv, Ds = class extends(Vy = da, f4 = [Jt], h4 = [Jt], d4 = [Jt], u4 = [or], c4 = [or], l4 = [or], Vy) {
  constructor(e, n) {
    var r = e, {modifiers:i, type:s, sensors:o} = r, a = YP(r, ["modifiers", "type", "sensors"]);
    super(a, n), _t($r, 5, this), pn(this, fv, _t($r, 8, this)), _t($r, 11, this), pn(this, pv, _t($r, 12, this)), _t($r, 15, this), pn(this, gv, _t($r, 16, this, this.isDragSource ? "dragging" : "idle")), _t($r, 19, this), this.type = s, this.sensors = o, this.modifiers = i, this.alignment = a.alignment;
  }
  get isDropping() {
    return this.status === "dropping" && this.isDragSource;
  }
  get isDragging() {
    return this.status === "dragging" && this.isDragSource;
  }
  get isDragSource() {
    var e, n;
    return ((n = (e = this.manager) == null ? void 0 : e.dragOperation.source) == null ? void 0 : n.id) === this.id;
  }
};
$r = Mc(Vy);
fv = new WeakMap();
pv = new WeakMap();
gv = new WeakMap();
Zt($r, 4, "type", f4, Ds, fv);
Zt($r, 4, "modifiers", h4, Ds, pv);
Zt($r, 4, "status", d4, Ds, gv);
Zt($r, 2, "isDropping", u4, Ds);
Zt($r, 2, "isDragging", c4, Ds);
Zt($r, 2, "isDragSource", l4, Ds);
ul($r, Ds);
var p4, g4, m4, b4, y4, x4, qy, tr, mv, bv, yv, xv, vv, Ls = class extends(qy = da, x4 = [Jt], y4 = [Jt], b4 = [Jt], m4 = [Jt], g4 = [Jt], p4 = [or], qy) {
  constructor(e, n) {
    var r = e, {accept:i, collisionDetector:s, collisionPriority:o, type:a} = r, l = YP(r, ["accept", "collisionDetector", "collisionPriority", "type"]);
    super(l, n), _t(tr, 5, this), pn(this, mv, _t(tr, 8, this)), _t(tr, 11, this), pn(this, bv, _t(tr, 12, this)), _t(tr, 15, this), pn(this, yv, _t(tr, 16, this)), _t(tr, 19, this), pn(this, xv, _t(tr, 20, this)), _t(tr, 23, this), pn(this, vv, _t(tr, 24, this)), _t(tr, 27, this), this.accept = i, this.collisionDetector = s, this.collisionPriority = o, this.type = a;
  }
  accepts(e) {
    const {accept:n} = this;
    return n ? typeof n == "function" ? n(e) : e.type ? Array.isArray(n) ? n.includes(e.type) : e.type === n : !1 : !0;
  }
  get isDropTarget() {
    var e, n;
    return ((n = (e = this.manager) == null ? void 0 : e.dragOperation.target) == null ? void 0 : n.id) === this.id;
  }
};
tr = Mc(qy);
mv = new WeakMap();
bv = new WeakMap();
yv = new WeakMap();
xv = new WeakMap();
vv = new WeakMap();
Zt(tr, 4, "accept", x4, Ls, mv);
Zt(tr, 4, "type", y4, Ls, bv);
Zt(tr, 4, "collisionDetector", b4, Ls, yv);
Zt(tr, 4, "collisionPriority", m4, Ls, xv);
Zt(tr, 4, "shape", g4, Ls, vv);
Zt(tr, 2, "isDropTarget", p4, Ls);
ul(tr, Ls);
var bc = class extends vr {
  constructor(t, e) {
    super(t, e), this.manager = t, this.options = e;
  }
}, J2 = class extends vr {
  constructor(t, e) {
    super(t, e), this.manager = t, this.options = e;
  }
  apply(t) {
    return t.transform;
  }
}, Jse = class {
  constructor(t) {
    this.draggables = new X2(), this.droppables = new X2(), this.plugins = new F0(t), this.sensors = new F0(t), this.modifiers = new F0(t);
  }
  register(t, e) {
    if (t instanceof Ds) {
      return this.draggables.register(t.id, t);
    }
    if (t instanceof Ls) {
      return this.droppables.register(t.id, t);
    }
    if (t.prototype instanceof J2) {
      return this.modifiers.register(t, e);
    }
    if (t.prototype instanceof bc) {
      return this.sensors.register(t, e);
    }
    if (t.prototype instanceof vr) {
      return this.plugins.register(t, e);
    }
    throw new Error("Invalid instance type");
  }
  unregister(t) {
    if (t instanceof da) {
      return t instanceof Ds ? this.draggables.unregister(t.id, t) : t instanceof Ls ? this.droppables.unregister(t.id, t) : () => {
      };
    }
    if (t.prototype instanceof J2) {
      return this.modifiers.unregister(t);
    }
    if (t.prototype instanceof bc) {
      return this.sensors.unregister(t);
    }
    if (t.prototype instanceof vr) {
      return this.plugins.unregister(t);
    }
    throw new Error("Invalid instance type");
  }
  destroy() {
    this.draggables.destroy(), this.droppables.destroy(), this.plugins.destroy(), this.sensors.destroy(), this.modifiers.destroy();
  }
}, v4, w4, _4, S4, k4, E4, T4, C4, A4, yu, qf, Rl, Dn, wv, _v, Sv, kv, Ev, xu;
A4 = [or], C4 = [Jt], T4 = [Jt], E4 = [Jt], k4 = [Jt], S4 = [Jt], _4 = [or], w4 = [or], v4 = [or];
var fs = class {
  constructor(t) {
    _t(Dn, 5, this), pn(this, yu), pn(this, qf), pn(this, Rl, new cl(void 0, (e, n) => e && n ? e.equals(n) : e === n)), this.status = new yo(), pn(this, wv, _t(Dn, 8, this, !1)), _t(Dn, 11, this), pn(this, _v, _t(Dn, 12, this, null)), _t(Dn, 15, this), pn(this, Sv, _t(Dn, 16, this, null)), _t(Dn, 19, this), pn(this, kv, _t(Dn, 20, this, null)), _t(Dn, 23, this), pn(this, Ev, _t(Dn, 24, this, [])), _t(Dn, 27, this), this.position = new Jg({x:0, y:0}), pn(this, xu, {x:0, y:0}), es(this, yu, t);
  }
  get shape() {
    const {current:t, initial:e, previous:n} = fr(this, Rl);
    return !t || !e ? null : {current:t, initial:e, previous:n};
  }
  set shape(t) {
    t ? fr(this, Rl).current = t : fr(this, Rl).reset();
  }
  get source() {
    var t;
    const e = this.sourceIdentifier;
    if (e == null) {
      return null;
    }
    const n = fr(this, yu).registry.draggables.get(e);
    return n && es(this, qf, n), (t = n ?? fr(this, qf)) != null ? t : null;
  }
  get target() {
    var t;
    const e = this.targetIdentifier;
    return e != null && (t = fr(this, yu).registry.droppables.get(e)) != null ? t : null;
  }
  get transform() {
    const {x:t, y:e} = this.position.delta;
    let n = {x:t, y:e};
    for (const r of this.modifiers) {
      n = r.apply(qP(VP({}, this.snapshot()), {transform:n}));
    }
    return es(this, xu, n), n;
  }
  snapshot() {
    return on(() => ({source:this.source, target:this.target, activatorEvent:this.activatorEvent, transform:fr(this, xu), shape:this.shape ? B0(this.shape) : null, position:B0(this.position), status:B0(this.status), canceled:this.canceled}));
  }
  reset() {
    Wn(() => {
      this.status.set("idle"), this.sourceIdentifier = null, this.targetIdentifier = null, fr(this, Rl).reset(), this.position.reset({x:0, y:0}), es(this, xu, {x:0, y:0}), this.modifiers = [];
    });
  }
};
Dn = Mc(null);
yu = new WeakMap();
qf = new WeakMap();
Rl = new WeakMap();
wv = new WeakMap();
_v = new WeakMap();
Sv = new WeakMap();
kv = new WeakMap();
Ev = new WeakMap();
xu = new WeakMap();
Zt(Dn, 2, "shape", A4, fs);
Zt(Dn, 4, "canceled", C4, fs, wv);
Zt(Dn, 4, "activatorEvent", T4, fs, _v);
Zt(Dn, 4, "sourceIdentifier", E4, fs, Sv);
Zt(Dn, 4, "targetIdentifier", k4, fs, kv);
Zt(Dn, 4, "modifiers", S4, fs, Ev);
Zt(Dn, 2, "source", _4, fs);
Zt(Dn, 2, "target", w4, fs);
Zt(Dn, 2, "transform", v4, fs);
ul(Dn, fs);
var Zse = {get rendering() {
  return Promise.resolve();
}}, eoe = class {
  constructor(e) {
    this.destroy = () => {
      this.dragOperation.status.idle || this.actions.stop({canceled:!0}), this.dragOperation.modifiers.forEach(u => u.destroy()), this.registry.destroy(), this.collisionObserver.destroy();
    };
    const {plugins:n = [], sensors:r = [], modifiers:i = [], renderer:s = Zse} = e ?? {}, o = new Qse(this), a = new Jse(this);
    this.registry = a, this.monitor = o, this.renderer = s, this.actions = new Xse(this), this.dragOperation = new fs(this), this.collisionObserver = new Yse(this), this.plugins = [Kse, ...n], this.modifiers = i, this.sensors = r;
    const {destroy:l} = this, c = dh(() => {
      var u, h, f;
      const p = on(() => this.dragOperation.modifiers), g = this.modifiers;
      p !== g && p.forEach(m => m.destroy()), this.dragOperation.modifiers = (f = (h = (u = this.dragOperation.source) == null ? void 0 : u.modifiers) == null ? void 0 : h.map(m => {
        const {plugin:b, options:x} = ov(m);
        return new b(this, x);
      })) != null ? f : g;
    });
    this.destroy = () => {
      c(), l();
    };
  }
  get plugins() {
    return this.registry.plugins.values;
  }
  set plugins(e) {
    this.registry.plugins.values = e;
  }
  get modifiers() {
    return this.registry.modifiers.values;
  }
  set modifiers(e) {
    this.registry.modifiers.values = e;
  }
  get sensors() {
    return this.registry.sensors.values;
  }
  set sensors(e) {
    this.registry.sensors.values = e;
  }
}, N4 = t => {
  throw TypeError(t);
}, Tv = (t, e, n) => e.has(t) || N4("Cannot " + n), At = (t, e, n) => (Tv(t, e, "read from private field"), e.get(t)), Kr = (t, e, n) => e.has(t) ? N4("Cannot add the same private member more than once") : e instanceof WeakSet ? e.add(t) : e.set(t, n), gi = (t, e, n, r) => (Tv(t, e, "write to private field"), e.set(t, n), n), I4 = (t, e, n) => (Tv(t, e, "access private method"), n);
function em(t) {
  return t ? t instanceof KeyframeEffect ? !0 : "getKeyframes" in t && typeof t.getKeyframes == "function" : !1;
}
function O4(t, e) {
  const n = t.getAnimations();
  if (n.length > 0) {
    for (const r of n) {
      if (r.playState !== "running") {
        continue;
      }
      const {effect:i} = r, o = (em(i) ? i.getKeyframes() : []).filter(e);
      if (o.length > 0) {
        return [o[o.length - 1], r];
      }
    }
  }
  return null;
}
function tm(t) {
  const {width:e, height:n, top:r, left:i, bottom:s, right:o} = t.getBoundingClientRect();
  return {width:e, height:n, top:r, left:i, bottom:s, right:o};
}
var P4 = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u";
function Cv(t) {
  const e = Object.prototype.toString.call(t);
  return e === "[object Window]" || e === "[object global]";
}
function Av(t) {
  return "nodeType" in t;
}
function xo(t) {
  var e, n, r;
  return t ? Cv(t) ? t : Av(t) ? "defaultView" in t ? (e = t.defaultView) != null ? e : window : (r = (n = t.ownerDocument) == null ? void 0 : n.defaultView) != null ? r : window : window : window;
}
function R4(t) {
  const {Document:e} = xo(t);
  return t instanceof e || "nodeType" in t && t.nodeType === Node.DOCUMENT_NODE;
}
function rl(t) {
  return !t || Cv(t) ? !1 : t instanceof xo(t).HTMLElement || "namespaceURI" in t && typeof t.namespaceURI == "string" && t.namespaceURI.endsWith("html");
}
function D4(t) {
  return t instanceof xo(t).SVGElement || "namespaceURI" in t && typeof t.namespaceURI == "string" && t.namespaceURI.endsWith("svg");
}
function Ms(t) {
  return t ? Cv(t) ? t.document : Av(t) ? R4(t) ? t : rl(t) || D4(t) ? t.ownerDocument : document : document : document;
}
function toe(t) {
  const {documentElement:e} = Ms(t), n = e.clientWidth, r = e.clientHeight;
  return {top:0, left:0, right:n, bottom:r, width:n, height:r};
}
function noe(t, e) {
  if (roe(t) && t.open === !1) {
    return !1;
  }
  const {overflow:n, overflowX:r, overflowY:i} = getComputedStyle(t);
  return n === "visible" && r === "visible" && i === "visible";
}
function roe(t) {
  return t.tagName === "DETAILS";
}
function Od(t, e = t.getBoundingClientRect(), n = 0) {
  var r;
  let i = e;
  const {ownerDocument:s} = t, o = (r = s.defaultView) != null ? r : window;
  let a = t.parentElement;
  for (; a && a !== s.documentElement;) {
    if (!noe(a)) {
      const f = a.getBoundingClientRect(), p = n * (f.bottom - f.top), g = n * (f.right - f.left), m = n * (f.bottom - f.top), b = n * (f.right - f.left);
      i = {top:Math.max(i.top, f.top - p), right:Math.min(i.right, f.right + g), bottom:Math.min(i.bottom, f.bottom + m), left:Math.max(i.left, f.left - b), width:0, height:0}, i.width = i.right - i.left, i.height = i.bottom - i.top;
    }
    a = a.parentElement;
  }
  const l = o.innerWidth, c = o.innerHeight, u = n * c, h = n * l;
  return i = {top:Math.max(i.top, 0 - u), right:Math.min(i.right, l + h), bottom:Math.min(i.bottom, c + u), left:Math.max(i.left, 0 - h), width:0, height:0}, i.width = i.right - i.left, i.height = i.bottom - i.top, i.width < 0 && (i.width = 0), i.height < 0 && (i.height = 0), i;
}
function L4() {
  return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
}
function ioe(t) {
  const e = "input, textarea, select, canvas, [contenteditable]", n = t.cloneNode(!0), r = Array.from(t.querySelectorAll(e));
  return Array.from(n.querySelectorAll(e)).forEach((s, o) => {
    const a = r[o];
    if (Z2(s) && Z2(a) && (s.type !== "file" && (s.value = a.value), s.type === "radio" && s.name && (s.name = `Cloned__${s.name}`)), eE(s) && eE(a) && a.width > 0 && a.height > 0) {
      const l = s.getContext("2d");
      l == null || l.drawImage(a, 0, 0);
    }
  }), n;
}
function Z2(t) {
  return "value" in t;
}
function eE(t) {
  return t.tagName === "CANVAS";
}
function M4(t, {x:e, y:n}) {
  const r = t.elementFromPoint(e, n);
  if (soe(r)) {
    const {contentDocument:i} = r;
    if (i) {
      const {left:s, top:o} = r.getBoundingClientRect();
      return M4(i, {x:e - s, y:n - o});
    }
  }
  return r;
}
function soe(t) {
  return (t == null ? void 0 : t.tagName) === "IFRAME";
}
var Yy = new WeakMap(), B4 = class {
  constructor() {
    this.entries = new Set(), this.clear = () => {
      for (const t of this.entries) {
        const [e, {type:n, listener:r, options:i}] = t;
        e.removeEventListener(n, r, i);
      }
      this.entries.clear();
    };
  }
  bind(t, e) {
    const n = Array.isArray(e) ? e : [e], r = [];
    for (const i of n) {
      const {type:s, listener:o, options:a} = i, l = [t, i];
      t.addEventListener(s, o, a), this.entries.add(l), r.push(l);
    }
    return function() {
      for (const [s, {type:o, listener:a, options:l}] of r) {
        s.removeEventListener(o, a, l);
      }
    };
  }
};
function yc(t) {
  const e = t == null ? void 0 : t.ownerDocument.defaultView;
  if (e && e.self !== e.parent) {
    return e.frameElement;
  }
}
function ooe(t) {
  const e = new Set();
  let n = yc(t);
  for (; n;) {
    e.add(n), n = yc(n);
  }
  return e;
}
function aoe(t, e) {
  const n = setTimeout(t, e);
  return () => clearTimeout(n);
}
function $4(t, e) {
  const n = () => performance.now();
  let r, i;
  return function(...s) {
    const o = this;
    i ? (r == null || r(), r = aoe(() => {
      t.apply(o, s), i = n();
    }, e - (n() - i))) : (t.apply(o, s), i = n());
  };
}
function loe(t, e) {
  return t === e ? !0 : !t || !e ? !1 : t.top == e.top && t.left == e.left && t.right == e.right && t.bottom == e.bottom;
}
function coe(t, e = t.getBoundingClientRect()) {
  const {width:n, height:r} = Od(t, e);
  return n > 0 && r > 0;
}
var uoe = P4 ? ResizeObserver : class {
  observe() {
  }
  unobserve() {
  }
  disconnect() {
  }
}, Yf, doe = class extends uoe {
  constructor(t) {
    super(e => {
      if (!At(this, Yf)) {
        gi(this, Yf, !0);
        return;
      }
      t(e, this);
    }), Kr(this, Yf, !1);
  }
};
Yf = new WeakMap();
var tE = Array.from({length:100}, (t, e) => e / 100), F4 = 75, Sa, eg, Do, ka, vu, hr, id, wu, tg, z4, H4, U4 = class {
  constructor(t, e, n = {debug:!1, skipInitial:!1}) {
    this.element = t, this.callback = e, Kr(this, tg), this.disconnect = () => {
      var s, o, a;
      gi(this, id, !0), (s = At(this, Do)) == null || s.disconnect(), (o = At(this, ka)) == null || o.disconnect(), At(this, vu).disconnect(), (a = At(this, hr)) == null || a.remove();
    }, Kr(this, Sa, !0), Kr(this, eg), Kr(this, Do), Kr(this, ka), Kr(this, vu), Kr(this, hr), Kr(this, id, !1), Kr(this, wu, $4(() => {
      var s, o, a;
      const {element:l} = this;
      if ((s = At(this, ka)) == null || s.disconnect(), At(this, id) || !At(this, Sa) || !l.isConnected) {
        return;
      }
      const c = (o = l.ownerDocument) != null ? o : document, {innerHeight:u, innerWidth:h} = (a = c.defaultView) != null ? a : window, f = l.getBoundingClientRect(), p = Od(l, f), {top:g, left:m, bottom:b, right:x} = p, w = -Math.floor(g), v = -Math.floor(m), T = -Math.floor(h - x), I = -Math.floor(u - b), _ = `${w}px ${T}px ${I}px ${v}px`;
      this.boundingClientRect = f, gi(this, ka, new IntersectionObserver(N => {
        const [E] = N, {intersectionRect:C} = E;
        (E.intersectionRatio !== 1 ? E.intersectionRatio : as.intersectionRatio(C, Od(l))) !== 1 && At(this, wu).call(this);
      }, {threshold:tE, rootMargin:_, root:c})), At(this, ka).observe(l), I4(this, tg, z4).call(this);
    }, F4)), this.boundingClientRect = t.getBoundingClientRect(), gi(this, Sa, coe(t, this.boundingClientRect));
    let r = !0;
    this.callback = s => {
      r && (r = !1, n.skipInitial) || e(s);
    };
    const i = t.ownerDocument;
    n != null && n.debug && (gi(this, hr, document.createElement("div")), At(this, hr).style.background = "rgba(0,0,0,0.15)", At(this, hr).style.position = "fixed", At(this, hr).style.pointerEvents = "none", i.body.appendChild(At(this, hr))), gi(this, vu, new IntersectionObserver(s => {
      var o, a;
      const l = s[s.length - 1], {boundingClientRect:c, isIntersecting:u} = l, {width:h, height:f} = c, p = At(this, Sa);
      gi(this, Sa, u), !(!h && !f) && (p && !u ? ((o = At(this, ka)) == null || o.disconnect(), this.callback(null), (a = At(this, Do)) == null || a.disconnect(), gi(this, Do, void 0), At(this, hr) && (At(this, hr).style.visibility = "hidden")) : At(this, wu).call(this), u && !At(this, Do) && (gi(this, Do, new doe(At(this, wu))), At(this, Do).observe(t)));
    }, {threshold:tE, root:i})), At(this, Sa) && !n.skipInitial && this.callback(this.boundingClientRect), At(this, vu).observe(t);
  }
};
Sa = new WeakMap();
eg = new WeakMap();
Do = new WeakMap();
ka = new WeakMap();
vu = new WeakMap();
hr = new WeakMap();
id = new WeakMap();
wu = new WeakMap();
tg = new WeakSet();
z4 = function() {
  At(this, id) || (I4(this, tg, H4).call(this), !loe(this.boundingClientRect, At(this, eg)) && (this.callback(this.boundingClientRect), gi(this, eg, this.boundingClientRect)));
};
H4 = function() {
  if (At(this, hr)) {
    const {top:t, left:e, width:n, height:r} = Od(this.element);
    At(this, hr).style.overflow = "hidden", At(this, hr).style.visibility = "visible", At(this, hr).style.top = `${Math.floor(t)}px`, At(this, hr).style.left = `${Math.floor(e)}px`, At(this, hr).style.width = `${Math.floor(n)}px`, At(this, hr).style.height = `${Math.floor(r)}px`;
  }
};
var df = new WeakMap(), hf = new WeakMap();
function hoe(t, e) {
  let n = df.get(t);
  return n || (n = {disconnect:(new U4(t, i => {
    const s = df.get(t);
    s && s.callbacks.forEach(o => o(i));
  }, {skipInitial:!0})).disconnect, callbacks:new Set()}), n.callbacks.add(e), df.set(t, n), () => {
    n.callbacks.delete(e), n.callbacks.size === 0 && (df.delete(t), n.disconnect());
  };
}
function foe(t, e) {
  const n = new Set();
  for (const r of t) {
    const i = hoe(r, e);
    n.add(i);
  }
  return () => n.forEach(r => r());
}
function poe(t, e) {
  var n;
  const r = t.ownerDocument;
  if (!hf.has(r)) {
    const o = new AbortController(), a = new Set();
    document.addEventListener("scroll", l => a.forEach(c => c(l)), {capture:!0, passive:!0, signal:o.signal}), hf.set(r, {disconnect:() => o.abort(), listeners:a});
  }
  const {listeners:i, disconnect:s} = (n = hf.get(r)) != null ? n : {};
  return !i || !s ? () => {
  } : (i.add(e), () => {
    i.delete(e), i.size === 0 && (s(), hf.delete(r));
  });
}
var _u, Su, Gf, Gy, goe = class {
  constructor(t, e, n) {
    this.callback = e, Kr(this, _u), Kr(this, Su, !1), Kr(this, Gf), Kr(this, Gy, $4(o => {
      if (!At(this, Su) && o.target && "contains" in o.target && typeof o.target.contains == "function") {
        for (const a of At(this, Gf)) {
          if (o.target.contains(a)) {
            this.callback(At(this, _u).boundingClientRect);
            break;
          }
        }
      }
    }, F4));
    const r = ooe(t), i = foe(r, e), s = poe(t, At(this, Gy));
    gi(this, Gf, r), gi(this, _u, new U4(t, e, n)), this.disconnect = () => {
      At(this, Su) || (gi(this, Su, !0), i(), s(), At(this, _u).disconnect());
    };
  }
};
_u = new WeakMap();
Su = new WeakMap();
Gf = new WeakMap();
Gy = new WeakMap();
function Qy(t) {
  return "showPopover" in t && "hidePopover" in t && typeof t.showPopover == "function" && typeof t.hidePopover == "function";
}
function ku(t) {
  try {
    Qy(t) && t.isConnected && t.hasAttribute("popover") && !t.matches(":popover-open") && t.showPopover();
  } catch {
  }
}
function nE(t) {
  return !P4 || !t ? !1 : t === Ms(t).scrollingElement;
}
function W4(t) {
  const e = xo(t), n = nE(t) ? toe(t) : tm(t), r = nE(t) ? {height:e.innerHeight, width:e.innerWidth} : {height:t.clientHeight, width:t.clientWidth}, i = {current:{x:t.scrollLeft, y:t.scrollTop}, max:{x:t.scrollWidth - r.width, y:t.scrollHeight - r.height}}, s = i.current.y <= 0, o = i.current.x <= 0, a = i.current.y >= i.max.y, l = i.current.x >= i.max.x;
  return {rect:n, position:i, isTop:s, isLeft:o, isBottom:a, isRight:l};
}
function moe(t, e) {
  const {isTop:n, isBottom:r, isLeft:i, isRight:s, position:o} = W4(t), {x:a, y:l} = e ?? {x:0, y:0}, c = !n && o.current.y + l > 0, u = !r && o.current.y + l < o.max.y, h = !i && o.current.x + a > 0, f = !s && o.current.x + a < o.max.x;
  return {top:c, bottom:u, left:h, right:f, x:h || f, y:c || u};
}
var Nv = class {
  constructor(e) {
    this.scheduler = e, this.pending = !1, this.tasks = new Set(), this.resolvers = new Set(), this.flush = () => {
      const {tasks:n, resolvers:r} = this;
      this.pending = !1, this.tasks = new Set(), this.resolvers = new Set();
      for (const i of n) {
        i();
      }
      for (const i of r) {
        i();
      }
    };
  }
  schedule(e) {
    return this.tasks.add(e), this.pending || (this.pending = !0, this.scheduler(this.flush)), new Promise(n => this.resolvers.add(n));
  }
}, ng = new Nv(t => {
  typeof requestAnimationFrame == "function" ? requestAnimationFrame(t) : t();
}), boe = new Nv(t => setTimeout(t, 50)), rg = new Map(), yoe = rg.clear.bind(rg);
function ls(t, e = !1) {
  if (!e) {
    return rE(t);
  }
  let n = rg.get(t);
  return n || (n = rE(t), rg.set(t, n), boe.schedule(yoe), n);
}
function rE(t) {
  return xo(t).getComputedStyle(t);
}
function xoe(t, e = ls(t, !0)) {
  return e.position === "fixed" || e.position === "sticky";
}
function voe(t, e = ls(t, !0)) {
  const n = /(auto|scroll|overlay)/;
  return ["overflow", "overflowX", "overflowY"].some(i => {
    const s = e[i];
    return typeof s == "string" ? n.test(s) : !1;
  });
}
var woe = {excludeElement:!0};
function Ky(t, e = woe) {
  const {limit:n, excludeElement:r} = e, i = new Set();
  function s(o) {
    if (n != null && i.size >= n || !o) {
      return i;
    }
    if (R4(o) && o.scrollingElement != null && !i.has(o.scrollingElement)) {
      return i.add(o.scrollingElement), i;
    }
    if (!rl(o)) {
      return D4(o) ? s(o.parentElement) : i;
    }
    if (i.has(o)) {
      return i;
    }
    const a = ls(o, !0);
    if (r && o === t || voe(o, a) && i.add(o), xoe(o, a)) {
      const {scrollingElement:l} = o.ownerDocument;
      return l && i.add(l), i;
    }
    return s(o.parentNode);
  }
  return t ? s(t) : i;
}
function _oe(t) {
  const [e] = Ky(t, {limit:1});
  return e ?? null;
}
function xc(t, e = window.frameElement) {
  const n = {x:0, y:0, scaleX:1, scaleY:1};
  if (!t) {
    return n;
  }
  let r = yc(t);
  for (; r;) {
    if (r === e) {
      return n;
    }
    const i = tm(r), {x:s, y:o} = Soe(r, i);
    n.x = n.x + i.left, n.y = n.y + i.top, n.scaleX = n.scaleX * s, n.scaleY = n.scaleY * o, r = yc(r);
  }
  return n;
}
function Soe(t, e = tm(t)) {
  const n = Math.round(e.width), r = Math.round(e.height);
  if (rl(t)) {
    return {x:n / t.offsetWidth, y:r / t.offsetHeight};
  }
  const i = ls(t, !0);
  return {x:(parseFloat(i.width) || n) / n, y:(parseFloat(i.height) || r) / r};
}
function koe(t) {
  if (t === "none") {
    return null;
  }
  const e = t.split(" "), n = parseFloat(e[0]), r = parseFloat(e[1]);
  return isNaN(n) && isNaN(r) ? null : {x:isNaN(n) ? r : n, y:isNaN(r) ? n : r};
}
function Pd(t) {
  if (t === "none") {
    return null;
  }
  const [e, n, r = "0"] = t.split(" "), i = {x:parseFloat(e), y:parseFloat(n), z:parseInt(r, 10)};
  return isNaN(i.x) && isNaN(i.y) ? null : {x:isNaN(i.x) ? 0 : i.x, y:isNaN(i.y) ? 0 : i.y, z:isNaN(i.z) ? 0 : i.z};
}
function Iv(t) {
  var e, n, r, i, s, o, a, l, c;
  const {scale:u, transform:h, translate:f} = t, p = koe(u), g = Pd(f), m = Eoe(h);
  if (!m && !p && !g) {
    return null;
  }
  const b = {x:(e = p == null ? void 0 : p.x) != null ? e : 1, y:(n = p == null ? void 0 : p.y) != null ? n : 1}, x = {x:(r = g == null ? void 0 : g.x) != null ? r : 0, y:(i = g == null ? void 0 : g.y) != null ? i : 0}, w = {x:(s = m == null ? void 0 : m.x) != null ? s : 0, y:(o = m == null ? void 0 : m.y) != null ? o : 0, scaleX:(a = m == null ? void 0 : m.scaleX) != null ? a : 1, scaleY:(l = m == null ? void 0 : m.scaleY) != null ? l : 1};
  return {x:x.x + w.x, y:x.y + w.y, z:(c = g == null ? void 0 : g.z) != null ? c : 0, scaleX:b.x * w.scaleX, scaleY:b.y * w.scaleY};
}
function Eoe(t) {
  if (t.startsWith("matrix3d(")) {
    const e = t.slice(9, -1).split(/, /);
    return {x:+e[12], y:+e[13], scaleX:+e[0], scaleY:+e[5]};
  } else if (t.startsWith("matrix(")) {
    const e = t.slice(7, -1).split(/, /);
    return {x:+e[4], y:+e[5], scaleX:+e[0], scaleY:+e[3]};
  }
  return null;
}
var Mi = (t => (t[t.Idle = 0] = "Idle", t[t.Forward = 1] = "Forward", t[t.Reverse = -1] = "Reverse", t))(Mi || {}), Toe = {x:0.2, y:0.2}, Coe = {x:10, y:10};
function Aoe(t, e, n, r = 25, i = Toe, s = Coe) {
  const {x:o, y:a} = e, {rect:l, isTop:c, isBottom:u, isLeft:h, isRight:f} = W4(t), p = xc(t), g = ls(t, !0), m = Iv(g), b = m !== null ? (m == null ? void 0 : m.scaleX) < 0 : !1, x = m !== null ? (m == null ? void 0 : m.scaleY) < 0 : !1, w = new as(l.left * p.scaleX + p.x, l.top * p.scaleY + p.y, l.width * p.scaleX, l.height * p.scaleY), v = {x:0, y:0}, T = {x:0, y:0}, I = {height:w.height * i.y, width:w.width * i.x};
  return (!c || x && !u) && a <= w.top + I.height && (n == null ? void 0 : n.y) !== 1 && o >= w.left - s.x && o <= w.right + s.x ? (v.y = x ? 1 : -1, T.y = r * Math.abs((w.top + I.height - a) / I.height)) : (!u || x && !c) && a >= w.bottom - I.height && (n == null ? void 0 : n.y) !== -1 && o >= w.left - s.x && o <= w.right + s.x && (v.y = x ? -1 : 1, T.y = r * Math.abs((w.bottom - I.height - a) / I.height)), (!f || b && !h) && o >= w.right - I.width && (n == null ? void 0 : n.x) !== -1 && a >= w.top - 
  s.y && a <= w.bottom + s.y ? (v.x = b ? -1 : 1, T.x = r * Math.abs((w.right - I.width - o) / I.width)) : (!h || b && !f) && o <= w.left + I.width && (n == null ? void 0 : n.x) !== 1 && a >= w.top - s.y && a <= w.bottom + s.y && (v.x = b ? 1 : -1, T.x = r * Math.abs((w.left + I.width - o) / I.width)), {direction:v, speed:T};
}
function Noe(t) {
  return "scrollIntoViewIfNeeded" in t && typeof t.scrollIntoViewIfNeeded == "function";
}
function j4(t, e = !1) {
  if (Noe(t)) {
    t.scrollIntoViewIfNeeded(e);
    return;
  }
  if (!rl(t)) {
    return t.scrollIntoView();
  }
  var n = _oe(t);
  if (!rl(n)) {
    return;
  }
  const r = ls(n, !0), i = parseInt(r.getPropertyValue("border-top-width")), s = parseInt(r.getPropertyValue("border-left-width")), o = t.offsetTop - n.offsetTop < n.scrollTop, a = t.offsetTop - n.offsetTop + t.clientHeight - i > n.scrollTop + n.clientHeight, l = t.offsetLeft - n.offsetLeft < n.scrollLeft, c = t.offsetLeft - n.offsetLeft + t.clientWidth - s > n.scrollLeft + n.clientWidth, u = o && !a;
  (o || a) && e && (n.scrollTop = t.offsetTop - n.offsetTop - n.clientHeight / 2 - i + t.clientHeight / 2), (l || c) && e && (n.scrollLeft = t.offsetLeft - n.offsetLeft - n.clientWidth / 2 - s + t.clientWidth / 2), (o || a || l || c) && !e && t.scrollIntoView(u);
}
function Ioe(t, e, n) {
  const {scaleX:r, scaleY:i, x:s, y:o} = e, a = t.left + s + (1 - r) * parseFloat(n), l = t.top + o + (1 - i) * parseFloat(n.slice(n.indexOf(" ") + 1)), c = r ? t.width * r : t.width, u = i ? t.height * i : t.height;
  return {width:c, height:u, top:l, right:a + c, bottom:l + u, left:a};
}
function Ooe(t, e, n) {
  const {scaleX:r, scaleY:i, x:s, y:o} = e, a = t.left - s - (1 - r) * parseFloat(n), l = t.top - o - (1 - i) * parseFloat(n.slice(n.indexOf(" ") + 1)), c = r ? t.width / r : t.width, u = i ? t.height / i : t.height;
  return {width:c, height:u, top:l, right:a + c, bottom:l + u, left:a};
}
function V4({element:t, keyframes:e, options:n}) {
  return t.animate(e, n).finished;
}
function iE(t, e = ls(t).translate, n = !0) {
  if (n) {
    const r = O4(t, i => "translate" in i);
    if (r) {
      const {translate:i = ""} = r[0];
      if (typeof i == "string") {
        const s = Pd(i);
        if (s) {
          return s;
        }
      }
    }
  }
  if (e) {
    const r = Pd(e);
    if (r) {
      return r;
    }
  }
  return {x:0, y:0, z:0};
}
var Poe = new Nv(t => setTimeout(t, 0)), sd = new Map(), Roe = sd.clear.bind(sd);
function Doe(t) {
  const e = t.ownerDocument;
  let n = sd.get(e);
  if (n) {
    return n;
  }
  n = e.getAnimations(), sd.set(e, n), Poe.schedule(Roe);
  const r = n.filter(i => em(i.effect) && i.effect.target === t);
  return sd.set(t, r), n;
}
function Loe(t, e) {
  const n = Doe(t).filter(r => {
    var i, s;
    if (em(r.effect)) {
      const {target:o} = r.effect;
      if ((s = o && ((i = e.isValidTarget) == null ? void 0 : i.call(e, o))) != null ? s : !0) {
        return r.effect.getKeyframes().some(l => {
          for (const c of e.properties) {
            if (l[c]) {
              return !0;
            }
          }
        });
      }
    }
  }).map(r => {
    const {effect:i, currentTime:s} = r, o = i == null ? void 0 : i.getComputedTiming().duration;
    if (!(r.pending || r.playState === "finished") && typeof o == "number" && typeof s == "number" && s < o) {
      return r.currentTime = o, () => {
        r.currentTime = s;
      };
    }
  });
  if (n.length > 0) {
    return () => n.forEach(r => r == null ? void 0 : r());
  }
}
var qi = class extends as {
  constructor(t, e = {}) {
    var n, r, i, s;
    const {frameTransform:o = xc(t), ignoreTransforms:a, getBoundingClientRect:l = tm} = e, c = Loe(t, {properties:["transform", "translate", "scale", "width", "height"], isValidTarget:I => (I !== t || L4()) && I.contains(t)}), u = l(t);
    let {top:h, left:f, width:p, height:g} = u, m;
    const b = ls(t), x = Iv(b), w = {x:(n = x == null ? void 0 : x.scaleX) != null ? n : 1, y:(r = x == null ? void 0 : x.scaleY) != null ? r : 1}, v = Moe(t, b);
    c == null || c(), x && (m = Ooe(u, x, b.transformOrigin), (a || v) && (h = m.top, f = m.left, p = m.width, g = m.height));
    const T = {width:(i = m == null ? void 0 : m.width) != null ? i : p, height:(s = m == null ? void 0 : m.height) != null ? s : g};
    if (v && !a && m) {
      const I = Ioe(m, v, b.transformOrigin);
      h = I.top, f = I.left, p = I.width, g = I.height, w.x = v.scaleX, w.y = v.scaleY;
    }
    o && (a || (f *= o.scaleX, p *= o.scaleX, h *= o.scaleY, g *= o.scaleY), f += o.x, h += o.y), super(f, h, p, g), this.scale = w, this.intrinsicWidth = T.width, this.intrinsicHeight = T.height;
  }
};
function Moe(t, e) {
  var n;
  const r = t.getAnimations();
  let i = null;
  if (!r.length) {
    return null;
  }
  for (const s of r) {
    if (s.playState !== "running") {
      continue;
    }
    const o = em(s.effect) ? s.effect.getKeyframes() : [], a = o[o.length - 1];
    if (!a) {
      continue;
    }
    const {transform:l, translate:c, scale:u} = a;
    if (l || c || u) {
      const h = Iv({transform:typeof l == "string" && l ? l : e.transform, translate:typeof c == "string" && c ? c : e.translate, scale:typeof u == "string" && u ? u : e.scale});
      h && (i = i ? {x:i.x + h.x, y:i.y + h.y, z:(n = i.z) != null ? n : h.z, scaleX:i.scaleX * h.scaleX, scaleY:i.scaleY * h.scaleY} : h);
    }
  }
  return i;
}
function od(t) {
  return "style" in t && typeof t.style == "object" && t.style !== null && "setProperty" in t.style && "removeProperty" in t.style && typeof t.style.setProperty == "function" && typeof t.style.removeProperty == "function";
}
var Boe = class {
  constructor(t) {
    this.element = t, this.initial = new Map();
  }
  set(t, e = "") {
    const {element:n} = this;
    if (od(n)) {
      for (const [r, i] of Object.entries(t)) {
        const s = `${e}${r}`;
        this.initial.has(s) || this.initial.set(s, n.style.getPropertyValue(s)), n.style.setProperty(s, typeof i == "string" ? i : `${i}px`);
      }
    }
  }
  remove(t, e = "") {
    const {element:n} = this;
    if (od(n)) {
      for (const r of t) {
        const i = `${e}${r}`;
        n.style.removeProperty(i);
      }
    }
  }
  reset() {
    const {element:t} = this;
    if (od(t)) {
      for (const [e, n] of this.initial) {
        t.style.setProperty(e, n);
      }
      t.getAttribute("style") === "" && t.removeAttribute("style");
    }
  }
};
function Bc(t) {
  return t ? t instanceof xo(t).Element || Av(t) && t.nodeType === Node.ELEMENT_NODE : !1;
}
function Rd(t) {
  if (!t) {
    return !1;
  }
  const {KeyboardEvent:e} = xo(t.target);
  return t instanceof e;
}
function $oe(t) {
  if (!t) {
    return !1;
  }
  const {PointerEvent:e} = xo(t.target);
  return t instanceof e;
}
function Foe(t) {
  if (!Bc(t)) {
    return !1;
  }
  const {tagName:e} = t;
  return e === "INPUT" || e === "TEXTAREA" || zoe(t);
}
function zoe(t) {
  return t.hasAttribute("contenteditable") && t.getAttribute("contenteditable") !== "false";
}
var z0 = {};
function Xy(t) {
  const e = z0[t] == null ? 0 : z0[t] + 1;
  return z0[t] = e, `${t}-${e}`;
}
var Hoe = ({dragOperation:t, droppable:e}) => {
  const n = t.position.current;
  if (!n) {
    return null;
  }
  const {id:r} = e;
  if (!e.shape) {
    return null;
  }
  if (e.shape.containsPoint(n)) {
    const i = Ar.distance(e.shape.center, n);
    return {id:r, value:1 / i, type:zs.PointerIntersection, priority:Li.High};
  }
  return null;
}, Uoe = ({dragOperation:t, droppable:e}) => {
  const {shape:n} = t;
  if (!e.shape || !(n != null && n.current)) {
    return null;
  }
  const r = n.current.intersectionArea(e.shape);
  if (r) {
    const {position:i} = t, s = Ar.distance(e.shape.center, i.current), a = r / (n.current.area + e.shape.area - r) / s;
    return {id:e.id, value:a, type:zs.ShapeIntersection, priority:Li.Normal};
  }
  return null;
}, q4 = t => {
  var e;
  return (e = Hoe(t)) != null ? e : Uoe(t);
}, Woe = t => {
  const {dragOperation:e, droppable:n} = t, {shape:r, position:i} = e;
  if (!n.shape) {
    return null;
  }
  const s = r ? as.from(r.current.boundingRectangle).corners : void 0, a = as.from(n.shape.boundingRectangle).corners.reduce((l, c, u) => {
    var h;
    return l + Ar.distance(Ar.from(c), (h = s == null ? void 0 : s[u]) != null ? h : i.current);
  }, 0) / 4;
  return {id:n.id, value:1 / a, type:zs.Collision, priority:Li.Normal};
}, joe = Object.create, Ov = Object.defineProperty, Voe = Object.defineProperties, qoe = Object.getOwnPropertyDescriptor, Yoe = Object.getOwnPropertyDescriptors, ig = Object.getOwnPropertySymbols, Y4 = Object.prototype.hasOwnProperty, G4 = Object.prototype.propertyIsEnumerable, Q4 = (t, e) => (e = Symbol[t]) ? e : Symbol.for("Symbol." + t), $c = t => {
  throw TypeError(t);
}, Jy = (t, e, n) => e in t ? Ov(t, e, {enumerable:!0, configurable:!0, writable:!0, value:n}) : t[e] = n, Dd = (t, e) => {
  for (var n in e || (e = {})) {
    Y4.call(e, n) && Jy(t, n, e[n]);
  }
  if (ig) {
    for (var n of ig(e)) {
      G4.call(e, n) && Jy(t, n, e[n]);
    }
  }
  return t;
}, Pv = (t, e) => Voe(t, Yoe(e)), sE = (t, e) => Ov(t, "name", {value:e, configurable:!0}), K4 = (t, e) => {
  var n = {};
  for (var r in t) {
    Y4.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
  }
  if (t != null && ig) {
    for (var r of ig(t)) {
      e.indexOf(r) < 0 && G4.call(t, r) && (n[r] = t[r]);
    }
  }
  return n;
}, fh = t => {
  var e;
  return [, , , joe((e = t == null ? void 0 : t[Q4("metadata")]) != null ? e : null)];
}, X4 = ["class", "method", "getter", "setter", "accessor", "field", "value", "get", "set"], Eu = t => t !== void 0 && typeof t != "function" ? $c("Function expected") : t, Goe = (t, e, n, r, i) => ({kind:X4[t], name:e, metadata:r, addInitializer:s => n._ ? $c("Already initialized") : i.push(Eu(s || null))}), Fc = (t, e) => Jy(e, Q4("metadata"), t[3]), ar = (t, e, n, r) => {
  for (var i = 0, s = t[e >> 1], o = s && s.length; i < o; i++) {
    e & 1 ? s[i].call(n) : r = s[i].call(n, r);
  }
  return r;
}, vo = (t, e, n, r, i, s) => {
  var o, a, l, c, u, h = e & 7, f = !!(e & 8), p = !!(e & 16), g = h > 3 ? t.length + 1 : h ? f ? 1 : 2 : 0, m = X4[h + 5], b = h > 3 && (t[g - 1] = []), x = t[g] || (t[g] = []), w = h && (!p && !f && (i = i.prototype), h < 5 && (h > 3 || !p) && qoe(h < 4 ? i : {get [n]() {
    return gr(this, s);
  }, set [n](T) {
    return rs(this, s, T);
  }}, n));
  h ? p && h < 4 && sE(s, (h > 2 ? "set " : h > 1 ? "get " : "") + n) : sE(i, n);
  for (var v = r.length - 1; v >= 0; v--) {
    c = Goe(h, n, l = {}, t[3], x), h && (c.static = f, c.private = p, u = c.access = {has:p ? T => Qoe(i, T) : T => n in T}, h ^ 3 && (u.get = p ? T => (h ^ 1 ? gr : Zy)(T, i, h ^ 4 ? s : w.get) : T => T[n]), h > 2 && (u.set = p ? (T, I) => rs(T, i, I, h ^ 4 ? s : w.set) : (T, I) => T[n] = I)), a = (0,r[v])(h ? h < 4 ? p ? s : w[m] : h > 4 ? void 0 : {get:w.get, set:w.set} : i, c), l._ = 1, h ^ 4 || a === void 0 ? Eu(a) && (h > 4 ? b.unshift(a) : h ? p ? s = a : w[m] = a : i = a) : typeof a != "object" || 
    a === null ? $c("Object expected") : (Eu(o = a.get) && (w.get = o), Eu(o = a.set) && (w.set = o), Eu(o = a.init) && b.unshift(o));
  }
  return h || Fc(t, i), w && Ov(i, n, w), p ? h ^ 4 ? s : w : i;
}, Rv = (t, e, n) => e.has(t) || $c("Cannot " + n), Qoe = (t, e) => Object(e) !== e ? $c('Cannot use the "in" operator on this value') : t.has(e), gr = (t, e, n) => (Rv(t, e, "read from private field"), n ? n.call(t) : e.get(t)), yr = (t, e, n) => e.has(t) ? $c("Cannot add the same private member more than once") : e instanceof WeakSet ? e.add(t) : e.set(t, n), rs = (t, e, n, r) => (Rv(t, e, "write to private field"), r ? r.call(t, n) : e.set(t, n), n), Zy = (t, e, n) => (Rv(t, e, "access private method"), 
n), oE = {role:"button", roleDescription:"draggable"}, Koe = "dnd-kit-description", Xoe = "dnd-kit-announcement", Joe = {draggable:"To pick up a draggable item, press the space bar. While dragging, use the arrow keys to move the item in a given direction. Press space again to drop the item in its new position, or press escape to cancel."}, Zoe = {dragstart({operation:{source:t}}) {
  if (t) {
    return `Picked up draggable item ${t.id}.`;
  }
}, dragover({operation:{source:t, target:e}}) {
  if (!(!t || t.id === (e == null ? void 0 : e.id))) {
    return e ? `Draggable item ${t.id} was moved over droppable target ${e.id}.` : `Draggable item ${t.id} is no longer over a droppable target.`;
  }
}, dragend({operation:{source:t, target:e}, canceled:n}) {
  if (t) {
    return n ? `Dragging was cancelled. Draggable item ${t.id} was dropped.` : e ? `Draggable item ${t.id} was dropped over droppable target ${e.id}` : `Draggable item ${t.id} was dropped.`;
  }
}};
function eae(t) {
  const e = t.tagName.toLowerCase();
  return ["input", "select", "textarea", "a", "button"].includes(e);
}
function tae(t, e) {
  const n = document.createElement("div");
  return n.id = t, n.style.setProperty("display", "none"), n.textContent = e, n;
}
function nae(t) {
  const e = document.createElement("div");
  return e.id = t, e.setAttribute("role", "status"), e.setAttribute("aria-live", "polite"), e.setAttribute("aria-atomic", "true"), e.style.setProperty("position", "fixed"), e.style.setProperty("width", "1px"), e.style.setProperty("height", "1px"), e.style.setProperty("margin", "-1px"), e.style.setProperty("border", "0"), e.style.setProperty("padding", "0"), e.style.setProperty("overflow", "hidden"), e.style.setProperty("clip", "rect(0 0 0 0)"), e.style.setProperty("clip-path", "inset(100%)"), e.style.setProperty("white-space", 
  "nowrap"), e;
}
var rae = ["dragover", "dragmove"], iae = class extends vr {
  constructor(t, e) {
    super(t);
    const {id:n, idPrefix:{description:r = Koe, announcement:i = Xoe} = {}, announcements:s = Zoe, screenReaderInstructions:o = Joe, debounce:a = 500} = e ?? {}, l = n ? `${r}-${n}` : Xy(r), c = n ? `${i}-${n}` : Xy(i);
    let u, h, f, p;
    const g = (I = p) => {
      !f || !I || (f == null ? void 0 : f.nodeValue) !== I && (f.nodeValue = I);
    }, m = () => ng.schedule(g), b = sae(m, a), x = Object.entries(s).map(([I, _]) => this.manager.monitor.addEventListener(I, (N, E) => {
      const C = f;
      if (!C) {
        return;
      }
      const k = _ == null ? void 0 : _(N, E);
      k && C.nodeValue !== k && (p = k, rae.includes(I) ? b() : (m(), b.cancel()));
    })), w = () => {
      let I = [];
      u != null && u.isConnected || (u = tae(l, o.draggable), I.push(u)), h != null && h.isConnected || (h = nae(c), f = document.createTextNode(""), h.appendChild(f), I.push(h)), I.length > 0 && document.body.append(...I);
    }, v = new Set();
    function T() {
      for (const I of v) {
        I();
      }
    }
    this.registerEffect(() => {
      var I;
      v.clear();
      for (const _ of this.manager.registry.draggables.value) {
        const N = (I = _.handle) != null ? I : _.element;
        if (N) {
          (!u || !h) && v.add(w), (!eae(N) || L4()) && !N.hasAttribute("tabindex") && v.add(() => N.setAttribute("tabindex", "0")), !N.hasAttribute("role") && N.tagName.toLowerCase() !== "button" && v.add(() => N.setAttribute("role", oE.role)), N.hasAttribute("aria-roledescription") || v.add(() => N.setAttribute("aria-roledescription", oE.roleDescription)), N.hasAttribute("aria-describedby") || v.add(() => N.setAttribute("aria-describedby", l));
          for (const C of ["aria-pressed", "aria-grabbed"]) {
            const k = String(_.isDragging);
            N.getAttribute(C) !== k && v.add(() => N.setAttribute(C, k));
          }
          const E = String(_.disabled);
          N.getAttribute("aria-disabled") !== E && v.add(() => N.setAttribute("aria-disabled", E));
        }
      }
      v.size > 0 && ng.schedule(T);
    }), this.destroy = () => {
      super.destroy(), u == null || u.remove(), h == null || h.remove(), x.forEach(I => I());
    };
  }
};
function sae(t, e) {
  let n;
  const r = () => {
    clearTimeout(n), n = setTimeout(t, e);
  };
  return r.cancel = () => clearTimeout(n), r;
}
var oae = class extends vr {
  constructor(t, e) {
    super(t, e), this.manager = t;
    const n = Jp(() => {
      var r;
      return Ms((r = this.manager.dragOperation.source) == null ? void 0 : r.element);
    });
    this.destroy = si(() => {
      var r;
      const {dragOperation:i} = this.manager, {cursor:s = "grabbing", nonce:o} = (r = this.options) != null ? r : {};
      if (i.status.initialized) {
        const a = n.value, l = a.createElement("style");
        return o && l.setAttribute("nonce", o), l.textContent = `* { cursor: ${s} !important; }`, a.head.appendChild(l), () => l.remove();
      }
    });
  }
}, ph = "data-dnd-", ex = `${ph}dropping`, kr = "--dnd-", _s = `${ph}dragging`, sg = `${ph}placeholder`, aae = [_s, sg, "popover", "aria-pressed", "aria-grabbing"], lae = ["view-transition-name"], cae = `
  :root [${_s}] {
    position: fixed !important;
    pointer-events: none !important;
    touch-action: none;
    z-index: calc(infinity);
    will-change: translate;
    top: var(${kr}top, 0px) !important;
    left: var(${kr}left, 0px) !important;
    right: unset !important;
    bottom: unset !important;
    width: var(${kr}width, auto);
    max-width: var(${kr}width, auto);
    height: var(${kr}height, auto);
    max-height: var(${kr}height, auto);
    transition: var(${kr}transition) !important;
  }

  :root [${sg}] {
    transition: none;
  }

  :root [${sg}='hidden'] {
    visibility: hidden;
  }

  [${_s}] * {
    pointer-events: none !important;
  }

  [${_s}]:not([${ex}]) {
    translate: var(${kr}translate) !important;
  }

  [${_s}][style*='${kr}scale'] {
    scale: var(${kr}scale) !important;
    transform-origin: var(${kr}transform-origin) !important;
  }

  @layer {
    :where([${_s}][popover]) {
      overflow: visible;
      background: unset;
      border: unset;
      margin: unset;
      padding: unset;
      color: inherit;

      &:is(input, button) {
        border: revert;
        background: revert;
      }
    }
  }
  [${_s}]::backdrop, [${ph}overlay]:not([${_s}]) {
    display: none;
    visibility: hidden;
  }
`.replace(/\n+/g, " ").replace(/\s+/g, " ").trim();
function uae(t, e = "hidden") {
  return on(() => {
    const {element:n, manager:r} = t;
    if (!n || !r) {
      return;
    }
    const i = dae(n, r.registry.droppables), s = [], o = ioe(n), {remove:a} = o;
    return hae(i, o, s), fae(o, e), o.remove = () => {
      s.forEach(l => l()), a.call(o);
    }, o;
  });
}
function dae(t, e) {
  const n = new Map();
  for (const r of e) {
    if (r.element && (t === r.element || t.contains(r.element))) {
      const i = `${ph}${Xy("dom-id")}`;
      r.element.setAttribute(i, ""), n.set(r, i);
    }
  }
  return n;
}
function hae(t, e, n) {
  for (const [r, i] of t) {
    if (!r.element) {
      continue;
    }
    const s = `[${i}]`, o = e.matches(s) ? e : e.querySelector(s);
    if (r.element.removeAttribute(i), !o) {
      continue;
    }
    const a = r.element;
    r.proxy = o, o.removeAttribute(i), Yy.set(a, o), n.push(() => {
      Yy.delete(a), r.proxy = void 0;
    });
  }
}
function fae(t, e = "hidden") {
  t.setAttribute("inert", "true"), t.setAttribute("tab-index", "-1"), t.setAttribute("aria-hidden", "true"), t.setAttribute(sg, e);
}
function aE(t, e) {
  return t === e ? !0 : yc(t) === yc(e);
}
function lE(t) {
  const {target:e} = t;
  "newState" in t && t.newState === "closed" && Bc(e) && e.hasAttribute("popover") && requestAnimationFrame(() => ku(e));
}
function cE(t) {
  return t.tagName === "TR";
}
var og = new Map(), J4, tx, Ld, Dv, Qf, Z4, eR, Md = class extends(tx = vr, J4 = [Jt], tx) {
  constructor(e, n) {
    super(e, n), yr(this, Qf), yr(this, Dv, ar(Ld, 8, this)), ar(Ld, 11, this), this.state = {initial:{}, current:{}}, this.registerEffect(Zy(this, Qf, eR)), this.registerEffect(Zy(this, Qf, Z4));
  }
  destroy() {
    super.destroy();
    for (const [e, n] of og.entries()) {
      n.instances.has(this) && (n.instances.delete(this), n.instances.size === 0 && (n.cleanup(), og.delete(e)));
    }
  }
};
Ld = fh(tx);
Dv = new WeakMap();
Qf = new WeakSet();
Z4 = function() {
  var t, e, n;
  const {state:r, manager:i, options:s} = this, {dragOperation:o} = i, {position:a, source:l, status:c} = o;
  if (c.idle) {
    r.current = {}, r.initial = {};
    return;
  }
  if (!l) {
    return;
  }
  const {element:u, feedback:h} = l;
  if (!u || h === "none" || !c.initialized || c.initializing) {
    return;
  }
  const {initial:f} = r, p = (t = this.overlay) != null ? t : u, g = xc(p), m = xc(u), b = !aE(u, p), x = new qi(u, {frameTransform:b ? m : null, ignoreTransforms:!b}), w = {x:m.scaleX / g.scaleX, y:m.scaleY / g.scaleY};
  let {width:v, height:T, top:I, left:_} = x;
  b && (v = v / w.x, T = T / w.y);
  let N, E;
  const C = new Boe(p), {transition:k, translate:A, boxSizing:P, paddingBlockStart:W, paddingBlockEnd:F, paddingInlineStart:B, paddingInlineEnd:z, borderInlineStartWidth:j, borderInlineEndWidth:V, borderBlockStartWidth:ne, borderBlockEndWidth:D} = ls(u), ie = h === "clone", ee = P === "content-box", M = ee ? parseInt(B) + parseInt(z) + parseInt(j) + parseInt(V) : 0, X = ee ? parseInt(W) + parseInt(F) + parseInt(ne) + parseInt(D) : 0, ge = h !== "move" && !this.overlay ? uae(l, ie ? "clone" : "hidden") : 
  null, me = on(() => Rd(i.dragOperation.activatorEvent));
  if (A !== "none") {
    const ke = Pd(A);
    ke && !f.translate && (f.translate = ke);
  }
  if (!f.transformOrigin) {
    const ke = on(() => a.current);
    f.transformOrigin = {x:(ke.x - _ * g.scaleX - g.x) / (v * g.scaleX), y:(ke.y - I * g.scaleY - g.y) / (T * g.scaleY)};
  }
  const {transformOrigin:te} = f, q = I * g.scaleY + g.y, R = _ * g.scaleX + g.x;
  if (!f.coordinates && (f.coordinates = {x:R, y:q}, w.x !== 1 || w.y !== 1)) {
    const {scaleX:ke, scaleY:fe} = m, {x:Oe, y:We} = te;
    f.coordinates.x += (v * ke - v) * Oe, f.coordinates.y += (T * fe - T) * We;
  }
  f.dimensions || (f.dimensions = {width:v, height:T}), f.frameTransform || (f.frameTransform = g);
  const $ = {x:f.coordinates.x - R, y:f.coordinates.y - q}, G = {width:(f.dimensions.width * f.frameTransform.scaleX - v * g.scaleX) * te.x, height:(f.dimensions.height * f.frameTransform.scaleY - T * g.scaleY) * te.y}, J = {x:$.x / g.scaleX + G.width, y:$.y / g.scaleY + G.height}, U = {left:_ + J.x, top:I + J.y};
  p.setAttribute(_s, "true");
  const le = on(() => o.transform), be = (e = f.translate) != null ? e : {x:0, y:0}, je = le.x * g.scaleX + be.x, Ae = le.y * g.scaleY + be.y, ue = `${je}px ${Ae}px 0`, Le = k ? `${k}, translate 0ms linear` : "";
  C.set({width:v - M, height:T - X, top:U.top, left:U.left, translate:ue, transition:Le, scale:b ? `${w.x} ${w.y}` : "", "transform-origin":`${te.x * 100}% ${te.y * 100}%`}, kr), ge && (u.insertAdjacentElement("afterend", ge), s != null && s.rootElement && (typeof s.rootElement == "function" ? s.rootElement(l) : s.rootElement).appendChild(u)), Qy(p) && (p.hasAttribute("popover") || p.setAttribute("popover", "manual"), ku(p), p.addEventListener("beforetoggle", lE));
  const $e = new ResizeObserver(() => {
    if (!ge) {
      return;
    }
    const ke = new qi(ge, {frameTransform:g, ignoreTransforms:!0}), fe = te ?? {x:1, y:1}, Oe = (v - ke.width) * fe.x + J.x, We = (T - ke.height) * fe.y + J.y;
    if (C.set({width:ke.width - M, height:ke.height - X, top:I + We, left:_ + Oe}, kr), N == null || N.takeRecords(), cE(u) && cE(ge)) {
      const rt = Array.from(u.cells), st = Array.from(ge.cells);
      for (const [ft, St] of rt.entries()) {
        const ht = st[ft];
        St.style.width = `${ht.offsetWidth}px`;
      }
    }
    o.shape = new qi(p);
  }), Ye = new qi(p);
  on(() => o.shape = Ye);
  const Me = xo(p), Xe = ke => {
    this.manager.actions.stop({event:ke});
  };
  me && Me.addEventListener("resize", Xe), on(() => l.status) === "idle" && requestAnimationFrame(() => l.status = "dragging"), ge && ($e.observe(ge), N = new MutationObserver(ke => {
    let fe = !1;
    for (const Oe of ke) {
      if (Oe.target !== u) {
        fe = !0;
        continue;
      }
      if (Oe.type !== "attributes") {
        continue;
      }
      const We = Oe.attributeName;
      if (We.startsWith("aria-") || aae.includes(We)) {
        continue;
      }
      const rt = u.getAttribute(We);
      if (We === "style") {
        if (od(u) && od(ge)) {
          const st = u.style;
          for (const ft of Array.from(ge.style)) {
            st.getPropertyValue(ft) === "" && ge.style.removeProperty(ft);
          }
          for (const ft of Array.from(st)) {
            if (lae.includes(ft) || ft.startsWith(kr)) {
              continue;
            }
            const St = st.getPropertyValue(ft);
            ge.style.setProperty(ft, St);
          }
        }
      } else {
        rt !== null ? ge.setAttribute(We, rt) : ge.removeAttribute(We);
      }
    }
    fe && ie && (ge.innerHTML = u.innerHTML);
  }), N.observe(u, {attributes:!0, subtree:!0, childList:!0}), E = new MutationObserver(ke => {
    for (const fe of ke) {
      if (fe.addedNodes.length !== 0) {
        for (const Oe of Array.from(fe.addedNodes)) {
          if (Oe.contains(u) && u.nextElementSibling !== ge) {
            u.insertAdjacentElement("afterend", ge), ku(p);
            return;
          }
          if (Oe.contains(ge) && ge.previousElementSibling !== u) {
            ge.insertAdjacentElement("beforebegin", u), ku(p);
            return;
          }
        }
      }
    }
  }), E.observe(u.ownerDocument.body, {childList:!0, subtree:!0}));
  const it = (n = i.dragOperation.source) == null ? void 0 : n.id, se = () => {
    var ke;
    if (!me || it == null) {
      return;
    }
    const fe = i.registry.draggables.get(it), Oe = (ke = fe == null ? void 0 : fe.handle) != null ? ke : fe == null ? void 0 : fe.element;
    rl(Oe) && Oe.focus();
  }, oe = () => {
    N == null || N.disconnect(), E == null || E.disconnect(), $e.disconnect(), Me.removeEventListener("resize", Xe), Qy(p) && (p.removeEventListener("beforetoggle", lE), p.removeAttribute("popover")), p.removeAttribute(_s), C.reset(), l.status = "idle";
    const ke = r.current.translate != null;
    ge && (ke || ge.parentElement !== p.parentElement) && p.isConnected && ge.replaceWith(p), ge == null || ge.remove();
  }, we = dh(() => {
    var ke;
    const {transform:fe, status:Oe} = o;
    if (!(!fe.x && !fe.y && !r.current.translate) && Oe.dragging) {
      const We = (ke = f.translate) != null ? ke : {x:0, y:0}, rt = {x:fe.x / g.scaleX + We.x, y:fe.y / g.scaleY + We.y}, st = r.current.translate, ft = on(() => o.modifiers), St = on(() => {
        var xe;
        return (xe = o.shape) == null ? void 0 : xe.current;
      }), ht = me ? "250ms cubic-bezier(0.25, 1, 0.5, 1)" : "0ms linear";
      if (C.set({transition:`${k}, translate ${ht}`, translate:`${rt.x}px ${rt.y}px 0`}, kr), N == null || N.takeRecords(), St && St !== Ye && st && !ft.length) {
        const xe = Ar.delta(rt, st);
        o.shape = as.from(St.boundingRectangle).translate(xe.x * g.scaleX, xe.y * g.scaleY);
      } else {
        o.shape = new qi(p);
      }
      r.current.translate = rt;
    }
  }, function() {
    if (o.status.dropped) {
      this.dispose(), l.status = "dropping";
      let ke = r.current.translate;
      const fe = ke != null;
      if (!ke && u !== p && (ke = {x:0, y:0}), !ke) {
        oe();
        return;
      }
      const Oe = () => {
        var We, rt;
        {
          ku(p);
          const [, st] = (We = O4(p, kt => "translate" in kt)) != null ? We : [];
          st == null || st.pause();
          const ft = ge ?? u, St = {frameTransform:aE(p, ft) ? null : void 0}, ht = new qi(p, St), xe = (rt = Pd(ls(p).translate)) != null ? rt : ke, de = new qi(ft, St), qe = as.delta(ht, de, l.alignment), dt = {x:xe.x - qe.x, y:xe.y - qe.y}, gt = Math.round(ht.intrinsicHeight) !== Math.round(de.intrinsicHeight) ? {minHeight:[`${ht.intrinsicHeight}px`, `${de.intrinsicHeight}px`], maxHeight:[`${ht.intrinsicHeight}px`, `${de.intrinsicHeight}px`]} : {}, ze = Math.round(ht.intrinsicWidth) !== Math.round(de.intrinsicWidth) ? 
          {minWidth:[`${ht.intrinsicWidth}px`, `${de.intrinsicWidth}px`], maxWidth:[`${ht.intrinsicWidth}px`, `${de.intrinsicWidth}px`]} : {};
          C.set({transition:k}, kr), p.setAttribute(ex, ""), N == null || N.takeRecords(), V4({element:p, keyframes:Pv(Dd(Dd({}, gt), ze), {translate:[`${xe.x}px ${xe.y}px 0`, `${dt.x}px ${dt.y}px 0`]}), options:{duration:fe || p !== u ? 250 : 0, easing:"ease"}}).then(() => {
            p.removeAttribute(ex), st == null || st.finish(), oe(), requestAnimationFrame(se);
          });
        }
      };
      i.renderer.rendering.then(Oe);
    }
  });
  return () => {
    oe(), we();
  };
};
eR = function() {
  var t, e, n;
  const {status:r, source:i, target:s} = this.manager.dragOperation, {nonce:o} = (t = this.options) != null ? t : {};
  if (r.initializing) {
    const a = Ms((e = i == null ? void 0 : i.element) != null ? e : null), l = Ms((n = s == null ? void 0 : s.element) != null ? n : null), c = new Set([a, l]);
    for (const u of c) {
      let h = og.get(u);
      if (!h) {
        const f = document.createElement("style");
        f.textContent = cae, o && f.setAttribute("nonce", o), u.head.prepend(f);
        const p = new MutationObserver(g => {
          for (const m of g) {
            if (m.type === "childList") {
              const b = Array.from(m.removedNodes);
              b.length > 0 && b.includes(f) && u.head.prepend(f);
            }
          }
        });
        p.observe(u.head, {childList:!0}), h = {cleanup:() => {
          p.disconnect(), f.remove();
        }, instances:new Set()}, og.set(u, h);
      }
      h.instances.add(this);
    }
  }
};
vo(Ld, 4, "overlay", J4, Md, Dv);
Fc(Ld, Md);
Md.configure = sv(Md);
var pae = Md, ou = !0, gae = !1, tR, nR, rR, iR, qo, Lv, Mv;
iR = (rR = [Jt], Mi.Forward), nR = (tR = [Jt], Mi.Reverse);
var Bd = class {
  constructor() {
    yr(this, Lv, ar(qo, 8, this, ou)), ar(qo, 11, this), yr(this, Mv, ar(qo, 12, this, ou)), ar(qo, 15, this);
  }
  isLocked(t) {
    return t === Mi.Idle ? !1 : t == null ? this[Mi.Forward] === ou && this[Mi.Reverse] === ou : this[t] === ou;
  }
  unlock(t) {
    t !== Mi.Idle && (this[t] = gae);
  }
};
qo = fh(null);
Lv = new WeakMap();
Mv = new WeakMap();
vo(qo, 4, iR, rR, Bd, Lv);
vo(qo, 4, nR, tR, Bd, Mv);
Fc(qo, Bd);
var mae = [Mi.Forward, Mi.Reverse], uE = class {
  constructor() {
    this.x = new Bd(), this.y = new Bd();
  }
  isLocked() {
    return this.x.isLocked() && this.y.isLocked();
  }
}, bae = class extends vr {
  constructor(t) {
    super(t);
    const e = uh(new uE());
    let n = null;
    this.signal = e, si(() => {
      const {status:r} = t.dragOperation;
      if (!r.initialized) {
        n = null, e.value = new uE();
        return;
      }
      const {delta:i} = t.dragOperation.position;
      if (n) {
        const s = {x:dE(i.x, n.x), y:dE(i.y, n.y)}, o = e.peek();
        Wn(() => {
          for (const a of HP) {
            for (const l of mae) {
              s[a] === l && o[a].unlock(l);
            }
          }
          e.value = o;
        });
      }
      n = i;
    });
  }
  get current() {
    return this.signal.peek();
  }
};
function dE(t, e) {
  return Math.sign(t - e);
}
var sR, nx, $d, Bv, Lo, rx, gh = class extends(nx = Zg, sR = [Jt], nx) {
  constructor(t) {
    super(t), yr(this, Bv, ar($d, 8, this, !1)), ar($d, 11, this), yr(this, Lo), yr(this, rx, () => {
      if (!gr(this, Lo)) {
        return;
      }
      const {element:s, by:o} = gr(this, Lo);
      o.y && (s.scrollTop += o.y), o.x && (s.scrollLeft += o.x);
    }), this.scroll = s => {
      var o;
      if (this.disabled) {
        return !1;
      }
      const a = this.getScrollableElements();
      if (!a) {
        return rs(this, Lo, void 0), !1;
      }
      const {position:l} = this.manager.dragOperation, c = l == null ? void 0 : l.current;
      if (c) {
        const {by:u} = s ?? {}, h = u ? {x:hE(u.x), y:hE(u.y)} : void 0, f = h ? void 0 : this.scrollIntentTracker.current;
        if (f != null && f.isLocked()) {
          return !1;
        }
        for (const p of a) {
          const g = moe(p, u);
          if (g.x || g.y) {
            const {speed:m, direction:b} = Aoe(p, c, h);
            if (f) {
              for (const x of HP) {
                f[x].isLocked(b[x]) && (m[x] = 0, b[x] = 0);
              }
            }
            if (b.x || b.y) {
              const {x, y:w} = u ?? b, v = x * m.x, T = w * m.y;
              if (v || T) {
                const I = (o = gr(this, Lo)) == null ? void 0 : o.by;
                if (this.autoScrolling && I && (I.x && !v || I.y && !T)) {
                  continue;
                }
                return rs(this, Lo, {element:p, by:{x:v, y:T}}), ng.schedule(gr(this, rx)), !0;
              }
            }
          }
        }
      }
      return rs(this, Lo, void 0), !1;
    };
    let e = null, n = null;
    const r = Jp(() => {
      const {position:s, source:o} = t.dragOperation;
      if (!s) {
        return null;
      }
      const a = M4(Ms(o == null ? void 0 : o.element), s.current);
      return a && (e = a), a ?? e;
    }), i = Jp(() => {
      const s = r.value, {documentElement:o} = Ms(s);
      if (!s || s === o) {
        const {target:a} = t.dragOperation, l = a == null ? void 0 : a.element;
        if (l) {
          const c = Ky(l, {excludeElement:!1});
          return n = c, c;
        }
      }
      if (s) {
        const a = Ky(s, {excludeElement:!1});
        return this.autoScrolling && n && a.size < (n == null ? void 0 : n.size) ? n : (n = a, a);
      }
      return n = null, null;
    }, lo);
    this.getScrollableElements = () => i.value, this.scrollIntentTracker = new bae(t), this.destroy = t.monitor.addEventListener("dragmove", s => {
      this.disabled || s.defaultPrevented || !Rd(t.dragOperation.activatorEvent) || !s.by || this.scroll({by:s.by}) && s.preventDefault();
    });
  }
};
$d = fh(nx);
Bv = new WeakMap();
Lo = new WeakMap();
rx = new WeakMap();
vo($d, 4, "autoScrolling", sR, gh, Bv);
Fc($d, gh);
function hE(t) {
  return t > 0 ? Mi.Forward : t < 0 ? Mi.Reverse : Mi.Idle;
}
var yae = class {
  constructor(t) {
    this.scheduler = t, this.pending = !1, this.tasks = new Set(), this.resolvers = new Set(), this.flush = () => {
      const {tasks:e, resolvers:n} = this;
      this.pending = !1, this.tasks = new Set(), this.resolvers = new Set();
      for (const r of e) {
        r();
      }
      for (const r of n) {
        r();
      }
    };
  }
  schedule(t) {
    return this.tasks.add(t), this.pending || (this.pending = !0, this.scheduler(this.flush)), new Promise(e => this.resolvers.add(e));
  }
}, xae = new yae(t => {
  typeof requestAnimationFrame == "function" ? requestAnimationFrame(t) : t();
}), vae = 10, $v = class extends vr {
  constructor(t, e) {
    super(t);
    const n = t.registry.plugins.get(gh);
    if (!n) {
      throw new Error("AutoScroller plugin depends on Scroller plugin");
    }
    this.destroy = si(() => {
      if (this.disabled) {
        return;
      }
      const {position:r, status:i} = t.dragOperation;
      if (i.dragging) {
        if (n.scroll()) {
          n.autoScrolling = !0;
          const o = setInterval(() => xae.schedule(n.scroll), vae);
          return () => {
            clearInterval(o);
          };
        } else {
          n.autoScrolling = !1;
        }
      }
    });
  }
}, fE = {capture:!0, passive:!0}, Tu, wae = class extends Zg {
  constructor(t) {
    super(t), yr(this, Tu), this.handleScroll = () => {
      gr(this, Tu) == null && rs(this, Tu, setTimeout(() => {
        this.manager.collisionObserver.forceUpdate(!1), rs(this, Tu, void 0);
      }, 50));
    };
    const {dragOperation:e} = this.manager;
    this.destroy = si(() => {
      var n, r, i;
      if (e.status.dragging) {
        const o = (i = (r = (n = e.source) == null ? void 0 : n.element) == null ? void 0 : r.ownerDocument) != null ? i : document;
        return o.addEventListener("scroll", this.handleScroll, fE), () => {
          o.removeEventListener("scroll", this.handleScroll, fE);
        };
      }
    });
  }
};
Tu = new WeakMap();
var _ae = class extends vr {
  constructor(t, e) {
    super(t, e), this.manager = t, this.destroy = si(() => {
      var n;
      const {dragOperation:r} = this.manager, {nonce:i} = (n = this.options) != null ? n : {};
      if (r.status.initialized) {
        const s = document.createElement("style");
        return i && s.setAttribute("nonce", i), s.textContent = "* { user-select: none !important; -webkit-user-select: none !important; }", document.head.appendChild(s), H0(), document.addEventListener("selectionchange", H0, {capture:!0}), () => {
          document.removeEventListener("selectionchange", H0, {capture:!0}), s.remove();
        };
      }
    });
  }
};
function H0() {
  var t;
  (t = document.getSelection()) == null || t.removeAllRanges();
}
var Cu = Object.freeze({offset:10, keyboardCodes:{start:["Space", "Enter"], cancel:["Escape"], end:["Space", "Enter", "Tab"], up:["ArrowUp"], down:["ArrowDown"], left:["ArrowLeft"], right:["ArrowRight"]}, shouldActivate(t) {
  var e;
  const {event:n, source:r} = t, i = (e = r.handle) != null ? e : r.element;
  return n.target === i;
}}), Dl, ag = class extends bc {
  constructor(e, n) {
    super(e), this.manager = e, this.options = n, yr(this, Dl, []), this.listeners = new B4(), this.handleSourceKeyDown = (r, i, s) => {
      if (this.disabled || r.defaultPrevented || !Bc(r.target) || i.disabled) {
        return;
      }
      const {keyboardCodes:o = Cu.keyboardCodes, shouldActivate:a = Cu.shouldActivate} = s ?? {};
      o.start.includes(r.code) && this.manager.dragOperation.status.idle && a({event:r, source:i, manager:this.manager}) && this.handleStart(r, i, s);
    };
  }
  bind(e, n = this.options) {
    return si(() => {
      var i;
      const s = (i = e.handle) != null ? i : e.element, o = a => {
        Rd(a) && this.handleSourceKeyDown(a, e, n);
      };
      if (s) {
        return s.addEventListener("keydown", o), () => {
          s.removeEventListener("keydown", o);
        };
      }
    });
  }
  handleStart(e, n, r) {
    const {element:i} = n;
    if (!i) {
      throw new Error("Source draggable does not have an associated element");
    }
    e.preventDefault(), e.stopImmediatePropagation(), j4(i);
    const {center:s} = new qi(i);
    if (this.manager.actions.start({event:e, coordinates:{x:s.x, y:s.y}, source:n}).signal.aborted) {
      return this.cleanup();
    }
    this.sideEffects();
    const a = Ms(i), l = [this.listeners.bind(a, [{type:"keydown", listener:c => this.handleKeyDown(c, n, r), options:{capture:!0}}])];
    gr(this, Dl).push(...l);
  }
  handleKeyDown(e, n, r) {
    const {keyboardCodes:i = Cu.keyboardCodes} = r ?? {};
    if (_l(e, [...i.end, ...i.cancel])) {
      e.preventDefault();
      const s = _l(e, i.cancel);
      this.handleEnd(e, s);
      return;
    }
    _l(e, i.up) ? this.handleMove("up", e) : _l(e, i.down) && this.handleMove("down", e), _l(e, i.left) ? this.handleMove("left", e) : _l(e, i.right) && this.handleMove("right", e);
  }
  handleEnd(e, n) {
    this.manager.actions.stop({event:e, canceled:n}), this.cleanup();
  }
  handleMove(e, n) {
    var r, i;
    const {shape:s} = this.manager.dragOperation, o = n.shiftKey ? 5 : 1;
    let a = {x:0, y:0}, l = (i = (r = this.options) == null ? void 0 : r.offset) != null ? i : Cu.offset;
    if (typeof l == "number" && (l = {x:l, y:l}), !!s) {
      switch(e) {
        case "up":
          a = {x:0, y:-l.y * o};
          break;
        case "down":
          a = {x:0, y:l.y * o};
          break;
        case "left":
          a = {x:-l.x * o, y:0};
          break;
        case "right":
          a = {x:l.x * o, y:0};
          break;
      }
      (a.x || a.y) && (n.preventDefault(), this.manager.actions.move({event:n, by:a}));
    }
  }
  sideEffects() {
    const e = this.manager.registry.plugins.get($v);
    (e == null ? void 0 : e.disabled) === !1 && (e.disable(), gr(this, Dl).push(() => {
      e.enable();
    }));
  }
  cleanup() {
    gr(this, Dl).forEach(e => e()), rs(this, Dl, []);
  }
  destroy() {
    this.cleanup(), this.listeners.clear();
  }
};
Dl = new WeakMap();
ag.configure = sv(ag);
ag.defaults = Cu;
var Sae = ag;
function _l(t, e) {
  return e.includes(t.code);
}
var oR = Object.freeze({activationConstraints(t, e) {
  var n;
  const {pointerType:r, target:i} = t;
  if (!(r === "mouse" && Bc(i) && (e.handle === i || (n = e.handle) != null && n.contains(i)))) {
    return r === "touch" ? {delay:{value:250, tolerance:5}} : Foe(i) && !t.defaultPrevented ? {delay:{value:200, tolerance:0}} : {delay:{value:200, tolerance:10}, distance:{value:5}};
  }
}}), Ll, Ml, lg = class extends bc {
  constructor(e, n) {
    super(e), this.manager = e, this.options = n, yr(this, Ll, new Set()), yr(this, Ml), this.listeners = new B4(), this.latest = {event:void 0, coordinates:void 0}, this.handleMove = () => {
      const {event:r, coordinates:i} = this.latest;
      !r || !i || this.manager.actions.move({event:r, to:i});
    }, this.handleCancel = this.handleCancel.bind(this), this.handlePointerUp = this.handlePointerUp.bind(this), this.handleKeyDown = this.handleKeyDown.bind(this);
  }
  activationConstraints(e, n) {
    var r;
    const {activationConstraints:i = oR.activationConstraints} = (r = this.options) != null ? r : {};
    return typeof i == "function" ? i(e, n) : i;
  }
  bind(e, n = this.options) {
    return si(() => {
      var i;
      const s = new AbortController(), {signal:o} = s, a = c => {
        $oe(c) && this.handlePointerDown(c, e, n);
      };
      let l = [(i = e.handle) != null ? i : e.element];
      n != null && n.activatorElements && (Array.isArray(n.activatorElements) ? l = n.activatorElements : l = n.activatorElements(e));
      for (const c of l) {
        c && (Tae(c.ownerDocument.defaultView), c.addEventListener("pointerdown", a, {signal:o}));
      }
      return () => s.abort();
    });
  }
  handlePointerDown(e, n, r = {}) {
    if (this.disabled || !e.isPrimary || e.button !== 0 || !Bc(e.target) || n.disabled || kae(e) || !this.manager.dragOperation.status.idle) {
      return;
    }
    const {target:i} = e, s = rl(i) && i.draggable && i.getAttribute("draggable") === "true", o = xc(n.element);
    this.initialCoordinates = {x:e.clientX * o.scaleX + o.x, y:e.clientY * o.scaleY + o.y};
    const a = this.activationConstraints(e, n);
    if (e.sensor = this, !(a != null && a.delay) && !(a != null && a.distance)) {
      this.handleStart(n, e);
    } else {
      const {delay:h} = a;
      if (h) {
        const f = setTimeout(() => this.handleStart(n, e), h.value);
        rs(this, Ml, () => {
          clearTimeout(f), rs(this, Ml, void 0);
        });
      }
    }
    const l = Ms(e.target), c = this.listeners.bind(l, [{type:"pointermove", listener:h => this.handlePointerMove(h, n)}, {type:"pointerup", listener:this.handlePointerUp, options:{capture:!0}}, {type:"dragstart", listener:s ? this.handleCancel : ff, options:{capture:!0}}]), u = () => {
      var h;
      c(), (h = gr(this, Ml)) == null || h.call(this), this.initialCoordinates = void 0;
    };
    gr(this, Ll).add(u);
  }
  handlePointerMove(e, n) {
    const r = {x:e.clientX, y:e.clientY}, i = xc(n.element);
    if (r.x = r.x * i.scaleX + i.x, r.y = r.y * i.scaleY + i.y, this.manager.dragOperation.status.dragging) {
      e.preventDefault(), e.stopPropagation(), this.latest.event = e, this.latest.coordinates = r, ng.schedule(this.handleMove);
      return;
    }
    if (!this.initialCoordinates) {
      return;
    }
    const s = {x:r.x - this.initialCoordinates.x, y:r.y - this.initialCoordinates.y}, o = this.activationConstraints(e, n), {distance:a, delay:l} = o ?? {};
    if (a) {
      if (a.tolerance != null && $0(s, a.tolerance)) {
        return this.handleCancel(e);
      }
      if ($0(s, a.value)) {
        return this.handleStart(n, e);
      }
    }
    if (l && $0(s, l.tolerance)) {
      return this.handleCancel(e);
    }
  }
  handlePointerUp(e) {
    const {status:n} = this.manager.dragOperation;
    if (!n.idle) {
      e.preventDefault(), e.stopPropagation();
      const r = !n.initialized;
      this.manager.actions.stop({event:e, canceled:r});
    }
    this.cleanup();
  }
  handleKeyDown(e) {
    e.key === "Escape" && (e.preventDefault(), this.handleCancel(e));
  }
  handleStart(e, n) {
    var r;
    const {manager:i, initialCoordinates:s} = this;
    if ((r = gr(this, Ml)) == null || r.call(this), !s || !i.dragOperation.status.idle || n.defaultPrevented) {
      return;
    }
    if (i.actions.start({coordinates:s, event:n, source:e}).signal.aborted) {
      return this.cleanup();
    }
    n.preventDefault();
    const a = Ms(n.target), l = a.body;
    l.setPointerCapture(n.pointerId);
    const c = this.listeners.bind(a, [{type:"touchmove", listener:ff, options:{passive:!1}}, {type:"click", listener:ff}, {type:"contextmenu", listener:ff}, {type:"keydown", listener:this.handleKeyDown}, {type:"lostpointercapture", listener:u => {
      u.target === l && this.handlePointerUp(u);
    }}]);
    gr(this, Ll).add(c);
  }
  handleCancel(e) {
    const {dragOperation:n} = this.manager;
    n.status.initialized && this.manager.actions.stop({event:e, canceled:!0}), this.cleanup();
  }
  cleanup() {
    this.latest = {event:void 0, coordinates:void 0}, gr(this, Ll).forEach(e => e()), gr(this, Ll).clear();
  }
  destroy() {
    this.cleanup(), this.listeners.clear();
  }
};
Ll = new WeakMap();
Ml = new WeakMap();
lg.configure = sv(lg);
lg.defaults = oR;
var aR = lg;
function kae(t) {
  return "sensor" in t;
}
function ff(t) {
  t.preventDefault();
}
function Eae() {
}
var pE = new WeakSet();
function Tae(t) {
  !t || pE.has(t) || (t.addEventListener("touchmove", Eae, {capture:!1, passive:!1}), pE.add(t));
}
var Ga = {modifiers:[], plugins:[iae, $v, oae, pae, _ae], sensors:[aR, Sae]}, lR = class extends eoe {
  constructor(t = {}) {
    const {plugins:e = Ga.plugins, sensors:n = Ga.sensors, modifiers:r = []} = t;
    super(Pv(Dd({}, t), {plugins:[wae, gh, ...e], sensors:n, modifiers:r}));
  }
}, cR, uR, dR, ix, Yi, Fv, zv, Hv, zc = class extends(ix = Ds, dR = [Jt], uR = [Jt], cR = [Jt], ix) {
  constructor(t, e) {
    var n = t, {element:r, effects:i = () => [], handle:s, feedback:o = "default"} = n, a = K4(n, ["element", "effects", "handle", "feedback"]);
    super(Dd({effects:() => [...i(), () => {
      var l, c;
      const {manager:u} = this;
      if (!u) {
        return;
      }
      const f = ((c = (l = this.sensors) == null ? void 0 : l.map(ov)) != null ? c : [...u.sensors]).map(p => {
        const g = p instanceof bc ? p : u.registry.register(p.plugin), m = p instanceof bc ? void 0 : p.options;
        return g.bind(this, m);
      });
      return function() {
        f.forEach(g => g());
      };
    }]}, a), e), yr(this, Fv, ar(Yi, 8, this)), ar(Yi, 11, this), yr(this, zv, ar(Yi, 12, this)), ar(Yi, 15, this), yr(this, Hv, ar(Yi, 16, this)), ar(Yi, 19, this), this.element = r, this.handle = s, this.feedback = o;
  }
};
Yi = fh(ix);
Fv = new WeakMap();
zv = new WeakMap();
Hv = new WeakMap();
vo(Yi, 4, "handle", dR, zc, Fv);
vo(Yi, 4, "element", uR, zc, zv);
vo(Yi, 4, "feedback", cR, zc, Hv);
Fc(Yi, zc);
var hR, fR, sx, Yo, Uv, U0, pR, gR, ad, Wv, nm = class extends(sx = Ls, fR = [Jt], hR = [Jt], sx) {
  constructor(t, e) {
    var n = t, {element:r, effects:i = () => []} = n, s = K4(n, ["element", "effects"]);
    const {collisionDetector:o = q4} = s, a = c => {
      const {manager:u, element:h} = this;
      if (!h || c === null) {
        this.shape = void 0;
        return;
      }
      if (!u) {
        return;
      }
      const f = new qi(h), p = on(() => this.shape);
      return f && (p != null && p.equals(f)) ? p : (this.shape = f, f);
    }, l = uh(!1);
    super(Pv(Dd({}, s), {collisionDetector:o, effects:() => [...i(), () => {
      const {element:c, manager:u} = this;
      if (!u) {
        return;
      }
      const {dragOperation:h} = u, {source:f} = h;
      l.value = !!(f && h.status.initialized && c && !this.disabled && this.accepts(f));
    }, () => {
      const {element:c} = this;
      if (l.value && c) {
        const u = new goe(c, a);
        return () => {
          u.disconnect(), this.shape = void 0;
        };
      }
    }, () => {
      var c;
      if ((c = this.manager) != null && c.dragOperation.status.initialized) {
        return () => {
          this.shape = void 0;
        };
      }
    }]}), e), yr(this, ad), yr(this, Uv, ar(Yo, 8, this)), ar(Yo, 11, this), yr(this, Wv, ar(Yo, 12, this)), ar(Yo, 15, this), this.element = r, this.refreshShape = () => a();
  }
  set element(t) {
    rs(this, ad, t, gR);
  }
  get element() {
    var t;
    return (t = this.proxy) != null ? t : gr(this, ad, pR);
  }
};
Yo = fh(sx);
Uv = new WeakMap();
ad = new WeakSet();
Wv = new WeakMap();
U0 = vo(Yo, 20, "#element", fR, ad, Uv), pR = U0.get, gR = U0.set;
vo(Yo, 4, "proxy", hR, nm, Wv);
Fc(Yo, nm);
function Cae(t) {
  return t != null && typeof t == "object" && "current" in t;
}
function Ko(t) {
  var e;
  if (t != null) {
    return Cae(t) ? (e = t.current) != null ? e : void 0 : t;
  }
}
var Aae = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", Hc = Aae ? require$react.useLayoutEffect : require$react.useEffect;
function Nae() {
  const t = (0,require$react.useState)(0)[1];
  return (0,require$react.useCallback)(() => {
    t(e => e + 1);
  }, [t]);
}
function jv(t, e) {
  const n = (0,require$react.useRef)(new Map()), r = Nae();
  return Hc(() => {
    if (!t) {
      n.current.clear();
      return;
    }
    return si(() => {
      var i;
      let s = !1, o = !1;
      for (const a of n.current) {
        const [l] = a, c = on(() => a[1]), u = t[l];
        c !== u && (s = !0, n.current.set(l, u), o = (i = e == null ? void 0 : e(l, c, u)) != null ? i : !1);
      }
      s && (o ? (0,require$react_dom.flushSync)(r) : r());
    });
  }, [t]), (0,require$react.useMemo)(() => t && new Proxy(t, {get(i, s) {
    const o = i[s];
    return n.current.set(s, o), o;
  }}), [t]);
}
function Iae(t, e) {
  t();
}
function Sl(t) {
  const e = (0,require$react.useRef)(t);
  return Hc(() => {
    e.current = t;
  }, [t]), e;
}
function sn(t, e, n = require$react.useEffect, r = Object.is) {
  const i = (0,require$react.useRef)(t);
  n(() => {
    const s = i.current;
    r(t, s) || (i.current = t, e(t, s));
  }, [e, t]);
}
function nc(t, e) {
  const n = (0,require$react.useRef)(Ko(t));
  Hc(() => {
    const r = Ko(t);
    r !== n.current && (n.current = r, e(r));
  });
}
var Oae = Object.defineProperty, Pae = Object.defineProperties, Rae = Object.getOwnPropertyDescriptors, cg = Object.getOwnPropertySymbols, mR = Object.prototype.hasOwnProperty, bR = Object.prototype.propertyIsEnumerable, gE = (t, e, n) => e in t ? Oae(t, e, {enumerable:!0, configurable:!0, writable:!0, value:n}) : t[e] = n, yR = (t, e) => {
  for (var n in e || (e = {})) {
    mR.call(e, n) && gE(t, n, e[n]);
  }
  if (cg) {
    for (var n of cg(e)) {
      bR.call(e, n) && gE(t, n, e[n]);
    }
  }
  return t;
}, xR = (t, e) => Pae(t, Rae(e)), Dae = (t, e) => {
  var n = {};
  for (var r in t) {
    mR.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
  }
  if (t != null && cg) {
    for (var r of cg(t)) {
      e.indexOf(r) < 0 && bR.call(t, r) && (n[r] = t[r]);
    }
  }
  return n;
}, Lae = new lR(), vR = (0,require$react.createContext)(Lae), Mae = (0,require$react.memo)((0,require$react.forwardRef)(({children:t}, e) => {
  const [n, r] = (0,require$react.useState)(0), i = (0,require$react.useRef)(null), s = (0,require$react.useRef)(null), o = (0,require$react.useMemo)(() => ({renderer:{get rendering() {
    var a;
    return (a = i.current) != null ? a : Promise.resolve();
  }}, trackRendering(a) {
    i.current || (i.current = new Promise(l => {
      s.current = l;
    })), (0,require$react.startTransition)(() => {
      a(), r(l => l + 1);
    });
  }}), []);
  return Hc(() => {
    var a;
    (a = s.current) == null || a.call(s), i.current = null;
  }, [t, n]), (0,require$react.useImperativeHandle)(e, () => o), null;
})), W0 = [void 0, lo];
function wR(t) {
  var e = t, {children:n, onCollision:r, onBeforeDragStart:i, onDragStart:s, onDragMove:o, onDragOver:a, onDragEnd:l} = e, c = Dae(e, ["children", "onCollision", "onBeforeDragStart", "onDragStart", "onDragMove", "onDragOver", "onDragEnd"]), u;
  const h = (0,require$react.useRef)(null), [f, p] = (0,require$react.useState)((u = c.manager) != null ? u : null), {plugins:g, modifiers:m, sensors:b} = c, x = Sl(i), w = Sl(s), v = Sl(a), T = Sl(o), I = Sl(l), _ = Sl(r);
  return (0,require$react.useEffect)(() => {
    var N;
    if (!h.current) {
      throw new Error("Renderer not found");
    }
    const {renderer:E, trackRendering:C} = h.current, k = (N = c.manager) != null ? N : new lR(c);
    return k.renderer = E, k.monitor.addEventListener("beforedragstart", A => {
      const P = x.current;
      P && C(() => P(A, k));
    }), k.monitor.addEventListener("dragstart", A => {
      var P;
      return (P = w.current) == null ? void 0 : P.call(w, A, k);
    }), k.monitor.addEventListener("dragover", A => {
      const P = v.current;
      P && C(() => P(A, k));
    }), k.monitor.addEventListener("dragmove", A => {
      const P = T.current;
      P && C(() => P(A, k));
    }), k.monitor.addEventListener("dragend", A => {
      const P = I.current;
      P && C(() => P(A, k));
    }), k.monitor.addEventListener("collision", A => {
      var P;
      return (P = _.current) == null ? void 0 : P.call(_, A, k);
    }), (0,require$react.startTransition)(() => p(k)), k.destroy;
  }, [c.manager]), sn(g, () => f && (f.plugins = g ?? Ga.plugins), ...W0), sn(b, () => f && (f.sensors = b ?? Ga.sensors), ...W0), sn(m, () => f && (f.modifiers = m ?? Ga.modifiers), ...W0), (0,require$react_SLASH_jsx_runtime.jsxs)(vR.Provider, {value:f, children:[(0,require$react_SLASH_jsx_runtime.jsx)(Mae, {ref:h, children:n}), n]});
}
function _R() {
  return (0,require$react.useContext)(vR);
}
function Vv(t) {
  var e;
  const n = (e = _R()) != null ? e : void 0, [r] = (0,require$react.useState)(() => t(n));
  return r.manager !== n && (r.manager = n), Hc(r.register, [n, r]), r;
}
function Bae(t) {
  const {disabled:e, data:n, element:r, handle:i, id:s, modifiers:o, sensors:a} = t, l = Vv(u => new zc(xR(yR({}, t), {register:!1, handle:Ko(i), element:Ko(r)}), u)), c = jv(l, $ae);
  return sn(s, () => l.id = s), nc(i, u => l.handle = u), nc(r, u => l.element = u), sn(n, () => n && (l.data = n)), sn(e, () => l.disabled = e === !0), sn(a, () => l.sensors = a), sn(o, () => l.modifiers = o, void 0, lo), sn(t.feedback, () => {
    var u;
    return l.feedback = (u = t.feedback) != null ? u : "default";
  }), sn(t.alignment, () => l.alignment = t.alignment), {draggable:c, get isDragging() {
    return c.isDragging;
  }, get isDropping() {
    return c.isDropping;
  }, get isDragSource() {
    return c.isDragSource;
  }, handleRef:(0,require$react.useCallback)(u => {
    l.handle = u ?? void 0;
  }, [l]), ref:(0,require$react.useCallback)(u => {
    var h, f;
    !u && ((h = l.element) != null && h.isConnected) && !((f = l.manager) != null && f.dragOperation.status.idle) || (l.element = u ?? void 0);
  }, [l])};
}
function $ae(t, e, n) {
  return !!(t === "isDragSource" && !n && e);
}
var Fae = Object.create, SR = Object.defineProperty, zae = Object.getOwnPropertyDescriptor, kR = (t, e) => (e = Symbol[t]) ? e : Symbol.for("Symbol." + t), rm = t => {
  throw TypeError(t);
}, Hae = (t, e, n) => e in t ? SR(t, e, {enumerable:!0, configurable:!0, writable:!0, value:n}) : t[e] = n, Uae = t => {
  var e;
  return [, , , Fae((e = t == null ? void 0 : t[kR("metadata")]) != null ? e : null)];
}, ER = ["class", "method", "getter", "setter", "accessor", "field", "value", "get", "set"], TR = t => t !== void 0 && typeof t != "function" ? rm("Function expected") : t, Wae = (t, e, n, r, i) => ({kind:ER[t], name:e, metadata:r, addInitializer:s => n._ ? rm("Already initialized") : i.push(TR(s || null))}), jae = (t, e) => Hae(e, kR("metadata"), t[3]), Vae = (t, e, n, r) => {
  for (var i = 0, s = t[e >> 1], o = s && s.length; i < o; i++) {
    s[i].call(n);
  }
  return r;
}, CR = (t, e, n, r, i, s) => {
  for (var o, a, l, c, u = e & 7, h = !1, f = !1, p = 2, g = ER[u + 5], m = t[p] || (t[p] = []), b = (i = i.prototype, zae(i, n)), x = r.length - 1; x >= 0; x--) {
    l = Wae(u, n, a = {}, t[3], m), l.static = h, l.private = f, c = l.access = {has:w => n in w}, c.get = w => w[n], o = (0,r[x])(b[g], l), a._ = 1, TR(o) && (b[g] = o);
  }
  return b && SR(i, n, b), i;
}, AR = (t, e, n) => e.has(t) || rm("Cannot " + n), qae = (t, e, n) => (AR(t, e, "read from private field"), e.get(t)), Yae = (t, e, n) => e.has(t) ? rm("Cannot add the same private member more than once") : e instanceof WeakSet ? e.add(t) : e.set(t, n), Gae = (t, e, n, r) => (AR(t, e, "write to private field"), e.set(t, n), n), Ia = class ox {
  constructor(e, n) {
    this.x = e, this.y = n;
  }
  static delta(e, n) {
    return new ox(e.x - n.x, e.y - n.y);
  }
  static distance(e, n) {
    return Math.hypot(e.x - n.x, e.y - n.y);
  }
  static equals(e, n) {
    return e.x === n.x && e.y === n.y;
  }
  static from({x:e, y:n}) {
    return new ox(e, n);
  }
}, NR, IR, ax, Kf, mh, qv = class extends(ax = cl, IR = [or], NR = [or], ax) {
  constructor(t) {
    const e = Ia.from(t);
    super(e, (n, r) => Ia.equals(n, r)), Vae(mh, 5, this), Yae(this, Kf, 0), this.velocity = {x:0, y:0};
  }
  get delta() {
    return Ia.delta(this.current, this.initial);
  }
  get direction() {
    const {current:t, previous:e} = this;
    if (!e) {
      return null;
    }
    const n = {x:t.x - e.x, y:t.y - e.y};
    return !n.x && !n.y ? null : Math.abs(n.x) > Math.abs(n.y) ? n.x > 0 ? "right" : "left" : n.y > 0 ? "down" : "up";
  }
  get current() {
    return super.current;
  }
  set current(t) {
    const {current:e} = this, n = Ia.from(t), r = {x:n.x - e.x, y:n.y - e.y}, i = Date.now(), s = i - qae(this, Kf), o = a => Math.round(a / s * 100);
    Wn(() => {
      Gae(this, Kf, i), this.velocity = {x:o(r.x), y:o(r.y)}, super.current = n;
    });
  }
  reset(t = this.defaultValue) {
    super.reset(Ia.from(t)), this.velocity = {x:0, y:0};
  }
};
mh = Uae(ax);
Kf = new WeakMap();
CR(mh, 2, "delta", IR, qv);
CR(mh, 2, "direction", NR, qv);
jae(mh, qv);
var OR = (t => (t.Horizontal = "x", t.Vertical = "y", t))(OR || {});
Object.values(OR);
var Qae = ({dragOperation:t, droppable:e}) => {
  const n = t.position.current;
  if (!n) {
    return null;
  }
  const {id:r} = e;
  if (!e.shape) {
    return null;
  }
  if (e.shape.containsPoint(n)) {
    const i = Ia.distance(e.shape.center, n);
    return {id:r, value:1 / i, type:zs.PointerIntersection, priority:Li.High};
  }
  return null;
}, Kae = ({dragOperation:t, droppable:e}) => {
  const {shape:n} = t;
  if (!e.shape || !(n != null && n.current)) {
    return null;
  }
  const r = n.current.intersectionArea(e.shape);
  if (r) {
    const {position:i} = t, s = Ia.distance(e.shape.center, i.current), a = r / (n.current.area + e.shape.area - r) / s;
    return {id:e.id, value:a, type:zs.ShapeIntersection, priority:Li.Normal};
  }
  return null;
}, Xae = t => {
  var e;
  return (e = Qae(t)) != null ? e : Kae(t);
};
function PR(t) {
  const {collisionDetector:e, data:n, disabled:r, element:i, id:s, accept:o, type:a} = t, l = Vv(u => new nm(xR(yR({}, t), {register:!1, element:Ko(i)}), u)), c = jv(l);
  return sn(s, () => l.id = s), nc(i, u => l.element = u), sn(o, () => l.accept = o, void 0, lo), sn(e, () => l.collisionDetector = e ?? Xae), sn(n, () => n && (l.data = n)), sn(r, () => l.disabled = r === !0), sn(a, () => l.type = a), {droppable:c, get isDropTarget() {
    return c.isDropTarget;
  }, ref:(0,require$react.useCallback)(u => {
    var h, f;
    !u && ((h = l.element) != null && h.isConnected) && !((f = l.manager) != null && f.dragOperation.status.idle) || (l.element = u ?? void 0);
  }, [l])};
}
var Jae = Object.create, RR = Object.defineProperty, Zae = Object.defineProperties, ele = Object.getOwnPropertyDescriptor, tle = Object.getOwnPropertyDescriptors, ug = Object.getOwnPropertySymbols, DR = Object.prototype.hasOwnProperty, LR = Object.prototype.propertyIsEnumerable, nle = (t, e) => (e = Symbol[t]) ? e : Symbol.for("Symbol." + t), bh = t => {
  throw TypeError(t);
}, lx = (t, e, n) => e in t ? RR(t, e, {enumerable:!0, configurable:!0, writable:!0, value:n}) : t[e] = n, rle = (t, e) => {
  for (var n in e || (e = {})) {
    DR.call(e, n) && lx(t, n, e[n]);
  }
  if (ug) {
    for (var n of ug(e)) {
      LR.call(e, n) && lx(t, n, e[n]);
    }
  }
  return t;
}, ile = (t, e) => Zae(t, tle(e)), sle = (t, e) => {
  var n = {};
  for (var r in t) {
    DR.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
  }
  if (t != null && ug) {
    for (var r of ug(t)) {
      e.indexOf(r) < 0 && LR.call(t, r) && (n[r] = t[r]);
    }
  }
  return n;
}, ole = t => {
  var e;
  return [, , , Jae((e = void 0) != null ? e : null)];
}, MR = ["class", "method", "getter", "setter", "accessor", "field", "value", "get", "set"], Au = t => t !== void 0 && typeof t != "function" ? bh("Function expected") : t, ale = (t, e, n, r, i) => ({kind:MR[t], name:e, metadata:r, addInitializer:s => n._ ? bh("Already initialized") : i.push(Au(s || null))}), lle = (t, e) => lx(e, nle("metadata"), t[3]), pf = (t, e, n, r) => {
  for (var i = 0, s = t[e >> 1], o = s && s.length; i < o; i++) {
    e & 1 ? s[i].call(n) : r = s[i].call(n, r);
  }
  return r;
}, BR = (t, e, n, r, i, s) => {
  for (var o, a, l, c, u, h = e & 7, f = !1, p = !1, g = t.length + 1, m = MR[h + 5], b = t[g - 1] = [], x = t[g] || (t[g] = []), w = (i = i.prototype, ele({get [n]() {
    return Nu(this, s);
  }, set [n](T) {
    return Ea(this, s, T);
  }}, n)), v = r.length - 1; v >= 0; v--) {
    c = ale(h, n, l = {}, t[3], x), c.static = f, c.private = p, u = c.access = {has:T => n in T}, u.get = T => T[n], u.set = (T, I) => T[n] = I, a = (0,r[v])({get:w.get, set:w.set}, c), l._ = 1, a === void 0 ? Au(a) && (w[m] = a) : typeof a != "object" || a === null ? bh("Object expected") : (Au(o = a.get) && (w.get = o), Au(o = a.set) && (w.set = o), Au(o = a.init) && b.unshift(o));
  }
  return w && RR(i, n, w), i;
}, $R = (t, e, n) => e.has(t) || bh("Cannot " + n), Nu = (t, e, n) => ($R(t, e, "read from private field"), e.get(t)), au = (t, e, n) => e.has(t) ? bh("Cannot add the same private member more than once") : e instanceof WeakSet ? e.add(t) : e.set(t, n), Ea = (t, e, n, r) => ($R(t, e, "write to private field"), e.set(t, n), n);
function $a(t) {
  return t instanceof Qv || t instanceof UR;
}
var gf = 10, cle = class extends vr {
  constructor(t) {
    super(t);
    const e = si(() => {
      const {dragOperation:r} = t;
      if (Rd(r.activatorEvent) && $a(r.source) && r.status.initialized) {
        const i = t.registry.plugins.get(gh);
        if (i) {
          return i.disable(), () => i.enable();
        }
      }
    }), n = t.monitor.addEventListener("dragmove", (r, i) => {
      queueMicrotask(() => {
        if (this.disabled || r.defaultPrevented || !r.nativeEvent) {
          return;
        }
        const {dragOperation:s} = i;
        if (!Rd(r.nativeEvent) || !$a(s.source) || !s.shape) {
          return;
        }
        const {actions:o, collisionObserver:a, registry:l} = i, {by:c} = r;
        if (!c) {
          return;
        }
        const u = ule(c), {source:h, target:f} = s, {center:p} = s.shape.current, g = [], m = [];
        Wn(() => {
          for (const I of l.droppables) {
            const {id:_} = I;
            if (!I.accepts(h) || _ === (f == null ? void 0 : f.id) && $a(I) || !I.element) {
              continue;
            }
            let N = I.shape;
            const E = new qi(I.element, {getBoundingClientRect:C => Od(C, void 0, 0.2)});
            !E.height || !E.width || (u == "down" && p.y + gf < E.center.y || u == "up" && p.y - gf > E.center.y || u == "left" && p.x - gf > E.center.x || u == "right" && p.x + gf < E.center.x) && (g.push(I), I.shape = E, m.push(() => I.shape = N));
          }
        }), r.preventDefault(), a.disable();
        const b = a.computeCollisions(g, Woe);
        Wn(() => m.forEach(I => I()));
        const [x] = b;
        if (!x) {
          return;
        }
        const {id:w} = x, {index:v, group:T} = h.sortable;
        o.setDropTarget(w).then(() => {
          const {source:I, target:_, shape:N} = s;
          if (!I || !$a(I) || !N) {
            return;
          }
          const {index:E, group:C, target:k} = I.sortable, A = v !== E || T !== C, P = A ? k : _ == null ? void 0 : _.element;
          if (!P) {
            return;
          }
          j4(P);
          const W = new qi(P);
          if (!W) {
            return;
          }
          const F = as.delta(W, as.from(N.current.boundingRectangle), I.alignment);
          o.move({by:F}), A ? o.setDropTarget(I.id).then(() => a.enable()) : a.enable();
        });
      });
    });
    this.destroy = () => {
      n(), e();
    };
  }
};
function ule(t) {
  const {x:e, y:n} = t;
  if (e > 0) {
    return "right";
  }
  if (e < 0) {
    return "left";
  }
  if (n > 0) {
    return "down";
  }
  if (n < 0) {
    return "up";
  }
}
var dle = Object.defineProperty, hle = Object.defineProperties, fle = Object.getOwnPropertyDescriptors, mE = Object.getOwnPropertySymbols, ple = Object.prototype.hasOwnProperty, gle = Object.prototype.propertyIsEnumerable, bE = (t, e, n) => e in t ? dle(t, e, {enumerable:!0, configurable:!0, writable:!0, value:n}) : t[e] = n, yE = (t, e) => {
  for (var n in e || (e = {})) {
    ple.call(e, n) && bE(t, n, e[n]);
  }
  if (mE) {
    for (var n of mE(e)) {
      gle.call(e, n) && bE(t, n, e[n]);
    }
  }
  return t;
}, xE = (t, e) => hle(t, fle(e));
function mle(t, e, n) {
  if (e === n) {
    return t;
  }
  const r = t.slice();
  return r.splice(n, 0, r.splice(e, 1)[0]), r;
}
function ble(t, e, n) {
  var r, i;
  const {source:s, target:o, canceled:a} = e.operation;
  if (!s || !o || a) {
    return "preventDefault" in e && e.preventDefault(), t;
  }
  const l = (v, T) => v === T || typeof v == "object" && "id" in v && v.id === T;
  if (Array.isArray(t)) {
    const v = t.findIndex(I => l(I, s.id)), T = t.findIndex(I => l(I, o.id));
    if (v === -1 || T === -1) {
      return t;
    }
    if (!a && "index" in s && typeof s.index == "number") {
      const I = s.index;
      if (I !== v) {
        return n(t, v, I);
      }
    }
    return n(t, v, T);
  }
  const c = Object.entries(t);
  let u = -1, h, f = -1, p;
  for (const [v, T] of c) {
    if (u === -1 && (u = T.findIndex(I => l(I, s.id)), u !== -1 && (h = v)), f === -1 && (f = T.findIndex(I => l(I, o.id)), f !== -1 && (p = v)), u !== -1 && f !== -1) {
      break;
    }
  }
  if (!s.manager) {
    return t;
  }
  const {dragOperation:g} = s.manager, m = (i = (r = g.shape) == null ? void 0 : r.current.center) != null ? i : g.position.current;
  if (p == null && o.id in t) {
    const v = o.shape && m.y > o.shape.center.y ? t[o.id].length : 0;
    p = o.id, f = v;
  }
  if (h == null || p == null || h === p && u === f) {
    return "preventDefault" in e && e.preventDefault(), t;
  }
  if (h === p) {
    return xE(yE({}, t), {[h]:n(t[h], u, f)});
  }
  const x = o.shape && Math.round(m.y) > Math.round(o.shape.center.y) ? 1 : 0, w = t[h][u];
  return xE(yE({}, t), {[h]:[...t[h].slice(0, u), ...t[h].slice(u + 1)], [p]:[...t[p].slice(0, f + x), w, ...t[p].slice(f + x)]});
}
function yle(t, e) {
  return ble(t, e, mle);
}
var vE = "__default__", xle = class extends vr {
  constructor(t) {
    super(t);
    const e = () => {
      const r = new Map();
      for (const i of t.registry.droppables) {
        if (i instanceof Qv) {
          const {sortable:s} = i, {group:o} = s;
          let a = r.get(o);
          a || (a = new Set(), r.set(o, a)), a.add(s);
        }
      }
      for (const [i, s] of r) {
        r.set(i, new Set(mf(s)));
      }
      return r;
    }, n = [t.monitor.addEventListener("dragover", (r, i) => {
      if (this.disabled) {
        return;
      }
      const {dragOperation:s} = i, {source:o, target:a} = s;
      if (!$a(o) || !$a(a) || o.sortable === a.sortable) {
        return;
      }
      const l = e(), c = o.sortable.group === a.sortable.group, u = l.get(o.sortable.group), h = c ? u : l.get(a.sortable.group);
      !u || !h || queueMicrotask(() => {
        r.defaultPrevented || i.renderer.rendering.then(() => {
          var f, p, g;
          const m = e();
          for (const [k, A] of l.entries()) {
            const P = Array.from(A).entries();
            for (const [W, F] of P) {
              if (F.index !== W || F.group !== k || !((f = m.get(k)) != null && f.has(F))) {
                return;
              }
            }
          }
          const b = o.sortable.element, x = a.sortable.element;
          if (!x || !b || !c && a.id === o.sortable.group) {
            return;
          }
          const w = mf(u), v = c ? w : mf(h), T = (p = o.sortable.group) != null ? p : vE, I = (g = a.sortable.group) != null ? g : vE, _ = {[T]:w, [I]:v}, N = yle(_, r);
          if (_ === N) {
            return;
          }
          const E = N[I].indexOf(o.sortable), C = N[I].indexOf(a.sortable);
          i.collisionObserver.disable(), wE(b, E, x, C), Wn(() => {
            for (const [k, A] of N[T].entries()) {
              A.index = k;
            }
            if (!c) {
              for (const [k, A] of N[I].entries()) {
                A.group = a.sortable.group, A.index = k;
              }
            }
          }), i.actions.setDropTarget(o.id).then(() => i.collisionObserver.enable());
        });
      });
    }), t.monitor.addEventListener("dragend", (r, i) => {
      if (!r.canceled) {
        return;
      }
      const {dragOperation:s} = i, {source:o} = s;
      $a(o) && (o.sortable.initialIndex === o.sortable.index && o.sortable.initialGroup === o.sortable.group || queueMicrotask(() => {
        const a = e(), l = a.get(o.sortable.initialGroup);
        l && i.renderer.rendering.then(() => {
          for (const [p, g] of a.entries()) {
            const m = Array.from(g).entries();
            for (const [b, x] of m) {
              if (x.index !== b || x.group !== p) {
                return;
              }
            }
          }
          const c = mf(l), u = o.sortable.element, h = c[o.sortable.initialIndex], f = h == null ? void 0 : h.element;
          !h || !f || !u || (wE(u, h.index, f, o.index), Wn(() => {
            for (const [p, g] of a.entries()) {
              const m = Array.from(g).values();
              for (const b of m) {
                b.index = b.initialIndex, b.group = b.initialGroup;
              }
            }
          }));
        });
      }));
    })];
    this.destroy = () => {
      for (const r of n) {
        r();
      }
    };
  }
};
function wE(t, e, n, r) {
  const i = r < e ? "afterend" : "beforebegin";
  n.insertAdjacentElement(i, t);
}
function vle(t, e) {
  return t.index - e.index;
}
function mf(t) {
  return Array.from(t).sort(vle);
}
var wle = [cle, xle], FR = {duration:250, easing:"cubic-bezier(0.25, 1, 0.5, 1)", idle:!1}, bf = new Ese(), zR, HR, Go, Yv, Iu, Ou, Gv, Bl;
HR = [Jt], zR = [Jt];
var im = class {
  constructor(t, e) {
    au(this, Yv, pf(Go, 8, this)), pf(Go, 11, this), au(this, Iu), au(this, Ou), au(this, Gv, pf(Go, 12, this)), pf(Go, 15, this), au(this, Bl), this.register = () => (Wn(() => {
      var h, f;
      (h = this.manager) == null || h.registry.register(this.droppable), (f = this.manager) == null || f.registry.register(this.draggable);
    }), () => this.unregister()), this.unregister = () => {
      Wn(() => {
        var h, f;
        (h = this.manager) == null || h.registry.unregister(this.droppable), (f = this.manager) == null || f.registry.unregister(this.draggable);
      });
    }, this.destroy = () => {
      Wn(() => {
        this.droppable.destroy(), this.draggable.destroy();
      });
    };
    var n = t, {effects:r = () => [], group:i, index:s, sensors:o, type:a, transition:l = FR, plugins:c = wle} = n, u = sle(n, ["effects", "group", "index", "sensors", "type", "transition", "plugins"]);
    this.droppable = new Qv(u, e, this), this.draggable = new UR(ile(rle({}, u), {effects:() => [() => {
      var h, f, p;
      const g = (h = this.manager) == null ? void 0 : h.dragOperation.status;
      g != null && g.initializing && this.id === ((p = (f = this.manager) == null ? void 0 : f.dragOperation.source) == null ? void 0 : p.id) && bf.clear(this.manager), g != null && g.dragging && bf.set(this.manager, this.id, on(() => ({initialIndex:this.index, initialGroup:this.group})));
    }, () => {
      const {index:h, group:f, manager:p} = this, g = Nu(this, Ou), m = Nu(this, Iu);
      (h !== g || f !== m) && (Ea(this, Ou, h), Ea(this, Iu, f), this.animate());
    }, () => {
      const {target:h} = this, {feedback:f, isDragSource:p} = this.draggable;
      f == "move" && p && (this.droppable.disabled = !h);
    }, () => {
      const {manager:h} = this;
      for (const f of c) {
        h == null || h.registry.register(f);
      }
    }, ...r()], type:a, sensors:o}), e, this), Ea(this, Bl, u.element), this.manager = e, this.index = s, Ea(this, Ou, s), this.group = i, Ea(this, Iu, i), this.type = a, this.transition = l;
  }
  get initialIndex() {
    var t, e;
    return (e = (t = bf.get(this.manager, this.id)) == null ? void 0 : t.initialIndex) != null ? e : this.index;
  }
  get initialGroup() {
    var t, e;
    return (e = (t = bf.get(this.manager, this.id)) == null ? void 0 : t.initialGroup) != null ? e : this.group;
  }
  animate() {
    on(() => {
      const {manager:t, transition:e} = this, {shape:n} = this.droppable;
      if (!t) {
        return;
      }
      const {idle:r} = t.dragOperation.status;
      !n || !e || r && !e.idle || t.renderer.rendering.then(() => {
        const {element:i} = this;
        if (!i) {
          return;
        }
        const s = this.refreshShape();
        if (!s) {
          return;
        }
        const o = {x:n.boundingRectangle.left - s.boundingRectangle.left, y:n.boundingRectangle.top - s.boundingRectangle.top}, {translate:a} = ls(i), l = iE(i, a, !1), c = iE(i, a);
        (o.x || o.y) && V4({element:i, keyframes:{translate:[`${l.x + o.x}px ${l.y + o.y}px ${l.z}`, `${c.x}px ${c.y}px ${c.z}`]}, options:e}).then(() => {
          t.dragOperation.status.dragging || (this.droppable.shape = void 0);
        });
      });
    });
  }
  get manager() {
    return this.draggable.manager;
  }
  set manager(t) {
    Wn(() => {
      this.draggable.manager = t, this.droppable.manager = t;
    });
  }
  set element(t) {
    Wn(() => {
      const e = Nu(this, Bl), n = this.droppable.element, r = this.draggable.element;
      (!n || n === e) && (this.droppable.element = t), (!r || r === e) && (this.draggable.element = t), Ea(this, Bl, t);
    });
  }
  get element() {
    var t, e;
    const n = Nu(this, Bl);
    if (n) {
      return (e = (t = Yy.get(n)) != null ? t : n) != null ? e : this.droppable.element;
    }
  }
  set target(t) {
    this.droppable.element = t;
  }
  get target() {
    return this.droppable.element;
  }
  set source(t) {
    this.draggable.element = t;
  }
  get source() {
    return this.draggable.element;
  }
  get disabled() {
    return this.draggable.disabled && this.droppable.disabled;
  }
  set feedback(t) {
    this.draggable.feedback = t;
  }
  set disabled(t) {
    Wn(() => {
      this.droppable.disabled = t, this.draggable.disabled = t;
    });
  }
  set data(t) {
    Wn(() => {
      this.droppable.data = t, this.draggable.data = t;
    });
  }
  set handle(t) {
    this.draggable.handle = t;
  }
  set id(t) {
    Wn(() => {
      this.droppable.id = t, this.draggable.id = t;
    });
  }
  get id() {
    return this.droppable.id;
  }
  set sensors(t) {
    this.draggable.sensors = t;
  }
  set modifiers(t) {
    this.draggable.modifiers = t;
  }
  set collisionPriority(t) {
    this.droppable.collisionPriority = t;
  }
  set collisionDetector(t) {
    this.droppable.collisionDetector = t ?? q4;
  }
  set alignment(t) {
    this.draggable.alignment = t;
  }
  get alignment() {
    return this.draggable.alignment;
  }
  set type(t) {
    Wn(() => {
      this.droppable.type = t, this.draggable.type = t;
    });
  }
  get type() {
    return this.draggable.type;
  }
  set accept(t) {
    this.droppable.accept = t;
  }
  get accept() {
    return this.droppable.accept;
  }
  get isDropTarget() {
    return this.droppable.isDropTarget;
  }
  get isDragSource() {
    return this.draggable.isDragSource;
  }
  get isDragging() {
    return this.draggable.isDragging;
  }
  get isDropping() {
    return this.draggable.isDropping;
  }
  get status() {
    return this.draggable.status;
  }
  refreshShape() {
    return this.droppable.refreshShape();
  }
  accepts(t) {
    return this.droppable.accepts(t);
  }
};
Go = ole();
Yv = new WeakMap();
Iu = new WeakMap();
Ou = new WeakMap();
Gv = new WeakMap();
Bl = new WeakMap();
BR(Go, 4, "index", HR, im, Yv);
BR(Go, 4, "group", zR, im, Gv);
lle(Go, im);
var UR = class extends zc {
  constructor(t, e, n) {
    super(t, e), this.sortable = n;
  }
  get index() {
    return this.sortable.index;
  }
}, Qv = class extends nm {
  constructor(t, e, n) {
    super(t, e), this.sortable = n;
  }
}, _le = Object.defineProperty, Sle = Object.defineProperties, kle = Object.getOwnPropertyDescriptors, _E = Object.getOwnPropertySymbols, Ele = Object.prototype.hasOwnProperty, Tle = Object.prototype.propertyIsEnumerable, SE = (t, e, n) => e in t ? _le(t, e, {enumerable:!0, configurable:!0, writable:!0, value:n}) : t[e] = n, j0 = (t, e) => {
  for (var n in e || (e = {})) {
    Ele.call(e, n) && SE(t, n, e[n]);
  }
  if (_E) {
    for (var n of _E(e)) {
      Tle.call(e, n) && SE(t, n, e[n]);
    }
  }
  return t;
}, Cle = (t, e) => Sle(t, kle(e));
function WR(t) {
  const {accept:e, collisionDetector:n, collisionPriority:r, id:i, data:s, element:o, handle:a, index:l, group:c, disabled:u, feedback:h, modifiers:f, sensors:p, target:g, type:m} = t, b = j0(j0({}, FR), t.transition), x = Vv(v => new im(Cle(j0({}, t), {transition:b, register:!1, handle:Ko(a), element:Ko(o), target:Ko(g), feedback:h}), v)), w = jv(x, Ale);
  return sn(i, () => x.id = i), Hc(() => {
    Wn(() => {
      x.group = c, x.index = l;
    });
  }, [x, c, l]), sn(m, () => x.type = m), sn(e, () => x.accept = e, void 0, lo), sn(s, () => s && (x.data = s)), sn(l, () => {
    var v;
    (v = x.manager) != null && v.dragOperation.status.idle && (b != null && b.idle) && x.refreshShape();
  }, Iae), nc(a, v => x.handle = v), nc(o, v => x.element = v), nc(g, v => x.target = v), sn(u, () => x.disabled = u === !0), sn(p, () => x.sensors = p), sn(n, () => x.collisionDetector = n), sn(r, () => x.collisionPriority = r), sn(h, () => x.feedback = h ?? "default"), sn(b, () => x.transition = b, void 0, lo), sn(f, () => x.modifiers = f, void 0, lo), sn(t.alignment, () => x.alignment = t.alignment), {sortable:w, get isDragging() {
    return w.isDragging;
  }, get isDropping() {
    return w.isDropping;
  }, get isDragSource() {
    return w.isDragSource;
  }, get isDropTarget() {
    return w.isDropTarget;
  }, handleRef:(0,require$react.useCallback)(v => {
    x.handle = v ?? void 0;
  }, [x]), ref:(0,require$react.useCallback)(v => {
    var T, I;
    !v && ((T = x.element) != null && T.isConnected) && !((I = x.manager) != null && I.dragOperation.status.idle) || (x.element = v ?? void 0);
  }, [x]), sourceRef:(0,require$react.useCallback)(v => {
    var T, I;
    !v && ((T = x.source) != null && T.isConnected) && !((I = x.manager) != null && I.dragOperation.status.idle) || (x.source = v ?? void 0);
  }, [x]), targetRef:(0,require$react.useCallback)(v => {
    var T, I;
    !v && ((T = x.target) != null && T.isConnected) && !((I = x.manager) != null && I.dragOperation.status.idle) || (x.target = v ?? void 0);
  }, [x])};
}
function Ale(t, e, n) {
  return !!(t === "isDragSource" && !n && e);
}
const kE = t => Symbol.iterator in t, EE = t => "entries" in t, TE = (t, e) => {
  const n = t instanceof Map ? t : new Map(t.entries()), r = e instanceof Map ? e : new Map(e.entries());
  if (n.size !== r.size) {
    return !1;
  }
  for (const [i, s] of n) {
    if (!r.has(i) || !Object.is(s, r.get(i))) {
      return !1;
    }
  }
  return !0;
}, Nle = (t, e) => {
  const n = t[Symbol.iterator](), r = e[Symbol.iterator]();
  let i = n.next(), s = r.next();
  for (; !i.done && !s.done;) {
    if (!Object.is(i.value, s.value)) {
      return !1;
    }
    i = n.next(), s = r.next();
  }
  return !!i.done && !!s.done;
};
function Ile(t, e) {
  return Object.is(t, e) ? !0 : typeof t != "object" || t === null || typeof e != "object" || e === null || Object.getPrototypeOf(t) !== Object.getPrototypeOf(e) ? !1 : kE(t) && kE(e) ? EE(t) && EE(e) ? TE(t, e) : Nle(t, e) : TE({entries:() => Object.entries(t)}, {entries:() => Object.entries(e)});
}
function xr(t) {
  const e = default$$require$react.default.useRef(void 0);
  return n => {
    const r = t(n);
    return Ile(e.current, r) ? e.current : e.current = r;
  };
}
function Ole(t, e, n) {
  var r = this, i = (0,require$react.useRef)(null), s = (0,require$react.useRef)(0), o = (0,require$react.useRef)(null), a = (0,require$react.useRef)([]), l = (0,require$react.useRef)(), c = (0,require$react.useRef)(), u = (0,require$react.useRef)(t), h = (0,require$react.useRef)(!0);
  (0,require$react.useEffect)(function() {
    u.current = t;
  }, [t]);
  var f = !e && e !== 0 && typeof window < "u";
  if (typeof t != "function") {
    throw new TypeError("Expected a function");
  }
  e = +e || 0;
  var p = !!(n = n || {}).leading, g = !("trailing" in n) || !!n.trailing, m = "maxWait" in n, b = m ? Math.max(+n.maxWait || 0, e) : null;
  (0,require$react.useEffect)(function() {
    return h.current = !0, function() {
      h.current = !1;
    };
  }, []);
  var x = (0,require$react.useMemo)(function() {
    var w = function(E) {
      var C = a.current, k = l.current;
      return a.current = l.current = null, s.current = E, c.current = u.current.apply(k, C);
    }, v = function(E, C) {
      f && cancelAnimationFrame(o.current), o.current = f ? requestAnimationFrame(E) : setTimeout(E, C);
    }, T = function(E) {
      if (!h.current) {
        return !1;
      }
      var C = E - i.current;
      return !i.current || C >= e || C < 0 || m && E - s.current >= b;
    }, I = function(E) {
      return o.current = null, g && a.current ? w(E) : (a.current = l.current = null, c.current);
    }, _ = function E() {
      var C = Date.now();
      if (T(C)) {
        return I(C);
      }
      if (h.current) {
        var k = e - (C - i.current), A = m ? Math.min(k, b - (C - s.current)) : k;
        v(E, A);
      }
    }, N = function() {
      var E = Date.now(), C = T(E);
      if (a.current = [].slice.call(arguments), l.current = r, i.current = E, C) {
        if (!o.current && h.current) {
          return s.current = i.current, v(_, e), p ? w(i.current) : c.current;
        }
        if (m) {
          return v(_, e), w(i.current);
        }
      }
      return o.current || v(_, e), c.current;
    };
    return N.cancel = function() {
      o.current && (f ? cancelAnimationFrame(o.current) : clearTimeout(o.current)), s.current = 0, a.current = i.current = l.current = o.current = null;
    }, N.isPending = function() {
      return !!o.current;
    }, N.flush = function() {
      return o.current ? I(Date.now()) : c.current;
    }, N;
  }, [p, m, e, b, g, f]);
  return x;
}
function yf(t) {
  throw new Error('Could not dynamically require "' + t + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var jR = {exports:{}};
(function(t, e) {
  (function(n) {
    t.exports = n();
  })(function() {
    return function n(r, i, s) {
      function o(c, u) {
        if (!i[c]) {
          if (!r[c]) {
            var h = typeof yf == "function" && yf;
            if (!u && h) {
              return h(c, !0);
            }
            if (a) {
              return a(c, !0);
            }
            throw new Error("Cannot find module '" + c + "'");
          }
          u = i[c] = {exports:{}}, r[c][0].call(u.exports, function(f) {
            var p = r[c][1][f];
            return o(p || f);
          }, u, u.exports, n, r, i, s);
        }
        return i[c].exports;
      }
      for (var a = typeof yf == "function" && yf, l = 0; l < s.length; l++) {
        o(s[l]);
      }
      return o;
    }({1:[function(n, r, i) {
      (function(s, o, a, l, c, u, h, f, p) {
        var g = n("crypto");
        function m(_, N) {
          N = w(_, N);
          var E;
          return (E = N.algorithm !== "passthrough" ? g.createHash(N.algorithm) : new I()).write === void 0 && (E.write = E.update, E.end = E.update), T(N, E).dispatch(_), E.update || E.end(""), E.digest ? E.digest(N.encoding === "buffer" ? void 0 : N.encoding) : (_ = E.read(), N.encoding !== "buffer" ? _.toString(N.encoding) : _);
        }
        (i = r.exports = m).sha1 = function(_) {
          return m(_);
        }, i.keys = function(_) {
          return m(_, {excludeValues:!0, algorithm:"sha1", encoding:"hex"});
        }, i.MD5 = function(_) {
          return m(_, {algorithm:"md5", encoding:"hex"});
        }, i.keysMD5 = function(_) {
          return m(_, {algorithm:"md5", encoding:"hex", excludeValues:!0});
        };
        var b = g.getHashes ? g.getHashes().slice() : ["sha1", "md5"], x = (b.push("passthrough"), ["buffer", "hex", "binary", "base64"]);
        function w(_, N) {
          var E = {};
          if (E.algorithm = (N = N || {}).algorithm || "sha1", E.encoding = N.encoding || "hex", E.excludeValues = !!N.excludeValues, E.algorithm = E.algorithm.toLowerCase(), E.encoding = E.encoding.toLowerCase(), E.ignoreUnknown = N.ignoreUnknown === !0, E.respectType = N.respectType !== !1, E.respectFunctionNames = N.respectFunctionNames !== !1, E.respectFunctionProperties = N.respectFunctionProperties !== !1, E.unorderedArrays = N.unorderedArrays === !0, E.unorderedSets = N.unorderedSets !== !1, 
          E.unorderedObjects = N.unorderedObjects !== !1, E.replacer = N.replacer || void 0, E.excludeKeys = N.excludeKeys || void 0, _ === void 0) {
            throw new Error("Object argument required.");
          }
          for (var C = 0; C < b.length; ++C) {
            b[C].toLowerCase() === E.algorithm.toLowerCase() && (E.algorithm = b[C]);
          }
          if (b.indexOf(E.algorithm) === -1) {
            throw new Error('Algorithm "' + E.algorithm + '"  not supported. supported values: ' + b.join(", "));
          }
          if (x.indexOf(E.encoding) === -1 && E.algorithm !== "passthrough") {
            throw new Error('Encoding "' + E.encoding + '"  not supported. supported values: ' + x.join(", "));
          }
          return E;
        }
        function v(_) {
          if (typeof _ == "function") {
            return /^function\s+\w*\s*\(\s*\)\s*{\s+\[native code\]\s+}$/i.exec(Function.prototype.toString.call(_)) != null;
          }
        }
        function T(_, N, E) {
          E = E || [];
          function C(k) {
            return N.update ? N.update(k, "utf8") : N.write(k, "utf8");
          }
          return {dispatch:function(k) {
            return this["_" + ((k = _.replacer ? _.replacer(k) : k) === null ? "null" : typeof k)](k);
          }, _object:function(k) {
            var A, P = Object.prototype.toString.call(k), W = /\[object (.*)\]/i.exec(P);
            if (W = (W = W ? W[1] : "unknown:[" + P + "]").toLowerCase(), 0 <= (P = E.indexOf(k))) {
              return this.dispatch("[CIRCULAR:" + P + "]");
            }
            if (E.push(k), a !== void 0 && a.isBuffer && a.isBuffer(k)) {
              return C("buffer:"), C(k);
            }
            if (W === "object" || W === "function" || W === "asyncfunction") {
              return P = Object.keys(k), _.unorderedObjects && (P = P.sort()), _.respectType === !1 || v(k) || P.splice(0, 0, "prototype", "__proto__", "constructor"), _.excludeKeys && (P = P.filter(function(F) {
                return !_.excludeKeys(F);
              })), C("object:" + P.length + ":"), A = this, P.forEach(function(F) {
                A.dispatch(F), C(":"), _.excludeValues || A.dispatch(k[F]), C(",");
              });
            }
            if (!this["_" + W]) {
              if (_.ignoreUnknown) {
                return C("[" + W + "]");
              }
              throw new Error('Unknown object type "' + W + '"');
            }
            this["_" + W](k);
          }, _array:function(k, F) {
            F = F !== void 0 ? F : _.unorderedArrays !== !1;
            var P = this;
            if (C("array:" + k.length + ":"), !F || k.length <= 1) {
              return k.forEach(function(B) {
                return P.dispatch(B);
              });
            }
            var W = [], F = k.map(function(B) {
              var z = new I(), j = E.slice();
              return T(_, z, j).dispatch(B), W = W.concat(j.slice(E.length)), z.read().toString();
            });
            return E = E.concat(W), F.sort(), this._array(F, !1);
          }, _date:function(k) {
            return C("date:" + k.toJSON());
          }, _symbol:function(k) {
            return C("symbol:" + k.toString());
          }, _error:function(k) {
            return C("error:" + k.toString());
          }, _boolean:function(k) {
            return C("bool:" + k.toString());
          }, _string:function(k) {
            C("string:" + k.length + ":"), C(k.toString());
          }, _function:function(k) {
            C("fn:"), v(k) ? this.dispatch("[native]") : this.dispatch(k.toString()), _.respectFunctionNames !== !1 && this.dispatch("function-name:" + String(k.name)), _.respectFunctionProperties && this._object(k);
          }, _number:function(k) {
            return C("number:" + k.toString());
          }, _xml:function(k) {
            return C("xml:" + k.toString());
          }, _null:function() {
            return C("Null");
          }, _undefined:function() {
            return C("Undefined");
          }, _regexp:function(k) {
            return C("regex:" + k.toString());
          }, _uint8array:function(k) {
            return C("uint8array:"), this.dispatch(Array.prototype.slice.call(k));
          }, _uint8clampedarray:function(k) {
            return C("uint8clampedarray:"), this.dispatch(Array.prototype.slice.call(k));
          }, _int8array:function(k) {
            return C("int8array:"), this.dispatch(Array.prototype.slice.call(k));
          }, _uint16array:function(k) {
            return C("uint16array:"), this.dispatch(Array.prototype.slice.call(k));
          }, _int16array:function(k) {
            return C("int16array:"), this.dispatch(Array.prototype.slice.call(k));
          }, _uint32array:function(k) {
            return C("uint32array:"), this.dispatch(Array.prototype.slice.call(k));
          }, _int32array:function(k) {
            return C("int32array:"), this.dispatch(Array.prototype.slice.call(k));
          }, _float32array:function(k) {
            return C("float32array:"), this.dispatch(Array.prototype.slice.call(k));
          }, _float64array:function(k) {
            return C("float64array:"), this.dispatch(Array.prototype.slice.call(k));
          }, _arraybuffer:function(k) {
            return C("arraybuffer:"), this.dispatch(new Uint8Array(k));
          }, _url:function(k) {
            return C("url:" + k.toString());
          }, _map:function(k) {
            return C("map:"), k = Array.from(k), this._array(k, _.unorderedSets !== !1);
          }, _set:function(k) {
            return C("set:"), k = Array.from(k), this._array(k, _.unorderedSets !== !1);
          }, _file:function(k) {
            return C("file:"), this.dispatch([k.name, k.size, k.type, k.lastModfied]);
          }, _blob:function() {
            if (_.ignoreUnknown) {
              return C("[blob]");
            }
            throw Error(`Hashing Blob objects is currently not supported
(see https://github.com/puleos/object-hash/issues/26)
Use "options.replacer" or "options.ignoreUnknown"
`);
          }, _domwindow:function() {
            return C("domwindow");
          }, _bigint:function(k) {
            return C("bigint:" + k.toString());
          }, _process:function() {
            return C("process");
          }, _timer:function() {
            return C("timer");
          }, _pipe:function() {
            return C("pipe");
          }, _tcp:function() {
            return C("tcp");
          }, _udp:function() {
            return C("udp");
          }, _tty:function() {
            return C("tty");
          }, _statwatcher:function() {
            return C("statwatcher");
          }, _securecontext:function() {
            return C("securecontext");
          }, _connection:function() {
            return C("connection");
          }, _zlib:function() {
            return C("zlib");
          }, _context:function() {
            return C("context");
          }, _nodescript:function() {
            return C("nodescript");
          }, _httpparser:function() {
            return C("httpparser");
          }, _dataview:function() {
            return C("dataview");
          }, _signal:function() {
            return C("signal");
          }, _fsevent:function() {
            return C("fsevent");
          }, _tlswrap:function() {
            return C("tlswrap");
          }};
        }
        function I() {
          return {buf:"", write:function(_) {
            this.buf += _;
          }, end:function(_) {
            this.buf += _;
          }, read:function() {
            return this.buf;
          }};
        }
        i.writeToStream = function(_, N, E) {
          return E === void 0 && (E = N, N = {}), T(N = w(_, N), E).dispatch(_);
        };
      }).call(this, n("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, n("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/fake_9a5aa49d.js", "/");
    }, {buffer:3, crypto:5, lYpoI2:11}], 2:[function(n, r, i) {
      (function(s, o, a, l, c, u, h, f, p) {
        (function(g) {
          var m = typeof Uint8Array < "u" ? Uint8Array : Array, b = 43, x = 47, w = 48, v = 97, T = 65, I = 45, _ = 95;
          function N(E) {
            return E = E.charCodeAt(0), E === b || E === I ? 62 : E === x || E === _ ? 63 : E < w ? -1 : E < w + 10 ? E - w + 26 + 26 : E < T + 26 ? E - T : E < v + 26 ? E - v + 26 : void 0;
          }
          g.toByteArray = function(E) {
            var C, k;
            if (0 < E.length % 4) {
              throw new Error("Invalid string. Length must be a multiple of 4");
            }
            var A = E.length, A = E.charAt(A - 2) === "\x3d" ? 2 : E.charAt(A - 1) === "\x3d" ? 1 : 0, P = new m(3 * E.length / 4 - A), W = 0 < A ? E.length - 4 : E.length, F = 0;
            function B(z) {
              P[F++] = z;
            }
            for (C = 0; C < W; C += 4, 0) {
              B((16711680 & (k = N(E.charAt(C)) << 18 | N(E.charAt(C + 1)) << 12 | N(E.charAt(C + 2)) << 6 | N(E.charAt(C + 3)))) >> 16), B((65280 & k) >> 8), B(255 & k);
            }
            return A == 2 ? B(255 & (k = N(E.charAt(C)) << 2 | N(E.charAt(C + 1)) >> 4)) : A == 1 && (B((k = N(E.charAt(C)) << 10 | N(E.charAt(C + 1)) << 4 | N(E.charAt(C + 2)) >> 2) >> 8 & 255), B(255 & k)), P;
          }, g.fromByteArray = function(E) {
            var C, k, A, P, W = E.length % 3, F = "";
            function B(z) {
              return "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/".charAt(z);
            }
            for (C = 0, A = E.length - W; C < A; C += 3) {
              k = (E[C] << 16) + (E[C + 1] << 8) + E[C + 2], F += B((P = k) >> 18 & 63) + B(P >> 12 & 63) + B(P >> 6 & 63) + B(63 & P);
            }
            switch(W) {
              case 1:
                F = (F += B((k = E[E.length - 1]) >> 2)) + B(k << 4 & 63) + "\x3d\x3d";
                break;
              case 2:
                F = (F = (F += B((k = (E[E.length - 2] << 8) + E[E.length - 1]) >> 10)) + B(k >> 4 & 63)) + B(k << 2 & 63) + "\x3d";
            }
            return F;
          };
        })(i === void 0 ? this.base64js = {} : i);
      }).call(this, n("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, n("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/base64-js/lib/b64.js", "/node_modules/gulp-browserify/node_modules/base64-js/lib");
    }, {buffer:3, lYpoI2:11}], 3:[function(n, r, i) {
      (function(s, o, b, l, c, u, h, f, p) {
        var g = n("base64-js"), m = n("ieee754");
        function b(R, $, G) {
          if (!(this instanceof b)) {
            return new b(R, $, G);
          }
          var J, U, le, be, je = typeof R;
          if ($ === "base64" && je == "string") {
            for (R = (be = R).trim ? be.trim() : be.replace(/^\s+|\s+$/g, ""); R.length % 4 != 0;) {
              R += "\x3d";
            }
          }
          if (je == "number") {
            J = V(R);
          } else if (je == "string") {
            J = b.byteLength(R, $);
          } else {
            if (je != "object") {
              throw new Error("First argument needs to be a number, array or string.");
            }
            J = V(R.length);
          }
          if (b._useTypedArrays ? U = b._augment(new Uint8Array(J)) : ((U = this).length = J, U._isBuffer = !0), b._useTypedArrays && typeof R.byteLength == "number") {
            U._set(R);
          } else if (ne(be = R) || b.isBuffer(be) || be && typeof be == "object" && typeof be.length == "number") {
            for (le = 0; le < J; le++) {
              b.isBuffer(R) ? U[le] = R.readUInt8(le) : U[le] = R[le];
            }
          } else if (je == "string") {
            U.write(R, 0, $);
          } else if (je == "number" && !b._useTypedArrays && !G) {
            for (le = 0; le < J; le++) {
              U[le] = 0;
            }
          }
          return U;
        }
        function x(R, $, G, J) {
          return b._charsWritten = M(function(U) {
            for (var le = [], be = 0; be < U.length; be++) {
              le.push(255 & U.charCodeAt(be));
            }
            return le;
          }($), R, G, J);
        }
        function w(R, $, G, J) {
          return b._charsWritten = M(function(U) {
            for (var le, be, je = [], Ae = 0; Ae < U.length; Ae++) {
              be = U.charCodeAt(Ae), le = be >> 8, be = be % 256, je.push(be), je.push(le);
            }
            return je;
          }($), R, G, J);
        }
        function v(R, $, G) {
          var J = "";
          G = Math.min(R.length, G);
          for (var U = $; U < G; U++) {
            J += String.fromCharCode(R[U]);
          }
          return J;
        }
        function T(R, $, G, le) {
          le || (q(typeof G == "boolean", "missing or invalid endian"), q($ != null, "missing offset"), q($ + 1 < R.length, "Trying to read beyond buffer length"));
          var U, le = R.length;
          if (!(le <= $)) {
            return G ? (U = R[$], $ + 1 < le && (U |= R[$ + 1] << 8)) : (U = R[$] << 8, $ + 1 < le && (U |= R[$ + 1])), U;
          }
        }
        function I(R, $, G, le) {
          le || (q(typeof G == "boolean", "missing or invalid endian"), q($ != null, "missing offset"), q($ + 3 < R.length, "Trying to read beyond buffer length"));
          var U, le = R.length;
          if (!(le <= $)) {
            return G ? ($ + 2 < le && (U = R[$ + 2] << 16), $ + 1 < le && (U |= R[$ + 1] << 8), U |= R[$], $ + 3 < le && (U += R[$ + 3] << 24 >>> 0)) : ($ + 1 < le && (U = R[$ + 1] << 16), $ + 2 < le && (U |= R[$ + 2] << 8), $ + 3 < le && (U |= R[$ + 3]), U += R[$] << 24 >>> 0), U;
          }
        }
        function _(R, $, G, J) {
          if (J || (q(typeof G == "boolean", "missing or invalid endian"), q($ != null, "missing offset"), q($ + 1 < R.length, "Trying to read beyond buffer length")), !(R.length <= $)) {
            return J = T(R, $, G, !0), 32768 & J ? -1 * (65535 - J + 1) : J;
          }
        }
        function N(R, $, G, J) {
          if (J || (q(typeof G == "boolean", "missing or invalid endian"), q($ != null, "missing offset"), q($ + 3 < R.length, "Trying to read beyond buffer length")), !(R.length <= $)) {
            return J = I(R, $, G, !0), 2147483648 & J ? -1 * (4294967295 - J + 1) : J;
          }
        }
        function E(R, $, G, J) {
          return J || (q(typeof G == "boolean", "missing or invalid endian"), q($ + 3 < R.length, "Trying to read beyond buffer length")), m.read(R, $, G, 23, 4);
        }
        function C(R, $, G, J) {
          return J || (q(typeof G == "boolean", "missing or invalid endian"), q($ + 7 < R.length, "Trying to read beyond buffer length")), m.read(R, $, G, 52, 8);
        }
        function k(R, $, G, J, U) {
          if (U || (q($ != null, "missing value"), q(typeof J == "boolean", "missing or invalid endian"), q(G != null, "missing offset"), q(G + 1 < R.length, "trying to write beyond buffer length"), ge($, 65535)), U = R.length, !(U <= G)) {
            for (var le = 0, be = Math.min(U - G, 2); le < be; le++) {
              R[G + le] = ($ & 255 << 8 * (J ? le : 1 - le)) >>> 8 * (J ? le : 1 - le);
            }
          }
        }
        function A(R, $, G, J, U) {
          if (U || (q($ != null, "missing value"), q(typeof J == "boolean", "missing or invalid endian"), q(G != null, "missing offset"), q(G + 3 < R.length, "trying to write beyond buffer length"), ge($, 4294967295)), U = R.length, !(U <= G)) {
            for (var le = 0, be = Math.min(U - G, 4); le < be; le++) {
              R[G + le] = $ >>> 8 * (J ? le : 3 - le) & 255;
            }
          }
        }
        function P(R, $, G, J, U) {
          U || (q($ != null, "missing value"), q(typeof J == "boolean", "missing or invalid endian"), q(G != null, "missing offset"), q(G + 1 < R.length, "Trying to write beyond buffer length"), me($, 32767, -32768)), R.length <= G || k(R, 0 <= $ ? $ : 65535 + $ + 1, G, J, U);
        }
        function W(R, $, G, J, U) {
          U || (q($ != null, "missing value"), q(typeof J == "boolean", "missing or invalid endian"), q(G != null, "missing offset"), q(G + 3 < R.length, "Trying to write beyond buffer length"), me($, 2147483647, -2147483648)), R.length <= G || A(R, 0 <= $ ? $ : 4294967295 + $ + 1, G, J, U);
        }
        function F(R, $, G, J, U) {
          U || (q($ != null, "missing value"), q(typeof J == "boolean", "missing or invalid endian"), q(G != null, "missing offset"), q(G + 3 < R.length, "Trying to write beyond buffer length"), te($, 34028234663852886e22, -34028234663852886e22)), R.length <= G || m.write(R, $, G, J, 23, 4);
        }
        function B(R, $, G, J, U) {
          U || (q($ != null, "missing value"), q(typeof J == "boolean", "missing or invalid endian"), q(G != null, "missing offset"), q(G + 7 < R.length, "Trying to write beyond buffer length"), te($, 17976931348623157e292, -17976931348623157e292)), R.length <= G || m.write(R, $, G, J, 52, 8);
        }
        i.Buffer = b, i.SlowBuffer = b, i.INSPECT_MAX_BYTES = 50, b.poolSize = 8192, b._useTypedArrays = function() {
          try {
            var R = new ArrayBuffer(0), $ = new Uint8Array(R);
            return $.foo = function() {
              return 42;
            }, $.foo() === 42 && typeof $.subarray == "function";
          } catch {
            return !1;
          }
        }(), b.isEncoding = function(R) {
          switch(String(R).toLowerCase()) {
            case "hex":
            case "utf8":
            case "utf-8":
            case "ascii":
            case "binary":
            case "base64":
            case "raw":
            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
              return !0;
            default:
              return !1;
          }
        }, b.isBuffer = function(R) {
          return !(R == null || !R._isBuffer);
        }, b.byteLength = function(R, $) {
          var G;
          switch(R += "", $ || "utf8") {
            case "hex":
              G = R.length / 2;
              break;
            case "utf8":
            case "utf-8":
              G = ie(R).length;
              break;
            case "ascii":
            case "binary":
            case "raw":
              G = R.length;
              break;
            case "base64":
              G = ee(R).length;
              break;
            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
              G = 2 * R.length;
              break;
            default:
              throw new Error("Unknown encoding");
          }
          return G;
        }, b.concat = function(R, $) {
          if (q(ne(R), `Usage: Buffer.concat(list, [totalLength])
list should be an Array.`), R.length === 0) {
            return new b(0);
          }
          if (R.length === 1) {
            return R[0];
          }
          if (typeof $ != "number") {
            for (U = $ = 0; U < R.length; U++) {
              $ += R[U].length;
            }
          }
          for (var G = new b($), J = 0, U = 0; U < R.length; U++) {
            var le = R[U];
            le.copy(G, J), J += le.length;
          }
          return G;
        }, b.prototype.write = function(R, $, G, J) {
          isFinite($) ? isFinite(G) || (J = G, G = void 0) : (Ae = J, J = $, $ = G, G = Ae), $ = Number($) || 0;
          var U, le, be, je, Ae = this.length - $;
          switch((!G || Ae < (G = Number(G))) && (G = Ae), J = String(J || "utf8").toLowerCase()) {
            case "hex":
              U = function(ue, Le, $e, Ye) {
                $e = Number($e) || 0;
                var Me = ue.length - $e;
                (!Ye || Me < (Ye = Number(Ye))) && (Ye = Me), q((Me = Le.length) % 2 == 0, "Invalid hex string"), Me / 2 < Ye && (Ye = Me / 2);
                for (var Xe = 0; Xe < Ye; Xe++) {
                  var it = parseInt(Le.substr(2 * Xe, 2), 16);
                  q(!isNaN(it), "Invalid hex string"), ue[$e + Xe] = it;
                }
                return b._charsWritten = 2 * Xe, Xe;
              }(this, R, $, G);
              break;
            case "utf8":
            case "utf-8":
              le = this, be = $, je = G, U = b._charsWritten = M(ie(R), le, be, je);
              break;
            case "ascii":
            case "binary":
              U = x(this, R, $, G);
              break;
            case "base64":
              le = this, be = $, je = G, U = b._charsWritten = M(ee(R), le, be, je);
              break;
            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
              U = w(this, R, $, G);
              break;
            default:
              throw new Error("Unknown encoding");
          }
          return U;
        }, b.prototype.toString = function(R, $, G) {
          var J, U, le, be, je = this;
          if (R = String(R || "utf8").toLowerCase(), $ = Number($) || 0, (G = G !== void 0 ? Number(G) : je.length) === $) {
            return "";
          }
          switch(R) {
            case "hex":
              J = function(Ae, ue, Le) {
                var $e = Ae.length;
                (!ue || ue < 0) && (ue = 0), (!Le || Le < 0 || $e < Le) && (Le = $e);
                for (var Ye = "", Me = ue; Me < Le; Me++) {
                  Ye += D(Ae[Me]);
                }
                return Ye;
              }(je, $, G);
              break;
            case "utf8":
            case "utf-8":
              J = function(Ae, ue, Le) {
                var $e = "", Ye = "";
                Le = Math.min(Ae.length, Le);
                for (var Me = ue; Me < Le; Me++) {
                  Ae[Me] <= 127 ? ($e += X(Ye) + String.fromCharCode(Ae[Me]), Ye = "") : Ye += "%" + Ae[Me].toString(16);
                }
                return $e + X(Ye);
              }(je, $, G);
              break;
            case "ascii":
            case "binary":
              J = v(je, $, G);
              break;
            case "base64":
              U = je, be = G, J = (le = $) === 0 && be === U.length ? g.fromByteArray(U) : g.fromByteArray(U.slice(le, be));
              break;
            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
              J = function(Ae, ue, Le) {
                for (var $e = Ae.slice(ue, Le), Ye = "", Me = 0; Me < $e.length; Me += 2) {
                  Ye += String.fromCharCode($e[Me] + 256 * $e[Me + 1]);
                }
                return Ye;
              }(je, $, G);
              break;
            default:
              throw new Error("Unknown encoding");
          }
          return J;
        }, b.prototype.toJSON = function() {
          return {type:"Buffer", data:Array.prototype.slice.call(this._arr || this, 0)};
        }, b.prototype.copy = function(R, $, G, J) {
          if ($ = $ || 0, (J = J || J === 0 ? J : this.length) !== (G = G || 0) && R.length !== 0 && this.length !== 0) {
            q(G <= J, "sourceEnd \x3c sourceStart"), q(0 <= $ && $ < R.length, "targetStart out of bounds"), q(0 <= G && G < this.length, "sourceStart out of bounds"), q(0 <= J && J <= this.length, "sourceEnd out of bounds"), J > this.length && (J = this.length);
            var U = (J = R.length - $ < J - G ? R.length - $ + G : J) - G;
            if (U < 100 || !b._useTypedArrays) {
              for (var le = 0; le < U; le++) {
                R[le + $] = this[le + G];
              }
            } else {
              R._set(this.subarray(G, G + U), $);
            }
          }
        }, b.prototype.slice = function(R, $) {
          var G = this.length;
          if (R = j(R, G, 0), $ = j($, G, G), b._useTypedArrays) {
            return b._augment(this.subarray(R, $));
          }
          for (var J = $ - R, U = new b(J, void 0, !0), le = 0; le < J; le++) {
            U[le] = this[le + R];
          }
          return U;
        }, b.prototype.get = function(R) {
          return console.log(".get() is deprecated. Access using array indexes instead."), this.readUInt8(R);
        }, b.prototype.set = function(R, $) {
          return console.log(".set() is deprecated. Access using array indexes instead."), this.writeUInt8(R, $);
        }, b.prototype.readUInt8 = function(R, $) {
          if ($ || (q(R != null, "missing offset"), q(R < this.length, "Trying to read beyond buffer length")), !(R >= this.length)) {
            return this[R];
          }
        }, b.prototype.readUInt16LE = function(R, $) {
          return T(this, R, !0, $);
        }, b.prototype.readUInt16BE = function(R, $) {
          return T(this, R, !1, $);
        }, b.prototype.readUInt32LE = function(R, $) {
          return I(this, R, !0, $);
        }, b.prototype.readUInt32BE = function(R, $) {
          return I(this, R, !1, $);
        }, b.prototype.readInt8 = function(R, $) {
          if ($ || (q(R != null, "missing offset"), q(R < this.length, "Trying to read beyond buffer length")), !(R >= this.length)) {
            return 128 & this[R] ? -1 * (255 - this[R] + 1) : this[R];
          }
        }, b.prototype.readInt16LE = function(R, $) {
          return _(this, R, !0, $);
        }, b.prototype.readInt16BE = function(R, $) {
          return _(this, R, !1, $);
        }, b.prototype.readInt32LE = function(R, $) {
          return N(this, R, !0, $);
        }, b.prototype.readInt32BE = function(R, $) {
          return N(this, R, !1, $);
        }, b.prototype.readFloatLE = function(R, $) {
          return E(this, R, !0, $);
        }, b.prototype.readFloatBE = function(R, $) {
          return E(this, R, !1, $);
        }, b.prototype.readDoubleLE = function(R, $) {
          return C(this, R, !0, $);
        }, b.prototype.readDoubleBE = function(R, $) {
          return C(this, R, !1, $);
        }, b.prototype.writeUInt8 = function(R, $, G) {
          G || (q(R != null, "missing value"), q($ != null, "missing offset"), q($ < this.length, "trying to write beyond buffer length"), ge(R, 255)), $ >= this.length || (this[$] = R);
        }, b.prototype.writeUInt16LE = function(R, $, G) {
          k(this, R, $, !0, G);
        }, b.prototype.writeUInt16BE = function(R, $, G) {
          k(this, R, $, !1, G);
        }, b.prototype.writeUInt32LE = function(R, $, G) {
          A(this, R, $, !0, G);
        }, b.prototype.writeUInt32BE = function(R, $, G) {
          A(this, R, $, !1, G);
        }, b.prototype.writeInt8 = function(R, $, G) {
          G || (q(R != null, "missing value"), q($ != null, "missing offset"), q($ < this.length, "Trying to write beyond buffer length"), me(R, 127, -128)), $ >= this.length || (0 <= R ? this.writeUInt8(R, $, G) : this.writeUInt8(255 + R + 1, $, G));
        }, b.prototype.writeInt16LE = function(R, $, G) {
          P(this, R, $, !0, G);
        }, b.prototype.writeInt16BE = function(R, $, G) {
          P(this, R, $, !1, G);
        }, b.prototype.writeInt32LE = function(R, $, G) {
          W(this, R, $, !0, G);
        }, b.prototype.writeInt32BE = function(R, $, G) {
          W(this, R, $, !1, G);
        }, b.prototype.writeFloatLE = function(R, $, G) {
          F(this, R, $, !0, G);
        }, b.prototype.writeFloatBE = function(R, $, G) {
          F(this, R, $, !1, G);
        }, b.prototype.writeDoubleLE = function(R, $, G) {
          B(this, R, $, !0, G);
        }, b.prototype.writeDoubleBE = function(R, $, G) {
          B(this, R, $, !1, G);
        }, b.prototype.fill = function(R, $, G) {
          if ($ = $ || 0, G = G || this.length, q(typeof(R = typeof(R = R || 0) == "string" ? R.charCodeAt(0) : R) == "number" && !isNaN(R), "value is not a number"), q($ <= G, "end \x3c start"), G !== $ && this.length !== 0) {
            q(0 <= $ && $ < this.length, "start out of bounds"), q(0 <= G && G <= this.length, "end out of bounds");
            for (var J = $; J < G; J++) {
              this[J] = R;
            }
          }
        }, b.prototype.inspect = function() {
          for (var R = [], $ = this.length, G = 0; G < $; G++) {
            if (R[G] = D(this[G]), G === i.INSPECT_MAX_BYTES) {
              R[G + 1] = "...";
              break;
            }
          }
          return "\x3cBuffer " + R.join(" ") + "\x3e";
        }, b.prototype.toArrayBuffer = function() {
          if (typeof Uint8Array > "u") {
            throw new Error("Buffer.toArrayBuffer not supported in this browser");
          }
          if (b._useTypedArrays) {
            return (new b(this)).buffer;
          }
          for (var R = new Uint8Array(this.length), $ = 0, G = R.length; $ < G; $ += 1) {
            R[$] = this[$];
          }
          return R.buffer;
        };
        var z = b.prototype;
        function j(R, $, G) {
          return typeof R != "number" ? G : $ <= (R = ~~R) ? $ : 0 <= R || 0 <= (R += $) ? R : 0;
        }
        function V(R) {
          return (R = ~~Math.ceil(+R)) < 0 ? 0 : R;
        }
        function ne(R) {
          return (Array.isArray || function($) {
            return Object.prototype.toString.call($) === "[object Array]";
          })(R);
        }
        function D(R) {
          return R < 16 ? "0" + R.toString(16) : R.toString(16);
        }
        function ie(R) {
          for (var $ = [], G = 0; G < R.length; G++) {
            var J = R.charCodeAt(G);
            if (J <= 127) {
              $.push(R.charCodeAt(G));
            } else {
              for (var U = G, le = (55296 <= J && J <= 57343 && G++, encodeURIComponent(R.slice(U, G + 1)).substr(1).split("%")), be = 0; be < le.length; be++) {
                $.push(parseInt(le[be], 16));
              }
            }
          }
          return $;
        }
        function ee(R) {
          return g.toByteArray(R);
        }
        function M(R, $, G, J) {
          for (var U = 0; U < J && !(U + G >= $.length || U >= R.length); U++) {
            $[U + G] = R[U];
          }
          return U;
        }
        function X(R) {
          try {
            return decodeURIComponent(R);
          } catch {
            return "\ufffd";
          }
        }
        function ge(R, $) {
          q(typeof R == "number", "cannot write a non-number as a number"), q(0 <= R, "specified a negative value for writing an unsigned value"), q(R <= $, "value is larger than maximum value for type"), q(Math.floor(R) === R, "value has a fractional component");
        }
        function me(R, $, G) {
          q(typeof R == "number", "cannot write a non-number as a number"), q(R <= $, "value larger than maximum allowed value"), q(G <= R, "value smaller than minimum allowed value"), q(Math.floor(R) === R, "value has a fractional component");
        }
        function te(R, $, G) {
          q(typeof R == "number", "cannot write a non-number as a number"), q(R <= $, "value larger than maximum allowed value"), q(G <= R, "value smaller than minimum allowed value");
        }
        function q(R, $) {
          if (!R) {
            throw new Error($ || "Failed assertion");
          }
        }
        b._augment = function(R) {
          return R._isBuffer = !0, R._get = R.get, R._set = R.set, R.get = z.get, R.set = z.set, R.write = z.write, R.toString = z.toString, R.toLocaleString = z.toString, R.toJSON = z.toJSON, R.copy = z.copy, R.slice = z.slice, R.readUInt8 = z.readUInt8, R.readUInt16LE = z.readUInt16LE, R.readUInt16BE = z.readUInt16BE, R.readUInt32LE = z.readUInt32LE, R.readUInt32BE = z.readUInt32BE, R.readInt8 = z.readInt8, R.readInt16LE = z.readInt16LE, R.readInt16BE = z.readInt16BE, R.readInt32LE = z.readInt32LE, 
          R.readInt32BE = z.readInt32BE, R.readFloatLE = z.readFloatLE, R.readFloatBE = z.readFloatBE, R.readDoubleLE = z.readDoubleLE, R.readDoubleBE = z.readDoubleBE, R.writeUInt8 = z.writeUInt8, R.writeUInt16LE = z.writeUInt16LE, R.writeUInt16BE = z.writeUInt16BE, R.writeUInt32LE = z.writeUInt32LE, R.writeUInt32BE = z.writeUInt32BE, R.writeInt8 = z.writeInt8, R.writeInt16LE = z.writeInt16LE, R.writeInt16BE = z.writeInt16BE, R.writeInt32LE = z.writeInt32LE, R.writeInt32BE = z.writeInt32BE, R.writeFloatLE = 
          z.writeFloatLE, R.writeFloatBE = z.writeFloatBE, R.writeDoubleLE = z.writeDoubleLE, R.writeDoubleBE = z.writeDoubleBE, R.fill = z.fill, R.inspect = z.inspect, R.toArrayBuffer = z.toArrayBuffer, R;
        };
      }).call(this, n("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, n("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/buffer/index.js", "/node_modules/gulp-browserify/node_modules/buffer");
    }, {"base64-js":2, buffer:3, ieee754:10, lYpoI2:11}], 4:[function(n, r, i) {
      (function(s, o, g, l, c, u, h, f, p) {
        var g = n("buffer").Buffer, m = 4, b = new g(m);
        b.fill(0), r.exports = {hash:function(x, w, v, T) {
          for (var I = w(function(k, A) {
            k.length % m != 0 && (P = k.length + (m - k.length % m), k = g.concat([k, b], P));
            for (var P, W = [], F = A ? k.readInt32BE : k.readInt32LE, B = 0; B < k.length; B += m) {
              W.push(F.call(k, B));
            }
            return W;
          }(x = g.isBuffer(x) ? x : new g(x), T), 8 * x.length), w = T, _ = new g(v), N = w ? _.writeInt32BE : _.writeInt32LE, E = 0; E < I.length; E++) {
            N.call(_, I[E], 4 * E, !0);
          }
          return _;
        }};
      }).call(this, n("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, n("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/crypto-browserify/helpers.js", "/node_modules/gulp-browserify/node_modules/crypto-browserify");
    }, {buffer:3, lYpoI2:11}], 5:[function(n, r, i) {
      (function(s, o, g, l, c, u, h, f, p) {
        var g = n("buffer").Buffer, m = n("./sha"), b = n("./sha256"), x = n("./rng"), w = {sha1:m, sha256:b, md5:n("./md5")}, v = 64, T = new g(v);
        function I(k, A) {
          var P = w[k = k || "sha1"], W = [];
          return P || _("algorithm:", k, "is not yet supported"), {update:function(F) {
            return g.isBuffer(F) || (F = new g(F)), W.push(F), F.length, this;
          }, digest:function(F) {
            var B = g.concat(W), B = A ? function(z, j, V) {
              g.isBuffer(j) || (j = new g(j)), g.isBuffer(V) || (V = new g(V)), j.length > v ? j = z(j) : j.length < v && (j = g.concat([j, T], v));
              for (var ne = new g(v), D = new g(v), ie = 0; ie < v; ie++) {
                ne[ie] = 54 ^ j[ie], D[ie] = 92 ^ j[ie];
              }
              return V = z(g.concat([ne, V])), z(g.concat([D, V]));
            }(P, A, B) : P(B);
            return W = null, F ? B.toString(F) : B;
          }};
        }
        function _() {
          var k = [].slice.call(arguments).join(" ");
          throw new Error([k, "we accept pull requests", "http://github.com/dominictarr/crypto-browserify"].join(`
`));
        }
        T.fill(0), i.createHash = function(k) {
          return I(k);
        }, i.createHmac = I, i.randomBytes = function(k, A) {
          if (!A || !A.call) {
            return new g(x(k));
          }
          try {
            A.call(this, void 0, new g(x(k)));
          } catch (P) {
            A(P);
          }
        };
        var N, E = ["createCredentials", "createCipher", "createCipheriv", "createDecipher", "createDecipheriv", "createSign", "createVerify", "createDiffieHellman", "pbkdf2"], C = function(k) {
          i[k] = function() {
            _("sorry,", k, "is not implemented yet");
          };
        };
        for (N in E) {
          C(E[N]);
        }
      }).call(this, n("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, n("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/crypto-browserify/index.js", "/node_modules/gulp-browserify/node_modules/crypto-browserify");
    }, {"./md5":6, "./rng":7, "./sha":8, "./sha256":9, buffer:3, lYpoI2:11}], 6:[function(n, r, i) {
      (function(s, o, a, l, c, u, h, f, p) {
        var g = n("./helpers");
        function m(_, N) {
          _[N >> 5] |= 128 << N % 32, _[14 + (N + 64 >>> 9 << 4)] = N;
          for (var E = 1732584193, C = -271733879, k = -1732584194, A = 271733878, P = 0; P < _.length; P += 16) {
            var W = E, F = C, B = k, z = A, E = x(E, C, k, A, _[P + 0], 7, -680876936), A = x(A, E, C, k, _[P + 1], 12, -389564586), k = x(k, A, E, C, _[P + 2], 17, 606105819), C = x(C, k, A, E, _[P + 3], 22, -1044525330);
            E = x(E, C, k, A, _[P + 4], 7, -176418897), A = x(A, E, C, k, _[P + 5], 12, 1200080426), k = x(k, A, E, C, _[P + 6], 17, -1473231341), C = x(C, k, A, E, _[P + 7], 22, -45705983), E = x(E, C, k, A, _[P + 8], 7, 1770035416), A = x(A, E, C, k, _[P + 9], 12, -1958414417), k = x(k, A, E, C, _[P + 10], 17, -42063), C = x(C, k, A, E, _[P + 11], 22, -1990404162), E = x(E, C, k, A, _[P + 12], 7, 1804603682), A = x(A, E, C, k, _[P + 13], 12, -40341101), k = x(k, A, E, C, _[P + 14], 17, -1502002290), 
            E = w(E, C = x(C, k, A, E, _[P + 15], 22, 1236535329), k, A, _[P + 1], 5, -165796510), A = w(A, E, C, k, _[P + 6], 9, -1069501632), k = w(k, A, E, C, _[P + 11], 14, 643717713), C = w(C, k, A, E, _[P + 0], 20, -373897302), E = w(E, C, k, A, _[P + 5], 5, -701558691), A = w(A, E, C, k, _[P + 10], 9, 38016083), k = w(k, A, E, C, _[P + 15], 14, -660478335), C = w(C, k, A, E, _[P + 4], 20, -405537848), E = w(E, C, k, A, _[P + 9], 5, 568446438), A = w(A, E, C, k, _[P + 14], 9, -1019803690), 
            k = w(k, A, E, C, _[P + 3], 14, -187363961), C = w(C, k, A, E, _[P + 8], 20, 1163531501), E = w(E, C, k, A, _[P + 13], 5, -1444681467), A = w(A, E, C, k, _[P + 2], 9, -51403784), k = w(k, A, E, C, _[P + 7], 14, 1735328473), E = v(E, C = w(C, k, A, E, _[P + 12], 20, -1926607734), k, A, _[P + 5], 4, -378558), A = v(A, E, C, k, _[P + 8], 11, -2022574463), k = v(k, A, E, C, _[P + 11], 16, 1839030562), C = v(C, k, A, E, _[P + 14], 23, -35309556), E = v(E, C, k, A, _[P + 1], 4, -1530992060), 
            A = v(A, E, C, k, _[P + 4], 11, 1272893353), k = v(k, A, E, C, _[P + 7], 16, -155497632), C = v(C, k, A, E, _[P + 10], 23, -1094730640), E = v(E, C, k, A, _[P + 13], 4, 681279174), A = v(A, E, C, k, _[P + 0], 11, -358537222), k = v(k, A, E, C, _[P + 3], 16, -722521979), C = v(C, k, A, E, _[P + 6], 23, 76029189), E = v(E, C, k, A, _[P + 9], 4, -640364487), A = v(A, E, C, k, _[P + 12], 11, -421815835), k = v(k, A, E, C, _[P + 15], 16, 530742520), E = T(E, C = v(C, k, A, E, _[P + 2], 23, 
            -995338651), k, A, _[P + 0], 6, -198630844), A = T(A, E, C, k, _[P + 7], 10, 1126891415), k = T(k, A, E, C, _[P + 14], 15, -1416354905), C = T(C, k, A, E, _[P + 5], 21, -57434055), E = T(E, C, k, A, _[P + 12], 6, 1700485571), A = T(A, E, C, k, _[P + 3], 10, -1894986606), k = T(k, A, E, C, _[P + 10], 15, -1051523), C = T(C, k, A, E, _[P + 1], 21, -2054922799), E = T(E, C, k, A, _[P + 8], 6, 1873313359), A = T(A, E, C, k, _[P + 15], 10, -30611744), k = T(k, A, E, C, _[P + 6], 15, -1560198380), 
            C = T(C, k, A, E, _[P + 13], 21, 1309151649), E = T(E, C, k, A, _[P + 4], 6, -145523070), A = T(A, E, C, k, _[P + 11], 10, -1120210379), k = T(k, A, E, C, _[P + 2], 15, 718787259), C = T(C, k, A, E, _[P + 9], 21, -343485551), E = I(E, W), C = I(C, F), k = I(k, B), A = I(A, z);
          }
          return Array(E, C, k, A);
        }
        function b(_, N, E, C, k, A) {
          return I((N = I(I(N, _), I(C, A))) << k | N >>> 32 - k, E);
        }
        function x(_, N, E, C, k, A, P) {
          return b(N & E | ~N & C, _, N, k, A, P);
        }
        function w(_, N, E, C, k, A, P) {
          return b(N & C | E & ~C, _, N, k, A, P);
        }
        function v(_, N, E, C, k, A, P) {
          return b(N ^ E ^ C, _, N, k, A, P);
        }
        function T(_, N, E, C, k, A, P) {
          return b(E ^ (N | ~C), _, N, k, A, P);
        }
        function I(_, N) {
          var E = (65535 & _) + (65535 & N);
          return (_ >> 16) + (N >> 16) + (E >> 16) << 16 | 65535 & E;
        }
        r.exports = function(_) {
          return g.hash(_, m, 16);
        };
      }).call(this, n("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, n("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/crypto-browserify/md5.js", "/node_modules/gulp-browserify/node_modules/crypto-browserify");
    }, {"./helpers":4, buffer:3, lYpoI2:11}], 7:[function(n, r, i) {
      (function(s, o, a, l, c, u, h, f, p) {
        r.exports = function(g) {
          for (var m, b = new Array(g), x = 0; x < g; x++) {
            !(3 & x) && (m = 4294967296 * Math.random()), b[x] = m >>> ((3 & x) << 3) & 255;
          }
          return b;
        };
      }).call(this, n("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, n("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/crypto-browserify/rng.js", "/node_modules/gulp-browserify/node_modules/crypto-browserify");
    }, {buffer:3, lYpoI2:11}], 8:[function(n, r, i) {
      (function(s, o, a, l, c, u, h, f, p) {
        var g = n("./helpers");
        function m(w, v) {
          w[v >> 5] |= 128 << 24 - v % 32, w[15 + (v + 64 >> 9 << 4)] = v;
          for (var T, I, _, N = Array(80), E = 1732584193, C = -271733879, k = -1732584194, A = 271733878, P = -1009589776, W = 0; W < w.length; W += 16) {
            for (var F = E, B = C, z = k, j = A, V = P, ne = 0; ne < 80; ne++) {
              N[ne] = ne < 16 ? w[W + ne] : x(N[ne - 3] ^ N[ne - 8] ^ N[ne - 14] ^ N[ne - 16], 1);
              var D = b(b(x(E, 5), (D = C, I = k, _ = A, (T = ne) < 20 ? D & I | ~D & _ : !(T < 40) && T < 60 ? D & I | D & _ | I & _ : D ^ I ^ _)), b(b(P, N[ne]), (T = ne) < 20 ? 1518500249 : T < 40 ? 1859775393 : T < 60 ? -1894007588 : -899497514)), P = A, A = k, k = x(C, 30), C = E, E = D;
            }
            E = b(E, F), C = b(C, B), k = b(k, z), A = b(A, j), P = b(P, V);
          }
          return Array(E, C, k, A, P);
        }
        function b(w, v) {
          var T = (65535 & w) + (65535 & v);
          return (w >> 16) + (v >> 16) + (T >> 16) << 16 | 65535 & T;
        }
        function x(w, v) {
          return w << v | w >>> 32 - v;
        }
        r.exports = function(w) {
          return g.hash(w, m, 20, !0);
        };
      }).call(this, n("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, n("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/crypto-browserify/sha.js", "/node_modules/gulp-browserify/node_modules/crypto-browserify");
    }, {"./helpers":4, buffer:3, lYpoI2:11}], 9:[function(n, r, i) {
      (function(s, o, a, l, c, u, h, f, p) {
        function g(v, T) {
          var I = (65535 & v) + (65535 & T);
          return (v >> 16) + (T >> 16) + (I >> 16) << 16 | 65535 & I;
        }
        function m(v, T) {
          var I, _ = new Array(1116352408, 1899447441, 3049323471, 3921009573, 961987163, 1508970993, 2453635748, 2870763221, 3624381080, 310598401, 607225278, 1426881987, 1925078388, 2162078206, 2614888103, 3248222580, 3835390401, 4022224774, 264347078, 604807628, 770255983, 1249150122, 1555081692, 1996064986, 2554220882, 2821834349, 2952996808, 3210313671, 3336571891, 3584528711, 113926993, 338241895, 666307205, 773529912, 1294757372, 1396182291, 1695183700, 1986661051, 2177026350, 2456956037, 
          2730485921, 2820302411, 3259730800, 3345764771, 3516065817, 3600352804, 4094571909, 275423344, 430227734, 506948616, 659060556, 883997877, 958139571, 1322822218, 1537002063, 1747873779, 1955562222, 2024104815, 2227730452, 2361852424, 2428436474, 2756734187, 3204031479, 3329325298), N = new Array(1779033703, 3144134277, 1013904242, 2773480762, 1359893119, 2600822924, 528734635, 1541459225), E = new Array(64);
          v[T >> 5] |= 128 << 24 - T % 32, v[15 + (T + 64 >> 9 << 4)] = T;
          for (var C, k, A = 0; A < v.length; A += 16) {
            for (var P = N[0], W = N[1], F = N[2], B = N[3], z = N[4], j = N[5], V = N[6], ne = N[7], D = 0; D < 64; D++) {
              E[D] = D < 16 ? v[D + A] : g(g(g((k = E[D - 2], x(k, 17) ^ x(k, 19) ^ w(k, 10)), E[D - 7]), (k = E[D - 15], x(k, 7) ^ x(k, 18) ^ w(k, 3))), E[D - 16]), I = g(g(g(g(ne, x(k = z, 6) ^ x(k, 11) ^ x(k, 25)), z & j ^ ~z & V), _[D]), E[D]), C = g(x(C = P, 2) ^ x(C, 13) ^ x(C, 22), P & W ^ P & F ^ W & F), ne = V, V = j, j = z, z = g(B, I), B = F, F = W, W = P, P = g(I, C);
            }
            N[0] = g(P, N[0]), N[1] = g(W, N[1]), N[2] = g(F, N[2]), N[3] = g(B, N[3]), N[4] = g(z, N[4]), N[5] = g(j, N[5]), N[6] = g(V, N[6]), N[7] = g(ne, N[7]);
          }
          return N;
        }
        var b = n("./helpers"), x = function(v, T) {
          return v >>> T | v << 32 - T;
        }, w = function(v, T) {
          return v >>> T;
        };
        r.exports = function(v) {
          return b.hash(v, m, 32, !0);
        };
      }).call(this, n("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, n("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/crypto-browserify/sha256.js", "/node_modules/gulp-browserify/node_modules/crypto-browserify");
    }, {"./helpers":4, buffer:3, lYpoI2:11}], 10:[function(n, r, i) {
      (function(s, o, a, l, c, u, h, f, p) {
        i.read = function(g, m, b, x, A) {
          var v, T, I = 8 * A - x - 1, _ = (1 << I) - 1, N = _ >> 1, E = -7, C = b ? A - 1 : 0, k = b ? -1 : 1, A = g[m + C];
          for (C += k, v = A & (1 << -E) - 1, A >>= -E, E += I; 0 < E; v = 256 * v + g[m + C], C += k, E -= 8) {
          }
          for (T = v & (1 << -E) - 1, v >>= -E, E += x; 0 < E; T = 256 * T + g[m + C], C += k, E -= 8) {
          }
          if (v === 0) {
            v = 1 - N;
          } else {
            if (v === _) {
              return T ? NaN : 1 / 0 * (A ? -1 : 1);
            }
            T += Math.pow(2, x), v -= N;
          }
          return (A ? -1 : 1) * T * Math.pow(2, v - x);
        }, i.write = function(g, m, b, x, w, P) {
          var T, I, _ = 8 * P - w - 1, N = (1 << _) - 1, E = N >> 1, C = w === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, k = x ? 0 : P - 1, A = x ? 1 : -1, P = m < 0 || m === 0 && 1 / m < 0 ? 1 : 0;
          for (m = Math.abs(m), isNaN(m) || m === 1 / 0 ? (I = isNaN(m) ? 1 : 0, T = N) : (T = Math.floor(Math.log(m) / Math.LN2), m * (x = Math.pow(2, -T)) < 1 && (T--, x *= 2), 2 <= (m += 1 <= T + E ? C / x : C * Math.pow(2, 1 - E)) * x && (T++, x /= 2), N <= T + E ? (I = 0, T = N) : 1 <= T + E ? (I = (m * x - 1) * Math.pow(2, w), T += E) : (I = m * Math.pow(2, E - 1) * Math.pow(2, w), T = 0)); 8 <= w; g[b + k] = 255 & I, k += A, I /= 256, w -= 8) {
          }
          for (T = T << w | I, _ += w; 0 < _; g[b + k] = 255 & T, k += A, T /= 256, _ -= 8) {
          }
          g[b + k - A] |= 128 * P;
        };
      }).call(this, n("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, n("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/ieee754/index.js", "/node_modules/gulp-browserify/node_modules/ieee754");
    }, {buffer:3, lYpoI2:11}], 11:[function(n, r, i) {
      (function(s, o, a, l, c, u, h, f, p) {
        var g, m, b;
        function x() {
        }
        (s = r.exports = {}).nextTick = (m = typeof window < "u" && window.setImmediate, b = typeof window < "u" && window.postMessage && window.addEventListener, m ? function(w) {
          return window.setImmediate(w);
        } : b ? (g = [], window.addEventListener("message", function(w) {
          var v = w.source;
          v !== window && v !== null || w.data !== "process-tick" || (w.stopPropagation(), 0 < g.length && g.shift()());
        }, !0), function(w) {
          g.push(w), window.postMessage("process-tick", "*");
        }) : function(w) {
          setTimeout(w, 0);
        }), s.title = "browser", s.browser = !0, s.env = {}, s.argv = [], s.on = x, s.addListener = x, s.once = x, s.off = x, s.removeListener = x, s.removeAllListeners = x, s.emit = x, s.binding = function(w) {
          throw new Error("process.binding is not supported");
        }, s.cwd = function() {
          return "/";
        }, s.chdir = function(w) {
          throw new Error("process.chdir is not supported");
        };
      }).call(this, n("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, n("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/process/browser.js", "/node_modules/gulp-browserify/node_modules/process");
    }, {buffer:3, lYpoI2:11}]}, {}, [1])(1);
  });
})(jR);
var Ple = jR.exports;
const V0 = Vd(Ple);
var Rle = Vie({["../../node_modules/classnames/index.js"](t, e) {
  re(), function() {
    var n = {}.hasOwnProperty;
    function r() {
      for (var o = "", a = 0; a < arguments.length; a++) {
        var l = arguments[a];
        l && (o = s(o, i(l)));
      }
      return o;
    }
    function i(o) {
      if (typeof o == "string" || typeof o == "number") {
        return o;
      }
      if (typeof o != "object") {
        return "";
      }
      if (Array.isArray(o)) {
        return r.apply(null, o);
      }
      if (o.toString !== Object.prototype.toString && !o.toString.toString().includes("[native code]")) {
        return o.toString();
      }
      var a = "";
      for (var l in o) {
        n.call(o, l) && o[l] && (a = s(a, l));
      }
      return a;
    }
    function s(o, a) {
      return a ? o ? o + " " + a : o + a : o;
    }
    typeof e < "u" && e.exports ? (r.default = r, e.exports = r) : typeof define == "function" && typeof define.amd == "object" && define.amd ? define("classnames", [], function() {
      return r;
    }) : window.classNames = r;
  }();
}});
re();
re();
re();
var Dle = Yie(Rle()), Lle = (t, e, n = {baseClass:""}) => (r = {}) => {
  if (typeof r == "string") {
    const i = r;
    return e[`${t}-${i}`] && n.baseClass + e[`${t}-${i}`] || "";
  } else if (typeof r == "object") {
    const i = r, s = {};
    for (let a in i) {
      s[e[`${t}--${a}`]] = i[a];
    }
    const o = e[t];
    return n.baseClass + (0,Dle.default)(K({[o]:!!o}, s));
  } else {
    return n.baseClass + e[t] || "";
  }
}, Rt = Lle;
re();
var Mle = {ActionBar:"_ActionBar_rvadt_1", "ActionBar-label":"_ActionBar-label_rvadt_18", "ActionBar-action":"_ActionBar-action_rvadt_30", "ActionBar-group":"_ActionBar-group_rvadt_38"}, Fd = Rt("ActionBar", Mle), ts = ({label:t, children:e}) => (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:Fd(), onClick:n => {
  n.stopPropagation();
}, children:[t && (0,require$react_SLASH_jsx_runtime.jsx)(ts.Group, {children:(0,require$react_SLASH_jsx_runtime.jsx)("div", {className:Fd("label"), children:t})}), e]}), Ble = ({children:t, label:e, onClick:n}) => (0,require$react_SLASH_jsx_runtime.jsx)("button", {type:"button", className:Fd("action"), onClick:n, title:e, children:t}), $le = ({children:t}) => (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:Fd("group"), children:t}), Fle = ({label:t}) => (0,require$react_SLASH_jsx_runtime.jsx)("div", 
{className:Fd("label"), children:t});
ts.Action = Ble;
ts.Label = Fle;
ts.Group = $le;
re();
re();
var zle = {IconButton:"_IconButton_swpni_1", "IconButton--disabled":"_IconButton--disabled_swpni_20", "IconButton-title":"_IconButton-title_swpni_33"};
re();
re();
re();
re();
var CE = (t, e, n) => {
  const r = Array.from(t), [i] = r.splice(e, 1);
  return r.splice(n, 0, i), r;
};
re();
var Hle = (t, e, n) => {
  const r = Array.from(t);
  return r.splice(e, 1), r.splice(e, 0, n), r;
};
re();
re();
re();
re();
var Ule = (t, e, n) => {
  if (typeof e.state == "object") {
    const r = K(K({}, t), e.state);
    return e.state.indexes ? r : (console.warn("`set` is expensive and may cause unnecessary re-renders. Consider using a more atomic action instead."), xi(r, n.config));
  }
  return K(K({}, t), e.state(t));
};
re();
re();
var vc = (t, e, n) => {
  const r = Array.from(t || []);
  return r.splice(e, 0, n), r;
};
re();
var vi = t => t ? `${t}-${W2()}` : W2();
re();
var zd = (t, e) => {
  const [n] = t.split(":"), r = e.indexes.nodes[n];
  return ((r == null ? void 0 : r.path) || []).map(i => i.split(":")[0]);
};
re();
var VR = (t, e, n = !1) => {
  const r = vi(t.type);
  return uP(ve(K({}, t), {props:n ? ve(K({}, t.props), {id:r}) : K({}, t.props)}), e, i => i.map(s => {
    const o = vi(s.type);
    return ve(K({}, s), {props:n ? ve(K({}, s.props), {id:o}) : K({id:o}, s.props)});
  }));
};
function qR(t, e, n) {
  const r = e.id || vi(e.componentType), i = VR({type:e.componentType, props:ve(K({}, n.config.components[e.componentType].defaultProps || {}), {id:r})}, n.config), [s] = e.destinationZone.split(":"), o = zd(e.destinationZone, t);
  return xi(t, n.config, (a, l) => l === e.destinationZone ? vc(a || [], e.destinationIndex, i) : a, (a, l) => a.props.id === r || a.props.id === s || o.includes(a.props.id) || l.includes(e.destinationZone) ? a : null);
}
re();
var Wle = (t, e, n) => {
  const [r] = e.destinationZone.split(":"), i = zd(e.destinationZone, t), s = t.indexes.zones[e.destinationZone].contentIds[e.destinationIndex];
  if (s !== e.data.props.id) {
    throw new Error(`Can't change the id during a replace action. Please us "remove" and "insert" to define a new node.`);
  }
  const a = [], l = uP(e.data, n.config, (u, h) => (a.push(`${h.parentId}:${h.propName}`), u.map(f => {
    const p = vi(f.type);
    return ve(K({}, f), {props:K({id:p}, f.props)});
  }))), c = K({}, t);
  return Object.keys(t.indexes.zones).forEach(u => {
    u.split(":")[0] === s && (a.includes(u) || delete c.indexes.zones[u]);
  }), xi(c, n.config, (u, h) => {
    const f = [...u];
    return h === e.destinationZone && (f[e.destinationIndex] = l), f;
  }, (u, h) => {
    const f = h.map(p => p.split(":")[0]);
    return u.props.id === l.props.id ? l : u.props.id === r || i.indexOf(u.props.id) > -1 || f.indexOf(l.props.id) > -1 ? u : null;
  });
};
re();
var jle = (t, e, n) => xi(t, n.config, r => r, r => r.props.id === "root" ? ve(K({}, r), {props:K(K({}, r.props), e.root.props), readOnly:e.root.readOnly}) : r);
re();
re();
function is(t, e) {
  var n, r;
  const i = (n = e.indexes.zones) == null ? void 0 : n[t.zone || Cr];
  return i ? (r = e.indexes.nodes[i.contentIds[t.index]]) == null ? void 0 : r.data : void 0;
}
function Vle(t, e, n) {
  const r = is({index:e.sourceIndex, zone:e.sourceZone}, t), i = zd(e.sourceZone, t), s = ve(K({}, r), {props:ve(K({}, r.props), {id:vi(r.type)})}), o = xi(t, n.config, (a, l) => l === e.sourceZone ? vc(a, e.sourceIndex + 1, r) : a, (a, l, c) => {
    const u = l[l.length - 1];
    if (l.map(p => p.split(":")[0]).indexOf(s.props.id) > -1) {
      return ve(K({}, a), {props:ve(K({}, a.props), {id:vi(a.type)})});
    }
    if (u === e.sourceZone && c === e.sourceIndex + 1) {
      return s;
    }
    const [f] = e.sourceZone.split(":");
    return f === a.props.id || i.indexOf(a.props.id) > -1 ? a : null;
  });
  return ve(K({}, o), {ui:ve(K({}, o.ui), {itemSelector:{index:e.sourceIndex + 1, zone:e.sourceZone}})});
}
re();
re();
re();
var cx = (t, e) => {
  const n = Array.from(t);
  return n.splice(e, 1), n;
}, YR = (t, e, n) => {
  if (e.sourceZone === e.destinationZone && e.sourceIndex === e.destinationIndex) {
    return t;
  }
  const r = is({zone:e.sourceZone, index:e.sourceIndex}, t);
  if (!r) {
    return t;
  }
  const i = zd(e.sourceZone, t), s = zd(e.destinationZone, t);
  return xi(t, n.config, (o, a) => a === e.sourceZone && a === e.destinationZone ? vc(cx(o, e.sourceIndex), e.destinationIndex, r) : a === e.sourceZone ? cx(o, e.sourceIndex) : a === e.destinationZone ? vc(o, e.destinationIndex, r) : o, (o, a) => {
    const [l] = e.sourceZone.split(":"), [c] = e.destinationZone.split(":"), u = o.props.id;
    return l === u || c === u || r.props.id === u || i.indexOf(u) > -1 || s.indexOf(u) > -1 || a.includes(e.destinationZone) ? o : null;
  });
}, qle = (t, e, n) => YR(t, {sourceIndex:e.sourceIndex, sourceZone:e.destinationZone, destinationIndex:e.destinationIndex, destinationZone:e.destinationZone}, n);
re();
var Yle = (t, e, n) => {
  const r = is({index:e.index, zone:e.zone}, t), i = Object.entries(t.indexes.nodes).reduce((o, [a, l]) => l.path.map(u => u.split(":")[0]).includes(r.props.id) ? [...o, a] : o, [r.props.id]), s = xi(t, n.config, (o, a) => a === e.zone ? cx(o, e.index) : o);
  return Object.keys(s.data.zones || {}).forEach(o => {
    const a = o.split(":")[0];
    i.includes(a) && s.data.zones && delete s.data.zones[o];
  }), Object.keys(s.indexes.zones).forEach(o => {
    const a = o.split(":")[0];
    i.includes(a) && delete s.indexes.zones[o];
  }), i.forEach(o => {
    delete s.indexes.nodes[o];
  }), s;
};
re();
var Xf = {};
function Gle(t, e) {
  return Xf[e.zone] ? ve(K({}, t), {data:ve(K({}, t.data), {zones:ve(K({}, t.data.zones), {[e.zone]:Xf[e.zone]})}), indexes:ve(K({}, t.indexes), {zones:ve(K({}, t.indexes.zones), {[e.zone]:ve(K({}, t.indexes.zones[e.zone]), {contentIds:Xf[e.zone].map(n => n.props.id), type:"dropzone"})})})}) : ve(K({}, t), {data:hP(t.data, e.zone)});
}
function Qle(t, e) {
  const n = K({}, t.data.zones || {}), r = K({}, t.indexes.zones || {});
  return n[e.zone] && (Xf[e.zone] = n[e.zone], delete n[e.zone]), delete r[e.zone], ve(K({}, t), {data:ve(K({}, t.data), {zones:n}), indexes:ve(K({}, t.indexes), {zones:r})});
}
re();
var Kle = (t, e, n) => typeof e.data == "object" ? (console.warn("`setData` is expensive and may cause unnecessary re-renders. Consider using a more atomic action instead."), xi(ve(K({}, t), {data:K(K({}, t.data), e.data)}), n.config)) : xi(ve(K({}, t), {data:K(K({}, t.data), e.data(t.data))}), n.config);
re();
var Xle = (t, e) => typeof e.ui == "object" ? ve(K({}, t), {ui:K(K({}, t.ui), e.ui)}) : ve(K({}, t), {ui:K(K({}, t.ui), e.ui(t.ui))});
re();
var Hd = t => {
  const {data:e, ui:n} = t;
  return {data:e, ui:n};
};
re();
function Jle(t, e, n) {
  return (r, i) => {
    const s = t(r, i), o = !["registerZone", "unregisterZone", "setData", "setUi", "set"].includes(i.type);
    return (typeof i.recordHistory < "u" ? i.recordHistory : o) && e && e(s), n == null || n(i, Hd(s), Hd(r)), s;
  };
}
function AE({record:t, onAction:e, appStore:n}) {
  return Jle((r, i) => i.type === "set" ? Ule(r, i, n) : i.type === "insert" ? qR(r, i, n) : i.type === "replace" ? Wle(r, i, n) : i.type === "replaceRoot" ? jle(r, i, n) : i.type === "duplicate" ? Vle(r, i, n) : i.type === "reorder" ? qle(r, i, n) : i.type === "move" ? YR(r, i, n) : i.type === "remove" ? Yle(r, i, n) : i.type === "registerZone" ? Gle(r, i) : i.type === "unregisterZone" ? Qle(r, i) : i.type === "setData" ? Kle(r, i, n) : i.type === "setUi" ? Xle(r, i) : r, t, e);
}
re();
re();
var NE = {ControlLeft:"ctrl", ControlRight:"ctrl", MetaLeft:"meta", MetaRight:"meta", ShiftLeft:"shift", ShiftRight:"shift", KeyA:"a", KeyB:"b", KeyC:"c", KeyD:"d", KeyE:"e", KeyF:"f", KeyG:"g", KeyH:"h", KeyI:"i", KeyJ:"j", KeyK:"k", KeyL:"l", KeyM:"m", KeyN:"n", KeyO:"o", KeyP:"p", KeyQ:"q", KeyR:"r", KeyS:"s", KeyT:"t", KeyU:"u", KeyV:"v", KeyW:"w", KeyX:"x", KeyY:"y", KeyZ:"z"}, Ta = mP()(bP(t => ({held:{}, hold:e => t(n => n.held[e] ? n : {held:ve(K({}, n.held), {[e]:!0})}), release:e => t(n => 
n.held[e] ? {held:ve(K({}, n.held), {[e]:!1})} : n), reset:(e = {}) => t(() => ({held:e})), triggers:{}}))), GR = t => {
  const e = i => {
    const s = NE[i.code];
    if (s) {
      Ta.getState().hold(s);
      const {held:o, triggers:a} = Ta.getState();
      Object.values(a).forEach(({combo:l, cb:c}) => {
        Object.entries(l).every(([h, f]) => f === !!o[h]) && Object.entries(o).every(([h, f]) => f === !!l[h]) && (i.preventDefault(), c());
      }), s !== "meta" && s !== "ctrl" && s !== "shift" && Ta.getState().release(s);
    }
  }, n = i => {
    const s = NE[i.code];
    s && (s === "meta" ? Ta.getState().reset() : Ta.getState().release(s));
  }, r = i => {
    document.visibilityState === "hidden" && Ta.getState().reset();
  };
  return t.addEventListener("keydown", e), t.addEventListener("keyup", n), t.addEventListener("visibilitychange", r), () => {
    t.removeEventListener("keydown", e), t.removeEventListener("keyup", n), t.removeEventListener("visibilitychange", r);
  };
}, Zle = () => {
  (0,require$react.useEffect)(() => GR(document), []);
}, Fo = (t, e) => {
  (0,require$react.useEffect)(() => Ta.setState(n => ({triggers:ve(K({}, n.triggers), {[`${Object.keys(t).join("+")}`]:{combo:t, cb:e}})})), []);
}, IE = 0;
function ece(t, e = 300) {
  let n;
  return (...r) => {
    clearTimeout(n), n = setTimeout(() => {
      t(...r);
    }, e);
  };
}
var OE = t => ve(K({}, t), {ui:ve(K({}, t.ui), {field:{focus:null}})}), tce = (t, e) => {
  const n = ece(r => {
    const {histories:i, index:s} = e().history, o = {state:r, id:vi("history")}, a = [...i.slice(0, s + 1), o];
    t({history:ve(K({}, e().history), {histories:a, index:a.length - 1})});
  }, 250);
  return {initialAppState:{}, index:IE, histories:[], hasPast:() => e().history.index > IE, hasFuture:() => e().history.index < e().history.histories.length - 1, prevHistory:() => {
    const {history:r} = e();
    return r.hasPast() ? r.histories[r.index - 1] : null;
  }, nextHistory:() => {
    const r = e().history;
    return r.hasFuture() ? r.histories[r.index + 1] : null;
  }, currentHistory:() => e().history.histories[e().history.index], back:() => {
    var r;
    const {history:i, dispatch:s} = e();
    if (i.hasPast()) {
      const o = OE(((r = i.prevHistory()) == null ? void 0 : r.state) || i.initialAppState);
      s({type:"set", state:o}), t({history:ve(K({}, i), {index:i.index - 1})});
    }
  }, forward:() => {
    var r;
    const {history:i, dispatch:s} = e();
    if (i.hasFuture()) {
      const o = (r = i.nextHistory()) == null ? void 0 : r.state;
      s({type:"set", state:o ? OE(o) : {}}), t({history:ve(K({}, i), {index:i.index + 1})});
    }
  }, setHistories:r => {
    var i;
    const {dispatch:s, history:o} = e();
    s({type:"set", state:((i = r[r.length - 1]) == null ? void 0 : i.state) || o.initialAppState}), t({history:ve(K({}, o), {histories:r, index:r.length - 1})});
  }, setHistoryIndex:r => {
    var i;
    const {dispatch:s, history:o} = e();
    s({type:"set", state:((i = o.histories[r]) == null ? void 0 : i.state) || o.initialAppState}), t({history:ve(K({}, o), {index:r})});
  }, record:n};
};
function nce(t, {histories:e, index:n, initialAppState:r}) {
  (0,require$react.useEffect)(() => t.setState({history:ve(K({}, t.getState().history), {histories:e, index:n, initialAppState:r})}), [e, n, r]);
  const i = () => {
    t.getState().history.back();
  }, s = () => {
    t.getState().history.forward();
  };
  Fo({meta:!0, z:!0}, i), Fo({meta:!0, shift:!0, z:!0}, s), Fo({meta:!0, y:!0}, s), Fo({ctrl:!0, z:!0}, i), Fo({ctrl:!0, shift:!0, z:!0}, s), Fo({ctrl:!0, y:!0}, s);
}
re();
var rce = (t, e) => ({nodes:{}, registerNode:(n, r) => {
  const i = e().nodes, s = {id:n, methods:{sync:() => null, hideOverlay:() => null, showOverlay:() => null}, element:null}, o = i.nodes[n];
  t({nodes:ve(K({}, i), {nodes:ve(K({}, i.nodes), {[n]:ve(K(K(K({}, s), o), r), {id:n})})})});
}, unregisterNode:n => {
  const r = e().nodes;
  if (r.nodes[n]) {
    const s = K({}, r.nodes);
    delete s[n], t({nodes:ve(K({}, r), {nodes:s})});
  }
}});
re();
re();
var PE = (t, e) => {
  const n = [];
  return xi(t, e, r => r, r => (n.push(r), null)), n;
}, ice = (t, e) => {
  const n = (...i) => Qn(void 0, [...i], function*(s = {}, o) {
    const {state:a, permissions:l, config:c} = e(), {cache:u, globalPermissions:h} = l, f = (x, w = !1) => Qn(void 0, null, function*() {
      var v, T, I;
      const {config:_, state:N, setComponentLoading:E} = e(), C = x.type === "root" ? _.root : _.components[x.type];
      if (!C) {
        return;
      }
      const k = K(K({}, h), C.permissions);
      if (C.resolvePermissions) {
        const A = G1(x, (v = u[x.props.id]) == null ? void 0 : v.lastData);
        if (Object.values(A).some(P => P === !0) || w) {
          const P = E(x.props.id, !0, 50), W = yield C.resolvePermissions(x, {changed:A, lastPermissions:((T = u[x.props.id]) == null ? void 0 : T.lastPermissions) || null, permissions:k, appState:Hd(N), lastData:((I = u[x.props.id]) == null ? void 0 : I.lastData) || null}), F = e().permissions;
          t({permissions:ve(K({}, F), {cache:ve(K({}, F.cache), {[x.props.id]:{lastData:x, lastPermissions:W}}), resolvedPermissions:ve(K({}, F.resolvedPermissions), {[x.props.id]:W})})}), P();
        }
      }
    }), p = (x = !1) => {
      const {state:w} = e();
      f({type:"root", props:ve(K({}, w.data.root.props), {id:"root"})}, x);
    }, {item:g, type:m, root:b} = s;
    g ? yield f(g, o) : m ? PE(a, c).filter(x => x.type === m).map(x => Qn(void 0, null, function*() {
      yield f(x, o);
    })) : b ? p(o) : PE(a, c).map(x => Qn(void 0, null, function*() {
      yield f(x, o);
    }));
  });
  return {cache:{}, globalPermissions:{drag:!0, edit:!0, delete:!0, duplicate:!0, insert:!0}, resolvedPermissions:{}, getPermissions:({item:i, type:s, root:o} = {}) => {
    const {config:a, permissions:l} = e(), {globalPermissions:c, resolvedPermissions:u} = l;
    if (i) {
      const h = a.components[i.type], f = K(K({}, c), h == null ? void 0 : h.permissions), p = u[i.props.id];
      return p ? K(K({}, c), p) : f;
    } else if (s) {
      const h = a.components[s];
      return K(K({}, c), h == null ? void 0 : h.permissions);
    } else if (o) {
      const h = a.root, f = K(K({}, c), h == null ? void 0 : h.permissions), p = u.root;
      return p ? K(K({}, c), p) : f;
    }
    return c;
  }, resolvePermissions:n, refreshPermissions:i => n(i, !0)};
}, sce = (t, e) => {
  (0,require$react.useEffect)(() => {
    const {permissions:n} = t.getState(), {globalPermissions:r} = n;
    t.setState({permissions:ve(K({}, n), {globalPermissions:K(K({}, r), e)})}), n.resolvePermissions();
  }, [e]), (0,require$react.useEffect)(() => t.subscribe(n => n.state.data, () => {
    t.getState().permissions.resolvePermissions();
  }), []), (0,require$react.useEffect)(() => t.subscribe(n => n.config, () => {
    t.getState().permissions.resolvePermissions();
  }), []);
};
re();
var oce = (t, e) => ({fields:{}, loading:!1, lastResolvedData:{}, id:void 0}), ace = (t, e) => {
  const n = (0,require$react.useCallback)(r => Qn(void 0, null, function*() {
    var i, s;
    const {fields:o, lastResolvedData:a} = t.getState().fields, l = t.getState().state.indexes.nodes, c = l[e || "root"], u = c == null ? void 0 : c.data, h = c != null && c.parentId ? l[c.parentId] : null, f = (h == null ? void 0 : h.data) || null, {getComponentConfig:p, state:g} = t.getState(), m = p(u == null ? void 0 : u.type);
    if (!u || !m) {
      return;
    }
    const b = m.fields || {}, x = m.resolveFields;
    let w = o;
    if (r && (t.setState(v => ({fields:ve(K({}, v.fields), {fields:b, id:e})})), w = b), x) {
      const v = setTimeout(() => {
        t.setState(N => ({fields:ve(K({}, N.fields), {loading:!0})}));
      }, 50), T = ((i = a.props) == null ? void 0 : i.id) === e ? a : null, I = G1(u, T), _ = yield x(u, {changed:I, fields:b, lastFields:w, lastData:T, appState:Hd(g), parent:f});
      if (clearTimeout(v), ((s = t.getState().selectedItem) == null ? void 0 : s.props.id) !== e) {
        return;
      }
      t.setState({fields:{fields:_, loading:!1, lastResolvedData:u, id:e}});
    } else {
      t.setState(v => ({fields:ve(K({}, v.fields), {fields:b, id:e})}));
    }
  }), [e]);
  (0,require$react.useEffect)(() => (n(!0), t.subscribe(r => r.state.indexes.nodes[e || "root"], () => n())), [e]);
};
re();
var lce = t => {
  if ("type" in t && t.type !== "root") {
    throw new Error("Converting non-root item to root.");
  }
  const {readOnly:e} = t;
  if (t.props) {
    if ("id" in t.props) {
      const n = t.props, {id:r} = n;
      return {props:ua(n, ["id"]), readOnly:e};
    }
    return {props:t.props, readOnly:e};
  }
  return {props:{}, readOnly:e};
}, cce = {title:{type:"text"}}, QR = t => mP()(bP((e, n) => {
  var r, i;
  return ve(K({state:Py, config:{components:{}}, componentState:{}, plugins:[], overrides:{}, viewports:Gp, zoomConfig:{autoZoom:1, rootHeight:0, zoom:1}, status:"LOADING", iframe:{}, metadata:{}, fieldTransforms:{}}, t), {fields:oce(), history:tce(e, n), nodes:rce(e, n), permissions:ice(e, n), getComponentConfig:s => {
    var o;
    const {config:a, selectedItem:l} = n(), c = ((o = a.root) == null ? void 0 : o.fields) || cce;
    return s && s !== "root" ? a.components[s] : l ? a.components[l.type] : ve(K({}, a.root), {fields:c});
  }, selectedItem:(r = t == null ? void 0 : t.state) != null && r.ui.itemSelector ? is((i = t == null ? void 0 : t.state) == null ? void 0 : i.ui.itemSelector, t.state) : null, dispatch:s => e(o => {
    var a, l;
    const {record:c} = n().history, h = AE({record:c, appStore:o})(o.state, s), f = h.ui.itemSelector ? is(h.ui.itemSelector, h) : null;
    return (l = (a = n()).onAction) == null || l.call(a, s, h, n().state), ve(K({}, o), {state:h, selectedItem:f});
  }), setZoomConfig:s => e({zoomConfig:s}), setStatus:s => e({status:s}), setComponentState:s => e({componentState:s}), pendingLoadTimeouts:{}, setComponentLoading:(s, o = !0, a = 0) => {
    const {setComponentState:l, pendingLoadTimeouts:c} = n(), u = vi(), h = () => {
      var g;
      const {componentState:m} = n();
      l(ve(K({}, m), {[s]:ve(K({}, m[s]), {loadingCount:(((g = m[s]) == null ? void 0 : g.loadingCount) || 0) + 1})}));
    }, f = () => {
      var g;
      const {componentState:m} = n();
      clearTimeout(p), delete c[u], e({pendingLoadTimeouts:c}), l(ve(K({}, m), {[s]:ve(K({}, m[s]), {loadingCount:Math.max((((g = m[s]) == null ? void 0 : g.loadingCount) || 0) - 1, 0)})}));
    }, p = setTimeout(() => {
      o ? h() : f(), delete c[u], e({pendingLoadTimeouts:c});
    }, a);
    return e({pendingLoadTimeouts:ve(K({}, c), {[s]:p})}), f;
  }, unsetComponentLoading:s => {
    const {setComponentLoading:o} = n();
    o(s, !1);
  }, setUi:(s, o) => e(a => {
    const c = AE({record:() => {
    }, appStore:a})(a.state, {type:"setUi", ui:s, recordHistory:o}), u = c.ui.itemSelector ? is(c.ui.itemSelector, c) : null;
    return ve(K({}, a), {state:c, selectedItem:u});
  }), resolveComponentData:(s, o) => Qn(void 0, null, function*() {
    const {config:a, metadata:l, setComponentLoading:c, permissions:u} = n(), h = {};
    return yield dP(s, a, l, f => {
      const p = "id" in f.props ? f.props.id : "root";
      h[p] = c(p, !0, 50);
    }, f => Qn(void 0, null, function*() {
      const p = "id" in f.props ? f.props.id : "root";
      "type" in f ? yield u.refreshPermissions({item:f}) : yield u.refreshPermissions({root:!0}), h[p]();
    }), o);
  }), resolveAndCommitData:() => Qn(void 0, null, function*() {
    const {config:s, state:o, dispatch:a, resolveComponentData:l} = n();
    xi(o, s, c => c, c => (l(c, "load").then(u => {
      const {state:h} = n(), f = h.indexes.nodes[u.node.props.id];
      if (f && u.didChange) {
        if (u.node.props.id === "root") {
          a({type:"replaceRoot", root:lce(u.node)});
        } else {
          const p = `${f.parentId}:${f.zone}`, m = h.indexes.zones[p].contentIds.indexOf(u.node.props.id);
          a({type:"replace", data:u.node, destinationIndex:m, destinationZone:p});
        }
      }
    }), c));
  })});
})), Kv = (0,require$react.createContext)(QR());
function Be(t) {
  const e = (0,require$react.useContext)(Kv);
  return K1(e, t);
}
function oi() {
  return (0,require$react.useContext)(Kv);
}
re();
re();
re();
var uce = process.env.NODE_ENV === "production", q0 = "Invariant failed";
function RE(t, e) {
  if (uce) {
    throw new Error(q0);
  }
  var n = typeof e == "function" ? e() : e, r = n ? "".concat(q0, ": ").concat(n) : q0;
  throw new Error(r);
}
var xf = function(e) {
  var n = e.top, r = e.right, i = e.bottom, s = e.left, o = r - s, a = i - n, l = {top:n, right:r, bottom:i, left:s, width:o, height:a, x:s, y:n, center:{x:(r + s) / 2, y:(i + n) / 2}};
  return l;
}, dce = function(e, n) {
  return {top:e.top - n.top, left:e.left - n.left, bottom:e.bottom + n.bottom, right:e.right + n.right};
}, DE = function(e, n) {
  return {top:e.top + n.top, left:e.left + n.left, bottom:e.bottom - n.bottom, right:e.right - n.right};
}, Y0 = {top:0, right:0, bottom:0, left:0}, hce = function(e) {
  var n = e.borderBox, r = e.margin, i = r === void 0 ? Y0 : r, s = e.border, o = s === void 0 ? Y0 : s, a = e.padding, l = a === void 0 ? Y0 : a, c = xf(dce(n, i)), u = xf(DE(n, o)), h = xf(DE(u, l));
  return {marginBox:c, borderBox:xf(n), paddingBox:u, contentBox:h, margin:i, border:o, padding:l};
}, Ti = function(e) {
  var n = e.slice(0, -2), r = e.slice(-2);
  if (r !== "px") {
    return 0;
  }
  var i = Number(n);
  return isNaN(i) && (process.env.NODE_ENV !== "production" ? RE(!1, "Could not parse value [raw: " + e + ", without suffix: " + n + "]") : RE()), i;
}, fce = function(e, n) {
  var r = {top:Ti(n.marginTop), right:Ti(n.marginRight), bottom:Ti(n.marginBottom), left:Ti(n.marginLeft)}, i = {top:Ti(n.paddingTop), right:Ti(n.paddingRight), bottom:Ti(n.paddingBottom), left:Ti(n.paddingLeft)}, s = {top:Ti(n.borderTopWidth), right:Ti(n.borderRightWidth), bottom:Ti(n.borderBottomWidth), left:Ti(n.borderLeftWidth)};
  return hce({borderBox:e, margin:r, padding:i, border:s});
}, KR = function(e) {
  var n = e.getBoundingClientRect(), r = window.getComputedStyle(e);
  return fce(n, r);
}, pce = (t, e, n) => {
  const r = KR(e), {width:i, height:s} = r.contentBox, o = t.height === "auto" ? s : t.height;
  let a = 0, l = 1;
  if (t.width > i || o > s) {
    const c = Math.min(i / t.width, 1), u = Math.min(s / o, 1);
    n = c, c < u ? a = o / n : (a = o, n = u), l = n;
  } else {
    l = 1, n = 1, a = o;
  }
  return {autoZoom:l, rootHeight:a, zoom:n};
}, XR = t => {
  const e = oi();
  return r => {
    const {state:i, zoomConfig:s, setZoomConfig:o} = e.getState(), {viewports:a} = i.ui, l = (r == null ? void 0 : r.viewports) || a;
    t.current && o(pce(l == null ? void 0 : l.current, t.current, s.zoom));
  };
};
re();
var gce = {Loader:"_Loader_nacdm_13", "loader-animation":"_loader-animation_nacdm_1"}, mce = Rt("Loader", gce), dl = t => {
  var e = t, {color:n, size:r = 16} = e, i = ua(e, ["color", "size"]);
  return (0,require$react_SLASH_jsx_runtime.jsx)("span", K({className:mce(), style:{width:r, height:r, color:n}, "aria-label":"loading"}, i));
}, LE = Rt("IconButton", zle), ss = ({children:t, href:e, onClick:n, variant:r = "primary", type:i, disabled:s, tabIndex:o, newTab:a, fullWidth:l, title:c}) => {
  const [u, h] = (0,require$react.useState)(!1);
  return (0,require$react_SLASH_jsx_runtime.jsxs)(e ? "a" : "button", {className:LE({primary:r === "primary", secondary:r === "secondary", disabled:s, fullWidth:l}), onClick:g => {
    n && (h(!0), Promise.resolve(n(g)).then(() => {
      h(!1);
    }));
  }, type:i, disabled:s || u, tabIndex:o, target:a ? "_blank" : void 0, rel:a ? "noreferrer" : void 0, href:e, title:c, children:[(0,require$react_SLASH_jsx_runtime.jsx)("span", {className:LE("title"), children:c}), t, u && (0,require$react_SLASH_jsx_runtime.jsxs)(require$react_SLASH_jsx_runtime.Fragment, {children:["\u00a0\u00a0", (0,require$react_SLASH_jsx_runtime.jsx)(dl, {size:14})]})]});
};
re();
re();
var bce = {Button:"_Button_10byl_1", "Button--medium":"_Button--medium_10byl_29", "Button--large":"_Button--large_10byl_37", "Button-icon":"_Button-icon_10byl_44", "Button--primary":"_Button--primary_10byl_48", "Button--secondary":"_Button--secondary_10byl_67", "Button--flush":"_Button--flush_10byl_84", "Button--disabled":"_Button--disabled_10byl_88", "Button--fullWidth":"_Button--fullWidth_10byl_95", "Button-spinner":"_Button-spinner_10byl_100"};
re();
var yce = /^(data-.*)$/, xce = t => {
  let e = {};
  for (const n in t) {
    Object.prototype.hasOwnProperty.call(t, n) && yce.test(n) && (e[n] = t[n]);
  }
  return e;
}, G0 = Rt("Button", bce), ux = t => {
  var e = t, {children:n, href:r, onClick:i, variant:s = "primary", type:o, disabled:a, tabIndex:l, newTab:c, fullWidth:u, icon:h, size:f = "medium", loading:p = !1} = e, g = ua(e, ["children", "href", "onClick", "variant", "type", "disabled", "tabIndex", "newTab", "fullWidth", "icon", "size", "loading"]);
  const [m, b] = (0,require$react.useState)(p);
  (0,require$react.useEffect)(() => b(p), [p]);
  const x = r ? "a" : o ? "button" : "span", w = xce(g);
  return (0,require$react_SLASH_jsx_runtime.jsxs)(x, ve(K({className:G0({primary:s === "primary", secondary:s === "secondary", disabled:a, fullWidth:u, [f]:!0}), onClick:T => {
    i && (b(!0), Promise.resolve(i(T)).then(() => {
      b(!1);
    }));
  }, type:o, disabled:a || m, tabIndex:l, target:c ? "_blank" : void 0, rel:c ? "noreferrer" : void 0, href:r}, w), {children:[h && (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:G0("icon"), children:h}), n, m && (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:G0("spinner"), children:(0,require$react_SLASH_jsx_runtime.jsx)(dl, {size:14})})]}));
};
re();
re();
var Uc = {InputWrapper:"_InputWrapper_bsxfo_1", "Input-label":"_Input-label_bsxfo_5", "Input-labelIcon":"_Input-labelIcon_bsxfo_14", "Input-disabledIcon":"_Input-disabledIcon_bsxfo_21", "Input-input":"_Input-input_bsxfo_26", Input:"_Input_bsxfo_1", "Input--readOnly":"_Input--readOnly_bsxfo_82", "Input-radioGroupItems":"_Input-radioGroupItems_bsxfo_93", "Input-radio":"_Input-radio_bsxfo_93", "Input-radioInner":"_Input-radioInner_bsxfo_110", "Input-radioInput":"_Input-radioInput_bsxfo_155"};
re();
re();
re();
var JR = {ArrayField:"_ArrayField_14u8o_5", "ArrayField--isDraggingFrom":"_ArrayField--isDraggingFrom_14u8o_13", "ArrayField-addButton":"_ArrayField-addButton_14u8o_18", "ArrayField--hasItems":"_ArrayField--hasItems_14u8o_33", "ArrayField-inner":"_ArrayField-inner_14u8o_59", ArrayFieldItem:"_ArrayFieldItem_14u8o_67", "ArrayFieldItem--isDragging":"_ArrayFieldItem--isDragging_14u8o_78", "ArrayFieldItem--isExpanded":"_ArrayFieldItem--isExpanded_14u8o_82", "ArrayFieldItem-summary":"_ArrayFieldItem-summary_14u8o_97", 
"ArrayField--addDisabled":"_ArrayField--addDisabled_14u8o_127", "ArrayFieldItem-body":"_ArrayFieldItem-body_14u8o_166", "ArrayFieldItem-fieldset":"_ArrayFieldItem-fieldset_14u8o_175", "ArrayFieldItem-rhs":"_ArrayFieldItem-rhs_14u8o_183", "ArrayFieldItem-actions":"_ArrayFieldItem-actions_14u8o_189"};
re();
re();
re();
var vce = t => t.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase(), ZR = (...t) => t.filter((e, n, r) => !!e && e.trim() !== "" && r.indexOf(e) === n).join(" ").trim();
re();
re();
var wce = {xmlns:"http://www.w3.org/2000/svg", width:24, height:24, viewBox:"0 0 24 24", fill:"none", stroke:"currentColor", strokeWidth:2, strokeLinecap:"round", strokeLinejoin:"round"}, _ce = (0,require$react.forwardRef)((t, e) => {
  var n = t, {color:r = "currentColor", size:i = 24, strokeWidth:s = 2, absoluteStrokeWidth:o, className:a = "", children:l, iconNode:c} = n, u = ua(n, ["color", "size", "strokeWidth", "absoluteStrokeWidth", "className", "children", "iconNode"]);
  return (0,require$react.createElement)("svg", K(ve(K({ref:e}, wce), {width:i, height:i, stroke:r, strokeWidth:o ? Number(s) * 24 / Number(i) : s, className:ZR("lucide", a)}), u), [...c.map(([h, f]) => (0,require$react.createElement)(h, f)), ...(Array.isArray(l) ? l : [l])]);
}), an = (t, e) => {
  const n = (0,require$react.forwardRef)((r, i) => {
    var s = r, {className:o} = s, a = ua(s, ["className"]);
    return (0,require$react.createElement)(_ce, K({ref:i, iconNode:e, className:ZR(`lucide-${vce(t)}`, o)}, a));
  });
  return n.displayName = `${t}`, n;
};
re();
var sm = an("ChevronDown", [["path", {d:"m6 9 6 6 6-6", key:"qrunsl"}]]);
re();
var Sce = an("ChevronRight", [["path", {d:"m9 18 6-6-6-6", key:"mthhwq"}]]);
re();
var eD = an("ChevronUp", [["path", {d:"m18 15-6-6-6 6", key:"153udz"}]]);
re();
var kce = an("CircleCheckBig", [["path", {d:"M21.801 10A10 10 0 1 1 17 3.335", key:"yps3ct"}], ["path", {d:"m9 11 3 3L22 4", key:"1pflzl"}]]);
re();
var tD = an("Copy", [["rect", {width:"14", height:"14", x:"8", y:"8", rx:"2", ry:"2", key:"17jyea"}], ["path", {d:"M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2", key:"zix9uf"}]]);
re();
var Ece = an("CornerLeftUp", [["polyline", {points:"14 9 9 4 4 9", key:"m9oyvo"}], ["path", {d:"M20 20h-7a4 4 0 0 1-4-4V4", key:"1blwi3"}]]);
re();
var Tce = an("EllipsisVertical", [["circle", {cx:"12", cy:"12", r:"1", key:"41hilf"}], ["circle", {cx:"12", cy:"5", r:"1", key:"gxeob9"}], ["circle", {cx:"12", cy:"19", r:"1", key:"lyex9k"}]]);
re();
var ME = an("Globe", [["circle", {cx:"12", cy:"12", r:"10", key:"1mglay"}], ["path", {d:"M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20", key:"13o1zl"}], ["path", {d:"M2 12h20", key:"9i4pu4"}]]);
re();
var Cce = an("Hash", [["line", {x1:"4", x2:"20", y1:"9", y2:"9", key:"4lhtct"}], ["line", {x1:"4", x2:"20", y1:"15", y2:"15", key:"vyu0kd"}], ["line", {x1:"10", x2:"8", y1:"3", y2:"21", key:"1ggp8o"}], ["line", {x1:"16", x2:"14", y1:"3", y2:"21", key:"weycgp"}]]);
re();
var Ace = an("Layers", [["path", {d:"M12.83 2.18a2 2 0 0 0-1.66 0L2.6 6.08a1 1 0 0 0 0 1.83l8.58 3.91a2 2 0 0 0 1.66 0l8.58-3.9a1 1 0 0 0 0-1.83z", key:"zw3jo"}], ["path", {d:"M2 12a1 1 0 0 0 .58.91l8.6 3.91a2 2 0 0 0 1.65 0l8.58-3.9A1 1 0 0 0 22 12", key:"1wduqc"}], ["path", {d:"M2 17a1 1 0 0 0 .58.91l8.6 3.91a2 2 0 0 0 1.65 0l8.58-3.9A1 1 0 0 0 22 17", key:"kqbvx6"}]]);
re();
var Nce = an("LayoutGrid", [["rect", {width:"7", height:"7", x:"3", y:"3", rx:"1", key:"1g98yp"}], ["rect", {width:"7", height:"7", x:"14", y:"3", rx:"1", key:"6d4xhi"}], ["rect", {width:"7", height:"7", x:"14", y:"14", rx:"1", key:"nxv5o0"}], ["rect", {width:"7", height:"7", x:"3", y:"14", rx:"1", key:"1bb6yr"}]]);
re();
var nD = an("Link", [["path", {d:"M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71", key:"1cjeqo"}], ["path", {d:"M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71", key:"19qd67"}]]);
re();
var Ice = an("List", [["path", {d:"M3 12h.01", key:"nlz23k"}], ["path", {d:"M3 18h.01", key:"1tta3j"}], ["path", {d:"M3 6h.01", key:"1rqtza"}], ["path", {d:"M8 12h13", key:"1za7za"}], ["path", {d:"M8 18h13", key:"1lx6n3"}], ["path", {d:"M8 6h13", key:"ik3vkj"}]]);
re();
var Oce = an("LockOpen", [["rect", {width:"18", height:"11", x:"3", y:"11", rx:"2", ry:"2", key:"1w4ew1"}], ["path", {d:"M7 11V7a5 5 0 0 1 9.9-1", key:"1mm8w8"}]]);
re();
var Pce = an("Lock", [["rect", {width:"18", height:"11", x:"3", y:"11", rx:"2", ry:"2", key:"1w4ew1"}], ["path", {d:"M7 11V7a5 5 0 0 1 10 0v4", key:"fwvmzm"}]]);
re();
var Rce = an("Monitor", [["rect", {width:"20", height:"14", x:"2", y:"3", rx:"2", key:"48i651"}], ["line", {x1:"8", x2:"16", y1:"21", y2:"21", key:"1svkeh"}], ["line", {x1:"12", x2:"12", y1:"17", y2:"21", key:"vw1qmm"}]]);
re();
var Dce = an("PanelLeft", [["rect", {width:"18", height:"18", x:"3", y:"3", rx:"2", key:"afitv7"}], ["path", {d:"M9 3v18", key:"fh3hqa"}]]);
re();
var Lce = an("PanelRight", [["rect", {width:"18", height:"18", x:"3", y:"3", rx:"2", key:"afitv7"}], ["path", {d:"M15 3v18", key:"14nvp0"}]]);
re();
var Mce = an("Plus", [["path", {d:"M5 12h14", key:"1ays0h"}], ["path", {d:"M12 5v14", key:"s699le"}]]);
re();
var Bce = an("Redo2", [["path", {d:"m15 14 5-5-5-5", key:"12vg1m"}], ["path", {d:"M20 9H9.5A5.5 5.5 0 0 0 4 14.5A5.5 5.5 0 0 0 9.5 20H13", key:"6uklza"}]]);
re();
var $ce = an("Search", [["circle", {cx:"11", cy:"11", r:"8", key:"4ej97u"}], ["path", {d:"m21 21-4.3-4.3", key:"1qie3q"}]]);
re();
var Fce = an("SlidersHorizontal", [["line", {x1:"21", x2:"14", y1:"4", y2:"4", key:"obuewd"}], ["line", {x1:"10", x2:"3", y1:"4", y2:"4", key:"1q6298"}], ["line", {x1:"21", x2:"12", y1:"12", y2:"12", key:"1iu8h1"}], ["line", {x1:"8", x2:"3", y1:"12", y2:"12", key:"ntss68"}], ["line", {x1:"21", x2:"16", y1:"20", y2:"20", key:"14d8ph"}], ["line", {x1:"12", x2:"3", y1:"20", y2:"20", key:"m0wm8r"}], ["line", {x1:"14", x2:"14", y1:"2", y2:"6", key:"14e1ph"}], ["line", {x1:"8", x2:"8", y1:"10", y2:"14", 
key:"1i6ji0"}], ["line", {x1:"16", x2:"16", y1:"18", y2:"22", key:"1lctlv"}]]);
re();
var zce = an("Smartphone", [["rect", {width:"14", height:"20", x:"5", y:"2", rx:"2", ry:"2", key:"1yt0o3"}], ["path", {d:"M12 18h.01", key:"mhygvu"}]]);
re();
var Hce = an("Tablet", [["rect", {width:"16", height:"20", x:"4", y:"2", rx:"2", ry:"2", key:"76otgf"}], ["line", {x1:"12", x2:"12.01", y1:"18", y2:"18", key:"1dp563"}]]);
re();
var rD = an("Trash", [["path", {d:"M3 6h18", key:"d0wm0j"}], ["path", {d:"M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6", key:"4alrt4"}], ["path", {d:"M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2", key:"v07s0e"}]]);
re();
var Xv = an("Type", [["polyline", {points:"4 7 4 4 20 4 20 7", key:"1nosan"}], ["line", {x1:"9", x2:"15", y1:"20", y2:"20", key:"swin9y"}], ["line", {x1:"12", x2:"12", y1:"4", y2:"20", key:"1tx1rr"}]]);
re();
var Uce = an("Undo2", [["path", {d:"M9 14 4 9l5-5", key:"102s5s"}], ["path", {d:"M4 9h10.5a5.5 5.5 0 0 1 5.5 5.5a5.5 5.5 0 0 1-5.5 5.5H11", key:"f3b9sd"}]]);
re();
var Wce = an("ZoomIn", [["circle", {cx:"11", cy:"11", r:"8", key:"4ej97u"}], ["line", {x1:"21", x2:"16.65", y1:"21", y2:"16.65", key:"13gj7c"}], ["line", {x1:"11", x2:"11", y1:"8", y2:"14", key:"1vmskp"}], ["line", {x1:"8", x2:"14", y1:"11", y2:"11", key:"durymu"}]]);
re();
var jce = an("ZoomOut", [["circle", {cx:"11", cy:"11", r:"8", key:"4ej97u"}], ["line", {x1:"21", x2:"16.65", y1:"21", y2:"16.65", key:"13gj7c"}], ["line", {x1:"8", x2:"14", y1:"11", y2:"11", key:"durymu"}]]);
re();
re();
re();
var Vce = {DragIcon:"_DragIcon_17p8x_1", "DragIcon--disabled":"_DragIcon--disabled_17p8x_8"}, qce = Rt("DragIcon", Vce), iD = ({isDragDisabled:t}) => (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:qce({disabled:t}), children:(0,require$react_SLASH_jsx_runtime.jsx)("svg", {viewBox:"0 0 20 20", width:"12", fill:"currentColor", children:(0,require$react_SLASH_jsx_runtime.jsx)("path", {d:"M7 2a2 2 0 1 0 .001 4.001A2 2 0 0 0 7 2zm0 6a2 2 0 1 0 .001 4.001A2 2 0 0 0 7 8zm0 6a2 2 0 1 0 .001 4.001A2 2 0 0 0 7 14zm6-8a2 2 0 1 0-.001-4.001A2 2 0 0 0 13 6zm0 2a2 2 0 1 0 .001 4.001A2 2 0 0 0 13 8zm0 6a2 2 0 1 0 .001 4.001A2 2 0 0 0 13 14z"})})});
re();
re();
var BE = {delay:{value:200, tolerance:10}}, $E = {delay:{value:200, tolerance:10}, distance:{value:5}}, sD = ({other:t = $E, mouse:e, touch:n = BE} = {touch:BE, other:$E}) => {
  const [r] = (0,require$react.useState)(() => [aR.configure({activationConstraints(i, s) {
    var o;
    const {pointerType:a, target:l} = i;
    return a === "mouse" && Bc(l) && (s.handle === l || (o = s.handle) != null && o.contains(l)) ? e : a === "touch" ? n : t;
  }})]);
  return r;
};
re();
re();
re();
var $l = (t, e, n, r, i) => {
}, Q0 = "increasing", Yce = (t, e) => {
  var n;
  const {dragOperation:r, droppable:i} = t, {shape:s} = i, {position:o} = r, a = (n = r.shape) == null ? void 0 : n.current;
  if (!a || !s) {
    return null;
  }
  const l = s.center, c = Math.sqrt(Math.pow(l.x - e.x, 2) + Math.pow(l.y - e.y, 2)), u = Math.sqrt(Math.pow(l.x - o.current.x, 2) + Math.pow(l.y - o.current.y, 2));
  return Q0 = u === c ? Q0 : u < c ? "decreasing" : "increasing", $l(a.center, l, i.id.toString()), Q0 === "decreasing" ? {id:i.id, value:1, type:zs.Collision} : null;
};
re();
var oD = (t, e) => t === "dynamic" ? Math.abs(e.y) > Math.abs(e.x) ? e.y === 0 ? null : e.y > 0 ? "down" : "up" : e.x === 0 ? null : e.x > 0 ? "right" : "left" : t === "x" ? e.x === 0 ? null : e.x > 0 ? "right" : "left" : e.y === 0 ? null : e.y > 0 ? "down" : "up";
re();
var Gce = (t, e, n, r = 0) => {
  const i = t.boundingRectangle, s = e.center;
  if (n === "down") {
    const a = r * e.boundingRectangle.height;
    return i.bottom >= s.y + a;
  } else if (n === "up") {
    const a = r * e.boundingRectangle.height;
    return i.top < s.y - a;
  } else if (n === "left") {
    const a = r * e.boundingRectangle.width;
    return s.x - a >= i.left;
  }
  const o = r * e.boundingRectangle.width;
  return i.right - o >= s.x;
};
re();
var FE = 10, Vi = {current:{x:0, y:0}, delta:{x:0, y:0}, previous:{x:0, y:0}, direction:null}, Qce = (t, e = "dynamic") => (Vi.current = t, Vi.delta = {x:t.x - Vi.previous.x, y:t.y - Vi.previous.y}, Vi.direction = oD(e, Vi.delta) || Vi.direction, (Math.abs(Vi.delta.x) > FE || Math.abs(Vi.delta.y) > FE) && (Vi.previous = Ar.from(t)), Vi);
re();
var Kce = ({dragOperation:t, droppable:e}) => {
  const n = t.position.current;
  if (!n) {
    return null;
  }
  const {id:r} = e;
  if (!e.shape) {
    return null;
  }
  if (e.shape.containsPoint(n)) {
    const i = Ar.distance(e.shape.center, n);
    return {id:r, value:1 / i, type:zs.PointerIntersection, priority:Li.High};
  }
  return null;
}, Xce = t => {
  const {dragOperation:e, droppable:n} = t, {shape:r, position:i} = e;
  if (!n.shape) {
    return null;
  }
  const s = r ? as.from(r.current.boundingRectangle).corners : void 0, a = as.from(n.shape.boundingRectangle).corners.reduce((l, c, u) => {
    var h;
    return l + Ar.distance(Ar.from(c), (h = s == null ? void 0 : s[u]) != null ? h : i.current);
  }, 0) / 4;
  return {id:n.id, value:1 / a, type:zs.Collision, priority:Li.Normal};
};
re();
var dx = ch(() => ({fallbackEnabled:!1})), K0 = "", aD = (t, e = 0.05) => n => {
  var r, i, s, o, a;
  const {dragOperation:l, droppable:c} = n, {position:u} = l, h = (r = l.shape) == null ? void 0 : r.current, {shape:f} = c;
  if (!h || !f) {
    return null;
  }
  const {center:p} = h, {fallbackEnabled:g} = dx.getState(), m = Qce(u.current, t), b = {direction:m.direction}, {center:x} = f, w = Gce(h, f, m.direction, e);
  if (((i = l.source) == null ? void 0 : i.id) === c.id) {
    const I = Yce(n, m.previous);
    if ($l(p, x, c.id.toString()), I) {
      return ve(K({}, I), {priority:Li.Highest, data:b});
    }
  }
  const v = h.intersectionArea(f), T = v / f.area;
  if (v && w) {
    $l(p, x, c.id.toString());
    const I = {id:c.id, value:T, priority:Li.High, type:zs.Collision}, _ = K0 === c.id;
    return K0 = "", ve(K({}, I), {id:_ ? "flush" : I.id, data:b});
  }
  if (g && ((s = l.source) == null ? void 0 : s.id) !== c.id) {
    const I = f.boundingRectangle.right > h.boundingRectangle.left && f.boundingRectangle.left < h.boundingRectangle.right, _ = f.boundingRectangle.bottom > h.boundingRectangle.top && f.boundingRectangle.top < h.boundingRectangle.bottom;
    if (t === "y" && I || _) {
      const N = Xce(n);
      if (N) {
        const E = oD(t, {x:h.center.x - (((o = c.shape) == null ? void 0 : o.center.x) || 0), y:h.center.y - (((a = c.shape) == null ? void 0 : a.center.y) || 0)});
        return b.direction = E, v ? ($l(p, x, c.id.toString()), K0 = c.id, ve(K({}, N), {priority:Li.Low, data:b})) : ($l(p, x, c.id.toString()), ve(K({}, N), {priority:Li.Lowest, data:b}));
      }
    }
  }
  return $l(p, x, c.id.toString()), null;
}, Jce = ({children:t, onDragStart:e, onDragEnd:n, onMove:r}) => {
  const i = sD({mouse:{distance:{value:5}}});
  return (0,require$react_SLASH_jsx_runtime.jsx)(wR, {sensors:i, onDragStart:s => {
    var o, a;
    return e((a = (o = s.operation.source) == null ? void 0 : o.id.toString()) != null ? a : "");
  }, onDragOver:(s, o) => {
    var a;
    s.preventDefault();
    const {operation:l} = s, {source:c, target:u} = l;
    if (!c || !u) {
      return;
    }
    let h = c.data.index, f = u.data.index;
    const p = (a = o.collisionObserver.collisions[0]) == null ? void 0 : a.data;
    if (h !== f && c.id !== u.id) {
      const g = (p == null ? void 0 : p.direction) === "up" ? "before" : "after";
      f >= h && (f = f - 1), g === "after" && (f = f + 1), r({source:h, target:f});
    }
  }, onDragEnd:() => {
    setTimeout(() => {
      n();
    }, 250);
  }, children:t});
}, Zce = ({id:t, index:e, disabled:n, children:r, type:i = "item"}) => {
  const {ref:s, isDragging:o, isDropping:a, handleRef:l} = WR({id:t, type:i, index:e, disabled:n, data:{index:e}, collisionDetector:aD("y")});
  return r({isDragging:o, isDropping:a, ref:s, handleRef:l});
};
re();
var dg = (0,require$react.createContext)({}), lD = () => {
  const t = (0,require$react.useContext)(dg);
  return ve(K({}, t), {readOnlyFields:t.readOnlyFields || {}});
}, cD = ({children:t, name:e, subName:n, wildcardName:r = e, readOnlyFields:i}) => {
  const s = `${e}.${n}`, o = `${r}.${n}`, a = (0,require$react.useMemo)(() => Object.keys(i).reduce((l, c) => {
    if (c.indexOf(s) > -1 || c.indexOf(o) > -1) {
      const h = new RegExp(`^(${e}|${r}).`.replace(/\[/g, "\\[").replace(/\]/g, "\\]").replace(/\./g, "\\.").replace(/\*/g, "\\*")), f = c.replace(h, "");
      return ve(K({}, l), {[f]:i[c]});
    }
    return l;
  }, {}), [e, n, r, i]);
  return (0,require$react_SLASH_jsx_runtime.jsx)(dg.Provider, {value:{readOnlyFields:a, localName:n}, children:t});
}, X0 = Rt("ArrayField", JR), No = Rt("ArrayFieldItem", JR), eue = ({field:t, onChange:e, value:n, name:r, label:i, labelIcon:s, readOnly:o, id:a, Label:l = c => (0,require$react_SLASH_jsx_runtime.jsx)("div", K({}, c))}) => {
  const c = Be(W => W.state.ui.arrayState[a]), u = Be(W => W.setUi), {readOnlyFields:h, localName:f = r} = lD(), p = n, g = c || {items:Array.from(p || []).map((W, F) => ({_originalIndex:F, _arrayId:`${a}-${F}`})), openId:""}, [m, b] = (0,require$react.useState)({arrayState:g, value:p});
  (0,require$react.useEffect)(() => {
    var W;
    const F = (W = x.getState().state.ui.arrayState[a]) != null ? W : g;
    b({arrayState:F, value:p});
  }, [p]);
  const x = oi(), w = (0,require$react.useCallback)(W => {
    const F = x.getState().state;
    return {arrayState:ve(K({}, F.ui.arrayState), {[a]:K(K({}, g), W)})};
  }, [g, x]), v = (0,require$react.useCallback)(() => g.items.reduce((W, F) => F._originalIndex > W ? F._originalIndex : W, -1), [g]), T = (0,require$react.useCallback)(W => {
    let F = v();
    const B = Array.from(W || []).map((z, j) => {
      var V;
      const ne = g.items[j], D = {_originalIndex:typeof(ne == null ? void 0 : ne._originalIndex) < "u" ? ne._originalIndex : F + 1, _arrayId:((V = g.items[j]) == null ? void 0 : V._arrayId) || `${a}-${F + 1}`};
      return D._originalIndex > F && (F = D._originalIndex), D;
    });
    return ve(K({}, g), {items:B});
  }, [g]);
  (0,require$react.useEffect)(() => {
    g.items.length > 0 && u(w(g));
  }, []);
  const [I, _] = (0,require$react.useState)(""), N = !!I, C = !Be(W => W.permissions.getPermissions({item:W.selectedItem}).edit), k = (0,require$react.useRef)(p), A = (0,require$react.useCallback)(W => {
    if (t.type !== "array" || !t.arrayFields) {
      return;
    }
    const F = x.getState().config;
    return Yp({value:W, fields:t.arrayFields, mappers:{slot:({value:B}) => B.map(j => VR(j, F, !0))}, config:F});
  }, [x, t]);
  if (t.type !== "array" || !t.arrayFields) {
    return null;
  }
  const P = t.max !== void 0 && m.arrayState.items.length >= t.max || o;
  return (0,require$react_SLASH_jsx_runtime.jsx)(l, {label:i || r, icon:s || (0,require$react_SLASH_jsx_runtime.jsx)(Ice, {size:16}), el:"div", readOnly:o, children:(0,require$react_SLASH_jsx_runtime.jsx)(Jce, {onDragStart:W => _(W), onDragEnd:() => {
    _(""), e(k.current);
  }, onMove:W => {
    if (g.items[W.source]._arrayId !== I) {
      return;
    }
    const F = CE(m.value, W.source, W.target), B = CE(g.items, W.source, W.target), z = x.getState().state, j = {arrayState:ve(K({}, z.ui.arrayState), {[a]:ve(K({}, g), {items:B})})};
    u(j, !1), b({value:F, arrayState:ve(K({}, g), {items:B})}), k.current = F;
  }, children:(0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:X0({hasItems:Array.isArray(p) && p.length > 0, addDisabled:P}), children:[m.arrayState.items.length > 0 && (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:X0("inner"), "data-dnd-container":!0, children:m.arrayState.items.map((W, F) => {
    const {_arrayId:B = `${a}-${F}`, _originalIndex:z = F} = W, j = Array.from(m.value || [])[F] || {};
    return (0,require$react_SLASH_jsx_runtime.jsx)(Zce, {id:B, index:F, disabled:o, children:({isDragging:V, ref:ne, handleRef:D}) => (0,require$react_SLASH_jsx_runtime.jsxs)("div", {ref:ne, className:No({isExpanded:g.openId === B, isDragging:V, readOnly:o}), children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {ref:D, onClick:ie => {
      V || (ie.preventDefault(), ie.stopPropagation(), g.openId === B ? u(w({openId:""})) : u(w({openId:B})));
    }, className:No("summary"), children:[t.getItemSummary ? t.getItemSummary(j, F) : `Item #${z}`, (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:No("rhs"), children:[!o && (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:No("actions"), children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {className:No("action"), children:(0,require$react_SLASH_jsx_runtime.jsx)(ss, {type:"button", disabled:!!P, onClick:ie => {
      ie.stopPropagation();
      const ee = [...(p || [])], M = A(ee[F]);
      ee.splice(F, 0, M);
      const X = w(T(ee));
      u(X, !1), e(ee);
    }, title:"Duplicate", children:(0,require$react_SLASH_jsx_runtime.jsx)(tD, {size:16})})}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:No("action"), children:(0,require$react_SLASH_jsx_runtime.jsx)(ss, {type:"button", disabled:t.min !== void 0 && t.min >= m.arrayState.items.length, onClick:ie => {
      ie.stopPropagation();
      const ee = [...(p || [])], M = [...(g.items || [])];
      ee.splice(F, 1), M.splice(F, 1), u(w({items:M}), !1), e(ee);
    }, title:"Delete", children:(0,require$react_SLASH_jsx_runtime.jsx)(rD, {size:16})})})]}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {children:(0,require$react_SLASH_jsx_runtime.jsx)(iD, {})})]})]}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:No("body"), children:g.openId === B && (0,require$react_SLASH_jsx_runtime.jsx)("fieldset", {className:No("fieldset"), children:Object.keys(t.arrayFields).map(ie => {
      const ee = t.arrayFields[ie], X = `${`${r}[${F}]`}.${ie}`, ge = `${f}[${F}]`, me = `${f}[*]`, te = `${ge}.${ie}`, q = `${me}.${ie}`, R = C || (typeof h[X] < "u" ? h[te] : h[q]), $ = ee.label || ie;
      return (0,require$react_SLASH_jsx_runtime.jsx)(cD, {name:ge, wildcardName:me, subName:ie, readOnlyFields:h, children:(0,require$react_SLASH_jsx_runtime.jsx)(om, {name:X, label:$, id:`${B}_${ie}`, readOnly:R, field:ve(K({}, ee), {label:$}), value:j[ie], onChange:(G, J) => {
        e(Hle(p, F, ve(K({}, j), {[ie]:G})), J);
      }})}, X);
    })})})]})}, B);
  })}), !P && (0,require$react_SLASH_jsx_runtime.jsx)("button", {type:"button", className:X0("addButton"), onClick:() => {
    var W;
    if (N) {
      return;
    }
    const F = p || [], B = V1(A((W = t.defaultItemProps) != null ? W : {}), t.arrayFields), z = [...F, B], j = T(z);
    u(w(j), !1), e(z);
  }, children:(0,require$react_SLASH_jsx_runtime.jsx)(Mce, {size:21})})]})})});
};
re();
var tue = Rt("Input", Uc), zE = ({field:t, onChange:e, readOnly:n, value:r, name:i, label:s, labelIcon:o, Label:a, id:l}) => {
  const c = r;
  return (0,require$react_SLASH_jsx_runtime.jsx)(a, {label:s || i, icon:o || (0,require$react_SLASH_jsx_runtime.jsxs)(require$react_SLASH_jsx_runtime.Fragment, {children:[t.type === "text" && (0,require$react_SLASH_jsx_runtime.jsx)(Xv, {size:16}), t.type === "number" && (0,require$react_SLASH_jsx_runtime.jsx)(Cce, {size:16})]}), readOnly:n, children:(0,require$react_SLASH_jsx_runtime.jsx)("input", {className:tue("input"), autoComplete:"off", type:t.type, title:s || i, name:i, value:c != null && c.toString ? 
  c.toString() : "", onChange:u => {
    if (t.type === "number") {
      const h = Number(u.currentTarget.value);
      if (typeof t.min < "u" && h < t.min || typeof t.max < "u" && h > t.max) {
        return;
      }
      e(h);
    } else {
      e(u.currentTarget.value);
    }
  }, readOnly:n, tabIndex:n ? -1 : void 0, id:l, min:t.type === "number" ? t.min : void 0, max:t.type === "number" ? t.max : void 0, placeholder:t.type === "text" || t.type === "number" ? t.placeholder : void 0, step:t.type === "number" ? t.step : void 0})});
};
re();
re();
re();
var uD = {"ExternalInput-actions":"_ExternalInput-actions_91ls0_1", "ExternalInput-button":"_ExternalInput-button_91ls0_5", "ExternalInput--dataSelected":"_ExternalInput--dataSelected_91ls0_24", "ExternalInput--readOnly":"_ExternalInput--readOnly_91ls0_31", "ExternalInput-detachButton":"_ExternalInput-detachButton_91ls0_35", ExternalInput:"_ExternalInput_91ls0_1", ExternalInputModal:"_ExternalInputModal_91ls0_79", "ExternalInputModal-grid":"_ExternalInputModal-grid_91ls0_89", "ExternalInputModal--filtersToggled":"_ExternalInputModal--filtersToggled_91ls0_100", 
"ExternalInputModal-filters":"_ExternalInputModal-filters_91ls0_105", "ExternalInputModal-masthead":"_ExternalInputModal-masthead_91ls0_124", "ExternalInputModal-tableWrapper":"_ExternalInputModal-tableWrapper_91ls0_133", "ExternalInputModal-table":"_ExternalInputModal-table_91ls0_133", "ExternalInputModal-thead":"_ExternalInputModal-thead_91ls0_149", "ExternalInputModal-th":"_ExternalInputModal-th_91ls0_149", "ExternalInputModal-td":"_ExternalInputModal-td_91ls0_164", "ExternalInputModal-tr":"_ExternalInputModal-tr_91ls0_169", 
"ExternalInputModal-tbody":"_ExternalInputModal-tbody_91ls0_176", "ExternalInputModal--hasData":"_ExternalInputModal--hasData_91ls0_202", "ExternalInputModal-loadingBanner":"_ExternalInputModal-loadingBanner_91ls0_206", "ExternalInputModal--isLoading":"_ExternalInputModal--isLoading_91ls0_223", "ExternalInputModal-searchForm":"_ExternalInputModal-searchForm_91ls0_227", "ExternalInputModal-search":"_ExternalInputModal-search_91ls0_227", "ExternalInputModal-searchIcon":"_ExternalInputModal-searchIcon_91ls0_264", 
"ExternalInputModal-searchIconText":"_ExternalInputModal-searchIconText_91ls0_289", "ExternalInputModal-searchInput":"_ExternalInputModal-searchInput_91ls0_299", "ExternalInputModal-searchActions":"_ExternalInputModal-searchActions_91ls0_313", "ExternalInputModal-searchActionIcon":"_ExternalInputModal-searchActionIcon_91ls0_326", "ExternalInputModal-footerContainer":"_ExternalInputModal-footerContainer_91ls0_330", "ExternalInputModal-footer":"_ExternalInputModal-footer_91ls0_330", "ExternalInputModal-field":"_ExternalInputModal-field_91ls0_343"};
re();
re();
var nue = {Modal:"_Modal_ikbaj_1", "Modal--isOpen":"_Modal--isOpen_ikbaj_15", "Modal-inner":"_Modal-inner_ikbaj_19"}, HE = Rt("Modal", nue), rue = ({children:t, onClose:e, isOpen:n}) => {
  const [r, i] = (0,require$react.useState)(null);
  return (0,require$react.useEffect)(() => {
    i(document.getElementById("puck-portal-root"));
  }, []), r ? (0,require$react_dom.createPortal)((0,require$react_SLASH_jsx_runtime.jsx)("div", {className:HE({isOpen:n}), onClick:e, children:(0,require$react_SLASH_jsx_runtime.jsx)("div", {className:HE("inner"), onClick:s => s.stopPropagation(), children:t})}), r) : (0,require$react_SLASH_jsx_runtime.jsx)("div", {});
};
re();
re();
var iue = {Heading:"_Heading_qxrry_1", "Heading--xxxxl":"_Heading--xxxxl_qxrry_12", "Heading--xxxl":"_Heading--xxxl_qxrry_18", "Heading--xxl":"_Heading--xxl_qxrry_22", "Heading--xl":"_Heading--xl_qxrry_26", "Heading--l":"_Heading--l_qxrry_30", "Heading--m":"_Heading--m_qxrry_34", "Heading--s":"_Heading--s_qxrry_38", "Heading--xs":"_Heading--xs_qxrry_42"}, sue = Rt("Heading", iue), Jv = ({children:t, rank:e, size:n = "m"}) => {
  const r = e ? `h${e}` : "span";
  return (0,require$react_SLASH_jsx_runtime.jsx)(r, {className:sue({[n]:!0}), children:t});
};
re();
var vf = Rt("ExternalInput", uD), Nn = Rt("ExternalInputModal", uD), UE = {}, oue = ({field:t, onChange:e, value:n = null, name:r, id:i, readOnly:s}) => {
  const {mapProp:o = k => k, mapRow:a = k => k, filterFields:l} = t || {}, [c, u] = (0,require$react.useState)([]), [h, f] = (0,require$react.useState)(!1), [p, g] = (0,require$react.useState)(!0), m = !!l, [b, x] = (0,require$react.useState)(t.initialFilters || {}), [w, v] = (0,require$react.useState)(m), T = (0,require$react.useMemo)(() => c.map(a), [c]), I = (0,require$react.useMemo)(() => {
    const k = new Set();
    for (const A of T) {
      for (const P of Object.keys(A)) {
        (typeof A[P] == "string" || typeof A[P] == "number" || (0,require$react.isValidElement)(A[P])) && k.add(P);
      }
    }
    return Array.from(k);
  }, [T]), [_, N] = (0,require$react.useState)(t.initialQuery || ""), E = (0,require$react.useCallback)((k, A) => Qn(void 0, null, function*() {
    g(!0);
    const P = `${i}-${k}-${JSON.stringify(A)}`, W = UE[P] || (yield t.fetchList({query:k, filters:A}));
    W && (u(W), g(!1), UE[P] = W);
  }), [i, t]), C = (0,require$react.useCallback)(k => t.renderFooter ? t.renderFooter(k) : (0,require$react_SLASH_jsx_runtime.jsxs)("span", {className:Nn("footer"), children:[k.items.length, " result", k.items.length === 1 ? "" : "s"]}), [t.renderFooter]);
  return (0,require$react.useEffect)(() => {
    E(_, b);
  }, []), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:vf({dataSelected:!!n, modalVisible:h, readOnly:s}), id:i, children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:vf("actions"), children:[(0,require$react_SLASH_jsx_runtime.jsx)("button", {type:"button", onClick:() => f(!0), className:vf("button"), disabled:s, children:n ? t.getItemSummary ? t.getItemSummary(n) : "External item" : (0,require$react_SLASH_jsx_runtime.jsxs)(require$react_SLASH_jsx_runtime.Fragment, {children:[(0,require$react_SLASH_jsx_runtime.jsx)(nD, 
  {size:"16"}), (0,require$react_SLASH_jsx_runtime.jsx)("span", {children:t.placeholder})]})}), n && (0,require$react_SLASH_jsx_runtime.jsx)("button", {type:"button", className:vf("detachButton"), onClick:() => {
    e(null);
  }, disabled:s, children:(0,require$react_SLASH_jsx_runtime.jsx)(Oce, {size:16})})]}), (0,require$react_SLASH_jsx_runtime.jsx)(rue, {onClose:() => f(!1), isOpen:h, children:(0,require$react_SLASH_jsx_runtime.jsxs)("form", {className:Nn({isLoading:p, loaded:!p, hasData:T.length > 0, filtersToggled:w}), onSubmit:k => {
    k.preventDefault(), E(_, b);
  }, children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {className:Nn("masthead"), children:t.showSearch ? (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:Nn("searchForm"), children:[(0,require$react_SLASH_jsx_runtime.jsxs)("label", {className:Nn("search"), children:[(0,require$react_SLASH_jsx_runtime.jsx)("span", {className:Nn("searchIconText"), children:"Search"}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:Nn("searchIcon"), children:(0,require$react_SLASH_jsx_runtime.jsx)($ce, 
  {size:"18"})}), (0,require$react_SLASH_jsx_runtime.jsx)("input", {className:Nn("searchInput"), name:"q", type:"search", placeholder:t.placeholder, onChange:k => {
    N(k.currentTarget.value);
  }, autoComplete:"off", value:_})]}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:Nn("searchActions"), children:[(0,require$react_SLASH_jsx_runtime.jsx)(ux, {type:"submit", loading:p, fullWidth:!0, children:"Search"}), m && (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:Nn("searchActionIcon"), children:(0,require$react_SLASH_jsx_runtime.jsx)(ss, {type:"button", title:"Toggle filters", onClick:k => {
    k.preventDefault(), k.stopPropagation(), v(!w);
  }, children:(0,require$react_SLASH_jsx_runtime.jsx)(Fce, {size:20})})})]})]}) : (0,require$react_SLASH_jsx_runtime.jsx)(Jv, {rank:"2", size:"xs", children:t.placeholder || "Select data"})}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:Nn("grid"), children:[m && (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:Nn("filters"), children:m && Object.keys(l).map(k => {
    const A = l[k];
    return (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:Nn("field"), children:(0,require$react_SLASH_jsx_runtime.jsx)(om, {field:A, name:k, id:`external_field_${k}_filter`, label:A.label || k, value:b[k], onChange:P => {
      const W = ve(K({}, b), {[k]:P});
      x(W), E(_, W);
    }})}, k);
  })}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:Nn("tableWrapper"), children:[(0,require$react_SLASH_jsx_runtime.jsxs)("table", {className:Nn("table"), children:[(0,require$react_SLASH_jsx_runtime.jsx)("thead", {className:Nn("thead"), children:(0,require$react_SLASH_jsx_runtime.jsx)("tr", {className:Nn("tr"), children:I.map(k => (0,require$react_SLASH_jsx_runtime.jsx)("th", {className:Nn("th"), style:{textAlign:"left"}, children:k}, k))})}), (0,require$react_SLASH_jsx_runtime.jsx)("tbody", 
  {className:Nn("tbody"), children:T.map((k, A) => (0,require$react_SLASH_jsx_runtime.jsx)("tr", {style:{whiteSpace:"nowrap"}, className:Nn("tr"), onClick:() => {
    e(o(c[A])), f(!1);
  }, children:I.map(P => (0,require$react_SLASH_jsx_runtime.jsx)("td", {className:Nn("td"), children:k[P]}, P))}, A))})]}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:Nn("loadingBanner"), children:(0,require$react_SLASH_jsx_runtime.jsx)(dl, {size:24})})]})]}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:Nn("footerContainer"), children:(0,require$react_SLASH_jsx_runtime.jsx)(C, {items:T})})]})})]});
}, aue = ({field:t, onChange:e, value:n, name:r, label:i, labelIcon:s, Label:o, id:a, readOnly:l}) => {
  var c, u, h;
  const f = t, p = t;
  return (0,require$react.useEffect)(() => {
    p.adaptor && console.error("Warning: The `adaptor` API is deprecated. Please use updated APIs on the `external` field instead. This will be a breaking change in a future release.");
  }, []), t.type !== "external" ? null : (0,require$react_SLASH_jsx_runtime.jsx)(o, {label:i || r, icon:s || (0,require$react_SLASH_jsx_runtime.jsx)(nD, {size:16}), el:"div", children:(0,require$react_SLASH_jsx_runtime.jsx)(oue, {name:r, field:ve(K({}, f), {placeholder:(c = p.adaptor) != null && c.name ? `Select from ${p.adaptor.name}` : f.placeholder || "Select data", mapProp:((u = p.adaptor) == null ? void 0 : u.mapProp) || f.mapProp, mapRow:f.mapRow, fetchList:(h = p.adaptor) != null && h.fetchList ? 
  () => Qn(void 0, null, function*() {
    return yield p.adaptor.fetchList(p.adaptorParams);
  }) : f.fetchList}), onChange:e, value:n, id:a, readOnly:l})});
};
re();
var wf = Rt("Input", Uc), lue = ({field:t, onChange:e, readOnly:n, value:r, name:i, id:s, label:o, labelIcon:a, Label:l}) => t.type !== "radio" || !t.options ? null : (0,require$react_SLASH_jsx_runtime.jsx)(l, {icon:a || (0,require$react_SLASH_jsx_runtime.jsx)(kce, {size:16}), label:o || i, readOnly:n, el:"div", children:(0,require$react_SLASH_jsx_runtime.jsx)("div", {className:wf("radioGroupItems"), id:s, children:t.options.map(c => {
  var u;
  return (0,require$react_SLASH_jsx_runtime.jsxs)("label", {className:wf("radio"), children:[(0,require$react_SLASH_jsx_runtime.jsx)("input", {type:"radio", className:wf("radioInput"), value:JSON.stringify({value:c.value}), name:i, onChange:h => {
    e(JSON.parse(h.target.value).value);
  }, disabled:n, checked:r === c.value}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:wf("radioInner"), children:c.label || ((u = c.value) == null ? void 0 : u.toString())})]}, c.label + c.value);
})})});
re();
var cue = Rt("Input", Uc), uue = ({field:t, onChange:e, label:n, labelIcon:r, Label:i, value:s, name:o, readOnly:a, id:l}) => t.type !== "select" || !t.options ? null : (0,require$react_SLASH_jsx_runtime.jsx)(i, {label:n || o, icon:r || (0,require$react_SLASH_jsx_runtime.jsx)(sm, {size:16}), readOnly:a, children:(0,require$react_SLASH_jsx_runtime.jsx)("select", {id:l, title:n || o, className:cue("input"), disabled:a, onChange:c => {
  e(JSON.parse(c.target.value).value);
}, value:JSON.stringify({value:s}), children:t.options.map(c => (0,require$react_SLASH_jsx_runtime.jsx)("option", {label:c.label, value:JSON.stringify({value:c.value})}, c.label + JSON.stringify(c.value)))})});
re();
var due = Rt("Input", Uc), hue = ({field:t, onChange:e, readOnly:n, value:r, name:i, label:s, labelIcon:o, Label:a, id:l}) => (0,require$react_SLASH_jsx_runtime.jsx)(a, {label:s || i, icon:o || (0,require$react_SLASH_jsx_runtime.jsx)(Xv, {size:16}), readOnly:n, children:(0,require$react_SLASH_jsx_runtime.jsx)("textarea", {id:l, className:due("input"), autoComplete:"off", name:i, value:typeof r > "u" ? "" : r, onChange:c => e(c.currentTarget.value), readOnly:n, tabIndex:n ? -1 : void 0, rows:5, placeholder:t.type === 
"textarea" ? t.placeholder : void 0})});
re();
re();
var fue = {ObjectField:"_ObjectField_1ua3y_5", "ObjectField-fieldset":"_ObjectField-fieldset_1ua3y_13"}, WE = Rt("ObjectField", fue), pue = ({field:t, onChange:e, value:n, name:r, label:i, labelIcon:s, Label:o, readOnly:a, id:l}) => {
  const {readOnlyFields:c, localName:u = r} = lD();
  if (t.type !== "object" || !t.objectFields) {
    return null;
  }
  const h = n || {};
  return (0,require$react_SLASH_jsx_runtime.jsx)(o, {label:i || r, icon:s || (0,require$react_SLASH_jsx_runtime.jsx)(Tce, {size:16}), el:"div", readOnly:a, children:(0,require$react_SLASH_jsx_runtime.jsx)("div", {className:WE(), children:(0,require$react_SLASH_jsx_runtime.jsx)("fieldset", {className:WE("fieldset"), children:Object.keys(t.objectFields).map(f => {
    const p = t.objectFields[f], g = `${u}.${f}`, m = a || c[g], b = p.label || f;
    return (0,require$react_SLASH_jsx_runtime.jsx)(cD, {name:u || l, subName:f, readOnlyFields:c, children:(0,require$react_SLASH_jsx_runtime.jsx)(om, {name:g, label:g, id:`${l}_${f}`, readOnly:m, field:ve(K({}, p), {label:b}), value:h[f], onChange:(x, w) => {
      e(ve(K({}, h), {[f]:x}), w);
    }})}, g);
  })})})});
};
re();
var Zv = () => {
  if (typeof default$$require$react.default.useId < "u") {
    return default$$require$react.default.useId();
  }
  const [t] = (0,require$react.useState)(vi());
  return t;
}, Jf = Rt("Input", Uc), gue = Rt("InputWrapper", Uc), mue = ({children:t, icon:e, label:n, el:r = "label", readOnly:i, className:s}) => (0,require$react_SLASH_jsx_runtime.jsxs)(r, {className:s, children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:Jf("label"), children:[e ? (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:Jf("labelIcon"), children:e}) : (0,require$react_SLASH_jsx_runtime.jsx)(require$react_SLASH_jsx_runtime.Fragment, {}), n, i && (0,require$react_SLASH_jsx_runtime.jsx)("div", 
{className:Jf("disabledIcon"), title:"Read-only", children:(0,require$react_SLASH_jsx_runtime.jsx)(Pce, {size:"12"})})]}), t]}), bue = ({children:t, icon:e, label:n, el:r = "label", readOnly:i}) => {
  const s = Be(a => a.overrides), o = (0,require$react.useMemo)(() => s.fieldLabel || mue, [s]);
  return n ? (0,require$react_SLASH_jsx_runtime.jsx)(o, {label:n, icon:e, className:Jf({readOnly:i}), readOnly:i, el:r, children:t}) : (0,require$react_SLASH_jsx_runtime.jsx)(require$react_SLASH_jsx_runtime.Fragment, {children:t});
}, Gs = {array:eue, external:aue, object:pue, select:uue, textarea:hue, radio:lue, text:zE, number:zE};
function yue(t) {
  var e;
  const n = Be(T => T.dispatch), r = Be(T => T.overrides), i = Be(T => {
    var I;
    return (I = T.selectedItem) == null ? void 0 : I.readOnly;
  }), s = (0,require$react.useContext)(dg), {id:o, Label:a = bue} = t, l = t.field, c = l.label, u = l.labelIcon, h = Zv(), f = o || h, p = (0,require$react.useMemo)(() => {
    var T, I, _, N, E, C, k, A;
    return ve(K({}, r.fieldTypes), {array:((T = r.fieldTypes) == null ? void 0 : T.array) || Gs.array, external:((I = r.fieldTypes) == null ? void 0 : I.external) || Gs.external, object:((_ = r.fieldTypes) == null ? void 0 : _.object) || Gs.object, select:((N = r.fieldTypes) == null ? void 0 : N.select) || Gs.select, textarea:((E = r.fieldTypes) == null ? void 0 : E.textarea) || Gs.textarea, radio:((C = r.fieldTypes) == null ? void 0 : C.radio) || Gs.radio, text:((k = r.fieldTypes) == null ? void 0 : 
    k.text) || Gs.text, number:((A = r.fieldTypes) == null ? void 0 : A.number) || Gs.number});
  }, [r]), g = (0,require$react.useMemo)(() => ve(K({}, t), {field:l, label:c, labelIcon:u, Label:a, id:f}), [t, l, c, u, a, f]), m = (0,require$react.useCallback)(T => {
    g.name && (T.target.nodeName === "INPUT" || T.target.nodeName === "TEXTAREA") && (T.stopPropagation(), n({type:"setUi", ui:{field:{focus:g.name}}}));
  }, [g.name]), b = (0,require$react.useCallback)(T => {
    "name" in T.target && n({type:"setUi", ui:{field:{focus:null}}});
  }, []);
  let x = (0,require$react.useMemo)(() => l.type !== "custom" && l.type !== "slot" ? Gs[l.type] : T => null, [l.type]), w = (0,require$react.useMemo)(() => {
    if (l.type === "custom") {
      return l.render ? l.render : null;
    }
    if (l.type !== "slot") {
      return p[l.type];
    }
  }, [l.type, p]);
  const {visible:v = !0} = t.field;
  if (!v || l.type === "slot") {
    return null;
  }
  if (!w) {
    throw new Error(`Field type for ${l.type} did not exist.`);
  }
  return (0,require$react_SLASH_jsx_runtime.jsx)(dg.Provider, {value:{readOnlyFields:s.readOnlyFields || i || {}, localName:(e = s.localName) != null ? e : g.name}, children:(0,require$react_SLASH_jsx_runtime.jsx)("div", {className:gue(), onFocus:m, onBlur:b, onClick:T => {
    T.stopPropagation();
  }, children:(0,require$react_SLASH_jsx_runtime.jsx)(w, ve(K({}, g), {children:(0,require$react_SLASH_jsx_runtime.jsx)(x, K({}, g))}))})});
}
function om(t) {
  const e = Be(l => l.state.ui.field.focus === t.name), {value:n, onChange:r} = t, [i, s] = (0,require$react.useState)(n), o = (0,require$react.useCallback)((l, c) => {
    s(l), r(l, c);
  }, [r]);
  (0,require$react.useEffect)(() => {
    e || s(n);
  }, [n]), (0,require$react.useEffect)(() => {
    e || n !== i && s(n);
  }, [e, n, i]);
  const a = {value:i, onChange:o};
  return (0,require$react_SLASH_jsx_runtime.jsx)(yue, K(K({}, t), a));
}
re();
re();
re();
re();
var xue = {DraggableComponent:"_DraggableComponent_1vaqy_1", "DraggableComponent-overlayWrapper":"_DraggableComponent-overlayWrapper_1vaqy_12", "DraggableComponent-overlay":"_DraggableComponent-overlay_1vaqy_12", "DraggableComponent-loadingOverlay":"_DraggableComponent-loadingOverlay_1vaqy_34", "DraggableComponent--hover":"_DraggableComponent--hover_1vaqy_50", "DraggableComponent--isSelected":"_DraggableComponent--isSelected_1vaqy_57", "DraggableComponent-actionsOverlay":"_DraggableComponent-actionsOverlay_1vaqy_71", 
"DraggableComponent-actions":"_DraggableComponent-actions_1vaqy_71"};
re();
function jE(t) {
  let e = {x:0, y:0}, n = t;
  for (; n && n !== document.documentElement;) {
    const r = n.parentElement;
    r && (e.x += r.scrollLeft, e.y += r.scrollTop), n = r;
  }
  return e;
}
re();
var Wc = (0,require$react.createContext)(null), bi = (0,require$react.createContext)(ch(() => ({zoneDepthIndex:{}, nextZoneDepthIndex:{}, areaDepthIndex:{}, nextAreaDepthIndex:{}, draggedItem:null, previewIndex:{}, enabledIndex:{}, hoveringComponent:null}))), vue = ({children:t, store:e}) => (0,require$react_SLASH_jsx_runtime.jsx)(bi.Provider, {value:e, children:t}), Ud = ({children:t, value:e}) => {
  const n = Be(s => s.dispatch), r = (0,require$react.useCallback)(s => {
    n({type:"registerZone", zone:s});
  }, [n]), i = (0,require$react.useMemo)(() => K({registerZone:r}, e), [e]);
  return (0,require$react_SLASH_jsx_runtime.jsx)(require$react_SLASH_jsx_runtime.Fragment, {children:i && (0,require$react_SLASH_jsx_runtime.jsx)(Wc.Provider, {value:i, children:t})});
};
re();
function wue(t) {
  let e = new DOMMatrixReadOnly(), n = t.parentElement;
  for (; n && n !== document.documentElement;) {
    const r = getComputedStyle(n).transform;
    r && r !== "none" && (e = (new DOMMatrixReadOnly(r)).multiply(e)), n = n.parentElement;
  }
  return {scaleX:e.a, scaleY:e.d};
}
re();
function Qa(t, e) {
  const n = (0,require$react.useContext)(t);
  if (!n) {
    throw new Error("useContextStore must be used inside context");
  }
  return K1(n, xr(e));
}
re();
var dD = (t, e = []) => {
  const n = oi();
  return (0,require$react.useCallback)(() => {
    let r = () => {
    };
    const i = o => {
      o ? t(!1) : (setTimeout(() => {
        t(!0);
      }, 0), r && r());
    }, s = n.getState().state.ui.isDragging;
    return i(s), s && (r = n.subscribe(o => o.state.ui.isDragging, o => {
      i(o);
    })), r;
  }, [n, ...e]);
}, kl = Rt("DraggableComponent", xue), hD = 8, _ue = hD * 6.5, Sue = -44, VE = hD, kue = ({label:t, children:e, parentAction:n}) => (0,require$react_SLASH_jsx_runtime.jsxs)(ts, {children:[(0,require$react_SLASH_jsx_runtime.jsxs)(ts.Group, {children:[n, t && (0,require$react_SLASH_jsx_runtime.jsx)(ts.Label, {label:t})]}), (0,require$react_SLASH_jsx_runtime.jsx)(ts.Group, {children:e})]}), Eue = ({children:t}) => (0,require$react_SLASH_jsx_runtime.jsx)(require$react_SLASH_jsx_runtime.Fragment, {children:t}), 
Tue = ({children:t, depth:e, componentType:n, id:r, index:i, zoneCompound:s, isLoading:o = !1, isSelected:a = !1, debug:l, label:c, autoDragAxis:u, userDragAxis:h, inDroppableZone:f = !0}) => {
  const p = Be(fe => {
    var Oe;
    return ((Oe = fe.selectedItem) == null ? void 0 : Oe.props.id) === r ? fe.zoomConfig.zoom : 1;
  }), g = Be(fe => fe.overrides), m = Be(fe => fe.dispatch), b = Be(fe => fe.iframe), x = (0,require$react.useContext)(Wc), [w, v] = (0,require$react.useState)({}), T = (0,require$react.useCallback)((fe, Oe) => {
    var We;
    (We = x == null ? void 0 : x.registerLocalZone) == null || We.call(x, fe, Oe), v(rt => ve(K({}, rt), {[fe]:Oe}));
  }, [v]), I = (0,require$react.useCallback)(fe => {
    var Oe;
    (Oe = x == null ? void 0 : x.unregisterLocalZone) == null || Oe.call(x, fe), v(We => {
      const rt = K({}, We);
      return delete rt[fe], rt;
    });
  }, [v]), _ = Object.values(w).filter(Boolean).length > 0, N = Be(xr(fe => {
    var Oe;
    return (Oe = fe.state.indexes.nodes[r]) == null ? void 0 : Oe.path;
  })), E = Be(xr(fe => {
    const Oe = is({index:i, zone:s}, fe.state);
    return fe.permissions.getPermissions({item:Oe});
  })), C = (0,require$react.useContext)(bi), [k, A] = (0,require$react.useState)(h || u), P = (0,require$react.useMemo)(() => aD(k), [k]), {ref:W, isDragging:F, sortable:B} = WR({id:r, index:i, group:s, type:"component", data:{areaId:x == null ? void 0 : x.areaId, zone:s, index:i, componentType:n, containsActiveZone:_, depth:e, path:N || [], inDroppableZone:f}, collisionPriority:e, collisionDetector:P, transition:{duration:200, easing:"cubic-bezier(0.2, 0, 0, 1)"}, feedback:"clone"});
  (0,require$react.useEffect)(() => {
    const fe = C.getState().enabledIndex[s];
    B.droppable.disabled = !fe, B.draggable.disabled = !E.drag;
    const Oe = C.subscribe(We => {
      B.droppable.disabled = !We.enabledIndex[s];
    });
    return z.current && !E.drag ? (z.current.setAttribute("data-puck-disabled", ""), () => {
      var We;
      (We = z.current) == null || We.removeAttribute("data-puck-disabled"), Oe();
    }) : Oe;
  }, [E.drag, s]);
  const z = (0,require$react.useRef)(null), j = (0,require$react.useCallback)(fe => {
    W(fe), fe && (z.current = fe);
  }, [W]), [V, ne] = (0,require$react.useState)();
  (0,require$react.useEffect)(() => {
    var fe, Oe, We;
    ne(b.enabled ? (fe = z.current) == null ? void 0 : fe.ownerDocument.body : (We = (Oe = z.current) == null ? void 0 : Oe.closest("[data-puck-preview]")) != null ? We : document.body);
  }, [b.enabled, z.current]);
  const D = (0,require$react.useCallback)(() => {
    var fe, Oe, We;
    if (!z.current) {
      return;
    }
    const rt = z.current.getBoundingClientRect(), st = jE(z.current), ft = b.enabled ? null : (fe = z.current) == null ? void 0 : fe.closest("[data-puck-preview]"), St = ft == null ? void 0 : ft.getBoundingClientRect(), ht = ft ? jE(ft) : {x:0, y:0}, xe = {x:st.x - ht.x - ((Oe = St == null ? void 0 : St.left) != null ? Oe : 0), y:st.y - ht.y - ((We = St == null ? void 0 : St.top) != null ? We : 0)}, de = {height:z.current.offsetHeight, width:z.current.offsetWidth}, qe = wue(z.current);
    return {left:`${(rt.left + xe.x) / qe.scaleX}px`, top:`${(rt.top + xe.y) / qe.scaleY}px`, height:`${de.height}px`, width:`${de.width}px`};
  }, [z.current]), [ie, ee] = (0,require$react.useState)(), M = (0,require$react.useCallback)(() => {
    ee(D());
  }, [z.current, b]);
  (0,require$react.useEffect)(() => {
    if (z.current) {
      const fe = new ResizeObserver(M);
      return fe.observe(z.current), () => {
        fe.disconnect();
      };
    }
  }, [z.current]);
  const X = Be(fe => fe.nodes.registerNode), ge = (0,require$react.useCallback)(() => {
    ue(!1);
  }, []), me = (0,require$react.useCallback)(() => {
    ue(!0);
  }, []);
  (0,require$react.useEffect)(() => {
    var fe;
    return X(r, {methods:{sync:M, showOverlay:me, hideOverlay:ge}, element:(fe = z.current) != null ? fe : null}), () => {
      X(r, {methods:{sync:() => null, hideOverlay:() => null, showOverlay:() => null}, element:null});
    };
  }, [r, s, i, n, M]);
  const te = (0,require$react.useMemo)(() => g.actionBar || kue, [g.actionBar]), q = (0,require$react.useMemo)(() => g.componentOverlay || Eue, [g.componentOverlay]), R = (0,require$react.useCallback)(fe => {
    fe.target.closest("[data-puck-overlay-portal]") || fe.stopPropagation(), m({type:"setUi", ui:{itemSelector:{index:i, zone:s}}});
  }, [i, s, r]), $ = oi(), G = (0,require$react.useCallback)(() => {
    const {nodes:fe, zones:Oe} = $.getState().state.indexes, We = fe[r], rt = We != null && We.parentId ? fe[We == null ? void 0 : We.parentId] : null;
    if (!rt || !We.parentId) {
      return;
    }
    const st = `${rt.parentId}:${rt.zone}`, ft = Oe[st].contentIds.indexOf(We.parentId);
    m({type:"setUi", ui:{itemSelector:{zone:st, index:ft}}});
  }, [x, N]), J = (0,require$react.useCallback)(() => {
    m({type:"duplicate", sourceIndex:i, sourceZone:s});
  }, [i, s]), U = (0,require$react.useCallback)(() => {
    m({type:"remove", index:i, zone:s});
  }, [i, s]), [le, be] = (0,require$react.useState)(!1), je = Qa(bi, fe => fe.hoveringComponent === r);
  (0,require$react.useEffect)(() => {
    if (!z.current) {
      return;
    }
    const fe = z.current, Oe = rt => {
      const st = !!C.getState().draggedItem;
      be(st ? !!F : !0), rt.stopPropagation();
    }, We = rt => {
      rt.stopPropagation(), be(!1);
    };
    return fe.setAttribute("data-puck-component", r), fe.setAttribute("data-puck-dnd", r), fe.style.position = "relative", fe.addEventListener("click", R), fe.addEventListener("mouseover", Oe), fe.addEventListener("mouseout", We), () => {
      fe.removeAttribute("data-puck-component"), fe.removeAttribute("data-puck-dnd"), fe.removeEventListener("click", R), fe.removeEventListener("mouseover", Oe), fe.removeEventListener("mouseout", We);
    };
  }, [z.current, R, _, s, r, F, f]);
  const [Ae, ue] = (0,require$react.useState)(!1), [Le, $e] = (0,require$react.useState)(!0), [Ye, Me] = (0,require$react.useTransition)();
  (0,require$react.useEffect)(() => {
    Me(() => {
      le || je || a ? (M(), ue(!0), it(!1)) : ue(!1);
    });
  }, [le, je, a, b]);
  const [Xe, it] = (0,require$react.useState)(!1), se = dD(fe => {
    fe ? Me(() => {
      M(), $e(!0);
    }) : $e(!1);
  });
  (0,require$react.useEffect)(() => {
    F && it(!0);
  }, [F]), (0,require$react.useEffect)(() => {
    if (Xe) {
      return se();
    }
  }, [Xe, se]);
  const oe = (0,require$react.useCallback)(fe => {
    if (fe && fe.ownerDocument.defaultView) {
      const We = fe.getBoundingClientRect(), st = We.x < 0, St = We.y < 0;
      st && (fe.style.transformOrigin = "left top", fe.style.left = "0px"), St && (fe.style.top = "12px", st || (fe.style.transformOrigin = "right top"));
    }
  }, [p]);
  (0,require$react.useEffect)(() => {
    if (h) {
      A(h);
      return;
    }
    if (z.current) {
      const fe = window.getComputedStyle(z.current);
      if (fe.display === "inline" || fe.display === "inline-block") {
        A("x");
        return;
      }
    }
    A(u);
  }, [z, h, u]);
  const we = (0,require$react.useMemo)(() => (x == null ? void 0 : x.areaId) && (x == null ? void 0 : x.areaId) !== "root" && (0,require$react_SLASH_jsx_runtime.jsx)(ts.Action, {onClick:G, label:"Select parent", children:(0,require$react_SLASH_jsx_runtime.jsx)(Ece, {size:16})}), [x == null ? void 0 : x.areaId]), ke = (0,require$react.useMemo)(() => ve(K({}, x), {areaId:r, zoneCompound:s, index:i, depth:e + 1, registerLocalZone:T, unregisterLocalZone:I}), [x, r, s, i, e, T, I]);
  return (0,require$react_SLASH_jsx_runtime.jsxs)(Ud, {value:ke, children:[Le && Ae && (0,require$react_dom.createPortal)((0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:kl({isSelected:a, isDragging:F, hover:le || je}), style:K({}, ie), "data-puck-overlay":!0, children:[l, o && (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:kl("loadingOverlay"), children:(0,require$react_SLASH_jsx_runtime.jsx)(dl, {})}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:kl("actionsOverlay"), 
  style:{top:_ue / p}, children:(0,require$react_SLASH_jsx_runtime.jsx)("div", {className:kl("actions"), style:{transform:`scale(${1 / p}`, top:Sue / p, right:0, paddingLeft:VE, paddingRight:VE}, ref:oe, children:(0,require$react_SLASH_jsx_runtime.jsxs)(te, {parentAction:we, label:c, children:[E.duplicate && (0,require$react_SLASH_jsx_runtime.jsx)(ts.Action, {onClick:J, label:"Duplicate", children:(0,require$react_SLASH_jsx_runtime.jsx)(tD, {size:16})}), E.delete && (0,require$react_SLASH_jsx_runtime.jsx)(ts.Action, 
  {onClick:U, label:"Delete", children:(0,require$react_SLASH_jsx_runtime.jsx)(rD, {size:16})})]})})}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:kl("overlayWrapper"), children:(0,require$react_SLASH_jsx_runtime.jsx)(q, {componentId:r, componentType:n, hover:le, isSelected:a, children:(0,require$react_SLASH_jsx_runtime.jsx)("div", {className:kl("overlay")})})})]}), V || document.body), t(j)]});
};
re();
var Cue = {DropZone:"_DropZone_1i2sv_1", "DropZone--hasChildren":"_DropZone--hasChildren_1i2sv_11", "DropZone--isAreaSelected":"_DropZone--isAreaSelected_1i2sv_24", "DropZone--hoveringOverArea":"_DropZone--hoveringOverArea_1i2sv_25", "DropZone--isRootZone":"_DropZone--isRootZone_1i2sv_25", "DropZone--isDestination":"_DropZone--isDestination_1i2sv_35", "DropZone-item":"_DropZone-item_1i2sv_47", "DropZone-hitbox":"_DropZone-hitbox_1i2sv_51", "DropZone--isEnabled":"_DropZone--isEnabled_1i2sv_59", "DropZone--isAnimating":"_DropZone--isAnimating_1i2sv_68"};
re();
re();
var fD = {Drawer:"_Drawer_pl7z0_1", "Drawer-draggable":"_Drawer-draggable_pl7z0_8", "Drawer-draggableBg":"_Drawer-draggableBg_pl7z0_12", "DrawerItem-draggable":"_DrawerItem-draggable_pl7z0_22", "DrawerItem--disabled":"_DrawerItem--disabled_pl7z0_35", DrawerItem:"_DrawerItem_pl7z0_22", "Drawer--isDraggingFrom":"_Drawer--isDraggingFrom_pl7z0_45", "DrawerItem-name":"_DrawerItem-name_pl7z0_63"};
re();
re();
re();
function Aue(t, e) {
  const n = setTimeout(t, e);
  return () => clearTimeout(n);
}
function Nue(t, e) {
  const n = () => performance.now();
  let r, i = 0;
  return function(...s) {
    const o = n(), a = this;
    o - i >= e ? (t.apply(a, s), i = o) : (r == null || r(), r = Aue(() => {
      t.apply(a, s), i = n();
    }, e - (o - i)));
  };
}
re();
var wc = () => {
  if (typeof window > "u") {
    return;
  }
  let t = document.querySelector("#preview-frame");
  return (t == null ? void 0 : t.tagName) === "IFRAME" ? t.contentDocument || document : (t == null ? void 0 : t.ownerDocument) || document;
};
re();
var Iue = class {
  constructor(t, e) {
    this.scaleFactor = 1, this.frameEl = null, this.frameRect = null;
    var n;
    this.target = t, this.original = e, this.frameEl = document.querySelector("iframe#preview-frame"), this.frameEl && (this.frameRect = this.frameEl.getBoundingClientRect(), this.scaleFactor = this.frameRect.width / (((n = this.frameEl.contentWindow) == null ? void 0 : n.innerWidth) || 1));
  }
  get x() {
    return this.original.x;
  }
  get y() {
    return this.original.y;
  }
  get global() {
    return document !== this.target.ownerDocument && this.frameRect ? {x:this.x * this.scaleFactor + this.frameRect.left, y:this.y * this.scaleFactor + this.frameRect.top} : this.original;
  }
  get frame() {
    return document === this.target.ownerDocument && this.frameRect ? {x:(this.x - this.frameRect.left) / this.scaleFactor, y:(this.y - this.frameRect.top) / this.scaleFactor} : this.original;
  }
};
re();
var Oue = typeof PointerEvent < "u" ? PointerEvent : Event, pD = class extends Oue {
  constructor(t, e) {
    super(t, e), this._originalTarget = null, this.originalTarget = e.originalTarget;
  }
  set originalTarget(t) {
    this._originalTarget = t;
  }
  get originalTarget() {
    return this._originalTarget;
  }
}, Pue = t => t.sort((e, n) => {
  const r = e.data, i = n.data;
  return r.depth > i.depth ? 1 : i.depth > r.depth ? -1 : 0;
}), Rue = t => {
  let e = t == null ? void 0 : t.id;
  if (!t) {
    return null;
  }
  if (t.type === "component") {
    const n = t.data;
    n.containsActiveZone ? e = null : e = n.zone;
  } else if (t.type === "void") {
    return "void";
  }
  return e;
}, _f = 6, Due = (t, e) => {
  const n = [];
  let r = t.target.ownerDocument.elementsFromPoint(t.x, t.y);
  const i = r.find(o => o.getAttribute("data-puck-preview")), s = r.find(o => o.getAttribute("data-puck-drawer"));
  if (s && (r = [s]), i) {
    const o = wc();
    o && (r = o.elementsFromPoint(t.frame.x, t.frame.y));
  }
  if (r) {
    for (let o = 0; o < r.length; o++) {
      const a = r[o], l = a.getAttribute("data-puck-dropzone"), c = a.getAttribute("data-puck-dnd"), u = a.hasAttribute("data-puck-dnd-void");
      if ((l || c) && !u) {
        const h = a.getBoundingClientRect(), f = {left:h.left + _f, right:h.right - _f, top:h.top + _f, bottom:h.bottom - _f};
        if (t.frame.x < f.left || t.frame.x > f.right || t.frame.y > f.bottom || t.frame.y < f.top) {
          continue;
        }
      }
      if (l) {
        const h = e.registry.droppables.get(l);
        h && n.push(h);
      }
      if (c) {
        const h = e.registry.droppables.get(c);
        h && n.push(h);
      }
    }
  }
  return n;
}, Lue = (t, e) => {
  var n;
  const r = Due(t, e);
  if (r.length > 0) {
    const i = Pue(r), s = e.dragOperation.source, o = i.findIndex(g => g.id === (s == null ? void 0 : s.id)), a = s == null ? void 0 : s.id;
    let l = [...i];
    a && o > -1 && l.splice(o, 1), l = l.filter(g => {
      const m = g.data;
      if (a && o > -1 && m.path.indexOf(a) > -1) {
        return !1;
      }
      if (g.type === "dropzone") {
        const b = g.data;
        if (!b.isDroppableTarget || b.areaId === a) {
          return !1;
        }
      } else if (g.type === "component" && !g.data.inDroppableZone) {
        return !1;
      }
      return !0;
    }), l.reverse();
    const c = l[0];
    if (!c) {
      return {zone:null, area:null};
    }
    const u = c.data, h = "containsActiveZone" in u, f = Rue(c), p = h && u.containsActiveZone ? l[0].id : (n = l[0]) == null ? void 0 : n.data.areaId;
    return {zone:f, area:p};
  }
  return {zone:Cr, area:Y1};
}, Mue = ({onChange:t}, e) => class extends vr {
  constructor(r, i) {
    super(r), !(typeof window > "u") && this.registerEffect(() => {
      const o = Nue(c => {
        const u = c instanceof pD && c.originalTarget || c.target, h = new Iue(u, {x:c.clientX, y:c.clientY});
        document.elementsFromPoint(h.global.x, h.global.y).some(g => g.id === e) && t(Lue(h, r), r);
      }, 50), a = c => {
        o(c);
      };
      return document.body.addEventListener("pointermove", a, {capture:!0}), () => {
        document.body.removeEventListener("pointermove", a, {capture:!0});
      };
    });
  }
};
re();
var Bue = (t, e, n, r) => Qn(void 0, null, function*() {
  const i = vi(t), s = {type:"insert", componentType:t, destinationIndex:n, destinationZone:e, id:i}, {state:o, dispatch:a, resolveComponentData:l} = r, c = qR(o, s, r);
  a(ve(K({}, s), {recordHistory:!0}));
  const u = {index:n, zone:e};
  a({type:"setUi", ui:{itemSelector:u}});
  const h = is(u, c);
  if (h) {
    const f = yield l(h, "insert");
    f.didChange && a({type:"replace", destinationZone:u.zone, destinationIndex:u.index, data:f.node});
  }
});
re();
function $ue(t) {
  function e(n) {
    return n ? n.getAttribute("dir") || e(n.parentElement) : "ltr";
  }
  return t ? e(t) : "ltr";
}
var gD = (0,require$react.createContext)({dragListeners:{}});
function Fue(t, e, n = []) {
  const {setDragListeners:r} = (0,require$react.useContext)(gD);
  (0,require$react.useEffect)(() => {
    r && r(i => ve(K({}, i), {[t]:[...(i[t] || []), e]}));
  }, n);
}
var zue = 100, Hue = t => {
  const e = (0,require$react.useRef)(null);
  return (0,require$react.useCallback)(n => {
    dx.setState({fallbackEnabled:!1});
    const r = vi();
    e.current = r, setTimeout(() => {
      e.current === r && (dx.setState({fallbackEnabled:!0}), n.collisionObserver.forceUpdate(!0));
    }, t);
  }, []);
}, Uue = ({children:t, disableAutoScroll:e}) => {
  const n = Be(v => v.dispatch), r = oi(), i = Zv(), s = (0,require$react.useRef)(null), o = Hue(100), [a] = (0,require$react.useState)(() => ch(() => ({zoneDepthIndex:{}, nextZoneDepthIndex:{}, areaDepthIndex:{}, nextAreaDepthIndex:{}, draggedItem:null, previewIndex:{}, enabledIndex:{}, hoveringComponent:null}))), l = (0,require$react.useCallback)((v, T) => {
    const {zoneDepthIndex:I = {}, areaDepthIndex:_ = {}} = a.getState() || {}, N = Object.keys(I).length > 0, E = Object.keys(_).length > 0;
    let C = !1, k = !1;
    return (v.zone && !I[v.zone] || !v.zone && N) && (C = !0), (v.area && !_[v.area] || !v.area && E) && (k = !0), {zoneChanged:C, areaChanged:k};
  }, [a]), c = (0,require$react.useCallback)((v, T) => {
    const {zoneChanged:I, areaChanged:_} = l(v, i);
    !I && !_ || (a.setState({zoneDepthIndex:v.zone ? {[v.zone]:!0} : {}, areaDepthIndex:v.area ? {[v.area]:!0} : {}}), o(T), setTimeout(() => {
      T.collisionObserver.forceUpdate(!0);
    }, 50), s.current = null);
  }, [a]), u = Ole(c, zue), h = () => {
    u.cancel(), s.current = null;
  };
  (0,require$react.useEffect)(() => {
  }, []);
  const [f] = (0,require$react.useState)(() => [...(e ? Ga.plugins.filter(v => v !== $v) : Ga.plugins), Mue({onChange:(v, T) => {
    const I = a.getState(), {zoneChanged:_, areaChanged:N} = l(v, i), E = T.dragOperation.status.dragging;
    if (N || _) {
      let C = {}, k = {};
      v.zone && (C = {[v.zone]:!0}), v.area && (k = {[v.area]:!0}), a.setState({nextZoneDepthIndex:C, nextAreaDepthIndex:k});
    }
    if (v.zone !== "void" && (I != null && I.zoneDepthIndex.void)) {
      c(v, T);
      return;
    }
    if (N) {
      if (E) {
        const C = s.current;
        C && C.area === v.area && C.zone === v.zone || (h(), u(v, T), s.current = v);
      } else {
        h(), c(v, T);
      }
      return;
    }
    _ && c(v, T), h();
  }}, i)]), p = sD(), [g, m] = (0,require$react.useState)({}), b = (0,require$react.useRef)(null), x = (0,require$react.useRef)(void 0), w = (0,require$react.useMemo)(() => ({mode:"edit", areaId:"root", depth:0}), []);
  return (0,require$react_SLASH_jsx_runtime.jsx)("div", {id:i, children:(0,require$react_SLASH_jsx_runtime.jsx)(gD.Provider, {value:{dragListeners:g, setDragListeners:m}, children:(0,require$react_SLASH_jsx_runtime.jsx)(wR, {plugins:f, sensors:p, onDragEnd:(v, T) => {
    var I, _;
    const N = (I = wc()) == null ? void 0 : I.querySelector("[data-puck-entry]");
    N == null || N.removeAttribute("data-puck-dragging");
    const {source:E, target:C} = v.operation;
    if (!E) {
      a.setState({draggedItem:null});
      return;
    }
    const {zone:k, index:A} = E.data, {previewIndex:P = {}} = a.getState() || {}, W = ((_ = P[k]) == null ? void 0 : _.props.id) === E.id ? P[k] : null, F = () => {
      var z, j;
      if (a.setState({draggedItem:null}), v.canceled || (C == null ? void 0 : C.type) === "void") {
        a.setState({previewIndex:{}}), (z = g.dragend) == null || z.forEach(V => {
          V(v, T);
        }), n({type:"setUi", ui:{itemSelector:null, isDragging:!1}});
        return;
      }
      W && (a.setState({previewIndex:{}}), W.type === "insert" ? Bue(W.componentType, W.zone, W.index, r.getState()) : x.current && n({type:"move", sourceIndex:x.current.index, sourceZone:x.current.zone, destinationIndex:W.index, destinationZone:W.zone, recordHistory:!1})), n({type:"setUi", ui:{itemSelector:{index:A, zone:k}, isDragging:!1}, recordHistory:!0}), (j = g.dragend) == null || j.forEach(V => {
        V(v, T);
      });
    };
    let B;
    B = si(() => {
      E.status === "idle" && (F(), B == null || B());
    });
  }, onDragOver:(v, T) => {
    var I, _, N, E;
    if (v.preventDefault(), !((I = a.getState()) == null ? void 0 : I.draggedItem)) {
      return;
    }
    h();
    const {source:k, target:A} = v.operation;
    if (!A || !k || A.type === "void") {
      return;
    }
    const [P] = k.id.split(":"), [W] = A.id.split(":"), F = k.data;
    let B = F.zone, z = F.index, j = "", V = 0;
    if (A.type === "component") {
      const D = A.data;
      j = D.zone, V = D.index;
      const ie = (_ = T.collisionObserver.collisions[0]) == null ? void 0 : _.data, ee = $ue(A.element), M = (ie == null ? void 0 : ie.direction) === "up" || ee === "ltr" && (ie == null ? void 0 : ie.direction) === "left" || ee === "rtl" && (ie == null ? void 0 : ie.direction) === "right" ? "before" : "after";
      V >= z && B === j && (V = V - 1), M === "after" && (V = V + 1);
    } else {
      j = A.id.toString(), V = 0;
    }
    const ne = ((N = r.getState().state.indexes.nodes[A.id]) == null ? void 0 : N.path) || [];
    if (!(W === P || ne.find(D => {
      const [ie] = D.split(":");
      return ie === P;
    }))) {
      if (b.current === "new") {
        a.setState({previewIndex:{[j]:{componentType:F.componentType, type:"insert", index:V, zone:j, element:k.element, props:{id:k.id.toString()}}}});
      } else {
        x.current || (x.current = {zone:F.zone, index:F.index});
        const D = is(x.current, r.getState().state);
        D && a.setState({previewIndex:{[j]:{componentType:F.componentType, type:"move", index:V, zone:j, props:D.props, element:k.element}}});
      }
      (E = g.dragover) == null || E.forEach(D => {
        D(v, T);
      });
    }
  }, onDragStart:(v, T) => {
    var I;
    const {source:_} = v.operation;
    if (_ && _.type !== "void") {
      const N = _.data, E = is({zone:N.zone, index:N.index}, r.getState().state);
      E && a.setState({previewIndex:{[N.zone]:{componentType:N.componentType, type:"move", index:N.index, zone:N.zone, props:E.props, element:_.element}}});
    }
    (I = g.dragstart) == null || I.forEach(N => {
      N(v, T);
    });
  }, onBeforeDragStart:v => {
    var T, I, _, N;
    const E = ((T = v.operation.source) == null ? void 0 : T.type) === "drawer";
    b.current = E ? "new" : "existing", x.current = void 0, a.setState({draggedItem:v.operation.source}), ((I = r.getState().selectedItem) == null ? void 0 : I.props.id) !== ((_ = v.operation.source) == null ? void 0 : _.id) ? n({type:"setUi", ui:{itemSelector:null, isDragging:!0}, recordHistory:!1}) : n({type:"setUi", ui:{isDragging:!0}, recordHistory:!1});
    const C = (N = wc()) == null ? void 0 : N.querySelector("[data-puck-entry]");
    C == null || C.setAttribute("data-puck-dragging", "true");
  }, children:(0,require$react_SLASH_jsx_runtime.jsx)(vue, {store:a, children:(0,require$react_SLASH_jsx_runtime.jsx)(Ud, {value:w, children:t})})})})});
}, Wue = ({children:t, disableAutoScroll:e}) => Be(r => r.status) === "LOADING" ? t : (0,require$react_SLASH_jsx_runtime.jsx)(Uue, {disableAutoScroll:e, children:t}), Zf = Rt("Drawer", fD), El = Rt("DrawerItem", fD), hx = ({children:t, name:e, label:n, dragRef:r, isDragDisabled:i}) => {
  const s = (0,require$react.useMemo)(() => t || (({children:o}) => (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:El("default"), children:o})), [t]);
  return (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:El({disabled:i}), ref:r, onMouseDown:o => o.preventDefault(), "data-testid":r ? `drawer-item:${e}` : "", "data-puck-drawer-item":!0, children:(0,require$react_SLASH_jsx_runtime.jsx)(s, {name:e, children:(0,require$react_SLASH_jsx_runtime.jsx)("div", {className:El("draggableWrapper"), children:(0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:El("draggable"), children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {className:El("name"), 
  children:n ?? e}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:El("icon"), children:(0,require$react_SLASH_jsx_runtime.jsx)(iD, {})})]})})})});
}, jue = ({children:t, name:e, label:n, id:r, isDragDisabled:i}) => {
  const {ref:s} = Bae({id:r, data:{componentType:e}, disabled:i, type:"drawer"});
  return (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:Zf("draggable"), children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {className:Zf("draggableBg"), children:(0,require$react_SLASH_jsx_runtime.jsx)(hx, {name:e, label:n, children:t})}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:Zf("draggableFg"), children:(0,require$react_SLASH_jsx_runtime.jsx)(hx, {name:e, label:n, dragRef:s, isDragDisabled:i, children:t})})]});
}, Vue = ({name:t, children:e, id:n, label:r, index:i, isDragDisabled:s}) => {
  const o = n || t, [a, l] = (0,require$react.useState)(vi(o));
  return typeof i < "u" && console.error("Warning: The `index` prop on Drawer.Item is deprecated and no longer required."), Fue("dragend", () => {
    l(vi(o));
  }, [o]), (0,require$react_SLASH_jsx_runtime.jsx)("div", {children:(0,require$react_SLASH_jsx_runtime.jsx)(jue, {name:t, label:r, id:a, isDragDisabled:s, children:e})}, a);
}, ew = ({children:t, droppableId:e, direction:n}) => {
  e && console.error("Warning: The `droppableId` prop on Drawer is deprecated and no longer required."), n && console.error("Warning: The `direction` prop on Drawer is deprecated and no longer required to achieve multi-directional dragging.");
  const r = Zv(), {ref:i} = PR({id:r, type:"void", collisionPriority:0});
  return (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:Zf(), ref:i, "data-puck-dnd":r, "data-puck-drawer":!0, "data-puck-dnd-void":!0, children:t});
};
ew.Item = Vue;
re();
var qE = (t, e) => t.getState().state.indexes.zones[e].contentIds.length, que = ({zoneCompound:t, userMinEmptyHeight:e, ref:n}) => {
  const r = oi(), [i, s] = (0,require$react.useState)(0), [o, a] = (0,require$react.useState)(!1), {draggedItem:l, isZone:c} = Qa(bi, f => {
    var p, g;
    return {draggedItem:((p = f.draggedItem) == null ? void 0 : p.data.zone) === t ? f.draggedItem : null, isZone:((g = f.draggedItem) == null ? void 0 : g.data.zone) === t};
  }), u = (0,require$react.useRef)(0), h = dD(f => {
    var p;
    if (f) {
      const g = qE(r, t);
      if (s(0), g || u.current === 0) {
        a(!1);
        return;
      }
      const m = r.getState().selectedItem, b = r.getState().state.indexes.zones, x = r.getState().nodes;
      (p = x.nodes[m == null ? void 0 : m.props.id]) == null || p.methods.hideOverlay(), setTimeout(() => {
        var w;
        (((w = b[t]) == null ? void 0 : w.contentIds) || []).forEach(T => {
          const I = x.nodes[T];
          I == null || I.methods.sync();
        }), m && setTimeout(() => {
          var T, I;
          (T = x.nodes[m.props.id]) == null || T.methods.sync(), (I = x.nodes[m.props.id]) == null || I.methods.showOverlay();
        }, 200), a(!1);
      }, 100);
    }
  }, [r, i, t]);
  return (0,require$react.useEffect)(() => {
    if (l && n.current && c) {
      const f = n.current.getBoundingClientRect();
      return u.current = qE(r, t), s(f.height), a(!0), h();
    }
  }, [n.current, l, h]), [i || e, o];
};
re();
function Yue(t, e) {
  typeof t == "function" ? t(e) : t && typeof t == "object" && "current" in t && (t.current = e);
}
function Gue(t, e) {
  t.forEach(n => {
    Yue(n, e);
  });
}
re();
re();
function Que(t, e) {
  const n = _R();
  return (0,require$react.useCallback)((...r) => Qn(this, null, function*() {
    return yield n == null ? void 0 : n.renderer.rendering, t(...r);
  }), [...e, n]);
}
var Kue = (t, e) => {
  const n = (0,require$react.useContext)(bi), r = Qa(bi, u => u.previewIndex[e]), i = Be(u => u.state.ui.isDragging), [s, o] = (0,require$react.useState)(t), [a, l] = (0,require$react.useState)(r), c = Que((u, h, f, p, g) => {
    f && !g || (h ? h.type === "insert" ? o(vc(u.filter(m => m !== h.props.id), h.index, h.props.id)) : o(vc(u.filter(m => m !== h.props.id), h.index, h.props.id)) : o(g ? u.filter(m => m !== p) : u), l(h));
  }, []);
  return (0,require$react.useEffect)(() => {
    var u;
    const h = n.getState(), f = (u = h.draggedItem) == null ? void 0 : u.id, p = Object.keys(h.previewIndex || {}).length > 0;
    c(t, r, i, f, p);
  }, [t, r, i]), [s, a];
};
re();
var Xue = "dynamic", Jue = "x", YE = "y", Zue = (t, e) => {
  const n = Be(o => o.status), [r, i] = (0,require$react.useState)(e || YE), s = (0,require$react.useCallback)(() => {
    if (t.current) {
      const o = window.getComputedStyle(t.current);
      o.display === "grid" ? i(Xue) : o.display === "flex" && o.flexDirection === "row" ? i(Jue) : i(YE);
    }
  }, [t.current]);
  return (0,require$react.useEffect)(() => {
    const o = () => {
      s();
    };
    return window.addEventListener("viewportchange", o), () => {
      window.removeEventListener("viewportchange", o);
    };
  }, []), (0,require$react.useEffect)(s, [n, e]), [r, s];
};
re();
var ede = ({componentId:t, zone:e}) => {
  const n = Be(s => s.config), r = Be(s => s.metadata), i = Be(xr(s => {
    var o, a;
    const l = s.state.indexes;
    return ((a = (o = l.zones[`${t}:${e}`]) == null ? void 0 : o.contentIds) != null ? a : []).map(u => l.nodes[u].flatData);
  }));
  return (0,require$react_SLASH_jsx_runtime.jsx)(Q1, {content:i, zone:e, config:n, metadata:r});
};
re();
re();
re();
var tde = (t, e = {}) => {
  if (!t) {
    return;
  }
  const {disableDrag:n = !1, disableDragOnFocus:r = !0} = e, i = a => {
    a.stopPropagation();
  };
  t.addEventListener("mouseover", i, {capture:!0});
  const s = () => {
    setTimeout(() => {
      t.addEventListener("pointerdown", i, {capture:!0});
    }, 200);
  }, o = () => {
    t.removeEventListener("pointerdown", i, {capture:!0});
  };
  return r ? (t.addEventListener("focus", s, {capture:!0}), t.addEventListener("blur", o, {capture:!0})) : n && t.addEventListener("pointerdown", i, {capture:!0}), t.setAttribute("data-puck-overlay-portal", "true"), () => {
    t.removeEventListener("mouseover", i, {capture:!0}), r ? (t.removeEventListener("focus", s, {capture:!0}), t.removeEventListener("blur", s, {capture:!0})) : n && t.removeEventListener("pointerdown", i, {capture:!0}), t.removeAttribute("data-puck-overlay-portal");
  };
};
re();
var nde = {InlineTextField:"_InlineTextField_1xph6_1"};
re();
function rde(t, e, n) {
  const r = e.split("."), i = K({}, t);
  let s = i;
  for (let o = 0; o < r.length; o++) {
    const [a, l] = r[o].replace("]", "").split("["), c = o === r.length - 1;
    if (l !== void 0) {
      Array.isArray(s[a]) || (s[a] = []);
      const u = Number(l);
      if (c) {
        s[a][u] = n;
        continue;
      }
      s[a][u] === void 0 && (s[a][u] = {}), s = s[a][u];
      continue;
    }
    if (c) {
      s[a] = n;
      continue;
    }
    s[a] === void 0 && (s[a] = {}), s = s[a];
  }
  return K(K({}, t), i);
}
re();
var mD = (t, e) => {
  const n = t.indexes.nodes[e];
  if (!n) {
    return;
  }
  const r = `${n.parentId}:${n.zone}`, i = t.indexes.zones[r].contentIds.indexOf(e);
  return {zone:r, index:i};
}, ide = Rt("InlineTextField", nde), sde = ({propPath:t, componentId:e, value:n, isReadOnly:r, opts:i = {}}) => {
  var s;
  const o = (0,require$react.useRef)(null), a = oi(), l = (s = i.disableLineBreaks) != null ? s : !1;
  (0,require$react.useEffect)(() => {
    const p = a.getState(), g = p.state.indexes.nodes[e].data;
    if (!p.getComponentConfig(g.type)) {
      throw new Error(`InlineTextField Error: No config defined for ${g.type}`);
    }
    if (o.current) {
      n !== o.current.innerText && o.current.replaceChildren(n);
      const b = tde(o.current), x = w => Qn(void 0, null, function*() {
        var v;
        const T = a.getState(), I = T.state.indexes.nodes[e], _ = `${I.parentId}:${I.zone}`, N = (v = T.state.indexes.zones[_]) == null ? void 0 : v.contentIds.indexOf(e);
        let E = w.target.innerText;
        l && (E = E.replaceAll(/\n/gm, ""));
        const C = rde(I.data.props, t, E), k = yield T.resolveComponentData(ve(K({}, I.data), {props:C}), "replace");
        T.dispatch({type:"replace", data:k.node, destinationIndex:N, destinationZone:_});
      });
      return o.current.addEventListener("input", x), () => {
        var w;
        (w = o.current) == null || w.removeEventListener("input", x), b == null || b();
      };
    }
  }, [a, o.current, n, l]);
  const [c, u] = (0,require$react.useState)(!1), [h, f] = (0,require$react.useState)(!1);
  return (0,require$react_SLASH_jsx_runtime.jsx)("span", {className:ide(), ref:o, contentEditable:c || h ? "plaintext-only" : "false", onClick:p => {
    p.preventDefault(), p.stopPropagation();
  }, onClickCapture:p => {
    p.preventDefault(), p.stopPropagation();
    const g = mD(a.getState().state, e);
    a.getState().setUi({itemSelector:g});
  }, onKeyDown:p => {
    p.stopPropagation(), (l && p.key === "Enter" || r) && p.preventDefault();
  }, onKeyUp:p => {
    p.stopPropagation(), p.preventDefault();
  }, onMouseOverCapture:() => u(!0), onMouseOutCapture:() => u(!1), onFocus:() => f(!0), onBlur:() => f(!1)});
}, J0 = (0,require$react.memo)(sde), ode = () => ({text:({value:t, componentId:e, field:n, propPath:r, isReadOnly:i}) => n.contentEditable ? (0,require$react_SLASH_jsx_runtime.jsx)(J0, {propPath:r, componentId:e, value:t, opts:{disableLineBreaks:!0}, isReadOnly:i}) : t, textarea:({value:t, componentId:e, field:n, propPath:r, isReadOnly:i}) => n.contentEditable ? (0,require$react_SLASH_jsx_runtime.jsx)(J0, {propPath:r, componentId:e, value:t, isReadOnly:i}) : t, custom:({value:t, componentId:e, field:n, 
propPath:r, isReadOnly:i}) => n.contentEditable && typeof t == "string" ? (0,require$react_SLASH_jsx_runtime.jsx)(J0, {propPath:r, componentId:e, value:t, isReadOnly:i}) : t}), ade = Rt("DropZone", Cue), fx = t => (0,require$react_SLASH_jsx_runtime.jsx)(bD, K({}, t)), lde = ({zoneCompound:t, componentId:e, index:n, dragAxis:r, collisionAxis:i, inDroppableZone:s}) => {
  var o, a;
  const l = Be(V => V.metadata), c = (0,require$react.useContext)(Wc), {depth:u = 1} = c ?? {}, h = (0,require$react.useContext)(bi), f = Be(xr(V => {
    var ne;
    return (ne = V.state.indexes.nodes[e]) == null ? void 0 : ne.flatData.props;
  })), p = Be(V => {
    var ne;
    return (ne = V.state.indexes.nodes[e]) == null ? void 0 : ne.data.type;
  }), g = Be(xr(V => {
    var ne;
    return (ne = V.state.indexes.nodes[e]) == null ? void 0 : ne.data.readOnly;
  })), m = oi(), b = (0,require$react.useMemo)(() => {
    if (f) {
      return ese({type:p, props:f});
    }
    const V = h.getState().previewIndex[t];
    return e === (V == null ? void 0 : V.props.id) ? {type:V.componentType, props:V.props, previewType:V.type, element:V.element} : null;
  }, [m, e, t, p, f]), x = Be(V => b != null && b.type ? V.config.components[b.type] : null), w = (0,require$react.useMemo)(() => ({renderDropZone:fx, isEditing:!0, dragRef:null, metadata:K(K({}, l), x == null ? void 0 : x.metadata)}), [l, x == null ? void 0 : x.metadata]), v = Be(V => V.overrides), T = Be(V => {
    var ne;
    return ((ne = V.componentState[e]) == null ? void 0 : ne.loadingCount) > 0;
  }), I = Be(V => {
    var ne;
    return ((ne = V.selectedItem) == null ? void 0 : ne.props.id) === e || !1;
  });
  let _ = (a = (o = x == null ? void 0 : x.label) != null ? o : b == null ? void 0 : b.type.toString()) != null ? a : "Component";
  const N = (0,require$react.useMemo)(() => function() {
    var ne;
    return b && "element" in b && b.element ? (0,require$react_SLASH_jsx_runtime.jsx)("div", {dangerouslySetInnerHTML:{__html:b.element.outerHTML}}) : (0,require$react_SLASH_jsx_runtime.jsx)(hx, {name:_, children:(ne = v.componentItem) != null ? ne : v.drawerItem});
  }, [e, _, v]), E = (0,require$react.useMemo)(() => ve(K(K({}, x == null ? void 0 : x.defaultProps), b == null ? void 0 : b.props), {puck:w, editMode:!0}), [x == null ? void 0 : x.defaultProps, b == null ? void 0 : b.props, w]), C = (0,require$react.useMemo)(() => {
    var V;
    return {type:(V = b == null ? void 0 : b.type) != null ? V : p, props:E};
  }, [b == null ? void 0 : b.type, p, E]), k = Be(V => V.config), A = Be(V => V.plugins), P = Be(V => V.fieldTransforms), W = (0,require$react.useMemo)(() => K(K(K(K({}, pP(fx, V => (0,require$react_SLASH_jsx_runtime.jsx)(ede, {componentId:e, zone:V.zone}))), ode()), A.reduce((V, ne) => K(K({}, V), ne.fieldTransforms), {})), P), [A, P]), F = fP(k, C, W, g, T);
  if (!b) {
    return;
  }
  let B = x ? x.render : () => (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{padding:48, textAlign:"center"}, children:["No configuration for ", b.type]}), z = b.type;
  const j = "previewType" in b ? b.previewType === "insert" : !1;
  return j && (B = N), (0,require$react_SLASH_jsx_runtime.jsx)(Tue, {id:e, componentType:z, zoneCompound:t, depth:u + 1, index:n, isLoading:T, isSelected:I, label:_, autoDragAxis:r, userDragAxis:i, inDroppableZone:s, children:V => x != null && x.inline && !j ? (0,require$react_SLASH_jsx_runtime.jsx)(require$react_SLASH_jsx_runtime.Fragment, {children:(0,require$react_SLASH_jsx_runtime.jsx)(B, ve(K({}, F), {puck:ve(K({}, F.puck), {dragRef:V})}))}) : (0,require$react_SLASH_jsx_runtime.jsx)("div", {ref:V, 
  children:(0,require$react_SLASH_jsx_runtime.jsx)(B, K({}, F))})});
}, cde = (0,require$react.memo)(lde), bD = (0,require$react.forwardRef)(function({zone:e, allow:n, disallow:r, style:i, className:s, minEmptyHeight:o = 128, collisionAxis:a}, l) {
  const c = (0,require$react.useContext)(Wc), u = oi(), {areaId:h, depth:f = 0, registerLocalZone:p, unregisterLocalZone:g} = c ?? {}, m = Be(xr(ie => {
    var ee;
    return h ? (ee = ie.state.indexes.nodes[h]) == null ? void 0 : ee.path : null;
  }));
  let b = Cr;
  h && e !== Cr && (b = `${h}:${e}`);
  const x = b === Cr || e === Cr || h === "root", w = Qa(bi, ie => ie.nextAreaDepthIndex[h || ""]), v = Be(xr(ie => {
    var ee;
    return (ee = ie.state.indexes.zones[b]) == null ? void 0 : ee.contentIds;
  })), T = Be(xr(ie => {
    var ee;
    return (ee = ie.state.indexes.zones[b]) == null ? void 0 : ee.type;
  }));
  (0,require$react.useEffect)(() => {
    (!T || T === "dropzone") && c != null && c.registerZone && (c == null || c.registerZone(b));
  }, [T, u]), (0,require$react.useEffect)(() => {
    T === "dropzone" && b !== Cr && console.warn("DropZones have been deprecated in favor of slot fields and will be removed in a future version of Puck. Please see the migration guide: https://www.puckeditor.com/docs/guides/migrations/dropzones-to-slots");
  }, [T]);
  const I = (0,require$react.useMemo)(() => v || [], [v]), _ = (0,require$react.useRef)(null), N = (0,require$react.useCallback)(ie => {
    if (!ie) {
      return !0;
    }
    if (r) {
      const ee = n || [];
      if ((r || []).filter(X => ee.indexOf(X) === -1).indexOf(ie) !== -1) {
        return !1;
      }
    } else if (n && n.indexOf(ie) === -1) {
      return !1;
    }
    return !0;
  }, [n, r]), E = Qa(bi, ie => {
    var ee;
    const M = (ee = ie.draggedItem) == null ? void 0 : ee.data.componentType;
    return N(M);
  }), C = w || x, k = Qa(bi, ie => {
    var ee;
    let M = !0;
    return M = (ee = ie.zoneDepthIndex[b]) != null ? ee : !1, M && (M = E), M;
  });
  (0,require$react.useEffect)(() => (p && p(b, E || k), () => {
    g && g(b);
  }), [E, k, b]);
  const [A, P] = Kue(I, b), W = k && (P ? A.length === 1 : A.length === 0), F = (0,require$react.useContext)(bi);
  (0,require$react.useEffect)(() => {
    const {enabledIndex:ie} = F.getState();
    F.setState({enabledIndex:ve(K({}, ie), {[b]:k})});
  }, [k, F, b]);
  const B = {id:b, collisionPriority:k ? f : 0, disabled:!W, collisionDetector:Kce, type:"dropzone", data:{areaId:h, depth:f, isDroppableTarget:E, path:m || []}}, {ref:z} = PR(B), j = Be(ie => (ie == null ? void 0 : ie.selectedItem) && h === (ie == null ? void 0 : ie.selectedItem.props.id)), [V] = Zue(_, a), [ne, D] = que({zoneCompound:b, userMinEmptyHeight:o, ref:_});
  return (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:`${ade({isRootZone:x, hoveringOverArea:C, isEnabled:k, isAreaSelected:j, hasChildren:I.length > 0, isAnimating:D})}${s ? ` ${s}` : ""}`, ref:ie => {
    Gue([_, z, l], ie);
  }, "data-testid":`dropzone:${b}`, "data-puck-dropzone":b, style:ve(K({}, i), {"--min-empty-height":`${ne}px`, backgroundColor:i == null ? void 0 : i.backgroundColor}), children:A.map((ie, ee) => (0,require$react_SLASH_jsx_runtime.jsx)(cde, {zoneCompound:b, componentId:ie, dragAxis:V, index:ee, collisionAxis:a, inDroppableZone:E}, ie))});
}), ude = ({config:t, item:e, metadata:n}) => {
  const r = t.components[e.type], i = Qg(t, e, o => (0,require$react_SLASH_jsx_runtime.jsx)(Q1, ve(K({}, o), {config:t, metadata:n}))), s = (0,require$react.useMemo)(() => ({areaId:i.id, depth:1}), [i]);
  return (0,require$react_SLASH_jsx_runtime.jsx)(Ud, {value:s, children:(0,require$react_SLASH_jsx_runtime.jsx)(r.render, ve(K({}, i), {puck:ve(K({}, i.puck), {renderDropZone:px, metadata:K(K({}, n), r.metadata)})}))}, i.id);
}, px = t => (0,require$react_SLASH_jsx_runtime.jsx)(yD, K({}, t)), yD = (0,require$react.forwardRef)(function({className:e, style:n, zone:r}, i) {
  const s = (0,require$react.useContext)(Wc), {areaId:o = "root"} = s || {}, {config:a, data:l, metadata:c} = (0,require$react.useContext)(mx);
  let u = `${o}:${r}`, h = (l == null ? void 0 : l.content) || [];
  return (0,require$react.useEffect)(() => {
    h || s != null && s.registerZone && (s == null || s.registerZone(u));
  }, [h]), !l || !a ? null : (u !== Cr && (h = hP(l, u).zones[u]), (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:e, style:n, ref:i, children:h.map(f => a.components[f.type] ? (0,require$react_SLASH_jsx_runtime.jsx)(ude, {config:a, item:f, metadata:c}, f.props.id) : null)}));
}), gx = t => (0,require$react_SLASH_jsx_runtime.jsx)(dde, K({}, t)), dde = (0,require$react.forwardRef)(function(e, n) {
  const r = (0,require$react.useContext)(Wc);
  return (r == null ? void 0 : r.mode) === "edit" ? (0,require$react_SLASH_jsx_runtime.jsx)(require$react_SLASH_jsx_runtime.Fragment, {children:(0,require$react_SLASH_jsx_runtime.jsx)(bD, ve(K({}, e), {ref:n}))}) : (0,require$react_SLASH_jsx_runtime.jsx)(require$react_SLASH_jsx_runtime.Fragment, {children:(0,require$react_SLASH_jsx_runtime.jsx)(yD, ve(K({}, e), {ref:n}))});
}), mx = default$$require$react.default.createContext({config:{components:{}}, data:{root:{}, content:[]}, metadata:{}});
function hde({config:t, data:e, metadata:n = {}}) {
  var r;
  const i = ve(K({}, e), {root:e.root || {}, content:e.content || []}), s = "props" in i.root ? i.root.props : i.root, o = (s == null ? void 0 : s.title) || "", a = ve(K({}, s), {puck:{renderDropZone:gx, isEditing:!1, dragRef:null, metadata:n}, title:o, editMode:!1, id:"puck-root"}), l = Qg(t, {type:"root", props:a}, u => (0,require$react_SLASH_jsx_runtime.jsx)(gP, ve(K({}, u), {config:t, metadata:n}))), c = (0,require$react.useMemo)(() => ({mode:"render", depth:0}), []);
  return (r = t.root) != null && r.render ? (0,require$react_SLASH_jsx_runtime.jsx)(mx.Provider, {value:{config:t, data:i, metadata:n}, children:(0,require$react_SLASH_jsx_runtime.jsx)(Ud, {value:c, children:(0,require$react_SLASH_jsx_runtime.jsx)(t.root.render, ve(K({}, l), {children:(0,require$react_SLASH_jsx_runtime.jsx)(px, {zone:Ry})}))})}) : (0,require$react_SLASH_jsx_runtime.jsx)(mx.Provider, {value:{config:t, data:i, metadata:n}, children:(0,require$react_SLASH_jsx_runtime.jsx)(Ud, {value:c, 
  children:(0,require$react_SLASH_jsx_runtime.jsx)(px, {zone:Ry})})});
}
re();
var GE = t => {
  const e = {back:t.history.back, forward:t.history.forward, setHistories:t.history.setHistories, setHistoryIndex:t.history.setHistoryIndex, hasPast:t.history.hasPast(), hasFuture:t.history.hasFuture(), histories:t.history.histories, index:t.history.index};
  return {appState:Hd(t.state), config:t.config, dispatch:t.dispatch, getPermissions:t.permissions.getPermissions, refreshPermissions:t.permissions.refreshPermissions, history:e, selectedItem:t.selectedItem || null, getItemBySelector:r => is(r, t.state), getItemById:r => t.state.indexes.nodes[r].data, getSelectorForId:r => mD(t.state, r)};
}, fde = (0,require$react.createContext)(null), QE = t => ({state:t.state, config:t.config, dispatch:t.dispatch, permissions:t.permissions, history:t.history, selectedItem:t.selectedItem}), pde = t => {
  const [e] = (0,require$react.useState)(() => ch(() => GE(QE(t.getState()))));
  return (0,require$react.useEffect)(() => t.subscribe(n => QE(n), n => {
    e.setState(GE(n));
  }), []), e;
};
re();
re();
re();
var gde = {SidebarSection:"_SidebarSection_8boj8_1", "SidebarSection-title":"_SidebarSection-title_8boj8_12", "SidebarSection--noBorderTop":"_SidebarSection--noBorderTop_8boj8_20", "SidebarSection-content":"_SidebarSection-content_8boj8_24", "SidebarSection--noPadding":"_SidebarSection--noPadding_8boj8_28", "SidebarSection-breadcrumbLabel":"_SidebarSection-breadcrumbLabel_8boj8_41", "SidebarSection-breadcrumbs":"_SidebarSection-breadcrumbs_8boj8_70", "SidebarSection-breadcrumb":"_SidebarSection-breadcrumb_8boj8_41", 
"SidebarSection-heading":"_SidebarSection-heading_8boj8_82", "SidebarSection-loadingOverlay":"_SidebarSection-loadingOverlay_8boj8_86"};
re();
var mde = t => {
  const e = Be(s => {
    var o;
    return (o = s.selectedItem) == null ? void 0 : o.props.id;
  }), n = Be(s => s.config), r = Be(s => {
    var o;
    return (o = s.state.indexes.nodes[e]) == null ? void 0 : o.path;
  }), i = oi();
  return (0,require$react.useMemo)(() => {
    const s = (r == null ? void 0 : r.map(o => {
      var a, l, c;
      const [u] = o.split(":");
      if (u === "root") {
        return {label:"Page", selector:null};
      }
      const h = i.getState().state.indexes.nodes[u], f = h.path[h.path.length - 1], g = (((a = i.getState().state.indexes.zones[f]) == null ? void 0 : a.contentIds) || []).indexOf(u);
      return {label:h ? (c = (l = n.components[h.data.type]) == null ? void 0 : l.label) != null ? c : h.data.type : "Component", selector:h ? {index:g, zone:h.path[h.path.length - 1]} : null};
    })) || [];
    return s.slice(s.length - t);
  }, [r, t]);
}, Io = Rt("SidebarSection", gde), bx = ({children:t, title:e, background:n, showBreadcrumbs:r, noBorderTop:i, noPadding:s, isLoading:o}) => {
  const a = Be(c => c.setUi), l = mde(1);
  return (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:Io({noBorderTop:i, noPadding:s}), style:{background:n}, children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {className:Io("title"), children:(0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:Io("breadcrumbs"), children:[r ? l.map((c, u) => (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:Io("breadcrumb"), children:[(0,require$react_SLASH_jsx_runtime.jsx)("button", {type:"button", className:Io("breadcrumbLabel"), 
  onClick:() => a({itemSelector:c.selector}), children:c.label}), (0,require$react_SLASH_jsx_runtime.jsx)(Sce, {size:16})]}, u)) : null, (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:Io("heading"), children:(0,require$react_SLASH_jsx_runtime.jsx)(Jv, {rank:"2", size:"xs", children:e})})]})}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:Io("content"), children:t}), o && (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:Io("loadingOverlay"), children:(0,require$react_SLASH_jsx_runtime.jsx)(dl, 
  {size:32})})]});
};
re();
var xD = {Puck:"_Puck_1yxlw_19", "Puck-portal":"_Puck-portal_1yxlw_31", "PuckLayout-inner":"_PuckLayout-inner_1yxlw_38", "PuckLayout--mounted":"_PuckLayout--mounted_1yxlw_59", "PuckLayout--leftSideBarVisible":"_PuckLayout--leftSideBarVisible_1yxlw_63", "PuckLayout--rightSideBarVisible":"_PuckLayout--rightSideBarVisible_1yxlw_69", "PuckLayout-mounted":"_PuckLayout-mounted_1yxlw_83", PuckLayout:"_PuckLayout_1yxlw_38"};
re();
re();
var bde = {PuckFields:"_PuckFields_10bh7_1", "PuckFields--isLoading":"_PuckFields--isLoading_10bh7_6", "PuckFields-loadingOverlay":"_PuckFields-loadingOverlay_10bh7_10", "PuckFields-loadingOverlayInner":"_PuckFields-loadingOverlayInner_10bh7_25", "PuckFields-field":"_PuckFields-field_10bh7_32", "PuckFields--wrapFields":"_PuckFields--wrapFields_10bh7_36"}, ep = Rt("PuckFields", bde), yde = ({children:t}) => (0,require$react_SLASH_jsx_runtime.jsx)(require$react_SLASH_jsx_runtime.Fragment, {children:t}), 
xde = (t, e) => (n, r) => Qn(void 0, null, function*() {
  let i;
  const {dispatch:s, state:o, selectedItem:a, resolveComponentData:l} = e.getState(), {data:c, ui:u} = o, {itemSelector:h} = u, f = c.root.props || c.root;
  a ? i = a.props : i = f;
  const p = ve(K({}, i), {[t]:n});
  a && h ? s({type:"replace", destinationIndex:h.index, destinationZone:h.zone || Cr, data:(yield l(ve(K({}, a), {props:p}), "replace")).node, ui:r}) : c.root.props ? s({type:"replaceRoot", root:(yield l(ve(K({}, c.root), {props:p}), "replace")).node, ui:K(K({}, u), r), recordHistory:!0}) : s({type:"setData", data:{root:p}});
}), vde = ({fieldName:t}) => {
  const e = Be(c => c.fields.fields[t]), n = Be(c => ((c.selectedItem ? c.selectedItem.readOnly : c.state.data.root.readOnly) || {})[t]), r = Be(c => {
    const u = c.state.data.root.props || c.state.data.root;
    return c.selectedItem ? c.selectedItem.props[t] : u[t];
  }), i = Be(c => e ? c.selectedItem ? `${c.selectedItem.props.id}_${e.type}_${t}` : `root_${e.type}_${t}` : null), s = Be(xr(c => {
    const {selectedItem:u, permissions:h} = c;
    return u ? h.getPermissions({item:u}) : h.getPermissions({root:!0});
  })), o = oi(), a = (0,require$react.useCallback)(xde(t, o), [t]), {visible:l = !0} = e ?? {};
  return !e || !i || !l || e.type === "slot" ? null : (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:ep("field"), children:(0,require$react_SLASH_jsx_runtime.jsx)(om, {field:e, name:t, id:i, readOnly:!s.edit || n, value:r, onChange:a})}, i);
}, wde = (0,require$react.memo)(vde), _de = ({wrapFields:t = !0}) => {
  const e = Be(u => u.overrides), n = Be(u => {
    var h, f;
    const p = u.selectedItem ? (h = u.componentState[u.selectedItem.props.id]) == null ? void 0 : h.loadingCount : (f = u.componentState.root) == null ? void 0 : f.loadingCount;
    return (p ?? 0) > 0;
  }), r = Be(xr(u => u.state.ui.itemSelector)), i = Be(u => {
    var h;
    return (h = u.selectedItem) == null ? void 0 : h.props.id;
  }), s = oi();
  ace(s, i);
  const o = Be(u => u.fields.loading), a = Be(xr(u => u.fields.id === i ? Object.keys(u.fields.fields) : [])), l = o || n, c = (0,require$react.useMemo)(() => e.fields || yde, [e]);
  return (0,require$react_SLASH_jsx_runtime.jsxs)("form", {className:ep({wrapFields:t}), onSubmit:u => {
    u.preventDefault();
  }, children:[(0,require$react_SLASH_jsx_runtime.jsx)(c, {isLoading:l, itemSelector:r, children:a.map(u => (0,require$react_SLASH_jsx_runtime.jsx)(wde, {fieldName:u}, u))}), l && (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:ep("loadingOverlay"), children:(0,require$react_SLASH_jsx_runtime.jsx)("div", {className:ep("loadingOverlayInner"), children:(0,require$react_SLASH_jsx_runtime.jsx)(dl, {size:16})})})]});
}, vD = (0,require$react.memo)(_de);
re();
re();
re();
re();
var Sde = {ComponentList:"_ComponentList_1rrlt_1", "ComponentList--isExpanded":"_ComponentList--isExpanded_1rrlt_5", "ComponentList-content":"_ComponentList-content_1rrlt_9", "ComponentList-title":"_ComponentList-title_1rrlt_17", "ComponentList-titleIcon":"_ComponentList-titleIcon_1rrlt_53"}, Sf = Rt("ComponentList", Sde), wD = ({name:t, label:e}) => {
  var n;
  const r = Be(s => s.overrides), i = Be(s => s.permissions.getPermissions({type:t}).insert);
  return (0,require$react.useEffect)(() => {
    r.componentItem && console.warn("The `componentItem` override has been deprecated and renamed to `drawerItem`");
  }, [r]), (0,require$react_SLASH_jsx_runtime.jsx)(ew.Item, {label:e, name:t, isDragDisabled:!i, children:(n = r.componentItem) != null ? n : r.drawerItem});
}, Gl = ({children:t, title:e, id:n}) => {
  const r = Be(a => a.config), i = Be(a => a.setUi), s = Be(a => a.state.ui.componentList), {expanded:o = !0} = s[n] || {};
  return (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:Sf({isExpanded:o}), children:[e && (0,require$react_SLASH_jsx_runtime.jsxs)("button", {type:"button", className:Sf("title"), onClick:() => i({componentList:ve(K({}, s), {[n]:ve(K({}, s[n]), {expanded:!o})})}), title:o ? `Collapse${e ? ` ${e}` : ""}` : `Expand${e ? ` ${e}` : ""}`, children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {children:e}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:Sf("titleIcon"), children:o ? 
  (0,require$react_SLASH_jsx_runtime.jsx)(eD, {size:12}) : (0,require$react_SLASH_jsx_runtime.jsx)(sm, {size:12})})]}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:Sf("content"), children:(0,require$react_SLASH_jsx_runtime.jsx)(ew, {children:t || Object.keys(r.components).map(a => {
    var l;
    return (0,require$react_SLASH_jsx_runtime.jsx)(wD, {label:(l = r.components[a].label) != null ? l : a, name:a}, a);
  })})})]});
};
Gl.Item = wD;
var kde = () => {
  const [t, e] = (0,require$react.useState)(), n = Be(i => i.config), r = Be(i => i.state.ui.componentList);
  return (0,require$react.useEffect)(() => {
    var i, s, o;
    if (Object.keys(r).length > 0) {
      const a = [];
      let l;
      l = Object.entries(r).map(([u, h]) => !h.components || (h.components.forEach(f => {
        a.push(f);
      }), h.visible === !1) ? null : (0,require$react_SLASH_jsx_runtime.jsx)(Gl, {id:u, title:h.title || u, children:h.components.map((f, p) => {
        var g;
        const m = n.components[f] || {};
        return (0,require$react_SLASH_jsx_runtime.jsx)(Gl.Item, {label:(g = m.label) != null ? g : f, name:f, index:p}, f);
      })}, u));
      const c = Object.keys(n.components).filter(u => a.indexOf(u) === -1);
      c.length > 0 && !((i = r.other) != null && i.components) && ((s = r.other) == null ? void 0 : s.visible) !== !1 && l.push((0,require$react_SLASH_jsx_runtime.jsx)(Gl, {id:"other", title:((o = r.other) == null ? void 0 : o.title) || "Other", children:c.map((u, h) => {
        var f;
        const p = n.components[u] || {};
        return (0,require$react_SLASH_jsx_runtime.jsx)(Gl.Item, {name:u, label:(f = p.label) != null ? f : u, index:h}, u);
      })}, "other")), e(l);
    }
  }, [n.categories, n.components, r]), t;
}, _D = () => {
  const t = Be(r => r.overrides), e = kde(), n = (0,require$react.useMemo)(() => (t.components && console.warn("The `components` override has been deprecated and renamed to `drawer`"), t.components || t.drawer || "div"), [t]);
  return (0,require$react_SLASH_jsx_runtime.jsx)(n, {children:e || (0,require$react_SLASH_jsx_runtime.jsx)(Gl, {id:"all"})});
};
re();
re();
var yx = 'style, link[rel\x3d"stylesheet"]', Ede = t => {
  const e = [];
  return t.querySelectorAll(yx).forEach(n => {
    n.tagName === "STYLE" ? n.innerHTML.trim() && e.push(n) : e.push(n);
  }), e;
}, KE = t => Array.from(document.styleSheets).find(e => e.ownerNode.href === t.href), Tde = t => {
  if (t) {
    try {
      return [...Array.from(t.cssRules)].map(e => e.cssText).join("");
    } catch {
      console.warn("Access to stylesheet %s is denied. Ignoring\u2026", t.href);
    }
  }
  return "";
}, XE = (t, e) => {
  const n = t.attributes;
  (n == null ? void 0 : n.length) > 0 && Array.from(n).forEach(r => {
    e.setAttribute(r.name, r.value);
  });
}, JE = t => setTimeout(t, 0), Cde = ({children:t, debug:e = !1, onStylesLoaded:n = () => null}) => {
  const {document:r, window:i} = Ade();
  return (0,require$react.useEffect)(() => {
    if (!i || !r) {
      return () => {
      };
    }
    let s = [];
    const o = {}, a = w => s.findIndex(v => v.original === w), l = (w, v = !1) => Qn(void 0, null, function*() {
      let T;
      if (w.nodeName === "LINK" && v) {
        T = document.createElement("style"), T.type = "text/css";
        let I = KE(w);
        I || (yield new Promise(N => {
          const E = () => {
            N(), w.removeEventListener("load", E);
          };
          w.addEventListener("load", E);
        }), I = KE(w));
        const _ = Tde(I);
        if (!_) {
          e && console.warn("Tried to load styles for link element, but couldn't find them. Skipping...");
          return;
        }
        T.innerHTML = _, T.setAttribute("data-href", w.getAttribute("href"));
      } else {
        T = w.cloneNode(!0);
      }
      return T;
    }), c = w => Qn(void 0, null, function*() {
      const v = a(w);
      if (v > -1) {
        e && console.log("Tried to add an element that was already mirrored. Updating instead..."), s[v].mirror.innerText = w.innerText;
        return;
      }
      const T = yield l(w);
      if (!T) {
        return;
      }
      const I = V0(T.outerHTML);
      if (o[I]) {
        e && console.log("iframe already contains element that is being mirrored. Skipping...");
        return;
      }
      o[I] = !0, r.head.append(T), s.push({original:w, mirror:T}), e && console.log(`Added style node ${w.outerHTML}`);
    }), u = w => {
      var v, T;
      const I = a(w);
      if (I === -1) {
        e && console.log("Tried to remove an element that did not exist. Skipping...");
        return;
      }
      const _ = V0(w.outerHTML);
      (T = (v = s[I]) == null ? void 0 : v.mirror) == null || T.remove(), delete o[_], e && console.log(`Removed style node ${w.outerHTML}`);
    }, h = new MutationObserver(w => {
      w.forEach(v => {
        v.type === "childList" && (v.addedNodes.forEach(T => {
          if (T.nodeType === Node.TEXT_NODE || T.nodeType === Node.ELEMENT_NODE) {
            const I = T.nodeType === Node.TEXT_NODE ? T.parentElement : T;
            I && I.matches(yx) && JE(() => c(I));
          }
        }), v.removedNodes.forEach(T => {
          if (T.nodeType === Node.TEXT_NODE || T.nodeType === Node.ELEMENT_NODE) {
            const I = T.nodeType === Node.TEXT_NODE ? T.parentElement : T;
            I && I.matches(yx) && JE(() => u(I));
          }
        }));
      });
    }), f = i.parent.document, p = Ede(f), g = [];
    let m = 0;
    const b = f.getElementsByTagName("html")[0];
    XE(b, r.documentElement);
    const x = f.getElementsByTagName("body")[0];
    return XE(x, r.body), Promise.all(p.map((w, v) => Qn(void 0, null, function*() {
      if (w.nodeName === "LINK") {
        const I = w.href;
        if (g.indexOf(I) > -1) {
          return;
        }
        g.push(I);
      }
      const T = yield l(w);
      if (T) {
        return s.push({original:w, mirror:T}), T;
      }
    }))).then(w => {
      const v = w.filter(T => typeof T < "u");
      v.forEach(T => {
        T.onload = () => {
          m = m + 1, m >= s.length && n();
        }, T.onerror = () => {
          console.warn("AutoFrame couldn't load a stylesheet"), m = m + 1, m >= s.length && n();
        };
      }), r.head.innerHTML = "", r.head.append(...v), h.observe(f.head, {childList:!0, subtree:!0}), v.forEach(T => {
        const I = V0(T.outerHTML);
        o[I] = !0;
      });
    }), () => {
      h.disconnect();
    };
  }, []), (0,require$react_SLASH_jsx_runtime.jsx)(require$react_SLASH_jsx_runtime.Fragment, {children:t});
}, tw = (0,require$react.createContext)({}), Ade = () => (0,require$react.useContext)(tw);
function SD(t) {
  var e = t, {children:n, className:r, debug:i, id:s, onReady:o = () => {
  }, onNotReady:a = () => {
  }, frameRef:l} = e, c = ua(e, ["children", "className", "debug", "id", "onReady", "onNotReady", "frameRef"]);
  const [u, h] = (0,require$react.useState)(!1), [f, p] = (0,require$react.useState)({}), [g, m] = (0,require$react.useState)(), [b, x] = (0,require$react.useState)(!1);
  return (0,require$react.useEffect)(() => {
    var w;
    if (l.current) {
      const v = l.current.contentDocument, T = l.current.contentWindow;
      p({document:v || void 0, window:T || void 0}), m((w = l.current.contentDocument) == null ? void 0 : w.getElementById("frame-root")), v && T && b ? o() : a();
    }
  }, [l, u, b]), (0,require$react_SLASH_jsx_runtime.jsx)("iframe", ve(K({}, c), {className:r, id:s, srcDoc:'\x3c!DOCTYPE html\x3e\x3chtml\x3e\x3chead\x3e\x3c/head\x3e\x3cbody\x3e\x3cdiv id\x3d"frame-root" data-puck-entry\x3e\x3c/div\x3e\x3c/body\x3e\x3c/html\x3e', ref:l, onLoad:() => {
    h(!0);
  }, children:(0,require$react_SLASH_jsx_runtime.jsx)(tw.Provider, {value:f, children:u && g && (0,require$react_SLASH_jsx_runtime.jsx)(Cde, {debug:i, onStylesLoaded:() => x(!0), children:(0,require$react_dom.createPortal)(n, g)})})}));
}
SD.displayName = "AutoFrame";
var Nde = SD;
re();
var Ide = {PuckPreview:"_PuckPreview_z2rgu_1", "PuckPreview-frame":"_PuckPreview-frame_z2rgu_6"}, Z0 = Rt("PuckPreview", Ide), Ode = t => {
  const e = Be(n => n.status);
  (0,require$react.useEffect)(() => {
    if (t.current && e === "READY") {
      const n = t.current, r = o => {
        const a = new pD("pointermove", ve(K({}, o), {bubbles:!0, cancelable:!1, clientX:o.clientX, clientY:o.clientY, originalTarget:o.target}));
        n.dispatchEvent(a);
      }, i = () => {
        var o;
        s(), (o = n.contentDocument) == null || o.addEventListener("pointermove", r, {capture:!0});
      }, s = () => {
        var o;
        (o = n.contentDocument) == null || o.removeEventListener("pointermove", r);
      };
      return i(), () => {
        s();
      };
    }
  }, [e]);
}, kD = ({id:t = "puck-preview"}) => {
  const e = Be(g => g.dispatch), n = Be(g => g.state.data.root), r = Be(g => g.config), i = Be(g => g.setStatus), s = Be(g => g.iframe), o = Be(g => g.overrides), a = Be(g => g.metadata), l = Be(g => g.state.ui.previewMode === "edit" ? null : g.state.data), c = (0,require$react.useCallback)(g => {
    var m, b;
    const x = Qg(r, {type:"root", props:g}, fx);
    return (m = r.root) != null && m.render ? (b = r.root) == null ? void 0 : b.render(K({id:"puck-root"}, x)) : (0,require$react_SLASH_jsx_runtime.jsx)(require$react_SLASH_jsx_runtime.Fragment, {children:x.children});
  }, [r]), u = (0,require$react.useMemo)(() => o.iframe, [o]), h = n.props || n, f = (0,require$react.useRef)(null);
  Ode(f);
  const p = l ? (0,require$react_SLASH_jsx_runtime.jsx)(hde, {data:l, config:r, metadata:a}) : (0,require$react_SLASH_jsx_runtime.jsx)(c, ve(K({}, h), {puck:{renderDropZone:gx, isEditing:!0, dragRef:null, metadata:a}, editMode:!0, children:(0,require$react_SLASH_jsx_runtime.jsx)(gx, {zone:Cr})}));
  return (0,require$react.useEffect)(() => {
    s.enabled || i("READY");
  }, [s.enabled]), (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:Z0(), id:t, "data-puck-preview":!0, onClick:g => {
    const m = g.target;
    !m.hasAttribute("data-puck-component") && !m.hasAttribute("data-puck-dropzone") && e({type:"setUi", ui:{itemSelector:null}});
  }, children:s.enabled ? (0,require$react_SLASH_jsx_runtime.jsx)(Nde, {id:"preview-frame", className:Z0("frame"), "data-rfd-iframe":!0, onReady:() => {
    i("READY");
  }, onNotReady:() => {
    i("MOUNTED");
  }, frameRef:f, children:(0,require$react_SLASH_jsx_runtime.jsx)(tw.Consumer, {children:({document:g}) => u ? (0,require$react_SLASH_jsx_runtime.jsx)(u, {document:g, children:p}) : p})}) : (0,require$react_SLASH_jsx_runtime.jsx)("div", {id:"preview-frame", className:Z0("frame"), ref:f, "data-puck-entry":!0, children:p})});
};
re();
re();
re();
var ED = {LayerTree:"_LayerTree_7rx04_1", "LayerTree-zoneTitle":"_LayerTree-zoneTitle_7rx04_11", "LayerTree-helper":"_LayerTree-helper_7rx04_17", Layer:"_Layer_7rx04_1", "Layer-inner":"_Layer-inner_7rx04_29", "Layer--containsZone":"_Layer--containsZone_7rx04_35", "Layer-clickable":"_Layer-clickable_7rx04_39", "Layer--isSelected":"_Layer--isSelected_7rx04_61", "Layer-chevron":"_Layer-chevron_7rx04_77", "Layer--childIsSelected":"_Layer--childIsSelected_7rx04_78", "Layer-zones":"_Layer-zones_7rx04_82", 
"Layer-title":"_Layer-title_7rx04_96", "Layer-name":"_Layer-name_7rx04_105", "Layer-icon":"_Layer-icon_7rx04_111", "Layer-zoneIcon":"_Layer-zoneIcon_7rx04_116"};
re();
var Pde = t => {
  const e = K({}, t.style);
  t.style.scrollMargin = "256px", t && (t == null || t.scrollIntoView({behavior:"smooth"}), t.style.scrollMargin = e.scrollMargin || "");
};
re();
var Rde = (t, e) => {
  let n;
  const r = function() {
    clearTimeout(n), n = setTimeout(function() {
      e(), t == null || t.removeEventListener("scroll", r);
    }, 50);
  };
  t == null || t.addEventListener("scroll", r), setTimeout(() => {
    n || e();
  }, 50);
}, kf = Rt("LayerTree", ED), Oo = Rt("Layer", ED), Dde = ({index:t, itemId:e, zoneCompound:n}) => {
  var r;
  const i = Be(w => w.config), s = Be(w => w.state.ui.itemSelector), o = Be(w => w.dispatch), a = (0,require$react.useCallback)(w => {
    o({type:"setUi", ui:{itemSelector:w}});
  }, [o]), c = Be(w => {
    var v;
    return (v = w.selectedItem) == null ? void 0 : v.props.id;
  }) === e || s && s.zone === Cr && !n, u = Be(w => w.state.indexes.nodes[e]), h = Be(xr(w => Object.keys(w.state.indexes.zones).filter(v => v.split(":")[0] === e))), f = h.length > 0, p = (0,require$react.useContext)(bi), g = Qa(bi, w => w.hoveringComponent === e), m = Be(w => {
    var v, T;
    const I = w.state.indexes.nodes[(v = w.selectedItem) == null ? void 0 : v.props.id];
    return (T = I == null ? void 0 : I.path.some(_ => {
      const [N] = _.split(":");
      return N === e;
    })) != null ? T : !1;
  }), b = i.components[u.data.type], x = (r = b == null ? void 0 : b.label) != null ? r : u.data.type.toString();
  return (0,require$react_SLASH_jsx_runtime.jsxs)("li", {className:Oo({isSelected:c, isHovering:g, containsZone:f, childIsSelected:m}), children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {className:Oo("inner"), children:(0,require$react_SLASH_jsx_runtime.jsxs)("button", {type:"button", className:Oo("clickable"), onClick:() => {
    if (c) {
      a(null);
      return;
    }
    const w = wc(), v = w == null ? void 0 : w.querySelector(`[data-puck-component="${e}"]`);
    if (!v) {
      a({index:t, zone:n});
      return;
    }
    Pde(v), Rde(w, () => {
      a({index:t, zone:n});
    });
  }, onMouseEnter:w => {
    w.stopPropagation(), p.setState({hoveringComponent:e});
  }, onMouseLeave:w => {
    w.stopPropagation(), p.setState({hoveringComponent:null});
  }, children:[f && (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:Oo("chevron"), title:c ? "Collapse" : "Expand", children:(0,require$react_SLASH_jsx_runtime.jsx)(sm, {size:"12"})}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:Oo("title"), children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {className:Oo("icon"), children:u.data.type === "Text" || u.data.type === "Heading" ? (0,require$react_SLASH_jsx_runtime.jsx)(Xv, {size:"16"}) : (0,require$react_SLASH_jsx_runtime.jsx)(Nce, 
  {size:"16"})}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:Oo("name"), children:x})]})]})}), f && h.map(w => (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:Oo("zones"), children:(0,require$react_SLASH_jsx_runtime.jsx)(TD, {zoneCompound:w})}, w))]});
}, TD = ({label:t, zoneCompound:e}) => {
  const n = Be(i => {
    var s, o, a, l;
    if (t) {
      return t;
    }
    if (e === Cr) {
      return;
    }
    const [c, u] = e.split(":"), h = (s = i.state.indexes.nodes[c]) == null ? void 0 : s.data.type, f = h && h !== Y1 ? i.config.components[h] : i.config.root;
    return (l = (a = (o = f == null ? void 0 : f.fields) == null ? void 0 : o[u]) == null ? void 0 : a.label) != null ? l : u;
  }), r = Be(xr(i => {
    var s, o;
    return e ? (o = (s = i.state.indexes.zones[e]) == null ? void 0 : s.contentIds) != null ? o : [] : [];
  }));
  return (0,require$react_SLASH_jsx_runtime.jsxs)(require$react_SLASH_jsx_runtime.Fragment, {children:[n && (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:kf("zoneTitle"), children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {className:kf("zoneIcon"), children:(0,require$react_SLASH_jsx_runtime.jsx)(Ace, {size:"16"})}), n]}), (0,require$react_SLASH_jsx_runtime.jsxs)("ul", {className:kf(), children:[r.length === 0 && (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:kf("helper"), 
  children:"No items"}), r.map((i, s) => (0,require$react_SLASH_jsx_runtime.jsx)(Dde, {index:s, itemId:i, zoneCompound:e}, i))]})]});
};
re();
var Lde = (t, e) => Object.keys(t.indexes.zones).filter(n => n.split(":")[0] === e), CD = () => {
  const t = Be(r => r.overrides.outline), e = Be(xr(r => Lde(r.state, "root"))), n = (0,require$react.useMemo)(() => t || "div", [t]);
  return (0,require$react_SLASH_jsx_runtime.jsx)(n, {children:e.map(r => (0,require$react_SLASH_jsx_runtime.jsx)(TD, {label:e.length === 1 ? "" : r.split(":")[1], zoneCompound:r}, r))});
};
re();
re();
re();
var AD = {ViewportControls:"_ViewportControls_gejzr_1", "ViewportControls-divider":"_ViewportControls-divider_gejzr_15", "ViewportControls-zoomSelect":"_ViewportControls-zoomSelect_gejzr_21", "ViewportButton--isActive":"_ViewportButton--isActive_gejzr_38", "ViewportButton-inner":"_ViewportButton-inner_gejzr_38"}, ZE = {Smartphone:(0,require$react_SLASH_jsx_runtime.jsx)(zce, {size:16}), Tablet:(0,require$react_SLASH_jsx_runtime.jsx)(Hce, {size:16}), Monitor:(0,require$react_SLASH_jsx_runtime.jsx)(Rce, 
{size:16})}, Ef = Rt("ViewportControls", AD), eT = Rt("ViewportButton", AD), Mde = ({children:t, height:e = "auto", title:n, width:r, onClick:i}) => {
  const s = Be(l => l.state.ui.viewports), [o, a] = (0,require$react.useState)(!1);
  return (0,require$react.useEffect)(() => {
    a(r === s.current.width);
  }, [r, s.current.width]), (0,require$react_SLASH_jsx_runtime.jsx)("span", {className:eT({isActive:o}), children:(0,require$react_SLASH_jsx_runtime.jsx)(ss, {type:"button", title:n, disabled:o, onClick:l => {
    l.stopPropagation(), i({width:r, height:e});
  }, children:(0,require$react_SLASH_jsx_runtime.jsx)("span", {className:eT("inner"), children:t})})});
}, tT = [{label:"25%", value:0.25}, {label:"50%", value:0.5}, {label:"75%", value:0.75}, {label:"100%", value:1}, {label:"125%", value:1.25}, {label:"150%", value:1.5}, {label:"200%", value:2}], Bde = ({autoZoom:t, zoom:e, onViewportChange:n, onZoom:r}) => {
  var i, s;
  const o = Be(c => c.viewports), a = tT.find(c => c.value === t), l = (0,require$react.useMemo)(() => [...tT, ...(a ? [] : [{value:t, label:`${(t * 100).toFixed(0)}% (Auto)`}])].filter(c => c.value <= t).sort((c, u) => c.value > u.value ? 1 : -1), [t]);
  return (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:Ef(), children:[o.map((c, u) => (0,require$react_SLASH_jsx_runtime.jsx)(Mde, {height:c.height, width:c.width, title:c.label ? `Switch to ${c.label} viewport` : "Switch viewport", onClick:n, children:typeof c.icon == "string" ? ZE[c.icon] || c.icon : c.icon || ZE.Smartphone}, u)), (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:Ef("divider")}), (0,require$react_SLASH_jsx_runtime.jsx)(ss, {type:"button", title:"Zoom viewport out", 
  disabled:e <= ((i = l[0]) == null ? void 0 : i.value), onClick:c => {
    c.stopPropagation(), r(l[Math.max(l.findIndex(u => u.value === e) - 1, 0)].value);
  }, children:(0,require$react_SLASH_jsx_runtime.jsx)(jce, {size:16})}), (0,require$react_SLASH_jsx_runtime.jsx)(ss, {type:"button", title:"Zoom viewport in", disabled:e >= ((s = l[l.length - 1]) == null ? void 0 : s.value), onClick:c => {
    c.stopPropagation(), r(l[Math.min(l.findIndex(u => u.value === e) + 1, l.length - 1)].value);
  }, children:(0,require$react_SLASH_jsx_runtime.jsx)(Wce, {size:16})}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:Ef("divider")}), (0,require$react_SLASH_jsx_runtime.jsx)("select", {className:Ef("zoomSelect"), value:e.toString(), onClick:c => {
    c.stopPropagation();
  }, onChange:c => {
    r(parseFloat(c.currentTarget.value));
  }, children:l.map(c => (0,require$react_SLASH_jsx_runtime.jsx)("option", {value:c.value, label:c.label}, c.label))})]});
};
re();
var $de = {PuckCanvas:"_PuckCanvas_18jay_1", "PuckCanvas-controls":"_PuckCanvas-controls_18jay_16", "PuckCanvas-inner":"_PuckCanvas-inner_18jay_21", "PuckCanvas-root":"_PuckCanvas-root_18jay_30", "PuckCanvas--ready":"_PuckCanvas--ready_18jay_55", "PuckCanvas-loader":"_PuckCanvas-loader_18jay_60", "PuckCanvas--showLoader":"_PuckCanvas--showLoader_18jay_70"};
re();
var ND = (0,require$react.createContext)(null), Fde = ({children:t}) => {
  const e = (0,require$react.useRef)(null), n = (0,require$react.useMemo)(() => ({frameRef:e}), []);
  return (0,require$react_SLASH_jsx_runtime.jsx)(ND.Provider, {value:n, children:t});
}, ID = () => {
  const t = (0,require$react.useContext)(ND);
  if (t === null) {
    throw new Error("useCanvasFrame must be used within a FrameProvider");
  }
  return t;
}, lu = Rt("PuckCanvas", $de), eb = 150, zde = () => {
  const {frameRef:t} = ID(), e = XR(t), {dispatch:n, overrides:r, setUi:i, zoomConfig:s, setZoomConfig:o, status:a, iframe:l} = Be(xr(_ => ({dispatch:_.dispatch, overrides:_.overrides, setUi:_.setUi, zoomConfig:_.zoomConfig, setZoomConfig:_.setZoomConfig, status:_.status, iframe:_.iframe}))), {leftSideBarVisible:c, rightSideBarVisible:u, leftSideBarWidth:h, rightSideBarWidth:f, viewports:p} = Be(xr(_ => ({leftSideBarVisible:_.state.ui.leftSideBarVisible, rightSideBarVisible:_.state.ui.rightSideBarVisible, 
  leftSideBarWidth:_.state.ui.leftSideBarWidth, rightSideBarWidth:_.state.ui.rightSideBarWidth, viewports:_.state.ui.viewports}))), [g, m] = (0,require$react.useState)(!1), b = (0,require$react.useRef)(!1), x = (0,require$react.useMemo)(() => ({children:N}) => (0,require$react_SLASH_jsx_runtime.jsx)(require$react_SLASH_jsx_runtime.Fragment, {children:N}), []), w = (0,require$react.useMemo)(() => r.preview || x, [r]), v = (0,require$react.useCallback)(() => {
    if (t.current) {
      const _ = t.current, N = KR(_);
      return {width:N.contentBox.width, height:N.contentBox.height};
    }
    return {width:0, height:0};
  }, [t]);
  (0,require$react.useEffect)(() => {
    e();
  }, [t, c, u, h, f, p]), (0,require$react.useEffect)(() => {
    const {height:_} = v();
    p.current.height === "auto" && o(ve(K({}, s), {rootHeight:_ / s.zoom}));
  }, [s.zoom, v, o]), (0,require$react.useEffect)(() => {
    e();
  }, [p.current.width, p]), (0,require$react.useEffect)(() => {
    if (!t.current) {
      return;
    }
    const _ = new ResizeObserver(() => {
      b.current || e();
    });
    return _.observe(t.current), () => {
      _.disconnect();
    };
  }, [t.current]);
  const [T, I] = (0,require$react.useState)(!1);
  return (0,require$react.useEffect)(() => {
    setTimeout(() => {
      I(!0);
    }, 500);
  }, []), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:lu({ready:a === "READY" || !l.enabled || !l.waitForStyles, showLoader:T}), onClick:_ => {
    const N = _.target;
    !N.hasAttribute("data-puck-component") && !N.hasAttribute("data-puck-dropzone") && n({type:"setUi", ui:{itemSelector:null}, recordHistory:!0});
  }, children:[p.controlsVisible && l.enabled && (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:lu("controls"), children:(0,require$react_SLASH_jsx_runtime.jsx)(Bde, {autoZoom:s.autoZoom, zoom:s.zoom, onViewportChange:_ => {
    m(!0), b.current = !0;
    const N = ve(K({}, _), {height:_.height || "auto", zoom:s.zoom}), E = {viewports:ve(K({}, p), {current:N})};
    i(E), e({viewports:ve(K({}, p), {current:N})});
  }, onZoom:_ => {
    m(!0), b.current = !0, o(ve(K({}, s), {zoom:_}));
  }})}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:lu("inner"), ref:t, children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {className:lu("root"), style:{width:l.enabled ? p.current.width : "100%", height:s.rootHeight, transform:l.enabled ? `scale(${s.zoom})` : void 0, transition:g ? `width ${eb}ms ease-out, height ${eb}ms ease-out, transform ${eb}ms ease-out` : "", overflow:l.enabled ? void 0 : "auto"}, suppressHydrationWarning:!0, id:"puck-canvas-root", onTransitionEnd:() => 
  {
    m(!1), b.current = !1;
  }, children:(0,require$react_SLASH_jsx_runtime.jsx)(w, {children:(0,require$react_SLASH_jsx_runtime.jsx)(kD, {})})}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:lu("loader"), children:(0,require$react_SLASH_jsx_runtime.jsx)(dl, {size:24})})]})]});
};
re();
re();
var Hde = ({overrides:t, plugins:e}) => {
  const n = K({}, t);
  return e == null || e.forEach(r => {
    r.overrides && Object.keys(r.overrides).forEach(i => {
      var s;
      const o = i;
      if (!((s = r.overrides) != null && s[o])) {
        return;
      }
      if (o === "fieldTypes") {
        const c = r.overrides.fieldTypes;
        Object.keys(c).forEach(u => {
          n.fieldTypes = n.fieldTypes || {};
          const h = n.fieldTypes[u], f = p => c[u](ve(K({}, p), {children:h ? h(p) : p.children}));
          n.fieldTypes[u] = f;
        });
        return;
      }
      const a = n[o], l = c => r.overrides[o](ve(K({}, c), {children:a ? a(c) : c.children}));
      n[o] = l;
    });
  }), n;
}, Ude = ({overrides:t, plugins:e}) => (0,require$react.useMemo)(() => Hde({overrides:t, plugins:e}), [e, t]);
re();
var xx = ({children:t}) => (0,require$react_SLASH_jsx_runtime.jsx)(require$react_SLASH_jsx_runtime.Fragment, {children:t});
re();
var Wde = "", jde = (t, e) => {
  const [n, r] = (0,require$react.useState)();
  return (0,require$react.useEffect)(() => {
    r(document.createElement("style"));
  }, []), (0,require$react.useEffect)(() => {
    var i;
    if (!(!n || typeof window > "u")) {
      if (n.innerHTML = t, e) {
        const s = wc();
        (i = s == null ? void 0 : s.head) == null || i.appendChild(n);
      }
      document.head.appendChild(n);
    }
  }, [e, n]), n;
}, Vde = t => jde(Wde, t);
re();
var qde = () => {
  const t = oi(), e = (0,require$react.useCallback)(() => {
    const n = t.getState().dispatch;
    n({type:"setUi", ui:r => ({previewMode:r.previewMode === "edit" ? "interactive" : "edit"})});
  }, [t]);
  Fo({meta:!0, i:!0}, e), Fo({ctrl:!0, i:!0}, e);
};
re();
re();
re();
var Yde = {MenuBar:"_MenuBar_8pf8c_1", "MenuBar--menuOpen":"_MenuBar--menuOpen_8pf8c_14", "MenuBar-inner":"_MenuBar-inner_8pf8c_29", "MenuBar-history":"_MenuBar-history_8pf8c_45"}, tb = Rt("MenuBar", Yde);
function Gde({menuOpen:t = !1, renderHeaderActions:e, setMenuOpen:n}) {
  const r = Be(a => a.history.back), i = Be(a => a.history.forward), s = Be(a => a.history.hasFuture()), o = Be(a => a.history.hasPast());
  return (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:tb({menuOpen:t}), onClick:a => {
    var l;
    const c = a.target;
    window.matchMedia("(min-width: 638px)").matches || c.tagName === "A" && ((l = c.getAttribute("href")) != null && l.startsWith("#")) && n(!1);
  }, children:(0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:tb("inner"), children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:tb("history"), children:[(0,require$react_SLASH_jsx_runtime.jsx)(ss, {type:"button", title:"undo", disabled:!o, onClick:r, children:(0,require$react_SLASH_jsx_runtime.jsx)(Uce, {size:21})}), (0,require$react_SLASH_jsx_runtime.jsx)(ss, {type:"button", title:"redo", disabled:!s, onClick:i, children:(0,require$react_SLASH_jsx_runtime.jsx)(Bce, {size:21})})]}), 
  (0,require$react_SLASH_jsx_runtime.jsx)(require$react_SLASH_jsx_runtime.Fragment, {children:e && e()})]})});
}
re();
var Qde = {PuckHeader:"_PuckHeader_15xnq_1", "PuckHeader-inner":"_PuckHeader-inner_15xnq_10", "PuckHeader-toggle":"_PuckHeader-toggle_15xnq_20", "PuckHeader--rightSideBarVisible":"_PuckHeader--rightSideBarVisible_15xnq_27", "PuckHeader-rightSideBarToggle":"_PuckHeader-rightSideBarToggle_15xnq_27", "PuckHeader--leftSideBarVisible":"_PuckHeader--leftSideBarVisible_15xnq_28", "PuckHeader-leftSideBarToggle":"_PuckHeader-leftSideBarToggle_15xnq_28", "PuckHeader-title":"_PuckHeader-title_15xnq_32", "PuckHeader-path":"_PuckHeader-path_15xnq_36", 
"PuckHeader-tools":"_PuckHeader-tools_15xnq_43", "PuckHeader-menuButton":"_PuckHeader-menuButton_15xnq_49", "PuckHeader--menuOpen":"_PuckHeader--menuOpen_15xnq_54"}, Qs = Rt("PuckHeader", Qde), Kde = () => {
  const {onPublish:t, renderHeader:e, renderHeaderActions:n, headerTitle:r, headerPath:i, iframe:s} = nw(), o = Be(w => w.dispatch), a = oi(), l = (0,require$react.useMemo)(() => e ? (console.warn("`renderHeader` is deprecated. Please use `overrides.header` and the `usePuck` hook instead"), v => {
    var T = v, {actions:I} = T, _ = ua(T, ["actions"]);
    const N = e, E = Be(C => C.state);
    return (0,require$react_SLASH_jsx_runtime.jsx)(N, ve(K({}, _), {dispatch:o, state:E, children:I}));
  }) : xx, [e]), c = (0,require$react.useMemo)(() => n ? (console.warn("`renderHeaderActions` is deprecated. Please use `overrides.headerActions` and the `usePuck` hook instead."), v => {
    const T = n, I = Be(_ => _.state);
    return (0,require$react_SLASH_jsx_runtime.jsx)(T, ve(K({}, v), {dispatch:o, state:I}));
  }) : xx, [n]), u = Be(w => w.overrides.header || l), h = Be(w => w.overrides.headerActions || c), [f, p] = (0,require$react.useState)(!1), g = Be(w => {
    var v, T;
    return (T = ((v = w.state.indexes.nodes.root) == null ? void 0 : v.data).props.title) != null ? T : "";
  }), m = Be(w => w.state.ui.leftSideBarVisible), b = Be(w => w.state.ui.rightSideBarVisible), x = (0,require$react.useCallback)(w => {
    const v = window.matchMedia("(min-width: 638px)").matches, T = w === "left" ? m : b, I = w === "left" ? "rightSideBarVisible" : "leftSideBarVisible";
    o({type:"setUi", ui:K({[`${w}SideBarVisible`]:!T}, v ? {} : {[I]:!1})});
  }, [o, m, b]);
  return (0,require$react_SLASH_jsx_runtime.jsx)(u, {actions:(0,require$react_SLASH_jsx_runtime.jsx)(require$react_SLASH_jsx_runtime.Fragment, {children:(0,require$react_SLASH_jsx_runtime.jsx)(h, {children:(0,require$react_SLASH_jsx_runtime.jsx)(ux, {onClick:() => {
    const w = a.getState().state.data;
    t && t(w);
  }, icon:(0,require$react_SLASH_jsx_runtime.jsx)(ME, {size:"14px"}), children:"Publish"})})}), children:(0,require$react_SLASH_jsx_runtime.jsx)("header", {className:Qs({leftSideBarVisible:m, rightSideBarVisible:b}), children:(0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:Qs("inner"), children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:Qs("toggle"), children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {className:Qs("leftSideBarToggle"), children:(0,require$react_SLASH_jsx_runtime.jsx)(ss, 
  {type:"button", onClick:() => {
    x("left");
  }, title:"Toggle left sidebar", children:(0,require$react_SLASH_jsx_runtime.jsx)(Dce, {focusable:"false"})})}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:Qs("rightSideBarToggle"), children:(0,require$react_SLASH_jsx_runtime.jsx)(ss, {type:"button", onClick:() => {
    x("right");
  }, title:"Toggle right sidebar", children:(0,require$react_SLASH_jsx_runtime.jsx)(Lce, {focusable:"false"})})})]}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:Qs("title"), children:(0,require$react_SLASH_jsx_runtime.jsxs)(Jv, {rank:"2", size:"xs", children:[r || g || "Page", i && (0,require$react_SLASH_jsx_runtime.jsxs)(require$react_SLASH_jsx_runtime.Fragment, {children:[" ", (0,require$react_SLASH_jsx_runtime.jsx)("code", {className:Qs("path"), children:i})]})]})}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", 
  {className:Qs("tools"), children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {className:Qs("menuButton"), children:(0,require$react_SLASH_jsx_runtime.jsx)(ss, {type:"button", onClick:() => p(!f), title:"Toggle menu bar", children:f ? (0,require$react_SLASH_jsx_runtime.jsx)(eD, {focusable:"false"}) : (0,require$react_SLASH_jsx_runtime.jsx)(sm, {focusable:"false"})})}), (0,require$react_SLASH_jsx_runtime.jsx)(Gde, {dispatch:o, onPublish:t, menuOpen:f, renderHeaderActions:() => (0,require$react_SLASH_jsx_runtime.jsx)(h, 
  {children:(0,require$react_SLASH_jsx_runtime.jsx)(ux, {onClick:() => {
    const w = a.getState().state.data;
    t && t(w);
  }, icon:(0,require$react_SLASH_jsx_runtime.jsx)(ME, {size:"14px"}), children:"Publish"})}), setMenuOpen:p})]})]})})});
}, Xde = (0,require$react.memo)(Kde);
re();
re();
re();
var Jde = {ResizeHandle:"_ResizeHandle_144bf_2", "ResizeHandle--left":"_ResizeHandle--left_144bf_16", "ResizeHandle--right":"_ResizeHandle--right_144bf_20"}, Zde = Rt("ResizeHandle", Jde), ehe = ({position:t, sidebarRef:e, onResize:n, onResizeEnd:r}) => {
  const {frameRef:i} = ID(), s = XR(i), o = (0,require$react.useRef)(null), a = (0,require$react.useRef)(!1), l = (0,require$react.useRef)(0), c = (0,require$react.useRef)(0), u = (0,require$react.useCallback)(p => {
    if (!a.current) {
      return;
    }
    const g = p.clientX - l.current, m = t === "left" ? c.current + g : c.current - g, b = Math.max(192, m);
    n(b), p.preventDefault();
  }, [n, t]), h = (0,require$react.useCallback)(() => {
    var p;
    if (!a.current) {
      return;
    }
    a.current = !1, document.body.style.cursor = "", document.body.style.userSelect = "";
    const g = document.getElementById("resize-overlay");
    g && document.body.removeChild(g), document.removeEventListener("mousemove", u), document.removeEventListener("mouseup", h);
    const m = ((p = e.current) == null ? void 0 : p.getBoundingClientRect().width) || 0;
    r(m), s();
  }, [r]), f = (0,require$react.useCallback)(p => {
    var g;
    a.current = !0, l.current = p.clientX, c.current = ((g = e.current) == null ? void 0 : g.getBoundingClientRect().width) || 0, document.body.style.cursor = "col-resize", document.body.style.userSelect = "none";
    const m = document.createElement("div");
    m.id = "resize-overlay", m.setAttribute("data-resize-overlay", ""), document.body.appendChild(m), document.addEventListener("mousemove", u), document.addEventListener("mouseup", h), p.preventDefault();
  }, [t, u, h]);
  return (0,require$react_SLASH_jsx_runtime.jsx)("div", {ref:o, className:Zde({[t]:!0}), onMouseDown:f});
};
re();
var the = {Sidebar:"_Sidebar_1xksb_1", "Sidebar--left":"_Sidebar--left_1xksb_8", "Sidebar--right":"_Sidebar--right_1xksb_14", "Sidebar-resizeHandle":"_Sidebar-resizeHandle_1xksb_20"}, nT = Rt("Sidebar", the), rT = ({position:t, sidebarRef:e, isVisible:n, onResize:r, onResizeEnd:i, children:s}) => n ? (0,require$react_SLASH_jsx_runtime.jsxs)(require$react_SLASH_jsx_runtime.Fragment, {children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {ref:e, className:nT({[t]:!0}), children:s}), (0,require$react_SLASH_jsx_runtime.jsx)("div", 
{className:`${nT("resizeHandle")}`, children:(0,require$react_SLASH_jsx_runtime.jsx)(ehe, {position:t, sidebarRef:e, onResize:r, onResizeEnd:i})})]}) : null;
re();
function iT(t, e) {
  const [n, r] = (0,require$react.useState)(null), i = (0,require$react.useRef)(null), s = Be(a => t === "left" ? a.state.ui.leftSideBarWidth : a.state.ui.rightSideBarWidth);
  (0,require$react.useEffect)(() => {
    if (typeof window < "u" && !s) {
      try {
        const a = localStorage.getItem("puck-sidebar-widths");
        if (a) {
          const c = JSON.parse(a)[t];
          c && e({type:"setUi", ui:{[t === "left" ? "leftSideBarWidth" : "rightSideBarWidth"]:c}});
        }
      } catch (a) {
        console.error(`Failed to load ${t} sidebar width from localStorage`, a);
      }
    }
  }, [e, t, s]), (0,require$react.useEffect)(() => {
    s !== void 0 && r(s);
  }, [s]);
  const o = (0,require$react.useCallback)(a => {
    e({type:"setUi", ui:{[t === "left" ? "leftSideBarWidth" : "rightSideBarWidth"]:a}});
    let l = {};
    try {
      const c = localStorage.getItem("puck-sidebar-widths");
      l = c ? JSON.parse(c) : {};
    } catch (c) {
      console.error(`Failed to save ${t} sidebar width to localStorage`, c);
    } finally {
      localStorage.setItem("puck-sidebar-widths", JSON.stringify(ve(K({}, l), {[t]:a})));
    }
    window.dispatchEvent(new CustomEvent("viewportchange", {bubbles:!0, cancelable:!1}));
  }, [e, t]);
  return {width:n, setWidth:r, sidebarRef:i, handleResizeEnd:o};
}
var sT = Rt("Puck", xD), oT = Rt("PuckLayout", xD), nhe = () => {
  const t = Be(e => {
    var n, r;
    return e.selectedItem ? (r = (n = e.config.components[e.selectedItem.type]) == null ? void 0 : n.label) != null ? r : e.selectedItem.type.toString() : "Page";
  });
  return (0,require$react_SLASH_jsx_runtime.jsx)(bx, {noPadding:!0, noBorderTop:!0, showBreadcrumbs:!0, title:t, children:(0,require$react_SLASH_jsx_runtime.jsx)(vD, {})});
}, OD = (0,require$react.createContext)({});
function rhe(t) {
  return (0,require$react_SLASH_jsx_runtime.jsx)(OD.Provider, {value:t, children:t.children});
}
var nw = () => (0,require$react.useContext)(OD);
function ihe({children:t}) {
  const {config:e, data:n, ui:r, onChange:i, permissions:s = {}, plugins:o, overrides:a, viewports:l = Gp, iframe:c, initialHistory:u, metadata:h, onAction:f, fieldTransforms:p} = nw(), g = (0,require$react.useMemo)(() => K({enabled:!0, waitForStyles:!0}, c), [c]), [m] = (0,require$react.useState)(() => {
    var k, A, P, W, F, B, z, j, V;
    const ne = K(K({}, Py.ui), r);
    let D = {};
    if (typeof window < "u") {
      window.matchMedia("(max-width: 638px)").matches && (D = ve(K({}, D), {leftSideBarVisible:!1, rightSideBarVisible:!1}));
      const X = window.innerWidth, me = Object.entries(l).map(([te, q]) => ({key:te, diff:Math.abs(X - q.width)})).sort((te, q) => te.diff > q.diff ? 1 : -1)[0].key;
      g.enabled && (D = ve(K({}, D), {viewports:ve(K({}, ne.viewports), {current:ve(K({}, ne.viewports.current), {height:((A = (k = r == null ? void 0 : r.viewports) == null ? void 0 : k.current) == null ? void 0 : A.height) || ((P = l[me]) == null ? void 0 : P.height) || "auto", width:((F = (W = r == null ? void 0 : r.viewports) == null ? void 0 : W.current) == null ? void 0 : F.width) || ((B = l[me]) == null ? void 0 : B.width)})})}));
    }
    Object.keys((n == null ? void 0 : n.root) || {}).length > 0 && !((z = n == null ? void 0 : n.root) != null && z.props) && console.warn("Warning: Defining props on `root` is deprecated. Please use `root.props`, or republish this page to migrate automatically.");
    const ie = ((j = n == null ? void 0 : n.root) == null ? void 0 : j.props) || (n == null ? void 0 : n.root) || {}, ee = K(K({}, (V = e.root) == null ? void 0 : V.defaultProps), ie), M = ve(K({}, Py), {data:ve(K({}, n), {root:ve(K({}, n == null ? void 0 : n.root), {props:ee}), content:n.content || []}), ui:ve(K(K({}, ne), D), {componentList:e.categories ? Object.entries(e.categories).reduce((X, [ge, me]) => ve(K({}, X), {[ge]:{title:me.title, components:me.components, expanded:me.defaultExpanded, 
    visible:me.visible}}), {}) : {}})});
    return xi(M, e);
  }), {appendData:b = !0} = u || {}, [x] = (0,require$react.useState)([...((u == null ? void 0 : u.histories) || []), ...(b ? [{state:m}] : [])].map(k => {
    let A = K(K({}, m), k.state);
    return k.state.indexes || (A = xi(A, e)), ve(K({}, k), {state:A});
  })), w = (u == null ? void 0 : u.index) || x.length - 1, v = x[w].state, T = Ude({overrides:a, plugins:o}), I = (0,require$react.useMemo)(() => {
    const A = (o || []).reduce((P, W) => K(K({}, P), W.fieldTransforms), {});
    return K(K({}, A), p);
  }, [p, o]), _ = (0,require$react.useCallback)(k => ({state:k, config:e, plugins:o || [], overrides:T, viewports:l, iframe:g, onAction:f, metadata:h, fieldTransforms:I}), [v, e, o, T, l, g, f, h, I]), [N] = (0,require$react.useState)(() => QR(_(v)));
  (0,require$react.useEffect)(() => {
    process.env.NODE_ENV !== "production" && (window.__PUCK_INTERNAL_DO_NOT_USE = {appStore:N});
  }, [N]), (0,require$react.useEffect)(() => {
    const k = N.getState().state;
    N.setState(K({}, _(k)));
  }, [e, o, T, l, g, f, h]), nce(N, {histories:x, index:w, initialAppState:v});
  const E = (0,require$react.useRef)(null);
  (0,require$react.useEffect)(() => {
    N.subscribe(k => k.state.data, k => {
      if (i) {
        if (Vp(k, E.current)) {
          return;
        }
        i(k), E.current = k;
      }
    });
  }, []), sce(N, s);
  const C = pde(N);
  return (0,require$react.useEffect)(() => {
    const {resolveAndCommitData:k} = N.getState();
    k();
  }, []), (0,require$react_SLASH_jsx_runtime.jsx)(Kv.Provider, {value:N, children:(0,require$react_SLASH_jsx_runtime.jsx)(fde.Provider, {value:C, children:t})});
}
function she({children:t}) {
  const {iframe:e, dnd:n, initialHistory:r} = nw(), i = (0,require$react.useMemo)(() => K({enabled:!0, waitForStyles:!0}, e), [e]);
  Vde(i.enabled);
  const s = Be(_ => _.dispatch), o = Be(_ => _.state.ui.leftSideBarVisible), a = Be(_ => _.state.ui.rightSideBarVisible), {width:l, setWidth:c, sidebarRef:u, handleResizeEnd:h} = iT("left", s), {width:f, setWidth:p, sidebarRef:g, handleResizeEnd:m} = iT("right", s);
  (0,require$react.useEffect)(() => {
    window.matchMedia("(min-width: 638px)").matches || s({type:"setUi", ui:{leftSideBarVisible:!1, rightSideBarVisible:!1}});
    const _ = () => {
      window.matchMedia("(min-width: 638px)").matches || s({type:"setUi", ui:N => K(K({}, N), N.rightSideBarVisible ? {leftSideBarVisible:!1} : {})});
    };
    return window.addEventListener("resize", _), () => {
      window.removeEventListener("resize", _);
    };
  }, []);
  const b = Be(_ => _.overrides), x = (0,require$react.useMemo)(() => b.puck || xx, [b]), [w, v] = (0,require$react.useState)(!1);
  (0,require$react.useEffect)(() => {
    v(!0);
  }, []);
  const T = Be(_ => _.status === "READY");
  Zle(), (0,require$react.useEffect)(() => {
    if (T && i.enabled) {
      const _ = wc();
      if (_) {
        return GR(_);
      }
    }
  }, [T, i.enabled]), qde();
  const I = {};
  return l && (I["--puck-user-left-side-bar-width"] = `${l}px`), f && (I["--puck-user-right-side-bar-width"] = `${f}px`), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:`Puck ${sT()}`, children:[(0,require$react_SLASH_jsx_runtime.jsx)(Wue, {disableAutoScroll:n == null ? void 0 : n.disableAutoScroll, children:(0,require$react_SLASH_jsx_runtime.jsx)(x, {children:t || (0,require$react_SLASH_jsx_runtime.jsx)(Fde, {children:(0,require$react_SLASH_jsx_runtime.jsx)("div", {className:oT({leftSideBarVisible:o, 
  mounted:w, rightSideBarVisible:a}), children:(0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:oT("inner"), style:I, children:[(0,require$react_SLASH_jsx_runtime.jsx)(Xde, {}), (0,require$react_SLASH_jsx_runtime.jsxs)(rT, {position:"left", sidebarRef:u, isVisible:o, onResize:c, onResizeEnd:h, children:[(0,require$react_SLASH_jsx_runtime.jsx)(bx, {title:"Components", noBorderTop:!0, children:(0,require$react_SLASH_jsx_runtime.jsx)(_D, {})}), (0,require$react_SLASH_jsx_runtime.jsx)(bx, {title:"Outline", 
  children:(0,require$react_SLASH_jsx_runtime.jsx)(CD, {})})]}), (0,require$react_SLASH_jsx_runtime.jsx)(zde, {}), (0,require$react_SLASH_jsx_runtime.jsx)(rT, {position:"right", sidebarRef:g, isVisible:a, onResize:p, onResizeEnd:m, children:(0,require$react_SLASH_jsx_runtime.jsx)(nhe, {})})]})})})})}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {id:"puck-portal-root", className:sT("portal")})]});
}
function yh(t) {
  return (0,require$react_SLASH_jsx_runtime.jsx)(rhe, ve(K({}, t), {children:(0,require$react_SLASH_jsx_runtime.jsx)(ihe, ve(K({}, t), {children:(0,require$react_SLASH_jsx_runtime.jsx)(she, K({}, t))}))}));
}
yh.Components = _D;
yh.Fields = vD;
yh.Outline = CD;
yh.Preview = kD;
re();
re();
re();
re();
re();
re();
re();
re();
re();
re();
re();
re();
re();
function ohe(t) {
  const e = {};
  for (const n of t.layout.zones) {
    e[n.id] = [];
  }
  for (const n of t.blocks) {
    if (n.hidden) {
      continue;
    }
    const r = e[n.zone] ?? [];
    r.push({type:n.type, props:{...n.props, _blockId:n.id, _blockSource:n.source, _blockRef:n.ref}}), e[n.zone] = r;
  }
  return {content:[], zones:e, root:{title:t.view_title}};
}
function ahe(t, e) {
  var r;
  const n = new Map();
  for (const i of e.layout.zones) {
    const s = ((r = t.zones) == null ? void 0 : r[i.id]) ?? [];
    for (const o of s) {
      const a = o.props._blockId ?? crypto.randomUUID(), {_blockId:l, _blockSource:c, _blockRef:u, ...h} = o.props;
      n.set(a, {id:a, type:o.type, zone:i.id, props:h, source:c, ref:u});
    }
  }
  for (const i of e.blocks) {
    i.hidden && !n.has(i.id) && n.set(i.id, i);
  }
  return Array.from(n.values());
}
function lhe(t) {
  return {components:{hero:{fields:{title:{type:"text"}, subtitle:{type:"text"}, image_path:{type:"text"}, audio_path:{type:"text"}}, defaultProps:{title:"Hero Title", subtitle:""}, render:({title:n, subtitle:r, image_path:i, audio_path:s}) => (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{padding:"2rem", textAlign:"center", background:"linear-gradient(135deg, #1a1a2e 0%, #16213e 100%)", borderRadius:"8px"}, children:[i && (0,require$react_SLASH_jsx_runtime.jsx)("img", {src:i, alt:n, style:{maxWidth:"100%", 
  borderRadius:"8px", marginBottom:"1rem"}}), (0,require$react_SLASH_jsx_runtime.jsx)("h1", {style:{color:"#fff", margin:"0 0 0.5rem"}, children:n}), r && (0,require$react_SLASH_jsx_runtime.jsx)("p", {style:{color:"#a0a0a0", margin:0}, children:r}), s && (0,require$react_SLASH_jsx_runtime.jsx)("audio", {controls:!0, src:s, style:{marginTop:"1rem", width:"100%", maxWidth:"400px"}})]})}, "rich-text":{fields:{markdown:{type:"textarea"}}, defaultProps:{markdown:"Start writing..."}, render:({markdown:n}) => 
  (0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{lineHeight:1.7, color:"#d0d0d0"}, children:(0,require$react_SLASH_jsx_runtime.jsx)("div", {dangerouslySetInnerHTML:{__html:n.replace(/\n/g, "\x3cbr/\x3e")}})})}, heading:{fields:{text:{type:"text"}, level:{type:"number", min:2, max:4}}, defaultProps:{text:"Heading", level:2}, render:({text:n, level:r}) => {
    const i = `h${r}`;
    return (0,require$react_SLASH_jsx_runtime.jsx)(i, {style:{color:"#e0e0e0", margin:"1.5rem 0 0.75rem"}, children:n});
  }}, playlist:{fields:{title:{type:"text"}, description:{type:"text"}, layout:{type:"select", options:[{label:"Compact", value:"compact"}, {label:"Cards", value:"cards"}, {label:"Broadcast", value:"broadcast"}]}, show_labels:{type:"radio", options:[{label:"Yes", value:!0}, {label:"No", value:!1}]}, show_descriptions:{type:"radio", options:[{label:"Yes", value:!0}, {label:"No", value:!1}]}, show_duration:{type:"radio", options:[{label:"Yes", value:!0}, {label:"No", value:!1}]}}, defaultProps:{title:"Playlist", 
  description:"", layout:"cards", show_labels:!0, show_descriptions:!0, show_duration:!0}, render:({title:n, description:r}) => (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{margin:"1.5rem 0"}, children:[n && (0,require$react_SLASH_jsx_runtime.jsx)("h3", {style:{fontWeight:600, margin:"0 0 0.5rem"}, children:n}), r && (0,require$react_SLASH_jsx_runtime.jsx)("p", {style:{color:"#a0a0a0"}, children:r}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{padding:"1rem", background:"rgba(255,255,255,0.05)", 
  borderRadius:"8px", color:"#a0a0a0"}, children:"[Playlist tracks would render here]"})]})}, track:{fields:{audio_path:{type:"text"}, title:{type:"text"}, commentary:{type:"textarea"}, show_player:{type:"radio", options:[{label:"Yes", value:!0}, {label:"No", value:!1}]}}, defaultProps:{title:"Track", show_player:!0}, render:({title:n}) => (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{padding:"1rem", background:"rgba(255,255,255,0.05)", borderRadius:"8px", display:"flex", alignItems:"center", 
  gap:"1rem"}, children:[(0,require$react_SLASH_jsx_runtime.jsx)("button", {style:{width:"48px", height:"48px", borderRadius:"50%", border:"none", background:"#3b82f6", color:"#fff", cursor:"pointer"}, children:"\u25b6"}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{fontWeight:600}, children:n})]})}, callout:{fields:{tone:{type:"select", options:[{label:"Note", value:"note"}, {label:"Tip", value:"tip"}, {label:"Warning", value:"warning"}, {label:"Promo", value:"promo"}]}, title:{type:"text"}, 
  markdown:{type:"textarea"}}, defaultProps:{tone:"note", title:"", markdown:"Callout content..."}, render:({tone:n, title:r, markdown:i}) => {
    const s = {note:"#3b82f6", tip:"#22c55e", warning:"#f59e0b", promo:"#ec4899"};
    return (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{borderLeft:`4px solid ${s[n] ?? s.note}`, background:`${s[n] ?? s.note}20`, padding:"1rem", borderRadius:"0 8px 8px 0"}, children:[r && (0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{fontWeight:600, marginBottom:"0.5rem"}, children:r}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {children:i})]});
  }}, cta:{fields:{label:{type:"text"}, href:{type:"text"}, tone:{type:"select", options:[{label:"Primary", value:"primary"}, {label:"Secondary", value:"secondary"}]}}, defaultProps:{label:"Click here", href:"#", tone:"primary"}, render:({label:n, href:r, tone:i}) => (0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{textAlign:"center", margin:"1.5rem 0"}, children:(0,require$react_SLASH_jsx_runtime.jsx)("a", {href:r, style:{display:"inline-block", padding:"0.75rem 1.5rem", borderRadius:"8px", 
  background:i === "primary" ? "#3b82f6" : "transparent", color:i === "primary" ? "#fff" : "#3b82f6", border:i === "primary" ? "none" : "2px solid #3b82f6", textDecoration:"none", fontWeight:600}, children:n})})}, image:{fields:{src:{type:"text"}, alt:{type:"text"}, caption:{type:"text"}}, defaultProps:{src:"", alt:""}, render:({src:n, alt:r, caption:i}) => (0,require$react_SLASH_jsx_runtime.jsxs)("figure", {style:{margin:"1.5rem 0"}, children:[n && (0,require$react_SLASH_jsx_runtime.jsx)("img", 
  {src:n, alt:r, style:{maxWidth:"100%", borderRadius:"8px"}}), i && (0,require$react_SLASH_jsx_runtime.jsx)("figcaption", {style:{textAlign:"center", color:"#a0a0a0", fontSize:"0.875rem", marginTop:"0.5rem"}, children:i})]})}, divider:{fields:{}, render:() => (0,require$react_SLASH_jsx_runtime.jsx)("hr", {style:{border:"none", borderTop:"1px solid rgba(255,255,255,0.1)", margin:"2rem 0"}})}, "contract-ref":{fields:{ref_type:{type:"select", options:[{label:"Path", value:"path"}, {label:"ID", value:"id"}]}, 
  ref_path:{type:"text"}, ref_id:{type:"text"}, include_layout:{type:"radio", options:[{label:"Yes", value:!0}, {label:"No", value:!1}]}}, defaultProps:{ref_type:"path", ref_path:"", ref_id:"", include_layout:!1}, render:({ref_type:n, ref_path:r, ref_id:i}) => (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{padding:"1rem", background:"rgba(59, 130, 246, 0.1)", border:"2px dashed #3b82f6", borderRadius:"8px", color:"#93bbfd"}, children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{fontWeight:600, 
  marginBottom:"0.5rem"}, children:"Contract Reference"}), n === "path" ? (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{fontSize:"0.875rem"}, children:["Path: ", r || "(none)"]}) : (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{fontSize:"0.875rem"}, children:["ID: ", i || "(none)"]}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{fontSize:"0.75rem", marginTop:"0.5rem", opacity:0.7}, children:"Referenced contract blocks will be composed into this zone at render time."})]})}}, 
  root:{fields:{title:{type:"text"}}}};
}
function che({contract:t, onChange:e}) {
  const [n, r] = (0,require$react.useState)(() => ohe(t)), i = (0,require$react.useCallback)(o => {
    if (r(o), e) {
      const a = ahe(o, t);
      e({...t, blocks:a});
    }
  }, [t, e]), s = lhe(t.layout.zones);
  return (0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{height:"100%", display:"flex", flexDirection:"column"}, children:(0,require$react_SLASH_jsx_runtime.jsx)(yh, {config:s, data:n, onChange:i, overrides:{header:() => (0,require$react_SLASH_jsx_runtime.jsx)(require$react_SLASH_jsx_runtime.Fragment, {})}})});
}
function uhe({contract:t, contentMd:e, assets:n, validationErrors:r}) {
  const [i, s] = (0,require$react.useState)("contract"), o = a => JSON.stringify(a, null, 2).replace(/"([^"]+)":/g, ":$1").replace(/true/g, "true").replace(/false/g, "false").replace(/null/g, "nil");
  return (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{display:"flex", flexDirection:"column", height:"100%", background:"var(--token-colors-background-surface)", borderTop:"1px solid var(--token-colors-border-default)"}, children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{display:"flex", gap:0, borderBottom:"1px solid var(--token-colors-border-default)"}, children:["contract", "content", "assets", "validation"].map(a => (0,require$react_SLASH_jsx_runtime.jsxs)("button", {onClick:() => 
  s(a), style:{padding:"8px 16px", background:i === a ? "var(--token-colors-background-surface)" : "transparent", border:"none", borderBottom:i === a ? "2px solid #3b82f6" : "2px solid transparent", color:i === a ? "#fff" : "var(--token-colors-text-muted)", cursor:"pointer", fontSize:"13px", fontWeight:500, textTransform:"capitalize"}, children:[a, a === "validation" && r && r.length > 0 && (0,require$react_SLASH_jsx_runtime.jsxs)("span", {style:{marginLeft:"4px", color:"#ef4444"}, children:["(", 
  r.length, ")"]})]}, a))}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{flex:1, overflow:"auto", padding:"12px"}, children:[i === "contract" && (0,require$react_SLASH_jsx_runtime.jsx)("pre", {style:{margin:0, fontSize:"12px", lineHeight:1.5, color:"#d0d0d0", whiteSpace:"pre-wrap", wordBreak:"break-word"}, children:o(t)}), i === "content" && (0,require$react_SLASH_jsx_runtime.jsx)("pre", {style:{margin:0, fontSize:"12px", lineHeight:1.5, color:"#d0d0d0", whiteSpace:"pre-wrap"}, children:e || 
  "No content.md file"}), i === "assets" && (0,require$react_SLASH_jsx_runtime.jsx)("div", {children:n && n.length > 0 ? (0,require$react_SLASH_jsx_runtime.jsx)("ul", {style:{margin:0, padding:"0 0 0 16px", fontSize:"12px", color:"#d0d0d0"}, children:n.map(a => (0,require$react_SLASH_jsx_runtime.jsx)("li", {style:{padding:"4px 0"}, children:a}, a))}) : (0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{color:"var(--token-colors-text-muted)", fontSize:"12px"}, children:"No assets in this draft."})}), 
  i === "validation" && (0,require$react_SLASH_jsx_runtime.jsx)("div", {children:r && r.length > 0 ? (0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{display:"flex", flexDirection:"column", gap:"8px"}, children:r.map((a, l) => (0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{padding:"8px 12px", background:"rgba(239, 68, 68, 0.1)", borderLeft:"3px solid #ef4444", borderRadius:"0 4px 4px 0", fontSize:"12px", color:"#fca5a5"}, children:a}, l))}) : (0,require$react_SLASH_jsx_runtime.jsx)("div", 
  {style:{color:"#22c55e", fontSize:"12px"}, children:"\u2713 Contract is valid"})})]})]});
}
function dhe(t) {
  const e = [];
  (!t.view_id || t.view_id.trim().length === 0) && e.push("view_id is required"), (!t.view_title || t.view_title.trim().length === 0) && e.push("view_title is required"), t.view_kind || e.push("view_kind is required"), typeof t.view_schema_version != "number" && e.push("view_schema_version must be a number"), t.view_status || e.push("view_status is required"), (!t.layout || !t.layout.template) && e.push("layout.template is required"), (!t.layout.zones || t.layout.zones.length === 0) && e.push("layout.zones must contain at least one zone");
  const n = new Set();
  for (const i of t.layout.zones) {
    i.id ? n.has(i.id) ? e.push(`Duplicate zone id: ${i.id}`) : n.add(i.id) : e.push("All zones must have an id"), i.label || e.push(`Zone ${i.id ?? "(unknown)"} must have a label`), (!i.accepts || i.accepts.length === 0) && e.push(`Zone ${i.id ?? "(unknown)"} must specify accepted block types`);
  }
  const r = new Set();
  for (const i of t.blocks) {
    if (i.id ? r.has(i.id) ? e.push(`Duplicate block id: ${i.id}`) : r.add(i.id) : e.push("All blocks must have an id"), i.type || e.push(`Block ${i.id ?? "(unknown)"} must have a type`), i.zone ? n.has(i.zone) || e.push(`Block ${i.id} references unknown zone: ${i.zone}`) : e.push(`Block ${i.id ?? "(unknown)"} must specify a zone`), i.zone) {
      const s = t.layout.zones.find(o => o.id === i.zone);
      s && s.accepts && !s.accepts.includes(i.type) && e.push(`Block type '${i.type}' is not accepted in zone '${i.zone}'`);
    }
  }
  return t.editor || e.push("editor policy is required"), t.publishing || e.push("publishing metadata is required"), t.settings || e.push("settings are required"), e;
}
function hhe(t) {
  const e = fhe(t), {value:n} = rw(e, 0);
  return n;
}
function fhe(t) {
  const e = [];
  let n = 0;
  for (; n < t.length;) {
    const r = t[n];
    if (PD(r)) {
      n++;
    } else if (r === ";" && t[n + 1] === ";") {
      for (; n < t.length && t[n] !== `
`;) {
        n++;
      }
    } else if (r === '"') {
      let i = '"';
      for (n++; n < t.length && t[n] !== '"';) {
        t[n] === "\\" && (i += t[n], n++), i += t[n], n++;
      }
      i += '"', e.push(i), n++;
    } else if (r === ":") {
      let i = ":";
      for (n++; n < t.length && !aT(t[n]);) {
        i += t[n], n++;
      }
      e.push(i);
    } else if (r === "{" || r === "}" || r === "[" || r === "]") {
      e.push(r), n++;
    } else {
      let i = "";
      for (; n < t.length && !aT(t[n]);) {
        i += t[n], n++;
      }
      i && e.push(i);
    }
  }
  return e;
}
function PD(t) {
  return t === " " || t === `
` || t === "\t" || t === "," || t === "\r";
}
function aT(t) {
  return PD(t) || t === "{" || t === "}" || t === "[" || t === "]" || t === void 0;
}
function rw(t, e) {
  if (e >= t.length) {
    return {value:null, nextIndex:e};
  }
  const n = t[e];
  if (n === "{") {
    return phe(t, e + 1);
  }
  if (n === "[") {
    return ghe(t, e + 1);
  }
  if (n.startsWith('"')) {
    return {value:n.slice(1, -1), nextIndex:e + 1};
  }
  if (n.startsWith(":")) {
    return {value:n, nextIndex:e + 1};
  }
  if (n === "true") {
    return {value:!0, nextIndex:e + 1};
  }
  if (n === "false") {
    return {value:!1, nextIndex:e + 1};
  }
  if (n === "nil") {
    return {value:null, nextIndex:e + 1};
  }
  const r = Number(n);
  return Number.isNaN(r) ? {value:n, nextIndex:e + 1} : {value:r, nextIndex:e + 1};
}
function phe(t, e) {
  const n = {};
  for (; e < t.length && t[e] !== "}";) {
    const r = t[e];
    if (!(r != null && r.startsWith(":"))) {
      e++;
      continue;
    }
    const i = r.slice(1).replace(/-/g, "_");
    e++;
    const {value:s, nextIndex:o} = rw(t, e);
    n[i] = s, e = o;
  }
  return {value:n, nextIndex:e + 1};
}
function ghe(t, e) {
  const n = [];
  for (; e < t.length && t[e] !== "]";) {
    const {value:r, nextIndex:i} = rw(t, e);
    n.push(r), e = i;
  }
  return {value:n, nextIndex:e + 1};
}
function vx(t) {
  return t == null ? "nil" : typeof t == "string" ? `"${t}"` : typeof t == "number" || typeof t == "boolean" ? String(t) : Array.isArray(t) ? `[${t.map(vx).join(" ")}]` : typeof t == "object" ? `{${Object.entries(t).map(([n, r]) => `:${n.replace(/_/g, "-")} ${vx(r)}`).join(" ")}}` : String(t);
}
const mhe = "_page_3zdob_1", bhe = "_header_3zdob_9", yhe = "_titleRow_3zdob_16", xhe = "_saveButton_3zdob_22", vhe = "_splitPanel_3zdob_43", whe = "_canvasPanel_3zdob_51", _he = "_sourcePanel_3zdob_58", Ks = {page:mhe, header:bhe, titleRow:yhe, saveButton:xhe, splitPanel:vhe, canvasPanel:whe, sourcePanel:_he}, She = {view_id:"untitled", view_title:"Untitled Draft", view_kind:"article-page", view_schema_version:1, view_status:"draft", layout:{template:"article-page", zones:[{id:"header", label:"Header", 
accepts:["hero", "image"], max_blocks:1}, {id:"body", label:"Body", accepts:["rich-text", "heading", "callout", "image", "cta", "divider"]}]}, blocks:[], editor:{locked:!1, allowed_actions:["drag", "drop", "duplicate", "hide", "delete", "edit-props"], default_panel:"layout"}, publishing:{defer_index:!1, skip_translation:!0}, settings:{language:"en", allow_comments:!0}};
async function khe(t) {
  const e = await fetch(`/api/ingestion/file?path=${encodeURIComponent(`${t}/view-contract.edn`)}`);
  if (!e.ok) {
    throw new Error(`Failed to load view-contract.edn: ${e.status}`);
  }
  const n = (await e.json()).content, r = Ehe(n);
  let i;
  try {
    const s = await fetch(`/api/ingestion/file?path=${encodeURIComponent(`${t}/content.md`)}`);
    s.ok && (i = (await s.json()).content);
  } catch {
  }
  return {contract:r, contentMd:i};
}
function Ehe(t) {
  var s, o, a, l, c, u, h, f, p, g, m, b;
  const e = hhe(t), n = x => typeof x == "string" && x.startsWith(":") ? x.slice(1) : String(x), r = x => x.map(w => {
    const v = w;
    return {id:String(v.id ?? ""), type:n(v.type), zone:n(v.zone), props:v.props ?? {}, source:v.source ? {kind:n(v.source.kind), path:String(v.source.path ?? "")} : void 0, ref:v.ref ? {kind:"contract-ref", ref_type:n(v.ref.ref_type), ref_path:String(v.ref.ref_path ?? ""), ref_id:String(v.ref.ref_id ?? ""), include_layout:v.ref.include_layout === !0, zone_mapping:v.ref.zone_mapping} : void 0, hidden:v.hidden === !0};
  }).filter(w => w.id && w.type), i = x => x.map(w => {
    const v = w;
    return {id:n(v.id), label:String(v.label ?? ""), accepts:Array.isArray(v.accepts) ? v.accepts.map(T => n(T)) : [], max_blocks:v.max_blocks === null ? void 0 : v.max_blocks};
  });
  return {view_id:String(e.view_id ?? e["view/id"] ?? "untitled"), view_title:String(e.view_title ?? e["view/title"] ?? "Untitled"), view_kind:n(e.view_kind ?? e["view/kind"]) ?? "article-page", view_schema_version:Number(e.view_schema_version ?? e["view/schema_version"] ?? 1), view_status:n(e.view_status ?? e["view/status"]) ?? "draft", source:e.source ? (() => {
    const x = e.source;
    return {kind:n(x.kind), path:String(x.path ?? ""), imported_at:String(x.imported_at ?? "")};
  })() : void 0, garden:e.garden ? {id:String(e.garden.id ?? ""), visibility:n(e.garden.visibility)} : void 0, layout:{template:n(((s = e.layout) == null ? void 0 : s.template) ?? "article-page"), zones:i(((o = e.layout) == null ? void 0 : o.zones) ?? [])}, blocks:r(e.blocks ?? []), editor:{locked:((a = e.editor) == null ? void 0 : a.locked) === !0, allowed_actions:Array.isArray((l = e.editor) == null ? void 0 : l.allowed_actions) ? e.editor.allowed_actions.map(String) : ["drag", "drop", "duplicate", 
  "hide", "delete", "edit-props"], default_panel:String(((c = e.editor) == null ? void 0 : c.default_panel) ?? "layout")}, publishing:{defer_index:(((u = e.publishing) == null ? void 0 : u.defer_index) ?? !1) === !0, skip_translation:(((h = e.publishing) == null ? void 0 : h.skip_translation) ?? !0) === !0, last_published_at:(f = e.publishing) == null ? void 0 : f.last_published_at, canonical_url:(p = e.publishing) == null ? void 0 : p.canonical_url}, settings:{language:String(((g = e.settings) == 
  null ? void 0 : g.language) ?? "en"), allow_comments:(((m = e.settings) == null ? void 0 : m.allow_comments) ?? !0) === !0, chat_actor_id:(b = e.settings) == null ? void 0 : b.chat_actor_id}};
}
function hfe() {
  const {"*":t} = (0,require$react_router_dom.useParams)(), e = (0,require$react_router_dom.useNavigate)(), [n, r] = (0,require$react.useState)(She), [i, s] = (0,require$react.useState)(), [o, a] = (0,require$react.useState)(!0), [l, c] = (0,require$react.useState)(null), [u, h] = (0,require$react.useState)(!1), [f, p] = (0,require$react.useState)(!1);
  (0,require$react.useEffect)(() => {
    if (!t) {
      a(!1), c("No draft path specified");
      return;
    }
    let x = !1;
    return a(!0), c(null), khe(t).then(({contract:w, contentMd:v}) => {
      x || (r(w), s(v));
    }).catch(w => {
      x || c(w instanceof Error ? w.message : String(w));
    }).finally(() => {
      x || a(!1);
    }), () => {
      x = !0;
    };
  }, [t]);
  const g = (0,require$react.useCallback)(x => {
    r(x), h(!0);
  }, []), m = (0,require$react.useCallback)(async() => {
    if (!(!t || !u)) {
      p(!0);
      try {
        const x = `${t}/view-contract.edn`, w = The(n), v = await fetch("/api/ingestion/file", {method:"PUT", headers:{"Content-Type":"application/json"}, body:JSON.stringify({path:x, content:w})});
        if (!v.ok) {
          throw new Error(await v.text());
        }
        h(!1);
      } catch (x) {
        console.error("Save failed:", x);
      } finally {
        p(!1);
      }
    }
  }, [t, n, u]), b = dhe(n);
  return o ? (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:Ks.page, children:(0,require$react_SLASH_jsx_runtime.jsx)("div", {style:{display:"flex", alignItems:"center", justifyContent:"center", height:"100%", color:"var(--token-colors-text-muted)"}, children:"Loading draft\u2026"})}) : l ? (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:Ks.page, children:(0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{display:"flex", alignItems:"center", justifyContent:"center", height:"100%", 
  color:"#ef4444"}, children:["Error: ", l]})}) : (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:Ks.page, children:[(0,require$react_SLASH_jsx_runtime.jsx)("header", {className:Ks.header, children:(0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:Ks.titleRow, children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {style:{display:"flex", alignItems:"center", gap:"12px"}, children:[(0,require$react_SLASH_jsx_runtime.jsx)("button", {onClick:() => e("/cms"), style:{background:"none", 
  border:"none", color:"var(--token-colors-text-muted)", cursor:"pointer", fontSize:"18px"}, title:"Back to CMS", children:"\u2190"}), (0,require$react_SLASH_jsx_runtime.jsx)("span", {style:{fontWeight:600, fontSize:"16px"}, children:n.view_title}), (0,require$react_SLASH_jsx_runtime.jsx)("span", {style:{fontSize:"12px", color:"var(--token-colors-text-muted)", padding:"2px 8px", background:"rgba(255,255,255,0.05)", borderRadius:"4px"}, children:n.view_status})]}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", 
  {style:{display:"flex", alignItems:"center", gap:"8px"}, children:[u && (0,require$react_SLASH_jsx_runtime.jsx)("span", {style:{fontSize:"12px", color:"#f59e0b"}, children:"Unsaved changes"}), (0,require$react_SLASH_jsx_runtime.jsx)("button", {className:Ks.saveButton, onClick:() => void m(), disabled:f || !u, children:f ? "Saving\u2026" : "Save"})]})]})}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:Ks.splitPanel, children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {className:Ks.canvasPanel, 
  children:(0,require$react_SLASH_jsx_runtime.jsx)(che, {contract:n, onChange:g})}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:Ks.sourcePanel, children:(0,require$react_SLASH_jsx_runtime.jsx)(uhe, {contract:n, contentMd:i, validationErrors:b})})]})]});
}
function The(t) {
  const e = r => r.replace(/_/g, "-"), n = r => {
    if (r == null || typeof r != "object") {
      return r;
    }
    if (Array.isArray(r)) {
      return r.map(n);
    }
    const i = {};
    for (const [s, o] of Object.entries(r)) {
      i[e(s)] = n(o);
    }
    return i;
  };
  return vx(n(t));
}
const Che = 40;
function Ahe(t = {}) {
  return Che;
}
function lT(t, e) {
  const n = new Set(), r = [];
  for (const i of [...t, ...e]) {
    !(i != null && i.session) || n.has(i.session) || (n.add(i.session), r.push(i));
  }
  return r;
}
function cT(t) {
  return t.trim().toLowerCase();
}
function Fl(t) {
  if (t == null) {
    return "\u2014";
  }
  const e = new Date(t);
  return Number.isNaN(e.getTime()) ? String(t) : e.toLocaleString();
}
function uT(t) {
  return typeof t != "object" || t === null ? !1 : typeof t.type == "string";
}
function dT(t) {
  const e = t.contentParts ?? t.content_parts;
  if (Array.isArray(e)) {
    return e.filter(uT);
  }
  const n = t.receipt;
  if (typeof n == "object" && n !== null) {
    const r = n.contentParts ?? n.content_parts;
    if (Array.isArray(r)) {
      return r.filter(uT);
    }
  }
  return [];
}
function Nhe(t) {
  return [t.session, t.title ?? "", t.project ?? "", t.actor_id ?? "", t.contract_id ?? "", t.trigger_id ?? "", t.event_type ?? "", t.event_id ?? "", t.event_scope_id ?? "", t.schedule_id ?? "", (t.event_types ?? []).join(" "), (t.contract_actors ?? []).join(" ")].join(" ").toLowerCase();
}
function Ihe(t) {
  return t.is_active ? t.active_status ?? "active" : t.active_status ?? "inactive";
}
function RD(t) {
  switch(t) {
    case "running":
      return "warning";
    case "waiting_input":
      return "info";
    case "completed":
      return "success";
    case "failed":
    case "aborted":
      return "error";
    default:
      return "default";
  }
}
function am(t, e) {
  for (const n of e) {
    const r = t[n];
    if (typeof r == "string" && r.trim()) {
      return r.trim();
    }
  }
  return null;
}
function Ql(t) {
  return am(t.agent_spec ?? {}, ["subAgentId", "sub_agent_id", "sub-agent-id"]);
}
function Pu(t) {
  return am(t.agent_spec ?? {}, ["parentAgentId", "parent_agent_id", "parent-agent-id"]);
}
function DD(t) {
  return am(t.agent_spec ?? {}, ["role"]);
}
function iw(t) {
  return am(t.agent_spec ?? {}, ["contractId", "contract_id", "contract-id"]);
}
function nb(t) {
  var n, r, i;
  const e = ((n = t.agent_spec) == null ? void 0 : n.toolPolicies) ?? ((r = t.agent_spec) == null ? void 0 : r.tool_policies) ?? ((i = t.agent_spec) == null ? void 0 : i["tool-policies"]);
  return Array.isArray(e) ? e.length : 0;
}
function Ohe(t) {
  return [t.run_id, t.session_id ?? "", t.conversation_id ?? "", t.status, t.model ?? "", Ql(t) ?? "", Pu(t) ?? "", DD(t) ?? "", iw(t) ?? "", t.latest_user_message ?? "", JSON.stringify(t.agent_spec ?? {})].join(" ").toLowerCase();
}
function Phe(t) {
  const e = Ql(t);
  return e ? `sub-agent ${e}` : iw(t) ?? DD(t) ?? t.conversation_id ?? t.session_id ?? t.run_id;
}
function hT(t) {
  if (!t.ts) {
    return Number.MAX_SAFE_INTEGER;
  }
  const e = (new Date(t.ts)).getTime();
  return Number.isNaN(e) ? Number.MAX_SAFE_INTEGER : e;
}
function sw(t) {
  return t.map((e, n) => ({item:e, index:n})).sort((e, n) => {
    const r = hT(e.item) - hT(n.item);
    return r !== 0 ? r : e.index - n.index;
  }).map(({item:e}) => e);
}
function fT(t) {
  var i, s, o;
  const e = t.run_id, n = [];
  for (let a = 0; a < t.request_messages.length; a++) {
    const l = t.request_messages[a];
    n.push({kind:"user_message", id:`${e}:request:${a}`, content:l.content, contentParts:l.contentParts, ts:t.created_at});
  }
  const r = (t.trace_blocks ?? []).filter(a => {
    var l;
    return a.kind === "reasoning" && ((l = a.content) == null ? void 0 : l.trim());
  }).map(a => ({kind:"thinking", id:`${e}:trace:${a.id}`, content:a.content ?? "", ts:a.at ?? t.updated_at, model:t.model}));
  if (r.length > 0 ? n.push(...r) : (i = t.reasoning) != null && i.trim() && n.push({kind:"thinking", id:`${e}:reasoning`, content:t.reasoning, ts:t.updated_at, model:t.model}), t.tool_receipts) {
    for (const a of t.tool_receipts) {
      n.push({kind:"tool_call", id:`${e}:tool:${a.id}`, receipt:a, ts:a.ended_at ?? a.started_at});
    }
  }
  if ((s = t.answer) != null && s.trim() && n.push({kind:"agent_turn", id:`${e}:answer`, content:t.answer, model:t.model, contentParts:t.contentParts, toolReceipts:[], status:t.status, ts:t.updated_at}), t.events) {
    for (const a of t.events) {
      a.type === "tool_start" || a.type === "tool_end" || a.type === "tool_update" || n.push({kind:"system_note", id:`${e}:event:${a.type}:${a.at ?? ""}`, title:a.type ?? "event", content:a.preview ?? a.error ?? "", ts:a.at, variant:a.error || (o = a.type) != null && o.includes("failed") ? "error" : "info"});
    }
  }
  return sw(n);
}
function Rhe(t) {
  const e = [];
  for (const n of t) {
    if (n.kind === "knoxx.message") {
      const r = ja(n) ?? {}, i = r.contentParts ?? r.content_parts;
      n.role === "user" ? e.push({kind:"user_message", id:n.id, content:n.text ?? "", ts:n.ts, contentParts:i}) : n.role === "assistant" ? e.push({kind:"agent_turn", id:n.id, content:n.text ?? "", ts:n.ts, model:n.model, contentParts:i, toolReceipts:[]}) : e.push({kind:"system_note", id:n.id, title:n.kind ?? "system", content:n.text ?? "", ts:n.ts});
    } else if (n.kind === "knoxx.reasoning") {
      e.push({kind:"thinking", id:n.id, content:n.text ?? "", ts:n.ts, model:n.model});
    } else if (n.kind === "knoxx.tool_receipt") {
      const i = (ja(n) ?? {}).receipt;
      i && e.push({kind:"tool_call", id:n.id, receipt:i, ts:n.ts});
    } else if (n.kind === "knoxx.run") {
      const r = ja(n) ?? {}, i = r.status, s = r.model;
      e.push({kind:"system_note", id:n.id, title:"Run", content:`Status: ${i ?? "unknown"}${s ? ` \u00b7 Model: ${s}` : ""}`, ts:n.ts, variant:i === "completed" ? "success" : i === "failed" ? "error" : "info"});
    }
  }
  return sw(e);
}
function Dhe(t, e) {
  var i, s, o, a, l, c, u, h;
  const n = [], r = new Map();
  for (const f of e) {
    if (f.type === "tool_start" || f.type === "tool_end" || f.type === "tool_update") {
      const p = f.tool_call_id ?? f.tool_name ?? "unknown", g = r.get(p) ?? {updates:[]};
      f.type === "tool_start" ? g.start = f : f.type === "tool_end" ? g.end = f : g.updates.push(f), r.set(p, g);
    }
  }
  for (const [f, p] of r) {
    const g = {id:f, tool_name:((i = p.start) == null ? void 0 : i.tool_name) ?? ((s = p.end) == null ? void 0 : s.tool_name) ?? f, status:p.end ? p.end.is_error ? "failed" : "completed" : "running", input_preview:(o = p.start) == null ? void 0 : o.preview, result_preview:(a = p.end) == null ? void 0 : a.preview, is_error:typeof((l = p.end) == null ? void 0 : l.is_error) == "boolean" ? p.end.is_error : void 0, updates:p.updates.map(m => m.preview ?? "").filter(Boolean)};
    n.push({kind:"tool_call", id:`${t}:tool:${f}`, receipt:g, ts:((c = p.end) == null ? void 0 : c.at) ?? ((u = p.start) == null ? void 0 : u.at)});
  }
  for (const f of e) {
    f.type === "tool_start" || f.type === "tool_end" || f.type === "tool_update" || n.push({kind:"system_note", id:`${t}:event:${f.type}:${f.at ?? ""}`, title:f.type ?? "event", content:f.preview ?? f.error ?? "", ts:f.at, variant:f.error || (h = f.type) != null && h.includes("failed") ? "error" : "info"});
  }
  return sw(n);
}
function Lhe(t) {
  switch(t.kind) {
    case "user_message":
      return [t.content, t.ts].filter(Boolean).join(" ").toLowerCase();
    case "agent_turn":
      return [t.content, t.model ?? "", t.status ?? "", t.ts].filter(Boolean).join(" ").toLowerCase();
    case "thinking":
      return [t.content, t.model ?? "", t.ts].filter(Boolean).join(" ").toLowerCase();
    case "tool_call":
      return [t.receipt.tool_name ?? "", t.receipt.id, t.receipt.input_preview ?? "", t.receipt.result_preview ?? ""].filter(Boolean).join(" ").toLowerCase();
    case "system_note":
      return [t.title, t.content, t.ts].filter(Boolean).join(" ").toLowerCase();
  }
}
function Mhe({session:t, active:e, onSelect:n}) {
  const r = Ihe(t), i = t.contract_id, s = t.actor_id, o = t.sub_agent_id, a = t.trigger_id, l = t.event_type, c = t.schedule_id;
  return (0,require$react_SLASH_jsx_runtime.jsxs)("button", {type:"button", onClick:n, "aria-pressed":e, className:`w-full rounded-xl border px-4 py-3 text-left transition ${e ? "border-indigo-500 bg-indigo-950/30" : "border-slate-800 bg-slate-950/50 hover:border-slate-700 hover:bg-slate-950"}`, children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"flex items-start justify-between gap-3", children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"min-w-0", children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", 
  {className:"text-sm font-semibold text-slate-100", children:t.title ?? "session"}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"mt-1 font-mono text-xs text-slate-400 break-all", children:t.session})]}), (0,require$react_SLASH_jsx_runtime.jsx)(ct, {size:"sm", variant:RD(r), children:r})]}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"mt-2 flex flex-wrap gap-2 text-xs text-slate-500", children:[(0,require$react_SLASH_jsx_runtime.jsxs)("span", {children:[t.event_count ?? 
  0, " events"]}), o ? (0,require$react_SLASH_jsx_runtime.jsxs)(require$react_SLASH_jsx_runtime.Fragment, {children:[(0,require$react_SLASH_jsx_runtime.jsx)("span", {children:"\u2022"}), (0,require$react_SLASH_jsx_runtime.jsxs)("span", {className:"font-mono text-[11px] text-sky-300", children:["sub-agent ", o]})]}) : null, i ? (0,require$react_SLASH_jsx_runtime.jsxs)(require$react_SLASH_jsx_runtime.Fragment, {children:[(0,require$react_SLASH_jsx_runtime.jsx)("span", {children:"\u2022"}), (0,require$react_SLASH_jsx_runtime.jsxs)("span", 
  {className:"font-mono text-[11px] text-slate-400", children:["contract ", i]})]}) : null, s ? (0,require$react_SLASH_jsx_runtime.jsxs)(require$react_SLASH_jsx_runtime.Fragment, {children:[(0,require$react_SLASH_jsx_runtime.jsx)("span", {children:"\u2022"}), (0,require$react_SLASH_jsx_runtime.jsxs)("span", {className:"font-mono text-[11px] text-slate-400", children:["actor ", s]})]}) : null, a ? (0,require$react_SLASH_jsx_runtime.jsxs)(require$react_SLASH_jsx_runtime.Fragment, {children:[(0,require$react_SLASH_jsx_runtime.jsx)("span", 
  {children:"\u2022"}), (0,require$react_SLASH_jsx_runtime.jsxs)("span", {className:"font-mono text-[11px] text-amber-300", children:["trigger ", a]})]}) : null, l ? (0,require$react_SLASH_jsx_runtime.jsxs)(require$react_SLASH_jsx_runtime.Fragment, {children:[(0,require$react_SLASH_jsx_runtime.jsx)("span", {children:"\u2022"}), (0,require$react_SLASH_jsx_runtime.jsxs)("span", {className:"font-mono text-[11px] text-cyan-300", children:["event ", l]})]}) : null, c ? (0,require$react_SLASH_jsx_runtime.jsxs)(require$react_SLASH_jsx_runtime.Fragment, 
  {children:[(0,require$react_SLASH_jsx_runtime.jsx)("span", {children:"\u2022"}), (0,require$react_SLASH_jsx_runtime.jsxs)("span", {className:"font-mono text-[11px] text-slate-400", children:["schedule ", c]})]}) : null, t.last_ts ? (0,require$react_SLASH_jsx_runtime.jsxs)(require$react_SLASH_jsx_runtime.Fragment, {children:[(0,require$react_SLASH_jsx_runtime.jsx)("span", {children:"\u2022"}), (0,require$react_SLASH_jsx_runtime.jsxs)("span", {children:["last ", Fl(t.last_ts)]})]}) : null]})]});
}
function Bhe({hits:t}) {
  return t.length === 0 ? (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"text-xs text-slate-500", children:"No semantic hits."}) : (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"space-y-2", children:t.map((e, n) => (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"rounded-lg border border-slate-800 bg-slate-950/60 p-3", children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"text-xs text-slate-400", children:e.role ?? ""}), (0,require$react_SLASH_jsx_runtime.jsx)("div", 
  {className:"mt-1 text-sm text-slate-200", children:(0,require$react_SLASH_jsx_runtime.jsx)(mr, {content:e.snippet ?? e.text ?? "", theme:"dark", variant:"compact", lineNumbers:!1, copyButton:!1})}), typeof e.distance == "number" ? (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"mt-2 text-[11px] text-slate-500", children:["distance ", e.distance.toFixed(4)]}) : null]}, `${e.session ?? "hit"}:${n}`))});
}
function ffe({defaultMode:t = "active", builtInActorId:e, builtInContractId:n, className:r}) {
  const i = (0,require$react_router_dom.useLocation)(), s = (0,require$react.useMemo)(() => {
    const se = new URLSearchParams(i.search);
    return {runId:se.get("run") ?? se.get("runId"), sessionId:se.get("session") ?? se.get("sessionId") ?? se.get("conversation") ?? se.get("conversationId")};
  }, [i.search]), [o, a] = (0,require$react.useState)(t), [l, c] = (0,require$react.useState)(!0), [u, h] = (0,require$react.useState)([]), f = (0,require$react.useRef)([]);
  f.current = u;
  const [p, g] = (0,require$react.useState)(0), [m, b] = (0,require$react.useState)(!1), [x, w] = (0,require$react.useState)(!0), [v, T] = (0,require$react.useState)(!1), [I, _] = (0,require$react.useState)(null), [N, E] = (0,require$react.useState)([]), [C, k] = (0,require$react.useState)(!1), [A, P] = (0,require$react.useState)(""), [W, F] = (0,require$react.useState)(""), [B, z] = (0,require$react.useState)(""), [j, V] = (0,require$react.useState)(!1), [ne, D] = (0,require$react.useState)([]), 
  [ie, ee] = (0,require$react.useState)(null), [M, X] = (0,require$react.useState)([]), [ge, me] = (0,require$react.useState)(!1), [te, q] = (0,require$react.useState)(null), [R, $] = (0,require$react.useState)([]), [G, J] = (0,require$react.useState)("all"), U = (0,require$react.useMemo)(() => cT(A), [A]), le = (0,require$react.useMemo)(() => cT(W), [W]), be = (0,require$react.useMemo)(() => {
    if (o !== "active") {
      return [];
    }
    const se = U, oe = M.filter(we => !(e && Ql(we) !== e && Pu(we) !== e || n && iw(we) !== n));
    return se ? oe.filter(we => Ohe(we).includes(se)) : oe;
  }, [M, e, n, U, o]), je = (0,require$react.useMemo)(() => {
    const se = U, ke = u.filter(fe => o === "active" ? !!fe.is_active : !fe.is_active).filter(fe => !(e && fe.actor_id !== e || n && fe.contract_id !== n)).filter(fe => G === "all" ? !0 : fe.actor_id === G);
    return se ? ke.filter(fe => Nhe(fe).includes(se)) : ke;
  }, [u, U, o, e, n, G]), Ae = (0,require$react.useMemo)(() => u.find(se => se.session === I) ?? null, [u, I]), ue = (0,require$react.useMemo)(() => M.find(se => se.conversation_id === I || se.session_id === I) ?? null, [M, I]);
  (0,require$react.useEffect)(() => {
    const se = je.map(oe => oe.session);
    _(oe => oe && (se.includes(oe) || s.runId || s.sessionId) ? oe : se[0] ?? null);
  }, [je, s.runId, s.sessionId]);
  const Le = (0,require$react.useCallback)(async() => {
    try {
      me(!0);
      const se = await AA(250);
      X(se), ee(null);
    } catch {
      try {
        const se = await Eb(250);
        X(se);
      } catch (se) {
        ee(se instanceof Error ? se.message : String(se));
      }
    } finally {
      me(!1);
    }
  }, []), $e = (0,require$react.useCallback)(async(se = 0) => {
    const oe = se > 0;
    try {
      oe ? T(!0) : w(!0);
      const we = G !== "all" ? G : void 0, ke = await Ua({limit:Ahe({builtInActorId:e, builtInContractId:n, actorId:we}), offset:se, actorId:we, contractId:n}), fe = ke.rows ?? [];
      if (oe) {
        const Oe = lT(f.current, fe);
        f.current = Oe, h(Oe);
      } else {
        const Oe = f.current.filter(rt => !fe.some(st => st.session === rt.session)), We = lT(fe, Oe);
        f.current = We, h(We);
      }
      g(ke.total ?? f.current.length), b(ke.has_more ?? !1), ee(null);
    } catch (we) {
      ee(we instanceof Error ? we.message : String(we));
    } finally {
      oe ? T(!1) : w(!1);
    }
  }, [e, n, G]);
  (0,require$react.useEffect)(() => {
    let se = !1;
    const oe = async() => {
      se || await Promise.all([$e(0), Le()]);
    };
    if (oe(), !l) {
      return () => {
        se = !0;
      };
    }
    const we = window.setInterval(() => {
      oe();
    }, 1e4);
    return () => {
      se = !0, window.clearInterval(we);
    };
  }, [l, Le, $e]), (0,require$react.useEffect)(() => {
    var ke, fe;
    let se = !1;
    const oe = (ke = s.runId) == null ? void 0 : ke.trim(), we = (fe = s.sessionId) == null ? void 0 : fe.trim();
    return oe ? (a("history"), c(!1), k(!0), hd(oe).then(Oe => {
      se || (_(Oe.conversation_id ?? Oe.session_id ?? Oe.run_id), E(fT(Oe)), D([]), ee(null));
    }).catch(Oe => {
      se || ee(Oe instanceof Error ? Oe.message : String(Oe));
    }).finally(() => {
      se || k(!1);
    })) : we && (a("history"), c(!1), _(we)), () => {
      se = !0;
    };
  }, [s.runId, s.sessionId]), (0,require$react.useEffect)(() => {
    let se = !1;
    return Jx().then(oe => {
      se || $(oe.actors ?? []);
    }).catch(() => {
    }), () => {
      se = !0;
    };
  }, []);
  const Ye = async se => {
    if (x || v || !m) {
      return;
    }
    const oe = se.currentTarget;
    oe.scrollHeight - oe.scrollTop - oe.clientHeight > 120 || await $e(f.current.length);
  }, Me = (0,require$react.useCallback)(async se => {
    const oe = se.run_id || se.session_id || se.conversation_id || "active-agent";
    try {
      q(oe), await NA({conversation_id:se.conversation_id, session_id:se.session_id, run_id:se.run_id, reason:"operator_abort_from_audit_panel"}), await Promise.all([Le(), $e(0)]), se.conversation_id && I === se.conversation_id && E([]), ee(null);
    } catch (we) {
      ee(we instanceof Error ? we.message : String(we));
    } finally {
      q(null);
    }
  }, [Le, $e, I]);
  (0,require$react.useEffect)(() => {
    let se = !1;
    const oe = async() => {
      if (!s.runId) {
        if (!I) {
          E([]), D([]);
          return;
        }
        try {
          k(!0);
          const ke = f.current.find(Oe => Oe.session === I) ?? null;
          if (ke != null && ke.is_active || ue) {
            const Oe = ue ? [ue] : await Eb(150);
            if (se) {
              return;
            }
            const We = Oe.find(rt => rt.conversation_id === I || rt.session_id === I) ?? null;
            if (We != null && We.run_id) {
              const rt = await hd(We.run_id);
              if (se) {
                return;
              }
              E(fT(rt)), D([]), ee(null);
              return;
            }
            try {
              const rt = await e1(I);
              if (se) {
                return;
              }
              if (rt.run_id) {
                const st = await t1(rt.run_id);
                if (se) {
                  return;
                }
                if (st.events && st.events.length > 0) {
                  E(Dhe(rt.run_id, st.events)), D([]), ee(null);
                  return;
                }
              }
            } catch {
            }
          }
          const fe = await qx(I);
          if (se) {
            return;
          }
          E(Rhe(fe.rows ?? [])), D([]), ee(null);
        } catch (ke) {
          se || ee(ke instanceof Error ? ke.message : String(ke));
        } finally {
          se || k(!1);
        }
      }
    };
    if (oe(), !l) {
      return () => {
        se = !0;
      };
    }
    const we = window.setInterval(() => {
      oe();
    }, 1e4);
    return () => {
      se = !0, window.clearInterval(we);
    };
  }, [I, l, ue, s.runId]);
  const Xe = (0,require$react.useMemo)(() => {
    if (!le) {
      return N;
    }
    const se = le;
    return N.filter(oe => Lhe(oe).includes(se));
  }, [N, le]), it = (0,require$react.useCallback)(async() => {
    const se = B.trim();
    if (!I || !se) {
      D([]);
      return;
    }
    V(!0);
    try {
      const oe = await Yx({query:se, k:12, sessionId:I});
      D(oe.hits ?? []), ee(null);
    } catch (oe) {
      ee(oe instanceof Error ? oe.message : String(oe));
    } finally {
      V(!1);
    }
  }, [B, I]);
  return (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:`h-full ${r ?? ""}`, children:[ie ? (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"mb-4 rounded-lg border border-red-800 bg-red-950/40 p-3 text-sm text-red-200", children:ie}) : null, (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"grid h-full min-h-0 grid-cols-[360px_minmax(0,1fr)] gap-4", children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"flex flex-col overflow-hidden rounded-xl border border-slate-800 bg-slate-900", 
  children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"shrink-0 border-b border-slate-800 px-4 py-3", children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"flex items-center justify-between gap-2", children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"text-sm font-semibold text-slate-200", children:"Sessions"}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"text-xs text-slate-500", children:p > 0 ? `${je.length}/${p}` : je.length})]}), 
  (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"mt-3 grid grid-cols-2 gap-2", children:[(0,require$react_SLASH_jsx_runtime.jsx)(Ke, {variant:o === "active" ? "primary" : "ghost", size:"sm", onClick:() => a("active"), children:"Active"}), (0,require$react_SLASH_jsx_runtime.jsx)(Ke, {variant:o === "history" ? "primary" : "ghost", size:"sm", onClick:() => a("history"), children:"History"})]}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"mt-2", children:(0,require$react_SLASH_jsx_runtime.jsxs)("div", 
  {className:"grid grid-cols-2 gap-2", children:[(0,require$react_SLASH_jsx_runtime.jsx)(Ke, {variant:"ghost", size:"sm", onClick:() => c(se => !se), children:l ? "Pause refresh" : "Resume refresh"}), (0,require$react_SLASH_jsx_runtime.jsx)(Ke, {variant:"ghost", size:"sm", onClick:() => void Promise.all([$e(0), Le()]), disabled:x || ge, children:"Refresh now"})]})}), R.length > 0 ? (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"mt-2", children:(0,require$react_SLASH_jsx_runtime.jsxs)("select", 
  {"aria-label":"Filter by actor", value:G, onChange:se => {
    J(se.target.value), $e(0);
  }, className:"w-full rounded-md border border-slate-800 bg-slate-950/80 px-2.5 py-2 text-sm text-slate-100 outline-none focus:border-sky-500", children:[(0,require$react_SLASH_jsx_runtime.jsx)("option", {value:"all", children:"All actors"}), R.map(se => (0,require$react_SLASH_jsx_runtime.jsx)("option", {value:se.id, children:se.id}, se.id))]})}) : null, (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"mt-3", children:(0,require$react_SLASH_jsx_runtime.jsx)("input", {"aria-label":"Search sessions", 
  value:A, onChange:se => P(se.target.value), placeholder:e || n ? "Search\u2026 (filters active)" : "Search\u2026", className:"w-full rounded-md border border-slate-800 bg-slate-950/80 px-2.5 py-2 text-sm text-slate-100 outline-none focus:border-sky-500"})})]}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"min-h-0 flex-1 overflow-y-auto p-3", onScroll:Ye, children:[x && u.length === 0 ? (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"text-sm text-slate-500", children:"Loading sessions\u2026"}) : 
  null, !x && je.length === 0 ? (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"text-sm text-slate-500", children:"No sessions match."}) : null, (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"space-y-3", children:[je.map(se => (0,require$react_SLASH_jsx_runtime.jsx)(Mhe, {session:se, active:se.session === I, onSelect:() => _(se.session)}, se.session)), v ? (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"px-2 py-1 text-xs text-slate-500", children:"Loading more\u2026"}) : 
  null]})]})]}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"min-h-0 overflow-y-auto rounded-xl border border-slate-800 bg-slate-900 p-4", children:[I ? null : (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"text-sm text-slate-500", children:"Select a session to inspect."}), I && C && N.length === 0 ? (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"text-sm text-slate-500", children:"Loading session\u2026"}) : null, I ? (0,require$react_SLASH_jsx_runtime.jsxs)("div", 
  {className:"space-y-4", children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"flex flex-col gap-3 md:flex-row md:items-start md:justify-between", children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"min-w-0", children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"text-lg font-semibold text-slate-100", children:"Agent audit logs"}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"mt-1 font-mono text-xs text-slate-400 break-all", children:I}), 
  (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"mt-2 text-xs text-slate-500", children:"OpenPlanner session trace (knoxx-session)."}), Ae != null && Ae.sub_agent_id || Ae != null && Ae.contract_id || Ae != null && Ae.actor_id || ue ? (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"mt-2 flex flex-wrap gap-2 text-[11px] text-slate-500", children:[Ae != null && Ae.sub_agent_id ? (0,require$react_SLASH_jsx_runtime.jsxs)("span", {className:"rounded bg-sky-950 px-2 py-1 font-mono text-sky-200", 
  children:["sub-agent ", Ae.sub_agent_id]}) : null, ue && Ql(ue) ? (0,require$react_SLASH_jsx_runtime.jsxs)("span", {className:"rounded bg-sky-950 px-2 py-1 font-mono text-sky-200", children:["sub-agent ", Ql(ue)]}) : null, ue != null && ue.model ? (0,require$react_SLASH_jsx_runtime.jsxs)("span", {className:"rounded bg-violet-950 px-2 py-1 font-mono text-violet-200", children:["model ", ue.model]}) : null, ue && nb(ue) > 0 ? (0,require$react_SLASH_jsx_runtime.jsxs)("span", {className:"rounded bg-emerald-950 px-2 py-1 font-mono text-emerald-200", 
  children:[nb(ue), " tools"]}) : null, Ae != null && Ae.contract_id ? (0,require$react_SLASH_jsx_runtime.jsxs)("span", {className:"rounded bg-slate-950 px-2 py-1 font-mono text-slate-300", children:["contract ", Ae.contract_id]}) : null, Ae != null && Ae.actor_id ? (0,require$react_SLASH_jsx_runtime.jsxs)("span", {className:"rounded bg-slate-950 px-2 py-1 font-mono text-slate-300", children:["actor ", Ae.actor_id]}) : null, ue && Pu(ue) ? (0,require$react_SLASH_jsx_runtime.jsxs)("span", {className:"rounded bg-slate-950 px-2 py-1 font-mono text-slate-300", 
  children:["parent ", Pu(ue)]}) : null]}) : null]}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"flex flex-wrap gap-2", children:(0,require$react_SLASH_jsx_runtime.jsxs)(ct, {size:"sm", variant:"info", children:[Xe.length, "/", N.length, " items"]})})]}), o === "active" ? (0,require$react_SLASH_jsx_runtime.jsxs)(Mn, {variant:"outlined", padding:"sm", children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"flex flex-col gap-2 md:flex-row md:items-center md:justify-between", 
  children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"text-xs font-semibold uppercase tracking-wide text-slate-400", children:"Live active agent sessions"}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"mt-1 text-xs text-slate-500", children:"Admin/operator view across actors. Abort stops exactly one active conversation/session."})]}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"flex items-center gap-2", 
  children:[(0,require$react_SLASH_jsx_runtime.jsxs)(ct, {size:"sm", variant:be.length > 0 ? "warning" : "default", children:[be.length, " running"]}), (0,require$react_SLASH_jsx_runtime.jsx)(Ke, {variant:"ghost", size:"sm", onClick:() => void Le(), disabled:ge, children:ge ? "Refreshing\u2026" : "Refresh"})]})]}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"mt-3 space-y-2", children:be.length === 0 ? (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"text-sm text-slate-500", 
  children:"No active runtime sessions match."}) : be.map(se => {
    const oe = se.run_id || se.session_id || se.conversation_id || "active-agent", we = !!(I && (se.conversation_id === I || se.session_id === I)), ke = te === oe, fe = Ql(se), Oe = Pu(se), We = nb(se);
    return (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:`rounded-lg border p-3 ${we ? "border-indigo-500 bg-indigo-950/30" : "border-slate-800 bg-slate-950/70"}`, children:(0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"flex flex-col gap-3 md:flex-row md:items-start md:justify-between", children:[(0,require$react_SLASH_jsx_runtime.jsxs)("button", {type:"button", className:"min-w-0 flex-1 text-left", onClick:() => _(se.conversation_id ?? se.session_id ?? I), children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", 
    {className:"flex flex-wrap items-center gap-2", children:[(0,require$react_SLASH_jsx_runtime.jsx)("span", {className:"text-sm font-semibold text-slate-100", children:Phe(se)}), (0,require$react_SLASH_jsx_runtime.jsx)(ct, {size:"sm", variant:fe ? "info" : "default", children:fe ? "sub-agent" : "agent"}), (0,require$react_SLASH_jsx_runtime.jsx)(ct, {size:"sm", variant:RD(se.status), children:se.status}), se.model ? (0,require$react_SLASH_jsx_runtime.jsx)(ct, {size:"sm", variant:se.model === "gemma4:e4b" ? 
    "success" : "default", children:se.model}) : null, We > 0 ? (0,require$react_SLASH_jsx_runtime.jsxs)(ct, {size:"sm", variant:"info", children:[We, " tools"]}) : null, se.has_active_stream ? (0,require$react_SLASH_jsx_runtime.jsx)(ct, {size:"sm", variant:"info", children:"stream"}) : null, se.active_turn_registered ? (0,require$react_SLASH_jsx_runtime.jsx)(ct, {size:"sm", variant:"warning", children:"abortable"}) : null]}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"mt-1 break-all font-mono text-xs text-slate-400", 
    children:se.conversation_id ?? se.session_id ?? se.run_id}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"mt-2 flex flex-wrap gap-2 text-xs text-slate-500", children:[Oe ? (0,require$react_SLASH_jsx_runtime.jsxs)("span", {children:["parent ", (0,require$react_SLASH_jsx_runtime.jsx)("span", {className:"font-mono text-slate-400", children:Oe})]}) : null, se.run_id ? (0,require$react_SLASH_jsx_runtime.jsxs)("span", {children:["run ", (0,require$react_SLASH_jsx_runtime.jsx)("span", 
    {className:"font-mono text-slate-400", children:se.run_id})]}) : null, se.session_id ? (0,require$react_SLASH_jsx_runtime.jsxs)("span", {children:["session ", (0,require$react_SLASH_jsx_runtime.jsx)("span", {className:"font-mono text-slate-400", children:se.session_id})]}) : null, se.updated_at ? (0,require$react_SLASH_jsx_runtime.jsxs)("span", {children:["updated ", Fl(se.updated_at)]}) : null]}), se.latest_user_message ? (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"mt-2 line-clamp-2 text-xs text-slate-300", 
    children:se.latest_user_message}) : null, se.error ? (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"mt-2 text-xs text-red-300", children:se.error}) : null]}), (0,require$react_SLASH_jsx_runtime.jsx)("button", {type:"button", onClick:() => void Me(se), disabled:ke, className:"rounded-md border border-red-800 bg-red-950/60 px-3 py-2 text-sm font-semibold text-red-100 hover:bg-red-900 disabled:opacity-60", title:"Abort only this active agent conversation/session.", children:ke ? "Stopping\u2026" : 
    "Stop this agent"})]})}, oe);
  })})]}) : null, (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"grid gap-3 md:grid-cols-2", children:[(0,require$react_SLASH_jsx_runtime.jsxs)(Mn, {variant:"outlined", padding:"sm", children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"text-xs font-semibold uppercase tracking-wide text-slate-400", children:"Keyword search"}), (0,require$react_SLASH_jsx_runtime.jsx)("input", {"aria-label":"Search events", value:W, onChange:se => F(se.target.value), placeholder:"Search\u2026", 
  className:"mt-2 w-full rounded-md border border-slate-800 bg-slate-950/80 px-2.5 py-2 text-sm text-slate-100 outline-none focus:border-sky-500"})]}), (0,require$react_SLASH_jsx_runtime.jsxs)(Mn, {variant:"outlined", padding:"sm", children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"flex items-center justify-between gap-2", children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"text-xs font-semibold uppercase tracking-wide text-slate-400", children:"Semantic search"}), 
  (0,require$react_SLASH_jsx_runtime.jsx)(Ke, {variant:"ghost", size:"sm", onClick:() => void it(), disabled:j || !B.trim(), children:j ? "Searching\u2026" : "Search"})]}), (0,require$react_SLASH_jsx_runtime.jsx)("input", {"aria-label":"Semantic search", value:B, onChange:se => z(se.target.value), placeholder:"Ask the trace\u2026", className:"mt-2 w-full rounded-md border border-slate-800 bg-slate-950/80 px-2.5 py-2 text-sm text-slate-100 outline-none focus:border-sky-500", onKeyDown:se => {
    se.key === "Enter" && (se.preventDefault(), it());
  }})]})]}), ne.length > 0 ? (0,require$react_SLASH_jsx_runtime.jsxs)(Mn, {variant:"outlined", padding:"sm", children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"text-xs font-semibold uppercase tracking-wide text-slate-400", children:"Semantic hits"}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"mt-3", children:(0,require$react_SLASH_jsx_runtime.jsx)(Bhe, {hits:ne})})]}) : null, (0,require$react_SLASH_jsx_runtime.jsxs)(Mn, {variant:"outlined", padding:"sm", children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", 
  {className:"text-xs font-semibold uppercase tracking-wide text-slate-400", children:"Session timeline"}), (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"mt-3 space-y-3", children:Xe.length === 0 ? (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"text-sm text-slate-500", children:"No items match your filters."}) : Xe.map(se => {
    switch(se.kind) {
      case "user_message":
        {
          const oe = se.contentParts ? dT({contentParts:se.contentParts}) : [];
          return (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"rounded-lg border border-green-800/30 bg-green-950/20 p-3", children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"flex items-start justify-between gap-3", children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"min-w-0", children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"text-sm font-semibold text-slate-100", children:"User"}), se.ts ? (0,require$react_SLASH_jsx_runtime.jsx)("div", 
          {className:"mt-1 text-xs text-slate-400", children:Fl(se.ts)}) : null]}), (0,require$react_SLASH_jsx_runtime.jsx)(ct, {size:"sm", variant:"success", children:"user"})]}), se.content ? (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"mt-3 text-sm text-slate-200", children:(0,require$react_SLASH_jsx_runtime.jsx)(mr, {content:se.content, theme:"dark", variant:"compact", lineNumbers:!1, copyButton:!1})}) : null, oe.length > 0 ? (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"mt-3", 
          children:(0,require$react_SLASH_jsx_runtime.jsx)(Ra, {parts:oe})}) : null]}, se.id);
        }
      case "agent_turn":
        {
          const oe = se.contentParts ? dT({contentParts:se.contentParts}) : [];
          return (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"rounded-lg border border-slate-700 bg-slate-950/70 p-3", children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"flex items-start justify-between gap-3", children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"min-w-0", children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"text-sm font-semibold text-slate-100", children:"Agent"}), se.ts ? (0,require$react_SLASH_jsx_runtime.jsx)("div", 
          {className:"mt-1 text-xs text-slate-400", children:Fl(se.ts)}) : null]}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"flex gap-2", children:[(0,require$react_SLASH_jsx_runtime.jsx)(ct, {size:"sm", variant:"info", children:"assistant"}), se.model ? (0,require$react_SLASH_jsx_runtime.jsx)(ct, {size:"sm", variant:"default", children:se.model}) : null, se.status ? (0,require$react_SLASH_jsx_runtime.jsx)(ct, {size:"sm", variant:se.status === "completed" ? "success" : se.status === 
          "failed" ? "error" : "warning", children:se.status}) : null]})]}), se.content ? (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"mt-3 text-sm text-slate-200", children:(0,require$react_SLASH_jsx_runtime.jsx)(mr, {content:se.content, theme:"dark", variant:"compact", lineNumbers:!1, copyButton:!1})}) : null, oe.length > 0 ? (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"mt-3", children:(0,require$react_SLASH_jsx_runtime.jsx)(Ra, {parts:oe})}) : null, se.toolReceipts.length > 
          0 ? (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"mt-3 space-y-2", children:se.toolReceipts.map(we => (0,require$react_SLASH_jsx_runtime.jsx)(gp, {receipt:we}, we.id))}) : null]}, se.id);
        }
      case "thinking":
        return (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"rounded-lg border border-violet-800/40 bg-violet-950/20 p-3", children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"flex items-start justify-between gap-3", children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"min-w-0", children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"text-sm font-semibold text-violet-100", children:"Thinking"}), se.ts ? (0,require$react_SLASH_jsx_runtime.jsx)("div", 
        {className:"mt-1 text-xs text-slate-400", children:Fl(se.ts)}) : null]}), (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"flex gap-2", children:[(0,require$react_SLASH_jsx_runtime.jsx)(ct, {size:"sm", variant:"info", children:"reasoning"}), se.model ? (0,require$react_SLASH_jsx_runtime.jsx)(ct, {size:"sm", variant:"default", children:se.model}) : null]})]}), se.content ? (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"mt-3 text-sm text-violet-100/90", children:(0,require$react_SLASH_jsx_runtime.jsx)(mr, 
        {content:se.content, theme:"dark", variant:"compact", lineNumbers:!1, copyButton:!1})}) : null]}, se.id);
      case "tool_call":
        return (0,require$react_SLASH_jsx_runtime.jsx)(gp, {receipt:se.receipt}, se.id);
      case "system_note":
        return (0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"rounded-lg border border-slate-800 bg-slate-950/70 p-3", children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"flex items-start justify-between gap-3", children:[(0,require$react_SLASH_jsx_runtime.jsxs)("div", {className:"min-w-0", children:[(0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"text-sm font-semibold text-slate-100", children:se.title}), se.ts ? (0,require$react_SLASH_jsx_runtime.jsx)("div", 
        {className:"mt-1 text-xs text-slate-400", children:Fl(se.ts)}) : null]}), se.variant ? (0,require$react_SLASH_jsx_runtime.jsx)(ct, {size:"sm", variant:se.variant, children:se.variant}) : null]}), se.content ? (0,require$react_SLASH_jsx_runtime.jsx)("div", {className:"mt-2 text-sm text-slate-200", children:(0,require$react_SLASH_jsx_runtime.jsx)(mr, {content:se.content, theme:"dark", variant:"compact", lineNumbers:!1, copyButton:!1})}) : null]}, se.id);
    }
  })})]})]}) : null]})]})]});
}

};